// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/DMSans-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/DMSans-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/DMSans-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/DMSans-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/DMSans-Medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/DMSans-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/DMSans-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/DMSans-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/DMSans-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/DMSans-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/DMSans-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/DMSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%231ee0ac%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%275%27 viewBox=%270 0 4 5%27%3e%3cpath fill=%27%23343a40%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23e85347%27 viewBox=%270 0 12 12%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23e85347%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%274%27 viewBox=%270 0 4 4%27%3e%3cpath stroke=%27%23fff%27 d=%27M0 2h4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../fonts/Nioicon.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../fonts/Nioicon.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../fonts/Nioicon.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../fonts/Nioicon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%278%27%20height%3D%2712%27%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%3E%3Cpath%20d%3D%27M0%200L8%200%208%2012%204.09117821%209%200%2012z%27%2F%3E%3C%2Fsvg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%3E%3Cg%20id%3D%22checklist-unchecked%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%3Crect%20id%3D%22Rectangle%22%20width%3D%2215%22%20height%3D%2215%22%20x%3D%22.5%22%20y%3D%22.5%22%20fill-rule%3D%22nonzero%22%20stroke%3D%22%234C4C4C%22%20rx%3D%222%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%3E%3Cg%20id%3D%22checklist-checked%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%3Crect%20id%3D%22Rectangle%22%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22%234099FF%22%20fill-rule%3D%22nonzero%22%20rx%3D%222%22%2F%3E%3Cpath%20id%3D%22Path%22%20fill%3D%22%23FFF%22%20fill-rule%3D%22nonzero%22%20d%3D%22M11.5703186%2C3.14417309%20C11.8516238%2C2.73724603%2012.4164781%2C2.62829933%2012.83558%2C2.89774797%20C13.260121%2C3.17069355%2013.3759736%2C3.72932262%2013.0909105%2C4.14168582%20L7.7580587%2C11.8560195%20C7.43776896%2C12.3193404%206.76483983%2C12.3852142%206.35607322%2C11.9948725%20L3.02491697%2C8.8138662%20C2.66090143%2C8.46625845%202.65798871%2C7.89594698%203.01850234%2C7.54483354%20C3.373942%2C7.19866177%203.94940006%2C7.19592841%204.30829608%2C7.5386474%20L6.85276923%2C9.9684299%20L11.5703186%2C3.14417309%20Z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%3E%0A%20%20%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%3Cpath%20fill%3D%22%23000%22%20fill-rule%3D%22nonzero%22%20d%3D%22M15%2C6%20C15%2C5.45%2014.55%2C5%2014%2C5%20L6%2C5%20C5.45%2C5%205%2C5.45%205%2C6%20L5%2C10%20C5%2C10.55%205.45%2C11%206%2C11%20L14%2C11%20C14.55%2C11%2015%2C10.55%2015%2C10%20L15%2C9%20L16%2C9%20L16%2C12%20L9%2C12%20L9%2C19%20C9%2C19.55%209.45%2C20%2010%2C20%20L11%2C20%20C11.55%2C20%2012%2C19.55%2012%2C19%20L12%2C14%20L18%2C14%20L18%2C7%20L15%2C7%20L15%2C6%20Z%22%2F%3E%0A%20%20%20%20%3Cpath%20fill%3D%22%23000%22%20fill-rule%3D%22nonzero%22%20d%3D%22M1%2C1%20L8.25%2C1%20C8.66421356%2C1%209%2C1.33578644%209%2C1.75%20L9%2C1.75%20C9%2C2.16421356%208.66421356%2C2.5%208.25%2C2.5%20L2.5%2C2.5%20L2.5%2C8.25%20C2.5%2C8.66421356%202.16421356%2C9%201.75%2C9%20L1.75%2C9%20C1.33578644%2C9%201%2C8.66421356%201%2C8.25%20L1%2C1%20Z%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%3E%3Cpath%20d%3D%22M4%203h16a1%201%200%200%201%201%201v16a1%201%200%200%201-1%201H4a1%201%200%200%201-1-1V4a1%201%200%200%201%201-1zm1%202v14h14V5H5zm4.79%202.565l5.64%204.028a.5.5%200%200%201%200%20.814l-5.64%204.028a.5.5%200%200%201-.79-.407V7.972a.5.5%200%200%201%20.79-.407z%22%2F%3E%3C%2Fsvg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2236%22%20height%3D%2212%22%20viewBox%3D%220%200%2036%2012%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%3Ccircle%20cx%3D%226%22%20cy%3D%226%22%20r%3D%223%22%20fill%3D%22rgba%280%2C%200%2C%200%2C%20.2%29%22%3E%0A%20%20%20%20%3Canimate%20attributeName%3D%22r%22%20values%3D%223%3B5%3B3%22%20calcMode%3D%22linear%22%20dur%3D%221s%22%20repeatCount%3D%22indefinite%22%20%2F%3E%0A%20%20%3C%2Fcircle%3E%0A%20%20%3Ccircle%20cx%3D%2218%22%20cy%3D%226%22%20r%3D%223%22%20fill%3D%22rgba%280%2C%200%2C%200%2C%20.2%29%22%3E%0A%20%20%20%20%3Canimate%20attributeName%3D%22r%22%20values%3D%223%3B5%3B3%22%20calcMode%3D%22linear%22%20begin%3D%22.33s%22%20dur%3D%221s%22%20repeatCount%3D%22indefinite%22%20%2F%3E%0A%20%20%3C%2Fcircle%3E%0A%20%20%3Ccircle%20cx%3D%2230%22%20cy%3D%226%22%20r%3D%223%22%20fill%3D%22rgba%280%2C%200%2C%200%2C%20.2%29%22%3E%0A%20%20%20%20%3Canimate%20attributeName%3D%22r%22%20values%3D%223%3B5%3B3%22%20calcMode%3D%22linear%22%20begin%3D%22.66s%22%20dur%3D%221s%22%20repeatCount%3D%22indefinite%22%20%2F%3E%0A%20%20%3C%2Fcircle%3E%0A%3C%2Fsvg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%274%27%20height%3D%274%27%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%3E%3Cpath%20stroke%3D%27%23ff0000%27%20fill%3D%27none%27%20stroke-linecap%3D%27round%27%20stroke-opacity%3D%27.75%27%20d%3D%27M0%203L2%201%204%203%27%2F%3E%3C%2Fsvg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%274%27%20height%3D%274%27%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%3E%3Cpath%20stroke%3D%27%2300A835%27%20fill%3D%27none%27%20stroke-linecap%3D%27round%27%20d%3D%27M0%203L2%201%204%203%27%2F%3E%3C%2Fsvg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("data:image/gif;base64,R0lGODlhCQAJAJEAAAAAAP///7u7u////yH5BAEAAAMALAAAAAAJAAkAAAIQnG+CqCN/mlyvsRUpThG6AgA7", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("data:image/gif;base64,R0lGODlhDQAKAIABALu7u////yH5BAEAAAEALAAAAAANAAoAAAIXjI8GybGu1JuxHoAfRNRW3TWXyF2YiRUAOw==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("data:image/gif;base64,R0lGODlhDgAKAIABALu7u////yH5BAEAAAEALAAAAAAOAAoAAAIajI8Hybbx4oOuqgTynJd6bGlWg3DkJzoaUAAAOw==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("data:image/gif;base64,R0lGODlhDgAKAIABALu7u////yH5BAEAAAEALAAAAAAOAAoAAAIZjI8Hybbx4oOuqgTynJf2Ln2NOHpQpmhAAQA7", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("data:image/gif;base64,R0lGODlhDgAKAIABALu7u////yH5BAEAAAEALAAAAAAOAAoAAAIajI8HybbxInR0zqeAdhtJlXwV1oCll2HaWgAAOw==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("data:image/gif;base64,R0lGODlhDgAKAIABALu7u////yH5BAEAAAEALAAAAAAOAAoAAAIajI8HybbxIoiuwjane4iq5GlW05GgIkIZUAAAOw==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("data:image/gif;base64,R0lGODlhDgAKAIABALu7u////yH5BAEAAAEALAAAAAAOAAoAAAIajI8HybbxIoiuwjan04jep1iZ1XRlAo5bVgAAOw==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("data:image/gif;base64,R0lGODlhEgAKAIABALu7u////yH5BAEAAAEALAAAAAASAAoAAAIfjI9poI0cgDywrhuxfbrzDEbQM2Ei5aRjmoySW4pAAQA7", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("data:image/gif;base64,R0lGODlhKAAKAIABALu7u////yH5BAEAAAEALAAAAAAoAAoAAAI5jI+pywcNY3sBWHdNrplytD2ellDeSVbp+GmWqaDqDMepc8t17Y4vBsK5hDyJMcI6KkuYU+jpjLoKADs=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("data:image/gif;base64,R0lGODlhKgAKAIABALu7u////yH5BAEAAAEALAAAAAAqAAoAAAI6jI+pywkNY3wG0GBvrsd2tXGYSGnfiF7ikpXemTpOiJScasYoDJJrjsG9gkCJ0ag6KhmaIe3pjDYBBQA7", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("data:image/gif;base64,R0lGODlhPgAKAIABALu7u////yH5BAEAAAEALAAAAAA+AAoAAAJPjI+py+0Knpz0xQDyuUhvfoGgIX5iSKZYgq5uNL5q69asZ8s5rrf0yZmpNkJZzFesBTu8TOlDVAabUyatguVhWduud3EyiUk45xhTTgMBBQA7", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("data:image/gif;base64,R0lGODlhLQAKAIABALu7u////yH5BAEAAAEALAAAAAAtAAoAAAI/jI+pywwNozSP1gDyyZcjb3UaRpXkWaXmZW4OqKLhBmLs+K263DkJK7OJeifh7FicKD9A1/IpGdKkyFpNmCkAADs=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("data:image/gif;base64,R0lGODlhFQAKAIABALu7uwAAACH5BAEAAAEALAAAAAAVAAoAAAIjjI+ZoN0cgDwSmnpz1NCueYERhnibZVKLNnbOq8IvKpJtVQAAOw==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("data:image/gif;base64,R0lGODlhJAAKAIAAALu7u////yH5BAEAAAEALAAAAAAkAAoAAAI0jI+py+2fwAHUSFvD3RlvG4HIp4nX5JFSpnZUJ6LlrM52OE7uSWosBHScgkSZj7dDKnWAAgA7", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("data:image/gif;base64,R0lGODlhJwAKAIABALu7uwAAACH5BAEAAAEALAAAAAAnAAoAAAI3jI+pywYNI3uB0gpsRtt5fFnfNZaVSYJil4Wo03Hv6Z62uOCgiXH1kZIIJ8NiIxRrAZNMZAtQAAA7", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("data:image/gif;base64,R0lGODlhHgAKAIABAKqqqv///yH5BAEAAAEALAAAAAAeAAoAAAItjI+pG8APjZOTzgtqy7I3f1yehmQcFY4WKZbqByutmW4aHUd6vfcVbgudgpYCADs=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("data:image/gif;base64,R0lGODlhDQAKAIAAALu7u////yH5BAEAAAEALAAAAAANAAoAAAIXjI8GybGuYnqUVSjvw26DzzXiqIDlVwAAOw==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("data:image/gif;base64,R0lGODlhDQAKAIABALu7u////yH5BAEAAAEALAAAAAANAAoAAAIXjI8GybH6HHt0qourxC6CvzXieHyeWQAAOw==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("data:image/gif;base64,R0lGODlhDQAKAIABALu7u////yH5BAEAAAEALAAAAAANAAoAAAIXjI8GybEOnmOvUoWznTqeuEjNSCqeGRUAOw==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("data:image/gif;base64,R0lGODdhDAAMAIABAMzMzP///ywAAAAADAAMAAACFoQfqYeabNyDMkBQb81Uat85nxguUAEAOw==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("../fonts/tinymce-mobile.woff?8x92w3", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("data:application/x-font-ttf;charset=utf-8;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("data:image/gif;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("data:image/gif;base64,R0lGODlhCwAHAIAAACgoKP///yH5BAEAAAEALAAAAAALAAcAAAIORI4JlrqN1oMSnmmZDQUAOw==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("data:image/gif;base64,R0lGODlhCwAHAIAAACgoKP///yH5BAEAAAEALAAAAAALAAcAAAINjI+AC7rWHIsPtmoxLAA7", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_60___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27><filter id=%27jstree-grayscale%27><feColorMatrix type=%27matrix%27 values=%270.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0%27/></filter></svg>#jstree-grayscale", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_61___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAkCAMAAAB/qqA+AAAABlBMVEUAAAAAAAClZ7nPAAAAAnRSTlMNAMM9s3UAAAAXSURBVHjajcEBAQAAAIKg/H/aCQZ70AUBjAATb6YPDgAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_62___ = new URL("../images/jsTree/32px.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_63___ = new URL("../images/jsTree/32px-dark.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_64___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAACAQMAAAB49I5GAAAABlBMVEUAAAAdHRvEkCwcAAAAAXRSTlMAQObYZgAAAAxJREFUCNdjAAMOBgAAGAAJMwQHdQAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_65___ = new URL("../images/jsTree/throbber.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_66___ = new URL("../images/jsTree/throbber-dark.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_67___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAACAQMAAABv1h6PAAAABlBMVEUAAAAdHRvEkCwcAAAAAXRSTlMAQObYZgAAAAxJREFUCNdjAAMHBgAAiABBI4gz9AAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_68___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAACAQMAAAAD0EyKAAAABlBMVEUAAAAdHRvEkCwcAAAAAXRSTlMAQObYZgAAAAxJREFUCNdjgIIGBgABCgCBvVLXcAAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_69___ = new URL("../images/jsTree/40px.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_70___ = new URL("../images/jsTree/40px-dark.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___, { hash: "#Nioicon" });
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_62___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_63___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
var ___CSS_LOADER_URL_REPLACEMENT_64___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_60___);
var ___CSS_LOADER_URL_REPLACEMENT_65___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_61___);
var ___CSS_LOADER_URL_REPLACEMENT_66___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_62___);
var ___CSS_LOADER_URL_REPLACEMENT_67___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_63___);
var ___CSS_LOADER_URL_REPLACEMENT_68___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_64___);
var ___CSS_LOADER_URL_REPLACEMENT_69___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_65___);
var ___CSS_LOADER_URL_REPLACEMENT_70___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_66___);
var ___CSS_LOADER_URL_REPLACEMENT_71___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_67___);
var ___CSS_LOADER_URL_REPLACEMENT_72___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_68___);
var ___CSS_LOADER_URL_REPLACEMENT_73___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_69___);
var ___CSS_LOADER_URL_REPLACEMENT_74___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_70___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** 01. FONTS */
@font-face {
  font-family: "DM Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: local("DM Sans Bold"), local("DMSans-Bold"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: bold;
  font-style: normal;
}
@font-face {
  font-family: "DM Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  src: local("DM Sans Medium"), local("DMSans-Medium"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "DM Sans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  src: local("DM Sans Regular"), local("DMSans-Regular"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
/**
 * Bootstrap (https://getbootstrap.com/) 
 */
:root {
  --blue: #559bfb;
  --indigo: #2c3782;
  --purple: #816bff;
  --pink: #ff63a5;
  --red: #e85347;
  --orange: #ffa353;
  --yellow: #f4bd0e;
  --green: #1ee0ac;
  --teal: #20c997;
  --cyan: #09c2de;
  --white: #fff;
  --gray: #6c757d;
  --gray-dark: #343a40;
  --primary: #4461F2;
  --secondary: #364a63;
  --success: #1ee0ac;
  --info: #09c2de;
  --warning: #f4bd0e;
  --danger: #e85347;
  --dark: #1c2b46;
  --gray: #8091a7;
  --light: #e5e9f2;
  --lighter: #f5f6fa;
  --breakpoint-xs: 0;
  --breakpoint-mb: 420px;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --breakpoint-xxl: 1540px;
  --font-family-sans-serif: ("DM Sans", sans-serif), "Helvetica Neue", Arial, "Noto Sans", sans-serif;
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

article,
aside,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section {
  display: block;
}

body {
  margin: 0;
  font-family: "DM Sans", sans-serif, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
  font-size: 0.775rem;
  font-weight: 400;
  line-height: 1.65;
  color: #526484;
  text-align: left;
  background-color: #f5f6fa;
}

[tabindex="-1"]:focus:not(:focus-visible) {
  outline: 0 !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  cursor: help;
  border-bottom: 0;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small {
  font-size: 80%;
}

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #9d72ff;
  text-decoration: none;
  background-color: transparent;
}
a:hover {
  color: #7a3fff;
  text-decoration: underline;
}

a:not([href]) {
  color: inherit;
  text-decoration: none;
}
a:not([href]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em;
}

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar;
}

figure {
  margin: 0 0 1rem;
}

img {
  vertical-align: middle;
  border-style: none;
}

svg {
  overflow: hidden;
  vertical-align: middle;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: #8094ae;
  text-align: left;
  caption-side: bottom;
}

th {
  text-align: inherit;
}

label {
  display: inline-block;
  margin-bottom: 16px;
}

button {
  border-radius: 0;
}

button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type=radio],
input[type=checkbox] {
  box-sizing: border-box;
  padding: 0;
}

textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
  cursor: pointer;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  margin-bottom: 0.5rem;
  font-family: "DM Sans", sans-serif;
  font-weight: 700;
  line-height: 1.1;
  color: #364a63;
}

h1, .h1 {
  font-size: 2rem;
}

h2, .h2 {
  font-size: 1.75rem;
}

h3, .h3 {
  font-size: 1.5rem;
}

h4, .h4 {
  font-size: 1.25rem;
}

h5, .h5 {
  font-size: 1.15rem;
}

h6, .h6 {
  font-size: 1rem;
}

.lead {
  font-size: 0.89125rem;
  font-weight: 400;
}

.display-1 {
  font-size: 6rem;
  font-weight: 300;
  line-height: 1.1;
}

.display-2 {
  font-size: 5.5rem;
  font-weight: 300;
  line-height: 1.1;
}

.display-3 {
  font-size: 4.5rem;
  font-weight: 300;
  line-height: 1.1;
}

.display-4 {
  font-size: 3.5rem;
  font-weight: 300;
  line-height: 1.1;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid #b7c2d0;
}

small,
.small {
  font-size: 85%;
  font-weight: 400;
}

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 90%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 0.96875rem;
}

.blockquote-footer {
  display: block;
  font-size: 85%;
  color: #b6c6e3;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #f5f6fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 90%;
  color: #6c757d;
}

code {
  font-size: 87.5%;
  color: #ff63a5;
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #212529;
  border-radius: 3px;
}
kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: 700;
}

pre {
  display: block;
  font-size: 87.5%;
  color: #212529;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm,
.container-mb {
  width: 100%;
  padding-right: 14px;
  padding-left: 14px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 420px) {
  .container-mb, .container {
    max-width: 420px;
  }
}
@media (min-width: 576px) {
  .container-sm, .container-mb, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container-mb, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container-mb, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container-mb, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1540px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container-mb, .container {
    max-width: 1440px;
  }
}
.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -14px;
  margin-left: -14px;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.no-gutters > .col,
.no-gutters > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}

.col-xxl,
.col-xxl-auto, .col-xxl-12, .col-xxl-11, .col-xxl-10, .col-xxl-9, .col-xxl-8, .col-xxl-7, .col-xxl-6, .col-xxl-5, .col-xxl-4, .col-xxl-3, .col-xxl-2, .col-xxl-1, .col-xl,
.col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg,
.col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md,
.col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm,
.col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col-mb,
.col-mb-auto, .col-mb-12, .col-mb-11, .col-mb-10, .col-mb-9, .col-mb-8, .col-mb-7, .col-mb-6, .col-mb-5, .col-mb-4, .col-mb-3, .col-mb-2, .col-mb-1, .col,
.col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
  position: relative;
  width: 100%;
  padding-right: 14px;
  padding-left: 14px;
}

.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

.row-cols-1 > * {
  flex: 0 0 100%;
  max-width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 50%;
  max-width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 25%;
  max-width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 20%;
  max-width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 16.6666666667%;
  max-width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}

.col-1 {
  flex: 0 0 8.33333333%;
  max-width: 8.33333333%;
}

.col-2 {
  flex: 0 0 16.66666667%;
  max-width: 16.66666667%;
}

.col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.col-4 {
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}

.col-5 {
  flex: 0 0 41.66666667%;
  max-width: 41.66666667%;
}

.col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.col-7 {
  flex: 0 0 58.33333333%;
  max-width: 58.33333333%;
}

.col-8 {
  flex: 0 0 66.66666667%;
  max-width: 66.66666667%;
}

.col-9 {
  flex: 0 0 75%;
  max-width: 75%;
}

.col-10 {
  flex: 0 0 83.33333333%;
  max-width: 83.33333333%;
}

.col-11 {
  flex: 0 0 91.66666667%;
  max-width: 91.66666667%;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.order-first {
  order: -1;
}

.order-last {
  order: 13;
}

.order-0 {
  order: 0;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.order-4 {
  order: 4;
}

.order-5 {
  order: 5;
}

.order-6 {
  order: 6;
}

.order-7 {
  order: 7;
}

.order-8 {
  order: 8;
}

.order-9 {
  order: 9;
}

.order-10 {
  order: 10;
}

.order-11 {
  order: 11;
}

.order-12 {
  order: 12;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

@media (min-width: 420px) {
  .col-mb {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-mb-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-mb-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-mb-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-mb-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-mb-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-mb-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-mb-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-mb-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-mb-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-mb-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-mb-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-mb-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-mb-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-mb-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-mb-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-mb-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-mb-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-mb-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-mb-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-mb-first {
    order: -1;
  }
  .order-mb-last {
    order: 13;
  }
  .order-mb-0 {
    order: 0;
  }
  .order-mb-1 {
    order: 1;
  }
  .order-mb-2 {
    order: 2;
  }
  .order-mb-3 {
    order: 3;
  }
  .order-mb-4 {
    order: 4;
  }
  .order-mb-5 {
    order: 5;
  }
  .order-mb-6 {
    order: 6;
  }
  .order-mb-7 {
    order: 7;
  }
  .order-mb-8 {
    order: 8;
  }
  .order-mb-9 {
    order: 9;
  }
  .order-mb-10 {
    order: 10;
  }
  .order-mb-11 {
    order: 11;
  }
  .order-mb-12 {
    order: 12;
  }
  .offset-mb-0 {
    margin-left: 0;
  }
  .offset-mb-1 {
    margin-left: 8.33333333%;
  }
  .offset-mb-2 {
    margin-left: 16.66666667%;
  }
  .offset-mb-3 {
    margin-left: 25%;
  }
  .offset-mb-4 {
    margin-left: 33.33333333%;
  }
  .offset-mb-5 {
    margin-left: 41.66666667%;
  }
  .offset-mb-6 {
    margin-left: 50%;
  }
  .offset-mb-7 {
    margin-left: 58.33333333%;
  }
  .offset-mb-8 {
    margin-left: 66.66666667%;
  }
  .offset-mb-9 {
    margin-left: 75%;
  }
  .offset-mb-10 {
    margin-left: 83.33333333%;
  }
  .offset-mb-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-sm-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-sm-first {
    order: -1;
  }
  .order-sm-last {
    order: 13;
  }
  .order-sm-0 {
    order: 0;
  }
  .order-sm-1 {
    order: 1;
  }
  .order-sm-2 {
    order: 2;
  }
  .order-sm-3 {
    order: 3;
  }
  .order-sm-4 {
    order: 4;
  }
  .order-sm-5 {
    order: 5;
  }
  .order-sm-6 {
    order: 6;
  }
  .order-sm-7 {
    order: 7;
  }
  .order-sm-8 {
    order: 8;
  }
  .order-sm-9 {
    order: 9;
  }
  .order-sm-10 {
    order: 10;
  }
  .order-sm-11 {
    order: 11;
  }
  .order-sm-12 {
    order: 12;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-md-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-md-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-md-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-md-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-md-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-md-first {
    order: -1;
  }
  .order-md-last {
    order: 13;
  }
  .order-md-0 {
    order: 0;
  }
  .order-md-1 {
    order: 1;
  }
  .order-md-2 {
    order: 2;
  }
  .order-md-3 {
    order: 3;
  }
  .order-md-4 {
    order: 4;
  }
  .order-md-5 {
    order: 5;
  }
  .order-md-6 {
    order: 6;
  }
  .order-md-7 {
    order: 7;
  }
  .order-md-8 {
    order: 8;
  }
  .order-md-9 {
    order: 9;
  }
  .order-md-10 {
    order: 10;
  }
  .order-md-11 {
    order: 11;
  }
  .order-md-12 {
    order: 12;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-lg-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-lg-first {
    order: -1;
  }
  .order-lg-last {
    order: 13;
  }
  .order-lg-0 {
    order: 0;
  }
  .order-lg-1 {
    order: 1;
  }
  .order-lg-2 {
    order: 2;
  }
  .order-lg-3 {
    order: 3;
  }
  .order-lg-4 {
    order: 4;
  }
  .order-lg-5 {
    order: 5;
  }
  .order-lg-6 {
    order: 6;
  }
  .order-lg-7 {
    order: 7;
  }
  .order-lg-8 {
    order: 8;
  }
  .order-lg-9 {
    order: 9;
  }
  .order-lg-10 {
    order: 10;
  }
  .order-lg-11 {
    order: 11;
  }
  .order-lg-12 {
    order: 12;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-xl-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-xl-first {
    order: -1;
  }
  .order-xl-last {
    order: 13;
  }
  .order-xl-0 {
    order: 0;
  }
  .order-xl-1 {
    order: 1;
  }
  .order-xl-2 {
    order: 2;
  }
  .order-xl-3 {
    order: 3;
  }
  .order-xl-4 {
    order: 4;
  }
  .order-xl-5 {
    order: 5;
  }
  .order-xl-6 {
    order: 6;
  }
  .order-xl-7 {
    order: 7;
  }
  .order-xl-8 {
    order: 8;
  }
  .order-xl-9 {
    order: 9;
  }
  .order-xl-10 {
    order: 10;
  }
  .order-xl-11 {
    order: 11;
  }
  .order-xl-12 {
    order: 12;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 1540px) {
  .col-xxl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-xxl-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-xxl-first {
    order: -1;
  }
  .order-xxl-last {
    order: 13;
  }
  .order-xxl-0 {
    order: 0;
  }
  .order-xxl-1 {
    order: 1;
  }
  .order-xxl-2 {
    order: 2;
  }
  .order-xxl-3 {
    order: 3;
  }
  .order-xxl-4 {
    order: 4;
  }
  .order-xxl-5 {
    order: 5;
  }
  .order-xxl-6 {
    order: 6;
  }
  .order-xxl-7 {
    order: 7;
  }
  .order-xxl-8 {
    order: 8;
  }
  .order-xxl-9 {
    order: 9;
  }
  .order-xxl-10 {
    order: 10;
  }
  .order-xxl-11 {
    order: 11;
  }
  .order-xxl-12 {
    order: 12;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #526484;
}
.table th,
.table td {
  padding: 0.5rem;
  vertical-align: top;
  border-top: 1px solid #dbdfea;
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dbdfea;
}
.table tbody + tbody {
  border-top: 2px solid #dbdfea;
}

.table-sm th,
.table-sm td {
  padding: 0.25rem;
}

.table-bordered {
  border: 1px solid #dbdfea;
}
.table-bordered th,
.table-bordered td {
  border: 1px solid #dbdfea;
}
.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 2px;
}

.table-borderless th,
.table-borderless td,
.table-borderless thead th,
.table-borderless tbody + tbody {
  border: 0;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: #f5f6fa;
}

.table-hover tbody tr:hover {
  color: #526484;
  background-color: #f5f6fa;
}

.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: #cbd3fb;
}
.table-primary th,
.table-primary td,
.table-primary thead th,
.table-primary tbody + tbody {
  border-color: #9eadf8;
}

.table-hover .table-primary:hover {
  background-color: #b3bff9;
}
.table-hover .table-primary:hover > td,
.table-hover .table-primary:hover > th {
  background-color: #b3bff9;
}

.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: #c7ccd3;
}
.table-secondary th,
.table-secondary td,
.table-secondary thead th,
.table-secondary tbody + tbody {
  border-color: #96a1ae;
}

.table-hover .table-secondary:hover {
  background-color: #b9bfc8;
}
.table-hover .table-secondary:hover > td,
.table-hover .table-secondary:hover > th {
  background-color: #b9bfc8;
}

.table-success,
.table-success > th,
.table-success > td {
  background-color: #c0f6e8;
}
.table-success th,
.table-success td,
.table-success thead th,
.table-success tbody + tbody {
  border-color: #8aefd4;
}

.table-hover .table-success:hover {
  background-color: #aaf3e0;
}
.table-hover .table-success:hover > td,
.table-hover .table-success:hover > th {
  background-color: #aaf3e0;
}

.table-info,
.table-info > th,
.table-info > td {
  background-color: #baeef6;
}
.table-info th,
.table-info td,
.table-info thead th,
.table-info tbody + tbody {
  border-color: #7fdfee;
}

.table-hover .table-info:hover {
  background-color: #a3e8f3;
}
.table-hover .table-info:hover > td,
.table-hover .table-info:hover > th {
  background-color: #a3e8f3;
}

.table-warning,
.table-warning > th,
.table-warning > td {
  background-color: #fcedbc;
}
.table-warning th,
.table-warning td,
.table-warning thead th,
.table-warning tbody + tbody {
  border-color: #f9dd82;
}

.table-hover .table-warning:hover {
  background-color: #fbe6a4;
}
.table-hover .table-warning:hover > td,
.table-hover .table-warning:hover > th {
  background-color: #fbe6a4;
}

.table-danger,
.table-danger > th,
.table-danger > td {
  background-color: #f9cfcb;
}
.table-danger th,
.table-danger td,
.table-danger thead th,
.table-danger tbody + tbody {
  border-color: #f3a69f;
}

.table-hover .table-danger:hover {
  background-color: #f6bab4;
}
.table-hover .table-danger:hover > td,
.table-hover .table-danger:hover > th {
  background-color: #f6bab4;
}

.table-dark,
.table-dark > th,
.table-dark > td {
  background-color: #bfc4cb;
}
.table-dark th,
.table-dark td,
.table-dark thead th,
.table-dark tbody + tbody {
  border-color: #89919f;
}

.table-hover .table-dark:hover {
  background-color: #b1b7c0;
}
.table-hover .table-dark:hover > td,
.table-hover .table-dark:hover > th {
  background-color: #b1b7c0;
}

.table-gray,
.table-gray > th,
.table-gray > td {
  background-color: #dbe0e6;
}
.table-gray th,
.table-gray td,
.table-gray thead th,
.table-gray tbody + tbody {
  border-color: #bdc6d1;
}

.table-hover .table-gray:hover {
  background-color: #ccd3dc;
}
.table-hover .table-gray:hover > td,
.table-hover .table-gray:hover > th {
  background-color: #ccd3dc;
}

.table-light,
.table-light > th,
.table-light > td {
  background-color: #f8f9fb;
}
.table-light th,
.table-light td,
.table-light thead th,
.table-light tbody + tbody {
  border-color: #f1f4f8;
}

.table-hover .table-light:hover {
  background-color: #e8ebf2;
}
.table-hover .table-light:hover > td,
.table-hover .table-light:hover > th {
  background-color: #e8ebf2;
}

.table-lighter,
.table-lighter > th,
.table-lighter > td {
  background-color: #fcfcfe;
}
.table-lighter th,
.table-lighter td,
.table-lighter thead th,
.table-lighter tbody + tbody {
  border-color: #fafafc;
}

.table-hover .table-lighter:hover {
  background-color: #e9e9f8;
}
.table-hover .table-lighter:hover > td,
.table-hover .table-lighter:hover > th {
  background-color: #e9e9f8;
}

.table-active,
.table-active > th,
.table-active > td {
  background-color: #f5f6fa;
}

.table-hover .table-active:hover {
  background-color: #e4e7f2;
}
.table-hover .table-active:hover > td,
.table-hover .table-active:hover > th {
  background-color: #e4e7f2;
}

.table .thead-dark th {
  color: #fff;
  background-color: #2b3748;
  border-color: #3c4d62;
}
.table .thead-light th {
  color: #364a63;
  background-color: #f5f6fa;
  border-color: #dbdfea;
}

.table-dark {
  color: #fff;
  background-color: #2b3748;
}
.table-dark th,
.table-dark td,
.table-dark thead th {
  border-color: #3c4d62;
}
.table-dark.table-bordered {
  border: 0;
}
.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: #344357;
}
.table-dark.table-hover tbody tr:hover {
  color: #fff;
  background-color: #344357;
}

@media (max-width: 419.98px) {
  .table-responsive-mb {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-mb > .table-bordered {
    border: 0;
  }
}
@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-sm > .table-bordered {
    border: 0;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-md > .table-bordered {
    border: 0;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-lg > .table-bordered {
    border: 0;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-xl > .table-bordered {
    border: 0;
  }
}
@media (max-width: 1539.98px) {
  .table-responsive-xxl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-xxl > .table-bordered {
    border: 0;
  }
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.table-responsive > .table-bordered {
  border: 0;
}

.form-control, .rdl-filter, .dual-listbox .dual-listbox__search, div.dataTables_wrapper div.dataTables_filter input {
  display: block;
  width: 100%;
  height: calc(2.125rem + 2px);
  padding: 0.4375rem 1rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.25rem;
  color: #3c4d62;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #dbdfea;
  border-radius: 4px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control, .rdl-filter, .dual-listbox .dual-listbox__search, div.dataTables_wrapper div.dataTables_filter input {
    transition: none;
  }
}
.form-control::-ms-expand, .rdl-filter::-ms-expand, .dual-listbox .dual-listbox__search::-ms-expand, div.dataTables_wrapper div.dataTables_filter input::-ms-expand {
  background-color: transparent;
  border: 0;
}
.form-control:-moz-focusring, .rdl-filter:-moz-focusring, .dual-listbox .dual-listbox__search:-moz-focusring, div.dataTables_wrapper div.dataTables_filter input:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #3c4d62;
}
.form-control:focus, .rdl-filter:focus, .dual-listbox .dual-listbox__search:focus, div.dataTables_wrapper div.dataTables_filter input:focus {
  color: #3c4d62;
  background-color: #fff;
  border-color: #4461F2;
  outline: 0;
  box-shadow: 0 0 0 3px rgba(68, 97, 242, 0.1);
}
.form-control::placeholder, .rdl-filter::placeholder, .dual-listbox .dual-listbox__search::placeholder, div.dataTables_wrapper div.dataTables_filter input::placeholder {
  color: #b6c6e3;
  opacity: 1;
}
.form-control:disabled, .rdl-filter:disabled, .dual-listbox .dual-listbox__search:disabled, div.dataTables_wrapper div.dataTables_filter input:disabled, .form-control[readonly], [readonly].rdl-filter, .dual-listbox [readonly].dual-listbox__search, div.dataTables_wrapper div.dataTables_filter input[readonly] {
  background-color: #f5f6fa;
  opacity: 1;
}

input[type=date].form-control, input[type=date].rdl-filter, .dual-listbox input[type=date].dual-listbox__search, div.dataTables_wrapper div.dataTables_filter input[type=date],
input[type=time].form-control,
input[type=time].rdl-filter,
.dual-listbox input[type=time].dual-listbox__search,
div.dataTables_wrapper div.dataTables_filter input[type=time],
input[type=datetime-local].form-control,
input[type=datetime-local].rdl-filter,
.dual-listbox input[type=datetime-local].dual-listbox__search,
div.dataTables_wrapper div.dataTables_filter input[type=datetime-local],
input[type=month].form-control,
input[type=month].rdl-filter,
.dual-listbox input[type=month].dual-listbox__search,
div.dataTables_wrapper div.dataTables_filter input[type=month] {
  appearance: none;
}

input[type=date]::-webkit-calendar-picker-indicator, input[type=time]::-webkit-calendar-picker-indicator {
  background: transparent;
  bottom: 0;
  color: transparent;
  cursor: pointer;
  height: auto;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: auto;
}

select.form-control:focus::-ms-value, select.rdl-filter:focus::-ms-value, .dual-listbox select.dual-listbox__search:focus::-ms-value {
  color: #3c4d62;
  background-color: #fff;
}

.form-control-file,
.form-control-range {
  display: block;
  width: 100%;
}

.col-form-label {
  padding-top: calc(0.4375rem + 1px);
  padding-bottom: calc(0.4375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.25rem;
}

.col-form-label-lg {
  padding-top: calc(0.6875rem + 1px);
  padding-bottom: calc(0.6875rem + 1px);
  font-size: 0.9375rem;
  line-height: 1.25rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.75rem;
  line-height: 1.25rem;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.4375rem 0;
  margin-bottom: 0;
  font-size: 0.8125rem;
  line-height: 1.25rem;
  color: #364a63;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  height: calc(1.75rem + 2px);
  padding: 0.25rem 1rem;
  font-size: 0.75rem;
  line-height: 1.25rem;
  border-radius: 3px;
}

.form-control-lg {
  height: calc(2.625rem + 2px);
  padding: 0.6875rem 1rem;
  font-size: 0.9375rem;
  line-height: 1.25rem;
  border-radius: 5px;
}

select.form-control[size], select[size].rdl-filter, .dual-listbox select[size].dual-listbox__search, select.form-control[multiple], select[multiple].rdl-filter, .dual-listbox select[multiple].dual-listbox__search {
  height: auto;
}

textarea.form-control, textarea.rdl-filter, .dual-listbox textarea.dual-listbox__search {
  height: auto;
}

.form-group {
  margin-bottom: 1rem;
}

.form-text {
  display: block;
  margin-top: 0.25rem;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-row > .col,
.form-row > [class*=col-] {
  padding-right: 5px;
  padding-left: 5px;
}

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}

.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  color: #8094ae;
}

.form-check-label {
  margin-bottom: 0;
}

.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
}
.form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #1ee0ac;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.75rem;
  margin-top: 0.1rem;
  font-size: 0.8125rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(30, 224, 172, 0.9);
  border-radius: 3px;
}
.form-row > .col > .valid-tooltip, .form-row > [class*=col-] > .valid-tooltip {
  left: 5px;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .was-validated .rdl-filter:valid, .was-validated .dual-listbox .dual-listbox__search:valid, .dual-listbox .was-validated .dual-listbox__search:valid, .was-validated div.dataTables_wrapper div.dataTables_filter input:valid, div.dataTables_wrapper div.dataTables_filter .was-validated input:valid, .form-control.is-valid, .is-valid.rdl-filter, .dual-listbox .is-valid.dual-listbox__search, div.dataTables_wrapper div.dataTables_filter input.is-valid {
  border-color: #1ee0ac;
  padding-right: 2.125rem !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-repeat: no-repeat;
  background-position: right add(0.3125rem, 0.21875rem) center;
  background-size: add(0.625rem, 0.4375rem) add(0.625rem, 0.4375rem);
}
.was-validated .form-control:valid:focus, .was-validated .rdl-filter:valid:focus, .was-validated .dual-listbox .dual-listbox__search:valid:focus, .dual-listbox .was-validated .dual-listbox__search:valid:focus, .was-validated div.dataTables_wrapper div.dataTables_filter input:valid:focus, div.dataTables_wrapper div.dataTables_filter .was-validated input:valid:focus, .form-control.is-valid:focus, .is-valid.rdl-filter:focus, .dual-listbox .is-valid.dual-listbox__search:focus, div.dataTables_wrapper div.dataTables_filter input.is-valid:focus {
  border-color: #1ee0ac;
  box-shadow: 0 0 0 0.2rem rgba(30, 224, 172, 0.25);
}

.was-validated select.form-control:valid, .was-validated select.rdl-filter:valid, .was-validated .dual-listbox select.dual-listbox__search:valid, .dual-listbox .was-validated select.dual-listbox__search:valid, select.form-control.is-valid, select.is-valid.rdl-filter, .dual-listbox select.is-valid.dual-listbox__search {
  padding-right: 4rem !important;
  background-position: right 2rem center;
}

.was-validated textarea.form-control:valid, .was-validated textarea.rdl-filter:valid, .was-validated .dual-listbox textarea.dual-listbox__search:valid, .dual-listbox .was-validated textarea.dual-listbox__search:valid, textarea.form-control.is-valid, textarea.is-valid.rdl-filter, .dual-listbox textarea.is-valid.dual-listbox__search {
  padding-right: 2.125rem;
  background-position: top add(0.3125rem, 0.21875rem) right add(0.3125rem, 0.21875rem);
}

.was-validated .custom-select:valid, .was-validated div.dataTables_wrapper div.dataTables_length select:valid, div.dataTables_wrapper div.dataTables_length .was-validated select:valid, .custom-select.is-valid, div.dataTables_wrapper div.dataTables_length select.is-valid {
  border-color: #1ee0ac;
  padding-right: calc(0.75em + 2.65625rem) !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) right 1rem center/8px 10px no-repeat, #fff url(${___CSS_LOADER_URL_REPLACEMENT_15___}) center right 2rem/add(0.625rem, 0.4375rem) add(0.625rem, 0.4375rem) no-repeat;
}
.was-validated .custom-select:valid:focus, .was-validated div.dataTables_wrapper div.dataTables_length select:valid:focus, div.dataTables_wrapper div.dataTables_length .was-validated select:valid:focus, .custom-select.is-valid:focus, div.dataTables_wrapper div.dataTables_length select.is-valid:focus {
  border-color: #1ee0ac;
  box-shadow: 0 0 0 0.2rem rgba(30, 224, 172, 0.25);
}

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #1ee0ac;
}
.was-validated .form-check-input:valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {
  color: #1ee0ac;
}
.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {
  border-color: #1ee0ac;
}
.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {
  border-color: #4ae7bd;
  background-color: #4ae7bd;
}
.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(30, 224, 172, 0.25);
}
.was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #1ee0ac;
}

.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {
  border-color: #1ee0ac;
}
.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {
  border-color: #1ee0ac;
  box-shadow: 0 0 0 0.2rem rgba(30, 224, 172, 0.25);
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #e85347;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.75rem;
  margin-top: 0.1rem;
  font-size: 0.8125rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(232, 83, 71, 0.9);
  border-radius: 3px;
}
.form-row > .col > .invalid-tooltip, .form-row > [class*=col-] > .invalid-tooltip {
  left: 5px;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .was-validated .rdl-filter:invalid, .was-validated .dual-listbox .dual-listbox__search:invalid, .dual-listbox .was-validated .dual-listbox__search:invalid, .was-validated div.dataTables_wrapper div.dataTables_filter input:invalid, div.dataTables_wrapper div.dataTables_filter .was-validated input:invalid, .form-control.is-invalid, .is-invalid.rdl-filter, .dual-listbox .is-invalid.dual-listbox__search, div.dataTables_wrapper div.dataTables_filter input.is-invalid {
  border-color: #e85347;
  padding-right: 2.125rem !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-repeat: no-repeat;
  background-position: right add(0.3125rem, 0.21875rem) center;
  background-size: add(0.625rem, 0.4375rem) add(0.625rem, 0.4375rem);
}
.was-validated .form-control:invalid:focus, .was-validated .rdl-filter:invalid:focus, .was-validated .dual-listbox .dual-listbox__search:invalid:focus, .dual-listbox .was-validated .dual-listbox__search:invalid:focus, .was-validated div.dataTables_wrapper div.dataTables_filter input:invalid:focus, div.dataTables_wrapper div.dataTables_filter .was-validated input:invalid:focus, .form-control.is-invalid:focus, .is-invalid.rdl-filter:focus, .dual-listbox .is-invalid.dual-listbox__search:focus, div.dataTables_wrapper div.dataTables_filter input.is-invalid:focus {
  border-color: #e85347;
  box-shadow: 0 0 0 0.2rem rgba(232, 83, 71, 0.25);
}

.was-validated select.form-control:invalid, .was-validated select.rdl-filter:invalid, .was-validated .dual-listbox select.dual-listbox__search:invalid, .dual-listbox .was-validated select.dual-listbox__search:invalid, select.form-control.is-invalid, select.is-invalid.rdl-filter, .dual-listbox select.is-invalid.dual-listbox__search {
  padding-right: 4rem !important;
  background-position: right 2rem center;
}

.was-validated textarea.form-control:invalid, .was-validated textarea.rdl-filter:invalid, .was-validated .dual-listbox textarea.dual-listbox__search:invalid, .dual-listbox .was-validated textarea.dual-listbox__search:invalid, textarea.form-control.is-invalid, textarea.is-invalid.rdl-filter, .dual-listbox textarea.is-invalid.dual-listbox__search {
  padding-right: 2.125rem;
  background-position: top add(0.3125rem, 0.21875rem) right add(0.3125rem, 0.21875rem);
}

.was-validated .custom-select:invalid, .was-validated div.dataTables_wrapper div.dataTables_length select:invalid, div.dataTables_wrapper div.dataTables_length .was-validated select:invalid, .custom-select.is-invalid, div.dataTables_wrapper div.dataTables_length select.is-invalid {
  border-color: #e85347;
  padding-right: calc(0.75em + 2.65625rem) !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) right 1rem center/8px 10px no-repeat, #fff url(${___CSS_LOADER_URL_REPLACEMENT_17___}) center right 2rem/add(0.625rem, 0.4375rem) add(0.625rem, 0.4375rem) no-repeat;
}
.was-validated .custom-select:invalid:focus, .was-validated div.dataTables_wrapper div.dataTables_length select:invalid:focus, div.dataTables_wrapper div.dataTables_length .was-validated select:invalid:focus, .custom-select.is-invalid:focus, div.dataTables_wrapper div.dataTables_length select.is-invalid:focus {
  border-color: #e85347;
  box-shadow: 0 0 0 0.2rem rgba(232, 83, 71, 0.25);
}

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #e85347;
}
.was-validated .form-check-input:invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {
  color: #e85347;
}
.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {
  border-color: #e85347;
}
.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  border-color: #ee7d74;
  background-color: #ee7d74;
}
.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(232, 83, 71, 0.25);
}
.was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #e85347;
}

.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #e85347;
}
.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {
  border-color: #e85347;
  box-shadow: 0 0 0 0.2rem rgba(232, 83, 71, 0.25);
}

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}
.form-inline .form-check {
  width: 100%;
}
@media (min-width: 576px) {
  .form-inline label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
  }
  .form-inline .form-group {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row wrap;
    align-items: center;
    margin-bottom: 0;
  }
  .form-inline .form-control, .form-inline .rdl-filter, .form-inline .dual-listbox .dual-listbox__search, .dual-listbox .form-inline .dual-listbox__search, .form-inline div.dataTables_wrapper div.dataTables_filter input, div.dataTables_wrapper div.dataTables_filter .form-inline input {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }
  .form-inline .form-control-plaintext {
    display: inline-block;
  }
  .form-inline .input-group,
  .form-inline .custom-select,
  .form-inline div.dataTables_wrapper div.dataTables_length select,
  div.dataTables_wrapper div.dataTables_length .form-inline select {
    width: auto;
  }
  .form-inline .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding-left: 0;
  }
  .form-inline .form-check-input {
    position: relative;
    flex-shrink: 0;
    margin-top: 0;
    margin-right: 0.25rem;
    margin-left: 0;
  }
  .form-inline .custom-control {
    align-items: center;
    justify-content: center;
  }
  .form-inline .custom-control-label {
    margin-bottom: 0;
  }
}

.btn, .dual-listbox .dual-listbox__button {
  display: inline-block;
  font-family: "DM Sans", sans-serif;
  font-weight: 700;
  color: #526484;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.4375rem 1.125rem;
  font-size: 0.8125rem;
  line-height: 1.25rem;
  border-radius: 4px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn, .dual-listbox .dual-listbox__button {
    transition: none;
  }
}
.btn:hover, .dual-listbox .dual-listbox__button:hover {
  color: #526484;
  text-decoration: none;
}
.btn:focus, .dual-listbox .dual-listbox__button:focus, .btn.focus, .dual-listbox .focus.dual-listbox__button {
  outline: 0;
  box-shadow: 0 0 0 3px rgba(68, 97, 242, 0.1);
}
.btn.disabled, .dual-listbox .disabled.dual-listbox__button, .btn:disabled, .dual-listbox .dual-listbox__button:disabled {
  opacity: 0.5;
}
.btn:not(:disabled):not(.disabled), .dual-listbox .dual-listbox__button:not(:disabled):not(.disabled) {
  cursor: pointer;
}
a.btn.disabled, .dual-listbox a.disabled.dual-listbox__button,
fieldset:disabled a.btn,
fieldset:disabled .dual-listbox a.dual-listbox__button,
.dual-listbox fieldset:disabled a.dual-listbox__button {
  pointer-events: none;
}

.btn-primary {
  color: #fff;
  background-color: #4461F2;
  border-color: #4461F2;
}
.btn-primary:hover {
  color: #fff;
  background-color: #2043f0;
  border-color: #1439ef;
}
.btn-primary:focus, .btn-primary.focus {
  color: #fff;
  background-color: #2043f0;
  border-color: #1439ef;
  box-shadow: 0 0 0 0.2rem rgba(96, 121, 244, 0.5);
}
.btn-primary.disabled, .btn-primary:disabled {
  color: #fff;
  background-color: #4461F2;
  border-color: #4461F2;
}
.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #1439ef;
  border-color: #1034e6;
}
.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(96, 121, 244, 0.5);
}

.btn-secondary {
  color: #fff;
  background-color: #364a63;
  border-color: #364a63;
}
.btn-secondary:hover {
  color: #fff;
  background-color: #29384a;
  border-color: #243142;
}
.btn-secondary:focus, .btn-secondary.focus {
  color: #fff;
  background-color: #29384a;
  border-color: #243142;
  box-shadow: 0 0 0 0.2rem rgba(84, 101, 122, 0.5);
}
.btn-secondary.disabled, .btn-secondary:disabled {
  color: #fff;
  background-color: #364a63;
  border-color: #364a63;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #243142;
  border-color: #202b3a;
}
.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(84, 101, 122, 0.5);
}

.btn-success {
  color: #fff;
  background-color: #1ee0ac;
  border-color: #1ee0ac;
}
.btn-success:hover {
  color: #fff;
  background-color: #19be92;
  border-color: #18b389;
}
.btn-success:focus, .btn-success.focus {
  color: #fff;
  background-color: #19be92;
  border-color: #18b389;
  box-shadow: 0 0 0 0.2rem rgba(64, 229, 184, 0.5);
}
.btn-success.disabled, .btn-success:disabled {
  color: #fff;
  background-color: #1ee0ac;
  border-color: #1ee0ac;
}
.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {
  color: #fff;
  background-color: #18b389;
  border-color: #16a881;
}
.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(64, 229, 184, 0.5);
}

.btn-info {
  color: #fff;
  background-color: #09c2de;
  border-color: #09c2de;
}
.btn-info:hover {
  color: #fff;
  background-color: #08a2b9;
  border-color: #0797ad;
}
.btn-info:focus, .btn-info.focus {
  color: #fff;
  background-color: #08a2b9;
  border-color: #0797ad;
  box-shadow: 0 0 0 0.2rem rgba(46, 203, 227, 0.5);
}
.btn-info.disabled, .btn-info:disabled {
  color: #fff;
  background-color: #09c2de;
  border-color: #09c2de;
}
.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {
  color: #fff;
  background-color: #0797ad;
  border-color: #078ca1;
}
.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(46, 203, 227, 0.5);
}

.btn-warning {
  color: #fff;
  background-color: #f4bd0e;
  border-color: #f4bd0e;
}
.btn-warning:hover {
  color: #fff;
  background-color: #d2a20a;
  border-color: #c69909;
}
.btn-warning:focus, .btn-warning.focus {
  color: #fff;
  background-color: #d2a20a;
  border-color: #c69909;
  box-shadow: 0 0 0 0.2rem rgba(246, 199, 50, 0.5);
}
.btn-warning.disabled, .btn-warning:disabled {
  color: #fff;
  background-color: #f4bd0e;
  border-color: #f4bd0e;
}
.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {
  color: #fff;
  background-color: #c69909;
  border-color: #ba8f08;
}
.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(246, 199, 50, 0.5);
}

.btn-danger {
  color: #fff;
  background-color: #e85347;
  border-color: #e85347;
}
.btn-danger:hover {
  color: #fff;
  background-color: #e43325;
  border-color: #e02b1c;
}
.btn-danger:focus, .btn-danger.focus {
  color: #fff;
  background-color: #e43325;
  border-color: #e02b1c;
  box-shadow: 0 0 0 0.2rem rgba(235, 109, 99, 0.5);
}
.btn-danger.disabled, .btn-danger:disabled {
  color: #fff;
  background-color: #e85347;
  border-color: #e85347;
}
.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: #e02b1c;
  border-color: #d5281b;
}
.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(235, 109, 99, 0.5);
}

.btn-dark {
  color: #fff;
  background-color: #1c2b46;
  border-color: #1c2b46;
}
.btn-dark:hover {
  color: #fff;
  background-color: #111a2b;
  border-color: #0d1522;
}
.btn-dark:focus, .btn-dark.focus {
  color: #fff;
  background-color: #111a2b;
  border-color: #0d1522;
  box-shadow: 0 0 0 0.2rem rgba(62, 75, 98, 0.5);
}
.btn-dark.disabled, .btn-dark:disabled {
  color: #fff;
  background-color: #1c2b46;
  border-color: #1c2b46;
}
.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: #0d1522;
  border-color: #0a0f18;
}
.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(62, 75, 98, 0.5);
}

.btn-gray {
  color: #fff;
  background-color: #8091a7;
  border-color: #8091a7;
}
.btn-gray:hover {
  color: #fff;
  background-color: #697d97;
  border-color: #647790;
}
.btn-gray:focus, .btn-gray.focus {
  color: #fff;
  background-color: #697d97;
  border-color: #647790;
  box-shadow: 0 0 0 0.2rem rgba(147, 162, 180, 0.5);
}
.btn-gray.disabled, .btn-gray:disabled {
  color: #fff;
  background-color: #8091a7;
  border-color: #8091a7;
}
.btn-gray:not(:disabled):not(.disabled):active, .btn-gray:not(:disabled):not(.disabled).active, .show > .btn-gray.dropdown-toggle {
  color: #fff;
  background-color: #647790;
  border-color: #5f7189;
}
.btn-gray:not(:disabled):not(.disabled):active:focus, .btn-gray:not(:disabled):not(.disabled).active:focus, .show > .btn-gray.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(147, 162, 180, 0.5);
}

.btn-light, .dual-listbox .dual-listbox__button {
  color: #101924;
  background-color: #e5e9f2;
  border-color: #e5e9f2;
}
.btn-light:hover, .dual-listbox .dual-listbox__button:hover {
  color: #101924;
  background-color: #ccd3e5;
  border-color: #c3cce1;
}
.btn-light:focus, .dual-listbox .dual-listbox__button:focus, .btn-light.focus, .dual-listbox .focus.dual-listbox__button {
  color: #101924;
  background-color: #ccd3e5;
  border-color: #c3cce1;
  box-shadow: 0 0 0 0.2rem rgba(197, 202, 211, 0.5);
}
.btn-light.disabled, .dual-listbox .disabled.dual-listbox__button, .btn-light:disabled, .dual-listbox .dual-listbox__button:disabled {
  color: #101924;
  background-color: #e5e9f2;
  border-color: #e5e9f2;
}
.btn-light:not(:disabled):not(.disabled):active, .dual-listbox .dual-listbox__button:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .dual-listbox .dual-listbox__button:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle, .dual-listbox .show > .dropdown-toggle.dual-listbox__button {
  color: #101924;
  background-color: #c3cce1;
  border-color: #bbc5dd;
}
.btn-light:not(:disabled):not(.disabled):active:focus, .dual-listbox .dual-listbox__button:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .dual-listbox .dual-listbox__button:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus, .dual-listbox .show > .dropdown-toggle.dual-listbox__button:focus {
  box-shadow: 0 0 0 0.2rem rgba(197, 202, 211, 0.5);
}

.btn-lighter {
  color: #101924;
  background-color: #f5f6fa;
  border-color: #f5f6fa;
}
.btn-lighter:hover {
  color: #101924;
  background-color: #dcdfed;
  border-color: #d3d7e9;
}
.btn-lighter:focus, .btn-lighter.focus {
  color: #101924;
  background-color: #dcdfed;
  border-color: #d3d7e9;
  box-shadow: 0 0 0 0.2rem rgba(211, 213, 218, 0.5);
}
.btn-lighter.disabled, .btn-lighter:disabled {
  color: #101924;
  background-color: #f5f6fa;
  border-color: #f5f6fa;
}
.btn-lighter:not(:disabled):not(.disabled):active, .btn-lighter:not(:disabled):not(.disabled).active, .show > .btn-lighter.dropdown-toggle {
  color: #101924;
  background-color: #d3d7e9;
  border-color: #cbd0e5;
}
.btn-lighter:not(:disabled):not(.disabled):active:focus, .btn-lighter:not(:disabled):not(.disabled).active:focus, .show > .btn-lighter.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(211, 213, 218, 0.5);
}

.btn-outline-primary {
  color: #4461F2;
  border-color: #4461F2;
}
.btn-outline-primary:hover {
  color: #fff;
  background-color: #4461F2;
  border-color: #4461F2;
}
.btn-outline-primary:focus, .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(68, 97, 242, 0.5);
}
.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #4461F2;
  background-color: transparent;
}
.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #4461F2;
  border-color: #4461F2;
}
.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(68, 97, 242, 0.5);
}

.btn-outline-secondary {
  color: #364a63;
  border-color: #364a63;
}
.btn-outline-secondary:hover {
  color: #fff;
  background-color: #364a63;
  border-color: #364a63;
}
.btn-outline-secondary:focus, .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(54, 74, 99, 0.5);
}
.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
  color: #364a63;
  background-color: transparent;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #364a63;
  border-color: #364a63;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(54, 74, 99, 0.5);
}

.btn-outline-success {
  color: #1ee0ac;
  border-color: #1ee0ac;
}
.btn-outline-success:hover {
  color: #fff;
  background-color: #1ee0ac;
  border-color: #1ee0ac;
}
.btn-outline-success:focus, .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(30, 224, 172, 0.5);
}
.btn-outline-success.disabled, .btn-outline-success:disabled {
  color: #1ee0ac;
  background-color: transparent;
}
.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #1ee0ac;
  border-color: #1ee0ac;
}
.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(30, 224, 172, 0.5);
}

.btn-outline-info {
  color: #09c2de;
  border-color: #09c2de;
}
.btn-outline-info:hover {
  color: #fff;
  background-color: #09c2de;
  border-color: #09c2de;
}
.btn-outline-info:focus, .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(9, 194, 222, 0.5);
}
.btn-outline-info.disabled, .btn-outline-info:disabled {
  color: #09c2de;
  background-color: transparent;
}
.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #09c2de;
  border-color: #09c2de;
}
.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(9, 194, 222, 0.5);
}

.btn-outline-warning {
  color: #f4bd0e;
  border-color: #f4bd0e;
}
.btn-outline-warning:hover {
  color: #fff;
  background-color: #f4bd0e;
  border-color: #f4bd0e;
}
.btn-outline-warning:focus, .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 189, 14, 0.5);
}
.btn-outline-warning.disabled, .btn-outline-warning:disabled {
  color: #f4bd0e;
  background-color: transparent;
}
.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {
  color: #fff;
  background-color: #f4bd0e;
  border-color: #f4bd0e;
}
.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(244, 189, 14, 0.5);
}

.btn-outline-danger {
  color: #e85347;
  border-color: #e85347;
}
.btn-outline-danger:hover {
  color: #fff;
  background-color: #e85347;
  border-color: #e85347;
}
.btn-outline-danger:focus, .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 83, 71, 0.5);
}
.btn-outline-danger.disabled, .btn-outline-danger:disabled {
  color: #e85347;
  background-color: transparent;
}
.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #e85347;
  border-color: #e85347;
}
.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(232, 83, 71, 0.5);
}

.btn-outline-dark {
  color: #1c2b46;
  border-color: #1c2b46;
}
.btn-outline-dark:hover {
  color: #fff;
  background-color: #1c2b46;
  border-color: #1c2b46;
}
.btn-outline-dark:focus, .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(28, 43, 70, 0.5);
}
.btn-outline-dark.disabled, .btn-outline-dark:disabled {
  color: #1c2b46;
  background-color: transparent;
}
.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #1c2b46;
  border-color: #1c2b46;
}
.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(28, 43, 70, 0.5);
}

.btn-outline-gray {
  color: #8091a7;
  border-color: #8091a7;
}
.btn-outline-gray:hover {
  color: #fff;
  background-color: #8091a7;
  border-color: #8091a7;
}
.btn-outline-gray:focus, .btn-outline-gray.focus {
  box-shadow: 0 0 0 0.2rem rgba(128, 145, 167, 0.5);
}
.btn-outline-gray.disabled, .btn-outline-gray:disabled {
  color: #8091a7;
  background-color: transparent;
}
.btn-outline-gray:not(:disabled):not(.disabled):active, .btn-outline-gray:not(:disabled):not(.disabled).active, .show > .btn-outline-gray.dropdown-toggle {
  color: #fff;
  background-color: #8091a7;
  border-color: #8091a7;
}
.btn-outline-gray:not(:disabled):not(.disabled):active:focus, .btn-outline-gray:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-gray.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(128, 145, 167, 0.5);
}

.btn-outline-light, .dt-buttons .btn-secondary {
  color: #e5e9f2;
  border-color: #e5e9f2;
}
.btn-outline-light:hover, .dt-buttons .btn-secondary:hover {
  color: #101924;
  background-color: #e5e9f2;
  border-color: #e5e9f2;
}
.btn-outline-light:focus, .dt-buttons .btn-secondary:focus, .btn-outline-light.focus, .dt-buttons .focus.btn-secondary {
  box-shadow: 0 0 0 0.2rem rgba(229, 233, 242, 0.5);
}
.btn-outline-light.disabled, .dt-buttons .disabled.btn-secondary, .btn-outline-light:disabled, .dt-buttons .btn-secondary:disabled {
  color: #e5e9f2;
  background-color: transparent;
}
.btn-outline-light:not(:disabled):not(.disabled):active, .dt-buttons .btn-secondary:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .dt-buttons .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle, .dt-buttons .show > .dropdown-toggle.btn-secondary {
  color: #101924;
  background-color: #e5e9f2;
  border-color: #e5e9f2;
}
.btn-outline-light:not(:disabled):not(.disabled):active:focus, .dt-buttons .btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .dt-buttons .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus, .dt-buttons .show > .dropdown-toggle.btn-secondary:focus {
  box-shadow: 0 0 0 0.2rem rgba(229, 233, 242, 0.5);
}

.btn-outline-lighter {
  color: #f5f6fa;
  border-color: #f5f6fa;
}
.btn-outline-lighter:hover {
  color: #101924;
  background-color: #f5f6fa;
  border-color: #f5f6fa;
}
.btn-outline-lighter:focus, .btn-outline-lighter.focus {
  box-shadow: 0 0 0 0.2rem rgba(245, 246, 250, 0.5);
}
.btn-outline-lighter.disabled, .btn-outline-lighter:disabled {
  color: #f5f6fa;
  background-color: transparent;
}
.btn-outline-lighter:not(:disabled):not(.disabled):active, .btn-outline-lighter:not(:disabled):not(.disabled).active, .show > .btn-outline-lighter.dropdown-toggle {
  color: #101924;
  background-color: #f5f6fa;
  border-color: #f5f6fa;
}
.btn-outline-lighter:not(:disabled):not(.disabled):active:focus, .btn-outline-lighter:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-lighter.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(245, 246, 250, 0.5);
}

.btn-link {
  font-weight: 400;
  color: #9d72ff;
  text-decoration: none;
}
.btn-link:hover {
  color: #7a3fff;
  text-decoration: underline;
}
.btn-link:focus, .btn-link.focus {
  text-decoration: underline;
}
.btn-link:disabled, .btn-link.disabled {
  color: #f5f6fa;
  pointer-events: none;
}

.btn-lg, .btn-group-lg > .btn, .dual-listbox .btn-group-lg > .dual-listbox__button {
  padding: 0.6875rem 1.5rem;
  font-size: 0.9375rem;
  line-height: 1.25rem;
  border-radius: 5px;
}

.btn-sm, .btn-group-sm > .btn, .dual-listbox .btn-group-sm > .dual-listbox__button {
  padding: 0.25rem 0.75rem;
  font-size: 0.75rem;
  line-height: 1.25rem;
  border-radius: 3px;
}

.btn-block {
  display: block;
  width: 100%;
}
.btn-block + .btn-block {
  margin-top: 0.5rem;
}

input[type=submit].btn-block,
input[type=reset].btn-block,
input[type=button].btn-block {
  width: 100%;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.width {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.width {
    transition: none;
  }
}

.dropup,
.dropright,
.dropdown,
.dropleft {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  text-align: left;
  min-width: 180px;
  padding: 0 0;
  margin: 0.125rem 0 0;
  font-size: 0.8125rem;
  color: #526484;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #e5e9f2;
  border-radius: 4px;
}

.dropdown-menu-left {
  right: auto;
  left: 0;
}

.dropdown-menu-right {
  right: 0;
  left: auto;
}

@media (min-width: 420px) {
  .dropdown-menu-mb-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-mb-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 576px) {
  .dropdown-menu-sm-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1540px) {
  .dropdown-menu-xxl-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-right {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropright .dropdown-menu {
  top: 0;
  margin-top: 0;
  right: auto;
  left: 100%;
  margin-left: 0.125rem;
}
.dropright .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropright .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropright .dropdown-toggle::after {
  vertical-align: 0;
}

.dropleft .dropdown-menu {
  top: 0;
  margin-top: 0;
  right: 100%;
  left: auto;
  margin-right: 0.125rem;
}
.dropleft .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropleft .dropdown-toggle::after {
  display: none;
}
.dropleft .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropleft .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-menu[x-placement^=top], .dropdown-menu[x-placement^=right], .dropdown-menu[x-placement^=bottom], .dropdown-menu[x-placement^=left] {
  right: auto;
  bottom: auto;
}

.dropdown-divider {
  height: 0;
  margin: 12px 0;
  overflow: hidden;
  border-top: 1px solid #e5e9f2;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 8px 14px;
  clear: both;
  font-weight: 400;
  color: #364a63;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dropdown-item:first-child {
  border-top-left-radius: calc(4px - 1px);
  border-top-right-radius: calc(4px - 1px);
}
.dropdown-item:last-child {
  border-bottom-right-radius: calc(4px - 1px);
  border-bottom-left-radius: calc(4px - 1px);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: #4461F2;
  text-decoration: none;
  background-color: #ebeef2;
}
.dropdown-item.active, .dropdown-item:active {
  color: #4461F2;
  text-decoration: none;
  background-color: #dbdfea;
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: #ebeef2;
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0 14px;
  margin-bottom: 0;
  font-size: 0.75rem;
  color: #8091a7;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 8px 14px;
  color: #364a63;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn, .dual-listbox .btn-group > .dual-listbox__button,
.btn-group-vertical > .btn,
.dual-listbox .btn-group-vertical > .dual-listbox__button {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn:hover, .dual-listbox .btn-group > .dual-listbox__button:hover,
.btn-group-vertical > .btn:hover,
.dual-listbox .btn-group-vertical > .dual-listbox__button:hover {
  z-index: 1;
}
.btn-group > .btn:focus, .dual-listbox .btn-group > .dual-listbox__button:focus, .btn-group > .btn:active, .dual-listbox .btn-group > .dual-listbox__button:active, .btn-group > .btn.active, .dual-listbox .btn-group > .active.dual-listbox__button,
.btn-group-vertical > .btn:focus,
.dual-listbox .btn-group-vertical > .dual-listbox__button:focus,
.btn-group-vertical > .btn:active,
.dual-listbox .btn-group-vertical > .dual-listbox__button:active,
.btn-group-vertical > .btn.active,
.dual-listbox .btn-group-vertical > .active.dual-listbox__button {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn:not(:first-child), .dual-listbox .btn-group > .dual-listbox__button:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle), .dual-listbox .btn-group > .dual-listbox__button:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn,
.dual-listbox .btn-group > .btn-group:not(:last-child) > .dual-listbox__button {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:not(:first-child), .dual-listbox .btn-group > .dual-listbox__button:not(:first-child),
.btn-group > .btn-group:not(:first-child) > .btn,
.dual-listbox .btn-group > .btn-group:not(:first-child) > .dual-listbox__button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.84375rem;
  padding-left: 0.84375rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropright .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split, .dual-listbox .btn-group-sm > .dual-listbox__button + .dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split, .dual-listbox .btn-group-lg > .dual-listbox__button + .dropdown-toggle-split {
  padding-right: 1.125rem;
  padding-left: 1.125rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn, .dual-listbox .btn-group-vertical > .dual-listbox__button,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child), .dual-listbox .btn-group-vertical > .dual-listbox__button:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle), .dual-listbox .btn-group-vertical > .dual-listbox__button:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn,
.dual-listbox .btn-group-vertical > .btn-group:not(:last-child) > .dual-listbox__button {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:not(:first-child), .dual-listbox .btn-group-vertical > .dual-listbox__button:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) > .btn,
.dual-listbox .btn-group-vertical > .btn-group:not(:first-child) > .dual-listbox__button {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.btn-group-toggle > .btn, .dual-listbox .btn-group-toggle > .dual-listbox__button,
.btn-group-toggle > .btn-group > .btn,
.dual-listbox .btn-group-toggle > .btn-group > .dual-listbox__button {
  margin-bottom: 0;
}
.btn-group-toggle > .btn input[type=radio], .dual-listbox .btn-group-toggle > .dual-listbox__button input[type=radio],
.btn-group-toggle > .btn input[type=checkbox],
.dual-listbox .btn-group-toggle > .dual-listbox__button input[type=checkbox],
.btn-group-toggle > .btn-group > .btn input[type=radio],
.btn-group-toggle > .btn-group > .btn input[type=checkbox] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control, .input-group > .rdl-filter, .dual-listbox .input-group > .dual-listbox__search, div.dataTables_wrapper div.dataTables_filter .input-group > input,
.input-group > .form-control-plaintext,
.input-group > .custom-select,
div.dataTables_wrapper div.dataTables_length .input-group > select,
.input-group > .custom-file {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin-bottom: 0;
}
.input-group > .form-control + .form-control, .input-group > .rdl-filter + .form-control, .input-group > .form-control + .rdl-filter, .input-group > .rdl-filter + .rdl-filter, .dual-listbox .input-group > .dual-listbox__search + .form-control, .dual-listbox .input-group > .dual-listbox__search + .rdl-filter, .dual-listbox .input-group > .form-control + .dual-listbox__search, .dual-listbox .input-group > .rdl-filter + .dual-listbox__search, .dual-listbox .input-group > .dual-listbox__search + .dual-listbox__search, div.dataTables_wrapper div.dataTables_filter .input-group > input + .form-control, div.dataTables_wrapper div.dataTables_filter .input-group > input + .rdl-filter, div.dataTables_wrapper div.dataTables_filter .dual-listbox .input-group > input + .dual-listbox__search, .dual-listbox div.dataTables_wrapper div.dataTables_filter .input-group > input + .dual-listbox__search, div.dataTables_wrapper div.dataTables_filter .input-group > .form-control + input, div.dataTables_wrapper div.dataTables_filter .input-group > .rdl-filter + input, div.dataTables_wrapper div.dataTables_filter .dual-listbox .input-group > .dual-listbox__search + input, .dual-listbox div.dataTables_wrapper div.dataTables_filter .input-group > .dual-listbox__search + input, div.dataTables_wrapper div.dataTables_filter .input-group > input + input,
.input-group > .form-control + .custom-select,
.input-group > .rdl-filter + .custom-select,
.dual-listbox .input-group > .dual-listbox__search + .custom-select,
div.dataTables_wrapper div.dataTables_filter .input-group > input + .custom-select,
div.dataTables_wrapper div.dataTables_length .input-group > .form-control + select,
div.dataTables_wrapper div.dataTables_length .input-group > .rdl-filter + select,
div.dataTables_wrapper div.dataTables_length .dual-listbox .input-group > .dual-listbox__search + select,
.dual-listbox div.dataTables_wrapper div.dataTables_length .input-group > .dual-listbox__search + select,
div.dataTables_wrapper div.dataTables_length div.dataTables_filter .input-group > input + select,
div.dataTables_wrapper div.dataTables_filter div.dataTables_length .input-group > input + select,
.input-group > .form-control + .custom-file,
.input-group > .rdl-filter + .custom-file,
.dual-listbox .input-group > .dual-listbox__search + .custom-file,
div.dataTables_wrapper div.dataTables_filter .input-group > input + .custom-file,
.input-group > .form-control-plaintext + .form-control,
.input-group > .form-control-plaintext + .rdl-filter,
.dual-listbox .input-group > .form-control-plaintext + .dual-listbox__search,
div.dataTables_wrapper div.dataTables_filter .input-group > .form-control-plaintext + input,
.input-group > .form-control-plaintext + .custom-select,
div.dataTables_wrapper div.dataTables_length .input-group > .form-control-plaintext + select,
.input-group > .form-control-plaintext + .custom-file,
.input-group > .custom-select + .form-control,
.input-group > .custom-select + .rdl-filter,
.dual-listbox .input-group > .custom-select + .dual-listbox__search,
div.dataTables_wrapper div.dataTables_filter .input-group > .custom-select + input,
div.dataTables_wrapper div.dataTables_length .input-group > select + .form-control,
div.dataTables_wrapper div.dataTables_length .input-group > select + .rdl-filter,
div.dataTables_wrapper div.dataTables_length .dual-listbox .input-group > select + .dual-listbox__search,
.dual-listbox div.dataTables_wrapper div.dataTables_length .input-group > select + .dual-listbox__search,
div.dataTables_wrapper div.dataTables_length div.dataTables_filter .input-group > select + input,
div.dataTables_wrapper div.dataTables_filter div.dataTables_length .input-group > select + input,
.input-group > .custom-select + .custom-select,
div.dataTables_wrapper div.dataTables_length .input-group > select + .custom-select,
div.dataTables_wrapper div.dataTables_length .input-group > .custom-select + select,
div.dataTables_wrapper div.dataTables_length .input-group > select + select,
.input-group > .custom-select + .custom-file,
div.dataTables_wrapper div.dataTables_length .input-group > select + .custom-file,
.input-group > .custom-file + .form-control,
.input-group > .custom-file + .rdl-filter,
.dual-listbox .input-group > .custom-file + .dual-listbox__search,
div.dataTables_wrapper div.dataTables_filter .input-group > .custom-file + input,
.input-group > .custom-file + .custom-select,
div.dataTables_wrapper div.dataTables_length .input-group > .custom-file + select,
.input-group > .custom-file + .custom-file {
  margin-left: -1px;
}
.input-group > .form-control:focus, .input-group > .rdl-filter:focus, .dual-listbox .input-group > .dual-listbox__search:focus, div.dataTables_wrapper div.dataTables_filter .input-group > input:focus,
.input-group > .custom-select:focus,
div.dataTables_wrapper div.dataTables_length .input-group > select:focus,
.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {
  z-index: 3;
}
.input-group > .custom-file .custom-file-input:focus {
  z-index: 4;
}
.input-group > .form-control:not(:last-child), .input-group > .rdl-filter:not(:last-child), .dual-listbox .input-group > .dual-listbox__search:not(:last-child), div.dataTables_wrapper div.dataTables_filter .input-group > input:not(:last-child),
.input-group > .custom-select:not(:last-child),
div.dataTables_wrapper div.dataTables_length .input-group > select:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > .form-control:not(:first-child), .input-group > .rdl-filter:not(:first-child), .dual-listbox .input-group > .dual-listbox__search:not(:first-child), div.dataTables_wrapper div.dataTables_filter .input-group > input:not(:first-child),
.input-group > .custom-select:not(:first-child),
div.dataTables_wrapper div.dataTables_length .input-group > select:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .custom-file {
  display: flex;
  align-items: center;
}
.input-group > .custom-file:not(:last-child) .custom-file-label, .input-group > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > .custom-file:not(:first-child) .custom-file-label {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group-prepend,
.input-group-append {
  display: flex;
}
.input-group-prepend .btn, .input-group-prepend .dual-listbox .dual-listbox__button, .dual-listbox .input-group-prepend .dual-listbox__button,
.input-group-append .btn,
.input-group-append .dual-listbox .dual-listbox__button,
.dual-listbox .input-group-append .dual-listbox__button {
  position: relative;
  z-index: 2;
}
.input-group-prepend .btn:focus, .input-group-prepend .dual-listbox .dual-listbox__button:focus, .dual-listbox .input-group-prepend .dual-listbox__button:focus,
.input-group-append .btn:focus,
.input-group-append .dual-listbox .dual-listbox__button:focus,
.dual-listbox .input-group-append .dual-listbox__button:focus {
  z-index: 3;
}
.input-group-prepend .btn + .btn, .input-group-prepend .dual-listbox .dual-listbox__button + .btn, .dual-listbox .input-group-prepend .dual-listbox__button + .btn, .input-group-prepend .dual-listbox .btn + .dual-listbox__button, .dual-listbox .input-group-prepend .btn + .dual-listbox__button, .input-group-prepend .dual-listbox .dual-listbox__button + .dual-listbox__button, .dual-listbox .input-group-prepend .dual-listbox__button + .dual-listbox__button,
.input-group-prepend .btn + .input-group-text,
.input-group-prepend .dual-listbox .dual-listbox__button + .input-group-text,
.dual-listbox .input-group-prepend .dual-listbox__button + .input-group-text,
.input-group-prepend .input-group-text + .input-group-text,
.input-group-prepend .input-group-text + .btn,
.input-group-prepend .dual-listbox .input-group-text + .dual-listbox__button,
.dual-listbox .input-group-prepend .input-group-text + .dual-listbox__button,
.input-group-append .btn + .btn,
.input-group-append .dual-listbox .dual-listbox__button + .btn,
.dual-listbox .input-group-append .dual-listbox__button + .btn,
.input-group-append .dual-listbox .btn + .dual-listbox__button,
.dual-listbox .input-group-append .btn + .dual-listbox__button,
.input-group-append .dual-listbox .dual-listbox__button + .dual-listbox__button,
.dual-listbox .input-group-append .dual-listbox__button + .dual-listbox__button,
.input-group-append .btn + .input-group-text,
.input-group-append .dual-listbox .dual-listbox__button + .input-group-text,
.dual-listbox .input-group-append .dual-listbox__button + .input-group-text,
.input-group-append .input-group-text + .input-group-text,
.input-group-append .input-group-text + .btn,
.input-group-append .dual-listbox .input-group-text + .dual-listbox__button,
.dual-listbox .input-group-append .input-group-text + .dual-listbox__button {
  margin-left: -1px;
}

.input-group-prepend {
  margin-right: -1px;
}

.input-group-append {
  margin-left: -1px;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.4375rem 1rem;
  margin-bottom: 0;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.25rem;
  color: #3c4d62;
  text-align: center;
  white-space: nowrap;
  background-color: #ebeef2;
  border: 1px solid #dbdfea;
  border-radius: 4px;
}
.input-group-text input[type=radio],
.input-group-text input[type=checkbox] {
  margin-top: 0;
}

.input-group-lg > .form-control:not(textarea), .input-group-lg > .rdl-filter:not(textarea), .dual-listbox .input-group-lg > .dual-listbox__search:not(textarea), div.dataTables_wrapper div.dataTables_filter .input-group-lg > input:not(textarea),
.input-group-lg > .custom-select,
div.dataTables_wrapper div.dataTables_length .input-group-lg > select {
  height: calc(2.625rem + 2px);
}

.input-group-lg > .form-control, .input-group-lg > .rdl-filter, .dual-listbox .input-group-lg > .dual-listbox__search, div.dataTables_wrapper div.dataTables_filter .input-group-lg > input,
.input-group-lg > .custom-select,
div.dataTables_wrapper div.dataTables_length .input-group-lg > select,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.dual-listbox .input-group-lg > .input-group-prepend > .dual-listbox__button,
.input-group-lg > .input-group-append > .btn,
.dual-listbox .input-group-lg > .input-group-append > .dual-listbox__button {
  padding: 0.6875rem 1rem;
  font-size: 0.9375rem;
  line-height: 1.25rem;
  border-radius: 5px;
}

.input-group-sm > .form-control:not(textarea), .input-group-sm > .rdl-filter:not(textarea), .dual-listbox .input-group-sm > .dual-listbox__search:not(textarea), div.dataTables_wrapper div.dataTables_filter .input-group-sm > input:not(textarea),
.input-group-sm > .custom-select,
div.dataTables_wrapper div.dataTables_length .input-group-sm > select {
  height: calc(1.75rem + 2px);
}

.input-group-sm > .form-control, .input-group-sm > .rdl-filter, .dual-listbox .input-group-sm > .dual-listbox__search, div.dataTables_wrapper div.dataTables_filter .input-group-sm > input,
.input-group-sm > .custom-select,
div.dataTables_wrapper div.dataTables_length .input-group-sm > select,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.dual-listbox .input-group-sm > .input-group-prepend > .dual-listbox__button,
.input-group-sm > .input-group-append > .btn,
.dual-listbox .input-group-sm > .input-group-append > .dual-listbox__button {
  padding: 0.25rem 1rem;
  font-size: 0.75rem;
  line-height: 1.25rem;
  border-radius: 3px;
}

.input-group-lg > .custom-select, div.dataTables_wrapper div.dataTables_length .input-group-lg > select,
.input-group-sm > .custom-select,
div.dataTables_wrapper div.dataTables_length .input-group-sm > select {
  padding-right: 2rem;
}

.input-group > .input-group-prepend > .btn, .dual-listbox .input-group > .input-group-prepend > .dual-listbox__button,
.input-group > .input-group-prepend > .input-group-text,
.input-group > .input-group-append:not(:last-child) > .btn,
.dual-listbox .input-group > .input-group-append:not(:last-child) > .dual-listbox__button,
.input-group > .input-group-append:not(:last-child) > .input-group-text,
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.dual-listbox .input-group > .input-group-append:last-child > .dual-listbox__button:not(:last-child):not(.dropdown-toggle),
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .input-group-append > .btn, .dual-listbox .input-group > .input-group-append > .dual-listbox__button,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.dual-listbox .input-group > .input-group-prepend:not(:first-child) > .dual-listbox__button,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.dual-listbox .input-group > .input-group-prepend:first-child > .dual-listbox__button:not(:first-child),
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.custom-control {
  position: relative;
  z-index: 1;
  display: block;
  min-height: 1.27875rem;
  padding-left: 2.25rem;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.custom-control-input {
  position: absolute;
  left: 0;
  z-index: -1;
  width: 1.5rem;
  height: 1.389375rem;
  opacity: 0;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #4461F2;
  background-color: #4461F2;
}
.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 3px rgba(68, 97, 242, 0.1);
}
.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #4461F2;
}
.custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  color: #fff;
  background-color: #4461F2;
  border-color: #4461F2;
}
.custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {
  color: #6c757d;
}
.custom-control-input[disabled] ~ .custom-control-label::before, .custom-control-input:disabled ~ .custom-control-label::before {
  background-color: #f5f6fa;
}

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
}
.custom-control-label:before, .custom-control-label:after {
  z-index: 1;
}
.custom-control-label::before {
  position: absolute;
  top: -0.110625rem;
  left: -2.25rem;
  display: block;
  width: 1.5rem;
  height: 1.5rem;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: #dbdfea solid 2px;
}
.custom-control-label::after {
  position: absolute;
  top: -0.110625rem;
  left: -2.25rem;
  display: block;
  width: 1.5rem;
  height: 1.5rem;
  content: "";
  background: no-repeat 50%/50% 50%;
}

.custom-checkbox .custom-control-label::before {
  border-radius: 4px;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  border-color: #559bfb;
  background-color: #559bfb;
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(68, 97, 242, 0.8);
}
.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
  background-color: rgba(68, 97, 242, 0.8);
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}
.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(68, 97, 242, 0.8);
}

.custom-switch {
  padding-left: 3.75rem;
}
.custom-switch .custom-control-label::before {
  left: -3.75rem;
  width: 3rem;
  pointer-events: all;
  border-radius: 1.5rem;
}
.custom-switch .custom-control-label::after {
  top: calc(-0.110625rem + 4px);
  left: calc(-3.75rem + 4px);
  width: 1rem;
  height: 1rem;
  background-color: #dbdfea;
  border-radius: 1.5rem;
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-switch .custom-control-label::after {
    transition: none;
  }
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  transform: translateX(1.5rem);
}
.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(68, 97, 242, 0.8);
}

.custom-select, div.dataTables_wrapper div.dataTables_length select {
  display: inline-block;
  width: 100%;
  height: calc(2.125rem + 2px);
  padding: 0.4375rem 2rem 0.4375rem 1rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.25rem;
  color: #3c4d62;
  vertical-align: middle;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_16___}) right 1rem center/8px 10px no-repeat;
  border: 1px solid #dbdfea;
  border-radius: 4px;
  appearance: none;
}
.custom-select:focus, div.dataTables_wrapper div.dataTables_length select:focus {
  border-color: #4461F2;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(85, 155, 251, 0.25);
}
.custom-select:focus::-ms-value, div.dataTables_wrapper div.dataTables_length select:focus::-ms-value {
  color: #3c4d62;
  background-color: #fff;
}
.custom-select[multiple], div.dataTables_wrapper div.dataTables_length select[multiple], .custom-select[size]:not([size="1"]), div.dataTables_wrapper div.dataTables_length select[size]:not([size="1"]) {
  height: auto;
  padding-right: 1rem;
  background-image: none;
}
.custom-select:disabled, div.dataTables_wrapper div.dataTables_length select:disabled {
  color: #6c757d;
  background-color: #e9ecef;
}
.custom-select::-ms-expand, div.dataTables_wrapper div.dataTables_length select::-ms-expand {
  display: none;
}
.custom-select:-moz-focusring, div.dataTables_wrapper div.dataTables_length select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #3c4d62;
}

.custom-select-sm {
  height: calc(1.75rem + 2px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 1rem;
  font-size: 0.75rem;
}

.custom-select-lg {
  height: calc(2.625rem + 2px);
  padding-top: 0.6875rem;
  padding-bottom: 0.6875rem;
  padding-left: 1rem;
  font-size: 0.9375rem;
}

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(2.125rem + 2px);
  margin-bottom: 0;
}

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(2.125rem + 2px);
  margin: 0;
  opacity: 0;
}
.custom-file-input:focus ~ .custom-file-label {
  border-color: #4461F2;
  box-shadow: 0 0 0 3px rgba(68, 97, 242, 0.1);
}
.custom-file-input[disabled] ~ .custom-file-label, .custom-file-input:disabled ~ .custom-file-label {
  background-color: #f5f6fa;
}
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Browse";
}
.custom-file-input ~ .custom-file-label[data-browse]::after {
  content: attr(data-browse);
}

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(2.125rem + 2px);
  padding: 0.4375rem 1rem;
  font-weight: 400;
  line-height: 1.25rem;
  color: #3c4d62;
  background-color: #fff;
  border: 1px solid #dbdfea;
  border-radius: 4px;
}
.custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  height: 2.125rem;
  padding: 0.4375rem 1rem;
  line-height: 1.25rem;
  color: #3c4d62;
  content: "Browse";
  background-color: #ebeef2;
  border-left: inherit;
  border-radius: 0 4px 4px 0;
}

.custom-range {
  width: 100%;
  height: 1.4rem;
  padding: 0;
  background-color: transparent;
  appearance: none;
}
.custom-range:focus {
  outline: none;
}
.custom-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #f5f6fa, 0 0 0 3px rgba(68, 97, 242, 0.1);
}
.custom-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #f5f6fa, 0 0 0 3px rgba(68, 97, 242, 0.1);
}
.custom-range:focus::-ms-thumb {
  box-shadow: 0 0 0 1px #f5f6fa, 0 0 0 3px rgba(68, 97, 242, 0.1);
}
.custom-range::-moz-focus-outer {
  border: 0;
}
.custom-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #559bfb;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.custom-range::-webkit-slider-thumb:active {
  background-color: white;
}
.custom-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.custom-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #559bfb;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.custom-range::-moz-range-thumb:active {
  background-color: white;
}
.custom-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.custom-range::-ms-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: 0;
  margin-right: 0.2rem;
  margin-left: 0.2rem;
  background-color: #559bfb;
  border: 0;
  border-radius: 1rem;
  -ms-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-ms-thumb {
    -ms-transition: none;
    transition: none;
  }
}
.custom-range::-ms-thumb:active {
  background-color: white;
}
.custom-range::-ms-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: transparent;
  border-color: transparent;
  border-width: 0.5rem;
}
.custom-range::-ms-fill-lower {
  background-color: #dee2e6;
  border-radius: 1rem;
}
.custom-range::-ms-fill-upper {
  margin-right: 15px;
  background-color: #dee2e6;
  border-radius: 1rem;
}
.custom-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-webkit-slider-runnable-track {
  cursor: default;
}
.custom-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-moz-range-track {
  cursor: default;
}
.custom-range:disabled::-ms-thumb {
  background-color: #adb5bd;
}

.custom-control-label::before,
.custom-file-label,
.custom-select,
div.dataTables_wrapper div.dataTables_length select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-control-label::before,
  .custom-file-label,
  .custom-select,
  div.dataTables_wrapper div.dataTables_length select {
    transition: none;
  }
}

.image-control.custom-control {
  padding-left: 0;
}
.image-control .custom-control-input:checked ~ .custom-control-label:before {
  border-color: #fff;
}
.image-control .custom-control-input:checked ~ .custom-control-label img {
  opacity: 0.8;
}
.image-control .custom-control-label {
  padding-top: 0;
  border-radius: 4px;
  overflow: hidden;
  background-color: #1f2b3a;
}
.image-control .custom-control-label img {
  transition: opacity 0.3s ease;
}
.image-control .custom-control-label:before, .image-control .custom-control-label:after {
  z-index: 9;
}
.image-control .custom-control-label::before {
  border-width: 1px;
  top: 1rem;
  left: 1rem;
}
.image-control .custom-control-label::after {
  top: 1rem;
  left: 1rem;
}
.image-control:hover .custom-control-label img {
  opacity: 0.8;
}

.custom-control-pro {
  padding-left: 0;
  position: relative;
}
.custom-control-pro.no-control.checked {
  z-index: 3;
}
.custom-control-pro.no-control.focused {
  z-index: 2;
}
.custom-control-pro.no-control .custom-control-label {
  padding: 0.375rem 1.125rem;
  border-width: 2px;
}
.custom-control-pro.no-control .custom-control-input:checked ~ .custom-control-label {
  border-color: #4461F2;
  z-index: 2;
}
.custom-control-pro.no-control .custom-control-input:not(:disabled):active ~ .custom-control-label {
  border-color: #4461F2;
}
.custom-control-pro.no-control .custom-control-input[disabled] ~ .custom-control-label, .custom-control-pro.no-control .custom-control-input:disabled ~ .custom-control-label {
  color: #6c757d;
}
.custom-control-pro-block.custom-control {
  display: flex;
}
.custom-control-pro-block .custom-control-label {
  width: 100%;
}
.custom-control-pro .custom-control-label {
  border: 1px solid #e5e9f2;
  padding: 1.125rem 1.125rem 1.125rem 3.375rem;
  font-size: 13px;
  line-height: 1.25rem;
  border-radius: 4px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  display: inline-flex;
  align-items: center;
  background-color: #fff;
}
@media (prefers-reduced-motion: reduce) {
  .custom-control-pro .custom-control-label {
    transition: none;
  }
}
.custom-control-pro .custom-control-label::before, .custom-control-pro .custom-control-label::after {
  top: 50%;
  transform: translateY(-50%);
  left: 1.125rem;
}
.custom-control-pro .custom-control-label .icon {
  font-size: 1.4em;
  line-height: inherit;
}
.custom-control-pro .custom-control-label .icon-lg {
  font-size: 2.2em;
}
.custom-control-pro .custom-control-label > span {
  white-space: nowrap;
}
.custom-control-pro .custom-control-label > span:only-child {
  width: 100%;
}
.custom-control-pro .custom-control-label .icon + span, .custom-control-pro .custom-control-label span + .icon {
  padding-left: 8px;
}
.custom-control-pro.custom-control-sm {
  padding-left: 0;
}
.custom-control-pro.custom-control-sm .custom-control-label {
  padding: 0.6875rem 1.125rem 0.6875rem 3rem;
  font-size: 13px;
  line-height: 1.25rem;
  border-radius: 4px;
}
.custom-control-pro.custom-control-sm .custom-control-label::before, .custom-control-pro.custom-control-sm .custom-control-label::after {
  top: 50%;
  transform: translateY(-50%);
  left: 1.125rem;
}
.custom-control-pro-icon.custom-control-pro .custom-control-label {
  padding-left: 0;
  padding-right: 0;
}
.custom-control-pro-icon.custom-control-pro .custom-control-label .icon {
  text-align: center;
  width: 2.125rem;
}

.custom-control.color-control {
  padding: 4px !important;
}
.custom-control.color-control .custom-control-label::before {
  opacity: 0;
  display: block;
  left: -4px;
  right: -4px;
  top: -4px;
  bottom: -4px;
  border-radius: 50%;
  border: 2px solid #4461F2 !important;
  background: transparent !important;
  transition: 0.3s ease;
}
.custom-control.color-control .custom-control-label::after {
  display: none;
}
.custom-control.color-control .custom-control-input:checked ~ .custom-control-label::before {
  opacity: 1;
}

.no-control {
  padding-left: 0;
}
.no-control .custom-control-label::before, .no-control .custom-control-label::after {
  display: none;
}

.form-control-slider {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

.custom-control-group {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  margin: -0.375rem;
}
.custom-control-group > * {
  padding: 0.375rem;
}
.custom-control-stacked {
  margin: 0;
}
.custom-control-stacked > * {
  padding: 0;
  margin: -1px;
}
.custom-control-stacked:not(.custom-control-vertical) > *:not(:first-child) .custom-control-label {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.custom-control-stacked:not(.custom-control-vertical) > *:not(:last-child) .custom-control-label {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.custom-control-vertical {
  flex-direction: column;
  align-items: start;
}
.custom-control-vertical > * {
  width: 100%;
}
.custom-control-vertical .custom-control {
  display: flex;
}
.custom-control-vertical .custom-control .custom-control-label {
  width: 100%;
}
.custom-control-vertical.custom-control-stacked > *:not(:first-child) .custom-control-label {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.custom-control-vertical.custom-control-stacked > *:not(:last-child) .custom-control-label {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}
.nav-link:hover, .nav-link:focus {
  text-decoration: none;
}
.nav-link.disabled {
  color: #6c757d;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}
.nav-tabs .nav-link {
  margin-bottom: -1px;
  background-color: transparent;
  border: 1px solid transparent;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: #e9ecef #e9ecef #dee2e6;
}
.nav-tabs .nav-link.disabled {
  color: #6c757d;
  background-color: transparent;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #495057;
  background-color: #f5f6fa;
  border-color: #dee2e6 #dee2e6 #f5f6fa;
}
.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  background: none;
  border: 0;
  border-radius: 4px;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #559bfb;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
}
.navbar .container,
.navbar .container-fluid,
.navbar .container-mb,
.navbar .container-sm,
.navbar .container-md,
.navbar .container-lg,
.navbar .container-xl,
.navbar .container-xxl {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  display: inline-block;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
  margin-right: 1rem;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  text-decoration: none;
}

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}
.navbar-nav .dropdown-menu {
  position: static;
  float: none;
}

.navbar-text {
  display: inline-block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 4px;
}
.navbar-toggler:hover, .navbar-toggler:focus {
  text-decoration: none;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: no-repeat center center;
  background-size: 100% 100%;
}

@media (max-width: 419.98px) {
  .navbar-expand-mb > .container,
  .navbar-expand-mb > .container-fluid,
  .navbar-expand-mb > .container-mb,
  .navbar-expand-mb > .container-sm,
  .navbar-expand-mb > .container-md,
  .navbar-expand-mb > .container-lg,
  .navbar-expand-mb > .container-xl,
  .navbar-expand-mb > .container-xxl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 420px) {
  .navbar-expand-mb {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-mb .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-mb .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-mb .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-mb > .container,
  .navbar-expand-mb > .container-fluid,
  .navbar-expand-mb > .container-mb,
  .navbar-expand-mb > .container-sm,
  .navbar-expand-mb > .container-md,
  .navbar-expand-mb > .container-lg,
  .navbar-expand-mb > .container-xl,
  .navbar-expand-mb > .container-xxl {
    flex-wrap: nowrap;
  }
  .navbar-expand-mb .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-mb .navbar-toggler {
    display: none;
  }
}
@media (max-width: 575.98px) {
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid,
  .navbar-expand-sm > .container-mb,
  .navbar-expand-sm > .container-sm,
  .navbar-expand-sm > .container-md,
  .navbar-expand-sm > .container-lg,
  .navbar-expand-sm > .container-xl,
  .navbar-expand-sm > .container-xxl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid,
  .navbar-expand-sm > .container-mb,
  .navbar-expand-sm > .container-sm,
  .navbar-expand-sm > .container-md,
  .navbar-expand-sm > .container-lg,
  .navbar-expand-sm > .container-xl,
  .navbar-expand-sm > .container-xxl {
    flex-wrap: nowrap;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid,
  .navbar-expand-md > .container-mb,
  .navbar-expand-md > .container-sm,
  .navbar-expand-md > .container-md,
  .navbar-expand-md > .container-lg,
  .navbar-expand-md > .container-xl,
  .navbar-expand-md > .container-xxl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid,
  .navbar-expand-md > .container-mb,
  .navbar-expand-md > .container-sm,
  .navbar-expand-md > .container-md,
  .navbar-expand-md > .container-lg,
  .navbar-expand-md > .container-xl,
  .navbar-expand-md > .container-xxl {
    flex-wrap: nowrap;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid,
  .navbar-expand-lg > .container-mb,
  .navbar-expand-lg > .container-sm,
  .navbar-expand-lg > .container-md,
  .navbar-expand-lg > .container-lg,
  .navbar-expand-lg > .container-xl,
  .navbar-expand-lg > .container-xxl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid,
  .navbar-expand-lg > .container-mb,
  .navbar-expand-lg > .container-sm,
  .navbar-expand-lg > .container-md,
  .navbar-expand-lg > .container-lg,
  .navbar-expand-lg > .container-xl,
  .navbar-expand-lg > .container-xxl {
    flex-wrap: nowrap;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}
@media (max-width: 1199.98px) {
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid,
  .navbar-expand-xl > .container-mb,
  .navbar-expand-xl > .container-sm,
  .navbar-expand-xl > .container-md,
  .navbar-expand-xl > .container-lg,
  .navbar-expand-xl > .container-xl,
  .navbar-expand-xl > .container-xxl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid,
  .navbar-expand-xl > .container-mb,
  .navbar-expand-xl > .container-sm,
  .navbar-expand-xl > .container-md,
  .navbar-expand-xl > .container-lg,
  .navbar-expand-xl > .container-xl,
  .navbar-expand-xl > .container-xxl {
    flex-wrap: nowrap;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}
@media (max-width: 1539.98px) {
  .navbar-expand-xxl > .container,
  .navbar-expand-xxl > .container-fluid,
  .navbar-expand-xxl > .container-mb,
  .navbar-expand-xxl > .container-sm,
  .navbar-expand-xxl > .container-md,
  .navbar-expand-xxl > .container-lg,
  .navbar-expand-xxl > .container-xl,
  .navbar-expand-xxl > .container-xxl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 1540px) {
  .navbar-expand-xxl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-xxl > .container,
  .navbar-expand-xxl > .container-fluid,
  .navbar-expand-xxl > .container-mb,
  .navbar-expand-xxl > .container-sm,
  .navbar-expand-xxl > .container-md,
  .navbar-expand-xxl > .container-lg,
  .navbar-expand-xxl > .container-xl,
  .navbar-expand-xxl > .container-xxl {
    flex-wrap: nowrap;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
}
.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-mb,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl,
.navbar-expand > .container-xxl {
  padding-right: 0;
  padding-left: 0;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-mb,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl,
.navbar-expand > .container-xxl {
  flex-wrap: nowrap;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.7);
}
.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.1);
}
.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}
.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-text a {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-dark .navbar-brand {
  color: #fff;
}
.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
  color: #fff;
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5);
}
.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.75);
}
.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}
.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: #fff;
}
.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.1);
}
.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}
.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.5);
}
.navbar-dark .navbar-text a {
  color: #fff;
}
.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {
  color: #fff;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 0 solid rgba(0, 0, 0, 0.125);
  border-radius: 4px;
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem;
}

.card-title {
  margin-bottom: 0.75rem;
}

.card-subtitle {
  margin-top: -0.375rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}
.card-link + .card-link {
  margin-left: 1.25rem;
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.07);
  border-bottom: 0 solid rgba(0, 0, 0, 0.125);
}
.card-header:first-child {
  border-radius: 3px 3px 0 0;
}

.card-footer {
  padding: 0.75rem 1.25rem;
  background-color: rgba(0, 0, 0, 0.07);
  border-top: 0 solid rgba(0, 0, 0, 0.125);
}
.card-footer:last-child {
  border-radius: 0 0 3px 3px;
}

.card-header-tabs {
  margin-right: -0.625rem;
  margin-bottom: -0.75rem;
  margin-left: -0.625rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.625rem;
  margin-left: -0.625rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
  border-radius: 3px;
}

.card-img,
.card-img-top,
.card-img-bottom {
  flex-shrink: 0;
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}

.card-deck .card {
  margin-bottom: 14px;
}
@media (min-width: 576px) {
  .card-deck {
    display: flex;
    flex-flow: row wrap;
    margin-right: -14px;
    margin-left: -14px;
  }
  .card-deck .card {
    flex: 1 0;
    margin-right: 14px;
    margin-bottom: 0;
    margin-left: 14px;
  }
}

.card-group > .card {
  margin-bottom: 14px;
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.card-columns .card {
  margin-bottom: 0.75rem;
}
@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }
  .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}

.accordion {
  overflow-anchor: none;
}
.accordion > .card {
  overflow: hidden;
}
.accordion > .card:not(:last-of-type) {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.accordion > .card:not(:first-of-type) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.accordion > .card > .card-header {
  border-radius: 0;
  margin-bottom: 0;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.25rem 0;
  margin-bottom: 0;
  font-size: 0.6875rem;
  list-style: none;
  background-color: transparent;
  border-radius: 4px;
}

.breadcrumb-item {
  display: flex;
}
.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}
.breadcrumb-item + .breadcrumb-item::before {
  display: inline-block;
  padding-right: 0.5rem;
  color: #8091a7;
  content: "/";
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: underline;
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: none;
}
.breadcrumb-item.active {
  color: #b7c2d0;
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 4px;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5625rem 0.625rem;
  margin-left: -1px;
  line-height: 1rem;
  color: #526484;
  background-color: #fff;
  border: 1px solid #e5e9f2;
}
.page-link:hover {
  z-index: 2;
  color: #7a3fff;
  text-decoration: none;
  background-color: #ebeef2;
  border-color: #e5e9f2;
}
.page-link:focus {
  z-index: 3;
  outline: 0;
  box-shadow: none;
}

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.page-item:last-child .page-link {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.page-item.active .page-link {
  z-index: 1;
  color: #fff;
  background-color: #4461F2;
  border-color: #4461F2;
}
.page-item.disabled .page-link {
  color: #dbdfea;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #e5e9f2;
}

.pagination-lg .page-link {
  padding: 0.5625rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1.5;
}
.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.pagination-sm .page-link {
  padding: 0.4375rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1.5;
}
.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}
.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}

.badge {
  display: inline-block;
  padding: 0 0.375rem;
  font-size: 0.675rem;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 3px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .badge {
    transition: none;
  }
}
a.badge:hover, a.badge:focus {
  text-decoration: none;
}

.badge:empty {
  display: none;
}

.btn .badge, .dual-listbox .dual-listbox__button .badge {
  position: relative;
  top: -1px;
}

.badge-pill {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  border-radius: 10rem;
}

.badge-primary {
  color: #fff;
  background-color: #4461F2;
}
a.badge-primary:hover, a.badge-primary:focus {
  color: #fff;
  background-color: #1439ef;
}
a.badge-primary:focus, a.badge-primary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(68, 97, 242, 0.5);
}

.badge-secondary {
  color: #fff;
  background-color: #364a63;
}
a.badge-secondary:hover, a.badge-secondary:focus {
  color: #fff;
  background-color: #243142;
}
a.badge-secondary:focus, a.badge-secondary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(54, 74, 99, 0.5);
}

.badge-success {
  color: #fff;
  background-color: #1ee0ac;
}
a.badge-success:hover, a.badge-success:focus {
  color: #fff;
  background-color: #18b389;
}
a.badge-success:focus, a.badge-success.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(30, 224, 172, 0.5);
}

.badge-info {
  color: #fff;
  background-color: #09c2de;
}
a.badge-info:hover, a.badge-info:focus {
  color: #fff;
  background-color: #0797ad;
}
a.badge-info:focus, a.badge-info.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(9, 194, 222, 0.5);
}

.badge-warning {
  color: #fff;
  background-color: #f4bd0e;
}
a.badge-warning:hover, a.badge-warning:focus {
  color: #fff;
  background-color: #c69909;
}
a.badge-warning:focus, a.badge-warning.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(244, 189, 14, 0.5);
}

.badge-danger {
  color: #fff;
  background-color: #e85347;
}
a.badge-danger:hover, a.badge-danger:focus {
  color: #fff;
  background-color: #e02b1c;
}
a.badge-danger:focus, a.badge-danger.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(232, 83, 71, 0.5);
}

.badge-dark {
  color: #fff;
  background-color: #1c2b46;
}
a.badge-dark:hover, a.badge-dark:focus {
  color: #fff;
  background-color: #0d1522;
}
a.badge-dark:focus, a.badge-dark.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(28, 43, 70, 0.5);
}

.badge-gray {
  color: #fff;
  background-color: #8091a7;
}
a.badge-gray:hover, a.badge-gray:focus {
  color: #fff;
  background-color: #647790;
}
a.badge-gray:focus, a.badge-gray.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(128, 145, 167, 0.5);
}

.badge-light {
  color: #101924;
  background-color: #e5e9f2;
}
a.badge-light:hover, a.badge-light:focus {
  color: #101924;
  background-color: #c3cce1;
}
a.badge-light:focus, a.badge-light.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(229, 233, 242, 0.5);
}

.badge-lighter {
  color: #101924;
  background-color: #f5f6fa;
}
a.badge-lighter:hover, a.badge-lighter:focus {
  color: #101924;
  background-color: #d3d7e9;
}
a.badge-lighter:focus, a.badge-lighter.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(245, 246, 250, 0.5);
}

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #e9ecef;
  border-radius: 5px;
}
@media (min-width: 576px) {
  .jumbotron {
    padding: 4rem 2rem;
  }
}

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
}

.alert {
  position: relative;
  padding: 1rem 1.25rem;
  margin-bottom: 2rem;
  border: 1px solid transparent;
  border-radius: 4px;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
}

.alert-dismissible {
  padding-right: 4rem;
}
.alert-dismissible .close {
  position: absolute;
  top: 0;
  right: 0;
  padding: 1rem 1.25rem;
  color: inherit;
}

.alert-primary {
  color: #3951cb;
  background-color: #e9ecfd;
  border-color: #bcc6fa;
}
.alert-primary hr {
  border-top-color: #a4b2f8;
}
.alert-primary .alert-link {
  color: #2b40a6;
}

.alert-secondary {
  color: #2d3e53;
  background-color: #e7e9ec;
  border-color: #b7bec7;
}
.alert-secondary hr {
  border-top-color: #a9b1bc;
}
.alert-secondary .alert-link {
  color: #1b2532;
}

.alert-success {
  color: #19bc90;
  background-color: #e4fbf5;
  border-color: #aef4e1;
}
.alert-success hr {
  border-top-color: #98f1d9;
}
.alert-success .alert-link {
  color: #138f6e;
}

.alert-info {
  color: #08a3ba;
  background-color: #e1f8fb;
  border-color: #a6e9f3;
}
.alert-info hr {
  border-top-color: #90e3f0;
}
.alert-info .alert-link {
  color: #067889;
}

.alert-warning {
  color: #cd9f0c;
  background-color: #fef7e2;
  border-color: #fbe7a8;
}
.alert-warning hr {
  border-top-color: #fae090;
}
.alert-warning .alert-link {
  color: #9d7a09;
}

.alert-danger {
  color: #c3463c;
  background-color: #fceae9;
  border-color: #f7c1bd;
}
.alert-danger hr {
  border-top-color: #f4aca6;
}
.alert-danger .alert-link {
  color: #9c3830;
}

.alert-dark {
  color: #18243b;
  background-color: #e4e6e9;
  border-color: #adb3bc;
}
.alert-dark hr {
  border-top-color: #9fa6b1;
}
.alert-dark .alert-link {
  color: #090e17;
}

.alert-gray {
  color: #6c7a8c;
  background-color: #f0f2f4;
  border-color: #d1d7df;
}
.alert-gray hr {
  border-top-color: #c2cad5;
}
.alert-gray .alert-link {
  color: #56616f;
}

.alert-light {
  color: #c0c4cb;
  background-color: #fcfcfd;
  border-color: #f6f7fa;
}
.alert-light hr {
  border-top-color: #e6e8f1;
}
.alert-light .alert-link {
  color: #a4aab4;
}

.alert-lighter {
  color: #cecfd2;
  background-color: #fefefe;
  border-color: #fbfcfd;
}
.alert-lighter hr {
  border-top-color: #eaeff5;
}
.alert-lighter .alert-link {
  color: #b3b5ba;
}

@keyframes progress-bar-stripes {
  from {
    background-position: 0.5rem 0;
  }
  to {
    background-position: 0 0;
  }
}
.progress {
  display: flex;
  height: 0.5rem;
  overflow: hidden;
  line-height: 0;
  font-size: 0.75rem;
  background-color: #f5f6fa;
  border-radius: 2px;
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #4461F2;
  transition: width 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 0.5rem 0.5rem;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.media {
  display: flex;
  align-items: flex-start;
}

.media-body {
  flex: 1 1;
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 4px;
}

.list-group-item-action {
  width: 100%;
  color: #495057;
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: #495057;
  text-decoration: none;
  background-color: #f8f9fa;
}
.list-group-item-action:active {
  color: #526484;
  background-color: #e9ecef;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
}
.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #559bfb;
  border-color: #559bfb;
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: -1px;
  border-top-width: 1px;
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child {
  border-bottom-left-radius: 4px;
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child {
  border-top-right-radius: 4px;
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: 1px;
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: -1px;
  border-left-width: 1px;
}

@media (min-width: 420px) {
  .list-group-horizontal-mb {
    flex-direction: row;
  }
  .list-group-horizontal-mb > .list-group-item:first-child {
    border-bottom-left-radius: 4px;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-mb > .list-group-item:last-child {
    border-top-right-radius: 4px;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-mb > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-mb > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-mb > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child {
    border-bottom-left-radius: 4px;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child {
    border-top-right-radius: 4px;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child {
    border-bottom-left-radius: 4px;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child {
    border-top-right-radius: 4px;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child {
    border-bottom-left-radius: 4px;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child {
    border-top-right-radius: 4px;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child {
    border-bottom-left-radius: 4px;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child {
    border-top-right-radius: 4px;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 1540px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child {
    border-bottom-left-radius: 4px;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child {
    border-top-right-radius: 4px;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 1px;
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  color: #23327e;
  background-color: #cbd3fb;
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: #23327e;
  background-color: #b3bff9;
}
.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: #23327e;
  border-color: #23327e;
}

.list-group-item-secondary {
  color: #1c2633;
  background-color: #c7ccd3;
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: #1c2633;
  background-color: #b9bfc8;
}
.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: #1c2633;
  border-color: #1c2633;
}

.list-group-item-success {
  color: #107459;
  background-color: #c0f6e8;
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: #107459;
  background-color: #aaf3e0;
}
.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: #107459;
  border-color: #107459;
}

.list-group-item-info {
  color: #056573;
  background-color: #baeef6;
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: #056573;
  background-color: #a3e8f3;
}
.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: #056573;
  border-color: #056573;
}

.list-group-item-warning {
  color: #7f6207;
  background-color: #fcedbc;
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: #7f6207;
  background-color: #fbe6a4;
}
.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: #7f6207;
  border-color: #7f6207;
}

.list-group-item-danger {
  color: #792b25;
  background-color: #f9cfcb;
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: #792b25;
  background-color: #f6bab4;
}
.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: #792b25;
  border-color: #792b25;
}

.list-group-item-dark {
  color: #0f1624;
  background-color: #bfc4cb;
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: #0f1624;
  background-color: #b1b7c0;
}
.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: #0f1624;
  border-color: #0f1624;
}

.list-group-item-gray {
  color: #434b57;
  background-color: #dbe0e6;
}
.list-group-item-gray.list-group-item-action:hover, .list-group-item-gray.list-group-item-action:focus {
  color: #434b57;
  background-color: #ccd3dc;
}
.list-group-item-gray.list-group-item-action.active {
  color: #fff;
  background-color: #434b57;
  border-color: #434b57;
}

.list-group-item-light {
  color: #77797e;
  background-color: #f8f9fb;
}
.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  color: #77797e;
  background-color: #e8ebf2;
}
.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: #77797e;
  border-color: #77797e;
}

.list-group-item-lighter {
  color: #7f8082;
  background-color: #fcfcfe;
}
.list-group-item-lighter.list-group-item-action:hover, .list-group-item-lighter.list-group-item-action:focus {
  color: #7f8082;
  background-color: #e9e9f8;
}
.list-group-item-lighter.list-group-item-action.active {
  color: #fff;
  background-color: #7f8082;
  border-color: #7f8082;
}

.close {
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
}
.close:hover {
  color: #000;
  text-decoration: none;
}
.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {
  opacity: 0.75;
}

button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
}

a.close.disabled {
  pointer-events: none;
}

.toast {
  flex-basis: 350px;
  max-width: 350px;
  font-size: 0.875rem;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
  opacity: 0;
  border-radius: 0.25rem;
}
.toast:not(:last-child) {
  margin-bottom: 0.75rem;
}
.toast.showing {
  opacity: 1;
}
.toast.show {
  display: block;
  opacity: 1;
}
.toast.hide {
  display: none;
}

.toast-header {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  color: #6c757d;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.toast-body {
  padding: 0.75rem;
}

.modal-open {
  overflow: hidden;
}
.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -30px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none !important;
}
.modal.modal-static .modal-dialog {
  transform: scale(0.95);
}

.modal-dialog-scrollable {
  display: flex;
  max-height: calc(100% - 1rem);
}
.modal-dialog-scrollable .modal-content {
  max-height: calc(100vh - 1rem);
  overflow: hidden;
}
.modal-dialog-scrollable .modal-header,
.modal-dialog-scrollable .modal-footer {
  flex-shrink: 0;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}
.modal-dialog-centered::before {
  display: block;
  height: calc(100vh - 1rem);
  height: min-content;
  content: "";
}
.modal-dialog-centered.modal-dialog-scrollable {
  flex-direction: column;
  justify-content: center;
  height: 100%;
}
.modal-dialog-centered.modal-dialog-scrollable .modal-content {
  max-height: none;
}
.modal-dialog-centered.modal-dialog-scrollable::before {
  content: none;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 0 solid rgba(0, 0, 0, 0);
  border-radius: 5px;
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #364a63;
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: 0.5;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #dbdfea;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.modal-header .close {
  padding: 1rem 1.25rem;
  margin: -1rem -1.25rem -1rem auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1.25rem;
}

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 1rem;
  border-top: 1px solid #dbdfea;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}
.modal-footer > * {
  margin: 0.25rem;
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 520px;
    margin: 1.75rem auto;
  }
  .modal-dialog-scrollable {
    max-height: calc(100% - 3.5rem);
  }
  .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 3.5rem);
  }
  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }
  .modal-dialog-centered::before {
    height: calc(100vh - 3.5rem);
    height: min-content;
  }
  .modal-sm {
    max-width: 360px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    max-width: 720px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    max-width: 980px;
  }
}
.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: "DM Sans", sans-serif, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.65;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: 0.8125rem;
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: 0.9;
}
.tooltip .arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}
.tooltip .arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top, .bs-tooltip-auto[x-placement^=top] {
  padding: 0.4rem 0;
}
.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=top] .arrow {
  bottom: 0;
}
.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=top] .arrow::before {
  top: 0;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #1f2b3a;
}

.bs-tooltip-right, .bs-tooltip-auto[x-placement^=right] {
  padding: 0 0.4rem;
}
.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=right] .arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=right] .arrow::before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #1f2b3a;
}

.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=bottom] {
  padding: 0.4rem 0;
}
.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=bottom] .arrow {
  top: 0;
}
.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #1f2b3a;
}

.bs-tooltip-left, .bs-tooltip-auto[x-placement^=left] {
  padding: 0 0.4rem;
}
.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=left] .arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=left] .arrow::before {
  left: 0;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #1f2b3a;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.75rem;
  color: #fff;
  text-align: center;
  background-color: #1f2b3a;
  border-radius: 3px;
}

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: "DM Sans", sans-serif, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.65;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}
.popover .arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
  margin: 0 5px;
}
.popover .arrow::before, .popover .arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top, .bs-popover-auto[x-placement^=top] {
  margin-bottom: 0.5rem;
}
.bs-popover-top > .arrow, .bs-popover-auto[x-placement^=top] > .arrow {
  bottom: calc(-0.5rem - 1px);
}
.bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^=top] > .arrow::before {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=top] > .arrow::after {
  bottom: 1px;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #fff;
}

.bs-popover-right, .bs-popover-auto[x-placement^=right] {
  margin-left: 0.5rem;
}
.bs-popover-right > .arrow, .bs-popover-auto[x-placement^=right] > .arrow {
  left: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 5px 0;
}
.bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^=right] > .arrow::before {
  left: 0;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^=right] > .arrow::after {
  left: 1px;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #fff;
}

.bs-popover-bottom, .bs-popover-auto[x-placement^=bottom] {
  margin-top: 0.5rem;
}
.bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^=bottom] > .arrow {
  top: calc(-0.5rem - 1px);
}
.bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^=bottom] > .arrow::before {
  top: 0;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^=bottom] > .arrow::after {
  top: 1px;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #fff;
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 1px solid #f7f7f7;
}

.bs-popover-left, .bs-popover-auto[x-placement^=left] {
  margin-right: 0.5rem;
}
.bs-popover-left > .arrow, .bs-popover-auto[x-placement^=left] > .arrow {
  right: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 5px 0;
}
.bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^=left] > .arrow::before {
  right: 0;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^=left] > .arrow::after {
  right: 1px;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #fff;
}

.popover-header {
  padding: 0.5rem 0.75rem;
  margin-bottom: 0;
  font-size: 0.775rem;
  background-color: #f7f7f7;
  border-bottom: 1px solid #ebebeb;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 0.5rem 0.75rem;
  color: #526484;
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-left),
.active.carousel-item-right {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-right),
.active.carousel-item-left {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-left,
  .carousel-fade .active.carousel-item-right {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: 50%/100% 100% no-repeat;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators li {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators li {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  border: 0.25em solid currentcolor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: 0.75s linear infinite spinner-border;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  background-color: currentcolor;
  border-radius: 50%;
  opacity: 0;
  animation: 0.75s linear infinite spinner-grow;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    animation-duration: 1.5s;
  }
}
.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.bg-primary {
  background-color: #4461F2 !important;
}

a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  background-color: #1439ef !important;
}

.bg-secondary {
  background-color: #364a63 !important;
}

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: #243142 !important;
}

.bg-success {
  background-color: #1ee0ac !important;
}

a.bg-success:hover, a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  background-color: #18b389 !important;
}

.bg-info {
  background-color: #09c2de !important;
}

a.bg-info:hover, a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  background-color: #0797ad !important;
}

.bg-warning {
  background-color: #f4bd0e !important;
}

a.bg-warning:hover, a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  background-color: #c69909 !important;
}

.bg-danger {
  background-color: #e85347 !important;
}

a.bg-danger:hover, a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  background-color: #e02b1c !important;
}

.bg-dark {
  background-color: #1c2b46 !important;
}

a.bg-dark:hover, a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  background-color: #0d1522 !important;
}

.bg-gray {
  background-color: #8091a7 !important;
}

a.bg-gray:hover, a.bg-gray:focus,
button.bg-gray:hover,
button.bg-gray:focus {
  background-color: #647790 !important;
}

.bg-light, .dual-listbox .dual-listbox__item:hover {
  background-color: #e5e9f2 !important;
}

a.bg-light:hover, .dual-listbox a.dual-listbox__item:hover, a.bg-light:focus,
button.bg-light:hover,
.dual-listbox button.dual-listbox__item:hover,
button.bg-light:focus {
  background-color: #c3cce1 !important;
}

.bg-lighter, .rdl-control > option:hover {
  background-color: #f5f6fa !important;
}

a.bg-lighter:hover, a.bg-lighter:focus,
button.bg-lighter:hover,
button.bg-lighter:focus {
  background-color: #d3d7e9 !important;
}

.bg-white {
  background-color: #fff !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.border {
  border: 1px solid #dbdfea !important;
}

.border-top {
  border-top: 1px solid #dbdfea !important;
}

.border-right {
  border-right: 1px solid #dbdfea !important;
}

.border-bottom {
  border-bottom: 1px solid #dbdfea !important;
}

.border-left {
  border-left: 1px solid #dbdfea !important;
}

.border-0, .no-bdr {
  border: 0 !important;
}

.border-top-0, .no-bdr-y, .no-bdr-t {
  border-top: 0 !important;
}

.border-right-0, .no-bdr-x, .no-bdr-r {
  border-right: 0 !important;
}

.border-bottom-0, .no-bdr-y, .no-bdr-b {
  border-bottom: 0 !important;
}

.border-left-0, .no-bdr-x, .no-bdr-l {
  border-left: 0 !important;
}

.border-primary {
  border-color: #4461F2 !important;
}

.border-secondary {
  border-color: #364a63 !important;
}

.border-success {
  border-color: #1ee0ac !important;
}

.border-info {
  border-color: #09c2de !important;
}

.border-warning {
  border-color: #f4bd0e !important;
}

.border-danger {
  border-color: #e85347 !important;
}

.border-dark {
  border-color: #1c2b46 !important;
}

.border-gray {
  border-color: #8091a7 !important;
}

.border-light {
  border-color: #e5e9f2 !important;
}

.border-lighter {
  border-color: #f5f6fa !important;
}

.border-white {
  border-color: #fff !important;
}

.rounded-sm {
  border-radius: 3px !important;
}

.rounded {
  border-radius: 4px !important;
}

.rounded-top {
  border-top-left-radius: 4px !important;
  border-top-right-radius: 4px !important;
}

.rounded-right {
  border-top-right-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
}

.rounded-bottom {
  border-bottom-right-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}

.rounded-left {
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}

.rounded-lg {
  border-radius: 5px !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 1.5rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.d-none {
  display: none !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex, .stretch, .center, .between-center, .between-start, .justify-around, .justify-between, .justify-center, .justify-end, .justify-start, .align-center, .align-end, .align-start {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

@media (min-width: 420px) {
  .d-mb-none {
    display: none !important;
  }
  .d-mb-inline {
    display: inline !important;
  }
  .d-mb-inline-block {
    display: inline-block !important;
  }
  .d-mb-block {
    display: block !important;
  }
  .d-mb-table {
    display: table !important;
  }
  .d-mb-table-row {
    display: table-row !important;
  }
  .d-mb-table-cell {
    display: table-cell !important;
  }
  .d-mb-flex {
    display: flex !important;
  }
  .d-mb-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 576px) {
  .d-sm-none {
    display: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 1540px) {
  .d-xxl-none {
    display: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
}
@media print {
  .d-print-none {
    display: none !important;
  }
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
}
.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.embed-responsive::before {
  display: block;
  content: "";
}
.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.embed-responsive-21by9::before {
  padding-top: 42.85714286%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.justify-content-start, .justify-start {
  justify-content: flex-start !important;
}

.justify-content-end, .justify-end {
  justify-content: flex-end !important;
}

.justify-content-center, .center, .justify-center {
  justify-content: center !important;
}

.justify-content-between, .between-center, .between-start, .justify-between {
  justify-content: space-between !important;
}

.justify-content-around, .justify-around {
  justify-content: space-around !important;
}

.align-items-start, .between-start, .align-start {
  align-items: flex-start !important;
}

.align-items-end, .align-end {
  align-items: flex-end !important;
}

.align-items-center, .center, .between-center, .align-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch, .stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

@media (min-width: 420px) {
  .flex-mb-row {
    flex-direction: row !important;
  }
  .flex-mb-column {
    flex-direction: column !important;
  }
  .flex-mb-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-mb-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-mb-wrap {
    flex-wrap: wrap !important;
  }
  .flex-mb-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-mb-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-mb-fill {
    flex: 1 1 auto !important;
  }
  .flex-mb-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-mb-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-mb-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-mb-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-mb-start {
    justify-content: flex-start !important;
  }
  .justify-content-mb-end {
    justify-content: flex-end !important;
  }
  .justify-content-mb-center {
    justify-content: center !important;
  }
  .justify-content-mb-between {
    justify-content: space-between !important;
  }
  .justify-content-mb-around {
    justify-content: space-around !important;
  }
  .align-items-mb-start {
    align-items: flex-start !important;
  }
  .align-items-mb-end {
    align-items: flex-end !important;
  }
  .align-items-mb-center {
    align-items: center !important;
  }
  .align-items-mb-baseline {
    align-items: baseline !important;
  }
  .align-items-mb-stretch {
    align-items: stretch !important;
  }
  .align-content-mb-start {
    align-content: flex-start !important;
  }
  .align-content-mb-end {
    align-content: flex-end !important;
  }
  .align-content-mb-center {
    align-content: center !important;
  }
  .align-content-mb-between {
    align-content: space-between !important;
  }
  .align-content-mb-around {
    align-content: space-around !important;
  }
  .align-content-mb-stretch {
    align-content: stretch !important;
  }
  .align-self-mb-auto {
    align-self: auto !important;
  }
  .align-self-mb-start {
    align-self: flex-start !important;
  }
  .align-self-mb-end {
    align-self: flex-end !important;
  }
  .align-self-mb-center {
    align-self: center !important;
  }
  .align-self-mb-baseline {
    align-self: baseline !important;
  }
  .align-self-mb-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 1540px) {
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
}
.float-left {
  float: left !important;
}

.float-right {
  float: right !important;
}

.float-none {
  float: none !important;
}

@media (min-width: 420px) {
  .float-mb-left {
    float: left !important;
  }
  .float-mb-right {
    float: right !important;
  }
  .float-mb-none {
    float: none !important;
  }
}
@media (min-width: 576px) {
  .float-sm-left {
    float: left !important;
  }
  .float-sm-right {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
}
@media (min-width: 768px) {
  .float-md-left {
    float: left !important;
  }
  .float-md-right {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
}
@media (min-width: 992px) {
  .float-lg-left {
    float: left !important;
  }
  .float-lg-right {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important;
  }
  .float-xl-right {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
}
@media (min-width: 1540px) {
  .float-xxl-left {
    float: left !important;
  }
  .float-xxl-right {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
}
.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.position-static {
  position: static !important;
}

.position-relative, .pos-rel {
  position: relative !important;
}

.position-absolute, .pos-abs {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@supports (position: sticky) {
  .sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(43, 55, 72, 0.15) !important;
}

.shadow {
  box-shadow: 0 3px 12px 1px rgba(43, 55, 72, 0.15) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(43, 55, 72, 0.25) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.vw-100 {
  width: 100vw !important;
}

.vh-100 {
  height: 100vh !important;
}

.m-0 {
  margin: 0 !important;
}

.mt-0,
.my-0 {
  margin-top: 0 !important;
}

.mr-0,
.mx-0 {
  margin-right: 0 !important;
}

.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}

.ml-0,
.mx-0 {
  margin-left: 0 !important;
}

.m-1 {
  margin: 0.375rem !important;
}

.mt-1,
.my-1 {
  margin-top: 0.375rem !important;
}

.mr-1,
.mx-1 {
  margin-right: 0.375rem !important;
}

.mb-1,
.my-1 {
  margin-bottom: 0.375rem !important;
}

.ml-1,
.mx-1 {
  margin-left: 0.375rem !important;
}

.m-2 {
  margin: 0.75rem !important;
}

.mt-2,
.my-2 {
  margin-top: 0.75rem !important;
}

.mr-2,
.mx-2 {
  margin-right: 0.75rem !important;
}

.mb-2,
.my-2 {
  margin-bottom: 0.75rem !important;
}

.ml-2,
.mx-2 {
  margin-left: 0.75rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.mt-3,
.my-3 {
  margin-top: 1rem !important;
}

.mr-3,
.mx-3 {
  margin-right: 1rem !important;
}

.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}

.ml-3,
.mx-3 {
  margin-left: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.mt-4,
.my-4 {
  margin-top: 1.5rem !important;
}

.mr-4,
.mx-4 {
  margin-right: 1.5rem !important;
}

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}

.ml-4,
.mx-4 {
  margin-left: 1.5rem !important;
}

.m-5 {
  margin: 2.75rem !important;
}

.mt-5,
.my-5 {
  margin-top: 2.75rem !important;
}

.mr-5,
.mx-5 {
  margin-right: 2.75rem !important;
}

.mb-5,
.my-5 {
  margin-bottom: 2.75rem !important;
}

.ml-5,
.mx-5 {
  margin-left: 2.75rem !important;
}

.m-gs {
  margin: 28px !important;
}

.mt-gs,
.my-gs {
  margin-top: 28px !important;
}

.mr-gs,
.mx-gs {
  margin-right: 28px !important;
}

.mb-gs,
.my-gs {
  margin-bottom: 28px !important;
}

.ml-gs,
.mx-gs {
  margin-left: 28px !important;
}

.p-0 {
  padding: 0 !important;
}

.pt-0,
.py-0 {
  padding-top: 0 !important;
}

.pr-0,
.px-0 {
  padding-right: 0 !important;
}

.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}

.pl-0,
.px-0 {
  padding-left: 0 !important;
}

.p-1 {
  padding: 0.375rem !important;
}

.pt-1,
.py-1 {
  padding-top: 0.375rem !important;
}

.pr-1,
.px-1 {
  padding-right: 0.375rem !important;
}

.pb-1,
.py-1 {
  padding-bottom: 0.375rem !important;
}

.pl-1,
.px-1 {
  padding-left: 0.375rem !important;
}

.p-2 {
  padding: 0.75rem !important;
}

.pt-2,
.py-2 {
  padding-top: 0.75rem !important;
}

.pr-2,
.px-2 {
  padding-right: 0.75rem !important;
}

.pb-2,
.py-2 {
  padding-bottom: 0.75rem !important;
}

.pl-2,
.px-2 {
  padding-left: 0.75rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.pt-3,
.py-3 {
  padding-top: 1rem !important;
}

.pr-3,
.px-3 {
  padding-right: 1rem !important;
}

.pb-3,
.py-3 {
  padding-bottom: 1rem !important;
}

.pl-3,
.px-3 {
  padding-left: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.pt-4,
.py-4 {
  padding-top: 1.5rem !important;
}

.pr-4,
.px-4 {
  padding-right: 1.5rem !important;
}

.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important;
}

.pl-4,
.px-4 {
  padding-left: 1.5rem !important;
}

.p-5 {
  padding: 2.75rem !important;
}

.pt-5,
.py-5 {
  padding-top: 2.75rem !important;
}

.pr-5,
.px-5 {
  padding-right: 2.75rem !important;
}

.pb-5,
.py-5 {
  padding-bottom: 2.75rem !important;
}

.pl-5,
.px-5 {
  padding-left: 2.75rem !important;
}

.p-gs {
  padding: 28px !important;
}

.pt-gs,
.py-gs {
  padding-top: 28px !important;
}

.pr-gs,
.px-gs {
  padding-right: 28px !important;
}

.pb-gs,
.py-gs {
  padding-bottom: 28px !important;
}

.pl-gs,
.px-gs {
  padding-left: 28px !important;
}

.m-n1 {
  margin: -0.375rem !important;
}

.mt-n1,
.my-n1 {
  margin-top: -0.375rem !important;
}

.mr-n1,
.mx-n1 {
  margin-right: -0.375rem !important;
}

.mb-n1,
.my-n1 {
  margin-bottom: -0.375rem !important;
}

.ml-n1,
.mx-n1 {
  margin-left: -0.375rem !important;
}

.m-n2 {
  margin: -0.75rem !important;
}

.mt-n2,
.my-n2 {
  margin-top: -0.75rem !important;
}

.mr-n2,
.mx-n2 {
  margin-right: -0.75rem !important;
}

.mb-n2,
.my-n2 {
  margin-bottom: -0.75rem !important;
}

.ml-n2,
.mx-n2 {
  margin-left: -0.75rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.mt-n3,
.my-n3 {
  margin-top: -1rem !important;
}

.mr-n3,
.mx-n3 {
  margin-right: -1rem !important;
}

.mb-n3,
.my-n3 {
  margin-bottom: -1rem !important;
}

.ml-n3,
.mx-n3 {
  margin-left: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.mt-n4,
.my-n4 {
  margin-top: -1.5rem !important;
}

.mr-n4,
.mx-n4 {
  margin-right: -1.5rem !important;
}

.mb-n4,
.my-n4 {
  margin-bottom: -1.5rem !important;
}

.ml-n4,
.mx-n4 {
  margin-left: -1.5rem !important;
}

.m-n5 {
  margin: -2.75rem !important;
}

.mt-n5,
.my-n5 {
  margin-top: -2.75rem !important;
}

.mr-n5,
.mx-n5 {
  margin-right: -2.75rem !important;
}

.mb-n5,
.my-n5 {
  margin-bottom: -2.75rem !important;
}

.ml-n5,
.mx-n5 {
  margin-left: -2.75rem !important;
}

.m-ngs {
  margin: -28px !important;
}

.mt-ngs,
.my-ngs {
  margin-top: -28px !important;
}

.mr-ngs,
.mx-ngs {
  margin-right: -28px !important;
}

.mb-ngs,
.my-ngs {
  margin-bottom: -28px !important;
}

.ml-ngs,
.mx-ngs {
  margin-left: -28px !important;
}

.m-auto {
  margin: auto !important;
}

.mt-auto,
.my-auto {
  margin-top: auto !important;
}

.mr-auto,
.mx-auto {
  margin-right: auto !important;
}

.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}

.ml-auto,
.mx-auto {
  margin-left: auto !important;
}

@media (min-width: 420px) {
  .m-mb-0 {
    margin: 0 !important;
  }
  .mt-mb-0,
  .my-mb-0 {
    margin-top: 0 !important;
  }
  .mr-mb-0,
  .mx-mb-0 {
    margin-right: 0 !important;
  }
  .mb-mb-0,
  .my-mb-0 {
    margin-bottom: 0 !important;
  }
  .ml-mb-0,
  .mx-mb-0 {
    margin-left: 0 !important;
  }
  .m-mb-1 {
    margin: 0.375rem !important;
  }
  .mt-mb-1,
  .my-mb-1 {
    margin-top: 0.375rem !important;
  }
  .mr-mb-1,
  .mx-mb-1 {
    margin-right: 0.375rem !important;
  }
  .mb-mb-1,
  .my-mb-1 {
    margin-bottom: 0.375rem !important;
  }
  .ml-mb-1,
  .mx-mb-1 {
    margin-left: 0.375rem !important;
  }
  .m-mb-2 {
    margin: 0.75rem !important;
  }
  .mt-mb-2,
  .my-mb-2 {
    margin-top: 0.75rem !important;
  }
  .mr-mb-2,
  .mx-mb-2 {
    margin-right: 0.75rem !important;
  }
  .mb-mb-2,
  .my-mb-2 {
    margin-bottom: 0.75rem !important;
  }
  .ml-mb-2,
  .mx-mb-2 {
    margin-left: 0.75rem !important;
  }
  .m-mb-3 {
    margin: 1rem !important;
  }
  .mt-mb-3,
  .my-mb-3 {
    margin-top: 1rem !important;
  }
  .mr-mb-3,
  .mx-mb-3 {
    margin-right: 1rem !important;
  }
  .mb-mb-3,
  .my-mb-3 {
    margin-bottom: 1rem !important;
  }
  .ml-mb-3,
  .mx-mb-3 {
    margin-left: 1rem !important;
  }
  .m-mb-4 {
    margin: 1.5rem !important;
  }
  .mt-mb-4,
  .my-mb-4 {
    margin-top: 1.5rem !important;
  }
  .mr-mb-4,
  .mx-mb-4 {
    margin-right: 1.5rem !important;
  }
  .mb-mb-4,
  .my-mb-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-mb-4,
  .mx-mb-4 {
    margin-left: 1.5rem !important;
  }
  .m-mb-5 {
    margin: 2.75rem !important;
  }
  .mt-mb-5,
  .my-mb-5 {
    margin-top: 2.75rem !important;
  }
  .mr-mb-5,
  .mx-mb-5 {
    margin-right: 2.75rem !important;
  }
  .mb-mb-5,
  .my-mb-5 {
    margin-bottom: 2.75rem !important;
  }
  .ml-mb-5,
  .mx-mb-5 {
    margin-left: 2.75rem !important;
  }
  .m-mb-gs {
    margin: 28px !important;
  }
  .mt-mb-gs,
  .my-mb-gs {
    margin-top: 28px !important;
  }
  .mr-mb-gs,
  .mx-mb-gs {
    margin-right: 28px !important;
  }
  .mb-mb-gs,
  .my-mb-gs {
    margin-bottom: 28px !important;
  }
  .ml-mb-gs,
  .mx-mb-gs {
    margin-left: 28px !important;
  }
  .p-mb-0 {
    padding: 0 !important;
  }
  .pt-mb-0,
  .py-mb-0 {
    padding-top: 0 !important;
  }
  .pr-mb-0,
  .px-mb-0 {
    padding-right: 0 !important;
  }
  .pb-mb-0,
  .py-mb-0 {
    padding-bottom: 0 !important;
  }
  .pl-mb-0,
  .px-mb-0 {
    padding-left: 0 !important;
  }
  .p-mb-1 {
    padding: 0.375rem !important;
  }
  .pt-mb-1,
  .py-mb-1 {
    padding-top: 0.375rem !important;
  }
  .pr-mb-1,
  .px-mb-1 {
    padding-right: 0.375rem !important;
  }
  .pb-mb-1,
  .py-mb-1 {
    padding-bottom: 0.375rem !important;
  }
  .pl-mb-1,
  .px-mb-1 {
    padding-left: 0.375rem !important;
  }
  .p-mb-2 {
    padding: 0.75rem !important;
  }
  .pt-mb-2,
  .py-mb-2 {
    padding-top: 0.75rem !important;
  }
  .pr-mb-2,
  .px-mb-2 {
    padding-right: 0.75rem !important;
  }
  .pb-mb-2,
  .py-mb-2 {
    padding-bottom: 0.75rem !important;
  }
  .pl-mb-2,
  .px-mb-2 {
    padding-left: 0.75rem !important;
  }
  .p-mb-3 {
    padding: 1rem !important;
  }
  .pt-mb-3,
  .py-mb-3 {
    padding-top: 1rem !important;
  }
  .pr-mb-3,
  .px-mb-3 {
    padding-right: 1rem !important;
  }
  .pb-mb-3,
  .py-mb-3 {
    padding-bottom: 1rem !important;
  }
  .pl-mb-3,
  .px-mb-3 {
    padding-left: 1rem !important;
  }
  .p-mb-4 {
    padding: 1.5rem !important;
  }
  .pt-mb-4,
  .py-mb-4 {
    padding-top: 1.5rem !important;
  }
  .pr-mb-4,
  .px-mb-4 {
    padding-right: 1.5rem !important;
  }
  .pb-mb-4,
  .py-mb-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-mb-4,
  .px-mb-4 {
    padding-left: 1.5rem !important;
  }
  .p-mb-5 {
    padding: 2.75rem !important;
  }
  .pt-mb-5,
  .py-mb-5 {
    padding-top: 2.75rem !important;
  }
  .pr-mb-5,
  .px-mb-5 {
    padding-right: 2.75rem !important;
  }
  .pb-mb-5,
  .py-mb-5 {
    padding-bottom: 2.75rem !important;
  }
  .pl-mb-5,
  .px-mb-5 {
    padding-left: 2.75rem !important;
  }
  .p-mb-gs {
    padding: 28px !important;
  }
  .pt-mb-gs,
  .py-mb-gs {
    padding-top: 28px !important;
  }
  .pr-mb-gs,
  .px-mb-gs {
    padding-right: 28px !important;
  }
  .pb-mb-gs,
  .py-mb-gs {
    padding-bottom: 28px !important;
  }
  .pl-mb-gs,
  .px-mb-gs {
    padding-left: 28px !important;
  }
  .m-mb-n1 {
    margin: -0.375rem !important;
  }
  .mt-mb-n1,
  .my-mb-n1 {
    margin-top: -0.375rem !important;
  }
  .mr-mb-n1,
  .mx-mb-n1 {
    margin-right: -0.375rem !important;
  }
  .mb-mb-n1,
  .my-mb-n1 {
    margin-bottom: -0.375rem !important;
  }
  .ml-mb-n1,
  .mx-mb-n1 {
    margin-left: -0.375rem !important;
  }
  .m-mb-n2 {
    margin: -0.75rem !important;
  }
  .mt-mb-n2,
  .my-mb-n2 {
    margin-top: -0.75rem !important;
  }
  .mr-mb-n2,
  .mx-mb-n2 {
    margin-right: -0.75rem !important;
  }
  .mb-mb-n2,
  .my-mb-n2 {
    margin-bottom: -0.75rem !important;
  }
  .ml-mb-n2,
  .mx-mb-n2 {
    margin-left: -0.75rem !important;
  }
  .m-mb-n3 {
    margin: -1rem !important;
  }
  .mt-mb-n3,
  .my-mb-n3 {
    margin-top: -1rem !important;
  }
  .mr-mb-n3,
  .mx-mb-n3 {
    margin-right: -1rem !important;
  }
  .mb-mb-n3,
  .my-mb-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-mb-n3,
  .mx-mb-n3 {
    margin-left: -1rem !important;
  }
  .m-mb-n4 {
    margin: -1.5rem !important;
  }
  .mt-mb-n4,
  .my-mb-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-mb-n4,
  .mx-mb-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-mb-n4,
  .my-mb-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-mb-n4,
  .mx-mb-n4 {
    margin-left: -1.5rem !important;
  }
  .m-mb-n5 {
    margin: -2.75rem !important;
  }
  .mt-mb-n5,
  .my-mb-n5 {
    margin-top: -2.75rem !important;
  }
  .mr-mb-n5,
  .mx-mb-n5 {
    margin-right: -2.75rem !important;
  }
  .mb-mb-n5,
  .my-mb-n5 {
    margin-bottom: -2.75rem !important;
  }
  .ml-mb-n5,
  .mx-mb-n5 {
    margin-left: -2.75rem !important;
  }
  .m-mb-ngs {
    margin: -28px !important;
  }
  .mt-mb-ngs,
  .my-mb-ngs {
    margin-top: -28px !important;
  }
  .mr-mb-ngs,
  .mx-mb-ngs {
    margin-right: -28px !important;
  }
  .mb-mb-ngs,
  .my-mb-ngs {
    margin-bottom: -28px !important;
  }
  .ml-mb-ngs,
  .mx-mb-ngs {
    margin-left: -28px !important;
  }
  .m-mb-auto {
    margin: auto !important;
  }
  .mt-mb-auto,
  .my-mb-auto {
    margin-top: auto !important;
  }
  .mr-mb-auto,
  .mx-mb-auto {
    margin-right: auto !important;
  }
  .mb-mb-auto,
  .my-mb-auto {
    margin-bottom: auto !important;
  }
  .ml-mb-auto,
  .mx-mb-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important;
  }
  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important;
  }
  .mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important;
  }
  .mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important;
  }
  .ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important;
  }
  .m-sm-1 {
    margin: 0.375rem !important;
  }
  .mt-sm-1,
  .my-sm-1 {
    margin-top: 0.375rem !important;
  }
  .mr-sm-1,
  .mx-sm-1 {
    margin-right: 0.375rem !important;
  }
  .mb-sm-1,
  .my-sm-1 {
    margin-bottom: 0.375rem !important;
  }
  .ml-sm-1,
  .mx-sm-1 {
    margin-left: 0.375rem !important;
  }
  .m-sm-2 {
    margin: 0.75rem !important;
  }
  .mt-sm-2,
  .my-sm-2 {
    margin-top: 0.75rem !important;
  }
  .mr-sm-2,
  .mx-sm-2 {
    margin-right: 0.75rem !important;
  }
  .mb-sm-2,
  .my-sm-2 {
    margin-bottom: 0.75rem !important;
  }
  .ml-sm-2,
  .mx-sm-2 {
    margin-left: 0.75rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .mt-sm-3,
  .my-sm-3 {
    margin-top: 1rem !important;
  }
  .mr-sm-3,
  .mx-sm-3 {
    margin-right: 1rem !important;
  }
  .mb-sm-3,
  .my-sm-3 {
    margin-bottom: 1rem !important;
  }
  .ml-sm-3,
  .mx-sm-3 {
    margin-left: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .mt-sm-4,
  .my-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mr-sm-4,
  .mx-sm-4 {
    margin-right: 1.5rem !important;
  }
  .mb-sm-4,
  .my-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-sm-4,
  .mx-sm-4 {
    margin-left: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 2.75rem !important;
  }
  .mt-sm-5,
  .my-sm-5 {
    margin-top: 2.75rem !important;
  }
  .mr-sm-5,
  .mx-sm-5 {
    margin-right: 2.75rem !important;
  }
  .mb-sm-5,
  .my-sm-5 {
    margin-bottom: 2.75rem !important;
  }
  .ml-sm-5,
  .mx-sm-5 {
    margin-left: 2.75rem !important;
  }
  .m-sm-gs {
    margin: 28px !important;
  }
  .mt-sm-gs,
  .my-sm-gs {
    margin-top: 28px !important;
  }
  .mr-sm-gs,
  .mx-sm-gs {
    margin-right: 28px !important;
  }
  .mb-sm-gs,
  .my-sm-gs {
    margin-bottom: 28px !important;
  }
  .ml-sm-gs,
  .mx-sm-gs {
    margin-left: 28px !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important;
  }
  .pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important;
  }
  .pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important;
  }
  .pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important;
  }
  .p-sm-1 {
    padding: 0.375rem !important;
  }
  .pt-sm-1,
  .py-sm-1 {
    padding-top: 0.375rem !important;
  }
  .pr-sm-1,
  .px-sm-1 {
    padding-right: 0.375rem !important;
  }
  .pb-sm-1,
  .py-sm-1 {
    padding-bottom: 0.375rem !important;
  }
  .pl-sm-1,
  .px-sm-1 {
    padding-left: 0.375rem !important;
  }
  .p-sm-2 {
    padding: 0.75rem !important;
  }
  .pt-sm-2,
  .py-sm-2 {
    padding-top: 0.75rem !important;
  }
  .pr-sm-2,
  .px-sm-2 {
    padding-right: 0.75rem !important;
  }
  .pb-sm-2,
  .py-sm-2 {
    padding-bottom: 0.75rem !important;
  }
  .pl-sm-2,
  .px-sm-2 {
    padding-left: 0.75rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .pt-sm-3,
  .py-sm-3 {
    padding-top: 1rem !important;
  }
  .pr-sm-3,
  .px-sm-3 {
    padding-right: 1rem !important;
  }
  .pb-sm-3,
  .py-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pl-sm-3,
  .px-sm-3 {
    padding-left: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .pt-sm-4,
  .py-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pr-sm-4,
  .px-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pb-sm-4,
  .py-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-sm-4,
  .px-sm-4 {
    padding-left: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 2.75rem !important;
  }
  .pt-sm-5,
  .py-sm-5 {
    padding-top: 2.75rem !important;
  }
  .pr-sm-5,
  .px-sm-5 {
    padding-right: 2.75rem !important;
  }
  .pb-sm-5,
  .py-sm-5 {
    padding-bottom: 2.75rem !important;
  }
  .pl-sm-5,
  .px-sm-5 {
    padding-left: 2.75rem !important;
  }
  .p-sm-gs {
    padding: 28px !important;
  }
  .pt-sm-gs,
  .py-sm-gs {
    padding-top: 28px !important;
  }
  .pr-sm-gs,
  .px-sm-gs {
    padding-right: 28px !important;
  }
  .pb-sm-gs,
  .py-sm-gs {
    padding-bottom: 28px !important;
  }
  .pl-sm-gs,
  .px-sm-gs {
    padding-left: 28px !important;
  }
  .m-sm-n1 {
    margin: -0.375rem !important;
  }
  .mt-sm-n1,
  .my-sm-n1 {
    margin-top: -0.375rem !important;
  }
  .mr-sm-n1,
  .mx-sm-n1 {
    margin-right: -0.375rem !important;
  }
  .mb-sm-n1,
  .my-sm-n1 {
    margin-bottom: -0.375rem !important;
  }
  .ml-sm-n1,
  .mx-sm-n1 {
    margin-left: -0.375rem !important;
  }
  .m-sm-n2 {
    margin: -0.75rem !important;
  }
  .mt-sm-n2,
  .my-sm-n2 {
    margin-top: -0.75rem !important;
  }
  .mr-sm-n2,
  .mx-sm-n2 {
    margin-right: -0.75rem !important;
  }
  .mb-sm-n2,
  .my-sm-n2 {
    margin-bottom: -0.75rem !important;
  }
  .ml-sm-n2,
  .mx-sm-n2 {
    margin-left: -0.75rem !important;
  }
  .m-sm-n3 {
    margin: -1rem !important;
  }
  .mt-sm-n3,
  .my-sm-n3 {
    margin-top: -1rem !important;
  }
  .mr-sm-n3,
  .mx-sm-n3 {
    margin-right: -1rem !important;
  }
  .mb-sm-n3,
  .my-sm-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-sm-n3,
  .mx-sm-n3 {
    margin-left: -1rem !important;
  }
  .m-sm-n4 {
    margin: -1.5rem !important;
  }
  .mt-sm-n4,
  .my-sm-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-sm-n4,
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-sm-n4,
  .my-sm-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-sm-n4,
  .mx-sm-n4 {
    margin-left: -1.5rem !important;
  }
  .m-sm-n5 {
    margin: -2.75rem !important;
  }
  .mt-sm-n5,
  .my-sm-n5 {
    margin-top: -2.75rem !important;
  }
  .mr-sm-n5,
  .mx-sm-n5 {
    margin-right: -2.75rem !important;
  }
  .mb-sm-n5,
  .my-sm-n5 {
    margin-bottom: -2.75rem !important;
  }
  .ml-sm-n5,
  .mx-sm-n5 {
    margin-left: -2.75rem !important;
  }
  .m-sm-ngs {
    margin: -28px !important;
  }
  .mt-sm-ngs,
  .my-sm-ngs {
    margin-top: -28px !important;
  }
  .mr-sm-ngs,
  .mx-sm-ngs {
    margin-right: -28px !important;
  }
  .mb-sm-ngs,
  .my-sm-ngs {
    margin-bottom: -28px !important;
  }
  .ml-sm-ngs,
  .mx-sm-ngs {
    margin-left: -28px !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important;
  }
  .mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important;
  }
  .ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important;
  }
  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important;
  }
  .mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important;
  }
  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important;
  }
  .ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important;
  }
  .m-md-1 {
    margin: 0.375rem !important;
  }
  .mt-md-1,
  .my-md-1 {
    margin-top: 0.375rem !important;
  }
  .mr-md-1,
  .mx-md-1 {
    margin-right: 0.375rem !important;
  }
  .mb-md-1,
  .my-md-1 {
    margin-bottom: 0.375rem !important;
  }
  .ml-md-1,
  .mx-md-1 {
    margin-left: 0.375rem !important;
  }
  .m-md-2 {
    margin: 0.75rem !important;
  }
  .mt-md-2,
  .my-md-2 {
    margin-top: 0.75rem !important;
  }
  .mr-md-2,
  .mx-md-2 {
    margin-right: 0.75rem !important;
  }
  .mb-md-2,
  .my-md-2 {
    margin-bottom: 0.75rem !important;
  }
  .ml-md-2,
  .mx-md-2 {
    margin-left: 0.75rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .mt-md-3,
  .my-md-3 {
    margin-top: 1rem !important;
  }
  .mr-md-3,
  .mx-md-3 {
    margin-right: 1rem !important;
  }
  .mb-md-3,
  .my-md-3 {
    margin-bottom: 1rem !important;
  }
  .ml-md-3,
  .mx-md-3 {
    margin-left: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .mt-md-4,
  .my-md-4 {
    margin-top: 1.5rem !important;
  }
  .mr-md-4,
  .mx-md-4 {
    margin-right: 1.5rem !important;
  }
  .mb-md-4,
  .my-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-md-4,
  .mx-md-4 {
    margin-left: 1.5rem !important;
  }
  .m-md-5 {
    margin: 2.75rem !important;
  }
  .mt-md-5,
  .my-md-5 {
    margin-top: 2.75rem !important;
  }
  .mr-md-5,
  .mx-md-5 {
    margin-right: 2.75rem !important;
  }
  .mb-md-5,
  .my-md-5 {
    margin-bottom: 2.75rem !important;
  }
  .ml-md-5,
  .mx-md-5 {
    margin-left: 2.75rem !important;
  }
  .m-md-gs {
    margin: 28px !important;
  }
  .mt-md-gs,
  .my-md-gs {
    margin-top: 28px !important;
  }
  .mr-md-gs,
  .mx-md-gs {
    margin-right: 28px !important;
  }
  .mb-md-gs,
  .my-md-gs {
    margin-bottom: 28px !important;
  }
  .ml-md-gs,
  .mx-md-gs {
    margin-left: 28px !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .pt-md-0,
  .py-md-0 {
    padding-top: 0 !important;
  }
  .pr-md-0,
  .px-md-0 {
    padding-right: 0 !important;
  }
  .pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important;
  }
  .pl-md-0,
  .px-md-0 {
    padding-left: 0 !important;
  }
  .p-md-1 {
    padding: 0.375rem !important;
  }
  .pt-md-1,
  .py-md-1 {
    padding-top: 0.375rem !important;
  }
  .pr-md-1,
  .px-md-1 {
    padding-right: 0.375rem !important;
  }
  .pb-md-1,
  .py-md-1 {
    padding-bottom: 0.375rem !important;
  }
  .pl-md-1,
  .px-md-1 {
    padding-left: 0.375rem !important;
  }
  .p-md-2 {
    padding: 0.75rem !important;
  }
  .pt-md-2,
  .py-md-2 {
    padding-top: 0.75rem !important;
  }
  .pr-md-2,
  .px-md-2 {
    padding-right: 0.75rem !important;
  }
  .pb-md-2,
  .py-md-2 {
    padding-bottom: 0.75rem !important;
  }
  .pl-md-2,
  .px-md-2 {
    padding-left: 0.75rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .pt-md-3,
  .py-md-3 {
    padding-top: 1rem !important;
  }
  .pr-md-3,
  .px-md-3 {
    padding-right: 1rem !important;
  }
  .pb-md-3,
  .py-md-3 {
    padding-bottom: 1rem !important;
  }
  .pl-md-3,
  .px-md-3 {
    padding-left: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .pt-md-4,
  .py-md-4 {
    padding-top: 1.5rem !important;
  }
  .pr-md-4,
  .px-md-4 {
    padding-right: 1.5rem !important;
  }
  .pb-md-4,
  .py-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-md-4,
  .px-md-4 {
    padding-left: 1.5rem !important;
  }
  .p-md-5 {
    padding: 2.75rem !important;
  }
  .pt-md-5,
  .py-md-5 {
    padding-top: 2.75rem !important;
  }
  .pr-md-5,
  .px-md-5 {
    padding-right: 2.75rem !important;
  }
  .pb-md-5,
  .py-md-5 {
    padding-bottom: 2.75rem !important;
  }
  .pl-md-5,
  .px-md-5 {
    padding-left: 2.75rem !important;
  }
  .p-md-gs {
    padding: 28px !important;
  }
  .pt-md-gs,
  .py-md-gs {
    padding-top: 28px !important;
  }
  .pr-md-gs,
  .px-md-gs {
    padding-right: 28px !important;
  }
  .pb-md-gs,
  .py-md-gs {
    padding-bottom: 28px !important;
  }
  .pl-md-gs,
  .px-md-gs {
    padding-left: 28px !important;
  }
  .m-md-n1 {
    margin: -0.375rem !important;
  }
  .mt-md-n1,
  .my-md-n1 {
    margin-top: -0.375rem !important;
  }
  .mr-md-n1,
  .mx-md-n1 {
    margin-right: -0.375rem !important;
  }
  .mb-md-n1,
  .my-md-n1 {
    margin-bottom: -0.375rem !important;
  }
  .ml-md-n1,
  .mx-md-n1 {
    margin-left: -0.375rem !important;
  }
  .m-md-n2 {
    margin: -0.75rem !important;
  }
  .mt-md-n2,
  .my-md-n2 {
    margin-top: -0.75rem !important;
  }
  .mr-md-n2,
  .mx-md-n2 {
    margin-right: -0.75rem !important;
  }
  .mb-md-n2,
  .my-md-n2 {
    margin-bottom: -0.75rem !important;
  }
  .ml-md-n2,
  .mx-md-n2 {
    margin-left: -0.75rem !important;
  }
  .m-md-n3 {
    margin: -1rem !important;
  }
  .mt-md-n3,
  .my-md-n3 {
    margin-top: -1rem !important;
  }
  .mr-md-n3,
  .mx-md-n3 {
    margin-right: -1rem !important;
  }
  .mb-md-n3,
  .my-md-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-md-n3,
  .mx-md-n3 {
    margin-left: -1rem !important;
  }
  .m-md-n4 {
    margin: -1.5rem !important;
  }
  .mt-md-n4,
  .my-md-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-md-n4,
  .mx-md-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-md-n4,
  .my-md-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-md-n4,
  .mx-md-n4 {
    margin-left: -1.5rem !important;
  }
  .m-md-n5 {
    margin: -2.75rem !important;
  }
  .mt-md-n5,
  .my-md-n5 {
    margin-top: -2.75rem !important;
  }
  .mr-md-n5,
  .mx-md-n5 {
    margin-right: -2.75rem !important;
  }
  .mb-md-n5,
  .my-md-n5 {
    margin-bottom: -2.75rem !important;
  }
  .ml-md-n5,
  .mx-md-n5 {
    margin-left: -2.75rem !important;
  }
  .m-md-ngs {
    margin: -28px !important;
  }
  .mt-md-ngs,
  .my-md-ngs {
    margin-top: -28px !important;
  }
  .mr-md-ngs,
  .mx-md-ngs {
    margin-right: -28px !important;
  }
  .mb-md-ngs,
  .my-md-ngs {
    margin-bottom: -28px !important;
  }
  .ml-md-ngs,
  .mx-md-ngs {
    margin-left: -28px !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mt-md-auto,
  .my-md-auto {
    margin-top: auto !important;
  }
  .mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important;
  }
  .mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important;
  }
  .ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important;
  }
  .mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important;
  }
  .mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important;
  }
  .mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important;
  }
  .ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important;
  }
  .m-lg-1 {
    margin: 0.375rem !important;
  }
  .mt-lg-1,
  .my-lg-1 {
    margin-top: 0.375rem !important;
  }
  .mr-lg-1,
  .mx-lg-1 {
    margin-right: 0.375rem !important;
  }
  .mb-lg-1,
  .my-lg-1 {
    margin-bottom: 0.375rem !important;
  }
  .ml-lg-1,
  .mx-lg-1 {
    margin-left: 0.375rem !important;
  }
  .m-lg-2 {
    margin: 0.75rem !important;
  }
  .mt-lg-2,
  .my-lg-2 {
    margin-top: 0.75rem !important;
  }
  .mr-lg-2,
  .mx-lg-2 {
    margin-right: 0.75rem !important;
  }
  .mb-lg-2,
  .my-lg-2 {
    margin-bottom: 0.75rem !important;
  }
  .ml-lg-2,
  .mx-lg-2 {
    margin-left: 0.75rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .mt-lg-3,
  .my-lg-3 {
    margin-top: 1rem !important;
  }
  .mr-lg-3,
  .mx-lg-3 {
    margin-right: 1rem !important;
  }
  .mb-lg-3,
  .my-lg-3 {
    margin-bottom: 1rem !important;
  }
  .ml-lg-3,
  .mx-lg-3 {
    margin-left: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .mt-lg-4,
  .my-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mr-lg-4,
  .mx-lg-4 {
    margin-right: 1.5rem !important;
  }
  .mb-lg-4,
  .my-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-lg-4,
  .mx-lg-4 {
    margin-left: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 2.75rem !important;
  }
  .mt-lg-5,
  .my-lg-5 {
    margin-top: 2.75rem !important;
  }
  .mr-lg-5,
  .mx-lg-5 {
    margin-right: 2.75rem !important;
  }
  .mb-lg-5,
  .my-lg-5 {
    margin-bottom: 2.75rem !important;
  }
  .ml-lg-5,
  .mx-lg-5 {
    margin-left: 2.75rem !important;
  }
  .m-lg-gs {
    margin: 28px !important;
  }
  .mt-lg-gs,
  .my-lg-gs {
    margin-top: 28px !important;
  }
  .mr-lg-gs,
  .mx-lg-gs {
    margin-right: 28px !important;
  }
  .mb-lg-gs,
  .my-lg-gs {
    margin-bottom: 28px !important;
  }
  .ml-lg-gs,
  .mx-lg-gs {
    margin-left: 28px !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important;
  }
  .pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important;
  }
  .pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important;
  }
  .pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important;
  }
  .p-lg-1 {
    padding: 0.375rem !important;
  }
  .pt-lg-1,
  .py-lg-1 {
    padding-top: 0.375rem !important;
  }
  .pr-lg-1,
  .px-lg-1 {
    padding-right: 0.375rem !important;
  }
  .pb-lg-1,
  .py-lg-1 {
    padding-bottom: 0.375rem !important;
  }
  .pl-lg-1,
  .px-lg-1 {
    padding-left: 0.375rem !important;
  }
  .p-lg-2 {
    padding: 0.75rem !important;
  }
  .pt-lg-2,
  .py-lg-2 {
    padding-top: 0.75rem !important;
  }
  .pr-lg-2,
  .px-lg-2 {
    padding-right: 0.75rem !important;
  }
  .pb-lg-2,
  .py-lg-2 {
    padding-bottom: 0.75rem !important;
  }
  .pl-lg-2,
  .px-lg-2 {
    padding-left: 0.75rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .pt-lg-3,
  .py-lg-3 {
    padding-top: 1rem !important;
  }
  .pr-lg-3,
  .px-lg-3 {
    padding-right: 1rem !important;
  }
  .pb-lg-3,
  .py-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pl-lg-3,
  .px-lg-3 {
    padding-left: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .pt-lg-4,
  .py-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pr-lg-4,
  .px-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pb-lg-4,
  .py-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-lg-4,
  .px-lg-4 {
    padding-left: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 2.75rem !important;
  }
  .pt-lg-5,
  .py-lg-5 {
    padding-top: 2.75rem !important;
  }
  .pr-lg-5,
  .px-lg-5 {
    padding-right: 2.75rem !important;
  }
  .pb-lg-5,
  .py-lg-5 {
    padding-bottom: 2.75rem !important;
  }
  .pl-lg-5,
  .px-lg-5 {
    padding-left: 2.75rem !important;
  }
  .p-lg-gs {
    padding: 28px !important;
  }
  .pt-lg-gs,
  .py-lg-gs {
    padding-top: 28px !important;
  }
  .pr-lg-gs,
  .px-lg-gs {
    padding-right: 28px !important;
  }
  .pb-lg-gs,
  .py-lg-gs {
    padding-bottom: 28px !important;
  }
  .pl-lg-gs,
  .px-lg-gs {
    padding-left: 28px !important;
  }
  .m-lg-n1 {
    margin: -0.375rem !important;
  }
  .mt-lg-n1,
  .my-lg-n1 {
    margin-top: -0.375rem !important;
  }
  .mr-lg-n1,
  .mx-lg-n1 {
    margin-right: -0.375rem !important;
  }
  .mb-lg-n1,
  .my-lg-n1 {
    margin-bottom: -0.375rem !important;
  }
  .ml-lg-n1,
  .mx-lg-n1 {
    margin-left: -0.375rem !important;
  }
  .m-lg-n2 {
    margin: -0.75rem !important;
  }
  .mt-lg-n2,
  .my-lg-n2 {
    margin-top: -0.75rem !important;
  }
  .mr-lg-n2,
  .mx-lg-n2 {
    margin-right: -0.75rem !important;
  }
  .mb-lg-n2,
  .my-lg-n2 {
    margin-bottom: -0.75rem !important;
  }
  .ml-lg-n2,
  .mx-lg-n2 {
    margin-left: -0.75rem !important;
  }
  .m-lg-n3 {
    margin: -1rem !important;
  }
  .mt-lg-n3,
  .my-lg-n3 {
    margin-top: -1rem !important;
  }
  .mr-lg-n3,
  .mx-lg-n3 {
    margin-right: -1rem !important;
  }
  .mb-lg-n3,
  .my-lg-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-lg-n3,
  .mx-lg-n3 {
    margin-left: -1rem !important;
  }
  .m-lg-n4 {
    margin: -1.5rem !important;
  }
  .mt-lg-n4,
  .my-lg-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-lg-n4,
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-lg-n4,
  .my-lg-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-lg-n4,
  .mx-lg-n4 {
    margin-left: -1.5rem !important;
  }
  .m-lg-n5 {
    margin: -2.75rem !important;
  }
  .mt-lg-n5,
  .my-lg-n5 {
    margin-top: -2.75rem !important;
  }
  .mr-lg-n5,
  .mx-lg-n5 {
    margin-right: -2.75rem !important;
  }
  .mb-lg-n5,
  .my-lg-n5 {
    margin-bottom: -2.75rem !important;
  }
  .ml-lg-n5,
  .mx-lg-n5 {
    margin-left: -2.75rem !important;
  }
  .m-lg-ngs {
    margin: -28px !important;
  }
  .mt-lg-ngs,
  .my-lg-ngs {
    margin-top: -28px !important;
  }
  .mr-lg-ngs,
  .mx-lg-ngs {
    margin-right: -28px !important;
  }
  .mb-lg-ngs,
  .my-lg-ngs {
    margin-bottom: -28px !important;
  }
  .ml-lg-ngs,
  .mx-lg-ngs {
    margin-left: -28px !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important;
  }
  .mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important;
  }
  .ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important;
  }
  .mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important;
  }
  .mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important;
  }
  .mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important;
  }
  .ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important;
  }
  .m-xl-1 {
    margin: 0.375rem !important;
  }
  .mt-xl-1,
  .my-xl-1 {
    margin-top: 0.375rem !important;
  }
  .mr-xl-1,
  .mx-xl-1 {
    margin-right: 0.375rem !important;
  }
  .mb-xl-1,
  .my-xl-1 {
    margin-bottom: 0.375rem !important;
  }
  .ml-xl-1,
  .mx-xl-1 {
    margin-left: 0.375rem !important;
  }
  .m-xl-2 {
    margin: 0.75rem !important;
  }
  .mt-xl-2,
  .my-xl-2 {
    margin-top: 0.75rem !important;
  }
  .mr-xl-2,
  .mx-xl-2 {
    margin-right: 0.75rem !important;
  }
  .mb-xl-2,
  .my-xl-2 {
    margin-bottom: 0.75rem !important;
  }
  .ml-xl-2,
  .mx-xl-2 {
    margin-left: 0.75rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .mt-xl-3,
  .my-xl-3 {
    margin-top: 1rem !important;
  }
  .mr-xl-3,
  .mx-xl-3 {
    margin-right: 1rem !important;
  }
  .mb-xl-3,
  .my-xl-3 {
    margin-bottom: 1rem !important;
  }
  .ml-xl-3,
  .mx-xl-3 {
    margin-left: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .mt-xl-4,
  .my-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mr-xl-4,
  .mx-xl-4 {
    margin-right: 1.5rem !important;
  }
  .mb-xl-4,
  .my-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-xl-4,
  .mx-xl-4 {
    margin-left: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 2.75rem !important;
  }
  .mt-xl-5,
  .my-xl-5 {
    margin-top: 2.75rem !important;
  }
  .mr-xl-5,
  .mx-xl-5 {
    margin-right: 2.75rem !important;
  }
  .mb-xl-5,
  .my-xl-5 {
    margin-bottom: 2.75rem !important;
  }
  .ml-xl-5,
  .mx-xl-5 {
    margin-left: 2.75rem !important;
  }
  .m-xl-gs {
    margin: 28px !important;
  }
  .mt-xl-gs,
  .my-xl-gs {
    margin-top: 28px !important;
  }
  .mr-xl-gs,
  .mx-xl-gs {
    margin-right: 28px !important;
  }
  .mb-xl-gs,
  .my-xl-gs {
    margin-bottom: 28px !important;
  }
  .ml-xl-gs,
  .mx-xl-gs {
    margin-left: 28px !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important;
  }
  .pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important;
  }
  .pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important;
  }
  .pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important;
  }
  .p-xl-1 {
    padding: 0.375rem !important;
  }
  .pt-xl-1,
  .py-xl-1 {
    padding-top: 0.375rem !important;
  }
  .pr-xl-1,
  .px-xl-1 {
    padding-right: 0.375rem !important;
  }
  .pb-xl-1,
  .py-xl-1 {
    padding-bottom: 0.375rem !important;
  }
  .pl-xl-1,
  .px-xl-1 {
    padding-left: 0.375rem !important;
  }
  .p-xl-2 {
    padding: 0.75rem !important;
  }
  .pt-xl-2,
  .py-xl-2 {
    padding-top: 0.75rem !important;
  }
  .pr-xl-2,
  .px-xl-2 {
    padding-right: 0.75rem !important;
  }
  .pb-xl-2,
  .py-xl-2 {
    padding-bottom: 0.75rem !important;
  }
  .pl-xl-2,
  .px-xl-2 {
    padding-left: 0.75rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .pt-xl-3,
  .py-xl-3 {
    padding-top: 1rem !important;
  }
  .pr-xl-3,
  .px-xl-3 {
    padding-right: 1rem !important;
  }
  .pb-xl-3,
  .py-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pl-xl-3,
  .px-xl-3 {
    padding-left: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .pt-xl-4,
  .py-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pr-xl-4,
  .px-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pb-xl-4,
  .py-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-xl-4,
  .px-xl-4 {
    padding-left: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 2.75rem !important;
  }
  .pt-xl-5,
  .py-xl-5 {
    padding-top: 2.75rem !important;
  }
  .pr-xl-5,
  .px-xl-5 {
    padding-right: 2.75rem !important;
  }
  .pb-xl-5,
  .py-xl-5 {
    padding-bottom: 2.75rem !important;
  }
  .pl-xl-5,
  .px-xl-5 {
    padding-left: 2.75rem !important;
  }
  .p-xl-gs {
    padding: 28px !important;
  }
  .pt-xl-gs,
  .py-xl-gs {
    padding-top: 28px !important;
  }
  .pr-xl-gs,
  .px-xl-gs {
    padding-right: 28px !important;
  }
  .pb-xl-gs,
  .py-xl-gs {
    padding-bottom: 28px !important;
  }
  .pl-xl-gs,
  .px-xl-gs {
    padding-left: 28px !important;
  }
  .m-xl-n1 {
    margin: -0.375rem !important;
  }
  .mt-xl-n1,
  .my-xl-n1 {
    margin-top: -0.375rem !important;
  }
  .mr-xl-n1,
  .mx-xl-n1 {
    margin-right: -0.375rem !important;
  }
  .mb-xl-n1,
  .my-xl-n1 {
    margin-bottom: -0.375rem !important;
  }
  .ml-xl-n1,
  .mx-xl-n1 {
    margin-left: -0.375rem !important;
  }
  .m-xl-n2 {
    margin: -0.75rem !important;
  }
  .mt-xl-n2,
  .my-xl-n2 {
    margin-top: -0.75rem !important;
  }
  .mr-xl-n2,
  .mx-xl-n2 {
    margin-right: -0.75rem !important;
  }
  .mb-xl-n2,
  .my-xl-n2 {
    margin-bottom: -0.75rem !important;
  }
  .ml-xl-n2,
  .mx-xl-n2 {
    margin-left: -0.75rem !important;
  }
  .m-xl-n3 {
    margin: -1rem !important;
  }
  .mt-xl-n3,
  .my-xl-n3 {
    margin-top: -1rem !important;
  }
  .mr-xl-n3,
  .mx-xl-n3 {
    margin-right: -1rem !important;
  }
  .mb-xl-n3,
  .my-xl-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-xl-n3,
  .mx-xl-n3 {
    margin-left: -1rem !important;
  }
  .m-xl-n4 {
    margin: -1.5rem !important;
  }
  .mt-xl-n4,
  .my-xl-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-xl-n4,
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-xl-n4,
  .my-xl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-xl-n4,
  .mx-xl-n4 {
    margin-left: -1.5rem !important;
  }
  .m-xl-n5 {
    margin: -2.75rem !important;
  }
  .mt-xl-n5,
  .my-xl-n5 {
    margin-top: -2.75rem !important;
  }
  .mr-xl-n5,
  .mx-xl-n5 {
    margin-right: -2.75rem !important;
  }
  .mb-xl-n5,
  .my-xl-n5 {
    margin-bottom: -2.75rem !important;
  }
  .ml-xl-n5,
  .mx-xl-n5 {
    margin-left: -2.75rem !important;
  }
  .m-xl-ngs {
    margin: -28px !important;
  }
  .mt-xl-ngs,
  .my-xl-ngs {
    margin-top: -28px !important;
  }
  .mr-xl-ngs,
  .mx-xl-ngs {
    margin-right: -28px !important;
  }
  .mb-xl-ngs,
  .my-xl-ngs {
    margin-bottom: -28px !important;
  }
  .ml-xl-ngs,
  .mx-xl-ngs {
    margin-left: -28px !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important;
  }
  .mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important;
  }
  .ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 1540px) {
  .m-xxl-0 {
    margin: 0 !important;
  }
  .mt-xxl-0,
  .my-xxl-0 {
    margin-top: 0 !important;
  }
  .mr-xxl-0,
  .mx-xxl-0 {
    margin-right: 0 !important;
  }
  .mb-xxl-0,
  .my-xxl-0 {
    margin-bottom: 0 !important;
  }
  .ml-xxl-0,
  .mx-xxl-0 {
    margin-left: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.375rem !important;
  }
  .mt-xxl-1,
  .my-xxl-1 {
    margin-top: 0.375rem !important;
  }
  .mr-xxl-1,
  .mx-xxl-1 {
    margin-right: 0.375rem !important;
  }
  .mb-xxl-1,
  .my-xxl-1 {
    margin-bottom: 0.375rem !important;
  }
  .ml-xxl-1,
  .mx-xxl-1 {
    margin-left: 0.375rem !important;
  }
  .m-xxl-2 {
    margin: 0.75rem !important;
  }
  .mt-xxl-2,
  .my-xxl-2 {
    margin-top: 0.75rem !important;
  }
  .mr-xxl-2,
  .mx-xxl-2 {
    margin-right: 0.75rem !important;
  }
  .mb-xxl-2,
  .my-xxl-2 {
    margin-bottom: 0.75rem !important;
  }
  .ml-xxl-2,
  .mx-xxl-2 {
    margin-left: 0.75rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .mt-xxl-3,
  .my-xxl-3 {
    margin-top: 1rem !important;
  }
  .mr-xxl-3,
  .mx-xxl-3 {
    margin-right: 1rem !important;
  }
  .mb-xxl-3,
  .my-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .ml-xxl-3,
  .mx-xxl-3 {
    margin-left: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .mt-xxl-4,
  .my-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mr-xxl-4,
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .mb-xxl-4,
  .my-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-xxl-4,
  .mx-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 2.75rem !important;
  }
  .mt-xxl-5,
  .my-xxl-5 {
    margin-top: 2.75rem !important;
  }
  .mr-xxl-5,
  .mx-xxl-5 {
    margin-right: 2.75rem !important;
  }
  .mb-xxl-5,
  .my-xxl-5 {
    margin-bottom: 2.75rem !important;
  }
  .ml-xxl-5,
  .mx-xxl-5 {
    margin-left: 2.75rem !important;
  }
  .m-xxl-gs {
    margin: 28px !important;
  }
  .mt-xxl-gs,
  .my-xxl-gs {
    margin-top: 28px !important;
  }
  .mr-xxl-gs,
  .mx-xxl-gs {
    margin-right: 28px !important;
  }
  .mb-xxl-gs,
  .my-xxl-gs {
    margin-bottom: 28px !important;
  }
  .ml-xxl-gs,
  .mx-xxl-gs {
    margin-left: 28px !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .pt-xxl-0,
  .py-xxl-0 {
    padding-top: 0 !important;
  }
  .pr-xxl-0,
  .px-xxl-0 {
    padding-right: 0 !important;
  }
  .pb-xxl-0,
  .py-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pl-xxl-0,
  .px-xxl-0 {
    padding-left: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.375rem !important;
  }
  .pt-xxl-1,
  .py-xxl-1 {
    padding-top: 0.375rem !important;
  }
  .pr-xxl-1,
  .px-xxl-1 {
    padding-right: 0.375rem !important;
  }
  .pb-xxl-1,
  .py-xxl-1 {
    padding-bottom: 0.375rem !important;
  }
  .pl-xxl-1,
  .px-xxl-1 {
    padding-left: 0.375rem !important;
  }
  .p-xxl-2 {
    padding: 0.75rem !important;
  }
  .pt-xxl-2,
  .py-xxl-2 {
    padding-top: 0.75rem !important;
  }
  .pr-xxl-2,
  .px-xxl-2 {
    padding-right: 0.75rem !important;
  }
  .pb-xxl-2,
  .py-xxl-2 {
    padding-bottom: 0.75rem !important;
  }
  .pl-xxl-2,
  .px-xxl-2 {
    padding-left: 0.75rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .pt-xxl-3,
  .py-xxl-3 {
    padding-top: 1rem !important;
  }
  .pr-xxl-3,
  .px-xxl-3 {
    padding-right: 1rem !important;
  }
  .pb-xxl-3,
  .py-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pl-xxl-3,
  .px-xxl-3 {
    padding-left: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .pt-xxl-4,
  .py-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pr-xxl-4,
  .px-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pb-xxl-4,
  .py-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-xxl-4,
  .px-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 2.75rem !important;
  }
  .pt-xxl-5,
  .py-xxl-5 {
    padding-top: 2.75rem !important;
  }
  .pr-xxl-5,
  .px-xxl-5 {
    padding-right: 2.75rem !important;
  }
  .pb-xxl-5,
  .py-xxl-5 {
    padding-bottom: 2.75rem !important;
  }
  .pl-xxl-5,
  .px-xxl-5 {
    padding-left: 2.75rem !important;
  }
  .p-xxl-gs {
    padding: 28px !important;
  }
  .pt-xxl-gs,
  .py-xxl-gs {
    padding-top: 28px !important;
  }
  .pr-xxl-gs,
  .px-xxl-gs {
    padding-right: 28px !important;
  }
  .pb-xxl-gs,
  .py-xxl-gs {
    padding-bottom: 28px !important;
  }
  .pl-xxl-gs,
  .px-xxl-gs {
    padding-left: 28px !important;
  }
  .m-xxl-n1 {
    margin: -0.375rem !important;
  }
  .mt-xxl-n1,
  .my-xxl-n1 {
    margin-top: -0.375rem !important;
  }
  .mr-xxl-n1,
  .mx-xxl-n1 {
    margin-right: -0.375rem !important;
  }
  .mb-xxl-n1,
  .my-xxl-n1 {
    margin-bottom: -0.375rem !important;
  }
  .ml-xxl-n1,
  .mx-xxl-n1 {
    margin-left: -0.375rem !important;
  }
  .m-xxl-n2 {
    margin: -0.75rem !important;
  }
  .mt-xxl-n2,
  .my-xxl-n2 {
    margin-top: -0.75rem !important;
  }
  .mr-xxl-n2,
  .mx-xxl-n2 {
    margin-right: -0.75rem !important;
  }
  .mb-xxl-n2,
  .my-xxl-n2 {
    margin-bottom: -0.75rem !important;
  }
  .ml-xxl-n2,
  .mx-xxl-n2 {
    margin-left: -0.75rem !important;
  }
  .m-xxl-n3 {
    margin: -1rem !important;
  }
  .mt-xxl-n3,
  .my-xxl-n3 {
    margin-top: -1rem !important;
  }
  .mr-xxl-n3,
  .mx-xxl-n3 {
    margin-right: -1rem !important;
  }
  .mb-xxl-n3,
  .my-xxl-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-xxl-n3,
  .mx-xxl-n3 {
    margin-left: -1rem !important;
  }
  .m-xxl-n4 {
    margin: -1.5rem !important;
  }
  .mt-xxl-n4,
  .my-xxl-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-xxl-n4,
  .mx-xxl-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-xxl-n4,
  .my-xxl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-xxl-n4,
  .mx-xxl-n4 {
    margin-left: -1.5rem !important;
  }
  .m-xxl-n5 {
    margin: -2.75rem !important;
  }
  .mt-xxl-n5,
  .my-xxl-n5 {
    margin-top: -2.75rem !important;
  }
  .mr-xxl-n5,
  .mx-xxl-n5 {
    margin-right: -2.75rem !important;
  }
  .mb-xxl-n5,
  .my-xxl-n5 {
    margin-bottom: -2.75rem !important;
  }
  .ml-xxl-n5,
  .mx-xxl-n5 {
    margin-left: -2.75rem !important;
  }
  .m-xxl-ngs {
    margin: -28px !important;
  }
  .mt-xxl-ngs,
  .my-xxl-ngs {
    margin-top: -28px !important;
  }
  .mr-xxl-ngs,
  .mx-xxl-ngs {
    margin-right: -28px !important;
  }
  .mb-xxl-ngs,
  .my-xxl-ngs {
    margin-bottom: -28px !important;
  }
  .ml-xxl-ngs,
  .mx-xxl-ngs {
    margin-left: -28px !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mt-xxl-auto,
  .my-xxl-auto {
    margin-top: auto !important;
  }
  .mr-xxl-auto,
  .mx-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-auto,
  .my-xxl-auto {
    margin-bottom: auto !important;
  }
  .ml-xxl-auto,
  .mx-xxl-auto {
    margin-left: auto !important;
  }
}
.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
  background-color: rgba(0, 0, 0, 0);
}

.text-monospace, .ff-mono {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
}

.text-justify {
  text-align: justify !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

@media (min-width: 420px) {
  .text-mb-left {
    text-align: left !important;
  }
  .text-mb-right {
    text-align: right !important;
  }
  .text-mb-center {
    text-align: center !important;
  }
}
@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important;
  }
  .text-sm-right {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important;
  }
  .text-md-right {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important;
  }
  .text-lg-right {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important;
  }
  .text-xl-right {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1540px) {
  .text-xxl-left {
    text-align: left !important;
  }
  .text-xxl-right {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
.text-lowercase, .lcap {
  text-transform: lowercase !important;
}

.text-uppercase, .ucap {
  text-transform: uppercase !important;
}

.text-capitalize, .ccap {
  text-transform: capitalize !important;
}

.font-weight-light, .fw-light {
  font-weight: 300 !important;
}

.font-weight-lighter, .fw-lighter {
  font-weight: lighter !important;
}

.font-weight-normal, .fw-normal {
  font-weight: 400 !important;
}

.font-weight-bold, .fw-bold {
  font-weight: 700 !important;
}

.font-weight-bolder, .fw-bolder {
  font-weight: bolder !important;
}

.font-italic, .ff-italic {
  font-style: italic !important;
}

.text-white {
  color: #fff !important;
}

.text-primary {
  color: #4461F2 !important;
}

a.text-primary:hover, a.text-primary:focus {
  color: #0f31da !important;
}

.text-secondary {
  color: #364a63 !important;
}

a.text-secondary:hover, a.text-secondary:focus {
  color: #1b2532 !important;
}

.text-success {
  color: #1ee0ac !important;
}

a.text-success:hover, a.text-success:focus {
  color: #159d78 !important;
}

.text-info {
  color: #09c2de !important;
}

a.text-info:hover, a.text-info:focus {
  color: #068294 !important;
}

.text-warning {
  color: #f4bd0e !important;
}

a.text-warning:hover, a.text-warning:focus {
  color: #ae8608 !important;
}

.text-danger {
  color: #e85347 !important;
}

a.text-danger:hover, a.text-danger:focus {
  color: #c92619 !important;
}

.text-dark {
  color: #1c2b46 !important;
}

a.text-dark:hover, a.text-dark:focus {
  color: #06090f !important;
}

.text-gray {
  color: #8091a7 !important;
}

a.text-gray:hover, a.text-gray:focus {
  color: #596b81 !important;
}

.text-light {
  color: #e5e9f2 !important;
}

a.text-light:hover, a.text-light:focus {
  color: #b2bed9 !important;
}

.text-lighter {
  color: #f5f6fa !important;
}

a.text-lighter:hover, a.text-lighter:focus {
  color: #c2c8e1 !important;
}

.text-body {
  color: #526484 !important;
}

.text-muted {
  color: #8094ae !important;
}

.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-break {
  word-break: break-word !important;
  overflow-wrap: break-word !important;
}

.text-reset {
  color: inherit !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media print {
  *,
  *::before,
  *::after {
    text-shadow: none !important;
    box-shadow: none !important;
  }
  a:not(.btn) {
    text-decoration: underline;
  }
  abbr[title]::after {
    content: " (" attr(title) ")";
  }
  pre {
    white-space: pre-wrap !important;
  }
  pre,
  blockquote {
    border: 1px solid #8091a7;
    page-break-inside: avoid;
  }
  tr,
  img {
    page-break-inside: avoid;
  }
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }
  h2,
  h3 {
    page-break-after: avoid;
  }
  @page {
    size: a3;
  }
  body {
    min-width: 992px !important;
  }
  .container {
    min-width: 992px !important;
  }
  .navbar {
    display: none;
  }
  .badge {
    border: 1px solid #000;
  }
  .table {
    border-collapse: collapse !important;
  }
  .table td,
  .table th {
    background-color: #fff !important;
  }
  .table-bordered th,
  .table-bordered td {
    border: 1px solid #dbdfea !important;
  }
  .table-dark {
    color: inherit;
  }
  .table-dark th,
  .table-dark td,
  .table-dark thead th,
  .table-dark tbody + tbody {
    border-color: #dbdfea;
  }
  .table .thead-dark th {
    color: inherit;
    border-color: #dbdfea;
  }
}
html {
  font-size: 16px;
}

ol, ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

a {
  transition: color 0.4s, background-color 0.4s, border 0.4s, box-shadow 0.4s;
}
a:focus {
  outline: none;
}

img {
  max-width: 100%;
}

strong {
  font-weight: 500;
}

h1:last-child, h2:last-child, h3:last-child, h4:last-child, h5:last-child, h6:last-child, .h1:last-child, .h2:last-child, .h3:last-child, .h4:last-child, .h5:last-child, .h6:last-child, p:last-child {
  margin-bottom: 0;
}

h1, .h1, h2, .h2 {
  letter-spacing: -0.03em;
}

h3, .h3, h4, .h4 {
  letter-spacing: -0.02em;
}

h5, .h5, h6, .h6 {
  letter-spacing: -0.01em;
}

@media (min-width: 992px) {
  h1, .h1 {
    font-size: 3.75rem;
    font-weight: 400;
    letter-spacing: -0.04em;
  }
  h2, .h2 {
    font-size: 2.5rem;
    letter-spacing: -0.03em;
  }
  h3, .h3 {
    font-size: 2rem;
    letter-spacing: -0.03em;
  }
  h4, .h4 {
    font-size: 1.5rem;
  }
  h5, .h5 {
    font-size: 1.25rem;
  }
  h6, .h6 {
    font-size: 1.05rem;
  }
}
.list-inline li {
  display: inline-block;
}
.list-inline li:not(:last-child) {
  margin-right: 1rem;
}

.ellipsis, .nk-msg-text .title, .attach-item span, .tb-odr-item .tb-odr-info, .tb-tnx-item .tb-tnx-desc, .text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ff-base {
  font-family: "DM Sans", sans-serif !important;
}
.ff-alt {
  font-family: "DM Sans", sans-serif !important;
}
.fw-medium {
  font-weight: 500 !important;
}
.text-white h1, .text-white h2, .text-white h3, .text-white h4, .text-white h5, .text-white h6,
.text-white .h1, .text-white .h2, .text-white .h3, .text-white .h4, .text-white .h5, .text-white .h6 {
  color: #fff;
}

@media (min-width: 992px) {
  .lead {
    font-size: 0.96875rem;
  }
}
.text-soft {
  color: #8094ae !important;
}
.text-base {
  color: #526484 !important;
}
.text-head {
  color: #364a63 !important;
}

.circle {
  border-radius: 50%;
}

.round {
  border-radius: 4px;
}
.round-sm {
  border-radius: 3px;
}
.round-lg {
  border-radius: 5px;
}
.round-xl {
  border-radius: 10px;
}

svg {
  height: 100%;
  max-width: 100%;
}

.sq {
  height: 40px;
  width: 40px;
}
.sq-xs {
  height: 18px;
  width: 18px;
}
.sq-sm {
  height: 24px;
  width: 24px;
}
.sq-md {
  height: 32px;
  width: 32px;
}
.sq-lg {
  height: 60px;
  width: 60px;
}
.sq-xl {
  height: 80px;
  width: 80px;
}

.divider {
  border-top: 1px solid #e5e9f2 !important;
  margin: 28px 0;
  display: block;
}
.divider.xs {
  margin: 0.5rem 0;
}
.divider.sm {
  margin: 1rem 0;
}
.divider.md {
  margin: 1.5rem 0;
}
.divider.lg {
  margin: 2.25rem 0;
}
.divider.xl {
  margin: 2.75rem 0;
}

.bg-blue {
  background-color: #559bfb !important;
}

.text-blue {
  color: #559bfb !important;
}

.bg-azure {
  background-color: #1676fb !important;
}

.text-azure {
  color: #1676fb !important;
}

.bg-indigo {
  background-color: #2c3782 !important;
}

.text-indigo {
  color: #2c3782 !important;
}

.bg-purple {
  background-color: #816bff !important;
}

.text-purple {
  color: #816bff !important;
}

.bg-pink {
  background-color: #ff63a5 !important;
}

.text-pink {
  color: #ff63a5 !important;
}

.bg-orange {
  background-color: #ffa353 !important;
}

.text-orange {
  color: #ffa353 !important;
}

.bg-teal {
  background-color: #20c997 !important;
}

.text-teal {
  color: #20c997 !important;
}

.bg-blue-dim {
  background-color: #e9f2fe !important;
}

.text-blue-dim {
  color: #e9f2fe !important;
}

.bg-azure-dim {
  background-color: #e1edfe !important;
}

.text-azure-dim {
  color: #e1edfe !important;
}

.bg-indigo-dim {
  background-color: #e4e5ef !important;
}

.text-indigo-dim {
  color: #e4e5ef !important;
}

.bg-purple-dim {
  background-color: #efecff !important;
}

.text-purple-dim {
  color: #efecff !important;
}

.bg-pink-dim {
  background-color: #ffebf3 !important;
}

.text-pink-dim {
  color: #ffebf3 !important;
}

.bg-orange-dim {
  background-color: #fff3e9 !important;
}

.text-orange-dim {
  color: #fff3e9 !important;
}

.bg-teal-dim {
  background-color: #e2f8f1 !important;
}

.text-teal-dim {
  color: #e2f8f1 !important;
}

.bg-primary-dim, .rdl-control > option:active, .rdl-control > option:focus, .dual-listbox .dual-listbox__item:active, .dual-listbox .dual-listbox__item.dual-listbox__item--selected {
  background-color: #e7eafd !important;
}

.text-primary-dim {
  color: #e7eafd !important;
}

.bg-success-dim {
  background-color: #e2fbf4 !important;
}

.text-success-dim {
  color: #e2fbf4 !important;
}

.bg-info-dim {
  background-color: #dff7fb !important;
}

.text-info-dim {
  color: #dff7fb !important;
}

.bg-warning-dim {
  background-color: #fef6e0 !important;
}

.text-warning-dim {
  color: #fef6e0 !important;
}

.bg-danger-dim {
  background-color: #fce9e7 !important;
}

.text-danger-dim {
  color: #fce9e7 !important;
}

.bg-secondary-dim {
  background-color: #e5ecf5 !important;
}

.text-secondary-dim {
  color: #e5ecf5 !important;
}

.bg-dark-dim {
  background-color: #d9e1ef !important;
}

.text-dark-dim {
  color: #d9e1ef !important;
}

.bg-gray-dim {
  background-color: #edf2f9 !important;
}

.text-gray-dim {
  color: #edf2f9 !important;
}

.bg-gray-100 {
  background-color: #ebeef2 !important;
}

.bg-gray-200 {
  background-color: #e5e9f2 !important;
}

.bg-gray-300 {
  background-color: #dbdfea !important;
}

.bg-gray-400 {
  background-color: #b7c2d0 !important;
}

.bg-gray-500 {
  background-color: #8091a7 !important;
}

.bg-gray-600 {
  background-color: #3c4d62 !important;
}

.bg-gray-700 {
  background-color: #344357 !important;
}

.bg-gray-800 {
  background-color: #2b3748 !important;
}

.bg-gray-900 {
  background-color: #1f2b3a !important;
}

.bg-abstract {
  background-image: linear-gradient(to right, #2c3782 calc(60% - 150px), #39469f calc(60% - 150px), #39469f 60%, #4856b5 60%, #4856b5 calc(60% + 150px), #5b6ac6 calc(60% + 150px), #5b6ac6 100%);
}

.bg-white-1 {
  background: rgba(255, 255, 255, 0.1) !important;
}

.bg-white-2 {
  background: rgba(255, 255, 255, 0.2) !important;
}

.bg-white-3 {
  background: rgba(255, 255, 255, 0.3) !important;
}

.bg-white-4 {
  background: rgba(255, 255, 255, 0.4) !important;
}

.bg-white-5 {
  background: rgba(255, 255, 255, 0.5) !important;
}

.bg-white-6 {
  background: rgba(255, 255, 255, 0.6) !important;
}

.bg-white-7 {
  background: rgba(255, 255, 255, 0.7) !important;
}

.bg-white-8 {
  background: rgba(255, 255, 255, 0.8) !important;
}

.bg-white-9 {
  background: rgba(255, 255, 255, 0.9) !important;
}

.border-transparent {
  border-color: transparent;
}

.w-80px {
  width: 80px !important;
}

.w-min-80px {
  min-width: 80px !important;
}

.w-max-80px {
  max-width: 80px !important;
}

.w-90px {
  width: 90px !important;
}

.w-min-90px {
  min-width: 90px !important;
}

.w-max-90px {
  max-width: 90px !important;
}

.w-100px {
  width: 100px !important;
}

.w-min-100px {
  min-width: 100px !important;
}

.w-max-100px {
  max-width: 100px !important;
}

.w-110px {
  width: 110px !important;
}

.w-min-110px {
  min-width: 110px !important;
}

.w-max-110px {
  max-width: 110px !important;
}

.w-120px {
  width: 120px !important;
}

.w-min-120px {
  min-width: 120px !important;
}

.w-max-120px {
  max-width: 120px !important;
}

.w-125px {
  width: 125px !important;
}

.w-min-125px {
  min-width: 125px !important;
}

.w-max-125px {
  max-width: 125px !important;
}

.w-130px {
  width: 130px !important;
}

.w-min-130px {
  min-width: 130px !important;
}

.w-max-130px {
  max-width: 130px !important;
}

.w-140px {
  width: 140px !important;
}

.w-min-140px {
  min-width: 140px !important;
}

.w-max-140px {
  max-width: 140px !important;
}

.w-150px {
  width: 150px !important;
}

.w-min-150px {
  min-width: 150px !important;
}

.w-max-150px {
  max-width: 150px !important;
}

.w-175px {
  width: 175px !important;
}

.w-min-175px {
  min-width: 175px !important;
}

.w-max-175px {
  max-width: 175px !important;
}

.w-200px {
  width: 200px !important;
}

.w-min-200px {
  min-width: 200px !important;
}

.w-max-200px {
  max-width: 200px !important;
}

.w-220px {
  width: 220px !important;
}

.w-min-220px {
  min-width: 220px !important;
}

.w-max-220px {
  max-width: 220px !important;
}

.w-225px {
  width: 225px !important;
}

.w-min-225px {
  min-width: 225px !important;
}

.w-max-225px {
  max-width: 225px !important;
}

.w-250px {
  width: 250px !important;
}

.w-min-250px {
  min-width: 250px !important;
}

.w-max-250px {
  max-width: 250px !important;
}

.w-300px {
  width: 300px !important;
}

.w-min-300px {
  min-width: 300px !important;
}

.w-max-300px {
  max-width: 300px !important;
}

.w-350px {
  width: 350px !important;
}

.w-min-350px {
  min-width: 350px !important;
}

.w-max-350px {
  max-width: 350px !important;
}

.w-400px {
  width: 400px !important;
}

.w-min-400px {
  min-width: 400px !important;
}

.w-max-400px {
  max-width: 400px !important;
}

.w-550px {
  width: 550px !important;
}

.w-min-550px {
  min-width: 550px !important;
}

.w-max-550px {
  max-width: 550px !important;
}

.w-max-100, .wide-xs-fix, .wide-sm-fix, .wide-md-fix, .wide-lg-fix {
  max-width: 100% !important;
}

.w-min-100 {
  min-width: 100% !important;
}

.w-max-auto {
  max-width: inherit !important;
}

.w-min-auto {
  min-width: auto !important;
}

.w-15 {
  width: 15% !important;
}

.w-20 {
  width: 20% !important;
}

.w-30 {
  width: 30% !important;
}

.w-35 {
  width: 35% !important;
}

.w-40 {
  width: 40% !important;
}

.w-45 {
  width: 45% !important;
}

.w-55 {
  width: 55% !important;
}

.w-60 {
  width: 60% !important;
}

.w-65 {
  width: 65% !important;
}

.w-70 {
  width: 70% !important;
}

.w-80 {
  width: 80% !important;
}

.w-85 {
  width: 85% !important;
}

.w-90 {
  width: 90% !important;
}

.w-95 {
  width: 95% !important;
}

@media (min-width: 576px) {
  .wide-xs {
    max-width: 520px !important;
  }
  .wide-xs-fix {
    width: 520px !important;
  }
}
@media (min-width: 768px) {
  .wide-sm {
    max-width: 720px !important;
  }
  .wide-sm-fix {
    width: 720px !important;
  }
}
@media (min-width: 992px) {
  .wide-md {
    max-width: 960px !important;
  }
  .wide-md-fix {
    width: 960px !important;
  }
}
@media (min-width: 1200px) {
  .wide-lg {
    max-width: 1140px !important;
  }
  .wide-lg-fix {
    width: 1140px !important;
  }
}
@media (min-width: 1280px) {
  .wide-xl {
    max-width: 1240px !important;
  }
  .wide-xl-fix {
    width: 1240px !important;
  }
}
.wide-xs-fix {
  width: 520px !important;
}

.wide-sm-fix {
  width: 720px !important;
}

.wide-md-fix {
  width: 960px !important;
}

.wide-lg-fix {
  width: 1140px !important;
}

.wide-xl-fix {
  width: 1240px !important;
}

@media (min-width: 1200px) and (max-width: 1660px) {
  .wide-fit {
    max-width: 1140px;
  }
}
.h-100px {
  height: 100px !important;
}

.h-min-100px {
  min-height: 100px !important;
}

.h-max-100px {
  max-height: 100px !important;
}

.h-150px {
  height: 150px !important;
}

.h-min-150px {
  min-height: 150px !important;
}

.h-max-150px {
  max-height: 150px !important;
}

.h-175px {
  height: 175px !important;
}

.h-min-175px {
  min-height: 175px !important;
}

.h-max-175px {
  max-height: 175px !important;
}

.h-200px {
  height: 200px !important;
}

.h-min-200px {
  min-height: 200px !important;
}

.h-max-200px {
  max-height: 200px !important;
}

.h-225px {
  height: 225px !important;
}

.h-min-225px {
  min-height: 225px !important;
}

.h-max-225px {
  max-height: 225px !important;
}

.h-250px {
  height: 250px !important;
}

.h-min-250px {
  min-height: 250px !important;
}

.h-max-250px {
  max-height: 250px !important;
}

.h-275px {
  height: 275px !important;
}

.h-min-275px {
  min-height: 275px !important;
}

.h-max-275px {
  max-height: 275px !important;
}

.h-300px {
  height: 300px !important;
}

.h-min-300px {
  min-height: 300px !important;
}

.h-max-300px {
  max-height: 300px !important;
}

.h-325px {
  height: 325px !important;
}

.h-min-325px {
  min-height: 325px !important;
}

.h-max-325px {
  max-height: 325px !important;
}

.h-350px {
  height: 350px !important;
}

.h-min-350px {
  min-height: 350px !important;
}

.h-max-350px {
  max-height: 350px !important;
}

.h-375px {
  height: 375px !important;
}

.h-min-375px {
  min-height: 375px !important;
}

.h-max-375px {
  max-height: 375px !important;
}

.h-400px {
  height: 400px !important;
}

.h-min-400px {
  min-height: 400px !important;
}

.h-max-400px {
  max-height: 400px !important;
}

.h-425px {
  height: 425px !important;
}

.h-min-425px {
  min-height: 425px !important;
}

.h-max-425px {
  max-height: 425px !important;
}

.h-450px {
  height: 450px !important;
}

.h-min-450px {
  min-height: 450px !important;
}

.h-max-450px {
  max-height: 450px !important;
}

.h-475px {
  height: 475px !important;
}

.h-min-475px {
  min-height: 475px !important;
}

.h-max-475px {
  max-height: 475px !important;
}

.h-500px {
  height: 500px !important;
}

.h-min-500px {
  min-height: 500px !important;
}

.h-max-500px {
  max-height: 500px !important;
}

.absolute-top-left {
  position: absolute;
  top: 0;
  left: 0;
}
.absolute-top-right {
  position: absolute;
  top: 0;
  right: 0;
}
.absolute-bottom-left {
  position: absolute;
  bottom: 0;
  left: 0;
}
.absolute-bottom-right {
  position: absolute;
  bottom: 0;
  right: 0;
}

.shrink-0 {
  flex-shrink: 0;
}

.badge {
  position: relative;
  border: 1px solid currentColor;
  line-height: 1.125rem;
  font-family: "DM Sans", sans-serif;
  letter-spacing: 0.01em;
  vertical-align: middle;
  display: inline-flex;
}
.badge .icon + span, .badge span + .icon {
  padding-left: 4px;
}
.badge-sm {
  padding: 0.3125rem 0.75rem;
  font-size: 0.75rem;
}
.badge-sm.badge-pill {
  padding: 0.3125rem 0.875rem;
}
.badge-md {
  padding: 0.47rem 1rem;
  font-size: 0.8125rem !important;
}
.badge-lg {
  padding: 0.75rem 1.25rem;
  font-size: 0.93rem !important;
}
.badge-xl {
  padding: 0.875rem 1.5rem;
  font-size: 1.125rem !important;
}
.badge-light {
  color: #364a63;
}
.badge-lighter {
  color: #526484;
}
.badge .icon {
  font-size: 1rem;
}

.badge-primary {
  border-color: #4461F2;
}

.badge-secondary {
  border-color: #364a63;
}

.badge-success {
  border-color: #1ee0ac;
}

.badge-info {
  border-color: #09c2de;
}

.badge-warning {
  border-color: #f4bd0e;
}

.badge-danger {
  border-color: #e85347;
}

.badge-dark {
  border-color: #1c2b46;
}

.badge-gray {
  border-color: #8091a7;
}

.badge-light {
  border-color: #e5e9f2;
}

.badge-lighter {
  border-color: #f5f6fa;
}

.badge-outline-primary {
  color: #4461F2;
  border-color: #8fa0f7;
}

.badge-outline-secondary {
  color: #364a63;
  border-color: #8692a1;
}

.badge-outline-success {
  color: #1ee0ac;
  border-color: #78eccd;
}

.badge-outline-info {
  color: #09c2de;
  border-color: #6bdaeb;
}

.badge-outline-warning {
  color: #f4bd0e;
  border-color: #f8d76e;
}

.badge-outline-danger {
  color: #e85347;
  border-color: #f19891;
}

.badge-outline-dark {
  color: #1c2b46;
  border-color: #778090;
}

.badge-outline-gray {
  color: #8091a7;
  border-color: #b3bdca;
}

.badge-outline-light {
  color: #b7c2d0;
  border-color: #d4dae3;
}

.badge-outline-lighter {
  color: #e5e9f2;
  border-color: #eff2f7;
}

.badge-dim.badge-primary {
  color: #4461F2;
  background-color: #eaeefe;
  border-color: #eaeefe;
}

.badge-dim.badge-outline-primary {
  color: #4461F2;
  background-color: #eaeefe;
  border-color: #b4c0fa;
}

.badge-dim.badge-secondary {
  color: #364a63;
  background-color: #e9ebee;
  border-color: #e9ebee;
}

.badge-dim.badge-outline-secondary {
  color: #364a63;
  background-color: #e9ebee;
  border-color: #afb7c1;
}

.badge-dim.badge-success {
  color: #1ee0ac;
  background-color: #e6fcf6;
  border-color: #e6fcf6;
}

.badge-dim.badge-outline-success {
  color: #1ee0ac;
  background-color: #e6fcf6;
  border-color: #a5f3de;
}

.badge-dim.badge-info {
  color: #09c2de;
  background-color: #e4f8fb;
  border-color: #e4f8fb;
}

.badge-dim.badge-outline-info {
  color: #09c2de;
  background-color: #e4f8fb;
  border-color: #9de7f2;
}

.badge-dim.badge-warning {
  color: #f4bd0e;
  background-color: #fef8e4;
  border-color: #fef8e4;
}

.badge-dim.badge-outline-warning {
  color: #f4bd0e;
  background-color: #fef8e4;
  border-color: #fbe59f;
}

.badge-dim.badge-danger {
  color: #e85347;
  background-color: #fceceb;
  border-color: #fceceb;
}

.badge-dim.badge-outline-danger {
  color: #e85347;
  background-color: #fceceb;
  border-color: #f6bab5;
}

.badge-dim.badge-dark {
  color: #1c2b46;
  background-color: #e6e8eb;
  border-color: #e6e8eb;
}

.badge-dim.badge-outline-dark {
  color: #1c2b46;
  background-color: #e6e8eb;
  border-color: #a4aab5;
}

.badge-dim.badge-gray {
  color: #8091a7;
  background-color: #f1f3f5;
  border-color: #f1f3f5;
}

.badge-dim.badge-outline-gray {
  color: #8091a7;
  background-color: #f1f3f5;
  border-color: #ccd3dc;
}

.badge-dim.badge-light {
  color: #b7c2d0;
  background-color: #f7f8fa;
  border-color: #f7f8fa;
}

.badge-dim.badge-outline-light {
  color: #b7c2d0;
  background-color: #f7f8fa;
  border-color: #e2e7ec;
}

.badge-dim.badge-lighter {
  color: #e5e9f2;
  background-color: #fcfdfe;
  border-color: #fcfdfe;
}

.badge-dim.badge-outline-lighter {
  color: #e5e9f2;
  background-color: #fcfdfe;
  border-color: #f5f6fa;
}

.badge-dot {
  display: inline-flex;
  align-items: center;
  background-color: transparent;
  border: none;
  padding-left: 12px;
  padding-right: 0;
  font-size: 12px;
}
.badge-dot:before {
  position: absolute;
  content: "";
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  display: inline-block;
  height: 6px;
  width: 6px;
  margin-top: -1px;
  border-radius: 50%;
  background: currentColor;
}
.badge-dot.has-bg {
  border-radius: 20px;
  padding: 3px 12px 3px 24px;
}
.badge-dot.has-bg:before {
  left: 12px;
  margin-top: 0;
}
.badge-dot.badge-sm, .badge-dot.badge-md {
  padding-left: 16px;
}
.badge-dot.badge-sm:before, .badge-dot.badge-md:before {
  height: 8px;
  width: 8px;
  margin-top: 0;
}
.badge-dot.badge-sm.has-bg, .badge-dot.badge-md.has-bg {
  border-radius: 20px;
  padding: 5px 12px 5px 28px;
}
.badge-dot.badge-sm.has-bg:before, .badge-dot.badge-md.has-bg:before {
  left: 12px;
}
.badge-dot.badge-lg, .badge-dot.badge-xl {
  padding-left: 24px;
}
.badge-dot.badge-lg:before, .badge-dot.badge-xl:before {
  height: 12px;
  width: 12px;
  margin-top: 0;
}

.badge-dot.badge-primary {
  color: #4461F2;
}
.badge-dot.badge-primary.has-bg {
  background-color: rgba(68, 97, 242, 0.15);
}

.badge-dot.badge-secondary {
  color: #364a63;
}
.badge-dot.badge-secondary.has-bg {
  background-color: rgba(54, 74, 99, 0.15);
}

.badge-dot.badge-success {
  color: #1ee0ac;
}
.badge-dot.badge-success.has-bg {
  background-color: rgba(30, 224, 172, 0.15);
}

.badge-dot.badge-info {
  color: #09c2de;
}
.badge-dot.badge-info.has-bg {
  background-color: rgba(9, 194, 222, 0.15);
}

.badge-dot.badge-warning {
  color: #f4bd0e;
}
.badge-dot.badge-warning.has-bg {
  background-color: rgba(244, 189, 14, 0.15);
}

.badge-dot.badge-danger {
  color: #e85347;
}
.badge-dot.badge-danger.has-bg {
  background-color: rgba(232, 83, 71, 0.15);
}

.badge-dot.badge-dark {
  color: #1c2b46;
}
.badge-dot.badge-dark.has-bg {
  background-color: rgba(28, 43, 70, 0.15);
}

.badge-dot.badge-gray {
  color: #8091a7;
}
.badge-dot.badge-gray.has-bg {
  background-color: rgba(128, 145, 167, 0.15);
}

.badge-dot.badge-light {
  color: #b7c2d0;
}
.badge-dot.badge-light.has-bg {
  background-color: rgba(183, 194, 208, 0.15);
}

.badge-dot.badge-lighter {
  color: #e5e9f2;
}
.badge-dot.badge-lighter.has-bg {
  background-color: rgba(229, 233, 242, 0.15);
}

@media (max-width: 767.98px) {
  .badge-dot-sm {
    width: 0;
    overflow: hidden;
  }
}
@media (max-width: 413px) {
  .badge-dot-mb {
    width: 0;
    overflow: hidden;
  }
}
@media (max-width: 369px) {
  .badge-dot-xs {
    width: 0;
    overflow: hidden;
  }
}
.alert:last-child {
  margin-bottom: 0;
}
.alert-link {
  box-shadow: 0 1px 0 currentColor;
}
.alert-link:hover {
  box-shadow: none;
}
.alert h5, .alert h6, .alert .title {
  font-size: 1.05rem;
}
.alert.alert-icon {
  padding-left: 3.25rem;
}
.alert.alert-icon > .icon {
  position: absolute;
  font-size: 1.25rem;
  line-height: 1;
  width: 2rem;
  top: 1rem;
  left: 1.25rem;
  margin-left: -1px;
}
.alert-dismissible .close {
  top: 50%;
  transform: translateY(-50%);
  transition: 0.3s ease;
  margin-top: -1px;
}
.alert-dismissible .close [aria-hidden=true] {
  display: none;
}
.alert-dismissible .close:focus {
  outline: none;
}
.alert-dismissible .close:hover {
  color: currentColor;
}
.alert-dismissible .close:after {
  font-family: "Nioicon";
  content: "\\ea06";
  font-size: 1.1rem;
}
.alert-light, .alert-lighter, .alert-gray {
  border-color: #e5e9f2;
  color: #526484;
}
.alert-light .alert-link, .alert-lighter .alert-link, .alert-gray .alert-link {
  color: #526484;
}
.alert-alt {
  position: relative;
  padding: 0.875rem;
  border-radius: 12px;
}
.alert-alt.alert-icon {
  padding-left: 4rem;
}
.alert-alt.alert-icon > .icon {
  position: absolute;
  font-size: 2rem;
  line-height: 1;
  width: 4rem;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  text-align: center;
  opacity: 0.5;
}

a.alert:hover {
  color: currentColor;
}

.alert-fill.alert-primary {
  color: #fff;
  background: #4461F2;
}

.alert-fill.alert-secondary {
  color: #fff;
  background: #364a63;
}

.alert-fill.alert-success {
  color: #fff;
  background: #1ee0ac;
}

.alert-fill.alert-info {
  color: #fff;
  background: #09c2de;
}

.alert-fill.alert-warning {
  color: #fff;
  background: #f4bd0e;
}

.alert-fill.alert-danger {
  color: #fff;
  background: #e85347;
}

.alert-fill.alert-dark {
  color: #fff;
  background: #1c2b46;
}

.alert-fill.alert-gray {
  color: #fff;
  background: #8091a7;
}

.alert-fill.alert-light {
  color: #101924;
  background: #e5e9f2;
}

.alert-fill.alert-lighter {
  color: #101924;
  background: #ebeef2;
}

.alert-fill {
  border-width: 0;
}
.alert-fill .alert-link, .alert-fill .icon, .alert-fill h4, .alert-fill h5, .alert-fill h6 {
  color: currentColor;
}
.alert-fill.alert-light {
  color: #364a63;
}
.alert-fill.alert-lighter {
  color: #526484;
}

.alert-pro {
  box-shadow: 0 4px 15px 0 rgba(31, 43, 58, 0.1);
  border: none;
  border-left: 4px solid transparent;
  color: #526484;
  line-height: 1.5;
  background: #fff;
}
.alert-pro.no-shadow {
  box-shadow: none;
}
.alert-pro.no-border {
  border-left: 0;
}
.alert-pro.alert-icon {
  padding-left: 4rem;
}
.alert-pro.alert-icon > .icon {
  font-size: 1.75rem;
  top: 50%;
  transform: translateY(-50%);
}

.alert-pro.alert-primary {
  border-color: #4461F2;
}
.alert-pro.alert-primary > .icon {
  color: #4461F2;
}

.alert-pro.alert-secondary {
  border-color: #364a63;
}
.alert-pro.alert-secondary > .icon {
  color: #364a63;
}

.alert-pro.alert-success {
  border-color: #1ee0ac;
}
.alert-pro.alert-success > .icon {
  color: #1ee0ac;
}

.alert-pro.alert-info {
  border-color: #09c2de;
}
.alert-pro.alert-info > .icon {
  color: #09c2de;
}

.alert-pro.alert-warning {
  border-color: #f4bd0e;
}
.alert-pro.alert-warning > .icon {
  color: #f4bd0e;
}

.alert-pro.alert-danger {
  border-color: #e85347;
}
.alert-pro.alert-danger > .icon {
  color: #e85347;
}

.alert-pro.alert-dark {
  border-color: #1c2b46;
}
.alert-pro.alert-dark > .icon {
  color: #1c2b46;
}

.alert-pro.alert-gray {
  border-color: #8091a7;
}
.alert-pro.alert-gray > .icon {
  color: #8091a7;
}

.alert-pro.alert-light {
  border-color: #b7c2d0;
}
.alert-pro.alert-light > .icon {
  color: #b7c2d0;
}

.alert-pro.alert-lighter {
  border-color: #b7c2d0;
}
.alert-pro.alert-lighter > .icon {
  color: #b7c2d0;
}

.breadcrumb-item {
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
}
.breadcrumb-item a:not(:hover) {
  color: #8094ae;
}
.breadcrumb-pipe .breadcrumb-item + .breadcrumb-item::before {
  content: "|";
}
.breadcrumb-arrow .breadcrumb-item + .breadcrumb-item::before {
  font-family: "Nioicon";
  content: "\\ea6d";
}
.breadcrumb-item.active:not(:only-child) {
  font-weight: 400;
}

.breadcrumb-alt .breadcrumb-item {
  text-transform: unset;
  letter-spacing: 0;
  color: #8094ae;
}

.breadcrumb-xs .breadcrumb-item + .breadcrumb-item {
  padding-left: 0.25rem;
}
.breadcrumb-xs .breadcrumb-item + .breadcrumb-item:before {
  padding-right: 0.25rem;
  font-size: 0.8em;
}

.breadcrumb-sm .breadcrumb-item {
  font-size: 13px;
}

.link {
  display: inline-flex;
  align-items: center;
  font-size: 0.85rem;
  font-weight: 500;
  font-family: "DM Sans", sans-serif;
  line-height: 1;
  border: none;
  background: transparent;
  transition: all 0.3s ease;
  white-space: nowrap;
}
.link:focus {
  box-shadow: none;
  outline: none;
}
.link .icon {
  font-size: 1.3em;
}
.link span, .link .icon {
  display: inline-block;
}
.link .icon-circle {
  display: inline-flex;
}
.link .icon + span, .link span + .icon {
  padding-left: 10px;
}
.link-md {
  font-size: 1.25rem;
}
.link-sm {
  font-size: 0.75rem;
}
.link-dim {
  opacity: 0.7;
}
.link-dim:hover {
  opacity: 1;
}
.link-block {
  display: flex;
}
.link-between {
  justify-content: space-between;
}

.link-primary {
  color: #4461F2 !important;
}

.link-on-primary:hover {
  color: #4461F2 !important;
}

.link-secondary {
  color: #364a63 !important;
}

.link-on-secondary:hover {
  color: #364a63 !important;
}

.link-success {
  color: #1ee0ac !important;
}

.link-on-success:hover {
  color: #1ee0ac !important;
}

.link-info {
  color: #09c2de !important;
}

.link-on-info:hover {
  color: #09c2de !important;
}

.link-warning {
  color: #f4bd0e !important;
}

.link-on-warning:hover {
  color: #f4bd0e !important;
}

.link-danger {
  color: #e85347 !important;
}

.link-on-danger:hover {
  color: #e85347 !important;
}

.link-dark {
  color: #1c2b46 !important;
}

.link-on-dark:hover {
  color: #1c2b46 !important;
}

.link-gray {
  color: #8091a7 !important;
}

.link-on-gray:hover {
  color: #8091a7 !important;
}

.link-light {
  color: #8094ae !important;
}

.link-on-light:hover {
  color: #8094ae !important;
}

.link-lighter {
  color: #b7c2d0 !important;
}

.link-on-lighter:hover {
  color: #b7c2d0 !important;
}

.link-text {
  color: #526484 !important;
}

.link-on-text:hover {
  color: #526484 !important;
}

.link-danger:hover, .link-warning:hover, .link-success:hover, .link-info:hover {
  color: #526484 !important;
}

.btn, .dual-listbox .dual-listbox__button {
  position: relative;
  letter-spacing: 0.02em;
  display: inline-flex;
  align-items: center;
}
.btn-xl {
  padding: 0.6875rem 1.5rem;
  font-size: 0.9375rem;
  line-height: 1.25rem;
  border-radius: 5px;
}
.btn-xs {
  padding: 0.125rem 0.5rem;
  font-size: 0.6875rem;
  line-height: 1rem;
  border-radius: 3px;
}
.btn .icon, .dual-listbox .dual-listbox__button .icon {
  font-size: 1.4em;
  line-height: inherit;
}
.btn > span, .dual-listbox .dual-listbox__button > span {
  display: inline-block;
  white-space: nowrap;
}
.btn > span:only-child, .dual-listbox .dual-listbox__button > span:only-child {
  width: 100%;
}
.btn .icon + span, .dual-listbox .dual-listbox__button .icon + span, .btn span + .icon, .dual-listbox .dual-listbox__button span + .icon {
  padding-left: 8px;
}
.btn .dd-indc, .dual-listbox .dual-listbox__button .dd-indc {
  transform: translateX(-8px);
}
.btn span + .dd-indc, .dual-listbox .dual-listbox__button span + .dd-indc {
  transform: translateX(8px);
}
.btn-lg .icon + span, .btn-group-lg > .btn .icon + span, .dual-listbox .btn-group-lg > .dual-listbox__button .icon + span, .btn-lg span + .icon, .btn-group-lg > .btn span + .icon, .dual-listbox .btn-group-lg > .dual-listbox__button span + .icon {
  padding-left: 12px;
}
.btn-round {
  border-radius: 2.125rem;
}
.btn-block {
  justify-content: center;
}
.btn-ucap, .btn.ucap, .dual-listbox .ucap.dual-listbox__button {
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.05em;
}
.btn-icon:not([class*=btn-icon-break]), .dt-buttons .btn-secondary:not([class*=btn-icon-break]) {
  padding-left: 0;
  padding-right: 0;
}
.btn-icon .icon, .dt-buttons .btn-secondary .icon {
  width: 2.125rem;
}
.btn-icon.btn-xl .icon, .dt-buttons .btn-xl.btn-secondary .icon {
  width: 2.625rem;
}
.btn-icon.btn-lg .icon, .dt-buttons .btn-lg.btn-secondary .icon, .btn-group-lg > .btn-icon.btn .icon, .dual-listbox .btn-group-lg > .btn-icon.dual-listbox__button .icon, .dt-buttons .btn-group-lg > .btn.btn-secondary .icon, .dt-buttons .dual-listbox .btn-group-lg > .btn-secondary.dual-listbox__button .icon, .dual-listbox .dt-buttons .btn-group-lg > .btn-secondary.dual-listbox__button .icon {
  width: 2.625rem;
}
.btn-icon.btn-sm .icon, .dt-buttons .btn-sm.btn-secondary .icon, .btn-group-sm > .btn-icon.btn .icon, .dual-listbox .btn-group-sm > .btn-icon.dual-listbox__button .icon, .dt-buttons .btn-group-sm > .btn.btn-secondary .icon, .dt-buttons .dual-listbox .btn-group-sm > .btn-secondary.dual-listbox__button .icon, .dual-listbox .dt-buttons .btn-group-sm > .btn-secondary.dual-listbox__button .icon {
  width: 1.75rem;
}
.btn-icon.btn-xs .icon, .dt-buttons .btn-xs.btn-secondary .icon {
  width: 1.25rem;
  font-size: 1.1em;
}
.btn-icon .dot, .dt-buttons .btn-secondary .dot {
  top: 0.35rem;
  position: absolute;
  right: 0.35rem;
  transform: translate(50%, -50%);
}
.btn-icon .badge, .dt-buttons .btn-secondary .badge {
  top: 0.25rem;
  position: absolute;
  right: 0.25rem;
  transform: translate(50%, -50%);
}
.btn-icon .badge-circle, .dt-buttons .btn-secondary .badge-circle {
  border-radius: 50%;
  height: 1.125rem;
  width: 1.125rem;
  padding: 0;
  font-weight: 700;
  font-size: 11px;
  text-align: center;
  justify-content: center;
}
.btn-mw {
  min-width: 120px;
  justify-content: center;
}
.btn-wrap {
  flex-direction: column;
  align-items: center;
  flex-grow: 0;
}
.btn-extext {
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  margin-top: 0.25rem;
  color: #8094ae;
}
.btn-wider {
  display: flex;
}
.btn-wider .icon + span, .btn-wider span + .icon {
  margin-left: auto;
}
.btn-auto {
  min-width: auto;
}
.btn-pd-auto {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.btn .spinner-border, .dual-listbox .dual-listbox__button .spinner-border, .btn .spinner-grow, .dual-listbox .dual-listbox__button .spinner-grow {
  margin: 0.125rem;
}
.btn .spinner-border + span, .dual-listbox .dual-listbox__button .spinner-border + span, .btn .spinner-grow + span, .dual-listbox .dual-listbox__button .spinner-grow + span {
  margin-left: 0.25rem;
}
.btn-indc {
  width: 100%;
}
.btn-indc .icon {
  font-size: 1.43em;
}
.btn-indc .indc {
  opacity: 0.6;
  margin-left: -8px;
  margin-right: auto;
}
.btn-indc span + .indc {
  margin-left: auto;
  margin-right: -8px;
}

@media (min-width: 768px) {
  .btn-xl {
    padding: 0.625rem 2rem;
    font-size: 1.125rem;
    line-height: 2rem;
    border-radius: 5px;
  }
  .btn-xl.btn-round {
    border-radius: 3.25rem;
  }
  .btn-icon.btn-xl .icon, .dt-buttons .btn-xl.btn-secondary .icon {
    width: 3.25rem;
  }
}
.btn-trigger {
  position: relative;
  z-index: 1;
  color: #526484;
}
.btn-trigger:focus {
  box-shadow: none;
}
.btn-trigger:before {
  position: absolute;
  z-index: -1;
  height: 20px;
  width: 20px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transform-origin: 50% 50%;
  content: "";
  background-color: #e5e9f2;
  border-radius: 50%;
  opacity: 0;
  transition: all 0.3s;
}
.is-dark .btn-trigger:before {
  background-color: #26164b;
}
.show > .btn-trigger:before {
  opacity: 1;
  height: 120%;
  width: 120%;
}
.btn-trigger:hover:before, .btn-trigger:focus:before, .btn-trigger.active:not(.revarse):before {
  opacity: 1;
  height: 120%;
  width: 120%;
}
.btn-trigger.active:hover:before {
  background-color: #dbdfea;
}
a:hover .btn-trigger:before {
  opacity: 1;
  height: 120%;
  width: 120%;
}

.btn-dim.btn-outline-primary {
  color: #4461F2;
  background-color: #eaeefe;
  border-color: #b4c0fa;
}
.btn-dim.btn-outline-primary:not(:disabled):not(.disabled):hover {
  color: #fff;
  background-color: #4461F2;
  border-color: #4461F2;
}

.btn-white.btn-outline-primary:not(.btn-dim):not(:disabled):not(.disabled):hover, .dt-buttons .btn-outline-primary.btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover, .btn-trans.btn-outline-primary:not(.btn-dim):not(:disabled):not(.disabled):hover {
  color: #4461F2;
  background: #eaeefe;
}

.btn-dim.btn-outline-success {
  color: #1ee0ac;
  background-color: #e6fcf6;
  border-color: #a5f3de;
}
.btn-dim.btn-outline-success:not(:disabled):not(.disabled):hover {
  color: #fff;
  background-color: #1ee0ac;
  border-color: #1ee0ac;
}

.btn-white.btn-outline-success:not(.btn-dim):not(:disabled):not(.disabled):hover, .dt-buttons .btn-outline-success.btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover, .btn-trans.btn-outline-success:not(.btn-dim):not(:disabled):not(.disabled):hover {
  color: #1ee0ac;
  background: #e6fcf6;
}

.btn-dim.btn-outline-warning {
  color: #f4bd0e;
  background-color: #fef8e4;
  border-color: #fbe59f;
}
.btn-dim.btn-outline-warning:not(:disabled):not(.disabled):hover {
  color: #fff;
  background-color: #f4bd0e;
  border-color: #f4bd0e;
}

.btn-white.btn-outline-warning:not(.btn-dim):not(:disabled):not(.disabled):hover, .dt-buttons .btn-outline-warning.btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover, .btn-trans.btn-outline-warning:not(.btn-dim):not(:disabled):not(.disabled):hover {
  color: #f4bd0e;
  background: #fef8e4;
}

.btn-dim.btn-outline-info {
  color: #09c2de;
  background-color: #e4f8fb;
  border-color: #9de7f2;
}
.btn-dim.btn-outline-info:not(:disabled):not(.disabled):hover {
  color: #fff;
  background-color: #09c2de;
  border-color: #09c2de;
}

.btn-white.btn-outline-info:not(.btn-dim):not(:disabled):not(.disabled):hover, .dt-buttons .btn-outline-info.btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover, .btn-trans.btn-outline-info:not(.btn-dim):not(:disabled):not(.disabled):hover {
  color: #09c2de;
  background: #e4f8fb;
}

.btn-dim.btn-outline-danger {
  color: #e85347;
  background-color: #fceceb;
  border-color: #f6bab5;
}
.btn-dim.btn-outline-danger:not(:disabled):not(.disabled):hover {
  color: #fff;
  background-color: #e85347;
  border-color: #e85347;
}

.btn-white.btn-outline-danger:not(.btn-dim):not(:disabled):not(.disabled):hover, .dt-buttons .btn-outline-danger.btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover, .btn-trans.btn-outline-danger:not(.btn-dim):not(:disabled):not(.disabled):hover {
  color: #e85347;
  background: #fceceb;
}

.btn-dim.btn-outline-secondary {
  color: #364a63;
  background-color: #e9ebee;
  border-color: #b9c0c8;
}
.btn-dim.btn-outline-secondary:not(:disabled):not(.disabled):hover {
  color: #fff;
  background-color: #364a63;
  border-color: #364a63;
}

.btn-white.btn-outline-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover, .dt-buttons .btn-outline-secondary.btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover, .btn-trans.btn-outline-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover {
  color: #364a63;
  background: #e9ebee;
}

.btn-dim.btn-outline-gray {
  color: #3c4d62;
  background-color: #f1f3f5;
  border-color: #d3d9e0;
}
.btn-dim.btn-outline-gray:not(:disabled):not(.disabled):hover {
  color: #fff;
  background-color: #3c4d62;
  border-color: #3c4d62;
}

.btn-white.btn-outline-gray:not(.btn-dim):not(:disabled):not(.disabled):hover, .dt-buttons .btn-outline-gray.btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover, .btn-trans.btn-outline-gray:not(.btn-dim):not(:disabled):not(.disabled):hover {
  color: #3c4d62;
  background: #f1f3f5;
}

.btn-dim.btn-outline-dark {
  color: #1f2b3a;
  background-color: #e6e8e9;
  border-color: #b1b5ba;
}
.btn-dim.btn-outline-dark:not(:disabled):not(.disabled):hover {
  color: #fff;
  background-color: #1f2b3a;
  border-color: #1f2b3a;
}

.btn-white.btn-outline-dark:not(.btn-dim):not(:disabled):not(.disabled):hover, .dt-buttons .btn-outline-dark.btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover, .btn-trans.btn-outline-dark:not(.btn-dim):not(:disabled):not(.disabled):hover {
  color: #1f2b3a;
  background: #e6e8e9;
}

.btn-dim.btn-outline-light, .dt-buttons .btn-dim.btn-secondary {
  color: #526484;
  background-color: #f5f6fa;
  border-color: #dbdfea;
}
.btn-dim.btn-outline-light:not(:disabled):not(.disabled):hover, .dt-buttons .btn-dim.btn-secondary:not(:disabled):not(.disabled):hover {
  color: #fff;
  background-color: #526484;
  border-color: #526484;
}

.btn-white.btn-outline-light:not(.btn-dim):not(:disabled):not(.disabled):hover, .dt-buttons .btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover, .btn-trans.btn-outline-light:not(.btn-dim):not(:disabled):not(.disabled):hover {
  color: #526484;
  background: #f5f6fa;
}

.btn-dim.btn-primary {
  color: #4461F2;
  background-color: #eaeefe;
  border-color: transparent;
}
.btn-dim.btn-primary:not(:disabled):not(.disabled):hover {
  color: #fff;
  background-color: #4461F2;
  border-color: #4461F2;
}

.btn-dim.btn-secondary {
  color: #364a63;
  background-color: #e9ebee;
  border-color: transparent;
}
.btn-dim.btn-secondary:not(:disabled):not(.disabled):hover {
  color: #fff;
  background-color: #364a63;
  border-color: #364a63;
}

.btn-dim.btn-success {
  color: #1ee0ac;
  background-color: #e6fcf6;
  border-color: transparent;
}
.btn-dim.btn-success:not(:disabled):not(.disabled):hover {
  color: #fff;
  background-color: #1ee0ac;
  border-color: #1ee0ac;
}

.btn-dim.btn-warning {
  color: #f4bd0e;
  background-color: #fef8e4;
  border-color: transparent;
}
.btn-dim.btn-warning:not(:disabled):not(.disabled):hover {
  color: #fff;
  background-color: #f4bd0e;
  border-color: #f4bd0e;
}

.btn-dim.btn-info {
  color: #09c2de;
  background-color: #e4f8fb;
  border-color: transparent;
}
.btn-dim.btn-info:not(:disabled):not(.disabled):hover {
  color: #fff;
  background-color: #09c2de;
  border-color: #09c2de;
}

.btn-dim.btn-danger {
  color: #e85347;
  background-color: #fceceb;
  border-color: transparent;
}
.btn-dim.btn-danger:not(:disabled):not(.disabled):hover {
  color: #fff;
  background-color: #e85347;
  border-color: #e85347;
}

.btn-dim.btn-gray {
  color: #3c4d62;
  background-color: #eaebee;
  border-color: transparent;
}
.btn-dim.btn-gray:not(:disabled):not(.disabled):hover {
  color: #fff;
  background-color: #3c4d62;
  border-color: #3c4d62;
}

.btn-dim.btn-dark {
  color: #1f2b3a;
  background-color: #e6e8e9;
  border-color: transparent;
}
.btn-dim.btn-dark:not(:disabled):not(.disabled):hover {
  color: #fff;
  background-color: #1f2b3a;
  border-color: #1f2b3a;
}

.btn-dim.btn-light, .dual-listbox .btn-dim.dual-listbox__button {
  color: #8091a7;
  background-color: #f1f3f5;
  border-color: transparent;
}
.btn-dim.btn-light:not(:disabled):not(.disabled):hover, .dual-listbox .btn-dim.dual-listbox__button:not(:disabled):not(.disabled):hover {
  color: #fff;
  background-color: #8091a7;
  border-color: #8091a7;
}

.btn-dim.btn-lighter {
  color: #b7c2d0;
  background-color: #f7f8fa;
  border-color: transparent;
}
.btn-dim.btn-lighter:not(:disabled):not(.disabled):hover {
  color: #101924;
  background-color: #b7c2d0;
  border-color: #b7c2d0;
}

.btn-trans.btn, .dual-listbox .btn-trans.dual-listbox__button {
  background-color: transparent;
  border-color: transparent;
}
.btn-outline-light, .dt-buttons .btn-secondary {
  border-color: #dbdfea;
}
.btn-outline-lighter {
  border-color: #e5e9f2;
}
.btn-outline-light, .dt-buttons .btn-secondary, .btn-outline-lighter {
  color: #526484;
}
.btn-white, .dt-buttons .btn-secondary, .btn-white.btn-dim {
  background: #fff;
}
.btn-white.btn-outline-light:not(.btn-dim):not(:disabled):not(.disabled):hover, .dt-buttons .btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover {
  color: #fff;
  background: #526484;
  border-color: #526484;
}

.btn-p-0 {
  padding: 0;
}
.btn-px-0 {
  padding-left: 0;
  padding-right: 0;
}
.btn-py-0 {
  padding-top: 0;
  padding-bottom: 0;
}
.btn-nofocus {
  box-shadow: none !important;
}

.btn-toolbar-sep {
  border-right: 1px solid #e5e9f2;
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.card-tools .btn-toolbar-sep {
  padding: 0 !important;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.btn-group.is-tags .btn-xs:first-child {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.btn-group.is-tags .btn-xs:last-child {
  margin-left: 0;
}
.btn-group.is-tags .btn-xs .icon {
  width: 1rem;
}
.btn-group.is-tags .btn-dim:not(:disabled):not(.disabled):hover {
  border-color: transparent;
}

.dropup, .dropright, .dropdown, .dropleft {
  display: inline-flex;
}

.dropdown-toggle {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  margin-bottom: 0;
}
.dropdown-toggle:not([class*=indicator]):after {
  display: none;
}

.clickable * {
  pointer-events: none;
}

.dropdown-menu {
  overflow: hidden;
  border: 1px solid #e5e9f2;
  box-shadow: 0 3px 12px 1px rgba(58, 34, 114, 0.15);
}

.dropdown-inner {
  padding: 0 1.75rem;
}
.dropdown-inner + .dropdown-inner {
  border-top: 1px solid #e5e9f2;
}
.dropdown-head, .dropdown-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1.25rem;
  border-bottom: 1px solid #e5e9f2;
}
.dropdown-head.center, .dropdown-foot.center {
  justify-content: center;
}
.dropdown-head {
  border-bottom: 1px solid #e5e9f2;
}
.dropdown-foot {
  border-top: 1px solid #e5e9f2;
}
.dropdown-body-sm {
  padding: 0.75rem;
}
.dropdown-body-rg {
  padding: 1.25rem;
}
.dropdown-body-md {
  padding: 1.5rem;
}
.dropdown-body-lg {
  padding: 2.25rem;
}
.dropdown-title {
  font-weight: 500;
  color: #364a63;
}

[class*=dropdown-indicator]:after {
  border: none !important;
  font-family: "Nioicon";
  vertical-align: middle;
  content: "\\e9c5";
  margin-left: 1.8rem;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  font-size: 14px;
}
.dropup [class*=dropdown-indicator]:after {
  content: "\\e9da";
}

.dropdown-indicator-caret:after {
  content: "\\e998";
}
.dropup .dropdown-indicator-caret:after {
  content: "\\e998";
}
.dropdown-indicator-caret-up:after {
  content: "\\e99e";
}
.dropup .dropdown-indicator-caret-up:after {
  content: "\\e99e";
}
.dropdown-indicator-up:after {
  content: "\\e93c";
}
.dropup .dropdown-indicator-up:after {
  content: "\\e93c";
}
.dropdown-indicator-down:after {
  content: "\\e939";
}
.dropup .dropdown-indicator-down:after {
  content: "\\e939";
}
.dropdown-indicator-dubble:after {
  content: "\\e9db";
}
.dropup .dropdown-indicator-dubble:after {
  content: "\\e9de";
}
.dropdown-indicator-unfold:after {
  content: "\\ec16";
}
.dropup .dropdown-indicator-unfold:after {
  content: "\\ec16";
}

.dropdown-menu-center {
  left: 50% !important;
}
.dropdown-menu-bottom {
  bottom: 0 !important;
}
.dropdown-menu-xxs {
  min-width: 70px;
  max-width: 70px;
}
.dropdown-menu-xxs.dropdown-menu-center {
  margin-left: -35px;
}
.dropdown-menu-xs {
  min-width: 120px;
  max-width: 120px;
}
.dropdown-menu-xs.dropdown-menu-center {
  margin-left: -60px;
}
.dropdown-menu-md {
  min-width: 280px;
  max-width: 280px;
}
.dropdown-menu-md.dropdown-menu-center {
  margin-left: -140px;
}
.dropdown-menu-sm {
  min-width: 140px;
  max-width: 140px;
}
.dropdown-menu-sm.dropdown-menu-center {
  margin-left: -70px;
}
.dropdown-menu-lg {
  min-width: 320px;
  max-width: 320px;
}
.dropdown-menu-lg.dropdown-menu-center {
  margin-left: -160px;
}
.dropdown-menu-xl {
  min-width: 360px;
  max-width: 360px;
}
.dropdown-menu-xl.dropdown-menu-center {
  margin-left: -180px;
}
.dropdown-menu-auto {
  min-width: 100%;
  max-width: 100%;
}
.dropdown-menu-mxh {
  max-height: 400px;
  overflow: auto;
}

.nk-quick-nav .dropdown-menu {
  margin-top: 11px;
  margin-right: -6px;
}

@media (max-width: 420px) {
  .dropdown-menu-xl, .dropdown-menu-lg, .dropdown-menu-md {
    min-width: calc(100vw - 40px);
    max-width: calc(100vw - 40px);
  }
  .nk-quick-nav .dropdown-menu-xl, .nk-quick-nav .dropdown-menu-lg, .nk-quick-nav .dropdown-menu-md {
    margin-right: 0;
    margin-left: 16px;
  }
  .nk-quick-nav li:last-child .dropdown-menu-xl, .nk-quick-nav li:last-child .dropdown-menu-lg, .nk-quick-nav li:last-child .dropdown-menu-md {
    margin-left: 0;
    margin-right: 3px;
  }
}
.dropdown-menu-s1 {
  border-top: 3px solid #4461F2;
}

.dropdown-toggle-split > .icon {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}

.card {
  box-shadow: 0px 1px 3px 0px rgba(54, 74, 99, 0.05);
}
.card .card {
  box-shadow: 0px 1px 6px 1px rgba(54, 74, 99, 0.1);
}
.card + .card:not(.card .card + .card) {
  margin-top: 28px;
}
.card + .nk-block-head {
  padding-top: 2.5rem;
}
.card-full {
  height: 100%;
}
.card.is-dark {
  background: #3a2272;
}
.card-bordered {
  border: 1px solid #dbdfea;
}
.card-bordered.is-dark {
  border-color: #3a2272;
}
.card-bordered.dashed {
  border-style: dashed;
}
.card-inner {
  padding: 1.25rem;
}
.card-inner-sm {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.card-inner-group .card-inner:not(:last-child) {
  border-bottom: 1px solid #dbdfea;
}
.card-head {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: -0.25rem -0.5rem 1rem;
}
.card-head > * {
  padding: 0.25rem 0.5rem;
}
.card-head > .title:only-child {
  width: 100%;
}
.card-title-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}
.card-title-group .card-title {
  margin-bottom: 0;
}
.card-title-group:only-child, .card-title-group .card-search {
  margin-top: -0.25rem;
  margin-bottom: -0.25rem;
}
.card-title h6.title:not(:last-child) {
  margin-bottom: 0.25rem;
}
.card-title p {
  font-size: 12px;
  color: #8094ae;
}
.card-title p .icon {
  line-height: inherit;
  vertical-align: middle;
}
.card-title-sm .title {
  font-size: 14px;
}
.card-title small {
  font-weight: 500;
  color: #8094ae;
}
.is-dark .card-title {
  color: #fff;
}
.is-dark .card-title .title {
  color: inherit;
}
.card-subtitle {
  color: #8094ae;
  font-family: "DM Sans", sans-serif;
  font-weight: normal;
}
.card-tools-nav {
  display: flex;
  margin: -6px -10px -5px;
}
.card-tools-nav li {
  padding: 0 10px;
}
.card-tools-nav li a {
  position: relative;
  color: #8094ae;
  padding: 10px 0;
  display: block;
  line-height: 1;
}
.card-tools-nav li a:before {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  content: "";
  background: #4461F2;
  opacity: 0;
}
.card-tools-nav li a:hover, .card-tools-nav li a.active {
  color: #526484;
}
.card-tools-nav li a.active::before {
  opacity: 1;
}
.card-tools-nav li.active a {
  color: #526484;
}
.card-tools-nav li.active a::before {
  opacity: 1;
}
.card-tools.mr-n1 {
  margin-right: -0.5rem !important;
}
.card-hint {
  font-size: 1rem;
  color: #dbdfea;
}
.card-tools {
  display: flex;
  margin-right: 0.5rem;
}
.card-tools-wrapper {
  display: flex;
}
.card-note {
  font-size: 12px;
  line-height: 1.125rem;
  color: #8094ae;
  display: flex;
}
.card-note .icon {
  font-size: 1.2em;
  line-height: 1.125rem;
  margin-right: 0.5rem;
  display: inline-block;
}

@media (max-width: 575.98px) {
  .card-head.ui-v2 .card-tools {
    width: calc(100% + 20px);
    margin: 0 -10px;
    padding-top: 0.5rem;
  }
  .card-head.ui-v2 .card-tools-nav {
    padding: 0 0.75rem;
    border-bottom: 1px solid #e5e9f2;
  }
  .card-head.ui-v2 .card-tools-nav li a {
    padding-bottom: 1rem;
  }
  .card-stretch {
    margin-left: -18px;
    margin-right: -18px;
    border-left: 0;
    border-right: 0;
    border-radius: 0;
  }
}
@media (min-width: 576px) {
  .card-inner {
    padding: 1.5rem;
  }
  .card-inner-sm {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .card-inner-md {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .card-header {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
@media (min-width: 768px) {
  .card-inner-lg {
    padding: 2.5rem;
  }
  .card-inner-xl {
    padding: 3.75rem;
  }
}
.form-icon {
  position: absolute;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  top: 0;
  width: calc(1rem + 24px);
  height: calc(2.125rem + 2px);
}
.form-icon.sm {
  height: calc(1.75rem + 2px);
}
.form-icon.lg {
  height: calc(2.625rem + 2px);
}
.form-icon.xl {
  height: calc(3.25rem + 2px);
}
.form-icon .icon {
  font-size: 16px;
  color: #8094ae;
}
.form-icon + .form-control, .form-icon + .rdl-filter, .dual-listbox .form-icon + .dual-listbox__search, div.dataTables_wrapper div.dataTables_filter .form-icon + input {
  padding-left: calc(1rem + 24px);
}
.form-icon-right {
  left: auto;
  right: -1px;
}
.form-icon-right + .form-control, .form-icon-right + .rdl-filter, .dual-listbox .form-icon-right + .dual-listbox__search, div.dataTables_wrapper div.dataTables_filter .form-icon-right + input {
  padding-left: 1rem;
  padding-right: calc(1rem + 24px);
}
.form-info {
  position: absolute;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  top: 50%;
  right: 0;
  border-left: 1px solid #dbdfea;
  padding: 0.125rem 1.25rem;
  transform: translateY(-50%);
  color: #8094ae;
}
.form-info + .form-control, .form-info + .rdl-filter, .dual-listbox .form-info + .dual-listbox__search, div.dataTables_wrapper div.dataTables_filter .form-info + input {
  padding-right: calc(1rem + 24px);
}
.form-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #344357;
  margin-bottom: 0.5rem;
}
.form-label-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}
.form-label-group .form-label {
  margin-bottom: 0;
}
.form-label + .form-note {
  margin-top: -0.35rem;
}
.form-label-outlined {
  position: absolute;
  top: 0.4375rem;
  left: 0.6666666667rem;
  transform-origin: left;
  padding: 0 0.4rem;
  font-weight: 400;
  line-height: 1.25rem;
  color: #3c4d62;
  background-color: #fff;
  z-index: 1;
  transition: all 0.3s ease;
  margin-bottom: 0;
  font-size: 0.8125rem;
}
.form-control-lg ~ .form-label-outlined {
  top: 0.6875rem;
  padding: 0 0.3773584906rem;
  font-size: 0.9375rem;
}
.form-control-sm ~ .form-label-outlined {
  font-size: 0.75rem;
  top: 0.25rem;
  left: 0.4rem;
}
.focused .form-control-sm ~ .form-label-outlined, .form-select.form-control-sm ~ .form-label-outlined {
  font-size: 11px;
}
.focused .form-label-outlined, .form-select ~ .form-label-outlined {
  top: calc(-0.4375rem + -2px);
  font-size: 11px;
}
.form-control-xl ~ .form-label-outlined {
  font-size: 0.9375rem;
  line-height: 2rem;
  top: 0.625rem;
  padding: 0 0.5rem;
  left: 0.8333333333rem;
}
.focused .form-control-xl ~ .form-label-outlined, .form-select.form-control-xl ~ .form-label-outlined {
  top: calc(-0.625rem + -5px);
}
.focused .form-control-lg ~ .form-label-outlined, .focused .form-control-xl ~ .form-label-outlined, .form-select.form-control-lg ~ .form-label-outlined, .form-select.form-control-xl ~ .form-label-outlined {
  font-size: 12px;
}
.form-note {
  font-size: 12px;
  color: #8094ae;
  font-style: italic;
  display: block;
}
.form-note-alt {
  font-size: 12px;
  color: #8094ae;
}
.form-note-group {
  display: flex;
  justify-content: space-between;
  margin-top: 0.5rem;
  margin-bottom: -0.25rem;
}
.form-control-xl {
  height: calc(3.25rem + 2px);
  padding: 0.625rem 1.25rem;
  font-size: 0.9375rem;
  line-height: 2rem;
  border-radius: 5px;
}
.form-control-outlined {
  cursor: pointer;
}
.focused .form-control-outlined {
  cursor: auto;
}
.form-control-wrap, .form-control-group {
  position: relative;
}
.form-control-wrap + .form-note, .form-control-group + .form-note {
  margin-top: 0.5rem;
}
.form-control-noborder {
  border-color: transparent;
}
.form-control-noborder:focus {
  border-color: #dbdfea;
  box-shadow: none;
}
.form-control-solid {
  border-color: #fff;
}
.form-control-solid:focus {
  box-shadow: none;
  border-color: #dbdfea;
}
.form-control-number {
  font-size: 20px;
  padding: 20px;
  height: 74px;
}
.form-control-password-big {
  font-size: 44px;
  height: calc(1rem*2 + 1.25rem + 1px);
  padding: 1rem 1rem;
}
.form-control.error, .error.rdl-filter, .dual-listbox .error.dual-listbox__search, div.dataTables_wrapper div.dataTables_filter input.error {
  border-color: #e85347;
}
.form-control.error:focus, .error.rdl-filter:focus, .dual-listbox .error.dual-listbox__search:focus, div.dataTables_wrapper div.dataTables_filter input.error:focus {
  box-shadow: 0 0 0 3px rgba(232, 83, 71, 0.1);
}
.form-control.focus, .focus.rdl-filter, .dual-listbox .focus.dual-listbox__search, div.dataTables_wrapper div.dataTables_filter input.focus {
  border-color: #4461F2;
  box-shadow: 0 0 0 3px rgba(68, 97, 242, 0.1);
}
.form-control-simple {
  border: none;
  padding: 0;
}
.form-control-simple:focus {
  box-shadow: none;
}
.form-group {
  position: relative;
  margin-bottom: 1.25rem;
}
.form-group:last-child {
  margin-bottom: 0;
}
.form-select {
  height: calc(2.125rem + 2px);
}
.form-select:not(.form-control):not(.rdl-filter) {
  opacity: 0;
}
.form-select-sm, .form-select[data-ui*=sm] {
  height: calc(1.75rem + 2px);
}
.form-select-lg, .form-select[data-ui*=lg] {
  height: calc(2.625rem + 2px);
}
.form-select-xl, .form-select[data-ui*=xl] {
  height: calc(3.25rem + 2px);
}
.form-focus-none:focus {
  border-color: transparent;
  box-shadow: none;
}
.form-action .btn + .btn, .form-action .dual-listbox .dual-listbox__button + .btn, .dual-listbox .form-action .dual-listbox__button + .btn, .form-action .dual-listbox .btn + .dual-listbox__button, .dual-listbox .form-action .btn + .dual-listbox__button, .form-action .dual-listbox .dual-listbox__button + .dual-listbox__button, .dual-listbox .form-action .dual-listbox__button + .dual-listbox__button {
  margin-left: 1.25rem;
}
.form-round {
  border-radius: 100px;
}

.custom-select, div.dataTables_wrapper div.dataTables_length select {
  appearance: none;
  -webkit-appearance: none;
}
.custom-select option, div.dataTables_wrapper div.dataTables_length select option {
  border-radius: 3px;
  padding: 5px 0.5rem;
  margin: 2px -0.5rem;
  cursor: pointer;
  color: #526484;
}
.custom-select option:last-child, div.dataTables_wrapper div.dataTables_length select option:last-child {
  margin-bottom: -0.5rem;
}

.form-control-select {
  position: relative;
}
.form-control-select .form-control, .form-control-select .rdl-filter, .form-control-select .dual-listbox .dual-listbox__search, .dual-listbox .form-control-select .dual-listbox__search, .form-control-select div.dataTables_wrapper div.dataTables_filter input, div.dataTables_wrapper div.dataTables_filter .form-control-select input {
  appearance: none;
  -webkit-appearance: none;
}
.form-control-select-multiple .custom-select, .form-control-select-multiple div.dataTables_wrapper div.dataTables_length select, div.dataTables_wrapper div.dataTables_length .form-control-select-multiple select {
  padding-top: 0.375rem;
  padding-bottom: 0.875rem;
}
.form-control-select-multiple .custom-select option, .form-control-select-multiple div.dataTables_wrapper div.dataTables_length select option, div.dataTables_wrapper div.dataTables_length .form-control-select-multiple select option {
  border-radius: 3px;
  padding: 5px 0.5rem;
  margin: 2px -0.5rem;
  cursor: pointer;
  color: #526484;
}
.form-control-select-multiple .custom-select option:last-child, .form-control-select-multiple div.dataTables_wrapper div.dataTables_length select option:last-child, div.dataTables_wrapper div.dataTables_length .form-control-select-multiple select option:last-child {
  margin-bottom: -0.5rem;
}
.form-control-select:after {
  font-family: "Nioicon";
  content: "\\e9c5";
  pointer-events: none;
  position: absolute;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  right: 1px;
  top: 1px;
  width: calc(calc(2.125rem + 2px) - 2px);
  height: calc(calc(2.125rem + 2px) - 2px);
}
.form-control-select:after.sm:after {
  width: calc(calc(1.75rem + 2px) - 2px);
  height: calc(calc(1.75rem + 2px) - 2px);
}
.form-control-select:after.lg:after {
  width: calc(calc(2.625rem + 2px) - 2px);
  height: calc(calc(2.625rem + 2px) - 2px);
}

textarea.no-resize {
  resize: none;
}
textarea.form-control, textarea.rdl-filter, .dual-listbox textarea.dual-listbox__search {
  min-height: 122px;
  padding-top: 0.65625rem;
}
textarea.textarea-sm {
  min-height: 92px;
}
textarea.textarea-lg {
  min-height: 208px;
}
textarea.textarea-auto {
  min-height: 0;
}

.custom-file-input ~ .error, .custom-file-input ~ .invalid, .form-control ~ .error, .rdl-filter ~ .error, .dual-listbox .dual-listbox__search ~ .error, div.dataTables_wrapper div.dataTables_filter input ~ .error, .form-control ~ .invalid, .rdl-filter ~ .invalid, .dual-listbox .dual-listbox__search ~ .invalid, div.dataTables_wrapper div.dataTables_filter input ~ .invalid, .input-group ~ .error, .input-group ~ .invalid {
  color: #e85347;
  font-size: 11px;
  font-style: italic;
}

.custom-btn-check {
  position: relative;
}
.custom-btn-check input {
  position: absolute;
  opacity: 0;
  height: 1px;
  width: 1px;
}
.custom-btn-check input:checked ~ label {
  color: #fff;
  border-color: #4461F2;
  background-color: #4461F2;
}
.custom-btn-check label {
  display: inline-block;
  border: 2px solid #ebeef2;
  background-color: #ebeef2;
  font-weight: 500;
  color: #526484;
  text-align: center;
  padding: 0.4375rem 1.125rem;
  font-size: 0.8125rem;
  line-height: 1.25rem;
  border-radius: 4px;
  transition: all 0.3s;
  margin-bottom: 0 !important;
}
.custom-btn-sm label {
  padding: 0.25rem 1rem;
  font-size: 0.75rem;
  line-height: 1.25rem;
}
.custom-btn-round label {
  border-radius: 60px;
}
.custom-btn-outline label {
  background-color: transparent;
}

.custom-control {
  display: inline-flex;
  min-height: 1.5rem;
}
.custom-control.notext {
  margin-left: -0.75rem;
}
.custom-control.notext .custom-control-label {
  position: relative;
  left: 0.75rem;
}
.custom-control-label {
  font-size: 14px;
  line-height: 1.25rem;
  padding-top: 0.125rem;
}
.custom-control-label::before, .custom-control-label::after {
  top: 0;
}
.custom-control-label:after {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-image: none !important;
  font-family: "Nioicon";
  color: #fff;
  opacity: 0;
}
.custom-checkbox .custom-control-label:after {
  content: "\\e9bd";
}
.custom-radio .custom-control-label:after {
  content: "\\e980";
}
.custom-control .custom-control-input:checked ~ .custom-control-label::after {
  opacity: 1;
}
.custom-control .custom-control-input[disabled] ~ .custom-control-label, .custom-control .custom-control-input:disabled ~ .custom-control-label {
  opacity: 0.7;
  color: #364a63;
}
.custom-control-sm {
  min-height: 1.125rem;
  padding-left: 1.625rem;
}
.custom-control-sm.notext {
  margin-left: -0.5rem;
}
.custom-control-sm.notext .custom-control-label {
  left: 0.5rem;
}
.custom-control-sm .custom-control-label {
  font-size: 12px;
  line-height: 1.125rem;
  padding-top: 0;
}
.custom-control-sm .custom-control-label::before, .custom-control-sm .custom-control-label::after {
  left: -1.625rem;
  width: 1.125rem;
  height: 1.125rem;
}
.custom-control-sm .custom-control-label:after {
  font-size: 0.9em;
}
.custom-control-lg {
  min-height: 2rem;
  padding-left: 3rem;
}
.custom-control-lg.notext {
  margin-left: -1rem;
}
.custom-control-lg.notext .custom-control-label {
  left: 1rem;
}
.custom-control-lg .custom-control-label {
  font-size: 15px;
  line-height: 1.375rem;
  padding-top: 0.3125rem;
}
.custom-control-lg .custom-control-label::before, .custom-control-lg .custom-control-label::after {
  left: -3rem;
  width: 2rem;
  height: 2rem;
}
.custom-control-lg .custom-control-label:after {
  font-size: 1.2em;
}
.custom-control-input {
  position: absolute;
  height: 1px;
  width: 1px;
  opacity: 0;
}
.custom-control.is-right {
  padding-left: 0;
  padding-right: 2.25rem;
}
.custom-control.is-right .custom-control-label:before, .custom-control.is-right .custom-control-label:after {
  left: auto;
  right: -2.25rem;
}
.custom-control.is-right.custom-control-sm {
  padding-right: 1.625rem;
}
.custom-control.is-right.custom-control-sm .custom-control-label:before, .custom-control.is-right.custom-control-sm .custom-control-label:after {
  right: -1.625rem;
}
.custom-control.is-right.custom-control-lg {
  padding-right: 3rem;
}
.custom-control.is-right.custom-control-lg .custom-control-label:before, .custom-control.is-right.custom-control-lg .custom-control-label:after {
  right: -3rem;
}
.custom-file-label {
  white-space: nowrap;
  overflow: hidden;
}
.custom-select, div.dataTables_wrapper div.dataTables_length select {
  background: #fff;
}

.custom-switch {
  padding-left: 3.75rem;
}
.custom-switch .custom-control-label::before {
  left: -3.75rem;
  width: 3rem;
  border-radius: 1.5rem;
}
.custom-switch .custom-control-label::after {
  opacity: 1;
  top: 0.25rem;
  left: calc(-3.75rem + 4px);
  width: 1rem;
  height: 1rem;
  border-radius: 1.5rem;
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(calc(2rem - 8px));
}
.custom-switch.custom-control-sm {
  padding-left: 2.46875rem;
}
.custom-switch.custom-control-sm .custom-control-label::before {
  left: -2.46875rem;
  width: 1.96875rem;
  border-radius: 0.984375rem;
}
.custom-switch.custom-control-sm .custom-control-label::after {
  top: 0.2375rem;
  left: calc(-2.46875rem + 4px);
  width: 0.65rem;
  height: 0.65rem;
  border-radius: 0.984375rem;
}
.custom-switch.custom-control-sm .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(calc(1.31875rem - 8px));
}
.custom-switch.custom-control-lg {
  padding-left: 5rem;
}
.custom-switch.custom-control-lg .custom-control-label::before {
  left: -5rem;
  width: 4rem;
  border-radius: 2rem;
}
.custom-switch.custom-control-lg .custom-control-label::after {
  top: 0.375rem;
  left: calc(-5rem + 6px);
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 2rem;
}
.custom-switch.custom-control-lg .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(calc(2.75rem - 12px));
}
.custom-switch.is-right {
  padding-left: 0;
  padding-right: 3.75rem;
}
.custom-switch.is-right .custom-control-label:before, .custom-switch.is-right .custom-control-label:after {
  left: auto;
  right: -2.25rem;
}
.custom-switch.is-right .custom-control-label::before {
  right: -3.75rem;
}
.custom-switch.is-right .custom-control-label::after {
  right: calc(-3.75rem + 4px);
}
.custom-switch.is-right .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(calc(-2rem + 8px));
}
.custom-switch.is-right.custom-control-sm {
  padding-right: 2.46875rem;
}
.custom-switch.is-right.custom-control-sm .custom-control-label::before {
  right: -2.46875rem;
}
.custom-switch.is-right.custom-control-sm .custom-control-label::after {
  right: calc(-2.46875rem + 4px);
}
.custom-switch.is-right.custom-control-sm .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(calc(-1.31875rem + 8px));
}
.custom-switch.is-right.custom-control-lg {
  padding-right: 5rem;
}
.custom-switch.is-right.custom-control-lg .custom-control-label::before {
  right: -5rem;
}
.custom-switch.is-right.custom-control-lg .custom-control-label::after {
  right: calc(-5rem + 6px);
}
.custom-switch.is-right.custom-control-lg .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(calc(-2.75rem + 12px));
}

label {
  cursor: pointer;
}
input[type=radio]:checked ~ label {
  cursor: default;
}

.is-alter .form-control ~ .invalid, .is-alter .rdl-filter ~ .invalid, .is-alter .dual-listbox .dual-listbox__search ~ .invalid, .dual-listbox .is-alter .dual-listbox__search ~ .invalid, .is-alter div.dataTables_wrapper div.dataTables_filter input ~ .invalid, div.dataTables_wrapper div.dataTables_filter .is-alter input ~ .invalid, .is-alter .input-group ~ .invalid, .custom-control .invalid {
  position: absolute;
  left: 0;
  color: #fff;
  font-size: 11px;
  line-height: 1;
  bottom: calc(100% + 4px);
  background: #ed756b;
  padding: 0.3rem 0.5rem;
  z-index: 1;
  border-radius: 3px;
  white-space: nowrap;
}
.is-alter .form-control ~ .invalid:before, .is-alter .rdl-filter ~ .invalid:before, .is-alter .dual-listbox .dual-listbox__search ~ .invalid:before, .dual-listbox .is-alter .dual-listbox__search ~ .invalid:before, .is-alter div.dataTables_wrapper div.dataTables_filter input ~ .invalid:before, div.dataTables_wrapper div.dataTables_filter .is-alter input ~ .invalid:before, .is-alter .input-group ~ .invalid:before, .custom-control .invalid:before {
  position: absolute;
  content: "";
  height: 0;
  width: 0;
  border-left: 6px solid #ed756b;
  border-right: 6px solid transparent;
  left: 10px;
  border-bottom: 6px solid transparent;
  bottom: -6px;
}

.is-alter .form-control ~ .invalid, .is-alter .rdl-filter ~ .invalid, .is-alter .dual-listbox .dual-listbox__search ~ .invalid, .dual-listbox .is-alter .dual-listbox__search ~ .invalid, .is-alter div.dataTables_wrapper div.dataTables_filter input ~ .invalid, div.dataTables_wrapper div.dataTables_filter .is-alter input ~ .invalid, .is-alter .input-group ~ .invalid {
  left: auto;
  right: 0;
}
.is-alter .form-control ~ .invalid::before, .is-alter .rdl-filter ~ .invalid::before, .is-alter .dual-listbox .dual-listbox__search ~ .invalid::before, .dual-listbox .is-alter .dual-listbox__search ~ .invalid::before, .is-alter div.dataTables_wrapper div.dataTables_filter input ~ .invalid::before, div.dataTables_wrapper div.dataTables_filter .is-alter input ~ .invalid::before, .is-alter .input-group ~ .invalid::before {
  left: auto;
  right: 10px;
  border-right-color: #ed756b;
  border-left-color: transparent;
  bottom: -4px;
}

.table thead tr:last-child th {
  border-bottom: 1px solid #dbdfea;
}
.table-dark thead tr:last-child th, .table thead.thead-dark tr:last-child th {
  border-color: #3c4d62;
}
.table td:first-child, .table th:first-child {
  padding-left: 1.25rem;
}
.table td:last-child, .table th:last-child {
  padding-right: 1.25rem;
}
.table th {
  line-height: 1.1;
}
.table th.overline-title {
  line-height: 1.25rem;
  font-weight: 500;
}
.table caption {
  font-style: italic;
  padding-left: 1.25rem;
}
.table-bordered td, .table-bordered th {
  padding-left: 1rem;
  padding-right: 1rem;
}
.table-plain td:first-child, .table-plain th:first-child {
  padding-left: 0;
}
.table-plain td:last-child, .table-plain th:last-child {
  padding-right: 0;
}
.table-lg td {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.table-lg th {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.table-vm td, .table-vm th, .table td.vm, .table th.vm {
  vertical-align: middle;
}

@media (min-width: 576px) {
  .table-lg td:first-child, .table-lg th:first-child {
    padding-left: 1.5rem;
  }
  .table-lg td:last-child, .table-lg th:last-child {
    padding-right: 1.5rem;
  }
}
.media-center {
  align-items: center;
}
.media-object {
  display: inline-flex;
}
.media > *:first-child {
  flex-shrink: 0;
}
.media > *:last-child {
  flex-grow: 1;
  max-width: 100%;
}

.nav {
  margin: -0.5rem -1rem;
}
.nav .nav-link {
  display: inline-flex;
  align-items: center;
}
.nav .nav-link .icon + span, .nav .nav-link span + .icon {
  margin-left: 0.75rem;
}
.nav .nav-link .icon {
  font-size: 1.3em;
}
.nav-tabs {
  font-family: "DM Sans", sans-serif;
  margin: 0;
  font-size: 0.8125rem;
  border-bottom: 1px solid #dbdfea;
}
.nav-tabs-s2 {
  border-bottom: none;
  justify-content: center;
}
.nav-tabs + .tab-content {
  margin-top: 1.25rem;
}
.nav-tabs .nav-item {
  padding-right: 1.25rem;
}
.nav-tabs .nav-item:last-child {
  padding-right: 0;
}
.nav-tabs .nav-item.active .nav-link {
  color: #4461F2;
}
.nav-tabs .nav-item.active .nav-link:after {
  opacity: 1;
}
.nav-tabs .nav-link {
  padding: 1rem 0;
  font-weight: 700;
  color: #526484;
  position: relative;
  border: none;
  outline: none;
  display: inline-flex;
  align-items: center;
}
.nav-tabs .nav-link .icon {
  font-size: 1.4em;
}
.nav-tabs .nav-link .icon + span {
  margin-left: 0.5rem;
}
.nav-tabs .nav-link .badge {
  margin-left: 0.25rem;
}
.nav-tabs .nav-link:hover {
  color: #364a63;
}
.nav-tabs .nav-link:focus {
  color: #4461F2;
}
.nav-tabs .nav-link:before, .nav-tabs .nav-link:after {
  position: absolute;
  content: "";
}
.nav-tabs .nav-link:after {
  left: 0;
  right: 0;
  bottom: 0;
  height: 3px;
  background: #4461F2;
  opacity: 0;
}
.nav-tabs .nav-link.active {
  color: #4461F2;
  border: none;
  background-color: transparent;
}
.nav-tabs .nav-link.active:after {
  opacity: 1;
}
.nav-sm {
  font-size: 0.8125rem;
}

@media (min-width: 768px) {
  .nav-tabs .nav-item {
    padding-right: 1.5rem;
  }
  .nav-tabs-sm .nav-item {
    padding-right: 1.25rem;
  }
}
@media (min-width: 992px) {
  .nav-tabs .nav-item {
    padding-right: 1.75rem;
  }
  .nav-tabs-sm .nav-item {
    padding-right: 1.25rem;
  }
  .nav-tabs .nav-link {
    font-size: 0.875rem;
  }
}
@media (min-width: 1200px) {
  .nav-tabs .nav-item {
    padding-right: 2.25rem;
  }
  .nav-tabs-sm .nav-item {
    padding-right: 1.25rem;
  }
}
@media (max-width: 575.98px) {
  .nav-tabs.is-stretch {
    margin-left: -18px;
    margin-right: -18px;
    padding-left: 18px;
    padding-right: 18px;
  }
}
.nav-item-trigger {
  display: inline-flex;
  align-items: center;
  margin: -1px -0.5rem 0 auto;
}

.nav-tabs-card {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  font-family: "DM Sans", sans-serif;
}

@media (min-width: 576px) {
  .nav-tabs-card {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
@media (max-width: 767.98px) {
  .nav-tabs-mb-icon .nav-item {
    padding-right: 0.75rem;
  }
  .nav-tabs-mb-icon .nav-link .icon {
    font-size: 1.25rem;
    padding: 0 0.5rem;
  }
  .nav-tabs-mb-icon .nav-link .icon + span {
    display: none;
  }
}
@media (max-width: 359px) {
  .nav-tabs-mb-icon .nav-item {
    padding-right: 0.35rem;
  }
}
.is-medium.nav-tabs .nav-link {
  padding: 0.75rem 0;
}

.modal-content {
  position: relative;
  min-height: 40px;
  box-shadow: 0px 0px 1px 0px rgba(82, 100, 132, 0.2), 0px 8px 15.52px 0.48px rgba(28, 43, 70, 0.15);
}
.modal-content > .close {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  height: 2.25rem;
  width: 2.25rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: #526484;
  z-index: 1;
  transition: all 0.3s;
}
.modal-body .stretched {
  border-radius: 0;
  margin-left: -1.25rem;
  margin-right: -1.25rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.modal-body .stretched.alert {
  border: none;
}
.modal-body .stretched.alert-icon {
  padding-left: 3.25rem;
}
.modal-body-md {
  padding: 1.75rem 1.25rem;
}
.modal-body-md .stretched {
  margin-left: -1.25rem;
  margin-right: -1.25rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.modal-body-md .stretched.alert-icon {
  padding-left: 4.5rem;
}
.modal-body-lg {
  padding: 2.25rem 1.25rem;
}
.modal-body-lg .stretched {
  margin-left: -1.25rem;
  margin-right: -1.25rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.modal-body-lg .stretched.alert-icon {
  padding-left: 4.5rem;
}
.modal-footer-stretch {
  justify-content: stretch;
}
.modal-footer-between {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: -0.25rem 0;
}
.modal-footer-between > div {
  padding: 0.25rem 0;
}
.modal-dialog {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}
.modal-dialog::before {
  height: calc(100vh - 1rem);
}
.modal.fade .modal-dialog {
  transform: translate(0, -10px);
}
.modal.zoom .modal-dialog {
  transform: scale(0.95);
  transition: transform 0.3s ease-out;
}
.modal-dialog-top {
  align-items: flex-start;
}
.modal.fade .modal-dialog-top {
  transform: translate(0, -30px);
}
.modal-dialog-bottom {
  align-items: flex-end;
}

@media (min-width: 576px) {
  .modal-dialog {
    min-height: calc(100% - 3.5rem);
  }
  .modal-dialog::before {
    height: calc(100vh - 3.5rem);
  }
  .modal-body {
    padding: 1.5rem 1.5rem;
  }
  .modal-body .stretched {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .modal-body .stretched.alert-icon {
    padding-left: 3.5rem;
  }
  .modal-body-sm {
    padding: 1.25rem 1.25rem;
  }
  .modal-body-sm .stretched {
    margin-left: -1.25rem;
    margin-right: -1.25rem;
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .modal-body-sm .stretched.alert-icon {
    padding-left: 3.25rem;
  }
  .modal-body-md {
    padding: 2.25rem 2.5rem;
  }
  .modal-body-md .stretched {
    margin-left: -2.5rem;
    margin-right: -2.5rem;
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .modal-body-md .stretched.alert-icon {
    padding-left: 4.5rem;
  }
  .modal-body-md .stretched.alert-icon > .icon {
    left: 2.5rem;
  }
  .modal-body-lg {
    padding: 3.75rem 3.75rem;
  }
  .modal-body-lg .stretched {
    margin-left: -3.75rem;
    margin-right: -3.75rem;
    padding-left: 3.75rem;
    padding-right: 3.75rem;
  }
  .modal-body-lg .stretched.alert-icon {
    padding-left: 5.75rem;
  }
  .modal-header {
    padding: 1rem 1.5rem;
  }
  .modal-header-sm {
    padding: 0.75rem 1.25rem;
  }
  .modal-footer {
    padding: 1rem 1.5rem;
  }
  .modal-footer-sm {
    padding: 0.75rem 1.25rem;
  }
}
@media (min-width: 768px) {
  .modal-md {
    max-width: 600px;
  }
}
.pagination-goto {
  display: inline-flex;
  align-items: center;
  font-size: 0.8125rem;
  text-transform: uppercase;
}

.page-link {
  font-size: 0.8125rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: calc(1rem + 1.125rem + 2px);
}
.pagination-sm .page-link {
  line-height: 0.875rem;
  min-width: calc(0.875rem + 0.875rem + 2px);
}
.pagination-lg .page-link {
  line-height: 1.5rem;
  min-width: calc(1.5rem + 1.125rem + 2px);
}
.pagination-xl .page-link {
  padding: 0.875rem 0.75rem;
  font-size: 1.38125rem;
  line-height: 1.5rem;
  min-width: calc(1.5rem + 1.75rem + 2px);
}
.page-link .icon {
  font-size: 0.8125rem;
  line-height: inherit;
}
.page-link:not([href]) {
  background-color: transparent;
  color: inherit;
}
.page-link:not([href]) .icon:before {
  position: relative;
  top: 1px;
}
.page-link-prev span, .page-link-next span {
  display: none;
}

@media (min-width: 576px) {
  .page-link-prev span, .page-link-next span {
    display: block;
  }
  .page-link-prev .icon {
    padding-right: 0.25rem;
  }
  .page-link-next .icon {
    padding-left: 0.25rem;
  }
}
.progress-bar {
  height: 100%;
  line-height: 1;
}
.progress-sm {
  height: 0.25rem;
}
.progress-md {
  height: 0.375rem;
}
.progress-lg {
  height: 1rem;
}
.progress-pill, .progress-pill .progress-bar {
  border-radius: 100px;
}
.progress-text {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #8094ae;
  margin-bottom: 0.25rem;
}
.progress-label {
  font-size: 0.875rem;
}
.progress-amount {
  font-size: 12px;
  padding-left: 0.5rem;
}
.progress-alt {
  display: flex;
  align-items: center;
  overflow: visible;
}
.progress-alt .progress-bar {
  border-radius: 2px;
}
.progress-reverse {
  flex-direction: row-reverse;
}
.progress-bordered .progress-bar {
  margin-top: -2px;
  border: 2px solid #fff;
  box-sizing: content-box;
}
.progress-bordered .progress-bar:not(:first-child) {
  margin-left: -4px;
}
.progress-bordered.progress-reverse .progress-bar {
  margin-left: 0;
}
.progress-bordered.progress-reverse .progress-bar:not(:last-child) {
  margin-left: -5px;
}
.progress-rating {
  display: flex;
  align-items: center;
}
.progress-rating-title {
  width: 48px;
  flex-grow: 0;
  line-height: 1.25rem;
}
.progress-rating-percent {
  width: 40px;
  line-height: 1.25rem;
  text-align: right;
}
.progress-rating .progress {
  flex-grow: 1;
}

.toast .close {
  display: inline-flex;
  margin-right: -0.5rem;
  margin-left: 0.5rem;
}

.rating {
  display: flex;
  align-items: center;
  margin: 0 -0.125rem;
  color: #f4bd0e;
}
.rating > * {
  padding: 0 0.125rem;
  display: inline-flex;
}
.rating .icon {
  font-size: 1rem;
}
.rating-wrap {
  display: inline-flex;
  align-items: flex-start;
}
.rating-wrap .amount {
  line-height: 1.25rem;
}
.rating-wrap .rating + span, .rating-wrap span + .rating {
  margin-left: 0.75rem;
}
.rating-pill {
  padding: 0.35rem 0.875rem;
  border-radius: 3rem;
}

.rating-card-description .icon {
  color: #4461F2;
}
.rating-card-description li {
  color: #8094ae;
}
.rating-progress {
  display: flex;
  align-items: center;
}

.icon + span, span + .icon {
  margin-left: 0.25rem;
}

@font-face {
  font-family: "Nioicon";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
.ni {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "Nioicon" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.ni-centos:before {
  content: "\\ece6";
}

.ni-covid:before {
  content: "\\ece7";
}

.ni-fedora:before {
  content: "\\ece8";
}

.ni-hot-fill:before {
  content: "\\ece9";
}

.ni-hot:before {
  content: "\\ecea";
}

.ni-linux-server:before {
  content: "\\eceb";
}

.ni-linux:before {
  content: "\\ecec";
}

.ni-note-add-fill:before {
  content: "\\eced";
}

.ni-repeat-fill:before {
  content: "\\ecee";
}

.ni-tranx-fill:before {
  content: "\\ecef";
}

.ni-ubuntu:before {
  content: "\\ecf0";
}

.ni-virus:before {
  content: "\\ecf1";
}

.ni-b-chrome:before {
  content: "\\ec63";
}

.ni-b-edge:before {
  content: "\\ec64";
}

.ni-b-firefox:before {
  content: "\\ec94";
}

.ni-b-ie:before {
  content: "\\ec95";
}

.ni-b-opera:before {
  content: "\\ec96";
}

.ni-b-safari:before {
  content: "\\ec97";
}

.ni-b-si:before {
  content: "\\ec98";
}

.ni-b-uc:before {
  content: "\\ec99";
}

.ni-brick-fill:before {
  content: "\\ec9a";
}

.ni-brick:before {
  content: "\\ec9b";
}

.ni-col-3s:before {
  content: "\\ec9c";
}

.ni-col-4s:before {
  content: "\\ec9d";
}

.ni-col-2s:before {
  content: "\\ec9e";
}

.ni-comments:before {
  content: "\\ec9f";
}

.ni-dot-sq:before {
  content: "\\eca0";
}

.ni-dot:before {
  content: "\\eca1";
}

.ni-footer:before {
  content: "\\eca2";
}

.ni-header:before {
  content: "\\eca3";
}

.ni-heading:before {
  content: "\\eca4";
}

.ni-layout-alt-fill:before {
  content: "\\eca5";
}

.ni-layout-alt:before {
  content: "\\eca6";
}

.ni-layout-fill1:before {
  content: "\\eca7";
}

.ni-layout1:before {
  content: "\\eca8";
}

.ni-list-index-fill:before {
  content: "\\eca9";
}

.ni-list-index:before {
  content: "\\ecaa";
}

.ni-list-thumb-alt-fill:before {
  content: "\\ecab";
}

.ni-list-thumb-alt:before {
  content: "\\ecac";
}

.ni-list-thumb-fill:before {
  content: "\\ecad";
}

.ni-list-thumb:before {
  content: "\\ecae";
}

.ni-masonry-fill:before {
  content: "\\ecaf";
}

.ni-masonry:before {
  content: "\\ecb0";
}

.ni-menu-circled:before {
  content: "\\ecb1";
}

.ni-menu-squared:before {
  content: "\\ecb2";
}

.ni-notice:before {
  content: "\\ecb3";
}

.ni-pen2:before {
  content: "\\ecb4";
}

.ni-property-blank:before {
  content: "\\ecb5";
}

.ni-propert-blank:before {
  content: "\\ecb5";
}

.ni-property-add:before {
  content: "\\ecb6";
}

.ni-property-alt:before {
  content: "\\ecb7";
}

.ni-property-remove:before {
  content: "\\ecb8";
}

.ni-property:before {
  content: "\\ecb9";
}

.ni-puzzle-fill:before {
  content: "\\ecba";
}

.ni-puzzle:before {
  content: "\\ecbb";
}

.ni-quote-left:before {
  content: "\\ecbc";
}

.ni-quote-right:before {
  content: "\\ecbd";
}

.ni-row-mix:before {
  content: "\\ecbe";
}

.ni-row-view1:before {
  content: "\\ecbf";
}

.ni-sidebar-r:before {
  content: "\\ecc0";
}

.ni-text2:before {
  content: "\\ecc1";
}

.ni-tile-thumb-fill:before {
  content: "\\ecc2";
}

.ni-tile-thumb:before {
  content: "\\ecc3";
}

.ni-view-col-fill:before {
  content: "\\ecc4";
}

.ni-view-col-sq:before {
  content: "\\ecc5";
}

.ni-view-col:before {
  content: "\\ecc6";
}

.ni-view-col2:before {
  content: "\\ecc7";
}

.ni-view-col3:before {
  content: "\\ecc8";
}

.ni-view-cols-fill:before {
  content: "\\ecc9";
}

.ni-view-cols-sq:before {
  content: "\\ecca";
}

.ni-view-cols:before {
  content: "\\eccb";
}

.ni-view-grid-fill:before {
  content: "\\eccc";
}

.ni-view-grid-sq:before {
  content: "\\eccd";
}

.ni-view-grid-wd:before {
  content: "\\ecce";
}

.ni-view-grid:before {
  content: "\\eccf";
}

.ni-view-grid2-wd:before {
  content: "\\ecd0";
}

.ni-view-grid3-wd:before {
  content: "\\ecd1";
}

.ni-view-group-fill:before {
  content: "\\ecd2";
}

.ni-view-group-wd:before {
  content: "\\ecd3";
}

.ni-view-list-fill:before {
  content: "\\ecd4";
}

.ni-view-list-sq:before {
  content: "\\ecd5";
}

.ni-view-list-wd:before {
  content: "\\ecd6";
}

.ni-view-list:before {
  content: "\\ecd7";
}

.ni-view-panel-fill:before {
  content: "\\ecd8";
}

.ni-view-panel-sq:before {
  content: "\\ecd9";
}

.ni-view-panel:before {
  content: "\\ecda";
}

.ni-view-row-fill:before {
  content: "\\ecdb";
}

.ni-view-row-sq:before {
  content: "\\ecdc";
}

.ni-view-row-wd:before {
  content: "\\ecdd";
}

.ni-view-row:before {
  content: "\\ecde";
}

.ni-view-x1:before {
  content: "\\ecdf";
}

.ni-view-x2:before {
  content: "\\ece0";
}

.ni-view-x3:before {
  content: "\\ece1";
}

.ni-view-x4:before {
  content: "\\ece2";
}

.ni-view-x5:before {
  content: "\\ece3";
}

.ni-view-x6:before {
  content: "\\ece4";
}

.ni-view-x7:before {
  content: "\\ece5";
}

.ni-dashlite:before {
  content: "\\eb91";
}

.ni-dashlite-circle:before {
  content: "\\ec56";
}

.ni-dashlite-alt:before {
  content: "\\ec57";
}

.ni-master-card:before {
  content: "\\ec58";
}

.ni-paypal:before {
  content: "\\ec59";
}

.ni-visa-alt:before {
  content: "\\ec5a";
}

.ni-coin-eur:before {
  content: "\\ec5b";
}

.ni-coin-gbp:before {
  content: "\\ec5c";
}

.ni-sign-ada-alt:before {
  content: "\\ec5d";
}

.ni-sign-bch-alt:before {
  content: "\\ec5e";
}

.ni-sign-bgp-alt:before {
  content: "\\ec5f";
}

.ni-sign-bnb-alt:before {
  content: "\\ec60";
}

.ni-sign-brl-alt:before {
  content: "\\ec61";
}

.ni-sign-btc-alt:before {
  content: "\\ec62";
}

.ni-sign-cc-alt:before {
  content: "\\ec65";
}

.ni-sign-cc-alt2:before {
  content: "\\ec66";
}

.ni-sign-chf-alt:before {
  content: "\\ec67";
}

.ni-sign-cny-alt:before {
  content: "\\ec68";
}

.ni-sign-czk-alt:before {
  content: "\\ec69";
}

.ni-sign-dash-alt:before {
  content: "\\ec6a";
}

.ni-sign-dkk-alt:before {
  content: "\\ec6b";
}

.ni-sign-eos-alt:before {
  content: "\\ec6c";
}

.ni-sign-eth-alt:before {
  content: "\\ec6d";
}

.ni-sign-eur-alt2:before {
  content: "\\ec6e";
}

.ni-sign-euro-alt:before {
  content: "\\ec6f";
}

.ni-sign-gbp-alt2:before {
  content: "\\ec70";
}

.ni-sign-hkd-alt:before {
  content: "\\ec71";
}

.ni-sign-idr-alt:before {
  content: "\\ec72";
}

.ni-sign-inr-alt:before {
  content: "\\ec73";
}

.ni-sign-jpy-alt:before {
  content: "\\ec74";
}

.ni-sign-kr-alt:before {
  content: "\\ec75";
}

.ni-sign-ltc-alt:before {
  content: "\\ec76";
}

.ni-sign-ltc:before {
  content: "\\ec77";
}

.ni-sign-mxn-alt:before {
  content: "\\ec78";
}

.ni-sign-mxr-alt:before {
  content: "\\ec79";
}

.ni-sign-myr-alt:before {
  content: "\\ec7a";
}

.ni-sign-paypal-alt:before {
  content: "\\ec7b";
}

.ni-sign-paypal-full:before {
  content: "\\ec7c";
}

.ni-sign-php-alt:before {
  content: "\\ec7d";
}

.ni-sign-pln-alt:before {
  content: "\\ec7e";
}

.ni-sign-rub-alt:before {
  content: "\\ec7f";
}

.ni-sign-sek-alt:before {
  content: "\\ec80";
}

.ni-sign-sgd-alt:before {
  content: "\\ec81";
}

.ni-sign-kobo-alt:before {
  content: "\\ec82";
}

.ni-sign-steem-alt:before {
  content: "\\ec83";
}

.ni-sign-steller-alt:before {
  content: "\\ec84";
}

.ni-sign-stripe-fulll:before {
  content: "\\ec85";
}

.ni-sign-thb-alt:before {
  content: "\\ec86";
}

.ni-sign-trx-alt:before {
  content: "\\ec87";
}

.ni-sign-try-alt:before {
  content: "\\ec88";
}

.ni-sign-usd-alt:before {
  content: "\\ec89";
}

.ni-sign-usd-alt2:before {
  content: "\\ec8a";
}

.ni-sign-usdc-alt:before {
  content: "\\ec8b";
}

.ni-sign-usdt-alt:before {
  content: "\\ec8c";
}

.ni-sign-visa-alt:before {
  content: "\\ec8d";
}

.ni-sign-vnd-alt:before {
  content: "\\ec8e";
}

.ni-sign-waves-alt:before {
  content: "\\ec8f";
}

.ni-sign-xem-alt:before {
  content: "\\ec90";
}

.ni-sign-xrp-new-alt:before {
  content: "\\ec91";
}

.ni-sign-xrp-old-alt:before {
  content: "\\ec92";
}

.ni-sign-zcash-alt:before {
  content: "\\ec93";
}

.ni-chevron-left:before {
  content: "\\e9cc";
}

.ni-chevron-right:before {
  content: "\\e9d3";
}

.ni-chevron-up:before {
  content: "\\e9da";
}

.ni-chevron-down:before {
  content: "\\e9c5";
}

.ni-chevron-left-round:before {
  content: "\\e9cb";
}

.ni-chevron-right-round:before {
  content: "\\e9d2";
}

.ni-chevron-up-round:before {
  content: "\\e9d9";
}

.ni-chevron-down-round:before {
  content: "\\e9c4";
}

.ni-chevron-left-round-fill:before {
  content: "\\e9ca";
}

.ni-chevron-right-round-fill:before {
  content: "\\e9d1";
}

.ni-chevron-up-round-fill:before {
  content: "\\e9d8";
}

.ni-chevron-down-round-fill:before {
  content: "\\e9c3";
}

.ni-chevron-left-c:before {
  content: "\\e9c6";
}

.ni-chevron-right-c:before {
  content: "\\e9cd";
}

.ni-chevron-up-c:before {
  content: "\\e9d4";
}

.ni-chevron-down-c:before {
  content: "\\e9bf";
}

.ni-chevron-left-fill-c:before {
  content: "\\e9c9";
}

.ni-chevron-right-fill-c:before {
  content: "\\e9d0";
}

.ni-chevron-up-fill-c:before {
  content: "\\e9d7";
}

.ni-chevron-down-fill-c:before {
  content: "\\e9c2";
}

.ni-chevron-left-circle:before {
  content: "\\e9c8";
}

.ni-chevron-right-circle:before {
  content: "\\e9cf";
}

.ni-chevron-up-circle:before {
  content: "\\e9d6";
}

.ni-chevron-down-circle:before {
  content: "\\e9c1";
}

.ni-chevron-left-circle-fill:before {
  content: "\\e9c7";
}

.ni-chevron-right-circle-fill:before {
  content: "\\e9ce";
}

.ni-chevron-up-circle-fill:before {
  content: "\\e9d5";
}

.ni-chevron-down-circle-fill:before {
  content: "\\e9c0";
}

.ni-caret-left:before {
  content: "\\e99b";
}

.ni-caret-right:before {
  content: "\\e99d";
}

.ni-caret-up:before {
  content: "\\e99f";
}

.ni-caret-down:before {
  content: "\\e999";
}

.ni-caret-left-fill:before {
  content: "\\e99a";
}

.ni-caret-right-fill:before {
  content: "\\e99c";
}

.ni-caret-up-fill:before {
  content: "\\e99e";
}

.ni-caret-down-fill:before {
  content: "\\e998";
}

.ni-sort:before {
  content: "\\ebbf";
}

.ni-sort-up:before {
  content: "\\ebbd";
}

.ni-sort-down:before {
  content: "\\ebb9";
}

.ni-sort-fill:before {
  content: "\\ebba";
}

.ni-sort-up-fill:before {
  content: "\\ebbc";
}

.ni-sort-down-fill:before {
  content: "\\ebb8";
}

.ni-sort-v:before {
  content: "\\ebbe";
}

.ni-swap-v:before {
  content: "\\ebdc";
}

.ni-swap:before {
  content: "\\ebdd";
}

.ni-arrow-left-round:before {
  content: "\\e937";
}

.ni-arrow-right-round:before {
  content: "\\e942";
}

.ni-arrow-up-round:before {
  content: "\\e94f";
}

.ni-arrow-down-round:before {
  content: "\\e92c";
}

.ni-arrow-left-round-fill:before {
  content: "\\e936";
}

.ni-arrow-right-round-fill:before {
  content: "\\e941";
}

.ni-arrow-up-round-fill:before {
  content: "\\e94e";
}

.ni-arrow-down-round-fill:before {
  content: "\\e92b";
}

.ni-arrow-left-c:before {
  content: "\\e932";
}

.ni-arrow-right-c:before {
  content: "\\e93d";
}

.ni-arrow-up-c:before {
  content: "\\e948";
}

.ni-arrow-down-c:before {
  content: "\\e925";
}

.ni-arrow-left-fill-c:before {
  content: "\\e935";
}

.ni-arrow-right-fill-c:before {
  content: "\\e940";
}

.ni-arrow-up-fill-c:before {
  content: "\\e94b";
}

.ni-arrow-down-fill-c:before {
  content: "\\e928";
}

.ni-arrow-left-circle:before {
  content: "\\e934";
}

.ni-arrow-right-circle:before {
  content: "\\e93f";
}

.ni-arrow-up-circle:before {
  content: "\\e94a";
}

.ni-arrow-down-circle:before {
  content: "\\e927";
}

.ni-arrow-left-circle-fill:before {
  content: "\\e933";
}

.ni-arrow-up-circle-fill:before {
  content: "\\e949";
}

.ni-arrow-down-circle-fill:before {
  content: "\\e926";
}

.ni-arrow-right-circle-fill:before {
  content: "\\e93e";
}

.ni-chevrons-left:before {
  content: "\\e9dc";
}

.ni-chevrons-right:before {
  content: "\\e9dd";
}

.ni-chevrons-up:before {
  content: "\\e9de";
}

.ni-chevrons-down:before {
  content: "\\e9db";
}

.ni-first:before {
  content: "\\ea59";
}

.ni-last:before {
  content: "\\eab8";
}

.ni-back-ios:before {
  content: "\\e958";
}

.ni-forward-ios:before {
  content: "\\ea6d";
}

.ni-upword-ios:before {
  content: "\\ec20";
}

.ni-downward-ios:before {
  content: "\\ea23";
}

.ni-back-alt:before {
  content: "\\e955";
}

.ni-forward-alt:before {
  content: "\\ea69";
}

.ni-upword-alt:before {
  content: "\\ec1f";
}

.ni-downward-alt:before {
  content: "\\ea22";
}

.ni-back-alt-fill:before {
  content: "\\e954";
}

.ni-forward-alt-fill:before {
  content: "\\ea68";
}

.ni-upword-alt-fill:before {
  content: "\\ec1e";
}

.ni-downward-alt-fill:before {
  content: "\\ea21";
}

.ni-arrow-long-left:before {
  content: "\\e93a";
}

.ni-arrow-long-right:before {
  content: "\\e93b";
}

.ni-arrow-long-up:before {
  content: "\\e93c";
}

.ni-arrow-long-down:before {
  content: "\\e939";
}

.ni-arrow-left:before {
  content: "\\e938";
}

.ni-arrow-right:before {
  content: "\\e943";
}

.ni-arrow-up:before {
  content: "\\e950";
}

.ni-arrow-down:before {
  content: "\\e92d";
}

.ni-arrow-up-left:before {
  content: "\\e94c";
}

.ni-arrow-up-right:before {
  content: "\\e94d";
}

.ni-arrow-down-left:before {
  content: "\\e929";
}

.ni-arrow-down-right:before {
  content: "\\e92a";
}

.ni-arrow-to-left:before {
  content: "\\e945";
}

.ni-arrow-to-right:before {
  content: "\\e946";
}

.ni-arrow-to-up:before {
  content: "\\e947";
}

.ni-arrow-to-down:before {
  content: "\\e944";
}

.ni-arrow-from-left:before {
  content: "\\e92f";
}

.ni-arrow-from-right:before {
  content: "\\e930";
}

.ni-arrow-from-up:before {
  content: "\\e931";
}

.ni-arrow-from-down:before {
  content: "\\e92e";
}

.ni-curve-down-left:before {
  content: "\\ea0b";
}

.ni-curve-up-right:before {
  content: "\\ea12";
}

.ni-curve-up-left:before {
  content: "\\ea11";
}

.ni-curve-down-right:before {
  content: "\\ea0c";
}

.ni-curve-left-up:before {
  content: "\\ea0e";
}

.ni-curve-right-up:before {
  content: "\\ea10";
}

.ni-curve-left-down:before {
  content: "\\ea0d";
}

.ni-curve-right-down:before {
  content: "\\ea0f";
}

.ni-back-arrow:before {
  content: "\\e957";
}

.ni-forward-arrow:before {
  content: "\\ea6b";
}

.ni-back-arrow-fill:before {
  content: "\\e956";
}

.ni-forward-arrow-fill:before {
  content: "\\ea6a";
}

.ni-navigate:before {
  content: "\\eb0f";
}

.ni-navigate-up:before {
  content: "\\eb0e";
}

.ni-navigate-fill:before {
  content: "\\eb0c";
}

.ni-navigate-up-fill:before {
  content: "\\eb0d";
}

.ni-send:before {
  content: "\\eb6f";
}

.ni-send-alt:before {
  content: "\\eb6e";
}

.ni-unfold-less:before {
  content: "\\ec15";
}

.ni-unfold-more:before {
  content: "\\ec16";
}

.ni-exchange-v:before {
  content: "\\ea32";
}

.ni-exchange:before {
  content: "\\ea33";
}

.ni-expand:before {
  content: "\\ea34";
}

.ni-shrink:before {
  content: "\\eb83";
}

.ni-focus:before {
  content: "\\ea5e";
}

.ni-maximize:before {
  content: "\\eadf";
}

.ni-minimize:before {
  content: "\\eaf2";
}

.ni-maximize-alt:before {
  content: "\\eade";
}

.ni-minimize-alt:before {
  content: "\\eaf1";
}

.ni-shuffle:before {
  content: "\\eb84";
}

.ni-cross-sm:before {
  content: "\\ea05";
}

.ni-cross:before {
  content: "\\ea06";
}

.ni-cross-round:before {
  content: "\\ea04";
}

.ni-cross-circle:before {
  content: "\\ea01";
}

.ni-cross-c:before {
  content: "\\e9ff";
}

.ni-cross-round-fill:before {
  content: "\\ea03";
}

.ni-cross-circle-fill:before {
  content: "\\ea00";
}

.ni-cross-fill-c:before {
  content: "\\ea02";
}

.ni-na:before {
  content: "\\eb0b";
}

.ni-check:before {
  content: "\\e9be";
}

.ni-check-thick:before {
  content: "\\e9bd";
}

.ni-done:before {
  content: "\\ea1c";
}

.ni-check-round:before {
  content: "\\e9bc";
}

.ni-check-circle:before {
  content: "\\e9b8";
}

.ni-check-c:before {
  content: "\\e9b5";
}

.ni-check-round-fill:before {
  content: "\\e9bb";
}

.ni-check-circle-fill:before {
  content: "\\e9b7";
}

.ni-check-fill-c:before {
  content: "\\e9b9";
}

.ni-check-circle-cut:before {
  content: "\\e9b6";
}

.ni-check-round-cut:before {
  content: "\\e9ba";
}

.ni-bullet:before {
  content: "\\e981";
}

.ni-circle:before {
  content: "\\e9e0";
}

.ni-square:before {
  content: "\\ebca";
}

.ni-square-c:before {
  content: "\\ebc7";
}

.ni-bullet-fill:before {
  content: "\\e980";
}

.ni-circle-fill:before {
  content: "\\e9df";
}

.ni-square-fill:before {
  content: "\\ebc9";
}

.ni-square-fill-c:before {
  content: "\\ebc8";
}

.ni-plus-sm:before {
  content: "\\eb43";
}

.ni-minus-sm:before {
  content: "\\eaf9";
}

.ni-plus:before {
  content: "\\eb44";
}

.ni-minus:before {
  content: "\\eafa";
}

.ni-plus-round:before {
  content: "\\eb42";
}

.ni-minus-round:before {
  content: "\\eaf8";
}

.ni-plus-circle:before {
  content: "\\eb3d";
}

.ni-minus-circle:before {
  content: "\\eaf5";
}

.ni-plus-c:before {
  content: "\\eb3b";
}

.ni-minus-c:before {
  content: "\\eaf3";
}

.ni-plus-round-fill:before {
  content: "\\eb41";
}

.ni-plus-circle-fill:before {
  content: "\\eb3c";
}

.ni-minus-round-fill:before {
  content: "\\eaf7";
}

.ni-minus-circle-fill:before {
  content: "\\eaf4";
}

.ni-plus-fill-c:before {
  content: "\\eb3e";
}

.ni-minus-fill-c:before {
  content: "\\eaf6";
}

.ni-plus-medi:before {
  content: "\\eb40";
}

.ni-plus-medi-fill:before {
  content: "\\eb3f";
}

.ni-equal-sm:before {
  content: "\\ea30";
}

.ni-equal:before {
  content: "\\ea31";
}

.ni-calc:before {
  content: "\\e982";
}

.ni-search:before {
  content: "\\eb6c";
}

.ni-zoom-out:before {
  content: "\\ec55";
}

.ni-zoom-in:before {
  content: "\\ec54";
}

.ni-play:before {
  content: "\\eb3a";
}

.ni-play-fill:before {
  content: "\\eb39";
}

.ni-play-circle:before {
  content: "\\eb38";
}

.ni-play-circle-fill:before {
  content: "\\eb37";
}

.ni-pause:before {
  content: "\\eb26";
}

.ni-pause-fill:before {
  content: "\\eb25";
}

.ni-pause-circle:before {
  content: "\\eb24";
}

.ni-pause-circle-fill:before {
  content: "\\eb23";
}

.ni-stop:before {
  content: "\\ebd6";
}

.ni-stop-fill:before {
  content: "\\ebd5";
}

.ni-stop-circle:before {
  content: "\\ebd4";
}

.ni-stop-circle-fill:before {
  content: "\\ebd3";
}

.ni-rewind:before {
  content: "\\eb62";
}

.ni-forward:before {
  content: "\\ea6e";
}

.ni-rewind-fill:before {
  content: "\\eb61";
}

.ni-forward-fill:before {
  content: "\\ea6c";
}

.ni-step-back:before {
  content: "\\ebd1";
}

.ni-step-forward:before {
  content: "\\ebd2";
}

.ni-vol-off:before {
  content: "\\ec40";
}

.ni-vol-no:before {
  content: "\\ec3f";
}

.ni-vol-half:before {
  content: "\\ec3e";
}

.ni-vol:before {
  content: "\\ec41";
}

.ni-mic:before {
  content: "\\eaef";
}

.ni-mic-off:before {
  content: "\\eaee";
}

.ni-video:before {
  content: "\\ec39";
}

.ni-video-off:before {
  content: "\\ec38";
}

.ni-video-fill:before {
  content: "\\ec37";
}

.ni-loader:before {
  content: "\\ead2";
}

.ni-power:before {
  content: "\\eb47";
}

.ni-signout:before {
  content: "\\ebb2";
}

.ni-signin:before {
  content: "\\ebb1";
}

.ni-upload:before {
  content: "\\ec1d";
}

.ni-download:before {
  content: "\\ea20";
}

.ni-alert-circle:before {
  content: "\\e90d";
}

.ni-alert:before {
  content: "\\e910";
}

.ni-caution:before {
  content: "\\e9a3";
}

.ni-report:before {
  content: "\\eb5e";
}

.ni-alert-c:before {
  content: "\\e90b";
}

.ni-alert-circle-fill:before {
  content: "\\e90c";
}

.ni-alert-fill:before {
  content: "\\e90f";
}

.ni-caution-fill:before {
  content: "\\e9a2";
}

.ni-report-fill:before {
  content: "\\eb5c";
}

.ni-alert-fill-c:before {
  content: "\\e90e";
}

.ni-info-i:before {
  content: "\\eaa8";
}

.ni-info:before {
  content: "\\eaa9";
}

.ni-info-fill:before {
  content: "\\eaa7";
}

.ni-help:before {
  content: "\\ea98";
}

.ni-help-fill:before {
  content: "\\ea97";
}

.ni-archived:before {
  content: "\\e924";
}

.ni-archive:before {
  content: "\\e922";
}

.ni-unarchive:before {
  content: "\\ec12";
}

.ni-archived-fill:before {
  content: "\\e923";
}

.ni-archive-fill:before {
  content: "\\e921";
}

.ni-unarchive-fill:before {
  content: "\\ec11";
}

.ni-bag:before {
  content: "\\e95a";
}

.ni-bag-fill:before {
  content: "\\e959";
}

.ni-bell:before {
  content: "\\e965";
}

.ni-bell-off:before {
  content: "\\e964";
}

.ni-bell-fill:before {
  content: "\\e962";
}

.ni-bell-off-fill:before {
  content: "\\e963";
}

.ni-wifi:before {
  content: "\\ec4b";
}

.ni-wifi-off:before {
  content: "\\ec4a";
}

.ni-live:before {
  content: "\\ead1";
}

.ni-signal:before {
  content: "\\ebb0";
}

.ni-bluetooth:before {
  content: "\\e96d";
}

.ni-blank-alt:before {
  content: "\\e967";
}

.ni-blank:before {
  content: "\\e968";
}

.ni-blank-fill:before {
  content: "\\e969";
}

.ni-blankf-fill:before {
  content: "\\e969";
}

.ni-block-over:before {
  content: "\\e96a";
}

.ni-book-read:before {
  content: "\\e970";
}

.ni-book:before {
  content: "\\e971";
}

.ni-book-fill:before {
  content: "\\e96f";
}

.ni-bulb-fill:before {
  content: "\\e97e";
}

.ni-bulb:before {
  content: "\\e97f";
}

.ni-calendar-alt-fill:before {
  content: "\\e983";
}

.ni-calendar-alt:before {
  content: "\\e984";
}

.ni-calendar-booking-fill:before {
  content: "\\e985";
}

.ni-calendar-booking:before {
  content: "\\e986";
}

.ni-calendar-check-fill:before {
  content: "\\e987";
}

.ni-calendar-check:before {
  content: "\\e988";
}

.ni-calendar-fill:before {
  content: "\\e989";
}

.ni-calendar:before {
  content: "\\e98a";
}

.ni-calender-date-fill:before {
  content: "\\e98b";
}

.ni-calender-date:before {
  content: "\\e98c";
}

.ni-call:before {
  content: "\\e990";
}

.ni-call-alt:before {
  content: "\\e98e";
}

.ni-call-alt-fill:before {
  content: "\\e98d";
}

.ni-call-fill:before {
  content: "\\e98f";
}

.ni-camera-fill:before {
  content: "\\e991";
}

.ni-camera:before {
  content: "\\e992";
}

.ni-capsule:before {
  content: "\\e994";
}

.ni-capsule-fill:before {
  content: "\\e993";
}

.ni-cards:before {
  content: "\\e997";
}

.ni-cards-fill:before {
  content: "\\e996";
}

.ni-cart:before {
  content: "\\e9a1";
}

.ni-cart-fill:before {
  content: "\\e9a0";
}

.ni-cc:before {
  content: "\\e9ae";
}

.ni-cc-alt:before {
  content: "\\e9a5";
}

.ni-cc-alt2:before {
  content: "\\e9a7";
}

.ni-cc-secure:before {
  content: "\\e9ac";
}

.ni-cc-new:before {
  content: "\\e9a9";
}

.ni-cc-off:before {
  content: "\\e9aa";
}

.ni-cc-fill:before {
  content: "\\e9a8";
}

.ni-cc-alt-fill:before {
  content: "\\e9a4";
}

.ni-cc-alt2-fill:before {
  content: "\\e9a6";
}

.ni-cc-secure-fill:before {
  content: "\\e9ab";
}

.ni-msg-circle:before {
  content: "\\eb07";
}

.ni-chat-circle:before {
  content: "\\e9b2";
}

.ni-msg:before {
  content: "\\eb09";
}

.ni-chat:before {
  content: "\\e9b4";
}

.ni-question-alt:before {
  content: "\\eb4b";
}

.ni-question:before {
  content: "\\eb4c";
}

.ni-msg-circle-fill:before {
  content: "\\eb06";
}

.ni-chat-circle-fill:before {
  content: "\\e9b1";
}

.ni-msg-fill:before {
  content: "\\eb08";
}

.ni-chat-fill:before {
  content: "\\e9b3";
}

.ni-clip-h:before {
  content: "\\e9e1";
}

.ni-clip-v:before {
  content: "\\e9e2";
}

.ni-clip:before {
  content: "\\e9e3";
}

.ni-link-alt:before {
  content: "\\eac5";
}

.ni-unlink:before {
  content: "\\ec18";
}

.ni-unlink-alt:before {
  content: "\\ec17";
}

.ni-link-h:before {
  content: "\\eac7";
}

.ni-link-v:before {
  content: "\\eac8";
}

.ni-link:before {
  content: "\\eac9";
}

.ni-clipboard:before {
  content: "\\e9e7";
}

.ni-clipboad-check:before {
  content: "\\e9e5";
}

.ni-clipboard-fill:before {
  content: "\\e9e6";
}

.ni-clipboad-check-fill:before {
  content: "\\e9e4";
}

.ni-clock:before {
  content: "\\e9e9";
}

.ni-clock-fill:before {
  content: "\\e9e8";
}

.ni-cloud:before {
  content: "\\e9eb";
}

.ni-upload-cloud:before {
  content: "\\ec1c";
}

.ni-download-cloud:before {
  content: "\\ea1f";
}

.ni-cloud-fill:before {
  content: "\\e9ea";
}

.ni-contact:before {
  content: "\\e9f9";
}

.ni-contact-fill:before {
  content: "\\e9f8";
}

.ni-coffee:before {
  content: "\\e9f0";
}

.ni-coffee-fill:before {
  content: "\\e9ef";
}

.ni-box-view:before {
  content: "\\e976";
}

.ni-col-view:before {
  content: "\\e9f5";
}

.ni-sidebar:before {
  content: "\\eb86";
}

.ni-layout:before {
  content: "\\eabe";
}

.ni-table-view:before {
  content: "\\ebdf";
}

.ni-layout2:before {
  content: "\\eabf";
}

.ni-row-view:before {
  content: "\\eb63";
}

.ni-dot-box:before {
  content: "\\ea1e";
}

.ni-layout-fill:before {
  content: "\\eabd";
}

.ni-box-view-fill:before {
  content: "\\e975";
}

.ni-sidebar-fill:before {
  content: "\\eb85";
}

.ni-table-view-fill:before {
  content: "\\ebde";
}

.ni-dot-box-fill:before {
  content: "\\ea1d";
}

.ni-template:before {
  content: "\\ebee";
}

.ni-browser:before {
  content: "\\e97a";
}

.ni-toolbar:before {
  content: "\\ec02";
}

.ni-browser-fill:before {
  content: "\\e979";
}

.ni-toolbar-fill:before {
  content: "\\ec01";
}

.ni-template-fill:before {
  content: "\\ebed";
}

.ni-box:before {
  content: "\\e977";
}

.ni-package:before {
  content: "\\eb20";
}

.ni-layer:before {
  content: "\\eaba";
}

.ni-layers:before {
  content: "\\eabc";
}

.ni-panel:before {
  content: "\\eb22";
}

.ni-server:before {
  content: "\\eb71";
}

.ni-layer-fill:before {
  content: "\\eab9";
}

.ni-layers-fill:before {
  content: "\\eabb";
}

.ni-package-fill:before {
  content: "\\eb1f";
}

.ni-panel-fill:before {
  content: "\\eb21";
}

.ni-server-fill:before {
  content: "\\eb70";
}

.ni-color-palette:before {
  content: "\\e9f7";
}

.ni-color-palette-fill:before {
  content: "\\e9f6";
}

.ni-copy:before {
  content: "\\e9fb";
}

.ni-copy-fill:before {
  content: "\\e9fa";
}

.ni-crop-alt:before {
  content: "\\e9fd";
}

.ni-crop:before {
  content: "\\e9fe";
}

.ni-target:before {
  content: "\\ebe7";
}

.ni-crosshair:before {
  content: "\\ea08";
}

.ni-crosshair-fill:before {
  content: "\\ea07";
}

.ni-db-fill:before {
  content: "\\ea15";
}

.ni-db:before {
  content: "\\ea16";
}

.ni-hard-drive:before {
  content: "\\ea90";
}

.ni-cpu:before {
  content: "\\e9fc";
}

.ni-disk:before {
  content: "\\ea1b";
}

.ni-pen:before {
  content: "\\eb2b";
}

.ni-edit-alt:before {
  content: "\\ea29";
}

.ni-pen-fill:before {
  content: "\\eb2a";
}

.ni-edit-alt-fill:before {
  content: "\\ea28";
}

.ni-pen-alt-fill:before {
  content: "\\eb29";
}

.ni-edit-fill:before {
  content: "\\ea2a";
}

.ni-edit:before {
  content: "\\ea2b";
}

.ni-external-alt:before {
  content: "\\ea35";
}

.ni-external:before {
  content: "\\ea36";
}

.ni-eye-alt:before {
  content: "\\ea38";
}

.ni-eye-alt-fill:before {
  content: "\\ea37";
}

.ni-eye:before {
  content: "\\ea3c";
}

.ni-eye-fill:before {
  content: "\\ea39";
}

.ni-eye-off:before {
  content: "\\ea3b";
}

.ni-eye-off-fill:before {
  content: "\\ea3a";
}

.ni-file:before {
  content: "\\ea53";
}

.ni-file-minus:before {
  content: "\\ea49";
}

.ni-file-plus:before {
  content: "\\ea4c";
}

.ni-file-remove:before {
  content: "\\ea4e";
}

.ni-file-check:before {
  content: "\\ea41";
}

.ni-file-code:before {
  content: "\\ea42";
}

.ni-file-docs:before {
  content: "\\ea44";
}

.ni-file-img:before {
  content: "\\ea47";
}

.ni-file-doc:before {
  content: "\\ea43";
}

.ni-file-pdf:before {
  content: "\\ea4a";
}

.ni-file-xls:before {
  content: "\\ea51";
}

.ni-file-zip:before {
  content: "\\ea52";
}

.ni-file-download:before {
  content: "\\ea45";
}

.ni-file-text:before {
  content: "\\ea50";
}

.ni-files:before {
  content: "\\ea55";
}

.ni-file-fill:before {
  content: "\\ea46";
}

.ni-file-minus-fill:before {
  content: "\\ea48";
}

.ni-file-plus-fill:before {
  content: "\\ea4b";
}

.ni-file-remove-fill:before {
  content: "\\ea4d";
}

.ni-file-check-fill:before {
  content: "\\ea40";
}

.ni-file-text-fill:before {
  content: "\\ea4f";
}

.ni-files-fill:before {
  content: "\\ea54";
}

.ni-folder:before {
  content: "\\ea65";
}

.ni-folder-minus:before {
  content: "\\ea62";
}

.ni-folder-plus:before {
  content: "\\ea63";
}

.ni-folder-remove:before {
  content: "\\ea64";
}

.ni-folder-check:before {
  content: "\\ea5f";
}

.ni-folder-list:before {
  content: "\\ea61";
}

.ni-folders:before {
  content: "\\ea67";
}

.ni-folder-fill:before {
  content: "\\ea60";
}

.ni-folders-fill:before {
  content: "\\ea66";
}

.ni-filter-alt:before {
  content: "\\ea56";
}

.ni-sort-line:before {
  content: "\\ebbb";
}

.ni-filter-fill:before {
  content: "\\ea57";
}

.ni-filter:before {
  content: "\\ea58";
}

.ni-flag:before {
  content: "\\ea5b";
}

.ni-flag-fill:before {
  content: "\\ea5a";
}

.ni-notify:before {
  content: "\\eb16";
}

.ni-dashboard:before {
  content: "\\ea14";
}

.ni-dashboard-fill:before {
  content: "\\ea13";
}

.ni-grid-sq:before {
  content: "\\ea89";
}

.ni-grid:before {
  content: "\\ea8a";
}

.ni-grid-c:before {
  content: "\\ea83";
}

.ni-grid-alt:before {
  content: "\\ea7e";
}

.ni-grid-plus:before {
  content: "\\ea88";
}

.ni-grid-add-c:before {
  content: "\\ea7b";
}

.ni-grid-fill:before {
  content: "\\ea85";
}

.ni-grid-fill-c:before {
  content: "\\ea84";
}

.ni-grid-alt-fill:before {
  content: "\\ea7d";
}

.ni-grid-plus-fill:before {
  content: "\\ea87";
}

.ni-grid-add-fill-c:before {
  content: "\\ea7c";
}

.ni-grid-box-alt-fill:before {
  content: "\\ea7f";
}

.ni-grid-box-alt:before {
  content: "\\ea80";
}

.ni-grid-box:before {
  content: "\\ea82";
}

.ni-grid-box-fill:before {
  content: "\\ea81";
}

.ni-grid-line:before {
  content: "\\ea86";
}

.ni-menu-alt-left:before {
  content: "\\eae6";
}

.ni-menu-alt-r:before {
  content: "\\eae7";
}

.ni-menu-alt:before {
  content: "\\eae8";
}

.ni-menu-center:before {
  content: "\\eae9";
}

.ni-menu-left:before {
  content: "\\eaea";
}

.ni-menu-right:before {
  content: "\\eaeb";
}

.ni-menu:before {
  content: "\\eaec";
}

.ni-trend-up:before {
  content: "\\ec0a";
}

.ni-trend-down:before {
  content: "\\ec09";
}

.ni-line-chart-down:before {
  content: "\\eac2";
}

.ni-line-chart-up:before {
  content: "\\eac3";
}

.ni-line-chart:before {
  content: "\\eac4";
}

.ni-bar-chart:before {
  content: "\\e95e";
}

.ni-bar-chart-alt:before {
  content: "\\e95c";
}

.ni-chart-up:before {
  content: "\\e9b0";
}

.ni-chart-down:before {
  content: "\\e9af";
}

.ni-growth:before {
  content: "\\ea8c";
}

.ni-growth-fill:before {
  content: "\\ea8b";
}

.ni-bar-chart-fill:before {
  content: "\\e95d";
}

.ni-bar-c:before {
  content: "\\e95b";
}

.ni-bar-fill-c:before {
  content: "\\e95f";
}

.ni-pie:before {
  content: "\\eb30";
}

.ni-pie-alt:before {
  content: "\\eb2e";
}

.ni-pie-fill:before {
  content: "\\eb2f";
}

.ni-activity:before {
  content: "\\e906";
}

.ni-activity-alt:before {
  content: "\\e903";
}

.ni-activity-round:before {
  content: "\\e905";
}

.ni-activity-round-fill:before {
  content: "\\e904";
}

.ni-meter:before {
  content: "\\eaed";
}

.ni-speed:before {
  content: "\\ebc5";
}

.ni-happy:before {
  content: "\\ea8e";
}

.ni-sad:before {
  content: "\\eb66";
}

.ni-meh:before {
  content: "\\eae5";
}

.ni-happy-fill:before {
  content: "\\ea8f";
}

.ni-happyf-fill:before {
  content: "\\ea8f";
}

.ni-sad-fill:before {
  content: "\\eb65";
}

.ni-meh-fill:before {
  content: "\\eae4";
}

.ni-home:before {
  content: "\\ea9c";
}

.ni-home-alt:before {
  content: "\\ea9a";
}

.ni-home-fill:before {
  content: "\\ea9b";
}

.ni-img:before {
  content: "\\eaa0";
}

.ni-img-fill:before {
  content: "\\ea9f";
}

.ni-inbox:before {
  content: "\\eaa6";
}

.ni-inbox-in:before {
  content: "\\eaa3";
}

.ni-inbox-out:before {
  content: "\\eaa5";
}

.ni-inbox-fill:before {
  content: "\\eaa1";
}

.ni-inbox-in-fill:before {
  content: "\\eaa2";
}

.ni-inbox-out-fill:before {
  content: "\\eaa4";
}

.ni-link-group:before {
  content: "\\eac6";
}

.ni-lock:before {
  content: "\\ead7";
}

.ni-lock-alt:before {
  content: "\\ead5";
}

.ni-lock-fill:before {
  content: "\\ead6";
}

.ni-lock-alt-fill:before {
  content: "\\ead4";
}

.ni-unlock:before {
  content: "\\ec1a";
}

.ni-unlock-fill:before {
  content: "\\ec19";
}

.ni-mail:before {
  content: "\\eada";
}

.ni-emails:before {
  content: "\\ea2e";
}

.ni-mail-fill:before {
  content: "\\ead9";
}

.ni-emails-fill:before {
  content: "\\ea2d";
}

.ni-map-pin:before {
  content: "\\eadc";
}

.ni-location:before {
  content: "\\ead3";
}

.ni-map:before {
  content: "\\eadd";
}

.ni-map-pin-fill:before {
  content: "\\eadb";
}

.ni-list:before {
  content: "\\ead0";
}

.ni-list-ol:before {
  content: "\\eace";
}

.ni-align-center:before {
  content: "\\e911";
}

.ni-align-justify:before {
  content: "\\e912";
}

.ni-align-left:before {
  content: "\\e913";
}

.ni-align-right:before {
  content: "\\e914";
}

.ni-list-check:before {
  content: "\\eacc";
}

.ni-list-round:before {
  content: "\\eacf";
}

.ni-card-view:before {
  content: "\\e995";
}

.ni-list-fill:before {
  content: "\\eacd";
}

.ni-save:before {
  content: "\\eb68";
}

.ni-save-fill:before {
  content: "\\eb67";
}

.ni-move:before {
  content: "\\eb04";
}

.ni-scissor:before {
  content: "\\eb6b";
}

.ni-text:before {
  content: "\\ebf2";
}

.ni-text-a:before {
  content: "\\ebf0";
}

.ni-bold:before {
  content: "\\e96e";
}

.ni-italic:before {
  content: "\\eaad";
}

.ni-underline:before {
  content: "\\ec13";
}

.ni-percent:before {
  content: "\\eb2c";
}

.ni-at:before {
  content: "\\e952";
}

.ni-hash:before {
  content: "\\ea91";
}

.ni-code:before {
  content: "\\e9ee";
}

.ni-code-download:before {
  content: "\\e9ed";
}

.ni-terminal:before {
  content: "\\ebef";
}

.ni-cmd:before {
  content: "\\e9ec";
}

.ni-sun:before {
  content: "\\ebd9";
}

.ni-sun-fill:before {
  content: "\\ebd8";
}

.ni-moon-fill:before {
  content: "\\eafe";
}

.ni-moon:before {
  content: "\\eaff";
}

.ni-light:before {
  content: "\\eac1";
}

.ni-light-fill:before {
  content: "\\eac0";
}

.ni-more-v:before {
  content: "\\eb03";
}

.ni-more-h:before {
  content: "\\eb01";
}

.ni-more-h-alt:before {
  content: "\\eb00";
}

.ni-more-v-alt:before {
  content: "\\eb02";
}

.ni-music:before {
  content: "\\eb0a";
}

.ni-movie:before {
  content: "\\eb05";
}

.ni-offer:before {
  content: "\\eb18";
}

.ni-offer-fill:before {
  content: "\\eb17";
}

.ni-opt-alt:before {
  content: "\\eb1a";
}

.ni-opt:before {
  content: "\\eb1e";
}

.ni-opt-dot-alt:before {
  content: "\\eb1b";
}

.ni-opt-dot:before {
  content: "\\eb1d";
}

.ni-opt-dot-fill:before {
  content: "\\eb1c";
}

.ni-opt-alt-fill:before {
  content: "\\eb19";
}

.ni-user-alt:before {
  content: "\\ec24";
}

.ni-user-alt-fill:before {
  content: "\\ec23";
}

.ni-user:before {
  content: "\\ec33";
}

.ni-users:before {
  content: "\\ec35";
}

.ni-user-add:before {
  content: "\\ec22";
}

.ni-user-remove:before {
  content: "\\ec31";
}

.ni-user-check:before {
  content: "\\ec27";
}

.ni-user-cross:before {
  content: "\\ec2b";
}

.ni-account-setting:before {
  content: "\\e902";
}

.ni-account-setting-alt:before {
  content: "\\e900";
}

.ni-user-list:before {
  content: "\\ec2f";
}

.ni-user-fill:before {
  content: "\\ec2d";
}

.ni-users-fill:before {
  content: "\\ec34";
}

.ni-user-add-fill:before {
  content: "\\ec21";
}

.ni-user-remove-fill:before {
  content: "\\ec30";
}

.ni-user-check-fill:before {
  content: "\\ec26";
}

.ni-user-cross-fill:before {
  content: "\\ec2a";
}

.ni-account-setting-fill:before {
  content: "\\e901";
}

.ni-user-list-fill:before {
  content: "\\ec2e";
}

.ni-user-circle:before {
  content: "\\ec28";
}

.ni-user-circle-fill:before {
  content: "\\ec29";
}

.ni-user-c:before {
  content: "\\ec25";
}

.ni-user-fill-c:before {
  content: "\\ec2c";
}

.ni-user-round:before {
  content: "\\ec32";
}

.ni-printer:before {
  content: "\\eb31";
}

.ni-printer-fill:before {
  content: "\\eb48";
}

.ni-laptop:before {
  content: "\\eab6";
}

.ni-monitor:before {
  content: "\\eafd";
}

.ni-tablet:before {
  content: "\\ebe0";
}

.ni-mobile:before {
  content: "\\eafb";
}

.ni-undo:before {
  content: "\\ec14";
}

.ni-redo:before {
  content: "\\eb51";
}

.ni-reload-alt:before {
  content: "\\eb54";
}

.ni-reload:before {
  content: "\\eb55";
}

.ni-regen-alt:before {
  content: "\\eb52";
}

.ni-regen:before {
  content: "\\eb53";
}

.ni-invest:before {
  content: "\\eaac";
}

.ni-history:before {
  content: "\\ea99";
}

.ni-histroy:before {
  content: "\\ea99";
}

.ni-update:before {
  content: "\\ec1b";
}

.ni-repeat:before {
  content: "\\eb57";
}

.ni-repeat-v:before {
  content: "\\eb56";
}

.ni-tranx:before {
  content: "\\ec03";
}

.ni-reply-all:before {
  content: "\\eb59";
}

.ni-reply:before {
  content: "\\eb5b";
}

.ni-reply-fill:before {
  content: "\\eb5a";
}

.ni-reply-all-fill:before {
  content: "\\eb58";
}

.ni-notes:before {
  content: "\\eb15";
}

.ni-note-add:before {
  content: "\\eb13";
}

.ni-notes-alt:before {
  content: "\\eb14";
}

.ni-article:before {
  content: "\\e951";
}

.ni-text-rich:before {
  content: "\\ebf1";
}

.ni-todo:before {
  content: "\\ebfe";
}

.ni-report-profit:before {
  content: "\\eb5d";
}

.ni-reports-alt:before {
  content: "\\eb5f";
}

.ni-reports:before {
  content: "\\eb60";
}

.ni-task:before {
  content: "\\ebea";
}

.ni-note-add-c:before {
  content: "\\eb11";
}

.ni-task-c:before {
  content: "\\ebe8";
}

.ni-todo-fill:before {
  content: "\\ebfd";
}

.ni-note-add-fill-c:before {
  content: "\\eb12";
}

.ni-task-fill-c:before {
  content: "\\ebe9";
}

.ni-scan-fill:before {
  content: "\\eb69";
}

.ni-scan:before {
  content: "\\eb6a";
}

.ni-qr:before {
  content: "\\eb4a";
}

.ni-money:before {
  content: "\\eafc";
}

.ni-coins:before {
  content: "\\e9f4";
}

.ni-coin:before {
  content: "\\e9f3";
}

.ni-coin-alt:before {
  content: "\\e9f2";
}

.ni-coin-alt-fill:before {
  content: "\\e9f1";
}

.ni-setting-alt-fill:before {
  content: "\\eb72";
}

.ni-setting-alt:before {
  content: "\\eb73";
}

.ni-setting-fill:before {
  content: "\\eb74";
}

.ni-setting:before {
  content: "\\eb75";
}

.ni-share-alt:before {
  content: "\\eb76";
}

.ni-share-fill:before {
  content: "\\eb77";
}

.ni-share:before {
  content: "\\eb78";
}

.ni-network:before {
  content: "\\eb10";
}

.ni-rss:before {
  content: "\\eb64";
}

.ni-shield:before {
  content: "\\eb82";
}

.ni-shield-star:before {
  content: "\\eb81";
}

.ni-shield-check:before {
  content: "\\eb7c";
}

.ni-shield-alert:before {
  content: "\\eb7a";
}

.ni-shield-off:before {
  content: "\\eb7f";
}

.ni-security:before {
  content: "\\eb6d";
}

.ni-policy:before {
  content: "\\eb46";
}

.ni-shield-alert-fill:before {
  content: "\\eb79";
}

.ni-shield-check-fill:before {
  content: "\\eb7b";
}

.ni-shield-fill:before {
  content: "\\eb7d";
}

.ni-shield-half:before {
  content: "\\eb7e";
}

.ni-shield-star-fill:before {
  content: "\\eb80";
}

.ni-policy-fill:before {
  content: "\\eb45";
}

.ni-spark:before {
  content: "\\ebc4";
}

.ni-spark-off:before {
  content: "\\ebc3";
}

.ni-spark-fill:before {
  content: "\\ebc1";
}

.ni-spark-off-fill:before {
  content: "\\ebc2";
}

.ni-wallet:before {
  content: "\\ec47";
}

.ni-wallet-alt:before {
  content: "\\ec42";
}

.ni-wallet-in:before {
  content: "\\ec44";
}

.ni-wallet-out:before {
  content: "\\ec45";
}

.ni-wallet-saving:before {
  content: "\\ec46";
}

.ni-wallet-fill:before {
  content: "\\ec43";
}

.ni-star:before {
  content: "\\ebd0";
}

.ni-star-half:before {
  content: "\\ebce";
}

.ni-star-half-fill:before {
  content: "\\ebcd";
}

.ni-star-fill:before {
  content: "\\ebcc";
}

.ni-star-round:before {
  content: "\\ebcf";
}

.ni-heart:before {
  content: "\\ea95";
}

.ni-heart-fill:before {
  content: "\\ea94";
}

.ni-swap-alt-fill:before {
  content: "\\ebda";
}

.ni-swap-alt:before {
  content: "\\ebdb";
}

.ni-thumbs-down:before {
  content: "\\ebf3";
}

.ni-thumbs-up:before {
  content: "\\ebf4";
}

.ni-tag:before {
  content: "\\ebe4";
}

.ni-tag-alt:before {
  content: "\\ebe2";
}

.ni-tags:before {
  content: "\\ebe6";
}

.ni-tag-fill:before {
  content: "\\ebe3";
}

.ni-tag-alt-fill:before {
  content: "\\ebe1";
}

.ni-tags-fill:before {
  content: "\\ebe5";
}

.ni-bookmark:before {
  content: "\\e973";
}

.ni-bookmark-fill:before {
  content: "\\e972";
}

.ni-label:before {
  content: "\\eab5";
}

.ni-label-fill:before {
  content: "\\eab4";
}

.ni-priority:before {
  content: "\\eb36";
}

.ni-piority:before {
  content: "\\eb36";
}

.ni-priority-fill:before {
  content: "\\eb35";
}

.ni-piority-fill:before {
  content: "\\eb35";
}

.ni-label-alt:before {
  content: "\\eab3";
}

.ni-label-alt-fill:before {
  content: "\\eab2";
}

.ni-ticket-alt:before {
  content: "\\ebf6";
}

.ni-ticket:before {
  content: "\\ebfc";
}

.ni-ticket-minus:before {
  content: "\\ebf9";
}

.ni-ticket-plus:before {
  content: "\\ebfb";
}

.ni-ticket-alt-fill:before {
  content: "\\ebf5";
}

.ni-ticket-fill:before {
  content: "\\ebf7";
}

.ni-ticket-minus-fill:before {
  content: "\\ebf8";
}

.ni-ticket-plus-fill:before {
  content: "\\ebfa";
}

.ni-toggle-off:before {
  content: "\\ebff";
}

.ni-toggle-on:before {
  content: "\\ec00";
}

.ni-trash-alt:before {
  content: "\\ec04";
}

.ni-trash-empty:before {
  content: "\\ec06";
}

.ni-trash:before {
  content: "\\ec08";
}

.ni-trash-fill:before {
  content: "\\ec07";
}

.ni-trash-empty-fill:before {
  content: "\\ec05";
}

.ni-delete-fill:before {
  content: "\\ea17";
}

.ni-delete:before {
  content: "\\ea18";
}

.ni-alarm-alt:before {
  content: "\\e909";
}

.ni-alarm:before {
  content: "\\e90a";
}

.ni-bugs:before {
  content: "\\e97b";
}

.ni-building:before {
  content: "\\e97d";
}

.ni-building-fill:before {
  content: "\\e97c";
}

.ni-headphone:before {
  content: "\\ea93";
}

.ni-headphone-fill:before {
  content: "\\ea92";
}

.ni-aperture:before {
  content: "\\e91b";
}

.ni-help-alt:before {
  content: "\\ea96";
}

.ni-award:before {
  content: "\\e953";
}

.ni-briefcase:before {
  content: "\\e978";
}

.ni-gift:before {
  content: "\\ea6f";
}

.ni-globe:before {
  content: "\\ea74";
}

.ni-umbrela:before {
  content: "\\ec10";
}

.ni-truck:before {
  content: "\\ec0b";
}

.ni-sign-usd:before {
  content: "\\eba7";
}

.ni-sign-dollar:before {
  content: "\\eba7";
}

.ni-sign-mxn:before {
  content: "\\eb99";
}

.ni-sign-sgd:before {
  content: "\\eba0";
}

.ni-sign-euro:before {
  content: "\\eb94";
}

.ni-sign-eur:before {
  content: "\\eb94";
}

.ni-sign-gbp:before {
  content: "\\eb89";
}

.ni-sign-pound:before {
  content: "\\eb89";
}

.ni-sign-thb:before {
  content: "\\eba4";
}

.ni-sign-inr:before {
  content: "\\eb97";
}

.ni-sign-jpy:before {
  content: "\\eb98";
}

.ni-sign-yen:before {
  content: "\\eb98";
}

.ni-sign-cny:before {
  content: "\\eb8e";
}

.ni-sign-kobo:before {
  content: "\\eba1";
}

.ni-sign-chf:before {
  content: "\\eb8d";
}

.ni-sign-vnd:before {
  content: "\\ebaa";
}

.ni-sign-php:before {
  content: "\\eb9c";
}

.ni-sign-brl:before {
  content: "\\eb8b";
}

.ni-sign-idr:before {
  content: "\\eb96";
}

.ni-sign-czk:before {
  content: "\\eb8f";
}

.ni-sign-hkd:before {
  content: "\\eb95";
}

.ni-sign-kr:before {
  content: "\\eb9f";
}

.ni-sign-dkk:before {
  content: "\\eb9f";
}

.ni-sign-nok:before {
  content: "\\eb9f";
}

.ni-sign-sek:before {
  content: "\\eb9f";
}

.ni-sign-rub:before {
  content: "\\eb9e";
}

.ni-sign-myr:before {
  content: "\\eb9b";
}

.ni-sign-pln:before {
  content: "\\eb9d";
}

.ni-sign-try:before {
  content: "\\eba6";
}

.ni-sign-waves:before {
  content: "\\ebab";
}

.ni-waves:before {
  content: "\\ebab";
}

.ni-sign-trx:before {
  content: "\\eba5";
}

.ni-tron:before {
  content: "\\eba5";
}

.ni-sign-xem:before {
  content: "\\ebac";
}

.ni-nem:before {
  content: "\\ebac";
}

.ni-sign-mxr:before {
  content: "\\eb9a";
}

.ni-monero:before {
  content: "\\eb9a";
}

.ni-sign-usdc:before {
  content: "\\eba8";
}

.ni-sign-steller:before {
  content: "\\eba3";
}

.ni-sign-steem:before {
  content: "\\eba2";
}

.ni-sign-usdt:before {
  content: "\\eba9";
}

.ni-tether:before {
  content: "\\eba9";
}

.ni-sign-btc:before {
  content: "\\eb8c";
}

.ni-bitcoin:before {
  content: "\\eb8c";
}

.ni-sign-bch:before {
  content: "\\eb88";
}

.ni-bitcoin-cash:before {
  content: "\\eb88";
}

.ni-sign-bnb:before {
  content: "\\eb8a";
}

.ni-binance:before {
  content: "\\eb8a";
}

.ni-sign-ada:before {
  content: "\\eb87";
}

.ni-sign-zcash:before {
  content: "\\ebaf";
}

.ni-sign-eth:before {
  content: "\\eb93";
}

.ni-ethereum:before {
  content: "\\eb93";
}

.ni-sign-dash:before {
  content: "\\eb90";
}

.ni-dash:before {
  content: "\\eb90";
}

.ni-sign-xrp-old:before {
  content: "\\ebae";
}

.ni-ripple-old:before {
  content: "\\ebae";
}

.ni-sign-eos:before {
  content: "\\eb92";
}

.ni-eos:before {
  content: "\\eb92";
}

.ni-sign-xrp:before {
  content: "\\ebad";
}

.ni-ripple:before {
  content: "\\ebad";
}

.ni-american-express:before {
  content: "\\e918";
}

.ni-jcb:before {
  content: "\\eaae";
}

.ni-cc-jcb:before {
  content: "\\eaae";
}

.ni-mc:before {
  content: "\\eae0";
}

.ni-cc-mc:before {
  content: "\\eae0";
}

.ni-discover:before {
  content: "\\ea1a";
}

.ni-cc-discover:before {
  content: "\\ea1a";
}

.ni-visa:before {
  content: "\\ec3d";
}

.ni-cc-visa:before {
  content: "\\ec3d";
}

.ni-cc-paypal:before {
  content: "\\eb27";
}

.ni-cc-stripe:before {
  content: "\\e9ad";
}

.ni-amazon-pay:before {
  content: "\\e916";
}

.ni-amazon-pay-fill:before {
  content: "\\e915";
}

.ni-google-pay:before {
  content: "\\ea77";
}

.ni-google-pay-fill:before {
  content: "\\ea76";
}

.ni-apple-pay:before {
  content: "\\e91d";
}

.ni-apple-pay-fill:before {
  content: "\\e91c";
}

.ni-angular:before {
  content: "\\e91a";
}

.ni-react:before {
  content: "\\eb4d";
}

.ni-laravel:before {
  content: "\\eab7";
}

.ni-html5:before {
  content: "\\ea9e";
}

.ni-css3-fill:before {
  content: "\\ea09";
}

.ni-css3:before {
  content: "\\ea0a";
}

.ni-js:before {
  content: "\\eab0";
}

.ni-php:before {
  content: "\\eb2d";
}

.ni-python:before {
  content: "\\eb49";
}

.ni-bootstrap:before {
  content: "\\e974";
}

.ni-ebay:before {
  content: "\\ea27";
}

.ni-google-wallet:before {
  content: "\\ea79";
}

.ni-google-drive:before {
  content: "\\ea75";
}

.ni-google-play-store:before {
  content: "\\ea78";
}

.ni-android:before {
  content: "\\e919";
}

.ni-blogger-fill:before {
  content: "\\e96b";
}

.ni-blogger:before {
  content: "\\e96c";
}

.ni-hangout:before {
  content: "\\ea8d";
}

.ni-apple-store:before {
  content: "\\e91f";
}

.ni-apple-store-ios:before {
  content: "\\e91e";
}

.ni-stripe:before {
  content: "\\ebd7";
}

.ni-apple:before {
  content: "\\e920";
}

.ni-microsoft:before {
  content: "\\eaf0";
}

.ni-windows:before {
  content: "\\ec4c";
}

.ni-amazon:before {
  content: "\\e917";
}

.ni-paypal-alt:before {
  content: "\\eb28";
}

.ni-airbnb:before {
  content: "\\e908";
}

.ni-adobe:before {
  content: "\\e907";
}

.ni-mailchimp:before {
  content: "\\ead8";
}

.ni-dropbox:before {
  content: "\\ea26";
}

.ni-digital-ocean:before {
  content: "\\ea19";
}

.ni-slack:before {
  content: "\\ebb5";
}

.ni-slack-hash:before {
  content: "\\ebb4";
}

.ni-stack-overflow:before {
  content: "\\ebcb";
}

.ni-soundcloud:before {
  content: "\\ebc0";
}

.ni-blackberry:before {
  content: "\\e966";
}

.ni-spotify:before {
  content: "\\ebc6";
}

.ni-kickstarter:before {
  content: "\\eab1";
}

.ni-houzz:before {
  content: "\\ea9d";
}

.ni-vine:before {
  content: "\\ec3c";
}

.ni-yelp:before {
  content: "\\ec4f";
}

.ni-yoast:before {
  content: "\\ec50";
}

.ni-envato:before {
  content: "\\ea2f";
}

.ni-wordpress:before {
  content: "\\ec4e";
}

.ni-wp:before {
  content: "\\ec4e";
}

.ni-wordpress-fill:before {
  content: "\\ec4d";
}

.ni-elementor:before {
  content: "\\ea2c";
}

.ni-joomla:before {
  content: "\\eaaf";
}

.ni-megento:before {
  content: "\\eae3";
}

.ni-git:before {
  content: "\\ea70";
}

.ni-github:before {
  content: "\\ea73";
}

.ni-github-round:before {
  content: "\\ea72";
}

.ni-github-circle:before {
  content: "\\ea71";
}

.ni-dribbble:before {
  content: "\\ea25";
}

.ni-dribbble-round:before {
  content: "\\ea24";
}

.ni-behance:before {
  content: "\\e961";
}

.ni-behance-fill:before {
  content: "\\e960";
}

.ni-flickr:before {
  content: "\\ea5d";
}

.ni-flickr-round:before {
  content: "\\ea5c";
}

.ni-medium:before {
  content: "\\eae2";
}

.ni-medium-round:before {
  content: "\\eae1";
}

.ni-reddit:before {
  content: "\\eb50";
}

.ni-reddit-round:before {
  content: "\\eb4f";
}

.ni-reddit-circle:before {
  content: "\\eb4e";
}

.ni-google:before {
  content: "\\ea7a";
}

.ni-facebook-f:before {
  content: "\\ea3e";
}

.ni-facebook-fill:before {
  content: "\\ea3f";
}

.ni-facebook-circle:before {
  content: "\\ea3d";
}

.ni-instagram:before {
  content: "\\eaab";
}

.ni-instagram-round:before {
  content: "\\eaaa";
}

.ni-linkedin:before {
  content: "\\eacb";
}

.ni-linkedin-round:before {
  content: "\\eaca";
}

.ni-twitter:before {
  content: "\\ec0f";
}

.ni-twitter-round:before {
  content: "\\ec0e";
}

.ni-pinterest:before {
  content: "\\eb34";
}

.ni-pinterest-round:before {
  content: "\\eb33";
}

.ni-pinterest-circle:before {
  content: "\\eb32";
}

.ni-tumblr:before {
  content: "\\ec0d";
}

.ni-tumblr-round:before {
  content: "\\ec0c";
}

.ni-skype:before {
  content: "\\ebb3";
}

.ni-viber:before {
  content: "\\ec36";
}

.ni-whatsapp:before {
  content: "\\ec49";
}

.ni-whatsapp-round:before {
  content: "\\ec48";
}

.ni-snapchat:before {
  content: "\\ebb7";
}

.ni-snapchat-fill:before {
  content: "\\ebb6";
}

.ni-telegram:before {
  content: "\\ebec";
}

.ni-telegram-circle:before {
  content: "\\ebeb";
}

.ni-youtube-line:before {
  content: "\\ec52";
}

.ni-youtube:before {
  content: "\\ec52";
}

.ni-youtube-fill:before {
  content: "\\ec53";
}

.ni-youtube-round:before {
  content: "\\ec51";
}

.ni-vimeo:before {
  content: "\\ec3b";
}

.ni-vimeo-fill:before {
  content: "\\ec3a";
}

.com {
  color: #93a1a1;
}

.lit {
  color: #195f91;
}

.pun, .opn, .clo {
  color: #93a1a1;
}

.fun {
  color: #dc322f;
}

.str, .atv {
  color: #D14;
}

.kwd, .linenums .tag {
  color: #1e347b;
}

.typ, .atn, .dec, .var {
  color: teal;
}

.pln {
  color: #48484c;
}

.prettyprint {
  padding: 8px;
  background-color: #f7f7f9;
  border: 1px solid #e1e1e8;
}

.prettyprint.linenums {
  box-shadow: inset 40px 0 0 #fbfbfc, inset 41px 0 0 #ececf0;
}

/* Specify class=linenums on a pre to get line numbering */
ol.linenums {
  margin: 0 0 0 33px;
}

ol.linenums li {
  padding-left: 12px;
  color: #bebec5;
  line-height: 18px;
  text-shadow: 0 1px 0 #fff;
}

.dnd-handle {
  display: flex;
}
.dnd-handle .handle {
  position: relative;
  font-size: 1.125rem;
  cursor: move;
  height: 1.25rem;
  width: 1.25rem;
  margin-right: 0.5rem;
}
.dnd-handle .handle:after {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  font-family: "Nioicon";
  content: "\\eb04";
  font-size: 1rem;
}

/** SimpleBar.js - v5.1.0 | License MIT License  */
[data-simplebar] {
  position: relative;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
}

.simplebar-wrapper {
  overflow: hidden;
  width: inherit;
  height: inherit;
  max-width: inherit;
  max-height: inherit;
}

.simplebar-mask {
  direction: inherit;
  position: absolute;
  overflow: hidden;
  padding: 0;
  margin: 0;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: auto !important;
  height: auto !important;
  z-index: 0;
}

.simplebar-offset {
  direction: inherit !important;
  box-sizing: inherit !important;
  resize: none !important;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 0;
  margin: 0;
  -webkit-overflow-scrolling: touch;
}

.simplebar-content-wrapper, .simplebar-scroll-content {
  direction: inherit;
  box-sizing: border-box !important;
  position: relative;
  display: block;
  height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */
  width: auto;
  visibility: visible;
  max-width: 100%; /* Not required for horizontal scroll to trigger */
  max-height: 100%; /* Needed for vertical scroll to trigger */
  scrollbar-width: none;
  -ms-overflow-style: none;
  overflow: hidden scroll;
}

.simplebar-content-wrapper::-webkit-scrollbar, .simplebar-scroll-content::-webkit-scrollbar,
.simplebar-hide-scrollbar::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.simplebar-content:before,
.simplebar-content:after {
  content: " ";
  display: table;
}

.simplebar-placeholder {
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  pointer-events: none;
}

.simplebar-height-auto-observer-wrapper {
  box-sizing: inherit !important;
  height: 100%;
  width: 100%;
  max-width: 1px;
  position: relative;
  float: left;
  max-height: 1px;
  overflow: hidden;
  z-index: -1;
  padding: 0;
  margin: 0;
  pointer-events: none;
  flex-grow: inherit;
  flex-shrink: 0;
  flex-basis: 0;
}

.simplebar-height-auto-observer {
  box-sizing: inherit;
  display: block;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 1000%;
  width: 1000%;
  min-height: 1px;
  min-width: 1px;
  overflow: hidden;
  pointer-events: none;
  z-index: -1;
}

.simplebar-track {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}

[data-simplebar].simplebar-dragging .simplebar-content {
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
}

[data-simplebar].simplebar-dragging .simplebar-track {
  pointer-events: all;
}

.simplebar-scrollbar {
  position: absolute;
  left: 0;
  right: 0;
  min-height: 10px;
}
.simplebar-scrollbar .hidden-scrollbar {
  visibility: hidden;
}

.simplebar-scrollbar:before {
  position: absolute;
  content: "";
  background: #8094ae;
  border-radius: 7px;
  left: 2px;
  right: 2px;
  opacity: 0;
  transition: opacity 0.2s linear;
}

.simplebar-scrollbar.simplebar-visible:before {
  /* When hovered, remove all transitions from drag handle */
  opacity: 0.5;
  transition: opacity 0s linear;
}

.simplebar-track.simplebar-vertical {
  top: 0;
  width: 8px !important;
  transition: width 0.1s;
}
.simplebar-track.simplebar-vertical.simplebar-hover {
  width: 10px !important;
}
.simplebar-track.simplebar-vertical .nk-sidebar {
  visibility: hidden !important;
}

.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
  top: 2px;
  bottom: 2px;
}

.simplebar-track.simplebar-horizontal {
  left: 0;
  height: 8px !important;
  transition: height 0.1s;
}
.simplebar-track.simplebar-horizontal.simplebar-hover {
  height: 10px !important;
}
.nk-sidebar .simplebar-track.simplebar-horizontal, .nk-sidebar-fat .simplebar-track.simplebar-horizontal, .nk-apps-sidebar .simplebar-track.simplebar-horizontal {
  visibility: hidden !important;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {
  height: 100%;
  left: 2px;
  right: 2px;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar {
  right: auto;
  left: 0;
  top: 2px;
  height: 7px;
  min-height: 0;
  min-width: 10px;
  width: auto;
}

/* Rtl support */
[data-simplebar-direction=rtl] .simplebar-track.simplebar-vertical {
  right: auto;
  left: 0;
}

.hs-dummy-scrollbar-size {
  direction: rtl;
  position: fixed;
  opacity: 0;
  visibility: hidden;
  height: 500px;
  width: 500px;
  overflow-y: hidden;
  overflow-x: scroll;
}

.simplebar-hide-scrollbar {
  position: fixed;
  left: 0;
  visibility: hidden;
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

/** Slick Slider */
.slick-slider {
  position: relative;
  display: block;
  box-sizing: border-box;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  touch-action: pan-y;
  -webkit-tap-highlight-color: transparent;
}

.slick-list {
  position: relative;
  overflow: hidden;
  display: block;
  margin: 0;
  padding: 0;
}
.slick-list:focus {
  outline: none;
}
.slick-list.dragging {
  cursor: pointer;
  cursor: hand;
}

.slick-slider .slick-track,
.slick-slider .slick-list {
  transform: translate3d(0, 0, 0);
}

.slick-track {
  position: relative;
  left: 0;
  top: 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.slick-track:before, .slick-track:after {
  content: "";
  display: table;
}
.slick-track:after {
  clear: both;
}
.slick-loading .slick-track {
  visibility: hidden;
}

.slick-slide {
  float: left;
  height: 100%;
  min-height: 1px;
  display: none;
}
.slick-slide img {
  display: block;
}
.slick-slide.slick-loading img {
  display: none;
}
.slick-slide.dragging img {
  pointer-events: none;
}
.slick-initialized .slick-slide {
  display: block;
}
.slick-loading .slick-slide {
  visibility: hidden;
}
.slick-vertical .slick-slide {
  display: block;
  height: auto;
  border: 1px solid transparent;
}
.slick-slide:focus {
  outline: none;
  border: none;
}

.slick-arrow.slick-hidden {
  display: none;
}

.slick-dots {
  display: flex !important;
  justify-content: center;
  padding-top: 1.5rem;
}
.slick-dots li {
  display: inline-flex;
  padding: 0 6px;
}
.slick-dots li button {
  background-color: #dbdfea;
  border: none;
  border-radius: 20px;
  text-indent: -99999px;
  height: 8px;
  width: 8px;
  padding: 0;
  overflow: hidden;
  transition: all 0.4s linear;
}
.slick-dots li button:focus {
  outline: none;
}
.slick-dots li.slick-active button {
  background-color: #8094ae;
}

.slick-next, .slick-prev {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  height: 44px;
  width: 44px;
  z-index: 9;
  font-size: 24px;
  color: #8094ae;
  background: #fff;
  transition: all 0.4s linear;
  border: 1px solid #e5e9f2;
}
.slick-next:hover, .slick-prev:hover {
  color: #526484;
  background: #f5f6fa;
  border-color: #dbdfea;
  opacity: 1;
}
.slick-disabled .slick-next, .slick-disabled .slick-prev {
  cursor: default;
  color: #dbdfea;
}
.slick-disabled .slick-next:hover, .slick-disabled .slick-prev:hover {
  color: #dbdfea;
  background: #fff;
  border-color: #e5e9f2;
}

.slick-next {
  right: -10px;
}

.slick-prev {
  left: -10px;
}

/* The MIT License Copyright (c) 2012 Matias Meno <m@tias.me> */
@keyframes passing-through {
  0% {
    opacity: 0;
    transform: translateY(40px);
  }
  30%, 70% {
    opacity: 1;
    transform: translateY(0px);
  }
  100% {
    opacity: 0;
    transform: translateY(-40px);
  }
}
@keyframes slide-in {
  0% {
    opacity: 0;
    transform: translateY(40px);
  }
  30% {
    opacity: 1;
    transform: translateY(0px);
  }
}
@keyframes pulse {
  0% {
    transform: scale(1);
  }
  10% {
    transform: scale(1.1);
  }
  20% {
    transform: scale(1);
  }
}
.dropzone,
.dropzone * {
  box-sizing: border-box;
}

.dropzone {
  min-height: 150px;
  border: 1px dashed #e5e9f2;
  border-radius: 4px;
  background: white;
  padding: 20px 20px;
}
.dropzone.small {
  min-height: 86px;
}
.dropzone.custom {
  min-height: 1rem !important;
  padding: 5px 10px;
}

.dropzone.dz-clickable {
  cursor: pointer;
}

.dropzone.dz-clickable * {
  cursor: default;
}

.dropzone.dz-clickable .dz-message,
.dropzone.dz-clickable .dz-message * {
  cursor: pointer;
}

.dropzone.dz-started .dz-message {
  display: none;
}

.dropzone.dz-drag-hover {
  border-style: solid;
}

.dropzone.dz-drag-hover .dz-message {
  opacity: 0.5;
}

.dropzone .dz-message {
  text-align: center;
  margin: 1em 0;
}
.dropzone .dz-message span {
  display: block;
  color: rgba(82, 100, 132, 0.6);
}
.dropzone .dz-message-text {
  font-size: 13px;
}
.dropzone .dz-message-text span {
  display: inline-block;
  color: #4461F2;
}
.dropzone .dz-message-or {
  font-size: 16px;
  margin-bottom: 4px;
  text-transform: uppercase;
}

.dropzone .dz-preview {
  position: relative;
  display: inline-block;
  vertical-align: top;
  margin: 16px;
  min-height: 100px;
}

.dropzone .dz-preview:hover {
  z-index: 1000;
}

.dropzone .dz-preview:hover .dz-details {
  opacity: 1;
}

.dropzone .dz-preview.dz-file-preview .dz-image {
  border-radius: 20px;
  background: #999;
  background: linear-gradient(to bottom, #eee, #ddd);
}

.dropzone .dz-preview.dz-file-preview .dz-details {
  opacity: 1;
}

.dropzone .dz-preview.dz-image-preview {
  background: white;
}

.dropzone .dz-preview.dz-image-preview .dz-details {
  transition: opacity 0.2s linear;
}

.dropzone .dz-preview .dz-remove {
  font-size: 14px;
  text-align: center;
  display: block;
  cursor: pointer;
  border: none;
}

.dropzone .dz-preview .dz-remove:hover {
  text-decoration: underline;
}

.dropzone .dz-preview:hover .dz-details {
  opacity: 1;
}

.dropzone .dz-preview .dz-details {
  z-index: 20;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  font-size: 13px;
  min-width: 100%;
  max-width: 100%;
  padding: 2em 1em;
  text-align: center;
  color: rgba(0, 0, 0, 0.9);
  line-height: 150%;
}

.dropzone .dz-preview .dz-details .dz-size {
  margin-bottom: 1em;
  font-size: 16px;
}

.dropzone .dz-preview .dz-details .dz-filename {
  white-space: nowrap;
}

.dropzone .dz-preview .dz-details .dz-filename:hover span {
  border: 1px solid rgba(200, 200, 200, 0.8);
  background-color: rgba(255, 255, 255, 0.8);
}

.dropzone .dz-preview .dz-details .dz-filename:not(:hover) {
  overflow: hidden;
  text-overflow: ellipsis;
}

.dropzone .dz-preview .dz-details .dz-filename:not(:hover) span {
  border: 1px solid transparent;
}

.dropzone .dz-preview .dz-details .dz-filename span,
.dropzone .dz-preview .dz-details .dz-size span {
  background-color: rgba(255, 255, 255, 0.4);
  padding: 0 0.4em;
  border-radius: 3px;
}

.dropzone .dz-preview:hover .dz-image img {
  transform: scale(1.05, 1.05);
  filter: blur(8px);
}

.dropzone .dz-preview .dz-image {
  border-radius: 20px;
  overflow: hidden;
  width: 120px;
  height: 120px;
  position: relative;
  display: block;
  z-index: 10;
}

.dropzone .dz-preview .dz-image img {
  display: block;
}

.dropzone .dz-preview.dz-success .dz-success-mark {
  animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);
}

.dropzone .dz-preview.dz-error .dz-error-mark {
  opacity: 1;
  animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);
}

.dropzone .dz-preview .dz-success-mark,
.dropzone .dz-preview .dz-error-mark {
  pointer-events: none;
  opacity: 0;
  z-index: 500;
  position: absolute;
  display: block;
  top: 50%;
  left: 50%;
  margin-left: -27px;
  margin-top: -27px;
}

.dropzone .dz-preview .dz-success-mark svg,
.dropzone .dz-preview .dz-error-mark svg {
  display: block;
  width: 54px;
  height: 54px;
}

.dropzone .dz-preview.dz-processing .dz-progress {
  opacity: 1;
  transition: all 0.2s linear;
}

.dropzone .dz-preview.dz-complete .dz-progress {
  opacity: 0;
  transition: opacity 0.4s ease-in;
}

.dropzone .dz-preview:not(.dz-processing) .dz-progress {
  animation: pulse 6s ease infinite;
}

.dropzone .dz-preview .dz-progress {
  opacity: 1;
  z-index: 1000;
  pointer-events: none;
  position: absolute;
  height: 16px;
  left: 50%;
  top: 50%;
  margin-top: -8px;
  width: 80px;
  margin-left: -40px;
  background: rgba(255, 255, 255, 0.9);
  -webkit-transform: scale(1);
  border-radius: 8px;
  overflow: hidden;
}

.dropzone .dz-preview .dz-progress .dz-upload {
  background: #333;
  background: linear-gradient(to bottom, #666, #444);
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 0;
  transition: width 300ms ease-in-out;
}

.dropzone .dz-preview.dz-error .dz-error-message {
  display: block;
}

.dropzone .dz-preview.dz-error:hover .dz-error-message {
  opacity: 1;
  pointer-events: auto;
}

.dropzone .dz-preview .dz-error-message {
  pointer-events: none;
  z-index: 1000;
  position: absolute;
  display: block;
  display: none;
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 8px;
  font-size: 13px;
  top: 130px;
  left: -10px;
  width: 140px;
  background: #be2626;
  background: linear-gradient(to bottom, #be2626, #a92222);
  padding: 0.5em 1.2em;
  color: white;
}

.dropzone .dz-preview .dz-error-message:after {
  content: "";
  position: absolute;
  top: -6px;
  left: 64px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #be2626;
}

table.dataTable {
  clear: both;
  max-width: none !important;
  border-collapse: separate !important;
  border-spacing: 0;
}

table.dataTable td.dataTables_empty,
table.dataTable th.dataTables_empty {
  text-align: center;
}

table.dataTable.nowrap th,
table.dataTable.nowrap td {
  white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_length label {
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_length select {
  width: auto;
  display: inline-block;
}

div.dataTables_wrapper div.dataTables_length label {
  display: inline-flex;
  align-items: center;
}

div.dataTables_wrapper div.dataTables_length span {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

div.dataTables_wrapper div.dataTables_filter label {
  font-weight: normal;
  white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_filter input {
  display: inline-block;
}

div.dataTables_wrapper div.dataTables_info {
  padding: 0.5rem 0;
  white-space: nowrap;
  font-size: 0.75rem;
}

div.dataTables_wrapper div.dataTables_paginate {
  margin: 0;
  white-space: nowrap;
  text-align: right;
}

div.dataTables_wrapper div.dataTables_paginate ul.pagination {
  margin: 2px 0;
  justify-content: center;
}

div.dataTables_wrapper div.dataTables_processing {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -100px;
  width: 200px;
  margin-top: -26px;
  text-align: center;
  padding: 1em 0;
}

div.dataTables_wrapper label {
  margin-bottom: 0;
}

table.dataTable thead > tr > th.sorting_asc, table.dataTable thead > tr > th.sorting_desc, table.dataTable thead > tr > th.sorting,
table.dataTable thead > tr > td.sorting_asc,
table.dataTable thead > tr > td.sorting_desc,
table.dataTable thead > tr > td.sorting {
  padding-right: 30px;
}

table.dataTable thead > tr > th:active,
table.dataTable thead > tr > td:active {
  outline: none;
}

table.dataTable thead .sorting,
table.dataTable thead .sorting_asc,
table.dataTable thead .sorting_desc,
table.dataTable thead .sorting_asc_disabled,
table.dataTable thead .sorting_desc_disabled {
  cursor: pointer;
  position: relative;
}

table.dataTable thead .sorting:before, table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:before,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc_disabled:before,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:before,
table.dataTable thead .sorting_desc_disabled:after {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: block;
  opacity: 0.3;
}

table.dataTable thead .sorting:before,
table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_desc:before,
table.dataTable thead .sorting_asc_disabled:before,
table.dataTable thead .sorting_desc_disabled:before {
  right: 1em;
  content: "↑";
}

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:after {
  right: 0.5em;
  content: "↓";
}

table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_desc:after {
  opacity: 1;
}

table.dataTable thead .sorting_asc_disabled:before,
table.dataTable thead .sorting_desc_disabled:after {
  opacity: 0;
}

div.dataTables_scrollHead table.dataTable {
  margin-bottom: 0 !important;
}

div.dataTables_scrollBody table {
  border-top: none;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

div.dataTables_scrollBody table thead .sorting:before,
div.dataTables_scrollBody table thead .sorting_asc:before,
div.dataTables_scrollBody table thead .sorting_desc:before,
div.dataTables_scrollBody table thead .sorting:after,
div.dataTables_scrollBody table thead .sorting_asc:after,
div.dataTables_scrollBody table thead .sorting_desc:after {
  display: none;
}

div.dataTables_scrollBody table tbody tr:first-child th,
div.dataTables_scrollBody table tbody tr:first-child td {
  border-top: none;
}

div.dataTables_scrollFoot > .dataTables_scrollFootInner {
  box-sizing: content-box;
}

div.dataTables_scrollFoot > .dataTables_scrollFootInner > table {
  margin-top: 0 !important;
  border-top: none;
}

@media screen and (max-width: 767px) {
  div.dataTables_wrapper div.dataTables_info,
  div.dataTables_wrapper div.dataTables_paginate {
    text-align: center;
  }
}
table.dataTable.table-sm > thead > tr > th {
  padding-right: 20px;
}

table.dataTable.table-sm .sorting:before,
table.dataTable.table-sm .sorting_asc:before,
table.dataTable.table-sm .sorting_desc:before {
  top: 5px;
  right: 0.85em;
}

table.dataTable.table-sm .sorting:after,
table.dataTable.table-sm .sorting_asc:after,
table.dataTable.table-sm .sorting_desc:after {
  top: 5px;
}

table.table-bordered.dataTable th,
table.table-bordered.dataTable td {
  border-left-width: 0;
}

table.table-bordered.dataTable th:last-child, table.table-bordered.dataTable th:last-child,
table.table-bordered.dataTable td:last-child,
table.table-bordered.dataTable td:last-child {
  border-right-width: 0;
}

table.table-bordered.dataTable tbody th,
table.table-bordered.dataTable tbody td {
  border-bottom-width: 0;
}

div.dataTables_scrollHead table.table-bordered {
  border-bottom-width: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row {
  margin: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row > div[class^=col-]:first-child {
  padding-left: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row > div[class^=col-]:last-child {
  padding-right: 0;
}

@media (min-width: 768px) {
  div.dataTables_wrapper div.dataTables_paginate ul.pagination {
    justify-content: flex-start;
  }
}
table.dataTable.dtr-inline.collapsed > tbody > tr:not(.child) > td:first-child,
table.dataTable.dtr-inline.collapsed > tbody > tr:not(.child) > th:first-child {
  cursor: pointer;
}
table.dataTable.dtr-inline.collapsed > tbody > tr:not(.child) > td:first-child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr:not(.child) > th:first-child:before {
  content: "\\eb43";
  font-family: "Nioicon";
  margin-right: 0.4rem;
}

table.dataTable.dtr-inline.collapsed > tbody > tr.parent > td:first-child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr.parent > th:first-child:before {
  content: "\\eaf9";
}

@media (max-width: 575px) {
  div.dataTables_wrapper div.dataTables_paginate ul.pagination {
    justify-content: flex-start;
  }
  div.dataTables_wrapper div.dataTables_paginate ul.pagination li:not(.previous):not(.next) {
    display: none;
  }
  div.dataTables_wrapper div.dataTables_paginate ul.pagination .page-link {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  div.dataTables_wrapper div.dataTables_info {
    text-align: right !important;
  }
}
.dataTable td:focus {
  outline: none;
}

.datatable-wrap {
  border: 1px solid #e5e9f2;
  border-radius: 4px;
}

.dtr-details {
  padding-left: 0.25rem;
}
.dtr-details .dtr-title {
  font-weight: 700;
  margin-right: 0.25rem;
}

.nk-tb-col-check, .nk-tb-col-tools {
  pointer-events: none;
}
.nk-tb-col-check > *, .nk-tb-col-tools > * {
  pointer-events: auto;
}
.nk-tb-col-check:before, .nk-tb-col-check:after, .nk-tb-col-tools:before, .nk-tb-col-tools:after {
  display: none !important;
}

.nk-tb-col-check {
  padding-right: 0.5rem !important;
}

@keyframes dtb-spinner {
  100% {
    transform: rotate(360deg);
  }
}
div.dt-button-info {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 400px;
  margin-top: -100px;
  margin-left: -200px;
  background-color: #f5f6fa;
  box-shadow: 0 0 0 200vh rgba(31, 43, 58, 0.3);
  border-radius: 4px;
  text-align: center;
  z-index: 2020;
  overflow: hidden;
  border: 1px solid #e5e9f2;
}

div.dt-button-info h2 {
  padding: 2rem;
  margin: 0;
  font-weight: normal;
  border-bottom: 1px solid #e5e9f2;
  background-color: #fff;
  font-size: 1.75rem;
}

div.dt-button-info > div {
  padding: 1.25rem;
}

div.dt-button-collection-title {
  text-align: center;
  padding: 0.3em 0 0.5em;
  font-size: 0.9em;
}

div.dt-button-collection-title:empty {
  display: none;
}

div.dt-button-collection {
  position: absolute;
  z-index: 1000;
  width: 100%;
}

div.dt-button-collection div.dropdown-menu {
  display: block;
  z-index: 1001;
  min-width: 100px;
  top: 10px;
}
.dropdown-position-right div.dt-button-collection div.dropdown-menu {
  right: 0;
  left: auto;
}

div.dt-button-collection div.dt-button-collection-title {
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.15);
}

div.dt-button-collection.fixed {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: -75px;
  border-radius: 0;
}

div.dt-button-collection.fixed.two-column {
  margin-left: -200px;
}

div.dt-button-collection.fixed.three-column {
  margin-left: -225px;
}

div.dt-button-collection.fixed.four-column {
  margin-left: -300px;
}

div.dt-button-collection > :last-child {
  display: block !important;
  -ms-column-gap: 8px;
  -o-column-gap: 8px;
  column-gap: 8px;
}

div.dt-button-collection > :last-child > * {
  page-break-inside: avoid;
  break-inside: avoid;
}

div.dt-button-collection.two-column {
  width: 400px;
}

div.dt-button-collection.two-column > :last-child {
  padding-bottom: 1px;
  -ms-column-count: 2;
  -o-column-count: 2;
  column-count: 2;
}

div.dt-button-collection.three-column {
  width: 450px;
}

div.dt-button-collection.three-column > :last-child {
  padding-bottom: 1px;
  -ms-column-count: 3;
  -o-column-count: 3;
  column-count: 3;
}

div.dt-button-collection.four-column {
  width: 600px;
}

div.dt-button-collection.four-column > :last-child {
  padding-bottom: 1px;
  -ms-column-count: 4;
  -o-column-count: 4;
  column-count: 4;
}

div.dt-button-collection .dt-button {
  border-radius: 0;
}

div.dt-button-collection.fixed {
  max-width: none;
}

div.dt-button-collection.fixed:before, div.dt-button-collection.fixed:after {
  display: none;
}

div.dt-button-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background-color: rgba(31, 43, 58, 0.3);
  display: none !important;
}

@media screen and (max-width: 767px) {
  div.dt-buttons {
    float: none;
    width: 100%;
    text-align: center;
    margin-bottom: 0.5em;
  }
  div.dt-buttons a.btn, div.dt-buttons .dual-listbox a.dual-listbox__button, .dual-listbox div.dt-buttons a.dual-listbox__button {
    float: none;
  }
}
div.dt-buttons button.btn.processing, div.dt-buttons .dual-listbox button.processing.dual-listbox__button, .dual-listbox div.dt-buttons button.processing.dual-listbox__button,
div.dt-buttons div.btn.processing,
div.dt-buttons .dual-listbox div.processing.dual-listbox__button,
.dual-listbox div.dt-buttons div.processing.dual-listbox__button,
div.dt-buttons a.btn.processing,
div.dt-buttons .dual-listbox a.processing.dual-listbox__button,
.dual-listbox div.dt-buttons a.processing.dual-listbox__button {
  color: rgba(0, 0, 0, 0.2);
}

div.dt-buttons button.btn.processing:after, div.dt-buttons .dual-listbox button.processing.dual-listbox__button:after, .dual-listbox div.dt-buttons button.processing.dual-listbox__button:after,
div.dt-buttons div.btn.processing:after,
div.dt-buttons .dual-listbox div.processing.dual-listbox__button:after,
.dual-listbox div.dt-buttons div.processing.dual-listbox__button:after,
div.dt-buttons a.btn.processing:after,
div.dt-buttons .dual-listbox a.processing.dual-listbox__button:after,
.dual-listbox div.dt-buttons a.processing.dual-listbox__button:after {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 16px;
  height: 16px;
  margin: -8px 0 0 -8px;
  box-sizing: border-box;
  display: block;
  content: " ";
  border: 2px solid #282828;
  border-radius: 50%;
  border-left-color: transparent;
  border-right-color: transparent;
  animation: dtb-spinner 1500ms infinite linear;
  -o-animation: dtb-spinner 1500ms infinite linear;
  -ms-animation: dtb-spinner 1500ms infinite linear;
  -webkit-animation: dtb-spinner 1500ms infinite linear;
  -moz-animation: dtb-spinner 1500ms infinite linear;
}

.dt-buttons .btn-secondary span {
  display: none;
}
.dt-buttons .btn-secondary:before {
  font-size: 1.125rem;
  font-weight: normal;
  font-style: normal;
  width: 2.125rem;
  font-family: "Nioicon";
}

.dt-export-title {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.buttons-copy:before {
  content: "\\e9fb";
}
.buttons-pdf:before {
  content: "\\ea4a";
}
.buttons-excel:before {
  content: "\\ea51";
}
.buttons-csv:before {
  content: "\\ea50";
}
.buttons-print:before {
  content: "\\eb31";
}
.buttons-colvis:before {
  content: "\\ecc5";
}
.buttons-columnVisibility {
  position: relative;
  padding-right: 42px;
  font-size: 12px;
  font-weight: 500;
  color: #526484;
  transition: all 0.4s;
}
.buttons-columnVisibility.active:not(:hover) {
  color: #526484;
  background-color: transparent;
}
.buttons-columnVisibility.active:after {
  content: "\\e9be";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 1rem;
  font-family: "Nioicon";
}

@media (max-width: 600px) {
  .with-export > .col-5, .with-export > .col-7, .with-export > .col-sm-4, .with-export > .col-sm-8 {
    width: 100% !important;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .with-export .datatable-filter .justify-content-end, .with-export .datatable-filter .justify-end {
    justify-content: space-between !important;
  }
  .with-export .dataTables_filter label {
    display: block;
  }
  .with-export .dataTables_filter .form-control, .with-export .dataTables_filter .rdl-filter, .with-export .dataTables_filter .dual-listbox .dual-listbox__search, .dual-listbox .with-export .dataTables_filter .dual-listbox__search, .with-export div.dataTables_wrapper div.dataTables_filter input, div.dataTables_wrapper .with-export div.dataTables_filter input {
    width: 100% !important;
  }
}
.rdt_Table {
  margin: 1rem 0px;
  border: 1px solid #e5e9f2;
  border-radius: 4px;
  background: #fff;
}

.rdt_TableHeadRow {
  min-height: 40px !important;
  background: #fff;
}

.rdt_TableCol > input[type=checkbox] {
  margin-left: 10px;
}

.rdt_TableCol {
  padding-right: 10px !important;
  color: #526484 !important;
  font-weight: bold !important;
  font-size: 0.9rem !important;
}
.rdt_TableCol .rdt_TableCol_Sortable {
  display: flex;
  flex-direction: row;
  justify-content: space-between !important;
}
.rdt_TableCol .rdt_TableCol_Sortable:hover, .rdt_TableCol .rdt_TableCol_Sortable:focus {
  opacity: 1 !important;
}
.rdt_TableCol:last-child {
  padding-right: 10px !important;
}

.rdt_TableRow {
  color: #526484 !important;
  font-size: 0.875rem !important;
  font-weight: 400 !important;
  line-height: 1.65 !important;
}

.dtr-details {
  color: #526484 !important;
  margin: 0 !important;
}

.rdt_TableHeadRow > .rdt_TableCol > .custom-control {
  margin-left: 0px;
}

/** SweetAlert2 | github.com/sweetalert2/sweetalert2 */
.swal2-popup.swal2-toast {
  flex-direction: row;
  align-items: center;
  width: auto;
  padding: 0.625em;
  overflow-y: hidden;
  background: #fff;
  box-shadow: 0 0 0.625em #d9d9d9;
}
.swal2-popup.swal2-toast .swal2-header {
  flex-direction: row;
}
.swal2-popup.swal2-toast .swal2-title {
  flex-grow: 1;
  justify-content: flex-start;
  margin: 0 0.6em;
  font-size: 1em;
}
.swal2-popup.swal2-toast .swal2-footer {
  margin: 0.5em 0 0;
  padding: 0.5em 0 0;
  font-size: 0.8em;
}
.swal2-popup.swal2-toast .swal2-close {
  position: static;
  width: 0.8em;
  height: 0.8em;
  line-height: 0.8;
}
.swal2-popup.swal2-toast .swal2-content {
  justify-content: flex-start;
  font-size: 1em;
}
.swal2-popup.swal2-toast .swal2-icon {
  width: 2em;
  min-width: 2em;
  height: 2em;
  margin: 0;
}
.swal2-popup.swal2-toast .swal2-icon .swal2-icon-content {
  display: flex;
  align-items: center;
  font-size: 1.8em;
  font-weight: bold;
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .swal2-popup.swal2-toast .swal2-icon .swal2-icon-content {
    font-size: 0.25em;
  }
}
.swal2-popup.swal2-toast .swal2-icon.swal2-success .swal2-success-ring {
  width: 2em;
  height: 2em;
}
.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line] {
  top: 0.875em;
  width: 1.375em;
}
.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class\$=left] {
  left: 0.3125em;
}
.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class\$=right] {
  right: 0.3125em;
}
.swal2-popup.swal2-toast .swal2-actions {
  flex-basis: auto !important;
  width: auto;
  height: auto;
  margin: 0 0.3125em;
}
.swal2-popup.swal2-toast .swal2-actions .btn, .swal2-popup.swal2-toast .swal2-actions .dual-listbox .dual-listbox__button, .dual-listbox .swal2-popup.swal2-toast .swal2-actions .dual-listbox__button {
  margin: 0 0.5em;
}
.swal2-popup.swal2-toast .swal2-styled {
  margin: 0 0.5em;
  padding: 0.3125em 0.625em;
  font-size: 1em;
}
.swal2-popup.swal2-toast .swal2-styled:focus {
  box-shadow: 0 0 0 1px #fff, 0 0 0 3px rgba(68, 97, 242, 0.4);
}
.swal2-popup.swal2-toast .swal2-success {
  border-color: #1ee0ac;
}
.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line] {
  position: absolute;
  width: 1.6em;
  height: 3em;
  transform: rotate(45deg);
  border-radius: 50%;
}
.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class\$=left] {
  top: -0.8em;
  left: -0.5em;
  border-radius: 4em 0 0 4em;
  transform: rotate(-45deg);
  transform-origin: 2em 2em;
}
.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class\$=right] {
  top: -0.25em;
  left: 0.9375em;
  border-radius: 0 4em 4em 0;
  transform-origin: 0 1.5em;
}
.swal2-popup.swal2-toast .swal2-success .swal2-success-ring {
  width: 2em;
  height: 2em;
}
.swal2-popup.swal2-toast .swal2-success .swal2-success-fix {
  top: 0;
  left: 0.4375em;
  width: 0.4375em;
  height: 2.6875em;
}
.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line] {
  height: 0.3125em;
}
.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class\$=tip] {
  top: 1.125em;
  left: 0.1875em;
  width: 0.75em;
}
.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class\$=long] {
  top: 0.9375em;
  right: 0.1875em;
  width: 1.375em;
}
.swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip {
  animation: swal2-toast-animate-success-line-tip 0.75s;
}
.swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long {
  animation: swal2-toast-animate-success-line-long 0.75s;
}
.swal2-popup.swal2-toast.swal2-show {
  animation: swal2-toast-show 0.5s;
}
.swal2-popup.swal2-toast.swal2-hide {
  animation: swal2-toast-hide 0.1s forwards;
}

.swal2-container {
  display: flex !important;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0.625em !important;
  overflow-x: hidden !important;
  transition: background-color 0.1s !important;
  -webkit-overflow-scrolling: touch;
}
.swal2-container.swal2-backdrop-show {
  background: rgba(28, 43, 70, 0.4) !important;
}
.swal2-container.swal2-backdrop-hide {
  background: transparent !important;
}
.swal2-container.swal2-top {
  align-items: flex-start;
}
.swal2-container.swal2-top-start, .swal2-container.swal2-top-left {
  align-items: flex-start;
  justify-content: flex-start;
}
.swal2-container.swal2-top-end, .swal2-container.swal2-top-right {
  align-items: flex-start;
  justify-content: flex-end;
}
.swal2-container.swal2-center {
  align-items: center;
}
.swal2-container.swal2-center-start, .swal2-container.swal2-center-left {
  align-items: center;
  justify-content: flex-start;
}
.swal2-container.swal2-center-end, .swal2-container.swal2-center-right {
  align-items: center;
  justify-content: flex-end;
}
.swal2-container.swal2-bottom {
  align-items: flex-end;
}
.swal2-container.swal2-bottom-start, .swal2-container.swal2-bottom-left {
  align-items: flex-end;
  justify-content: flex-start;
}
.swal2-container.swal2-bottom-end, .swal2-container.swal2-bottom-right {
  align-items: flex-end;
  justify-content: flex-end;
}
.swal2-container.swal2-bottom > :first-child, .swal2-container.swal2-bottom-start > :first-child, .swal2-container.swal2-bottom-left > :first-child, .swal2-container.swal2-bottom-end > :first-child, .swal2-container.swal2-bottom-right > :first-child {
  margin-top: auto;
}
.swal2-container.swal2-grow-fullscreen > .swal2-modal {
  display: flex !important;
  flex: 1 1;
  align-self: stretch;
  justify-content: center;
}
.swal2-container.swal2-grow-row > .swal2-modal {
  display: flex !important;
  flex: 1 1;
  align-content: center;
  justify-content: center;
}
.swal2-container.swal2-grow-column {
  flex: 1 1;
  flex-direction: column;
}
.swal2-container.swal2-grow-column.swal2-top, .swal2-container.swal2-grow-column.swal2-center, .swal2-container.swal2-grow-column.swal2-bottom {
  align-items: center;
}
.swal2-container.swal2-grow-column.swal2-top-start, .swal2-container.swal2-grow-column.swal2-center-start, .swal2-container.swal2-grow-column.swal2-bottom-start, .swal2-container.swal2-grow-column.swal2-top-left, .swal2-container.swal2-grow-column.swal2-center-left, .swal2-container.swal2-grow-column.swal2-bottom-left {
  align-items: flex-start;
}
.swal2-container.swal2-grow-column.swal2-top-end, .swal2-container.swal2-grow-column.swal2-center-end, .swal2-container.swal2-grow-column.swal2-bottom-end, .swal2-container.swal2-grow-column.swal2-top-right, .swal2-container.swal2-grow-column.swal2-center-right, .swal2-container.swal2-grow-column.swal2-bottom-right {
  align-items: flex-end;
}
.swal2-container.swal2-grow-column > .swal2-modal {
  display: flex !important;
  flex: 1 1;
  align-content: center;
  justify-content: center;
}
.swal2-container:not(.swal2-top):not(.swal2-top-start):not(.swal2-top-end):not(.swal2-top-left):not(.swal2-top-right):not(.swal2-center-start):not(.swal2-center-end):not(.swal2-center-left):not(.swal2-center-right):not(.swal2-bottom):not(.swal2-bottom-start):not(.swal2-bottom-end):not(.swal2-bottom-left):not(.swal2-bottom-right):not(.swal2-grow-fullscreen) > .swal2-modal {
  margin: auto;
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .swal2-container .swal2-modal {
    margin: 0 !important;
  }
}

.swal2-popup {
  display: flex !important;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: center;
  width: 480px !important;
  padding: 2.75rem 2.5rem !important;
  border: none !important;
  border-radius: 4px !important;
}
.swal2-popup:focus {
  outline: none;
}
.swal2-popup.swal2-loading {
  overflow-y: hidden;
}

.swal2-header {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.swal2-title {
  margin: 0 0 0.4em !important;
  padding: 0 !important;
  color: #364a63 !important;
  font-size: 1.5rem !important;
  font-weight: 700 !important;
}

.swal2-html-container {
  margin-bottom: 1rem !important;
}

.swal2-actions {
  width: 100% !important;
}
.swal2-actions .btn, .swal2-actions .dual-listbox .dual-listbox__button, .dual-listbox .swal2-actions .dual-listbox__button {
  margin: 0 0.75rem !important;
}
.swal2-actions:not(.swal2-loading) .swal2-styled[disabled] {
  opacity: 0.4;
}
.swal2-actions:not(.swal2-loading) .swal2-styled:hover {
  background-image: linear-gradient(rgba(31, 43, 58, 0.1), rgba(31, 43, 58, 0.1));
}
.swal2-actions:not(.swal2-loading) .swal2-styled:active {
  background-image: linear-gradient(rgba(31, 43, 58, 0.2), rgba(31, 43, 58, 0.2));
}
.swal2-actions.swal2-loading .swal2-styled.swal2-confirm {
  box-sizing: border-box !important;
  width: 2.5em !important;
  height: 2.5em !important;
  margin: 0.46875em !important;
  padding: 0 !important;
  animation: swal2-rotate-loading 1.5s linear 0s infinite normal !important;
  border: 0.25em solid transparent !important;
  border-radius: 100% !important;
  border-color: transparent !important;
  background-color: transparent !important;
  color: transparent !important;
  cursor: default;
  -webkit-user-select: none !important;
          user-select: none !important;
}
.swal2-actions.swal2-loading .swal2-styled:focus {
  border: none;
}
.swal2-actions.swal2-loading .swal2-styled.swal2-cancel {
  margin-right: 30px;
  margin-left: 30px;
}
.swal2-actions.swal2-loading :not(.swal2-styled).swal2-confirm::after {
  content: "";
  display: inline-block;
  width: 15px;
  height: 15px;
  animation: swal2-rotate-loading 1.5s linear 0s infinite normal;
  border: 3px solid #b4c4d7;
  border-radius: 50%;
  margin-left: 5px;
  border-right-color: transparent;
  box-shadow: 1px 1px 1px #fff;
}

.swal2-styled {
  margin: 0 0.75rem !important;
  box-shadow: none !important;
  padding: 0.6875rem 1.25rem !important;
  font-size: 0.9375rem !important;
  line-height: 1.25rem !important;
  border-radius: 5px !important;
  min-width: 90px !important;
}
.swal2-loading .swal2-styled {
  min-width: 0 !important;
}
.swal2-styled:not([disabled]) {
  cursor: pointer !important;
}
.swal2-styled.swal2-confirm {
  border: 0;
  border-radius: 0.25em;
  background: initial;
  background-color: #1ee0ac !important;
  color: #fff;
}
.swal2-styled.swal2-confirm:focus {
  outline: none !important;
  background-color: !important;
  box-shadow: none !important;
}
.swal2-styled.swal2-cancel {
  border: 0;
  border-radius: 0.25em;
  background: initial;
  background-color: #e85347 !important;
  color: #fff;
}
.swal2-styled.swal2-cancel:focus {
  outline: none;
}
.swal2-styled::-moz-focus-inner {
  border: 0;
}

.swal2-footer {
  justify-content: center;
  margin: 1.25em 0 0;
  padding: 1em 0 0;
  border-top: 1px solid #eee;
  color: #5a7ca7;
  font-size: 1em;
}

.swal2-timer-progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0.25em;
  background: rgba(31, 43, 58, 0.2);
}

.swal2-image {
  max-width: 100%;
  margin: 0 auto 1.5rem !important;
}

.swal2-close {
  position: absolute;
  z-index: 2;
  /* 1617 */
  top: 0;
  right: 0;
  justify-content: center;
  width: 1.2em;
  height: 1.2em;
  padding: 0;
  overflow: hidden;
  transition: color 0.1s ease-out;
  border: none;
  border-radius: 0;
  outline: initial;
  background: transparent;
  color: #f7f8fa;
  font-family: serif;
  font-size: 2.5em;
  line-height: 1.2;
  cursor: pointer;
}
.swal2-close:hover {
  transform: none !important;
  background: transparent !important;
  color: #e85347 !important;
}
.swal2-close::-moz-focus-inner {
  border: 0;
}

.swal2-html-container {
  margin: 0 0 1rem !important;
  color: #8094ae !important;
  font-size: 0.875rem !important;
  font-weight: normal !important;
}

.swal2-validation-message {
  display: none;
  align-items: center;
  justify-content: center !important;
  padding: 0.625em !important;
  overflow: hidden;
  background: white !important;
  color: #728fb3 !important;
  font-size: 1em !important;
  font-weight: 300 !important;
}
.swal2-validation-message::before {
  content: "!";
  display: inline-block;
  width: 1.5em;
  min-width: 1.5em;
  height: 1.5em;
  margin: 0 0.625em;
  zoom: !important;
  border-radius: 50%;
  background-color: #e85347 !important;
  color: #fff !important;
  font-weight: 600;
  line-height: 1.5em;
  text-align: center;
}

.swal2-icon {
  width: 5em !important;
  height: 5em !important;
  margin: -0.5rem auto 1.5rem !important;
  zoom: !important;
  border: 0.25em solid transparent !important;
  font-family: inherit !important;
  line-height: 5em !important;
  cursor: default !important;
  -webkit-user-select: none !important;
          user-select: none !important;
  transform: scale(0.8) !important;
}
.swal2-icon .swal2-icon-content {
  display: flex;
  align-items: center;
  font-size: 3.75em;
}
.swal2-icon.swal2-error {
  border-color: #e85347 !important;
  color: #e85347 !important;
}
.swal2-icon.swal2-error .swal2-x-mark {
  position: relative;
  flex-grow: 1;
}
.swal2-icon.swal2-error [class^=swal2-x-mark-line] {
  display: block;
  position: absolute;
  top: 2.3125em;
  width: 2.9375em;
  height: 0.3125em;
  border-radius: 0.125em;
  background-color: #e85347 !important;
}
.swal2-icon.swal2-error [class^=swal2-x-mark-line][class\$=left] {
  left: 1.0625em;
  transform: rotate(45deg);
}
.swal2-icon.swal2-error [class^=swal2-x-mark-line][class\$=right] {
  right: 1em;
  transform: rotate(-45deg);
}
.swal2-icon.swal2-error.swal2-icon-show {
  animation: swal2-animate-error-icon 0.5s !important;
}
.swal2-icon.swal2-error.swal2-icon-show .swal2-x-mark {
  animation: swal2-animate-error-x-mark 0.5s !important;
}
.swal2-icon.swal2-warning {
  border-color: #f6c630 !important;
  color: #f4bd0e !important;
}
.swal2-icon.swal2-info {
  border-color: #55e3f8 !important;
  color: #09c2de !important;
}
.swal2-icon.swal2-question {
  border-color: #8798b5 !important;
  color: #526484 !important;
}
.swal2-icon.swal2-success {
  border-color: #1ee0ac !important;
  color: #1ee0ac !important;
}
.swal2-icon.swal2-success [class^=swal2-success-circular-line] {
  position: absolute;
  width: 3.75em;
  height: 7.5em;
  transform: rotate(45deg);
  border-radius: 50%;
}
.swal2-icon.swal2-success [class^=swal2-success-circular-line][class\$=left] {
  top: -0.4375em;
  left: -2.0635em;
  transform: rotate(-45deg);
  transform-origin: 3.75em 3.75em;
  border-radius: 7.5em 0 0 7.5em;
}
.swal2-icon.swal2-success [class^=swal2-success-circular-line][class\$=right] {
  top: -0.6875em;
  left: 1.875em;
  transform: rotate(-45deg);
  transform-origin: 0 3.75em;
  border-radius: 0 7.5em 7.5em 0;
}
.swal2-icon.swal2-success .swal2-success-ring {
  position: absolute;
  z-index: 2;
  top: -0.25em;
  left: -0.25em;
  box-sizing: content-box;
  width: 100%;
  height: 100%;
  border: 0.25em solid rgba(30, 224, 172, 0.3) !important;
  border-radius: 50%;
}
.swal2-icon.swal2-success .swal2-success-fix {
  position: absolute;
  z-index: 1;
  top: 0.5em;
  left: 1.625em;
  width: 0.4375em;
  height: 5.625em;
  transform: rotate(-45deg);
}
.swal2-icon.swal2-success [class^=swal2-success-line] {
  display: block;
  position: absolute;
  z-index: 2;
  height: 0.3125em;
  border-radius: 0.125em;
  background-color: #1ee0ac !important;
}
.swal2-icon.swal2-success [class^=swal2-success-line][class\$=tip] {
  top: 2.875em;
  left: 0.875em;
  width: 1.5625em;
  transform: rotate(45deg);
}
.swal2-icon.swal2-success [class^=swal2-success-line][class\$=long] {
  top: 2.375em;
  right: 0.5em;
  width: 2.9375em;
  transform: rotate(-45deg);
}
.swal2-icon.swal2-success.swal2-icon-show .swal2-success-line-tip {
  animation: swal2-animate-success-line-tip 0.75s;
}
.swal2-icon.swal2-success.swal2-icon-show .swal2-success-line-long {
  animation: swal2-animate-success-line-long 0.75s;
}
.swal2-icon.swal2-success.swal2-icon-show .swal2-success-circular-line-right {
  animation: swal2-rotate-success-circular-line 4.25s ease-in;
}

@supports (-ms-accelerator: true) {
  .swal2-range input {
    width: 100% !important;
  }
  .swal2-range output {
    display: none;
  }
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .swal2-range input {
    width: 100% !important;
  }
  .swal2-range output {
    display: none;
  }
}
@-moz-document url-prefix() {
  .swal2-close:focus {
    outline: 2px solid rgba(68, 97, 242, 0.4);
  }
}
@keyframes swal2-toast-show {
  0% {
    transform: translateY(-0.625em) rotateZ(2deg) !important;
  }
  33% {
    transform: translateY(0) rotateZ(-2deg) !important;
  }
  66% {
    transform: translateY(0.3125em) rotateZ(2deg) !important;
  }
  100% {
    transform: translateY(0) rotateZ(0deg) !important;
  }
}
@keyframes swal2-toast-hide {
  100% {
    transform: rotateZ(1deg) !important;
    opacity: 0 !important;
  }
}
@keyframes swal2-toast-animate-success-line-tip {
  0% {
    top: 0.5625em !important;
    left: 0.0625em !important;
    width: 0 !important;
  }
  54% {
    top: 0.125em !important;
    left: 0.125em !important;
    width: 0 !important;
  }
  70% {
    top: 0.625em;
    left: -0.25em !important;
    width: 1.625em !important;
  }
  84% {
    top: 1.0625em !important;
    left: 0.75em !important;
    width: 0.5em !important;
  }
  100% {
    top: 1.125em !important;
    left: 0.1875em !important;
    width: 0.75em !important;
  }
}
@keyframes swal2-toast-animate-success-line-long {
  0% {
    top: 1.625em !important;
    right: 1.375em !important;
    width: 0;
  }
  65% {
    top: 1.25em !important;
    right: 0.9375em !important;
    width: 0;
  }
  84% {
    top: 0.9375em !important;
    right: 0;
    width: 1.125em !important;
  }
  100% {
    top: 0.9375em !important;
    right: 0.1875em !important;
    width: 1.375em !important;
  }
}
@keyframes swal2-show {
  0% {
    opacity: 0 !important;
    transform: translate(0, 20px) !important;
  }
  40% {
    opacity: 1 !important;
  }
  100% {
    transform: translate(0, 0) !important;
  }
}
@keyframes swal2-hide {
  0% {
    transform: scale(1) !important;
    opacity: 1 !important;
  }
  100% {
    transform: scale(0.7) !important;
    opacity: 0 !important;
  }
}
@keyframes swal2-animate-success-line-tip {
  0% {
    top: 1.1875em;
    left: 0.0625em;
    width: 0;
  }
  54% {
    top: 1.0625em;
    left: 0.125em;
    width: 0;
  }
  70% {
    top: 2.1875em;
    left: -0.375em;
    width: 3.125em;
  }
  84% {
    top: 3em;
    left: 1.3125em;
    width: 1.0625em;
  }
  100% {
    top: 2.8125em;
    left: 0.875em;
    width: 1.5625em;
  }
}
@keyframes swal2-animate-success-line-long {
  0% {
    top: 3.375em;
    right: 2.875em;
    width: 0;
  }
  65% {
    top: 3.375em;
    right: 2.875em;
    width: 0;
  }
  84% {
    top: 2.1875em;
    right: 0;
    width: 3.4375em;
  }
  100% {
    top: 2.375em;
    right: 0.5em;
    width: 2.9375em;
  }
}
@keyframes swal2-rotate-success-circular-line {
  0% {
    transform: rotate(-45deg);
  }
  5% {
    transform: rotate(-45deg);
  }
  12% {
    transform: rotate(-405deg);
  }
  100% {
    transform: rotate(-405deg);
  }
}
@keyframes swal2-animate-error-x-mark {
  0% {
    margin-top: 1.625em;
    transform: scale(0.4);
    opacity: 0;
  }
  50% {
    margin-top: 1.625em;
    transform: scale(0.4);
    opacity: 0;
  }
  80% {
    margin-top: -0.375em;
    transform: scale(1.15);
  }
  100% {
    margin-top: 0;
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes swal2-animate-error-icon {
  0% {
    transform: scale(0.8) rotateX(100deg);
    opacity: 0;
  }
  100% {
    transform: scale(0.8) rotateX(0deg);
    opacity: 1;
  }
}
@keyframes swal2-rotate-loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) {
  overflow: hidden;
}
body.swal2-height-auto {
  height: auto !important;
}
body.swal2-no-backdrop .swal2-container {
  top: auto !important;
  right: auto !important;
  bottom: auto !important;
  left: auto !important;
  max-width: calc(100% - 0.625em * 2) !important;
  background-color: transparent !important;
}
body.swal2-no-backdrop .swal2-container > .swal2-modal {
  box-shadow: 0 0 10px rgba(28, 43, 70, 0.4) !important;
}
body.swal2-no-backdrop .swal2-container.swal2-top {
  top: 0 !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
}
body.swal2-no-backdrop .swal2-container.swal2-top-start, body.swal2-no-backdrop .swal2-container.swal2-top-left {
  top: 0 !important;
  left: 0 !important;
}
body.swal2-no-backdrop .swal2-container.swal2-top-end, body.swal2-no-backdrop .swal2-container.swal2-top-right {
  top: 0 !important;
  right: 0 !important;
}
body.swal2-no-backdrop .swal2-container.swal2-center {
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
}
body.swal2-no-backdrop .swal2-container.swal2-center-start, body.swal2-no-backdrop .swal2-container.swal2-center-left {
  top: 50% !important;
  left: 0 !important;
  transform: translateY(-50%);
}
body.swal2-no-backdrop .swal2-container.swal2-center-end, body.swal2-no-backdrop .swal2-container.swal2-center-right {
  top: 50% !important;
  right: 0 !important;
  transform: translateY(-50%) !important;
}
body.swal2-no-backdrop .swal2-container.swal2-bottom {
  bottom: 0 !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
}
body.swal2-no-backdrop .swal2-container.swal2-bottom-start, body.swal2-no-backdrop .swal2-container.swal2-bottom-left {
  bottom: 0 !important;
  left: 0 !important;
}
body.swal2-no-backdrop .swal2-container.swal2-bottom-end, body.swal2-no-backdrop .swal2-container.swal2-bottom-right {
  right: 0 !important;
  bottom: 0 !important;
}
@media print {
  body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) {
    overflow-y: scroll !important;
  }
  body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) > [aria-hidden=true] {
    display: none !important;
  }
  body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) .swal2-container {
    position: static !important;
  }
}
body.swal2-toast-shown .swal2-container {
  background-color: transparent;
}
body.swal2-toast-shown .swal2-container.swal2-top {
  top: 0;
  right: auto;
  bottom: auto;
  left: 50%;
  transform: translateX(-50%);
}
body.swal2-toast-shown .swal2-container.swal2-top-end, body.swal2-toast-shown .swal2-container.swal2-top-right {
  top: 0;
  bottom: auto;
  right: 0;
  left: auto;
}
body.swal2-toast-shown .swal2-container.swal2-top-start, body.swal2-toast-shown .swal2-container.swal2-top-left {
  top: 0;
  bottom: auto;
  left: 0;
  right: auto;
}
body.swal2-toast-shown .swal2-container.swal2-center-start, body.swal2-toast-shown .swal2-container.swal2-center-left {
  top: 50%;
  bottom: auto;
  right: auto;
  left: 0;
  transform: translateY(-50%);
}
body.swal2-toast-shown .swal2-container.swal2-center {
  top: 50%;
  right: auto;
  bottom: auto;
  left: 50%;
  transform: translate(-50%, -50%);
}
body.swal2-toast-shown .swal2-container.swal2-center-end, body.swal2-toast-shown .swal2-container.swal2-center-right {
  top: 50%;
  bottom: auto;
  right: 0;
  left: auto;
  transform: translateY(-50%);
}
body.swal2-toast-shown .swal2-container.swal2-bottom-start, body.swal2-toast-shown .swal2-container.swal2-bottom-left {
  top: auto;
  bottom: 0;
  right: auto;
  left: 0;
}
body.swal2-toast-shown .swal2-container.swal2-bottom {
  top: auto;
  right: auto;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
body.swal2-toast-shown .swal2-container.swal2-bottom-end, body.swal2-toast-shown .swal2-container.swal2-bottom-right {
  top: auto;
  bottom: 0;
  right: 0;
  left: auto;
}
body.swal2-toast-column .swal2-toast {
  flex-direction: column;
  align-items: stretch;
}
body.swal2-toast-column .swal2-toast .swal2-actions {
  flex: 1 1;
  align-self: stretch;
  height: 2.2em;
  margin-top: 0.3125em;
}
body.swal2-toast-column .swal2-toast .swal2-loading {
  justify-content: center;
}
body.swal2-toast-column .swal2-toast .swal2-input {
  height: 2em;
  margin: 0.3125em auto;
  font-size: 1em;
}
body.swal2-toast-column .swal2-toast .swal2-validation-message {
  font-size: 1em !important;
}

.tagify {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  border: 1px solid #e5e9f2;
  padding: 3px;
  line-height: 1.1;
  cursor: text;
  outline: none;
  position: relative;
  transition: 0.1s;
  font-size: 14px;
}
@keyframes tags--bump {
  30% {
    transform: scale(1.2);
  }
}
@keyframes rotateLoader {
  to {
    transform: rotate(1turn);
  }
}
@media (max-width: 576px) {
  .tagify {
    padding: 4px;
    font-size: 12px;
  }
}
.tagify:hover {
  border-color: #dbdfea;
}
.tagify.tagify--focus {
  transition: 0s;
  border-color: #4461F2;
}
.tagify[readonly] {
  cursor: default;
}
.tagify[readonly] > .tagify__input {
  visibility: hidden;
  width: 0;
  margin: 5px 0;
}
.tagify[readonly] .tagify__tag__removeBtn {
  display: none;
}
.tagify[readonly] .tagify__tag > div {
  padding: 0.25rem 0.5rem 0.25rem 0.675rem;
}
.tagify[readonly] .tagify__tag > div::before {
  background: linear-gradient(45deg, #fff 25%, transparent 25%, transparent 50%, #fff 50%, #fff 75%, transparent 75%, transparent) 0/5px 5px;
  box-shadow: none;
  filter: brightness(0.95);
}
.tagify--loading .tagify__input::before {
  content: none;
}
.tagify--loading .tagify__input::after {
  content: "";
  vertical-align: middle;
  margin: -2px 0 -2px 0.5em;
  opacity: 1;
  width: 0.7em;
  height: 0.7em;
  border: 3px solid;
  border-color: #EEE #BBB #888 transparent;
  border-radius: 50%;
  animation: rotateLoader 0.4s infinite linear;
}
.tagify--loading .tagify__input:empty::after {
  margin-left: 0;
}
.tagify + input,
.tagify + textarea {
  display: none !important;
}
.tagify__tag {
  display: inline-flex;
  align-items: center;
  margin: 2px;
  position: relative;
  z-index: 1;
  outline: none;
  cursor: default;
  transition: 0.13s ease-out;
}
.tagify__tag > div {
  vertical-align: top;
  box-sizing: border-box;
  max-width: 100%;
  padding: 0.25rem 0.5rem 0.25rem 0.675rem;
  color: #526484;
  line-height: inherit;
  border-radius: 15px;
  -webkit-user-select: none;
          user-select: none;
  transition: 0.13s ease-out;
}
.tagify__tag > div > * {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: top;
  min-width: var(--tag--min-width);
  max-width: var(--tag--max-width);
  transition: 0.8s ease, 0.1s color;
}
.tagify__tag > div > *[contenteditable] {
  outline: none;
  -webkit-user-select: text;
          user-select: text;
  cursor: text;
  margin: -2px;
  padding: 2px;
  max-width: 350px;
}
.tagify__tag > div::before {
  content: "";
  position: absolute;
  border-radius: inherit;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
  pointer-events: none;
  transition: 120ms ease;
  box-shadow: 0 0 0 1.1em #fff inset;
  border: 1px solid #e5e9f2;
}
.tagify__tag:hover:not([readonly]) div::before {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  box-shadow: 0 0 0 1.1em #f5f6fa inset;
}
.tagify__tag.tagify--noAnim > div::before {
  animation: none;
}
.tagify__tag.tagify--hide {
  width: 0 !important;
  padding-left: 0;
  padding-right: 0;
  margin-left: 0;
  margin-right: 0;
  opacity: 0;
  transform: scale(0);
  transition: 0.3s;
  pointer-events: none;
}
.tagify__tag.tagify--mark div::before {
  animation: none;
}
.tagify__tag.tagify--notAllowed:not(.tagify__tag--editable) div > span {
  opacity: 0.5;
}
.tagify__tag.tagify--notAllowed:not(.tagify__tag--editable) div::before {
  box-shadow: 0 0 0 1.1em rgba(114, 128, 146, 0.5) inset !important;
  transition: 0.2s;
}
.tagify__tag[readonly] .tagify__tag__removeBtn {
  display: none;
}
.tagify__tag[readonly] > div::before {
  background: linear-gradient(45deg, #fff 25%, transparent 25%, transparent 50%, #fff 50%, #fff 75%, transparent 75%, transparent) 0/5px 5px;
  box-shadow: none;
  filter: brightness(0.95);
  border-color: none;
}
.tagify__tag--editable > div {
  color: #526484;
}
.tagify__tag--editable > div::before {
  box-shadow: 0 0 0 2px #f5f6fa inset !important;
}
.tagify__tag--editable.tagify--invalid > div::before {
  box-shadow: 0 0 0 2px #728092 inset !important;
}
.tagify__tag__removeBtn {
  order: 5;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  cursor: pointer;
  font: 14px Serif;
  background: none;
  color: #364a63;
  width: 14px;
  height: 14px;
  margin-right: 4.6666666667px;
  margin-left: -4.6666666667px;
  transition: 0.2s ease-out;
}
.tagify__tag__removeBtn::after {
  position: relative;
  content: "×";
  top: 1px;
}
.tagify__tag__removeBtn:hover {
  color: white;
  background: #606c7c;
}
.tagify__tag__removeBtn:hover + div::before {
  transition: 0.2s;
}
.tagify:not(.tagify--mix) .tagify__input br {
  display: none;
}
.tagify:not(.tagify--mix) .tagify__input * {
  display: inline;
  white-space: nowrap;
}
.tagify__input {
  display: block;
  min-width: 60px;
  margin: 2px;
  padding: 0.25rem 0.5rem 0.25rem 0.675rem;
  line-height: inherit;
  position: relative;
  white-space: pre-line;
  /*
      in "mix mode" the tags are inside the "input" element
  */
}
.tagify__input::before {
  display: inline-block;
  width: 0;
}
.tagify__input:empty {
  display: flex;
}
.tagify__input:empty::before {
  transition: 0.2s ease-out;
  opacity: 0.7;
  transform: none;
  width: auto;
}
.tagify__input:focus {
  outline: none;
}
.tagify__input:focus::before {
  transition: 0.2s ease-out;
  opacity: 0;
  transform: translatex(6px);
}
@supports (-moz-appearance: none) {
  .tagify__input:focus::before {
    display: none;
  }
}
.tagify__input:focus:empty::before {
  transition: 0.2s ease-out;
  opacity: 0.5;
  transform: none;
}
@supports (-moz-appearance: none) {
  .tagify__input:focus:empty::before {
    display: inline-block;
  }
}
.tagify__input::before {
  content: attr(data-placeholder);
  line-height: 1.8;
  position: absolute;
  top: 0;
  z-index: 1;
  color: #526484;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
}
.tagify--mix .tagify__input::before {
  position: static;
  line-height: inherit;
}
@supports (-moz-appearance: none) {
  .tagify__input::before {
    line-height: inherit;
    position: relative;
  }
}
.tagify__input::after {
  content: attr(data-suggest);
  display: inline-block;
  white-space: pre; /* allows spaces at the beginning */
  color: #526484;
  opacity: 0.3;
  pointer-events: none;
  max-width: 100px;
}
.tagify__input .tagify__tag {
  margin: 0;
}
.tagify__input .tagify__tag > div {
  padding-top: 0;
  padding-bottom: 0;
}
.tagify--mix {
  line-height: 1.7;
}
.tagify--mix .tagify__input {
  padding: 5px;
  margin: 0;
  width: 100%;
  height: 100%;
  line-height: inherit;
}
.tagify--mix .tagify__input::after {
  content: none;
}
.tagify--select::after {
  content: ">";
  opacity: 0.5;
  position: absolute;
  top: 50%;
  right: 0;
  bottom: 0;
  font: 16px monospace;
  line-height: 8px;
  height: 8px;
  pointer-events: none;
  transform: translate(-150%, -50%) scaleX(1.2) rotate(90deg);
  transition: 0.2s ease-in-out;
}
.tagify--select[aria-expanded=true]::after {
  transform: translate(-150%, -50%) rotate(270deg) scaleY(1.2);
}
.tagify--select .tagify__tag {
  position: absolute;
  top: 0;
  right: 1.8em;
  bottom: 0;
}
.tagify--select .tagify__tag div {
  display: none;
}
.tagify--select .tagify__input {
  width: 100%;
}
.tagify--invalid {
  border-color: #728092;
}
.tagify__dropdown {
  position: absolute;
  z-index: 9999;
  transform: translateY(4px);
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(54, 74, 99, 0.1);
  border-radius: 4px;
}
.tagify__dropdown[placement=top] {
  margin-top: 0;
  transform: translateY(-4px);
  box-shadow: 0 -1px 4px rgba(54, 74, 99, 0.1);
}
.tagify__dropdown--text {
  box-shadow: 0 0 0 3px rgba(68, 97, 242, 0.1);
  font-size: 0.9em;
}
.tagify__dropdown--text .tagify__dropdown__wrapper {
  border-width: 1px;
}
.tagify__dropdown__wrapper {
  max-height: 300px;
  overflow: hidden;
  background: white;
  border: 1px solid #e5e9f2;
  padding: 0.25rem;
  border-radius: 4px;
  transition: 0.25s cubic-bezier(0, 1, 0.5, 1);
}
.tagify__dropdown__wrapper:hover {
  overflow: auto;
}
.tagify__dropdown--initial .tagify__dropdown__wrapper {
  max-height: 20px;
  transform: translateY(-1em);
}
.tagify__dropdown--initial[placement=top] .tagify__dropdown__wrapper {
  transform: translateY(2em);
}
.tagify__dropdown__item {
  box-sizing: inherit;
  padding: 0.25rem 0.5rem 0.25rem 0.675rem;
  margin: 1px;
  cursor: pointer;
  border-radius: 2px;
  position: relative;
  outline: none;
}
.tagify__dropdown__item--active {
  background: #4461F2;
  color: white;
}
.tagify__dropdown__item:active {
  filter: brightness(105%);
}
.tagify__dropdown__createTagBtn {
  width: 100%;
  background: #4461F2;
  color: white;
  border: none;
}

.tags-input {
  width: 100%;
}

.ql-container {
  box-sizing: border-box;
  font-size: 13px;
  height: 100%;
  margin: 0px;
  position: relative;
  min-height: 160px;
}

.ql-container.ql-disabled .ql-tooltip {
  visibility: hidden;
}

.ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {
  pointer-events: none;
}

.ql-clipboard {
  left: -100000px;
  height: 1px;
  overflow-y: hidden;
  position: absolute;
  top: 50%;
}

.ql-clipboard p {
  margin: 0;
  padding: 0;
}

.ql-editor {
  box-sizing: border-box;
  line-height: 1.42;
  height: 100%;
  outline: none;
  overflow-y: auto;
  padding: 12px 15px;
  tab-size: 4;
  -moz-tab-size: 4;
  text-align: left;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.ql-editor > * {
  cursor: text;
}

.ql-editor p,
.ql-editor ol,
.ql-editor ul,
.ql-editor pre,
.ql-editor blockquote,
.ql-editor h1,
.ql-editor h2,
.ql-editor h3,
.ql-editor h4,
.ql-editor h5,
.ql-editor h6 {
  margin: 0;
  padding: 0;
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}

.ql-editor ol,
.ql-editor ul {
  padding-left: 1.5em;
}

.ql-editor ol > li,
.ql-editor ul > li {
  list-style-type: none;
}

.ql-editor ul > li::before {
  content: "•";
}

.ql-editor ul[data-checked=true],
.ql-editor ul[data-checked=false] {
  pointer-events: none;
}

.ql-editor ul[data-checked=true] > li *,
.ql-editor ul[data-checked=false] > li * {
  pointer-events: all;
}

.ql-editor ul[data-checked=true] > li::before,
.ql-editor ul[data-checked=false] > li::before {
  color: #777;
  cursor: pointer;
  pointer-events: all;
}

.ql-editor ul[data-checked=true] > li::before {
  content: "☑";
}

.ql-editor ul[data-checked=false] > li::before {
  content: "☐";
}

.ql-editor li::before {
  display: inline-block;
  white-space: nowrap;
  width: 1.2em;
}

.ql-editor li:not(.ql-direction-rtl)::before {
  margin-left: -1.5em;
  margin-right: 0.3em;
  text-align: right;
}

.ql-editor li.ql-direction-rtl::before {
  margin-left: 0.3em;
  margin-right: -1.5em;
}

.ql-editor ol li:not(.ql-direction-rtl),
.ql-editor ul li:not(.ql-direction-rtl) {
  padding-left: 1.5em;
}

.ql-editor ol li.ql-direction-rtl,
.ql-editor ul li.ql-direction-rtl {
  padding-right: 1.5em;
}

.ql-editor ol li {
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  counter-increment: list-0;
}

.ql-editor ol li:before {
  content: counter(list-0, decimal) ". ";
}

.ql-editor ol li.ql-indent-1 {
  counter-increment: list-1;
}

.ql-editor ol li.ql-indent-1:before {
  content: counter(list-1, lower-alpha) ". ";
}

.ql-editor ol li.ql-indent-1 {
  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}

.ql-editor ol li.ql-indent-2 {
  counter-increment: list-2;
}

.ql-editor ol li.ql-indent-2:before {
  content: counter(list-2, lower-roman) ". ";
}

.ql-editor ol li.ql-indent-2 {
  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}

.ql-editor ol li.ql-indent-3 {
  counter-increment: list-3;
}

.ql-editor ol li.ql-indent-3:before {
  content: counter(list-3, decimal) ". ";
}

.ql-editor ol li.ql-indent-3 {
  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
}

.ql-editor ol li.ql-indent-4 {
  counter-increment: list-4;
}

.ql-editor ol li.ql-indent-4:before {
  content: counter(list-4, lower-alpha) ". ";
}

.ql-editor ol li.ql-indent-4 {
  counter-reset: list-5 list-6 list-7 list-8 list-9;
}

.ql-editor ol li.ql-indent-5 {
  counter-increment: list-5;
}

.ql-editor ol li.ql-indent-5:before {
  content: counter(list-5, lower-roman) ". ";
}

.ql-editor ol li.ql-indent-5 {
  counter-reset: list-6 list-7 list-8 list-9;
}

.ql-editor ol li.ql-indent-6 {
  counter-increment: list-6;
}

.ql-editor ol li.ql-indent-6:before {
  content: counter(list-6, decimal) ". ";
}

.ql-editor ol li.ql-indent-6 {
  counter-reset: list-7 list-8 list-9;
}

.ql-editor ol li.ql-indent-7 {
  counter-increment: list-7;
}

.ql-editor ol li.ql-indent-7:before {
  content: counter(list-7, lower-alpha) ". ";
}

.ql-editor ol li.ql-indent-7 {
  counter-reset: list-8 list-9;
}

.ql-editor ol li.ql-indent-8 {
  counter-increment: list-8;
}

.ql-editor ol li.ql-indent-8:before {
  content: counter(list-8, lower-roman) ". ";
}

.ql-editor ol li.ql-indent-8 {
  counter-reset: list-9;
}

.ql-editor ol li.ql-indent-9 {
  counter-increment: list-9;
}

.ql-editor ol li.ql-indent-9:before {
  content: counter(list-9, decimal) ". ";
}

.ql-editor .ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 3em;
}

.ql-editor li.ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 4.5em;
}

.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 3em;
}

.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 4.5em;
}

.ql-editor .ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 6em;
}

.ql-editor li.ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 7.5em;
}

.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 6em;
}

.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 7.5em;
}

.ql-editor .ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 9em;
}

.ql-editor li.ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 10.5em;
}

.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 9em;
}

.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 10.5em;
}

.ql-editor .ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 12em;
}

.ql-editor li.ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 13.5em;
}

.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 12em;
}

.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 13.5em;
}

.ql-editor .ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 15em;
}

.ql-editor li.ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 16.5em;
}

.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 15em;
}

.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 16.5em;
}

.ql-editor .ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 18em;
}

.ql-editor li.ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 19.5em;
}

.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 18em;
}

.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 19.5em;
}

.ql-editor .ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 21em;
}

.ql-editor li.ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 22.5em;
}

.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 21em;
}

.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 22.5em;
}

.ql-editor .ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 24em;
}

.ql-editor li.ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 25.5em;
}

.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 24em;
}

.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 25.5em;
}

.ql-editor .ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 27em;
}

.ql-editor li.ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 28.5em;
}

.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 27em;
}

.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 28.5em;
}

.ql-editor .ql-video {
  display: block;
  max-width: 100%;
}

.ql-editor .ql-video.ql-align-center {
  margin: 0 auto;
}

.ql-editor .ql-video.ql-align-right {
  margin: 0 0 0 auto;
}

.ql-editor .ql-bg-black {
  background-color: #000;
}

.ql-editor .ql-bg-red {
  background-color: #e60000;
}

.ql-editor .ql-bg-orange {
  background-color: #f90;
}

.ql-editor .ql-bg-yellow {
  background-color: #ff0;
}

.ql-editor .ql-bg-green {
  background-color: #008a00;
}

.ql-editor .ql-bg-blue {
  background-color: #06c;
}

.ql-editor .ql-bg-purple {
  background-color: #93f;
}

.ql-editor .ql-color-white {
  color: #fff;
}

.ql-editor .ql-color-red {
  color: #e60000;
}

.ql-editor .ql-color-orange {
  color: #f90;
}

.ql-editor .ql-color-yellow {
  color: #ff0;
}

.ql-editor .ql-color-green {
  color: #008a00;
}

.ql-editor .ql-color-blue {
  color: #06c;
}

.ql-editor .ql-color-purple {
  color: #93f;
}

.ql-editor .ql-font-serif {
  font-family: Georgia, Times New Roman, serif;
}

.ql-editor .ql-font-monospace {
  font-family: Monaco, Courier New, monospace;
}

.ql-editor .ql-size-small {
  font-size: 0.75em;
}

.ql-editor .ql-size-large {
  font-size: 1.5em;
}

.ql-editor .ql-size-huge {
  font-size: 2.5em;
}

.ql-editor .ql-direction-rtl {
  direction: rtl;
  text-align: inherit;
}

.ql-editor .ql-align-center {
  text-align: center;
}

.ql-editor .ql-align-justify {
  text-align: justify;
}

.ql-editor .ql-align-right {
  text-align: right;
}

.ql-editor.ql-blank::before {
  color: rgba(0, 0, 0, 0.6);
  content: attr(data-placeholder);
  font-style: italic;
  left: 15px;
  pointer-events: none;
  position: absolute;
  right: 15px;
}

.ql-toolbar:after {
  clear: both;
  content: "";
  display: table;
}

.ql-toolbar button {
  background: none;
  border: none;
  cursor: pointer;
  display: inline-block;
  float: left;
  height: 24px;
  padding: 3px 5px;
  width: 28px;
}

.ql-toolbar button svg {
  float: left;
  height: 100%;
}

.ql-toolbar button:active:hover {
  outline: none;
}

.ql-toolbar input.ql-image[type=file] {
  display: none;
}

.ql-toolbar button:hover,
.ql-toolbar button:focus,
.ql-toolbar button.ql-active,
.ql-toolbar .ql-picker-label:hover,
.ql-toolbar .ql-picker-label.ql-active,
.ql-toolbar .ql-picker-item:hover,
.ql-toolbar .ql-picker-item.ql-selected {
  color: #4461F2;
}

.ql-toolbar button:hover .ql-fill,
.ql-toolbar button:focus .ql-fill,
.ql-toolbar button.ql-active .ql-fill,
.ql-toolbar .ql-picker-label:hover .ql-fill,
.ql-toolbar .ql-picker-label.ql-active .ql-fill,
.ql-toolbar .ql-picker-item:hover .ql-fill,
.ql-toolbar .ql-picker-item.ql-selected .ql-fill,
.ql-toolbar button:hover .ql-stroke.ql-fill,
.ql-toolbar button:focus .ql-stroke.ql-fill,
.ql-toolbar button.ql-active .ql-stroke.ql-fill,
.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {
  fill: #4461F2;
}

.ql-toolbar button:hover .ql-stroke,
.ql-toolbar button:focus .ql-stroke,
.ql-toolbar button.ql-active .ql-stroke,
.ql-toolbar .ql-picker-label:hover .ql-stroke,
.ql-toolbar .ql-picker-label.ql-active .ql-stroke,
.ql-toolbar .ql-picker-item:hover .ql-stroke,
.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
.ql-toolbar button:hover .ql-stroke-miter,
.ql-toolbar button:focus .ql-stroke-miter,
.ql-toolbar button.ql-active .ql-stroke-miter,
.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {
  stroke: #4461F2;
}

@media (pointer: coarse) {
  .ql-toolbar button:hover:not(.ql-active) {
    color: #526484;
  }
  .ql-toolbar button:hover:not(.ql-active) .ql-fill,
  .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {
    fill: #526484;
  }
  .ql-toolbar button:hover:not(.ql-active) .ql-stroke,
  .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {
    stroke: #526484;
  }
}
.ql-hidden {
  display: none;
}

.ql-out-bottom,
.ql-out-top {
  visibility: hidden;
}

.ql-tooltip {
  position: absolute;
  transform: translateY(10px);
}

.ql-tooltip a {
  cursor: pointer;
  text-decoration: none;
}

.ql-tooltip.ql-flip {
  transform: translateY(-10px);
}

.ql-formats {
  display: inline-block;
  vertical-align: middle;
}

.ql-formats:after {
  clear: both;
  content: "";
  display: table;
}

.ql-stroke {
  fill: none;
  stroke: #526484;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2;
}

.ql-stroke-miter {
  fill: none;
  stroke: #526484;
  stroke-miterlimit: 10;
  stroke-width: 2;
}

.ql-fill,
.ql-stroke.ql-fill {
  fill: #526484;
}

.ql-empty {
  fill: none;
}

.ql-even {
  fill-rule: evenodd;
}

.ql-thin,
.ql-stroke.ql-thin {
  stroke-width: 1;
}

.ql-transparent {
  opacity: 0.4;
}

.ql-direction svg:last-child {
  display: none;
}

.ql-direction.ql-active svg:last-child {
  display: inline;
}

.ql-direction.ql-active svg:first-child {
  display: none;
}

.ql-editor h1 {
  font-size: 2em;
}

.ql-editor h2 {
  font-size: 1.5em;
}

.ql-editor h3 {
  font-size: 1.17em;
}

.ql-editor h4 {
  font-size: 1em;
}

.ql-editor h5 {
  font-size: 0.83em;
}

.ql-editor h6 {
  font-size: 0.67em;
}

.ql-editor a {
  text-decoration: underline;
}

.ql-editor blockquote {
  margin-bottom: 5px;
  margin-top: 5px;
  border-left: 4px solid #dbdfea;
  padding-left: 16px;
}

.ql-editor code,
.ql-editor pre {
  background-color: #f0f0f0;
  border-radius: 3px;
}

.ql-editor pre {
  white-space: pre-wrap;
  margin-bottom: 5px;
  margin-top: 5px;
  padding: 5px 10px;
}

.ql-editor code {
  font-size: 85%;
  padding: 2px 4px;
}

.ql-editor pre.ql-syntax {
  background-color: #23241f;
  color: #f8f8f2;
  overflow: visible;
}

.ql-editor img {
  max-width: 100%;
}

.ql-picker {
  color: #526484;
  display: inline-block;
  float: left;
  font-size: 14px;
  font-weight: 500;
  height: 24px;
  position: relative;
  vertical-align: middle;
}

.ql-picker-label {
  cursor: pointer;
  display: inline-block;
  height: 100%;
  padding-left: 8px;
  padding-right: 2px;
  position: relative;
  width: 100%;
}
.ql-picker-label:focus {
  box-shadow: none;
  border: none;
  outline: none;
}

.ql-picker-label::before {
  display: inline-block;
  line-height: 22px;
}

.ql-picker-options {
  background-color: #fff;
  display: none;
  min-width: 100%;
  padding: 4px 16px;
  position: absolute;
  white-space: nowrap;
  border-radius: 4px;
}

.ql-picker-options .ql-picker-item {
  cursor: pointer;
  display: block;
  padding-bottom: 5px;
  padding-top: 5px;
}

.ql-picker.ql-expanded .ql-picker-label {
  color: #1c2b46;
  z-index: 2;
}

.ql-picker.ql-expanded .ql-picker-label .ql-fill {
  fill: #8094ae;
}

.ql-picker.ql-expanded .ql-picker-label .ql-stroke {
  stroke: #8094ae;
}

.ql-picker.ql-expanded .ql-picker-options {
  display: block;
  margin-top: -1px;
  top: 100%;
  z-index: 1;
}

.ql-color-picker,
.ql-icon-picker {
  width: 28px;
}

.ql-color-picker .ql-picker-label,
.ql-icon-picker .ql-picker-label {
  padding: 2px 4px;
}

.ql-color-picker .ql-picker-label svg,
.ql-icon-picker .ql-picker-label svg {
  right: 4px;
}

.ql-icon-picker .ql-picker-options {
  padding: 4px 0px;
}

.ql-icon-picker .ql-picker-item {
  height: 24px;
  width: 24px;
  padding: 2px 4px;
}

.ql-color-picker .ql-picker-options {
  padding: 8px;
  width: 158px;
}

.ql-color-picker .ql-picker-item {
  border: 1px solid transparent;
  float: left;
  height: 16px;
  margin: 2px;
  padding: 0px;
  width: 16px;
}

.ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
  position: absolute;
  margin-top: -9px;
  right: 0;
  top: 50%;
  width: 18px;
}

.ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=""])::before,
.ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=""])::before,
.ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=""])::before,
.ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=""])::before,
.ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=""])::before,
.ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=""])::before {
  content: attr(data-label);
}

.ql-picker.ql-header {
  width: 98px;
}

.ql-picker.ql-header .ql-picker-label::before,
.ql-picker.ql-header .ql-picker-item::before {
  content: "Normal";
}

.ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "Heading 1";
}

.ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "Heading 2";
}

.ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "Heading 3";
}

.ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "Heading 4";
}

.ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "Heading 5";
}

.ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "Heading 6";
}

.ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  font-size: 2em;
}

.ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  font-size: 1.5em;
}

.ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  font-size: 1.17em;
}

.ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  font-size: 1em;
}

.ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  font-size: 0.83em;
}

.ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  font-size: 0.67em;
}

.ql-picker.ql-font {
  width: 108px;
}

.ql-picker.ql-font .ql-picker-label::before,
.ql-picker.ql-font .ql-picker-item::before {
  content: "Sans Serif";
}

.ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
  content: "Serif";
}

.ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
  content: "Monospace";
}

.ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
  font-family: Georgia, Times New Roman, serif;
}

.ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
  font-family: Monaco, Courier New, monospace;
}

.ql-picker.ql-size {
  width: 98px;
}

.ql-picker.ql-size .ql-picker-label::before,
.ql-picker.ql-size .ql-picker-item::before {
  content: "Normal";
}

.ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-picker.ql-size .ql-picker-item[data-value=small]::before {
  content: "Small";
}

.ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-picker.ql-size .ql-picker-item[data-value=large]::before {
  content: "Large";
}

.ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
  content: "Huge";
}

.ql-picker.ql-size .ql-picker-item[data-value=small]::before {
  font-size: 10px;
}

.ql-picker.ql-size .ql-picker-item[data-value=large]::before {
  font-size: 18px;
}

.ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
  font-size: 32px;
}

.ql-color-picker.ql-background .ql-picker-item {
  background-color: #fff;
}

.ql-color-picker.ql-color .ql-picker-item {
  background-color: #000;
}

.ql-toolbar {
  border: 1px solid #e5e9f2;
  border-radius: 4px 4px 0 0;
  box-sizing: border-box;
  padding: 8px;
  padding-bottom: 0;
}

.ql-toolbar .ql-formats {
  margin-right: 15px;
  padding-bottom: 8px;
}

.ql-toolbar .ql-picker-label {
  border: 1px solid transparent;
}

.ql-toolbar .ql-picker-options {
  border: 1px solid transparent;
  box-shadow: 0 0.125rem 0.25rem rgba(43, 55, 72, 0.15);
}

.ql-toolbar .ql-picker.ql-expanded .ql-picker-options {
  border-color: #e5e9f2;
}

.ql-toolbar .ql-color-picker .ql-picker-item.ql-selected,
.ql-toolbar .ql-color-picker .ql-picker-item:hover {
  border-color: #3c4d62;
}

.ql-toolbar + .ql-container {
  border-top: 0px;
}

.ql-tooltip {
  background-color: #fff;
  border: 1px solid #e5e9f2;
  box-shadow: 0px 0px 5px #ddd;
  color: #526484;
  padding: 5px 12px;
  white-space: nowrap;
}

.ql-tooltip::before {
  content: "Visit URL:";
  line-height: 26px;
  margin-right: 8px;
}

.ql-tooltip input[type=text] {
  display: none;
  border: 1px solid #e5e9f2;
  font-size: 13px;
  height: 26px;
  margin: 0px;
  padding: 3px 5px;
  width: 170px;
}

.ql-tooltip a.ql-preview {
  display: inline-block;
  max-width: 200px;
  overflow-x: hidden;
  text-overflow: ellipsis;
  vertical-align: top;
}

.ql-tooltip a.ql-action::after {
  content: "Edit";
  border-right: 1px solid #e5e9f2;
  margin-left: 16px;
  padding-right: 8px;
}

.ql-tooltip a.ql-remove::before {
  content: "Remove";
  margin-left: 8px;
}

.ql-tooltip a {
  line-height: 26px;
}

.ql-tooltip.ql-editing a.ql-preview,
.ql-tooltip.ql-editing a.ql-remove {
  display: none;
}

.ql-tooltip.ql-editing input[type=text] {
  display: inline-block;
}

.ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: "Save";
  padding-right: 0px;
}

.ql-tooltip[data-mode=link]::before {
  content: "Enter link:";
}

.ql-tooltip[data-mode=formula]::before {
  content: "Enter formula:";
}

.ql-tooltip[data-mode=video]::before {
  content: "Enter video:";
}

a {
  color: #4461F2;
}

.ql-container {
  border: 1px solid #e5e9f2;
  border-radius: 0 0 4px 4px;
}

/**
 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
 * Licensed under the LGPL or a commercial license.
 * For LGPL see License.txt in the project root for license information.
 * For commercial licenses see https://www.tiny.cloud/
 */
.mce-content-body .mce-item-anchor {
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_30___}) no-repeat center;
  cursor: default;
  display: inline-block;
  height: 12px !important;
  padding: 0 2px;
  -webkit-user-modify: read-only;
  -moz-user-modify: read-only;
  -webkit-user-select: all;
  user-select: all;
  width: 8px !important;
}

.mce-content-body .mce-item-anchor[data-mce-selected] {
  outline-offset: 1px;
}

.tox-comments-visible .tox-comment {
  background-color: #fff0b7;
}

.tox-comments-visible .tox-comment--active {
  background-color: #ffe168;
}

.tox-checklist > li:not(.tox-checklist--hidden) {
  list-style: none;
  margin: 0.25em 0;
}

.tox-checklist > li:not(.tox-checklist--hidden)::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
  cursor: pointer;
  height: 1em;
  margin-left: -1.5em;
  margin-top: 0.125em;
  position: absolute;
  width: 1em;
}

.tox-checklist li:not(.tox-checklist--hidden).tox-checklist--checked::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
}

[dir=rtl] .tox-checklist > li:not(.tox-checklist--hidden)::before {
  margin-left: 0;
  margin-right: -1.5em;
}

/* stylelint-disable */
/* http://prismjs.com/ */
/**
 * prism.js default theme for JavaScript, CSS and HTML
 * Based on dabblet (http://dabblet.com)
 * @author Lea Verou
 */
code[class*=language-],
pre[class*=language-] {
  background: none;
  font-size: 1em;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  word-wrap: normal;
  line-height: 1.5;
  tab-size: 4;
  hyphens: none;
}

pre[class*=language-]::selection,
pre[class*=language-] ::selection,
code[class*=language-]::selection,
code[class*=language-] ::selection {
  text-shadow: none;
  background: #b3d4fc;
}

@media print {
  code[class*=language-],
  pre[class*=language-] {
    text-shadow: none;
  }
}
/* Code blocks */
pre[class*=language-] {
  padding: 1em;
  margin: 0.5em 0;
  overflow: auto;
}

:not(pre) > code[class*=language-],
pre[class*=language-] {
  background: #f5f2f0;
}

/* Inline code */
:not(pre) > code[class*=language-] {
  padding: 0.1em;
  border-radius: 0.3em;
  white-space: normal;
}

.token.comment,
.token.prolog,
.token.doctype,
.token.cdata {
  color: slategray;
}

.token.punctuation {
  color: #999;
}

.namespace {
  opacity: 0.7;
}

.token.property,
.token.tag,
.token.boolean,
.token.number,
.token.constant,
.token.symbol,
.token.deleted {
  color: #905;
}

.token.selector,
.token.attr-name,
.token.string,
.token.char,
.token.builtin,
.token.inserted {
  color: #690;
}

.token.operator,
.token.entity,
.token.url,
.language-css .token.string,
.style .token.string {
  color: #9a6e3a;
  background: hsla(0deg, 0%, 100%, 0.5);
}

.token.atrule,
.token.attr-value,
.token.keyword {
  color: #07a;
}

.token.function,
.token.class-name {
  color: #DD4A68;
}

.token.regex,
.token.important,
.token.variable {
  color: #e90;
}

.token.important,
.token.bold {
  font-weight: bold;
}

.token.italic {
  font-style: italic;
}

.token.entity {
  cursor: help;
}

/* stylelint-enable */
.mce-content-body {
  overflow-wrap: break-word;
  word-wrap: break-word;
}

.mce-content-body .mce-visual-caret {
  background-color: black;
  background-color: currentColor;
  position: absolute;
}

.mce-content-body .mce-visual-caret-hidden {
  display: none;
}

.mce-content-body *[data-mce-caret] {
  left: -1000px;
  margin: 0;
  padding: 0;
  position: absolute;
  right: auto;
  top: 0;
}

.mce-content-body .mce-offscreen-selection {
  left: -2000000px;
  max-width: 1000000px;
  position: absolute;
}

.mce-content-body *[contentEditable=false] {
  cursor: default;
}

.mce-content-body *[contentEditable=true] {
  cursor: text;
}

.tox-cursor-format-painter {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_33___}), default;
}

.mce-content-body figure.align-left {
  float: left;
}

.mce-content-body figure.align-right {
  float: right;
}

.mce-content-body figure.image.align-center {
  display: table;
  margin-left: auto;
  margin-right: auto;
}

.mce-preview-object {
  border: 1px solid gray;
  display: inline-block;
  line-height: 0;
  margin: 0 2px 0 2px;
  position: relative;
}

.mce-preview-object .mce-shim {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.mce-preview-object[data-mce-selected="2"] .mce-shim {
  display: none;
}

.mce-object {
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_35___}) no-repeat center;
  border: 1px dashed #aaa;
}

.mce-pagebreak {
  border: 1px dashed #aaa;
  cursor: default;
  display: block;
  height: 5px;
  margin-top: 15px;
  page-break-before: always;
  width: 100%;
}

@media print {
  .mce-pagebreak {
    border: 0;
  }
}
.tiny-pageembed .mce-shim {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.tiny-pageembed[data-mce-selected="2"] .mce-shim {
  display: none;
}

.tiny-pageembed {
  display: inline-block;
  position: relative;
}

.tiny-pageembed--21by9,
.tiny-pageembed--16by9,
.tiny-pageembed--4by3,
.tiny-pageembed--1by1 {
  display: block;
  overflow: hidden;
  padding: 0;
  position: relative;
  width: 100%;
}

.tiny-pageembed--21by9 {
  padding-top: 42.857143%;
}

.tiny-pageembed--16by9 {
  padding-top: 56.25%;
}

.tiny-pageembed--4by3 {
  padding-top: 75%;
}

.tiny-pageembed--1by1 {
  padding-top: 100%;
}

.tiny-pageembed--21by9 iframe,
.tiny-pageembed--16by9 iframe,
.tiny-pageembed--4by3 iframe,
.tiny-pageembed--1by1 iframe {
  border: 0;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.mce-content-body[data-mce-placeholder] {
  position: relative;
}

.mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before {
  color: rgba(34, 47, 62, 0.7);
  content: attr(data-mce-placeholder);
  position: absolute;
}

.mce-content-body:not([dir=rtl])[data-mce-placeholder]:not(.mce-visualblocks)::before {
  left: 1px;
}

.mce-content-body[dir=rtl][data-mce-placeholder]:not(.mce-visualblocks)::before {
  right: 1px;
}

.mce-content-body div.mce-resizehandle {
  background-color: #4099ff;
  border-color: #4099ff;
  border-style: solid;
  border-width: 1px;
  box-sizing: border-box;
  height: 10px;
  position: absolute;
  width: 10px;
  z-index: 10000;
}

.mce-content-body div.mce-resizehandle:hover {
  background-color: #4099ff;
}

.mce-content-body div.mce-resizehandle:nth-of-type(1) {
  cursor: nwse-resize;
}

.mce-content-body div.mce-resizehandle:nth-of-type(2) {
  cursor: nesw-resize;
}

.mce-content-body div.mce-resizehandle:nth-of-type(3) {
  cursor: nwse-resize;
}

.mce-content-body div.mce-resizehandle:nth-of-type(4) {
  cursor: nesw-resize;
}

.mce-content-body .mce-clonedresizable {
  opacity: 0.5;
  outline: 1px dashed black;
  position: absolute;
  z-index: 10000;
}

.mce-content-body .mce-resize-helper {
  background: #555;
  background: rgba(0, 0, 0, 0.75);
  border: 1px;
  border-radius: 3px;
  color: white;
  display: none;
  font-size: 12px;
  line-height: 14px;
  margin: 5px 10px;
  padding: 5px;
  position: absolute;
  white-space: nowrap;
  z-index: 10001;
}

.tox-rtc-user-selection {
  position: relative;
}

.tox-rtc-user-cursor {
  bottom: 0;
  cursor: default;
  position: absolute;
  top: 0;
  width: 2px;
}

.tox-rtc-user-cursor::before {
  background-color: inherit;
  border-radius: 50%;
  content: "";
  display: block;
  height: 8px;
  position: absolute;
  right: -3px;
  top: -3px;
  width: 8px;
}

.tox-rtc-user-cursor:hover::after {
  background-color: inherit;
  border-radius: 100px;
  box-sizing: border-box;
  color: #fff;
  content: attr(data-user);
  display: block;
  font-size: 12px;
  font-weight: bold;
  left: -5px;
  min-height: 8px;
  min-width: 8px;
  padding: 0 12px;
  position: absolute;
  top: -11px;
  white-space: nowrap;
  z-index: 1000;
}

.tox-rtc-user-selection--1 .tox-rtc-user-cursor {
  background-color: #2dc26b;
}

.tox-rtc-user-selection--2 .tox-rtc-user-cursor {
  background-color: #e03e2d;
}

.tox-rtc-user-selection--3 .tox-rtc-user-cursor {
  background-color: #f1c40f;
}

.tox-rtc-user-selection--4 .tox-rtc-user-cursor {
  background-color: #3598db;
}

.tox-rtc-user-selection--5 .tox-rtc-user-cursor {
  background-color: #b96ad9;
}

.tox-rtc-user-selection--6 .tox-rtc-user-cursor {
  background-color: #e67e23;
}

.tox-rtc-user-selection--7 .tox-rtc-user-cursor {
  background-color: #aaa69d;
}

.tox-rtc-user-selection--8 .tox-rtc-user-cursor {
  background-color: #f368e0;
}

.tox-rtc-remote-image {
  background: #eaeaea url(${___CSS_LOADER_URL_REPLACEMENT_36___}) no-repeat center center;
  border: 1px solid #ccc;
  min-height: 240px;
  min-width: 320px;
}

.mce-match-marker {
  background: #aaa;
  color: #fff;
}

.mce-match-marker-selected {
  background: #39f;
  color: #fff;
}

.mce-match-marker-selected::selection {
  background: #39f;
  color: #fff;
}

.mce-content-body img[data-mce-selected],
.mce-content-body table[data-mce-selected] {
  outline: 3px solid #b4d7ff;
}

.mce-content-body hr[data-mce-selected] {
  outline: 3px solid #b4d7ff;
  outline-offset: 1px;
}

.mce-content-body *[contentEditable=false] *[contentEditable=true]:focus {
  outline: 3px solid #b4d7ff;
}

.mce-content-body *[contentEditable=false] *[contentEditable=true]:hover {
  outline: 3px solid #b4d7ff;
}

.mce-content-body *[contentEditable=false][data-mce-selected] {
  cursor: not-allowed;
  outline: 3px solid #b4d7ff;
}

.mce-content-body.mce-content-readonly *[contentEditable=true]:focus,
.mce-content-body.mce-content-readonly *[contentEditable=true]:hover {
  outline: none;
}

.mce-content-body *[data-mce-selected=inline-boundary] {
  background-color: #b4d7ff;
}

.mce-content-body .mce-edit-focus {
  outline: 3px solid #b4d7ff;
}

.mce-content-body td[data-mce-selected],
.mce-content-body th[data-mce-selected] {
  background-color: #b4d7ff !important;
}

.mce-content-body td[data-mce-selected]::selection,
.mce-content-body th[data-mce-selected]::selection {
  background: none;
}

.mce-content-body td[data-mce-selected] *,
.mce-content-body th[data-mce-selected] * {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

.mce-content-body img::selection {
  background: none;
}

.ephox-snooker-resizer-bar {
  background-color: #b4d7ff;
  opacity: 0;
  -webkit-user-select: none;
  user-select: none;
}

.ephox-snooker-resizer-cols {
  cursor: col-resize;
}

.ephox-snooker-resizer-rows {
  cursor: row-resize;
}

.ephox-snooker-resizer-bar.ephox-snooker-resizer-bar-dragging {
  opacity: 1;
}

.mce-spellchecker-word {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
  background-position: 0 calc(100% + 1px);
  background-repeat: repeat-x;
  background-size: auto 6px;
  cursor: default;
  height: 2rem;
}

.mce-spellchecker-grammar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  background-position: 0 calc(100% + 1px);
  background-repeat: repeat-x;
  background-size: auto 6px;
  cursor: default;
}

.mce-toc {
  border: 1px solid gray;
}

.mce-toc h2 {
  margin: 4px;
}

.mce-toc li {
  list-style-type: none;
}

.mce-item-table,
.mce-item-table td,
.mce-item-table th,
.mce-item-table caption {
  border: 1px dashed #bbb;
}

.mce-visualblocks p,
.mce-visualblocks h1,
.mce-visualblocks h2,
.mce-visualblocks h3,
.mce-visualblocks h4,
.mce-visualblocks h5,
.mce-visualblocks h6,
.mce-visualblocks div:not([data-mce-bogus]),
.mce-visualblocks section,
.mce-visualblocks article,
.mce-visualblocks blockquote,
.mce-visualblocks address,
.mce-visualblocks pre,
.mce-visualblocks figure,
.mce-visualblocks figcaption,
.mce-visualblocks hgroup,
.mce-visualblocks aside,
.mce-visualblocks ul,
.mce-visualblocks ol,
.mce-visualblocks dl {
  background-repeat: no-repeat;
  border: 1px dashed #bbb;
  margin-left: 3px;
  padding-top: 10px;
}

.mce-visualblocks p {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
}

.mce-visualblocks h1 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}

.mce-visualblocks h2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
}

.mce-visualblocks h3 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
}

.mce-visualblocks h4 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
}

.mce-visualblocks h5 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
}

.mce-visualblocks h6 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
}

.mce-visualblocks div:not([data-mce-bogus]) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
}

.mce-visualblocks section {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
}

.mce-visualblocks article {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
}

.mce-visualblocks blockquote {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
}

.mce-visualblocks address {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
}

.mce-visualblocks pre {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_51___});
}

.mce-visualblocks figure {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
}

.mce-visualblocks figcaption {
  border: 1px dashed #bbb;
}

.mce-visualblocks hgroup {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_53___});
}

.mce-visualblocks aside {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
}

.mce-visualblocks ul {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
}

.mce-visualblocks ol {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
}

.mce-visualblocks dl {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_57___});
}

.mce-visualblocks:not([dir=rtl]) p,
.mce-visualblocks:not([dir=rtl]) h1,
.mce-visualblocks:not([dir=rtl]) h2,
.mce-visualblocks:not([dir=rtl]) h3,
.mce-visualblocks:not([dir=rtl]) h4,
.mce-visualblocks:not([dir=rtl]) h5,
.mce-visualblocks:not([dir=rtl]) h6,
.mce-visualblocks:not([dir=rtl]) div:not([data-mce-bogus]),
.mce-visualblocks:not([dir=rtl]) section,
.mce-visualblocks:not([dir=rtl]) article,
.mce-visualblocks:not([dir=rtl]) blockquote,
.mce-visualblocks:not([dir=rtl]) address,
.mce-visualblocks:not([dir=rtl]) pre,
.mce-visualblocks:not([dir=rtl]) figure,
.mce-visualblocks:not([dir=rtl]) figcaption,
.mce-visualblocks:not([dir=rtl]) hgroup,
.mce-visualblocks:not([dir=rtl]) aside,
.mce-visualblocks:not([dir=rtl]) ul,
.mce-visualblocks:not([dir=rtl]) ol,
.mce-visualblocks:not([dir=rtl]) dl {
  margin-left: 3px;
}

.mce-visualblocks[dir=rtl] p,
.mce-visualblocks[dir=rtl] h1,
.mce-visualblocks[dir=rtl] h2,
.mce-visualblocks[dir=rtl] h3,
.mce-visualblocks[dir=rtl] h4,
.mce-visualblocks[dir=rtl] h5,
.mce-visualblocks[dir=rtl] h6,
.mce-visualblocks[dir=rtl] div:not([data-mce-bogus]),
.mce-visualblocks[dir=rtl] section,
.mce-visualblocks[dir=rtl] article,
.mce-visualblocks[dir=rtl] blockquote,
.mce-visualblocks[dir=rtl] address,
.mce-visualblocks[dir=rtl] pre,
.mce-visualblocks[dir=rtl] figure,
.mce-visualblocks[dir=rtl] figcaption,
.mce-visualblocks[dir=rtl] hgroup,
.mce-visualblocks[dir=rtl] aside,
.mce-visualblocks[dir=rtl] ul,
.mce-visualblocks[dir=rtl] ol,
.mce-visualblocks[dir=rtl] dl {
  background-position-x: right;
  margin-right: 3px;
}

.mce-nbsp,
.mce-shy {
  background: #aaa;
}

.mce-shy::after {
  content: "-";
}

.mce-content-body table {
  border-collapse: collapse;
}

.tox-edit-area {
  font-family: "DM Sans", sans-serif;
}

/**
 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
 * Licensed under the LGPL or a commercial license.
 * For LGPL see License.txt in the project root for license information.
 * For commercial licenses see https://www.tiny.cloud/
 */
.mce-content-body .mce-item-anchor {
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_30___}) no-repeat center;
  cursor: default;
  display: inline-block;
  height: 12px !important;
  padding: 0 2px;
  -webkit-user-modify: read-only;
  -moz-user-modify: read-only;
  -webkit-user-select: all;
  user-select: all;
  width: 8px !important;
}

.mce-content-body .mce-item-anchor[data-mce-selected] {
  outline-offset: 1px;
}

.tox-comments-visible .tox-comment {
  background-color: #fff0b7;
}

.tox-comments-visible .tox-comment--active {
  background-color: #ffe168;
}

.tox-checklist > li:not(.tox-checklist--hidden) {
  list-style: none;
  margin: 0.25em 0;
}

.tox-checklist > li:not(.tox-checklist--hidden)::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
  cursor: pointer;
  height: 1em;
  margin-left: -1.5em;
  margin-top: 0.125em;
  position: absolute;
  width: 1em;
}

.tox-checklist li:not(.tox-checklist--hidden).tox-checklist--checked::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
}

[dir=rtl] .tox-checklist > li:not(.tox-checklist--hidden)::before {
  margin-left: 0;
  margin-right: -1.5em;
}

/* stylelint-disable */
/* http://prismjs.com/ */
/**
 * prism.js default theme for JavaScript, CSS and HTML
 * Based on dabblet (http://dabblet.com)
 * @author Lea Verou
 */
code[class*=language-],
pre[class*=language-] {
  background: none;
  font-size: 1em;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  word-wrap: normal;
  line-height: 1.5;
  tab-size: 4;
  hyphens: none;
}

pre[class*=language-]::selection,
pre[class*=language-] ::selection,
code[class*=language-]::selection,
code[class*=language-] ::selection {
  text-shadow: none;
  background: #b3d4fc;
}

@media print {
  code[class*=language-],
  pre[class*=language-] {
    text-shadow: none;
  }
}
/* Code blocks */
pre[class*=language-] {
  padding: 1em;
  margin: 0.5em 0;
  overflow: auto;
}

:not(pre) > code[class*=language-],
pre[class*=language-] {
  background: #f5f2f0;
}

/* Inline code */
:not(pre) > code[class*=language-] {
  padding: 0.1em;
  border-radius: 0.3em;
  white-space: normal;
}

.token.comment,
.token.prolog,
.token.doctype,
.token.cdata {
  color: slategray;
}

.token.punctuation {
  color: #999;
}

.namespace {
  opacity: 0.7;
}

.token.property,
.token.tag,
.token.boolean,
.token.number,
.token.constant,
.token.symbol,
.token.deleted {
  color: #905;
}

.token.selector,
.token.attr-name,
.token.string,
.token.char,
.token.builtin,
.token.inserted {
  color: #690;
}

.token.operator,
.token.entity,
.token.url,
.language-css .token.string,
.style .token.string {
  color: #9a6e3a;
  background: hsla(0deg, 0%, 100%, 0.5);
}

.token.atrule,
.token.attr-value,
.token.keyword {
  color: #07a;
}

.token.function,
.token.class-name {
  color: #DD4A68;
}

.token.regex,
.token.important,
.token.variable {
  color: #e90;
}

.token.important,
.token.bold {
  font-weight: bold;
}

.token.italic {
  font-style: italic;
}

.token.entity {
  cursor: help;
}

/* stylelint-enable */
.mce-content-body {
  overflow-wrap: break-word;
  word-wrap: break-word;
}

.mce-content-body .mce-visual-caret {
  background-color: black;
  background-color: currentColor;
  position: absolute;
}

.mce-content-body .mce-visual-caret-hidden {
  display: none;
}

.mce-content-body *[data-mce-caret] {
  margin: 0;
  padding: 0;
  position: absolute;
  right: auto;
  left: -1000px;
  top: 0;
}

.mce-content-body .mce-offscreen-selection {
  left: -2000000px;
  max-width: 1000000px;
  position: absolute;
}

.mce-content-body *[contentEditable=false] {
  cursor: default;
}

.mce-content-body *[contentEditable=true] {
  cursor: text;
}

.tox-cursor-format-painter {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_33___}), default;
}

.mce-content-body figure.align-left {
  float: left;
}

.mce-content-body figure.align-right {
  float: right;
}

.mce-content-body figure.image.align-center {
  display: table;
  margin-left: auto;
  margin-right: auto;
}

.mce-preview-object {
  border: 1px solid gray;
  display: inline-block;
  line-height: 0;
  margin: 0 2px 0 2px;
  position: relative;
}

.mce-preview-object .mce-shim {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.mce-preview-object[data-mce-selected="2"] .mce-shim {
  display: none;
}

.mce-object {
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_35___}) no-repeat center;
  border: 1px dashed #aaa;
}

.mce-pagebreak {
  border: 1px dashed #aaa;
  cursor: default;
  display: block;
  height: 5px;
  margin-top: 15px;
  page-break-before: always;
  width: 100%;
}

@media print {
  .mce-pagebreak {
    border: 0;
  }
}
.tiny-pageembed .mce-shim {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.tiny-pageembed[data-mce-selected="2"] .mce-shim {
  display: none;
}

.tiny-pageembed {
  display: inline-block;
  position: relative;
}

.tiny-pageembed--21by9,
.tiny-pageembed--16by9,
.tiny-pageembed--4by3,
.tiny-pageembed--1by1 {
  display: block;
  overflow: hidden;
  padding: 0;
  position: relative;
  width: 100%;
}

.tiny-pageembed--21by9 {
  padding-top: 42.857143%;
}

.tiny-pageembed--16by9 {
  padding-top: 56.25%;
}

.tiny-pageembed--4by3 {
  padding-top: 75%;
}

.tiny-pageembed--1by1 {
  padding-top: 100%;
}

.tiny-pageembed--21by9 iframe,
.tiny-pageembed--16by9 iframe,
.tiny-pageembed--4by3 iframe,
.tiny-pageembed--1by1 iframe {
  border: 0;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.mce-content-body[data-mce-placeholder] {
  position: relative;
}

.mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before {
  color: rgba(34, 47, 62, 0.7);
  content: attr(data-mce-placeholder);
  position: absolute;
}

.mce-content-body:not([dir=rtl])[data-mce-placeholder]:not(.mce-visualblocks)::before {
  left: 1px;
}

.mce-content-body[dir=rtl][data-mce-placeholder]:not(.mce-visualblocks)::before {
  right: 1px;
}

.mce-content-body div.mce-resizehandle {
  background-color: #4099ff;
  border-color: #4099ff;
  border-style: solid;
  border-width: 1px;
  box-sizing: border-box;
  height: 10px;
  position: absolute;
  width: 10px;
  z-index: 10000;
}

.mce-content-body div.mce-resizehandle:hover {
  background-color: #4099ff;
}

.mce-content-body div.mce-resizehandle:nth-of-type(1) {
  cursor: nwse-resize;
}

.mce-content-body div.mce-resizehandle:nth-of-type(2) {
  cursor: nesw-resize;
}

.mce-content-body div.mce-resizehandle:nth-of-type(3) {
  cursor: nwse-resize;
}

.mce-content-body div.mce-resizehandle:nth-of-type(4) {
  cursor: nesw-resize;
}

.mce-content-body .mce-clonedresizable {
  opacity: 0.5;
  outline: 1px dashed black;
  position: absolute;
  z-index: 10000;
}

.mce-content-body .mce-resize-helper {
  background: #555;
  background: rgba(0, 0, 0, 0.75);
  border: 1px;
  border-radius: 3px;
  color: white;
  display: none;
  font-size: 12px;
  line-height: 14px;
  margin: 5px 10px;
  padding: 5px;
  position: absolute;
  white-space: nowrap;
  z-index: 10001;
}

.tox-rtc-user-selection {
  position: relative;
}

.tox-rtc-user-cursor {
  bottom: 0;
  cursor: default;
  position: absolute;
  top: 0;
  width: 2px;
}

.tox-rtc-user-cursor::before {
  background-color: inherit;
  border-radius: 50%;
  content: "";
  display: block;
  height: 8px;
  position: absolute;
  right: -3px;
  top: -3px;
  width: 8px;
}

.tox-rtc-user-cursor:hover::after {
  background-color: inherit;
  border-radius: 100px;
  box-sizing: border-box;
  color: #fff;
  content: attr(data-user);
  display: block;
  font-size: 12px;
  font-weight: bold;
  left: -5px;
  min-height: 8px;
  min-width: 8px;
  padding: 0 12px;
  position: absolute;
  top: -11px;
  white-space: nowrap;
  z-index: 1000;
}

.tox-rtc-user-selection--1 .tox-rtc-user-cursor {
  background-color: #2dc26b;
}

.tox-rtc-user-selection--2 .tox-rtc-user-cursor {
  background-color: #e03e2d;
}

.tox-rtc-user-selection--3 .tox-rtc-user-cursor {
  background-color: #f1c40f;
}

.tox-rtc-user-selection--4 .tox-rtc-user-cursor {
  background-color: #3598db;
}

.tox-rtc-user-selection--5 .tox-rtc-user-cursor {
  background-color: #b96ad9;
}

.tox-rtc-user-selection--6 .tox-rtc-user-cursor {
  background-color: #e67e23;
}

.tox-rtc-user-selection--7 .tox-rtc-user-cursor {
  background-color: #aaa69d;
}

.tox-rtc-user-selection--8 .tox-rtc-user-cursor {
  background-color: #f368e0;
}

.tox-rtc-remote-image {
  background: #eaeaea url(${___CSS_LOADER_URL_REPLACEMENT_36___}) no-repeat center center;
  border: 1px solid #ccc;
  min-height: 240px;
  min-width: 320px;
}

.mce-match-marker {
  background: #aaa;
  color: #fff;
}

.mce-match-marker-selected {
  background: #39f;
  color: #fff;
}

.mce-match-marker-selected::selection {
  background: #39f;
  color: #fff;
}

.mce-content-body img[data-mce-selected],
.mce-content-body table[data-mce-selected] {
  outline: 3px solid #b4d7ff;
}

.mce-content-body hr[data-mce-selected] {
  outline: 3px solid #b4d7ff;
  outline-offset: 1px;
}

.mce-content-body *[contentEditable=false] *[contentEditable=true]:focus {
  outline: 3px solid #b4d7ff;
}

.mce-content-body *[contentEditable=false] *[contentEditable=true]:hover {
  outline: 3px solid #b4d7ff;
}

.mce-content-body *[contentEditable=false][data-mce-selected] {
  cursor: not-allowed;
  outline: 3px solid #b4d7ff;
}

.mce-content-body.mce-content-readonly *[contentEditable=true]:focus,
.mce-content-body.mce-content-readonly *[contentEditable=true]:hover {
  outline: none;
}

.mce-content-body *[data-mce-selected=inline-boundary] {
  background-color: #b4d7ff;
}

.mce-content-body .mce-edit-focus {
  outline: 3px solid #b4d7ff;
}

.mce-content-body td[data-mce-selected],
.mce-content-body th[data-mce-selected] {
  background-color: #b4d7ff !important;
}

.mce-content-body td[data-mce-selected]::selection,
.mce-content-body th[data-mce-selected]::selection {
  background: none;
}

.mce-content-body td[data-mce-selected] *,
.mce-content-body th[data-mce-selected] * {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

.mce-content-body img::selection {
  background: none;
}

.ephox-snooker-resizer-bar {
  background-color: #b4d7ff;
  opacity: 0;
  -webkit-user-select: none;
  user-select: none;
}

.ephox-snooker-resizer-cols {
  cursor: col-resize;
}

.ephox-snooker-resizer-rows {
  cursor: row-resize;
}

.ephox-snooker-resizer-bar.ephox-snooker-resizer-bar-dragging {
  opacity: 1;
}

.mce-spellchecker-word {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
  background-position: 0 calc(100% + 1px);
  background-repeat: repeat-x;
  background-size: auto 6px;
  cursor: default;
  height: 2rem;
}

.mce-spellchecker-grammar {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  background-position: 0 calc(100% + 1px);
  background-repeat: repeat-x;
  background-size: auto 6px;
  cursor: default;
}

.mce-toc {
  border: 1px solid gray;
}

.mce-toc h2 {
  margin: 4px;
}

.mce-toc li {
  list-style-type: none;
}

.mce-item-table,
.mce-item-table td,
.mce-item-table th,
.mce-item-table caption {
  border: 1px dashed #bbb;
}

.mce-visualblocks p,
.mce-visualblocks h1,
.mce-visualblocks h2,
.mce-visualblocks h3,
.mce-visualblocks h4,
.mce-visualblocks h5,
.mce-visualblocks h6,
.mce-visualblocks div:not([data-mce-bogus]),
.mce-visualblocks section,
.mce-visualblocks article,
.mce-visualblocks blockquote,
.mce-visualblocks address,
.mce-visualblocks pre,
.mce-visualblocks figure,
.mce-visualblocks figcaption,
.mce-visualblocks hgroup,
.mce-visualblocks aside,
.mce-visualblocks ul,
.mce-visualblocks ol,
.mce-visualblocks dl {
  background-repeat: no-repeat;
  border: 1px dashed #bbb;
  margin-left: 3px;
  padding-top: 10px;
}

.mce-visualblocks p {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
}

.mce-visualblocks h1 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}

.mce-visualblocks h2 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
}

.mce-visualblocks h3 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
}

.mce-visualblocks h4 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
}

.mce-visualblocks h5 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
}

.mce-visualblocks h6 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
}

.mce-visualblocks div:not([data-mce-bogus]) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
}

.mce-visualblocks section {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
}

.mce-visualblocks article {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
}

.mce-visualblocks blockquote {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
}

.mce-visualblocks address {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
}

.mce-visualblocks pre {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_51___});
}

.mce-visualblocks figure {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
}

.mce-visualblocks figcaption {
  border: 1px dashed #bbb;
}

.mce-visualblocks hgroup {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_53___});
}

.mce-visualblocks aside {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
}

.mce-visualblocks ul {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
}

.mce-visualblocks ol {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
}

.mce-visualblocks dl {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_57___});
}

.mce-visualblocks p,
.mce-visualblocks h1,
.mce-visualblocks h2,
.mce-visualblocks h3,
.mce-visualblocks h4,
.mce-visualblocks h5,
.mce-visualblocks h6,
.mce-visualblocks div:not([data-mce-bogus]),
.mce-visualblocks section,
.mce-visualblocks article,
.mce-visualblocks blockquote,
.mce-visualblocks address,
.mce-visualblocks pre,
.mce-visualblocks figure,
.mce-visualblocks figcaption,
.mce-visualblocks hgroup,
.mce-visualblocks aside,
.mce-visualblocks ul,
.mce-visualblocks ol,
.mce-visualblocks dl {
  margin-left: 3px;
}

.mce-nbsp,
.mce-shy {
  background: #aaa;
}

.mce-shy::after {
  content: "-";
}

.tinymce-inline:focus {
  box-shadow: none;
  outline: none;
}

/**
 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
 * Licensed under the LGPL or a commercial license.
 * For LGPL see License.txt in the project root for license information.
 * For commercial licenses see https://www.tiny.cloud/
 */
.tinymce-mobile-unfocused-selections .tinymce-mobile-unfocused-selection {
  /* Note: this file is used inside the content, so isn't part of theming */
  background-color: green;
  display: inline-block;
  opacity: 0.5;
  position: absolute;
}

.mce-content-body body {
  -webkit-text-size-adjust: none;
}
.mce-content-body body img {
  /* this is related to the content margin */
  max-width: 96vw;
}
.mce-content-body body table img {
  max-width: 95%;
}
.mce-content-body table {
  border-collapse: collapse;
}

/*
 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
 * Licensed under the LGPL or a commercial license.
 * For LGPL see License.txt in the project root for license information.
 * For commercial licenses see https://www.tiny.cloud/
 */
.tox {
  box-sizing: content-box;
  color: #526484;
  cursor: auto;
  font-size: 16px;
  font-style: normal;
  font-weight: normal;
  line-height: normal;
  -webkit-tap-highlight-color: transparent;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  vertical-align: initial;
  white-space: normal;
}

.tox *:not(svg):not(rect) {
  box-sizing: inherit;
  cursor: inherit;
  direction: inherit;
  font-size: inherit;
  font-style: inherit;
  font-weight: inherit;
  line-height: inherit;
  -webkit-tap-highlight-color: inherit;
  text-align: inherit;
  text-decoration: inherit;
  text-transform: inherit;
  vertical-align: inherit;
  white-space: inherit;
}

.tox *:not(svg):not(rect) {
  /* stylelint-disable-line no-duplicate-selectors */
  background: transparent;
  border: 0;
  float: none;
  height: auto;
  margin: 0;
  max-width: none;
  outline: 0;
  padding: 0;
  position: static;
  width: auto;
}

.tox {
  direction: ltr;
  text-align: left;
}

.tox-tinymce {
  border: 1px solid #e5e9f2 !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
  position: relative !important;
  visibility: inherit !important;
}

.tox-tinymce-inline {
  border: none;
  box-shadow: none;
}

.tox-tinymce-inline .tox-editor-header {
  border: 1px solid #e5e9f2;
  border-radius: 0;
  box-shadow: none;
}

.tox-tinymce-aux {
  z-index: 1300;
}

.tox-tinymce *:focus,
.tox-tinymce-aux *:focus {
  outline: none;
}

button::-moz-focus-inner {
  border: 0;
}

.tox .accessibility-issue__header {
  align-items: center;
  display: flex;
  margin-bottom: 4px;
}

.tox .accessibility-issue__description {
  align-items: stretch;
  border: 1px solid #e5e9f2;
  border-radius: 3px;
  display: flex;
  justify-content: space-between;
}

.tox .accessibility-issue__description > div {
  padding-bottom: 4px;
}

.tox .accessibility-issue__description > div > div {
  align-items: center;
  display: flex;
  margin-bottom: 4px;
}

.tox .accessibility-issue__description > *:last-child:not(:only-child) {
  border-color: #e5e9f2;
  border-style: solid;
}

.tox .accessibility-issue__repair {
  margin-top: 16px;
}

.tox .tox-dialog__body-content .accessibility-issue--info .accessibility-issue__description {
  background-color: rgba(32, 122, 183, 0.1);
  border-color: rgba(32, 122, 183, 0.4);
  color: #526484;
}

.tox .tox-dialog__body-content .accessibility-issue--info .accessibility-issue__description > *:last-child {
  border-color: rgba(32, 122, 183, 0.4);
}

.tox .tox-dialog__body-content .accessibility-issue--info .tox-form__group h2 {
  color: #207ab7;
}

.tox .tox-dialog__body-content .accessibility-issue--info .tox-icon svg {
  fill: #207ab7;
}

.tox .tox-dialog__body-content .accessibility-issue--info a .tox-icon {
  color: #207ab7;
}

.tox .tox-dialog__body-content .accessibility-issue--warn .accessibility-issue__description {
  background-color: rgba(255, 165, 0, 0.1);
  border-color: rgba(255, 165, 0, 0.5);
  color: #526484;
}

.tox .tox-dialog__body-content .accessibility-issue--warn .accessibility-issue__description > *:last-child {
  border-color: rgba(255, 165, 0, 0.5);
}

.tox .tox-dialog__body-content .accessibility-issue--warn .tox-form__group h2 {
  color: #cc8500;
}

.tox .tox-dialog__body-content .accessibility-issue--warn .tox-icon svg {
  fill: #cc8500;
}

.tox .tox-dialog__body-content .accessibility-issue--warn a .tox-icon {
  color: #cc8500;
}

.tox .tox-dialog__body-content .accessibility-issue--error .accessibility-issue__description {
  background-color: rgba(204, 0, 0, 0.1);
  border-color: rgba(204, 0, 0, 0.4);
  color: #526484;
}

.tox .tox-dialog__body-content .accessibility-issue--error .accessibility-issue__description > *:last-child {
  border-color: rgba(204, 0, 0, 0.4);
}

.tox .tox-dialog__body-content .accessibility-issue--error .tox-form__group h2 {
  color: #c00;
}

.tox .tox-dialog__body-content .accessibility-issue--error .tox-icon svg {
  fill: #c00;
}

.tox .tox-dialog__body-content .accessibility-issue--error a .tox-icon {
  color: #c00;
}

.tox .tox-dialog__body-content .accessibility-issue--success .accessibility-issue__description {
  background-color: rgba(120, 171, 70, 0.1);
  border-color: rgba(120, 171, 70, 0.4);
  color: #526484;
}

.tox .tox-dialog__body-content .accessibility-issue--success .accessibility-issue__description > *:last-child {
  border-color: rgba(120, 171, 70, 0.4);
}

.tox .tox-dialog__body-content .accessibility-issue--success .tox-form__group h2 {
  color: #78AB46;
}

.tox .tox-dialog__body-content .accessibility-issue--success .tox-icon svg {
  fill: #78AB46;
}

.tox .tox-dialog__body-content .accessibility-issue--success a .tox-icon {
  color: #78AB46;
}

.tox .tox-dialog__body-content .accessibility-issue__header h1,
.tox .tox-dialog__body-content .tox-form__group .accessibility-issue__description h2 {
  margin-top: 0;
}

.tox .tox-dialog__body-content .accessibility-issue__header .tox-button {
  margin-left: 4px;
}

.tox .tox-dialog__body-content .accessibility-issue__header > *:nth-last-child(2) {
  margin-left: auto;
}

.tox .tox-dialog__body-content .accessibility-issue__description {
  padding: 4px 4px 4px 8px;
}

.tox .tox-dialog__body-content .accessibility-issue__description > *:last-child {
  border-left-width: 1px;
  padding-left: 4px;
}

.tox .tox-anchorbar {
  display: flex;
  flex: 0 0 auto;
}

.tox .tox-bar {
  display: flex;
  flex: 0 0 auto;
}

.tox .tox-button {
  background-color: #207ab7;
  background-image: none;
  background-position: 0 0;
  background-repeat: repeat;
  border-color: #207ab7;
  border-radius: 3px;
  border-style: solid;
  border-width: 1px;
  box-shadow: none;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  font-style: normal;
  font-weight: bold;
  letter-spacing: normal;
  line-height: 24px;
  margin: 0;
  outline: none;
  padding: 4px 16px;
  text-align: center;
  text-decoration: none;
  text-transform: capitalize;
  white-space: nowrap;
}

.tox .tox-button[disabled] {
  background-color: #207ab7;
  background-image: none;
  border-color: #207ab7;
  box-shadow: none;
  color: rgba(255, 255, 255, 0.5);
  cursor: not-allowed;
}

.tox .tox-button:focus:not(:disabled) {
  background-color: #1c6ca1;
  background-image: none;
  border-color: #1c6ca1;
  box-shadow: none;
  color: #fff;
}

.tox .tox-button:hover:not(:disabled) {
  background-color: #1c6ca1;
  background-image: none;
  border-color: #1c6ca1;
  box-shadow: none;
  color: #fff;
}

.tox .tox-button:active:not(:disabled) {
  background-color: #185d8c;
  background-image: none;
  border-color: #185d8c;
  box-shadow: none;
  color: #fff;
}

.tox .tox-button--secondary {
  background-color: #f0f0f0;
  background-image: none;
  background-position: 0 0;
  background-repeat: repeat;
  border-color: #f0f0f0;
  border-radius: 3px;
  border-style: solid;
  border-width: 1px;
  box-shadow: none;
  color: #526484;
  font-size: 14px;
  font-style: normal;
  font-weight: bold;
  letter-spacing: normal;
  outline: none;
  padding: 4px 16px;
  text-decoration: none;
  text-transform: capitalize;
}

.tox .tox-button--secondary[disabled] {
  background-color: #f0f0f0;
  background-image: none;
  border-color: #f0f0f0;
  box-shadow: none;
  color: rgba(82, 100, 132, 0.5);
}

.tox .tox-button--secondary:focus:not(:disabled) {
  background-color: #e3e3e3;
  background-image: none;
  border-color: #e3e3e3;
  box-shadow: none;
  color: #526484;
}

.tox .tox-button--secondary:hover:not(:disabled) {
  background-color: #e3e3e3;
  background-image: none;
  border-color: #e3e3e3;
  box-shadow: none;
  color: #526484;
}

.tox .tox-button--secondary:active:not(:disabled) {
  background-color: #d6d6d6;
  background-image: none;
  border-color: #d6d6d6;
  box-shadow: none;
  color: #526484;
}

.tox .tox-button--icon,
.tox .tox-button.tox-button--icon,
.tox .tox-button.tox-button--secondary.tox-button--icon {
  padding: 4px;
}

.tox .tox-button--icon .tox-icon svg,
.tox .tox-button.tox-button--icon .tox-icon svg,
.tox .tox-button.tox-button--secondary.tox-button--icon .tox-icon svg {
  display: block;
  fill: currentColor;
}

.tox .tox-button-link {
  background: 0;
  border: none;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block;
  font-size: 16px;
  font-weight: normal;
  line-height: 1.3;
  margin: 0;
  padding: 0;
  white-space: nowrap;
}

.tox .tox-button-link--sm {
  font-size: 14px;
}

.tox .tox-button--naked {
  background-color: transparent;
  border-color: transparent;
  box-shadow: unset;
  color: #526484;
}

.tox .tox-button--naked[disabled] {
  background-color: #f0f0f0;
  border-color: #f0f0f0;
  box-shadow: none;
  color: rgba(82, 100, 132, 0.5);
}

.tox .tox-button--naked:hover:not(:disabled) {
  background-color: #e3e3e3;
  border-color: #e3e3e3;
  box-shadow: none;
  color: #526484;
}

.tox .tox-button--naked:focus:not(:disabled) {
  background-color: #e3e3e3;
  border-color: #e3e3e3;
  box-shadow: none;
  color: #526484;
}

.tox .tox-button--naked:active:not(:disabled) {
  background-color: #d6d6d6;
  border-color: #d6d6d6;
  box-shadow: none;
  color: #526484;
}

.tox .tox-button--naked .tox-icon svg {
  fill: currentColor;
}

.tox .tox-button--naked.tox-button--icon:hover:not(:disabled) {
  color: #526484;
}

.tox .tox-checkbox {
  align-items: center;
  border-radius: 3px;
  cursor: pointer;
  display: flex;
  height: 36px;
  min-width: 36px;
}

.tox .tox-checkbox__input {
  /* Hide from view but visible to screen readers */
  height: 1px;
  overflow: hidden;
  position: absolute;
  top: auto;
  width: 1px;
}

.tox .tox-checkbox__icons {
  align-items: center;
  border-radius: 3px;
  box-shadow: 0 0 0 2px transparent;
  box-sizing: content-box;
  display: flex;
  height: 24px;
  justify-content: center;
  padding: 3px;
  width: 24px;
}

.tox .tox-checkbox__icons .tox-checkbox-icon__unchecked svg {
  display: block;
  fill: rgba(34, 47, 62, 0.3);
}

.tox .tox-checkbox__icons .tox-checkbox-icon__indeterminate svg {
  display: none;
  fill: #207ab7;
}

.tox .tox-checkbox__icons .tox-checkbox-icon__checked svg {
  display: none;
  fill: #207ab7;
}

.tox .tox-checkbox--disabled {
  color: rgba(82, 100, 132, 0.5);
  cursor: not-allowed;
}

.tox .tox-checkbox--disabled .tox-checkbox__icons .tox-checkbox-icon__checked svg {
  fill: rgba(82, 100, 132, 0.5);
}

.tox .tox-checkbox--disabled .tox-checkbox__icons .tox-checkbox-icon__unchecked svg {
  fill: rgba(82, 100, 132, 0.5);
}

.tox .tox-checkbox--disabled .tox-checkbox__icons .tox-checkbox-icon__indeterminate svg {
  fill: rgba(82, 100, 132, 0.5);
}

.tox input.tox-checkbox__input:checked + .tox-checkbox__icons .tox-checkbox-icon__unchecked svg {
  display: none;
}

.tox input.tox-checkbox__input:checked + .tox-checkbox__icons .tox-checkbox-icon__checked svg {
  display: block;
}

.tox input.tox-checkbox__input:indeterminate + .tox-checkbox__icons .tox-checkbox-icon__unchecked svg {
  display: none;
}

.tox input.tox-checkbox__input:indeterminate + .tox-checkbox__icons .tox-checkbox-icon__indeterminate svg {
  display: block;
}

.tox input.tox-checkbox__input:focus + .tox-checkbox__icons {
  border-radius: 3px;
  box-shadow: inset 0 0 0 1px #207ab7;
  padding: 3px;
}

.tox .tox-checkbox__label {
  margin-left: 4px;
}

.tox .tox-checkbox__input {
  left: -10000px;
}

.tox .tox-bar .tox-checkbox {
  margin-left: 4px;
}

.tox {
  /* stylelint-disable-next-line no-descending-specificity */
}

.tox .tox-collection--toolbar .tox-collection__group {
  display: flex !important;
  padding: 0 !important;
}

.tox .tox-collection--grid .tox-collection__group {
  display: flex !important;
  flex-wrap: wrap !important;
  max-height: 208px !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  padding: 0 !important;
}

.tox .tox-collection--list .tox-collection__group {
  border-bottom-width: 0 !important;
  border-color: #e5e9f2 !important;
  border-left-width: 0 !important;
  border-right-width: 0 !important;
  border-style: solid !important;
  border-top-width: 1px !important;
  padding: 4px 0 !important;
}

.tox .tox-collection--list .tox-collection__group:first-child {
  border-top-width: 0 !important;
}

.tox .tox-collection__group-heading {
  background-color: #e6e6e6 !important;
  color: rgba(34, 47, 62, 0.7) !important;
  cursor: default !important;
  font-size: 12px !important;
  font-style: normal !important;
  font-weight: normal !important;
  margin-bottom: 4px !important;
  margin-top: -4px !important;
  padding: 4px 8px !important;
  text-transform: none !important;
  -webkit-touch-callout: none !important;
  -webkit-user-select: none !important;
  user-select: none !important;
}

.tox .tox-collection__item {
  align-items: center !important;
  color: #526484 !important;
  cursor: pointer !important;
  display: flex !important;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none !important;
}

.tox .tox-collection--list .tox-collection__item {
  padding: 4px 8px !important;
}

.tox .tox-collection--toolbar .tox-collection__item {
  border-radius: 3px !important;
  padding: 4px !important;
}

.tox .tox-collection--grid .tox-collection__item {
  border-radius: 3px !important;
  padding: 4px !important;
}

.tox .tox-collection--list .tox-collection__item--enabled {
  background-color: #fff !important;
  color: #526484 !important;
}

.tox .tox-collection--list .tox-collection__item--active {
  background-color: #ebeef2 !important;
}

.tox .tox-collection--toolbar .tox-collection__item--enabled {
  background-color: #c8cbcf !important;
  color: #526484 !important;
}

.tox .tox-collection--toolbar .tox-collection__item--active {
  background-color: #ebeef2 !important;
}

.tox .tox-collection--grid .tox-collection__item--enabled {
  background-color: #c8cbcf !important;
  color: #526484 !important;
}

.tox .tox-collection--grid .tox-collection__item--active:not(.tox-collection__item--state-disabled) {
  background-color: #ebeef2 !important;
  color: #526484 !important;
}

.tox .tox-collection--list .tox-collection__item--active:not(.tox-collection__item--state-disabled) {
  color: #526484 !important;
}

.tox .tox-collection--toolbar .tox-collection__item--active:not(.tox-collection__item--state-disabled) {
  color: #526484 !important;
}

.tox .tox-collection__item--state-disabled {
  background-color: transparent !important;
  color: rgba(82, 100, 132, 0.5) !important;
  cursor: not-allowed !important;
}

.tox .tox-collection__item-icon,
.tox .tox-collection__item-checkmark {
  align-items: center !important;
  display: flex !important;
  height: 24px !important;
  justify-content: center !important;
  width: 24px !important;
}

.tox .tox-collection__item-icon svg,
.tox .tox-collection__item-checkmark svg {
  fill: currentColor !important;
}

.tox .tox-collection--toolbar-lg .tox-collection__item-icon {
  height: 48px !important;
  width: 48px !important;
}

.tox .tox-collection__item-label {
  color: currentColor !important;
  display: inline-block !important;
  flex: 1 1 !important;
  -ms-flex-preferred-size: auto;
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: normal !important;
  line-height: 24px !important;
  text-transform: none !important;
  word-break: break-all !important;
}

.tox .tox-collection__item-accessory {
  color: rgba(34, 47, 62, 0.7) !important;
  display: inline-block !important;
  font-size: 14px !important;
  height: 24px !important;
  line-height: 24px !important;
  text-transform: none !important;
}

.tox .tox-collection__item-caret {
  align-items: center !important;
  display: flex !important;
  min-height: 24px !important;
}

.tox .tox-collection__item-caret::after {
  content: "" !important;
  font-size: 0 !important;
  min-height: inherit !important;
}

.tox .tox-collection__item-caret svg {
  fill: #526484 !important;
}

.tox .tox-collection--list .tox-collection__item:not(.tox-collection__item--enabled) .tox-collection__item-checkmark svg {
  display: none !important;
}

.tox .tox-collection--list .tox-collection__item:not(.tox-collection__item--enabled) .tox-collection__item-accessory + .tox-collection__item-checkmark {
  display: none !important;
}

.tox .tox-collection--horizontal {
  background-color: #fff !important;
  border: 1px solid #e5e9f2 !important;
  border-radius: 3px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15) !important;
  display: flex !important;
  flex: 0 0 auto !important;
  flex-shrink: 0 !important;
  flex-wrap: nowrap !important;
  margin-bottom: 0 !important;
  overflow-x: auto !important;
  padding: 0 !important;
}

.tox .tox-collection--horizontal .tox-collection__group {
  align-items: center !important;
  display: flex !important;
  flex-wrap: nowrap !important;
  margin: 0 !important;
  padding: 0 4px !important;
}

.tox .tox-collection--horizontal .tox-collection__item {
  height: 34px !important;
  margin: 2px 0 3px 0 !important;
  padding: 0 4px !important;
}

.tox .tox-collection--horizontal .tox-collection__item-label {
  white-space: nowrap !important;
}

.tox .tox-collection--horizontal .tox-collection__item-caret {
  margin-left: 4px !important;
}

.tox .tox-collection--horizontal .tox-collection__group:not(:last-of-type) {
  border-right: 1px solid #e5e9f2 !important;
}

.tox .tox-collection--list .tox-collection__item > *:not(:first-child) {
  margin-left: 8px !important;
}

.tox .tox-collection--list .tox-collection__item-label:first-child {
  margin-left: 4px !important;
}

.tox .tox-collection__item-accessory {
  margin-left: 16px !important;
  text-align: right !important;
}

.tox .tox-collection .tox-collection__item-caret {
  margin-left: 16px !important;
}

.tox .tox-color-picker-container {
  display: flex !important;
  flex-direction: row !important;
  height: 225px !important;
  margin: 0 !important;
}

.tox .tox-sv-palette {
  box-sizing: border-box;
  display: flex;
  height: 100%;
}

.tox .tox-sv-palette-spectrum {
  height: 100%;
}

.tox .tox-sv-palette,
.tox .tox-sv-palette-spectrum {
  width: 225px;
}

.tox .tox-sv-palette-thumb {
  background: none;
  border: 1px solid black;
  border-radius: 50%;
  box-sizing: content-box;
  height: 12px;
  position: absolute;
  width: 12px;
}

.tox .tox-sv-palette-inner-thumb {
  border: 1px solid white;
  border-radius: 50%;
  height: 10px;
  position: absolute;
  width: 10px;
}

.tox .tox-hue-slider {
  box-sizing: border-box;
  height: 100%;
  width: 25px;
}

.tox .tox-hue-slider-spectrum {
  background: linear-gradient(to bottom, #f00, #ff0080, #f0f, #8000ff, #00f, #0080ff, #0ff, #00ff80, #0f0, #80ff00, #ff0, #ff8000, #f00);
  height: 100%;
  width: 100%;
}

.tox .tox-hue-slider,
.tox .tox-hue-slider-spectrum {
  width: 20px;
}

.tox .tox-hue-slider-thumb {
  background: white;
  border: 1px solid black;
  box-sizing: content-box;
  height: 4px;
  width: 100%;
}

.tox .tox-rgb-form {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.tox .tox-rgb-form div {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  width: inherit;
}

.tox .tox-rgb-form input {
  width: 6em;
}

.tox .tox-rgb-form input.tox-invalid {
  /* Need !important to override Chrome's focus styling unfortunately */
  border: 1px solid red !important;
}

.tox .tox-rgb-form .tox-rgba-preview {
  border: 1px solid black;
  flex-grow: 2;
  margin-bottom: 0;
}

.tox .tox-sv-palette {
  margin-right: 15px;
}

.tox .tox-hue-slider {
  margin-right: 15px;
}

.tox .tox-hue-slider-thumb {
  margin-left: -1px;
}

.tox .tox-rgb-form label {
  margin-right: 0.5em;
}

.tox .tox-toolbar .tox-swatches,
.tox .tox-toolbar__primary .tox-swatches,
.tox .tox-toolbar__overflow .tox-swatches {
  margin: 2px 0 3px 4px;
}

.tox .tox-collection--list .tox-collection__group .tox-swatches-menu {
  border: 0;
  margin: -4px 0;
}

.tox .tox-swatches__row {
  display: flex;
}

.tox .tox-swatch {
  height: 30px;
  transition: transform 0.15s, box-shadow 0.15s;
  width: 30px;
}

.tox .tox-swatch:hover,
.tox .tox-swatch:focus {
  box-shadow: 0 0 0 1px rgba(127, 127, 127, 0.3) inset;
  transform: scale(0.8);
}

.tox .tox-swatch--remove {
  align-items: center;
  display: flex;
  justify-content: center;
}

.tox .tox-swatch--remove svg path {
  stroke: #e74c3c;
}

.tox .tox-swatches__picker-btn {
  align-items: center;
  background-color: transparent;
  border: 0;
  cursor: pointer;
  display: flex;
  height: 30px;
  justify-content: center;
  outline: none;
  padding: 0;
  width: 30px;
}

.tox .tox-swatches__picker-btn svg {
  height: 24px;
  width: 24px;
}

.tox .tox-swatches__picker-btn:hover {
  background: #ebeef2;
}

.tox .tox-swatches__picker-btn {
  margin-left: auto;
}

.tox .tox-comment-thread {
  background: #fff;
  position: relative;
}

.tox .tox-comment-thread > *:not(:first-child) {
  margin-top: 8px;
}

.tox .tox-comment {
  background: #fff;
  border: 1px solid #e5e9f2;
  border-radius: 3px;
  box-shadow: 0 4px 8px 0 rgba(34, 47, 62, 0.1);
  padding: 8px 8px 16px 8px;
  position: relative;
}

.tox .tox-comment__header {
  align-items: center;
  color: #526484;
  display: flex;
  justify-content: space-between;
}

.tox .tox-comment__date {
  color: rgba(34, 47, 62, 0.7);
  font-size: 12px;
}

.tox .tox-comment__body {
  color: #526484;
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  line-height: 1.3;
  margin-top: 8px;
  position: relative;
  text-transform: initial;
}

.tox .tox-comment__body textarea {
  resize: none;
  white-space: normal;
  width: 100%;
}

.tox .tox-comment__expander {
  padding-top: 8px;
}

.tox .tox-comment__expander p {
  color: rgba(34, 47, 62, 0.7);
  font-size: 14px;
  font-style: normal;
}

.tox .tox-comment__body p {
  margin: 0;
}

.tox .tox-comment__buttonspacing {
  padding-top: 16px;
  text-align: center;
}

.tox .tox-comment-thread__overlay::after {
  background: #fff;
  bottom: 0;
  content: "";
  display: flex;
  left: 0;
  opacity: 0.9;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 5;
}

.tox .tox-comment__reply {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin-top: 8px;
}

.tox .tox-comment__reply > *:first-child {
  margin-bottom: 8px;
  width: 100%;
}

.tox .tox-comment__edit {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin-top: 16px;
}

.tox .tox-comment__gradient::after {
  background: linear-gradient(rgba(255, 255, 255, 0), #fff);
  bottom: 0;
  content: "";
  display: block;
  height: 5em;
  margin-top: -40px;
  position: absolute;
  width: 100%;
}

.tox .tox-comment__overlay {
  background: #fff;
  bottom: 0;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  left: 0;
  opacity: 0.9;
  position: absolute;
  right: 0;
  text-align: center;
  top: 0;
  z-index: 5;
}

.tox .tox-comment__loading-text {
  align-items: center;
  color: #526484;
  display: flex;
  flex-direction: column;
  position: relative;
}

.tox .tox-comment__loading-text > div {
  padding-bottom: 16px;
}

.tox .tox-comment__overlaytext {
  bottom: 0;
  flex-direction: column;
  font-size: 14px;
  left: 0;
  padding: 1em;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 10;
}

.tox .tox-comment__overlaytext p {
  background-color: #fff;
  box-shadow: 0 0 8px 8px #fff;
  color: #526484;
  text-align: center;
}

.tox .tox-comment__overlaytext div:nth-of-type(2) {
  font-size: 0.8em;
}

.tox .tox-comment__busy-spinner {
  align-items: center;
  background-color: #fff;
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 20;
}

.tox .tox-comment__scroll {
  display: flex;
  flex-direction: column;
  flex-shrink: 1;
  overflow: auto;
}

.tox .tox-conversations {
  margin: 8px;
}

.tox .tox-comment__edit {
  margin-left: 8px;
}

.tox .tox-comment__buttonspacing > *:last-child,
.tox .tox-comment__edit > *:last-child,
.tox .tox-comment__reply > *:last-child {
  margin-left: 8px;
}

.tox .tox-user {
  align-items: center;
  display: flex;
}

.tox .tox-user__avatar svg {
  fill: rgba(34, 47, 62, 0.7);
}

.tox .tox-user__name {
  color: rgba(34, 47, 62, 0.7);
  font-size: 12px;
  font-style: normal;
  font-weight: bold;
  text-transform: uppercase;
}

.tox .tox-user__avatar svg {
  margin-right: 8px;
}

.tox .tox-user__avatar + .tox-user__name {
  margin-left: 8px;
}

.tox .tox-dialog-wrap {
  align-items: center;
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1100;
}

.tox .tox-dialog-wrap__backdrop {
  background-color: rgba(255, 255, 255, 0.75);
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;
}

.tox .tox-dialog-wrap__backdrop--opaque {
  background-color: #fff;
}

.tox .tox-dialog {
  background-color: #fff;
  border-color: #e5e9f2;
  border-radius: 3px;
  border-style: solid;
  border-width: 1px;
  box-shadow: 0 16px 16px -10px rgba(34, 47, 62, 0.15), 0 0 40px 1px rgba(34, 47, 62, 0.15);
  display: flex;
  flex-direction: column;
  max-height: 100%;
  max-width: 480px;
  overflow: hidden;
  position: relative;
  width: 95vw;
  z-index: 2;
}

@media only screen and (max-width: 767px) {
  body:not(.tox-force-desktop) .tox .tox-dialog {
    align-self: flex-start;
    margin: 8px auto;
    width: calc(100vw - 16px);
  }
}
.tox .tox-dialog-inline {
  z-index: 1100;
}

.tox .tox-dialog__header {
  align-items: center;
  background-color: #fff;
  border-bottom: none;
  color: #526484;
  display: flex;
  font-size: 16px;
  justify-content: space-between;
  padding: 8px 16px 0 16px;
  position: relative;
}

.tox .tox-dialog__header .tox-button {
  z-index: 1;
}

.tox .tox-dialog__draghandle {
  cursor: grab;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.tox .tox-dialog__draghandle:active {
  cursor: grabbing;
}

.tox .tox-dialog__dismiss {
  margin-left: auto;
}

.tox .tox-dialog__title {
  font-size: 20px;
  font-style: normal;
  font-weight: normal;
  line-height: 1.3;
  margin: 0;
  text-transform: none;
}

.tox .tox-dialog__body {
  color: #526484;
  display: flex;
  flex: 1 1;
  -ms-flex-preferred-size: auto;
  font-size: 16px;
  font-style: normal;
  font-weight: normal;
  line-height: 1.3;
  min-width: 0;
  text-align: left;
  text-transform: none;
}

@media only screen and (max-width: 767px) {
  body:not(.tox-force-desktop) .tox .tox-dialog__body {
    flex-direction: column;
  }
}
.tox .tox-dialog__body-nav {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  padding: 16px 16px;
}

@media only screen and (max-width: 767px) {
  body:not(.tox-force-desktop) .tox .tox-dialog__body-nav {
    flex-direction: row;
    -webkit-overflow-scrolling: touch;
    overflow-x: auto;
    padding-bottom: 0;
  }
}
.tox .tox-dialog__body-nav-item {
  border-bottom: 2px solid transparent;
  color: rgba(34, 47, 62, 0.7);
  display: inline-block;
  font-size: 14px;
  line-height: 1.3;
  margin-bottom: 8px;
  text-decoration: none;
  white-space: nowrap;
}

.tox .tox-dialog__body-nav-item:focus {
  background-color: rgba(32, 122, 183, 0.1);
}

.tox .tox-dialog__body-nav-item--active {
  border-bottom: 2px solid #207ab7;
  color: #207ab7;
}

.tox .tox-dialog__body-content {
  box-sizing: border-box;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  -ms-flex-preferred-size: auto;
  max-height: 650px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  padding: 16px 16px;
}

.tox .tox-dialog__body-content > * {
  margin-bottom: 0;
  margin-top: 16px;
}

.tox .tox-dialog__body-content > *:first-child {
  margin-top: 0;
}

.tox .tox-dialog__body-content > *:last-child {
  margin-bottom: 0;
}

.tox .tox-dialog__body-content > *:only-child {
  margin-bottom: 0;
  margin-top: 0;
}

.tox .tox-dialog__body-content a {
  color: #207ab7;
  cursor: pointer;
  text-decoration: none;
}

.tox .tox-dialog__body-content a:hover,
.tox .tox-dialog__body-content a:focus {
  color: #185d8c;
  text-decoration: none;
}

.tox .tox-dialog__body-content a:active {
  color: #185d8c;
  text-decoration: none;
}

.tox .tox-dialog__body-content svg {
  fill: #526484;
}

.tox .tox-dialog__body-content ul {
  display: block;
  list-style-type: disc;
  margin-bottom: 16px;
  margin-inline-end: 0;
  margin-inline-start: 0;
  padding-inline-start: 2.5rem;
}

.tox .tox-dialog__body-content .tox-form__group h1 {
  color: #526484;
  font-size: 20px;
  font-style: normal;
  font-weight: bold;
  letter-spacing: normal;
  margin-bottom: 16px;
  margin-top: 2rem;
  text-transform: none;
}

.tox .tox-dialog__body-content .tox-form__group h2 {
  color: #526484;
  font-size: 16px;
  font-style: normal;
  font-weight: bold;
  letter-spacing: normal;
  margin-bottom: 16px;
  margin-top: 2rem;
  text-transform: none;
}

.tox .tox-dialog__body-content .tox-form__group p {
  margin-bottom: 16px;
}

.tox .tox-dialog__body-content .tox-form__group h1:first-child,
.tox .tox-dialog__body-content .tox-form__group h2:first-child,
.tox .tox-dialog__body-content .tox-form__group p:first-child {
  margin-top: 0;
}

.tox .tox-dialog__body-content .tox-form__group h1:last-child,
.tox .tox-dialog__body-content .tox-form__group h2:last-child,
.tox .tox-dialog__body-content .tox-form__group p:last-child {
  margin-bottom: 0;
}

.tox .tox-dialog__body-content .tox-form__group h1:only-child,
.tox .tox-dialog__body-content .tox-form__group h2:only-child,
.tox .tox-dialog__body-content .tox-form__group p:only-child {
  margin-bottom: 0;
  margin-top: 0;
}

.tox .tox-dialog--width-lg {
  height: 650px;
  max-width: 1200px;
}

.tox .tox-dialog--width-md {
  max-width: 800px;
}

.tox .tox-dialog--width-md .tox-dialog__body-content {
  overflow: auto;
}

.tox .tox-dialog__body-content--centered {
  text-align: center;
}

.tox .tox-dialog__footer {
  align-items: center;
  background-color: #fff;
  border-top: 1px solid #e5e9f2;
  display: flex;
  justify-content: space-between;
  padding: 8px 16px;
}

.tox .tox-dialog__footer-start,
.tox .tox-dialog__footer-end {
  display: flex;
}

.tox .tox-dialog__busy-spinner {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.75);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 3;
}

.tox .tox-dialog__table {
  border-collapse: collapse;
  width: 100%;
}

.tox .tox-dialog__table thead th {
  font-weight: bold;
  padding-bottom: 8px;
}

.tox .tox-dialog__table tbody tr {
  border-bottom: 1px solid #e5e9f2;
}

.tox .tox-dialog__table tbody tr:last-child {
  border-bottom: none;
}

.tox .tox-dialog__table td {
  padding-bottom: 8px;
  padding-top: 8px;
}

.tox .tox-dialog__popups {
  position: absolute;
  width: 100%;
  z-index: 1100;
}

.tox .tox-dialog__body-iframe {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  -ms-flex-preferred-size: auto;
}

.tox .tox-dialog__body-iframe .tox-navobj {
  display: flex;
  flex: 1 1;
  -ms-flex-preferred-size: auto;
}

.tox .tox-dialog__body-iframe .tox-navobj :nth-child(2) {
  flex: 1 1;
  -ms-flex-preferred-size: auto;
  height: 100%;
}

.tox .tox-dialog-dock-fadeout {
  opacity: 0;
  visibility: hidden;
}

.tox .tox-dialog-dock-fadein {
  opacity: 1;
  visibility: visible;
}

.tox .tox-dialog-dock-transition {
  transition: visibility 0s linear 0.3s, opacity 0.3s ease;
}

.tox .tox-dialog-dock-transition.tox-dialog-dock-fadein {
  transition-delay: 0s;
}

body.tox-dialog__disable-scroll {
  overflow: hidden;
}

.tox.tox-platform-ie {
  /* IE11 CSS styles go here */
}

.tox.tox-platform-ie .tox-dialog-wrap {
  position: -ms-device-fixed;
}

@media only screen and (max-width: 767px) {
  body:not(.tox-force-desktop) .tox .tox-dialog__body-nav {
    margin-right: 0;
  }
}
@media only screen and (max-width: 767px) {
  body:not(.tox-force-desktop) .tox .tox-dialog__body-nav-item:not(:first-child) {
    margin-left: 8px;
  }
}
.tox .tox-dialog__footer .tox-dialog__footer-start > *,
.tox .tox-dialog__footer .tox-dialog__footer-end > * {
  margin-left: 8px;
}

.tox .tox-dropzone-container {
  display: flex;
  flex: 1 1;
  -ms-flex-preferred-size: auto;
}

.tox .tox-dropzone {
  align-items: center;
  background: #fff;
  border: 2px dashed #e5e9f2;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  min-height: 100px;
  padding: 10px;
}

.tox .tox-dropzone p {
  color: rgba(34, 47, 62, 0.7);
  margin: 0 0 16px 0;
}

.tox .tox-edit-area {
  display: flex;
  flex: 1 1;
  -ms-flex-preferred-size: auto;
  overflow: hidden;
  position: relative;
}

.tox .tox-edit-area__iframe {
  background-color: #fff;
  border: 0;
  box-sizing: border-box;
  flex: 1 1;
  -ms-flex-preferred-size: auto;
  height: 100%;
  position: absolute;
  width: 100%;
}

.mce-content-body {
  font-family: arial;
}

.tox.tox-inline-edit-area {
  border: 1px dotted #e5e9f2;
}

.tox .tox-editor-container {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  overflow: hidden;
}

.tox .tox-editor-header {
  z-index: 1;
}

.tox:not(.tox-tinymce-inline) .tox-editor-header {
  box-shadow: none;
  transition: box-shadow 0.5s;
}

.tox.tox-tinymce--toolbar-bottom .tox-editor-header,
.tox.tox-tinymce-inline .tox-editor-header {
  margin-bottom: -1px;
}

.tox.tox-tinymce--toolbar-sticky-on .tox-editor-header {
  box-shadow: 0 4px 4px -3px rgba(0, 0, 0, 0.25);
}

.tox-editor-dock-fadeout {
  opacity: 0;
  visibility: hidden;
}

.tox-editor-dock-fadein {
  opacity: 1;
  visibility: visible;
}

.tox-editor-dock-transition {
  transition: visibility 0s linear 0.25s, opacity 0.25s ease;
}

.tox-editor-dock-transition.tox-editor-dock-fadein {
  transition-delay: 0s;
}

.tox .tox-control-wrap {
  flex: 1 1;
  position: relative;
}

.tox .tox-control-wrap:not(.tox-control-wrap--status-invalid) .tox-control-wrap__status-icon-invalid,
.tox .tox-control-wrap:not(.tox-control-wrap--status-unknown) .tox-control-wrap__status-icon-unknown,
.tox .tox-control-wrap:not(.tox-control-wrap--status-valid) .tox-control-wrap__status-icon-valid {
  display: none;
}

.tox .tox-control-wrap svg {
  display: block;
}

.tox .tox-control-wrap__status-icon-wrap {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.tox .tox-control-wrap__status-icon-invalid svg {
  fill: #c00;
}

.tox .tox-control-wrap__status-icon-unknown svg {
  fill: orange;
}

.tox .tox-control-wrap__status-icon-valid svg {
  fill: green;
}

.tox .tox-control-wrap--status-invalid .tox-textfield,
.tox .tox-control-wrap--status-unknown .tox-textfield,
.tox .tox-control-wrap--status-valid .tox-textfield {
  padding-right: 32px;
}

.tox .tox-control-wrap__status-icon-wrap {
  right: 4px;
}

.tox .tox-autocompleter {
  max-width: 25em;
}

.tox .tox-autocompleter .tox-menu {
  max-width: 25em;
}

.tox .tox-autocompleter .tox-autocompleter-highlight {
  font-weight: bold;
}

.tox .tox-color-input {
  display: flex;
  position: relative;
  z-index: 1;
}

.tox .tox-color-input .tox-textfield {
  z-index: -1;
}

.tox .tox-color-input span {
  border-color: rgba(34, 47, 62, 0.2);
  border-radius: 3px;
  border-style: solid;
  border-width: 1px;
  box-shadow: none;
  box-sizing: border-box;
  height: 24px;
  position: absolute;
  top: 6px;
  width: 24px;
}

.tox .tox-color-input span:hover:not([aria-disabled=true]),
.tox .tox-color-input span:focus:not([aria-disabled=true]) {
  border-color: #207ab7;
  cursor: pointer;
}

.tox .tox-color-input span::before {
  background-image: linear-gradient(45deg, rgba(0, 0, 0, 0.25) 25%, transparent 25%), linear-gradient(-45deg, rgba(0, 0, 0, 0.25) 25%, transparent 25%), linear-gradient(45deg, transparent 75%, rgba(0, 0, 0, 0.25) 75%), linear-gradient(-45deg, transparent 75%, rgba(0, 0, 0, 0.25) 75%);
  background-position: 0 0, 0 6px, 6px -6px, -6px 0;
  background-size: 12px 12px;
  border: 1px solid #fff;
  border-radius: 3px;
  box-sizing: border-box;
  content: "";
  height: 24px;
  left: -1px;
  position: absolute;
  top: -1px;
  width: 24px;
  z-index: -1;
}

.tox .tox-color-input span[aria-disabled=true] {
  cursor: not-allowed;
}

.tox .tox-color-input .tox-textfield {
  padding-left: 36px;
}

.tox .tox-color-input span {
  left: 6px;
}

.tox .tox-label,
.tox .tox-toolbar-label {
  color: rgba(34, 47, 62, 0.7);
  display: block;
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  line-height: 1.3;
  padding: 0 8px 0 0;
  text-transform: none;
  white-space: nowrap;
}

.tox .tox-toolbar-label {
  padding: 0 8px;
}

.tox .tox-label {
  padding: 0 0 0 8px;
}

.tox .tox-form {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  -ms-flex-preferred-size: auto;
}

.tox .tox-form__group {
  box-sizing: border-box;
  margin-bottom: 4px;
}

.tox .tox-form-group--maximize {
  flex: 1 1;
}

.tox .tox-form__group--error {
  color: #c00;
}

.tox .tox-form__group--collection {
  display: flex;
}

.tox .tox-form__grid {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

.tox .tox-form__grid--2col > .tox-form__group {
  width: calc(50% - 4px);
}

.tox .tox-form__grid--3col > .tox-form__group {
  width: calc(33.3333333333% - 4px);
}

.tox .tox-form__grid--4col > .tox-form__group {
  width: calc(25% - 4px);
}

.tox .tox-form__controls-h-stack {
  align-items: center;
  display: flex;
}

.tox .tox-form__group--inline {
  align-items: center;
  display: flex;
}

.tox .tox-form__group--stretched {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  -ms-flex-preferred-size: auto;
}

.tox .tox-form__group--stretched .tox-textarea {
  flex: 1 1;
  -ms-flex-preferred-size: auto;
}

.tox .tox-form__group--stretched .tox-navobj {
  display: flex;
  flex: 1 1;
  -ms-flex-preferred-size: auto;
}

.tox .tox-form__group--stretched .tox-navobj :nth-child(2) {
  flex: 1 1;
  -ms-flex-preferred-size: auto;
  height: 100%;
}

.tox .tox-form__controls-h-stack > *:not(:first-child) {
  margin-left: 4px;
}

.tox .tox-lock.tox-locked .tox-lock-icon__unlock,
.tox .tox-lock:not(.tox-locked) .tox-lock-icon__lock {
  display: none;
}

.tox .tox-textfield,
.tox .tox-toolbar-textfield,
.tox .tox-textarea {
  appearance: none;
  background-color: #fff;
  border-color: #e5e9f2;
  border-radius: 3px;
  border-style: solid;
  border-width: 1px;
  box-shadow: none;
  box-sizing: border-box;
  color: #526484;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  min-height: 34px;
  outline: none;
  padding: 5px 4.75px;
  resize: none;
  width: 100%;
}

.tox .tox-textfield[disabled],
.tox .tox-textarea[disabled] {
  background-color: #f2f2f2;
  color: rgba(34, 47, 62, 0.85);
  cursor: not-allowed;
}

.tox .tox-textfield:focus,
.tox .tox-textarea:focus {
  background-color: #fff;
  border-color: #207ab7;
  box-shadow: none;
  outline: none;
}

.tox .tox-toolbar-textfield {
  border-width: 0;
  margin-bottom: 3px;
  margin-top: 2px;
  max-width: 250px;
}

.tox .tox-naked-btn {
  background-color: transparent;
  border: 0;
  border-color: transparent;
  box-shadow: unset;
  color: #207ab7;
  cursor: pointer;
  display: block;
  margin: 0;
  padding: 0;
}

.tox .tox-naked-btn svg {
  display: block;
  fill: #526484;
}

.tox .tox-toolbar-textfield + * {
  margin-left: 4px;
}

.tox .tox-selectfield {
  cursor: pointer;
  position: relative;
}

.tox .tox-selectfield select {
  appearance: none;
  background-color: #fff;
  border-color: #e5e9f2;
  border-radius: 3px;
  border-style: solid;
  border-width: 1px;
  box-shadow: none;
  box-sizing: border-box;
  color: #526484;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  min-height: 34px;
  outline: none;
  padding: 5px 4.75px;
  resize: none;
  width: 100%;
}

.tox .tox-selectfield select[disabled] {
  background-color: #f2f2f2;
  color: rgba(34, 47, 62, 0.85);
  cursor: not-allowed;
}

.tox .tox-selectfield select::-ms-expand {
  display: none;
}

.tox .tox-selectfield select:focus {
  background-color: #fff;
  border-color: #207ab7;
  box-shadow: none;
  outline: none;
}

.tox .tox-selectfield svg {
  pointer-events: none;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.tox .tox-selectfield select[size="0"],
.tox .tox-selectfield select[size="1"] {
  padding-right: 24px;
}

.tox .tox-selectfield svg {
  right: 8px;
}

.tox .tox-textarea {
  appearance: textarea;
  white-space: pre-wrap;
}

.tox-fullscreen {
  border: 0;
  height: 100%;
  left: 0;
  margin: 0;
  overflow: hidden;
  overscroll-behavior: none;
  padding: 0;
  position: fixed;
  top: 0;
  touch-action: pinch-zoom;
  width: 100%;
}

.tox-fullscreen .tox.tox-tinymce.tox-fullscreen .tox-statusbar__resize-handle {
  display: none;
}

.tox-fullscreen .tox.tox-tinymce.tox-fullscreen {
  z-index: 1200;
}

.tox-fullscreen .tox.tox-tinymce-aux {
  z-index: 1201;
}

.tox .tox-help__more-link {
  list-style: none;
  margin-top: 1em;
}

.tox .tox-image-tools {
  width: 100%;
}

.tox .tox-image-tools__toolbar {
  align-items: center;
  display: flex;
  justify-content: center;
}

.tox .tox-image-tools__image {
  background-color: #666;
  height: 380px;
  overflow: auto;
  position: relative;
  width: 100%;
}

.tox .tox-image-tools__image,
.tox .tox-image-tools__image + .tox-image-tools__toolbar {
  margin-top: 8px;
}

.tox .tox-image-tools__image-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_58___});
}

.tox .tox-image-tools__toolbar > .tox-spacer {
  flex: 1 1;
  -ms-flex-preferred-size: auto;
}

.tox .tox-croprect-block {
  background: black;
  filter: alpha(opacity=50);
  opacity: 0.5;
  position: absolute;
  zoom: 1;
}

.tox .tox-croprect-handle {
  border: 2px solid white;
  height: 20px;
  left: 0;
  position: absolute;
  top: 0;
  width: 20px;
}

.tox .tox-croprect-handle-move {
  border: 0;
  cursor: move;
  position: absolute;
}

.tox .tox-croprect-handle-nw {
  cursor: nw-resize;
  border-width: 2px 0 0 2px;
  left: 100px;
  margin: -2px 0 0 -2px;
  top: 100px;
}

.tox .tox-croprect-handle-ne {
  border-width: 2px 2px 0 0;
  cursor: ne-resize;
  left: 200px;
  margin: -2px 0 0 -20px;
  top: 100px;
}

.tox .tox-croprect-handle-sw {
  border-width: 0 0 2px 2px;
  cursor: sw-resize;
  left: 100px;
  margin: -20px 2px 0 -2px;
  top: 200px;
}

.tox .tox-croprect-handle-se {
  border-width: 0 2px 2px 0;
  cursor: se-resize;
  left: 200px;
  margin: -20px 0 0 -20px;
  top: 200px;
}

.tox .tox-image-tools__toolbar > .tox-slider:not(:first-of-type) {
  margin-left: 8px;
}

.tox .tox-image-tools__toolbar > .tox-button + .tox-slider {
  margin-left: 32px;
}

.tox .tox-image-tools__toolbar > .tox-slider + .tox-button {
  margin-left: 32px;
}

.tox .tox-insert-table-picker {
  display: flex;
  flex-wrap: wrap;
  width: 170px;
}

.tox .tox-insert-table-picker > div {
  border-color: #e5e9f2;
  border-style: solid;
  border-width: 0 1px 1px 0;
  box-sizing: border-box;
  height: 17px;
  width: 17px;
}

.tox .tox-collection--list .tox-collection__group .tox-insert-table-picker {
  margin: -4px 0;
}

.tox .tox-insert-table-picker .tox-insert-table-picker__selected {
  background-color: rgba(32, 122, 183, 0.5);
  border-color: rgba(32, 122, 183, 0.5);
}

.tox .tox-insert-table-picker__label {
  color: rgba(34, 47, 62, 0.7);
  display: block;
  font-size: 14px;
  padding: 4px;
  text-align: center;
  width: 100%;
}

.tox .tox-insert-table-picker > div:nth-child(10n) {
  border-right: 0;
}

.tox {
  /* stylelint-disable */
  /* stylelint-enable */
}

.tox .tox-menu {
  background-color: #fff;
  border: 1px solid #e5e9f2;
  border-radius: 3px;
  box-shadow: 0 4px 8px 0 rgba(34, 47, 62, 0.1);
  display: inline-block;
  overflow: hidden;
  vertical-align: top;
  z-index: 1150;
}

.tox .tox-menu.tox-collection.tox-collection--list {
  padding: 0;
}

.tox .tox-menu.tox-collection.tox-collection--toolbar {
  padding: 4px;
}

.tox .tox-menu.tox-collection.tox-collection--grid {
  padding: 4px;
}

.tox .tox-menu__label h1,
.tox .tox-menu__label h2,
.tox .tox-menu__label h3,
.tox .tox-menu__label h4,
.tox .tox-menu__label h5,
.tox .tox-menu__label h6,
.tox .tox-menu__label p,
.tox .tox-menu__label blockquote,
.tox .tox-menu__label code {
  margin: 0;
}

.tox .tox-menubar {
  background: #fff !important;
  display: flex !important;
  flex: 0 0 auto !important;
  flex-shrink: 0 !important;
  flex-wrap: wrap !important;
  padding: 0 4px 0 4px !important;
  border-bottom: 1px solid #e5e9f2;
}

.tox.tox-tinymce:not(.tox-tinymce-inline) .tox-editor-header:not(:first-child) .tox-menubar {
  border-top: 1px solid #e5e9f2 !important;
}

.tox-tinymce-inline .tox-editor-header .tox-toolbar:first-child {
  border-radius: 4px 4px 0 0 !important;
}
.tox-tinymce-inline .tox-editor-header .tox-toolbar:last-child {
  border-radius: 4px 4px !important;
}

/* Deprecated. Remove in next major release */
.tox .tox-mbtn {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 3px;
  box-shadow: none;
  color: #526484;
  display: flex;
  flex: 0 0 auto;
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  height: 34px;
  justify-content: center;
  margin: 2px 0 3px 0;
  outline: none;
  overflow: hidden;
  padding: 0 4px;
  text-transform: none;
  width: auto;
}

.tox .tox-mbtn[disabled] {
  background-color: transparent;
  border: 0;
  box-shadow: none;
  color: rgba(82, 100, 132, 0.5);
  cursor: not-allowed;
}

.tox .tox-mbtn:focus:not(:disabled) {
  background: #ebeef2;
  border: 0;
  box-shadow: none;
  color: #526484;
}

.tox .tox-mbtn--active {
  background: #ebeef2;
  border: 0;
  box-shadow: none;
  color: #526484;
}

.tox .tox-mbtn:hover:not(:disabled):not(.tox-mbtn--active) {
  background: #ebeef2;
  border: 0;
  box-shadow: none;
  color: #526484;
}

.tox .tox-mbtn__select-label {
  cursor: default;
  font-weight: normal;
  margin: 0 4px;
}

.tox .tox-mbtn[disabled] .tox-mbtn__select-label {
  cursor: not-allowed;
}

.tox .tox-mbtn__select-chevron {
  align-items: center;
  display: flex;
  justify-content: center;
  width: 16px;
  display: none;
}

.tox .tox-notification {
  border-radius: 3px;
  border-style: solid;
  border-width: 1px;
  box-shadow: none;
  box-sizing: border-box;
  display: grid;
  font-size: 14px;
  font-weight: normal;
  grid-template-columns: minmax(40px, 1fr) auto minmax(40px, 1fr);
  margin-top: 4px;
  opacity: 0;
  padding: 4px;
  transition: transform 100ms ease-in, opacity 150ms ease-in;
}

.tox .tox-notification p {
  font-size: 14px;
  font-weight: normal;
}

.tox .tox-notification a {
  text-decoration: underline;
}

.tox .tox-notification--in {
  opacity: 1;
}

.tox .tox-notification--success {
  background-color: #e4eeda;
  border-color: #d7e6c8;
  color: #526484;
}

.tox .tox-notification--success p {
  color: #526484;
}

.tox .tox-notification--success a {
  color: #547831;
}

.tox .tox-notification--success svg {
  fill: #526484;
}

.tox .tox-notification--error {
  background-color: #f8dede;
  border-color: #f2bfbf;
  color: #526484;
}

.tox .tox-notification--error p {
  color: #526484;
}

.tox .tox-notification--error a {
  color: #c00;
}

.tox .tox-notification--error svg {
  fill: #526484;
}

.tox .tox-notification--warn,
.tox .tox-notification--warning {
  background-color: #fffaea;
  border-color: #ffe89d;
  color: #526484;
}

.tox .tox-notification--warn p,
.tox .tox-notification--warning p {
  color: #526484;
}

.tox .tox-notification--warn a,
.tox .tox-notification--warning a {
  color: #526484;
}

.tox .tox-notification--warn svg,
.tox .tox-notification--warning svg {
  fill: #526484;
}

.tox .tox-notification--info {
  background-color: #d9edf7;
  border-color: #779ecb;
  color: #526484;
}

.tox .tox-notification--info p {
  color: #526484;
}

.tox .tox-notification--info a {
  color: #526484;
}

.tox .tox-notification--info svg {
  fill: #526484;
}

.tox .tox-notification__body {
  align-self: center;
  color: #526484;
  font-size: 14px;
  -ms-grid-column-span: 1;
  grid-column-end: 3;
  grid-column-start: 2;
  -ms-grid-row-span: 1;
  grid-row-end: 2;
  grid-row-start: 1;
  text-align: center;
  white-space: normal;
  word-break: break-all;
  word-break: break-word;
}

.tox .tox-notification__body > * {
  margin: 0;
}

.tox .tox-notification__body > * + * {
  margin-top: 1rem;
}

.tox .tox-notification__icon {
  align-self: center;
  -ms-grid-column-span: 1;
  grid-column-end: 2;
  grid-column-start: 1;
  -ms-grid-row-span: 1;
  grid-row-end: 2;
  grid-row-start: 1;
  justify-self: end;
}

.tox .tox-notification__icon svg {
  display: block;
}

.tox .tox-notification__dismiss {
  align-self: start;
  -ms-grid-column-span: 1;
  grid-column-end: 4;
  grid-column-start: 3;
  -ms-grid-row-span: 1;
  grid-row-end: 2;
  grid-row-start: 1;
  justify-self: end;
}

.tox .tox-notification .tox-progress-bar {
  -ms-grid-column-span: 3;
  grid-column-end: 4;
  grid-column-start: 1;
  -ms-grid-row-span: 1;
  grid-row-end: 3;
  grid-row-start: 2;
  justify-self: center;
}

.tox .tox-pop {
  display: inline-block;
  position: relative;
}

.tox .tox-pop--resizing {
  transition: width 0.1s ease;
}

.tox .tox-pop--resizing .tox-toolbar {
  flex-wrap: nowrap;
}

.tox .tox-pop__dialog {
  background-color: #fff;
  border: 1px solid #e5e9f2;
  border-radius: 3px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  min-width: 0;
  overflow: hidden;
}

.tox .tox-pop__dialog > *:not(.tox-toolbar) {
  margin: 4px 4px 4px 8px;
}

.tox .tox-pop__dialog .tox-toolbar {
  background-color: transparent;
  margin-bottom: -1px;
}

.tox .tox-pop::before,
.tox .tox-pop::after {
  border-style: solid;
  content: "";
  display: block;
  height: 0;
  position: absolute;
  width: 0;
}

.tox .tox-pop.tox-pop--bottom::before,
.tox .tox-pop.tox-pop--bottom::after {
  left: 50%;
  top: 100%;
}

.tox .tox-pop.tox-pop--bottom::after {
  border-color: #fff transparent transparent transparent;
  border-width: 8px;
  margin-left: -8px;
  margin-top: -1px;
}

.tox .tox-pop.tox-pop--bottom::before {
  border-color: #e5e9f2 transparent transparent transparent;
  border-width: 9px;
  margin-left: -9px;
}

.tox .tox-pop.tox-pop--top::before,
.tox .tox-pop.tox-pop--top::after {
  left: 50%;
  top: 0;
  transform: translateY(-100%);
}

.tox .tox-pop.tox-pop--top::after {
  border-color: transparent transparent #fff transparent;
  border-width: 8px;
  margin-left: -8px;
  margin-top: 1px;
}

.tox .tox-pop.tox-pop--top::before {
  border-color: transparent transparent #e5e9f2 transparent;
  border-width: 9px;
  margin-left: -9px;
}

.tox .tox-pop.tox-pop--left::before,
.tox .tox-pop.tox-pop--left::after {
  left: 0;
  top: calc(50% - 1px);
  transform: translateY(-50%);
}

.tox .tox-pop.tox-pop--left::after {
  border-color: transparent #fff transparent transparent;
  border-width: 8px;
  margin-left: -15px;
}

.tox .tox-pop.tox-pop--left::before {
  border-color: transparent #e5e9f2 transparent transparent;
  border-width: 10px;
  margin-left: -19px;
}

.tox .tox-pop.tox-pop--right::before,
.tox .tox-pop.tox-pop--right::after {
  left: 100%;
  top: calc(50% + 1px);
  transform: translateY(-50%);
}

.tox .tox-pop.tox-pop--right::after {
  border-color: transparent transparent transparent #fff;
  border-width: 8px;
  margin-left: -1px;
}

.tox .tox-pop.tox-pop--right::before {
  border-color: transparent transparent transparent #e5e9f2;
  border-width: 10px;
  margin-left: -1px;
}

.tox .tox-pop.tox-pop--align-left::before,
.tox .tox-pop.tox-pop--align-left::after {
  left: 20px;
}

.tox .tox-pop.tox-pop--align-right::before,
.tox .tox-pop.tox-pop--align-right::after {
  left: calc(100% - 20px);
}

.tox .tox-sidebar-wrap {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  -ms-flex-preferred-size: 0;
  min-height: 0;
}

.tox .tox-sidebar {
  background-color: #fff;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.tox .tox-sidebar__slider {
  display: flex;
  overflow: hidden;
}

.tox .tox-sidebar__pane-container {
  display: flex;
}

.tox .tox-sidebar__pane {
  display: flex;
}

.tox .tox-sidebar--sliding-closed {
  opacity: 0;
}

.tox .tox-sidebar--sliding-open {
  opacity: 1;
}

.tox .tox-sidebar--sliding-growing,
.tox .tox-sidebar--sliding-shrinking {
  transition: width 0.5s ease, opacity 0.5s ease;
}

.tox .tox-selector {
  background-color: #4099ff;
  border-color: #4099ff;
  border-style: solid;
  border-width: 1px;
  box-sizing: border-box;
  display: inline-block;
  height: 10px;
  position: absolute;
  width: 10px;
}

.tox.tox-platform-touch .tox-selector {
  height: 12px;
  width: 12px;
}

.tox .tox-slider {
  align-items: center;
  display: flex;
  flex: 1 1;
  -ms-flex-preferred-size: auto;
  height: 24px;
  justify-content: center;
  position: relative;
}

.tox .tox-slider__rail {
  background-color: transparent;
  border: 1px solid #e5e9f2;
  border-radius: 3px;
  height: 10px;
  min-width: 120px;
  width: 100%;
}

.tox .tox-slider__handle {
  background-color: #207ab7;
  border: 2px solid #185d8c;
  border-radius: 3px;
  box-shadow: none;
  height: 24px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 14px;
}

.tox .tox-source-code {
  overflow: auto;
}

.tox .tox-spinner {
  display: flex;
}

.tox .tox-spinner > div {
  animation: tam-bouncing-dots 1.5s ease-in-out 0s infinite both;
  background-color: rgba(34, 47, 62, 0.7);
  border-radius: 100%;
  height: 8px;
  width: 8px;
}

.tox .tox-spinner > div:nth-child(1) {
  animation-delay: -0.32s;
}

.tox .tox-spinner > div:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes tam-bouncing-dots {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
.tox .tox-spinner > div:not(:first-child) {
  margin-left: 4px;
}

.tox .tox-statusbar {
  align-items: center !important;
  background-color: #fff !important;
  border-top: 1px solid #e5e9f2 !important;
  color: rgba(34, 47, 62, 0.7) !important;
  display: flex !important;
  flex: 0 0 auto !important;
  font-size: 12px !important;
  font-weight: normal !important;
  height: 18px !important;
  overflow: hidden !important;
  padding: 0 8px !important;
  position: relative !important;
  text-transform: uppercase !important;
}

.tox .tox-statusbar__text-container {
  display: flex !important;
  flex: 1 1 auto !important;
  justify-content: flex-end !important;
  overflow: hidden !important;
}

.tox .tox-statusbar__path {
  display: flex !important;
  flex: 1 1 auto !important;
  margin-right: auto !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.tox .tox-statusbar__path > * {
  display: inline !important;
  white-space: nowrap !important;
}

.tox .tox-statusbar__wordcount {
  flex: 0 0 auto;
  margin-left: 1ch;
}

.tox .tox-statusbar a,
.tox .tox-statusbar__path-item,
.tox .tox-statusbar__wordcount {
  color: rgba(34, 47, 62, 0.7) !important;
  text-decoration: none !important;
}

.tox .tox-statusbar a:hover:not(:disabled):not([aria-disabled=true]),
.tox .tox-statusbar__path-item:hover:not(:disabled):not([aria-disabled=true]),
.tox .tox-statusbar__wordcount:hover:not(:disabled):not([aria-disabled=true]),
.tox .tox-statusbar a:focus:not(:disabled):not([aria-disabled=true]),
.tox .tox-statusbar__path-item:focus:not(:disabled):not([aria-disabled=true]),
.tox .tox-statusbar__wordcount:focus:not(:disabled):not([aria-disabled=true]) {
  cursor: pointer;
  text-decoration: underline;
}

.tox .tox-statusbar__resize-handle {
  align-items: flex-end;
  align-self: stretch;
  cursor: nwse-resize;
  display: flex;
  flex: 0 0 auto;
  justify-content: flex-end;
  margin-left: auto;
  margin-right: -8px;
  padding-left: 1ch;
}

.tox .tox-statusbar__resize-handle svg {
  display: block !important;
  fill: rgba(34, 47, 62, 0.7);
}

.tox .tox-statusbar__path > * {
  margin-right: 4px;
}

.tox .tox-throbber {
  z-index: 1400;
}

.tox .tox-throbber__busy-spinner {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.6);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.tox .tox-tbtn {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 3px;
  box-shadow: none;
  color: #526484;
  display: flex;
  flex: 0 0 auto;
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  height: 34px;
  justify-content: center;
  margin: 2px 0 3px 0;
  outline: none;
  overflow: hidden;
  padding: 0;
  text-transform: none;
  width: 34px;
}

.tox .tox-tbtn svg {
  display: block;
  fill: #526484;
}

.tox .tox-tbtn.tox-tbtn-more {
  padding-left: 5px;
  padding-right: 5px;
  width: inherit;
}

.tox .tox-tbtn:focus {
  background: #ebeef2;
  border: 0;
  box-shadow: none;
}

.tox .tox-tbtn:hover {
  background: #ebeef2;
  border: 0;
  box-shadow: none;
  color: #526484;
}

.tox .tox-tbtn:hover svg {
  fill: #526484;
}

.tox .tox-tbtn:active {
  background: #c8cbcf;
  border: 0;
  box-shadow: none;
  color: #526484;
}

.tox .tox-tbtn:active svg {
  fill: #526484;
}

.tox .tox-tbtn--disabled,
.tox .tox-tbtn--disabled:hover,
.tox .tox-tbtn:disabled,
.tox .tox-tbtn:disabled:hover {
  background: transparent;
  border: 0;
  box-shadow: none;
  color: rgba(82, 100, 132, 0.5);
  cursor: not-allowed;
}

.tox .tox-tbtn--disabled svg,
.tox .tox-tbtn--disabled:hover svg,
.tox .tox-tbtn:disabled svg,
.tox .tox-tbtn:disabled:hover svg {
  /* stylelint-disable-line no-descending-specificity */
  fill: rgba(82, 100, 132, 0.5);
}

.tox .tox-tbtn--enabled,
.tox .tox-tbtn--enabled:hover {
  background: #c8cbcf;
  border: 0;
  box-shadow: none;
  color: #526484;
}

.tox .tox-tbtn--enabled > *,
.tox .tox-tbtn--enabled:hover > * {
  transform: none;
}

.tox .tox-tbtn--enabled svg,
.tox .tox-tbtn--enabled:hover svg {
  /* stylelint-disable-line no-descending-specificity */
  fill: #526484;
}

.tox .tox-tbtn:focus:not(.tox-tbtn--disabled) {
  color: #526484;
}

.tox .tox-tbtn:focus:not(.tox-tbtn--disabled) svg {
  fill: #526484;
}

.tox .tox-tbtn:active > * {
  transform: none;
}

.tox .tox-tbtn--md {
  height: 51px;
  width: 51px;
}

.tox .tox-tbtn--lg {
  flex-direction: column;
  height: 68px;
  width: 68px;
}

.tox .tox-tbtn--return {
  align-self: stretch;
  height: unset;
  width: 16px;
}

.tox .tox-tbtn--labeled {
  padding: 0 4px;
  width: unset;
}

.tox .tox-tbtn__vlabel {
  display: block;
  font-size: 10px;
  font-weight: normal;
  letter-spacing: -0.025em;
  margin-bottom: 4px;
  white-space: nowrap;
}

.tox .tox-tbtn--select {
  margin: 2px 0 3px 0;
  padding: 0 4px;
  width: auto;
}

.tox .tox-tbtn__select-label {
  cursor: default;
  font-weight: normal;
  margin: 0 4px;
}

.tox .tox-tbtn__select-chevron {
  align-items: center;
  display: flex;
  justify-content: center;
  width: 16px;
}

.tox .tox-tbtn__select-chevron svg {
  fill: rgba(82, 100, 132, 0.5);
}

.tox .tox-tbtn--bespoke .tox-tbtn__select-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 7em;
}

.tox .tox-split-button {
  border: 0;
  border-radius: 3px;
  box-sizing: border-box;
  display: flex;
  margin: 2px 0 3px 0;
  overflow: hidden;
}

.tox .tox-split-button:hover {
  box-shadow: 0 0 0 1px #ebeef2 inset;
}

.tox .tox-split-button:focus {
  background: #ebeef2;
  box-shadow: none;
  color: #526484;
}

.tox .tox-split-button > * {
  border-radius: 0;
}

.tox .tox-split-button__chevron {
  width: 16px;
}

.tox .tox-split-button__chevron svg {
  fill: rgba(82, 100, 132, 0.5);
}

.tox .tox-split-button .tox-tbtn {
  margin: 0;
}

.tox.tox-platform-touch .tox-split-button .tox-tbtn:first-child {
  width: 30px;
}

.tox.tox-platform-touch .tox-split-button__chevron {
  width: 20px;
}

.tox .tox-split-button.tox-tbtn--disabled:hover,
.tox .tox-split-button.tox-tbtn--disabled:focus,
.tox .tox-split-button.tox-tbtn--disabled .tox-tbtn:hover,
.tox .tox-split-button.tox-tbtn--disabled .tox-tbtn:focus {
  background: transparent;
  box-shadow: none;
  color: rgba(82, 100, 132, 0.5);
}

.tox .tox-toolbar-overlord {
  background-color: #fff;
}

.tox .tox-toolbar,
.tox .tox-toolbar__primary,
.tox .tox-toolbar__overflow {
  background: #fff !important;
  border-bottom: 1px solid #e5e9f2 !important;
  display: flex !important;
  flex: 0 0 auto !important;
  flex-shrink: 0 !important;
  flex-wrap: wrap !important;
  padding: 0 0 !important;
}

.tox .tox-toolbar__overflow.tox-toolbar__overflow--closed {
  height: 0;
  opacity: 0;
  padding-bottom: 0;
  padding-top: 0;
  visibility: hidden;
}

.tox .tox-toolbar__overflow--growing {
  transition: height 0.3s ease, opacity 0.2s linear 0.1s;
}

.tox .tox-toolbar__overflow--shrinking {
  transition: opacity 0.3s ease, height 0.2s linear 0.1s, visibility 0s linear 0.3s;
}

.tox .tox-menubar + .tox-toolbar,
.tox .tox-menubar + .tox-toolbar-overlord .tox-toolbar__primary {
  border-top: 1px solid #e5e9f2 !important;
  margin-top: -1px !important;
}

.tox .tox-toolbar--scrolling {
  flex-wrap: nowrap;
  overflow-x: auto;
}

.tox .tox-pop .tox-toolbar {
  border-width: 0;
}

.tox .tox-toolbar--no-divider {
  background-image: none !important;
}

.tox-tinymce:not(.tox-tinymce-inline) .tox-editor-header:not(:first-child) .tox-toolbar:first-child,
.tox-tinymce:not(.tox-tinymce-inline) .tox-editor-header:not(:first-child) .tox-toolbar-overlord:first-child .tox-toolbar__primary {
  border-top: 1px solid #e5e9f2 !important;
}

.tox.tox-tinymce-aux .tox-toolbar__overflow {
  background-color: #fff;
  border: 1px solid #e5e9f2;
  border-radius: 3px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

.tox[dir=rtl] .tox-tbtn__icon-rtl svg {
  transform: rotateY(180deg);
}

.tox .tox-toolbar__group {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  margin: 0 0;
  padding: 0 4px 0 4px;
}

.tox .tox-toolbar__group--pull-right {
  margin-left: auto;
}

.tox .tox-toolbar--scrolling .tox-toolbar__group {
  flex-shrink: 0;
  flex-wrap: nowrap;
}

.tox .tox-toolbar__group:not(:last-of-type) {
  border-right: 1px solid #e5e9f2;
}

.tox .tox-tooltip {
  display: inline-block;
  padding: 8px;
  position: relative;
}

.tox .tox-tooltip__body {
  background-color: #526484 !important;
  border-radius: 3px !important;
  box-shadow: 0 2px 4px rgba(34, 47, 62, 0.3) !important;
  color: rgba(255, 255, 255, 0.75) !important;
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: normal !important;
  padding: 4px 8px !important;
  text-transform: none !important;
}

.tox .tox-tooltip__arrow {
  position: absolute;
}

.tox .tox-tooltip--down .tox-tooltip__arrow {
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #526484;
  bottom: 0;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
}

.tox .tox-tooltip--up .tox-tooltip__arrow {
  border-bottom: 8px solid #526484;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  left: 50%;
  position: absolute;
  top: 0;
  transform: translateX(-50%);
}

.tox .tox-tooltip--right .tox-tooltip__arrow {
  border-bottom: 8px solid transparent;
  border-left: 8px solid #526484;
  border-top: 8px solid transparent;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.tox .tox-tooltip--left .tox-tooltip__arrow {
  border-bottom: 8px solid transparent;
  border-right: 8px solid #526484;
  border-top: 8px solid transparent;
  left: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.tox .tox-well {
  border: 1px solid #e5e9f2;
  border-radius: 3px;
  padding: 8px;
  width: 100%;
}

.tox .tox-well > *:first-child {
  margin-top: 0;
}

.tox .tox-well > *:last-child {
  margin-bottom: 0;
}

.tox .tox-well > *:only-child {
  margin: 0;
}

.tox .tox-custom-editor {
  border: 1px solid #e5e9f2;
  border-radius: 3px;
  display: flex;
  flex: 1 1;
  position: relative;
}

/* stylelint-disable */
.tox {
  /* stylelint-enable */
}

.tox .tox-dialog-loading::before {
  background-color: rgba(0, 0, 0, 0.5);
  content: "";
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: 1000;
}

.tox .tox-tab {
  cursor: pointer;
}

.tox .tox-dialog__content-js {
  display: flex;
  flex: 1 1;
  -ms-flex-preferred-size: auto;
}

.tox .tox-dialog__body-content .tox-collection {
  display: flex !important;
  flex: 1 1 !important;
  -ms-flex-preferred-size: auto !important;
}

.tox .tox-image-tools-edit-panel {
  height: 60px;
}

.tox .tox-image-tools__sidebar {
  height: 60px;
}

/**
 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
 * Licensed under the LGPL or a commercial license.
 * For LGPL see License.txt in the project root for license information.
 * For commercial licenses see https://www.tiny.cloud/
 */
/* RESET all the things! */
.tinymce-mobile-outer-container {
  all: initial;
  display: block;
}

.tinymce-mobile-outer-container * {
  border: 0;
  box-sizing: initial;
  cursor: inherit;
  float: none;
  line-height: 1;
  margin: 0;
  outline: 0;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
  /* TBIO-3691, stop the gray flicker on touch. */
  text-shadow: none;
  white-space: nowrap;
}

.tinymce-mobile-icon-arrow-back::before {
  content: "\\e5cd";
}

.tinymce-mobile-icon-image::before {
  content: "\\e412";
}

.tinymce-mobile-icon-cancel-circle::before {
  content: "\\e5c9";
}

.tinymce-mobile-icon-full-dot::before {
  content: "\\e061";
}

.tinymce-mobile-icon-align-center::before {
  content: "\\e234";
}

.tinymce-mobile-icon-align-left::before {
  content: "\\e236";
}

.tinymce-mobile-icon-align-right::before {
  content: "\\e237";
}

.tinymce-mobile-icon-bold::before {
  content: "\\e238";
}

.tinymce-mobile-icon-italic::before {
  content: "\\e23f";
}

.tinymce-mobile-icon-unordered-list::before {
  content: "\\e241";
}

.tinymce-mobile-icon-ordered-list::before {
  content: "\\e242";
}

.tinymce-mobile-icon-font-size::before {
  content: "\\e245";
}

.tinymce-mobile-icon-underline::before {
  content: "\\e249";
}

.tinymce-mobile-icon-link::before {
  content: "\\e157";
}

.tinymce-mobile-icon-unlink::before {
  content: "\\eca2";
}

.tinymce-mobile-icon-color::before {
  content: "\\e891";
}

.tinymce-mobile-icon-previous::before {
  content: "\\e314";
}

.tinymce-mobile-icon-next::before {
  content: "\\e315";
}

.tinymce-mobile-icon-large-font::before,
.tinymce-mobile-icon-style-formats::before {
  content: "\\e264";
}

.tinymce-mobile-icon-undo::before {
  content: "\\e166";
}

.tinymce-mobile-icon-redo::before {
  content: "\\e15a";
}

.tinymce-mobile-icon-removeformat::before {
  content: "\\e239";
}

.tinymce-mobile-icon-small-font::before {
  content: "\\e906";
}

.tinymce-mobile-icon-readonly-back::before,
.tinymce-mobile-format-matches::after {
  content: "\\e5ca";
}

.tinymce-mobile-icon-small-heading::before {
  content: "small";
}

.tinymce-mobile-icon-large-heading::before {
  content: "large";
}

.tinymce-mobile-icon-small-heading::before,
.tinymce-mobile-icon-large-heading::before {
  font-family: sans-serif;
  font-size: 80%;
}

.tinymce-mobile-mask-edit-icon::before {
  content: "\\e254";
}

.tinymce-mobile-icon-back::before {
  content: "\\e5c4";
}

.tinymce-mobile-icon-heading::before {
  /* TODO: Translate */
  content: "Headings";
  font-family: sans-serif;
  font-size: 80%;
  font-weight: bold;
}

.tinymce-mobile-icon-h1::before {
  content: "H1";
  font-weight: bold;
}

.tinymce-mobile-icon-h2::before {
  content: "H2";
  font-weight: bold;
}

.tinymce-mobile-icon-h3::before {
  content: "H3";
  font-weight: bold;
}

.tinymce-mobile-outer-container .tinymce-mobile-disabled-mask {
  align-items: center;
  display: flex;
  justify-content: center;
  background: rgba(51, 51, 51, 0.5);
  height: 100%;
  position: absolute;
  top: 0;
  width: 100%;
}

.tinymce-mobile-outer-container .tinymce-mobile-disabled-mask .tinymce-mobile-content-container {
  align-items: center;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  font-family: sans-serif;
  font-size: 1em;
  justify-content: space-between;
}

.tinymce-mobile-outer-container .tinymce-mobile-disabled-mask .tinymce-mobile-content-container .mixin-menu-item {
  align-items: center;
  display: flex;
  justify-content: center;
  border-radius: 50%;
  height: 2.1em;
  width: 2.1em;
}

.tinymce-mobile-outer-container .tinymce-mobile-disabled-mask .tinymce-mobile-content-container .tinymce-mobile-content-tap-section {
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-size: 1em;
}

@media only screen and (min-device-width: 700px) {
  .tinymce-mobile-outer-container .tinymce-mobile-disabled-mask .tinymce-mobile-content-container .tinymce-mobile-content-tap-section {
    font-size: 1.2em;
  }
}
.tinymce-mobile-outer-container .tinymce-mobile-disabled-mask .tinymce-mobile-content-container .tinymce-mobile-content-tap-section .tinymce-mobile-mask-tap-icon {
  align-items: center;
  display: flex;
  justify-content: center;
  border-radius: 50%;
  height: 2.1em;
  width: 2.1em;
  background-color: white;
  color: #207ab7;
}

.tinymce-mobile-outer-container .tinymce-mobile-disabled-mask .tinymce-mobile-content-container .tinymce-mobile-content-tap-section .tinymce-mobile-mask-tap-icon::before {
  content: "\\e900";
  font-family: "tinymce-mobile", sans-serif;
}

.tinymce-mobile-outer-container .tinymce-mobile-disabled-mask .tinymce-mobile-content-container .tinymce-mobile-content-tap-section:not(.tinymce-mobile-mask-tap-icon-selected) .tinymce-mobile-mask-tap-icon {
  z-index: 2;
}

.tinymce-mobile-android-container.tinymce-mobile-android-maximized {
  background: #ffffff;
  border: none;
  bottom: 0;
  display: flex;
  flex-direction: column;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
}

.tinymce-mobile-android-container:not(.tinymce-mobile-android-maximized) {
  position: relative;
}

.tinymce-mobile-android-container .tinymce-mobile-editor-socket {
  display: flex;
  flex-grow: 1;
}

.tinymce-mobile-android-container .tinymce-mobile-editor-socket iframe {
  display: flex !important;
  flex-grow: 1;
  height: auto !important;
}

.tinymce-mobile-android-scroll-reload {
  overflow: hidden;
}

:not(.tinymce-mobile-readonly-mode) > .tinymce-mobile-android-selection-context-toolbar {
  margin-top: 23px;
}

.tinymce-mobile-toolstrip {
  background: #fff;
  display: flex;
  flex: 0 0 auto;
  z-index: 1;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar {
  align-items: center;
  background-color: #fff;
  border-bottom: 1px solid #cccccc;
  display: flex;
  flex: 1 1;
  height: 2.5em;
  width: 100%;
  /* Make it no larger than the toolstrip, so that it needs to scroll */
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar:not(.tinymce-mobile-context-toolbar) .tinymce-mobile-toolbar-group {
  align-items: center;
  display: flex;
  height: 100%;
  flex-shrink: 1;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar:not(.tinymce-mobile-context-toolbar) .tinymce-mobile-toolbar-group > div {
  align-items: center;
  display: flex;
  height: 100%;
  flex: 1 1;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar:not(.tinymce-mobile-context-toolbar) .tinymce-mobile-toolbar-group.tinymce-mobile-exit-container {
  background: #f44336;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar:not(.tinymce-mobile-context-toolbar) .tinymce-mobile-toolbar-group.tinymce-mobile-toolbar-scrollable-group {
  flex-grow: 1;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar:not(.tinymce-mobile-context-toolbar) .tinymce-mobile-toolbar-group .tinymce-mobile-toolbar-group-item {
  padding-left: 0.5em;
  padding-right: 0.5em;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar:not(.tinymce-mobile-context-toolbar) .tinymce-mobile-toolbar-group .tinymce-mobile-toolbar-group-item.tinymce-mobile-toolbar-button {
  align-items: center;
  display: flex;
  height: 80%;
  margin-left: 2px;
  margin-right: 2px;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar:not(.tinymce-mobile-context-toolbar) .tinymce-mobile-toolbar-group .tinymce-mobile-toolbar-group-item.tinymce-mobile-toolbar-button.tinymce-mobile-toolbar-button-selected {
  background: #c8cbcf;
  color: #cccccc;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar:not(.tinymce-mobile-context-toolbar) .tinymce-mobile-toolbar-group:first-of-type,
.tinymce-mobile-toolstrip .tinymce-mobile-toolbar:not(.tinymce-mobile-context-toolbar) .tinymce-mobile-toolbar-group:last-of-type {
  background: #207ab7;
  color: #eceff1;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar {
  /* Note, this file is imported inside .tinymce-mobile-context-toolbar, so that prefix is on everything here. */
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group {
  align-items: center;
  display: flex;
  height: 100%;
  flex: 1 1;
  padding-bottom: 0.4em;
  padding-top: 0.4em;
  /* Make any buttons appearing on the left and right display in the centre (e.g. color edges) */
  /* For widgets like the colour picker, use the whole height */
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serialised-dialog {
  display: flex;
  min-height: 1.5em;
  overflow: hidden;
  padding-left: 0;
  padding-right: 0;
  position: relative;
  width: 100%;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serialised-dialog .tinymce-mobile-serialised-dialog-chain {
  display: flex;
  height: 100%;
  transition: left cubic-bezier(0.4, 0, 1, 1) 0.15s;
  width: 100%;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serialised-dialog .tinymce-mobile-serialised-dialog-chain .tinymce-mobile-serialised-dialog-screen {
  display: flex;
  flex: 0 0 auto;
  justify-content: space-between;
  width: 100%;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serialised-dialog .tinymce-mobile-serialised-dialog-chain .tinymce-mobile-serialised-dialog-screen input {
  font-family: Sans-serif;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serialised-dialog .tinymce-mobile-serialised-dialog-chain .tinymce-mobile-serialised-dialog-screen .tinymce-mobile-input-container {
  display: flex;
  flex-grow: 1;
  position: relative;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serialised-dialog .tinymce-mobile-serialised-dialog-chain .tinymce-mobile-serialised-dialog-screen .tinymce-mobile-input-container .tinymce-mobile-input-container-x {
  align-self: center;
  background: inherit;
  border: none;
  border-radius: 50%;
  color: #888;
  font-size: 0.6em;
  font-weight: bold;
  height: 100%;
  padding-right: 2px;
  position: absolute;
  right: 0;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serialised-dialog .tinymce-mobile-serialised-dialog-chain .tinymce-mobile-serialised-dialog-screen .tinymce-mobile-input-container.tinymce-mobile-input-container-empty .tinymce-mobile-input-container-x {
  display: none;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serialised-dialog .tinymce-mobile-serialised-dialog-chain .tinymce-mobile-serialised-dialog-screen .tinymce-mobile-icon-previous,
.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serialised-dialog .tinymce-mobile-serialised-dialog-chain .tinymce-mobile-serialised-dialog-screen .tinymce-mobile-icon-next {
  align-items: center;
  display: flex;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serialised-dialog .tinymce-mobile-serialised-dialog-chain .tinymce-mobile-serialised-dialog-screen .tinymce-mobile-icon-previous::before,
.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serialised-dialog .tinymce-mobile-serialised-dialog-chain .tinymce-mobile-serialised-dialog-screen .tinymce-mobile-icon-next::before {
  align-items: center;
  display: flex;
  font-weight: bold;
  height: 100%;
  padding-left: 0.5em;
  padding-right: 0.5em;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serialised-dialog .tinymce-mobile-serialised-dialog-chain .tinymce-mobile-serialised-dialog-screen .tinymce-mobile-icon-previous.tinymce-mobile-toolbar-navigation-disabled::before,
.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serialised-dialog .tinymce-mobile-serialised-dialog-chain .tinymce-mobile-serialised-dialog-screen .tinymce-mobile-icon-next.tinymce-mobile-toolbar-navigation-disabled::before {
  visibility: hidden;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-dot-item {
  color: #cccccc;
  font-size: 10px;
  line-height: 10px;
  margin: 0 2px;
  padding-top: 3px;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-dot-item.tinymce-mobile-dot-active {
  color: #c8cbcf;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-icon-large-font::before,
.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-icon-large-heading::before {
  margin-left: 0.5em;
  margin-right: 0.9em;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-icon-small-font::before,
.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-icon-small-heading::before {
  margin-left: 0.9em;
  margin-right: 0.5em;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-slider {
  display: flex;
  flex: 1 1;
  margin-left: 0;
  margin-right: 0;
  padding: 0.28em 0;
  position: relative;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-slider .tinymce-mobile-slider-size-container {
  align-items: center;
  display: flex;
  flex-grow: 1;
  height: 100%;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-slider .tinymce-mobile-slider-size-container .tinymce-mobile-slider-size-line {
  background: #cccccc;
  display: flex;
  flex: 1 1;
  height: 0.2em;
  margin-bottom: 0.3em;
  margin-top: 0.3em;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-slider.tinymce-mobile-hue-slider-container {
  padding-left: 2em;
  padding-right: 2em;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-slider.tinymce-mobile-hue-slider-container .tinymce-mobile-slider-gradient-container {
  align-items: center;
  display: flex;
  flex-grow: 1;
  height: 100%;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-slider.tinymce-mobile-hue-slider-container .tinymce-mobile-slider-gradient-container .tinymce-mobile-slider-gradient {
  background: linear-gradient(to right, hsl(0deg, 100%, 50%) 0%, hsl(60deg, 100%, 50%) 17%, hsl(120deg, 100%, 50%) 33%, hsl(180deg, 100%, 50%) 50%, hsl(240deg, 100%, 50%) 67%, hsl(300deg, 100%, 50%) 83%, hsl(0deg, 100%, 50%) 100%);
  display: flex;
  flex: 1 1;
  height: 0.2em;
  margin-bottom: 0.3em;
  margin-top: 0.3em;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-slider.tinymce-mobile-hue-slider-container .tinymce-mobile-hue-slider-black {
  /* Not part of theming */
  background: black;
  height: 0.2em;
  margin-bottom: 0.3em;
  margin-top: 0.3em;
  width: 1.2em;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-slider.tinymce-mobile-hue-slider-container .tinymce-mobile-hue-slider-white {
  /* Not part of theming */
  background: white;
  height: 0.2em;
  margin-bottom: 0.3em;
  margin-top: 0.3em;
  width: 1.2em;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-slider .tinymce-mobile-slider-thumb {
  /* vertically centering trick (margin: auto, top: 0, bottom: 0). On iOS and Safari, if you leave
     * out these values, then it shows the thumb at the top of the spectrum. This is probably because it is
     * absolutely positioned with only a left value, and not a top. Note, on Chrome it seems to be fine without
     * this approach.
    */
  align-items: center;
  background-clip: padding-box;
  background-color: #455a64;
  border: 0.5em solid rgba(136, 136, 136, 0);
  border-radius: 3em;
  bottom: 0;
  color: #fff;
  display: flex;
  height: 0.5em;
  justify-content: center;
  left: -10px;
  margin: auto;
  position: absolute;
  top: 0;
  transition: border 120ms cubic-bezier(0.39, 0.58, 0.57, 1);
  width: 0.5em;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-slider .tinymce-mobile-slider-thumb.tinymce-mobile-thumb-active {
  border: 0.5em solid rgba(136, 136, 136, 0.39);
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serializer-wrapper,
.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group > div {
  align-items: center;
  display: flex;
  height: 100%;
  flex: 1 1;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serializer-wrapper {
  flex-direction: column;
  justify-content: center;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-toolbar-group-item {
  align-items: center;
  display: flex;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-toolbar-group-item:not(.tinymce-mobile-serialised-dialog) {
  height: 100%;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-dot-container {
  display: flex;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group input {
  background: #ffffff;
  border: none;
  border-radius: 0;
  color: #455a64;
  flex-grow: 1;
  font-size: 0.85em;
  padding-bottom: 0.1em;
  padding-left: 5px;
  padding-top: 0.1em;
}

.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group input::placeholder {
  /* WebKit, Blink, Edge */
  color: #888;
}

/* dropup */
.tinymce-mobile-dropup {
  background: white;
  display: flex;
  overflow: hidden;
  width: 100%;
}

.tinymce-mobile-dropup.tinymce-mobile-dropup-shrinking {
  transition: height 0.3s ease-out;
}

.tinymce-mobile-dropup.tinymce-mobile-dropup-growing {
  transition: height 0.3s ease-in;
}

.tinymce-mobile-dropup.tinymce-mobile-dropup-closed {
  flex-grow: 0;
}

.tinymce-mobile-dropup.tinymce-mobile-dropup-open:not(.tinymce-mobile-dropup-growing) {
  flex-grow: 1;
}

/* TODO min-height for device size and orientation */
.tinymce-mobile-ios-container .tinymce-mobile-dropup:not(.tinymce-mobile-dropup-closed) {
  min-height: 200px;
}

@media only screen and (orientation: landscape) {
  .tinymce-mobile-dropup:not(.tinymce-mobile-dropup-closed) {
    min-height: 200px;
  }
}
@media only screen and (min-device-width: 320px) and (max-device-width: 568px) and (orientation: landscape) {
  .tinymce-mobile-ios-container .tinymce-mobile-dropup:not(.tinymce-mobile-dropup-closed) {
    min-height: 150px;
  }
}
/* styles menu */
.tinymce-mobile-styles-menu {
  font-family: sans-serif;
  outline: 4px solid black;
  overflow: hidden;
  position: relative;
  width: 100%;
}

.tinymce-mobile-styles-menu [role=menu] {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: absolute;
  width: 100%;
}

.tinymce-mobile-styles-menu [role=menu].transitioning {
  transition: transform 0.5s ease-in-out;
}

.tinymce-mobile-styles-menu .tinymce-mobile-styles-item {
  border-bottom: 1px solid #ddd;
  color: #455a64;
  cursor: pointer;
  display: flex;
  padding: 1em 1em;
  position: relative;
}

.tinymce-mobile-styles-menu .tinymce-mobile-styles-collapser .tinymce-mobile-styles-collapse-icon::before {
  color: #455a64;
  content: "\\e314";
  font-family: "tinymce-mobile", sans-serif;
}

.tinymce-mobile-styles-menu .tinymce-mobile-styles-item.tinymce-mobile-styles-item-is-menu::after {
  color: #455a64;
  content: "\\e315";
  font-family: "tinymce-mobile", sans-serif;
  padding-left: 1em;
  padding-right: 1em;
  position: absolute;
  right: 0;
}

.tinymce-mobile-styles-menu .tinymce-mobile-styles-item.tinymce-mobile-format-matches::after {
  font-family: "tinymce-mobile", sans-serif;
  padding-left: 1em;
  padding-right: 1em;
  position: absolute;
  right: 0;
}

.tinymce-mobile-styles-menu .tinymce-mobile-styles-separator,
.tinymce-mobile-styles-menu .tinymce-mobile-styles-collapser {
  align-items: center;
  background: #fff;
  border-top: #455a64;
  color: #455a64;
  display: flex;
  min-height: 2.5em;
  padding-left: 1em;
  padding-right: 1em;
}

.tinymce-mobile-styles-menu [data-transitioning-destination=before][data-transitioning-state],
.tinymce-mobile-styles-menu [data-transitioning-state=before] {
  transform: translate(-100%);
}

.tinymce-mobile-styles-menu [data-transitioning-destination=current][data-transitioning-state],
.tinymce-mobile-styles-menu [data-transitioning-state=current] {
  transform: translate(0%);
}

.tinymce-mobile-styles-menu [data-transitioning-destination=after][data-transitioning-state],
.tinymce-mobile-styles-menu [data-transitioning-state=after] {
  transform: translate(100%);
}

@font-face {
  font-family: "tinymce-mobile";
  font-style: normal;
  font-weight: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_59___}) format("woff");
}
@media (min-device-width: 700px) {
  .tinymce-mobile-outer-container,
  .tinymce-mobile-outer-container input {
    font-size: 25px;
  }
}
@media (max-device-width: 700px) {
  .tinymce-mobile-outer-container,
  .tinymce-mobile-outer-container input {
    font-size: 18px;
  }
}
.tinymce-mobile-icon {
  font-family: "tinymce-mobile", sans-serif;
}

.mixin-flex-and-centre {
  align-items: center;
  display: flex;
  justify-content: center;
}

.mixin-flex-bar {
  align-items: center;
  display: flex;
  height: 100%;
}

.tinymce-mobile-outer-container .tinymce-mobile-editor-socket iframe {
  background-color: #fff;
  width: 100%;
}

.tinymce-mobile-editor-socket .tinymce-mobile-mask-edit-icon {
  /* Note, on the iPod touch in landscape, this isn't visible when the navbar appears */
  background-color: #207ab7;
  border-radius: 50%;
  bottom: 1em;
  color: white;
  font-size: 1em;
  height: 2.1em;
  position: fixed;
  right: 2em;
  width: 2.1em;
  align-items: center;
  display: flex;
  justify-content: center;
}

@media only screen and (min-device-width: 700px) {
  .tinymce-mobile-editor-socket .tinymce-mobile-mask-edit-icon {
    font-size: 1.2em;
  }
}
.tinymce-mobile-outer-container:not(.tinymce-mobile-fullscreen-maximized) .tinymce-mobile-editor-socket {
  height: 300px;
  overflow: hidden;
}

.tinymce-mobile-outer-container:not(.tinymce-mobile-fullscreen-maximized) .tinymce-mobile-editor-socket iframe {
  height: 100%;
}

.tinymce-mobile-outer-container:not(.tinymce-mobile-fullscreen-maximized) .tinymce-mobile-toolstrip {
  display: none;
}

/*
  Note, that if you don't include this (::-webkit-file-upload-button), the toolbar width gets
  increased and the whole body becomes scrollable. It's important!
 */
input[type=file]::-webkit-file-upload-button {
  display: none;
}

@media only screen and (min-device-width: 320px) and (max-device-width: 568px) and (orientation: landscape) {
  .tinymce-mobile-ios-container .tinymce-mobile-editor-socket .tinymce-mobile-mask-edit-icon {
    bottom: 50%;
  }
}
/* classes attached to <body> */
.fc-not-allowed,
.fc-not-allowed .fc-event { /* override events' custom cursors */
  cursor: not-allowed;
}

.fc-unselectable {
  -webkit-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.fc {
  /* layout of immediate children */
  display: flex;
  flex-direction: column;
  font-size: 1em;
}

.fc,
.fc *,
.fc *:before,
.fc *:after {
  box-sizing: border-box;
}

.fc table {
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 1em; /* normalize cross-browser */
}

.fc th {
  text-align: center;
}

.fc th,
.fc td {
  vertical-align: top;
  padding: 0;
}

.fc .table-bordered {
  border-radius: 4px;
}
.fc .table-bordered thead th, .fc .table-bordered thead td {
  border-bottom-width: 0;
}
.fc .table-bordered thead > tr > th, .fc .table-bordered thead > tr > td {
  border-bottom-width: 1px;
}
.fc thead tr:first-child td:first-child, .fc thead tr:first-child th:first-child {
  border-radius: 4px 0 0 0;
}
.fc thead tr:first-child td:last-child, .fc thead tr:first-child th:last-child {
  border-radius: 0 4px 0 0;
}
.fc tbody tr:last-child td:first-child, .fc tbody tr:last-child th:first-child {
  border-radius: 0 0 0 4px;
}
.fc tbody tr:last-child td:last-child, .fc tbody tr:last-child th:last-child {
  border-radius: 0 0 4px 0;
}

.fc a[data-navlink] {
  cursor: pointer;
}

.fc a[data-navlink]:hover {
  text-decoration: underline;
}

.fc-direction-ltr {
  direction: ltr;
  text-align: left;
}

.fc-direction-rtl {
  direction: rtl;
  text-align: right;
}

.fc-theme-standard td,
.fc-theme-standard th {
  border: 1px solid #ddd;
  border: 1px solid var(--fc-border-color, #ddd);
}

/* for FF, which doesn't expand a 100% div within a table cell. use absolute positioning */
/* inner-wrappers are responsible for being absolute */
/* TODO: best place for this? */
.fc-liquid-hack td,
.fc-liquid-hack th {
  position: relative;
}

@font-face {
  font-family: "fcicons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_60___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
.fc-icon, .fa {
  /* added for fc */
  display: inline-block;
  width: 1em;
  height: 1em;
  text-align: center;
  -webkit-user-select: none;
  user-select: none;
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "fcicons" !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.fc-icon-chevron-left:before, .fa-chevron-left:before {
  content: "\\e900";
}

.fc-icon-chevron-right:before, .fa-chevron-right:before {
  content: "\\e901";
}

.fc-icon-chevrons-left:before, .fa-chevrons-left:before {
  content: "\\e902";
}

.fc-icon-chevrons-right:before, .fa-chevrons-right:before {
  content: "\\e903";
}

.fc-icon-minus-square:before, .fa-minus-square:before {
  content: "\\e904";
}

.fc-icon-plus-square:before, .fa-plus-square:before {
  content: "\\e905";
}

.fc-icon-x:before, .fa-times:before {
  content: "\\e906";
}

/*
Lots taken from Flatly (MIT): https://bootswatch.com/4/flatly/bootstrap.css

These styles only apply when the standard-theme is activated.
When it's NOT activated, the fc-button classes won't even be in the DOM.
*/
.fc {
  /* reset */
}

.fc .fc-button {
  border-radius: 0;
  overflow: visible;
  text-transform: none;
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

.fc .fc-button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color;
}

.fc .fc-button {
  -webkit-appearance: button;
}

.fc .fc-button:not(:disabled) {
  cursor: pointer;
}

.fc .fc-button::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

.fc {
  /* theme */
}

.fc .fc-button {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.4em 0.65em;
  font-size: 1em;
  line-height: 1.5;
  border-radius: 0.25em;
}

.fc .fc-button:hover {
  text-decoration: none;
}

.fc .fc-button:focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(44, 62, 80, 0.25);
}

.fc .fc-button:disabled {
  opacity: 0.65;
}

.fc {
  /* "primary" coloring */
}

.fc .fc-button-primary {
  color: #fff;
  color: var(--fc-button-text-color, #fff);
  background-color: #2C3E50;
  background-color: var(--fc-button-bg-color, #2C3E50);
  border-color: #2C3E50;
  border-color: var(--fc-button-border-color, #2C3E50);
}

.fc .fc-button-primary:hover {
  color: #fff;
  color: var(--fc-button-text-color, #fff);
  background-color: #1e2b37;
  background-color: var(--fc-button-hover-bg-color, #1e2b37);
  border-color: #1a252f;
  border-color: var(--fc-button-hover-border-color, #1a252f);
}

.fc .fc-button-primary:disabled { /* not DRY */
  color: #fff;
  color: var(--fc-button-text-color, #fff);
  background-color: #2C3E50;
  background-color: var(--fc-button-bg-color, #2C3E50);
  border-color: #2C3E50;
  border-color: var(--fc-button-border-color, #2C3E50); /* overrides :hover */
}

.fc .fc-button-primary:focus {
  box-shadow: 0 0 0 0.2rem rgba(76, 91, 106, 0.5);
}

.fc .fc-button-primary:not(:disabled):active,
.fc .fc-button-primary:not(:disabled).fc-button-active {
  color: #fff;
  color: var(--fc-button-text-color, #fff);
  background-color: #1a252f;
  background-color: var(--fc-button-active-bg-color, #1a252f);
  border-color: #151e27;
  border-color: var(--fc-button-active-border-color, #151e27);
}

.fc .fc-button-primary:not(:disabled):active:focus,
.fc .fc-button-primary:not(:disabled).fc-button-active:focus {
  box-shadow: 0 0 0 0.2rem rgba(76, 91, 106, 0.5);
}

.fc {
  /* icons within buttons */
}

.fc .fc-button .fc-icon {
  vertical-align: middle;
  font-size: 1.5em; /* bump up the size (but don't make it bigger than line-height of button, which is 1.5em also) */
}

.fc .fc-button-group {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}

.fc .fc-button-group > .fc-button {
  position: relative;
  flex: 1 1 auto;
}

.fc .fc-button-group > .fc-button:hover {
  z-index: 1;
}

.fc .fc-button-group > .fc-button:focus,
.fc .fc-button-group > .fc-button:active,
.fc .fc-button-group > .fc-button.fc-button-active {
  z-index: 1;
}

.fc-direction-ltr .fc-button-group > .fc-button:not(:first-child) {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.fc-direction-ltr .fc-button-group > .fc-button:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.fc-direction-rtl .fc-button-group > .fc-button:not(:first-child) {
  margin-right: -1px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.fc-direction-rtl .fc-button-group > .fc-button:not(:last-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.fc .fc-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media (max-width: 767.98px) {
  .fc .fc-toolbar {
    flex-direction: column;
  }
}
.fc .fc-toolbar.fc-header-toolbar {
  margin: -0.5rem 0 0.75rem;
}
.fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk {
  display: flex;
  align-items: center;
  padding: 0.5rem 0;
}
.fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk:empty {
  display: none;
}
.fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .btn, .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .dual-listbox .dual-listbox__button, .dual-listbox .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .dual-listbox__button {
  position: relative;
  font-family: "DM Sans", sans-serif;
  font-weight: 700;
  font-size: 12px;
  background: transparent;
  color: #8094ae;
  border: 1px solid #dbdfea;
  text-transform: capitalize;
}
.fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .btn:disabled, .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .dual-listbox .dual-listbox__button:disabled, .dual-listbox .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .dual-listbox__button:disabled {
  background: transparent;
  color: #8094ae;
  border: 1px solid #dbdfea;
}
.fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .btn:hover, .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .dual-listbox .dual-listbox__button:hover, .dual-listbox .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .dual-listbox__button:hover, .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .btn:focus, .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .dual-listbox .dual-listbox__button:focus, .dual-listbox .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .dual-listbox__button:focus {
  color: #526484;
  background: #f5f6fa;
  border: 1px solid #dbdfea;
}
.fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .btn:focus, .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .dual-listbox .dual-listbox__button:focus, .dual-listbox .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .dual-listbox__button:focus {
  box-shadow: 0 0 0 0.2rem rgba(219, 223, 234, 0.5);
}
.fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .btn.active, .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .dual-listbox .active.dual-listbox__button, .dual-listbox .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .active.dual-listbox__button {
  color: #364a63;
  border: 1px solid #dbdfea;
  background: #f5f6fa;
  box-shadow: inset 0 0 4px -1px rgba(128, 148, 174, 0.25);
}
.fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .fc-prev-button, .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .fc-next-button {
  border: none !important;
}
.fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .fc-prev-button:hover, .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .fc-prev-button:focus, .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .fc-next-button:hover, .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .fc-next-button:focus {
  background: transparent !important;
  box-shadow: none !important;
}

@media (max-width: 767.98px) {
  .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk {
    justify-content: space-between;
    width: 100%;
  }
  .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .fc-dayGridMonth-button, .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .fc-timeGridWeek-button, .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .fc-timeGridDay-button, .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .fc-listWeek-button {
    color: transparent !important;
    width: 2.125rem;
  }
  .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .fc-dayGridMonth-button:before, .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .fc-timeGridWeek-button:before, .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .fc-timeGridDay-button:before, .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .fc-listWeek-button:before {
    color: #8094ae;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .fc-dayGridMonth-button:before {
    content: "M";
  }
  .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .fc-timeGridWeek-button:before {
    content: "W";
  }
  .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .fc-timeGridDay-button:before {
    content: "D";
  }
  .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .fc-listWeek-button:before {
    content: "L";
  }
  .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-title + .btn-group {
    margin-right: -0.75rem;
  }
}
.fc .fc-toolbar.fc-footer-toolbar {
  margin-top: 1.5em;
}

.fc .fc-toolbar-title {
  font-size: 1.125rem;
  margin: 0;
}

.fc-direction-ltr .fc-toolbar > * > :not(:first-child) {
  margin-left: 0.75em; /* space between */
}

.fc-direction-rtl .fc-toolbar > * > :not(:first-child) {
  margin-right: 0.75em; /* space between */
}

.fc-direction-rtl .fc-toolbar-ltr { /* when the toolbar-chunk positioning system is explicitly left-to-right */
  flex-direction: row-reverse;
}

.fc .fc-scroller {
  -webkit-overflow-scrolling: touch;
  position: relative; /* for abs-positioned elements within */
}

.fc .fc-scroller-liquid {
  height: 100%;
}

.fc .fc-scroller-liquid-absolute {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}

.fc .fc-scroller-harness {
  position: relative;
  overflow: hidden;
  direction: ltr;
  /* hack for chrome computing the scroller's right/left wrong for rtl. undone below... */
  /* TODO: demonstrate in codepen */
}

.fc .fc-scroller-harness-liquid {
  height: 100%;
}

.fc-direction-rtl .fc-scroller-harness > .fc-scroller { /* undo above hack */
  direction: rtl;
}

.fc-theme-standard .fc-scrollgrid {
  border: 1px solid #ddd;
  border: 1px solid var(--fc-border-color, #ddd); /* bootstrap does this. match */
}

.fc .fc-scrollgrid,
.fc .fc-scrollgrid table { /* all tables (self included) */
  width: 100%; /* because tables don't normally do this */
  table-layout: fixed;
}

.fc .fc-scrollgrid table { /* inner tables */
  border-top-style: hidden;
  border-left-style: hidden;
  border-right-style: hidden;
}

.fc .fc-scrollgrid {
  border-collapse: separate;
  border-right-width: 0;
  border-bottom-width: 0;
}

.fc .fc-scrollgrid-liquid {
  height: 100%;
}

.fc .fc-scrollgrid-section { /* a <tr> */
  height: 1px;
}

.fc .fc-scrollgrid-section > td {
  height: 1px; /* needs a height so inner div within grow. better than 0, for firefox */
}

.fc .fc-scrollgrid-section table {
  height: 1px;
  /* for most browsers, if a height isn't set on the table, can't do liquid-height within cells */
  /* serves as a min-height. harmless */
}

.fc .fc-scrollgrid-section-liquid {
  height: auto;
}

.fc .fc-scrollgrid-section-liquid > td {
  height: 100%; /* better than \`auto\`, for firefox */
}

.fc .fc-scrollgrid-section > * {
  border-top-width: 0;
  border-left-width: 0;
}

.fc .fc-scrollgrid-section-header > *,
.fc .fc-scrollgrid-section-footer > * {
  border-bottom-width: 0;
}

.fc .fc-scrollgrid-section-body table,
.fc .fc-scrollgrid-section-footer table {
  border-bottom-style: hidden; /* head keeps its bottom border tho */
}

.fc {
  /* stickiness */
}

.fc .fc-scrollgrid-section-sticky > * {
  background: #fff;
  background: var(--fc-page-bg-color, #fff);
  position: sticky;
  z-index: 2; /* TODO: var */
  /* TODO: box-shadow when sticking */
}

.fc .fc-scrollgrid-section-header.fc-scrollgrid-section-sticky > * {
  top: 0; /* because border-sharing causes a gap at the top */
  /* TODO: give safari -1. has bug */
}

.fc .fc-scrollgrid-section-footer.fc-scrollgrid-section-sticky > * {
  bottom: 0; /* known bug: bottom-stickiness doesn't work in safari */
}

.fc .fc-scrollgrid-sticky-shim { /* for horizontal scrollbar */
  height: 1px; /* needs height to create scrollbars */
  margin-bottom: -1px;
}

.fc-sticky { /* no .fc wrap because used as child of body */
  position: sticky;
}

.fc .fc-view-harness {
  flex-grow: 1; /* because this harness is WITHIN the .fc's flexbox */
  position: relative;
}

.fc {
  /* when the harness controls the height, make the view liquid */
}

.fc .fc-view-harness-active > .fc-view {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.fc .fc-col-header-cell-cushion {
  display: inline-block; /* x-browser for when sticky (when multi-tier header) */
  padding: 2px 4px;
}

.fc .fc-bg-event,
.fc .fc-non-business,
.fc .fc-highlight {
  /* will always have a harness with position:relative/absolute, so absolutely expand */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.fc .fc-non-business {
  background: rgba(215, 215, 215, 0.3);
  background: var(--fc-non-business-color, rgba(215, 215, 215, 0.3));
}

.fc .fc-bg-event {
  background: rgb(143, 223, 130);
  background: var(--fc-bg-event-color, rgb(143, 223, 130));
  opacity: 0.3;
  opacity: var(--fc-bg-event-opacity, 0.3);
}

.fc .fc-bg-event .fc-event-title {
  margin: 0.5em;
  font-size: 0.85em;
  font-size: var(--fc-small-font-size, 0.85em);
  font-style: italic;
}

.fc .fc-highlight {
  background: rgba(188, 232, 241, 0.3);
  background: var(--fc-highlight-color, rgba(188, 232, 241, 0.3));
}

.fc .fc-cell-shaded,
.fc .fc-day-disabled {
  background: rgba(208, 208, 208, 0.3);
  background: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));
}

/* link resets */
/* ---------------------------------------------------------------------------------------------------- */
.fc .fc-event {
  padding: 0.125rem 0.375rem;
  margin: 0.5rem 0.375rem;
}

a.fc-event,
a.fc-event:hover {
  text-decoration: none;
}

/* cursor */
.fc-event[href],
.fc-event.fc-event-draggable {
  cursor: pointer;
}

/* event text content */
/* ---------------------------------------------------------------------------------------------------- */
.fc-event .fc-event-main {
  position: relative;
  z-index: 2;
}

/* dragging */
/* ---------------------------------------------------------------------------------------------------- */
.fc-event-dragging:not(.fc-event-selected) { /* MOUSE */
  opacity: 0.75;
}

.fc-event-dragging.fc-event-selected { /* TOUCH */
  box-shadow: 0 2px 7px rgba(0, 0, 0, 0.3);
}

/* resizing */
/* ---------------------------------------------------------------------------------------------------- */
/* (subclasses should hone positioning for touch and non-touch) */
.fc-event .fc-event-resizer {
  display: none;
  position: absolute;
  z-index: 4;
}

.fc-event:hover,
.fc-event-selected { /* TOUCH */ }

.fc-event:hover .fc-event-resizer, .fc-event-selected .fc-event-resizer {
  display: block;
}

.fc-event-selected .fc-event-resizer {
  border-radius: 4px;
  border-radius: calc(var(--fc-event-resizer-dot-total-width, 8px) / 2);
  border-width: 1px;
  border-width: var(--fc-event-resizer-dot-border-width, 1px);
  width: 8px;
  width: var(--fc-event-resizer-dot-total-width, 8px);
  height: 8px;
  height: var(--fc-event-resizer-dot-total-width, 8px);
  border-style: solid;
  border-color: inherit;
  background: #fff;
  background: var(--fc-page-bg-color, #fff);
}

.fc-event-selected .fc-event-resizer:before {
  content: "";
  position: absolute;
  top: -20px;
  left: -20px;
  right: -20px;
  bottom: -20px;
}

/* selecting (always TOUCH) */
/* ---------------------------------------------------------------------------------------------------- */
.fc-event-selected {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.fc-event-selected:before {
  content: "";
  position: absolute;
  z-index: 3;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.fc-event-selected {
  /* dimmer effect */
}

.fc-event-selected:after {
  content: "";
  background: rgba(0, 0, 0, 0.25);
  background: var(--fc-event-selected-overlay-color, rgba(0, 0, 0, 0.25));
  position: absolute;
  z-index: 1;
  /* assume there's a border on all sides. overcome it. */
  /* sometimes there's NOT a border, in which case the dimmer will go over */
  /* an adjacent border, which looks fine. */
  top: -1px;
  left: -1px;
  right: -1px;
  bottom: -1px;
}

/*
A HORIZONTAL event
*/
.fc-h-event { /* allowed to be top-level */
  display: block;
  border: 1px solid #4461F2;
  background-color: #4461F2;
}

.fc-h-event .fc-event-main-frame {
  display: flex; /* for make fc-event-title-container expand */
}

.fc-h-event .fc-event-time {
  max-width: 100%; /* clip overflow on this element */
  overflow: hidden;
}

.fc-h-event .fc-event-title-container { /* serves as a container for the sticky cushion */
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0; /* important for allowing to shrink all the way */
}

.fc-h-event .fc-event-title {
  display: inline-block; /* need this to be sticky cross-browser */
  vertical-align: top; /* for not messing up line-height */
  left: 0; /* for sticky */
  right: 0; /* for sticky */
  max-width: 100%; /* clip overflow on this element */
  overflow: hidden;
}

.fc-h-event.fc-event-selected:before {
  /* expand hit area */
  top: -10px;
  bottom: -10px;
}

/* adjust border and border-radius (if there is any) for non-start/end */
.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-start),
.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-end) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left-width: 0;
}

.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-end),
.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-start) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right-width: 0;
}

/* resizers */
.fc-h-event:not(.fc-event-selected) .fc-event-resizer {
  top: 0;
  bottom: 0;
  width: 8px;
  width: var(--fc-event-resizer-thickness, 8px);
}

.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start,
.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end {
  cursor: w-resize;
  left: -4px;
  left: calc(var(--fc-event-resizer-thickness, 8px) / -2);
}

.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end,
.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start {
  cursor: e-resize;
  right: -4px;
  right: calc(var(--fc-event-resizer-thickness, 8px) / -2);
}

/* resizers for TOUCH */
.fc-h-event.fc-event-selected .fc-event-resizer {
  top: 50%;
  margin-top: -4px;
  margin-top: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);
}

.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-start,
.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-end {
  left: -4px;
  left: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);
}

.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-end,
.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-start {
  right: -4px;
  right: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);
}

:root {
  --fc-daygrid-event-dot-width: 8px;
}

.fc .fc-popover {
  position: fixed;
  top: 0; /* for when not positioned yet */
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.fc .fc-popover-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 3px 4px;
}

.fc .fc-popover-title {
  margin: 0 2px;
}

.fc .fc-popover-close {
  cursor: pointer;
  opacity: 0.65;
  font-size: 1.1em;
}

.fc-theme-standard .fc-popover {
  border: 1px solid #ddd;
  border: 1px solid var(--fc-border-color, #ddd);
  background: #fff;
  background: var(--fc-page-bg-color, #fff);
}

.fc-theme-standard .fc-popover-header {
  background: rgba(208, 208, 208, 0.3);
  background: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));
}

/* help things clear margins of inner content */
.fc-daygrid-day-frame,
.fc-daygrid-day-events,
.fc-daygrid-event-harness { /* for event top/bottom margins */ }

.fc-daygrid-day-frame:before, .fc-daygrid-day-events:before, .fc-daygrid-event-harness:before {
  content: "";
  clear: both;
  display: table;
}

.fc-daygrid-day-frame:after, .fc-daygrid-day-events:after, .fc-daygrid-event-harness:after {
  content: "";
  clear: both;
  display: table;
}

.fc .fc-daygrid-body { /* a <div> that wraps the table */
  position: relative;
  z-index: 1; /* container inner z-index's because <tr>s can't do it */
}

.fc .fc-daygrid-day.fc-day-today {
  background-color: rgba(68, 97, 242, 0.07);
}

.fc .fc-daygrid-day-frame {
  position: relative;
  min-height: 100%; /* seems to work better than \`height\` because sets height after rows/cells naturally do it */
}

.fc {
  /* cell top */
}

.fc .fc-daygrid-day-top {
  display: flex;
  flex-direction: row-reverse;
}

.fc .fc-day-other .fc-daygrid-day-top {
  opacity: 0.5;
}

.fc {
  /* day number (within cell top) */
}

.fc .fc-daygrid-day-number {
  position: relative;
  z-index: 4;
  padding: 4px;
}

.fc {
  /* event container */
}

.fc .fc-daygrid-day-events {
  margin-top: 1px; /* needs to be margin, not padding, so that available cell height can be computed */
}

.fc {
  /* positioning for balanced vs natural */
}

.fc .fc-daygrid-body-balanced .fc-daygrid-day-events {
  position: absolute;
  left: 0;
  right: 0;
}

.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events {
  position: relative; /* for containing abs positioned event harnesses */
  min-height: 2em; /* in addition to being a min-height during natural height, equalizes the heights a little bit */
}

.fc .fc-daygrid-body-natural { /* can coexist with -unbalanced */ }

.fc .fc-daygrid-body-natural .fc-daygrid-day-events {
  margin-bottom: 1em;
}

.fc {
  /* event harness */
}

.fc .fc-daygrid-event-harness {
  position: relative;
}

.fc .fc-daygrid-event-harness-abs {
  position: absolute;
  top: 0; /* fallback coords for when cannot yet be computed */
  left: 0; /* */
  right: 0; /* */
}

.fc .fc-daygrid-bg-harness {
  position: absolute;
  top: 0;
  bottom: 0;
}

.fc {
  /* bg content */
}

.fc .fc-daygrid-day-bg .fc-non-business {
  z-index: 1;
}

.fc .fc-daygrid-day-bg .fc-bg-event {
  z-index: 2;
}

.fc .fc-daygrid-day-bg .fc-highlight {
  z-index: 3;
}

.fc {
  /* events */
}

.fc .fc-daygrid-event {
  z-index: 6;
  margin: 0.375rem 0.5rem !important;
}

.fc .fc-daygrid-event.fc-event-mirror {
  z-index: 7;
}

.fc {
  /* cell bottom (within day-events) */
}

.fc .fc-daygrid-day-bottom {
  font-size: 0.85em;
  margin: 2px 3px 0;
}

.fc .fc-daygrid-more-link {
  position: relative;
  z-index: 4;
  cursor: pointer;
}

.fc {
  /* week number (within frame) */
}

.fc .fc-daygrid-week-number {
  position: absolute;
  z-index: 5;
  top: 0;
  padding: 2px;
  min-width: 1.5em;
  text-align: center;
  background-color: rgba(208, 208, 208, 0.3);
  background-color: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));
  color: #808080;
  color: var(--fc-neutral-text-color, #808080);
}

.fc {
  /* popover */
}

.fc .fc-more-popover {
  z-index: 8;
}

.fc .fc-more-popover .fc-popover-body {
  min-width: 220px;
  padding: 10px;
}

.fc-direction-ltr .fc-daygrid-event.fc-event-start,
.fc-direction-rtl .fc-daygrid-event.fc-event-end {
  margin-left: 0.25rem;
}

.fc-direction-ltr .fc-daygrid-event.fc-event-end,
.fc-direction-rtl .fc-daygrid-event.fc-event-start {
  margin-right: 0.25rem;
}

.fc-direction-ltr .fc-daygrid-week-number {
  left: 0;
  border-radius: 0 0 3px 0;
}

.fc-direction-rtl .fc-daygrid-week-number {
  right: 0;
  border-radius: 0 0 0 3px;
}

.fc-liquid-hack .fc-daygrid-day-frame {
  position: static; /* will cause inner absolute stuff to expand to <td> */
}

.fc-daygrid-event { /* make root-level, because will be dragged-and-dropped outside of a component root */
  position: relative; /* for z-indexes assigned later */
  white-space: nowrap;
  border-radius: 3px; /* dot event needs this to when selected */
  font-size: 0.85em;
  font-size: var(--fc-small-font-size, 0.85em);
}

/* --- the rectangle ("block") style of event --- */
.fc-daygrid-block-event .fc-event-time {
  font-weight: bold;
}

.fc-daygrid-block-event .fc-event-time,
.fc-daygrid-block-event .fc-event-title {
  padding: 1px;
}

/* --- the dot style of event --- */
.fc-daygrid-dot-event {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.25rem;
}

.fc-daygrid-dot-event .fc-event-title {
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0; /* important for allowing to shrink all the way */
  overflow: hidden;
  font-weight: bold;
}

.fc-daygrid-dot-event:hover,
.fc-daygrid-dot-event.fc-event-mirror {
  background: rgba(0, 0, 0, 0.1);
}

.fc-daygrid-dot-event.fc-event-selected:before {
  /* expand hit area */
  top: -10px;
  bottom: -10px;
}

.fc-daygrid-event-dot { /* the actual dot */
  margin: -2px 4px 0;
  box-sizing: content-box;
  width: 0;
  height: 0;
  border: 3px solid #4461F2;
  border-radius: 4px;
}

/* --- spacing between time and title --- */
.fc-direction-ltr .fc-daygrid-event .fc-event-time {
  margin-right: 3px;
}

.fc-direction-rtl .fc-daygrid-event .fc-event-time {
  margin-left: 3px;
}

/*
A VERTICAL event
*/
.fc-v-event { /* allowed to be top-level */
  display: block;
  border: 1px solid #4461F2;
  background-color: #4461F2;
}

.fc-v-event .fc-event-main {
  height: 100%;
}

.fc-v-event .fc-event-main-frame {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.fc-v-event .fc-event-time {
  flex-grow: 0;
  flex-shrink: 0;
  max-height: 100%;
  overflow: hidden;
}

.fc-v-event .fc-event-title-container { /* a container for the sticky cushion */
  flex-grow: 1;
  flex-shrink: 1;
  min-height: 0; /* important for allowing to shrink all the way */
}

.fc-v-event .fc-event-title { /* will have fc-sticky on it */
  top: 0;
  bottom: 0;
  max-height: 100%; /* clip overflow */
  overflow: hidden;
}

.fc-v-event:not(.fc-event-start) {
  border-top-width: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.fc-v-event:not(.fc-event-end) {
  border-bottom-width: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.fc-v-event.fc-event-selected:before {
  /* expand hit area */
  left: -10px;
  right: -10px;
}

.fc-v-event {
  /* resizer (mouse AND touch) */
}

.fc-v-event .fc-event-resizer-start {
  cursor: n-resize;
}

.fc-v-event .fc-event-resizer-end {
  cursor: s-resize;
}

.fc-v-event {
  /* resizer for MOUSE */
}

.fc-v-event:not(.fc-event-selected) .fc-event-resizer {
  height: 8px;
  height: var(--fc-event-resizer-thickness, 8px);
  left: 0;
  right: 0;
}

.fc-v-event:not(.fc-event-selected) .fc-event-resizer-start {
  top: -4px;
  top: calc(var(--fc-event-resizer-thickness, 8px) / -2);
}

.fc-v-event:not(.fc-event-selected) .fc-event-resizer-end {
  bottom: -4px;
  bottom: calc(var(--fc-event-resizer-thickness, 8px) / -2);
}

.fc-v-event {
  /* resizer for TOUCH (when event is "selected") */
}

.fc-v-event.fc-event-selected .fc-event-resizer {
  left: 50%;
  margin-left: -4px;
  margin-left: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);
}

.fc-v-event.fc-event-selected .fc-event-resizer-start {
  top: -4px;
  top: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);
}

.fc-v-event.fc-event-selected .fc-event-resizer-end {
  bottom: -4px;
  bottom: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);
}

.fc .fc-timegrid .fc-daygrid-body { /* the all-day daygrid within the timegrid view */
  z-index: 2; /* put above the timegrid-body so that more-popover is above everything. TODO: better solution */
}

.fc .fc-timegrid-divider {
  padding: 0 0 2px; /* browsers get confused when you set height. use padding instead */
}

.fc .fc-timegrid-body {
  position: relative;
  z-index: 1; /* scope the z-indexes of slots and cols */
  min-height: 100%; /* fill height always, even when slat table doesn't grow */
}

.fc .fc-timegrid-axis-chunk { /* for advanced ScrollGrid */
  position: relative;
}

.fc .fc-timegrid-axis-chunk > table {
  position: relative;
  z-index: 1; /* above the now-indicator-container */
}

.fc .fc-timegrid-slots {
  position: relative;
  z-index: 1;
}

.fc .fc-timegrid-slot { /* a <td> */
  height: 1.5em;
  border-bottom: 0; /* each cell owns its top border */
  padding: 0.25rem;
}

.fc .fc-timegrid-slot:empty:before {
  content: " "; /* make sure there's at least an empty space to create height for height syncing */
}

.fc .fc-timegrid-slot-minor {
  border-top-style: dotted;
}

.fc .fc-timegrid-slot-label-cushion {
  display: inline-block;
  white-space: nowrap;
}

.fc .fc-timegrid-slot-label {
  vertical-align: middle; /* vertical align the slots */
}

.fc {
  /* slots AND axis cells (top-left corner of view including the "all-day" text) */
}

.fc .fc-timegrid-axis-cushion,
.fc .fc-timegrid-slot-label-cushion {
  padding: 0 4px;
}

.fc {
  /* axis cells (top-left corner of view including the "all-day" text) */
  /* vertical align is more complicated, uses flexbox */
}

.fc .fc-timegrid-axis-frame-liquid {
  height: 100%; /* will need liquid-hack in FF */
}

.fc .fc-timegrid-axis-frame {
  overflow: hidden;
  display: flex;
  align-items: center; /* vertical align */
  justify-content: flex-end; /* horizontal align. matches text-align below */
}

.fc .fc-timegrid-axis-cushion {
  max-width: 60px; /* limits the width of the "all-day" text */
  flex-shrink: 0; /* allows text to expand how it normally would, regardless of constrained width */
}

.fc-direction-ltr .fc-timegrid-slot-label-frame {
  text-align: right;
}

.fc-direction-rtl .fc-timegrid-slot-label-frame {
  text-align: left;
}

.fc-liquid-hack .fc-timegrid-axis-frame-liquid {
  height: auto;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.fc .fc-timegrid-col.fc-day-today {
  background-color: rgba(68, 97, 242, 0.07);
}

.fc .fc-timegrid-col-frame {
  min-height: 100%; /* liquid-hack is below */
  position: relative;
}

.fc-liquid-hack .fc-timegrid-col-frame {
  height: auto;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.fc-media-screen .fc-timegrid-cols {
  position: absolute; /* no z-index. children will decide and go above slots */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.fc-media-screen .fc-timegrid-cols > table {
  height: 100%;
}

.fc-media-screen .fc-timegrid-col-bg,
.fc-media-screen .fc-timegrid-col-events,
.fc-media-screen .fc-timegrid-now-indicator-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.fc-media-screen .fc-timegrid-event-harness {
  position: absolute; /* top/left/right/bottom will all be set by JS */
}

.fc {
  /* bg */
}

.fc .fc-timegrid-col-bg {
  z-index: 2; /* TODO: kill */
}

.fc .fc-timegrid-col-bg .fc-non-business {
  z-index: 1;
}

.fc .fc-timegrid-col-bg .fc-bg-event {
  z-index: 2;
}

.fc .fc-timegrid-col-bg .fc-highlight {
  z-index: 3;
}

.fc .fc-timegrid-bg-harness {
  position: absolute; /* top/bottom will be set by JS */
  left: 0;
  right: 0;
}

.fc {
  /* fg events */
  /* (the mirror segs are put into a separate container with same classname, */
  /* and they must be after the normal seg container to appear at a higher z-index) */
}

.fc .fc-timegrid-col-events {
  z-index: 3;
  /* child event segs have z-indexes that are scoped within this div */
}

.fc {
  /* now indicator */
}

.fc .fc-timegrid-now-indicator-container {
  bottom: 0;
  overflow: hidden; /* don't let overflow of lines/arrows cause unnecessary scrolling */
  /* z-index is set on the individual elements */
}

.fc-direction-ltr .fc-timegrid-col-events {
  margin: 0 2.5% 0 2px;
}

.fc-direction-rtl .fc-timegrid-col-events {
  margin: 0 2px 0 2.5%;
}

.fc-timegrid-event-harness-inset .fc-timegrid-event,
.fc-timegrid-event.fc-event-mirror {
  box-shadow: 0px 0px 0px 1px #fff;
  box-shadow: 0px 0px 0px 1px var(--fc-page-bg-color, #fff);
}

.fc-timegrid-event { /* events need to be root */
  font-size: 0.85em;
  font-size: var(--fc-small-font-size, 0.85em);
  border-radius: 3px;
}

.fc-timegrid-event .fc-event-main {
  padding: 1px 1px 0;
}

.fc-timegrid-event .fc-event-time {
  white-space: nowrap;
  font-size: 0.85em;
  font-size: var(--fc-small-font-size, 0.85em);
  margin-bottom: 1px;
}

.fc-timegrid-event-condensed .fc-event-main-frame {
  flex-direction: row;
  overflow: hidden;
}

.fc-timegrid-event-condensed .fc-event-time:after {
  content: " - "; /* dash surrounded by non-breaking spaces */
}

.fc-timegrid-event-condensed .fc-event-title {
  font-size: 0.85em;
  font-size: var(--fc-small-font-size, 0.85em);
}

.fc-media-screen .fc-timegrid-event {
  position: absolute; /* absolute WITHIN the harness */
  top: 0;
  bottom: 1px; /* stay away from bottom slot line */
  left: 0;
  right: 0;
}

.fc {
  /* line */
}

.fc .fc-timegrid-now-indicator-line {
  position: absolute;
  z-index: 4;
  left: 0;
  right: 0;
  border-style: solid;
  border-color: #e85347;
  border-width: 1px 0 0;
}

.fc {
  /* arrow */
}

.fc .fc-timegrid-now-indicator-arrow {
  position: absolute;
  z-index: 4;
  margin-top: -5px; /* vertically center on top coordinate */
  border-style: solid;
  border-color: #e85347;
}

.fc-direction-ltr .fc-timegrid-now-indicator-arrow {
  left: 0;
  /* triangle pointing right. TODO: mixin */
  border-width: 5px 0 5px 6px;
  border-top-color: transparent;
  border-bottom-color: transparent;
}

.fc-direction-rtl .fc-timegrid-now-indicator-arrow {
  right: 0;
  /* triangle pointing left. TODO: mixin */
  border-width: 5px 6px 5px 0;
  border-top-color: transparent;
  border-bottom-color: transparent;
}

:root {
  --fc-list-event-dot-width: 10px;
  --fc-list-event-hover-bg-color: #f5f5f5;
}

.fc-theme-standard .fc-list {
  border: 1px solid #ddd;
}

.fc {
  /* message when no events */
}

.fc .fc-list-empty {
  background-color: #f5f6fa;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center; /* vertically aligns fc-list-empty-inner */
}

.fc .fc-list-empty-cushion {
  margin: 5em 0;
}

.fc {
  /* table within the scroller */
  /* ---------------------------------------------------------------------------------------------------- */
}

.fc .fc-list-table {
  width: 100%;
  border-style: hidden; /* kill outer border on theme */
}

.fc .fc-list-table tr > * {
  border-left: 0;
  border-right: 0;
}

.fc .fc-list-sticky .fc-list-day > * { /* the cells */
  position: sticky;
  top: 0;
  background: #fff;
  background: var(--fc-page-bg-color, #fff); /* for when headers are styled to be transparent and sticky */
}

.fc .fc-list-table th {
  padding: 0; /* uses an inner-wrapper instead... */
}

.fc .fc-list-table td,
.fc .fc-list-day-cushion {
  padding: 0.75rem 1rem;
}

.fc .fc-list-table th .fc-list-day-cushion {
  padding: 0.5rem 1rem;
}

.fc {
  /* date heading rows */
  /* ---------------------------------------------------------------------------------------------------- */
}

.fc .fc-list-day-cushion:after {
  content: "";
  clear: both;
  display: table; /* clear floating */
}

.fc-theme-standard .fc-list-day-cushion {
  background-color: rgba(208, 208, 208, 0.3);
  background-color: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));
}

.fc-direction-ltr .fc-list-day-text,
.fc-direction-rtl .fc-list-day-side-text {
  float: left;
}

.fc-direction-ltr .fc-list-day-side-text,
.fc-direction-rtl .fc-list-day-text {
  float: right;
}

/* make the dot closer to the event title */
.fc-direction-ltr .fc-list-table .fc-list-event-graphic {
  padding-right: 0;
}

.fc-direction-rtl .fc-list-table .fc-list-event-graphic {
  padding-left: 0;
}

.fc .fc-list-event.fc-event-forced-url {
  cursor: pointer; /* whole row will seem clickable */
}

.fc {
  /* shrink certain cols */
}

.fc .fc-list-event-graphic,
.fc .fc-list-event-time {
  white-space: nowrap;
  width: 1px;
}

.fc .fc-list-event-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  background-color: #4461F2;
  border: 2px solid #4461F2;
  border-radius: 5px;
}

.fc {
  /* reset <a> styling */
}

.fc .fc-list-event-title a {
  color: inherit;
  text-decoration: none;
}

.fc {
  /* underline link when hovering over any part of row */
}

.fc .fc-list-event.fc-event-forced-url:hover a {
  text-decoration: underline;
}

.fc-theme-bootstrap a:not([href]) {
  color: inherit; /* natural color for navlinks */
}

.fc a.fc-event:not([href]) {
  color: #fff;
  background: #4461F2;
}
.fc a.fc-event:not([href]) .fc-daygrid-event-dot {
  border-color: #fff;
}

.fc-prev-button, .fc-next-button {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.fc-prev-button > .fa, .fc-next-button > .fa {
  font-size: 1.25rem;
}

span[class*=fc-event] .dot {
  display: inline-block;
  border: 1px solid #4461F2;
  margin-right: 0.5rem;
}

a.fc-event-primary {
  background-color: #4461F2 !important;
  border-color: #4461F2 !important;
  color: #fff !important;
}
a.fc-event-primary .fc-daygrid-event-dot, a.fc-event-primary .fc-list-event-dot {
  border-color: #fff !important;
}

.modal-header.fc-event-primary {
  background-color: #4461F2 !important;
  border-color: #4461F2 !important;
}
.modal-header.fc-event-primary .close, .modal-header.fc-event-primary .modal-title {
  color: #fff !important;
}

span.fc-event-primary .dot {
  background-color: #4461F2 !important;
  border-color: #4461F2 !important;
}

.fc-event-primary:not(a) .fc-list-event-dot {
  background-color: #4461F2 !important;
  border-color: #4461F2 !important;
}

a.fc-event-success {
  background-color: #1ee0ac !important;
  border-color: #1ee0ac !important;
  color: #fff !important;
}
a.fc-event-success .fc-daygrid-event-dot, a.fc-event-success .fc-list-event-dot {
  border-color: #fff !important;
}

.modal-header.fc-event-success {
  background-color: #1ee0ac !important;
  border-color: #1ee0ac !important;
}
.modal-header.fc-event-success .close, .modal-header.fc-event-success .modal-title {
  color: #fff !important;
}

span.fc-event-success .dot {
  background-color: #1ee0ac !important;
  border-color: #1ee0ac !important;
}

.fc-event-success:not(a) .fc-list-event-dot {
  background-color: #1ee0ac !important;
  border-color: #1ee0ac !important;
}

a.fc-event-info {
  background-color: #09c2de !important;
  border-color: #09c2de !important;
  color: #fff !important;
}
a.fc-event-info .fc-daygrid-event-dot, a.fc-event-info .fc-list-event-dot {
  border-color: #fff !important;
}

.modal-header.fc-event-info {
  background-color: #09c2de !important;
  border-color: #09c2de !important;
}
.modal-header.fc-event-info .close, .modal-header.fc-event-info .modal-title {
  color: #fff !important;
}

span.fc-event-info .dot {
  background-color: #09c2de !important;
  border-color: #09c2de !important;
}

.fc-event-info:not(a) .fc-list-event-dot {
  background-color: #09c2de !important;
  border-color: #09c2de !important;
}

a.fc-event-warning {
  background-color: #f4bd0e !important;
  border-color: #f4bd0e !important;
  color: #fff !important;
}
a.fc-event-warning .fc-daygrid-event-dot, a.fc-event-warning .fc-list-event-dot {
  border-color: #fff !important;
}

.modal-header.fc-event-warning {
  background-color: #f4bd0e !important;
  border-color: #f4bd0e !important;
}
.modal-header.fc-event-warning .close, .modal-header.fc-event-warning .modal-title {
  color: #fff !important;
}

span.fc-event-warning .dot {
  background-color: #f4bd0e !important;
  border-color: #f4bd0e !important;
}

.fc-event-warning:not(a) .fc-list-event-dot {
  background-color: #f4bd0e !important;
  border-color: #f4bd0e !important;
}

a.fc-event-danger {
  background-color: #e85347 !important;
  border-color: #e85347 !important;
  color: #fff !important;
}
a.fc-event-danger .fc-daygrid-event-dot, a.fc-event-danger .fc-list-event-dot {
  border-color: #fff !important;
}

.modal-header.fc-event-danger {
  background-color: #e85347 !important;
  border-color: #e85347 !important;
}
.modal-header.fc-event-danger .close, .modal-header.fc-event-danger .modal-title {
  color: #fff !important;
}

span.fc-event-danger .dot {
  background-color: #e85347 !important;
  border-color: #e85347 !important;
}

.fc-event-danger:not(a) .fc-list-event-dot {
  background-color: #e85347 !important;
  border-color: #e85347 !important;
}

a.fc-event-secondary {
  background-color: #364a63 !important;
  border-color: #364a63 !important;
  color: #fff !important;
}
a.fc-event-secondary .fc-daygrid-event-dot, a.fc-event-secondary .fc-list-event-dot {
  border-color: #fff !important;
}

.modal-header.fc-event-secondary {
  background-color: #364a63 !important;
  border-color: #364a63 !important;
}
.modal-header.fc-event-secondary .close, .modal-header.fc-event-secondary .modal-title {
  color: #fff !important;
}

span.fc-event-secondary .dot {
  background-color: #364a63 !important;
  border-color: #364a63 !important;
}

.fc-event-secondary:not(a) .fc-list-event-dot {
  background-color: #364a63 !important;
  border-color: #364a63 !important;
}

a.fc-event-dark {
  background-color: #1f2b3a !important;
  border-color: #1f2b3a !important;
  color: #fff !important;
}
a.fc-event-dark .fc-daygrid-event-dot, a.fc-event-dark .fc-list-event-dot {
  border-color: #fff !important;
}

.modal-header.fc-event-dark {
  background-color: #1f2b3a !important;
  border-color: #1f2b3a !important;
}
.modal-header.fc-event-dark .close, .modal-header.fc-event-dark .modal-title {
  color: #fff !important;
}

span.fc-event-dark .dot {
  background-color: #1f2b3a !important;
  border-color: #1f2b3a !important;
}

.fc-event-dark:not(a) .fc-list-event-dot {
  background-color: #1f2b3a !important;
  border-color: #1f2b3a !important;
}

a.fc-event-blue {
  background-color: #559bfb !important;
  border-color: #559bfb !important;
  color: #fff !important;
}
a.fc-event-blue .fc-daygrid-event-dot, a.fc-event-blue .fc-list-event-dot {
  border-color: #fff !important;
}

.modal-header.fc-event-blue {
  background-color: #559bfb !important;
  border-color: #559bfb !important;
}
.modal-header.fc-event-blue .close, .modal-header.fc-event-blue .modal-title {
  color: #fff !important;
}

span.fc-event-blue .dot {
  background-color: #559bfb !important;
  border-color: #559bfb !important;
}

.fc-event-blue:not(a) .fc-list-event-dot {
  background-color: #559bfb !important;
  border-color: #559bfb !important;
}

a.fc-event-azure {
  background-color: #1676fb !important;
  border-color: #1676fb !important;
  color: #fff !important;
}
a.fc-event-azure .fc-daygrid-event-dot, a.fc-event-azure .fc-list-event-dot {
  border-color: #fff !important;
}

.modal-header.fc-event-azure {
  background-color: #1676fb !important;
  border-color: #1676fb !important;
}
.modal-header.fc-event-azure .close, .modal-header.fc-event-azure .modal-title {
  color: #fff !important;
}

span.fc-event-azure .dot {
  background-color: #1676fb !important;
  border-color: #1676fb !important;
}

.fc-event-azure:not(a) .fc-list-event-dot {
  background-color: #1676fb !important;
  border-color: #1676fb !important;
}

a.fc-event-indigo {
  background-color: #2c3782 !important;
  border-color: #2c3782 !important;
  color: #fff !important;
}
a.fc-event-indigo .fc-daygrid-event-dot, a.fc-event-indigo .fc-list-event-dot {
  border-color: #fff !important;
}

.modal-header.fc-event-indigo {
  background-color: #2c3782 !important;
  border-color: #2c3782 !important;
}
.modal-header.fc-event-indigo .close, .modal-header.fc-event-indigo .modal-title {
  color: #fff !important;
}

span.fc-event-indigo .dot {
  background-color: #2c3782 !important;
  border-color: #2c3782 !important;
}

.fc-event-indigo:not(a) .fc-list-event-dot {
  background-color: #2c3782 !important;
  border-color: #2c3782 !important;
}

a.fc-event-purple {
  background-color: #816bff !important;
  border-color: #816bff !important;
  color: #fff !important;
}
a.fc-event-purple .fc-daygrid-event-dot, a.fc-event-purple .fc-list-event-dot {
  border-color: #fff !important;
}

.modal-header.fc-event-purple {
  background-color: #816bff !important;
  border-color: #816bff !important;
}
.modal-header.fc-event-purple .close, .modal-header.fc-event-purple .modal-title {
  color: #fff !important;
}

span.fc-event-purple .dot {
  background-color: #816bff !important;
  border-color: #816bff !important;
}

.fc-event-purple:not(a) .fc-list-event-dot {
  background-color: #816bff !important;
  border-color: #816bff !important;
}

a.fc-event-pink {
  background-color: #ff63a5 !important;
  border-color: #ff63a5 !important;
  color: #fff !important;
}
a.fc-event-pink .fc-daygrid-event-dot, a.fc-event-pink .fc-list-event-dot {
  border-color: #fff !important;
}

.modal-header.fc-event-pink {
  background-color: #ff63a5 !important;
  border-color: #ff63a5 !important;
}
.modal-header.fc-event-pink .close, .modal-header.fc-event-pink .modal-title {
  color: #fff !important;
}

span.fc-event-pink .dot {
  background-color: #ff63a5 !important;
  border-color: #ff63a5 !important;
}

.fc-event-pink:not(a) .fc-list-event-dot {
  background-color: #ff63a5 !important;
  border-color: #ff63a5 !important;
}

a.fc-event-orange {
  background-color: #ffa353 !important;
  border-color: #ffa353 !important;
  color: #fff !important;
}
a.fc-event-orange .fc-daygrid-event-dot, a.fc-event-orange .fc-list-event-dot {
  border-color: #fff !important;
}

.modal-header.fc-event-orange {
  background-color: #ffa353 !important;
  border-color: #ffa353 !important;
}
.modal-header.fc-event-orange .close, .modal-header.fc-event-orange .modal-title {
  color: #fff !important;
}

span.fc-event-orange .dot {
  background-color: #ffa353 !important;
  border-color: #ffa353 !important;
}

.fc-event-orange:not(a) .fc-list-event-dot {
  background-color: #ffa353 !important;
  border-color: #ffa353 !important;
}

a.fc-event-teal {
  background-color: #20c997 !important;
  border-color: #20c997 !important;
  color: #fff !important;
}
a.fc-event-teal .fc-daygrid-event-dot, a.fc-event-teal .fc-list-event-dot {
  border-color: #fff !important;
}

.modal-header.fc-event-teal {
  background-color: #20c997 !important;
  border-color: #20c997 !important;
}
.modal-header.fc-event-teal .close, .modal-header.fc-event-teal .modal-title {
  color: #fff !important;
}

span.fc-event-teal .dot {
  background-color: #20c997 !important;
  border-color: #20c997 !important;
}

.fc-event-teal:not(a) .fc-list-event-dot {
  background-color: #20c997 !important;
  border-color: #20c997 !important;
}

a.fc-event-primary-dim {
  background-color: #e7eafd !important;
  border-color: #e7eafd !important;
  color: #4461F2 !important;
}
a.fc-event-primary-dim .fc-daygrid-event-dot, a.fc-event-primary-dim .fc-list-event-dot {
  border-color: #4461F2 !important;
}

.modal-header.fc-event-primary-dim {
  background-color: #e7eafd !important;
  color: #4461F2 !important;
  border-color: #cfd5fb !important;
}
.modal-header.fc-event-primary-dim .close, .modal-header.fc-event-primary-dim .modal-title {
  color: #4461F2 !important;
}

span.fc-event-primary-dim .dot {
  background-color: #e7eafd !important;
  border-color: #4461F2 !important;
}

.fc-event-primary-dim:not(a) .fc-list-event-dot {
  background-color: #e7eafd !important;
  border-color: #7489f5 !important;
}

a.fc-event-success-dim {
  background-color: #e2fbf4 !important;
  border-color: #e2fbf4 !important;
  color: #1ee0ac !important;
}
a.fc-event-success-dim .fc-daygrid-event-dot, a.fc-event-success-dim .fc-list-event-dot {
  border-color: #1ee0ac !important;
}

.modal-header.fc-event-success-dim {
  background-color: #e2fbf4 !important;
  color: #1ee0ac !important;
  border-color: #ccf8ec !important;
}
.modal-header.fc-event-success-dim .close, .modal-header.fc-event-success-dim .modal-title {
  color: #1ee0ac !important;
}

span.fc-event-success-dim .dot {
  background-color: #e2fbf4 !important;
  border-color: #1ee0ac !important;
}

.fc-event-success-dim:not(a) .fc-list-event-dot {
  background-color: #e2fbf4 !important;
  border-color: #4ae7bd !important;
}

a.fc-event-info-dim {
  background-color: #dff7fb !important;
  border-color: #dff7fb !important;
  color: #09c2de !important;
}
a.fc-event-info-dim .fc-daygrid-event-dot, a.fc-event-info-dim .fc-list-event-dot {
  border-color: #09c2de !important;
}

.modal-header.fc-event-info-dim {
  background-color: #dff7fb !important;
  color: #09c2de !important;
  border-color: #c8f1f8 !important;
}
.modal-header.fc-event-info-dim .close, .modal-header.fc-event-info-dim .modal-title {
  color: #09c2de !important;
}

span.fc-event-info-dim .dot {
  background-color: #dff7fb !important;
  border-color: #09c2de !important;
}

.fc-event-info-dim:not(a) .fc-list-event-dot {
  background-color: #dff7fb !important;
  border-color: #24daf6 !important;
}

a.fc-event-warning-dim {
  background-color: #fef6e0 !important;
  border-color: #fef6e0 !important;
  color: #f4bd0e !important;
}
a.fc-event-warning-dim .fc-daygrid-event-dot, a.fc-event-warning-dim .fc-list-event-dot {
  border-color: #f4bd0e !important;
}

.modal-header.fc-event-warning-dim {
  background-color: #fef6e0 !important;
  color: #f4bd0e !important;
  border-color: #fdefc7 !important;
}
.modal-header.fc-event-warning-dim .close, .modal-header.fc-event-warning-dim .modal-title {
  color: #f4bd0e !important;
}

span.fc-event-warning-dim .dot {
  background-color: #fef6e0 !important;
  border-color: #f4bd0e !important;
}

.fc-event-warning-dim:not(a) .fc-list-event-dot {
  background-color: #fef6e0 !important;
  border-color: #f6ca3f !important;
}

a.fc-event-danger-dim {
  background-color: #fce9e7 !important;
  border-color: #fce9e7 !important;
  color: #e85347 !important;
}
a.fc-event-danger-dim .fc-daygrid-event-dot, a.fc-event-danger-dim .fc-list-event-dot {
  border-color: #e85347 !important;
}

.modal-header.fc-event-danger-dim {
  background-color: #fce9e7 !important;
  color: #e85347 !important;
  border-color: #f9d4d0 !important;
}
.modal-header.fc-event-danger-dim .close, .modal-header.fc-event-danger-dim .modal-title {
  color: #e85347 !important;
}

span.fc-event-danger-dim .dot {
  background-color: #fce9e7 !important;
  border-color: #e85347 !important;
}

.fc-event-danger-dim:not(a) .fc-list-event-dot {
  background-color: #fce9e7 !important;
  border-color: #ee7d74 !important;
}

a.fc-event-secondary-dim {
  background-color: #e5ecf5 !important;
  border-color: #e5ecf5 !important;
  color: #364a63 !important;
}
a.fc-event-secondary-dim .fc-daygrid-event-dot, a.fc-event-secondary-dim .fc-list-event-dot {
  border-color: #364a63 !important;
}

.modal-header.fc-event-secondary-dim {
  background-color: #e5ecf5 !important;
  color: #364a63 !important;
  border-color: #d3dfee !important;
}
.modal-header.fc-event-secondary-dim .close, .modal-header.fc-event-secondary-dim .modal-title {
  color: #364a63 !important;
}

span.fc-event-secondary-dim .dot {
  background-color: #e5ecf5 !important;
  border-color: #364a63 !important;
}

.fc-event-secondary-dim:not(a) .fc-list-event-dot {
  background-color: #e5ecf5 !important;
  border-color: #486384 !important;
}

a.fc-event-dark-dim {
  background-color: #d9e1ef !important;
  border-color: #d9e1ef !important;
  color: #1f2b3a !important;
}
a.fc-event-dark-dim .fc-daygrid-event-dot, a.fc-event-dark-dim .fc-list-event-dot {
  border-color: #1f2b3a !important;
}

.modal-header.fc-event-dark-dim {
  background-color: #d9e1ef !important;
  color: #1f2b3a !important;
  border-color: #c7d3e7 !important;
}
.modal-header.fc-event-dark-dim .close, .modal-header.fc-event-dark-dim .modal-title {
  color: #1f2b3a !important;
}

span.fc-event-dark-dim .dot {
  background-color: #d9e1ef !important;
  border-color: #1f2b3a !important;
}

.fc-event-dark-dim:not(a) .fc-list-event-dot {
  background-color: #d9e1ef !important;
  border-color: #31445b !important;
}

a.fc-event-blue-dim {
  background-color: #e9f2fe !important;
  border-color: #e9f2fe !important;
  color: #559bfb !important;
}
a.fc-event-blue-dim .fc-daygrid-event-dot, a.fc-event-blue-dim .fc-list-event-dot {
  border-color: #559bfb !important;
}

.modal-header.fc-event-blue-dim {
  background-color: #e9f2fe !important;
  color: #559bfb !important;
  border-color: #d1e4fd !important;
}
.modal-header.fc-event-blue-dim .close, .modal-header.fc-event-blue-dim .modal-title {
  color: #559bfb !important;
}

span.fc-event-blue-dim .dot {
  background-color: #e9f2fe !important;
  border-color: #559bfb !important;
}

.fc-event-blue-dim:not(a) .fc-list-event-dot {
  background-color: #e9f2fe !important;
  border-color: #87b8fc !important;
}

a.fc-event-azure-dim {
  background-color: #e1edfe !important;
  border-color: #e1edfe !important;
  color: #1676fb !important;
}
a.fc-event-azure-dim .fc-daygrid-event-dot, a.fc-event-azure-dim .fc-list-event-dot {
  border-color: #1676fb !important;
}

.modal-header.fc-event-azure-dim {
  background-color: #e1edfe !important;
  color: #1676fb !important;
  border-color: #c8defd !important;
}
.modal-header.fc-event-azure-dim .close, .modal-header.fc-event-azure-dim .modal-title {
  color: #1676fb !important;
}

span.fc-event-azure-dim .dot {
  background-color: #e1edfe !important;
  border-color: #1676fb !important;
}

.fc-event-azure-dim:not(a) .fc-list-event-dot {
  background-color: #e1edfe !important;
  border-color: #4893fc !important;
}

a.fc-event-indigo-dim {
  background-color: #e4e5ef !important;
  border-color: #e4e5ef !important;
  color: #2c3782 !important;
}
a.fc-event-indigo-dim .fc-daygrid-event-dot, a.fc-event-indigo-dim .fc-list-event-dot {
  border-color: #2c3782 !important;
}

.modal-header.fc-event-indigo-dim {
  background-color: #e4e5ef !important;
  color: #2c3782 !important;
  border-color: #d4d6e6 !important;
}
.modal-header.fc-event-indigo-dim .close, .modal-header.fc-event-indigo-dim .modal-title {
  color: #2c3782 !important;
}

span.fc-event-indigo-dim .dot {
  background-color: #e4e5ef !important;
  border-color: #2c3782 !important;
}

.fc-event-indigo-dim:not(a) .fc-list-event-dot {
  background-color: #e4e5ef !important;
  border-color: #3947a8 !important;
}

a.fc-event-purple-dim {
  background-color: #efecff !important;
  border-color: #efecff !important;
  color: #816bff !important;
}
a.fc-event-purple-dim .fc-daygrid-event-dot, a.fc-event-purple-dim .fc-list-event-dot {
  border-color: #816bff !important;
}

.modal-header.fc-event-purple-dim {
  background-color: #efecff !important;
  color: #816bff !important;
  border-color: #dad3ff !important;
}
.modal-header.fc-event-purple-dim .close, .modal-header.fc-event-purple-dim .modal-title {
  color: #816bff !important;
}

span.fc-event-purple-dim .dot {
  background-color: #efecff !important;
  border-color: #816bff !important;
}

.fc-event-purple-dim:not(a) .fc-list-event-dot {
  background-color: #efecff !important;
  border-color: #ac9eff !important;
}

a.fc-event-pink-dim {
  background-color: #ffebf3 !important;
  border-color: #ffebf3 !important;
  color: #ff63a5 !important;
}
a.fc-event-pink-dim .fc-daygrid-event-dot, a.fc-event-pink-dim .fc-list-event-dot {
  border-color: #ff63a5 !important;
}

.modal-header.fc-event-pink-dim {
  background-color: #ffebf3 !important;
  color: #ff63a5 !important;
  border-color: #ffd2e4 !important;
}
.modal-header.fc-event-pink-dim .close, .modal-header.fc-event-pink-dim .modal-title {
  color: #ff63a5 !important;
}

span.fc-event-pink-dim .dot {
  background-color: #ffebf3 !important;
  border-color: #ff63a5 !important;
}

.fc-event-pink-dim:not(a) .fc-list-event-dot {
  background-color: #ffebf3 !important;
  border-color: #ff96c2 !important;
}

a.fc-event-orange-dim {
  background-color: #fff3e9 !important;
  border-color: #fff3e9 !important;
  color: #ffa353 !important;
}
a.fc-event-orange-dim .fc-daygrid-event-dot, a.fc-event-orange-dim .fc-list-event-dot {
  border-color: #ffa353 !important;
}

.modal-header.fc-event-orange-dim {
  background-color: #fff3e9 !important;
  color: #ffa353 !important;
  border-color: #ffe5d0 !important;
}
.modal-header.fc-event-orange-dim .close, .modal-header.fc-event-orange-dim .modal-title {
  color: #ffa353 !important;
}

span.fc-event-orange-dim .dot {
  background-color: #fff3e9 !important;
  border-color: #ffa353 !important;
}

.fc-event-orange-dim:not(a) .fc-list-event-dot {
  background-color: #fff3e9 !important;
  border-color: #ffbe86 !important;
}

a.fc-event-teal-dim {
  background-color: #e2f8f1 !important;
  border-color: #e2f8f1 !important;
  color: #20c997 !important;
}
a.fc-event-teal-dim .fc-daygrid-event-dot, a.fc-event-teal-dim .fc-list-event-dot {
  border-color: #20c997 !important;
}

.modal-header.fc-event-teal-dim {
  background-color: #e2f8f1 !important;
  color: #20c997 !important;
  border-color: #cdf3e7 !important;
}
.modal-header.fc-event-teal-dim .close, .modal-header.fc-event-teal-dim .modal-title {
  color: #20c997 !important;
}

span.fc-event-teal-dim .dot {
  background-color: #e2f8f1 !important;
  border-color: #20c997 !important;
}

.fc-event-teal-dim:not(a) .fc-list-event-dot {
  background-color: #e2f8f1 !important;
  border-color: #3ce0af !important;
}

.fc-draggable {
  background-color: #4461F2;
  border-radius: 4px;
  margin: 0.75rem 0;
  padding: 0.25rem 0.5rem;
  font-size: 13px;
  color: #fff;
  list-style: none;
  display: inline-block;
}

.fc-day {
  color: #364a63;
}

.fc-day-other {
  color: #526484;
}

.fc-col-header-cell {
  color: #526484;
}

/** nouislider - 14.1.1 - 12/15/2019 | These styles are required for noUiSlider to function. */
.noUi-target,
.noUi-target * {
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  touch-action: none;
  user-select: none;
  box-sizing: border-box;
}

.noUi-target {
  position: relative;
}

.noUi-base,
.noUi-connects {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}

/* Wrapper for all connect elements.
 */
.noUi-connects {
  overflow: hidden;
  z-index: 0;
}

.noUi-connect,
.noUi-origin {
  will-change: transform;
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  -ms-transform-origin: 0 0;
  -webkit-transform-origin: 0 0;
  -webkit-transform-style: preserve-3d;
  transform-origin: 0 0;
  transform-style: flat;
}

.noUi-connect {
  height: 100%;
  width: 100%;
}

.noUi-origin {
  height: 10%;
  width: 10%;
}

/* Offset direction
 */
/* Give origins 0 height/width so they don't interfere with clicking the
 * connect elements.
 */
.noUi-vertical .noUi-origin {
  width: 100%;
}

.noUi-horizontal .noUi-origin {
  height: 100%;
}

.noUi-handle {
  backface-visibility: hidden;
  position: absolute;
}
.noUi-handle:focus {
  outline: none;
}

.noUi-touch-area {
  height: 100%;
  width: 100%;
}
.noUi-touch-area:focus {
  outline: none;
}

.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
  transition: transform 0.3s;
}

.noUi-state-drag * {
  cursor: inherit !important;
}

/* Slider size and handle placement;
 */
.noUi-horizontal {
  height: 8px;
}

.noUi-horizontal .noUi-handle {
  width: 28px;
  height: 28px;
  right: -14px;
  top: 50%;
  transform: translateY(-50%);
}

.noUi-vertical {
  width: 8px;
  height: 200px;
}

.noUi-vertical .noUi-handle {
  width: 28px;
  height: 28px;
  left: 50%;
  top: -14px;
  transform: translateX(-50%);
}

/* Styling;
 * Giving the connect element a border radius causes issues with using transform: scale
 */
.noUi-target {
  background: #dbdfea;
  border-radius: 4px;
}

.noUi-connects {
  border-radius: 3px;
}

.noUi-connect {
  background: #4461F2;
}

/* Handles and cursors;
 */
.noUi-draggable {
  cursor: ew-resize;
}

.noUi-vertical .noUi-draggable {
  cursor: ns-resize;
}

.noUi-handle {
  border: 1px solid #dbdfea;
  border-radius: 50%;
  background: #fff;
  cursor: default;
  box-shadow: 0 3px 12px 1px rgba(43, 55, 72, 0.15);
}

.noUi-active {
  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #DDD, 0 3px 6px -3px #BBB;
}

/* Handle stripes;
 */
.noUi-handle:before,
.noUi-handle:after {
  content: "";
  display: block;
  position: absolute;
  height: 10px;
  width: 1px;
  background: #dbdfea;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.noUi-horizontal .noUi-handle:before {
  margin-left: -2px;
}

.noUi-horizontal .noUi-handle:after {
  margin-left: 2px;
}

.noUi-vertical .noUi-handle:before,
.noUi-vertical .noUi-handle:after {
  width: 10px;
  height: 1px;
}

.noUi-vertical .noUi-handle:before {
  margin-top: -2px;
}

.noUi-vertical .noUi-handle:after {
  margin-top: 2px;
}

/* Disabled state;
 */
[disabled] .noUi-connect {
  background: #e5e9f2;
}

[disabled].noUi-target,
[disabled].noUi-handle,
[disabled] .noUi-handle {
  cursor: not-allowed;
}

/* Base;
 *
 */
.noUi-pips,
.noUi-pips * {
  box-sizing: border-box;
}

.noUi-pips {
  position: absolute;
  color: #999;
}

/* Values;
 *
 */
.noUi-value {
  position: absolute;
  white-space: nowrap;
  text-align: center;
}

.noUi-value-sub {
  color: #ccc;
  font-size: 10px;
}

/* Markings;
 *
 */
.noUi-marker {
  position: absolute;
  background: #CCC;
}

.noUi-marker-sub {
  background: #AAA;
}

.noUi-marker-large {
  background: #AAA;
}

/* Horizontal layout;
 *
 */
.noUi-pips-horizontal {
  padding: 10px 0;
  height: 80px;
  top: 100%;
  left: 0;
  width: 100%;
}

.noUi-value-horizontal {
  transform: translate(-50%, 50%);
}

.noUi-marker-horizontal.noUi-marker {
  margin-left: -1px;
  width: 2px;
  height: 5px;
}

.noUi-marker-horizontal.noUi-marker-sub {
  height: 10px;
}

.noUi-marker-horizontal.noUi-marker-large {
  height: 15px;
}

/* Vertical layout;
 *
 */
.noUi-pips-vertical {
  padding: 0 10px;
  height: 100%;
  top: 0;
  left: 100%;
}

.noUi-value-vertical {
  transform: translate(0, -50%);
  padding-left: 25px;
}

.noUi-marker-vertical.noUi-marker {
  width: 5px;
  height: 2px;
  margin-top: -1px;
}

.noUi-marker-vertical.noUi-marker-sub {
  width: 10px;
}

.noUi-marker-vertical.noUi-marker-large {
  width: 15px;
}

.noUi-tooltip {
  display: block;
  position: absolute;
  border: 1px solid #D9D9D9;
  border-radius: 3px;
  background: #1f2b3a;
  color: #fff;
  padding: 0.25rem 0.75rem;
  text-align: center;
  white-space: nowrap;
  font-size: 13px;
  opacity: 0;
  transition: all 0.3s ease;
}

.noUi-handle:hover .noUi-tooltip {
  opacity: 0.9;
}

.noUi-horizontal .noUi-tooltip {
  transform: translate(-50%, 0);
  left: 50%;
  bottom: 120%;
}

.noUi-vertical .noUi-tooltip {
  transform: translate(0, -50%);
  top: 50%;
  right: 120%;
}

.dual-listbox {
  display: flex;
  flex-direction: column;
}
.dual-listbox .dual-listbox__container {
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
}
.dual-listbox .dual-listbox__search {
  max-width: 300px;
}
.dual-listbox .dual-listbox__search--hidden {
  display: none;
}
.dual-listbox .dual-listbox__available,
.dual-listbox .dual-listbox__selected {
  border: 1px solid #e5e9f2;
  height: 300px;
  overflow-y: auto;
  padding: 0;
  width: 300px;
  margin-top: 0;
  border-radius: 0 0 4px 4px;
}
.dual-listbox .dual-listbox__buttons, .dual-listbox .rdl-actions-right, .dual-listbox .rdl-actions-left {
  display: flex;
  flex-direction: column;
  margin: 3px 10px;
}
.dual-listbox .dual-listbox__button {
  justify-content: center;
  text-transform: capitalize;
  display: block;
}
.dual-listbox .dual-listbox__title {
  font-size: 1rem;
  font-weight: 500;
  padding: 0.5rem 1rem;
  border-left: 1px solid #e5e9f2;
  border-right: 1px solid #e5e9f2;
  border-top: 1px solid #e5e9f2;
  margin-top: 1rem;
  -webkit-margin-before: 1rem;
  border-radius: 4px 4px 0 0;
}
.dual-listbox .dual-listbox__item {
  display: block;
  padding: 0.5rem 1rem;
  cursor: pointer;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  border-bottom: 1px solid #e5e9f2;
  transition: background-color 0.2s ease;
}
.react-dual-listbox {
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.react-dual-listbox * {
  box-sizing: border-box;
}

.react-dual-listbox input:disabled,
.react-dual-listbox select:disabled {
  background: #eee;
  cursor: not-allowed;
}

.react-dual-listbox button,
.react-dual-listbox select {
  line-height: 1.42857;
  font-family: inherit;
}

.rdl-selected:focus-visible {
  border: none;
}

.rdl-filter,
.rdl-control {
  display: block;
  border: 1px solid #ccc;
  border-radius: 2px;
  padding: 8px 12px;
  width: 100%;
  color: #333;
  font-size: 14px;
}

.rdl-filter {
  max-width: 300px;
  margin-bottom: 10px !important;
}
.rdl-filter--hidden {
  display: none;
}

.rdl-control-container {
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
}

.rdl-control-label {
  font-size: 1rem;
  font-weight: 500;
  padding: 0.5rem 1rem;
  border-left: 1px solid #e5e9f2;
  border-right: 1px solid #e5e9f2;
  border-top: 1px solid #e5e9f2;
  margin-top: 1rem;
  -webkit-margin-before: 1rem;
  border-radius: 4px 4px 0 0;
  margin-bottom: 0 !important;
  width: 100%;
}

.rdl-control-label.rdl-sr-only {
  position: absolute;
  clip: rect(0 0 0 0);
}

.rdl-control {
  flex: 1 0 auto;
  border: 1px solid #e5e9f2;
  height: 300px;
  overflow-y: auto;
  padding: 0;
  width: 300px;
  margin-top: 0;
  border-radius: 0 0 4px 4px;
}
.rdl-control:focus {
  outline: none;
}

.rdl-control > option {
  display: block;
  padding: 0.5rem 1rem;
  cursor: pointer;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  border-bottom: 1px solid #e5e9f2;
  transition: background-color 0.2s ease;
}
.rdl-control > option:active, .rdl-control > option:focus {
  outline: none;
  background: transparent !important;
}

.rdl-control optgroup {
  font: inherit;
  font-weight: 700;
}

/*
.rdl-actions {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  margin: 0 10px;
  padding: 10px 0px;
}
/*
.rdl-has-header .rdl-actions {
  padding-top: 31px;
}
.rdl-has-filter .rdl-actions {
  padding-top: 44px;
}
.rdl-has-header.rdl-has-filter .rdl-actions {
  padding-top: 75px;
}
*/
.rdl-actions {
  display: inline-flex;
  flex-direction: column;
}

.rdl-move {
  margin-bottom: 5px;
  border: none;
  background: transparent;
}

.rdl-move:focus {
  border: none;
  outline: none !important;
}

.rdl-move:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.rdl-move:last-child {
  margin-bottom: 0;
}

.rdl-move i {
  margin: 0 -1px;
}

.rdl-align-top .rdl-available {
  margin-right: 10px;
}

.rdl-align-top .rdl-selected {
  margin-left: 10px;
}

.rdl-align-top .rdl-control {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.rdl-align-top .rdl-actions-left,
.rdl-align-top .rdl-actions-right {
  flex-direction: row;
  margin: 0;
}

.rdl-align-top .rdl-list-box .rdl-move {
  flex: 0 1 50%;
}

.rdl-align-top .rdl-list-box .rdl-move:first-child {
  margin-bottom: 0;
  border-right: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.rdl-align-top .rdl-list-box .rdl-move:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.css-tlfecz-indicatorContainer,
.css-1gtu0rj-indicatorContainer,
.css-1okebmr-indicatorSeparator {
  display: none !important;
}

.css-1pahdxg-control {
  border-color: transparent !important;
  box-shadow: none !important;
}

.react-select-container {
  box-sizing: border-box !important;
  margin: 0 !important;
  position: relative !important;
  vertical-align: middle !important;
  cursor: pointer !important;
  min-height: calc(2.125rem + 2px) !important;
}

.react-select__control {
  cursor: pointer !important;
  color: #526484 !important;
  border: 1px solid #dbdfea !important;
}

.react-select__control:hover {
  border-color: #dbdfea !important;
}

.react-select__single-value {
  color: #526484 !important;
  line-height: 1.25rem !important;
  font-family: Roboto, sans-serif !important;
  font-size: 13px !important;
  font-weight: 400 !important;
}

.react-select__control--is-focused,
.react-select__control--menu-is-open,
.react-select__control + .react-select__control--is-focused, .react-select__control + .react-select__control--menu-is-open {
  border: 1px solid #dbdfea !important;
  cursor: pointer !important;
  box-shadow: none !important;
}

.react-select__menu {
  background-color: #fff !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  border: 1px solid #dbdfea !important;
  font-family: "DM Sans", sans-serif !important;
  font-size: 13px !important;
  font-weight: 400 !important;
  display: block !important;
  padding: 6px !important;
  z-index: 1000 !important;
}

.react-select__option {
  background-color: #fff !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  font-family: "DM Sans", sans-serif !important;
  font-size: 13px !important;
  font-weight: 400 !important;
  cursor: pointer !important;
  display: block !important;
  font-weight: normal;
  display: block;
  white-space: nowrap;
  min-height: 1.2em;
  color: #526484;
  padding: 0.375rem 0.75rem !important;
}

.react-select__option:not(:last-child) {
  margin-bottom: 0.125rem;
}

.react-select__option:hover {
  font-weight: normal;
  display: block;
  white-space: nowrap;
  background-color: #ebeef2 !important;
}

.react-select__option--is-selected {
  color: #526484 !important;
  background: #ebeef2 !important;
}

.react-select__placeholder {
  color: #8094ae !important;
  font-size: small !important;
  margin-left: 5px;
  padding: 0 0.35rem !important;
}

.react-select__multi-value {
  background-color: #ebeef2 !important;
  border-radius: 3px !important;
  cursor: pointer !important;
}

.react-select__multi-value__remove {
  color: #526484 !important;
  cursor: pointer !important;
  display: inline-block !important;
  font-weight: bold !important;
}

.react-select__multi-value__remove:hover {
  background: transparent !important;
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow, .react-datepicker__navigation-icon::before {
  border-color: #ccc;
  border-style: solid;
  border-width: 3px 3px 0 0;
  content: "";
  display: block;
  height: 9px;
  position: absolute;
  top: 6px;
  width: 9px;
}

.react-datepicker-popper {
  background-color: #fff;
  padding: 10px;
  border-radius: 4px;
  direction: ltr;
  border: 1px solid #dbdfea;
  box-shadow: none;
  min-width: 240px;
  font-size: 0.8125rem;
}

.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {
  margin-left: -4px;
  right: 0;
  position: absolute;
  width: 0;
}

.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {
  box-sizing: content-box;
  position: absolute;
  border: 8px solid transparent;
  height: 0;
  width: 1px;
  content: "";
  z-index: -1;
  border-width: 8px;
  left: -8px;
}

.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  border-bottom-color: #aeaeae;
}

.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {
  top: 0;
  margin-top: -8px;
}

.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {
  border-top: none;
  border-bottom-color: #f0f0f0;
}

.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {
  top: 0;
}

.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {
  top: -1px;
  border-bottom-color: #aeaeae;
}

.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle {
  bottom: 0;
  margin-bottom: -8px;
}

.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after {
  border-bottom: none;
  border-top-color: #fff;
}

.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after {
  bottom: 0;
}

.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {
  bottom: -1px;
  border-top-color: #aeaeae;
}

.react-datepicker {
  display: inline-block;
  position: relative;
  background-color: #fff;
  border: 1px solid #aeaeae;
  border-radius: 0.3rem;
  margin-top: 5px;
}

.date-picker-range > .react-datepicker-wrapper {
  display: inline;
  width: 45%;
}

.date-picker-range .start-m input {
  border-radius: 3px 0px 0px 3px !important;
}
.date-picker-range .end-m input {
  border-radius: 0px 3px 3px 0px !important;
}

.react-datepicker-wrapper {
  display: inline-block;
  padding: 0;
  border: 0;
  width: 100%;
}

.react-datepicker--time-only .react-datepicker__triangle {
  left: 35px;
}

.react-datepicker--time-only .react-datepicker__time-container {
  border-left: 0;
}

.react-datepicker--time-only .react-datepicker__time,
.react-datepicker--time-only .react-datepicker__time-box {
  border-bottom-left-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.react-datepicker__triangle {
  position: absolute;
  left: 50px;
  display: none;
}

.react-datepicker-popper {
  z-index: 10;
}

.react-datepicker-popper[data-placement^=bottom] {
  padding-top: 10px;
}

.react-datepicker-popper[data-placement=bottom-end] .react-datepicker__triangle, .react-datepicker-popper[data-placement=top-end] .react-datepicker__triangle {
  left: auto;
  right: 50px;
}

.react-datepicker-popper[data-placement^=top] {
  padding-bottom: 10px;
}

.react-datepicker-popper[data-placement^=right] {
  padding-left: 8px;
}

.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle {
  left: auto;
  right: 42px;
}

.react-datepicker-popper[data-placement^=left] {
  padding-right: 8px;
}

.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle {
  left: 42px;
  right: auto;
}

.react-datepicker__header {
  text-align: center;
  position: relative;
  font-size: 0.8125rem;
  color: #526484;
  font-weight: bold;
}

.react-datepicker__header--time {
  padding-bottom: 8px;
  padding-left: 5px;
  padding-right: 5px;
}

.react-datepicker__header--time:not(.react-datepicker__header--time--only) {
  border-top-left-radius: 0;
}

.react-datepicker__header:not(.react-datepicker__header--has-time-select) {
  border-top-right-radius: 0.3rem;
}

.react-datepicker__year-dropdown-container--select,
.react-datepicker__month-dropdown-container--select,
.react-datepicker__month-year-dropdown-container--select,
.react-datepicker__year-dropdown-container--scroll,
.react-datepicker__month-dropdown-container--scroll,
.react-datepicker__month-year-dropdown-container--scroll {
  display: inline-block;
  margin: 0 2px;
}

.react-datepicker__current-month,
.react-datepicker-time__header,
.react-datepicker-year-header {
  margin-top: 0;
}

.react-datepicker-time__header {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.react-datepicker__navigation {
  background: none;
  display: flex;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  position: absolute;
  border: none;
  z-index: 1;
  height: 27px;
  width: 27px;
  margin: 0.1rem 0.5rem;
  text-indent: -999em;
  overflow: hidden;
}

.react-datepicker__navigation:hover {
  border-radius: 0.3rem;
}

.react-datepicker__navigation:focus, .react-datepicker__navigation:focus-visible {
  outline: none;
}

.react-datepicker__navigation--previous {
  left: 2px;
}

.react-datepicker__navigation--next {
  right: 2px;
}

.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {
  right: 85px;
}

.react-datepicker__navigation--years {
  position: relative;
  top: 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.react-datepicker__navigation--years-previous {
  top: 4px;
}

.react-datepicker__navigation--years-upcoming {
  top: -4px;
}

.react-datepicker__navigation:hover *::before {
  border-color: #a6a6a6;
}

.react-datepicker__navigation-icon {
  position: relative;
  top: -1px;
  font-size: 12px;
  width: 0;
}

.react-datepicker__navigation-icon--next {
  left: -2px;
}

.react-datepicker__navigation-icon--next::before {
  transform: rotate(45deg);
  left: -7px;
}

.react-datepicker__navigation-icon--previous {
  right: -2px;
}

.react-datepicker__navigation-icon--previous::before {
  transform: rotate(225deg);
  right: -7px;
}

.react-datepicker__month-container {
  float: left;
  padding: 0px;
}

.react-datepicker__year {
  margin: 0.4rem;
  text-align: center;
}

.react-datepicker__year-wrapper {
  display: flex;
  flex-wrap: wrap;
  max-width: 208px;
}

.react-datepicker__year .react-datepicker__year-text {
  display: inline-block;
  width: 4rem;
  margin: 2px;
}

.react-datepicker__month {
  margin: 0.4rem;
  text-align: center;
}

.react-datepicker__month .react-datepicker__month-text,
.react-datepicker__month .react-datepicker__quarter-text {
  display: inline-block;
  width: 5rem;
  margin: 2px;
}

.react-datepicker__input-time-container {
  clear: both;
  width: 100%;
  float: left;
  margin: 5px 0 10px 15px;
  text-align: left;
}

.react-datepicker__input-time-container .react-datepicker-time__caption {
  display: inline-block;
}

.react-datepicker__input-time-container .react-datepicker-time__input-container {
  display: inline-block;
}

.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input {
  display: inline-block;
  margin-left: 10px;
}

.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input {
  width: auto;
}

.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-inner-spin-button,
.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time] {
  -moz-appearance: textfield;
}

.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter {
  margin-left: 5px;
  display: inline-block;
}

.react-datepicker__time-container {
  float: right;
  border-left: 1px solid #aeaeae;
  width: 85px;
}

.react-datepicker__time-container--with-today-button {
  display: inline;
  border: 1px solid #aeaeae;
  border-radius: 0.3rem;
  position: absolute;
  right: -72px;
  top: 0;
}

.react-datepicker__time-container .react-datepicker__time {
  position: relative;
  background: white;
  border-bottom-right-radius: 0.3rem;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
  overflow-x: hidden;
  margin: 0 auto;
  text-align: center;
  border-bottom-right-radius: 0.3rem;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
  list-style: none;
  margin: 0;
  height: calc(195px + 0.85rem);
  overflow-y: scroll;
  padding-right: 0;
  padding-left: 0;
  width: 100%;
  box-sizing: content-box;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {
  height: 30px;
  padding: 5px 10px;
  white-space: nowrap;
  transition: all 0.3s;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {
  cursor: pointer;
  background-color: #f0f0f0;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {
  color: #4461F2;
  background-color: #e7dcff;
  transition: all 0.3s;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {
  color: #fff;
  background-color: #9d72ff;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled {
  color: #ccc;
}

.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover {
  cursor: default;
  background-color: transparent;
}

.react-datepicker__week-number {
  color: #ccc;
  display: inline-block;
  width: 1.7rem;
  line-height: 1.7rem;
  text-align: center;
  margin: 0.166rem;
}

.react-datepicker__week-number.react-datepicker__week-number--clickable {
  cursor: pointer;
}

.react-datepicker__week-number.react-datepicker__week-number--clickable:hover {
  border-radius: 0.3rem;
  background-color: #f0f0f0;
}

.react-datepicker__day-names,
.react-datepicker__week {
  white-space: nowrap;
  transition: all 0.3s;
}

.react-datepicker__day-names {
  margin-bottom: -8px;
  margin-top: 5px;
}

.react-datepicker__day-name,
.react-datepicker__day,
.react-datepicker__time-name {
  display: inline-block;
  width: 1.7rem;
  line-height: 1.7rem;
  text-align: center;
  margin: 0.166rem;
  transition: all 0.3s;
}

.react-datepicker__month--selected, .react-datepicker__month--in-selecting-range, .react-datepicker__month--in-range,
.react-datepicker__quarter--selected,
.react-datepicker__quarter--in-selecting-range,
.react-datepicker__quarter--in-range {
  border-radius: 0.3rem;
  color: #4461F2;
  background-color: #e7dcff;
}

.react-datepicker__month--selected:hover, .react-datepicker__month--in-selecting-range:hover, .react-datepicker__month--in-range:hover,
.react-datepicker__quarter--selected:hover,
.react-datepicker__quarter--in-selecting-range:hover,
.react-datepicker__quarter--in-range:hover {
  color: #fff;
  background-color: #9d72ff;
}

.react-datepicker__month--disabled,
.react-datepicker__quarter--disabled {
  color: #ccc;
  pointer-events: none;
}

.react-datepicker__month--disabled:hover,
.react-datepicker__quarter--disabled:hover {
  cursor: default;
  background-color: transparent;
}

.react-datepicker__day,
.react-datepicker__month-text,
.react-datepicker__quarter-text,
.react-datepicker__year-text {
  cursor: pointer;
  transition: all 0.3s;
}

.react-datepicker__day:hover,
.react-datepicker__month-text:hover,
.react-datepicker__quarter-text:hover,
.react-datepicker__year-text:hover {
  border-radius: 0.3rem;
  background-color: #f0f0f0;
}

.react-datepicker__day--outside-month {
  color: #dbdfea;
}

.react-datepicker__day--today,
.react-datepicker__month-text--today,
.react-datepicker__quarter-text--today,
.react-datepicker__year-text--today {
  color: #4461F2;
  background-color: #e7dcff;
  border-radius: 0.3rem;
}

.react-datepicker__day--highlighted,
.react-datepicker__month-text--highlighted,
.react-datepicker__quarter-text--highlighted,
.react-datepicker__year-text--highlighted {
  border-radius: 0.3rem;
  background-color: #3dcc4a;
  color: #fff;
}

.react-datepicker__day--highlighted:hover,
.react-datepicker__month-text--highlighted:hover,
.react-datepicker__quarter-text--highlighted:hover,
.react-datepicker__year-text--highlighted:hover {
  background-color: #32be3f;
}

.react-datepicker__day--highlighted-custom-1,
.react-datepicker__month-text--highlighted-custom-1,
.react-datepicker__quarter-text--highlighted-custom-1,
.react-datepicker__year-text--highlighted-custom-1 {
  color: magenta;
}

.react-datepicker__day--highlighted-custom-2,
.react-datepicker__month-text--highlighted-custom-2,
.react-datepicker__quarter-text--highlighted-custom-2,
.react-datepicker__year-text--highlighted-custom-2 {
  color: green;
}

.react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range,
.react-datepicker__month-text--selected,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--selected,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--selected,
.react-datepicker__year-text--in-selecting-range,
.react-datepicker__year-text--in-range {
  border-radius: 0.3rem;
  color: #fff !important;
  background-color: #9d72ff !important;
}

.react-datepicker__day--today:hover,
.react-datepicker__year-text--today:hover,
.react-datepicker__day--selected:hover, .react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover,
.react-datepicker__month-text--selected:hover,
.react-datepicker__month-text--in-selecting-range:hover,
.react-datepicker__month-text--in-range:hover,
.react-datepicker__quarter-text--selected:hover,
.react-datepicker__quarter-text--in-selecting-range:hover,
.react-datepicker__quarter-text--in-range:hover,
.react-datepicker__year-text--selected:hover,
.react-datepicker__year-text--in-selecting-range:hover,
.react-datepicker__year-text--in-range:hover {
  color: #fff;
  background-color: #9d72ff !important;
}

.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range),
.react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range),
.react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range),
.react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range) {
  background-color: #dbdfea;
}

.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__month--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__month--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range),
.react-datepicker__month--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__year-text--in-selecting-range) {
  background-color: #f0f0f0;
  color: #000;
}

.react-datepicker__day--disabled,
.react-datepicker__month-text--disabled,
.react-datepicker__quarter-text--disabled,
.react-datepicker__year-text--disabled {
  cursor: default;
  color: #ccc;
}

.react-datepicker__day--disabled:hover,
.react-datepicker__month-text--disabled:hover,
.react-datepicker__quarter-text--disabled:hover,
.react-datepicker__year-text--disabled:hover {
  background-color: transparent;
}

.react-datepicker__month-text.react-datepicker__month--selected:hover, .react-datepicker__month-text.react-datepicker__month--in-range:hover, .react-datepicker__month-text.react-datepicker__quarter--selected:hover, .react-datepicker__month-text.react-datepicker__quarter--in-range:hover,
.react-datepicker__quarter-text.react-datepicker__month--selected:hover,
.react-datepicker__quarter-text.react-datepicker__month--in-range:hover,
.react-datepicker__quarter-text.react-datepicker__quarter--selected:hover,
.react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover {
  color: #fff;
  background-color: #9d72ff;
}

.react-datepicker__month-text:hover,
.react-datepicker__quarter-text:hover {
  background-color: #f0f0f0;
}

.react-datepicker__input-container {
  position: relative;
  display: inline-block;
  width: 100%;
}

.react-datepicker__year-read-view,
.react-datepicker__month-read-view,
.react-datepicker__month-year-read-view {
  border: 1px solid transparent;
  border-radius: 0.3rem;
  position: relative;
}

.react-datepicker__year-read-view:hover,
.react-datepicker__month-read-view:hover,
.react-datepicker__month-year-read-view:hover {
  cursor: pointer;
}

.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {
  border-top-color: #b3b3b3;
}

.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow {
  transform: rotate(135deg);
  right: -16px;
  top: 0;
}

.react-datepicker__year-dropdown,
.react-datepicker__month-dropdown,
.react-datepicker__month-year-dropdown {
  background-color: #f0f0f0;
  position: absolute;
  width: 50%;
  left: 25%;
  top: 30px;
  z-index: 1;
  text-align: center;
  border-radius: 0.3rem;
  border: 1px solid #aeaeae;
}

.react-datepicker__year-dropdown:hover,
.react-datepicker__month-dropdown:hover,
.react-datepicker__month-year-dropdown:hover {
  cursor: pointer;
}

.react-datepicker__year-dropdown--scrollable,
.react-datepicker__month-dropdown--scrollable,
.react-datepicker__month-year-dropdown--scrollable {
  height: 150px;
  overflow-y: scroll;
}

.react-datepicker__year-option,
.react-datepicker__month-option,
.react-datepicker__month-year-option {
  line-height: 20px;
  width: 100%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.react-datepicker__year-option:first-of-type,
.react-datepicker__month-option:first-of-type,
.react-datepicker__month-year-option:first-of-type {
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
}

.react-datepicker__year-option:last-of-type,
.react-datepicker__month-option:last-of-type,
.react-datepicker__month-year-option:last-of-type {
  -webkit-user-select: none;
  user-select: none;
  border-bottom-left-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.react-datepicker__year-option:hover,
.react-datepicker__month-option:hover,
.react-datepicker__month-year-option:hover {
  background-color: #ccc;
}

.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,
.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {
  border-bottom-color: #b3b3b3;
}

.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,
.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,
.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {
  border-top-color: #b3b3b3;
}

.react-datepicker__year-option--selected,
.react-datepicker__month-option--selected,
.react-datepicker__month-year-option--selected {
  position: absolute;
  left: 15px;
}

.react-datepicker__close-icon {
  cursor: pointer;
  background-color: transparent;
  border: 0;
  outline: 0;
  padding: 0 6px 0 0;
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  display: table-cell;
  vertical-align: middle;
}

.react-datepicker__close-icon::after {
  cursor: pointer;
  background-color: #216ba5;
  color: #fff;
  border-radius: 50%;
  height: 16px;
  width: 16px;
  padding: 2px;
  font-size: 12px;
  line-height: 1;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  content: "×";
}

.react-datepicker__today-button {
  background: #f0f0f0;
  border-top: 1px solid #aeaeae;
  cursor: pointer;
  text-align: center;
  padding: 5px 0;
  clear: left;
}

.react-datepicker__portal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  left: 0;
  top: 0;
  justify-content: center;
  align-items: center;
  display: flex;
  z-index: 2147483647;
}

.react-datepicker__portal .react-datepicker__day-name,
.react-datepicker__portal .react-datepicker__day,
.react-datepicker__portal .react-datepicker__time-name {
  width: 3rem;
  line-height: 3rem;
}

@media (max-width: 400px), (max-height: 550px) {
  .react-datepicker__portal .react-datepicker__day-name,
  .react-datepicker__portal .react-datepicker__day,
  .react-datepicker__portal .react-datepicker__time-name {
    width: 2rem;
    line-height: 2rem;
  }
}
.react-datepicker__portal .react-datepicker__current-month,
.react-datepicker__portal .react-datepicker-time__header {
  font-size: 1.44rem;
}

.date-picker-range {
  display: flex;
  flex-direction: row;
}

/* Magnific Popup CSS */
.mfp-bg {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1042;
  overflow: hidden;
  position: fixed;
  background: #0b0b0b;
  opacity: 0.8;
}

.mfp-wrap {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1043;
  position: fixed;
  outline: none !important;
  -webkit-backface-visibility: hidden;
}

.mfp-container {
  text-align: center;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  padding: 0 8px;
  box-sizing: border-box;
}

.mfp-container:before {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}

.mfp-align-top .mfp-container:before {
  display: none;
}

.mfp-content {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin: 0 auto;
  text-align: left;
  z-index: 1045;
}

.mfp-inline-holder .mfp-content,
.mfp-ajax-holder .mfp-content {
  width: 100%;
  cursor: auto;
}

.mfp-ajax-cur {
  cursor: progress;
}

.mfp-zoom-out-cur, .mfp-zoom-out-cur .mfp-image-holder .mfp-close {
  cursor: zoom-out;
}

.mfp-zoom {
  cursor: pointer;
  cursor: zoom-in;
}

.mfp-auto-cursor .mfp-content {
  cursor: auto;
}

.mfp-close,
.mfp-arrow,
.mfp-preloader,
.mfp-counter {
  -webkit-user-select: none;
  user-select: none;
}

.mfp-loading.mfp-figure {
  display: none;
}

.mfp-hide {
  display: none !important;
}

.mfp-preloader {
  color: #CCC;
  position: absolute;
  top: 50%;
  width: auto;
  text-align: center;
  margin-top: -0.8em;
  left: 8px;
  right: 8px;
  z-index: 1044;
}
.mfp-preloader a {
  color: #CCC;
}
.mfp-preloader a:hover {
  color: #FFF;
}

.mfp-s-ready .mfp-preloader {
  display: none;
}

.mfp-s-error .mfp-content {
  display: none;
}

button.mfp-arrow {
  overflow: visible;
  cursor: pointer;
  background: transparent;
  border: 0;
  -webkit-appearance: none;
  display: block;
  outline: none;
  padding: 0;
  z-index: 1046;
  box-shadow: none;
  touch-action: manipulation;
}
button::-moz-focus-inner {
  padding: 0;
  border: 0;
}

button.mfp-close {
  overflow: visible;
  cursor: pointer;
  border: 0;
  -webkit-appearance: none;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  padding: 0;
  z-index: 1046;
  box-shadow: 0 3px 12px 1px rgba(43, 55, 72, 0.15);
  touch-action: manipulation;
}
button::-moz-focus-inner {
  padding: 0;
  border: 0;
}

.mfp-close {
  width: 44px;
  height: 44px;
  line-height: 44px;
  position: absolute;
  right: 0;
  top: 0;
  text-decoration: none;
  text-align: center;
  transform: translate(50%, -50%);
  color: #FFF;
  font-style: normal;
  font-size: 28px;
  font-family: Arial, Baskerville, monospace;
  background-color: #fff;
  border-radius: 50%;
}
.mfp-close:hover, .mfp-close:focus {
  opacity: 1;
}
.mfp-close:active {
  top: 1px;
}
.mfp-close:after {
  position: absolute;
  font-family: "Nioicon";
  content: "\\ea05";
  color: #526484;
}

.mfp-close-btn-in .mfp-close {
  color: #333;
}

.mfp-image-holder .mfp-close,
.mfp-iframe-holder .mfp-close {
  color: #fff;
}

.mfp-counter {
  position: absolute;
  top: 0;
  right: 0;
  color: #CCC;
  font-size: 12px;
  line-height: 18px;
  white-space: nowrap;
}

.mfp-arrow {
  position: absolute;
  opacity: 0.65;
  margin: 0;
  top: 50%;
  margin-top: -55px;
  padding: 0;
  width: 90px;
  height: 110px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.mfp-arrow:active {
  margin-top: -54px;
}
.mfp-arrow:hover, .mfp-arrow:focus {
  opacity: 1;
}
.mfp-arrow:before, .mfp-arrow:after {
  content: "";
  display: block;
  width: 0;
  height: 0;
  position: absolute;
  left: 0;
  top: 0;
  margin-top: 35px;
  margin-left: 35px;
  border: medium inset transparent;
}
.mfp-arrow:after {
  border-top-width: 13px;
  border-bottom-width: 13px;
  top: 8px;
}
.mfp-arrow:before {
  border-top-width: 21px;
  border-bottom-width: 21px;
  opacity: 0.7;
}

.mfp-arrow-left {
  left: 0;
}
.mfp-arrow-left:after {
  border-right: 17px solid #FFF;
  margin-left: 31px;
}
.mfp-arrow-left:before {
  margin-left: 25px;
  border-right: 27px solid #3F3F3F;
}

.mfp-arrow-right {
  right: 0;
}
.mfp-arrow-right:after {
  border-left: 17px solid #FFF;
  margin-left: 39px;
}
.mfp-arrow-right:before {
  border-left: 27px solid #3F3F3F;
}

.mfp-iframe-holder {
  padding-top: 40px;
  padding-bottom: 40px;
}
.mfp-iframe-holder .mfp-content {
  line-height: 0;
  width: 100%;
  max-width: 900px;
}

.mfp-iframe-scaler {
  width: 100%;
  height: 0;
  overflow: hidden;
  padding-top: 56.25%;
}
.mfp-iframe-scaler iframe {
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);
  background: #000;
  border-radius: 8px;
}

/* Main image in popup */
img.mfp-img {
  width: auto;
  max-width: 100%;
  height: auto;
  display: block;
  line-height: 0;
  box-sizing: border-box;
  margin: 0 auto;
  border-radius: 8px;
}

/* The shadow behind the image */
.mfp-figure {
  line-height: 0;
}
.mfp-figure:after {
  content: "";
  position: absolute;
  left: 0;
  top: 40px;
  bottom: 40px;
  display: block;
  right: 0;
  width: auto;
  height: auto;
  z-index: -1;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);
  background: #444;
}
.mfp-figure small {
  color: #BDBDBD;
  display: block;
  font-size: 12px;
  line-height: 14px;
}
.mfp-figure figure {
  margin: 0;
}

.mfp-bottom-bar {
  margin-top: -36px;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  cursor: auto;
}

.mfp-title {
  text-align: left;
  line-height: 18px;
  color: #F3F3F3;
  word-wrap: break-word;
  padding-right: 36px;
}

.mfp-image-holder .mfp-content {
  max-width: 100%;
}

.mfp-gallery .mfp-image-holder .mfp-figure {
  cursor: pointer;
}

@media screen and (max-width: 800px) and (orientation: landscape), screen and (max-height: 300px) {
  /**
   * Remove all paddings around the image on small screen
   */
  .mfp-img-mobile .mfp-image-holder {
    padding-left: 0;
    padding-right: 0;
  }
  .mfp-img-mobile img.mfp-img {
    padding: 0;
  }
  .mfp-img-mobile .mfp-figure:after {
    top: 0;
    bottom: 0;
  }
  .mfp-img-mobile .mfp-figure small {
    display: inline;
    margin-left: 5px;
  }
  .mfp-img-mobile .mfp-bottom-bar {
    background: rgba(0, 0, 0, 0.6);
    bottom: 0;
    margin: 0;
    top: auto;
    padding: 3px 5px;
    position: fixed;
    box-sizing: border-box;
  }
  .mfp-img-mobile .mfp-bottom-bar:empty {
    padding: 0;
  }
  .mfp-img-mobile .mfp-counter {
    right: 5px;
    top: 3px;
  }
  .mfp-img-mobile .mfp-close {
    top: 0;
    right: 0;
    width: 35px;
    height: 35px;
    line-height: 35px;
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    text-align: center;
    padding: 0;
  }
}
@media all and (max-width: 900px) {
  .mfp-arrow {
    transform: scale(0.75);
  }
  .mfp-arrow-left {
    transform-origin: 0;
  }
  .mfp-arrow-right {
    transform-origin: 100%;
  }
  .mfp-container {
    padding-left: 6px;
    padding-right: 6px;
  }
}
@keyframes modal-video {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes modal-video-inner {
  from {
    transform: translate(0, 100px);
  }
  to {
    transform: translate(0, 0);
  }
}
.modal-video {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000000;
  cursor: pointer;
  opacity: 1;
  animation-timing-function: ease-out;
  animation-duration: 0.3s;
  animation-name: modal-video;
  transition: opacity 0.3s ease-out;
}

.modal-video-effect-exit {
  opacity: 0;
}
.modal-video-effect-exit .modal-video-movie-wrap {
  transform: translate(0, 100px);
}

.modal-video-body {
  max-width: 960px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 0 10px;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
}

.modal-video-inner {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
@media (orientation: landscape) {
  .modal-video-inner {
    padding: 10px 60px;
    box-sizing: border-box;
  }
}

.modal-video-movie-wrap {
  width: 100%;
  height: 0;
  position: relative;
  padding-bottom: 56.25%;
  background-color: #333;
  animation-timing-function: ease-out;
  animation-duration: 0.3s;
  animation-name: modal-video-inner;
  transform: translate(0, 0);
  transition: transform 0.3s ease-out;
}
.modal-video-movie-wrap iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.modal-video-close-btn {
  position: absolute;
  z-index: 2;
  top: -45px;
  right: 0px;
  display: inline-block;
  width: 35px;
  height: 35px;
  overflow: hidden;
  border: none;
  background: transparent;
}
@media (orientation: landscape) {
  .modal-video-close-btn {
    top: 0;
    right: -45px;
  }
}
.modal-video-close-btn:before {
  transform: rotate(45deg);
}
.modal-video-close-btn:after {
  transform: rotate(-45deg);
}
.modal-video-close-btn:before, .modal-video-close-btn:after {
  content: "";
  position: absolute;
  height: 2px;
  width: 100%;
  top: 50%;
  left: 0;
  margin-top: -1px;
  background: #fff;
  border-radius: 5px;
  margin-top: -6px;
}

:root {
  --toastify-color-light: #fff;
  --toastify-color-dark: #121212;
  --toastify-color-info: #09c2de;
  --toastify-color-success: #1ee0ac;
  --toastify-color-warning: #f4bd0e;
  --toastify-color-error: #e85347;
  --toastify-color-transparent: rgba(255, 255, 255, 0.7);
  --toastify-icon-color-info: var(--toastify-color-info);
  --toastify-icon-color-success: var(--toastify-color-success);
  --toastify-icon-color-warning: var(--toastify-color-warning);
  --toastify-icon-color-error: var(--toastify-color-error);
  --toastify-toast-width: 320px;
  --toastify-toast-background: #fff;
  --toastify-toast-min-height: 64px;
  --toastify-toast-max-height: 800px;
  --toastify-font-family: sans-serif;
  --toastify-z-index: 9999;
  --toastify-text-color-light: #757575;
  --toastify-text-color-dark: #fff;
  --toastify-text-color-info: #fff;
  --toastify-text-color-success: #fff;
  --toastify-text-color-warning: #fff;
  --toastify-text-color-error: #fff;
  --toastify-spinner-color: #616161;
  --toastify-spinner-color-empty-area: #e0e0e0;
  --toastify-color-progress-light: linear-gradient(
    to right,
    #4cd964,
    #5ac8fa,
    #007aff,
    #34aadc,
    #5856d6,
    #ff2d55
  );
  --toastify-color-progress-dark: #bb86fc;
  --toastify-color-progress-info: var(--toastify-color-info);
  --toastify-color-progress-success: var(--toastify-color-success);
  --toastify-color-progress-warning: var(--toastify-color-warning);
  --toastify-color-progress-error: var(--toastify-color-error);
}

.Toastify__toast-container {
  z-index: var(--toastify-z-index);
  -webkit-transform: translate3d(0, 0, var(--toastify-z-index) px);
  position: fixed;
  box-sizing: border-box;
  color: #fff;
  background-color: transparent;
}

.Toastify__toast-container--top-left {
  top: 1em;
  left: 1em;
}

.Toastify__toast-container--top-center {
  top: 1em;
  left: 50%;
  transform: translateX(-50%);
}

.Toastify__toast-container--top-right {
  top: 1em;
  right: 1em;
}

.Toastify__toast-container--bottom-left {
  bottom: 1em;
  left: 1em;
}

.Toastify__toast-container--bottom-center {
  bottom: 1em;
  left: 50%;
  transform: translateX(-50%);
}

.Toastify__toast-container--bottom-right {
  bottom: 1em;
  right: 1em;
}

@media only screen and (max-width: 480px) {
  .Toastify__toast-container {
    width: 100vw;
    padding: 0;
    left: 0;
    margin: 0;
  }
  .Toastify__toast-container--top-left, .Toastify__toast-container--top-center, .Toastify__toast-container--top-right {
    top: 0;
    transform: translateX(0);
  }
  .Toastify__toast-container--bottom-left, .Toastify__toast-container--bottom-center, .Toastify__toast-container--bottom-right {
    bottom: 0;
    transform: translateX(0);
  }
  .Toastify__toast-container--rtl {
    right: 0;
    left: initial;
  }
}
.Toastify__toast {
  position: relative;
  min-height: var(--toastify-toast-min-height);
  box-sizing: border-box;
  border-radius: 4px;
  color: #526484 !important;
  margin-bottom: 1rem;
  width: 425px;
  background-color: #fff;
  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1), 0 2px 15px 0 rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  max-height: var(--toastify-toast-max-height);
  overflow: hidden;
  font-family: var(--toastify-font-family);
  border-left: 4px solid transparent;
  padding: 0.8rem 0.2rem 0.8rem 1.25rem;
  opacity: 1;
  cursor: pointer;
  direction: ltr;
}

.Toastify__toast--rtl {
  direction: rtl;
}

.Toastify__toast-body {
  margin: auto 0;
  flex: 1 1 auto;
  padding: 6px;
  display: flex;
  font-size: 0.875rem;
  line-height: 1.3rem;
  align-items: center;
}
.Toastify__toast-body .toastr-text {
  padding-left: 0.5rem;
}

.toastr-text > h4, .toastr-text > h5, .toastr-text > h6 {
  margin-bottom: 0.35rem;
  font-size: 1rem;
}
.is-dark .toastr-text > h4, .is-dark .toastr-text > h5, .is-dark .toastr-text > h6 {
  color: #fff;
}

.Toastify__toast-body > div:last-child {
  flex: 1 1;
}

.Toastify__toast-icon {
  margin-inline-end: 10px;
  width: 20px;
  flex-shrink: 0;
  display: flex;
}

.Toastify--animate {
  animation-fill-mode: both;
  animation-duration: 0.7s;
}

.Toastify--animate-icon {
  animation-fill-mode: both;
  animation-duration: 0.3s;
}

.toast-close-button {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-block;
  height: 32px;
  width: 32px;
  text-indent: -9999px;
  cursor: pointer;
}
.toast-close-button:after {
  position: absolute;
  top: 0;
  left: 0;
  text-indent: 0;
  color: #8094ae;
  font-family: "Nioicon";
  content: "\\ea06";
  font-size: 18px;
  line-height: 32px;
  width: 100%;
  text-align: center;
}
.is-dark .toast-close-button:after {
  color: #dbdfea;
}

@media only screen and (max-width: 480px) {
  .Toastify__toast {
    margin-bottom: 0;
    border-radius: 0;
  }
}
.Toastify__toast-theme--dark {
  background: var(--toastify-color-dark);
  border-color: #09c2de;
  color: #fff !important;
}
.Toastify__toast-theme--dark .icon {
  color: #09c2de;
}
.Toastify__toast-theme--dark .toast-close-button {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-block;
  height: 32px;
  width: 32px;
  text-indent: -9999px;
  cursor: pointer;
}
.Toastify__toast-theme--dark .toast-close-button:after {
  position: absolute;
  top: 0;
  left: 0;
  text-indent: 0;
  color: #dbdfea;
  font-family: "Nioicon";
  content: "\\ea06";
  font-size: 18px;
  line-height: 32px;
  width: 100%;
  text-align: center;
}
.Toastify__toast-theme--dark .btn-trigger::before {
  background: none;
}

.Toastify__toast-theme--dark > h5 {
  color: #fff !important;
}

.Toastify__toast-theme--light {
  color: var(--toastify-text-color-light);
}

.Toastify__toast--default {
  color: var(--toastify-text-color-light);
}

.Toastify__toast--info {
  border-color: #09c2de;
}
.Toastify__toast--info .icon {
  color: #09c2de;
}

.Toastify__toast--success {
  border-color: #1ee0ac;
}
.Toastify__toast--success .icon {
  color: #1ee0ac;
}

.Toastify__toast--warning {
  border-color: #f4bd0e;
}
.Toastify__toast--warning .icon {
  color: #f4bd0e;
}

.Toastify__toast--error {
  border-color: #e85347;
}
.Toastify__toast--error .icon {
  color: #e85347;
}

.Toastify__progress-bar-theme--light {
  background: var(--toastify-color-progress-light);
}

.Toastify__progress-bar-theme--dark {
  background: var(--toastify-color-progress-dark);
}

.Toastify__progress-bar--info {
  background: var(--toastify-color-progress-info);
}

.Toastify__progress-bar--success {
  background: var(--toastify-color-progress-success);
}

.Toastify__progress-bar--warning {
  background: var(--toastify-color-progress-warning);
}

.Toastify__progress-bar--error {
  background: var(--toastify-color-progress-error);
}

.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info, .Toastify__progress-bar-theme--colored.Toastify__progress-bar--success, .Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning, .Toastify__progress-bar-theme--colored.Toastify__progress-bar--error {
  background: var(--toastify-color-transparent);
}

.Toastify__close-button {
  color: #8094ae;
  background: transparent;
  font-family: "Nioicon";
  outline: none;
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  opacity: 0.7;
  transition: 0.3s ease;
  align-self: flex-start;
}
.Toastify__close-button:active, .Toastify__close-button:focus {
  outline: none !important;
}

.Toastify__close-button--light {
  color: #000;
  opacity: 0.3;
}

.Toastify__close-button > svg {
  fill: currentColor;
  height: 16px;
  width: 14px;
}

.Toastify__close-button:hover, .Toastify__close-button:focus {
  opacity: 1;
}

@keyframes Toastify__trackProgress {
  0% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(0);
  }
}
.Toastify__progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5px;
  z-index: var(--toastify-z-index);
  opacity: 0.7;
  transform-origin: left;
}

.Toastify__progress-bar--animated {
  animation: Toastify__trackProgress linear 1 forwards;
}

.Toastify__progress-bar--controlled {
  transition: transform 0.2s;
}

.Toastify__progress-bar--rtl {
  right: 0;
  left: initial;
  transform-origin: right;
}

.Toastify__spinner {
  width: 20px;
  height: 20px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: var(--toastify-spinner-color-empty-area);
  border-right-color: var(--toastify-spinner-color);
  animation: Toastify__spin 0.65s linear infinite;
}

@keyframes Toastify__bounceInRight {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
  }
  75% {
    transform: translate3d(10px, 0, 0);
  }
  90% {
    transform: translate3d(-5px, 0, 0);
  }
  to {
    transform: none;
  }
}
@keyframes Toastify__bounceOutRight {
  20% {
    opacity: 1;
    transform: translate3d(-20px, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(2000px, 0, 0);
  }
}
@keyframes Toastify__bounceInLeft {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }
  75% {
    transform: translate3d(-10px, 0, 0);
  }
  90% {
    transform: translate3d(5px, 0, 0);
  }
  to {
    transform: none;
  }
}
@keyframes Toastify__bounceOutLeft {
  20% {
    opacity: 1;
    transform: translate3d(20px, 0, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0);
  }
}
@keyframes Toastify__bounceInUp {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(0, 3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  75% {
    transform: translate3d(0, 10px, 0);
  }
  90% {
    transform: translate3d(0, -5px, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__bounceOutUp {
  20% {
    transform: translate3d(0, -10px, 0);
  }
  40%, 45% {
    opacity: 1;
    transform: translate3d(0, 20px, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
}
@keyframes Toastify__bounceInDown {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(0, -3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, 25px, 0);
  }
  75% {
    transform: translate3d(0, -10px, 0);
  }
  90% {
    transform: translate3d(0, 5px, 0);
  }
  to {
    transform: none;
  }
}
@keyframes Toastify__bounceOutDown {
  20% {
    transform: translate3d(0, 10px, 0);
  }
  40%, 45% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
}
.Toastify__bounce-enter--top-left, .Toastify__bounce-enter--bottom-left {
  animation-name: Toastify__bounceInLeft;
}

.Toastify__bounce-enter--top-right, .Toastify__bounce-enter--bottom-right {
  animation-name: Toastify__bounceInRight;
}

.Toastify__bounce-enter--top-center {
  animation-name: Toastify__bounceInDown;
}

.Toastify__bounce-enter--bottom-center {
  animation-name: Toastify__bounceInUp;
}

.Toastify__bounce-exit--top-left, .Toastify__bounce-exit--bottom-left {
  animation-name: Toastify__bounceOutLeft;
}

.Toastify__bounce-exit--top-right, .Toastify__bounce-exit--bottom-right {
  animation-name: Toastify__bounceOutRight;
}

.Toastify__bounce-exit--top-center {
  animation-name: Toastify__bounceOutUp;
}

.Toastify__bounce-exit--bottom-center {
  animation-name: Toastify__bounceOutDown;
}

@keyframes Toastify__zoomIn {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}
@keyframes Toastify__zoomOut {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  to {
    opacity: 0;
  }
}
.Toastify__zoom-enter {
  animation-name: Toastify__zoomIn;
}

.Toastify__zoom-exit {
  animation-name: Toastify__zoomOut;
}

@keyframes Toastify__flipIn {
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }
  40% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    animation-timing-function: ease-in;
  }
  60% {
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }
  80% {
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  }
  to {
    transform: perspective(400px);
  }
}
@keyframes Toastify__flipOut {
  from {
    transform: perspective(400px);
  }
  30% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    opacity: 1;
  }
  to {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    opacity: 0;
  }
}
.Toastify__flip-enter {
  animation-name: Toastify__flipIn;
}

.Toastify__flip-exit {
  animation-name: Toastify__flipOut;
}

@keyframes Toastify__slideInRight {
  from {
    transform: translate3d(110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideInLeft {
  from {
    transform: translate3d(-110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideInUp {
  from {
    transform: translate3d(0, 110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideInDown {
  from {
    transform: translate3d(0, -110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes Toastify__slideOutRight {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(110%, 0, 0);
  }
}
@keyframes Toastify__slideOutLeft {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(-110%, 0, 0);
  }
}
@keyframes Toastify__slideOutDown {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, 500px, 0);
  }
}
@keyframes Toastify__slideOutUp {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, -500px, 0);
  }
}
.Toastify__slide-enter--top-left, .Toastify__slide-enter--bottom-left {
  animation-name: Toastify__slideInLeft;
}

.Toastify__slide-enter--top-right, .Toastify__slide-enter--bottom-right {
  animation-name: Toastify__slideInRight;
}

.Toastify__slide-enter--top-center {
  animation-name: Toastify__slideInDown;
}

.Toastify__slide-enter--bottom-center {
  animation-name: Toastify__slideInUp;
}

.Toastify__slide-exit--top-left, .Toastify__slide-exit--bottom-left {
  animation-name: Toastify__slideOutLeft;
}

.Toastify__slide-exit--top-right, .Toastify__slide-exit--bottom-right {
  animation-name: Toastify__slideOutRight;
}

.Toastify__slide-exit--top-center {
  animation-name: Toastify__slideOutUp;
}

.Toastify__slide-exit--bottom-center {
  animation-name: Toastify__slideOutDown;
}

@keyframes Toastify__spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
/*# sourceMappingURL=ReactToastify.css.map */
.jvectormap-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  touch-action: none;
}

.jvectormap-tip {
  position: absolute;
  display: none;
  border: solid 1px #CDCDCD;
  border-radius: 3px;
  background: #292929;
  color: white;
  font-family: sans-serif, Verdana;
  font-size: smaller;
  padding: 3px;
}

.jvectormap-zoomin, .jvectormap-zoomout, .jvectormap-goback {
  position: absolute;
  left: 10px;
  border-radius: 3px;
  background: #292929;
  padding: 3px;
  color: white;
  cursor: pointer;
  line-height: 10px;
  text-align: center;
  box-sizing: content-box;
}

.jvectormap-zoomin, .jvectormap-zoomout {
  width: 10px;
  height: 10px;
}

.jvectormap-zoomin {
  top: 10px;
}

.jvectormap-zoomout {
  top: 30px;
}

.jvectormap-goback {
  bottom: 10px;
  z-index: 1000;
  padding: 6px;
}

.jvectormap-spinner {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: center no-repeat url(${___CSS_LOADER_URL_REPLACEMENT_61___});
}

.jvectormap-legend-title {
  font-weight: bold;
  font-size: 14px;
  text-align: center;
}

.jvectormap-legend-cnt {
  position: absolute;
}

.jvectormap-legend-cnt-h {
  bottom: 0;
  right: 0;
}

.jvectormap-legend-cnt-v {
  top: 0;
  right: 0;
}

.jvectormap-legend {
  background: black;
  color: white;
  border-radius: 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend {
  float: left;
  margin: 0 10px 10px 0;
  padding: 3px 3px 1px 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {
  float: left;
}

.jvectormap-legend-cnt-v .jvectormap-legend {
  margin: 10px 10px 0 0;
  padding: 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick {
  width: 40px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {
  height: 15px;
}

.jvectormap-legend-cnt-v .jvectormap-legend-tick-sample {
  height: 20px;
  width: 20px;
  display: inline-block;
  vertical-align: middle;
}

.jvectormap-legend-tick-text {
  font-size: 12px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-text {
  text-align: center;
}

.jvectormap-legend-cnt-v .jvectormap-legend-tick-text {
  display: inline-block;
  vertical-align: middle;
  line-height: 20px;
  padding-left: 3px;
}

/* jsTree default theme */
.jstree-node,
.jstree-children,
.jstree-container-ul {
  display: block;
  margin: 0;
  padding: 0;
  list-style-type: none;
  list-style-image: none;
}

.jstree-node {
  white-space: nowrap;
}

.jstree-anchor {
  display: inline-block;
  color: black;
  white-space: nowrap;
  padding: 0 4px 0 1px;
  margin: 0;
  vertical-align: top;
}

.jstree-anchor:focus {
  outline: 0;
}

.jstree-anchor,
.jstree-anchor:link,
.jstree-anchor:visited,
.jstree-anchor:hover,
.jstree-anchor:active {
  text-decoration: none;
  color: inherit;
}

.jstree-icon {
  display: inline-block;
  text-decoration: none;
  margin: 0;
  padding: 0;
  vertical-align: top;
  text-align: center;
}

.jstree-icon:empty {
  display: inline-block;
  text-decoration: none;
  margin: 0;
  padding: 0;
  vertical-align: top;
  text-align: center;
}

.jstree-ocl {
  cursor: pointer;
}

.jstree-leaf > .jstree-ocl {
  cursor: default;
}

.jstree .jstree-open > .jstree-children {
  display: block;
}

.jstree .jstree-closed > .jstree-children,
.jstree .jstree-leaf > .jstree-children {
  display: none;
}

.jstree-anchor > .jstree-themeicon {
  margin-right: 2px;
}

.jstree-no-icons .jstree-themeicon,
.jstree-anchor > .jstree-themeicon-hidden {
  display: none;
}

.jstree-hidden,
.jstree-node.jstree-hidden {
  display: none;
}

.jstree-rtl .jstree-anchor {
  padding: 0 1px 0 4px;
}

.jstree-rtl .jstree-anchor > .jstree-themeicon {
  margin-left: 2px;
  margin-right: 0;
}

.jstree-rtl .jstree-node {
  margin-left: 0;
}

.jstree-rtl .jstree-container-ul > .jstree-node {
  margin-right: 0;
}

.jstree-wholerow-ul {
  position: relative;
  display: inline-block;
  min-width: 100%;
}

.jstree-wholerow-ul .jstree-leaf > .jstree-ocl {
  cursor: pointer;
}

.jstree-wholerow-ul .jstree-anchor,
.jstree-wholerow-ul .jstree-icon {
  position: relative;
}

.jstree-wholerow-ul .jstree-wholerow {
  width: 100%;
  cursor: pointer;
  position: absolute;
  left: 0;
  -webkit-user-select: none;
  user-select: none;
}

.jstree-contextmenu .jstree-anchor {
  -webkit-user-select: none;
  /* disable selection/Copy of UIWebView */
  -webkit-touch-callout: none;
  /* disable the IOS popup when long-press on a link */
}

.vakata-context {
  display: none;
}

.vakata-context,
.vakata-context ul {
  margin: 0;
  padding: 0.5rem 0;
  position: absolute;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #e5e9f2;
  box-shadow: 0 3px 12px 1px rgba(58, 34, 114, 0.15);
  min-width: 140px;
}

.vakata-context ul {
  list-style: none;
  left: 100%;
  margin-top: -2.7em;
  margin-left: -4px;
}

.vakata-context .vakata-context-right ul {
  left: auto;
  right: 100%;
  margin-left: auto;
  margin-right: -4px;
}

.vakata-context li {
  list-style: none;
}

.vakata-context li > a {
  display: block;
  padding: 0 1.25rem;
  text-decoration: none;
  width: auto;
  white-space: nowrap;
  line-height: 2.4em;
  font-weight: 500;
  color: #526484;
}

.vakata-context li > a:hover {
  position: relative;
  color: #4461F2;
  background: #f5f6fa;
  box-shadow: none;
}

.vakata-context li > a.vakata-context-parent {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_62___});
  background-position: right center;
  background-repeat: no-repeat;
}

.vakata-context li > a:focus {
  outline: 0;
}

.vakata-context .vakata-context-hover > a {
  position: relative;
  color: #4461F2;
  background: #f5f6fa;
  box-shadow: none;
}

.vakata-context .vakata-context-separator > a,
.vakata-context .vakata-context-separator > a:hover {
  background: white;
  border: 0;
  border-top: 1px solid #e2e3e3;
  height: 1px;
  min-height: 1px;
  max-height: 1px;
  padding: 0;
  margin: 0 0 0 2.4em;
  border-left: 1px solid #e0e0e0;
  text-shadow: 0 0 0 transparent;
  box-shadow: 0 0 0 transparent;
  border-radius: 0;
  display: none;
}

.vakata-context .vakata-contextmenu-disabled a,
.vakata-context .vakata-contextmenu-disabled a:hover {
  color: silver;
  background-color: transparent;
  border: 0;
  box-shadow: 0 0 0;
}

.vakata-context .vakata-contextmenu-disabled > a > i {
  filter: grayscale(100%);
}

.vakata-context li > a > i {
  text-decoration: none;
  display: inline-block;
  width: 2.4em;
  height: 2.4em;
  background: transparent;
  margin: 0 0 0 -2em;
  vertical-align: top;
  text-align: center;
  line-height: 2.4em;
}

.vakata-context li > a > i:empty {
  width: 2.4em;
  line-height: 2.4em;
}

.vakata-context li > a .vakata-contextmenu-sep {
  display: inline-block;
  width: 1px;
  height: 2.4em;
  background: white;
  margin: 0 0.5em 0 0;
  border-left: 1px solid #e2e3e3;
  display: none;
}

.vakata-context .vakata-contextmenu-shortcut {
  font-size: 0.8em;
  color: silver;
  opacity: 0.5;
  display: none;
}

.vakata-context-rtl ul {
  left: auto;
  right: 100%;
  margin-left: auto;
  margin-right: -4px;
}

.vakata-context-rtl li > a.vakata-context-parent {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
  background-position: left center;
  background-repeat: no-repeat;
}

.vakata-context-rtl .vakata-context-separator > a {
  margin: 0 2.4em 0 0;
  border-left: 0;
  border-right: 1px solid #e2e3e3;
}

.vakata-context-rtl .vakata-context-left ul {
  right: auto;
  left: 100%;
  margin-left: -4px;
  margin-right: auto;
}

.vakata-context-rtl li > a > i {
  margin: 0 -2em 0 0;
}

.vakata-context-rtl li > a .vakata-contextmenu-sep {
  margin: 0 0 0 0.5em;
  border-left-color: white;
  background: #e2e3e3;
}

#jstree-marker {
  position: absolute;
  top: 0;
  left: 0;
  margin: -5px 0 0 0;
  padding: 0;
  border-right: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 5px solid;
  width: 0;
  height: 0;
  font-size: 0;
  line-height: 0;
}

#jstree-dnd {
  line-height: 16px;
  margin: 0;
  padding: 4px;
}

#jstree-dnd .jstree-icon,
#jstree-dnd .jstree-copy {
  display: inline-block;
  text-decoration: none;
  margin: 0 2px 0 0;
  padding: 0;
  width: 16px;
  height: 16px;
}

#jstree-dnd .jstree-ok {
  background: green;
}

#jstree-dnd .jstree-er {
  background: red;
}

#jstree-dnd .jstree-copy {
  margin: 0 2px 0 2px;
}

.jstree-default .jstree-node,
.jstree-default .jstree-icon {
  background-repeat: no-repeat;
  background-color: transparent;
}

.jstree-default .jstree-anchor,
.jstree-default .jstree-animated,
.jstree-default .jstree-wholerow {
  transition: background-color 0.15s, box-shadow 0.15s !important;
}

.jstree-default .jstree-hovered {
  background: #f5f6fa !important;
  border-radius: 2px !important;
}
.dark-mode .jstree-default .jstree-hovered {
  background: #203247 !important;
}

.jstree-default .jstree-context {
  background: #f5f6fa !important;
  border-radius: 2px !important;
}
.dark-mode .jstree-default .jstree-context {
  background: #23364e;
}

.jstree-default .jstree-clicked {
  background: #ebeef2 !important;
  border-radius: 2px !important;
}
.dark-mode .jstree-default .jstree-clicked {
  background: #203247 !important;
}

.jstree-default .jstree-no-icons .jstree-anchor > .jstree-themeicon {
  display: none !important;
}

.jstree-default .jstree-disabled {
  background: transparent !important;
  color: #666666 !important;
}
.dark-mode .jstree-default .jstree-disabled {
  color: #8094ae !important;
}

.jstree-default .jstree-disabled.jstree-hovered {
  background: transparent !important;
  box-shadow: none !important;
}

.jstree-default .jstree-disabled.jstree-clicked {
  background: #efefef;
}

.jstree-default .jstree-disabled > .jstree-icon {
  opacity: 0.8;
  filter: url(${___CSS_LOADER_URL_REPLACEMENT_64___}) !important;
  /* Firefox 10+ */
  filter: gray;
  /* IE6-9 */
  -webkit-filter: grayscale(100%);
  /* Chrome 19+ & Safari 6+ */
}

.jstree-default .jstree-search {
  font-style: italic;
  color: #8b0000;
  font-weight: bold;
}

.jstree-default .jstree-no-checkboxes .jstree-checkbox {
  display: none;
}

.jstree-default.jstree-checkbox-no-clicked .jstree-clicked {
  background: transparent;
  box-shadow: none;
}

.jstree-default.jstree-checkbox-no-clicked .jstree-clicked.jstree-hovered {
  background: #e7f4f9;
}

.jstree-default.jstree-checkbox-no-clicked > .jstree-wholerow-ul .jstree-wholerow-clicked {
  background: transparent;
}

.jstree-default.jstree-checkbox-no-clicked > .jstree-wholerow-ul .jstree-wholerow-clicked.jstree-wholerow-hovered {
  background: #e7f4f9;
}

.jstree-default > .jstree-striped {
  min-width: 100%;
  display: inline-block;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_65___}) left top repeat;
}

.jstree-default > .jstree-wholerow-ul .jstree-hovered,
.jstree-default > .jstree-wholerow-ul .jstree-clicked {
  background: transparent;
  box-shadow: none;
  border-radius: 0;
}

.jstree-default .jstree-wholerow {
  box-sizing: border-box;
}

.jstree-default .jstree-wholerow-hovered {
  background: #f5f6fa !important;
}
.dark-mode .jstree-default .jstree-wholerow-hovered {
  background: #1d2d40 !important;
}

.jstree-default .jstree-wholerow-clicked {
  background: #f5f6fa !important;
}
.dark-mode .jstree-default .jstree-wholerow-clicked {
  background: #1d2d40 !important;
}

.jstree-default .jstree-node {
  min-height: 24px;
  line-height: 24px;
  margin-left: 24px;
  min-width: 24px;
}

.jstree-default .jstree-anchor {
  line-height: 24px;
  height: 24px;
}

.jstree-default .jstree-icon {
  width: 24px;
  height: 24px;
  line-height: 24px;
}

.jstree-default .jstree-icon:empty {
  width: 24px;
  height: 24px;
  line-height: 24px;
}

.jstree-default.jstree-rtl .jstree-node {
  margin-right: 24px;
}

.jstree-default .jstree-wholerow {
  height: 24px;
}

.jstree-default .jstree-node,
.jstree-default .jstree-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___}) !important;
}

.jstree-default .jstree-node {
  background-position: -292px -4px !important;
  background-repeat: repeat-y !important;
}

.jstree-default .jstree-last {
  background: transparent !important;
}

.jstree-default .jstree-open > .jstree-ocl {
  background-position: -132px -4px !important;
}

.jstree-default .jstree-closed > .jstree-ocl {
  background-position: -100px -4px !important;
}

.jstree-default .jstree-leaf > .jstree-ocl {
  background-position: -68px -4px !important;
}

.jstree-default .jstree-themeicon {
  background-position: -260px -4px !important;
}

.jstree-default > .jstree-no-dots .jstree-node,
.jstree-default > .jstree-no-dots .jstree-leaf > .jstree-ocl {
  background: transparent !important;
}

.jstree-default > .jstree-no-dots .jstree-open > .jstree-ocl {
  background-position: -36px -4px !important;
}

.jstree-default > .jstree-no-dots .jstree-closed > .jstree-ocl {
  background-position: -4px -4px !important;
}

.jstree-default .jstree-disabled {
  background: transparent !important;
}

.jstree-default .jstree-disabled.jstree-hovered {
  background: transparent !important;
}

.jstree-default .jstree-disabled.jstree-clicked {
  background: #efefef !important;
}

.jstree-default .jstree-checkbox {
  background-position: -164px -4px !important;
}

.jstree-default .jstree-checkbox:hover {
  background-position: -164px -36px !important;
}

.jstree-default.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox,
.jstree-default .jstree-checked > .jstree-checkbox {
  background-position: -228px -4px !important;
}

.jstree-default.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox:hover,
.jstree-default .jstree-checked > .jstree-checkbox:hover {
  background-position: -228px -36px !important;
}

.jstree-default .jstree-anchor > .jstree-undetermined {
  background-position: -196px -4px !important;
}

.jstree-default .jstree-anchor > .jstree-undetermined:hover {
  background-position: -196px -36px !important;
}

.dark-mode .jstree-default .jstree-node,
.dark-mode .jstree-default .jstree-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___}) !important;
}
.dark-mode .jstree-default .jstree-node {
  background-position: -292px -4px !important;
  background-repeat: repeat-y !important;
}
.dark-mode .jstree-default .jstree-last {
  background: transparent !important;
}
.dark-mode .jstree-default .jstree-open > .jstree-ocl {
  background-position: -132px -4px !important;
}
.dark-mode .jstree-default .jstree-closed > .jstree-ocl {
  background-position: -100px -4px !important;
}
.dark-mode .jstree-default .jstree-leaf > .jstree-ocl {
  background-position: -68px -4px !important;
}
.dark-mode .jstree-default .jstree-themeicon {
  background-position: -260px -4px !important;
}
.dark-mode .jstree-default > .jstree-no-dots .jstree-node,
.dark-mode .jstree-default > .jstree-no-dots .jstree-leaf > .jstree-ocl {
  background: transparent !important;
}
.dark-mode .jstree-default > .jstree-no-dots .jstree-open > .jstree-ocl {
  background-position: -36px -4px !important;
}
.dark-mode .jstree-default > .jstree-no-dots .jstree-closed > .jstree-ocl {
  background-position: -4px -4px !important;
}
.dark-mode .jstree-default .jstree-disabled {
  background: transparent !important;
}
.dark-mode .jstree-default .jstree-disabled.jstree-hovered {
  background: transparent !important;
}
.dark-mode .jstree-default .jstree-disabled.jstree-clicked {
  background: #182536 !important;
}
.dark-mode .jstree-default .jstree-checkbox {
  background-position: -164px -4px !important;
}
.dark-mode .jstree-default .jstree-checkbox:hover {
  background-position: -164px -36px !important;
}
.dark-mode .jstree-default.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox,
.dark-mode .jstree-default .jstree-checked > .jstree-checkbox {
  background-position: -228px -4px !important;
}
.dark-mode .jstree-default.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox:hover,
.dark-mode .jstree-default .jstree-checked > .jstree-checkbox:hover {
  background-position: -228px -36px !important;
}
.dark-mode .jstree-default .jstree-anchor > .jstree-undetermined {
  background-position: -196px -4px !important;
}
.dark-mode .jstree-default .jstree-anchor > .jstree-undetermined:hover {
  background-position: -196px -36px !important;
}

.jstree-default .jstree-checkbox-disabled {
  opacity: 0.8;
  filter: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
  /* Firefox 10+ */
  filter: gray;
  /* IE6-9 */
  -webkit-filter: grayscale(100%);
  /* Chrome 19+ & Safari 6+ */
}

.jstree-default > .jstree-striped {
  background-size: auto 48px;
}

.jstree-default.jstree-rtl .jstree-node {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_68___});
  background-position: 100% 1px;
  background-repeat: repeat-y;
}

.jstree-default.jstree-rtl .jstree-last {
  background: transparent;
}

.jstree-default.jstree-rtl .jstree-open > .jstree-ocl {
  background-position: -132px -36px;
}

.jstree-default.jstree-rtl .jstree-closed > .jstree-ocl {
  background-position: -100px -36px;
}

.jstree-default.jstree-rtl .jstree-leaf > .jstree-ocl {
  background-position: -68px -36px;
}

.jstree-default.jstree-rtl > .jstree-no-dots .jstree-node,
.jstree-default.jstree-rtl > .jstree-no-dots .jstree-leaf > .jstree-ocl {
  background: transparent !important;
}

.jstree-default.jstree-rtl > .jstree-no-dots .jstree-open > .jstree-ocl {
  background-position: -36px -36px;
}

.jstree-default.jstree-rtl > .jstree-no-dots .jstree-closed > .jstree-ocl {
  background-position: -4px -36px;
}

.jstree-default .jstree-themeicon-custom {
  background-color: transparent !important;
  background-position: 0 0 !important;
  margin-right: 0 !important;
  background-image: none !important;
}
.dark-mode .jstree-default .jstree-themeicon-custom {
  background-image: none !important;
}
.jstree-default .jstree-themeicon-custom.icon {
  font-size: 1rem !important;
}

.jstree-default > .jstree-container-ul .jstree-loading > .jstree-ocl {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_69___}) center center no-repeat !important;
}
.dark-mode .jstree-default > .jstree-container-ul .jstree-loading > .jstree-ocl {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_70___}) center center no-repeat !important;
}

.jstree-default .jstree-file {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_66___}) -100px -68px no-repeat !important;
}
.dark-mode .jstree-default .jstree-file {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_67___}) -100px -68px no-repeat !important;
}

.jstree-default .jstree-folder {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_66___}) -260px -4px no-repeat !important;
}
.dark-mode .jstree-default .jstree-folder {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_67___}) -260px -4px no-repeat !important;
}

.jstree-default > .jstree-container-ul > .jstree-node {
  margin-left: 0;
  margin-right: 0;
}

#jstree-dnd.jstree-default {
  line-height: 24px;
  padding: 0 4px;
}

#jstree-dnd.jstree-default .jstree-ok,
#jstree-dnd.jstree-default .jstree-er {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___}) !important;
  background-repeat: no-repeat;
  background-color: transparent;
}
.dark-mode #jstree-dnd.jstree-default .jstree-ok,
.dark-mode #jstree-dnd.jstree-default .jstree-er {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___}) !important;
  background-repeat: no-repeat;
  background-color: transparent;
}

#jstree-dnd.jstree-default i {
  background: transparent;
  width: 24px;
  height: 24px;
  line-height: 24px;
}

#jstree-dnd.jstree-default .jstree-ok {
  background-position: -4px -68px;
}

#jstree-dnd.jstree-default .jstree-er {
  background-position: -36px -68px;
}

.dark-mode #jstree-dnd.jstree-default .jstree-ok {
  background-position: -4px -68px;
}
.dark-mode #jstree-dnd.jstree-default .jstree-er {
  background-position: -36px -68px;
}

.jstree-default .jstree-ellipsis {
  overflow: hidden;
}

.jstree-default .jstree-ellipsis .jstree-anchor {
  width: calc(100% - 29px);
  text-overflow: ellipsis;
  overflow: hidden;
}

.jstree-default.jstree-rtl .jstree-node {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_68___});
}

.jstree-default.jstree-rtl .jstree-last {
  background: transparent;
}

.jstree-default-small .jstree-node {
  min-height: 18px;
  line-height: 18px;
  margin-left: 18px;
  min-width: 18px;
}

.jstree-default-small .jstree-anchor {
  line-height: 18px;
  height: 18px;
}

.jstree-default-small .jstree-icon {
  width: 18px;
  height: 18px;
  line-height: 18px;
}

.jstree-default-small .jstree-icon:empty {
  width: 18px;
  height: 18px;
  line-height: 18px;
}

.jstree-default-small.jstree-rtl .jstree-node {
  margin-right: 18px;
}

.jstree-default-small .jstree-wholerow {
  height: 18px;
}

.jstree-default-small .jstree-node,
.jstree-default-small .jstree-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___}) !important;
}

.jstree-default-small .jstree-node {
  background-position: -295px -7px;
  background-repeat: repeat-y;
}

.jstree-default-small .jstree-last {
  background: transparent;
}

.jstree-default-small .jstree-open > .jstree-ocl {
  background-position: -135px -7px;
}

.jstree-default-small .jstree-closed > .jstree-ocl {
  background-position: -103px -7px;
}

.jstree-default-small .jstree-leaf > .jstree-ocl {
  background-position: -71px -7px;
}

.jstree-default-small .jstree-themeicon {
  background-position: -263px -7px !important;
}

.jstree-default-small > .jstree-no-dots .jstree-node,
.jstree-default-small > .jstree-no-dots .jstree-leaf > .jstree-ocl {
  background: transparent;
}

.jstree-default-small > .jstree-no-dots .jstree-open > .jstree-ocl {
  background-position: -39px -7px;
}

.jstree-default-small > .jstree-no-dots .jstree-closed > .jstree-ocl {
  background-position: -7px -7px;
}

.jstree-default-small .jstree-disabled {
  background: transparent;
}

.jstree-default-small .jstree-disabled.jstree-hovered {
  background: transparent;
}

.jstree-default-small .jstree-disabled.jstree-clicked {
  background: #efefef;
}

.jstree-default-small .jstree-checkbox {
  background-position: -167px -7px;
}

.jstree-default-small .jstree-checkbox:hover {
  background-position: -167px -39px;
}

.jstree-default-small.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox,
.jstree-default-small .jstree-checked > .jstree-checkbox {
  background-position: -231px -7px !important;
}

.jstree-default-small.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox:hover,
.jstree-default-small .jstree-checked > .jstree-checkbox:hover {
  background-position: -231px -39px !important;
}

.jstree-default-small .jstree-anchor > .jstree-undetermined {
  background-position: -199px -7px;
}

.jstree-default-small .jstree-anchor > .jstree-undetermined:hover {
  background-position: -199px -39px;
}

.dark-mode .jstree-default-small .jstree-node,
.dark-mode .jstree-default-small .jstree-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___}) !important;
}
.dark-mode .jstree-default-small .jstree-node {
  background-position: -295px -7px;
  background-repeat: repeat-y;
}
.dark-mode .jstree-default-small .jstree-last {
  background: transparent;
}
.dark-mode .jstree-default-small .jstree-open > .jstree-ocl {
  background-position: -135px -7px;
}
.dark-mode .jstree-default-small .jstree-closed > .jstree-ocl {
  background-position: -103px -7px;
}
.dark-mode .jstree-default-small .jstree-leaf > .jstree-ocl {
  background-position: -71px -7px;
}
.dark-mode .jstree-default-small .jstree-themeicon {
  background-position: -263px -7px !important;
}
.dark-mode .jstree-default-small > .jstree-no-dots .jstree-node,
.dark-mode .jstree-default-small > .jstree-no-dots .jstree-leaf > .jstree-ocl {
  background: transparent;
}
.dark-mode .jstree-default-small > .jstree-no-dots .jstree-open > .jstree-ocl {
  background-position: -39px -7px;
}
.dark-mode .jstree-default-small > .jstree-no-dots .jstree-closed > .jstree-ocl {
  background-position: -7px -7px;
}
.dark-mode .jstree-default-small .jstree-disabled {
  background: transparent;
}
.dark-mode .jstree-default-small .jstree-disabled.jstree-hovered {
  background: transparent;
}
.dark-mode .jstree-default-small .jstree-disabled.jstree-clicked {
  background: #efefef;
}
.dark-mode .jstree-default-small .jstree-checkbox {
  background-position: -167px -7px;
}
.dark-mode .jstree-default-small .jstree-checkbox:hover {
  background-position: -167px -39px;
}
.dark-mode .jstree-default-small.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox,
.dark-mode .jstree-default-small .jstree-checked > .jstree-checkbox {
  background-position: -231px -7px;
}
.dark-mode .jstree-default-small.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox:hover,
.dark-mode .jstree-default-small .jstree-checked > .jstree-checkbox:hover {
  background-position: -231px -39px;
}
.dark-mode .jstree-default-small .jstree-anchor > .jstree-undetermined {
  background-position: -199px -7px;
}
.dark-mode .jstree-default-small .jstree-anchor > .jstree-undetermined:hover {
  background-position: -199px -39px;
}

.jstree-default-small .jstree-checkbox-disabled {
  opacity: 0.8;
  filter: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
  /* Firefox 10+ */
  filter: gray;
  /* IE6-9 */
  -webkit-filter: grayscale(100%);
  /* Chrome 19+ & Safari 6+ */
}

.jstree-default-small > .jstree-striped {
  background-size: auto 36px;
}

.jstree-default-small.jstree-rtl .jstree-node {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_68___});
  background-position: 100% 1px;
  background-repeat: repeat-y;
}

.jstree-default-small.jstree-rtl .jstree-last {
  background: transparent;
}

.jstree-default-small.jstree-rtl .jstree-open > .jstree-ocl {
  background-position: -135px -39px;
}

.jstree-default-small.jstree-rtl .jstree-closed > .jstree-ocl {
  background-position: -103px -39px;
}

.jstree-default-small.jstree-rtl .jstree-leaf > .jstree-ocl {
  background-position: -71px -39px;
}

.jstree-default-small.jstree-rtl > .jstree-no-dots .jstree-node,
.jstree-default-small.jstree-rtl > .jstree-no-dots .jstree-leaf > .jstree-ocl {
  background: transparent;
}

.jstree-default-small.jstree-rtl > .jstree-no-dots .jstree-open > .jstree-ocl {
  background-position: -39px -39px;
}

.jstree-default-small.jstree-rtl > .jstree-no-dots .jstree-closed > .jstree-ocl {
  background-position: -7px -39px;
}

.jstree-default-small .jstree-themeicon-custom {
  background-color: transparent !important;
  background-image: none !important;
  background-position: 0 0 !important;
}

.jstree-default-small > .jstree-container-ul .jstree-loading > .jstree-ocl {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_69___}) center center no-repeat;
}
.dark-mode .jstree-default-small > .jstree-container-ul .jstree-loading > .jstree-ocl {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_70___}) center center no-repeat;
}

.jstree-default-small .jstree-file {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_66___}) -103px -71px no-repeat;
}
.dark-mode .jstree-default-small .jstree-file {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_67___}) -103px -71px no-repeat !important;
}

.jstree-default-small .jstree-folder {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_66___}) -263px -7px no-repeat;
}
.dark-mode .jstree-default-small .jstree-folder {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_67___}) -263px -7px no-repeat !important;
}

.jstree-default-small > .jstree-container-ul > .jstree-node {
  margin-left: 0;
  margin-right: 0;
}

#jstree-dnd.jstree-default-small {
  line-height: 18px;
  padding: 0 4px;
}

#jstree-dnd.jstree-default-small .jstree-ok,
#jstree-dnd.jstree-default-small .jstree-er {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___});
  background-repeat: no-repeat;
  background-color: transparent;
}
.dark-mode #jstree-dnd.jstree-default-small .jstree-ok,
.dark-mode #jstree-dnd.jstree-default-small .jstree-er {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___}) !important;
  background-repeat: no-repeat;
  background-color: transparent;
}

#jstree-dnd.jstree-default-small i {
  background: transparent;
  width: 18px;
  height: 18px;
  line-height: 18px;
}

#jstree-dnd.jstree-default-small .jstree-ok {
  background-position: -7px -71px;
}

#jstree-dnd.jstree-default-small .jstree-er {
  background-position: -39px -71px;
}

.dark-mode #jstree-dnd.jstree-default-small .jstree-ok {
  background-position: -7px -71px;
}
.dark-mode #jstree-dnd.jstree-default-small .jstree-er {
  background-position: -39px -71px;
}

.jstree-default-small .jstree-ellipsis {
  overflow: hidden;
}

.jstree-default-small .jstree-ellipsis .jstree-anchor {
  width: calc(100% - 23px);
  text-overflow: ellipsis;
  overflow: hidden;
}

.jstree-default-small.jstree-rtl .jstree-node {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_71___});
}

.jstree-default-small.jstree-rtl .jstree-last {
  background: transparent;
}

.jstree-default-large .jstree-node {
  min-height: 32px;
  line-height: 32px;
  margin-left: 32px;
  min-width: 32px;
}

.jstree-default-large .jstree-anchor {
  line-height: 32px;
  height: 32px;
}

.jstree-default-large .jstree-icon {
  width: 32px;
  height: 32px;
  line-height: 32px;
}

.jstree-default-large .jstree-icon:empty {
  width: 32px;
  height: 32px;
  line-height: 32px;
}

.jstree-default-large.jstree-rtl .jstree-node {
  margin-right: 32px;
}

.jstree-default-large .jstree-wholerow {
  height: 32px;
}

.jstree-default-large .jstree-node,
.jstree-default-large .jstree-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___}) !important;
}

.jstree-default-large .jstree-node {
  background-position: -288px 0px;
  background-repeat: repeat-y;
}

.jstree-default-large .jstree-last {
  background: transparent;
}

.jstree-default-large .jstree-open > .jstree-ocl {
  background-position: -128px 0px;
}

.jstree-default-large .jstree-closed > .jstree-ocl {
  background-position: -96px 0px;
}

.jstree-default-large .jstree-leaf > .jstree-ocl {
  background-position: -64px 0px;
}

.jstree-default-large .jstree-themeicon {
  background-position: -256px 0px !important;
}

.jstree-default-large > .jstree-no-dots .jstree-node,
.jstree-default-large > .jstree-no-dots .jstree-leaf > .jstree-ocl {
  background: transparent;
}

.jstree-default-large > .jstree-no-dots .jstree-open > .jstree-ocl {
  background-position: -32px 0px;
}

.jstree-default-large > .jstree-no-dots .jstree-closed > .jstree-ocl {
  background-position: 0px 0px;
}

.jstree-default-large .jstree-disabled {
  background: transparent;
}

.jstree-default-large .jstree-disabled.jstree-hovered {
  background: transparent;
}

.jstree-default-large .jstree-disabled.jstree-clicked {
  background: #efefef;
}

.jstree-default-large .jstree-checkbox {
  background-position: -160px 0px;
}

.jstree-default-large .jstree-checkbox:hover {
  background-position: -160px -32px;
}

.jstree-default-large.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox,
.jstree-default-large .jstree-checked > .jstree-checkbox {
  background-position: -224px 0px;
}

.jstree-default-large.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox:hover,
.jstree-default-large .jstree-checked > .jstree-checkbox:hover {
  background-position: -224px -32px;
}

.jstree-default-large .jstree-anchor > .jstree-undetermined {
  background-position: -192px 0px;
}

.jstree-default-large .jstree-anchor > .jstree-undetermined:hover {
  background-position: -192px -32px;
}

.dark-mode .jstree-default-large .jstree-node,
.dark-mode .jstree-default-large .jstree-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___}) !important;
}
.dark-mode .jstree-default-large .jstree-node {
  background-position: -288px 0px;
  background-repeat: repeat-y;
}
.dark-mode .jstree-default-large .jstree-last {
  background: transparent;
}
.dark-mode .jstree-default-large .jstree-open > .jstree-ocl {
  background-position: -128px 0px;
}
.dark-mode .jstree-default-large .jstree-closed > .jstree-ocl {
  background-position: -96px 0px;
}
.dark-mode .jstree-default-large .jstree-leaf > .jstree-ocl {
  background-position: -64px 0px;
}
.dark-mode .jstree-default-large .jstree-themeicon {
  background-position: -256px 0px !important;
}
.dark-mode .jstree-default-large > .jstree-no-dots .jstree-node,
.dark-mode .jstree-default-large > .jstree-no-dots .jstree-leaf > .jstree-ocl {
  background: transparent;
}
.dark-mode .jstree-default-large > .jstree-no-dots .jstree-open > .jstree-ocl {
  background-position: -32px 0px;
}
.dark-mode .jstree-default-large > .jstree-no-dots .jstree-closed > .jstree-ocl {
  background-position: 0px 0px;
}
.dark-mode .jstree-default-large .jstree-disabled {
  background: transparent;
}
.dark-mode .jstree-default-large .jstree-disabled.jstree-hovered {
  background: transparent;
}
.dark-mode .jstree-default-large .jstree-disabled.jstree-clicked {
  background: #efefef;
}
.dark-mode .jstree-default-large .jstree-checkbox {
  background-position: -160px 0px;
}
.dark-mode .jstree-default-large .jstree-checkbox:hover {
  background-position: -160px -32px;
}
.dark-mode .jstree-default-large.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox,
.dark-mode .jstree-default-large .jstree-checked > .jstree-checkbox {
  background-position: -224px 0px;
}
.dark-mode .jstree-default-large.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox:hover,
.dark-mode .jstree-default-large .jstree-checked > .jstree-checkbox:hover {
  background-position: -224px -32px;
}
.dark-mode .jstree-default-large .jstree-anchor > .jstree-undetermined {
  background-position: -192px 0px;
}
.dark-mode .jstree-default-large .jstree-anchor > .jstree-undetermined:hover {
  background-position: -192px -32px;
}

.jstree-default-large .jstree-checkbox-disabled {
  opacity: 0.8;
  filter: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
  /* Firefox 10+ */
  filter: gray;
  /* IE6-9 */
  -webkit-filter: grayscale(100%);
  /* Chrome 19+ & Safari 6+ */
}

.jstree-default-large > .jstree-striped {
  background-size: auto 64px;
}

.jstree-default-large.jstree-rtl .jstree-node {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_68___});
  background-position: 100% 1px;
  background-repeat: repeat-y;
}

.jstree-default-large.jstree-rtl .jstree-last {
  background: transparent;
}

.jstree-default-large.jstree-rtl .jstree-open > .jstree-ocl {
  background-position: -128px -32px;
}

.jstree-default-large.jstree-rtl .jstree-closed > .jstree-ocl {
  background-position: -96px -32px;
}

.jstree-default-large.jstree-rtl .jstree-leaf > .jstree-ocl {
  background-position: -64px -32px;
}

.jstree-default-large.jstree-rtl > .jstree-no-dots .jstree-node,
.jstree-default-large.jstree-rtl > .jstree-no-dots .jstree-leaf > .jstree-ocl {
  background: transparent;
}

.jstree-default-large.jstree-rtl > .jstree-no-dots .jstree-open > .jstree-ocl {
  background-position: -32px -32px;
}

.jstree-default-large.jstree-rtl > .jstree-no-dots .jstree-closed > .jstree-ocl {
  background-position: 0px -32px;
}

.jstree-default-large .jstree-themeicon-custom {
  background-color: transparent !important;
  background-image: none !important;
  background-position: 0 0 !important;
}

.jstree-default-large > .jstree-container-ul .jstree-loading > .jstree-ocl {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_69___}) center center no-repeat;
}
.dark-mode .jstree-default-large > .jstree-container-ul .jstree-loading > .jstree-ocl {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_70___}) center center no-repeat;
}

.jstree-default-large .jstree-file {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_66___}) -96px -64px no-repeat;
}
.dark-mode .jstree-default-large .jstree-file {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_67___}) -96px -64px no-repeat;
}

.jstree-default-large .jstree-folder {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_66___}) -256px 0px no-repeat;
}
.dark-mode .jstree-default-large .jstree-folder {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_67___}) -256px 0px no-repeat;
}

.jstree-default-large > .jstree-container-ul > .jstree-node {
  margin-left: 0;
  margin-right: 0;
}

#jstree-dnd.jstree-default-large {
  line-height: 32px;
  padding: 0 4px;
}

#jstree-dnd.jstree-default-large .jstree-ok,
#jstree-dnd.jstree-default-large .jstree-er {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___});
  background-repeat: no-repeat;
  background-color: transparent;
}
.dark-mode #jstree-dnd.jstree-default-large .jstree-ok,
.dark-mode #jstree-dnd.jstree-default-large .jstree-er {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___});
  background-repeat: no-repeat;
  background-color: transparent;
}

#jstree-dnd.jstree-default-large i {
  background: transparent;
  width: 32px;
  height: 32px;
  line-height: 32px;
}

#jstree-dnd.jstree-default-large .jstree-ok {
  background-position: 0px -64px;
}

#jstree-dnd.jstree-default-large .jstree-er {
  background-position: -32px -64px;
}

.dark-mode #jstree-dnd.jstree-default-large .jstree-ok {
  background-position: 0px -64px;
}
.dark-mode #jstree-dnd.jstree-default-large .jstree-er {
  background-position: -32px -64px;
}

.jstree-default-large .jstree-ellipsis {
  overflow: hidden;
}

.jstree-default-large .jstree-ellipsis .jstree-anchor {
  width: calc(100% - 37px);
  text-overflow: ellipsis;
  overflow: hidden;
}

.jstree-default-large.jstree-rtl .jstree-node {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_72___});
}

.jstree-default-large.jstree-rtl .jstree-last {
  background: transparent;
}

@media (max-width: 768px) {
  #jstree-dnd.jstree-dnd-responsive {
    line-height: 40px;
    font-weight: bold;
    font-size: 1.1em;
    text-shadow: 1px 1px white;
  }
  #jstree-dnd.jstree-dnd-responsive > i {
    background: transparent;
    width: 40px;
    height: 40px;
  }
  #jstree-dnd.jstree-dnd-responsive > .jstree-ok {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_73___});
    background-position: 0 -200px;
    background-size: 120px 240px;
  }
  .dark-mode #jstree-dnd.jstree-dnd-responsive > .jstree-ok {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_74___});
    background-position: 0 -200px;
    background-size: 120px 240px;
  }
  #jstree-dnd.jstree-dnd-responsive > .jstree-er {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_73___});
    background-position: -40px -200px;
    background-size: 120px 240px;
  }
  .dark-mode #jstree-dnd.jstree-dnd-responsive > .jstree-er {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_74___});
    background-position: -40px -200px;
    background-size: 120px 240px;
  }
  #jstree-marker.jstree-dnd-responsive {
    border-left-width: 10px;
    border-top-width: 10px;
    border-bottom-width: 10px;
    margin-top: -10px;
  }
}
@media (max-width: 768px) {
  .jstree-default-responsive {
    /*
    .jstree-open > .jstree-ocl,
    .jstree-closed > .jstree-ocl { border-radius:20px; background-color:white; }
    */
  }
  .jstree-default-responsive .jstree-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_73___}) !important;
  }
  .dark-mode .jstree-default-responsive .jstree-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_74___}) !important;
  }
  .jstree-default-responsive .jstree-node,
  .jstree-default-responsive .jstree-leaf > .jstree-ocl {
    background: transparent;
  }
  .jstree-default-responsive .jstree-node {
    min-height: 40px;
    line-height: 40px;
    margin-left: 40px;
    min-width: 40px;
    white-space: nowrap;
  }
  .jstree-default-responsive .jstree-anchor {
    line-height: 40px;
    height: 40px;
  }
  .jstree-default-responsive .jstree-icon,
  .jstree-default-responsive .jstree-icon:empty {
    width: 40px;
    height: 40px;
    line-height: 40px;
  }
  .jstree-default-responsive > .jstree-container-ul > .jstree-node {
    margin-left: 0;
  }
  .jstree-default-responsive.jstree-rtl .jstree-node {
    margin-left: 0;
    margin-right: 40px;
    background: transparent;
  }
  .jstree-default-responsive.jstree-rtl .jstree-container-ul > .jstree-node {
    margin-right: 0;
  }
  .jstree-default-responsive .jstree-ocl,
  .jstree-default-responsive .jstree-themeicon,
  .jstree-default-responsive .jstree-checkbox {
    background-size: 120px 240px !important;
  }
  .jstree-default-responsive .jstree-leaf > .jstree-ocl,
  .jstree-default-responsive.jstree-rtl .jstree-leaf > .jstree-ocl {
    background: transparent;
  }
  .jstree-default-responsive .jstree-open > .jstree-ocl {
    background-position: 0 0 !important;
  }
  .jstree-default-responsive .jstree-closed > .jstree-ocl {
    background-position: 0 -40px !important;
  }
  .jstree-default-responsive.jstree-rtl .jstree-closed > .jstree-ocl {
    background-position: -40px 0 !important;
  }
  .jstree-default-responsive .jstree-themeicon {
    background-position: -40px -40px;
  }
  .jstree-default-responsive .jstree-checkbox,
  .jstree-default-responsive .jstree-checkbox:hover {
    background-position: -40px -80px;
  }
  .jstree-default-responsive.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox,
  .jstree-default-responsive.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox:hover,
  .jstree-default-responsive .jstree-checked > .jstree-checkbox,
  .jstree-default-responsive .jstree-checked > .jstree-checkbox:hover {
    background-position: 0 -80px;
  }
  .jstree-default-responsive .jstree-anchor > .jstree-undetermined,
  .jstree-default-responsive .jstree-anchor > .jstree-undetermined:hover {
    background-position: 0 -120px;
  }
  .dark-mode .jstree-default-responsive .jstree-ocl,
  .dark-mode .jstree-default-responsive .jstree-themeicon,
  .dark-mode .jstree-default-responsive .jstree-checkbox {
    background-size: 120px 240px;
  }
  .dark-mode .jstree-default-responsive .jstree-leaf > .jstree-ocl,
  .dark-mode .jstree-default-responsive.jstree-rtl .jstree-leaf > .jstree-ocl {
    background: transparent;
  }
  .dark-mode .jstree-default-responsive .jstree-open > .jstree-ocl {
    background-position: 0 0 !important;
  }
  .dark-mode .jstree-default-responsive .jstree-closed > .jstree-ocl {
    background-position: 0 -40px !important;
  }
  .dark-mode .jstree-default-responsive.jstree-rtl .jstree-closed > .jstree-ocl {
    background-position: -40px 0 !important;
  }
  .dark-mode .jstree-default-responsive .jstree-themeicon {
    background-position: -40px -40px;
  }
  .dark-mode .jstree-default-responsive .jstree-checkbox,
  .dark-mode .jstree-default-responsive .jstree-checkbox:hover {
    background-position: -40px -80px;
  }
  .dark-mode .jstree-default-responsive.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox,
  .dark-mode .jstree-default-responsive.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox:hover,
  .dark-mode .jstree-default-responsive .jstree-checked > .jstree-checkbox,
  .dark-mode .jstree-default-responsive .jstree-checked > .jstree-checkbox:hover {
    background-position: 0 -80px;
  }
  .dark-mode .jstree-default-responsive .jstree-anchor > .jstree-undetermined,
  .dark-mode .jstree-default-responsive .jstree-anchor > .jstree-undetermined:hover {
    background-position: 0 -120px;
  }
  .jstree-default-responsive .jstree-anchor {
    font-weight: bold;
    font-size: 1.1em;
    text-shadow: 1px 1px white;
  }
  .jstree-default-responsive > .jstree-striped {
    background: transparent !important;
  }
  .jstree-default-responsive .jstree-wholerow {
    border-top: 1px solid rgba(255, 255, 255, 0.7) !important;
    border-bottom: 1px solid rgba(64, 64, 64, 0.2) !important;
    background: #ebebeb !important;
    height: 40px !important;
  }
  .jstree-default-responsive .jstree-wholerow-hovered {
    background: transparent !important;
  }
  .jstree-default-responsive .jstree-wholerow-clicked, .jstree-default-responsive .jstree-wholerow-clicked:hover {
    background: #beebff !important;
  }
  .jstree-default-responsive .jstree-children .jstree-last > .jstree-wholerow {
    box-shadow: inset 0 -6px 3px -5px #666666 !important;
  }
  .jstree-default-responsive .jstree-children .jstree-open > .jstree-wholerow {
    box-shadow: inset 0 6px 3px -5px #666666 !important;
    border-top: 0;
  }
  .jstree-default-responsive .jstree-children .jstree-open + .jstree-open {
    box-shadow: none;
  }
  .jstree-default-responsive .jstree-node,
  .jstree-default-responsive .jstree-icon,
  .jstree-default-responsive .jstree-node > .jstree-ocl,
  .jstree-default-responsive .jstree-themeicon,
  .jstree-default-responsive .jstree-checkbox {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_73___}) !important;
    background-size: 120px 240px !important;
  }
  .jstree-default-responsive .jstree-node {
    background-position: -80px 0;
    background-repeat: repeat-y;
  }
  .jstree-default-responsive .jstree-last {
    background: transparent;
  }
  .jstree-default-responsive .jstree-leaf > .jstree-ocl {
    background-position: -40px -120px;
  }
  .jstree-default-responsive .jstree-last > .jstree-ocl {
    background-position: -40px -160px;
  }
  .jstree-default-responsive .jstree-themeicon-custom {
    background-color: transparent;
    background-image: none;
    background-position: 0 0;
  }
  .jstree-default-responsive .jstree-file {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_73___}) 0 -160px no-repeat !important;
    background-size: 120px 240px !important;
  }
  .jstree-default-responsive .jstree-folder {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_73___}) -40px -40px no-repeat !important;
    background-size: 120px 240px !important;
  }
  .dark-mode .jstree-default-responsive .jstree-node,
  .dark-mode .jstree-default-responsive .jstree-icon,
  .dark-mode .jstree-default-responsive .jstree-node > .jstree-ocl,
  .dark-mode .jstree-default-responsive .jstree-themeicon,
  .dark-mode .jstree-default-responsive .jstree-checkbox {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_74___});
    background-size: 120px 240px;
  }
  .dark-mode .jstree-default-responsive .jstree-node {
    background-position: -80px 0;
    background-repeat: repeat-y;
  }
  .dark-mode .jstree-default-responsive .jstree-last {
    background: transparent;
  }
  .dark-mode .jstree-default-responsive .jstree-leaf > .jstree-ocl {
    background-position: -40px -120px;
  }
  .dark-mode .jstree-default-responsive .jstree-last > .jstree-ocl {
    background-position: -40px -160px;
  }
  .dark-mode .jstree-default-responsive .jstree-themeicon-custom {
    background-color: transparent;
    background-image: none;
    background-position: 0 0;
  }
  .dark-mode .jstree-default-responsive .jstree-file {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_74___}) 0 -160px no-repeat;
    background-size: 120px 240px;
  }
  .dark-mode .jstree-default-responsive .jstree-folder {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_74___}) -40px -40px no-repeat;
    background-size: 120px 240px;
  }
  .jstree-default-responsive > .jstree-container-ul > .jstree-node {
    margin-left: 0;
    margin-right: 0;
  }
}
.nk-kanban {
  overflow: auto;
  padding-bottom: 1rem;
}

.kanban-container {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: auto;
}

.kanban-container * {
  box-sizing: border-box;
}

.kanban-board {
  display: flex;
  flex-direction: column;
  padding: 14px;
  position: relative;
  transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  flex-shrink: 0;
  width: 100%;
}

.kanban-board.disabled-board {
  opacity: 0.3;
}

.kanban-board.is-moving.gu-mirror {
  transform: rotate(3deg);
}

.kanban-board.is-moving.gu-mirror .kanban-drag {
  overflow: hidden;
  padding-right: 50px;
}

.kanban-board-header {
  background: #fff;
  border: 1px solid #e5e9f2;
  border-top: 3px solid #dbdfea;
  border-radius: 4px;
  padding: 0.5rem 1.25rem;
  margin-bottom: 1rem;
}

.kanban-primary {
  border-top-color: #4461F2;
}

.kanban-success {
  border-top-color: #1ee0ac;
}

.kanban-info {
  border-top-color: #09c2de;
}

.kanban-warning {
  border-top-color: #f4bd0e;
}

.kanban-danger {
  border-top-color: #e85347;
}

.kanban-dark {
  border-top-color: #1f2b3a;
}

.kanban-title-content {
  display: flex;
  align-items: center;
}
.kanban-title-content .title {
  font-size: 0.9375rem;
  margin-bottom: 0;
  margin-right: 0.75rem;
  color: #526484;
}

.kanban-title-board {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.kanban-board header .kanban-title-button {
  float: right;
}

.kanban-drag {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  flex-wrap: wrap;
}

.kanban-board .kanban-drag {
  min-height: 100px;
  margin-bottom: 1rem;
}
.kanban-board .kanban-drag:empty {
  border-radius: 4px;
  border: 1px dashed #e5e9f2;
}

.kanban-board:after {
  clear: both;
  display: block;
  content: "";
}

.kanban-item {
  border-radius: 4px;
  border: 1px solid #e5e9f2;
  padding: 1rem 1.25rem;
  margin-bottom: 0.75rem;
  background: #fff;
  width: 350px;
  transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
}
.kanban-item-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.kanban-item-title + .kanban-item-text {
  margin-top: 0.5rem;
}
.kanban-item-title .title {
  font-size: 0.9375rem;
  margin-bottom: 0;
  margin-right: 0.75rem;
}
.kanban-item-tags {
  display: flex;
  padding-top: 0.5rem;
  margin: -0.125rem;
}
.kanban-item-tags li {
  padding: 0.125rem;
}
.kanban-item-meta {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding-top: 0.5rem;
}
.kanban-item-meta-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 0 -0.25rem;
}
.kanban-item-meta-list:last-child {
  flex-wrap: nowrap;
}
.kanban-item-meta-list:first-child {
  padding-right: 1rem;
}
.kanban-item-meta-list li {
  font-size: 0.8125rem;
  padding: 0 0.25rem;
  color: #8094ae;
}
.kanban-item-meta-list li span {
  white-space: nowrap;
}
.kanban-item-meta-list li .icon + span {
  margin-left: 0.25rem;
}

.kanban-item:last-child {
  margin: 0;
}

.kanban-item.is-moving.gu-mirror {
  transform: rotate(3deg);
  height: auto !important;
}

/* Dragula CSS  */
.gu-mirror {
  position: fixed !important;
  margin: 0 !important;
  z-index: 9999 !important;
}

.gu-hide {
  display: none !important;
}

.gu-unselectable {
  -webkit-user-select: none !important;
  user-select: none !important;
}

.gu-transit {
  opacity: 0.2 !important;
  transform: rotate(0deg) !important;
}

.drag_handler {
  background: #fff;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  position: relative;
  top: -3px;
  float: left;
  margin-right: 4px;
}

.drag_handler:hover {
  cursor: move;
}

.drag_handler_icon {
  position: relative;
  display: block;
  background: #000;
  width: 24px;
  height: 2px;
  top: 12px;
  transition: 0.5s ease-in-out;
}

.drag_handler_icon:before,
.drag_handler_icon:after {
  background: #000;
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  transition: 0.5s ease-in-out;
}

.drag_handler_icon:before {
  top: 6px;
}

.drag_handler_icon:after {
  bottom: 6px;
}

.kanban-add-task {
  color: #4461F2;
  background: #fff;
  border: 1px dashed #e5e9f2;
  padding-top: 0.675rem;
  padding-bottom: 0.675rem;
}
.kanban-add-task:hover {
  color: #fff;
  background: #4461F2;
  border: 1px solid #4461F2;
}
.kanban-add-task:focus {
  outline: none;
  box-shadow: none;
}

/** 03. LAYOUTS */
body {
  min-width: 320px;
}
body.nav-shown {
  overflow: hidden;
}

.nk-body {
  outline: none;
}
.nk-app-root {
  outline: none;
}
.nk-main {
  position: relative;
}
.nk-wrap {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.nk-content {
  padding: 24px 4px;
}
.nk-content-fs {
  min-height: calc(100vh - (74px + 74px));
  display: flex;
  align-items: center;
}

@media (min-width: 576px) {
  .nk-content {
    padding: 32px 22px;
  }
  .nk-content-fluid {
    padding-left: 22px;
    padding-right: 22px;
  }
}
@media (min-width: 992px) {
  .nk-content-lg {
    padding-top: 36px;
    padding-bottom: 36px;
  }
  .nk-content-fluid {
    padding-left: 24px;
    padding-right: 24px;
  }
}
@media (min-width: 1660px) {
  .nk-content-lg {
    padding-top: 54px;
    padding-bottom: 54px;
  }
  .nk-content-fluid {
    padding-left: 44px;
    padding-right: 44px;
  }
}
.nk-content-body {
  flex-grow: 1;
}

.nk-wrap-nosidebar .nk-content {
  padding: 0 !important;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.logo-link {
  position: relative;
  display: inline-block;
  align-items: center;
}
.logo-dark {
  opacity: 1;
}
.tc-light .logo-dark, .is-dark .logo-dark, .is-theme .logo-dark {
  opacity: 0;
}
.logo-light {
  opacity: 0;
}
.tc-light .logo-light, .is-dark .logo-light, .is-theme .logo-light {
  opacity: 1;
}
.logo-img {
  max-height: 45px;
}
.logo-img-lg {
  max-height: 60px;
}
.logo-img-sm {
  max-height: 28px;
}
.logo-img-icon {
  max-height: 33px;
}
.logo-img:not(:first-child) {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

.nk-header {
  background: #f5f6fa;
  border-bottom: 1px solid #e5e9f2;
  padding: 0 6px;
  box-shadow: 0px 1px 3px 0px rgba(54, 74, 99, 0.05);
  z-index: 1010;
}
.nk-header.is-dark:not([class*=bg-]) {
  background: #101924;
  border-color: #203247;
}
.nk-header.is-light:not([class*=bg-]) {
  background: #fff;
}
.nk-header.is-theme:not([class*=bg-]) {
  background: #36206a;
  border-color: #4a2b91;
}
.nk-header-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  min-width: 320px;
}
.nk-header-fixed + .nk-content {
  position: relative;
}
.nk-header-wrap {
  position: relative;
  display: flex;
  align-items: center;
  margin: 0 -0.25rem;
}
.nk-header-wrap > * {
  padding: 0 0.25rem;
}
.nk-header-right {
  align-items: center;
  justify-content: flex-end;
}
.nk-header-center {
  justify-content: center;
}
.nk-header-tools {
  margin-left: auto;
  padding-top: 14px;
  padding-bottom: 14px;
}
.nk-header-brand {
  flex-shrink: 0;
  padding-top: 14px;
  padding-bottom: 14px;
}
.nk-header .dropdown-menu .lead-text {
  color: #364a63;
}
.nk-header .dropdown-menu .sub-text, .nk-header .dropdown-menu .overline-title, .nk-header .dropdown-menu .overline-title-alt {
  color: #8094ae;
}
.nk-header-search {
  display: none;
}
.nk-header-search .form-control, .nk-header-search div.dataTables_wrapper div.dataTables_filter input, div.dataTables_wrapper div.dataTables_filter .nk-header-search input, .nk-header-search .dual-listbox .dual-listbox__search, .dual-listbox .nk-header-search .dual-listbox__search, .nk-header-search .rdl-filter {
  background-color: transparent;
  border: none;
}
.is-dark .nk-header-search .icon {
  color: #fff;
}
.is-theme .nk-header-search .icon {
  color: #fff;
}
.nk-quick-nav {
  display: flex;
  align-items: center;
  margin: 0 -6px;
}
.nk-quick-nav > li {
  padding: 0 6px;
}
.nk-quick-nav > li.user-dropdown > a {
  padding: 0 2px;
}
.nk-quick-nav-icon {
  display: inline-flex;
  position: relative;
  font-size: 1.5rem;
  z-index: 1;
  color: #526484;
  padding: 0.375rem;
}
.is-dark .nk-quick-nav-icon {
  color: #9faec2;
}
.is-theme .nk-quick-nav-icon {
  color: #d4c2ff;
}
.is-theme .nk-quick-nav-icon.nk-nav-toggle {
  color: #fff;
}
.nk-quick-nav-icon:focus {
  box-shadow: none;
}
.nk-quick-nav-icon:before {
  position: absolute;
  z-index: -1;
  height: 20px;
  width: 20px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transform-origin: 50% 50%;
  content: "";
  background-color: #e5e9f2;
  border-radius: 50%;
  opacity: 0;
  transition: all 0.3s;
}
.is-dark .nk-quick-nav-icon:before {
  background-color: #0b1219;
}
.is-theme .nk-quick-nav-icon:before {
  background-color: #26164b;
}
.show > .nk-quick-nav-icon:before {
  opacity: 1;
  height: 116%;
  width: 116%;
}
.nk-quick-nav-icon:hover:before, .nk-quick-nav-icon.active:before {
  opacity: 1;
  height: 116%;
  width: 116%;
}

@media (max-width: 359px) {
  .nk-quick-nav {
    margin: 0 -3px;
  }
  .nk-quick-nav > li {
    padding: 0 3px;
  }
  .hide-mb-xs {
    display: none;
  }
}
@media (max-width: 575px) {
  .hide-mb-sm {
    display: none;
  }
}
@media (min-width: 576px) {
  .nk-header {
    padding: 0 22px;
  }
  .nk-header-search {
    display: flex;
    align-items: center;
    flex-grow: 1;
  }
  .nk-quick-nav {
    margin: 0 -10px;
  }
  .nk-quick-nav > li {
    padding: 0 10px;
  }
}
@media (min-width: 992px) {
  .nk-header-fluid {
    padding-left: 24px;
    padding-right: 24px;
  }
}
@media (min-width: 1660px) {
  .nk-header-fluid {
    padding-left: 44px;
    padding-right: 44px;
  }
}
.nk-header-menu {
  position: fixed;
  left: 0;
  transform: translateX(-100%);
  top: 0;
  width: 280px;
  height: 100vh;
  max-height: 100vh;
  z-index: 999;
  background: #fff;
}
.nk-header-menu-inner {
  overflow: auto;
  max-height: 100%;
  min-height: 100%;
}
.nk-header-menu.mobile-menu {
  padding-top: 65px;
  padding-left: 0;
  padding-right: 0;
  transition: transform 0.4s ease;
}
.nk-header-menu.nk-sidebar-active {
  transform: translateX(0);
}
.nk-header-mobile {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 28px;
  border-bottom: 1px solid #e5e9f2;
}
.nk-header-mobile .logo-dark {
  opacity: 1;
}
.nk-header-mobile .logo-light {
  opacity: 0;
}
.nk-header-mobile .nk-nav-toggle.nk-quick-nav-icon {
  color: #526484;
}
.nk-header-mobile .nk-nav-toggle.nk-quick-nav-icon:before {
  background-color: #e5e9f2;
}

@media (min-width: 992px) {
  .nk-header-menu {
    position: static;
    background: transparent;
    height: auto;
    max-height: auto;
    border-right: none;
    width: auto;
    padding: 0;
    overflow: visible;
    transform: translateX(0) !important;
  }
  .nk-header-menu .nk-header-mobile {
    display: none;
  }
}
.nk-header-app-name {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.nk-header-app-logo {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  margin-right: 0.75rem;
}
.nk-header-app-logo .icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 20px;
  color: #4461F2;
  background: rgba(68, 97, 242, 0.3);
}
.nk-header-app-info {
  line-height: 1.3;
}
.nk-header-app-info .sub-text {
  font-size: 11px;
  margin-bottom: 0.125rem;
}
.nk-header-app-info .lead-text {
  font-size: 14px;
}
.nk-header-app-switch {
  position: relative;
}
.nk-header-app-switch .nk-header-app-name {
  padding: 1.5rem 24px;
}
.nk-header-app-switch > a {
  display: block;
  width: 100%;
}
.nk-header-app-switch > a:after {
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1rem;
  content: "\\e9c5";
  font-family: "Nioicon";
}
.mobile-menu .nk-header-app-switch {
  width: 100%;
  border-bottom: 1px solid #e5e9f2;
}
.nk-header-app-switch .toggle-content {
  width: 100%;
  top: 0;
  transform: translateY(0);
  height: calc(100vh - 65px);
  overflow: auto;
  box-shadow: none;
  border-radius: 0;
  background: #fff;
}
.nk-header-app-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 24px;
}
.nk-header-app-head .title {
  font-size: 16px;
  font-weight: 500;
}
.nk-header-app-head .toggle {
  position: relative;
  height: 24px;
  width: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.nk-header-app-list li {
  border-bottom: 1px solid #e5e9f2;
}
.nk-header-app-list .nk-header-app-name {
  padding: 1rem 24px;
}

@media (max-height: 615px) {
  .nk-header-app-switch .dropdown-menu {
    max-height: 416px;
    overflow: auto;
  }
}
@media (min-width: 768px) {
  .nk-header-onlymobile {
    display: none;
  }
  .nk-header-onlymobile + .nk-content {
    margin-top: 0;
  }
}
.nk-sidebar {
  position: absolute;
  background: #f5f6fa;
  height: 100%;
  min-height: 100vh;
  top: 0;
  left: 0;
  transform: translateX(-100%);
  border-right: 1px solid #e5e9f2;
  z-index: 1021;
  width: 260px;
  transition: transform 450ms ease, width 450ms ease;
  box-shadow: 0px 1px 3px 0px rgba(54, 74, 99, 0.05);
}
.nk-sidebar + .nk-wrap {
  transition: padding 450ms ease;
}
.nk-sidebar + .nk-wrap > .nk-header-fixed {
  transition: left 450ms ease;
}
.nk-sidebar.is-light {
  background: #fff;
  border-right-color: #ebeef2;
}
.nk-sidebar.is-dark {
  background: #101924;
  border-right-color: #203247;
}
.nk-sidebar.is-theme {
  background: #36206a;
  border-right-color: #4a2b91;
}
.nk-sidebar-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(16, 25, 36, 0.4);
  z-index: 900;
  animation: overlay-fade-in 0.4s ease 1;
}
.nk-sidebar-element {
  overflow: hidden;
  width: 100%;
  max-height: 100%;
}
.nk-sidebar.nk-sidebar-active {
  transform: translateX(0);
}
.nk-sidebar-fixed {
  position: fixed;
  max-height: 100vh;
}
.nk-sidebar-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px;
  min-width: 100%;
  width: 260px;
  height: 74px;
}
.nk-sidebar-brand {
  position: relative;
  flex-shrink: 0;
}
.nk-sidebar-logo {
  transition: opacity 0.3s ease;
}
.nk-sidebar-logo .logo-img:not(:first-child) {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.nk-sidebar-footer {
  background-color: #f5f6fa;
  margin-top: auto;
  padding: 1.75rem 24px 1.75rem;
}
.is-light .nk-sidebar-footer {
  background: #fff;
}
.is-dark .nk-sidebar-footer {
  background-color: #101924;
}
.is-theme .nk-sidebar-footer {
  background-color: #36206a;
}
.nk-sidebar-body {
  position: relative;
}
.nk-sidebar-body .simplebar-content {
  padding-bottom: 0.25rem !important;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
.nk-sidebar-body .simplebar-scroll-content {
  min-height: 100%;
  width: 100%;
}
.nk-sidebar-content {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 74px);
}
.nk-sidebar-content .nk-sidebar-menu {
  padding-top: 1.5rem;
  padding-bottom: 3rem;
}
.nk-sidebar-content .nk-sidebar-menu[data-simplebar] {
  height: 100%;
}
.nk-sidebar-content[data-simplebar] > div {
  width: 100%;
}
.nk-sidebar.is-theme .user-balance-alt, .nk-sidebar.is-dark .user-balance-alt {
  color: #d4c2ff;
}
.nk-sidebar-profile {
  margin-top: auto;
  width: 100%;
}
.nk-sidebar-profile .user-avatar {
  height: 36px !important;
  width: 36px !important;
}
.nk-sidebar-profile .dropdown-toggle {
  width: 100%;
  padding: 14px 24px;
}
.nk-sidebar-profile .dropdown-toggle:after {
  margin-left: auto;
  font-size: 1.125rem;
  color: #8094ae;
}
.nk-sidebar-profile .dropdown-menu {
  width: calc(260px - 48px);
}

@keyframes overlay-fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@media (max-width: 991.98px) {
  .nk-sidebar-mobile {
    width: 260px !important;
  }
}
@media (min-width: 1200px) {
  .nk-sidebar-content .nk-sidebar-menu {
    padding-top: 1rem;
    padding-bottom: 2.5rem;
  }
  .nk-sidebar {
    overflow: hidden;
    transform: translateX(0);
    width: 260px;
  }
  .nk-sidebar + .nk-wrap, .nk-sidebar-overlay + .nk-wrap {
    padding-left: 260px;
  }
  .nk-sidebar + .nk-wrap > .nk-header-fixed, .nk-sidebar-overlay + .nk-wrap > .nk-header-fixed {
    left: 260px;
  }
  .nk-sidebar.is-compact:not(:hover) {
    width: 74px;
  }
  .nk-sidebar.is-compact:not(:hover) .logo-img {
    opacity: 0;
    transition: opacity 0.2s linear;
  }
  .nk-sidebar.is-compact:not(:hover) .logo-img-small {
    opacity: 1;
    left: -3px;
  }
  .nk-sidebar.is-compact:not(:hover) .user-card {
    position: relative;
    left: -5px;
  }
  .nk-sidebar.is-compact:not(:hover) .user-info {
    opacity: 0;
  }
  .nk-sidebar.is-compact:not(:hover) .nk-sidebar-profile .dropdown-menu {
    opacity: 0;
  }
  .nk-sidebar.is-compact + .nk-wrap {
    padding-left: 74px;
  }
  .nk-sidebar.is-compact + .nk-wrap > .nk-header-fixed {
    left: 74px;
  }
  .nk-sidebar-overlay {
    display: none;
  }
}
@media (min-width: 1200px) {
  .nk-sidebar {
    transform: translateX(0);
  }
}
.nk-profile {
  padding: 4px 12px;
}
.nk-profile-item {
  padding: 0.625rem 28px 0.625rem 12px;
}

.nk-menu li a {
  vertical-align: middle;
  display: flex;
  position: relative;
  align-items: center;
  transition: color 0.3s, background-color 0.3s;
}
.nk-menu-item {
  padding: 4px 12px;
}
.nk-menu-sub .nk-menu-item {
  padding: 1px 0;
}
.nk-menu-item.has-sub {
  position: relative;
}
.nk-menu > .nk-menu-item.menu-without-icon > .nk-menu-sub .nk-menu-link {
  padding-left: 0;
}
.nk-menu-link {
  padding: 0.625rem 28px 0.625rem 12px;
  color: #6e82a5;
  font-family: "DM Sans", sans-serif;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.01em;
  text-transform: none;
  line-height: 1.25rem;
  border-radius: 6px;
}
.nk-menu-link:hover {
  color: #6e82a5;
  background: #ebeef2;
}
.is-light .nk-menu-link:hover {
  color: #6e82a5;
  background: #ebeef2;
}
.is-dark .nk-menu-link:hover {
  background: #182536;
}
.is-theme .nk-menu-link:hover {
  background: #422782;
}
.nk-menu-link:hover .count {
  color: #6e82a5;
}
.active > .nk-menu-link {
  color: #fff;
  background: #4461F2;
}
.is-light .active > .nk-menu-link {
  color: #fff !important;
  background: #4461F2;
}
.is-dark .active > .nk-menu-link {
  background: #182536;
}
.is-theme .active > .nk-menu-link {
  background: #422782;
}
.active > .nk-menu-link .count {
  color: #fff;
}
.nk-menu-sub .nk-menu-link {
  padding: 0.375rem 40px 0.375rem 36px;
  font-family: "DM Sans", sans-serif;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: normal;
  text-transform: none;
  line-height: 1.25rem;
  color: #6e82a5;
}
.nk-menu-link.is-disable {
  cursor: default;
}
.nk-menu-link.is-disable:hover, .active > .nk-menu-link.is-disable {
  color: #6e82a5;
}
.nk-menu-link.is-disable:hover .count, .active > .nk-menu-link.is-disable .count {
  color: #6e82a5;
}
.is-light .nk-menu-link {
  color: #526484;
}
.is-theme .nk-menu-link {
  color: #b799ff;
}
.is-light .nk-menu-link:hover, .is-light .active > .nk-menu-link {
  color: #5c75f4;
}
.is-theme .nk-menu-link:hover, .is-theme .active > .nk-menu-link {
  color: #fff;
}
.nk-menu-link span.small {
  color: #8094ae;
  margin-left: 0.5rem;
}
.nk-menu-icon {
  font-weight: normal;
  letter-spacing: normal;
  width: 36px;
  line-height: 1;
  flex-grow: 0;
  flex-shrink: 0;
  color: #8094ae;
}
.is-theme .nk-menu-icon {
  color: #b799ff;
}
.nk-menu-icon svg,
.nk-menu-icon img {
  width: 36px;
}
.nk-menu-icon .icon {
  font-size: 24px;
  letter-spacing: normal;
  vertical-align: middle;
  color: currentColor;
  transition: color 0.4s, background-color 0.4s;
}
.nk-menu-icon .nk-menu-link:hover {
  color: #4461F2 !important;
}
.is-theme .nk-menu-icon .nk-menu-link:hover {
  color: #fff;
}
.nk-menu-item.active > .nk-menu-link .nk-menu-icon, .nk-menu-item.current-menu > .nk-menu-link .nk-menu-icon {
  color: #fff !important;
}
.is-theme .nk-menu-item.active > .nk-menu-link .nk-menu-icon, .is-theme .nk-menu-item.current-menu > .nk-menu-link .nk-menu-icon {
  color: #fff;
}
.nk-menu-link.is-disable:hover .nk-menu-icon {
  color: #8094ae;
}
.is-theme .nk-menu-link.is-disable:hover .nk-menu-icon {
  color: #d4c2ff;
}
.nk-menu-text {
  flex-grow: 1;
  display: inline-block;
}
.nk-menu-badge {
  border-radius: 3px;
  padding: 0 0.4rem;
  font-size: 11px;
  color: #9d72ff;
  background: #f0eaff;
  position: absolute;
  top: 50%;
  right: 24px;
  transform: translateY(-50%);
}
.has-sub .nk-menu-badge {
  right: 48px;
}
.is-dark .nk-menu-badge {
  color: #b695ff;
  background: #203247;
}
.is-theme .nk-menu-badge {
  color: #d4c2ff;
  background: #4e2e99;
}
.nk-menu-main .nk-menu-sub .nk-menu-badge {
  color: #9d72ff;
  background: #f0eaff;
}
.nk-menu-divider {
  margin: 4px 12px;
  border-bottom: 1px solid #dbdfea !important;
}
.nk-menu-heading {
  padding: 0.25rem 24px 0.5rem;
  color: #8094ae;
}
.is-theme .nk-menu-heading {
  color: #9e76ff;
}
.nk-menu-item + .nk-menu-heading {
  padding-top: 2.5rem;
}
.nk-menu-heading .overline-title {
  color: inherit;
  white-space: nowrap;
}
.nk-menu-heading span {
  font-size: 13px;
  font-weight: 400;
}
.nk-menu-hr {
  margin: 1.25rem 0;
  border-bottom: 1px solid #dbdfea;
}
.is-dark .nk-menu-hr {
  border-color: rgba(255, 255, 255, 0.12);
}
.is-theme .nk-menu-hr {
  border-color: rgba(255, 255, 255, 0.12);
}
.nk-menu-hr + .nk-menu-heading {
  padding-top: 1rem;
}
.nk-menu-toggle + .nk-menu-wrap {
  height: 0;
  overflow: hidden;
  transition: height 0.4s ease;
}
.nk-menu-sub {
  padding-bottom: 0.25rem;
}
.nk-menu-toggle + .nk-menu-sub {
  display: none;
}
.active > .nk-menu-sub {
  display: block;
}
.nk-menu-sub .nk-menu-link {
  padding-left: 48px;
}
.nk-menu-sub .nk-menu-link:hover {
  color: #4461F2;
}
.is-theme .nk-menu-sub .nk-menu-link:hover {
  color: #fff;
}
.nk-menu-sub .nk-menu-link:hover, .active > .nk-menu-sub .nk-menu-link {
  background-color: transparent;
}
.nk-menu-sub .nk-menu-sub {
  margin-left: 48px;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  padding-bottom: 0;
}
.nk-menu-sub .nk-menu-sub .nk-menu-link {
  padding-left: 0.5rem;
}
.nk-menu-sub .active > .nk-menu-link {
  color: #4461F2;
}
.is-theme .nk-menu-sub .active > .nk-menu-link {
  color: #fff;
}
.nk-menu-sub .active > .nk-menu-link:hover {
  background-color: #4461F2;
}
.nk-menu-sub .nk-menu-icon {
  width: 24px;
  margin-top: -1px;
}
.nk-menu-sub .nk-menu-icon .icon {
  margin-top: -1px;
  font-size: 1.2em;
}
.nk-menu-toggle {
  position: relative;
}
.nk-menu-toggle:after {
  position: absolute;
  font-family: "Nioicon";
  top: 50%;
  content: "\\e9d3";
  right: 1.25rem;
  transform: translateY(-50%);
  font-size: 1rem;
  color: #8094ae;
  transition: transform 0.3s, color 0.1s, opacity 0.3s ease 0.3s;
}
.is-dark .nk-menu-toggle:after, .is-theme .nk-menu-toggle:after {
  color: rgba(255, 255, 255, 0.4);
}
.has-sub.active > .nk-menu-toggle {
  background-color: transparent !important;
  color: #526484 !important;
}
.has-sub.active > .nk-menu-toggle:after {
  transform: translateY(-50%) rotate(90deg);
}
.nk-menu-toggle .icon {
  font-size: 24px;
  letter-spacing: normal;
  vertical-align: middle;
  color: #526484;
  transition: color 0.4s, background-color 0.4s;
}
.nk-menu .count {
  display: inline-block;
  font-size: 0.85em;
  margin-left: 0.25rem;
  color: #8094ae;
  line-height: 1;
}
.nk-menu-icon-colored .nk-menu-icon {
  color: #4461F2;
}

@media (min-width: 1200px) {
  .is-compact:not(:hover) .nk-menu-text {
    opacity: 0;
    transition: 0.4s linear;
  }
  .is-compact:not(:hover) .nk-menu-badge, .is-compact:not(:hover) .nk-menu-toggle:after {
    transition: none;
    opacity: 0;
    pointer-events: none;
  }
  .is-compact:not(:hover) .nk-menu-sub {
    display: none !important;
  }
  .is-compact:not(:hover) .nk-menu-wrap {
    height: 0 !important;
  }
  .is-compact:not(:hover) .nk-menu-heading {
    position: relative;
  }
  .is-compact:not(:hover) .nk-menu-heading .overline-title {
    opacity: 0;
  }
  .is-compact:not(:hover) .nk-menu-heading:not(:first-child):before {
    position: absolute;
    content: "";
    height: 1px;
    width: 100%;
    left: 0;
    top: 50%;
    background-color: #e5e9f2;
  }
  .is-compact.is-theme:not(:hover) .nk-menu-heading:not(:first-child):before {
    background-color: #4a2b91;
  }
  .is-compact.is-dark:not(:hover) .nk-menu-heading:not(:first-child):before {
    background-color: #203247;
  }
  .is-compact .nk-menu-badge {
    transition: opacity 0.3s ease 0.3s;
  }
  .is-compact .nk-menu-text {
    white-space: nowrap;
  }
}
.nk-menu-footer {
  display: flex;
}
.nk-menu-footer .nk-menu-link {
  padding-left: 0;
  padding-right: 0;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  color: #8094ae;
  font-family: "DM Sans", sans-serif;
  font-weight: 500;
}
.nk-menu-footer .nk-menu-link:hover {
  color: #5c75f4;
}
.is-theme .nk-menu-footer .nk-menu-link {
  color: #d4c2ff;
}
.nk-menu-footer .nk-menu-icon {
  width: 1.375rem;
  color: #4461F2;
}
.nk-menu-footer .nk-menu-icon .icon {
  font-size: 1rem;
}
.nk-menu-footer .nk-menu-text {
  font-size: 12px;
  line-height: 1.125rem;
}

.nk-sidebar .nk-menu > li .nk-menu-sub .nk-menu-link {
  padding-left: 1.5rem;
}
.nk-sidebar .nk-menu > li .nk-menu-sub .nk-menu-sub {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  padding-bottom: 0;
  margin-left: 48px;
  border-left: 1px solid #dbdfea;
}
.nk-sidebar .nk-menu > li .nk-menu-sub .nk-menu-sub .nk-menu-link {
  padding-left: 0.5rem;
}
.nk-sidebar.is-dark .nk-menu > li .nk-menu-sub .nk-menu-sub, .nk-sidebar.is-theme .nk-menu > li .nk-menu-sub .nk-menu-sub {
  border-color: rgba(255, 255, 255, 0.12);
}

.nk-footer {
  margin-top: auto;
  background: #fff;
  border-top: 1px solid #e5e9f2;
  padding: 20px 6px;
  box-shadow: 0px 1px 3px 0px rgba(54, 74, 99, 0.05);
}
.nk-footer.is-dark:not([class*=bg-]) {
  background: #38216e;
}
.nk-footer-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.nk-footer-copyright {
  color: #8094ae;
}
.nk-footer-copyright a {
  color: inherit;
}
.nk-footer-copyright a:hover {
  color: #4461F2;
}

@media (min-width: 576px) {
  .nk-footer {
    padding: 20px 22px;
  }
}
@media (min-width: 992px) {
  .nk-footer-fluid {
    padding-left: 24px;
    padding-right: 24px;
  }
}
@media (min-width: 1660px) {
  .nk-footer-fluid {
    padding-left: 44px;
    padding-right: 44px;
  }
}
.nk-split {
  position: relative;
  display: flex;
}
.nk-split-page {
  min-height: 100vh;
}
.nk-split-content {
  position: relative;
  flex-shrink: 0;
  width: 100%;
  min-height: 100%;
}
@media (min-width: 768px) {
  .nk-split-content-md {
    width: 642px;
  }
}
.nk-split-stretch {
  flex-grow: 1;
  flex-shrink: 1;
}

@media (max-width: 991.98px) {
  .nk-split-stretch.toggle-break-lg {
    width: 460px;
  }
}
@media (max-width: 575.98px) {
  .nk-split-sm {
    flex-wrap: wrap;
  }
}
@media (max-width: 767.98px) {
  .nk-split-md {
    flex-wrap: wrap;
  }
}
@media (max-width: 991.98px) {
  .nk-split-lg {
    flex-wrap: wrap;
  }
}
@media (max-width: 1199.98px) {
  .nk-split-xl {
    flex-wrap: wrap;
  }
}
@media (max-width: 1539.98px) {
  .nk-split-xxl {
    flex-wrap: wrap;
  }
}

/** 04. UTILITES */
canvas {
  width: 100%;
  max-width: 100%;
}

a:hover {
  text-decoration: none;
}

p:last-child {
  margin-bottom: 0;
}

.del {
  text-decoration: line-through;
}

span[data-toggle=tooltip]:focus {
  outline: none;
}

.g-0 {
  margin: 0 !important;
}
.g-0 > li, .g-0 > div {
  padding: 0 !important;
}

.gx-0 {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.gx-0 > li, .gx-0 > div {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.gy-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.gy-0 > li, .gy-0 > div {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.g-1 {
  margin: -0.1875rem !important;
}
.g-1 > li, .g-1 > div {
  padding: 0.1875rem !important;
}

.gx-1 {
  margin-left: -0.1875rem !important;
  margin-right: -0.1875rem !important;
}
.gx-1 > li, .gx-1 > div {
  padding-left: 0.1875rem !important;
  padding-right: 0.1875rem !important;
}

.gy-1 {
  margin-top: -0.1875rem !important;
  margin-bottom: -0.1875rem !important;
}
.gy-1 > li, .gy-1 > div {
  padding-top: 0.1875rem !important;
  padding-bottom: 0.1875rem !important;
}

.g-2 {
  margin: -0.375rem !important;
}
.g-2 > li, .g-2 > div {
  padding: 0.375rem !important;
}

.gx-2 {
  margin-left: -0.375rem !important;
  margin-right: -0.375rem !important;
}
.gx-2 > li, .gx-2 > div {
  padding-left: 0.375rem !important;
  padding-right: 0.375rem !important;
}

.gy-2 {
  margin-top: -0.375rem !important;
  margin-bottom: -0.375rem !important;
}
.gy-2 > li, .gy-2 > div {
  padding-top: 0.375rem !important;
  padding-bottom: 0.375rem !important;
}

.g-3 {
  margin: -0.5rem !important;
}
.g-3 > li, .g-3 > div {
  padding: 0.5rem !important;
}

.gx-3 {
  margin-left: -0.5rem !important;
  margin-right: -0.5rem !important;
}
.gx-3 > li, .gx-3 > div {
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}

.gy-3 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important;
}
.gy-3 > li, .gy-3 > div {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.g-4 {
  margin: -0.75rem !important;
}
.g-4 > li, .g-4 > div {
  padding: 0.75rem !important;
}

.gx-4 {
  margin-left: -0.75rem !important;
  margin-right: -0.75rem !important;
}
.gx-4 > li, .gx-4 > div {
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}

.gy-4 {
  margin-top: -0.75rem !important;
  margin-bottom: -0.75rem !important;
}
.gy-4 > li, .gy-4 > div {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}

.g-5 {
  margin: -1.375rem !important;
}
.g-5 > li, .g-5 > div {
  padding: 1.375rem !important;
}

.gx-5 {
  margin-left: -1.375rem !important;
  margin-right: -1.375rem !important;
}
.gx-5 > li, .gx-5 > div {
  padding-left: 1.375rem !important;
  padding-right: 1.375rem !important;
}

.gy-5 {
  margin-top: -1.375rem !important;
  margin-bottom: -1.375rem !important;
}
.gy-5 > li, .gy-5 > div {
  padding-top: 1.375rem !important;
  padding-bottom: 1.375rem !important;
}

.g-gs {
  margin: -14px !important;
}
.g-gs > li, .g-gs > div {
  padding: 14px !important;
}

.gx-gs {
  margin-left: -14px !important;
  margin-right: -14px !important;
}
.gx-gs > li, .gx-gs > div {
  padding-left: 14px !important;
  padding-right: 14px !important;
}

.gy-gs {
  margin-top: -14px !important;
  margin-bottom: -14px !important;
}
.gy-gs > li, .gy-gs > div {
  padding-top: 14px !important;
  padding-bottom: 14px !important;
}

.gap {
  width: 100%;
  display: block;
  height: 28px;
}

.gap-0 {
  height: 0;
}

.gap-1 {
  height: 0.375rem;
}

.gap-2 {
  height: 0.75rem;
}

.gap-3 {
  height: 1rem;
}

.gap-4 {
  height: 1.5rem;
}

.gap-5 {
  height: 2.75rem;
}

.gap-gs {
  height: 28px;
}

.gap-sm {
  height: 0.75rem;
}

.gap-md {
  height: 1.25rem;
}

.gap-lg {
  height: 2rem;
}

.gap-xl {
  height: 2.5rem;
}

.gap-10px {
  height: 10px;
}

.gap-20px {
  height: 20px;
}

.gap-30px {
  height: 30px;
}

.gap-40px {
  height: 40px;
}

.gap-50px {
  height: 50px;
}

.gap-60px {
  height: 60px;
}

.gap-70px {
  height: 70px;
}

.gap-80px {
  height: 80px;
}

.gap-90px {
  height: 90px;
}

.gap-100px {
  height: 100px;
}

.li-col2x > li {
  width: 50%;
  float: left;
}

.li-col3x > li {
  width: 33.3333333333%;
  float: left;
}

.li-col4x > li {
  width: 25%;
  float: left;
}

/** 05. COMPONENTS */
.alert-cta {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.alert-actions {
  display: inline-flex;
  align-items: center;
}
.alert-actions a + a {
  margin-left: 1rem;
}

.accordion {
  border-radius: 4px;
  background: #fff;
}
.accordion-heading {
  padding-bottom: 1.5rem;
}
.accordion-body {
  border-radius: 4px;
}
.accordion-item:not(:last-child) .accordion-head {
  border-bottom: 1px solid #dbdfea;
}
.accordion-item:not(:last-child) .accordion-inner {
  border-bottom: 1px solid #dbdfea;
}
.accordion-item:last-child .accordion-inner {
  border-top: 1px solid #dbdfea;
}
.accordion-head {
  padding: 1rem 2.25rem 1rem 1.25rem;
  display: block;
  position: relative;
}
.accordion-head .title {
  margin-bottom: 0;
  font-size: 1rem;
  color: #364a63;
  line-height: 1.3;
}
.accordion-head.collapsed .title {
  color: #526484;
}
.accordion-inner {
  padding: 1rem 1.25rem 1.25rem;
}
.accordion-icon {
  position: absolute;
  right: 1rem;
  top: 50%;
  font-size: 1rem;
  color: #364a63;
  transform: translateY(-50%);
  transition: rotate 0.4s;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
}
.accordion-icon:before {
  content: "\\e9da";
  font-family: "Nioicon";
  transition: 0.4s;
}
.accordion-head.collapsed .accordion-icon:before {
  content: "\\e9c5";
}

@media (min-width: 768px) {
  .accordion-head {
    padding: 1rem 1.5rem;
  }
  .accordion-inner {
    padding: 1rem 1.5rem 1.25rem;
  }
  .accordion-icon {
    right: 1.5rem;
  }
}
.accordion-s2 {
  border: none;
}
.accordion-s2 .accordion-icon {
  right: 0;
}
.accordion-s2 .accordion-icon:before {
  content: "\\eafa";
}
.accordion-s2 .accordion-head {
  padding: 0.5rem 2.25rem 0.5rem 0;
  border: none !important;
}
.accordion-s2 .accordion-head .title {
  font-size: 1.1rem;
  color: #4461F2;
}
.accordion-s2 .accordion-head.collapsed .title {
  color: #526484;
}
.accordion-s2 .accordion-head.collapsed .accordion-icon:before {
  content: "\\eb44";
}
.accordion-s2 .accordion-inner {
  padding: 0.5rem 0 0.625rem;
  border: none !important;
}

@media (min-width: 768px) {
  .accordion-s2 .accordion-head {
    padding: 0.5rem 2.25rem 0.5rem 0;
  }
  .accordion-s2 .accordion-inner {
    padding: 0.5rem 0 0.625rem;
  }
}
.accordion-s3 {
  border: none;
}
.accordion-s3 .accordion-icon {
  left: 0;
  right: auto;
}
.accordion-s3 .accordion-icon:before {
  content: "\\eafa";
}
.accordion-s3 .accordion-head {
  padding: 0.5rem 0 0.5rem 2.25rem;
  border: none !important;
}
.accordion-s3 .accordion-head .title {
  font-size: 1.1rem;
  color: #4461F2;
}
.accordion-s3 .accordion-head.collapsed .title {
  color: #526484;
}
.accordion-s3 .accordion-head.collapsed .accordion-icon:before {
  content: "\\eb44";
}
.accordion-s3 .accordion-inner {
  padding: 0.5rem 0 0.625rem;
  border: none !important;
}

@media (min-width: 768px) {
  .accordion-s3 .accordion-head {
    padding: 0.5rem 0 0.5rem 2.25rem;
  }
  .accordion-s3 .accordion-inner {
    padding: 0.5rem 2.25rem 0.625rem;
  }
}
.dot {
  position: relative;
  display: inline-block;
  border-radius: 50%;
  height: 8px;
  width: 8px;
}
.dot-label:after {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  border-radius: 50%;
  background: #fff;
  content: "";
  transform: scale(0.65);
}
.dot.sq {
  border-radius: 3px;
}
.dot.sq:after {
  border-radius: 3px;
}

.dot-xs {
  height: 4px;
  width: 4px;
}

.dot-sm {
  height: 6px;
  width: 6px;
}

.dot-md {
  height: 8px;
  width: 8px;
}

.dot-rg {
  height: 10px;
  width: 10px;
}

.dot-lg {
  height: 12px;
  width: 12px;
}

.dot-xl {
  height: 16px;
  width: 16px;
}

.dot-primary {
  background: #4461F2;
}

.dot-secondary {
  background: #364a63;
}

.dot-success {
  background: #1ee0ac;
}

.dot-info {
  background: #09c2de;
}

.dot-warning {
  background: #f4bd0e;
}

.dot-danger {
  background: #e85347;
}

.dot-dark {
  background: #1c2b46;
}

.dot-gray {
  background: #8091a7;
}

.dot-light {
  background: #e5e9f2;
}

.dot-lighter {
  background: #f5f6fa;
}

.list:not(:last-child) {
  margin-bottom: 1rem;
}
.list li {
  position: relative;
  padding-left: 1.5rem;
  line-height: 1.5rem;
}
.list li:not(:last-child) {
  padding-bottom: 0.5rem;
}
.list li:before {
  position: absolute;
  left: 0;
  font-size: 14px;
  line-height: 1.5rem;
  font-family: "Nioicon";
  content: "\\e980";
}
.list li span {
  color: #8094ae;
}
.list li ul {
  margin-top: 0.5rem;
}
.list-checked li:before {
  color: #4461F2;
  content: "\\e9b9";
}
.list-checked-circle li:before {
  color: #4461F2;
  content: "\\e9b7";
}
.list-cross li:before {
  color: rgba(232, 83, 71, 0.8);
  content: "\\ea02";
}
.list-status {
  list-style: none;
  line-height: 1.3;
}
.list-status li {
  display: inline-flex;
  align-items: center;
  padding-right: 1rem;
  vertical-align: middle;
}
.list-status .icon {
  margin-right: 0.375rem;
  line-height: 1.3;
}
.list-lg li {
  padding-left: 2rem;
}
.list-lg li:not(:last-child) {
  padding-bottom: 0.75rem;
}
.list-lg li:before {
  font-size: 1.35rem;
}
.list-sm li {
  padding-left: 1.2rem;
}
.list-sm li:not(:last-child) {
  padding-bottom: 0.35rem;
}
.list-sm li:before {
  font-size: 12px;
}
.list-step li {
  color: #8094ae;
  font-weight: 500;
}
.list-step li:before {
  content: "\\e9e0";
}
.list-step li.list-step-current {
  color: #364a63;
}
.list-step li.list-step-current:before {
  content: "\\ea1b";
  color: #4461F2;
}
.list-step li.list-step-done {
  color: #526484;
}
.list-step li.list-step-done:before {
  content: "\\e9b6";
  color: #1ee0ac;
}
.list-plain a {
  color: #526484;
  display: block;
  line-height: 1.3;
  padding: 0.5rem 0;
}
.list-plain a:hover {
  color: #4461F2;
}
.list-category a {
  font-weight: 500;
}
.list-download li > a {
  display: inline-block;
  padding: 0.25rem;
}
.list-download li > a > .icon {
  margin: 0 0.25rem;
  font-size: 1.25rem;
}

.list-primary li:before {
  color: #4461F2;
}

.list-secondary li:before {
  color: #364a63;
}

.list-success li:before {
  color: #1ee0ac;
}

.list-info li:before {
  color: #09c2de;
}

.list-warning li:before {
  color: #f4bd0e;
}

.list-danger li:before {
  color: #e85347;
}

.list-dark li:before {
  color: #1c2b46;
}

.list-gray li:before {
  color: #8091a7;
}

.list-light li:before {
  color: #e5e9f2;
}

.list-lighter li:before {
  color: #f5f6fa;
}

.link-bdr-t, .link-list-plain li + li, .link-list-opt-scrollable li + li, .link-list-opt li + li, .link-list + .link-list, .link-tidy li + li, .link-check + .link-check {
  border-top: 1px solid #e5e9f2;
}

.link-bdr-b {
  border-bottom: 1px solid #e5e9f2;
}

.link-pd-sm, .link-list-plain.sm a, .link-tidy.sm li {
  padding: 6px 1rem;
}

.link-act-check:after, .link-list-opt-scrollable li.active > a:after, .link-list-opt-scrollable a.active:after, .link-list-opt li.active > a:after, .link-list-opt a.active:after, .link-check li.active > a:after, .link-check li a.active:after {
  content: "\\e9bd";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 1rem;
  font-family: "Nioicon";
}

.link-check {
  padding: 0.5rem 0;
}
.link-check .divider {
  margin: 0.5rem 0;
}
.link-check li {
  display: block;
}
.link-check li > span, .link-check li a {
  display: block;
  line-height: 1.25rem;
  padding: 0.35rem 1rem;
}
.link-check li > span {
  text-transform: uppercase;
  color: #364a63;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 1px;
}
.link-check li a {
  display: flex;
  align-items: center;
  color: #526484;
  font-size: 13px;
  position: relative;
}
.link-check li a:hover {
  color: #4461F2;
  background: #f5f6fa;
}
.link-check li .icon {
  width: 1.75rem;
  font-size: 1.125rem;
}
.link-tidy.no-bdr {
  padding: 0.5rem 0;
}
.link-tidy.no-bdr li:not(.divider) {
  border-top-width: 0;
}
.link-tidy .divider {
  margin: 0.5rem 0;
}
.link-tidy li {
  position: relative;
  padding: 0.625rem 1.1rem;
  line-height: 1.3rem;
}
.link-list {
  padding: 0.75rem 0;
}
.link-list .divider {
  margin: 0.5rem 0;
}
.link-list a {
  display: flex;
  align-items: center;
  color: #526484;
  font-size: 13px;
  line-height: 1.4rem;
  font-weight: 500;
  padding: 0.575rem 0;
  position: relative;
}
.link-list a:hover {
  color: #4461F2;
}
.link-list a .icon {
  font-size: 1.125rem;
  width: 1.5rem;
  line-height: 1;
}

.link-list-opt.no-bdr {
  padding: 0.5rem 0;
}
.link-list-opt.no-bdr li:not(.divider) {
  border-top-width: 0;
}
.link-list-opt .divider {
  margin: 0.5rem 0;
}
.link-list-opt a {
  display: flex;
  align-items: center;
  padding: 0.625rem 1.125rem;
  font-size: 12px;
  font-weight: 500;
  color: #526484;
  transition: all 0.4s;
  line-height: 1.3rem;
  position: relative;
}
.link-list-opt a:hover {
  color: #4461F2;
  background: #f5f6fa;
}
.link-list-opt a .icon {
  font-size: 1.125rem;
  width: 1.75rem;
  opacity: 0.8;
}
.link-list-opt li.disabled > a, .link-list-opt a.disabled {
  pointer-events: none;
  color: #8094ae;
  opacity: 0.7;
}
.link-list-opt .opt-head {
  padding: 0.25rem 1.25rem;
  color: #8094ae;
}
.link-list-opt.ui-v2 a {
  font-weight: 400;
}
.link-list-opt.no-bdr + .link-check {
  margin-top: -0.75rem;
}
.link-list-opt.ui-colored li.active > a, .link-list-opt.ui-colored a.active {
  color: #4461F2;
}

.link-list-opt-scrollable {
  max-height: 250px;
  overflow-y: auto;
}
.link-list-opt-scrollable.no-bdr {
  padding: 0.5rem 0;
}
.link-list-opt-scrollable.no-bdr li:not(.divider) {
  border-top-width: 0;
}
.link-list-opt-scrollable .divider {
  margin: 0.5rem 0;
}
.link-list-opt-scrollable a {
  display: flex;
  align-items: center;
  padding: 0.625rem 1.125rem;
  font-size: 12px;
  font-weight: 500;
  color: #526484;
  transition: all 0.4s;
  line-height: 1.3rem;
  position: relative;
}
.link-list-opt-scrollable a:hover {
  color: #4461F2;
  background: #f5f6fa;
}
.link-list-opt-scrollable a .icon {
  font-size: 1.125rem;
  width: 1.75rem;
  opacity: 0.8;
}
.link-list-opt-scrollable li.disabled > a, .link-list-opt-scrollable a.disabled {
  pointer-events: none;
  color: #8094ae;
  opacity: 0.7;
}
.link-list-opt-scrollable .opt-head {
  padding: 0.25rem 1.25rem;
  color: #8094ae;
}
.link-list-opt-scrollable.ui-v2 a {
  font-weight: 400;
}
.link-list-opt-scrollable.no-bdr + .link-check {
  margin-top: -0.75rem;
}
.link-list-opt-scrollable.ui-colored li.active > a, .link-list-opt-scrollable.ui-colored a.active {
  color: #4461F2;
}

.link-list-menu {
  padding: 0.75rem 0;
}
.link-list-menu .divider {
  margin: 0.5rem 0;
}
.link-list-menu a {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0.75rem 1.25rem;
  font-weight: 500;
  color: #526484;
  transition: all 0.4s;
  line-height: 1.3rem;
}
.link-list-menu a:after {
  position: absolute;
  font-size: 1rem;
  font-family: "Nioicon";
  right: 1.25rem;
  content: "\\e9d3";
  color: #8094ae;
  transition: 0.3s ease;
}
.link-list-menu a .icon {
  font-size: 1.125rem;
  width: 1.75rem;
  opacity: 0.8;
  color: #8094ae;
  margin-top: -2px;
}
.link-list-menu li.active > a, .link-list-menu a.active, .link-list-menu a:hover, .link-list-menu li.active > a .icon, .link-list-menu a.active .icon, .link-list-menu a:hover .icon, .link-list-menu li.active > a:after, .link-list-menu a.active:after, .link-list-menu a:hover:after {
  color: #4461F2;
}
.link-list-menu.nav {
  display: block;
}

@media (min-width: 576px) {
  .link-list-menu a {
    padding: 1rem 1.5rem;
  }
}
.link-list-plain.no-bdr {
  padding: 0.5rem 0;
}
.link-list-plain.no-bdr li {
  border-top-width: 0;
}
.link-list-plain .divider {
  margin: 0.5rem 0;
}
.link-list-plain a {
  display: flex;
  align-items: center;
  padding: 0.5rem 1.25rem;
  color: #526484;
  transition: all 0.4s;
  line-height: 1.4rem;
  position: relative;
}
.link-list-plain a:hover {
  color: #4461F2;
  background: #f5f6fa;
}
.link-list-plain a .icon {
  font-size: 1.125rem;
  width: 1.75rem;
  opacity: 0.8;
  color: #4461F2;
}
.link-list-plain li.active > a, .link-list-plain a.active {
  color: #4461F2;
  background: #f5f6fa;
}
.link-list-plain.text-center a {
  justify-content: center;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.link-list-plain.li-col2x > li {
  border-right: 1px solid #e5e9f2;
  border-bottom: 1px solid #e5e9f2;
  border-top: 0;
}
.link-list-plain.li-col2x > li:nth-child(2n) {
  border-right: none;
}

.link-list-plain.li-col3x > li {
  border-right: 1px solid #e5e9f2;
  border-bottom: 1px solid #e5e9f2;
  border-top: 0;
}
.link-list-plain.li-col3x > li:nth-child(3n) {
  border-right: none;
}

.link-list-plain.li-col4x > li {
  border-right: 1px solid #e5e9f2;
  border-bottom: 1px solid #e5e9f2;
  border-top: 0;
}
.link-list-plain.li-col4x > li:nth-child(4n) {
  border-right: none;
}

.link-list-template a {
  font-weight: 400;
}

.passcode-icon {
  display: none;
}
.passcode-icon.icon-show {
  display: block;
}
.is-shown .passcode-icon.icon-show {
  display: none;
}
.is-hidden .passcode-icon.icon-show {
  display: block;
}
.is-shown .passcode-icon.icon-hide {
  display: block;
}
.is-hidden .passcode-icon.icon-hide {
  display: none;
}

.form-dropdown {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 0 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #8094ae;
}
.form-dropdown > div > span {
  margin: 0 0.5rem;
}
.form-dropdown .dropdown > a {
  display: inline-flex;
}

.form-clip, .form-text-hint {
  position: absolute;
  right: 2px;
  top: 2px;
  height: calc(2.125rem - 2px);
  display: flex;
  align-items: center;
  color: #4461F2;
  padding-left: 1rem;
  padding-right: 0.75rem;
  background: #fff;
  border-radius: 4px;
}
.form-clip.sm, .form-text-hint.sm {
  height: calc(1.75rem + 2px);
}
.form-clip.lg, .form-text-hint.lg {
  height: calc(2.625rem + 2px);
}
.form-clip.xl, .form-text-hint.xl {
  height: calc(3.25rem + 2px);
}
.form-clip .icon + span, .form-clip span + .icon, .form-text-hint .icon + span, .form-text-hint span + .icon {
  margin-left: 0.25rem;
}

.nk-upload-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(2.125rem + 2px);
  margin: 0;
  opacity: 0;
}
.nk-upload-label {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1.5rem;
  width: 100%;
  min-height: 150px;
  border-radius: 4px;
  border: 1px dashed #e5e9f2;
  padding-bottom: 0;
}
.nk-upload-init {
  display: block;
  text-align: center;
}
.nk-upload-files {
  padding-top: 2rem;
  display: flex;
  justify-content: center;
  margin: -0.5rem;
  padding-bottom: 2rem;
}
.nk-upload-files li {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  flex-direction: column;
  text-align: center;
  padding: 0.5rem;
}
.nk-upload-files li img {
  width: 60px;
  flex-shrink: 0;
  border-radius: 4px;
}
.is-multiple .nk-upload-files li img {
  width: 40px;
}
.is-multiple .nk-upload-files li .nk-upload-name {
  display: none;
}
.nk-upload-name {
  margin: 0.5rem 0 0;
  color: #526484;
  font-size: 0.8125rem;
  font-weight: 500;
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.nk-upload-response {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
}
.nk-upload-response .message {
  font-size: 12px;
  color: #8094ae;
}
.nk-upload-response .message + .icon {
  margin-left: 0.5rem;
}
.nk-upload-response .icon:after {
  font-family: "Nioicon";
}
.nk-upload-response .icon + .message {
  margin-left: 0.5rem;
}
.nk-upload-response.invalid .icon {
  color: #f4bd0e;
}
.nk-upload-response.invalid .icon:after {
  content: "\\e90f";
}
.nk-upload-response.valid .icon {
  color: #1ee0ac;
}
.nk-upload-response.valid .icon:after {
  content: "\\e9b7";
}
.nk-upload-response.error .icon {
  color: #e85347;
}
.nk-upload-response.error .icon:after {
  content: "\\ea00";
}
.nk-upload-foot {
  display: flex;
  justify-content: space-between;
  border-top: 1px dashed #e5e9f2;
  padding: 1rem 1.25rem;
  margin: 0 -1.5rem;
}
.nk-upload-foot > span, .nk-upload-foot > button {
  margin: 0.25rem;
}

.form-editor-custom textarea {
  border-radius: 4px 4px 0 0;
}
.form-editor-action {
  border: 1px solid #dbdfea;
  border-top: 0;
  border-radius: 0 0 4px 4px;
  padding: 0.25rem 0.5rem;
}
.form-editor-action > .link {
  padding: 0.5rem;
}
.form-editor-action > .link.collapsed {
  color: #8094ae;
}
.form-editor-action > .link .icon {
  margin-right: 0.25rem;
}
.form-editor-btn-group, .form-btn-group {
  display: flex;
  align-items: center;
  margin: -0.25rem;
  flex-wrap: wrap;
}
.form-editor-btn-group li, .form-btn-group li {
  padding: 0.25rem;
  line-height: 0.5rem;
}
.form-btn-group li:first-child {
  margin-right: 0.5rem;
}
.form-btn-secondary {
  margin-left: auto;
}

input[type=number] {
  appearance: textfield;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
}

.number-spinner {
  padding-left: 3.125rem;
  padding-right: 3.125rem;
  text-align: center;
}
.number-spinner:focus {
  border-color: #dbdfea;
}
.number-spinner-btn {
  position: absolute;
  top: 0;
}
.number-plus {
  right: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.number-minus {
  left: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group-addon {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  background-color: #f5f6fa;
  border: 1px solid #dbdfea;
  font-size: 0.75rem;
  border-radius: 4px;
}
.input-group-addon:not(:last-child) {
  border-right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group-addon:not(:first-child) {
  border-left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.page-title {
  font-family: "DM Sans", sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
}

@media (min-width: 992px) {
  .page-title {
    font-size: 1.75rem;
  }
}
.overline-title {
  font-size: 11px;
  line-height: 1.2;
  letter-spacing: 0.2em;
  color: #8094ae;
  text-transform: uppercase;
  font-weight: 700;
  font-family: "DM Sans", sans-serif, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
}
.text-light .overline-title {
  color: #8094ae;
}
.is-dark .overline-title {
  color: #b7c2d0;
}
.is-theme .overline-title {
  color: #d4c2ff;
}
.overline-title-alt {
  font-family: "DM Sans", sans-serif, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0.15em;
  font-size: 11px;
  color: #8094ae;
  text-transform: uppercase;
}
.is-dark .overline-title-alt {
  color: #8094ae;
}
.is-theme .overline-title-alt {
  color: #d4c2ff;
}
.overline-title-sap {
  position: relative;
  display: inline-block;
  margin-bottom: 0;
  padding-left: 0.35rem;
  padding-right: 0.25rem;
  color: #b6c6e3;
}
.overline-title-sap:before, .overline-title-sap:after {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 1px;
  content: "";
  background: #b6c6e3;
}
.overline-title-sap:before {
  right: 100%;
}
.overline-title-sap:after {
  left: 100%;
}

.caption-text {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.3;
  letter-spacing: -0.01em;
}
.caption-text + .sub-text, .caption-text + .sub-text-sm {
  margin-top: 0.5rem;
  display: block;
}

.lead-text {
  font-size: 0.875rem;
  font-weight: 700;
  color: #364a63;
  display: block;
}
.lead-text + .sub-text {
  font-size: 12px;
}
.lead-text span {
  color: #526484;
  font-weight: 400;
}
.lead-text-lg {
  font-size: 1.125rem;
  font-weight: 500;
  color: #364a63;
  display: block;
}
.is-theme .lead-text-lg {
  color: #fff;
}
.is-theme .is-light .lead-text-lg {
  color: #364a63;
}
.is-dark .lead-text {
  color: #b7c2d0;
}
.is-dark .lead-text span {
  color: #8091a7;
}
.is-theme .lead-text {
  color: #fff;
}
.is-theme .lead-text span {
  color: #d4c2ff;
}
.is-theme .is-light .lead-text, .is-dark .is-light .lead-text {
  color: #364a63;
}
.is-theme .is-light .lead-text span, .is-dark .is-light .lead-text span {
  color: #526484;
}

.sub-text {
  display: block;
  font-size: 13px;
  color: #8094ae;
}
.sub-text span + .dot, .sub-text .dot + span {
  margin-left: 0.25rem;
}
.sub-text-sm, .sub-text + .sub-text {
  font-size: 12px;
}
.sub-text-sm {
  color: #8094ae;
}
.is-theme .sub-text-sm {
  color: #d4c2ff;
}
.is-theme .is-light .sub-text-sm {
  color: #8094ae;
}
.text-ellipsis .sub-text {
  display: inline;
}
.sub-text strong {
  color: #526484;
  font-weight: 700;
}
.is-theme .sub-text strong {
  color: #d4c2ff;
}
.is-theme .is-light .sub-text strong {
  color: #526484;
}
.sub-text span {
  white-space: nowrap;
}
.is-theme .sub-text {
  color: #d4c2ff;
}
.is-theme .is-light .sub-text {
  color: #8094ae;
}

.text-date span {
  color: #526484;
}

h6 .badge {
  margin-left: 0.5rem;
}

.fs-9px {
  font-size: 9px;
}

.fs-10px {
  font-size: 10px;
}

.fs-11px {
  font-size: 11px;
}

.fs-12px {
  font-size: 12px;
}

.fs-13px {
  font-size: 13px;
}

.fs-14px {
  font-size: 14px;
}

.fs-15px {
  font-size: 15px;
}

.fs-16px {
  font-size: 16px;
}

.fs-17px {
  font-size: 17px;
}

.fs-18px {
  font-size: 18px;
}

.fs-19px {
  font-size: 19px;
}

.fs-20px {
  font-size: 20px;
}

.fs-21px {
  font-size: 21px;
}

.fs-22px {
  font-size: 22px;
}

.note-text {
  font-size: 12px;
  font-style: italic;
  color: #8094ae;
}

.card .table {
  margin-bottom: 0;
}
.card .table tr:first-child th, .card .table tr:first-child td {
  border-top: none;
}
.card .table tr:last-child td:first-child {
  border-bottom-left-radius: 4px;
}
.card .table tr:last-child td:last-child {
  border-bottom-right-radius: 4px;
}
.card .table tr:first-child th:first-child {
  border-top-left-radius: 4px;
}
.card .table tr:first-child th:last-child {
  border-top-right-radius: 4px;
}
.card + .lead-text {
  margin-top: 2rem;
}
.lead-text + .card {
  margin-top: 1rem;
}
.card-custom-s1 .card-inner-group .card-inner {
  border-bottom: 1px solid #dbdfea;
}

@media (max-width: 991.98px) {
  .card-custom-s1 .card-inner-lg {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
@media (min-width: 992px) {
  .card-custom-s1 .card-inner-group {
    border-right: 1px solid #dbdfea;
  }
  .card-custom-s1 .card-inner-group .card-inner:last-child {
    border-bottom: none;
  }
}
@media (min-width: 576px) {
  .card-search .card-body {
    padding: 1.5rem;
  }
}
.card-aside {
  width: 300px;
  background-color: #fff;
  min-height: 100vh;
  flex-shrink: 0;
}
.card-aside-left {
  order: -1;
  border-right: 1px solid #e5e9f2;
}
.card-aside-right {
  order: 100;
  border-left: 1px solid #e5e9f2;
}
.card-aside-wrap {
  display: flex;
}
.card-aside-wrap .card-inner, .card-aside-wrap .card-content {
  flex-grow: 1;
}

@media (max-width: 767.98px) {
  .toggle-break-md.card-aside .card-inner-group {
    max-height: 100vh;
  }
}
@media (max-width: 991.98px) {
  .toggle-break-lg.card-aside .card-inner-group {
    max-height: 100vh;
  }
}
@media (max-width: 1199.98px) {
  .toggle-break-xl.card-aside .card-inner-group {
    max-height: 100vh;
  }
}
@media (max-width: 1539.98px) {
  .toggle-break-xxl.card-aside .card-inner-group {
    max-height: 100vh;
  }
}
@media (min-width: 992px) {
  .card-aside {
    position: static;
    display: block;
  }
}
@media (min-width: 1540px) {
  .card-aside {
    width: 380px;
  }
}
.user-avatar, [class^=user-avatar]:not([class*=-group]) {
  border-radius: 50%;
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  background: #D9D9D9;
  font-size: 44px;
  font-weight: 700;
  letter-spacing: 0;
  flex-shrink: 0;
  position: relative;
}
.user-avatar + .user-info, [class^=user-avatar]:not([class*=-group]) + .user-info {
  margin-left: 1rem;
  width: max-content;
}
.user-avatar + .user-name, [class^=user-avatar]:not([class*=-group]) + .user-name {
  margin-left: 0.75rem;
}
.user-avatar img, [class^=user-avatar]:not([class*=-group]) img {
  border-radius: 50%;
}
.user-avatar.md + .user-info, [class^=user-avatar]:not([class*=-group]).md + .user-info {
  margin-left: 1.5rem;
}
.user-avatar.md + .user-name, [class^=user-avatar]:not([class*=-group]).md + .user-name {
  margin-left: 1.25rem;
}
.user-avatar .edit, [class^=user-avatar]:not([class*=-group]) .edit {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 50%;
  background-color: rgba(31, 43, 58, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  opacity: 0;
  transition: opacity 0.3s;
}
.user-avatar:hover .edit, [class^=user-avatar]:not([class*=-group]):hover .edit {
  opacity: 1;
}
.user-avatar .status, [class^=user-avatar]:not([class*=-group]) .status {
  border: 2px solid #fff;
  position: absolute;
  bottom: 0;
  right: 0;
}
.user-avatar.sq, [class^=user-avatar]:not([class*=-group]).sq {
  border-radius: 4px;
}
.user-avatar.sq img, [class^=user-avatar]:not([class*=-group]).sq img {
  border-radius: 4px;
}
.user-avatar.sq .status, [class^=user-avatar]:not([class*=-group]).sq .status {
  right: -6px;
  bottom: -6px;
}

.user-avatar-multiple {
  background-color: transparent !important;
}
.user-avatar-multiple .user-avatar {
  position: absolute;
  height: 70%;
  width: 70%;
  font-size: 80%;
  border: 2px solid #fff;
}
.user-avatar-multiple .user-avatar:nth-child(1) {
  top: 0;
  right: 0;
}
.user-avatar-multiple .user-avatar:nth-child(2) {
  bottom: 0;
  left: 0;
}

.user-card .user-avatar.d-none {
  margin-right: 1rem;
}
.user-card .user-avatar.d-none + .user-info, .user-card .user-avatar.d-none + .user-name {
  margin-left: 0;
}

.user-avatar-xl, .user-avatar.xl {
  height: 110px;
  width: 110px;
  font-size: 40px;
  font-weight: 400;
}
.user-avatar-xl .status, .user-avatar.xl .status {
  bottom: 9px;
  right: 9px;
}
.user-avatar-lg, .user-avatar.lg {
  height: 80px;
  width: 80px;
  font-size: 28px;
  font-weight: 400;
}
.user-avatar-lg .status, .user-avatar.lg .status {
  bottom: 5px;
  right: 5px;
}
.user-avatar-md, .user-avatar.md {
  height: 60px;
  width: 60px;
  font-size: 18px;
}
.user-avatar-md .status, .user-avatar.md .status {
  bottom: 2px;
  right: 2px;
}
.user-avatar-sm, .user-avatar.sm {
  height: 32px;
  width: 32px;
  font-size: 12px;
}
.user-avatar-sm .status, .user-avatar.sm .status {
  bottom: -2px;
  right: -2px;
}
.user-avatar-xs, .user-avatar.xs {
  height: 26px;
  width: 26px;
  font-size: 9px;
  font-weight: 700;
}
.user-avatar-xs .status, .user-avatar.xs .status {
  bottom: -2px;
  right: -2px;
}

.user-avatar[class*=-blue-dim] {
  color: #559bfb;
}

.user-avatar[class*=-azure-dim] {
  color: #1676fb;
}

.user-avatar[class*=-indigo-dim] {
  color: #2c3782;
}

.user-avatar[class*=-purple-dim] {
  color: #816bff;
}

.user-avatar[class*=-pink-dim] {
  color: #ff63a5;
}

.user-avatar[class*=-orange-dim] {
  color: #ffa353;
}

.user-avatar[class*=-teal-dim] {
  color: #20c997;
}

.user-avatar[class*=-primary-dim] {
  color: #4461F2;
}

.user-avatar[class*=-secondary-dim] {
  color: #364a63;
}

.user-avatar[class*=-success-dim] {
  color: #1ee0ac;
}

.user-avatar[class*=-info-dim] {
  color: #09c2de;
}

.user-avatar[class*=-warning-dim] {
  color: #f4bd0e;
}

.user-avatar[class*=-danger-dim] {
  color: #e85347;
}

.user-avatar[class*=-dark-dim] {
  color: #1f2b3a;
}

.user-avatar[class*=-gray-dim] {
  color: #8091a7;
}

.user-avatar[class*=-lighter] {
  color: #8094ae;
}

.user-avatar[class*=-light] {
  color: #526484;
}

.user-card {
  display: flex;
  align-items: center;
}
.user-card-wrap {
  padding-top: 1.125rem;
  padding-bottom: 1.125rem;
}
.user-card .user-info {
  color: #8094ae;
}
.user-card-menu {
  position: absolute;
  right: 1rem;
  top: 1rem;
}
.user-toggle {
  display: flex;
  align-items: center;
  padding: 0 1px 1px;
}
.user-status {
  font-size: 11px;
  font-weight: 500;
  line-height: 1;
  padding-top: 0.125rem;
  padding-bottom: 0.375rem;
}
.user-status-unverified {
  color: #e85347;
}
.user-status-verified {
  color: #1ee0ac;
}
.user-name {
  color: #526484;
  font-size: 13px;
  line-height: 16px;
  font-weight: 700;
}
.is-dark .user-name {
  color: #90a1b8;
}
.is-theme .user-name {
  color: #d4c2ff;
}
.user-action {
  margin-left: auto;
  font-size: 20px;
  color: #8094ae;
}
.user-account-info {
  padding-top: 1.5rem;
  padding-bottom: 1.25rem;
}
.user-account-data li {
  display: flex;
  justify-content: space-between;
  padding: 0.125rem 0;
}
.user-account-actions:not(:first-child) {
  margin-top: 1.5rem;
}
.user-account-actions ul {
  display: flex;
}
.user-account-actions ul li {
  width: 44%;
}
.user-account-actions ul li:last-child {
  width: 56%;
}
.user-account-actions .btn, .user-account-actions .dual-listbox .dual-listbox__button, .dual-listbox .user-account-actions .dual-listbox__button {
  width: 100%;
  font-size: 12px;
  letter-spacing: 0.04em;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  text-transform: uppercase;
}
.user-account-links {
  padding: 1rem 0;
  border-bottom: 1px solid #e5e9f2;
}
.user-account-info .user-account-links:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}
.user-account-info + .user-account-links {
  padding-top: 0;
  margin-top: -0.5rem;
}
.user-account-links a:link {
  padding: 0.5rem 0;
  display: flex;
}
.user-account-value {
  display: inline-flex;
}
.user-balance {
  font-size: 1.5rem;
  line-height: 1;
  padding: 0.125rem 0 0.375rem;
  color: #4461F2;
}
.user-balance small {
  font-size: 1rem;
}
.user-balance-alt {
  font-size: 15px;
  color: #526484;
  font-weight: 700;
}
.user-balance-alt span {
  font-weight: 400;
}
.user-balance-sub {
  font-size: 13px;
  color: #8094ae;
}
.user-balance-sub span {
  color: #526484;
}
.user-balance-sub + a {
  margin-top: 1rem;
}

.user-card-s2 {
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 0.5rem;
}
.user-card-s2 .user-avatar {
  margin: 0 auto;
}
.user-card-s2 .user-info {
  margin: 1.25rem 0 0 !important;
}
.user-card-s2 .user-info .sub-text {
  justify-content: center;
}
.user-card-s2 .user-info .badge {
  margin-bottom: 1rem;
}

.user-card-md .lead-text {
  font-size: 1rem;
}
.user-card-md .sub-text {
  font-size: 0.875rem;
}

.user-activity {
  display: flex;
}
.user-activity-group {
  display: flex;
  flex-wrap: wrap;
}
.user-activity-ck {
  height: 110px;
  padding: 0.5rem 0.375rem 0;
}
.user-activity .icon {
  width: 2.25rem;
  font-size: 1.5rem;
  color: #8094ae;
}
.user-activity .info span {
  display: block;
}
.user-activity .amount {
  font-size: 1.125rem;
  line-height: 1.3;
  font-weight: 500;
  color: #526484;
}
.user-activity .title {
  font-size: 12px;
  color: #8094ae;
}
.user-activity .gfx {
  align-self: flex-end;
  width: 50px;
  margin-left: 1rem;
  margin-bottom: 0.25rem;
}

.user-contacts li {
  color: #526484;
  display: flex;
  font-size: 0.875rem;
  line-height: 1.4rem;
  padding: 0.375rem 0;
}
.user-contacts li .icon {
  color: #8094ae;
  font-size: 1rem;
  width: 1.75rem;
  line-height: inherit;
  display: inline-block;
}

.user-avatar-group {
  display: flex;
}
.user-avatar-group .user-avatar {
  border: 2px solid #fff;
}
.user-avatar-group .user-avatar:not(:first-child) {
  margin-left: -20%;
}
.user-avatar-group .user-avatar.sm:not(:first-child) {
  margin-left: -1rem;
}
.user-avatar-group .user-avatar.xs:not(:first-child) {
  margin-left: -0.5rem;
}

.user-info .lead-text, .user-info .sub-text {
  display: flex;
  align-items: center;
}
.user-info .edit {
  font-size: 1.25rem;
  color: #8094ae;
  margin-left: 0.5rem;
  display: inline-flex;
}
.user-info .edit:hover {
  color: #4461F2;
}

.user-plan {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0.75rem 0;
}
.user-plan-title {
  display: flex;
  align-items: center;
  color: #364a63;
  font-weight: 700;
  font-size: 1rem;
}
.user-plan-title .icon {
  font-size: 1.5rem;
  margin-right: 0.75rem;
  color: #4461F2;
}
.user-plan-info, .user-plan-actions {
  padding: 0.5rem 0;
}
.user-plan-status {
  font-size: 13px;
  font-weight: 500;
  color: #8094ae;
  text-transform: uppercase;
  margin-top: 0.5rem;
}
.user-plan-progress {
  width: 100%;
  margin-top: 1rem;
}

.data-list:not(:first-child) {
  margin-top: 1.5rem;
}
.data-item {
  position: relative;
  padding: 1rem 1.25rem;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.data-item .icon {
  color: #8094ae;
  text-align: center;
  height: 32px;
  vertical-align: middle;
  line-height: 32px;
  display: inline-block;
}
.data-item:not(:last-child) {
  border-bottom: 1px solid #e5e9f2;
}
.data-item:hover .data-label {
  color: #526484;
}
.data-item:hover .data-value, .data-item:hover .icon {
  color: #364a63;
}
.data-head {
  padding: 0.5rem 1.25rem;
  margin-bottom: 0.25rem;
  background-color: #ebeef2;
  border-radius: 4px;
}
.data-head.is-plain {
  margin-bottom: 0;
  background-color: transparent;
}
.data-head.is-plain:first-child {
  margin-top: 1rem;
}
.data-head .title {
  color: #526484;
}
.data-col {
  flex-grow: 1;
}
.data-col span:not(.data-more) {
  display: inline-block;
  transition: color 0.3s;
}
.data-col-end {
  flex-grow: 0;
  margin-left: auto;
}
.data-label {
  color: #8094ae;
  width: 100%;
  flex-shrink: 0;
}
.data-value {
  color: #526484;
  font-size: 0.9375rem;
}
.data-more {
  position: relative;
  z-index: 4;
  text-align: center;
  line-height: 28px;
  height: 28px;
  width: 28px;
  display: inline-grid;
  align-content: center;
}
.data-more:before {
  position: absolute;
  z-index: -1;
  height: 20px;
  width: 20px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transform-origin: 50% 50%;
  content: "";
  background-color: #e5e9f2;
  border-radius: 50%;
  opacity: 0;
  transition: all 0.3s;
}
.data-item:hover .data-more:before {
  opacity: 1;
  height: 40px;
  width: 40px;
}
.data-more .icon {
  height: auto;
}
.data-more.disable:before {
  display: none;
}

.data-list-s2:not(:first-child) {
  margin-top: 1rem;
}
.data-list-s2 .data-item, .data-list-s2 .data-head {
  padding-left: 0;
  padding-right: 0;
  background: transparent;
}
.data-list-s2 .data-head {
  border-bottom: 1px solid #dbdfea;
}
.data-list-s2 .data-item:not(:last-child) {
  border-bottom-color: #dbdfea;
}
.data-list-s2 .data-label {
  color: #526484;
}
.data-list-s2 .data-placeholder {
  color: #8094ae;
}

@media (min-width: 768px) {
  .data-list:not(:first-child) {
    margin-top: 2rem;
  }
  .data-list-s2:not(:first-child) {
    margin-top: 1.25rem;
  }
  .data-item {
    padding: 1.5rem 1.25rem;
  }
  .data-col {
    display: flex;
    align-items: center;
  }
  .data-col-end {
    width: 200px;
    text-align: right;
    justify-content: flex-end;
  }
  .data-label:not([class^=w-]) {
    width: 50%;
  }
}
@media (min-width: 1200px) and (max-width: 1359px) {
  .card-aside-wrap .data-list .data-col {
    flex-wrap: wrap;
  }
  .card-aside-wrap .data-list .data-label {
    width: 100%;
  }
}
.is-compact .data-item {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.is-medium .data-item {
  padding-top: 1.125rem;
  padding-bottom: 1.125rem;
}

.dropdown-menu .nk-notification {
  max-height: 239px;
  overflow: auto;
}
.nk-notification-item {
  display: flex;
  align-items: center;
  padding: 1.25rem 1.75rem;
}
.nk-notification-icon {
  flex-shrink: 0;
  margin-right: 0.75rem;
}
.nk-notification-text {
  font-size: 13px;
  color: #526484;
}
.nk-notification-text span {
  color: #364a63;
}
.nk-notification-time {
  font-size: 11px;
  color: #8094ae;
}

.dropdown-menu .nk-chat-list, .dropdown-menu .chat-list {
  max-height: 274px;
  overflow: auto;
}

.icon-light {
  color: #fff;
}
.icon-dark {
  color: #364a63;
}
.icon-text {
  display: flex;
  align-items: center;
  font-size: 13px;
}
.icon-text .icon {
  font-size: 1.5em;
  width: 1.75rem;
}
.icon-image {
  width: 70px;
}
.icon-image + h6 {
  margin-top: 1rem;
}
.icon-circle {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: #4461F2;
  color: #fff;
  font-size: 18px;
  height: 36px;
  width: 36px;
}
.icon-circle-sm, .icon-circle.sm {
  height: 20px;
  width: 20px;
  font-size: 12px;
}
.icon-circle-md, .icon-circle.md {
  height: 28px;
  width: 28px;
  font-size: 14px;
}
.icon-circle-lg, .icon-circle.lg {
  height: 44px;
  width: 44px;
  font-size: 24px;
}
.icon-circle-xxl, .icon-circle.xxl {
  height: 80px;
  width: 80px;
  font-size: 40px;
}
.icon-status {
  position: relative;
  display: inline-flex;
}
.icon-status:after {
  position: absolute;
  border-radius: 50%;
  right: 0;
  top: 1px;
  height: 10px;
  width: 10px;
  border: 2px solid #fff;
  content: "";
}
.icon-status-info:after {
  background: #09c2de;
}
.icon-status-danger:after {
  background: #e85347;
}
.icon-status-success:after {
  background: #1ee0ac;
}
.icon-status-warning:after {
  background: #f4bd0e;
}
.icon-status-on:after {
  background: #1ee0ac;
}
.icon-status-off:after {
  background: #8094ae;
}
.icon-status-na:after {
  display: none;
}
.icon-overlap {
  display: inline-flex;
  align-items: center;
  flex-direction: row-reverse;
  flex-shrink: 0;
}
.icon-overlap li {
  border-radius: 50%;
  border: 2px solid #fff;
}
.icon-overlap li + li {
  margin-right: -14px;
}
.icon-overlap-alt {
  display: inline-flex;
  align-items: flex-end;
  flex-shrink: 0;
}
.icon-overlap-alt li {
  border-radius: 50%;
}
.icon-overlap-alt li + li {
  margin-left: -16px;
  margin-bottom: -10px;
}

.icon-circle[class*=btc] {
  background: #f9841e;
}

.icon-circle[class*=facebook] {
  background: #3b5998;
}

.icon-circle[class*=google] {
  background: #de5246;
}

.icon-circle[class*=btc-dim] {
  background: #feefe2;
}

.icon-circle[class*=eth-dim] {
  background: #eaedf6;
}

.icon-circle[class*=white] {
  background: #fff;
}

.icon[class*=bg-blue-dim] {
  color: #559bfb;
}

.icon[class*=bg-azure-dim] {
  color: #1676fb;
}

.icon[class*=bg-indigo-dim] {
  color: #2c3782;
}

.icon[class*=bg-purple-dim] {
  color: #816bff;
}

.icon[class*=bg-pink-dim] {
  color: #ff63a5;
}

.icon[class*=bg-orange-dim] {
  color: #ffa353;
}

.icon[class*=bg-teal-dim] {
  color: #20c997;
}

.icon[class*=bg-primary-dim] {
  color: #4461F2;
}

.icon[class*=bg-secondary-dim] {
  color: #364a63;
}

.icon[class*=bg-success-dim] {
  color: #1ee0ac;
}

.icon[class*=bg-info-dim] {
  color: #09c2de;
}

.icon[class*=bg-warning-dim] {
  color: #f4bd0e;
}

.icon[class*=bg-danger-dim] {
  color: #e85347;
}

.icon[class*=bg-light] {
  color: #526484;
}

.icon[class*=bg-lighter] {
  color: #8094ae;
}

.icon[class*=bg-dark-dim] {
  color: #dde2ea;
}

.icon[class*=bg-gray-dim] {
  color: #e9f0f9;
}

.icon[class*=bg-facebook-dim] {
  color: #3b5998;
}

.icon[class*=bg-google-dim] {
  color: #de5246;
}

.icon[class*=bg-btc-dim] {
  color: #f9841e;
}

.icon[class*=bg-eth-dim] {
  color: #6174b9;
}

.icon[class*=bg-white] {
  color: #526484;
}

.icon-avatar {
  width: 1.5rem;
  height: 1.5rem;
  display: inline-block;
  text-align: center;
  line-height: 1.5rem;
  border-radius: 50%;
  background: #e7dcff;
  color: #9d72ff;
  margin-right: 0.5rem;
  font-size: 12px;
}
.icon-avatar-md {
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  font-size: 14px;
}

.tb-col-hide, .tb-col-xxl, .tb-col-xl, .tb-col-lg, .tb-col-md, .tb-col-sm, .tb-col-mb, .tb-col-xs {
  display: none !important;
}

@media (min-width: 420px) {
  .tb-col-mb {
    display: table-cell !important;
  }
}
@media (min-width: 576px) {
  .tb-col-sm {
    display: table-cell !important;
  }
}
@media (min-width: 768px) {
  .tb-col-md {
    display: table-cell !important;
  }
}
@media (min-width: 992px) {
  .tb-col-lg {
    display: table-cell !important;
  }
}
@media (min-width: 1200px) {
  .tb-col-xl {
    display: table-cell !important;
  }
}
@media (min-width: 1540px) {
  .tb-col-xxl {
    display: table-cell !important;
  }
}
@media (min-width: 359px) {
  .tb-col-xs {
    display: table-cell !important;
  }
}
@media (min-width: 414px) {
  .tb-col-mb {
    display: table-cell !important;
  }
}
.table-middle td, .tb-row-middle td {
  vertical-align: middle;
}

.tb-col-end, .tb-col-action {
  text-align: right;
}
.tb-col-middle {
  vertical-align: middle;
}
.tb-col-action .link-cross, .tb-col-action .link-done {
  font-size: 1rem;
  text-align: center;
  line-height: 28px;
  height: 24px;
  width: 24px;
  display: inline-block;
  color: #8094ae;
  vertical-align: middle;
  border-radius: 12px;
}
.tb-col-action .link-cross .icon, .tb-col-action .link-done .icon {
  padding-left: 1px;
}
.tb-col-action .link-cross:hover {
  color: #e85347;
  background: #fce7e5;
}
.tb-col-action .link-done:hover {
  color: #1ee0ac;
  background: #e0fbf3;
}

@media (max-width: 575.98px) {
  .table-ulogs th.tb-col-ip {
    display: none;
  }
  .table-ulogs tr {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    position: relative;
    padding: 0.5rem 1.25rem;
  }
  .table-ulogs tr:not(:first-child) {
    border-top: 1px solid #dbdfea;
  }
  .table-ulogs tr td {
    padding: 0;
    border: 0;
  }
  .table-ulogs tr td:first-child, .table-ulogs tr td:last-child {
    padding: 0;
  }
  .table-ulogs tr td, .table-ulogs tr th {
    flex-grow: 1;
  }
  .table-ulogs tr td.tb-col-os {
    width: 100%;
  }
  .table-ulogs tr th.tb-col-os {
    width: 40%;
    min-width: 142px;
    flex-grow: 0;
  }
  .table-ulogs tr td.tb-col-ip {
    width: 40%;
    min-width: 130px;
    flex-grow: 0;
  }
  .table-ulogs tr .tb-col-action {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    padding: 0;
  }
  .table-ulogs thead tr {
    padding: 0;
  }
}
.toggle-content {
  opacity: 0;
  visibility: hidden;
  position: absolute;
  top: calc(100% + 10px);
  z-index: 9;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 3px 12px 1px rgba(43, 55, 72, 0.15);
  transform: translateY(10px);
}
.toggle-content-right {
  left: auto;
  right: 0;
}
.toggle-content-bottom {
  top: auto;
  bottom: 0;
}
.toggle-content.content-active {
  transition: all 0.2s ease;
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
.toggle-slide {
  position: fixed;
  top: 0;
  z-index: 1021;
  min-width: 260px;
  max-width: calc(100% - 40px);
  transition: transform 650ms ease;
}
.toggle-slide-left {
  left: 0;
  transform: translateX(-100%);
}
.toggle-slide-right {
  right: 0;
  transform: translateX(100%);
}
.toggle-slide.content-active {
  transform: translate(0) !important;
}
.toggle-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(31, 43, 58, 0.2);
  z-index: 1020;
  animation: overlay-fade-in 0.4s ease 1;
}

.toggle-expand-content {
  display: none;
}
.toggle-expand-content.expanded {
  display: block;
}

.toggle-expand .inactive-text, .toggle-opt .inactive-text {
  display: block;
}
.toggle-expand.active > .inactive-text, .toggle-opt.active > .inactive-text {
  display: none;
}

.toggle-expand .active-text, .toggle-opt .active-text {
  display: none;
}
.toggle-expand.active > .active-text, .toggle-opt.active > .active-text {
  display: block;
}

body.toggle-shown {
  overflow: hidden;
}

@media (min-width: 576px) {
  .nk-block-tools-toggle .toggle-expand {
    display: none;
  }
  .nk-block-tools-toggle .toggle-expand-content {
    display: block !important;
  }
}
@media (max-width: 575.98px) {
  .nk-block-tools-toggle .toggle-expand-content {
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    z-index: 99;
    width: 100vw;
    padding: 0 18px !important;
    background: #fff;
    margin-left: -18px;
    margin-right: -18px;
    box-shadow: 0 20px 35px rgba(0, 0, 0, 0.2);
  }
  .nk-block-tools-toggle .nk-block-tools {
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .nk-block-tools-toggle .nk-block-tools-opt {
    margin-left: auto;
  }
}
@media (max-width: 575.98px) {
  .card-tools-toggle .card-title-group {
    position: static;
  }
  .card-tools-toggle .toggle-wrap .toggle-content {
    padding: 1.25rem 1rem;
    transform: translate(0);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .card-tools-toggle .toggle-wrap .toggle-close {
    margin-right: auto;
  }
  .card-tools-toggle .toggle-wrap .toggle-close .btn-trigger:before {
    opacity: 0;
  }
  .card-tools-toggle .toggle-wrap .toggle-close .btn-trigger:hover:before {
    opacity: 1;
  }
}
@media (min-width: 576px) {
  .card-tools-toggle {
    z-index: 9;
  }
  .card-tools-toggle .toggle-wrap .toggle {
    display: none;
  }
  .card-tools-toggle .toggle-wrap .toggle-content {
    z-index: 9;
    opacity: 1;
    visibility: visible;
    position: static;
    background: transparent;
    box-shadow: none;
    transform: translate(0);
  }
  .card-tools-toggle .toggle-wrap .toggle-close {
    display: none;
  }
}
@media (min-width: 420px) {
  .toggle-break-mb {
    transition: none;
    opacity: 1;
    visibility: visible;
    transform: translateY(0) !important;
    position: static;
    background: transparent;
    box-shadow: none;
    z-index: 1 !important;
  }
  .toggle-break-mb.collapse {
    display: block;
  }
}
@media (min-width: 576px) {
  .toggle-break-sm {
    transition: none;
    opacity: 1;
    visibility: visible;
    transform: translateY(0) !important;
    position: static;
    background: transparent;
    box-shadow: none;
    z-index: 1 !important;
  }
  .toggle-break-sm.collapse {
    display: block;
  }
}
@media (min-width: 768px) {
  .toggle-break-md {
    transition: none;
    opacity: 1;
    visibility: visible;
    transform: translateY(0) !important;
    position: static;
    background: transparent;
    box-shadow: none;
    z-index: 1 !important;
  }
  .toggle-break-md.collapse {
    display: block;
  }
}
@media (min-width: 992px) {
  .toggle-break-lg {
    transition: none;
    opacity: 1;
    visibility: visible;
    transform: translateY(0) !important;
    position: static;
    background: transparent;
    box-shadow: none;
    z-index: 1 !important;
  }
  .toggle-break-lg.collapse {
    display: block;
  }
}
@media (min-width: 1200px) {
  .toggle-break-xl {
    transition: none;
    opacity: 1;
    visibility: visible;
    transform: translateY(0) !important;
    position: static;
    background: transparent;
    box-shadow: none;
    z-index: 1 !important;
  }
  .toggle-break-xl.collapse {
    display: block;
  }
}
@media (min-width: 1540px) {
  .toggle-break-xxl {
    transition: none;
    opacity: 1;
    visibility: visible;
    transform: translateY(0) !important;
    position: static;
    background: transparent;
    box-shadow: none;
    z-index: 1 !important;
  }
  .toggle-break-xxl.collapse {
    display: block;
  }
}
.nav-switch {
  display: inline-flex;
  margin-bottom: 1.5rem;
  border: 1px solid #dbdfea;
  border-radius: 30px;
  padding: 5px;
}
.nav-switch .nav-link {
  padding: 5px 16px;
  line-height: 20px;
  border-radius: 20px;
  position: static;
  text-transform: uppercase;
  font-family: "DM Sans", sans-serif;
  font-weight: 700;
  font-size: 12px;
  color: #8094ae;
}
.nav-switch .nav-link.active {
  background: #4461F2;
  color: #fff;
}
.nav-switch .nav-link:after {
  display: none;
}
.nav-switch .nav-item {
  padding: 0;
  margin: 0 1px;
}
.nav-switch .nav-item:last-child {
  margin-right: 0;
}
.nav-switch .nav-item:first-child {
  margin-left: 0;
}

@media (min-width: 576px) {
  .nav-switch {
    margin-bottom: 2.5rem;
  }
}
.nav-switch-s2 {
  display: inline-flex;
  border-radius: 4px;
  border: none;
}
.nav-switch-s2 .nav-link {
  padding: 0.25rem 0.7rem;
  line-height: 20px;
  border-radius: 0;
  position: static;
  text-transform: uppercase;
  font-family: "DM Sans", sans-serif;
  font-weight: 700;
  font-size: 12px;
  color: #8094ae;
  border: 1px solid #dbdfea;
}
.nav-switch-s2 .nav-link:hover, .nav-switch-s2 .nav-link:focus {
  color: #526484;
  background: #f5f6fa;
  border: 1px solid #dbdfea;
}
.nav-switch-s2 .nav-link.active {
  color: #364a63;
  border: 1px solid #dbdfea;
  background: #f5f6fa;
  box-shadow: inset 0 0 4px -1px rgba(128, 148, 174, 0.25);
}
.nav-switch-s2 .nav-link:after {
  display: none;
}
.nav-switch-s2 .nav-item {
  padding: 0;
  margin: 0;
}
.nav-switch-s2 .nav-item:last-child {
  margin-right: 0;
}
.nav-switch-s2 .nav-item:last-child .nav-link {
  border-radius: 0 4px 4px 0;
}
.nav-switch-s2 .nav-item:first-child {
  margin-left: 0;
}
.nav-switch-s2 .nav-item:first-child .nav-link {
  border-radius: 4px 0 0 4px;
}
.nav-switch-s2 .nav-item:not(:first-child) {
  margin-left: -1px;
}

.widget-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}
.widget-title > * {
  margin-bottom: 0;
}
.text-center .widget-title {
  justify-content: center;
}
.is-theme .widget-title a:hover {
  color: #fff;
}

.side-wg:not(:last-child) {
  margin-bottom: 2.5rem;
}
.side-wg-title {
  padding-bottom: 0.75rem;
}
.side-wg .back-to {
  font-size: 0.875rem;
  line-height: 1.1;
  font-weight: 400;
  position: relative;
  color: #8094ae;
  display: inline-flex;
  align-items: center;
}
.side-wg .back-to .icon {
  font-size: 1.25rem;
  width: 1.75rem;
  margin-top: -3px;
  display: inline-block;
}

.nk-ck {
  height: 260px;
}
.nk-ck-sm {
  height: 180px;
}

.nk-ck1 {
  height: 120px;
}

.nk-ck2 {
  height: 240px;
}

.nk-ck3 {
  height: 160px;
}

.nk-cktv {
  height: 300px;
  overflow: hidden;
  border: 1px solid #dbdfea;
  border-radius: 4px;
}
.nk-cktv .tradingview-widget-container {
  overflow: hidden;
  position: relative;
  top: 8px;
}
.nk-cktv .tradingview-widget-container > div {
  margin: -1px;
}

@media (min-width: 576px) {
  .nk-ck {
    height: 260px;
  }
  .nk-ck-sm {
    height: 180px;
  }
  .nk-ck1 {
    height: 120px;
  }
  .nk-ck2 {
    height: 240px;
  }
  .nk-ck3 {
    height: 258px;
  }
}
.nk-wg6-title:not(:first-child) {
  margin-top: 1.5rem;
}
.nk-wg6-title:not(:last-child) {
  margin-bottom: 1.5rem;
}
.nk-wg6-text:not(:last-child) {
  margin-bottom: 1.5rem;
}

.aside-wg + .aside-wg {
  padding-top: 2rem;
}

.nk-modal-title:not(:first-child) {
  margin-top: 1.5rem;
}
.nk-modal-title:not(:last-child) {
  margin-bottom: 1.5rem;
}
.nk-modal-title.title {
  font-size: 1.5rem;
}
.nk-modal-text:not(:last-child) {
  margin-bottom: 1.5rem;
}
.nk-modal-text .lead {
  font-size: 1.1rem;
  line-height: 1.5;
}
.nk-modal-text .sub-text {
  font-size: 14px;
}
.nk-modal-action {
  margin-top: 1.5rem;
}
.nk-modal-action-sm {
  margin-top: 1rem;
}
.nk-modal-action-md {
  margin-top: 2rem;
}
.nk-modal-action-lg {
  margin-top: 2.25rem;
}

.modal-body-lg .tab-content {
  margin-top: 2rem;
}

@media (min-width: 576px) {
  .nk-modal-action-md {
    margin-top: 2.5rem;
  }
  .nk-modal-action-lg {
    margin-top: 3.25rem;
  }
}
[data-toggle=modal] {
  cursor: pointer;
}

.search-wrap {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0;
  background: #fff;
  transition: opacity 0.4s;
  border-radius: 6px;
  pointer-events: none;
  display: flex;
  align-items: center;
}
.search-wrap.active {
  opacity: 1;
  z-index: 9;
  pointer-events: auto;
}
.search-wrap-extend {
  margin-top: -1rem;
  left: -2px;
  right: -2px;
}
.search-toggle {
  transition: all 0.4s;
  opacity: 1;
}
.search-toggle.active {
  opacity: 0;
}
.search-content {
  position: relative;
  width: 100%;
}
.search-content .form-control, .search-content div.dataTables_wrapper div.dataTables_filter input, div.dataTables_wrapper div.dataTables_filter .search-content input, .search-content .dual-listbox .dual-listbox__search, .dual-listbox .search-content .dual-listbox__search, .search-content .rdl-filter {
  padding-left: calc(2.125rem + 2px);
  padding-right: calc(2.125rem + 2px);
}
.search-content .form-control-sm {
  padding-left: calc(1.75rem + 2px);
  padding-right: calc(1.75rem + 2px);
}
.search-back, .search-submit {
  position: absolute;
  top: 50%;
}
.search-back:focus, .search-submit:focus {
  box-shadow: none;
}
.search-back {
  left: 0;
  transform: translate(-0.25rem, -50%);
}
.search-submit {
  right: 0;
  transform: translate(0.5rem, -50%);
}
.search-submit:hover {
  color: #4461F2;
}

.nk-search-box {
  margin-top: 1.5rem;
  margin-bottom: 1.25rem;
}
.nk-search-box .form-icon {
  height: 100%;
  border: none;
  background: transparent;
  width: 3.5rem;
}
.nk-search-box .form-control, .nk-search-box div.dataTables_wrapper div.dataTables_filter input, div.dataTables_wrapper div.dataTables_filter .nk-search-box input, .nk-search-box .dual-listbox .dual-listbox__search, .dual-listbox .nk-search-box .dual-listbox__search, .nk-search-box .rdl-filter {
  border-radius: 1.5rem;
  padding-left: 1.25rem;
  padding-right: 1.5rem;
}

.nk-block + .nk-block, .nk-block + .nk-block-head {
  padding-top: 28px;
}
.nk-block + .nk-block-lg, .nk-block + .nk-block-head-lg {
  padding-top: 2.5rem;
}
.nav-tabs + .nk-block {
  padding-top: 1.5rem;
}
.nav-tabs + .nk-block-sm {
  padding-top: 1rem;
}
.nk-block-area {
  display: flex;
}
.nk-block-area-column {
  flex-direction: column;
}
.nk-block-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.nk-block-between > .title:first-child {
  margin-bottom: 0;
}
.nk-block-middle {
  margin-top: auto;
  margin-bottom: auto;
}
.nk-block-head {
  position: relative;
  padding-bottom: 1.25rem;
}
.nk-block-head:only-child {
  padding-bottom: 0;
}
.nk-block-head h2:not(:last-child) {
  margin-bottom: 1rem;
}
.nk-block-head-sub {
  font-size: 1rem;
  line-height: 1.5rem;
  margin-bottom: 0.5rem;
  color: #8094ae;
  font-weight: 400;
  position: relative;
}
.nk-block-head-sub .back-to {
  color: inherit;
  display: inline-flex;
  align-items: center;
}
.nk-block-head-sub .back-to .icon {
  font-size: 1.5rem;
  width: 2rem;
  margin-top: -3px;
  display: inline-block;
}
.nk-block-head-sub .dropdown {
  position: absolute;
  right: -8px;
  top: -6px;
}
.nk-block-head-xs {
  padding-bottom: 0.75rem;
}
.nk-block-head-sm {
  padding-bottom: 1rem;
}
.nk-block-head-lg {
  padding-bottom: 1.5rem;
}
.nk-block-head + .nav-tabs {
  margin-top: -1rem;
}
.nk-content-body > .nk-block-head:first-child {
  padding-bottom: 1.75rem;
}
.nk-block-head .nk-block-text {
  margin-top: 1.5rem;
}
.nk-block-head .nk-block-text + .btn, .nk-block-head .dual-listbox .nk-block-text + .dual-listbox__button, .dual-listbox .nk-block-head .nk-block-text + .dual-listbox__button {
  margin-top: 1.5rem;
}
.nk-block-tools {
  display: flex;
  align-items: center;
}
.nk-block-tools > * {
  display: inline-flex;
}
.nk-block-des {
  color: #526484;
}
.nk-block-des strong {
  color: #364a63;
}
.nk-block-des .icon {
  vertical-align: middle;
}
.nk-block-content + .nk-block-head {
  padding-top: 2rem;
}
.nk-block-content + .nk-block-head-sm {
  padding-top: 1.5rem;
}
.nk-block-content-head:not(:last-child) {
  margin-bottom: 1rem;
}
.nk-block-title-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.nk-block-title-group .title {
  margin-bottom: 0;
}
.nk-block-title-group:not(:last-child) {
  margin-bottom: 0.5rem;
}

@media (min-width: 576px) {
  .nk-block-head-lg {
    padding-bottom: 2.5rem;
  }
  .nk-block-content + .nk-block-head {
    padding-top: 4rem;
  }
  .nk-block-content + .nk-block-head-sm {
    padding-top: 2.5rem;
  }
}
@media (min-width: 768px) {
  .nk-content-body > .nk-block-head:first-child {
    padding-bottom: 2.5rem;
  }
  .nk-content-body > .nk-block-head-sm:first-child {
    padding-bottom: 1.75rem;
  }
  .nav-tabs + .nk-block {
    padding-top: 2.5rem;
  }
  .nav-tabs + .nk-block-sm {
    padding-top: 2rem;
  }
  .nav-tabs + .nk-block-xs {
    padding-top: 1.25rem;
  }
  .nk-block-text h5, .nk-block-text h6 {
    font-size: 1rem;
  }
}
@media (max-width: 767.98px) {
  .nk-block-tools .opt-menu-md {
    order: 100;
    margin-left: auto;
  }
}
@media (min-width: 768px) {
  .nk-block-between-md {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
.nk-block-subhead {
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #dbdfea;
}

.nk-feature-center {
  text-align: center;
}

.filter-wg label.overline-title {
  margin-bottom: 0.5rem;
}

.change {
  line-height: 1;
}
.change .sign {
  font-family: "Nioicon";
}
.change .sign:before {
  content: "";
}
.change.up {
  color: #1ee0ac !important;
}
.change.up .sign:before {
  content: "\\e93c";
}
.change.down {
  color: #e85347 !important;
}
.change.down .sign:before {
  content: "\\e939";
}

.nk-knob > div {
  position: relative;
  display: inline-block !important;
}

.knob {
  height: 100% !important;
  margin-top: 0 !important;
  font-size: 1.5rem !important;
}

.knob-half {
  height: 50% !important;
  font-size: 1.25rem !important;
}

[class*=knob] {
  text-align: center;
  pointer-events: none;
  width: 100% !important;
  font-weight: 400 !important;
  font-family: "DM Sans", sans-serif !important;
  color: #364a63 !important;
  margin-left: 0 !important;
  left: 0;
  border: none;
}
[class*=knob]:focus {
  outline: none;
}

.stats {
  padding: 0 0 1rem;
}

@media (min-width: 1540px) {
  .nk-content-sidebar .stats {
    padding: 1.25rem 1.5rem 1rem;
  }
}
.collapse-shown {
  display: inline-block !important;
}
.collapsed .collapse-shown {
  display: none !important;
}
.collapse-hidden {
  display: none !important;
}
.collapsed .collapse-hidden {
  display: inline-block !important;
}

.clipboard-init {
  cursor: pointer;
}
.clipboard-success .clipboard-init {
  color: #1bca9b;
}
.clipboard-text {
  font-size: 12px;
}
.clipboard-success .form-control:focus, .clipboard-success div.dataTables_wrapper div.dataTables_filter input:focus, div.dataTables_wrapper div.dataTables_filter .clipboard-success input:focus, .clipboard-success .dual-listbox .dual-listbox__search:focus, .dual-listbox .clipboard-success .dual-listbox__search:focus, .clipboard-success .rdl-filter:focus {
  border-color: #dbdfea;
  box-shadow: inset 0 1px 1px rgba(16, 25, 36, 0.075);
}

.nk-news-item {
  display: flex;
  align-items: center;
}
.nk-news-icon {
  width: 2rem;
  display: inline-flex;
  flex-shrink: 0;
}
.nk-news-icon .icon {
  font-size: 24px;
  color: #4461F2;
}
.is-theme .nk-news-icon .icon {
  color: #5c75f4;
}
.nk-news-icon img {
  width: 24px;
}
.nk-news-text {
  display: flex;
  align-items: center;
  max-width: calc(100% - 1.5rem);
}
.nk-news-text p {
  font-size: 13px;
  margin-bottom: 0;
  color: #526484;
  font-weight: 500;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: calc(100% - 2rem);
}
.nk-news-text p span {
  color: #8094ae;
  font-weight: 400;
}
.is-dark .nk-news-text p {
  color: #90a1b8;
}
.is-dark .nk-news-text p span {
  color: rgba(128, 148, 174, 0.9);
}
.is-theme .nk-news-text p {
  color: #e6dcff;
}
.is-theme .nk-news-text p span {
  color: rgba(212, 194, 255, 0.8);
}
.nk-news-text .icon {
  color: #8094ae;
  margin-left: 0.25rem;
}
.is-dark .nk-news-text .icon {
  color: #8094ae;
}
.is-theme .nk-news-text .icon {
  color: #d4c2ff;
}
.nk-news-item:hover .nk-news-text .icon {
  color: #4461F2;
}

.language-list li:not(:last-child) .language-item {
  border-bottom: 1px solid #ecf2ff;
}
.language-item {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  color: #344357;
  transition: all 0.4s;
}
.language-item:hover {
  color: #3c4d62;
  background: #ebeef2;
}
.language-name {
  font-size: 12px;
}
.language-flag {
  width: 24px;
  margin-right: 12px;
}

.entry img, .entry .video, .entry .image-group {
  border-radius: 4px;
}
.entry img + p, .entry img + h2, .entry img + h3, .entry img + h4, .entry img + h5, .entry img + h6, .entry img + ul, .entry img + ol, .entry .video + p, .entry .video + h2, .entry .video + h3, .entry .video + h4, .entry .video + h5, .entry .video + h6, .entry .video + ul, .entry .video + ol, .entry .image-group + p, .entry .image-group + h2, .entry .image-group + h3, .entry .image-group + h4, .entry .image-group + h5, .entry .image-group + h6, .entry .image-group + ul, .entry .image-group + ol {
  margin-top: 2rem;
}
.entry p + img {
  margin-top: 1rem;
}
.entry p + h2, .entry p + h3, .entry p + h4, .entry p + h5, .entry p + h6, .entry p + .video, .entry p + .image-group {
  padding-top: 0.75rem;
}

p > span > .icon.ni {
  vertical-align: middle;
}

.btn-trigger + .dropdown-menu-right, .btn-trigger + .dropdown-menu-left {
  margin: -0.75rem 0;
}

.btn-trigger + .dropdown-menu-right {
  margin-right: 16px;
}

.btn-trigger + .dropdown-menu-left {
  margin-left: 16px;
}

@media (max-width: 420px) {
  .btn-trigger + .dropdown-menu-xl, .btn-trigger + .dropdown-menu-lg, .btn-trigger + .dropdown-menu-md {
    margin-left: 16px;
    margin-top: 0.25rem;
  }
}
.bq-note-item:not(:first-child) {
  margin-top: 1.75rem;
}
.bq-note-text {
  padding: 1rem 1.25rem;
  background: #f5f6fa;
  border-radius: 4px;
}
.bq-note-meta {
  font-size: 12px;
  color: #8094ae;
  margin-top: 0.75rem;
}
.bq-note-meta span > span {
  color: #526484;
}
.bq-note-meta .link {
  margin-left: 0.75rem;
}
.bq-note-sep {
  height: 0.25rem;
  display: block;
  visibility: hidden;
  padding: 0 0.25rem;
}
.bq-note-by {
  display: inline-block;
}

@media (min-width: 576px) {
  .bq-note-text {
    padding: 1.25rem 1.5rem;
  }
  .bq-note-sep {
    height: auto;
    display: inline-block;
    visibility: visible;
  }
}
@media (min-width: 1200px) and (max-width: 1359px) {
  .form-settings .col-lg-5, .form-settings .col-lg-7 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
.embed-responsive {
  border-radius: 4px;
}

.video {
  position: relative;
  overflow: hidden;
  border-radius: 4px;
}
.video:before {
  position: absolute;
  content: "";
  bottom: 0;
  right: 0;
  left: 0;
  height: 120px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0));
}
.video-play {
  display: flex;
  align-items: center;
  position: absolute;
  left: 2rem;
  bottom: 2rem;
  color: #fff;
  font-size: 1.25rem;
}
.video-play:hover {
  color: #fff;
}
.video-play .icon {
  font-size: 2rem;
}

.nk-slider {
  position: relative;
}
.nk-slider-s1 {
  width: 290px;
  max-width: 100%;
}
.nk-slider-s1 .slick-dots {
  position: absolute;
  right: 1.25rem;
  top: 1.5rem;
  padding-top: 0;
}
.nk-slider-s2 .slider-arrows > div {
  padding: 0.5rem 0;
}

.project-head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.25rem;
  align-items: flex-start;
}
.project-title {
  display: flex;
  align-items: center;
  margin-right: 0.75rem;
}
.project-title .user-avatar {
  margin-right: 1rem;
}
.project-title .title {
  font-size: 0.975rem;
}
.project-title .title:not(:last-child) {
  margin-bottom: 0.125rem;
}
.project-details {
  margin-bottom: 1rem;
}
.project-progress {
  margin-bottom: 1rem;
}
.project-progress-details {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}
.project-progress-task {
  display: flex;
  align-items: center;
  color: #8094ae;
}
.project-progress-task .icon {
  font-size: 1rem;
  line-height: 1.5rem;
  margin-right: 0.25rem;
}
.project-progress-percent {
  color: #526484;
  font-weight: 500;
}
.project-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.project-users {
  display: flex;
  align-items: center;
}
.project-list-progress {
  display: flex;
  align-items: center;
}
.project-list-progress .progress {
  width: 100px;
  margin-right: 0.5rem;
}

@media (min-width: 1540px) {
  .project-list-progress .progress {
    width: 140px;
    margin-right: 1rem;
  }
}
.team {
  position: relative;
}
.team-info {
  padding: 1rem 0 1.25rem;
}
.team-info li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.9375rem;
  line-height: 1.75rem;
}
.team-info li span:first-child {
  color: #8094ae;
}
.team-info li span:last-child {
  color: #526484;
}
.team-status {
  position: absolute;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 20px;
  border-radius: 50%;
}
.team-options {
  position: absolute;
  top: -0.25rem;
  right: -0.25rem;
}
.team-details {
  padding-top: 0.5rem;
  text-align: center;
  max-width: 200px;
  margin: 0 auto;
}
.team-statistics {
  display: flex;
  justify-content: space-around;
  text-align: center;
  padding: 1rem 0 1.5rem;
}
.team-statistics li span {
  display: block;
}
.team-statistics li span:first-child {
  font-size: 1.125rem;
  color: #1c2b46;
}
.team-statistics li span:last-child {
  font-size: 0.875rem;
  color: #8094ae;
}
.team-view {
  display: flex;
  justify-content: center;
  padding-bottom: 0.25rem;
}

/** 06. PAGES */
.nk-auth-body {
  padding: 1.25rem;
}
.nk-auth-footer {
  padding-bottom: 40px;
}
.nk-auth-body, .nk-auth-footer {
  width: 100%;
  max-width: 420px;
  margin-left: auto;
  margin-right: auto;
}
.nk-auth-footer {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.nk-auth-footer-full {
  margin-top: 0;
}

@media (min-width: 992px) {
  .nk-auth-container {
    width: 45%;
  }
}
@media (min-width: 1540px) {
  .nk-split .nk-auth-body, .nk-split .nk-auth-footer {
    margin-right: 90px;
  }
}
.nk-error-ld {
  padding: 2rem 1rem;
}
.nk-error-gfx {
  padding-bottom: 30px;
  max-width: 90%;
}
.nk-error-head {
  font-size: 160px;
  font-weight: 700;
  background: -webkit-linear-gradient(#4461F2, #3a2272);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  opacity: 0.9;
}
.nk-error-title {
  padding-bottom: 1rem;
}
.nk-error-text {
  font-size: 1rem;
}

@media (min-width: 576px) {
  .nk-error-lead {
    font-size: 200px;
  }
  .nk-error-gfx {
    padding-bottom: 60px;
    max-width: 520px;
  }
}
.clipboard-success-message {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1ee0ac;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s;
}
.clipboard-success .clipboard-success-message {
  opacity: 1;
}

/** 07. MISC */
.has-shadow.bg-lighter .card, .rdl-control > option.has-shadow:hover .card, .has-shadow.bg-lighter .sp-pdl-item, .rdl-control > option.has-shadow:hover .sp-pdl-item, .has-shadow.bg-lighter .invoice-wrap, .rdl-control > option.has-shadow:hover .invoice-wrap, .has-shadow.bg-lighter .accordion, .rdl-control > option.has-shadow:hover .accordion {
  box-shadow: 0 0 8px -3px rgba(60, 77, 98, 0.15);
}
.has-shadow .card, .has-shadow .sp-pdl-item, .has-shadow .invoice-wrap, .has-shadow .accordion {
  box-shadow: 0 0 6px -2px rgba(60, 77, 98, 0.2);
}
.has-shadow .data-head, .has-shadow .data-item {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.has-shadow .card .data-head:not(.is-plain) {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
  padding-left: 0.75rem;
}
.has-shadow .nav-tabs {
  box-shadow: 0 2px 0 -1px rgba(60, 77, 98, 0.06);
}
.has-shadow .nk-header {
  box-shadow: 0 3px 0 -1px rgba(60, 77, 98, 0.04);
}

.nio-version {
  text-transform: uppercase;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.02em;
  position: absolute;
  right: -1px;
  bottom: -3px;
}

.code-tag {
  color: #816bff;
}
.code-class {
  color: #ff63a5;
}
.code-fnc {
  color: #09c2de;
}

.nk-switch-icon {
  color: #90a1b8;
  height: 1.5rem;
  width: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.nk-switch-icon .icon {
  font-size: 1.5rem;
}
.nk-switch-icon .icon-sm {
  font-size: 1.25rem;
}
.nk-switch-icon:hover {
  color: #526484;
}
.nk-switch-icon.active {
  color: #4461F2;
}

.dark-switch {
  position: relative;
}
.dark-switch:before, .dark-switch:after {
  position: absolute;
  content: "";
  transform: translateY(-50%);
  border-radius: 1.5rem;
  display: block;
  top: 50%;
}
.dark-switch:before {
  right: 0;
  width: 3rem;
  height: 1.5rem;
  background-color: #fff;
  border: #dbdfea solid 2px;
}
.dark-switch:after {
  height: 1rem;
  width: 1rem;
  right: calc(2rem - 2px - .125rem);
  background-color: #dbdfea;
}
.dark-switch.active:before {
  background-color: #4461F2;
  border-color: #4461F2;
}
.dark-switch.active:after {
  right: calc(2px + .125rem);
  background-color: #fff;
}

.is-scrollable {
  overflow: auto;
}

.profile-ud-label {
  display: block;
  color: #8094ae;
}
.plain .profile-ud-label {
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.1em;
}
.wider .profile-ud-label {
  display: inline-flex;
  letter-spacing: -0.01em;
  width: 120px;
  flex-shrink: 0;
}
.profile-ud-value {
  color: #526484;
}
.wider .profile-ud-value {
  text-align: right;
  font-weight: 500;
  width: 100%;
}
.profile-ud.wider {
  display: flex;
  padding: 0.5rem 0;
}
.profile-ud-item:nth-child(n+2) .profile-ud.plain {
  margin-top: 1.25rem;
}

@media (min-width: 768px) {
  .profile-ud.wider {
    padding: 0.75rem 0;
  }
  .profile-ud-list {
    display: flex;
    flex-wrap: wrap;
    margin: -0.25rem -3.25rem;
    max-width: 960px;
  }
  .profile-ud-item {
    width: 50%;
    padding: 0 3.25rem;
  }
  .profile-ud-item:nth-child(2) .profile-ud.plain {
    margin-top: 0;
  }
}
.profile-stats .amount {
  font-size: 1.125rem;
  font-weight: 700;
}

.profile-balance-group {
  display: flex;
  align-items: flex-end;
}
.profile-balance-ck {
  position: relative;
  height: 70px;
  margin-top: 0.5rem;
}
.profile-balance-sub {
  font-size: 0.875rem;
  color: #8094ae;
}
.profile-balance-subtitle {
  font-size: 0.75rem;
  margin-top: 0.5rem;
}
.profile-balance-sub .icon {
  font-size: 0.75rem;
}
.profile-balance-plus {
  position: absolute;
}
.profile-balance-plus .icon {
  font-size: 1rem;
  line-height: 1.5rem;
}
.profile-balance-plus ~ * {
  padding-left: 24px;
}
.profile-balance-amount .number {
  font-size: 1.25rem;
  font-weight: 700;
  color: #364a63;
  line-height: 1.5rem;
  white-space: nowrap;
}
.profile-balance-amount .number small {
  font-weight: 400;
}

.steps ul {
  display: flex;
}
.steps ul li {
  flex-grow: 1;
}
.steps .current-info {
  display: none;
}

.actions ul {
  display: flex;
  margin: -10px;
  padding-top: 20px;
}
.actions ul li {
  padding: 10px;
}
.actions ul li:first-child {
  order: 1;
}
.actions ul li a {
  display: inline-block;
  position: relative;
  color: #fff;
  font-weight: 500;
  transition: all 0.4s ease;
  border-color: #4461F2;
  background: #4461F2;
  padding: 0.4375rem 1.125rem;
  font-size: 0.8125rem;
  line-height: 1.25rem;
  border-radius: 4px;
}
.actions ul li.disabled {
  display: none;
}

.nk-wizard-head {
  display: none;
}
.nk-wizard-simple .steps {
  margin-bottom: 20px;
}
.nk-wizard-simple .steps ul li {
  position: relative;
  padding-bottom: 5px;
  padding-right: 1rem;
  margin-bottom: 0.5rem;
}
.nk-wizard-simple .steps ul li h5 {
  border: none;
  padding: 0 0 6px 0;
  letter-spacing: 0.02em;
  font-size: 13px;
  text-transform: uppercase;
  font-weight: 500;
  color: #8094ae;
}
.nk-wizard-simple .steps ul li .number {
  font-size: 13px;
  color: #8094ae;
  font-weight: 700;
}
.nk-wizard-simple .steps ul li:after {
  position: absolute;
  height: 1px;
  width: 100%;
  left: 0;
  bottom: 0;
  content: "";
  transition: all 0.4s;
  background: #e5e9f2;
}
.nk-wizard-simple .steps ul li.done:after, .nk-wizard-simple .steps ul li.current:after {
  height: 2px;
  background: #4461F2;
  width: 100%;
}
.nk-wizard-simple .steps ul li.done h5, .nk-wizard-simple .steps ul li.done .number, .nk-wizard-simple .steps ul li.current h5, .nk-wizard-simple .steps ul li.current .number {
  color: #4461F2;
}
.nk-wizard-simple .steps ul li.current ~ .done:after {
  height: 1px;
  background: #e5e9f2;
}
.nk-wizard-simple .steps ul li.current ~ .done h5, .nk-wizard-simple .steps ul li.current ~ .done .number {
  color: #8094ae;
}
.nk-wizard-simple .steps .current-info {
  display: none;
}
.nk-wizard.is-vertical .steps ul {
  flex-wrap: wrap;
}
.nk-wizard.is-vertical .steps ul li h5 {
  text-transform: none;
}

@media (min-width: 768px) {
  .nk-wizard.is-vertical {
    display: flex;
    flex-wrap: wrap;
  }
  .nk-wizard.is-vertical .steps {
    width: 33%;
    padding-right: 2rem;
  }
  .nk-wizard.is-vertical .steps ul li {
    width: 100%;
  }
  .nk-wizard.is-vertical .steps ul li:not(:last-child) {
    margin-bottom: 1rem;
  }
  .nk-wizard.is-vertical .content {
    width: 66%;
  }
}
.tb-tnx-head {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  background: #f5f6fa;
}
.tb-tnx-head td, .tb-tnx-head th {
  color: #8094ae;
  padding: 0.625rem 0.25rem;
}
.tb-tnx-head th {
  border-radius: 0;
}
.tb-tnx-head th:first-child {
  border-top-left-radius: 4px;
}
.tb-tnx-head th:last-child {
  border-top-right-radius: 4px;
}
.tb-tnx-item {
  font-size: 14px;
}
.tb-tnx-item td {
  padding: 1.25rem 0.25rem;
  vertical-align: middle;
}
.is-compact .tb-tnx-item td {
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
}
.tb-tnx-id a {
  display: block;
}
.tb-tnx-id span {
  font-weight: 500;
}
.tb-tnx-item .tb-tnx-total {
  font-weight: 500;
  color: #526484;
}
.tb-tnx-desc {
  padding-right: 0.5rem;
}
.tb-tnx-item .tb-tnx-date {
  color: #8094ae;
}
.tb-tnx-item .tb-tnx-date .date {
  font-size: 13px;
}
.tb-tnx-action {
  width: 60px;
  text-align: right;
}
.tb-tnx-action .dropdown {
  margin-top: -0.25rem;
  margin-bottom: -0.25rem;
}
.tb-tnx-btns .btn + .btn, .tb-tnx-btns .dual-listbox .dual-listbox__button + .btn, .dual-listbox .tb-tnx-btns .dual-listbox__button + .btn, .tb-tnx-btns .dual-listbox .btn + .dual-listbox__button, .dual-listbox .tb-tnx-btns .btn + .dual-listbox__button, .tb-tnx-btns .dual-listbox .dual-listbox__button + .dual-listbox__button, .dual-listbox .tb-tnx-btns .dual-listbox__button + .dual-listbox__button {
  margin-left: 0.5rem;
}
.tb-tnx-btns + .dropdown {
  margin-left: 1rem;
}

@media (max-width: 767px) {
  .tb-tnx-item, .tb-tnx-head {
    display: flex;
    width: 100%;
  }
  .tb-tnx-item th, .tb-tnx-head th {
    flex-grow: 1;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .tb-tnx-item td, .tb-tnx-head td {
    flex-grow: 1;
    border: none;
    padding-top: 0;
    padding-bottom: 0;
  }
  .tb-tnx-item {
    flex-wrap: wrap;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .tb-tnx-item:not(:last-child) {
    border-bottom: 1px solid #e5e9f2;
  }
  .tb-tnx-amount {
    width: 110px;
    text-align: right;
  }
  .tb-tnx-id, .tb-tnx-head th:first-child {
    min-width: 85px;
    padding-right: 0.25rem !important;
    flex-grow: 0 !important;
  }
  .tb-tnx-info {
    width: 45%;
  }
  .tb-tnx-date .date {
    font-size: 12px;
  }
  .tb-tnx-date .date + .date {
    padding-left: 0.5rem;
  }
  .tb-tnx-action:last-child {
    flex-grow: 0;
    padding-left: 0.5rem;
    display: inline-flex;
    align-items: center;
  }
}
@media (max-width: 575px) {
  .tb-tnx-item {
    font-size: 13px;
  }
  .tb-tnx-id {
    width: 100%;
  }
  .tb-tnx-id + td {
    padding-left: 1.25rem;
  }
  .tb-tnx-info {
    width: 65%;
  }
  .tb-tnx-amount:last-child {
    width: 25%;
  }
  .tb-tnx-amount:not(:last-child) {
    display: none;
  }
  .tb-tnx-amount.is-alt {
    position: absolute;
    display: inline-flex;
    right: 1.25rem;
    width: auto;
  }
  .tb-tnx-amount.is-alt .tb-tnx-total {
    order: 5;
    padding-left: 1.25rem;
  }
}
@media (min-width: 768px) {
  .tb-tnx-desc, .tb-tnx-date, .tb-tnx-total, .tb-tnx-status {
    display: inline-block;
    vertical-align: middle;
  }
  .tb-tnx-desc, .tb-tnx-date {
    width: calc(50% - 4px);
  }
  .tb-tnx-total {
    width: calc(60% - 4px);
  }
  .tb-tnx-status {
    width: calc(40% - 4px);
  }
  .tb-tnx-amount {
    width: 25%;
  }
  .tb-tnx-date .date, .tb-tnx-date > span > span {
    width: calc(50% - 4px);
    display: inline-block;
  }
  .tb-tnx-date .date + .date, .tb-tnx-date > span > span + span {
    padding-left: 0.75rem;
  }
}
.tb-odr-item {
  font-size: 14px;
}
.tb-odr-item td {
  padding: 1rem 0.25rem;
  vertical-align: middle;
}
.tb-odr-id, .tb-odr-total {
  display: block;
}
.tb-odr-item .tb-odr-id, .tb-odr-item .tb-odr-total {
  font-weight: 500;
}
.tb-odr-id a {
  display: block;
}
.tb-odr-id span {
  font-weight: 500;
}
.tb-odr-item .tb-odr-total {
  color: #364a63;
}
.tb-odr-head .tb-odr-item .tb-odr-total {
  color: inherit;
}
.tb-odr-item .tb-odr-date {
  color: #8094ae;
}
.tb-odr-head .tb-odr-item .tb-odr-date {
  color: inherit;
}
.tb-odr-action > div, .tb-odr-action > .btn, .dual-listbox .tb-odr-action > .dual-listbox__button {
  vertical-align: middle;
}
.tb-odr-action:last-child {
  padding-left: 1.25rem;
  text-align: right;
}
.tb-odr-btns .btn + .btn, .tb-odr-btns .dual-listbox .dual-listbox__button + .btn, .dual-listbox .tb-odr-btns .dual-listbox__button + .btn, .tb-odr-btns .dual-listbox .btn + .dual-listbox__button, .dual-listbox .tb-odr-btns .btn + .dual-listbox__button, .tb-odr-btns .dual-listbox .dual-listbox__button + .dual-listbox__button, .dual-listbox .tb-odr-btns .dual-listbox__button + .dual-listbox__button {
  margin-left: 0.5rem;
}
.tb-odr-id {
  min-width: 90px;
}
.tb-odr-head {
  background: #f5f6fa;
}
.tb-odr-head th {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: #8094ae;
  padding: 0.625rem 0.25rem;
}

@media (max-width: 767px) {
  .tb-odr-item {
    display: flex;
  }
  .tb-odr-item th, .tb-odr-item td {
    flex-grow: 1;
  }
  .tb-odr-amount {
    text-align: right;
  }
}
@media (max-width: 575px) {
  .tb-odr-item {
    font-size: 13px;
  }
  .tb-odr-amount {
    width: 24%;
  }
  .tb-odr-info {
    width: 44%;
  }
  .tb-odr-action {
    width: 2rem;
    min-width: auto;
  }
  .tb-odr-item .tb-odr-action {
    padding-left: 0.5rem;
  }
}
@media (min-width: 768px) {
  .tb-odr-info {
    min-width: 55%;
  }
  .tb-odr-amount {
    width: 30%;
  }
  .tb-odr-total {
    min-width: 100px;
  }
  .tb-odr-id, .tb-odr-total {
    display: inline-block;
  }
  .tb-odr-id + span, .tb-odr-total + span {
    padding-left: 1rem;
  }
  .tb-odr-btns + .dropdown, .tb-odr-btns + .btn, .dual-listbox .tb-odr-btns + .dual-listbox__button {
    margin-left: 0.75rem;
  }
}
@media (min-width: 992px) {
  .tb-odr-id {
    min-width: 120px;
  }
  .tb-odr-total {
    min-width: 50%;
  }
}
.is-compact .tb-tnx-item td, .is-compact .tb-odr-item td {
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
}

@media (max-width: 767px) {
  .is-compact .tb-tnx-item, .is-compact .tb-odr-item {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .is-compact .tb-tnx-item td, .is-compact .tb-odr-item td {
    padding-top: 0;
    padding-bottom: 0;
  }
}
.nk-iv-wg5 {
  display: inline-flex;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
}
.nk-iv-wg5-head {
  margin-bottom: 1rem;
}
.nk-iv-wg5-title {
  margin-bottom: 0.25rem;
}
.nk-iv-wg5-subtitle {
  color: #8094ae;
}
.nk-iv-wg5-ck {
  margin-top: auto;
  position: relative;
  display: inline-block;
}
.nk-iv-wg5-ck-result {
  position: absolute;
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.nk-iv-wg5-ck-result .text-lead {
  font-size: 40px;
  font-weight: 300;
  color: #364a63;
  line-height: 1.3;
}
.nk-iv-wg5-ck-result .text-lead.sm {
  font-size: 30px;
}
.nk-iv-wg5-ck-result .text-sub {
  font-size: 12px;
  font-weight: 500;
  color: #8094ae;
}
.nk-iv-wg5-ck-minmax {
  display: flex;
  justify-content: space-between;
  color: #8094ae;
  font-size: 12px;
}

@media (min-width: 1200px) {
  .nk-iv-wg5-ck canvas {
    width: 300px !important;
    height: 150px !important;
  }
  .nk-iv-wg5-ck.sm canvas {
    width: 240px !important;
    height: 120px !important;
  }
}
.nk-tb-list {
  display: table;
  width: 100%;
  font-size: 13px;
  color: #8094ae;
}
.nk-tb-list.is-alt {
  color: #526484;
}
.nk-tb-list .list-status, .nk-tb-list .tb-status {
  font-size: 12px;
  font-weight: 500;
}
.nk-tb-list .tb-lead, .nk-tb-list .tb-amount {
  font-weight: 500;
  color: #364a63;
  display: block;
  line-height: 1.4;
}
.nk-tb-list .tb-lead-sub, .nk-tb-list .tb-amount-sub {
  color: #526484;
  display: block;
  line-height: 1.4;
}
.nk-tb-list .tb-sub, .nk-tb-list .tb-amount-sm {
  font-size: 0.9em;
}
.nk-tb-list .tb-amount span, .nk-tb-list .tb-amount .currency {
  color: #526484;
  font-weight: 400;
}
.nk-tb-list .user-info .tb-lead + span, .nk-tb-list .tb-lead + .tb-date {
  font-size: 11px;
}
.nk-tb-list .tb-country {
  display: flex;
  align-items: center;
}
.nk-tb-list .tb-country .name {
  color: #364a63;
}
.nk-tb-list .tb-country .flag {
  height: 16px;
  border-radius: 3px;
}
.nk-tb-list .tb-country .flag + .name {
  margin-left: 0.6875rem;
}
.nk-tb-list .tb-product {
  display: flex;
  align-items: center;
}
.nk-tb-list .tb-product .thumb {
  width: 48px;
  border-radius: 4px;
  margin-right: 1rem;
}
.nk-tb-list .tb-product .title {
  font-weight: 700;
  font-size: 0.875rem;
  color: #364a63;
}
.nk-tb-list .tb-asterisk {
  font-size: 1.125rem;
  line-height: 1;
  vertical-align: middle;
}
.nk-tb-list .tb-asterisk a {
  color: #4461F2;
}
.nk-tb-item {
  transition: background-color 0.3s, box-shadow 0.3s;
  display: table-row;
}
.nk-tb-item:not(.nk-tb-head):hover, .nk-tb-item:not(.nk-tb-head).seleted {
  background: #f8f9fc;
  box-shadow: 0 2px 15px -4px rgba(68, 97, 242, 0.4);
}
.nk-tb-col {
  position: relative;
  display: table-cell;
  vertical-align: middle;
  padding: 1rem 0.5rem;
}
.nk-tb-col:first-child {
  padding-left: 1.25rem;
}
.nk-tb-col:last-child {
  padding-right: 1.25rem;
}
.nk-tb-col-tools {
  max-width: 3.75rem;
}
.nk-tb-col-check {
  width: 3rem;
}
.nk-tb-col-check .custom-control {
  vertical-align: middle;
}
.nk-tb-item:not(:last-child) .nk-tb-col {
  border-bottom: 1px solid rgba(219, 223, 234, 0.9);
}
.nk-tb-head .nk-tb-col {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: #8094ae;
  font-size: 0.9em;
  border-bottom: 1px solid rgba(219, 223, 234, 0.9);
}
.nk-tb-col-action {
  text-align: right;
}
.nk-tb-col-action > .dropdown:last-child {
  right: -0.5rem;
}
.nk-tb-col-nosort:before, .nk-tb-col-nosort:after {
  display: none !important;
}
.nk-tb-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
}
.nk-tb-ulist .nk-tb-actions, .nk-tb-actions-adj .nk-tb-actions {
  right: -0.5rem;
}
.nk-tb-actions.visible1 {
  width: 1rem;
}
.nk-tb-action-hidden {
  opacity: 0;
  transition: 0.3s ease;
}
.nk-tb-item:hover .nk-tb-action-hidden {
  opacity: 1;
  background: #f8f9fc;
}
.nk-tb-list .nk-tb-head .btn-trigger .icon {
  font-size: 1.5em;
}
.nk-tb-list.is-separate {
  margin-top: -8px;
  border-collapse: separate;
  border-spacing: 0 8px;
}
.nk-tb-list.is-separate .nk-tb-item > .nk-tb-col {
  background: #fff;
  border: none;
  box-shadow: 0px 1px 3px 0px rgba(54, 74, 99, 0.05);
}
.nk-tb-list.is-separate .nk-tb-item > .nk-tb-col:first-child {
  border-radius: 4px 0 0 4px;
}
.nk-tb-list.is-separate .nk-tb-item > .nk-tb-col:last-child {
  border-radius: 0 4px 4px 0;
}
.nk-tb-list.is-separate .nk-tb-item:hover .nk-tb-action-hidden {
  background: #fff;
}
.nk-tb-list.is-separate .nk-tb-head .nk-tb-col {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

@media (min-width: 576px) {
  .nk-tb-col-check {
    width: 3.25rem;
  }
  .nk-tb-item .nk-tb-col:first-child {
    padding-left: 1.5rem;
  }
  .nk-tb-item .nk-tb-col:last-child {
    padding-right: 1.5rem;
  }
}
@media (min-width: 1540px) {
  .nk-tb-list {
    font-size: 14px;
  }
  .nk-tb-list .list-status, .nk-tb-list .tb-status {
    font-size: 13px;
  }
  .nk-tb-list .user-info .tb-lead + span, .nk-tb-list .tb-lead + .tb-date {
    font-size: 12px;
  }
}
.is-loose .nk-tb-item:not(.nk-tb-head) .nk-tb-col {
  padding-top: 1.125rem;
  padding-bottom: 1.125rem;
}

.is-medium .nk-tb-item:not(.nk-tb-head) .nk-tb-col {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.is-compact .nk-tb-item:not(.nk-tb-head) .nk-tb-col {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.timeline {
  color: #8094ae;
  line-height: 1.3;
}
.timeline + .timeline, .timeline-list + .timeline-head {
  margin-top: 1.75rem;
}
.timeline-head {
  font-size: 14px;
  color: #8094ae;
  margin-bottom: 1rem;
}
.timeline-item {
  position: relative;
  display: flex;
  align-items: flex-start;
}
.timeline-item:not(:last-child) {
  padding-bottom: 1.5rem;
}
.timeline-item:not(:last-child):before {
  position: absolute;
  height: calc(100% - 11px);
  width: 1px;
  background: #dbdfea;
  content: "";
  top: 13px;
  left: 5px;
}
.timeline-status {
  position: relative;
  height: 11px;
  width: 11px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 2px;
}
.timeline-status.is-outline:after {
  position: absolute;
  height: 7px;
  width: 7px;
  border-radius: 50%;
  background: #fff;
  content: "";
  top: 2px;
  left: 2px;
}
.timeline-date {
  position: relative;
  color: #8094ae;
  width: 90px;
  margin-left: 0.75rem;
  flex-shrink: 0;
  line-height: 1rem;
}
.timeline-date .icon {
  right: 0;
  margin-right: 0.25rem;
  vertical-align: middle;
  color: #8094ae;
  display: inline-block;
  position: absolute;
  top: 2px;
}
.timeline-data {
  padding-left: 8px;
}
.timeline-title {
  font-size: 15px;
  color: #364a63;
  margin-bottom: 0.75rem;
}
.timeline-des {
  color: #8094ae;
}
.timeline-des p {
  margin-bottom: 0.25rem;
}
.timeline .time {
  display: block;
  font-size: 12px;
  color: #8094ae;
}

@media (min-width: 576px) {
  .timeline + .timeline, .timeline-list + .timeline-head {
    margin-top: 2.5rem;
  }
}
@media (max-width: 413px) {
  .timeline-item {
    flex-wrap: wrap;
  }
  .timeline-date {
    width: 80px;
  }
  .timeline-data {
    padding: 0.75rem 0 0 24px;
  }
}
.invoice {
  position: relative;
}
.invoice-wrap {
  padding: 1.25rem;
  border-radius: 4px;
  background: #fff;
}
.invoice-action {
  position: absolute;
  right: 1.25rem;
  top: 1.25rem;
}
.invoice-brand {
  padding-bottom: 1.5rem;
}
.invoice-brand img {
  max-height: 60px;
}
.invoice-bills {
  font-size: 12px;
}
.invoice-bills .table {
  min-width: 580px;
}
.invoice-bills .table th {
  color: #4461F2;
  font-size: 12px;
  text-transform: uppercase;
  border-top: 0;
}
.invoice-bills .table th:last-child, .invoice-bills .table td:last-child {
  text-align: right;
}
.invoice-bills .table tfoot {
  border-top: 1px solid #dbdfea;
}
.invoice-bills .table tfoot td {
  border-top: 0;
  white-space: nowrap;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.invoice-bills .table tfoot tr:last-child td:not(:first-child), .invoice-bills .table tfoot tr:first-child td:not(:first-child) {
  font-weight: 500;
  padding-top: 1.25rem;
  padding-bottom: 0.25rem;
}
.invoice-bills .table tfoot tr:last-child td:not(:first-child) {
  border-top: 1px solid #dbdfea;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.invoice-head {
  padding-bottom: 1.5rem;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.invoice-desc {
  width: 210px;
  padding-top: 1.5rem;
}
.invoice-desc .title {
  text-transform: uppercase;
  color: #4461F2;
}
.invoice-desc ul li {
  padding: 0.25rem 0;
}
.invoice-desc ul span {
  font-size: 13px;
  font-weight: 500;
  color: #526484;
}
.invoice-desc ul span:first-child {
  min-width: 90px;
  display: inline-block;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #8094ae;
}
.invoice-desc ul span:last-child {
  padding-left: 0.75rem;
}
.invoice-contact .title {
  margin-bottom: 1rem;
}
.invoice-contact ul li {
  padding: 0.5rem 0;
  line-height: 1.3;
}
.invoice-contact ul li:first-child {
  padding-top: 0;
}
.invoice-contact ul li:last-child {
  padding-bottom: 0;
}
.invoice-contact ul .icon {
  line-height: 1.3;
  font-size: 1.1em;
  display: inline-block;
  vertical-align: top;
  margin-top: -2px;
  color: #4461F2;
  margin-right: 0.5rem;
}
.invoice-contact ul .icon + span {
  display: inline-block;
  vertical-align: top;
  color: #8094ae;
}
.invoice-print {
  max-width: 940px;
  margin: 2rem auto;
}
.invoice-print .invoice-wrap {
  padding: 0;
  border: none !important;
}

@media (min-width: 768px) {
  .invoice-wrap {
    padding: 3rem;
  }
  .invoice-head {
    flex-direction: row;
  }
  .invoice-desc {
    padding-top: 0;
  }
  .invoice-bills {
    font-size: 0.775rem;
  }
}
.pricing {
  position: relative;
  height: 100%;
}
.pricing-badge {
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
}
.pricing-head {
  text-align: center;
  padding: 1.75rem 1.5rem;
  border-bottom: 1px solid #e5e9f2;
}
.pricing-title .title {
  margin-bottom: 0.25rem;
}
.pricing-title:not(:last-child) {
  padding-bottom: 1.25rem;
}
.pricing-body {
  padding: 1.75rem 1.75rem 2rem;
}
.pricing-features li {
  display: flex;
  padding: 0.25rem 0;
}
.pricing-action {
  margin-top: 1.5rem;
  text-align: center;
}
.pricing-media {
  padding: 0.25rem 0;
  margin-bottom: 1.5rem;
}
.pricing-media img {
  max-width: 90px;
}
.pricing-amount {
  font-size: 0.875rem;
  color: #8094ae;
}
.pricing-amount .amount {
  font-size: 1.5rem;
  font-weight: 700;
  color: #526484;
}

.nk-add-product {
  top: 74px;
  background-color: #fff;
  width: 400px;
  height: calc(100vh - 74px);
  padding: 1.5rem;
}
.nk-add-product + .toggle-overlay {
  z-index: 700;
}

.rating {
  display: flex;
  align-items: center;
  margin: 0 -0.125rem;
  color: #f4bd0e;
}
.rating > * {
  padding: 0 0.125rem;
}
.rating .icon {
  font-size: 1rem;
}

.product-card {
  overflow: hidden;
  height: 100%;
}
.product-thumb {
  position: relative;
}
.product-badges {
  position: absolute;
  top: 1rem;
  left: 1rem;
  display: flex;
  flex-wrap: wrap;
  margin: -0.25rem;
}
.product-badges > li {
  padding: 0.25rem;
}
.product-tags {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.product-tags > li {
  padding: 0.25rem;
}
.product-tags a {
  color: #8094ae;
}
.product-tags a:hover {
  color: #4461F2;
}
.product-tags + .product-title {
  margin-top: 0.5rem;
}
.product-title a {
  color: #364a63;
}
.product-title + .product-price {
  margin-top: 1rem;
}
.product-actions {
  position: absolute;
  bottom: 0.25rem;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 4px 4px 0 0;
  overflow: hidden;
  transition: 0.2s linear;
  display: flex;
  opacity: 0;
}
.product-card:hover .product-actions {
  opacity: 1;
}
.product-actions li {
  padding: 0 0.125rem;
}
.product-actions li a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #526484;
  font-size: 15.6px;
  height: 2.125rem;
  width: 2.125rem;
  transition: 0.3s ease;
}
.product-actions li a:hover {
  color: #4461F2;
}
.product-gallery {
  position: relative;
  height: auto;
  margin: 0 0 30px 0;
  border-radius: 4px;
  border: 1px solid #e5e9f2;
}
.product-gallery .slick-list {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
.product-gallery .slider-nav {
  position: absolute;
  bottom: -30px;
  left: 50%;
  transform: translateX(-50%);
  width: 282px;
}
.product-gallery .slider-nav .slider-item {
  padding: 0 8px;
}
.product-gallery .slider-nav .slider-item .thumb {
  width: 78px;
  padding: 1px;
  border: 2px solid #e5e9f2;
  box-shadow: inset 1px 1px 0 #fff, inset -1px -1px 0 #fff, inset 1px -1px 0 #fff, inset -1px 1px 0 #fff;
  border-radius: 4px;
  transition: all 0.3s ease;
  cursor: pointer;
}
.product-gallery .slider-nav .slider-item.slick-current .thumb {
  border-color: #4461F2;
  cursor: default;
}
.product-rating {
  display: flex;
  align-items: center;
}
.product-rating .amount {
  margin-left: 0.5rem;
  color: #8094ae;
}
.product-excrept {
  margin-top: 1.5rem;
}
.product-meta {
  margin-top: 2rem;
}
.product-meta + .product-meta {
  margin-top: 1.25rem;
}

@media (max-width: 420px) {
  .product-gallery .slider-nav {
    width: 188px;
  }
}
@media (min-width: 768px) {
  .product-gallery .slider-nav {
    width: 384px;
  }
}
@media (min-width: 1540px) {
  .product-gallery .slider-nav {
    width: 470px;
  }
}
.gallery-image {
  position: relative;
  z-index: 1;
}

.nk-sale-data {
  flex-shrink: 0;
}
.nk-sale-data-group {
  display: flex;
  flex-wrap: wrap;
}
.nk-sale-data .amount {
  display: block;
  font-size: 1.75rem;
  color: #364a63;
}
.nk-sale-data .amount .change {
  font-size: 0.875rem;
}
.nk-sale-data .amount.sm {
  font-size: 1.125rem;
  color: #8094ae;
}
.nk-sale-data .sub-title {
  color: #8094ae;
  font-size: 12px;
}
.nk-sale-data .sub-title .change {
  margin-right: 0.5rem;
}

.nk-sales-ck {
  height: 80px;
  flex-grow: 1;
}
.nk-sales-ck.large {
  height: 200px;
}

@media (min-width: 992px) and (max-width: 1539.98px) {
  .nk-sales-ck.sales-revenue {
    height: 164px;
  }
}
.nk-wg-action {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.nk-wg-action-content {
  position: relative;
  padding-left: 2rem;
  padding-right: 1rem;
}
.nk-wg-action-content .icon {
  font-size: 1.5rem;
  left: 0;
  position: absolute;
  color: #8094ae;
}
.nk-wg-action-content .title {
  font-size: 14px;
  font-weight: 500;
  padding-bottom: 0.25rem;
}
.nk-wg-action-content p {
  color: #8094ae;
  font-size: 13px;
  line-height: 1.25rem;
}
.nk-wg-action-content p strong {
  color: #4461F2;
}

.nk-order-ovwg-ck {
  height: 180px;
}
.nk-order-ovwg-data {
  padding: 0.75rem 1.25rem 1.25rem;
  border: 2px solid transparent;
  border-radius: 4px;
}
.nk-order-ovwg-data .amount {
  font-size: 1.5rem;
  font-weight: 700;
}
.nk-order-ovwg-data .amount small {
  font-weight: 400;
}
.nk-order-ovwg-data .info {
  font-size: 12px;
  color: #8094ae;
  margin-bottom: 0.25rem;
}
.nk-order-ovwg-data .info strong {
  color: #364a63;
}
.nk-order-ovwg-data .title {
  font-size: 14px;
  line-height: 1.3;
  color: #8094ae;
  font-weight: 500;
}
.nk-order-ovwg-data .title .icon {
  font-size: 1rem;
  height: 28px;
  width: 28px;
  border-radius: 50%;
  background: #f5f6fa;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.5rem;
}
.nk-order-ovwg-data.buy {
  border-color: #8ff0d6;
}
.nk-order-ovwg-data.buy .amount, .nk-order-ovwg-data.buy .title .icon {
  color: #1ee0ac;
}
.nk-order-ovwg-data.sell {
  border-color: #a2b0f9;
}
.nk-order-ovwg-data.sell .amount, .nk-order-ovwg-data.sell .title .icon {
  color: #4461F2;
}

@media (min-width: 1540px) {
  .nk-order-ovwg-ck {
    height: 260px;
  }
}
.nk-activity-item {
  display: flex;
  align-items: center;
  padding: 1.25rem;
}
.nk-activity-item:not(:last-child) {
  border-bottom: 1px solid #e5e9f2;
}
.nk-activity-data {
  margin-left: 1rem;
}
.nk-activity-data .time {
  display: block;
  font-size: 12px;
  color: #8094ae;
  line-height: 1.3;
}

@media (min-width: 576px) {
  .nk-activity-item {
    display: flex;
    padding: 1rem 1.5rem;
  }
}
.nk-support-item {
  display: flex;
  padding: 1.25rem;
}
.nk-support-item:not(:last-child) {
  border-bottom: 1px solid #e5e9f2;
}
.nk-support-content {
  flex-grow: 1;
  margin-left: 1rem;
}
.nk-support-content .title {
  font-size: 0.875rem;
  font-weight: 700;
  color: #364a63;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.nk-support-content p {
  margin-bottom: 0;
  margin-top: 0.25rem;
}
.nk-support-content .time {
  display: block;
  font-size: 12px;
  color: #8094ae;
}

@media (min-width: 576px) {
  .nk-support-item {
    display: flex;
    padding: 1.25rem 1.5rem;
  }
}
.device-status {
  display: flex;
  flex-direction: column;
  padding-top: 1rem;
}
.device-status-ck {
  height: 200px;
  margin: auto 0;
}
.device-status-group {
  display: flex;
  justify-content: space-between;
  padding-top: 1.75rem;
  margin: auto;
  width: 280px;
  max-width: 100%;
}
.device-status-data > .icon {
  font-size: 1.5rem;
}
.device-status-data .title {
  font-size: 12px;
  color: #8094ae;
  margin-bottom: 0.5rem;
}
.device-status-data .amount {
  font-size: 1.125rem;
  color: #364a63;
  font-weight: 500;
}
.device-status-data .change {
  margin-left: -0.125rem;
}

.traffic-channel {
  margin-top: 1rem;
}
.traffic-channel-ck {
  height: 44px;
  width: 130px;
  margin-top: -4px;
  margin-bottom: -4px;
}
.traffic-channel-doughnut-ck {
  height: 160px;
}
.traffic-channel-group {
  display: flex;
  flex-wrap: wrap;
  padding-top: 1.75rem;
  margin-left: auto !important;
  margin-right: auto !important;
  width: 320px;
  max-width: 100%;
}
.traffic-channel-data {
  width: 50%;
}
.traffic-channel-data .title {
  display: flex;
  align-items: center;
  color: #8094ae;
  font-size: 12px;
}
.traffic-channel-data .title .dot {
  margin-right: 0.5rem;
}
.traffic-channel-data .amount {
  font-size: 1.125rem;
  color: #364a63;
  margin-left: 1.25rem;
}
.traffic-channel-data .amount small {
  font-size: 12px;
  color: #8094ae;
}

@media (max-width: 575.98px) {
  .traffic-channel-ck {
    width: 100%;
  }
  .traffic-channel-table .nk-tb-item {
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid #e5e9f2;
    padding: 1.125rem 0;
  }
  .traffic-channel-table .nk-tb-col {
    border-bottom: none !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .traffic-channel-table .nk-tb-channel {
    width: 50%;
  }
  .traffic-channel-table .nk-tb-sessions {
    width: 25%;
  }
  .traffic-channel-table .nk-tb-prev-sessions {
    display: none;
  }
  .traffic-channel-table .nk-tb-change {
    width: 25%;
  }
  .traffic-channel-table .nk-tb-trend {
    width: 100%;
    padding-left: 1.25rem;
  }
}
@media (min-width: 1540px) and (max-width: 1800px) {
  .traffic-channel-data .amount {
    font-size: 1rem;
  }
}
.analytic-data-group {
  display: flex;
  flex-wrap: wrap;
}
.analytic-data .title {
  font-size: 12px;
  font-weight: 500;
  color: #8094ae;
  margin-bottom: 0.375rem;
}
.analytic-data .title span {
  font-weight: 400;
}
.analytic-data .amount {
  color: #364a63;
  font-size: 1.5rem;
  line-height: 1.2;
  margin-bottom: 0.25rem;
}
.analytic-data .amount-sm {
  font-size: 1.125rem;
}
.analytic-data .change {
  font-size: 13px;
  margin-left: -0.125rem;
}
.analytic-data .subtitle {
  font-size: 12px;
  color: #8094ae;
}

@media (min-width: 1540px) and (max-width: 1800px) {
  .analytic-data .amount {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  .analytic-data .amount-sm {
    font-size: 1.125rem;
  }
}
.analytic-ov-data {
  width: 50%;
}
.analytic-ov-ck {
  height: 175px;
  margin-top: 2rem;
}

@media (min-width: 480px) {
  .analytic-ov-data {
    width: 25%;
  }
}
.analytic-au-data {
  width: 33.3333%;
}
.analytic-au-ck {
  height: 170px;
  margin-top: 2.25rem;
}

.analytic-wp-data {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.analytic-wp-ck {
  height: 36px;
}
.analytic-wp-graph {
  width: 150px;
  margin-top: 0.125rem;
  margin-bottom: 0.125rem;
}
.analytic-wp-graph .title {
  margin-bottom: 0;
}
.analytic-wp-text {
  text-align: right;
  margin-left: 0.5rem;
}

@media (min-width: 420px) and (max-width: 767px) {
  .analytic-wp-graph {
    width: 60%;
  }
}
@media (min-width: 1540px) and (max-width: 1800px) {
  .analytic-wp-graph {
    width: 120px;
  }
}
.chart-label {
  font-size: 12px;
  color: #8094ae;
}
.chart-label-group {
  margin-top: 0.5rem;
  display: flex;
  justify-content: space-between;
}

.analytics-map .vector-map {
  height: 160px;
  margin: 1rem 0;
}
.analytics-map-data {
  font-size: 0.875rem;
}
.analytics-map-data td {
  padding: 0.25rem 0;
}
.analytics-map-data .country {
  color: #8094ae;
}
.analytics-map-data .amount {
  color: #364a63;
  text-align: right;
}
.analytics-map-data .percent {
  text-align: right;
  color: #8094ae;
}
.analytics-map-data-list {
  width: 100%;
  margin-bottom: -0.25rem;
}

.nk-ecwg .amount {
  font-size: 2rem;
  font-weight: 500;
  color: #364a63;
}
.nk-ecwg .amount-sm {
  font-size: 1.5rem;
}
.nk-ecwg .amount-xs {
  font-size: 0.875rem;
}
.is-dark .nk-ecwg .amount {
  color: #fff;
}
.nk-ecwg .info {
  font-size: 0.875rem;
}
.is-dark .nk-ecwg .info {
  color: #d4c2ff;
}
.nk-ecwg .sub-title {
  font-size: 0.875rem;
  font-weight: 500;
}
.is-dark .nk-ecwg .sub-title {
  color: #fff;
}
.nk-ecwg .data {
  margin-top: 0.5rem;
}
.nk-ecwg .data:not(:last-child) {
  margin-bottom: 2rem;
}
.nk-ecwg .data-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.nk-ecwg .data-group .data {
  margin: 0;
  padding-right: 20px;
}
.nk-ecwg1-ck {
  height: 110px;
}
.nk-ecwg2-ck {
  height: 182px;
}
.nk-ecwg3-ck {
  height: 66px;
}
.nk-ecwg4 {
  display: flex;
  flex-direction: column;
}
.nk-ecwg4-ck {
  height: 180px;
  width: 180px;
  margin-right: 1.5rem;
}
.nk-ecwg4-legends {
  flex-grow: 1;
  padding: 1rem 0;
}
.nk-ecwg4-legends li {
  display: flex;
  justify-content: space-between;
  padding: 0.25rem 0;
}
.nk-ecwg4-legends .title {
  display: flex;
  align-items: center;
}
.nk-ecwg4-legends .title .dot {
  margin-right: 0.5rem;
}
.nk-ecwg5-ck {
  height: 140px;
}
.nk-ecwg5 .data-group {
  margin-bottom: 30px;
}
.nk-ecwg6-ck {
  width: 100px;
  height: 40px;
  margin-left: 20px;
}
.nk-ecwg7-ck {
  height: 180px;
  width: 180px;
  margin: 0 auto 15px;
}
.nk-ecwg7-legends {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.nk-ecwg7-legends li {
  padding: 0.25rem 1rem;
}
.nk-ecwg7-legends .title {
  display: flex;
  align-items: center;
  color: #8094ae;
}
.nk-ecwg7-legends .title .dot {
  margin-right: 0.5rem;
}
.nk-ecwg8-ck {
  height: 200px;
}
.nk-ecwg8-legends {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}
.nk-ecwg8-legends li {
  padding: 0.25rem 1rem;
}
.nk-ecwg8-legends .title {
  display: flex;
  align-items: center;
  color: #8094ae;
}
.nk-ecwg8-legends .title .dot {
  margin-right: 0.5rem;
}

@media (max-width: 490px) {
  .nk-ecwg4 .data-group {
    flex-wrap: wrap;
  }
  .nk-ecwg8-ck {
    height: 140px;
  }
}
@media (min-width: 1540px) {
  .nk-ecwg4-ck {
    height: 210px;
    width: 210px;
    margin-right: 2.5rem;
  }
}
.nk-top-products .item {
  display: flex;
  align-items: center;
  padding: 0.625rem 0;
  line-height: 1.2;
}
.nk-top-products .thumb {
  width: 44px;
  margin-right: 1rem;
}
.nk-top-products .thumb img {
  border-radius: 4px;
}
.nk-top-products .total {
  margin-left: auto;
  text-align: right;
}
.nk-top-products .title, .nk-top-products .amount {
  font-size: 0.9375rem;
  color: #364a63;
  margin-bottom: 0.25rem;
}
.nk-top-products .price, .nk-top-products .count {
  font-size: 0.8125rem;
  color: #8094ae;
  margin-bottom: 1px;
}

.nk-store-statistics .item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0;
}
.nk-store-statistics .title {
  font-size: 0.8125rem;
  color: #8094ae;
}
.nk-store-statistics .count {
  font-size: 1.25rem;
  color: #364a63;
  font-weight: 700;
}
.nk-store-statistics .icon {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  height: 44px;
  width: 44px;
  border-radius: 6px;
}

.nk-download {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem;
  border-radius: 4px;
  background: #fff;
}
.nk-download .data {
  display: flex;
  flex-grow: 1;
}
.nk-download .info {
  margin-top: 0.35rem;
}
.nk-download .title {
  font-size: 1rem;
  line-height: 1.2;
}
.nk-download .thumb {
  flex-shrink: 0;
  width: 3rem;
  margin-right: 1rem;
}
.nk-download .meta .version, .nk-download .meta .release {
  display: block;
  line-height: 1.2;
  padding: 0.25rem 0;
}
.nk-download .title .badge {
  margin-left: 1rem;
}

@media (min-width: 768px) {
  .nk-download {
    padding: 1.5rem;
  }
  .nk-download .thumb {
    width: 2.5rem;
    margin-right: 1.5rem;
  }
  .nk-download .data {
    align-items: center;
  }
  .nk-download .meta .version, .nk-download .meta .release {
    display: inline-block;
    padding-right: 1.5rem;
  }
}
@media (max-width: 575px) {
  .nk-download .data {
    width: 100%;
    padding-left: 4rem;
  }
  .nk-download .thumb {
    position: absolute;
    margin-left: -4rem;
  }
  .nk-download .actions {
    margin: 0.75rem 0 0;
    padding-left: 4rem;
  }
}
.nk-add-product {
  top: 74px;
  background-color: #fff;
  width: 400px;
  height: calc(100vh - 74px);
  padding: 1.5rem;
}
.nk-add-product + .toggle-overlay {
  z-index: 700;
}

.card-title .subtitle {
  color: #8094ae;
  font-size: 13px;
  font-weight: 500;
}
.card-amount {
  display: flex;
  align-items: baseline;
}
.card-amount .change {
  margin-left: 0.5rem;
}
.card-amount .amount {
  font-size: 1.5rem;
  color: #364a63;
}
.card-amount .amount span {
  color: #526484;
}

@media (min-width: 768px) and (max-width: 991.98px) {
  .card-amount .amount {
    font-size: 1rem;
    font-weight: 500;
  }
  .card-amount .amount span {
    font-weight: 400;
  }
  .card-amount .change {
    font-size: 12px;
  }
}
.card-inner .nav-tabs-card {
  margin-left: -1.25rem;
  margin-right: -1.25rem;
}

@media (min-width: 576px) {
  .card-inner .nav-tabs-card {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }
}
.nav-tabs-xs .nav-link {
  padding: 0.75rem 0;
  font-size: 13px;
  font-weight: 500;
}

@media (min-width: 768px) {
  .nav-tabs-xs .nav-item {
    padding-right: 1.25rem;
  }
}
@media (min-width: 992px) {
  .nav-tabs-sm .nav-item {
    padding-right: 1.25rem;
  }
}
@media (min-width: 1200px) {
  .nav-tabs-sm .nav-item {
    padding-right: 1.25rem;
  }
}
.invest-data {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.invest-data-history {
  margin-right: 20px;
  flex-grow: 1;
}
.invest-data-history .title {
  font-size: 11px;
  color: #8094ae;
  text-transform: uppercase;
  margin-bottom: 0.125rem;
  letter-spacing: 0.1em;
}
.invest-data-history .amount {
  font-size: 0.9375rem;
  line-height: 1.1;
  color: #364a63;
}
.invest-data-history .amount span {
  color: #526484;
}
.invest-data-amount {
  display: flex;
  flex-shrink: 0;
  flex-grow: 1;
}
.invest-data-ck {
  flex-grow: 1;
  height: 48px;
  width: 80px;
  margin-bottom: 0.125rem;
}

@media (min-width: 768px) and (max-width: 1350px), (max-width: 359px) {
  .invest-data {
    margin-top: 0.75rem;
  }
  .invest-data-amount {
    flex-wrap: wrap;
    flex-shrink: 1;
  }
  .invest-data-ck {
    height: 68px;
    width: 140px;
  }
}
@media (min-width: 768px) and (max-width: 991.98px) {
  .invest-data-history .amount {
    font-size: 0.75rem;
    font-weight: 700;
  }
  .invest-data-history .amount span {
    font-weight: 400;
  }
}
.invest-ov {
  padding: 1.25rem 0 1rem;
}
.invest-ov:last-child {
  padding-bottom: 0;
}
.invest-ov:not(:last-child) {
  border-bottom: 1px solid #e5e9f2;
}
.invest-ov .subtitle {
  color: #8094ae;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 0.25rem;
}
.invest-ov .title {
  font-size: 11px;
  color: #8094ae;
  text-transform: uppercase;
  margin-top: 0.25rem;
  letter-spacing: 0.1em;
}
.invest-ov .amount {
  font-size: 1.25rem;
  line-height: 1.1;
  color: #364a63;
}
.invest-ov .amount span {
  color: #526484;
}
.invest-ov-details {
  display: flex;
}
.invest-ov-info {
  width: 60%;
}
.invest-ov-stats {
  width: 40%;
}
.invest-ov-stats > div {
  display: flex;
  align-items: baseline;
}
.invest-ov-stats .change {
  margin-left: 0.25rem;
}

.invest-top-ck {
  padding-top: 20px;
  height: 70px;
}

.asterisk a {
  position: relative;
  color: #8094ae;
  display: inline-flex;
}
.asterisk a:hover, .asterisk a.active {
  color: #ffa353;
}
.asterisk a:hover .asterisk-on, .asterisk a.active .asterisk-on {
  opacity: 1;
}
.asterisk a.active:hover .asterisk-on {
  opacity: 0;
}
.asterisk-on {
  opacity: 0;
  position: absolute;
  left: 0;
  color: #ffa353;
  z-index: 1;
  transition: opacity 0.2s;
}

.nk-reply {
  height: 100%;
  max-height: 100%;
  overflow: auto;
}
.nk-reply-item {
  padding: 2rem 1.25rem;
}
.nk-reply-item + .nk-reply-item {
  padding-top: 0;
}
.nk-reply-item > div:not(.nk-reply-header) {
  margin-left: 48px;
}
.nk-reply-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}
.nk-reply-header .user-name {
  margin-left: 1rem;
  font-size: 0.875rem;
}
.nk-reply-header .user-name span {
  color: #8094ae;
  font-weight: 400;
}
.nk-reply-header .date-time {
  color: #8094ae;
  font-size: 12px;
}
.nk-reply-entry.note {
  background: #f5f6fa;
  padding: 1.25rem;
  border-radius: 4px;
}
.nk-reply-from {
  margin-top: 1.25rem;
  padding: 0.375rem 0.75rem;
  background: #f5f6fa;
  border-radius: 4px;
  display: inline-block;
  font-size: 13px;
}
.nk-reply-meta {
  overflow: hidden;
  text-align: center;
  margin: 0 1.25rem;
  padding: 0 2rem;
}
.nk-reply-meta-info {
  position: relative;
  display: inline-block;
  padding: 0 0.75rem;
  color: #8094ae;
  font-size: 13px;
  line-height: 1.4;
}
.nk-reply-meta-info span, .nk-reply-meta-info strong, .nk-reply-meta-info .who {
  color: #526484;
}
.nk-reply-meta-info .whom {
  color: #4461F2;
}
.nk-reply-meta-info:before, .nk-reply-meta-info:after {
  position: absolute;
  height: 1px;
  background: #e5e9f2;
  content: "";
  width: 100vw;
  top: 50%;
}
.nk-reply-meta-info:before {
  right: 100%;
}
.nk-reply-meta-info:after {
  left: 100%;
}
.nk-reply-form {
  border-top: 1px solid #e5e9f2;
}
.nk-reply-form-dropdown {
  margin-left: -0.5rem;
  margin-right: 0.75rem;
}
.nk-reply-form-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.25rem;
  border-bottom: 1px solid #e5e9f2;
}
.nk-reply-form-title {
  display: flex;
  align-items: center;
}
.nk-reply-form-title .title {
  color: #8094ae;
  margin-right: 0.75rem;
}
.nk-reply-form-field {
  padding: 0.5rem 1.25rem;
}
.nk-reply-form-field:not(:last-child) {
  border-bottom: 1px solid #e5e9f2;
}
.nk-reply-form-field .form-control, .nk-reply-form-field div.dataTables_wrapper div.dataTables_filter input, div.dataTables_wrapper div.dataTables_filter .nk-reply-form-field input, .nk-reply-form-field .dual-listbox .dual-listbox__search, .dual-listbox .nk-reply-form-field .dual-listbox__search, .nk-reply-form-field .rdl-filter {
  font-size: 0.875rem;
}
.nk-reply-form-field textarea.form-control, .nk-reply-form-field .dual-listbox textarea.dual-listbox__search, .dual-listbox .nk-reply-form-field textarea.dual-listbox__search, .nk-reply-form-field textarea.rdl-filter {
  min-height: 78px;
}
.nk-reply-form-field textarea.form-control.ex-large, .nk-reply-form-field .dual-listbox textarea.ex-large.dual-listbox__search, .dual-listbox .nk-reply-form-field textarea.ex-large.dual-listbox__search, .nk-reply-form-field textarea.ex-large.rdl-filter {
  min-height: 160px;
}
.nk-reply-form-field + .nk-reply-form-tools {
  border-top: 0;
}
.nk-reply-form-tools {
  padding: 1.25rem;
  border-top: 1px solid #e5e9f2;
  display: flex;
  justify-content: space-between;
}
.nk-reply-form-actions {
  display: inline-flex;
  align-items: center;
}
.nk-reply-form-options {
  display: inline-flex;
}
.nk-reply-form-input {
  display: flex;
}
.nk-reply-form-input .label {
  margin: 0.3rem 0.5rem 0.3rem 0;
  width: 1.25rem;
  color: #8094ae;
}
.nk-reply-form-input-group {
  width: 100%;
}
.nk-reply-form-input-cc, .nk-reply-form-input-bcc {
  display: none;
}
.nk-reply-form-input-cc.expanded, .nk-reply-form-input-bcc.expanded {
  display: flex;
}
.nk-reply-form-input .toggle-opt {
  display: inline-flex;
  align-items: center;
  color: #364a63;
}
.nk-reply-form-input .toggle-opt:hover {
  color: #4461F2;
}
.nk-reply-form-group {
  position: relative;
  padding: 1rem 0;
  flex-grow: 1;
  display: flex;
  align-items: flex-start;
}
.nk-reply-form-input-to {
  padding-right: 3.5rem;
}
.nk-reply-form-nav {
  position: absolute;
  display: flex;
  align-items: center;
  align-self: flex-start;
  padding: 1.0625rem 0 0;
  right: 0;
  top: 0;
  margin: 0 -0.375rem;
}
.nk-reply-form-nav li a {
  font-size: 12px;
  color: #8094ae;
  display: block;
  line-height: 1.5rem;
  padding: 0.25rem 0.375rem;
}
.nk-reply-form-nav li a:hover {
  color: #4461F2;
}
.nk-reply-form-attachment-list {
  background: rgba(235, 238, 242, 0.6);
  font-weight: 500;
  color: #526484;
  border-radius: 4px;
}
.is-collapsed .nk-reply-msg-info {
  display: none;
}
.nk-reply-msg-excerpt {
  color: #526484;
  display: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.is-collapsed .nk-reply-msg-excerpt {
  display: block;
}
.nk-reply-msg-meta {
  padding: 0.75rem;
}
.nk-reply-msg-meta li {
  display: flex;
  line-height: 1.125rem;
  padding: 0.1875rem 0;
}
.nk-reply-msg-meta li .label {
  width: 75px;
  text-align: right;
  color: #8094ae;
  font-size: 12px;
  margin-right: 0.75rem;
}
.nk-reply-msg-meta li .info {
  font-size: 13px;
}
.nk-reply-msg-meta li .info a {
  color: #526484;
}
.nk-reply-tools {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  cursor: default;
}
.nk-reply-tools .date {
  margin-right: 1rem;
  line-height: 2.25rem;
  color: #526484;
}
.nk-reply-tools .attach-msg {
  font-size: 1.25rem;
  margin-right: 0.375rem;
}
.nk-reply-desc {
  display: flex;
  flex-grow: 1;
}
.is-collapsed .nk-reply-desc {
  overflow: hidden;
}
.nk-reply-header .nk-reply-desc {
  align-items: center;
}
.nk-reply-info {
  margin-left: 1rem;
  max-width: calc(100% - 4.5rem);
}
.nk-reply-header.is-collapsed {
  margin-bottom: 0;
}
.nk-reply-header:not(.is-opened) {
  cursor: pointer;
}
.is-collapsed + .nk-reply-body {
  display: none;
}
.nk-reply-quick-btns ul {
  display: flex;
  align-items: center;
}

.is-collapsed .prev-msg, .is-collapsed .next-msg, .is-collapsed .more-actions, .is-collapsed .replyto-msg, .is-collapsed .forwardto-msg {
  display: none;
}

.input-mail {
  width: 100%;
  border: none;
}

@media (max-width: 767.98px) {
  .nk-reply-tools {
    flex-wrap: wrap;
  }
  .nk-reply-tools .date {
    font-size: 13px;
    margin-right: 0.5rem;
  }
  .nk-reply-tools .attach-msg {
    font-size: 1.25rem;
    margin-right: 0.375rem;
  }
}
@media (max-width: 419.98px) {
  .nk-reply-info {
    max-width: calc(100% - 2.5rem);
    margin-left: 0.75rem;
  }
  .is-collapsed .nk-reply-info {
    max-width: calc(100% - 4.5rem);
  }
  .nk-reply-info .date {
    font-size: 11px;
    color: #8094ae;
    margin-left: 0.375rem;
  }
  .nk-reply-info .lead-text {
    font-size: 13px;
  }
  .nk-reply-form-dropdown {
    margin-right: 0.5rem;
  }
  .nk-reply-form-group {
    flex-wrap: wrap;
    align-items: center;
  }
  .nk-reply-form-title {
    font-weight: 500;
  }
  .nk-reply-tools .attach-msg, .nk-reply-tools .date-msg {
    display: none;
  }
  .nk-reply-avatar {
    height: 30px;
    width: 30px;
  }
  .nk-reply-msg-excerpt {
    font-size: 12px;
    margin-top: 0.25rem;
  }
  .nk-reply-msg-info .sub-text {
    font-size: 12px;
  }
  .nk-reply-msg-info .dropdown-menu {
    margin-right: 16px !important;
  }
}
@media (min-width: 576px) {
  .nk-reply-form {
    margin: 0 2.25rem 2.25rem;
    border: 1px solid #e5e9f2;
    border-radius: 4px;
  }
  .nk-reply-form-header {
    padding: 0 1.5rem;
  }
  .nk-reply-form-field {
    padding: 0.5rem 1.5rem;
  }
  .nk-reply-form-field textarea.form-control.ex-large, .nk-reply-form-field .dual-listbox textarea.ex-large.dual-listbox__search, .dual-listbox .nk-reply-form-field textarea.ex-large.dual-listbox__search, .nk-reply-form-field textarea.ex-large.rdl-filter {
    min-height: 278px;
  }
  .nk-reply-form-tools {
    padding: 1rem 1.5rem;
  }
  .modal-body .nk-reply-form-tools {
    padding: 1.5rem;
  }
  .nk-reply-item {
    padding: 2rem 2.25rem;
  }
  .nk-reply-meta {
    margin: 0 2.25rem;
  }
  .nk-reply-header .date-time {
    font-size: 13px;
  }
  .nk-reply-quick-btns {
    margin: 0.5rem 2.25rem 2.25rem;
  }
}
@media (min-width: 992px) {
  .nk-reply-form {
    margin: 0 2.5rem 2.5rem;
  }
  .nk-reply-item {
    padding: 2rem 2.5rem;
  }
  .nk-reply-meta {
    margin: 0 2.5rem;
  }
  .nk-reply-quick-btns {
    margin: 0.5rem 2.5rem 2.5rem;
  }
}
.attach-files {
  margin-top: 1.75rem;
  border: 1px solid #e5e9f2;
  border-radius: 4px;
}
.attach-list {
  padding: 1rem 1.25rem;
  margin-bottom: -0.5rem;
  display: flex;
  flex-wrap: wrap;
}
.attach-item {
  width: 180px;
  padding-right: 2rem;
  padding-bottom: 0.5rem;
}
.attach-item a {
  display: flex;
  align-items: center;
  width: 100%;
  color: #526484;
}
.attach-item .icon {
  font-size: 1.5rem;
  color: #4461F2;
  margin-right: 0.75rem;
}
.attach-foot {
  border-top: 1px solid #e5e9f2;
  background: #f5f6fa;
  padding: 0.75rem 1.25rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.attach-info {
  font-weight: 500;
  color: #364a63;
}
.attach-download span {
  color: #8094ae;
  transition: all 0.3s;
}
.attach-download:hover span {
  color: #4461F2;
}

@media (max-width: 359px) {
  .attach-info {
    font-size: 12px;
  }
  .attach-download {
    font-size: 12px;
  }
}
.nk-msg-nav {
  position: relative;
  border-bottom: 1px solid #e5e9f2;
  padding: 0 1.25rem;
  background: #f5f6fa;
  z-index: 2;
}
.nk-msg-nav .search-wrap {
  padding: 0 1rem;
  bottom: -1px;
  border-bottom: 1px solid #e5e9f2;
}
.nk-msg-nav .search-submit {
  transform: translate(0.25rem, -50%);
}
.nk-msg-menu {
  display: flex;
  margin: 0 -0.75rem;
}
.nk-msg-menu-item {
  padding: 0 0.75rem;
}
.nk-msg-menu-item a {
  display: inline-flex;
  position: relative;
  color: #8094ae;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.5rem;
  padding: 1rem 0;
}
.nk-msg-menu-item a:after {
  position: absolute;
  content: "";
  height: 2px;
  background: #4461F2;
  bottom: -1px;
  left: 0;
  right: 0;
  opacity: 0;
  transition: 0.3s ease;
}
.nk-msg-menu-item a .icon {
  font-size: 1.125rem;
  line-height: 1.5rem;
}
.nk-msg-menu-item a:hover {
  color: #4461F2;
}
.nk-msg-menu-item.active a {
  color: #4461F2;
}
.nk-msg-menu-item.active a:after {
  opacity: 1;
}

.nk-msg {
  position: relative;
  display: flex;
  overflow: hidden;
  min-height: calc(100vh - (74px + 64px));
  max-height: calc(100vh - (74px + 64px));
  background: #fff;
}
.nk-msg-aside {
  background: #f5f6fa;
  width: 100%;
  overflow: hidden;
  max-height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}
.nk-msg-boxed .nk-msg-aside {
  background: rgba(245, 246, 250, 0.7);
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}
.nk-msg-list {
  max-height: 100%;
  height: 100%;
  overflow: auto;
}
.nk-msg-item {
  display: flex;
  padding: 1.25rem 1.25rem;
  cursor: pointer;
}
.nk-msg-item:not(:last-child) {
  border-bottom: 1px solid #e5e9f2;
}
.nk-msg-item.active, .nk-msg-item.current {
  background: #fff;
  cursor: default;
}
.nk-msg-info {
  max-width: calc(100% - 52px);
  margin-left: 0.75rem;
  flex-grow: 1;
}
.nk-msg-from {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.nk-msg-context {
  display: flex;
  justify-content: space-between;
  margin-top: 0.25rem;
}
.nk-msg-context .asterisk {
  margin-top: auto;
}
.nk-msg-sender {
  display: inline-flex;
  align-items: center;
  color: #8094ae;
  font-size: 12px;
}
.nk-msg-sender .name {
  margin-right: 0.5rem;
}
.is-unread .nk-msg-sender .name {
  font-weight: 500;
  color: #364a63;
}
.nk-msg-meta {
  display: inline-flex;
  align-items: center;
  color: #8094ae;
  font-size: 12px;
}
.nk-msg-meta .attchment .icon {
  font-size: 1.125rem;
}
.nk-msg-meta .date {
  margin-left: 0.75rem;
}
.nk-msg-text {
  max-width: calc(100% - 35px);
  flex-grow: 0;
  padding-right: 0.5rem;
}
.nk-msg-text .title {
  font-size: 15px;
  margin-bottom: 0.25rem;
}
.nk-msg-text p {
  font-size: 13px;
  color: #8094ae;
  max-height: 42px;
  overflow: hidden;
}
.is-unread .nk-msg-text p {
  color: #526484;
  font-weight: 500;
}
.nk-msg-lables {
  text-align: center;
  margin: -0.125rem;
  display: inline-flex;
  flex-direction: column;
}
.nk-msg-lables > div {
  padding: 0.125rem;
}
.nk-msg-lables .icon {
  font-size: 1.125rem;
}
.nk-msg-lables .badge {
  line-height: 14px;
  font-size: 10px;
  padding: 0 0.25rem;
}
.nk-msg-body {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: padding 0.3s ease-in-out;
  opacity: 0;
  pointer-events: none;
  z-index: 5;
}
.nk-msg-body.show-message {
  opacity: 1;
  pointer-events: auto;
}
.nk-msg-profile {
  position: absolute;
  top: 0;
  right: 0;
  transform: translateX(100%);
  width: 280px;
  height: 100%;
  max-height: 100%;
  transition: transform 0.3s ease-in-out;
  background: #fff;
  z-index: 100;
}
.nk-msg-profile-toggle {
  position: absolute;
  height: 36px;
  width: 36px;
  display: none;
  align-items: center;
  justify-content: center;
  bottom: -18px;
  right: -18px;
  margin-right: 40px;
  transition: right 0.3s ease-in-out, margin 0.3s ease-in-out 0.2s;
  border: 1px solid #e5e9f2;
  background-color: #fff;
  border-radius: 50%;
  font-size: 1.125rem;
  z-index: 2;
  color: #8094ae;
  z-index: 110;
}
.nk-msg-profile-toggle.active {
  margin-right: 0;
  transform: rotate(-180deg);
}
.nk-msg-profile-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(16, 25, 36, 0.4);
  z-index: 600;
  z-index: 90;
  animation: overlay-fade-in 0.4s ease 1;
}
.nk-msg-profile.visible {
  transform: none;
}
.nk-msg-head {
  position: relative;
  padding: 0.75rem 1.25rem;
  border-bottom: 1px solid #e5e9f2;
}
.nk-msg-head .title {
  margin-bottom: 0.5rem;
}
.nk-msg-head-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.nk-msg-hide {
  font-size: 1rem;
}
.nk-msg-tags {
  margin: 0 -0.75rem;
}
.nk-msg-tags li {
  padding: 0 0.75rem;
  color: #8094ae;
}
.nk-msg-tags li > span {
  display: inline-flex;
  align-items: center;
}
.nk-msg-tags li > span .icon {
  color: #4461F2;
  margin-right: 0.25rem;
}
.nk-msg-actions {
  display: flex;
  margin: 0 -0.25rem;
}
.nk-msg-actions li {
  padding: 0 0.25rem;
}

@media (max-width: 575.98px) {
  .nk-msg-boxed {
    border: none;
    border-radius: 4px;
    min-height: calc(100vh - (74px));
    max-height: calc(100vh - (74px));
  }
}
@media (min-width: 576px) {
  .nk-msg-nav {
    padding: 0 2rem;
  }
  .nk-msg-nav .search-wrap {
    padding: 0 1.7rem;
  }
  .nk-msg-item {
    padding: 1.25rem 2rem;
  }
  .nk-msg-head {
    padding: 1rem 2.25rem;
  }
  .nk-msg-head .title {
    margin-bottom: 1rem;
  }
}
@media (min-width: 576px) and (max-width: 991.98px) {
  .nk-msg-text .title {
    margin-top: 0.125rem;
    margin-bottom: 0.375rem;
  }
}
@media (min-width: 992px) {
  .nk-msg-nav {
    padding: 0 1.75rem;
  }
  .nk-msg-nav .search-wrap {
    padding: 0 1.425rem;
  }
  .nk-msg-item {
    padding: 1.25rem 1.75rem;
  }
  .nk-msg-head {
    padding: 2rem 2.5rem;
  }
  .nk-msg-head .title {
    max-height: 82px;
    overflow: hidden;
  }
  .nk-msg-aside {
    width: 320px;
    border-right: 1px solid #e5e9f2;
  }
  .nk-msg-body {
    position: static;
    opacity: 1;
    pointer-events: auto;
  }
  .nk-msg-profile {
    border-left: 1px solid #e5e9f2;
  }
  .nk-msg-profile-toggle {
    margin-right: 55px;
    display: flex;
  }
}
@media (min-width: 1540px) {
  .nk-msg-aside {
    width: 380px;
  }
}
@media (max-width: 1539.98px) {
  .profile-shown .nk-msg-profile-toggle {
    right: 262px;
  }
  .has-apps-sidebar .profile-shown .nk-msg-profile-toggle {
    right: -18px;
  }
}
@media (max-width: 1279px) {
  .has-apps-sidebar .profile-shown .nk-msg-profile-toggle {
    right: 262px;
  }
}
@media (min-width: 1540px) {
  .nk-msg-body.profile-shown {
    padding-right: 280px;
  }
}
@media (min-width: 1280px) {
  .has-apps-sidebar .nk-msg-body.profile-shown {
    padding-right: 280px;
  }
}
.ibx-count {
  position: relative;
  padding: 0.3125rem 0.75rem;
  font-size: 0.75rem;
  color: #8094ae;
  background: #fff;
  border: 1px solid #e5e9f2;
  display: inline-block;
  font-weight: 400;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 3px;
}
.ibx-count:before, .ibx-count:after {
  position: absolute;
  height: 0;
  width: 0;
  top: 50%;
  transform: translateY(-50%);
  content: "";
  border-style: solid;
}
.ibx-count:before {
  right: -8px;
  border-color: transparent transparent transparent #e5e9f2;
  border-width: 4px 0 4px 7px;
}
.ibx-count:after {
  right: -6px;
  border-width: 3px 0 3px 6px;
  border-color: transparent transparent transparent #fff;
}

.nk-ibx-context {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.nk-ibx-context-group {
  display: flex;
  align-items: center;
}
.nk-ibx-context-badges {
  margin-right: 0.75rem;
}
.nk-ibx-context-text {
  display: inline;
  color: #8094ae;
}
.is-unread .nk-ibx-context-text {
  color: #526484;
}
.nk-ibx-context-text .heading {
  color: #364a63;
}
.is-unread .nk-ibx-context-text .heading {
  font-weight: 500;
}

.ibx-actions {
  position: relative;
  display: inline-block;
  transition: background-color 0.3s;
}
.ibx-actions-hidden {
  position: absolute;
  display: flex;
  right: calc(100% + 8px);
  opacity: 0;
  transition: background-color 0.3s;
}
.nk-ibx-item:hover .ibx-actions-hidden {
  opacity: 1;
  background-color: #f5f6fa;
}
.nk-ibx-item:hover .ibx-actions {
  background-color: #f5f6fa;
}

.nk-ibx {
  position: relative;
  display: flex;
  overflow: hidden;
  min-height: calc(100vh - (74px + 64px));
  max-height: calc(100vh - (74px + 64px));
  background: #fff;
}
.nk-ibx-aside {
  position: absolute;
  background: #fff;
  width: 260px;
  overflow: hidden;
  height: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex-shrink: 0;
  border-right: 1px solid #e5e9f2;
  transform: translateX(-100%);
  z-index: 99;
  transition: transform 0.4s linear;
}
.nk-ibx-aside + .toggle-overlay {
  z-index: 90;
  position: absolute;
}
.nk-ibx-aside.content-active {
  transform: none;
}
.nk-ibx-nav {
  overflow: auto;
  flex-grow: 1;
  height: 100%;
  max-width: 100%;
}
.nk-ibx-nav .simplebar-content {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.nk-ibx-nav-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2rem 1.5rem 0.75rem;
}
.nk-ibx-nav-head .title {
  font-size: 1rem;
  margin-bottom: 0;
}
.nk-ibx-nav-head .dropdown > a, .nk-ibx-nav-head > .link {
  color: #8094ae;
  font-size: 0.875rem;
}
.nk-ibx-head {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1.25rem;
  border-bottom: 1px solid #e5e9f2;
  min-height: 61px;
}
.nk-ibx-head .title {
  font-size: 1rem;
  margin-bottom: 0;
}
.nk-ibx-head-actions, .nk-ibx-head-tools {
  display: flex;
  align-items: center;
}
.nk-ibx-head-tools .btn-icon.btn-trigger .icon, .nk-ibx-head-tools .dt-buttons .btn-trigger.btn-secondary .icon, .dt-buttons .nk-ibx-head-tools .btn-trigger.btn-secondary .icon {
  font-size: 1.25rem;
}
.nk-ibx-head .search-wrap {
  padding: 0 1.365rem 0 1rem;
}
.nk-ibx-head .search-wrap .icon {
  font-size: 1.25rem;
}
.nk-ibx-head .search-back {
  transform: translate(-0.5rem, -50%);
}
.nk-ibx-head-check {
  display: flex;
  margin-right: 0.325rem;
}
.nk-ibx-action {
  position: relative;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e5e9f2;
}
.nk-ibx-action-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.nk-ibx-action-item a {
  display: flex;
  align-items: center;
}
.nk-ibx-action-item .icon {
  font-size: 1.5rem;
}
.nk-ibx-action-item .icon + span {
  margin-left: 0.5rem;
}
.nk-ibx-action-item .search-toggle .icon {
  font-size: 1.125rem;
}
.nk-ibx-menu li {
  margin: 2px 0;
}
.nk-ibx-menu li:hover {
  background: #f5f6fa;
  border-radius: 3px;
}
.nk-ibx-menu li.active {
  background: #f0eaff;
  border-radius: 3px;
}
.nk-ibx-menu-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  border-radius: 4px;
}
.nk-ibx-menu-item .icon {
  font-size: 1.25rem;
  line-height: 1.5rem;
  width: 2rem;
  color: #8094ae;
}
.nk-ibx-menu-item .badge {
  margin-left: auto;
  min-width: 2.25rem;
  justify-content: center;
}
.active .nk-ibx-menu-item .icon {
  color: #4461F2;
}
.nk-ibx-menu-text {
  font-size: 0.875rem;
  color: #526484;
  font-weight: 500;
  line-height: 1.5rem;
}
.active .nk-ibx-menu-text {
  color: #4461F2;
}
.nk-ibx-label > li, .nk-ibx-contact > li {
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 4px;
  margin: 2px 0;
  transition: background-color 0.3s;
}
.nk-ibx-label > li > a, .nk-ibx-contact > li > a {
  display: flex;
  padding: 0.5rem 0.75rem;
  flex-grow: 1;
}
.nk-ibx-label > li .dropdown, .nk-ibx-contact > li .dropdown {
  opacity: 0;
}
.nk-ibx-label > li .dropdown > a, .nk-ibx-contact > li .dropdown > a {
  color: #526484;
  padding: 0.6875rem;
}
.nk-ibx-label > li:hover, .nk-ibx-contact > li:hover {
  background: #f5f6fa;
}
.nk-ibx-label > li:hover .dropdown, .nk-ibx-contact > li:hover .dropdown {
  opacity: 1;
}
.nk-ibx-label > li.active, .nk-ibx-contact > li.active {
  background: #d4c2ff;
}
.nk-ibx-label-text {
  line-height: 1;
  margin-left: 1rem;
  font-size: 0.875rem;
  color: #526484;
  font-weight: 500;
}
.nk-ibx-menu, .nk-ibx-label, .nk-ibx-contact {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.nk-ibx-menu {
  padding-top: 0.75rem;
}
.nk-ibx-contact {
  padding-bottom: 1.75rem;
}
.nk-ibx-status {
  margin-top: auto;
  background: #f5f6fa;
  padding: 1.5rem 1.5rem;
}
.nk-ibx-status-info {
  margin-bottom: 0.5rem;
}
.nk-ibx-status-info .icon {
  width: 1.25rem;
  display: inline-block;
}
.nk-ibx-body {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex-grow: 1;
  flex-shrink: 1;
}
.nk-ibx-list {
  display: flex;
  flex-direction: column;
  max-height: 100%;
  height: 100%;
  overflow: auto;
}
.nk-ibx-item {
  position: relative;
  display: flex;
  align-items: center;
  background: #fff;
  padding: 1rem 1.25rem;
  transition: background-color 0.3s;
  cursor: pointer;
}
.nk-ibx-item:not(:last-child) {
  border-bottom: 1px solid #e5e9f2;
}
.nk-ibx-item:not(.no-hover):hover, .nk-ibx-item.active {
  background: #f5f6fa;
}
.nk-ibx-item.is-unread {
  background: rgba(245, 246, 250, 0.6);
}
.nk-ibx-item-elem {
  padding: 0 8px;
  flex-shrink: 0;
}
.nk-ibx-item-elem:first-child {
  padding-left: 0;
}
.nk-ibx-item-check {
  width: 28px;
  display: inline-flex;
}
.nk-ibx-item-fluid {
  flex-grow: 1;
  flex-shrink: 1;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}
.nk-ibx-item-user .user-name {
  max-width: calc(100% - 50px);
}
.nk-ibx-item-user .user-name .lead-text {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 400;
}
.is-unread .nk-ibx-item-user .user-name .lead-text {
  font-weight: 500;
}
.nk-ibx-item-count {
  width: 3.25rem;
}
.nk-ibx-item-time {
  width: 80px;
  text-align: right;
}
.nk-ibx-item-attach {
  width: 2.25rem;
  text-align: center;
}
.nk-ibx-item-star .asterisk {
  padding: 0 0.25rem;
}
.nk-ibx-item-star .asterisk a {
  display: flex;
}
.nk-ibx-item-star .asterisk .icon {
  line-height: 1;
  font-size: 1.125rem;
}
.nk-ibx-item-tools {
  padding-right: 0;
  margin-left: auto;
  text-align: right;
}
.nk-ibx-item-check, .nk-ibx-item-star, .nk-ibx-item-attach {
  position: relative;
  z-index: 2;
}
.nk-ibx-item-tools {
  position: relative;
}
.nk-ibx-link {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
}
.nk-ibx-link + .nk-ibx-item-elem {
  padding-left: 0;
}
.nk-ibx-view {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #fff;
  z-index: 2;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.nk-ibx-view.show-ibx {
  opacity: 1;
  visibility: visible;
  pointer-events: all;
}
.nk-ibx-reply-head {
  padding: 1.5rem 1.25rem 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.nk-ibx-reply-head .title {
  margin-bottom: 0.75rem;
}
.nk-ibx-reply-header {
  margin-right: -0.5rem;
}
.nk-ibx-reply-item {
  position: relative;
}
.nk-ibx-reply-item > div:not(.nk-reply-header) {
  margin-left: 0;
  margin-top: 1.25rem;
  margin-bottom: 0.75rem;
}
.nk-ibx-reply-item:not(:last-child):after {
  position: absolute;
  left: 1.25rem;
  right: 1.25rem;
  height: 1px;
  bottom: 1rem;
  content: "";
  background: #e5e9f2;
}

@media (min-width: 576px) {
  .nk-ibx-item, .nk-ibx-head {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .nk-ibx-head .search-wrap {
    padding: 0 2.375rem 0 2rem;
  }
  .nk-ibx-reply-head {
    padding: 2em 2.25rem 0;
  }
  .nk-ibx-reply-item {
    padding-bottom: 2.75rem;
  }
  .nk-ibx-reply-item > div:not(.nk-reply-header) {
    margin-left: 56px;
  }
  .nk-ibx-reply-item:not(:last-child):after {
    bottom: 1.375rem;
    left: 2.25rem;
    right: 2.25rem;
  }
  .nk-ibx-reply-quick-btns, .nk-ibx-reply-form {
    margin-left: 5.75rem;
  }
}
@media (min-width: 768px) {
  .nk-ibx-item-user {
    width: 180px;
  }
}
@media (min-width: 992px) {
  .nk-ibx-aside {
    position: static;
    transform: none;
    transition: none;
    height: calc(100vh - 128px);
  }
  .nk-ibx-menu, .nk-ibx-label, .nk-ibx-contact {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .nk-ibx-menu {
    padding-top: 1rem;
  }
  .nk-ibx-contact {
    padding-bottom: 1rem;
  }
  .nk-ibx-nav-head {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .nk-ibx-item, .nk-ibx-head {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .nk-ibx-head .search-wrap {
    padding: 0 2.25rem 0 1.5rem;
  }
  .nk-ibx-body {
    max-width: calc(100% - 260px);
  }
  .nk-ibx-reply-quick-btns, .nk-ibx-reply-form {
    margin-left: 5.25rem;
  }
  .nk-ibx-reply-item, .nk-ibx-reply-head {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
}
@media (min-width: 1200px) {
  .nk-ibx-aside {
    width: 300px;
  }
  .nk-ibx-item-user {
    width: 200px;
  }
  .nk-ibx-item-time {
    margin-right: 5rem;
  }
}
@media (min-width: 1540px) {
  .nk-ibx-item-user {
    width: 260px;
  }
  .nk-ibx-item-tools {
    margin-left: 5rem;
  }
}
@media (max-width: 1199.98px) {
  .nk-ibx-item-attach {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .nk-ibx-item {
    flex-wrap: wrap;
  }
  .nk-ibx-item-elem {
    padding: 0 4px;
  }
  .nk-ibx-item-fluid {
    padding-left: 32px;
    padding-right: 48px;
    margin-top: 6px;
    width: calc(100% - 2.5rem);
  }
  .nk-ibx-item-fluid .heading {
    display: block;
  }
  .nk-ibx-item-count, .nk-ibx-item-attach {
    display: none;
  }
  .nk-ibx-item-user {
    flex-grow: 1;
  }
  .nk-ibx-item-user .user-avatar {
    height: 28px;
    width: 28px;
    font-size: 12px;
  }
  .nk-ibx-item-time {
    position: absolute;
    right: 32px;
    top: 19px;
  }
  .nk-ibx-item-tools {
    position: absolute;
    right: 28px;
    text-align: right;
    bottom: 18px;
  }
  .nk-ibx-item-star {
    position: absolute;
    left: 28px;
    top: 50px;
  }
  .nk-ibx-context-badges {
    display: none;
  }
  .ibx-actions-hidden {
    display: none;
  }
}
@media (max-width: 575.98px) {
  .nk-ibx-item-star {
    left: 12px;
  }
  .nk-ibx-item-time {
    right: 12px;
  }
  .nk-ibx-item-tools {
    right: 8px;
  }
  .nk-ibx-reply-head .title {
    font-size: 1.125rem;
  }
  .nk-ibx-reply .btn-icon.btn-trigger, .nk-ibx-reply .dt-buttons .btn-trigger.btn-secondary, .dt-buttons .nk-ibx-reply .btn-trigger.btn-secondary {
    padding-top: 0.3125rem;
    padding-bottom: 0.3125rem;
  }
  .nk-ibx-reply .btn-icon.btn-trigger .icon, .nk-ibx-reply .dt-buttons .btn-trigger.btn-secondary .icon, .dt-buttons .nk-ibx-reply .btn-trigger.btn-secondary .icon {
    width: 1.875rem;
  }
}
@media (max-width: 359px) {
  .nk-ibx-head .btn-icon.btn-trigger, .nk-ibx-head .dt-buttons .btn-trigger.btn-secondary, .dt-buttons .nk-ibx-head .btn-trigger.btn-secondary {
    padding-top: 0.3125rem;
    padding-bottom: 0.3125rem;
  }
  .nk-ibx-head .btn-icon.btn-trigger .icon, .nk-ibx-head .dt-buttons .btn-trigger.btn-secondary .icon, .dt-buttons .nk-ibx-head .btn-trigger.btn-secondary .icon {
    width: 1.875rem;
  }
}
@media (min-width: 576px) and (max-width: 991.98px) {
  .nk-ibx-aside {
    width: 320px;
  }
  .nk-ibx-menu, .nk-ibx-label, .nk-ibx-contact {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .nk-ibx-nav-head, .nk-ibx-status {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
}
.nk-fmg {
  position: relative;
  background-color: #f5f6fa;
  min-height: calc(100vh - (74px + 64px));
}
.nk-fmg-aside {
  position: fixed;
  width: 260px;
  overflow: hidden;
  height: 100%;
  max-height: 100%;
  background: #fff;
  flex-shrink: 0;
  left: 0;
  transform: translateX(-100%);
  border-right: 1px solid #e5e9f2;
  z-index: 99;
  top: 74px;
  transition: transform 0.4s linear;
  min-height: calc(100vh - 74px);
  max-height: calc(100vh - 74px);
  overflow-y: auto;
}
.nk-fmg-aside + .toggle-overlay {
  z-index: 90;
}
.nk-fmg-aside.content-active {
  transform: none;
}
.nk-fmg-aside .simplebar-content {
  height: 100%;
}
.nk-fmg-aside-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.nk-fmg-aside-top {
  margin-bottom: auto;
  margin-bottom: 30px;
}
.nk-fmg-menu {
  padding: 1rem;
}
.nk-fmg-menu li {
  margin: 2px 0;
}
.nk-fmg-menu-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0.5rem 0.75rem;
  border-radius: 4px;
}
.nk-fmg-menu-item:hover {
  background: #f5f6fa;
  border-radius: 3px;
}
.active > .nk-fmg-menu-item {
  background: #f0eaff;
  border-radius: 3px;
}
.nk-fmg-menu-item .icon {
  font-size: 1.25rem;
  line-height: 1.25rem;
  margin-top: -2px;
  width: 2rem;
  color: #8094ae;
}
.nk-fmg-menu-item .badge {
  margin-left: auto;
  min-width: 2.25rem;
}
.active > .nk-fmg-menu-item .icon {
  color: #4461F2;
}
.nk-fmg-menu-text {
  font-size: 0.875rem;
  color: #526484;
  font-weight: 500;
  line-height: 1.5rem;
}
.active > .nk-fmg-menu-item > .nk-fmg-menu-text {
  color: #4461F2;
}
.nk-fmg-menu li ul {
  margin-top: -0.125rem;
  margin-bottom: 0.5rem;
  padding-left: 2.75rem;
}
.nk-fmg-menu li ul ul {
  padding-left: 0.75rem;
  border-left: 1px solid #e5e9f2;
}
.nk-fmg-menu li ul .nk-fmg-menu-item {
  padding: 0.125rem 0;
}
.nk-fmg-menu li ul .nk-fmg-menu-item:hover, .nk-fmg-menu li ul .nk-fmg-menu-item.active {
  background: transparent;
}
.nk-fmg-menu li ul .nk-fmg-menu-item:hover span, .nk-fmg-menu li ul .nk-fmg-menu-item.active span {
  color: #4461F2;
}
.nk-fmg-menu li ul .nk-fmg-menu-text {
  font-size: 90%;
  line-height: 1.375rem;
}
.nk-fmg-status {
  padding: 1.75rem;
}
.nk-fmg-status-title {
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  color: #526484;
  margin-bottom: 1rem;
}
.nk-fmg-status-title .icon {
  font-size: 1.25rem;
  margin-right: 0.75rem;
}
.nk-fmg-status-info {
  font-size: 12px;
  font-weight: 500;
  color: #8094ae;
  margin-top: 1rem;
}
.nk-fmg-body {
  display: flex;
  flex-direction: column;
  max-height: 100%;
  flex-grow: 1;
  flex-shrink: 0;
}
.nk-fmg-body-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0.75rem 1.25rem;
  border-bottom: 1px solid #dbdfea;
  background-color: #fff;
  z-index: 9;
  position: relative;
  top: 0;
  border-top-right-radius: 4px;
}
.nk-fmg-body-content {
  padding: 1.125rem 1.25rem;
  height: 100%;
  max-height: 100%;
  overflow: auto;
}
.nk-fmg-body .simplebar-content {
  min-height: 470px;
}
.nk-fmg-search {
  display: flex;
  align-items: center;
  flex-grow: 1;
}
.nk-fmg-filter {
  margin-bottom: 1.25rem;
}
.nk-fmg-filter .form-label {
  font-weight: 500;
  font-size: 13px;
  color: #8094ae;
}
.nk-fmg-filter .form-group {
  margin-bottom: 1rem;
}
.nk-fmg-switch {
  background-color: transparent;
  border-top: 1px solid #e5e9f2;
}
.nk-fmg-switch > div {
  width: 100%;
}
.nk-fmg-switch .dropdown-toggle {
  padding: 1.25rem 1.75rem;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
}
.nk-fmg-switch .dropdown-toggle:after {
  position: absolute;
  right: 1.5rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1rem;
  color: #526484;
}
.nk-fmg-listing {
  min-height: 380px;
}
.nk-fmg-listing.is-scrollable {
  min-height: auto;
  max-height: 298px;
}

@media (min-width: 576px) {
  .nk-fmg-body-content {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }
  .nk-fmg-aside-top {
    margin-bottom: 100px;
  }
}
@media (min-width: 992px) {
  .nk-fmg {
    padding-left: 260px;
  }
  .nk-fmg-aside {
    transform: none;
    transition: none;
    width: 260px;
    position: absolute;
    left: 0;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    top: 0;
    min-height: 100%;
    max-height: 100%;
  }
  .nk-fmg-aside-top {
    flex-grow: 0;
  }
  .nk-fmg-body-head {
    padding: 0.75rem 1.75rem;
    z-index: 9;
  }
  .nk-fmg-body-content {
    padding: 1.75rem;
  }
}
@media (min-width: 1200px) {
  .nk-fmg {
    padding-left: 220px;
  }
  .nk-fmg-filter.toggle-expand-content {
    display: block !important;
  }
  .nk-fmg-aside {
    width: 220px;
  }
}
@media (min-width: 992px) and (max-width: 1360px) {
  .nk-fmg {
    padding-left: 220px;
  }
  .nk-fmg-aside {
    width: 220px;
  }
}
@media (min-width: 576px) and (max-width: 991.98px) {
  .nk-fmg-aside {
    width: 320px;
  }
  .nk-fmg-body-head, .nk-fmg-body-content, .nk-fmg-status, .nk-fmg-switch .dropdown-toggle {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .nk-fmg-menu {
    padding: 1rem 1.75rem;
  }
}
.nk-file .tb-sub {
  font-size: 12px;
  color: #8094ae;
}
.nk-file .tb-head {
  font-weight: 500;
  font-size: 13px;
  color: #8094ae;
}
.nk-file-info:hover .nk-file-name .asterisk a, .nk-file-info .nk-file-name .asterisk a.active {
  opacity: 1;
}
.nk-file-icon {
  margin-right: 8px;
  flex-shrink: 0;
}
.nk-file-icon-link {
  display: block;
  text-decoration: none;
  color: inherit;
}
.nk-file-icon-type {
  width: 32px;
  display: inline-block;
  text-decoration: none;
  color: inherit;
  margin: auto;
}
.nk-file-title {
  display: flex;
  align-items: center;
}
.nk-file-title .breadcrumb {
  padding-top: 0.25rem;
  padding-bottom: 0;
}
.nk-file-name {
  font-weight: 500;
  color: #364a63;
  position: relative;
  line-height: 1.4;
}
.nk-file-name-text {
  padding-right: 1.5rem;
  display: inline-block;
}
.nk-file-name-text .title {
  transition: color 0.3s;
  display: inline-block;
  text-decoration: none;
  word-break: break-word;
}
.nk-file-name-text a.title {
  color: #364a63;
}
.nk-file-name-text a.title:hover {
  color: #4461F2;
}
.nk-file-name-sub {
  font-size: 12px;
  color: #8094ae;
}
.nk-file-name .asterisk {
  position: absolute;
  display: inline-flex;
  margin-left: 0.5rem;
  transition: 0.3s opacity;
  margin-top: -1px;
  top: 50%;
  transform: translateY(-50%);
}
.nk-file-name .asterisk a {
  opacity: 0;
}
.nk-file-name .asterisk .icon {
  font-size: 1.125rem;
  color: #4461F2;
}
.nk-file-desc {
  display: flex;
  align-items: center;
  margin: 0 -0.375rem;
}
.nk-file-desc li {
  position: relative;
  padding: 0 0.375rem;
  font-size: 12px;
  color: #8094ae;
}
.nk-file-desc li:not(:first-child):before {
  content: "\\eca1";
  font-family: "Nioicon";
  position: absolute;
  left: 0;
  top: 50%;
  font-size: 11px;
  line-height: 10px;
  transform: translate(-50%, -50%);
  opacity: 0.8;
}
.nk-file-link {
  text-decoration: none;
  color: inherit;
  display: block;
}
.nk-file-link:hover .title {
  color: #4461F2;
}
.nk-file-info > .nk-file-link {
  padding: 0.75rem 0;
}
.is-compact .nk-file-info > .nk-file-link {
  padding: 0.375rem 0;
}
.nk-file-share-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.25rem;
  border-bottom: 1px solid #e5e9f2;
}
.nk-file-share-field {
  padding: 0.5rem 1.25rem;
}
.nk-file-share-field:not(:last-child) {
  border-bottom: 1px solid #e5e9f2;
}
.nk-file-share-field .form-control, .nk-file-share-field div.dataTables_wrapper div.dataTables_filter input, div.dataTables_wrapper div.dataTables_filter .nk-file-share-field input, .nk-file-share-field .dual-listbox .dual-listbox__search, .dual-listbox .nk-file-share-field .dual-listbox__search, .nk-file-share-field .rdl-filter {
  font-size: 0.875rem;
}
.nk-file-share-field textarea.form-control, .nk-file-share-field .dual-listbox textarea.dual-listbox__search, .dual-listbox .nk-file-share-field textarea.dual-listbox__search, .nk-file-share-field textarea.rdl-filter {
  min-height: 78px;
}
.nk-file-share-field textarea.form-control.ex-large, .nk-file-share-field .dual-listbox textarea.ex-large.dual-listbox__search, .dual-listbox .nk-file-share-field textarea.ex-large.dual-listbox__search, .nk-file-share-field textarea.ex-large.rdl-filter {
  min-height: 160px;
}
.nk-file-share-input {
  display: flex;
}
.nk-file-share-input .label {
  margin: 0.3rem 0.5rem 0.3rem 0;
  width: 1.25rem;
  color: #8094ae;
}
.nk-file-share-input-group {
  width: 100%;
}
.nk-file-share-group {
  position: relative;
  padding: 1rem 0;
  flex-grow: 1;
  display: flex;
  align-items: center;
}
.nk-file-share-nav {
  flex-shrink: 0;
}
.nk-file-details-row {
  display: flex;
  flex-wrap: wrap;
  padding: 0.25rem 0;
}
.nk-file-details-col {
  font-size: 13px;
}
.nk-file-details-col:first-child {
  color: #8094ae;
  width: 100%;
}
.nk-file-details-col:last-child {
  color: #526484;
}
.nk-file-details-col .breadcrumb {
  padding: 0;
}

@media (min-width: 420px) {
  .nk-file-details-row {
    flex-wrap: nowrap;
    padding: 0.375rem 0;
  }
  .nk-file-details-col:first-child {
    width: 100px;
    flex-shrink: 0;
  }
}
@media (min-width: 576px) {
  .nk-file-share-field textarea.form-control.ex-large, .nk-file-share-field .dual-listbox textarea.ex-large.dual-listbox__search, .dual-listbox .nk-file-share-field textarea.ex-large.dual-listbox__search, .nk-file-share-field textarea.ex-large.rdl-filter {
    min-height: 278px;
  }
}
.nk-files .nk-file .hideable {
  opacity: 0;
  transition: opacity 0.3s;
}
.nk-files .nk-file:hover .hideable {
  opacity: 1;
}
.nk-files .nk-file-item {
  display: table-row;
}
.nk-files .nk-file-item > div {
  position: relative;
  display: table-cell;
  padding: 0.5rem;
  vertical-align: middle;
}
.nk-files .nk-file-actions {
  width: 60px;
  text-align: center;
}
.nk-files-head {
  display: table-header-group;
}
.nk-files-head .nk-file-item > div {
  font-weight: 500;
  font-size: 0.8125rem;
  padding: 0.25rem;
}
.nk-files-head .nk-file-item > div:first-child {
  padding-left: 0;
}
.nk-files-head .nk-file-item > div:last-child {
  padding-right: 0.5rem;
}
.nk-files-head .dropdown-menu-xs {
  min-width: 140px;
  max-width: 140px;
}
.nk-files-list {
  display: table-row-group;
}
.nk-files-view-list {
  display: table;
  width: 100%;
}
.nk-files-view-list .nk-file {
  display: table-row;
}
.nk-files-view-list .nk-file.selected {
  background: #e7dcff;
}
.nk-files-view-list .nk-file.selected > div {
  background: transparent;
}
.nk-files-view-list .nk-file > div {
  padding: 0.5rem 0.375rem;
  height: 4rem;
  background-color: #fff;
}
.nk-files-view-list .nk-file > div:first-child {
  padding-left: 1.25rem;
}
.nk-files-view-list .nk-file > div.nk-file-info {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.nk-files-view-list .nk-file:first-child > div:first-child {
  border-top-left-radius: 4px;
}
.nk-files-view-list .nk-file:first-child > div:last-child {
  border-top-right-radius: 4px;
}
.nk-files-view-list .nk-file:last-child > div:first-child {
  border-bottom-left-radius: 4px;
}
.nk-files-view-list .nk-file:last-child > div:last-child {
  border-bottom-right-radius: 4px;
}
.nk-files-view-list .nk-file:not(:last-child) > div {
  border-bottom: 1px solid #dbdfea;
}
.nk-files-view-list .nk-file .custom-checkbox {
  margin-right: 1rem;
}
.nk-files-view-list .nk-file-members .tb-shared {
  position: absolute;
  left: -1rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1rem;
}
.nk-files-view-list .nk-file-name-text a.title {
  padding: 1rem 0 0.875rem;
}
.nk-files-view-list .nk-file-icon + .nk-file-name a.title {
  padding-left: 40px;
  margin-left: -40px;
}
.nk-files-view-list.is-compact .nk-file > div {
  height: 3rem;
}
.nk-files-view-grid .nk-files-head, .nk-files-view-group .nk-files-head {
  margin-bottom: 0.25rem;
  width: 100%;
  display: flex;
}
.nk-files-view-grid .nk-files-head .nk-file-item, .nk-files-view-group .nk-files-head .nk-file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0;
}
.nk-files-view-grid .nk-files-head .nk-file-item > div:not(.nk-file-info):not(.nk-file-actions), .nk-files-view-group .nk-files-head .nk-file-item > div:not(.nk-file-info):not(.nk-file-actions) {
  display: none;
}
.nk-files-view-grid .nk-files-head .nk-file-actions, .nk-files-view-group .nk-files-head .nk-file-actions {
  width: 30px;
  padding: 0 !important;
  margin-right: -4px;
}
.nk-files-view-grid .nk-files-list, .nk-files-view-group .nk-files-list {
  display: flex;
  flex-wrap: wrap;
  margin: -8px;
}
.nk-files-view-grid .nk-files-list .nk-file-actions, .nk-files-view-group .nk-files-list .nk-file-actions {
  position: absolute;
  border: 0 none;
  background: transparent;
  width: 46px;
  right: 4px;
  top: 10px;
}
.nk-files-view-grid .nk-files-list .custom-control, .nk-files-view-group .nk-files-list .custom-control {
  position: absolute;
}
.nk-files-view-grid .nk-file, .nk-files-view-group .nk-file {
  display: flex;
  position: relative;
  margin: 8px;
  background: #fff;
  border-radius: 4px;
}
.nk-files-view-grid .nk-file .nk-file-members, .nk-files-view-group .nk-file .nk-file-members {
  display: none;
}
.nk-files-view-grid .nk-file {
  display: block;
  position: relative;
  width: calc(50% - 16px);
  text-align: center;
  padding: 0.5rem 0.25rem;
}
.nk-files-view-grid .nk-file > div {
  display: block;
  padding: 0;
}
.nk-files-view-grid .nk-file-title {
  display: flex;
  flex-direction: column;
}
.nk-files-view-grid .nk-file-icon {
  display: block;
  margin: 0;
  width: 100%;
}
.nk-files-view-grid .nk-file-icon-type {
  width: 72px;
  padding: 0.5rem 0;
}
.nk-files-view-grid .nk-file-name .title {
  padding: 0.5rem 0.125rem 0.5rem;
}
.nk-files-view-grid .nk-file-name-text {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.nk-files-view-grid .nk-file-desc {
  padding: 0 0.25rem 0.75rem;
  margin-top: -0.125rem;
  justify-content: center;
}
.nk-files-view-grid .nk-file-desc .members {
  display: none;
}
.nk-files-view-grid .nk-file-info > .nk-file-link {
  padding: 0.5rem 0;
}
.nk-files-view-grid .nk-file .nk-file-members {
  display: none;
}
.nk-files-view-grid .nk-file .nk-file-meta {
  padding-bottom: 0.5rem;
}
.nk-files-view-grid .nk-file .custom-control {
  top: 0.75rem;
  left: 1rem;
}
.nk-files-view-group .nk-file {
  position: relative;
  padding: 0.5rem 0.5rem;
  width: 100%;
}
.nk-files-view-group .nk-file > div {
  display: block;
  width: 100%;
  padding-right: 2.5rem;
}
.nk-files-view-group .nk-file-desc {
  padding: 0.25rem 0.125rem 0;
}
.nk-files-view-group .nk-file-name-text a.title {
  padding: 0.125rem 0;
}
.nk-files-view-group .nk-file-icon + .nk-file-name a.title {
  padding-left: 40px;
  margin-left: -40px;
}
.nk-files-view-group .nk-file .nk-file-actions {
  right: 2px;
  top: 4px;
}
.nk-files-view-group .nk-file .custom-control {
  right: 0.5rem;
  bottom: 0.5rem;
}
.nk-files-view-group .nk-file .nk-file-meta {
  display: none;
}
.nk-files-group > .title {
  border-top: 1px solid #e5e9f2;
  font-size: 12px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 1rem 0;
  margin: 0;
}
.nk-files-group + .nk-files-group {
  margin-top: 3rem;
}

@media (max-width: 767.98px) {
  .nk-file-name-text {
    font-size: 13px;
  }
  .nk-files-view-grid .nk-file-name-text {
    font-size: 12px;
  }
}
@media (max-width: 991.98px) {
  .nk-fmg-body .nk-block-tools .btn-icon.btn-trigger .icon, .nk-fmg-body .nk-block-tools .dt-buttons .btn-trigger.btn-secondary .icon, .dt-buttons .nk-fmg-body .nk-block-tools .btn-trigger.btn-secondary .icon {
    font-size: 1.25rem;
  }
}
@media (min-width: 576px) {
  .nk-files-view-grid .nk-file {
    width: calc(33.33% - 16px);
  }
  .nk-files-view-group .nk-file {
    width: calc(100% - 16px);
  }
}
@media (min-width: 660px) {
  .nk-files-view-group .nk-file {
    width: calc(50% - 16px);
  }
}
@media (min-width: 1200px) {
  .nk-files-view-grid .nk-file {
    width: calc(25% - 16px);
  }
  .nk-files-view-group .nk-file {
    width: calc(50% - 16px);
  }
}
@media (min-width: 1540px) {
  .nk-files-view-grid .nk-file {
    width: calc(20% - 16px);
  }
  .nk-files-view-group .nk-file {
    width: calc(33.33% - 16px);
  }
}
@media (min-width: 1800px) {
  .nk-files-view-grid .nk-file {
    width: calc(16.66% - 16px);
  }
  .nk-files-view-group .nk-file {
    width: calc(25% - 16px);
  }
}
@media (max-width: 1199px) and (min-width: 992px), (max-width: 767px) {
  .nk-files-view-list .nk-file-members, .nk-files-view-list .nk-file-size {
    display: none !important;
  }
}
@media (max-width: 599px) {
  .nk-files-view-list .nk-file-icon-type {
    width: 24px;
  }
  .nk-files-view-list .nk-file-meta, .nk-files-view-list .nk-file-date, .nk-files-view-list .nk-file-size {
    display: none !important;
  }
  .nk-files-view-list .nk-file .custom-checkbox {
    margin-right: 0.75rem;
  }
}
@media (max-width: 359px) {
  .nk-files-view-grid .nk-file {
    width: 100%;
  }
}
.nk-upload-form {
  margin-bottom: 2.25rem;
}
.nk-upload-list > .title {
  font-size: 0.875rem;
  padding-bottom: 1rem;
}
.nk-upload-item {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  border-radius: 4px;
  border: 1px solid #e5e9f2;
  margin: 0.5rem 0;
}
.nk-upload-icon {
  width: 48px;
  margin-right: 0.25rem;
  flex-shrink: 0;
}
.nk-upload-info {
  font-weight: 500;
  color: #364a63;
  flex-grow: 1;
  padding-right: 0.75rem;
}
.nk-upload-title {
  display: flex;
  align-items: flex-end;
}
.nk-upload-title .title {
  font-size: 0.875rem;
}
.nk-upload-title .meta {
  font-size: 12px;
  margin-left: auto;
  color: #8094ae;
  font-weight: 400;
}
.nk-upload-size {
  font-size: 12px;
  color: #8094ae;
  font-weight: 400;
}
.nk-upload-progress {
  margin: 0.375rem 0 0.25rem;
}
.nk-upload-action {
  margin-left: auto;
}

.add-opt:hover .sub-text,
.add-opt:hover .icon {
  color: #4461F2;
}

.add-opt-icon .icon-circle, .contacts-add-link .icon-circle, .chat-members-link .icon-circle, .chat-option-link .icon-circle {
  height: 32px;
  width: 32px;
  font-size: 1rem;
}
.add-opt-icon .icon + span, .contacts-add-link .icon + span, .chat-members-link .icon + span, .chat-option-link .icon + span,
.add-opt-icon .icon + div,
.contacts-add-link .icon + div,
.chat-members-link .icon + div,
.chat-option-link .icon + div {
  margin-left: 0.75rem;
}

.chat-item {
  position: relative;
  border-radius: 4px;
  transition: background-color 0.3s;
}
.chat-item:hover {
  background-color: #ebeef2;
}
.chats-dropdown .chat-item:hover {
  background-color: #f5f6fa;
}
.chat-item:hover .chat-actions {
  opacity: 1;
  pointer-events: initial;
  transition: opacity 0.5s;
}
.chat-item.current {
  background-color: #f5f6fa;
}
.chat-item.current:hover {
  background-color: #ebeef2;
}
.chat-link {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.75rem;
  cursor: pointer;
}
.chat-media {
  height: 44px;
  width: 44px;
}
.chat-media + .chat-info {
  margin-left: 0.75rem;
}
.chat-info {
  width: calc(100% - 3.75rem);
}
.chat-from {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.chat-from .name {
  font-size: 0.9375rem;
  margin-bottom: 0;
  font-weight: 500;
  color: #526484;
}
.is-unread .chat-from .name {
  font-weight: 700;
  color: #364a63;
}
.chat-from .time {
  font-size: 12px;
  color: #8094ae;
}
.chat-context {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.chat-context .text {
  width: calc(100% - 2.5rem);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 13px;
  color: #8094ae;
}
.is-unread .chat-context .text {
  font-weight: 500;
  color: #526484;
}
.chat-context .status {
  display: flex;
  color: rgba(128, 148, 174, 0.8);
}
.is-unread .chat-context .status {
  color: #4461F2;
}
.chat-context .status.seen {
  color: #4461F2;
}
.chat-actions {
  background-color: #ebeef2;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0.75rem;
  opacity: 0;
  pointer-events: none;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 3rem;
}
.chat-profile-group {
  border-top: 1px solid #e5e9f2;
  padding: 0.25rem 0;
}
.chat-profile-head {
  padding: 1.25rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.chat-profile-head .title {
  margin-bottom: 0;
}
.chat-profile-head .indicator-icon {
  display: inline-flex;
}
.chat-profile-head.collapsed .indicator-icon {
  transform: rotate(-180deg);
}
.chat-profile-body-inner {
  padding: 0 1.5rem 1.5rem;
}
.chat-profile-options {
  margin: -0.25rem;
}
.chat-profile-options li {
  padding: 0.25rem;
}
.chat-profile-settings {
  margin: -0.5rem;
}
.chat-profile-settings li {
  padding: 0.5rem;
}
.chat-profile-settings .custom-control-sm .custom-control-label {
  padding-left: 0.25rem;
  font-size: 13px;
  font-weight: 500;
  color: #526484;
}
.chat-profile-media {
  display: flex;
  margin: -0.25rem;
}
.chat-profile-media li {
  width: 33.33%;
  padding: 0.25rem;
}
.chat-profile-media li a {
  display: inline-block;
}
.chat-profile-media li img {
  border-radius: 4px;
}
.chat-option-link {
  display: flex;
  align-items: center;
}
.chat-option-link .lead-text {
  font-weight: 500;
  font-size: 13px;
  transition: color 0.3s;
  color: #526484;
}
.chat-option-link:hover .lead-text {
  color: #1c2b46;
}
.chat-members {
  margin: -0.375rem -0.5rem;
}
.chat-members li {
  position: relative;
}
.chat-members-link {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.5rem;
}
.chat-members .user-card {
  position: relative;
  padding: 0.375rem 0.5rem;
  border-radius: 3px;
  transition: background-color 0.3s;
}
.chat-members .user-card > a {
  width: 100%;
  display: flex;
  align-items: center;
}
.chat-members .user-card:hover {
  background-color: #ebeef2;
}
.chat-members .user-card:hover .user-actions {
  opacity: 1;
  pointer-events: initial;
  transition: opacity 0.5s;
}
.chat-members .user-role {
  margin-left: auto;
  font-size: 12px;
  color: #8094ae;
}
.chat-members .user-actions {
  position: absolute;
  top: 0;
  right: 0.25rem;
  bottom: 0;
  width: 3rem;
  background-color: #ebeef2;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  opacity: 0;
  pointer-events: none;
}

.chat {
  display: flex;
  align-items: flex-end;
  margin: -4px;
}
.chat > div {
  padding: 4px;
}
.chat + .chat {
  padding-top: 0.5rem;
}
.chat-avatar {
  margin-bottom: 1.4rem;
}
.chat-avatar.no-meta {
  margin-bottom: 0;
}
.chat-bubble {
  display: flex;
  align-items: center;
  padding: 0.125rem 0;
}
.chat-bubble:hover .chat-msg-more {
  opacity: 1;
}
.chat-bubbles .attach-files {
  margin-top: 0.75rem;
}
.chat-msg {
  background-color: #fff;
  border-radius: 8px;
  padding: 5px 5px 8px 5px;
  word-break: normal;
  word-wrap: normal;
  overflow-wrap: normal;
  white-space: normal;
}
.chat-msg-more {
  display: flex;
  align-items: center;
  margin: 0 0.75rem;
  opacity: 0;
  flex-shrink: 0;
  transition: all 0.3s;
}
.chat-msg-more > li {
  padding: 0.25rem;
}
.chat-msg.is-light {
  background-color: #ebeef2;
  color: #526484;
}
.chat-msg.is-theme {
  background-color: #4461F2;
  color: #fff;
}
.chat-meta {
  display: flex;
  align-items: center;
  margin: 0.25rem -0.375rem 0;
}
.chat-meta li {
  position: relative;
  padding: 0 0.375rem;
  font-size: 12px;
  color: #8094ae;
}
.chat-meta li:not(:first-child):before {
  content: "\\eca1";
  font-family: "Nioicon";
  position: absolute;
  left: 0;
  top: 50%;
  font-size: 11px;
  line-height: 10px;
  transform: translate(-50%, -50%);
  opacity: 0.8;
}
.chat-sap {
  overflow: hidden;
  text-align: center;
  padding: 1rem 0;
}
.chat-sap-meta {
  position: relative;
  display: inline-block;
  padding: 0 0.75rem;
  color: #8094ae;
  font-size: 12px;
  line-height: 1.4;
}
.chat-sap-meta:before, .chat-sap-meta:after {
  position: absolute;
  height: 1px;
  background: #dbdfea;
  content: "";
  width: 100vw;
  top: 50%;
}
.chat-sap-meta:before {
  right: 100%;
}
.chat-sap-meta:after {
  left: 100%;
}
.chat.is-you .chat-bubbles .attach-files {
  border-color: #fff;
  overflow: hidden;
}
.chat.is-you .chat-bubbles .attach-files,
.chat.is-you .chat-bubbles .attach-foot {
  background-color: #fff;
}
.chat.is-you .chat-bubble:last-child .chat-msg {
  border-bottom-left-radius: 0;
}
.chat.is-you .chat-bubble:not(:first-child) .chat-msg {
  border-top-left-radius: 4px;
}
.chat.is-you .chat-bubble:not(:last-child) .chat-msg {
  border-bottom-left-radius: 4px;
}
.chat.is-me {
  justify-content: flex-end;
}
.chat.is-me .chat-msg {
  background-color: #86D97B;
  color: #000;
}
.chat.is-me .chat-meta {
  justify-content: flex-end;
}
.chat.is-me .chat-bubble {
  flex-direction: row-reverse;
}
.chat.is-me .chat-bubbles .attach-files {
  border-color: #d4c2ff;
  overflow: hidden;
}
.chat.is-me .chat-bubbles .attach-files,
.chat.is-me .chat-bubbles .attach-foot {
  background-color: #fff;
}
.chat.is-me .chat-bubble:last-child .chat-msg {
  border-bottom-right-radius: 0;
}
.chat.is-me .chat-bubble:not(:first-child) .chat-msg {
  border-top-right-radius: 4px;
}
.chat.is-me .chat-bubble:not(:last-child) .chat-msg {
  border-bottom-right-radius: 4px;
}
.chat-upload-option {
  display: none;
  position: absolute;
  left: 100%;
  padding: 0.5rem;
  background-color: #fff;
}
.chat-upload-option.expanded {
  display: block;
}
.chat-upload-option ul {
  display: flex;
  align-items: center;
}
.chat-upload-option a {
  color: #4461F2;
  font-size: 1.25rem;
  height: 36px;
  width: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.chat-upload-option a:hover {
  color: #1e41ef;
}

.fav-list {
  display: flex;
  margin: -0.375rem;
  overflow-x: auto;
}
.fav-list li {
  padding: 0.375rem;
}
.fav-list a:hover > .user-avatar:after {
  opacity: 1;
}
.fav-list .user-avatar {
  height: 44px;
  width: 44px;
}
.fav-list .user-avatar:after {
  content: "";
  position: absolute;
  width: 100%;
  left: 0;
  height: 100%;
  background: #e5e9f2;
  transform: scale(1.15);
  opacity: 0;
  border-radius: 50%;
  z-index: -1;
  transition: opacity 0.3s;
}

@media (min-width: 768px) {
  .fav-list {
    flex-wrap: wrap;
  }
}
@media (max-width: 859px) {
  .fav-list {
    margin: -0.375rem 0;
  }
  .fav-list li:first-child {
    padding-left: 0;
  }
  .fav-list li:last-child {
    padding-right: 0;
  }
}
.channel-list li {
  margin: 0.125rem -0.5rem;
}
.channel-list a {
  padding: 0.375rem 0.5rem;
  display: block;
  transition: all 0.3s;
  font-weight: 500;
  color: #526484;
  border-radius: 3px;
}
.channel-list a:hover, .channel-list a.active {
  color: #4461F2;
  background: #f0eaff;
}

.contacts-list {
  margin: -0.375rem -0.5rem;
}
.contacts-list + .contacts-list {
  margin-top: 1.75rem;
}
.contacts-list li {
  position: relative;
}
.contacts-list li > .title {
  padding-left: 1.25rem;
  margin-bottom: 0.25rem;
}
.contacts-list .user-card {
  position: relative;
  padding: 0.375rem 0.5rem;
  border-radius: 3px;
  transition: background-color 0.3s;
}
.contacts-list .user-card > a {
  width: 100%;
  display: flex;
  align-items: center;
}
.contacts-list .user-card:hover {
  background-color: #ebeef2;
}
.contacts-list .user-card:hover .user-actions {
  opacity: 1;
  pointer-events: initial;
  transition: opacity 0.4s;
}
.contacts-list .user-meta {
  margin-left: auto;
  font-size: 12px;
  color: #8094ae;
}
.contacts-list .user-actions {
  font-size: 12px;
  position: absolute;
  top: 0;
  right: 0.25rem;
  bottom: 0;
  width: 4.5rem;
  background-color: #ebeef2;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  opacity: 0;
  pointer-events: none;
}
.contacts-list .user-actions > a {
  padding: 0 0.375rem;
}
.contacts-add-link {
  padding: 0.375rem 0.5rem;
  display: flex;
  align-items: center;
}
.contacts-add-link .lead-text {
  font-weight: 500;
  font-size: 13px;
}

.nk-chat {
  position: relative;
  display: flex;
  overflow: hidden;
  min-height: calc(100vh - 64px);
  max-height: calc(100vh - (74px + 64px));
  background: #fff;
}
.nk-chat-blank {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  background-color: #ebeef2;
}
.nk-chat-blank-icon {
  margin-bottom: 1.5rem;
}
.nk-chat-aside {
  background: #fff;
  width: 100%;
  overflow: hidden;
  max-height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}
.nk-chat-aside-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.125rem 1.25rem 0.875rem;
}
.nk-chat-aside-user .title {
  font-size: 1.375rem;
  color: #364a63;
}
.nk-chat-aside-user .user-avatar {
  height: 36px;
  width: 36px;
}
.nk-chat-aside-user .user-avatar + .title {
  margin-left: 1rem;
}
.nk-chat-aside-user .dropdown-toggle:after {
  font-size: 1.125rem;
  color: #8094ae;
  margin-left: 1rem;
}
.nk-chat-aside-tools {
  display: flex;
  align-items: center;
}
.nk-chat-aside-body {
  max-height: 100%;
  height: 100%;
  overflow: auto;
}
.nk-chat-aside-search {
  padding: 0 1.25rem;
  margin-bottom: 1.75rem;
  margin-top: 0.25rem;
}
.nk-chat-aside-search .form-control, .nk-chat-aside-search div.dataTables_wrapper div.dataTables_filter input, div.dataTables_wrapper div.dataTables_filter .nk-chat-aside-search input, .nk-chat-aside-search .dual-listbox .dual-listbox__search, .dual-listbox .nk-chat-aside-search .dual-listbox__search, .nk-chat-aside-search .rdl-filter {
  background-color: #f5f6fa;
  border-color: #f5f6fa;
}
.nk-chat-aside-search .form-control::placeholder, .nk-chat-aside-search div.dataTables_wrapper div.dataTables_filter input::placeholder, div.dataTables_wrapper div.dataTables_filter .nk-chat-aside-search input::placeholder, .nk-chat-aside-search .dual-listbox .dual-listbox__search::placeholder, .dual-listbox .nk-chat-aside-search .dual-listbox__search::placeholder, .nk-chat-aside-search .rdl-filter::placeholder {
  color: #8094ae;
}
.nk-chat-aside-panel {
  padding: 0 1.25rem 1.75rem;
}
.nk-chat-aside-panel .title {
  margin-bottom: 0.75rem;
}
.nk-chat-list {
  padding: 0 0.5rem;
}
.nk-chat-list .title {
  margin-left: 0.75rem;
}
.nk-chat-body {
  background: #fff;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: padding 0.3s ease-in-out;
  opacity: 0;
  pointer-events: none;
  z-index: 5;
}
.nk-chat-body.show-chat {
  opacity: 1;
  pointer-events: auto;
}
.nk-chat-head {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.75rem;
  border-bottom: 1px solid #e5e9f2;
  background-color: #fff;
}
.nk-chat-head-info {
  width: 60%;
}
.nk-chat-head-info .user-avatar + .user-info {
  margin-left: 0.75rem;
}
.nk-chat-head-info .user-info .lead-text {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.nk-chat-head-info, .nk-chat-head-tools {
  display: flex;
  align-items: center;
  margin: -0.125rem;
}
.nk-chat-head-info > li, .nk-chat-head-tools > li {
  padding: 0.125rem;
}
.nk-chat-head-info .btn-icon .icon, .nk-chat-head-info .dt-buttons .btn-secondary .icon, .dt-buttons .nk-chat-head-info .btn-secondary .icon, .nk-chat-head-tools .btn-icon .icon, .nk-chat-head-tools .dt-buttons .btn-secondary .icon, .dt-buttons .nk-chat-head-tools .btn-secondary .icon {
  font-size: 1.25rem;
}
.nk-chat-head-search {
  position: absolute;
  top: calc(100% + 1rem);
  left: 0;
  z-index: 9;
  width: 100%;
  padding: 0 1.75rem;
  opacity: 0;
  pointer-events: none;
  transform: translateY(-10px);
  transition: all 0.5s;
}
.nk-chat-head-search.show-search {
  opacity: 1;
  pointer-events: auto;
  transform: none;
}
.nk-chat-panel {
  background-color: rgba(235, 238, 242, 0.7);
  height: 100%;
  max-height: 100%;
  overflow: auto;
  padding: 1.25rem;
}
.nk-chat-editor {
  display: flex;
  align-items: center;
  padding: 1rem 1.25rem;
  background-color: #fff;
}
.nk-chat-editor-form {
  padding: 0 0.5rem;
  flex-grow: 1;
}
.nk-chat-editor-form .form-control, .nk-chat-editor-form div.dataTables_wrapper div.dataTables_filter input, div.dataTables_wrapper div.dataTables_filter .nk-chat-editor-form input, .nk-chat-editor-form .dual-listbox .dual-listbox__search, .dual-listbox .nk-chat-editor-form .dual-listbox__search, .nk-chat-editor-form .rdl-filter {
  min-height: 36px;
  padding-top: 0.5rem;
}
.nk-chat-editor-upload, .nk-chat-editor-tools {
  display: flex;
  align-items: center;
}
.nk-chat-editor-upload .btn-icon .icon, .nk-chat-editor-upload .dt-buttons .btn-secondary .icon, .dt-buttons .nk-chat-editor-upload .btn-secondary .icon, .nk-chat-editor-tools .btn-icon .icon, .nk-chat-editor-tools .dt-buttons .btn-secondary .icon, .dt-buttons .nk-chat-editor-tools .btn-secondary .icon {
  font-size: 1.5rem;
}
.nk-chat-editor-upload {
  position: relative;
  z-index: 2;
}
.nk-chat-editor-upload .toggle-opt {
  transition: 0.3s;
}
.nk-chat-editor-upload .toggle-opt.active {
  opacity: 0.7;
  transform: rotate(-45deg);
}
.nk-chat-profile {
  position: absolute;
  top: 0;
  right: 0;
  transform: translateX(100%);
  width: 325px;
  height: 100%;
  max-height: 100%;
  transition: transform 0.3s ease-in-out;
  background: #fff;
  z-index: 100;
}
.nk-chat-profile-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(16, 25, 36, 0.4);
  z-index: 600;
  z-index: 90;
  animation: overlay-fade-in 0.4s ease 1;
}
.nk-chat-profile.visible {
  transform: none;
}

@media (max-width: 767.98px) {
  .nk-chat {
    border: none;
    border-radius: 4px;
    min-height: calc(100vh - (74px + 85px));
    max-height: calc(100vh - (74px + 85px));
  }
  .nk-chat-head {
    padding: 0.75rem 1.25rem;
  }
  .nk-chat-head-user {
    max-width: calc(100% - 34px);
  }
  .nk-chat-head-user .user-avatar {
    height: 36px;
    width: 36px;
  }
  .nk-chat-head-user .user-info {
    width: calc(100% - 36px - 0.75rem);
  }
}
@media (min-width: 576px) {
  .nk-chat-head-info, .nk-chat-head-tools {
    margin: -0.375rem;
  }
  .nk-chat-head-info > li, .nk-chat-head-tools > li {
    padding: 0.375rem;
  }
}
@media (min-width: 576px) and (max-width: 991px) {
  .nk-chat-aside-head, .nk-chat-aside-search {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .nk-chat-aside-panel {
    padding: 0 2.25rem 1.75rem;
  }
  .nk-chat-list {
    padding: 0 1.5rem;
  }
  .nk-chat-head, .nk-chat-panel, .nk-chat-editor {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .nk-chat-head-search {
    padding: 0 2.25rem;
  }
}
@media (min-width: 860px) {
  .nk-chat-aside {
    width: 320px;
    border-right: 1px solid #e5e9f2;
  }
  .nk-chat-body {
    position: static;
    opacity: 1;
    pointer-events: auto;
  }
  .nk-chat-body-close {
    display: none;
  }
}
@media (max-width: 859px) {
  .nk-chat-body.show-chat {
    position: fixed;
    z-index: 2999;
  }
  .nk-chat-head {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
}
@media (min-width: 860px) and (max-width: 991px) {
  .nk-chat-aside {
    width: 345px;
    border-right: 1px solid #e5e9f2;
  }
}
@media (max-width: 1300px) {
  .nk-chat-profile {
    width: 100%;
  }
}
@media (min-width: 992px) {
  .nk-chat-aside-panel, .nk-chat-aside-head, .nk-chat-aside-search {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .nk-chat-list {
    padding: 0 1rem;
  }
  .nk-chat-aside {
    width: 325px;
  }
  .nk-chat-panel {
    padding: 1.25rem 1.75rem;
  }
  .chat-profile-head, .chat-profile-body-inner {
    padding-right: 1.75rem;
    padding-left: 1.75rem;
  }
}
@media (min-width: 1540px) {
  .nk-chat-aside {
    width: 382px;
  }
  .nk-chat-body.profile-shown {
    padding-right: 365px;
  }
  .nk-chat-profile {
    width: 365px;
    border-left: 1px solid #e5e9f2;
  }
}
@media (max-width: 1539.98px) {
  .profile-shown .nk-chat-profile-toggle {
    right: 262px;
  }
  .has-apps-sidebar .profile-shown .nk-chat-profile-toggle {
    right: -18px;
  }
}
@media (max-width: 359px) {
  .nk-chat-profile {
    width: 365px;
  }
}
.nk-code-preview-box {
  display: block;
  color: #8094ae;
  padding: 0.15rem 1.25rem;
  border-left: 1px solid #e5e9f2;
}

.dashboard-preview {
  height: 200px;
  justify-content: center;
}

.dropdown-preview .dropdown-menu {
  position: static;
  display: block;
}
.dropdown-preview:after {
  display: block;
  clear: both;
  content: "";
}

@media (max-width: 420px) {
  .dropdown-preview .dropdown-menu-xl, .dropdown-preview .dropdown-menu-lg, .dropdown-preview .dropdown-menu-md {
    min-width: 100%;
    max-width: 100%;
  }
}
.prettyprint {
  padding: 1.25rem;
  white-space: pre;
  box-shadow: none !important;
  margin-bottom: 0;
  border-radius: 4px;
}

.code-block {
  position: relative;
  padding: 1.25rem;
  background: #fff;
  border-radius: 4px;
}
.code-block .clipboard-init {
  position: absolute;
  top: 12px;
  right: 12px;
}
.card-preview + .code-block {
  margin-top: 28px;
}
.code-block + .code-block {
  margin-top: -3px;
  border-top-color: #e5e9f2;
  border-radius: 0 0 4px 4px;
}
.code-block + .card-preview, .code-block + .nk-block-head {
  margin-top: 40px;
}
.code-block .prettyprint {
  background: #f5f6fa;
  border: none;
  padding: 0.75rem;
  font-size: 11px;
  line-height: 20px;
  max-height: 136px;
}
.code-block .title {
  margin-bottom: 1rem;
}
.code-block .btn, .code-block .dual-listbox .dual-listbox__button, .dual-listbox .code-block .dual-listbox__button {
  background-color: #fff;
}
.code-block .btn:focus, .code-block .dual-listbox .dual-listbox__button:focus, .dual-listbox .code-block .dual-listbox__button:focus, .code-block .btn:hover, .code-block .dual-listbox .dual-listbox__button:hover, .dual-listbox .code-block .dual-listbox__button:hover {
  border-color: #dbdfea;
  box-shadow: none;
}
.code-block-clean .title {
  font-size: 11px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #8094ae;
  font-weight: 500;
  display: block;
}

.preview-icon-list {
  display: flex;
  flex-wrap: wrap;
  margin: -15px;
}
.preview-icon-item {
  flex: 1 0 150px;
  padding: 15px;
  max-width: 50%;
}
.preview-icon-box {
  position: relative;
  padding: 25px 20px;
  text-align: center;
}
.preview-icon-box .btn-clipboard {
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0;
  z-index: 1;
}
.preview-icon-box .btn-clipboard:focus {
  border-color: transparent;
  box-shadow: none;
}
.preview-icon-box:hover .btn-clipboard {
  opacity: 1;
}
.preview-icon-wrap {
  padding-bottom: 5px;
}
.preview-icon-wrap .ni {
  font-size: 30px;
}
.preview-icon-svg .preview-icon-wrap {
  margin-bottom: 0.5rem;
}
.preview-icon-svg .preview-icon-wrap svg {
  width: 90px;
}
.preview-icon-name {
  color: #8094ae;
  font-size: 11px;
}

.preview-title, .preview-title-lg {
  display: block;
  padding-bottom: 0.75rem;
}
.preview-title-lg {
  font-size: 13px;
}
.preview-hr {
  border-top: 1px solid #dbdfea;
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.preview-hr + .preview-title {
  padding-top: 0.5rem;
}
.nk-block-head + .preview-hr {
  margin-top: 0.5rem;
}
.preview-list {
  display: flex;
  flex-wrap: wrap;
  margin: -0.75rem;
}
.preview-item {
  padding: 0.75rem;
}
.preview-btn-list {
  display: flex;
  flex-wrap: wrap;
  margin: -0.75rem;
}
.preview-btn-item {
  width: 50%;
  padding: 0.75rem;
}
.preview-btn-list-fw .preview-btn-item {
  width: 100%;
}
.preview-btn-list-3x .preview-btn-item {
  width: 33.33%;
}

.example-width > div, .example-height > div, .example-border > div, .example-spacing > div {
  font-size: 11px;
  padding: 0.5rem;
  text-align: center;
  background-color: #f5f6fa;
}
.example-border {
  margin: -0.5rem;
}
.example-border > div {
  height: 4.5rem;
  width: 4.5rem;
  margin: 0.5rem;
}
.example-border-all > div {
  border: 1px solid #dbdfea;
}
.example-width > div {
  height: 2rem;
  background-color: #ebeef2;
  margin-bottom: 0.25rem;
}
.example-height {
  height: 8rem;
}
.example-height > div {
  width: 8rem;
  background-color: #ebeef2;
  margin-right: 0.5rem;
}
.example-spacing > div {
  height: 2rem;
  width: 4.5rem;
  background-color: #ebeef2;
  margin-bottom: 0.5rem;
}
.example-spacing-pd > div {
  margin-right: 0.5rem;
  height: auto;
  width: auto;
}
.example-spacing-pd > div > span {
  display: block;
  padding: 0.25rem;
  line-height: 1;
  border-radius: 2px;
  background-color: #fff;
}
.example-alerts:not(:last-child) {
  margin-bottom: 28px;
}

.components-preview h4.title, .components-preview h5.title {
  font-size: 1.25rem;
  letter-spacing: -0.01rem;
  font-family: "DM Sans", sans-serif;
  font-weight: 500;
}
.components-preview .card-preview > .card-inner {
  padding: 1.25rem;
}

@media (min-width: 768px) {
  .preview-btn-item {
    width: 25%;
  }
  .preview-btn-list-fw .preview-btn-item {
    width: 25%;
  }
  .preview-btn-list-3x .preview-btn-item {
    width: 16.66%;
  }
}
@media (min-width: 992px) {
  .components-preview .nk-block + .nk-block-lg {
    padding-top: 3.75rem;
  }
}
@media (max-width: 767.98px) {
  .preview-reference tr, .preview-reference th, .preview-reference td {
    display: block;
    border: 0;
    width: 100% !important;
  }
  .preview-reference tbody tr {
    padding: 0.5rem 0;
  }
  .preview-reference tbody tr:not(:last-child) {
    border-bottom: 1px solid #e5e9f2;
  }
  .preview-reference tbody tr:nth-child(2n) {
    background-color: rgba(245, 246, 250, 0.3);
  }
  .preview-reference tr td {
    padding: 0.2rem 1.25rem;
  }
  .preview-reference tr th:not(:first-child) {
    display: none;
  }
}
.nk-sticky-toolbar {
  position: fixed;
  border: 3px solid #fff;
  top: 50%;
  background: #fff;
  z-index: 600;
  right: 0;
  border-radius: 6px 0 0 6px;
  border-right: 0;
  box-shadow: -2px 0 24px -2px rgba(43, 55, 72, 0.15);
}
.nk-sticky-toolbar li:not(:last-child) {
  border-bottom: 2px solid #fff;
}
.nk-sticky-toolbar li a {
  display: flex;
  height: 36px;
  width: 36px;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: inherit;
}

.demo-layout {
  background-color: rgba(85, 155, 251, 0.1);
  color: #559bfb;
}

.demo-thumb {
  background-color: rgba(30, 224, 172, 0.1);
  color: #1ee0ac;
}

.demo-settings {
  background-color: rgba(129, 107, 255, 0.1);
  color: #816bff;
}

.demo-purchase {
  background-color: rgba(255, 99, 165, 0.1);
  color: #ff63a5;
}

@media (min-width: 576px) {
  .nk-sticky-toolbar {
    top: 30%;
  }
  .nk-sticky-toolbar li a {
    font-size: 20px;
    height: 44px;
    width: 44px;
  }
  .nk-sticky-toolbar li.demo-thumb a {
    font-size: 22px;
  }
}
.nk-demo-panel {
  position: fixed;
  right: 0;
  top: 0;
  width: 320px;
  max-width: calc(100vw - 40px);
  max-height: 100vh;
  height: 100vh;
  z-index: 9999;
  background-color: #fff;
  box-shadow: 0 3px 12px 1px rgba(43, 55, 72, 0.15);
  padding: 0 0 1.5rem;
}
.nk-demo-panel + .toggle-overlay {
  z-index: 9000;
  background: rgba(16, 25, 36, 0.05);
}
.dark-mode .nk-demo-panel {
  box-shadow: 0 0 35px 5px rgba(0, 0, 0, 0.5);
}
.nk-demo-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1.5rem;
  text-transform: uppercase;
  border-bottom: 1px solid #e5e9f2;
}
.nk-demo-head h6 {
  font-size: 13px;
  letter-spacing: 0.1em;
}
.nk-demo-list {
  overflow: auto;
  max-height: calc(100vh - 60px);
}
.nk-demo-title {
  display: block;
  font-size: 0.875rem;
  padding: 0.675rem 0;
  text-align: center;
  color: #526484;
  border-top: none;
  border-radius: 0 0 4px 4px;
}
.nk-demo-title .subtitle {
  display: block;
  color: #8094ae;
  font-size: 11px;
}
.nk-demo-item {
  padding: 2rem 1.5rem 1rem;
  border-bottom: 1px solid #e5e9f2;
}
.nk-demo-item a {
  display: block;
}
.nk-demo-item a:hover .nk-demo-title {
  color: #4461F2;
}
.nk-demo-image {
  border: 1px solid #e5e9f2;
  border-radius: 4px 4px 0 0;
  padding: 1rem 1rem 0 1rem;
}
.nk-demo-image img {
  border-radius: inherit;
}
.nk-demo-note {
  background: #f5f6fa;
  padding-bottom: 2rem;
}

@media (min-width: 576px) {
  .nk-demo-item {
    padding: 2rem 2rem 1rem;
  }
  .nk-demo-head {
    padding: 15px 2rem 13px;
  }
  .nk-demo-note {
    padding-bottom: 2rem;
  }
}
@media (min-width: 768px) {
  .nk-demo-panel-2x {
    width: 640px;
  }
  .nk-demo-panel-2x .nk-demo-list .simplebar-content {
    display: flex;
    flex-wrap: wrap;
  }
  .nk-demo-panel-2x .nk-demo-list .simplebar-content .nk-demo-item {
    width: 50%;
  }
  .nk-demo-panel-2x .nk-demo-list .simplebar-content .nk-demo-item:not(:nth-child(2n)) {
    border-right: 1px solid #e5e9f2;
  }
}
.nk-opt-panel {
  overflow: auto;
  max-height: calc(100vh - 84px);
}
.nk-opt-reset {
  padding: 1.5rem 1.5rem 1.5rem;
}
.nk-opt-set {
  padding: 1.5rem 1.5rem 1.5rem;
}
.nk-opt-set:not(:last-child) {
  border-bottom: 1px solid #e5e9f2;
}
.nk-opt-set-title {
  padding: 0 0 0.5rem;
  text-transform: uppercase;
  color: #8094ae;
  letter-spacing: 2px;
  font-weight: 500;
  font-size: 11px;
}
.nk-opt-list {
  padding: 0;
  flex-wrap: wrap;
  margin: -0.5rem;
  display: flex;
}
.nk-opt-list + .nk-opt-set-title {
  margin-top: 1.25rem;
}
.nk-opt-item {
  width: 33%;
  text-align: center;
  padding: 0.5rem;
}
.nk-opt-item:not(.active):not(.disabled) {
  cursor: pointer;
}
.nk-opt-item.active {
  cursor: default;
}
.nk-opt-item.disabled {
  pointer-events: none;
}
.nk-opt-item.disabled > .nk-opt-item-name {
  opacity: 0.5;
}
.col-2x .nk-opt-item {
  width: 50%;
}
.col-4x .nk-opt-item {
  width: 25%;
}
.nk-opt-item-name {
  font-weight: 400;
  color: #526484;
  font-size: 12px;
  letter-spacing: 0.02em;
}
.nk-opt-item-name small {
  font-size: 11px;
}
.dark-mode .nk-opt-item-name {
  color: #8094ae;
}
.nk-opt-item-bg {
  background: #fff;
  width: 100%;
  height: 32px;
  border: 1px solid #dbdfea;
  padding: 3px;
  margin-bottom: 5px;
  position: relative;
  display: block;
  border-radius: 2px;
  transition: all 0.3s;
}
.dark-mode .nk-opt-item-bg {
  border-color: #3c4d62;
}
.nk-opt-item-bg > span:not(.nk-opt-item-name) {
  display: block;
  background: #526484;
  height: 100%;
  border-radius: 1px;
}
.nk-opt-item-bg > span:not(.nk-opt-item-name).bg-theme {
  background: #3a2272 !important;
}
.nk-opt-item-bg > span:not(.nk-opt-item-name).bg-light, .dual-listbox .nk-opt-item-bg > span.dual-listbox__item:not(.nk-opt-item-name):hover {
  background: #ebeef2 !important;
}
.nk-opt-item-bg > span:not(.nk-opt-item-name).bg-lighter {
  background: #f5f6fa !important;
}
.nk-opt-item-bg > span:not(.nk-opt-item-name).bg-dark {
  background: #101924 !important;
}
.nk-opt-item-bg > span:not(.nk-opt-item-name).theme-light {
  background: linear-gradient(90deg, #f5f6fa 0%, #f5f6fa 50%, #ebeef2 50%, #ebeef2 100%) !important;
}
.nk-opt-item-bg > span:not(.nk-opt-item-name).theme-dark {
  background: linear-gradient(90deg, #1f2b3a 0%, #1f2b3a 50%, #101924 50%, #101924 100%) !important;
}
.nk-opt-item-bg > span:not(.nk-opt-item-name).skin-default {
  background: linear-gradient(90deg, #3a2272 0%, #3a2272 28%, #4461F2 28%, #4461F2 72%, #d4c2ff 72%, #d4c2ff 100%) !important;
}
.nk-opt-item-bg > span:not(.nk-opt-item-name).skin-purple {
  background: linear-gradient(90deg, #4700e8 0%, #4700e8 28%, #854fff 28%, #854fff 72%, #e7dcff 72%, #e7dcff 100%) !important;
}
.nk-opt-item-bg > span:not(.nk-opt-item-name).skin-green {
  background: linear-gradient(90deg, #074e3b 0%, #074e3b 28%, #0fac81 28%, #0fac81 72%, #cfeee6 72%, #cfeee6 100%) !important;
}
.nk-opt-item-bg > span:not(.nk-opt-item-name).skin-blue {
  background: linear-gradient(90deg, #0144a0 0%, #0144a0 30%, #0971fe 30%, #0971fe 72%, #cee3ff 72%, #cee3ff 100%) !important;
}
.nk-opt-item-bg > span:not(.nk-opt-item-name).skin-egyptian {
  background: linear-gradient(90deg, #1a3767 0%, #1a3767 30%, #2e62b9 30%, #2e62b9 72%, #d5e0f1 72%, #d5e0f1 100%) !important;
}
.nk-opt-item-bg > span:not(.nk-opt-item-name).skin-red {
  background: linear-gradient(90deg, #ab0e21 0%, #ab0e21 30%, #ee3148 30%, #ee3148 72%, #fcd6da 72%, #fcd6da 100%) !important;
}
.nk-opt-item-bg > span:not(.nk-opt-item-name).skin-bluelite {
  background: linear-gradient(90deg, #001cfe 0%, #001cfe 28%, #6576ff 28%, #6576ff 72%, #e0e4ff 72%, #e0e4ff 100%) !important;
}
.nk-opt-item-bg:hover, .nk-opt-item-bg:focus {
  border-color: #b7c2d0;
}
.active > .nk-opt-item-bg {
  border-color: #4461F2;
  box-shadow: 0 0 0 2px rgba(68, 97, 242, 0.2);
}
.active > .nk-opt-item-bg:after {
  font-family: "Nioicon";
  content: "\\e9bd";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 0.875rem;
}
.active > .nk-opt-item-bg.is-light:after {
  color: #101924;
}
.only-text > .nk-opt-item-bg {
  margin-bottom: 0;
  height: 28px;
}
.only-text > .nk-opt-item-bg:after {
  display: none;
}
.disabled > .nk-opt-item-bg {
  border-color: #e5e9f2 !important;
}
.dark-mode .disabled > .nk-opt-item-bg {
  border-color: #3c4d62 !important;
}
.nk-opt-item-bg > .nk-opt-item-name {
  color: #364a63;
  font-size: 10px;
  line-height: 1;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 0.12em;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
}
.dark-mode .nk-opt-item-bg > .nk-opt-item-name {
  color: #b6c6e3;
}
.active > .nk-opt-item-bg > .nk-opt-item-name {
  color: #4461F2;
  font-weight: 700;
}

@media (min-width: 576px) {
  .nk-opt-set, .nk-opt-reset {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}
.pmo-lv {
  position: fixed;
  left: 50%;
  bottom: -50px;
  max-width: 90%;
  width: 590px;
  transform: translate(-50%, 100%);
  transition: all 0.4s;
  background: #fff;
  border-radius: 50px;
  box-shadow: 0 0 40px -2px rgba(31, 43, 58, 0.25);
  z-index: 9999;
}
.pmo-lv.active {
  transform: translate(-50%, 0);
  bottom: 20px;
  transition-delay: 1s;
}
.pmo-lv.pmo-dark {
  background: #0564e5;
}
.pmo-close {
  color: #364a63;
  border-radius: 50%;
  height: 36px;
  width: 36px;
  line-height: 38px;
  background: rgba(183, 194, 208, 0.6);
  text-align: center;
  display: inline-block;
  position: absolute;
  top: 50%;
  margin-top: -18px;
  right: 8px;
  font-size: 16px;
  z-index: 99;
}
.pmo-close:hover {
  color: #fff;
  background: #526484;
}
.pmo-dark .pmo-close {
  background: rgba(31, 43, 58, 0.3);
  color: #fff;
}
.pmo-dark .pmo-close:hover {
  background: rgba(31, 43, 58, 0.5);
}
.pmo-wrap {
  display: flex;
  padding: 0.875rem 3.5rem 0.875rem 1.5rem;
  align-items: center;
  border-radius: 50px;
  transition: all 300ms;
}
.pmo-wrap:hover {
  transform: translateX(5px);
}
.pmo-text {
  font-family: "DM Sans", sans-serif;
  font-size: 14px;
  line-height: 22px;
  font-weight: 500;
  letter-spacing: 0.02em;
  color: #e85347;
  transition: color 0.4s;
}
.pmo-text .ni {
  font-size: 20px;
  display: inline-block;
  vertical-align: middle;
  margin-left: 0.125rem;
  margin-top: -3px;
}
.pmo-dark .pmo-text {
  color: #fff;
}
.pmo-st {
  position: fixed;
  right: 25px;
  bottom: 0;
  display: flex;
  align-items: center;
  transition: all 0.4s;
  border-radius: 30px;
  transform: translateY(100%);
  box-shadow: 0 5px 40px 0 rgba(16, 25, 36, 0.3);
  color: #fff;
  background: #e85347;
  z-index: 99999;
}
.pmo-st:active, .pmo-st:focus, .pmo-st:hover {
  color: #fff;
}
.pmo-st.pmo-dark {
  background: #0564e5;
}
.pmo-st.active {
  bottom: 25px;
  transform: translateY(0);
  transition-delay: 0.4s;
}
.pmo-st-img {
  width: 60px;
  height: 60px;
  border-radius: 30px;
  padding: 18px 18px;
  transition: all 0.4s;
}
.pmo-st-text {
  padding: 14px 0;
  height: 60px;
  width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-weight: 600;
  transition: all 0.4s;
  visibility: hidden;
  font-size: 12px;
  line-height: 16px;
}
.pmo-st:hover .pmo-st-text {
  width: 220px;
  visibility: visible;
  padding: 14px 14px 14px 0;
}

@media (max-width: 575px) {
  .promo-cov-st {
    display: none;
  }
}
.dark-mode .nk-demo-panel {
  background-color: #141c26;
}
.dark-mode .nk-opt-item-bg {
  background-color: #101924;
}
.dark-mode .nk-demo-head, .dark-mode .nk-opt-set:not(:last-child), .dark-mode .nk-demo-item:not(:last-child) {
  border-color: #1d2d40;
}
.dark-mode .nk-demo-title {
  color: #dfe9fe;
}
.dark-mode .nk-demo-image {
  border-color: #1d2d40;
}

.ui-bordered .card,
.ui-bordered .code-block,
.ui-bordered .accordion:not(.accordion-s2):not(.accordion-s3),
.ui-bordered .card .card-inner + .table .tb-tnx-head,
.ui-bordered .nk-download {
  border: 1px solid #e5e9f2;
}
.ui-bordered .nk-tb-list.is-separate .nk-tb-item > div {
  border-top: 1px solid #e5e9f2;
  border-bottom: 1px solid #e5e9f2;
}
.ui-bordered .nk-tb-list.is-separate .nk-tb-item > div:first-child {
  border-left: 1px solid #e5e9f2;
}
.ui-bordered .nk-tb-list.is-separate .nk-tb-item > div:last-child {
  border-right: 1px solid #e5e9f2;
}
.ui-bordered .kanban-board-header {
  border-left: 1px solid #e5e9f2;
  border-right: 1px solid #e5e9f2;
  border-bottom: 1px solid #e5e9f2;
}
.ui-bordered .kanban-item {
  border: 1px solid #e5e9f2;
}

/* React Select */
body.dark-mode {
  background: #101924 !important;
  color: #b6c6e3;
}
body.dark-mode.ui-shady, body.dark-mode.ui-clean, body.dark-mode.bg-lighter, body.dark-mode.bg-light, .dual-listbox body.dark-mode.dual-listbox__item:hover {
  background: #0d141d !important;
}

.dark-mode .logo-dark {
  opacity: 0;
}
.dark-mode .logo-light {
  opacity: 1;
}
.dark-mode h1,
.dark-mode h2,
.dark-mode h3,
.dark-mode h4,
.dark-mode h5,
.dark-mode h6,
.dark-mode .h1,
.dark-mode .h2,
.dark-mode .h3,
.dark-mode .h4,
.dark-mode .h5,
.dark-mode .h6,
.dark-mode .lead-text,
.dark-mode .dropdown-title,
.dark-mode pre {
  color: #fff;
}
.dark-mode .text-base,
.dark-mode .text-body,
.dark-mode .link-text {
  color: #b6c6e3 !important;
}
.dark-mode .text-secondary,
.dark-mode .icon[class*=bg-secondary-dim],
.dark-mode .user-avatar[class*=-light],
.dark-mode .icon[class*=bg-light] {
  color: #8094ae !important;
}
.dark-mode .text-dark {
  color: #fff !important;
}
.dark-mode .text-muted {
  color: #8094ae !important;
}
.dark-mode .text-light,
.dark-mode .user-avatar[class*=-dark] {
  color: #8091a7 !important;
}
.dark-mode .text-lighter {
  color: #3c4d62 !important;
}
.dark-mode .text-indigo {
  color: #6370ca !important;
}
.dark-mode .bg-light, .dark-mode .dual-listbox .dual-listbox__item:hover, .dual-listbox .dark-mode .dual-listbox__item:hover {
  background-color: #0d141d !important;
}
.dark-mode .bg-lighter, .dark-mode .rdl-control > option:hover {
  background-color: #101924 !important;
}
.dark-mode .table-striped tbody tr:nth-of-type(odd) {
  background-color: #101924 !important;
}
.dark-mode .bg-white {
  background-color: #141c26 !important;
}
.dark-mode .bg-putih {
  background-color: #ffffff !important;
}
.dark-mode .bg-transparent.bg-transparent {
  background-color: transparent !important;
}
.dark-mode .bg-dark {
  background-color: #ebeef2 !important;
}
.dark-mode .bg-blue-dim {
  background-color: #1e2f46 !important;
}
.dark-mode .bg-azure-dim {
  background-color: #142a46 !important;
}
.dark-mode .bg-indigo-dim {
  background-color: #182034 !important;
}
.dark-mode .bg-purple-dim {
  background-color: #242847 !important;
}
.dark-mode .bg-pink-dim {
  background-color: #372739 !important;
}
.dark-mode .bg-orange-dim {
  background-color: #37302d !important;
}
.dark-mode .bg-teal-dim {
  background-color: #163637 !important;
}
.dark-mode .bg-primary-dim, .dark-mode .dual-listbox .dual-listbox__item:active, .dual-listbox .dark-mode .dual-listbox__item:active, .dark-mode .dual-listbox .dual-listbox__item.dual-listbox__item--selected, .dual-listbox .dark-mode .dual-listbox__item.dual-listbox__item--selected, .dark-mode .rdl-control > option:active, .dark-mode .rdl-control > option:focus {
  background-color: #1b2645 !important;
}
.dark-mode .bg-success-dim {
  background-color: #16393a !important;
}
.dark-mode .bg-info-dim {
  background-color: #123542 !important;
}
.dark-mode .bg-warning-dim {
  background-color: #363422 !important;
}
.dark-mode .bg-danger-dim {
  background-color: #34242b !important;
}
.dark-mode .bg-secondary-dim {
  background-color: #1b2532 !important;
}
.dark-mode .bg-dark-dim {
  background-color: #161e29 !important;
}
.dark-mode .bg-gray-dim {
  background-color: #242e39 !important;
}
.dark-mode .bg-btc-dim {
  background-color: #362c25 !important;
}
.dark-mode .bg-eth-dim {
  background-color: #20293c !important;
}
.dark-mode .alert-primary {
  color: #4461F2;
  background-color: #1b2645;
  border-color: #1b2645;
}
.dark-mode .alert-primary hr {
  border-top-color: #1b2645;
}
.dark-mode .alert-primary .alert-link {
  color: #1439ef;
}
.dark-mode .alert-fill.alert-primary {
  color: #fff;
  background: #4461F2;
}
.dark-mode .alert-fill.alert-primary .alert-link {
  color: #fff;
}
.dark-mode .alert-pro.alert-primary {
  border-color: #4461F2;
}
.dark-mode .alert-secondary {
  color: #8ca3c0;
  background-color: #1b2532;
  border-color: #1b2532;
}
.dark-mode .alert-secondary hr {
  border-top-color: #1b2532;
}
.dark-mode .alert-secondary .alert-link {
  color: #6b89ae;
}
.dark-mode .alert-fill.alert-secondary {
  color: #fff;
  background: #8ca3c0;
}
.dark-mode .alert-fill.alert-secondary .alert-link {
  color: #fff;
}
.dark-mode .alert-pro.alert-secondary {
  border-color: #8ca3c0;
}
.dark-mode .alert-success {
  color: #1ee0ac;
  background-color: #16393a;
  border-color: #16393a;
}
.dark-mode .alert-success hr {
  border-top-color: #16393a;
}
.dark-mode .alert-success .alert-link {
  color: #18b389;
}
.dark-mode .alert-fill.alert-success {
  color: #fff;
  background: #1ee0ac;
}
.dark-mode .alert-fill.alert-success .alert-link {
  color: #fff;
}
.dark-mode .alert-pro.alert-success {
  border-color: #1ee0ac;
}
.dark-mode .alert-warning {
  color: #f4bd0e;
  background-color: #363422;
  border-color: #363422;
}
.dark-mode .alert-warning hr {
  border-top-color: #363422;
}
.dark-mode .alert-warning .alert-link {
  color: #c69909;
}
.dark-mode .alert-fill.alert-warning {
  color: #fff;
  background: #f4bd0e;
}
.dark-mode .alert-fill.alert-warning .alert-link {
  color: #fff;
}
.dark-mode .alert-pro.alert-warning {
  border-color: #f4bd0e;
}
.dark-mode .alert-info {
  color: #09c2de;
  background-color: #123542;
  border-color: #123542;
}
.dark-mode .alert-info hr {
  border-top-color: #123542;
}
.dark-mode .alert-info .alert-link {
  color: #0797ad;
}
.dark-mode .alert-fill.alert-info {
  color: #fff;
  background: #09c2de;
}
.dark-mode .alert-fill.alert-info .alert-link {
  color: #fff;
}
.dark-mode .alert-pro.alert-info {
  border-color: #09c2de;
}
.dark-mode .alert-danger {
  color: #e85347;
  background-color: #34242b;
  border-color: #34242b;
}
.dark-mode .alert-danger hr {
  border-top-color: #34242b;
}
.dark-mode .alert-danger .alert-link {
  color: #e02b1c;
}
.dark-mode .alert-fill.alert-danger {
  color: #fff;
  background: #e85347;
}
.dark-mode .alert-fill.alert-danger .alert-link {
  color: #fff;
}
.dark-mode .alert-pro.alert-danger {
  border-color: #e85347;
}
.dark-mode .alert-gray {
  color: #b7c2d0;
  background-color: #242e39;
  border-color: #242e39;
}
.dark-mode .alert-gray hr {
  border-top-color: #242e39;
}
.dark-mode .alert-gray .alert-link {
  color: #98a8bc;
}
.dark-mode .alert-fill.alert-gray {
  color: #101924;
  background: #b7c2d0;
}
.dark-mode .alert-fill.alert-gray .alert-link {
  color: #101924;
}
.dark-mode .alert-pro.alert-gray {
  border-color: #b7c2d0;
}
.dark-mode .alert-dark {
  color: #1f2b3a;
  background-color: #161e29;
  border-color: #161e29;
}
.dark-mode .alert-dark hr {
  border-top-color: #161e29;
}
.dark-mode .alert-dark .alert-link {
  color: #0d1219;
}
.dark-mode .alert-fill.alert-dark {
  color: #fff;
  background: #1f2b3a;
}
.dark-mode .alert-fill.alert-dark .alert-link {
  color: #fff;
}
.dark-mode .alert-pro.alert-dark {
  border-color: #1f2b3a;
}
.dark-mode .alert-light {
  color: #ebeef2;
  background-color: #242e39;
  border-color: #242e39;
}
.dark-mode .alert-light hr {
  border-top-color: #242e39;
}
.dark-mode .alert-light .alert-link {
  color: #ccd4de;
}
.dark-mode .alert-fill.alert-light {
  color: #101924;
  background: #ebeef2;
}
.dark-mode .alert-fill.alert-light .alert-link {
  color: #101924;
}
.dark-mode .alert-pro.alert-light {
  border-color: #ebeef2;
}
.dark-mode .badge-dim.badge-primary {
  color: #4461F2;
  background-color: #1b2645;
  border-color: #1b2645;
}
.dark-mode .badge-dim.badge-outline-primary {
  color: #4461F2;
  background-color: #1b2645;
  border-color: #273878;
}
.dark-mode .badge-dim.badge-secondary {
  color: #8ca3c0;
  background-color: #26303d;
  border-color: #26303d;
}
.dark-mode .badge-dim.badge-outline-secondary {
  color: #8ca3c0;
  background-color: #26303d;
  border-color: #445264;
}
.dark-mode .badge-dim.badge-success {
  color: #1ee0ac;
  background-color: #16393a;
  border-color: #16393a;
}
.dark-mode .badge-dim.badge-outline-success {
  color: #1ee0ac;
  background-color: #16393a;
  border-color: #186a5c;
}
.dark-mode .badge-dim.badge-info {
  color: #09c2de;
  background-color: #123542;
  border-color: #123542;
}
.dark-mode .badge-dim.badge-outline-info {
  color: #09c2de;
  background-color: #123542;
  border-color: #105e70;
}
.dark-mode .badge-dim.badge-warning {
  color: #f4bd0e;
  background-color: #363422;
  border-color: #363422;
}
.dark-mode .badge-dim.badge-outline-warning {
  color: #f4bd0e;
  background-color: #363422;
  border-color: #6e5c1c;
}
.dark-mode .badge-dim.badge-danger {
  color: #e85347;
  background-color: #34242b;
  border-color: #34242b;
}
.dark-mode .badge-dim.badge-outline-danger {
  color: #e85347;
  background-color: #34242b;
  border-color: #693233;
}
.dark-mode .badge-dim.badge-dark {
  color: #ebeef2;
  background-color: #343c45;
  border-color: #343c45;
}
.dark-mode .badge-dim.badge-outline-dark {
  color: #ebeef2;
  background-color: #343c45;
  border-color: #6a7078;
}
.dark-mode .badge-dim.badge-gray {
  color: #8091a7;
  background-color: #242e39;
  border-color: #242e39;
}
.dark-mode .badge-dim.badge-outline-gray {
  color: #8091a7;
  background-color: #242e39;
  border-color: #3f4b5a;
}
.dark-mode .badge-dim.badge-light {
  color: #b7c2d0;
  background-color: #2c3540;
  border-color: #2c3540;
}
.dark-mode .badge-dim.badge-outline-light {
  color: #b7c2d0;
  background-color: #2c3540;
  border-color: #555e6a;
}
.dark-mode .badge-dim.badge-lighter {
  color: #8091a7;
  background-color: #242e39;
  border-color: #242e39;
}
.dark-mode .badge-dim.badge-outline-lighter {
  color: #8091a7;
  background-color: #242e39;
  border-color: #3f4b5a;
}
.dark-mode .badge-outline-secondary,
.dark-mode .badge-dot.badge-dark,
.dark-mode .badge-dot.badge-secondary {
  color: #b7c2d0;
}
.dark-mode .badge-outline-dark {
  color: #ebeef2;
  border-color: #ebeef2;
}
.dark-mode .badge-outline-light {
  color: #b7c2d0;
  border-color: #344357;
}
.dark-mode .badge-dot.badge-dark,
.dark-mode .badge-dot.badge-light {
  background-color: transparent;
}
.dark-mode .badge-dot.badge-light {
  color: #8091a7;
}
.dark-mode .badge-light,
.dark-mode .code-block .btn,
.dark-mode .code-block .dual-listbox .dual-listbox__button,
.dual-listbox .dark-mode .code-block .dual-listbox__button {
  color: #ebeef2;
  background: #344357;
  border-color: #344357;
}
.dark-mode .badge-dark {
  color: #1f2b3a;
  background: #e5e9f2;
  border-color: #e5e9f2;
}
.dark-mode .btn-light, .dark-mode .dual-listbox .dual-listbox__button, .dual-listbox .dark-mode .dual-listbox__button {
  color: #ebeef2;
  background: #344357;
  border-color: #344357;
}
.dark-mode .btn-light:not(:disabled):not(.disabled):hover, .dark-mode .dual-listbox .dual-listbox__button:not(:disabled):not(.disabled):hover, .dual-listbox .dark-mode .dual-listbox__button:not(:disabled):not(.disabled):hover, .dark-mode .btn-light:not(:disabled):not(.disabled):focus, .dark-mode .dual-listbox .dual-listbox__button:not(:disabled):not(.disabled):focus, .dual-listbox .dark-mode .dual-listbox__button:not(:disabled):not(.disabled):focus, .dark-mode .btn-light:not(:disabled):not(.disabled).focus, .dark-mode .dual-listbox .dual-listbox__button:not(:disabled):not(.disabled).focus, .dual-listbox .dark-mode .dual-listbox__button:not(:disabled):not(.disabled).focus, .dark-mode .btn-light:not(:disabled):not(.disabled):active, .dark-mode .dual-listbox .dual-listbox__button:not(:disabled):not(.disabled):active, .dual-listbox .dark-mode .dual-listbox__button:not(:disabled):not(.disabled):active, .dark-mode .btn-light:not(:disabled):not(.disabled).active, .dark-mode .dual-listbox .dual-listbox__button:not(:disabled):not(.disabled).active, .dual-listbox .dark-mode .dual-listbox__button:not(:disabled):not(.disabled).active {
  background: #435771;
  border-color: #435771;
  color: #ebeef2;
}
.dark-mode .btn-dark {
  color: #1f2b3a;
  background: #e5e9f2;
  border-color: #e5e9f2;
}
.dark-mode .btn-dark:not(:disabled):not(.disabled):hover, .dark-mode .btn-dark:not(:disabled):not(.disabled):focus, .dark-mode .btn-dark:not(:disabled):not(.disabled).focus, .dark-mode .btn-dark:not(:disabled):not(.disabled):active, .dark-mode .btn-dark:not(:disabled):not(.disabled).active {
  background: #fff;
  border-color: #fff;
  color: #1f2b3a;
}
.dark-mode .btn-outline-dark {
  border-color: #e5e9f2;
  color: #e5e9f2;
}
.dark-mode .btn-outline-dark:not(:disabled):not(.disabled):hover {
  background: #e5e9f2;
  color: #1f2b3a;
}
.dark-mode .btn-outline-secondary {
  border-color: #5a7ba5;
  color: #5a7ba5;
}
.dark-mode .btn-outline-secondary:not(:disabled):not(.disabled):hover {
  background: #5a7ba5;
  color: #fff;
}
.dark-mode .btn-outline-light, .dark-mode .dt-buttons .btn-secondary, .dt-buttons .dark-mode .btn-secondary {
  border-color: #3c4d62;
  color: #b7c2d0;
}
.dark-mode .btn-outline-light:not(:disabled):not(.disabled):hover, .dark-mode .dt-buttons .btn-secondary:not(:disabled):not(.disabled):hover, .dt-buttons .dark-mode .btn-secondary:not(:disabled):not(.disabled):hover {
  background: #3c4d62;
  color: #fff;
}
.dark-mode .btn-dim.btn-primary {
  color: #4461F2;
  background-color: #1d284b;
  border-color: transparent;
}
.dark-mode .btn-dim.btn-primary:not(:disabled):not(.disabled):hover {
  color: #7489f5;
  background-color: #273665;
  border-color: #273665;
}
.dark-mode .btn-dim.btn-secondary {
  color: #adbdd2;
  background-color: #1d2835;
  border-color: transparent;
}
.dark-mode .btn-dim.btn-secondary:not(:disabled):not(.disabled):hover {
  color: #ced8e4;
  background-color: #2a394c;
  border-color: #2a394c;
}
.dark-mode .btn-dim.btn-success {
  color: #1ee0ac;
  background-color: #163f3e;
  border-color: transparent;
}
.dark-mode .btn-dim.btn-success:not(:disabled):not(.disabled):hover {
  color: #4ae7bd;
  background-color: #1f5958;
  border-color: #1f5958;
}
.dark-mode .btn-dim.btn-warning {
  color: #f4bd0e;
  background-color: #3c3922;
  border-color: transparent;
}
.dark-mode .btn-dim.btn-warning:not(:disabled):not(.disabled):hover {
  color: #f6ca3f;
  background-color: #534f2f;
  border-color: #534f2f;
}
.dark-mode .btn-dim.btn-info {
  color: #09c2de;
  background-color: #123a47;
  border-color: transparent;
}
.dark-mode .btn-dim.btn-info:not(:disabled):not(.disabled):hover {
  color: #24daf6;
  background-color: #195163;
  border-color: #195163;
}
.dark-mode .btn-dim.btn-danger {
  color: #e85347;
  background-color: #3a262c;
  border-color: transparent;
}
.dark-mode .btn-dim.btn-danger:not(:disabled):not(.disabled):hover {
  color: #ee7d74;
  background-color: #50343c;
  border-color: #50343c;
}
.dark-mode .btn-dim.btn-gray {
  color: #b7c2d0;
  background-color: #27313d;
  border-color: transparent;
}
.dark-mode .btn-dim.btn-gray:not(:disabled):not(.disabled):hover {
  color: #d6dce4;
  background-color: #354253;
  border-color: #354253;
}
.dark-mode .btn-dim.btn-dark {
  color: #e5e9f2;
  background-color: #313a45;
  border-color: transparent;
}
.dark-mode .btn-dim.btn-dark:not(:disabled):not(.disabled):hover {
  color: white;
  background-color: #404c5a;
  border-color: #404c5a;
}
.dark-mode .btn-dim.btn-light, .dark-mode .dual-listbox .btn-dim.dual-listbox__button, .dual-listbox .dark-mode .btn-dim.dual-listbox__button {
  color: #ebeef2;
  background-color: #27313d;
  border-color: transparent;
}
.dark-mode .btn-dim.btn-light:not(:disabled):not(.disabled):hover, .dark-mode .dual-listbox .btn-dim.dual-listbox__button:not(:disabled):not(.disabled):hover, .dual-listbox .dark-mode .btn-dim.dual-listbox__button:not(:disabled):not(.disabled):hover {
  color: white;
  background-color: #354253;
  border-color: #354253;
}
.dark-mode .btn-dim.btn-lighter {
  color: #b7c2d0;
  background-color: #27313d;
  border-color: transparent;
}
.dark-mode .btn-dim.btn-lighter:not(:disabled):not(.disabled):hover {
  color: #d6dce4;
  background-color: #354253;
  border-color: #354253;
}
.dark-mode .btn-dim.btn-outline-primary {
  color: #4461F2;
  background-color: #1d284b;
  border-color: #25346d;
}
.dark-mode .btn-dim.btn-outline-primary:not(:disabled):not(.disabled):hover {
  color: #fff;
  background-color: #4461F2;
  border-color: #4461F2;
}
.dark-mode .btn-white.btn-outline-primary:not(.btn-dim):not(:disabled):not(.disabled):hover, .dark-mode .dt-buttons .btn-outline-primary.btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover, .dt-buttons .dark-mode .btn-outline-primary.btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover,
.dark-mode .btn-trans.btn-outline-primary:not(.btn-dim):not(:disabled):not(.disabled):hover {
  color: #4461F2;
  background: #1d284b;
}
.dark-mode .btn-dim.btn-outline-success {
  color: #1ee0ac;
  background-color: #163f3e;
  border-color: #186155;
}
.dark-mode .btn-dim.btn-outline-success:not(:disabled):not(.disabled):hover {
  color: #fff;
  background-color: #1ee0ac;
  border-color: #1ee0ac;
}
.dark-mode .btn-white.btn-outline-success:not(.btn-dim):not(:disabled):not(.disabled):hover, .dark-mode .dt-buttons .btn-outline-success.btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover, .dt-buttons .dark-mode .btn-outline-success.btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover,
.dark-mode .btn-trans.btn-outline-success:not(.btn-dim):not(:disabled):not(.disabled):hover {
  color: #1ee0ac;
  background: #163f3e;
}
.dark-mode .btn-dim.btn-outline-warning {
  color: #f4bd0e;
  background-color: #3c3922;
  border-color: #62541e;
}
.dark-mode .btn-dim.btn-outline-warning:not(:disabled):not(.disabled):hover {
  color: #fff;
  background-color: #f4bd0e;
  border-color: #f4bd0e;
}
.dark-mode .btn-white.btn-outline-warning:not(.btn-dim):not(:disabled):not(.disabled):hover, .dark-mode .dt-buttons .btn-outline-warning.btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover, .dt-buttons .dark-mode .btn-outline-warning.btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover,
.dark-mode .btn-trans.btn-outline-warning:not(.btn-dim):not(:disabled):not(.disabled):hover {
  color: #f4bd0e;
  background: #3c3922;
}
.dark-mode .btn-dim.btn-outline-info {
  color: #09c2de;
  background-color: #123a47;
  border-color: #105666;
}
.dark-mode .btn-dim.btn-outline-info:not(:disabled):not(.disabled):hover {
  color: #fff;
  background-color: #09c2de;
  border-color: #09c2de;
}
.dark-mode .btn-white.btn-outline-info:not(.btn-dim):not(:disabled):not(.disabled):hover, .dark-mode .dt-buttons .btn-outline-info.btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover, .dt-buttons .dark-mode .btn-outline-info.btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover,
.dark-mode .btn-trans.btn-outline-info:not(.btn-dim):not(:disabled):not(.disabled):hover {
  color: #09c2de;
  background: #123a47;
}
.dark-mode .btn-dim.btn-outline-danger {
  color: #e85347;
  background-color: #3a262c;
  border-color: #5e2f32;
}
.dark-mode .btn-dim.btn-outline-danger:not(:disabled):not(.disabled):hover {
  color: #fff;
  background-color: #e85347;
  border-color: #e85347;
}
.dark-mode .btn-white.btn-outline-danger:not(.btn-dim):not(:disabled):not(.disabled):hover, .dark-mode .dt-buttons .btn-outline-danger.btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover, .dt-buttons .dark-mode .btn-outline-danger.btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover,
.dark-mode .btn-trans.btn-outline-danger:not(.btn-dim):not(:disabled):not(.disabled):hover {
  color: #e85347;
  background: #3a262c;
}
.dark-mode .btn-dim.btn-outline-secondary {
  color: #6b89ae;
  background-color: #1d2835;
  border-color: #2c3c51;
}
.dark-mode .btn-dim.btn-outline-secondary:not(:disabled):not(.disabled):hover {
  color: #fff;
  background-color: #6b89ae;
  border-color: #6b89ae;
}
.dark-mode .btn-white.btn-outline-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover, .dark-mode .dt-buttons .btn-outline-secondary.btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover, .dt-buttons .dark-mode .btn-outline-secondary.btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover,
.dark-mode .btn-trans.btn-outline-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover {
  color: #6b89ae;
  background: #1d2835;
}
.dark-mode .btn-dim.btn-outline-gray {
  color: #b7c2d0;
  background-color: #27313d;
  border-color: #3a4553;
}
.dark-mode .btn-dim.btn-outline-gray:not(:disabled):not(.disabled):hover {
  color: #101924;
  background-color: #b7c2d0;
  border-color: #b7c2d0;
}
.dark-mode .btn-white.btn-outline-gray:not(.btn-dim):not(:disabled):not(.disabled):hover, .dark-mode .dt-buttons .btn-outline-gray.btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover, .dt-buttons .dark-mode .btn-outline-gray.btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover,
.dark-mode .btn-trans.btn-outline-gray:not(.btn-dim):not(:disabled):not(.disabled):hover {
  color: #b7c2d0;
  background: #27313d;
}
.dark-mode .btn-dim.btn-outline-dark {
  color: #e5e9f2;
  background-color: #313a45;
  border-color: #4d5662;
}
.dark-mode .btn-dim.btn-outline-dark:not(:disabled):not(.disabled):hover {
  color: #101924;
  background-color: #e5e9f2;
  border-color: #e5e9f2;
}
.dark-mode .btn-white.btn-outline-dark:not(.btn-dim):not(:disabled):not(.disabled):hover, .dark-mode .dt-buttons .btn-outline-dark.btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover, .dt-buttons .dark-mode .btn-outline-dark.btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover,
.dark-mode .btn-trans.btn-outline-dark:not(.btn-dim):not(:disabled):not(.disabled):hover {
  color: #e5e9f2;
  background: #313a45;
}
.dark-mode .btn-dim.btn-outline-light, .dark-mode .dt-buttons .btn-dim.btn-secondary, .dt-buttons .dark-mode .btn-dim.btn-secondary {
  color: #8091a7;
  background-color: #1b2531;
  border-color: #3a4553;
}
.dark-mode .btn-dim.btn-outline-light:not(:disabled):not(.disabled):hover, .dark-mode .dt-buttons .btn-dim.btn-secondary:not(:disabled):not(.disabled):hover, .dt-buttons .dark-mode .btn-dim.btn-secondary:not(:disabled):not(.disabled):hover {
  color: #fff;
  background-color: #8091a7;
  border-color: #8091a7;
}
.dark-mode .btn-white.btn-outline-light:not(.btn-dim):not(:disabled):not(.disabled):hover, .dark-mode .dt-buttons .btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover, .dt-buttons .dark-mode .btn-secondary:not(.btn-dim):not(:disabled):not(.disabled):hover,
.dark-mode .btn-trans.btn-outline-light:not(.btn-dim):not(:disabled):not(.disabled):hover {
  color: #8091a7;
  background: #1b2531;
}
.dark-mode .btn-dim.btn-outline-light:not(:disabled):not(.disabled):hover,
.dark-mode .btn-white.btn-outline-light:not(:disabled):not(.disabled):hover,
.dark-mode .dt-buttons .btn-secondary:not(:disabled):not(.disabled):hover,
.dt-buttons .dark-mode .btn-secondary:not(:disabled):not(.disabled):hover,
.dark-mode .btn-dim.btn-outline-light:not(:disabled):not(.disabled):active,
.dark-mode .btn-white.btn-outline-light:not(:disabled):not(.disabled):active,
.dark-mode .dt-buttons .btn-secondary:not(:disabled):not(.disabled):active,
.dt-buttons .dark-mode .btn-secondary:not(:disabled):not(.disabled):active,
.dark-mode .show > .btn-white.btn-outline-light.dropdown-toggle,
.dark-mode .dt-buttons .show > .dropdown-toggle.btn-secondary,
.dt-buttons .dark-mode .show > .dropdown-toggle.btn-secondary {
  background: #3c4d62;
  border-color: #3c4d62;
  color: #fff;
}
.dark-mode .btn-white, .dark-mode .dt-buttons .btn-secondary, .dt-buttons .dark-mode .btn-secondary,
.dark-mode .btn-white.btn-dim,
.dark-mode .btn-white.btn-outline-light {
  background: #141c26;
}
.dark-mode .btn-outline-light:focus, .dark-mode .dt-buttons .btn-secondary:focus, .dt-buttons .dark-mode .btn-secondary:focus,
.dark-mode .btn-outline-light.focus,
.dark-mode .dt-buttons .focus.btn-secondary,
.dt-buttons .dark-mode .focus.btn-secondary {
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.07) !important;
}
.dark-mode .border,
.dark-mode .border-bottom,
.dark-mode .border-top,
.dark-mode .border-left,
.dark-mode .border-right,
.dark-mode .dropdown-inner + .dropdown-inner,
.dark-mode .dropdown-head,
.dark-mode .dropdown-foot,
.dark-mode .preview-hr,
.dark-mode .select2-container--default .select2-selection--single,
.dark-mode .ql-picker-options,
.dark-mode .select2-container--default .select2-selection--multiple,
.dark-mode .select2-dropdown,
.dark-mode .select2-container--default .select2-search--dropdown .select2-search__field,
.dark-mode .ui-timepicker-standard,
.dark-mode .ql-toolbar,
.dark-mode .ql-container,
.dark-mode .note-editor,
.dark-mode .note-toolbar,
.dark-mode .tox .tox-menubar,
.dark-mode .tox-toolbar-overlord,
.dark-mode .tox-tinymce,
.dark-mode .tox .tox-toolbar__group:not(:last-of-type),
.dark-mode .tox .tox-statusbar,
.dark-mode .tox .tox-menu,
.dark-mode .tox-toolbar,
.dark-mode .tox-editor-header,
.dark-mode .tox .tox-toolbar,
.dark-mode .tox .tox-toolbar__primary,
.dark-mode .tox .tox-toolbar__overflow,
.dark-mode .tox .tox-collection--list .tox-collection__group,
.dark-mode .note-btn-group .note-btn,
.dark-mode .note-statusbar,
.dark-mode .nk-code-preview-box,
.dark-mode .swal2-footer,
.dark-mode .example-border-all > div,
.dark-mode .btn-toolbar-sep,
.dark-mode .page-link,
.dark-mode .table th,
.dark-mode .table td,
.dark-mode .table-bordered,
.dark-mode .table-bordered th,
.dark-mode .table-bordered td,
.dark-mode .datatable-wrap,
.dark-mode .nk-tb-head .nk-tb-col,
.dark-mode .list-group-item,
.dark-mode .modal-header,
.dark-mode .modal-footer,
.dark-mode .popover,
.dark-mode .popover-header,
.dark-mode .tagify__tag > div::before,
.dark-mode .tagify__tag:hover:not([readonly]) div::before,
.dark-mode .nk-tb-item:not(:last-child) .nk-tb-col,
.dark-mode .nk-activity-item:not(:last-child),
.dark-mode .nk-support-item:not(:last-child),
.dark-mode .card-inner-group .card-inner:not(:last-child),
.dark-mode .card-aside,
.dark-mode .nav-tabs,
.dark-mode .divider,
.dark-mode .data-item:not(:last-child),
.dark-mode .nk-footer,
.dark-mode .nav-switch-s2 .nav-link,
.dark-mode .accordion-item:last-child .accordion-inner,
.dark-mode .user-avatar-multiple .user-avatar {
  border-color: #1d2d40 !important;
}
.dark-mode .card,
.dark-mode .code-block,
.dark-mode .alert-pro,
.dark-mode .modal-content,
.dark-mode .toast,
.dark-mode .toastr {
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.4);
}
.dark-mode .toast-header {
  color: #8094ae;
}
.dark-mode .toast,
.dark-mode .toast-header {
  border-color: #203247;
  background: #18212d;
}
.dark-mode .table-active,
.dark-mode .table-active > th,
.dark-mode .table-active > td,
.dark-mode .table-hover tbody tr:hover,
.dark-mode .code-block .prettyprint,
.dark-mode .list-group-item,
.dark-mode .example-spacing-pd > div > span,
.dark-mode .custom-file-label::after,
.dark-mode .ql-picker-options,
.dark-mode .data-more:before,
.dark-mode .ui-state-hover,
.dark-mode .note-editor.note-frame .note-statusbar,
.dark-mode .note-editor.note-airframe .note-statusbar,
.dark-mode .swal2-popup,
.dark-mode .select2-container--default .select2-results__option--highlighted[aria-selected],
.dark-mode .select2-container--default .select2-results__option[aria-selected=true],
.dark-mode .select2-container--default .select2-selection--multiple .select2-selection__choice,
.dark-mode .select2-container--default .select2-search--dropdown .select2-search__field,
.dark-mode .example-width > div,
.dark-mode .example-height > div,
.dark-mode .example-border > div,
.dark-mode .example-spacing > div {
  background: #101924;
}
.dark-mode .tox .tox-tbtn:hover,
.dark-mode .tox .tox-collection--list .tox-collection__item--active,
.dark-mode .tox .tox-mbtn--active,
.dark-mode .tox .tox-mbtn:focus:not(:disabled),
.dark-mode .tox .tox-mbtn:hover:not(:disabled):not(.tox-mbtn--active),
.dark-mode .tox .tox-collection--list .tox-collection__item--enabled {
  background: #0a0f16;
}
.dark-mode .icon-overlap li {
  border-color: #141c26;
}
.dark-mode .card,
.dark-mode .kanban-add-task,
.dark-mode .kanban-board-header,
.dark-mode .kanban-item {
  background: #141c26;
}
.dark-mode .accordion,
.dark-mode .form-clip,
.dark-mode .form-text-hint,
.dark-mode .card-aside,
.dark-mode .code-block,
.dark-mode .alert-pro,
.dark-mode .modal-content,
.dark-mode .toastr,
.dark-mode .toggle-content,
.dark-mode .nav-switch-s2 .nav-link:hover,
.dark-mode .nav-switch-s2 .nav-link:focus,
.dark-mode .nav-switch-s2 .nav-link.active,
.dark-mode .select2-container--default .select2-selection--single,
.dark-mode .select2-container--default .select2-selection--multiple,
.dark-mode .select2-dropdown,
.dark-mode .custom-file-label,
.dark-mode .custom-select,
.dark-mode div.dataTables_wrapper div.dataTables_length select,
div.dataTables_wrapper div.dataTables_length .dark-mode select,
.dark-mode .popover,
.dark-mode .search-wrap,
.dark-mode .form-control,
.dark-mode div.dataTables_wrapper div.dataTables_filter input,
div.dataTables_wrapper div.dataTables_filter .dark-mode input,
.dark-mode .dual-listbox .dual-listbox__search,
.dual-listbox .dark-mode .dual-listbox__search,
.dark-mode .rdl-filter,
.dark-mode .form-label-outlined,
.dark-mode .input-mail,
.dark-mode .page-link,
.dark-mode .ui-timepicker-standard,
.dark-mode .note-editor,
.dark-mode .note-toolbar,
.dark-mode .tox .tox-edit-area__iframe,
.dark-mode .tox .tox-menubar,
.dark-mode .tox-toolbar-overlord,
.dark-mode .tox .tox-toolbar,
.dark-mode .tox .tox-toolbar__primary,
.dark-mode .tox .tox-toolbar__overflow,
.dark-mode .tox .tox-statusbar,
.dark-mode .tox .tox-menu,
.dark-mode .datepicker table tr td.today,
.dark-mode .datepicker table tr td.today:hover,
.dark-mode .datepicker table tr td.today.disabled,
.dark-mode .datepicker table tr td.today.disabled:hover,
.dark-mode .datepicker table tr td.day:hover,
.dark-mode .datepicker table tr td.day.focused,
.dark-mode .datepicker .datepicker-switch:hover,
.dark-mode .datepicker .prev:hover,
.dark-mode .datepicker .next:hover,
.dark-mode .datepicker tfoot tr th:hover {
  background: #141c26 !important;
}
.dark-mode .clipboard-success-message {
  background: rgba(20, 28, 38, 0.9);
}
.dark-mode .tagify__tag > div::before,
.dark-mode .tagify__tag:hover:not([readonly]) div::before {
  box-shadow: 0 0 0 1.1em #101924 inset;
}
.dark-mode .popover-header {
  background-color: #1a2430;
}
.dark-mode .popover {
  box-shadow: 0 0 20px -5px rgba(0, 0, 0, 0.6);
}
.dark-mode .bs-popover-bottom .popover-header::before,
.dark-mode .bs-popover-auto[x-placement^=bottom] .popover-header::before {
  border-color: #1d2d40;
}
.dark-mode .bs-popover-top > .arrow::before,
.dark-mode .bs-popover-auto[x-placement^=top] > .arrow::before {
  border-top-color: #1d2d40;
}
.dark-mode .bs-popover-top > .arrow::after,
.dark-mode .bs-popover-auto[x-placement^=top] > .arrow::after {
  border-top-color: #141c26;
}
.dark-mode .bs-popover-bottom > .arrow::before,
.dark-mode .bs-popover-auto[x-placement^=bottom] > .arrow::before {
  border-bottom-color: #1d2d40;
}
.dark-mode .bs-popover-bottom > .arrow::after,
.dark-mode .bs-popover-auto[x-placement^=bottom] > .arrow::after {
  border-bottom-color: #141c26;
}
.dark-mode .bs-popover-right > .arrow::before,
.dark-mode .bs-popover-auto[x-placement^=right] > .arrow::before {
  border-right-color: #1d2d40;
}
.dark-mode .bs-popover-right > .arrow::after,
.dark-mode .bs-popover-auto[x-placement^=right] > .arrow::after {
  border-right-color: #141c26;
}
.dark-mode .bs-popover-left > .arrow::before,
.dark-mode .bs-popover-auto[x-placement^=left] > .arrow::before {
  border-left-color: #1d2d40;
}
.dark-mode .bs-popover-left > .arrow::after,
.dark-mode .bs-popover-auto[x-placement^=left] > .arrow::after {
  border-left-color: #141c26;
}
.dark-mode .team-info li span:last-child,
.dark-mode .team-statistics li span:first-child,
.dark-mode .project-progress-percent,
.dark-mode .kanban-title-content .title,
.dark-mode .card-tools-nav li a:hover,
.dark-mode .card-tools-nav li a.active,
.dark-mode .card-tools-nav li.active a,
.dark-mode .card-amount .amount,
.dark-mode .accordion-head .title,
.dark-mode .custom-file-label::after,
.dark-mode .input-mail,
.dark-mode .form-control,
.dark-mode div.dataTables_wrapper div.dataTables_filter input,
div.dataTables_wrapper div.dataTables_filter .dark-mode input,
.dark-mode .dual-listbox .dual-listbox__search,
.dual-listbox .dark-mode .dual-listbox__search,
.dark-mode .rdl-filter,
.dark-mode .form-control:focus,
.dark-mode .form-label,
.dark-mode .form-label-outlined,
.dark-mode .input-group-text,
.dark-mode .table .thead-light th,
.dark-mode .table-hover tbody tr:hover,
.dark-mode .close,
.dark-mode .close:hover,
.dark-mode .user-name,
.dark-mode .nk-news-text p,
.dark-mode .data-item:hover .icon,
.dark-mode .accordion-icon {
  color: #fff !important;
}
.dark-mode .close {
  text-shadow: 0 1px 0 #141c26;
}
.dark-mode .close:focus {
  outline: none !important;
}
.dark-mode .nk-block-des,
.dark-mode .card-title p,
.dark-mode .nk-sale-data .sub-title,
.dark-mode .link-check li span,
.dark-mode .data-value,
.dark-mode .custom-file-label,
.dark-mode .custom-select,
.dark-mode div.dataTables_wrapper div.dataTables_length select,
div.dataTables_wrapper div.dataTables_length .dark-mode select,
.dark-mode .form-control-select-multiple .custom-select option,
.dark-mode .form-control-select-multiple div.dataTables_wrapper div.dataTables_length select option,
div.dataTables_wrapper div.dataTables_length .dark-mode .form-control-select-multiple select option,
.dark-mode .select2-container--default .select2-selection--single .select2-selection__rendered,
.dark-mode .select2-container--default .select2-selection--multiple .select2-selection__rendered,
.dark-mode .ui-timepicker-standard a,
.dark-mode .note-placeholder,
.dark-mode [class*=knob],
.dark-mode .tox .tox-tbtn:hover,
.dark-mode .tox .tox-statusbar a,
.dark-mode .tox .tox-statusbar__path-item,
.dark-mode .tox .tox-statusbar__wordcount,
.dark-mode .tox-collection__item-label > *,
.dark-mode .nk-quick-nav-icon,
.dark-mode .dropzone .dz-message span,
.dark-mode .datepicker table tr td.today,
.dark-mode .datepicker table tr td.today:hover,
.dark-mode .datepicker table tr td.today.disabled,
.dark-mode .datepicker table tr td.today.disabled:hover,
.dark-mode .datepicker table tr td.day:hover,
.dark-mode .datepicker table tr td.day.focused,
.dark-mode .page-link,
.dark-mode .alert-pro,
.dark-mode .nk-news-text p span,
.dark-mode .language-item,
.dark-mode .nk-tb-list .tb-lead-sub,
.dark-mode .nk-tb-list .tb-amount-sub {
  color: #8094ae !important;
}
.dark-mode .tox .tox-collection__item-accessory {
  color: #526484;
}
.dark-mode .nk-menu-link,
.dark-mode .link-dark,
.dark-mode .nk-menu-main .nk-menu-sub .nk-menu-link,
.dark-mode .link-list a {
  color: #8094ae;
}
.dark-mode .nk-menu-link:hover,
.dark-mode .link-dark:hover,
.dark-mode .nk-menu-main .nk-menu-sub .nk-menu-link:hover,
.dark-mode .link-list a:hover {
  color: #4461F2;
}
.dark-mode .nk-menu-badge {
  color: #dbdfea;
  background: #2a3a4e;
}
.dark-mode .is-dark .nk-menu-badge {
  color: #e7dcff;
}
.dark-mode .is-dark .nk-menu-badge {
  color: #b695ff;
}
.dark-mode .ql-picker.ql-expanded .ql-picker-label,
.dark-mode .active > .nk-menu-link,
.dark-mode .is-theme .nk-menu-link:hover .nk-menu-icon,
.dark-mode .is-theme .nk-menu-item.active > .nk-menu-link .nk-menu-icon,
.dark-mode .is-theme .nk-menu-item.current-menu > .nk-menu-link .nk-menu-icon,
.dark-mode .is-theme .nk-menu-sub .nk-menu-link:hover,
.dark-mode .is-theme .nk-menu-sub .active > .nk-menu-link,
.dark-mode .page-link:hover {
  color: #4461F2 !important;
}
.dark-mode .nk-menu-hr,
.dark-mode .nk-menu-main .nk-menu-sub,
.dark-mode .nk-sidebar .nk-menu > li .nk-menu-sub .nk-menu-sub,
.dark-mode .user-avatar-group .user-avatar {
  border-color: #1d2d40;
}
.dark-mode .table .thead-light th,
.dark-mode .page-item.disabled .page-link,
.dark-mode .page-link:hover,
.dark-mode .tb-odr-head,
.dark-mode .tb-tnx-head,
.dark-mode .custom-control-input[disabled] ~ .custom-control-label::before,
.dark-mode .custom-control-input:disabled ~ .custom-control-label::before {
  background-color: #28374b !important;
}
.dark-mode .progress,
.dark-mode .data-head,
.dark-mode .custom-control-label::before,
.dark-mode .input-group-text,
.dark-mode .nk-msg-profile-toggle {
  background-color: #212d3d !important;
}
.dark-mode .nk-msg-profile-toggle,
.dark-mode .custom-control-label::before,
.dark-mode .form-control,
.dark-mode div.dataTables_wrapper div.dataTables_filter input,
div.dataTables_wrapper div.dataTables_filter .dark-mode input,
.dark-mode .dual-listbox .dual-listbox__search,
.dual-listbox .dark-mode .dual-listbox__search,
.dark-mode .rdl-filter,
.dark-mode .input-mail,
.dark-mode .custom-file-label,
.dark-mode .input-group-text,
.dark-mode .custom-select,
.dark-mode div.dataTables_wrapper div.dataTables_length select,
div.dataTables_wrapper div.dataTables_length .dark-mode select,
.dark-mode .swal2-input,
.dark-mode .swal2-file,
.dark-mode .swal2-textarea,
.dark-mode .select2-container--default .select2-selection--single,
.dark-mode .select2-container--default .select2-selection--multiple,
.dark-mode .select2-dropdown,
.dark-mode .note-popover .popover-content .dropdown-style > li[aria-label=pre],
.dark-mode .note-editor .note-toolbar .dropdown-style > li[aria-label=pre],
.dark-mode .link-bdr-t,
.link-tidy .dark-mode li + li,
.link-list-opt .dark-mode li + li,
.dark-mode .link-list-opt-scrollable li + li,
.link-list-opt-scrollable .dark-mode li + li,
.link-list-plain .dark-mode li + li,
.dark-mode .link-check + .link-check,
.dark-mode .link-tidy li + li,
.dark-mode .link-list + .link-list,
.dark-mode .link-list-opt li + li,
.dark-mode .link-list-plain li,
.dark-mode .link-list-plain li + li {
  border-color: #384d69 !important;
}
.dark-mode .custom-switch .custom-control-label::after {
  background-color: #7f99bb !important;
}
.dark-mode .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff !important;
}
.dark-mode .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #4461F2 !important;
  border-color: #4461F2 !important;
}
.dark-mode .btn-trigger:before,
.dark-mode .btn-trigger.active:hover:before,
.dark-mode .nk-quick-nav-icon:before {
  background-color: #070a0f;
}
.dark-mode .dropdown-menu {
  background-color: #18212d;
  border-color: #263547;
  box-shadow: 0 3px 20px 1px rgba(0, 0, 0, 0.4);
}
.dark-mode .dropdown-menu-s1 {
  border-top-color: #4461F2;
}
.dark-mode .link-list-plain a,
.dark-mode .link-list-opt a,
.dark-mode .link-check li a {
  color: #b6c6e3;
}
.dark-mode .link-list-plain a:hover,
.dark-mode .link-list-opt a:hover,
.dark-mode .link-check li a:hover {
  background: #2a3a4e;
}
.dark-mode .border-transparent {
  border-color: transparent !important;
}
.dark-mode .note-editor .btn, .dark-mode .note-editor .dual-listbox .dual-listbox__button, .dual-listbox .dark-mode .note-editor .dual-listbox__button,
.dark-mode .ql-picker,
.dark-mode .tox .tox-tbtn__select-label,
.dark-mode .tox .tox-mbtn__select-label,
.dark-mode .lead-text span,
.dark-mode .data-list-s2 .data-label,
.dark-mode .btn-trigger,
.dark-mode .list-step li.list-step-done {
  color: #8094ae;
}
.dark-mode .ql-fill,
.dark-mode .ql-stroke.ql-fill,
.dark-mode .tox .tox-tbtn svg {
  fill: #8094ae;
}
.dark-mode .ql-stroke {
  stroke: #8094ae;
}
.dark-mode .team-info li span:first-child,
.dark-mode .team-statistics li span:last-child,
.dark-mode .project-progress-task,
.dark-mode .table,
.dark-mode .nk-tb-list,
.dark-mode .nk-tb-list .tb-amount span,
.dark-mode .nk-tb-list .tb-amount .currency,
.dark-mode .tb-tnx-item .tb-tnx-total,
.dark-mode .tb-odr-item .tb-odr-total,
.dark-mode .user-balance-sub span,
.dark-mode .dropdown-menu,
.dark-mode .pln,
.dark-mode .overline-title,
.dark-mode .nk-block-des strong,
.dark-mode .data-item:hover .data-value,
.dark-mode .data-item:hover .data-label,
.dark-mode .nk-notification-text,
.dark-mode .profile-ud-value,
.dark-mode .bq-note-meta span > span,
.dark-mode .tagify__tag > div,
.dark-mode .popover-body,
.dark-mode .input-mail::placeholder,
.dark-mode .list-apps-title {
  color: #b6c6e3;
}
.dark-mode .nk-notification-text span,
.dark-mode .is-unread .chat-context .text {
  color: #dfe9fe;
}
.dark-mode .nav-tabs .nav-link {
  color: #b6c6e3;
}
.dark-mode .nav-tabs .nav-link.active {
  color: #4461F2;
}
.dark-mode .nav-tabs .nav-link:hover {
  color: #fff;
}
.dark-mode .link-list-menu a,
.dark-mode .list-plain a {
  color: #8094ae;
}
.dark-mode .link-list-menu a:hover, .dark-mode .link-list-menu a.active,
.dark-mode .list-plain a:hover,
.dark-mode .list-plain a.active {
  color: #4461F2;
}
.dark-mode .nav-switch .nav-link.active,
.dark-mode .list-apps a:hover .list-apps-title {
  color: #fff;
}
.dark-mode .nk-tb-item:not(.nk-tb-head):hover,
.dark-mode .nk-tb-item:not(.nk-tb-head).seleted {
  box-shadow: 0 2px 15px -4px rgba(0, 0, 0, 0.7);
}
.dark-mode .nk-tb-item:hover .nk-tb-action-hidden,
.dark-mode .bq-note-text,
.dark-mode .nk-tb-item:not(.nk-tb-head):hover,
.dark-mode .nk-tb-item:not(.nk-tb-head).seleted {
  background: #11171f;
}
.dark-mode .nk-apps-sidebar .dropdown-menu .lead-text,
.dark-mode .list-step li.list-step-current,
.dark-mode .nk-tb-list .tb-lead,
.dark-mode .nk-tb-list .tb-amount,
.dark-mode .nk-support-content .title,
.dark-mode .nk-sale-data .amount {
  color: #fff;
}
.dark-mode .nk-support-content .time,
.dark-mode .page-item.disabled .page-link,
.dark-mode .card-hint,
.dark-mode .list-step li {
  color: #526484;
}
.dark-mode .nk-order-ovwg-data .title .icon,
.dark-mode .timeline-item:not(:last-child):before,
.dark-mode .timeline-status.is-outline:after {
  background-color: #263547;
}
.dark-mode .nk-footer {
  background-color: #101924;
}
.dark-mode .nk-order-ovwg-data .info strong,
.dark-mode .user-activity .amount,
.dark-mode .invest-data-history .amount,
.dark-mode .analytic-data .amount,
.dark-mode .traffic-channel-data .amount,
.dark-mode .analytics-map-data .amount,
.dark-mode .device-status-data .amount,
.dark-mode .invest-ov .amount,
.dark-mode .profile-balance-amount .number {
  color: #fff;
}
.dark-mode .invest-ov:not(:last-child) {
  border-color: #384d69;
}
.dark-mode .nk-header .dropdown-menu .lead-text,
.dark-mode .nk-sidebar-bar .dropdown-menu .lead-text {
  color: #fff;
}
.dark-mode .nk-header,
.dark-mode .nk-header.is-light:not([class*=bg-]),
.dark-mode .nk-sidebar,
.dark-mode .nk-sidebar.is-light,
.dark-mode .nk-sidebar-head {
  border-color: #203247 !important;
}
.dark-mode .nk-header,
.dark-mode .nk-header.is-light:not([class*=bg-]),
.dark-mode .nk-sidebar,
.dark-mode .nk-sidebar.is-light,
.dark-mode .nk-header.is-theme:not([class*=bg-]) {
  background: #101924;
}
.dark-mode .nk-chat-aside-user .title,
.dark-mode .nk-file-name,
.dark-mode .nk-file-name-text a.title,
.dark-mode .is-unread .nk-ibx-context-text .heading,
.dark-mode .chat-profile-settings .custom-control-sm .custom-control-label,
.dark-mode .attach-info,
.dark-mode .profile-stats .amount,
.dark-mode .is-unread .chat-from .name {
  color: #fff;
}
.dark-mode .nk-fmg-menu-item .icon,
.dark-mode .nk-ibx-menu-item .icon {
  color: #8094ae;
}
.dark-mode .nk-fmg-menu-text,
.dark-mode .nk-ibx-label-text,
.dark-mode .nk-ibx-menu-text,
.dark-mode .attach-item a,
.dark-mode .user-contacts li,
.dark-mode .nk-ibx-context-text .heading,
.dark-mode .chat-option-link:hover .lead-text,
.dark-mode .chat-from .name,
.dark-mode .user-plan-title {
  color: #b6c6e3;
}
.dark-mode .nk-file-name-text a.title:hover,
.dark-mode .active > .nk-fmg-menu-item .icon,
.dark-mode .active .nk-ibx-menu-text,
.dark-mode .active .nk-ibx-menu-item .icon {
  color: #4461F2;
}
.dark-mode .nk-chat,
.dark-mode .nk-chat-aside,
.dark-mode .nk-chat-profile,
.dark-mode .nk-chat-head,
.dark-mode .chat-profile-group,
.dark-mode .nk-fmg,
.dark-mode .nk-fmg-aside,
.dark-mode .nk-fmg-body-head,
.dark-mode .nk-fmg-switch,
.dark-mode .nk-files-view-grid .nk-file,
.dark-mode .nk-files-view-group .nk-file,
.dark-mode .nk-ibx,
.dark-mode .nk-ibx-aside,
.dark-mode .nk-ibx-head,
.dark-mode .nk-ibx-item,
.dark-mode .nk-reply-form,
.dark-mode .nk-reply-form-header,
.dark-mode .nk-reply-form-tools,
.dark-mode .nk-reply-form-field:not(:last-child),
.dark-mode .nk-msg,
.dark-mode .nk-msg-head,
.dark-mode .nk-msg-profile,
.dark-mode .attach-files,
.dark-mode .attach-foot,
.dark-mode .nk-msg-item:not(:last-child),
.dark-mode .nk-msg-aside,
.dark-mode .nk-msg-nav,
.dark-mode .nk-msg-nav .search-wrap,
.dark-mode .nk-files-group > .title,
.dark-mode .nk-file-share-header,
.dark-mode .nk-files-view-list .nk-file > div {
  border-color: #1d2d40 !important;
}
.dark-mode .nk-block-subhead,
.dark-mode .data-list-s2 .data-head,
.dark-mode .nk-profile-toggle,
.dark-mode .nk-profile-content,
.dark-mode .user-account-links {
  border-color: #2b3748;
}
.dark-mode .nk-upload-item,
.dark-mode .dropzone {
  border-color: #354358 !important;
}
.dark-mode .data-list-s2 .data-head {
  background: transparent !important;
}
.dark-mode .chat-sap-meta:before,
.dark-mode .chat-sap-meta:after,
.dark-mode .active > .nk-fmg-menu-item,
.dark-mode .nk-fmg-menu-item:hover,
.dark-mode .nk-ibx-status,
.dark-mode .nk-ibx-reply-item:not(:last-child):after,
.dark-mode .nk-reply-meta-info:before,
.dark-mode .nk-reply-meta-info:after {
  background: #1d2d40;
}
.dark-mode .nk-chat,
.dark-mode .nk-chat-aside,
.dark-mode .nk-chat-profile,
.dark-mode .nk-chat-head,
.dark-mode .chat-msg,
.dark-mode .nk-chat-editor,
.dark-mode .nk-chat-blank,
.dark-mode .nk-fmg,
.dark-mode .nk-fmg-aside,
.dark-mode .nk-fmg-body-head,
.dark-mode .nk-files-view-grid .nk-file,
.dark-mode .nk-files-view-group .nk-file,
.dark-mode .nk-ibx,
.dark-mode .nk-ibx-aside,
.dark-mode .nk-ibx-item,
.dark-mode .nk-ibx-view,
.dark-mode .nk-msg,
.dark-mode .nk-msg-head,
.dark-mode .nk-msg-profile,
.dark-mode .nk-fmg-switch {
  background: #141c26;
}
.dark-mode .nk-ibx-status .progress {
  background: #141c26 !important;
}
.dark-mode .nk-chat-panel,
.dark-mode .chat-item:hover,
.dark-mode .chat-item.current,
.dark-mode .chat-item:hover .chat-actions,
.dark-mode .chat-members .user-card:hover,
.dark-mode .chat-members .user-actions,
.dark-mode .nk-profile-content,
.dark-mode .nk-msg-item.active,
.dark-mode .nk-msg-item.current,
.dark-mode .channel-list a:hover,
.dark-mode .channel-list a.active {
  background: #0d141d !important;
}
.dark-mode .fav-list .user-avatar:after {
  background: #415a79;
}
.dark-mode .nk-ibx-item:not(.no-hover):hover,
.dark-mode .nk-ibx-item.active,
.dark-mode .nk-ibx-item:hover .ibx-actions-hidden,
.dark-mode .nk-ibx-item:hover .ibx-actions,
.dark-mode .nk-ibx-label > li:hover,
.dark-mode .nk-ibx-contact > li:hover,
.dark-mode .nk-ibx-menu li.active,
.dark-mode .nk-ibx-menu li:hover,
.dark-mode .dot-label:after,
.dark-mode .attach-foot,
.dark-mode .nk-reply-from,
.dark-mode .nk-reply-entry.note,
.dark-mode .nk-msg-aside,
.dark-mode .nk-msg-nav,
.dark-mode .nk-files-view-grid .nk-file,
.dark-mode .nk-files-view-group .nk-file,
.dark-mode .nk-files-view-list .nk-file > div {
  background: #101924;
}
.dark-mode .is-unread .nk-ibx-context-text,
.dark-mode .nk-upload-info {
  color: #dfe9fe;
}
.dark-mode .nk-reply-msg-excerpt,
.dark-mode .nk-ibx-context-text,
.dark-mode .user-contacts li .icon,
.dark-mode .nk-reply-tools .date {
  color: #8094ae;
}
.dark-mode .is-unread .nk-msg-sender .name {
  color: #fff;
}
.dark-mode .nk-reply-meta-info,
.dark-mode .nk-reply-from {
  color: #7a8faa;
}
.dark-mode .nk-reply-meta-info span,
.dark-mode .nk-reply-meta-info strong,
.dark-mode .nk-reply-meta-info .who,
.dark-mode .channel-list a {
  color: #b6c6e3;
}
.dark-mode .nk-reply-meta-info .whom {
  color: #4461F2;
}
.dark-mode .nk-reply-form-attachment-list {
  background: #0d141d;
}
.dark-mode .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .btn, .dark-mode .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .dual-listbox .dual-listbox__button, .dual-listbox .dark-mode .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .dual-listbox__button {
  color: #b6c6e3;
  border-color: #1d2d40;
}
.dark-mode .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .btn:disabled, .dark-mode .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .dual-listbox .dual-listbox__button:disabled, .dual-listbox .dark-mode .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .dual-listbox__button:disabled {
  color: #b6c6e3;
  border-color: #1d2d40;
}
.dark-mode .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .btn:hover, .dark-mode .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .dual-listbox .dual-listbox__button:hover, .dual-listbox .dark-mode .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .dual-listbox__button:hover, .dark-mode .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .btn:focus, .dark-mode .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .dual-listbox .dual-listbox__button:focus, .dual-listbox .dark-mode .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .dual-listbox__button:focus {
  color: #fff;
  background: #101924;
  border-color: #1d2d40;
}
.dark-mode .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .btn:focus, .dark-mode .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .dual-listbox .dual-listbox__button:focus, .dual-listbox .dark-mode .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .dual-listbox__button:focus {
  box-shadow: 0 0 0 0.2rem rgba(29, 45, 64, 0.5);
}
.dark-mode .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .btn.active, .dark-mode .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .dual-listbox .active.dual-listbox__button, .dual-listbox .dark-mode .fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk .active.dual-listbox__button {
  color: #4461F2;
  border-color: #1d2d40;
  background: #101924;
  box-shadow: inset 0 0 4px -1px rgba(29, 45, 64, 0.25);
}
.dark-mode .fc-day {
  color: #b6c6e3;
}
.dark-mode .fc-day-other {
  color: #8094ae;
}
.dark-mode .fc-list-day,
.dark-mode .fc-col-header-cell {
  color: #fff;
}
.dark-mode .fc .fc-list-empty {
  background: #101924;
}
.dark-mode .fc-timegrid-event-harness-inset .fc-timegrid-event,
.dark-mode .fc-timegrid-event.fc-event-mirror {
  box-shadow: 0px 0px 0px 1px #101924;
}
.dark-mode a.fc-event-primary-dim {
  background-color: #1b2645 !important;
  border-color: #1b2645 !important;
}
.dark-mode .modal-header.fc-event-primary-dim {
  background-color: #1b2645 !important;
  border-color: #141c33 !important;
}
.dark-mode span.fc-event-primary-dim .dot {
  background-color: #1b2645 !important;
}
.dark-mode .fc-event-primary-dim:not(a) .fc-list-event-dot {
  background-color: #1b2645 !important;
}
.dark-mode a.fc-event-success-dim {
  background-color: #16393a !important;
  border-color: #16393a !important;
}
.dark-mode .modal-header.fc-event-success-dim {
  background-color: #16393a !important;
  border-color: #0f2728 !important;
}
.dark-mode span.fc-event-success-dim .dot {
  background-color: #16393a !important;
}
.dark-mode .fc-event-success-dim:not(a) .fc-list-event-dot {
  background-color: #16393a !important;
}
.dark-mode a.fc-event-info-dim {
  background-color: #123542 !important;
  border-color: #123542 !important;
}
.dark-mode .modal-header.fc-event-info-dim {
  background-color: #123542 !important;
  border-color: #0d252e !important;
}
.dark-mode span.fc-event-info-dim .dot {
  background-color: #123542 !important;
}
.dark-mode .fc-event-info-dim:not(a) .fc-list-event-dot {
  background-color: #123542 !important;
}
.dark-mode a.fc-event-warning-dim {
  background-color: #363422 !important;
  border-color: #363422 !important;
}
.dark-mode .modal-header.fc-event-warning-dim {
  background-color: #363422 !important;
  border-color: #262518 !important;
}
.dark-mode span.fc-event-warning-dim .dot {
  background-color: #363422 !important;
}
.dark-mode .fc-event-warning-dim:not(a) .fc-list-event-dot {
  background-color: #363422 !important;
}
.dark-mode a.fc-event-danger-dim {
  background-color: #34242b !important;
  border-color: #34242b !important;
}
.dark-mode .modal-header.fc-event-danger-dim {
  background-color: #34242b !important;
  border-color: #251a1f !important;
}
.dark-mode span.fc-event-danger-dim .dot {
  background-color: #34242b !important;
}
.dark-mode .fc-event-danger-dim:not(a) .fc-list-event-dot {
  background-color: #34242b !important;
}
.dark-mode a.fc-event-secondary-dim {
  background-color: #1b2532 !important;
  border-color: #1b2532 !important;
}
.dark-mode .modal-header.fc-event-secondary-dim {
  background-color: #1b2532 !important;
  border-color: #121921 !important;
}
.dark-mode span.fc-event-secondary-dim .dot {
  background-color: #1b2532 !important;
}
.dark-mode .fc-event-secondary-dim:not(a) .fc-list-event-dot {
  background-color: #1b2532 !important;
}
.dark-mode a.fc-event-dark-dim {
  background-color: #161e29 !important;
  border-color: #161e29 !important;
}
.dark-mode .modal-header.fc-event-dark-dim {
  background-color: #161e29 !important;
  border-color: #0d1218 !important;
}
.dark-mode span.fc-event-dark-dim .dot {
  background-color: #161e29 !important;
}
.dark-mode .fc-event-dark-dim:not(a) .fc-list-event-dot {
  background-color: #161e29 !important;
}
.dark-mode a.fc-event-blue-dim {
  background-color: #1e2f46 !important;
  border-color: #1e2f46 !important;
}
.dark-mode .modal-header.fc-event-blue-dim {
  background-color: #1e2f46 !important;
  border-color: #162334 !important;
}
.dark-mode span.fc-event-blue-dim .dot {
  background-color: #1e2f46 !important;
}
.dark-mode .fc-event-blue-dim:not(a) .fc-list-event-dot {
  background-color: #1e2f46 !important;
}
.dark-mode a.fc-event-azure-dim {
  background-color: #142a46 !important;
  border-color: #142a46 !important;
}
.dark-mode .modal-header.fc-event-azure-dim {
  background-color: #142a46 !important;
  border-color: #0e1e32 !important;
}
.dark-mode span.fc-event-azure-dim .dot {
  background-color: #142a46 !important;
}
.dark-mode .fc-event-azure-dim:not(a) .fc-list-event-dot {
  background-color: #142a46 !important;
}
.dark-mode a.fc-event-indigo-dim {
  background-color: #1a233d !important;
  border-color: #1a233d !important;
}
.dark-mode .modal-header.fc-event-indigo-dim {
  background-color: #1a233d !important;
  border-color: #12192b !important;
}
.dark-mode span.fc-event-indigo-dim .dot {
  background-color: #1a233d !important;
}
.dark-mode .fc-event-indigo-dim:not(a) .fc-list-event-dot {
  background-color: #1a233d !important;
}
.dark-mode a.fc-event-purple-dim {
  background-color: #242847 !important;
  border-color: #242847 !important;
}
.dark-mode .modal-header.fc-event-purple-dim {
  background-color: #242847 !important;
  border-color: #1b1e36 !important;
}
.dark-mode span.fc-event-purple-dim .dot {
  background-color: #242847 !important;
}
.dark-mode .fc-event-purple-dim:not(a) .fc-list-event-dot {
  background-color: #242847 !important;
}
.dark-mode a.fc-event-pink-dim {
  background-color: #372739 !important;
  border-color: #372739 !important;
}
.dark-mode .modal-header.fc-event-pink-dim {
  background-color: #372739 !important;
  border-color: #281d2a !important;
}
.dark-mode span.fc-event-pink-dim .dot {
  background-color: #372739 !important;
}
.dark-mode .fc-event-pink-dim:not(a) .fc-list-event-dot {
  background-color: #372739 !important;
}
.dark-mode a.fc-event-orange-dim {
  background-color: #37302d !important;
  border-color: #37302d !important;
}
.dark-mode .modal-header.fc-event-orange-dim {
  background-color: #37302d !important;
  border-color: #292422 !important;
}
.dark-mode span.fc-event-orange-dim .dot {
  background-color: #37302d !important;
}
.dark-mode .fc-event-orange-dim:not(a) .fc-list-event-dot {
  background-color: #37302d !important;
}
.dark-mode a.fc-event-teal-dim {
  background-color: #163637 !important;
  border-color: #163637 !important;
}
.dark-mode .modal-header.fc-event-teal-dim {
  background-color: #163637 !important;
  border-color: #0f2425 !important;
}
.dark-mode span.fc-event-teal-dim .dot {
  background-color: #163637 !important;
}
.dark-mode .fc-event-teal-dim:not(a) .fc-list-event-dot {
  background-color: #163637 !important;
}
.dark-mode .code-block, .dark-mode .card-preview,
.dark-mode .card .card-inner + .table .tb-tnx-head,
.dark-mode .card-bordered, .dark-mode .kanban-add-task, .dark-mode .kanban-board-header, .dark-mode .kanban-item, .dark-mode .kanban-board .kanban-drag:empty,
.dark-mode .accordion-item:not(:last-child) .accordion-head,
.dark-mode .accordion-item:not(:last-child) .accordion-inner,
.dark-mode .accordion-item:last-child .accordion-inner,
.dark-mode .nk-download {
  border-color: #1d2d40;
}
.dark-mode .accordion:not(.accordion-s2):not(.accordion-s3) {
  border-color: #1d2d40 !important;
}
.dark-mode .card.bg-light .card-header, .dark-mode .dual-listbox .card.dual-listbox__item:hover .card-header, .dual-listbox .dark-mode .card.dual-listbox__item:hover .card-header,
.dark-mode .card.bg-lighter .card-header,
.dark-mode .rdl-control > option.card:hover .card-header {
  background: rgba(0, 0, 0, 0.2);
}
.dark-mode .nk-tb-list.is-separate .nk-tb-item > .nk-tb-col {
  border-top-color: #1d2d40;
  border-bottom-color: #1d2d40;
}
.dark-mode .nk-tb-list.is-separate .nk-tb-item > .nk-tb-col:first-child {
  border-left-color: #1d2d40;
}
.dark-mode .nk-tb-list.is-separate .nk-tb-item > .nk-tb-col:last-child {
  border-right-color: #1d2d40;
}
.dark-mode .modal-footer.bg-light, .dark-mode .dual-listbox .modal-footer.dual-listbox__item:hover, .dual-listbox .dark-mode .modal-footer.dual-listbox__item:hover {
  background-color: #11171f !important;
}
.dark-mode .kanban-primary {
  border-top-color: #4461F2;
}
.dark-mode .kanban-success {
  border-top-color: #1ee0ac;
}
.dark-mode .kanban-info {
  border-top-color: #09c2de;
}
.dark-mode .kanban-warning {
  border-top-color: #f4bd0e;
}
.dark-mode .kanban-danger {
  border-top-color: #e85347;
}
.dark-mode.ui-bordered .card,
.dark-mode.ui-bordered .code-block,
.dark-mode.ui-bordered .accordion:not(.accordion-s2):not(.accordion-s3),
.dark-mode.ui-bordered .accordion-item:last-child .accordion-inner,
.dark-mode.ui-bordered .card .card-inner + .table .tb-tnx-head,
.dark-mode.ui-bordered .card-bordered,
.dark-mode.ui-bordered .nk-download {
  border-color: #1d2d40;
}
.dark-mode.ui-bordered .nk-tb-list.is-separate .nk-tb-item > .nk-tb-col {
  border-top-color: #1d2d40;
  border-bottom-color: #1d2d40;
}
.dark-mode.ui-bordered .nk-tb-list.is-separate .nk-tb-item > .nk-tb-col:first-child {
  border-left-color: #1d2d40;
}
.dark-mode.ui-bordered .nk-tb-list.is-separate .nk-tb-item > .nk-tb-col:last-child {
  border-right-color: #1d2d40;
}
.dark-mode.ui-bordered .nk-files-view-grid .nk-file,
.dark-mode.ui-bordered .nk-files-view-group .nk-file {
  border: none !important;
}
.dark-mode .nk-order-ovwg-data.buy {
  border-color: #1a9276;
}
.dark-mode .nk-order-ovwg-data.sell {
  border-color: #3145a0;
}
.dark-mode .nk-sidebar-overlay {
  background: rgba(0, 0, 0, 0.6);
}
.dark-mode .toggle-overlay,
.dark-mode .nk-chat-profile-overlay {
  background: rgba(7, 10, 15, 0.75);
}
.dark-mode .swal2-container.swal2-backdrop-show {
  background: rgba(0, 0, 0, 0.85);
}
.dark-mode .modal-backdrop {
  opacity: 0.9;
  background: rgba(0, 0, 0, 0.9);
}
.dark-mode .is-light .nk-menu-link:hover,
.dark-mode .is-light .active > .nk-menu-link,
.dark-mode .nk-menu-link:hover,
.dark-mode .active > .nk-menu-link,
.dark-mode .is-theme .nk-menu-link:hover,
.dark-mode .is-theme .active > .nk-menu-link {
  background: #182536;
}
.dark-mode .nk-menu-sub .nk-menu-link:hover,
.dark-mode .active > .nk-menu-sub .nk-menu-link,
.dark-mode .nk-header-search .form-control,
.dark-mode .nk-header-search div.dataTables_wrapper div.dataTables_filter input,
div.dataTables_wrapper div.dataTables_filter .dark-mode .nk-header-search input,
.dark-mode .nk-header-search .dual-listbox .dual-listbox__search,
.dual-listbox .dark-mode .nk-header-search .dual-listbox__search,
.dark-mode .nk-header-search .rdl-filter {
  background-color: transparent !important;
}
.dark-mode .ui-bordered .nk-tb-list.is-separate .nk-tb-item > .nk-tb-col:first-child,
.dark-mode .ui-bordered .nk-tb-list.is-separate .nk-tb-item > .nk-tb-col {
  border-color: #1d2d40 !important;
}
.dark-mode .is-compact:not(:hover) .nk-menu-heading:not(:first-child):before {
  background-color: #1d2d40;
}
.dark-mode .nk-add-product {
  background: #1b2633;
  box-shadow: -10px 15px 30px 5px rgba(0, 0, 0, 0.4);
}
.dark-mode .nk-tb-list.is-separate .nk-tb-item > .nk-tb-col,
.dark-mode .nk-tb-list.is-separate .nk-tb-item:hover .nk-tb-action-hidden,
.dark-mode .nk-download {
  background-color: #141c26;
}
.dark-mode .nk-ecwg .amount,
.dark-mode .nk-store-statistics .count,
.dark-mode .nk-top-products .title,
.dark-mode .nk-top-products .amount,
.dark-mode .nk-tb-list .tb-product .title {
  color: #fff;
}
.dark-mode .nk-ecwg8-legends .title,
.dark-mode .nk-ecwg7-legends .title {
  color: #ecf2ff;
}
.dark-mode .dual-listbox .dual-listbox__available,
.dark-mode .dual-listbox .dual-listbox__selected {
  border-color: #384d69;
}
.dark-mode .dual-listbox .dual-listbox__title {
  border-left-color: #384d69;
  border-right-color: #384d69;
  border-top-color: #384d69;
}
.dark-mode .dual-listbox .dual-listbox__item {
  border-bottom-color: #384d69;
}
.dark-mode .input-group-addon {
  background-color: #1b2633;
  border-color: #384d69;
}
.dark-mode .border-light {
  border-color: #1d2d40 !important;
}
.dark-mode div.dt-button-info {
  background-color: #141c26;
}
.dark-mode div.dt-button-info h2 {
  background-color: #0f151c;
}
.dark-mode div.dt-button-info h2 {
  border-color: #1d2d40;
}
.dark-mode .dropzone {
  background: #101924;
}
.dark-mode .image-control .custom-control-input:checked ~ .custom-control-label:before {
  border-color: #384d69;
}
.dark-mode .image-control .custom-control-label {
  background-color: #1f2b3a;
}
.dark-mode .custom-control-pro .custom-control-label {
  background-color: #141c26;
  border-color: #384d69;
}
.dark-mode .custom-control.color-control .custom-control-label::before {
  background: transparent !important;
}
.dark-mode .slick-dots li button {
  background-color: #101924;
}
.dark-mode .slick-dots li.slick-active button {
  background-color: #4461F2;
}
.dark-mode .slick-next,
.dark-mode .slick-prev {
  color: #fff;
  background: #141c26;
  border-color: #1d2d40;
}
.dark-mode .slick-next:hover,
.dark-mode .slick-prev:hover {
  color: #fff;
  background: #4461F2;
  border-color: #4461F2;
}
.dark-mode .slick-disabled .slick-next,
.dark-mode .slick-disabled .slick-prev {
  color: #dbdfea;
}
.dark-mode .slick-disabled .slick-next:hover,
.dark-mode .slick-disabled .slick-prev:hover {
  color: #dbdfea;
  background: #141c26;
  border-color: #1d2d40;
}
.dark-mode .pricing-head {
  border-color: #1d2d40;
}
.dark-mode .pricing-amount .amount {
  color: #fff;
}
.dark-mode .product-title a {
  color: #fff;
}
.dark-mode .product-gallery {
  border-color: #1d2d40;
}
.dark-mode .product-gallery .slider-nav .slider-item .thumb {
  border-color: #1d2d40;
}
.dark-mode .product-gallery .slider-nav .slider-item.slick-current .thumb {
  border-color: #4461F2;
}
.dark-mode .invoice-wrap {
  background-color: #141c26;
  border-color: #1d2d40;
}
.dark-mode .invoice-bills .table tfoot {
  border-color: #1d2d40;
}
.dark-mode .nk-add-product {
  background: #101924;
  box-shadow: -10px 15px 30px 5px rgba(0, 0, 0, 0.4);
}
.dark-mode .noUi-target {
  background: #2f4158;
}
.dark-mode .noUi-handle:before,
.dark-mode .noUi-handle:after {
  background: #5a83b6;
}
.dark-mode .noUi-handle {
  border-color: #5a83b6;
  background: #080d12;
}
.dark-mode .noUi-active {
  box-shadow: inset 0 0 1px #000, inset 0 1px 7px #000, 0 3px 6px -3px #000;
}

@media (max-width: 576px) {
  .dark-mode .nk-block-tools-toggle .toggle-expand-content {
    background-color: #212d3d;
  }
}
.dark-mode {
  /* Pagination */
}
.dark-mode .icon[class*=text-danger] {
  color: #e85347 !important;
}
.dark-mode .icon[class*=text-blue] {
  color: #559bfb !important;
}
.dark-mode .icon[class*=text-purple] {
  color: #816bff !important;
}
.dark-mode .icon[class*=text-warning] {
  color: #f4bd0e !important;
}
.dark-mode .icon[class*=text-success] {
  color: #1ee0ac !important;
}
.dark-mode .icon[class*=text-pink] {
  color: #ff63a5 !important;
}
.dark-mode .icon[class*=text-orange] {
  color: #ffa353 !important;
}
.dark-mode .icon[class*=text-secondary] {
  color: #364a63 !important;
}
.dark-mode .react-select-container {
  box-sizing: border-box !important;
  margin: 0 !important;
  position: relative !important;
  vertical-align: middle !important;
  cursor: pointer !important;
  min-height: calc(2.125rem + 2px) !important;
}
.dark-mode .react-select__control {
  cursor: pointer !important;
  color: #8094ae !important;
  border: 1px solid #2b3748 !important;
  background-color: #141c26 !important;
}
.dark-mode .react-select__control:hover {
  border-color: #2b3748 !important;
}
.dark-mode .react-select__single-value {
  color: #8094ae !important;
  line-height: 1.25rem !important;
  font-family: Roboto, sans-serif !important;
  font-size: 13px !important;
  font-weight: 400 !important;
}
.dark-mode .react-select__control--is-focused,
.dark-mode .react-select__control--menu-is-open,
.dark-mode .react-select__control + .react-select__control--is-focused,
.dark-mode .react-select__control + .react-select__control--menu-is-open {
  border: 1px solid #2b3748 !important;
  cursor: pointer !important;
  box-shadow: none !important;
}
.dark-mode .react-select__menu {
  background-color: #141c26 !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  border: 1px solid #2b3748 !important;
  font-family: "DM Sans", sans-serif !important;
  font-size: 13px !important;
  font-weight: 400 !important;
  display: block !important;
  padding: 6px !important;
  z-index: 1000 !important;
}
.dark-mode .react-select__option {
  background-color: #141c26 !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  font-family: "DM Sans", sans-serif !important;
  font-size: 13px !important;
  font-weight: 400 !important;
  cursor: pointer !important;
  display: block !important;
  font-weight: normal;
  display: block;
  white-space: nowrap;
  min-height: 1.2em;
  color: #8094ae;
  padding: 0.375rem 0.75rem !important;
}
.dark-mode .react-select__option:not(:last-child) {
  margin-bottom: 0.125rem;
}
.dark-mode .react-select__option:hover {
  font-weight: normal;
  display: block;
  white-space: nowrap;
  background-color: #101924 !important;
}
.dark-mode .react-select__option--is-selected {
  color: #8094ae;
  background: #141c26 !important;
}
.dark-mode .react-select__placeholder {
  color: #8094ae !important;
  font-size: small !important;
  margin-left: 5px;
  padding: 0 0.35rem !important;
}
.dark-mode .react-select__multi-value__label {
  color: #8094ae !important;
}
.dark-mode .react-select__multi-value {
  background-color: #141c26 !important;
  border-radius: 3px !important;
  cursor: pointer !important;
}
.dark-mode .react-select__multi-value__remove {
  color: #8094ae !important;
  cursor: pointer !important;
  display: inline-block !important;
  font-weight: bold !important;
}
.dark-mode .react-select__multi-value__remove:hover {
  background: transparent !important;
}
.dark-mode .page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.dark-mode .page-item:last-child .page-link {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.dark-mode .page-item.active .page-link {
  z-index: 3;
  color: #141c26 !important;
  background-color: #4461F2 !important;
  border-color: #4461F2 !important;
}
.dark-mode .page-item.disabled .page-link {
  color: #dbdfea;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #e5e9f2;
}
.dark-mode .react-datepicker-popper {
  background-color: #141c26 !important;
  padding: 10px;
  border-radius: 4px;
  direction: ltr;
  border: 1px solid #2b3748;
  box-shadow: none;
  min-width: 240px;
  font-size: 0.8125rem;
}
.dark-mode .react-datepicker__time-container .react-datepicker__time {
  position: relative;
  background-color: #141c26 !important;
  border-bottom-right-radius: 0.3rem;
}
.dark-mode .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {
  color: #fff;
  background-color: #4461F2 !important;
}
.dark-mode .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {
  color: #8094ae !important;
  background-color: #141c26 !important;
}
.dark-mode .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {
  color: #8094ae !important;
  background-color: #141c26 !important;
}
.dark-mode .react-datepicker__header {
  text-align: center;
  position: relative;
  font-size: 0.8125rem;
  color: #b6c6e3;
  font-weight: bold;
}
.dark-mode .react-datepicker__navigation:hover {
  background: #101924;
}
.dark-mode .react-datepicker__navigation-icon {
  position: relative;
  top: -1px;
  font-size: 12px;
  color: #fff;
  width: 0;
}
.dark-mode .react-datepicker__day:hover,
.dark-mode .react-datepicker__month-text:hover,
.dark-mode .react-datepicker__quarter-text:hover,
.dark-mode .react-datepicker__year-text:hover {
  color: #8094ae !important;
  background-color: #101924 !important;
}
.dark-mode .react-datepicker__day--today,
.dark-mode .react-datepicker__month-text--today,
.dark-mode .react-datepicker__quarter-text--today,
.dark-mode .react-datepicker__year-text--today {
  color: #8094ae;
  background-color: #141c26;
  border-radius: 0.3rem;
}
.dark-mode .react-datepicker__month--selected,
.dark-mode .react-datepicker__month--in-selecting-range,
.dark-mode .react-datepicker__month--in-range,
.dark-mode .react-datepicker__quarter--selected,
.dark-mode .react-datepicker__quarter--in-selecting-range,
.dark-mode .react-datepicker__quarter--in-range {
  border-radius: 0.3rem;
  color: #fff !important;
  background-color: #4461F2 !important;
}
.dark-mode .react-datepicker__month--selected:hover,
.dark-mode .react-datepicker__month--in-selecting-range:hover,
.dark-mode .react-datepicker__month--in-range:hover,
.dark-mode .react-datepicker__quarter--selected:hover,
.dark-mode .react-datepicker__quarter--in-selecting-range:hover,
.dark-mode .react-datepicker__quarter--in-range:hover {
  color: #8094ae !important;
  background-color: #141c26 !important;
}
.dark-mode .react-datepicker__day--selected,
.dark-mode .react-datepicker__day--in-selecting-range,
.dark-mode .react-datepicker__day--in-range,
.dark-mode .react-datepicker__month-text--selected,
.dark-mode .react-datepicker__month-text--in-selecting-range,
.dark-mode .react-datepicker__month-text--in-range,
.dark-mode .react-datepicker__quarter-text--selected,
.dark-mode .react-datepicker__quarter-text--in-selecting-range,
.dark-mode .react-datepicker__quarter-text--in-range,
.dark-mode .react-datepicker__year-text--selected,
.dark-mode .react-datepicker__year-text--in-selecting-range,
.dark-mode .react-datepicker__year-text--in-range {
  border-radius: 0.3rem;
  color: #fff !important;
  background-color: #4461F2 !important;
}
.dark-mode .react-datepicker__day--today:hover,
.dark-mode .react-datepicker__year-text--today:hover,
.dark-mode .react-datepicker__day--selected:hover,
.dark-mode .react-datepicker__day--in-selecting-range:hover,
.dark-mode .react-datepicker__day--in-range:hover,
.dark-mode .react-datepicker__month-text--selected:hover,
.dark-mode .react-datepicker__month-text--in-selecting-range:hover,
.dark-mode .react-datepicker__month-text--in-range:hover,
.dark-mode .react-datepicker__quarter-text--selected:hover,
.dark-mode .react-datepicker__quarter-text--in-selecting-range:hover,
.dark-mode .react-datepicker__quarter-text--in-range:hover,
.dark-mode .react-datepicker__year-text--selected:hover,
.dark-mode .react-datepicker__year-text--in-selecting-range:hover,
.dark-mode .react-datepicker__year-text--in-range:hover {
  color: #8094ae !important;
  background-color: #141c26 !important;
}
.dark-mode .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range),
.dark-mode .react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range),
.dark-mode .react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range),
.dark-mode .react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range) {
  background-color: #4461F2;
  color: #fff;
}
.dark-mode .react-datepicker__month-text.react-datepicker__month--selected:hover,
.dark-mode .react-datepicker__month-text.react-datepicker__month--in-range:hover,
.dark-mode .react-datepicker__month-text.react-datepicker__quarter--selected:hover,
.dark-mode .react-datepicker__month-text.react-datepicker__quarter--in-range:hover,
.dark-mode .react-datepicker__quarter-text.react-datepicker__month--selected:hover,
.dark-mode .react-datepicker__quarter-text.react-datepicker__month--in-range:hover,
.dark-mode .react-datepicker__quarter-text.react-datepicker__quarter--selected:hover,
.dark-mode .react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover {
  background-color: #4461F2;
  color: #fff;
}
.dark-mode .rdt_TableRow,
.dark-mode .rdt_TableHeadRow,
.dark-mode .rdt_Table {
  background: #141c26;
  color: #b6c6e3 !important;
  border-color: #1d2d40;
}
.dark-mode .rdt_TableCol {
  color: #b6c6e3 !important;
}
.dark-mode .rdl-control {
  background-color: #141c26 !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  border-color: #2b3748 !important;
}
.dark-mode .rdl-control-label {
  background-color: #141c26 !important;
  box-shadow: none !important;
  border-color: #2b3748 !important;
}
.dark-mode .rdl-control > option {
  background-color: #141c26 !important;
  box-shadow: none !important;
  border-color: #384d69;
  color: #b6c6e3;
}
.dark-mode .rdl-control > option:hover {
  background-color: #101924 !important;
}
.dark-mode .rdt_ExpanderRow {
  background: #141c26 !important;
}
.dark-mode .dtr-details {
  color: #b6c6e3 !important;
}
.dark-mode .Toastify__toast {
  background: #141c26 !important;
  color: #fff !important;
}

/*! END @iO */`, "",{"version":3,"sources":["webpack://./src/assets/scss/dashlite.scss","webpack://./src/assets/scss/core/fonts/_dmsans.scss","webpack://./src/assets/scss/extend/bootstrap/_bootstrap.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./src/assets/scss/extend/bootstrap/_override_base/_reboot.scss","webpack://./src/assets/scss/extend/bootstrap/_variables.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./src/assets/scss/_dashlite_variables.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_hover.scss","webpack://./src/assets/scss/extend/bootstrap/_override_base/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_code.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid-framework.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-row.scss","webpack://./src/assets/scss/extend/bootstrap/_override_base/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./src/assets/scss/extend/bootstrap/_override_base/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/mixins/_nav-divider.scss","webpack://./src/assets/scss/extend/bootstrap/_override_base/_button-group.scss","webpack://./src/assets/scss/extend/bootstrap/_override_base/_input-group.scss","webpack://./src/assets/scss/extend/bootstrap/_override_base/_custom-forms.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./src/assets/scss/extend/bootstrap/_override_base/_navbar.scss","webpack://./src/assets/scss/extend/bootstrap/_override_base/_card.scss","webpack://./src/assets/scss/extend/bootstrap/_override_base/_breadcrumb.scss","webpack://./src/assets/scss/extend/bootstrap/_override_base/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/mixins/_badge.scss","webpack://./node_modules/bootstrap/scss/_jumbotron.scss","webpack://./src/assets/scss/extend/bootstrap/_override_base/_alert.scss","webpack://./node_modules/bootstrap/scss/mixins/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_media.scss","webpack://./src/assets/scss/extend/bootstrap/_override_base/_list-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_list-group.scss","webpack://./src/assets/scss/extend/bootstrap/_override_base/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./src/assets/scss/extend/bootstrap/_override_base/_modal.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/utilities/_align.scss","webpack://./node_modules/bootstrap/scss/mixins/_background-variant.scss","webpack://./node_modules/bootstrap/scss/utilities/_background.scss","webpack://./src/assets/scss/extend/bootstrap/_override_base/utilities/_borders.scss","webpack://./node_modules/bootstrap/scss/utilities/_display.scss","webpack://./node_modules/bootstrap/scss/utilities/_embed.scss","webpack://./node_modules/bootstrap/scss/utilities/_flex.scss","webpack://./src/assets/scss/extend/bootstrap/_override_base/utilities/_float.scss","webpack://./node_modules/bootstrap/scss/utilities/_interactions.scss","webpack://./node_modules/bootstrap/scss/utilities/_overflow.scss","webpack://./node_modules/bootstrap/scss/utilities/_position.scss","webpack://./node_modules/bootstrap/scss/utilities/_screenreaders.scss","webpack://./node_modules/bootstrap/scss/mixins/_screen-reader.scss","webpack://./node_modules/bootstrap/scss/utilities/_shadows.scss","webpack://./node_modules/bootstrap/scss/utilities/_sizing.scss","webpack://./src/assets/scss/extend/bootstrap/_override_base/utilities/_spacing.scss","webpack://./node_modules/bootstrap/scss/utilities/_stretched-link.scss","webpack://./src/assets/scss/extend/bootstrap/_override_base/utilities/_text.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-emphasis.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-hide.scss","webpack://./node_modules/bootstrap/scss/utilities/_visibility.scss","webpack://./node_modules/bootstrap/scss/_print.scss","webpack://./src/assets/scss/extend/bootstrap/utilites/_reboot.scss","webpack://./src/assets/scss/extend/bootstrap/utilites/_type.scss","webpack://./src/assets/scss/extend/bootstrap/utilites/_text.scss","webpack://./src/assets/scss/extend/bootstrap/utilites/_common.scss","webpack://./src/assets/scss/extend/bootstrap/utilites/_background.scss","webpack://./src/assets/scss/extend/bootstrap/utilites/_borders.scss","webpack://./src/assets/scss/extend/bootstrap/utilites/_sizing.scss","webpack://./src/assets/scss/extend/bootstrap/utilites/_position.scss","webpack://./src/assets/scss/extend/bootstrap/utilites/_flex.scss","webpack://./src/assets/scss/extend/bootstrap/components/_badge.scss","webpack://./src/assets/scss/extend/bootstrap/components/_alert.scss","webpack://./src/assets/scss/vendors/nioicon/_variables.scss","webpack://./src/assets/scss/extend/bootstrap/components/_breadcrumb.scss","webpack://./src/assets/scss/extend/bootstrap/components/_link.scss","webpack://./src/assets/scss/extend/bootstrap/components/_buttons.scss","webpack://./src/assets/scss/extend/bootstrap/components/_button-group.scss","webpack://./src/assets/scss/extend/bootstrap/components/_dropdown.scss","webpack://./src/assets/scss/extend/bootstrap/components/_card.scss","webpack://./src/assets/scss/extend/bootstrap/components/_forms.scss","webpack://./src/assets/scss/extend/bootstrap/components/_custom-forms.scss","webpack://./src/assets/scss/extend/bootstrap/components/_tables.scss","webpack://./src/assets/scss/extend/bootstrap/components/_media.scss","webpack://./src/assets/scss/extend/bootstrap/components/_nav.scss","webpack://./src/assets/scss/extend/bootstrap/components/_modal.scss","webpack://./src/assets/scss/extend/bootstrap/components/_pagination.scss","webpack://./src/assets/scss/extend/bootstrap/components/_progress.scss","webpack://./src/assets/scss/extend/bootstrap/components/_toast.scss","webpack://./src/assets/scss/extend/bootstrap/components/_rating.scss","webpack://./src/assets/scss/vendors/nioicon/nioicon.scss","webpack://./src/assets/scss/vendors/_prettify.scss","webpack://./src/assets/scss/vendors/_dnd.scss","webpack://./src/assets/scss/vendors/_simplebar.scss","webpack://./src/assets/scss/vendors/slick/_slick.scss","webpack://./src/assets/scss/vendors/dropzone/_dropzone.scss","webpack://./src/assets/scss/vendors/datatable/_datatable.scss","webpack://./src/assets/scss/vendors/datatable/_buttons.bootstrap4.scss","webpack://./src/assets/scss/vendors/react-datatable/_react-datatable.scss","webpack://./src/assets/scss/vendors/sweetalert2/_sweetalert2.scss","webpack://./src/assets/scss/vendors/sweetalert2/scss/_toasts.scss","webpack://./src/assets/scss/vendors/sweetalert2/variables.scss","webpack://./src/assets/scss/vendors/sweetalert2/scss/_mixins.scss","webpack://./src/assets/scss/vendors/sweetalert2/scss/_core.scss","webpack://./src/assets/scss/vendors/sweetalert2/scss/_polyfills.scss","webpack://./src/assets/scss/vendors/sweetalert2/scss/_toasts-animations.scss","webpack://./src/assets/scss/vendors/sweetalert2/scss/_animations.scss","webpack://./src/assets/scss/vendors/sweetalert2/scss/_body.scss","webpack://./src/assets/scss/vendors/sweetalert2/scss/_toasts-body.scss","webpack://./src/assets/scss/vendors/_tagify.scss","webpack://./src/assets/scss/vendors/quill/_quill.scss","webpack://./src/assets/scss/vendors/tinymce/ui/_content.scss","webpack://./src/assets/scss/vendors/tinymce/ui/_content.inline.scss","webpack://./src/assets/scss/vendors/tinymce/ui/_content.mobile.scss","webpack://./src/assets/scss/vendors/tinymce/ui/_skin.scss","webpack://./src/assets/scss/vendors/tinymce/ui/_skin.mobile.scss","webpack://./src/assets/scss/vendors/_fullcalendar.scss","webpack://./src/assets/scss/vendors/nouislider/_nouislider.scss","webpack://./src/assets/scss/vendors/dual-listbox/_dual-listbox.scss","webpack://./src/assets/scss/vendors/react-select/_react-select.scss","webpack://./src/assets/scss/vendors/react-datepicker/_react-datepicker.scss","webpack://./src/assets/scss/vendors/magnific-popup/_main.scss","webpack://./src/assets/scss/vendors/magnific-popup/_settings.scss","webpack://./src/assets/scss/vendors/react-modal-video/_react-modal-video.scss","webpack://./src/assets/scss/vendors/react-toastify/_react-toastify.scss","webpack://./src/assets/scss/vendors/jvector-map/_jvector.scss","webpack://./src/assets/scss/vendors/jsTree/_jsTree.scss","webpack://./src/assets/scss/vendors/_kanban.scss","webpack://./src/assets/scss/core/_style.scss","webpack://./src/assets/scss/core/layouts/_base.scss","webpack://./src/assets/scss/core/layouts/_header.scss","webpack://./src/assets/scss/core/layouts/_sidebar.scss","webpack://./src/assets/scss/core/layouts/_menu-main.scss","webpack://./src/assets/scss/core/layouts/_footer.scss","webpack://./src/assets/scss/core/layouts/_split.scss","webpack://./src/assets/scss/core/utilites/_reboot.scss","webpack://./src/assets/scss/core/utilites/_spacing.scss","webpack://./src/assets/scss/core/utilites/_sizing.scss","webpack://./src/assets/scss/core/components/_alert.scss","webpack://./src/assets/scss/core/components/_accordions.scss","webpack://./src/assets/scss/core/components/_badge.scss","webpack://./src/assets/scss/core/components/_list.scss","webpack://./src/assets/scss/core/components/_link.scss","webpack://./src/assets/scss/core/components/_forms.scss","webpack://./src/assets/scss/core/components/_title.scss","webpack://./src/assets/scss/core/components/_text.scss","webpack://./src/assets/scss/core/components/_card.scss","webpack://./src/assets/scss/core/components/_users.scss","webpack://./src/assets/scss/core/components/_data-list.scss","webpack://./src/assets/scss/core/components/_dropdown.scss","webpack://./src/assets/scss/core/components/_icons.scss","webpack://./src/assets/scss/core/components/_table.scss","webpack://./src/assets/scss/core/components/_toggle.scss","webpack://./src/assets/scss/core/components/_nav.scss","webpack://./src/assets/scss/core/components/_wgm.scss","webpack://./src/assets/scss/core/components/_modal.scss","webpack://./src/assets/scss/core/components/_search.scss","webpack://./src/assets/scss/core/components/_block.scss","webpack://./src/assets/scss/core/components/_feature.scss","webpack://./src/assets/scss/core/components/_misc.scss","webpack://./src/assets/scss/core/components/_sliders.scss","webpack://./src/assets/scss/core/components/_projects.scss","webpack://./src/assets/scss/core/components/_team.scss","webpack://./src/assets/scss/core/pages/auths/base.scss","webpack://./src/assets/scss/core/pages/errors/base.scss","webpack://./src/assets/scss/core/pages/misc.scss","webpack://./src/assets/scss/core/_misc.scss","webpack://./src/assets/scss/global/comps/_profiles.scss","webpack://./src/assets/scss/global/comps/_wizard.scss","webpack://./src/assets/scss/global/comps/_tb-tnx.scss","webpack://./src/assets/scss/global/comps/_tb-odr.scss","webpack://./src/assets/scss/global/comps/_tb-compact.scss","webpack://./src/assets/scss/global/comps/_knob.scss","webpack://./src/assets/scss/global/tables/_base.scss","webpack://./src/assets/scss/global/wgs/_timeline.scss","webpack://./src/assets/scss/global/wgs/_invoice.scss","webpack://./src/assets/scss/global/wgs/_pricing.scss","webpack://./src/assets/scss/global/wgs/_products.scss","webpack://./src/assets/scss/global/wgs/_gallery.scss","webpack://./src/assets/scss/global/wgs/_misc.scss","webpack://./src/assets/scss/global/wgs/_analytic.scss","webpack://./src/assets/scss/global/wgs/_ecommerce.scss","webpack://./src/assets/scss/global/wgs/_db-invest.scss","webpack://./src/assets/scss/apps/_asterisk.scss","webpack://./src/assets/scss/apps/_reply-comment.scss","webpack://./src/assets/scss/apps/_attach.scss","webpack://./src/assets/scss/apps/_messages.scss","webpack://./src/assets/scss/apps/_inbox.scss","webpack://./src/assets/scss/apps/_file-manager.scss","webpack://./src/assets/scss/apps/_chats.scss","webpack://./src/assets/scss/core/_preview.scss","webpack://./src/assets/scss/core/_mode-override.scss","webpack://./src/assets/scss/core/_dark-skin.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAOhB,eAAA;ACPA;EACI,sBAAA;EACA,4CAAA;EACA,kSAAA;EAKA,iBAAA;EACA,kBAAA;ADDJ;ACIA;EACI,sBAAA;EACA,4CAAA;EACA,sSAAA;EAKA,gBAAA;EACA,kBAAA;ADNJ;ACSA;EACI,sBAAA;EACA,6CAAA;EACA,4SAAA;EAKA,mBAAA;EACA,kBAAA;ADXJ;AEtBA;;EAAA;ACAA;EAGI,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,eAAA;EAAA,cAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,eAAA;EAAA,oBAAA;EAIA,kBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,eAAA;EAAA,eAAA;EAAA,gBAAA;EAAA,kBAAA;EAIA,kBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAKF,mGAAA;EACA,6GAAA;AH0CF;;AI1CA;;;EAGE,sBAAA;AJ6CF;;AI1CA;EACE,uBAAA;EACA,iBAAA;EACA,8BAAA;EACA,6CAAA;AJ6CF;;AIvCA;;;;;;;;;;EAUE,cAAA;AJ0CF;;AIhCA;EACE,SAAA;EACA,oFC6G4B;ECgBxB,mBAAA;EF3HJ,gBGsHW;EHrHX,iBG4GkB;EH3GlB,cGdY;EHeZ,gBAAA;EACA,yBGvCQ;AP0EV;;AIvBA;EACE,qBAAA;AJ0BF;;AIlBA;EACE,uBAAA;EACA,SAAA;EACA,iBAAA;AJqBF;;AITA;;;;;;EAME,aAAA;EACA,qBG4GiB;APhGnB;;AILA;EACE,aAAA;EACA,mBG6H0B;APrH5B;;AIGA;;EAGE,0BAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;AJDF;;AIIA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AJDF;;AIIA;;;EAGE,aAAA;EACA,mBAAA;AJDF;;AIIA;;;;EAIE,gBAAA;AJDF;;AIIA;EACE,gBGuBW;APxBb;;AIIA;EACE,qBAAA;EACA,cAAA;AJDF;;AIIA;EACE,gBAAA;AJDF;;AIIA;;EAEE,mBI0H4B;AR3H9B;;AIIA;EEPI,cAAA;ANOJ;;AISA;;EAEE,kBAAA;EElBE,cAAA;EFoBF,cAAA;EACA,wBAAA;AJNF;;AISA;EACE,eAAA;AJNF;;AIQA;EACE,WAAA;AJLF;;AIYA;EACE,cG9IkB;EH+IlB,qBChIwC;EDiIxC,6BAAA;AJTF;ASrLE;ELiME,cGvIkB;EHwIlB,0BCpIsC;AL2H1C;;AIkBA;EACE,cAAA;EACA,qBAAA;AJfF;AS9LE;ELgNE,cAAA;EACA,qBAAA;AJfJ;;AIuBA;;;;EAIE,iGI6C4B;EFlH1B,cAAA;ANkDJ;;AIuBA;EAEE,aAAA;EAEA,mBAAA;EAEA,cAAA;EAGA,6BAAA;AJzBF;;AIgCA;EAEE,gBAAA;AJ9BF;;AIqCA;EACE,sBAAA;EACA,kBAAA;AJlCF;;AIqCA;EAGE,gBAAA;EACA,sBAAA;AJpCF;;AI2CA;EACE,yBAAA;AJxCF;;AI2CA;EACE,mBCrD4B;EDsD5B,sBCtD4B;EDuD5B,cGjPY;EHkPZ,gBAAA;EACA,oBAAA;AJxCF;;AI2CA;EAGE,mBAAA;AJ1CF;;AIiDA;EAEE,qBAAA;EACA,mBG9B0B;APjB5B;;AIqDA;EAEE,gBAAA;AJnDF;;AI0DA;EACE,mBAAA;EACA,0CAAA;AJvDF;;AI0DA;;;;;EAKE,SAAA;EACA,oBAAA;EErKE,kBAAA;EFuKF,oBAAA;AJvDF;;AI0DA;;EAEE,iBAAA;AJvDF;;AI0DA;;EAEE,oBAAA;AJvDF;;AI6DA;EACE,eAAA;AJ1DF;;AIgEA;EACE,iBAAA;AJ7DF;;AImEA;;;;EAIE,0BAAA;AJhEF;;AIwEI;;;;EACE,eAAA;AJlEN;;AIwEA;;;;EAIE,UAAA;EACA,kBAAA;AJrEF;;AIwEA;;EAEE,sBAAA;EACA,UAAA;AJrEF;;AIwEA;EACE,cAAA;EAEA,gBAAA;AJtEF;;AIyEA;EAME,YAAA;EAEA,UAAA;EACA,SAAA;EACA,SAAA;AJ5EF;;AIiFA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EEhPI,iBAAA;EFkPJ,oBAAA;EACA,cAAA;EACA,mBAAA;AJ9EF;;AIiFA;EACE,wBAAA;AJ9EF;;AIkFA;;EAEE,YAAA;AJ/EF;;AIkFA;EAKE,oBAAA;EACA,wBAAA;AJnFF;;AI0FA;EACE,wBAAA;AJvFF;;AI+FA;EACE,aAAA;EACA,0BAAA;AJ5FF;;AImGA;EACE,qBAAA;AJhGF;;AImGA;EACE,kBAAA;EACA,eAAA;AJhGF;;AImGA;EACE,aAAA;AJhGF;;AIqGA;EACE,wBAAA;AJlGF;;AU5XA;;EAEE,qBH4MiB;EG3MjB,kCH4JmB;EG3JnB,gBHuKW;EGtKX,gBH4MiB;EG3MjB,cHmCc;AP4VhB;;AU5XA;EJqKM,eAAA;AN2NN;;AU/XA;EJoKM,kBAAA;AN+NN;;AUlYA;EJmKM,iBAAA;ANmON;;AUrYA;EJkKM,kBAAA;ANuON;;AUxYA;EJiKM,kBAAA;AN2ON;;AU3YA;EJgKM,eAAA;AN+ON;;AU7YA;EJ8JM,qBAAA;EI5JJ,gBHuJW;APyPb;;AU5YA;EJwJM,eAAA;EItJJ,gBLuK4B;EKtK5B,gBHwLiB;APuNnB;;AU7YA;EJmJM,iBAAA;EIjJJ,gBLmK4B;EKlK5B,gBHmLiB;AP6NnB;;AU9YA;EJ8IM,iBAAA;EI5IJ,gBL+J4B;EK9J5B,gBH8KiB;APmOnB;;AU/YA;EJyIM,iBAAA;EIvIJ,gBL2J4B;EK1J5B,gBHyKiB;APyOnB;;AU1YA;EACE,gBH6EU;EG5EV,mBH4EU;EG3EV,SAAA;EACA,6BAAA;AV6YF;;AUrYA;;EJkGI,cAAA;EI/FF,gBH0GW;AP8Rb;;AUrYA;;EAEE,cH8JoB;EG7JpB,yBH8JoB;AP0OtB;;AUhYA;EC/EE,eAAA;EACA,gBAAA;AXmdF;;AUhYA;ECpFE,eAAA;EACA,gBAAA;AXwdF;;AUlYA;EACE,qBAAA;AVqYF;AUnYE;EACE,oBL4H0B;ALyQ9B;;AU3XA;EJ2DI,cAAA;EIzDF,yBAAA;AV8XF;;AU1XA;EACE,mBHoBU;EDgDN,qBAAA;AN0TN;;AU1XA;EACE,cAAA;EJ+CE,cAAA;EI7CF,cH5EY;APycd;AU3XE;EACE,aAAA;AV6XJ;;AYhfA;ECIE,eAAA;EAGA,YAAA;Ab8eF;;AY/eA;EACE,gBJqgCkC;EIpgClC,yBLOQ;EKNR,yBAAA;EEEE,kBAAA;EDPF,eAAA;EAGA,YAAA;AbufF;;AYzeA;EAEE,qBAAA;AZ2eF;;AYxeA;EACE,qBAAA;EACA,cAAA;AZ2eF;;AYxeA;EN8HI,cAAA;EM5HF,cJ3BS;ARsgBX;;AelhBA;ETmKI,gBAAA;ESjKF,cRiCM;EQhCN,qBAAA;AfqhBF;AelhBE;EACE,cAAA;AfohBJ;;Ae/gBA;EACE,sBAAA;ETsJE,gBAAA;ESpJF,WRPO;EQQP,yBPDS;EMEP,kBAAA;AdkhBJ;Ae/gBE;EACE,UAAA;ET8IA,eAAA;ES5IA,gBRyJS;APwXb;;Ae3gBA;EACE,cAAA;ETqIE,gBAAA;ESnIF,cPjBS;AR+hBX;Ae3gBE;ETgIE,kBAAA;ES9HA,cAAA;EACA,kBAAA;Af6gBJ;;AexgBA;EACE,iBPikCkC;EOhkClC,kBAAA;Af2gBF;;AgBnjBE;;;;;;;;ECDA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AjB+jBF;;AkB5gBI;EFzCE;IACE,gBXqFe;ELoerB;AACF;AkBlhBI;EFzCE;IACE,gBXqFe;ELyerB;AACF;AkBvhBI;EFzCE;IACE,gBXqFe;EL8erB;AACF;AkB5hBI;EFzCE;IACE,gBXqFe;ELmfrB;AACF;AkBjiBI;EFzCE;IACE,iBXqFe;ELwfrB;AACF;AkBtiBI;EFzCE;IACE,iBXqFe;EL6frB;AACF;AgBvjBE;ECnCA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AjB6lBF;;AgBvjBE;EACE,eAAA;EACA,cAAA;AhB0jBJ;AgBxjBI;;EAEE,gBAAA;EACA,eAAA;AhB0jBN;;AmBhnBE;;;;;;;;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AnB0nBJ;;AmBpmBM;EACE,aAAA;EACA,YAAA;EACA,eAAA;AnBumBR;;AiB3kBE;EACE,cAAA;EACA,eAAA;AjB8kBJ;;AiBhlBE;EACE,aAAA;EACA,cAAA;AjBmlBJ;;AiBrlBE;EACE,wBAAA;EACA,yBAAA;AjBwlBJ;;AiB1lBE;EACE,aAAA;EACA,cAAA;AjB6lBJ;;AiB/lBE;EACE,aAAA;EACA,cAAA;AjBkmBJ;;AiBpmBE;EACE,wBAAA;EACA,yBAAA;AjBumBJ;;AmB1nBM;EFCJ,cAAA;EACA,WAAA;EACA,eAAA;AjB6nBF;;AmB1nBU;EFbR,qBAAA;EAIA,sBAAA;AjBwoBF;;AmB/nBU;EFbR,sBAAA;EAIA,uBAAA;AjB6oBF;;AmBpoBU;EFbR,aAAA;EAIA,cAAA;AjBkpBF;;AmBzoBU;EFbR,sBAAA;EAIA,uBAAA;AjBupBF;;AmB9oBU;EFbR,sBAAA;EAIA,uBAAA;AjB4pBF;;AmBnpBU;EFbR,aAAA;EAIA,cAAA;AjBiqBF;;AmBxpBU;EFbR,sBAAA;EAIA,uBAAA;AjBsqBF;;AmB7pBU;EFbR,sBAAA;EAIA,uBAAA;AjB2qBF;;AmBlqBU;EFbR,aAAA;EAIA,cAAA;AjBgrBF;;AmBvqBU;EFbR,sBAAA;EAIA,uBAAA;AjBqrBF;;AmB5qBU;EFbR,sBAAA;EAIA,uBAAA;AjB0rBF;;AmBjrBU;EFbR,cAAA;EAIA,eAAA;AjB+rBF;;AmBhrBM;EAAwB,SAAA;AnBorB9B;;AmBlrBM;EAAuB,SAAA;AnBsrB7B;;AmBnrBQ;EAAwB,QADb;AnBwrBnB;;AmBvrBQ;EAAwB,QADb;AnB4rBnB;;AmB3rBQ;EAAwB,QADb;AnBgsBnB;;AmB/rBQ;EAAwB,QADb;AnBosBnB;;AmBnsBQ;EAAwB,QADb;AnBwsBnB;;AmBvsBQ;EAAwB,QADb;AnB4sBnB;;AmB3sBQ;EAAwB,QADb;AnBgtBnB;;AmB/sBQ;EAAwB,QADb;AnBotBnB;;AmBntBQ;EAAwB,QADb;AnBwtBnB;;AmBvtBQ;EAAwB,QADb;AnB4tBnB;;AmB3tBQ;EAAwB,SADb;AnBguBnB;;AmB/tBQ;EAAwB,SADb;AnBouBnB;;AmBnuBQ;EAAwB,SADb;AnBwuBnB;;AmBhuBY;EFhBV,wBAAA;AjBovBF;;AmBpuBY;EFhBV,yBAAA;AjBwvBF;;AmBxuBY;EFhBV,gBAAA;AjB4vBF;;AmB5uBY;EFhBV,yBAAA;AjBgwBF;;AmBhvBY;EFhBV,yBAAA;AjBowBF;;AmBpvBY;EFhBV,gBAAA;AjBwwBF;;AmBxvBY;EFhBV,yBAAA;AjB4wBF;;AmB5vBY;EFhBV,yBAAA;AjBgxBF;;AmBhwBY;EFhBV,gBAAA;AjBoxBF;;AmBpwBY;EFhBV,yBAAA;AjBwxBF;;AmBxwBY;EFhBV,yBAAA;AjB4xBF;;AkBvxBI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EnBszBN;EiB1xBA;IACE,cAAA;IACA,eAAA;EjB4xBF;EiB9xBA;IACE,aAAA;IACA,cAAA;EjBgyBF;EiBlyBA;IACE,wBAAA;IACA,yBAAA;EjBoyBF;EiBtyBA;IACE,aAAA;IACA,cAAA;EjBwyBF;EiB1yBA;IACE,aAAA;IACA,cAAA;EjB4yBF;EiB9yBA;IACE,wBAAA;IACA,yBAAA;EjBgzBF;EmBn0BI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EjBq0BA;EmBl0BQ;IFbR,qBAAA;IAIA,sBAAA;EjB+0BA;EmBt0BQ;IFbR,sBAAA;IAIA,uBAAA;EjBm1BA;EmB10BQ;IFbR,aAAA;IAIA,cAAA;EjBu1BA;EmB90BQ;IFbR,sBAAA;IAIA,uBAAA;EjB21BA;EmBl1BQ;IFbR,sBAAA;IAIA,uBAAA;EjB+1BA;EmBt1BQ;IFbR,aAAA;IAIA,cAAA;EjBm2BA;EmB11BQ;IFbR,sBAAA;IAIA,uBAAA;EjBu2BA;EmB91BQ;IFbR,sBAAA;IAIA,uBAAA;EjB22BA;EmBl2BQ;IFbR,aAAA;IAIA,cAAA;EjB+2BA;EmBt2BQ;IFbR,sBAAA;IAIA,uBAAA;EjBm3BA;EmB12BQ;IFbR,sBAAA;IAIA,uBAAA;EjBu3BA;EmB92BQ;IFbR,cAAA;IAIA,eAAA;EjB23BA;EmB52BI;IAAwB,SAAA;EnB+2B5B;EmB72BI;IAAuB,SAAA;EnBg3B3B;EmB72BM;IAAwB,QADb;EnBi3BjB;EmBh3BM;IAAwB,QADb;EnBo3BjB;EmBn3BM;IAAwB,QADb;EnBu3BjB;EmBt3BM;IAAwB,QADb;EnB03BjB;EmBz3BM;IAAwB,QADb;EnB63BjB;EmB53BM;IAAwB,QADb;EnBg4BjB;EmB/3BM;IAAwB,QADb;EnBm4BjB;EmBl4BM;IAAwB,QADb;EnBs4BjB;EmBr4BM;IAAwB,QADb;EnBy4BjB;EmBx4BM;IAAwB,QADb;EnB44BjB;EmB34BM;IAAwB,SADb;EnB+4BjB;EmB94BM;IAAwB,SADb;EnBk5BjB;EmBj5BM;IAAwB,SADb;EnBq5BjB;EmB74BU;IFhBV,cAAA;EjBg6BA;EmBh5BU;IFhBV,wBAAA;EjBm6BA;EmBn5BU;IFhBV,yBAAA;EjBs6BA;EmBt5BU;IFhBV,gBAAA;EjBy6BA;EmBz5BU;IFhBV,yBAAA;EjB46BA;EmB55BU;IFhBV,yBAAA;EjB+6BA;EmB/5BU;IFhBV,gBAAA;EjBk7BA;EmBl6BU;IFhBV,yBAAA;EjBq7BA;EmBr6BU;IFhBV,yBAAA;EjBw7BA;EmBx6BU;IFhBV,gBAAA;EjB27BA;EmB36BU;IFhBV,yBAAA;EjB87BA;EmB96BU;IFhBV,yBAAA;EjBi8BA;AACF;AkB77BI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EnB29BN;EiB/7BA;IACE,cAAA;IACA,eAAA;EjBi8BF;EiBn8BA;IACE,aAAA;IACA,cAAA;EjBq8BF;EiBv8BA;IACE,wBAAA;IACA,yBAAA;EjBy8BF;EiB38BA;IACE,aAAA;IACA,cAAA;EjB68BF;EiB/8BA;IACE,aAAA;IACA,cAAA;EjBi9BF;EiBn9BA;IACE,wBAAA;IACA,yBAAA;EjBq9BF;EmBx+BI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EjB0+BA;EmBv+BQ;IFbR,qBAAA;IAIA,sBAAA;EjBo/BA;EmB3+BQ;IFbR,sBAAA;IAIA,uBAAA;EjBw/BA;EmB/+BQ;IFbR,aAAA;IAIA,cAAA;EjB4/BA;EmBn/BQ;IFbR,sBAAA;IAIA,uBAAA;EjBggCA;EmBv/BQ;IFbR,sBAAA;IAIA,uBAAA;EjBogCA;EmB3/BQ;IFbR,aAAA;IAIA,cAAA;EjBwgCA;EmB//BQ;IFbR,sBAAA;IAIA,uBAAA;EjB4gCA;EmBngCQ;IFbR,sBAAA;IAIA,uBAAA;EjBghCA;EmBvgCQ;IFbR,aAAA;IAIA,cAAA;EjBohCA;EmB3gCQ;IFbR,sBAAA;IAIA,uBAAA;EjBwhCA;EmB/gCQ;IFbR,sBAAA;IAIA,uBAAA;EjB4hCA;EmBnhCQ;IFbR,cAAA;IAIA,eAAA;EjBgiCA;EmBjhCI;IAAwB,SAAA;EnBohC5B;EmBlhCI;IAAuB,SAAA;EnBqhC3B;EmBlhCM;IAAwB,QADb;EnBshCjB;EmBrhCM;IAAwB,QADb;EnByhCjB;EmBxhCM;IAAwB,QADb;EnB4hCjB;EmB3hCM;IAAwB,QADb;EnB+hCjB;EmB9hCM;IAAwB,QADb;EnBkiCjB;EmBjiCM;IAAwB,QADb;EnBqiCjB;EmBpiCM;IAAwB,QADb;EnBwiCjB;EmBviCM;IAAwB,QADb;EnB2iCjB;EmB1iCM;IAAwB,QADb;EnB8iCjB;EmB7iCM;IAAwB,QADb;EnBijCjB;EmBhjCM;IAAwB,SADb;EnBojCjB;EmBnjCM;IAAwB,SADb;EnBujCjB;EmBtjCM;IAAwB,SADb;EnB0jCjB;EmBljCU;IFhBV,cAAA;EjBqkCA;EmBrjCU;IFhBV,wBAAA;EjBwkCA;EmBxjCU;IFhBV,yBAAA;EjB2kCA;EmB3jCU;IFhBV,gBAAA;EjB8kCA;EmB9jCU;IFhBV,yBAAA;EjBilCA;EmBjkCU;IFhBV,yBAAA;EjBolCA;EmBpkCU;IFhBV,gBAAA;EjBulCA;EmBvkCU;IFhBV,yBAAA;EjB0lCA;EmB1kCU;IFhBV,yBAAA;EjB6lCA;EmB7kCU;IFhBV,gBAAA;EjBgmCA;EmBhlCU;IFhBV,yBAAA;EjBmmCA;EmBnlCU;IFhBV,yBAAA;EjBsmCA;AACF;AkBlmCI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EnBgoCN;EiBpmCA;IACE,cAAA;IACA,eAAA;EjBsmCF;EiBxmCA;IACE,aAAA;IACA,cAAA;EjB0mCF;EiB5mCA;IACE,wBAAA;IACA,yBAAA;EjB8mCF;EiBhnCA;IACE,aAAA;IACA,cAAA;EjBknCF;EiBpnCA;IACE,aAAA;IACA,cAAA;EjBsnCF;EiBxnCA;IACE,wBAAA;IACA,yBAAA;EjB0nCF;EmB7oCI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EjB+oCA;EmB5oCQ;IFbR,qBAAA;IAIA,sBAAA;EjBypCA;EmBhpCQ;IFbR,sBAAA;IAIA,uBAAA;EjB6pCA;EmBppCQ;IFbR,aAAA;IAIA,cAAA;EjBiqCA;EmBxpCQ;IFbR,sBAAA;IAIA,uBAAA;EjBqqCA;EmB5pCQ;IFbR,sBAAA;IAIA,uBAAA;EjByqCA;EmBhqCQ;IFbR,aAAA;IAIA,cAAA;EjB6qCA;EmBpqCQ;IFbR,sBAAA;IAIA,uBAAA;EjBirCA;EmBxqCQ;IFbR,sBAAA;IAIA,uBAAA;EjBqrCA;EmB5qCQ;IFbR,aAAA;IAIA,cAAA;EjByrCA;EmBhrCQ;IFbR,sBAAA;IAIA,uBAAA;EjB6rCA;EmBprCQ;IFbR,sBAAA;IAIA,uBAAA;EjBisCA;EmBxrCQ;IFbR,cAAA;IAIA,eAAA;EjBqsCA;EmBtrCI;IAAwB,SAAA;EnByrC5B;EmBvrCI;IAAuB,SAAA;EnB0rC3B;EmBvrCM;IAAwB,QADb;EnB2rCjB;EmB1rCM;IAAwB,QADb;EnB8rCjB;EmB7rCM;IAAwB,QADb;EnBisCjB;EmBhsCM;IAAwB,QADb;EnBosCjB;EmBnsCM;IAAwB,QADb;EnBusCjB;EmBtsCM;IAAwB,QADb;EnB0sCjB;EmBzsCM;IAAwB,QADb;EnB6sCjB;EmB5sCM;IAAwB,QADb;EnBgtCjB;EmB/sCM;IAAwB,QADb;EnBmtCjB;EmBltCM;IAAwB,QADb;EnBstCjB;EmBrtCM;IAAwB,SADb;EnBytCjB;EmBxtCM;IAAwB,SADb;EnB4tCjB;EmB3tCM;IAAwB,SADb;EnB+tCjB;EmBvtCU;IFhBV,cAAA;EjB0uCA;EmB1tCU;IFhBV,wBAAA;EjB6uCA;EmB7tCU;IFhBV,yBAAA;EjBgvCA;EmBhuCU;IFhBV,gBAAA;EjBmvCA;EmBnuCU;IFhBV,yBAAA;EjBsvCA;EmBtuCU;IFhBV,yBAAA;EjByvCA;EmBzuCU;IFhBV,gBAAA;EjB4vCA;EmB5uCU;IFhBV,yBAAA;EjB+vCA;EmB/uCU;IFhBV,yBAAA;EjBkwCA;EmBlvCU;IFhBV,gBAAA;EjBqwCA;EmBrvCU;IFhBV,yBAAA;EjBwwCA;EmBxvCU;IFhBV,yBAAA;EjB2wCA;AACF;AkBvwCI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EnBqyCN;EiBzwCA;IACE,cAAA;IACA,eAAA;EjB2wCF;EiB7wCA;IACE,aAAA;IACA,cAAA;EjB+wCF;EiBjxCA;IACE,wBAAA;IACA,yBAAA;EjBmxCF;EiBrxCA;IACE,aAAA;IACA,cAAA;EjBuxCF;EiBzxCA;IACE,aAAA;IACA,cAAA;EjB2xCF;EiB7xCA;IACE,wBAAA;IACA,yBAAA;EjB+xCF;EmBlzCI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EjBozCA;EmBjzCQ;IFbR,qBAAA;IAIA,sBAAA;EjB8zCA;EmBrzCQ;IFbR,sBAAA;IAIA,uBAAA;EjBk0CA;EmBzzCQ;IFbR,aAAA;IAIA,cAAA;EjBs0CA;EmB7zCQ;IFbR,sBAAA;IAIA,uBAAA;EjB00CA;EmBj0CQ;IFbR,sBAAA;IAIA,uBAAA;EjB80CA;EmBr0CQ;IFbR,aAAA;IAIA,cAAA;EjBk1CA;EmBz0CQ;IFbR,sBAAA;IAIA,uBAAA;EjBs1CA;EmB70CQ;IFbR,sBAAA;IAIA,uBAAA;EjB01CA;EmBj1CQ;IFbR,aAAA;IAIA,cAAA;EjB81CA;EmBr1CQ;IFbR,sBAAA;IAIA,uBAAA;EjBk2CA;EmBz1CQ;IFbR,sBAAA;IAIA,uBAAA;EjBs2CA;EmB71CQ;IFbR,cAAA;IAIA,eAAA;EjB02CA;EmB31CI;IAAwB,SAAA;EnB81C5B;EmB51CI;IAAuB,SAAA;EnB+1C3B;EmB51CM;IAAwB,QADb;EnBg2CjB;EmB/1CM;IAAwB,QADb;EnBm2CjB;EmBl2CM;IAAwB,QADb;EnBs2CjB;EmBr2CM;IAAwB,QADb;EnBy2CjB;EmBx2CM;IAAwB,QADb;EnB42CjB;EmB32CM;IAAwB,QADb;EnB+2CjB;EmB92CM;IAAwB,QADb;EnBk3CjB;EmBj3CM;IAAwB,QADb;EnBq3CjB;EmBp3CM;IAAwB,QADb;EnBw3CjB;EmBv3CM;IAAwB,QADb;EnB23CjB;EmB13CM;IAAwB,SADb;EnB83CjB;EmB73CM;IAAwB,SADb;EnBi4CjB;EmBh4CM;IAAwB,SADb;EnBo4CjB;EmB53CU;IFhBV,cAAA;EjB+4CA;EmB/3CU;IFhBV,wBAAA;EjBk5CA;EmBl4CU;IFhBV,yBAAA;EjBq5CA;EmBr4CU;IFhBV,gBAAA;EjBw5CA;EmBx4CU;IFhBV,yBAAA;EjB25CA;EmB34CU;IFhBV,yBAAA;EjB85CA;EmB94CU;IFhBV,gBAAA;EjBi6CA;EmBj5CU;IFhBV,yBAAA;EjBo6CA;EmBp5CU;IFhBV,yBAAA;EjBu6CA;EmBv5CU;IFhBV,gBAAA;EjB06CA;EmB15CU;IFhBV,yBAAA;EjB66CA;EmB75CU;IFhBV,yBAAA;EjBg7CA;AACF;AkB56CI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EnB08CN;EiB96CA;IACE,cAAA;IACA,eAAA;EjBg7CF;EiBl7CA;IACE,aAAA;IACA,cAAA;EjBo7CF;EiBt7CA;IACE,wBAAA;IACA,yBAAA;EjBw7CF;EiB17CA;IACE,aAAA;IACA,cAAA;EjB47CF;EiB97CA;IACE,aAAA;IACA,cAAA;EjBg8CF;EiBl8CA;IACE,wBAAA;IACA,yBAAA;EjBo8CF;EmBv9CI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EjBy9CA;EmBt9CQ;IFbR,qBAAA;IAIA,sBAAA;EjBm+CA;EmB19CQ;IFbR,sBAAA;IAIA,uBAAA;EjBu+CA;EmB99CQ;IFbR,aAAA;IAIA,cAAA;EjB2+CA;EmBl+CQ;IFbR,sBAAA;IAIA,uBAAA;EjB++CA;EmBt+CQ;IFbR,sBAAA;IAIA,uBAAA;EjBm/CA;EmB1+CQ;IFbR,aAAA;IAIA,cAAA;EjBu/CA;EmB9+CQ;IFbR,sBAAA;IAIA,uBAAA;EjB2/CA;EmBl/CQ;IFbR,sBAAA;IAIA,uBAAA;EjB+/CA;EmBt/CQ;IFbR,aAAA;IAIA,cAAA;EjBmgDA;EmB1/CQ;IFbR,sBAAA;IAIA,uBAAA;EjBugDA;EmB9/CQ;IFbR,sBAAA;IAIA,uBAAA;EjB2gDA;EmBlgDQ;IFbR,cAAA;IAIA,eAAA;EjB+gDA;EmBhgDI;IAAwB,SAAA;EnBmgD5B;EmBjgDI;IAAuB,SAAA;EnBogD3B;EmBjgDM;IAAwB,QADb;EnBqgDjB;EmBpgDM;IAAwB,QADb;EnBwgDjB;EmBvgDM;IAAwB,QADb;EnB2gDjB;EmB1gDM;IAAwB,QADb;EnB8gDjB;EmB7gDM;IAAwB,QADb;EnBihDjB;EmBhhDM;IAAwB,QADb;EnBohDjB;EmBnhDM;IAAwB,QADb;EnBuhDjB;EmBthDM;IAAwB,QADb;EnB0hDjB;EmBzhDM;IAAwB,QADb;EnB6hDjB;EmB5hDM;IAAwB,QADb;EnBgiDjB;EmB/hDM;IAAwB,SADb;EnBmiDjB;EmBliDM;IAAwB,SADb;EnBsiDjB;EmBriDM;IAAwB,SADb;EnByiDjB;EmBjiDU;IFhBV,cAAA;EjBojDA;EmBpiDU;IFhBV,wBAAA;EjBujDA;EmBviDU;IFhBV,yBAAA;EjB0jDA;EmB1iDU;IFhBV,gBAAA;EjB6jDA;EmB7iDU;IFhBV,yBAAA;EjBgkDA;EmBhjDU;IFhBV,yBAAA;EjBmkDA;EmBnjDU;IFhBV,gBAAA;EjBskDA;EmBtjDU;IFhBV,yBAAA;EjBykDA;EmBzjDU;IFhBV,yBAAA;EjB4kDA;EmB5jDU;IFhBV,gBAAA;EjB+kDA;EmB/jDU;IFhBV,yBAAA;EjBklDA;EmBlkDU;IFhBV,yBAAA;EjBqlDA;AACF;AkBjlDI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EnB+mDN;EiBnlDA;IACE,cAAA;IACA,eAAA;EjBqlDF;EiBvlDA;IACE,aAAA;IACA,cAAA;EjBylDF;EiB3lDA;IACE,wBAAA;IACA,yBAAA;EjB6lDF;EiB/lDA;IACE,aAAA;IACA,cAAA;EjBimDF;EiBnmDA;IACE,aAAA;IACA,cAAA;EjBqmDF;EiBvmDA;IACE,wBAAA;IACA,yBAAA;EjBymDF;EmB5nDI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EjB8nDA;EmB3nDQ;IFbR,qBAAA;IAIA,sBAAA;EjBwoDA;EmB/nDQ;IFbR,sBAAA;IAIA,uBAAA;EjB4oDA;EmBnoDQ;IFbR,aAAA;IAIA,cAAA;EjBgpDA;EmBvoDQ;IFbR,sBAAA;IAIA,uBAAA;EjBopDA;EmB3oDQ;IFbR,sBAAA;IAIA,uBAAA;EjBwpDA;EmB/oDQ;IFbR,aAAA;IAIA,cAAA;EjB4pDA;EmBnpDQ;IFbR,sBAAA;IAIA,uBAAA;EjBgqDA;EmBvpDQ;IFbR,sBAAA;IAIA,uBAAA;EjBoqDA;EmB3pDQ;IFbR,aAAA;IAIA,cAAA;EjBwqDA;EmB/pDQ;IFbR,sBAAA;IAIA,uBAAA;EjB4qDA;EmBnqDQ;IFbR,sBAAA;IAIA,uBAAA;EjBgrDA;EmBvqDQ;IFbR,cAAA;IAIA,eAAA;EjBorDA;EmBrqDI;IAAwB,SAAA;EnBwqD5B;EmBtqDI;IAAuB,SAAA;EnByqD3B;EmBtqDM;IAAwB,QADb;EnB0qDjB;EmBzqDM;IAAwB,QADb;EnB6qDjB;EmB5qDM;IAAwB,QADb;EnBgrDjB;EmB/qDM;IAAwB,QADb;EnBmrDjB;EmBlrDM;IAAwB,QADb;EnBsrDjB;EmBrrDM;IAAwB,QADb;EnByrDjB;EmBxrDM;IAAwB,QADb;EnB4rDjB;EmB3rDM;IAAwB,QADb;EnB+rDjB;EmB9rDM;IAAwB,QADb;EnBksDjB;EmBjsDM;IAAwB,QADb;EnBqsDjB;EmBpsDM;IAAwB,SADb;EnBwsDjB;EmBvsDM;IAAwB,SADb;EnB2sDjB;EmB1sDM;IAAwB,SADb;EnB8sDjB;EmBtsDU;IFhBV,cAAA;EjBytDA;EmBzsDU;IFhBV,wBAAA;EjB4tDA;EmB5sDU;IFhBV,yBAAA;EjB+tDA;EmB/sDU;IFhBV,gBAAA;EjBkuDA;EmBltDU;IFhBV,yBAAA;EjBquDA;EmBrtDU;IFhBV,yBAAA;EjBwuDA;EmBxtDU;IFhBV,gBAAA;EjB2uDA;EmB3tDU;IFhBV,yBAAA;EjB8uDA;EmB9tDU;IFhBV,yBAAA;EjBivDA;EmBjuDU;IFhBV,gBAAA;EjBovDA;EmBpuDU;IFhBV,yBAAA;EjBuvDA;EmBvuDU;IFhBV,yBAAA;EjB0vDA;AACF;AoB9yDA;EACE,WAAA;EACA,mBb8HU;Ea7HV,cbsCY;AP0wDd;AoB7yDE;;EAEE,ef0N0B;EezN1B,mBAAA;EACA,6BAAA;ApB+yDJ;AoB5yDE;EACE,sBAAA;EACA,gCAAA;ApB8yDJ;AoB3yDE;EACE,6BAAA;ApB6yDJ;;AoBnyDE;;EAEE,gBfoM0B;ALkmD9B;;AoB7xDA;EACE,yBAAA;ApBgyDF;AoB9xDE;;EAEE,yBAAA;ApBgyDJ;AoB5xDI;;EAEE,wBAAA;ApB8xDN;;AoBxxDE;;;;EAIE,SAAA;ApB2xDJ;;AoBlxDE;EACE,yBbrDM;AP00DV;;ASp1DE;EW2EI,cb1CQ;Ea2CR,yBblEI;AP+0DV;;AqB/1DI;;;EAGE,yBD2F+B;ApBuwDrC;AqB91DM;;;;EAIE,qBDmFyE;ApB6wDjF;;ASr2DE;EYiBM,yBAJe;ArB41DvB;AqBt1DQ;;EAEE,yBARa;ArBg2DvB;;AqBn3DI;;;EAGE,yBD2F+B;ApB2xDrC;AqBl3DM;;;;EAIE,qBDmFyE;ApBiyDjF;;ASz3DE;EYiBM,yBAJe;ArBg3DvB;AqB12DQ;;EAEE,yBARa;ArBo3DvB;;AqBv4DI;;;EAGE,yBD2F+B;ApB+yDrC;AqBt4DM;;;;EAIE,qBDmFyE;ApBqzDjF;;AS74DE;EYiBM,yBAJe;ArBo4DvB;AqB93DQ;;EAEE,yBARa;ArBw4DvB;;AqB35DI;;;EAGE,yBD2F+B;ApBm0DrC;AqB15DM;;;;EAIE,qBDmFyE;ApBy0DjF;;ASj6DE;EYiBM,yBAJe;ArBw5DvB;AqBl5DQ;;EAEE,yBARa;ArB45DvB;;AqB/6DI;;;EAGE,yBD2F+B;ApBu1DrC;AqB96DM;;;;EAIE,qBDmFyE;ApB61DjF;;ASr7DE;EYiBM,yBAJe;ArB46DvB;AqBt6DQ;;EAEE,yBARa;ArBg7DvB;;AqBn8DI;;;EAGE,yBD2F+B;ApB22DrC;AqBl8DM;;;;EAIE,qBDmFyE;ApBi3DjF;;ASz8DE;EYiBM,yBAJe;ArBg8DvB;AqB17DQ;;EAEE,yBARa;ArBo8DvB;;AqBv9DI;;;EAGE,yBD2F+B;ApB+3DrC;AqBt9DM;;;;EAIE,qBDmFyE;ApBq4DjF;;AS79DE;EYiBM,yBAJe;ArBo9DvB;AqB98DQ;;EAEE,yBARa;ArBw9DvB;;AqB3+DI;;;EAGE,yBD2F+B;ApBm5DrC;AqB1+DM;;;;EAIE,qBDmFyE;ApBy5DjF;;ASj/DE;EYiBM,yBAJe;ArBw+DvB;AqBl+DQ;;EAEE,yBARa;ArB4+DvB;;AqB//DI;;;EAGE,yBD2F+B;ApBu6DrC;AqB9/DM;;;;EAIE,qBDmFyE;ApB66DjF;;ASrgEE;EYiBM,yBAJe;ArB4/DvB;AqBt/DQ;;EAEE,yBARa;ArBggEvB;;AqBnhEI;;;EAGE,yBD2F+B;ApB27DrC;AqBlhEM;;;;EAIE,qBDmFyE;ApBi8DjF;;ASzhEE;EYiBM,yBAJe;ArBghEvB;AqB1gEQ;;EAEE,yBARa;ArBohEvB;;AqBviEI;;;EAGE,yBdaI;AP6hEV;;ASviEE;EYiBM,yBAJe;ArB8hEvB;AqBxhEQ;;EAEE,yBARa;ArBkiEvB;;AoB18DI;EACE,WbzGG;Ea0GH,yBbhGM;EaiGN,qBbnGM;APgjEZ;AoBx8DI;EACE,cb3EU;Ea4EV,yBbrGI;EasGJ,qBb9GM;APwjEZ;;AoBr8DA;EACE,WbzHO;Ea0HP,yBbhHU;APwjEZ;AoBt8DE;;;EAGE,qBbvHQ;AP+jEZ;AoBr8DE;EACE,SAAA;ApBu8DJ;AoBn8DI;EACE,yBb/HM;APokEZ;AS1kEE;EW4IM,Wb/IC;EagJD,yBbvII;APwkEZ;;AkBjhEI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EpBm7DN;EoBh7DM;IACE,SAAA;EpBk7DR;AACF;AkB7hEI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EpB87DN;EoB37DM;IACE,SAAA;EpB67DR;AACF;AkBxiEI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EpBy8DN;EoBt8DM;IACE,SAAA;EpBw8DR;AACF;AkBnjEI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EpBo9DN;EoBj9DM;IACE,SAAA;EpBm9DR;AACF;AkB9jEI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EpB+9DN;EoB59DM;IACE,SAAA;EpB89DR;AACF;AkBzkEI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EpB0+DN;EoBv+DM;IACE,SAAA;EpBy+DR;AACF;AoBn/DI;EAEI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iCAAA;ApBo/DR;AoBj/DQ;EACE,SAAA;ApBm/DV;;AsB/pEA;EACE,cAAA;EACA,WAAA;EACA,4Bf2YsC;Ee1YtC,uBAAA;EhByKI,oBAAA;EgBtKJ,gBfiKW;EehKX,oBfyOyB;EexOzB,cfCU;EeAV,sBfRO;EeSP,4BAAA;EACA,yBAAA;ERDE,kBAAA;ESFE,wEDSJ;AtB6pEF;AuBlqEM;EDbN;ICcQ,gBAAA;EvBqqEN;AACF;AsB/pEE;EACE,6BAAA;EACA,SAAA;AtBiqEJ;AsB7pEE;EACE,kBAAA;EACA,0BAAA;AtB+pEJ;AwBtrEE;EACE,cjBGQ;EiBFR,sBjBNK;EiBOL,qBjB4CgB;EiB3ChB,UAAA;EAKE,4CjBwOqB;AP48D3B;AsB/pEE;EACE,cfDU;EeGV,UAAA;AtBgqEJ;AsBxpEE;EAEE,yBflCM;EeoCN,UAAA;AtBwpEJ;;AsBhpEE;;;;;;;;;;;;;EACE,gBAAA;AtB+pEJ;;AsB1pEA;EACE,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;AtB6pEF;;AsBzpEE;EAME,cf3EQ;Ee4ER,sBfpFK;AP2uET;;AsBlpEA;;EAEE,cAAA;EACA,WAAA;AtBqpEF;;AsB3oEA;EACE,kCAAA;EACA,qCAAA;EACA,gBAAA;EhBkDE,kBAAA;EgBhDF,oBfoIyB;AP0gE3B;;AsB3oEA;EACE,kCAAA;EACA,qCAAA;EhB2DI,oBAAA;EgBzDJ,oBf6IyB;APigE3B;;AsB3oEA;EACE,gCAAA;EACA,mCAAA;EhBoDI,kBAAA;EgBlDJ,oBfiIyB;AP6gE3B;;AsBroEA;EACE,cAAA;EACA,WAAA;EACA,oBAAA;EACA,gBAAA;EhBqCI,oBAAA;EgBnCJ,oBfuGyB;EetGzB,cfnGc;EeoGd,6BAAA;EACA,yBAAA;EACA,mBAAA;AtBwoEF;AsBtoEE;EAEE,gBAAA;EACA,eAAA;AtBuoEJ;;AsB3nEA;EACE,2Bf+OsC;Ee9OtC,qBAAA;EhBYI,kBAAA;EgBVJ,oBfyFyB;EOjPvB,kBAAA;AduxEJ;;AsB3nEA;EACE,4BfwOsC;EevOtC,uBAAA;EhBII,oBAAA;EgBFJ,oBfsFyB;EOtPvB,kBAAA;Ad+xEJ;;AsBznEE;EAEE,YAAA;AtB2nEJ;;AsBvnEA;EACE,YAAA;AtB0nEF;;AsBlnEA;EACE,mBd4TsC;ARyzDxC;;AsBlnEA;EACE,cAAA;EACA,mBd6SsC;ARw0DxC;;AsB7mEA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AtBgnEF;AsB9mEE;;EAEE,kBAAA;EACA,iBAAA;AtBgnEJ;;AsBvmEA;EACE,kBAAA;EACA,cAAA;EACA,qBdkRsC;ARw1DxC;;AsBvmEA;EACE,kBAAA;EACA,kBd8QsC;Ec7QtC,qBAAA;AtB0mEF;AsBxmEE;EAEE,cfxMU;APizEd;;AsBrmEA;EACE,gBAAA;AtBwmEF;;AsBrmEA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBdgQsC;ARw2DxC;AsBtmEE;EACE,gBAAA;EACA,aAAA;EACA,uBd4PoC;Ec3PpC,cAAA;AtBwmEJ;;AwBl0EE;EACE,aAAA;EACA,WAAA;EACA,mBhB2coC;EFtVpC,kBAAA;EkBnHA,cFkOqC;AtBmmEzC;;AwBl0EE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,wBAAA;EACA,kBAAA;ElBwHE,oBAAA;EkBtHF,gBhBuO0B;EgBtO1B,WAAA;EACA,yCAAA;EV9CA,kBAAA;Ado3EJ;AwBj0EI;EAEE,SAAA;AxBk0EN;;AwB7zEI;;;;EAEE,cAAA;AxBk0EN;;AwBh3EI;EAoDE,qBF+LmC;EE5LjC,kCAAA;EACA,0DAAA;EACA,4BAAA;EACA,4DAAA;EACA,kEAAA;AxB8zER;AwB3zEM;EACE,qBFoLiC;EEnLjC,iDAAA;AxB6zER;;AwB73EI;EAyEI,8BAAA;EACA,sCAAA;AxBwzER;;AwBl4EI;EAmFI,uBjB2RgC;EiB1RhC,oFAAA;AxBmzER;;AwBv4EI;EA2FE,qBFwJmC;EErJjC,mDAAA;EACA,sNAAA;AxB8yER;AwB3yEM;EACE,qBFgJiC;EE/IjC,iDAAA;AxB6yER;;AwBtyEM;EACE,cFuIiC;AtBkqEzC;AwBtyEM;;;EAEE,cAAA;AxByyER;;AwBlyEM;EACE,cF0HiC;AtB2qEzC;AwBnyEQ;EACE,qBFuH+B;AtB8qEzC;AwBhyEQ;EACE,qBAAA;EC5JN,yBD6J2B;AxBkyE/B;AwB7xEQ;EACE,iDAAA;AxB+xEV;AwB5xEQ;EACE,qBFsG+B;AtBwrEzC;;AwBrxEM;EACE,qBF4FiC;AtB4rEzC;AwBpxEQ;EACE,qBFuF+B;EEtF/B,iDAAA;AxBsxEV;;AwBv6EE;EACE,aAAA;EACA,WAAA;EACA,mBhB2coC;EFtVpC,kBAAA;EkBnHA,cFkOqC;AtBwsEzC;;AwBv6EE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,wBAAA;EACA,kBAAA;ElBwHE,oBAAA;EkBtHF,gBhBuO0B;EgBtO1B,WAAA;EACA,wCAAA;EV9CA,kBAAA;Ady9EJ;AwBt6EI;EAEE,SAAA;AxBu6EN;;AwBl6EI;;;;EAEE,cAAA;AxBu6EN;;AwBr9EI;EAoDE,qBF+LmC;EE5LjC,kCAAA;EACA,0DAAA;EACA,4BAAA;EACA,4DAAA;EACA,kEAAA;AxBm6ER;AwBh6EM;EACE,qBFoLiC;EEnLjC,gDAAA;AxBk6ER;;AwBl+EI;EAyEI,8BAAA;EACA,sCAAA;AxB65ER;;AwBv+EI;EAmFI,uBjB2RgC;EiB1RhC,oFAAA;AxBw5ER;;AwB5+EI;EA2FE,qBFwJmC;EErJjC,mDAAA;EACA,sNAAA;AxBm5ER;AwBh5EM;EACE,qBFgJiC;EE/IjC,gDAAA;AxBk5ER;;AwB34EM;EACE,cFuIiC;AtBuwEzC;AwB34EM;;;EAEE,cAAA;AxB84ER;;AwBv4EM;EACE,cF0HiC;AtBgxEzC;AwBx4EQ;EACE,qBFuH+B;AtBmxEzC;AwBr4EQ;EACE,qBAAA;EC5JN,yBD6J2B;AxBu4E/B;AwBl4EQ;EACE,gDAAA;AxBo4EV;AwBj4EQ;EACE,qBFsG+B;AtB6xEzC;;AwB13EM;EACE,qBF4FiC;AtBiyEzC;AwBz3EQ;EACE,qBFuF+B;EEtF/B,gDAAA;AxB23EV;;AsBzxEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AtB4xEF;AsBvxEE;EACE,WAAA;AtByxEJ;AkBrgFI;EIiPA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;EtBuxEJ;EsBnxEE;IACE,aAAA;IACA,cAAA;IACA,mBAAA;IACA,mBAAA;IACA,gBAAA;EtBqxEJ;EsBjxEE;IACE,qBAAA;IACA,WAAA;IACA,sBAAA;EtBmxEJ;EsB/wEE;IACE,qBAAA;EtBixEJ;EsB9wEE;;;;IAEE,WAAA;EtBkxEJ;EsB7wEE;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,eAAA;EtB+wEJ;EsB7wEE;IACE,kBAAA;IACA,cAAA;IACA,aAAA;IACA,qBdmKkC;IclKlC,cAAA;EtB+wEJ;EsB5wEE;IACE,mBAAA;IACA,uBAAA;EtB8wEJ;EsB5wEE;IACE,gBAAA;EtB8wEJ;AACF;;A0B7mFA;EACE,qBAAA;EACA,kCnB6JmB;EmB5JnB,gBnBwKW;EmBvKX,cnBmCY;EmBlCZ,kBAAA;EAGA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,6BAAA;ECuFA,2BAAA;ErB4EI,oBAAA;EqB1EJ,oBpB8IyB;EOtOvB,kBAAA;ESFE,qIGGJ;A1BinFF;AuBhnFM;EGdN;IHeQ,gBAAA;EvBmnFN;AACF;AS7nFE;EiBUE,cnBuBU;EmBtBV,qBAAA;A1BsnFJ;A0BnnFE;EAEE,UAAA;EACA,4CnBiOuB;APm5E3B;A0BhnFE;EAEE,YnBsS0B;AP20E9B;A0B7mFE;EACE,eAAA;A1B+mFJ;A0BjmFA;;;;EAEE,oBAAA;A1BqmFF;;A0B5lFE;EC3DA,WAAA;EFAE,yBpBqCW;EsBnCb,qBtBmCa;ALwnFf;ASvpFE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;A3BmqFzG;A2BvpFE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,gDAAA;A3BopFN;A2B/oFE;EAEE,WAAA;EACA,yBtBSW;EsBRX,qBtBQW;ALwoFf;A2BzoFE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A3BmrF7L;A2BpoFI;EAKI,gDAAA;A3BkoFR;;A0B1nFE;EC3DA,WAAA;EFAE,yBpBqCW;EsBnCb,qBtBmCa;ALspFf;ASrrFE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;A3BisFzG;A2BrrFE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,gDAAA;A3BkrFN;A2B7qFE;EAEE,WAAA;EACA,yBtBSW;EsBRX,qBtBQW;ALsqFf;A2BvqFE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A3BitF7L;A2BlqFI;EAKI,gDAAA;A3BgqFR;;A0BxpFE;EC3DA,WAAA;EFAE,yBpBqCW;EsBnCb,qBtBmCa;ALorFf;ASntFE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;A3B+tFzG;A2BntFE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,gDAAA;A3BgtFN;A2B3sFE;EAEE,WAAA;EACA,yBtBSW;EsBRX,qBtBQW;ALosFf;A2BrsFE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A3B+uF7L;A2BhsFI;EAKI,gDAAA;A3B8rFR;;A0BtrFE;EC3DA,WAAA;EFAE,yBpBqCW;EsBnCb,qBtBmCa;ALktFf;ASjvFE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;A3B6vFzG;A2BjvFE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,gDAAA;A3B8uFN;A2BzuFE;EAEE,WAAA;EACA,yBtBSW;EsBRX,qBtBQW;ALkuFf;A2BnuFE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A3B6wF7L;A2B9tFI;EAKI,gDAAA;A3B4tFR;;A0BptFE;EC3DA,WAAA;EFAE,yBpBqCW;EsBnCb,qBtBmCa;ALgvFf;AS/wFE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;A3B2xFzG;A2B/wFE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,gDAAA;A3B4wFN;A2BvwFE;EAEE,WAAA;EACA,yBtBSW;EsBRX,qBtBQW;ALgwFf;A2BjwFE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A3B2yF7L;A2B5vFI;EAKI,gDAAA;A3B0vFR;;A0BlvFE;EC3DA,WAAA;EFAE,yBpBqCW;EsBnCb,qBtBmCa;AL8wFf;AS7yFE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;A3ByzFzG;A2B7yFE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,gDAAA;A3B0yFN;A2BryFE;EAEE,WAAA;EACA,yBtBSW;EsBRX,qBtBQW;AL8xFf;A2B/xFE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A3By0F7L;A2B1xFI;EAKI,gDAAA;A3BwxFR;;A0BhxFE;EC3DA,WAAA;EFAE,yBpBqCW;EsBnCb,qBtBmCa;AL4yFf;AS30FE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;A3Bu1FzG;A2B30FE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,8CAAA;A3Bw0FN;A2Bn0FE;EAEE,WAAA;EACA,yBtBSW;EsBRX,qBtBQW;AL4zFf;A2B7zFE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A3Bu2F7L;A2BxzFI;EAKI,8CAAA;A3BszFR;;A0B9yFE;EC3DA,WAAA;EFAE,yBpBqCW;EsBnCb,qBtBmCa;AL00Ff;ASz2FE;EkBAE,WAAA;EFNA,yBED2D;EAS3D,qBATqG;A3Bq3FzG;A2Bz2FE;EAEE,WAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,iDAAA;A3Bs2FN;A2Bj2FE;EAEE,WAAA;EACA,yBtBSW;EsBRX,qBtBQW;AL01Ff;A2B31FE;EAGE,WAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A3Bq4F7L;A2Bt1FI;EAKI,iDAAA;A3Bo1FR;;A0B50FE;EC3DA,cAAA;EFAE,yBpBqCW;EsBnCb,qBtBmCa;ALw2Ff;ASv4FE;EkBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;A3Bm5FzG;A2Bv4FE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,iDAAA;A3Bo4FN;A2B/3FE;EAEE,cAAA;EACA,yBtBSW;EsBRX,qBtBQW;ALw3Ff;A2Bz3FE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A3Bm6F7L;A2Bp3FI;EAKI,iDAAA;A3Bk3FR;;A0B12FE;EC3DA,cAAA;EFAE,yBpBqCW;EsBnCb,qBtBmCa;ALs4Ff;ASr6FE;EkBAE,cAAA;EFNA,yBED2D;EAS3D,qBATqG;A3Bi7FzG;A2Br6FE;EAEE,cAAA;EFbA,yBED2D;EAgB3D,qBAhBqG;EAqBnG,iDAAA;A3Bk6FN;A2B75FE;EAEE,cAAA;EACA,yBtBSW;EsBRX,qBtBQW;ALs5Ff;A2Bv5FE;EAGE,cAAA;EACA,yBAzC+I;EA6C/I,qBA7CyL;A3Bi8F7L;A2Bl5FI;EAKI,iDAAA;A3Bg5FR;;A0Bl4FE;ECPA,ctBrBa;EsBsBb,qBtBtBa;ALm6Ff;ASl8FE;EkBwDE,WALgD;EAMhD,yBtB1BW;EsB2BX,qBtB3BW;ALw6Ff;A2B14FE;EAEE,+CAAA;A3B24FJ;A2Bx4FE;EAEE,ctBrCW;EsBsCX,6BAAA;A3By4FJ;A2Bt4FE;EAGE,WAAA;EACA,yBtB7CW;EsB8CX,qBtB9CW;ALo7Ff;A2Bp4FI;EAKI,+CAAA;A3Bk4FR;;A0B35FE;ECPA,ctBrBa;EsBsBb,qBtBtBa;AL47Ff;AS39FE;EkBwDE,WALgD;EAMhD,yBtB1BW;EsB2BX,qBtB3BW;ALi8Ff;A2Bn6FE;EAEE,8CAAA;A3Bo6FJ;A2Bj6FE;EAEE,ctBrCW;EsBsCX,6BAAA;A3Bk6FJ;A2B/5FE;EAGE,WAAA;EACA,yBtB7CW;EsB8CX,qBtB9CW;AL68Ff;A2B75FI;EAKI,8CAAA;A3B25FR;;A0Bp7FE;ECPA,ctBrBa;EsBsBb,qBtBtBa;ALq9Ff;ASp/FE;EkBwDE,WALgD;EAMhD,yBtB1BW;EsB2BX,qBtB3BW;AL09Ff;A2B57FE;EAEE,gDAAA;A3B67FJ;A2B17FE;EAEE,ctBrCW;EsBsCX,6BAAA;A3B27FJ;A2Bx7FE;EAGE,WAAA;EACA,yBtB7CW;EsB8CX,qBtB9CW;ALs+Ff;A2Bt7FI;EAKI,gDAAA;A3Bo7FR;;A0B78FE;ECPA,ctBrBa;EsBsBb,qBtBtBa;AL8+Ff;AS7gGE;EkBwDE,WALgD;EAMhD,yBtB1BW;EsB2BX,qBtB3BW;ALm/Ff;A2Br9FE;EAEE,+CAAA;A3Bs9FJ;A2Bn9FE;EAEE,ctBrCW;EsBsCX,6BAAA;A3Bo9FJ;A2Bj9FE;EAGE,WAAA;EACA,yBtB7CW;EsB8CX,qBtB9CW;AL+/Ff;A2B/8FI;EAKI,+CAAA;A3B68FR;;A0Bt+FE;ECPA,ctBrBa;EsBsBb,qBtBtBa;ALugGf;AStiGE;EkBwDE,WALgD;EAMhD,yBtB1BW;EsB2BX,qBtB3BW;AL4gGf;A2B9+FE;EAEE,gDAAA;A3B++FJ;A2B5+FE;EAEE,ctBrCW;EsBsCX,6BAAA;A3B6+FJ;A2B1+FE;EAGE,WAAA;EACA,yBtB7CW;EsB8CX,qBtB9CW;ALwhGf;A2Bx+FI;EAKI,gDAAA;A3Bs+FR;;A0B//FE;ECPA,ctBrBa;EsBsBb,qBtBtBa;ALgiGf;AS/jGE;EkBwDE,WALgD;EAMhD,yBtB1BW;EsB2BX,qBtB3BW;ALqiGf;A2BvgGE;EAEE,+CAAA;A3BwgGJ;A2BrgGE;EAEE,ctBrCW;EsBsCX,6BAAA;A3BsgGJ;A2BngGE;EAGE,WAAA;EACA,yBtB7CW;EsB8CX,qBtB9CW;ALijGf;A2BjgGI;EAKI,+CAAA;A3B+/FR;;A0BxhGE;ECPA,ctBrBa;EsBsBb,qBtBtBa;ALyjGf;ASxlGE;EkBwDE,WALgD;EAMhD,yBtB1BW;EsB2BX,qBtB3BW;AL8jGf;A2BhiGE;EAEE,8CAAA;A3BiiGJ;A2B9hGE;EAEE,ctBrCW;EsBsCX,6BAAA;A3B+hGJ;A2B5hGE;EAGE,WAAA;EACA,yBtB7CW;EsB8CX,qBtB9CW;AL0kGf;A2B1hGI;EAKI,8CAAA;A3BwhGR;;A0BjjGE;ECPA,ctBrBa;EsBsBb,qBtBtBa;ALklGf;ASjnGE;EkBwDE,WALgD;EAMhD,yBtB1BW;EsB2BX,qBtB3BW;ALulGf;A2BzjGE;EAEE,iDAAA;A3B0jGJ;A2BvjGE;EAEE,ctBrCW;EsBsCX,6BAAA;A3BwjGJ;A2BrjGE;EAGE,WAAA;EACA,yBtB7CW;EsB8CX,qBtB9CW;ALmmGf;A2BnjGI;EAKI,iDAAA;A3BijGR;;A0B1kGE;ECPA,ctBrBa;EsBsBb,qBtBtBa;AL2mGf;AS1oGE;EkBwDE,cALgD;EAMhD,yBtB1BW;EsB2BX,qBtB3BW;ALgnGf;A2BllGE;EAEE,iDAAA;A3BmlGJ;A2BhlGE;EAEE,ctBrCW;EsBsCX,6BAAA;A3BilGJ;A2B9kGE;EAGE,cAAA;EACA,yBtB7CW;EsB8CX,qBtB9CW;AL4nGf;A2B5kGI;EAKI,iDAAA;A3B0kGR;;A0BnmGE;ECPA,ctBrBa;EsBsBb,qBtBtBa;ALooGf;ASnqGE;EkBwDE,cALgD;EAMhD,yBtB1BW;EsB2BX,qBtB3BW;ALyoGf;A2B3mGE;EAEE,iDAAA;A3B4mGJ;A2BzmGE;EAEE,ctBrCW;EsBsCX,6BAAA;A3B0mGJ;A2BvmGE;EAGE,cAAA;EACA,yBtB7CW;EsB8CX,qBtB9CW;ALqpGf;A2BrmGI;EAKI,iDAAA;A3BmmGR;;A0BjnGA;EACE,gBnB4FW;EmB3FX,cnB1BkB;EmB2BlB,qBrBZwC;ALgoG1C;AS7rGE;EiB4EE,cnBlBkB;EmBmBlB,0BrBfsC;ALmoG1C;A0BjnGE;EAEE,0BrBpBsC;ALsoG1C;A0B/mGE;EAEE,cnB7EM;EmB8EN,oBAAA;A1BgnGJ;;A0BrmGA;ECPE,yBAAA;ErB4EI,oBAAA;EqB1EJ,oBpB8JyB;EOtPvB,kBAAA;AdysGJ;;A0BxmGA;ECXE,wBAAA;ErB4EI,kBAAA;EqB1EJ,oBpByJyB;EOjPvB,kBAAA;AdgtGJ;;A0BtmGA;EACE,cAAA;EACA,WAAA;A1BymGF;A0BtmGE;EACE,kBnB4M0B;AP45F9B;;A0BhmGE;;;EACE,WAAA;A1BqmGJ;;A4BhvGA;ELgBM,gCKfJ;A5BmvGF;AuBhuGM;EKpBN;ILqBQ,gBAAA;EvBmuGN;AACF;A4BtvGE;EACE,UAAA;A5BwvGJ;;A4BnvGE;EACE,aAAA;A5BsvGJ;;A4BlvGA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;ELDI,6BKEJ;A5BqvGF;AuBnvGM;EKNN;ILOQ,gBAAA;EvBsvGN;AACF;A4BxvGE;EACE,QAAA;EACA,YAAA;ELNE,4BKOF;A5B0vGJ;AuB7vGM;EKAJ;ILCM,gBAAA;EvBgwGN;AACF;;A6BrxGA;;;;EAIE,kBAAA;A7BwxGF;;A6BrxGA;EACE,mBAAA;A7BwxGF;A8BpwGI;EACE,qBAAA;EACA,oBtB+NwB;EsB9NxB,uBtB6NwB;EsB5NxB,WAAA;EAhCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;A9BuyGF;A8BlvGI;EACE,cAAA;A9BovGN;;A6B9xGA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,arBypBkC;EqBxpBlC,aAAA;EACA,WAAA;EACA,gBAAA;EACA,gBtBqgBkC;EsBpgBlC,YAAA;EACA,oBAAA;EvB0JI,oBAAA;EuBxJJ,ctBiBY;EsBhBZ,gBAAA;EACA,sBtBrBO;EsBsBP,4BAAA;EACA,yBAAA;EfdE,kBAAA;AdgzGJ;;A6BzxGI;EACE,WAAA;EACA,OAAA;A7B4xGN;;A6BzxGI;EACE,QAAA;EACA,UAAA;A7B4xGN;;AkBhxGI;EWnBA;IACE,WAAA;IACA,OAAA;E7BuyGJ;E6BpyGE;IACE,QAAA;IACA,UAAA;E7BsyGJ;AACF;AkB3xGI;EWnBA;IACE,WAAA;IACA,OAAA;E7BizGJ;E6B9yGE;IACE,QAAA;IACA,UAAA;E7BgzGJ;AACF;AkBryGI;EWnBA;IACE,WAAA;IACA,OAAA;E7B2zGJ;E6BxzGE;IACE,QAAA;IACA,UAAA;E7B0zGJ;AACF;AkB/yGI;EWnBA;IACE,WAAA;IACA,OAAA;E7Bq0GJ;E6Bl0GE;IACE,QAAA;IACA,UAAA;E7Bo0GJ;AACF;AkBzzGI;EWnBA;IACE,WAAA;IACA,OAAA;E7B+0GJ;E6B50GE;IACE,QAAA;IACA,UAAA;E7B80GJ;AACF;AkBn0GI;EWnBA;IACE,WAAA;IACA,OAAA;E7By1GJ;E6Bt1GE;IACE,QAAA;IACA,UAAA;E7Bw1GJ;AACF;A6Bj1GE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,uBtBmegC;APg3FpC;A8Bl3GI;EACE,qBAAA;EACA,oBtB+NwB;EsB9NxB,uBtB6NwB;EsB5NxB,WAAA;EAzBJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;A9B84GF;A8Bh2GI;EACE,cAAA;A9Bk2GN;;A6Bv1GE;EACE,MAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;EACA,qBtBqdgC;APq4FpC;A8Bv4GI;EACE,qBAAA;EACA,oBtB+NwB;EsB9NxB,uBtB6NwB;EsB5NxB,WAAA;EAlBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;A9B45GF;A8Br3GI;EACE,cAAA;A9Bu3GN;A6Bl2GI;EACE,iBAAA;A7Bo2GN;;A6B91GE;EACE,MAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;EACA,sBtBocgC;AP65FpC;A8B/5GI;EACE,qBAAA;EACA,oBtB+NwB;EsB9NxB,uBtB6NwB;EsB5NxB,WAAA;A9Bi6GN;A8Bt5GM;EACE,aAAA;A9Bw5GR;A8Br5GM;EACE,qBAAA;EACA,qBtB4MsB;EsB3MtB,uBtB0MsB;EsBzMtB,WAAA;EA9BN,mCAAA;EACA,yBAAA;EACA,sCAAA;A9Bs7GF;A8Br5GI;EACE,cAAA;A9Bu5GN;A6Bj3GI;EACE,iBAAA;A7Bm3GN;;A6B32GE;EAIE,WAAA;EACA,YAAA;A7B22GJ;;A6Bt2GA;EE9GE,SAAA;EACA,cAAA;EACA,gBAAA;EACA,6BAAA;A/Bw9GF;;A6Bt2GA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;EACA,gBtBgDW;EsB/CX,ctBjFc;EsBkFd,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;A7Bw2GF;A6Bn2GI;Ef/GA,uCAAA;EACA,wCAAA;Adq9GJ;A6Bn2GI;EfrGA,2CAAA;EACA,0CAAA;Ad28GJ;ASr+GE;EoBoIE,ctBxFgB;EsByFhB,qBAAA;EJ/IA,yBlBMQ;AP8+GZ;A6Bj2GE;EAEE,ctB/FgB;EsBgGhB,qBAAA;EJtJA,yBlBQQ;APi/GZ;A6B/1GE;EAEE,ctBtJQ;EsBuJR,oBAAA;EACA,6BAAA;A7Bg2GJ;;A6Bx1GA;EACE,cAAA;A7B21GF;;A6Bv1GA;EACE,cAAA;EACA,erBimBkC;EqBhmBlC,gBAAA;EvBAI,kBAAA;EuBEJ,ctBtKU;EsBuKV,mBAAA;A7B01GF;;A6Bt1GA;EACE,cAAA;EACA,iBAAA;EACA,ctB/Ic;APw+GhB;;AgCphHA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AhCuhHF;AgCrhHE;;;EACE,kBAAA;EACA,cAAA;AhCyhHJ;ASxhHE;;;EuBII,UAAA;AhCyhHN;AgCvhHI;;;;;;;EAGE,UAAA;AhC6hHN;;AgCvhHA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AhC0hHF;AgCxhHE;EACE,WAAA;AhC0hHJ;;AgCphHE;;EAEE,iBAAA;AhCuhHJ;AgCnhHE;;;ElBXE,0BAAA;EACA,6BAAA;AdmiHJ;AgCphHE;;;ElBFE,yBAAA;EACA,4BAAA;Ad2hHJ;;AgCxgHA;EACE,yBAAA;EACA,wBAAA;AhC2gHF;AgCzgHE;EAGE,cAAA;AhCygHJ;AgCtgHE;EACE,eAAA;AhCwgHJ;;AgCpgHA;EACE,wBAAA;EACA,uBAAA;AhCugHF;;AgCpgHA;EACE,uBAAA;EACA,sBAAA;AhCugHF;;AgCn/GA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AhCs/GF;AgCp/GE;;EAEE,WAAA;AhCs/GJ;AgCn/GE;;EAEE,gBAAA;AhCq/GJ;AgCj/GE;;;ElBrFE,6BAAA;EACA,4BAAA;Ad2kHJ;AgCl/GE;;;ElBxGE,yBAAA;EACA,0BAAA;Ad+lHJ;;AgCp+GE;;;EAEE,gBAAA;AhCw+GJ;AgCt+GI;;;;;EAEE,kBAAA;EACA,sBAAA;EACA,oBAAA;AhC2+GN;;AiCpoHA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;AjCuoHF;AiCroHE;;;;;EAIE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;AjCwoHJ;AiCtoHI;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGE,iBAAA;AjCkrHN;AiC7qHE;;;;EAGE,UAAA;AjCgrHJ;AiC5qHE;EACE,UAAA;AjC8qHJ;AiCzqHI;;;EnBVA,0BAAA;EACA,6BAAA;AdwrHJ;AiC5qHI;;;EnBCA,yBAAA;EACA,4BAAA;AdgrHJ;AiC3qHE;EACE,aAAA;EACA,mBAAA;AjC6qHJ;AiC3qHI;EnBxBA,0BAAA;EACA,6BAAA;AdssHJ;AiC3qHI;EnBdA,yBAAA;EACA,4BAAA;Ad4rHJ;;AiClqHA;;EAEE,aAAA;AjCqqHF;AiChqHE;;;;EACE,kBAAA;EACA,UAAA;AjCqqHJ;AiCnqHI;;;;EACE,UAAA;AjCwqHN;AiCpqHE;;;;;;;;;;;;;;;;;;;;;;EAIE,iBAAA;AjCwrHJ;;AiCprHA;EACE,kBAAA;AjCurHF;;AiCrrHA;EACE,iBAAA;AjCwrHF;;AiC/qHA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;E3BgEI,oBAAA;E2B9DJ,gB1ByDW;E0BxDX,oB1BiIyB;E0BhIzB,c1BvGU;E0BwGV,kBAAA;EACA,mBAAA;EACA,yB1B/GU;E0BgHV,yBAAA;EnB1GE,kBAAA;Ad6xHJ;AiC/qHE;;EAEE,aAAA;AjCirHJ;;AiCvqHA;;;EAEE,4B1ByQsC;APk6GxC;;AiCxqHA;;;;;;;;;EAME,uBAAA;E3B6BI,oBAAA;E2B3BJ,oB1B+GyB;EOtPvB,kBAAA;AdszHJ;;AiC3qHA;;;EAEE,2B1BuPsC;APw7GxC;;AiC5qHA;;;;;;;;;EAME,qBAAA;E3BYI,kBAAA;E2BVJ,oB1ByFyB;EOjPvB,kBAAA;Ad20HJ;;AiC/qHA;;;EAEE,mBAAA;AjCmrHF;;AiCxqHA;;;;;;;;EnBzJI,0BAAA;EACA,6BAAA;Ad40HJ;;AiC3qHA;;;;;;;;EnBpJI,yBAAA;EACA,4BAAA;Ad00HJ;;AkCl3HA;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,sBAAA;EACA,qBAAA;AlCq3HF;;AkCl3HA;EACE,oBAAA;EACA,kB1B0fsC;AR23GxC;;AkCl3HA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,a3BylBsC;E2BxlBtC,mBAAA;EACA,UAAA;AlCq3HF;AkCn3HE;EACE,W3BtBK;E2BuBL,qB7B4B0B;EoBtD1B,yBpBsD0B;AL01H9B;AkCj3HE;EAKI,4C3BoNqB;AP2pH3B;AkC32HE;EACE,qB3BagB;APg2HpB;AkC12HE;EACE,W3B1CK;E2B2CL,yB7BQ0B;E6BP1B,qB7BO0B;ALq2H9B;AkCr2HI;EACE,c1BhDK;ARu5HX;AkCr2HM;EACE,yB3B1CE;APi5HV;;AkC71HA;EACE,kBAAA;EACA,gBAAA;EAEA,mBAAA;AlC+1HF;AkC71HE;EACE,UAAA;AlC+1HJ;AkC51HE;EACE,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,a3B0hBoC;E2BzhBpC,c3ByhBoC;E2BxhBpC,oBAAA;EACA,WAAA;EACA,sB3BpFK;E2BqFL,yBAAA;AlC81HJ;AkCz1HE;EACE,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,a3B2gBoC;E2B1gBpC,c3B0gBoC;E2BzgBpC,WAAA;EACA,iCAAA;AlC21HJ;;AkCj1HE;EpBnGE,kBAAA;Adw7HJ;AkCh1HI;EACE,0DAAA;AlCk1HN;AkC70HI;EACE,qB1ByHwB;EiBpP1B,yBjBoP0B;ARutH9B;AkC50HI;EACE,0DAAA;AlC80HN;AkCz0HI;ETrIA,wCpByUgD;ALwoHpD;AkCz0HI;ETxIA,wCpByUgD;AL2oHpD;;AkCj0HE;EAEE,kB1ByZ4C;AR06GhD;AkC/zHI;EACE,0DAAA;AlCi0HN;AkC5zHI;ET/JA,wCpByUgD;ALqpHpD;;AkCpzHA;EACE,qBAAA;AlCuzHF;AkCrzHI;EACE,cAAA;EACA,W3B+ckC;E2B9clC,mBAAA;EAEA,qB3BgdkC;APs2GxC;AkCnzHI;EACE,6BAAA;EACA,0BAAA;EACA,W3B8ckC;E2B7clC,Y3B6ckC;E2B5clC,yB3BlLM;E2BoLN,qB3BsckC;EgBxnBlC,yIWmLA;AlCozHN;AuBn+HM;EWuKF;IXtKI,gBAAA;EvBs+HN;AACF;AkCpzHI;EACE,sB3BhMG;E2BiMH,6BAAA;AlCszHN;AkCjzHI;ETzMA,wCpByUgD;ALorHpD;;AkCvyHA;EACE,qBAAA;EACA,WAAA;EACA,4B3BsLsC;E2BrLtC,sCAAA;E5B5CI,oBAAA;E4B+CJ,gB3BpDW;E2BqDX,oB3BoByB;E2BnBzB,c3BpNU;E2BqNV,sBAAA;EACA,8FAAA;EACA,yBAAA;EpBtNE,kBAAA;EoByNF,gBAAA;AlCwyHF;AkCtyHE;EACE,qB3BlLgB;E2BmLhB,UAAA;EAKE,iD1BmW8B;ARi8GpC;AkCjyHI;EAME,c3B5OM;E2B6ON,sB3BrPG;APmhIT;AkC1xHE;EAEE,YAAA;EACA,mB3BhBuB;E2BiBvB,sBAAA;AlC2xHJ;AkCxxHE;EACE,c1B7PO;E0B8PP,yB1BlQO;AR4hIX;AkCtxHE;EACE,aAAA;AlCwxHJ;AkCpxHE;EACE,kBAAA;EACA,0BAAA;AlCsxHJ;;AkClxHA;EACE,2B3B2HsC;E2B1HtC,oB3B5ByB;E2B6BzB,uB3B7ByB;E2B8BzB,kB3B7ByB;ED7ErB,kBAAA;ANg4HN;;AkClxHA;EACE,4B3BoHsC;E2BnHtC,sB3B/ByB;E2BgCzB,yB3BhCyB;E2BiCzB,kB3BhCyB;EDlFrB,oBAAA;ANw4HN;;AkC7wHA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,4B3BkGsC;E2BjGtC,gBAAA;AlCgxHF;;AkC7wHA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,4B3B0FsC;E2BzFtC,SAAA;EACA,UAAA;AlCgxHF;AkC9wHE;EACE,qB3BpQgB;E2BqQhB,4C3BnEuB;APm1H3B;AkC5wHE;EAEE,yB3BjTM;AP8jIV;AkCzwHI;EACE,iB1B4Ta;AR+8GnB;AkCvwHE;EACE,0BAAA;AlCywHJ;;AkCrwHA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,4B3B0DsC;E2BzDtC,uBAAA;EAEA,gB3B/KW;E2BgLX,oB3BvGyB;E2BwGzB,c3B/UU;E2BgVV,sB3BxVO;E2ByVP,yBAAA;EpBhVE,kBAAA;AdwlIJ;AkCpwHE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,gB3BiCoC;E2BhCpC,uBAAA;EACA,oB3BvHuB;E2BwHvB,c3B/VQ;E2BgWR,iBAAA;ET3WA,yBlBMQ;E2BuWR,oBAAA;EpBjWA,0BAAA;AdwmIJ;;AkC5vHA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,6BAAA;EACA,gBAAA;AlC+vHF;AkC7vHE;EACE,aAAA;AlC+vHJ;AkC3vHI;EAA0B,+D1BsOe;ARwhH7C;AkC7vHI;EAA0B,+D1BqOe;AR2hH7C;AkC/vHI;EAA0B,+D1BoOe;AR8hH7C;AkC/vHE;EACE,SAAA;AlCiwHJ;AkC9vHE;EACE,W1BsNyC;E0BrNzC,Y1BqNyC;E0BpNzC,oBAAA;EThZA,yBjBoP0B;E0B8J1B,S1BqNyC;EM3lBzC,mBAAA;ESFE,oHW2YF;EX3YE,4GW2YF;EACA,gBAAA;AlC+vHJ;AuBvoIM;EW+XJ;IX9XM,wBAAA;IAAA,gBAAA;EvB0oIN;AACF;AkClwHI;ETxZA,uBjB4mByC;ARijH7C;AkChwHE;EACE,W1B+LgC;E0B9LhC,c1B+LgC;E0B9LhC,kBAAA;EACA,e1B8LgC;E0B7LhC,yB1B9ZO;E0B+ZP,yBAAA;EpBvZA,mBAAA;Ad0pIJ;AkC9vHE;EACE,W1B2LyC;E0B1LzC,Y1B0LyC;EiBpmBzC,yBjBoP0B;E0BwL1B,S1B2LyC;EM3lBzC,mBAAA;ESFE,iHWqaF;EXraE,4GWqaF;EACA,gBAAA;AlC+vHJ;AuBjqIM;EW0ZJ;IXzZM,qBAAA;IAAA,gBAAA;EvBoqIN;AACF;AkClwHI;ETlbA,uBjB4mByC;AR2kH7C;AkChwHE;EACE,W1BqKgC;E0BpKhC,c1BqKgC;E0BpKhC,kBAAA;EACA,e1BoKgC;E0BnKhC,yB1BxbO;E0BybP,yBAAA;EpBjbA,mBAAA;AdorIJ;AkC9vHE;EACE,W1BiKyC;E0BhKzC,Y1BgKyC;E0B/JzC,aAAA;EACA,oB3BjNuB;E2BkNvB,mB3BlNuB;EkBrPvB,yBjBoP0B;E0BqN1B,S1B8JyC;EM3lBzC,mBAAA;ESFE,gHWkcF;EXlcE,4GWkcF;EACA,gBAAA;AlC+vHJ;AuB9rIM;EWobJ;IXnbM,oBAAA;IAAA,gBAAA;EvBisIN;AACF;AkClwHI;ET/cA,uBjB4mByC;ARwmH7C;AkChwHE;EACE,W1BwIgC;E0BvIhC,c1BwIgC;E0BvIhC,kBAAA;EACA,e1BuIgC;E0BtIhC,6BAAA;EACA,yBAAA;EACA,oBAAA;AlCkwHJ;AkC9vHE;EACE,yB1B5dO;EMQP,mBAAA;AdqtIJ;AkC7vHE;EACE,kBAAA;EACA,yB1BleO;EMQP,mBAAA;Ad0tIJ;AkC3vHI;EACE,yB1BteK;ARmuIX;AkC1vHI;EACE,eAAA;AlC4vHN;AkCzvHI;EACE,yB1B9eK;ARyuIX;AkCxvHI;EACE,eAAA;AlC0vHN;AkCvvHI;EACE,yB1BtfK;AR+uIX;;AkCpvHA;;;;EXvfM,4GW0fJ;AlCwvHF;AuB9uIM;EWmfN;;;;IXlfQ,gBAAA;EvBovIN;AACF;;AkC3vHE;EACE,eAAA;AlC8vHJ;AkC3vHI;EACE,kB3B3gBG;APwwIT;AkC3vHI;EACE,YAAA;AlC6vHN;AkC1vHE;EACE,cAAA;EACA,kB3BnZa;E2BoZb,gBAAA;EACA,yB3B1gBQ;APswIZ;AkC3vHI;EACE,6BAAA;AlC6vHN;AkC3vHI;EACE,UAAA;AlC6vHN;AkC3vHI;EACE,iBAAA;EACA,SAAA;EACA,UAAA;AlC6vHN;AkC3vHI;EACE,SAAA;EACA,UAAA;AlC6vHN;AkCxvHM;EACE,YAAA;AlC0vHR;;AkCnvHA;EACE,eAAA;EACA,kBAAA;AlCsvHF;AkCpvHI;EACE,UAAA;AlCsvHN;AkCpvHI;EACE,UAAA;AlCsvHN;AkCpvHI;EACE,0BAAA;EACA,iBAAA;AlCsvHN;AkCnvHM;EACE,qB7B7gBsB;E6B+gBtB,UAAA;AlCovHR;AkClvHM;EACE,qB7BlhBsB;ALswI9B;AkC7uHQ;EACE,c1BzkBC;ARwzIX;AkCzuHI;EACE,aAAA;AlC2uHN;AkCzuHI;EACE,WAAA;AlC2uHN;AkCxuHE;EACE,yBAAA;EACA,4CAAA;EACA,e3B5cS;E2B6cT,oB3B/WuB;E2BgXvB,kB3B/da;EgBzHX,qIWylBF;EACA,oBAAA;EACA,mBAAA;EACA,sB3BnmBK;AP60IT;AuBl0IM;EW+kBJ;IX9kBM,gBAAA;EvBq0IN;AACF;AkC9uHI;EACE,QAAA;EACA,2BAAA;EACA,c3BvUwB;APujI9B;AkC5uHI;EACI,gBAAA;EACA,oBAAA;AlC8uHR;AkC7uHQ;EACE,gBAAA;AlC+uHV;AkC5uHI;EAEI,mBAAA;AlC6uHR;AkC5uHQ;EACI,WAAA;AlC8uHZ;AkC3uHI;EACE,iBAAA;AlC6uHN;AkC1uHE;EACE,eAAA;AlC4uHJ;AkC3uHI;EACE,0CAAA;EACA,e3BhfO;E2BifP,oB3BnZqB;E2BoZrB,kB3BngBW;APgvIjB;AkC5uHM;EACE,QAAA;EACA,2BAAA;EACA,c3BvWsB;APqlI9B;AkCxuHM;EACE,eAAA;EACA,gBAAA;AlC0uHR;AkCzuHQ;EACE,kBAAA;EACA,eAAA;AlC2uHV;;AkCpuHE;EACE,uBAAA;AlCuuHJ;AkCruHM;EACE,UAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,kCAAA;EACA,qBAAA;AlCuuHR;AkCruHM;EACE,aAAA;AlCuuHR;AkCluHQ;EACE,UAAA;AlCouHV;;AkC9tHA;EACE,eAAA;AlCiuHF;AkC/tHI;EACE,aAAA;AlCiuHN;;AkC3tHA;EACE,mBAAA;EACA,sBAAA;AlC8tHF;;AkCztHE;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AlC4tHJ;AkC3tHI;EACE,iBAAA;AlC6tHN;AkC1tHE;EACE,SAAA;AlC4tHJ;AkC3tHI;EACE,UAAA;EACA,YAAA;AlC6tHN;AkCztHQ;EACE,yBAAA;EACA,4BAAA;AlC2tHV;AkCztHQ;EACE,0BAAA;EACA,6BAAA;AlC2tHV;AkCttHE;EACE,sBAAA;EACA,kBAAA;AlCwtHJ;AkCvtHI;EACE,WAAA;AlCytHN;AkCvtHI;EACE,aAAA;AlCytHN;AkCxtHM;EACE,WAAA;AlC0tHR;AkCrtHQ;EACE,yBAAA;EACA,0BAAA;AlCutHV;AkCrtHQ;EACE,4BAAA;EACA,6BAAA;AlCutHV;;AmCj9IA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AnCo9IF;;AmCj9IA;EACE,cAAA;EACA,oBAAA;AnCo9IF;ASn9IE;E0BGE,qBAAA;AnCm9IJ;AmC/8IE;EACE,c3BXO;E2BYP,oBAAA;EACA,eAAA;AnCi9IJ;;AmCz8IA;EACE,gCAAA;AnC48IF;AmC18IE;EACE,mBAAA;EACA,6BAAA;EACA,6BAAA;ErBbA,2BAAA;EACA,4BAAA;Ad09IJ;ASt+IE;E0B6BI,kBAAA;EACA,qC3BipB8B;AR2zHpC;AmCz8II;EACE,c3BrCK;E2BsCL,6BAAA;EACA,yBAAA;AnC28IN;AmCv8IE;;EAEE,c3B5CO;E2B6CP,yB5BrCM;E4BsCN,qC3BsoBgC;ARm0HpC;AmCt8IE;EAEE,gBAAA;ErBtCA,yBAAA;EACA,0BAAA;Ad8+IJ;;AmC77IE;EACE,gBAAA;EACA,SAAA;ErB7DA,kBAAA;Ad8/IJ;AmC77IE;;EAEE,W5B5EK;E4B6EL,yB3BoK0B;AR2xI9B;;AmCr7IE;;EAEE,cAAA;EACA,kBAAA;AnCw7IJ;;AmCn7IE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AnCs7IJ;;AmC56IE;EACE,aAAA;AnC+6IJ;AmC76IE;EACE,cAAA;AnC+6IJ;;AoCxhJA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;ApC2hJF;AoCvhJE;;;;;;;;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;ApCgiJJ;AoC5gJA;EACE,qBAAA;EACA,sB5BkqBkC;E4BjqBlC,yB5BiqBkC;E4BhqBlC,kB7B6EU;EDgDN,kBAAA;E8BtHJ,oBAAA;EACA,mBAAA;ApCygJF;ASxjJE;E2BkDE,qBAAA;ApCygJJ;;AoChgJA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ApCmgJF;AoCjgJE;EACE,gBAAA;EACA,eAAA;ApCmgJJ;AoChgJE;EACE,gBAAA;EACA,WAAA;ApCkgJJ;;AoCz/IA;EACE,qBAAA;EACA,mB5BolBkC;E4BnlBlC,sB5BmlBkC;ARy6HpC;;AoCh/IA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;ApCi/IF;;AoC7+IA;EACE,wBAAA;E9ByDI,kBAAA;E8BvDJ,cAAA;EACA,6BAAA;EACA,6BAAA;EtB7GE,kBAAA;Ad8lJJ;AShmJE;E2BmHE,qBAAA;ApCg/IJ;;AoC1+IA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mCAAA;EACA,0BAAA;ApC6+IF;;AkBpjJI;EkBmFI;;;;;;;;IACE,gBAAA;IACA,eAAA;EpC4+IR;AACF;AkB/kJI;EkB8FA;IAoBI,qBAAA;IACA,2BAAA;EpCi+IN;EoC/9IM;IACE,mBAAA;EpCi+IR;EoC/9IQ;IACE,kBAAA;EpCi+IV;EoC99IQ;IACE,qB5BwhBwB;I4BvhBxB,oB5BuhBwB;ERy8HlC;EoC39IM;;;;;;;;IACE,iBAAA;EpCo+IR;EoCt9IM;IACE,wBAAA;IAGA,gBAAA;EpCs9IR;EoCn9IM;IACE,aAAA;EpCq9IR;AACF;AkBnmJI;EkBmFI;;;;;;;;IACE,gBAAA;IACA,eAAA;EpC0hJR;AACF;AkB7nJI;EkB8FA;IAoBI,qBAAA;IACA,2BAAA;EpC+gJN;EoC7gJM;IACE,mBAAA;EpC+gJR;EoC7gJQ;IACE,kBAAA;EpC+gJV;EoC5gJQ;IACE,qB5BwhBwB;I4BvhBxB,oB5BuhBwB;ERu/HlC;EoCzgJM;;;;;;;;IACE,iBAAA;EpCkhJR;EoCpgJM;IACE,wBAAA;IAGA,gBAAA;EpCogJR;EoCjgJM;IACE,aAAA;EpCmgJR;AACF;AkBjpJI;EkBmFI;;;;;;;;IACE,gBAAA;IACA,eAAA;EpCwkJR;AACF;AkB3qJI;EkB8FA;IAoBI,qBAAA;IACA,2BAAA;EpC6jJN;EoC3jJM;IACE,mBAAA;EpC6jJR;EoC3jJQ;IACE,kBAAA;EpC6jJV;EoC1jJQ;IACE,qB5BwhBwB;I4BvhBxB,oB5BuhBwB;ERqiIlC;EoCvjJM;;;;;;;;IACE,iBAAA;EpCgkJR;EoCljJM;IACE,wBAAA;IAGA,gBAAA;EpCkjJR;EoC/iJM;IACE,aAAA;EpCijJR;AACF;AkB/rJI;EkBmFI;;;;;;;;IACE,gBAAA;IACA,eAAA;EpCsnJR;AACF;AkBztJI;EkB8FA;IAoBI,qBAAA;IACA,2BAAA;EpC2mJN;EoCzmJM;IACE,mBAAA;EpC2mJR;EoCzmJQ;IACE,kBAAA;EpC2mJV;EoCxmJQ;IACE,qB5BwhBwB;I4BvhBxB,oB5BuhBwB;ERmlIlC;EoCrmJM;;;;;;;;IACE,iBAAA;EpC8mJR;EoChmJM;IACE,wBAAA;IAGA,gBAAA;EpCgmJR;EoC7lJM;IACE,aAAA;EpC+lJR;AACF;AkB7uJI;EkBmFI;;;;;;;;IACE,gBAAA;IACA,eAAA;EpCoqJR;AACF;AkBvwJI;EkB8FA;IAoBI,qBAAA;IACA,2BAAA;EpCypJN;EoCvpJM;IACE,mBAAA;EpCypJR;EoCvpJQ;IACE,kBAAA;EpCypJV;EoCtpJQ;IACE,qB5BwhBwB;I4BvhBxB,oB5BuhBwB;ERioIlC;EoCnpJM;;;;;;;;IACE,iBAAA;EpC4pJR;EoC9oJM;IACE,wBAAA;IAGA,gBAAA;EpC8oJR;EoC3oJM;IACE,aAAA;EpC6oJR;AACF;AkB3xJI;EkBmFI;;;;;;;;IACE,gBAAA;IACA,eAAA;EpCktJR;AACF;AkBrzJI;EkB8FA;IAoBI,qBAAA;IACA,2BAAA;EpCusJN;EoCrsJM;IACE,mBAAA;EpCusJR;EoCrsJQ;IACE,kBAAA;EpCusJV;EoCpsJQ;IACE,qB5BwhBwB;I4BvhBxB,oB5BuhBwB;ER+qIlC;EoCjsJM;;;;;;;;IACE,iBAAA;EpC0sJR;EoC5rJM;IACE,wBAAA;IAGA,gBAAA;EpC4rJR;EoCzrJM;IACE,aAAA;EpC2rJR;AACF;AoCxvJI;EAoBI,qBAAA;EACA,2BAAA;ApCuuJR;AoC1vJQ;;;;;;;;EACE,gBAAA;EACA,eAAA;ApCmwJV;AoChvJQ;EACE,mBAAA;ApCkvJV;AoChvJU;EACE,kBAAA;ApCkvJZ;AoC/uJU;EACE,qB5BwhBwB;E4BvhBxB,oB5BuhBwB;AR0tIpC;AoC5uJQ;;;;;;;;EACE,iBAAA;ApCqvJV;AoCvuJQ;EACE,wBAAA;EAGA,gBAAA;ApCuuJV;AoCpuJQ;EACE,aAAA;ApCsuJV;;AoCxtJE;EACE,yB5BogBgC;ARutIpC;ASh7JE;E2BwNI,yB5BigB8B;AR0tIpC;AoCttJI;EACE,yB5Byf8B;AR+tIpC;ASt7JE;E2BiOM,yB5Buf4B;ARiuIpC;AoCrtJM;EACE,yB5Bqf4B;ARkuIpC;AoCntJI;;;;EAIE,yB5B4e8B;ARyuIpC;AoCjtJE;EACE,yB5BqegC;E4BpehC,gC5ByegC;AR0uIpC;AoChtJE;EACE,0DAAA;ApCktJJ;AoC/sJE;EACE,yB5B4dgC;ARqvIpC;AoChtJI;EACE,yB5B4d8B;ARsvIpC;AS/8JE;E2BgQM,yB5Byd4B;ARyvIpC;;AoC1sJE;EACE,W7BhRK;AP69JT;ASt9JE;E2B4QI,W7BnRG;APg+JT;AoCxsJI;EACE,+B5B8b8B;AR4wIpC;AS59JE;E2BqRM,gC5B4b4B;AR8wIpC;AoCvsJM;EACE,gC5B0b4B;AR+wIpC;AoCrsJI;;;;EAIE,W7BxSG;AP++JT;AoCnsJE;EACE,+B5B0agC;E4BzahC,sC5B8agC;ARuxIpC;AoClsJE;EACE,0DAAA;ApCosJJ;AoCjsJE;EACE,+B5BiagC;ARkyIpC;AoClsJI;EACE,W7BxTG;AP4/JT;ASr/JE;E2BoTM,W7B3TC;AP+/JT;;AqCngKA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EAEA,qBAAA;EACA,sB9BHO;E8BIP,2BAAA;EACA,oCAAA;EvBIE,kBAAA;AdkgKJ;AqCngKE;EACE,eAAA;EACA,cAAA;ArCqgKJ;AqClgKE;EACE,mBAAA;EACA,sBAAA;ArCogKJ;AqClgKI;EACE,mBAAA;EvBAF,2BAAA;EACA,4BAAA;AdqgKJ;AqClgKI;EACE,sBAAA;EvBSF,+BAAA;EACA,8BAAA;Ad4/JJ;AqC//JE;;EAEE,aAAA;ArCigKJ;;AqC7/JA;EAGE,cAAA;EAGA,eAAA;EACA,gB9BkXkC;AP0oJpC;;AqCx/JA;EACE,sB9B4WkC;AP+oJpC;;AqCx/JA;EACE,qBAAA;EACA,gBAAA;ArC2/JF;;AqCx/JA;EACE,gBAAA;ArC2/JF;;ASjjKE;E4B2DE,qBAAA;ArC0/JJ;AqCv/JE;EACE,oB9B2VgC;AP8pJpC;;AqCj/JA;EACE,wBAAA;EACA,gBAAA;EAEA,qC9BuVkC;E8BtVlC,2CAAA;ArCm/JF;AqCj/JE;EvBxEE,0BAAA;Ad4jKJ;;AqC/+JA;EACE,wBAAA;EAEA,qC9B4UkC;E8B3UlC,wCAAA;ArCi/JF;AqC/+JE;EvBnFE,0BAAA;AdqkKJ;;AqCx+JA;EACE,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;ArC2+JF;;AqCx+JA;EACE,uBAAA;EACA,sBAAA;ArC2+JF;;AqCv+JA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,gB9BiTkC;EOjahC,kBAAA;Ad2lKJ;;AqCv+JA;;;EAGE,cAAA;EACA,WAAA;ArC0+JF;;AqCv+JA;;EvBlHI,2BAAA;EACA,4BAAA;Ad8lKJ;;AqCx+JA;;EvBzGI,+BAAA;EACA,8BAAA;AdslKJ;;AqCr+JE;EACE,mB9ByRgC;AP+sJpC;AkBxkKI;EmB8FJ;IAMI,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,kBAAA;ErCw+JF;EqCt+JE;IAEE,SAAA;IACA,kB9B6Q8B;I8B5Q9B,gBAAA;IACA,iB9B2Q8B;EP4tJlC;AACF;;AqC39JE;EACE,mB9B6PgC;APiuJpC;AkB1lKI;EmBwHJ;IAQI,aAAA;IACA,mBAAA;ErC89JF;EqC39JE;IAEE,SAAA;IACA,gBAAA;ErC49JJ;EqC19JI;IACE,cAAA;IACA,cAAA;ErC49JN;EqCv9JM;IvB1KJ,0BAAA;IACA,6BAAA;EdooKF;EqCz9JQ;;IAGE,0BAAA;ErC09JV;EqCx9JQ;;IAGE,6BAAA;ErCy9JV;EqCr9JM;IvB1KJ,yBAAA;IACA,4BAAA;EdkoKF;EqCv9JQ;;IAGE,yBAAA;ErCw9JV;EqCt9JQ;;IAGE,4BAAA;ErCu9JV;AACF;;AqC18JE;EACE,sB9BkLgC;AP2xJpC;AkBpoKI;EmBqLJ;IAMI,e9BiMgC;I8BhMhC,mB9BiMgC;I8BhMhC,UAAA;IACA,SAAA;ErC68JF;EqC38JE;IACE,qBAAA;IACA,WAAA;ErC68JJ;AACF;;AqCp8JA;EACE,qBAAA;ArCu8JF;AqCr8JE;EACE,gBAAA;ArCu8JJ;AqCr8JI;EACE,gBAAA;EvBtOF,6BAAA;EACA,4BAAA;Ad8qKJ;AqCr8JI;EvBxPA,yBAAA;EACA,0BAAA;AdgsKJ;AqCr8JI;EvBrQA,gBAAA;EuBuQE,gBAAA;ArCu8JN;;AsChuKA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,gB/BogBkC;EDpV9B,oBAAA;EgC9KJ,gBAAA;EACA,6B/BmgBkC;EOxfhC,kBAAA;AdytKJ;;AsChuKA;EACE,aAAA;AtCmuKF;AsChuKE;EACE,oB/BsfgC;AP4uJpC;AsCjuKI;EACE,qBAAA;EACA,qB/Bmf8B;E+Blf9B,c/BJM;E+BKN,YAAA;AtCmuKN;AsCztKE;EACE,0BAAA;AtC2tKJ;AsCxtKE;EACE,qBAAA;AtC0tKJ;AsCvtKE;EACE,c/BzBQ;APkvKZ;;AuCjwKA;EACE,aAAA;E5BGA,eAAA;EACA,gBAAA;EGaE,kBAAA;AdsvKJ;;AuClwKA;EACE,kBAAA;EACA,cAAA;EACA,2BAAA;EACA,iBAAA;EACA,iBhCmkBkC;EgClkBlC,chCiCY;EgC/BZ,sBhCLO;EgCMP,yBAAA;AvCowKF;AuClwKE;EACE,UAAA;EACA,chCmDkB;EgClDlB,qBAAA;EACA,yBhCTQ;EgCUR,qBhCTQ;AP6wKZ;AuCjwKE;EACE,UAAA;EACA,UhC8jBgC;EgC7jBhC,gBhC4jBgC;APusJpC;;AuC7vKI;EACE,cAAA;EzBaF,2BAAA;EACA,8BAAA;AdovKJ;AuC7vKI;EzBNA,4BAAA;EACA,+BAAA;AdswKJ;AuC5vKE;EACE,UAAA;EACA,WhCtCK;EgCuCL,yBhCYgB;EgCXhB,qBhCWgB;APmvKpB;AuC3vKE;EACE,chCvCQ;EgCwCR,oBAAA;EACA,YAAA;EACA,sBhC/CK;EgCgDL,qBhC5CQ;APyyKZ;;AwCnzKE;EACE,0BAAA;ElCgLE,kBAAA;EkC9KF,gBjCqKQ;APipKZ;AwCjzKM;E1BqCF,2BAAA;EACA,8BAAA;Ad+wKJ;AwChzKM;E1BkBF,4BAAA;EACA,+BAAA;AdiyKJ;;AwCj0KE;EACE,yBAAA;ElCgLE,kBAAA;EkC9KF,gBjCsKQ;AP8pKZ;AwC/zKM;E1BqCF,2BAAA;EACA,8BAAA;Ad6xKJ;AwC9zKM;E1BkBF,4BAAA;EACA,+BAAA;Ad+yKJ;;AyC70KA;EACE,qBAAA;EACA,mBAAA;EnC6KI,mBAAA;EmC3KJ,gBlCuKW;EkCtKX,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;E3BKE,kBAAA;ESFE,qIkBDJ;AzCg1KF;AuB30KM;EkBfN;IlBgBQ,gBAAA;EvB80KN;AACF;ASp1KE;EgCGI,qBAAA;AzCo1KN;;AyC/0KE;EACE,aAAA;AzCk1KJ;;AyC70KA;EACE,kBAAA;EACA,SAAA;AzCg1KF;;AyCz0KA;EACE,qBlCybkC;EkCxblC,oBlCwbkC;EO/chC,oBAAA;Ado2KJ;;AyCp0KE;ECjDA,WAAA;EACA,yBrCyCa;ALg1Kf;AS32KE;EiCVI,WAAA;EACA,yBAAA;A1Cw3KN;A0Cr3KI;EAEE,UAAA;EACA,+CAAA;A1Cs3KN;;AyCj1KE;ECjDA,WAAA;EACA,yBrCyCa;AL61Kf;ASx3KE;EiCVI,WAAA;EACA,yBAAA;A1Cq4KN;A0Cl4KI;EAEE,UAAA;EACA,8CAAA;A1Cm4KN;;AyC91KE;ECjDA,WAAA;EACA,yBrCyCa;AL02Kf;ASr4KE;EiCVI,WAAA;EACA,yBAAA;A1Ck5KN;A0C/4KI;EAEE,UAAA;EACA,gDAAA;A1Cg5KN;;AyC32KE;ECjDA,WAAA;EACA,yBrCyCa;ALu3Kf;ASl5KE;EiCVI,WAAA;EACA,yBAAA;A1C+5KN;A0C55KI;EAEE,UAAA;EACA,+CAAA;A1C65KN;;AyCx3KE;ECjDA,WAAA;EACA,yBrCyCa;ALo4Kf;AS/5KE;EiCVI,WAAA;EACA,yBAAA;A1C46KN;A0Cz6KI;EAEE,UAAA;EACA,gDAAA;A1C06KN;;AyCr4KE;ECjDA,WAAA;EACA,yBrCyCa;ALi5Kf;AS56KE;EiCVI,WAAA;EACA,yBAAA;A1Cy7KN;A0Ct7KI;EAEE,UAAA;EACA,+CAAA;A1Cu7KN;;AyCl5KE;ECjDA,WAAA;EACA,yBrCyCa;AL85Kf;ASz7KE;EiCVI,WAAA;EACA,yBAAA;A1Cs8KN;A0Cn8KI;EAEE,UAAA;EACA,8CAAA;A1Co8KN;;AyC/5KE;ECjDA,WAAA;EACA,yBrCyCa;AL26Kf;ASt8KE;EiCVI,WAAA;EACA,yBAAA;A1Cm9KN;A0Ch9KI;EAEE,UAAA;EACA,iDAAA;A1Ci9KN;;AyC56KE;ECjDA,cAAA;EACA,yBrCyCa;ALw7Kf;ASn9KE;EiCVI,cAAA;EACA,yBAAA;A1Cg+KN;A0C79KI;EAEE,UAAA;EACA,iDAAA;A1C89KN;;AyCz7KE;ECjDA,cAAA;EACA,yBrCyCa;ALq8Kf;ASh+KE;EiCVI,cAAA;EACA,yBAAA;A1C6+KN;A0C1+KI;EAEE,UAAA;EACA,iDAAA;A1C2+KN;;A2Cx/KA;EACE,kBAAA;EACA,mBnCyzBkC;EmCvzBlC,yBnCKS;EMSP,kBAAA;Ad6+KJ;AkBn8KI;EyB5DJ;IAQI,kBAAA;E3C2/KF;AACF;;A2Cx/KA;EACE,gBAAA;EACA,eAAA;E7BIE,gBAAA;Adw/KJ;;A4CtgLA;EACE,kBAAA;EACA,qBAAA;EACA,mBrC+bkC;EqC9blC,6BAAA;E9BUE,kBAAA;AdggLJ;;A4CrgLA;EAEE,cAAA;A5CugLF;;A4CngLA;EACE,gBrC6JW;APy2Kb;;A4C9/KA;EACE,mBAAA;A5CigLF;A4C//KE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,qBAAA;EACA,cAAA;A5CigLJ;;A4Cv/KE;EC7CA,cD8CqH;EnBzCnH,yBmByCuB;EC5CzB,qBD4CqE;A5C4/KvE;A6CtiLE;EACE,yBAAA;A7CwiLJ;A6CriLE;EACE,cAAA;A7CuiLJ;;A4CngLE;EC7CA,cD8CqH;EnBzCnH,yBmByCuB;EC5CzB,qBD4CqE;A5CwgLvE;A6CljLE;EACE,yBAAA;A7CojLJ;A6CjjLE;EACE,cAAA;A7CmjLJ;;A4C/gLE;EC7CA,cD8CqH;EnBzCnH,yBmByCuB;EC5CzB,qBD4CqE;A5CohLvE;A6C9jLE;EACE,yBAAA;A7CgkLJ;A6C7jLE;EACE,cAAA;A7C+jLJ;;A4C3hLE;EC7CA,cD8CqH;EnBzCnH,yBmByCuB;EC5CzB,qBD4CqE;A5CgiLvE;A6C1kLE;EACE,yBAAA;A7C4kLJ;A6CzkLE;EACE,cAAA;A7C2kLJ;;A4CviLE;EC7CA,cD8CqH;EnBzCnH,yBmByCuB;EC5CzB,qBD4CqE;A5C4iLvE;A6CtlLE;EACE,yBAAA;A7CwlLJ;A6CrlLE;EACE,cAAA;A7CulLJ;;A4CnjLE;EC7CA,cD8CqH;EnBzCnH,yBmByCuB;EC5CzB,qBD4CqE;A5CwjLvE;A6ClmLE;EACE,yBAAA;A7ComLJ;A6CjmLE;EACE,cAAA;A7CmmLJ;;A4C/jLE;EC7CA,cD8CqH;EnBzCnH,yBmByCuB;EC5CzB,qBD4CqE;A5CokLvE;A6C9mLE;EACE,yBAAA;A7CgnLJ;A6C7mLE;EACE,cAAA;A7C+mLJ;;A4C3kLE;EC7CA,cD8CqH;EnBzCnH,yBmByCuB;EC5CzB,qBD4CqE;A5CglLvE;A6C1nLE;EACE,yBAAA;A7C4nLJ;A6CznLE;EACE,cAAA;A7C2nLJ;;A4CvlLE;EC7CA,cD8CqH;EnBzCnH,yBmByCuB;EC5CzB,qBD4CqE;A5C4lLvE;A6CtoLE;EACE,yBAAA;A7CwoLJ;A6CroLE;EACE,cAAA;A7CuoLJ;;A4CnmLE;EC7CA,cD8CqH;EnBzCnH,yBmByCuB;EC5CzB,qBD4CqE;A5CwmLvE;A6ClpLE;EACE,yBAAA;A7CopLJ;A6CjpLE;EACE,cAAA;A7CmpLJ;;A8C3pLE;EACE;IAAO,6BAAA;E9C+pLT;E8C9pLE;IAAK,wBAAA;E9CiqLP;AACF;A8C9pLA;EACE,aAAA;EACA,czCssBkC;EyCrsBlC,gBAAA;EACA,cAAA;ExCwKI,kBAAA;EwCtKJ,yBvCQQ;EOJN,kBAAA;Ad6pLJ;;A8C5pLA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WvCfO;EuCgBP,kBAAA;EACA,mBAAA;EACA,yBzC2rBqC;EkBtsBjC,2BuBYJ;A9C+pLF;AuBvqLM;EuBDN;IvBEQ,gBAAA;EvB0qLN;AACF;;A8CjqLA;ErBYE,qMAAA;EqBVA,8BAAA;A9CoqLF;;A8ChqLE;EACE,kDAAA;A9CmqLJ;A8ChqLM;EAJJ;IAKM,eAAA;E9CmqLN;AACF;;A+C9sLA;EACE,aAAA;EACA,uBAAA;A/CitLF;;A+C9sLA;EACE,SAAA;A/CitLF;;AgDntLA;EACE,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;ElCQE,kBAAA;Ad6sLJ;;AgD3sLA;EACE,WAAA;EACA,cxCRS;EwCST,mBAAA;AhD8sLF;ASrtLE;EuCWE,UAAA;EACA,cxCdO;EwCeP,qBAAA;EACA,yBxCtBO;ARmuLX;AgD1sLE;EACE,czCWU;EyCVV,yBxC1BO;ARsuLX;;AgDnsLA;EACE,kBAAA;EACA,cAAA;EACA,wBAAA;EAGA,sBzCzCO;EyC0CP,sCAAA;AhDosLF;AgDlsLE;ElC1BE,+BAAA;EACA,gCAAA;Ad+tLJ;AgDlsLE;ElChBE,mCAAA;EACA,kCAAA;AdqtLJ;AgDlsLE;EAEE,cxClDO;EwCmDP,oBAAA;EACA,sBzCxDK;AP2vLT;AgD/rLE;EACE,UAAA;EACA,WzC9DK;EyC+DL,yBxCkL0B;EwCjL1B,qBxCiL0B;ARghL9B;AgD9rLE;EACE,mBAAA;AhDgsLJ;AgD9rLI;EACE,gBAAA;EACA,qBzCqDU;AP2oLhB;;AgDlrLI;EACE,mBAAA;AhDqrLN;AgDlrLQ;ElC1BJ,8BAAA;EAZA,0BAAA;Ad4tLJ;AgDjrLQ;ElC3CJ,4BAAA;EAYA,4BAAA;AdotLJ;AgDhrLQ;EACE,aAAA;AhDkrLV;AgD/qLQ;EACE,qBzCoBM;EyCnBN,oBAAA;AhDirLV;AgDhrLU;EACE,iBAAA;EACA,sBzCgBI;APkqLhB;;AkB5uLI;E8BmCA;IACE,mBAAA;EhD6sLJ;EgD1sLM;IlC1BJ,8BAAA;IAZA,0BAAA;EdovLF;EgDzsLM;IlC3CJ,4BAAA;IAYA,4BAAA;Ed4uLF;EgDxsLM;IACE,aAAA;EhD0sLR;EgDvsLM;IACE,qBzCoBM;IyCnBN,oBAAA;EhDysLR;EgDxsLQ;IACE,iBAAA;IACA,sBzCgBI;EP0rLd;AACF;AkBrwLI;E8BmCA;IACE,mBAAA;EhDquLJ;EgDluLM;IlC1BJ,8BAAA;IAZA,0BAAA;Ed4wLF;EgDjuLM;IlC3CJ,4BAAA;IAYA,4BAAA;EdowLF;EgDhuLM;IACE,aAAA;EhDkuLR;EgD/tLM;IACE,qBzCoBM;IyCnBN,oBAAA;EhDiuLR;EgDhuLQ;IACE,iBAAA;IACA,sBzCgBI;EPktLd;AACF;AkB7xLI;E8BmCA;IACE,mBAAA;EhD6vLJ;EgD1vLM;IlC1BJ,8BAAA;IAZA,0BAAA;EdoyLF;EgDzvLM;IlC3CJ,4BAAA;IAYA,4BAAA;Ed4xLF;EgDxvLM;IACE,aAAA;EhD0vLR;EgDvvLM;IACE,qBzCoBM;IyCnBN,oBAAA;EhDyvLR;EgDxvLQ;IACE,iBAAA;IACA,sBzCgBI;EP0uLd;AACF;AkBrzLI;E8BmCA;IACE,mBAAA;EhDqxLJ;EgDlxLM;IlC1BJ,8BAAA;IAZA,0BAAA;Ed4zLF;EgDjxLM;IlC3CJ,4BAAA;IAYA,4BAAA;EdozLF;EgDhxLM;IACE,aAAA;EhDkxLR;EgD/wLM;IACE,qBzCoBM;IyCnBN,oBAAA;EhDixLR;EgDhxLQ;IACE,iBAAA;IACA,sBzCgBI;EPkwLd;AACF;AkB70LI;E8BmCA;IACE,mBAAA;EhD6yLJ;EgD1yLM;IlC1BJ,8BAAA;IAZA,0BAAA;Edo1LF;EgDzyLM;IlC3CJ,4BAAA;IAYA,4BAAA;Ed40LF;EgDxyLM;IACE,aAAA;EhD0yLR;EgDvyLM;IACE,qBzCoBM;IyCnBN,oBAAA;EhDyyLR;EgDxyLQ;IACE,iBAAA;IACA,sBzCgBI;EP0xLd;AACF;AkBr2LI;E8BmCA;IACE,mBAAA;EhDq0LJ;EgDl0LM;IlC1BJ,8BAAA;IAZA,0BAAA;Ed42LF;EgDj0LM;IlC3CJ,4BAAA;IAYA,4BAAA;Edo2LF;EgDh0LM;IACE,aAAA;EhDk0LR;EgD/zLM;IACE,qBzCoBM;IyCnBN,oBAAA;EhDi0LR;EgDh0LQ;IACE,iBAAA;IACA,sBzCgBI;EPkzLd;AACF;AgDrzLA;ElClHI,gBAAA;Ad06LJ;AgDrzLE;EACE,qBAAA;AhDuzLJ;AgDrzLI;EACE,sBAAA;AhDuzLN;;AiD/7LE;EACE,cDmJsE;EClJtE,yBDkJuC;AhDgzL3C;ASv7LE;EwCPM,cD8IkE;EC7IlE,yBAAA;AjDi8LR;AiD97LM;EACE,W1CLC;E0CMD,yBDwIkE;ECvIlE,qBDuIkE;AhDyzL1E;;AiD78LE;EACE,cDmJsE;EClJtE,yBDkJuC;AhD8zL3C;ASr8LE;EwCPM,cD8IkE;EC7IlE,yBAAA;AjD+8LR;AiD58LM;EACE,W1CLC;E0CMD,yBDwIkE;ECvIlE,qBDuIkE;AhDu0L1E;;AiD39LE;EACE,cDmJsE;EClJtE,yBDkJuC;AhD40L3C;ASn9LE;EwCPM,cD8IkE;EC7IlE,yBAAA;AjD69LR;AiD19LM;EACE,W1CLC;E0CMD,yBDwIkE;ECvIlE,qBDuIkE;AhDq1L1E;;AiDz+LE;EACE,cDmJsE;EClJtE,yBDkJuC;AhD01L3C;ASj+LE;EwCPM,cD8IkE;EC7IlE,yBAAA;AjD2+LR;AiDx+LM;EACE,W1CLC;E0CMD,yBDwIkE;ECvIlE,qBDuIkE;AhDm2L1E;;AiDv/LE;EACE,cDmJsE;EClJtE,yBDkJuC;AhDw2L3C;AS/+LE;EwCPM,cD8IkE;EC7IlE,yBAAA;AjDy/LR;AiDt/LM;EACE,W1CLC;E0CMD,yBDwIkE;ECvIlE,qBDuIkE;AhDi3L1E;;AiDrgME;EACE,cDmJsE;EClJtE,yBDkJuC;AhDs3L3C;AS7/LE;EwCPM,cD8IkE;EC7IlE,yBAAA;AjDugMR;AiDpgMM;EACE,W1CLC;E0CMD,yBDwIkE;ECvIlE,qBDuIkE;AhD+3L1E;;AiDnhME;EACE,cDmJsE;EClJtE,yBDkJuC;AhDo4L3C;AS3gME;EwCPM,cD8IkE;EC7IlE,yBAAA;AjDqhMR;AiDlhMM;EACE,W1CLC;E0CMD,yBDwIkE;ECvIlE,qBDuIkE;AhD64L1E;;AiDjiME;EACE,cDmJsE;EClJtE,yBDkJuC;AhDk5L3C;ASzhME;EwCPM,cD8IkE;EC7IlE,yBAAA;AjDmiMR;AiDhiMM;EACE,W1CLC;E0CMD,yBDwIkE;ECvIlE,qBDuIkE;AhD25L1E;;AiD/iME;EACE,cDmJsE;EClJtE,yBDkJuC;AhDg6L3C;ASviME;EwCPM,cD8IkE;EC7IlE,yBAAA;AjDijMR;AiD9iMM;EACE,W1CLC;E0CMD,yBDwIkE;ECvIlE,qBDuIkE;AhDy6L1E;;AiD7jME;EACE,cDmJsE;EClJtE,yBDkJuC;AhD86L3C;ASrjME;EwCPM,cD8IkE;EC7IlE,yBAAA;AjD+jMR;AiD5jMM;EACE,W1CLC;E0CMD,yBDwIkE;ECvIlE,qBDuIkE;AhDu7L1E;;AkD9kMA;EACE,YAAA;E5CmLI,iBAAA;E4CjLJ,gB1C8R4B;E0C7R5B,cAAA;EACA,W3CKO;E2CJP,yB1CylCkC;E0CxlClC,YAAA;AlDilMF;AS5kME;EyCDE,W3CDK;E2CEL,qBAAA;AlDglMJ;AS5kME;EyCCI,aAAA;AlD8kMN;;AkDnkMA;EACE,UAAA;EACA,6BAAA;EACA,SAAA;AlDskMF;;AkDhkMA;EACE,oBAAA;AlDmkMF;;AmDzmMA;EAGE,iB3C24BkC;E2C14BlC,gB3C04BkC;EF1tB9B,mBAAA;E6C7KJ,2C3C44BkC;E2C34BlC,4BAAA;EACA,oCAAA;EACA,gD3C64BkC;E2C54BlC,UAAA;ErCOE,sBAAA;AdmmMJ;AmDvmME;EACE,sB3Cg4BgC;ARyuKpC;AmDtmME;EACE,UAAA;AnDwmMJ;AmDrmME;EACE,cAAA;EACA,UAAA;AnDumMJ;AmDpmME;EACE,aAAA;AnDsmMJ;;AmDlmMA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,c3CvBS;E2CwBT,2C3Cq3BkC;E2Cp3BlC,4BAAA;EACA,4CAAA;ErCZE,2CAAA;EACA,4CAAA;AdknMJ;;AmDnmMA;EACE,gB3Cm2BkC;ARmwKpC;;AoD5oMA;EAEE,gBAAA;ApD8oMF;AoD5oME;EACE,kBAAA;EACA,gBAAA;ApD8oMJ;;AoDzoMA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5C4pBkC;E4C3pBlC,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EAGA,UAAA;ApD0oMF;;AoDnoMA;EACE,kBAAA;EACA,WAAA;EACA,c5Ci5BkC;E4C/4BlC,oBAAA;ApDqoMF;AoDloME;E7B3BI,mC6B4BF;EACA,8B7CsnBgC;AP8gLpC;AuB7pMM;E6BuBJ;I7BtBM,gBAAA;EvBgqMN;AACF;AoDvoME;EACE,0B7CqnBgC;APohLpC;AoDroME;EACE,sB7CknBgC;APqhLpC;;AoDnoMA;EACE,aAAA;EACA,6BAAA;ApDsoMF;AoDpoME;EACE,8BAAA;EACA,gBAAA;ApDsoMJ;AoDnoME;;EAEE,cAAA;ApDqoMJ;AoDloME;EACE,gBAAA;ApDooMJ;;AoDhoMA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;ApDmoMF;AoDhoME;EACE,cAAA;EACA,0BAAA;EACA,mBAAA;EACA,WAAA;ApDkoMJ;AoD9nME;EACE,sBAAA;EACA,uBAAA;EACA,YAAA;ApDgoMJ;AoD9nMI;EACE,gBAAA;ApDgoMN;AoD7nMI;EACE,aAAA;ApD+nMN;;AoDznMA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAGA,oBAAA;EACA,sB7CzGO;E6C0GP,4BAAA;EACA,gCAAA;EtClGE,kBAAA;EsCsGF,UAAA;ApDwnMF;;AoDpnMA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5CgjBkC;E4C/iBlC,YAAA;EACA,aAAA;EACA,yB7CpFc;AP2sMhB;AoDpnME;EAAS,UAAA;ApDunMX;AoDtnME;EAAS,Y/CwjByB;ALikLpC;;AoDpnMA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,qB5C6zBkC;E4C5zBlC,gCAAA;EtCtHE,2BAAA;EACA,4BAAA;Ad8uMJ;AoDtnME;EACE,qB5CwzBgC;E4CtzBhC,iCAAA;ApDunMJ;;AoDlnMA;EACE,gBAAA;EACA,gB5CuI4B;AR8+L9B;;AoDhnMA;EACE,kBAAA;EAGA,cAAA;EACA,gB7CigBkC;APgnLpC;;AoD7mMA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,6BAAA;EtCzIE,+BAAA;EACA,8BAAA;Ad0vMJ;AoD5mME;EACE,eAAA;ApD8mMJ;;AoDzmMA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;ApD4mMF;;AkBnvMI;EkC6IF;IACE,gB/CggBgC;I+C/fhC,oBAAA;EpD0mMF;EoDvmMA;IACE,+BAAA;EpDymMF;EoDvmME;IACE,gCAAA;EpDymMJ;EoDrmMA;IACE,+BAAA;EpDumMF;EoDrmME;IACE,4BAAA;IACA,mBAAA;EpDumMJ;EoD/lMA;IAAY,gB/CwesB;EL0nLlC;AACF;AkB1wMI;EkC2KF;;IAEE,gB/CgegC;ELkoLlC;AACF;AkBhxMI;EkCkLF;IAAY,gB/C0dsB;ELwoLlC;AACF;AqDh1MA;EACE,kBAAA;EACA,a7CgrBkC;E6C/qBlC,cAAA;EACA,S7C61BkC;E8Cj2BlC,oFjDmK4B;EiDjK5B,kBAAA;EACA,gB/C2KW;E+C1KX,iB/CiKkB;E+ChKlB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EhDqKI,oBAAA;E+CzKJ,qBAAA;EACA,UAAA;ArD41MF;AqD11ME;EAAS,Y7Ci1ByB;AR4gLpC;AqD31ME;EACE,kBAAA;EACA,cAAA;EACA,a7Ci1BgC;E6Ch1BhC,c7Ci1BgC;AR4gLpC;AqD31MI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ArD61MN;;AqDx1MA;EACE,iBAAA;ArD21MF;AqDz1ME;EACE,SAAA;ArD21MJ;AqDz1MI;EACE,MAAA;EACA,6BAAA;EACA,yB9CpBM;AP+2MZ;;AqDt1MA;EACE,iBAAA;ArDy1MF;AqDv1ME;EACE,OAAA;EACA,a7CmzBgC;E6ClzBhC,c7CizBgC;ARwiLpC;AqDv1MI;EACE,QAAA;EACA,oCAAA;EACA,2B9CpCM;AP63MZ;;AqDp1MA;EACE,iBAAA;ArDu1MF;AqDr1ME;EACE,MAAA;ArDu1MJ;AqDr1MI;EACE,SAAA;EACA,6BAAA;EACA,4B9ClDM;APy4MZ;;AqDl1MA;EACE,iBAAA;ArDq1MF;AqDn1ME;EACE,QAAA;EACA,a7CqxBgC;E6CpxBhC,c7CmxBgC;ARkkLpC;AqDn1MI;EACE,OAAA;EACA,oCAAA;EACA,0B9ClEM;APu5MZ;;AqDh0MA;EACE,gB7C+uBkC;E6C9uBlC,wBAAA;EACA,W9CrGO;E8CsGP,kBAAA;EACA,yB9C5FU;EOFR,kBAAA;Adk6MJ;;AuDp7MA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,a/C8qBkC;E+C7qBlC,cAAA;EACA,gB/C+2BkC;E8Cp3BlC,oFjDmK4B;EiDjK5B,kBAAA;EACA,gB/C2KW;E+C1KX,iB/CiKkB;E+ChKlB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EhDqKI,mBAAA;EiDxKJ,qBAAA;EACA,sBhDJO;EgDKP,4BAAA;EACA,oCAAA;EzCGE,kBAAA;Ad+7MJ;AuD97ME;EACE,kBAAA;EACA,cAAA;EACA,W/C+2BgC;E+C92BhC,c/C+2BgC;E+C92BhC,aAAA;AvDg8MJ;AuD97MI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AvD+7MN;;AuD17MA;EACE,qB/Cg2BkC;AR6lLpC;AuD37ME;EACE,2BAAA;AvD67MJ;AuD37MI;EACE,SAAA;EACA,6BAAA;EACA,qC/C21B8B;ARkmLpC;AuD17MI;EACE,WhDoFU;EgDnFV,6BAAA;EACA,sBhD3CG;APu+MT;;AuDv7MA;EACE,mB/C40BkC;AR8mLpC;AuDx7ME;EACE,yBAAA;EACA,a/Cw0BgC;E+Cv0BhC,Y/Cs0BgC;E+Cr0BhC,aAAA;AvD07MJ;AuDx7MI;EACE,OAAA;EACA,oCAAA;EACA,uC/Co0B8B;ARsnLpC;AuDv7MI;EACE,ShD6DU;EgD5DV,oCAAA;EACA,wBhDlEG;AP2/MT;;AuDp7MA;EACE,kB/CqzBkC;ARkoLpC;AuDr7ME;EACE,wBAAA;AvDu7MJ;AuDr7MI;EACE,MAAA;EACA,oCAAA;EACA,wC/CgzB8B;ARuoLpC;AuDp7MI;EACE,QhDyCU;EgDxCV,oCAAA;EACA,yBhDtFG;AP4gNT;AuDj7ME;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,W/C4xBgC;E+C3xBhC,oBAAA;EACA,WAAA;EACA,gCAAA;AvDm7MJ;;AuD/6MA;EACE,oB/CqxBkC;AR6pLpC;AuDh7ME;EACE,0BAAA;EACA,a/CixBgC;E+ChxBhC,Y/C+wBgC;E+C9wBhC,aAAA;AvDk7MJ;AuDh7MI;EACE,QAAA;EACA,oCAAA;EACA,sC/C6wB8B;ARqqLpC;AuD/6MI;EACE,UhDMU;EgDLV,oCAAA;EACA,uBhDzHG;AP0iNT;;AuD35MA;EACE,uBAAA;EACA,gBAAA;EjD0BI,mBAAA;EiDvBJ,yB/C+tBkC;E+C9tBlC,gCAAA;EzCnIE,2BAAA;EACA,4BAAA;AdiiNJ;AuD55ME;EACE,aAAA;AvD85MJ;;AuD15MA;EACE,uBAAA;EACA,chD3HY;APwhNd;;AwDxjNA;EACE,kBAAA;AxD2jNF;;AwDxjNA;EACE,mBAAA;AxD2jNF;;AwDxjNA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AxD2jNF;AyDllNE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AzDolNJ;;AwD5jNA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EjClBI,sCiCmBJ;AxD+jNF;AuB9kNM;EiCQN;IjCPQ,gBAAA;EvBilNN;AACF;;AwDjkNA;;;EAGE,cAAA;AxDokNF;;AwDjkNA;;EAEE,2BAAA;AxDokNF;;AwDjkNA;;EAEE,4BAAA;AxDokNF;;AwD3jNE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AxD8jNJ;AwD3jNE;;;EAGE,UAAA;EACA,UAAA;AxD6jNJ;AwD1jNE;;EAEE,UAAA;EACA,UAAA;EjC5DE,2BiC6DF;AxD4jNJ;AuBrnNM;EiCqDJ;;IjCpDM,gBAAA;EvBynNN;AACF;;AwDzjNA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhDs9BmC;EgDr9BnC,UAAA;EACA,WjDzFO;EiD0FP,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YhDi9BmC;EeviC/B,8BiCuFJ;AxD2jNF;AuB9oNM;EiCkEN;;IjCjEQ,gBAAA;EvBkpNN;AACF;ASxpNE;;;E+C2FE,WjDlGK;EiDmGL,qBAAA;EACA,UAAA;EACA,YhD08BiC;ARwnLrC;;AwD/jNA;EACE,OAAA;AxDkkNF;;AwD7jNA;EACE,QAAA;AxDgkNF;;AwDzjNA;;EAEE,qBAAA;EACA,WhDm8BmC;EgDl8BnC,YhDk8BmC;EgDj8BnC,mCAAA;AxD4jNF;;AwD1jNA;EACE,0DAAA;AxD6jNF;;AwD3jNA;EACE,0DAAA;AxD8jNF;;AwDrjNA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EAEA,iBhDy5BmC;EgDx5BnC,gBhDw5BmC;EgDv5BnC,gBAAA;AxDujNF;AwDrjNE;EACE,uBAAA;EACA,cAAA;EACA,WhDu5BiC;EgDt5BjC,WhDu5BiC;EgDt5BjC,iBhDw5BiC;EgDv5BjC,gBhDu5BiC;EgDt5BjC,mBAAA;EACA,eAAA;EACA,sBjDjKK;EiDkKL,4BAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YAAA;EjC/JE,6BiCgKF;AxDsjNJ;AuBltNM;EiC6IJ;IjC5IM,gBAAA;EvBqtNN;AACF;AwDxjNE;EACE,UAAA;AxD0jNJ;;AwDjjNA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,WjD5LO;EiD6LP,kBAAA;AxDojNF;;A0DtvNA;EACE;IAAK,yBAAA;E1D0vNL;AACF;A0DxvNA;EACE,qBAAA;EACA,WlDskCwB;EkDrkCxB,YlDqkCwB;EkDpkCxB,wBlDskCwB;EkDrkCxB,iCAAA;EACA,+BAAA;EAEA,kBAAA;EACA,+CAAA;A1DyvNF;;A0DtvNA;EACE,WlDgkCwB;EkD/jCxB,YlD+jCwB;EkD9jCxB,mBlDgkCwB;ARyrL1B;;A0DlvNA;EACE;IACE,mBAAA;E1DqvNF;E0DnvNA;IACE,UAAA;IACA,eAAA;E1DqvNF;AACF;A0DlvNA;EACE,qBAAA;EACA,WlDsiCwB;EkDriCxB,YlDqiCwB;EkDpiCxB,wBlDsiCwB;EkDriCxB,8BAAA;EAEA,kBAAA;EACA,UAAA;EACA,6CAAA;A1DmvNF;;A0DhvNA;EACE,WlDgiCwB;EkD/hCxB,YlD+hCwB;ARotL1B;;A0D/uNE;EACE;;IAEE,wBAAA;E1DkvNJ;AACF;A2D9yNA;EAAqB,mCAAA;A3DizNrB;;A2DhzNA;EAAqB,8BAAA;A3DozNrB;;A2DnzNA;EAAqB,iCAAA;A3DuzNrB;;A2DtzNA;EAAqB,iCAAA;A3D0zNrB;;A2DzzNA;EAAqB,sCAAA;A3D6zNrB;;A2D5zNA;EAAqB,mCAAA;A3Dg0NrB;;A4Dl0NE;EACE,oCAAA;A5Dq0NJ;;AS3zNE;;;EmDLI,oCAAA;A5Ds0NN;;A4D50NE;EACE,oCAAA;A5D+0NJ;;ASr0NE;;;EmDLI,oCAAA;A5Dg1NN;;A4Dt1NE;EACE,oCAAA;A5Dy1NJ;;AS/0NE;;;EmDLI,oCAAA;A5D01NN;;A4Dh2NE;EACE,oCAAA;A5Dm2NJ;;ASz1NE;;;EmDLI,oCAAA;A5Do2NN;;A4D12NE;EACE,oCAAA;A5D62NJ;;ASn2NE;;;EmDLI,oCAAA;A5D82NN;;A4Dp3NE;EACE,oCAAA;A5Du3NJ;;AS72NE;;;EmDLI,oCAAA;A5Dw3NN;;A4D93NE;EACE,oCAAA;A5Di4NJ;;ASv3NE;;;EmDLI,oCAAA;A5Dk4NN;;A4Dx4NE;EACE,oCAAA;A5D24NJ;;ASj4NE;;;EmDLI,oCAAA;A5D44NN;;A4Dl5NE;EACE,oCAAA;A5Dq5NJ;;AS34NE;;;;EmDLI,oCAAA;A5Du5NN;;A4D75NE;EACE,oCAAA;A5Dg6NJ;;ASt5NE;;;EmDLI,oCAAA;A5Di6NN;;A6Dh6NA;EACE,iCAAA;A7Dm6NF;;A6Dh6NA;EACE,wCAAA;A7Dm6NF;;A8D96NA;EAAkB,oCAAA;A9Dk7NlB;;A8Dj7NA;EAAkB,wCAAA;A9Dq7NlB;;A8Dp7NA;EACE,0CAAA;A9Du7NF;;A8Dr7NA;EAAkB,2CAAA;A9Dy7NlB;;A8Dx7NA;EACE,yCAAA;A9D27NF;;A8Dx7NA;EAAmB,oBAAA;A9D47NnB;;A8D37NA;EAAmB,wBAAA;A9D+7NnB;;A8D97NA;EACE,0BAAA;A9Di8NF;;A8D/7NA;EAAmB,2BAAA;A9Dm8NnB;;A8Dj8NA;EACE,yBAAA;A9Do8NF;;A8Dh8NE;EACE,gCAAA;A9Dm8NJ;;A8Dp8NE;EACE,gCAAA;A9Du8NJ;;A8Dx8NE;EACE,gCAAA;A9D28NJ;;A8D58NE;EACE,gCAAA;A9D+8NJ;;A8Dh9NE;EACE,gCAAA;A9Dm9NJ;;A8Dp9NE;EACE,gCAAA;A9Du9NJ;;A8Dx9NE;EACE,gCAAA;A9D29NJ;;A8D59NE;EACE,gCAAA;A9D+9NJ;;A8Dh+NE;EACE,gCAAA;A9Dm+NJ;;A8Dp+NE;EACE,gCAAA;A9Du+NJ;;A8Dn+NA;EACE,6BAAA;A9Ds+NF;;A8D/9NA;EACE,6BAAA;A9Dk+NF;;A8D/9NA;EACE,6BAAA;A9Dk+NF;;A8D/9NA;EACE,sCAAA;EACA,uCAAA;A9Dk+NF;;A8D/9NA;EACE,uCAAA;EACA,0CAAA;A9Dk+NF;;A8D/9NA;EACE,0CAAA;EACA,yCAAA;A9Dk+NF;;A8D/9NA;EACE,sCAAA;EACA,yCAAA;A9Dk+NF;;A8D/9NA;EACE,6BAAA;A9Dk+NF;;A8D/9NA;EACE,6BAAA;A9Dk+NF;;A8D/9NA;EACE,gCAAA;A9Dk+NF;;A8D/9NA;EACE,2BAAA;A9Dk+NF;;AyDnjOE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AzDsjOJ;;A+D/iOM;EAAwB,wBAAA;A/DmjO9B;;A+DnjOM;EAAwB,0BAAA;A/DujO9B;;A+DvjOM;EAAwB,gCAAA;A/D2jO9B;;A+D3jOM;EAAwB,yBAAA;A/D+jO9B;;A+D/jOM;EAAwB,yBAAA;A/DmkO9B;;A+DnkOM;EAAwB,6BAAA;A/DukO9B;;A+DvkOM;EAAwB,8BAAA;A/D2kO9B;;A+D3kOM;EAAwB,wBAAA;A/D+kO9B;;A+D/kOM;EAAwB,+BAAA;A/DmlO9B;;AkBliOI;E6CjDE;IAAwB,wBAAA;E/DwlO5B;E+DxlOI;IAAwB,0BAAA;E/D2lO5B;E+D3lOI;IAAwB,gCAAA;E/D8lO5B;E+D9lOI;IAAwB,yBAAA;E/DimO5B;E+DjmOI;IAAwB,yBAAA;E/DomO5B;E+DpmOI;IAAwB,6BAAA;E/DumO5B;E+DvmOI;IAAwB,8BAAA;E/D0mO5B;E+D1mOI;IAAwB,wBAAA;E/D6mO5B;E+D7mOI;IAAwB,+BAAA;E/DgnO5B;AACF;AkBhkOI;E6CjDE;IAAwB,wBAAA;E/DqnO5B;E+DrnOI;IAAwB,0BAAA;E/DwnO5B;E+DxnOI;IAAwB,gCAAA;E/D2nO5B;E+D3nOI;IAAwB,yBAAA;E/D8nO5B;E+D9nOI;IAAwB,yBAAA;E/DioO5B;E+DjoOI;IAAwB,6BAAA;E/DooO5B;E+DpoOI;IAAwB,8BAAA;E/DuoO5B;E+DvoOI;IAAwB,wBAAA;E/D0oO5B;E+D1oOI;IAAwB,+BAAA;E/D6oO5B;AACF;AkB7lOI;E6CjDE;IAAwB,wBAAA;E/DkpO5B;E+DlpOI;IAAwB,0BAAA;E/DqpO5B;E+DrpOI;IAAwB,gCAAA;E/DwpO5B;E+DxpOI;IAAwB,yBAAA;E/D2pO5B;E+D3pOI;IAAwB,yBAAA;E/D8pO5B;E+D9pOI;IAAwB,6BAAA;E/DiqO5B;E+DjqOI;IAAwB,8BAAA;E/DoqO5B;E+DpqOI;IAAwB,wBAAA;E/DuqO5B;E+DvqOI;IAAwB,+BAAA;E/D0qO5B;AACF;AkB1nOI;E6CjDE;IAAwB,wBAAA;E/D+qO5B;E+D/qOI;IAAwB,0BAAA;E/DkrO5B;E+DlrOI;IAAwB,gCAAA;E/DqrO5B;E+DrrOI;IAAwB,yBAAA;E/DwrO5B;E+DxrOI;IAAwB,yBAAA;E/D2rO5B;E+D3rOI;IAAwB,6BAAA;E/D8rO5B;E+D9rOI;IAAwB,8BAAA;E/DisO5B;E+DjsOI;IAAwB,wBAAA;E/DosO5B;E+DpsOI;IAAwB,+BAAA;E/DusO5B;AACF;AkBvpOI;E6CjDE;IAAwB,wBAAA;E/D4sO5B;E+D5sOI;IAAwB,0BAAA;E/D+sO5B;E+D/sOI;IAAwB,gCAAA;E/DktO5B;E+DltOI;IAAwB,yBAAA;E/DqtO5B;E+DrtOI;IAAwB,yBAAA;E/DwtO5B;E+DxtOI;IAAwB,6BAAA;E/D2tO5B;E+D3tOI;IAAwB,8BAAA;E/D8tO5B;E+D9tOI;IAAwB,wBAAA;E/DiuO5B;E+DjuOI;IAAwB,+BAAA;E/DouO5B;AACF;AkBprOI;E6CjDE;IAAwB,wBAAA;E/DyuO5B;E+DzuOI;IAAwB,0BAAA;E/D4uO5B;E+D5uOI;IAAwB,gCAAA;E/D+uO5B;E+D/uOI;IAAwB,yBAAA;E/DkvO5B;E+DlvOI;IAAwB,yBAAA;E/DqvO5B;E+DrvOI;IAAwB,6BAAA;E/DwvO5B;E+DxvOI;IAAwB,8BAAA;E/D2vO5B;E+D3vOI;IAAwB,wBAAA;E/D8vO5B;E+D9vOI;IAAwB,+BAAA;E/DiwO5B;AACF;A+DxvOA;EAEI;IAAqB,wBAAA;E/D0vOvB;E+D1vOE;IAAqB,0BAAA;E/D6vOvB;E+D7vOE;IAAqB,gCAAA;E/DgwOvB;E+DhwOE;IAAqB,yBAAA;E/DmwOvB;E+DnwOE;IAAqB,yBAAA;E/DswOvB;E+DtwOE;IAAqB,6BAAA;E/DywOvB;E+DzwOE;IAAqB,8BAAA;E/D4wOvB;E+D5wOE;IAAqB,wBAAA;E/D+wOvB;E+D/wOE;IAAqB,+BAAA;E/DkxOvB;AACF;AgExyOA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;AhE0yOF;AgExyOE;EACE,cAAA;EACA,WAAA;AhE0yOJ;AgEvyOE;;;;;EAKE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AhEyyOJ;;AgEhyOI;EACE,yBAAA;AhEmyON;;AgEpyOI;EACE,mBAAA;AhEuyON;;AgExyOI;EACE,gBAAA;AhE2yON;;AgE5yOI;EACE,iBAAA;AhE+yON;;AiEx0OI;EAAgC,8BAAA;AjE40OpC;;AiE30OI;EAAgC,iCAAA;AjE+0OpC;;AiE90OI;EAAgC,sCAAA;AjEk1OpC;;AiEj1OI;EAAgC,yCAAA;AjEq1OpC;;AiEn1OI;EAA8B,0BAAA;AjEu1OlC;;AiEt1OI;EAA8B,4BAAA;AjE01OlC;;AiEz1OI;EAA8B,kCAAA;AjE61OlC;;AiE51OI;EAA8B,yBAAA;AjEg2OlC;;AiE/1OI;EAA8B,uBAAA;AjEm2OlC;;AiEl2OI;EAA8B,uBAAA;AjEs2OlC;;AiEr2OI;EAA8B,yBAAA;AjEy2OlC;;AiEx2OI;EAA8B,yBAAA;AjE42OlC;;AiE12OI;EAAoC,sCAAA;AjE82OxC;;AiE72OI;EAAoC,oCAAA;AjEi3OxC;;AiEh3OI;EAAoC,kCAAA;AjEo3OxC;;AiEn3OI;EAAoC,yCAAA;AjEu3OxC;;AiEt3OI;EAAoC,wCAAA;AjE03OxC;;AiEx3OI;EAAiC,kCAAA;AjE43OrC;;AiE33OI;EAAiC,gCAAA;AjE+3OrC;;AiE93OI;EAAiC,8BAAA;AjEk4OrC;;AiEj4OI;EAAiC,gCAAA;AjEq4OrC;;AiEp4OI;EAAiC,+BAAA;AjEw4OrC;;AiEt4OI;EAAkC,oCAAA;AjE04OtC;;AiEz4OI;EAAkC,kCAAA;AjE64OtC;;AiE54OI;EAAkC,gCAAA;AjEg5OtC;;AiE/4OI;EAAkC,uCAAA;AjEm5OtC;;AiEl5OI;EAAkC,sCAAA;AjEs5OtC;;AiEr5OI;EAAkC,iCAAA;AjEy5OtC;;AiEv5OI;EAAgC,2BAAA;AjE25OpC;;AiE15OI;EAAgC,iCAAA;AjE85OpC;;AiE75OI;EAAgC,+BAAA;AjEi6OpC;;AiEh6OI;EAAgC,6BAAA;AjEo6OpC;;AiEn6OI;EAAgC,+BAAA;AjEu6OpC;;AiEt6OI;EAAgC,8BAAA;AjE06OpC;;AkB95OI;E+ClDA;IAAgC,8BAAA;EjEq9OlC;EiEp9OE;IAAgC,iCAAA;EjEu9OlC;EiEt9OE;IAAgC,sCAAA;EjEy9OlC;EiEx9OE;IAAgC,yCAAA;EjE29OlC;EiEz9OE;IAA8B,0BAAA;EjE49OhC;EiE39OE;IAA8B,4BAAA;EjE89OhC;EiE79OE;IAA8B,kCAAA;EjEg+OhC;EiE/9OE;IAA8B,yBAAA;EjEk+OhC;EiEj+OE;IAA8B,uBAAA;EjEo+OhC;EiEn+OE;IAA8B,uBAAA;EjEs+OhC;EiEr+OE;IAA8B,yBAAA;EjEw+OhC;EiEv+OE;IAA8B,yBAAA;EjE0+OhC;EiEx+OE;IAAoC,sCAAA;EjE2+OtC;EiE1+OE;IAAoC,oCAAA;EjE6+OtC;EiE5+OE;IAAoC,kCAAA;EjE++OtC;EiE9+OE;IAAoC,yCAAA;EjEi/OtC;EiEh/OE;IAAoC,wCAAA;EjEm/OtC;EiEj/OE;IAAiC,kCAAA;EjEo/OnC;EiEn/OE;IAAiC,gCAAA;EjEs/OnC;EiEr/OE;IAAiC,8BAAA;EjEw/OnC;EiEv/OE;IAAiC,gCAAA;EjE0/OnC;EiEz/OE;IAAiC,+BAAA;EjE4/OnC;EiE1/OE;IAAkC,oCAAA;EjE6/OpC;EiE5/OE;IAAkC,kCAAA;EjE+/OpC;EiE9/OE;IAAkC,gCAAA;EjEigPpC;EiEhgPE;IAAkC,uCAAA;EjEmgPpC;EiElgPE;IAAkC,sCAAA;EjEqgPpC;EiEpgPE;IAAkC,iCAAA;EjEugPpC;EiErgPE;IAAgC,2BAAA;EjEwgPlC;EiEvgPE;IAAgC,iCAAA;EjE0gPlC;EiEzgPE;IAAgC,+BAAA;EjE4gPlC;EiE3gPE;IAAgC,6BAAA;EjE8gPlC;EiE7gPE;IAAgC,+BAAA;EjEghPlC;EiE/gPE;IAAgC,8BAAA;EjEkhPlC;AACF;AkBvgPI;E+ClDA;IAAgC,8BAAA;EjE6jPlC;EiE5jPE;IAAgC,iCAAA;EjE+jPlC;EiE9jPE;IAAgC,sCAAA;EjEikPlC;EiEhkPE;IAAgC,yCAAA;EjEmkPlC;EiEjkPE;IAA8B,0BAAA;EjEokPhC;EiEnkPE;IAA8B,4BAAA;EjEskPhC;EiErkPE;IAA8B,kCAAA;EjEwkPhC;EiEvkPE;IAA8B,yBAAA;EjE0kPhC;EiEzkPE;IAA8B,uBAAA;EjE4kPhC;EiE3kPE;IAA8B,uBAAA;EjE8kPhC;EiE7kPE;IAA8B,yBAAA;EjEglPhC;EiE/kPE;IAA8B,yBAAA;EjEklPhC;EiEhlPE;IAAoC,sCAAA;EjEmlPtC;EiEllPE;IAAoC,oCAAA;EjEqlPtC;EiEplPE;IAAoC,kCAAA;EjEulPtC;EiEtlPE;IAAoC,yCAAA;EjEylPtC;EiExlPE;IAAoC,wCAAA;EjE2lPtC;EiEzlPE;IAAiC,kCAAA;EjE4lPnC;EiE3lPE;IAAiC,gCAAA;EjE8lPnC;EiE7lPE;IAAiC,8BAAA;EjEgmPnC;EiE/lPE;IAAiC,gCAAA;EjEkmPnC;EiEjmPE;IAAiC,+BAAA;EjEomPnC;EiElmPE;IAAkC,oCAAA;EjEqmPpC;EiEpmPE;IAAkC,kCAAA;EjEumPpC;EiEtmPE;IAAkC,gCAAA;EjEymPpC;EiExmPE;IAAkC,uCAAA;EjE2mPpC;EiE1mPE;IAAkC,sCAAA;EjE6mPpC;EiE5mPE;IAAkC,iCAAA;EjE+mPpC;EiE7mPE;IAAgC,2BAAA;EjEgnPlC;EiE/mPE;IAAgC,iCAAA;EjEknPlC;EiEjnPE;IAAgC,+BAAA;EjEonPlC;EiEnnPE;IAAgC,6BAAA;EjEsnPlC;EiErnPE;IAAgC,+BAAA;EjEwnPlC;EiEvnPE;IAAgC,8BAAA;EjE0nPlC;AACF;AkB/mPI;E+ClDA;IAAgC,8BAAA;EjEqqPlC;EiEpqPE;IAAgC,iCAAA;EjEuqPlC;EiEtqPE;IAAgC,sCAAA;EjEyqPlC;EiExqPE;IAAgC,yCAAA;EjE2qPlC;EiEzqPE;IAA8B,0BAAA;EjE4qPhC;EiE3qPE;IAA8B,4BAAA;EjE8qPhC;EiE7qPE;IAA8B,kCAAA;EjEgrPhC;EiE/qPE;IAA8B,yBAAA;EjEkrPhC;EiEjrPE;IAA8B,uBAAA;EjEorPhC;EiEnrPE;IAA8B,uBAAA;EjEsrPhC;EiErrPE;IAA8B,yBAAA;EjEwrPhC;EiEvrPE;IAA8B,yBAAA;EjE0rPhC;EiExrPE;IAAoC,sCAAA;EjE2rPtC;EiE1rPE;IAAoC,oCAAA;EjE6rPtC;EiE5rPE;IAAoC,kCAAA;EjE+rPtC;EiE9rPE;IAAoC,yCAAA;EjEisPtC;EiEhsPE;IAAoC,wCAAA;EjEmsPtC;EiEjsPE;IAAiC,kCAAA;EjEosPnC;EiEnsPE;IAAiC,gCAAA;EjEssPnC;EiErsPE;IAAiC,8BAAA;EjEwsPnC;EiEvsPE;IAAiC,gCAAA;EjE0sPnC;EiEzsPE;IAAiC,+BAAA;EjE4sPnC;EiE1sPE;IAAkC,oCAAA;EjE6sPpC;EiE5sPE;IAAkC,kCAAA;EjE+sPpC;EiE9sPE;IAAkC,gCAAA;EjEitPpC;EiEhtPE;IAAkC,uCAAA;EjEmtPpC;EiEltPE;IAAkC,sCAAA;EjEqtPpC;EiEptPE;IAAkC,iCAAA;EjEutPpC;EiErtPE;IAAgC,2BAAA;EjEwtPlC;EiEvtPE;IAAgC,iCAAA;EjE0tPlC;EiEztPE;IAAgC,+BAAA;EjE4tPlC;EiE3tPE;IAAgC,6BAAA;EjE8tPlC;EiE7tPE;IAAgC,+BAAA;EjEguPlC;EiE/tPE;IAAgC,8BAAA;EjEkuPlC;AACF;AkBvtPI;E+ClDA;IAAgC,8BAAA;EjE6wPlC;EiE5wPE;IAAgC,iCAAA;EjE+wPlC;EiE9wPE;IAAgC,sCAAA;EjEixPlC;EiEhxPE;IAAgC,yCAAA;EjEmxPlC;EiEjxPE;IAA8B,0BAAA;EjEoxPhC;EiEnxPE;IAA8B,4BAAA;EjEsxPhC;EiErxPE;IAA8B,kCAAA;EjEwxPhC;EiEvxPE;IAA8B,yBAAA;EjE0xPhC;EiEzxPE;IAA8B,uBAAA;EjE4xPhC;EiE3xPE;IAA8B,uBAAA;EjE8xPhC;EiE7xPE;IAA8B,yBAAA;EjEgyPhC;EiE/xPE;IAA8B,yBAAA;EjEkyPhC;EiEhyPE;IAAoC,sCAAA;EjEmyPtC;EiElyPE;IAAoC,oCAAA;EjEqyPtC;EiEpyPE;IAAoC,kCAAA;EjEuyPtC;EiEtyPE;IAAoC,yCAAA;EjEyyPtC;EiExyPE;IAAoC,wCAAA;EjE2yPtC;EiEzyPE;IAAiC,kCAAA;EjE4yPnC;EiE3yPE;IAAiC,gCAAA;EjE8yPnC;EiE7yPE;IAAiC,8BAAA;EjEgzPnC;EiE/yPE;IAAiC,gCAAA;EjEkzPnC;EiEjzPE;IAAiC,+BAAA;EjEozPnC;EiElzPE;IAAkC,oCAAA;EjEqzPpC;EiEpzPE;IAAkC,kCAAA;EjEuzPpC;EiEtzPE;IAAkC,gCAAA;EjEyzPpC;EiExzPE;IAAkC,uCAAA;EjE2zPpC;EiE1zPE;IAAkC,sCAAA;EjE6zPpC;EiE5zPE;IAAkC,iCAAA;EjE+zPpC;EiE7zPE;IAAgC,2BAAA;EjEg0PlC;EiE/zPE;IAAgC,iCAAA;EjEk0PlC;EiEj0PE;IAAgC,+BAAA;EjEo0PlC;EiEn0PE;IAAgC,6BAAA;EjEs0PlC;EiEr0PE;IAAgC,+BAAA;EjEw0PlC;EiEv0PE;IAAgC,8BAAA;EjE00PlC;AACF;AkB/zPI;E+ClDA;IAAgC,8BAAA;EjEq3PlC;EiEp3PE;IAAgC,iCAAA;EjEu3PlC;EiEt3PE;IAAgC,sCAAA;EjEy3PlC;EiEx3PE;IAAgC,yCAAA;EjE23PlC;EiEz3PE;IAA8B,0BAAA;EjE43PhC;EiE33PE;IAA8B,4BAAA;EjE83PhC;EiE73PE;IAA8B,kCAAA;EjEg4PhC;EiE/3PE;IAA8B,yBAAA;EjEk4PhC;EiEj4PE;IAA8B,uBAAA;EjEo4PhC;EiEn4PE;IAA8B,uBAAA;EjEs4PhC;EiEr4PE;IAA8B,yBAAA;EjEw4PhC;EiEv4PE;IAA8B,yBAAA;EjE04PhC;EiEx4PE;IAAoC,sCAAA;EjE24PtC;EiE14PE;IAAoC,oCAAA;EjE64PtC;EiE54PE;IAAoC,kCAAA;EjE+4PtC;EiE94PE;IAAoC,yCAAA;EjEi5PtC;EiEh5PE;IAAoC,wCAAA;EjEm5PtC;EiEj5PE;IAAiC,kCAAA;EjEo5PnC;EiEn5PE;IAAiC,gCAAA;EjEs5PnC;EiEr5PE;IAAiC,8BAAA;EjEw5PnC;EiEv5PE;IAAiC,gCAAA;EjE05PnC;EiEz5PE;IAAiC,+BAAA;EjE45PnC;EiE15PE;IAAkC,oCAAA;EjE65PpC;EiE55PE;IAAkC,kCAAA;EjE+5PpC;EiE95PE;IAAkC,gCAAA;EjEi6PpC;EiEh6PE;IAAkC,uCAAA;EjEm6PpC;EiEl6PE;IAAkC,sCAAA;EjEq6PpC;EiEp6PE;IAAkC,iCAAA;EjEu6PpC;EiEr6PE;IAAgC,2BAAA;EjEw6PlC;EiEv6PE;IAAgC,iCAAA;EjE06PlC;EiEz6PE;IAAgC,+BAAA;EjE46PlC;EiE36PE;IAAgC,6BAAA;EjE86PlC;EiE76PE;IAAgC,+BAAA;EjEg7PlC;EiE/6PE;IAAgC,8BAAA;EjEk7PlC;AACF;AkBv6PI;E+ClDA;IAAgC,8BAAA;EjE69PlC;EiE59PE;IAAgC,iCAAA;EjE+9PlC;EiE99PE;IAAgC,sCAAA;EjEi+PlC;EiEh+PE;IAAgC,yCAAA;EjEm+PlC;EiEj+PE;IAA8B,0BAAA;EjEo+PhC;EiEn+PE;IAA8B,4BAAA;EjEs+PhC;EiEr+PE;IAA8B,kCAAA;EjEw+PhC;EiEv+PE;IAA8B,yBAAA;EjE0+PhC;EiEz+PE;IAA8B,uBAAA;EjE4+PhC;EiE3+PE;IAA8B,uBAAA;EjE8+PhC;EiE7+PE;IAA8B,yBAAA;EjEg/PhC;EiE/+PE;IAA8B,yBAAA;EjEk/PhC;EiEh/PE;IAAoC,sCAAA;EjEm/PtC;EiEl/PE;IAAoC,oCAAA;EjEq/PtC;EiEp/PE;IAAoC,kCAAA;EjEu/PtC;EiEt/PE;IAAoC,yCAAA;EjEy/PtC;EiEx/PE;IAAoC,wCAAA;EjE2/PtC;EiEz/PE;IAAiC,kCAAA;EjE4/PnC;EiE3/PE;IAAiC,gCAAA;EjE8/PnC;EiE7/PE;IAAiC,8BAAA;EjEggQnC;EiE//PE;IAAiC,gCAAA;EjEkgQnC;EiEjgQE;IAAiC,+BAAA;EjEogQnC;EiElgQE;IAAkC,oCAAA;EjEqgQpC;EiEpgQE;IAAkC,kCAAA;EjEugQpC;EiEtgQE;IAAkC,gCAAA;EjEygQpC;EiExgQE;IAAkC,uCAAA;EjE2gQpC;EiE1gQE;IAAkC,sCAAA;EjE6gQpC;EiE5gQE;IAAkC,iCAAA;EjE+gQpC;EiE7gQE;IAAgC,2BAAA;EjEghQlC;EiE/gQE;IAAgC,iCAAA;EjEkhQlC;EiEjhQE;IAAgC,+BAAA;EjEohQlC;EiEnhQE;IAAgC,6BAAA;EjEshQlC;EiErhQE;IAAgC,+BAAA;EjEwhQlC;EiEvhQE;IAAgC,8BAAA;EjE0hQlC;AACF;AkErkQI;EACE,sBAAA;AlEukQN;;AkErkQI;EACE,uBAAA;AlEwkQN;;AkEtkQI;EAAwB,sBAAA;AlE0kQ5B;;AkB1hQI;EgDtDA;IACE,sBAAA;ElEolQJ;EkEllQE;IACE,uBAAA;ElEolQJ;EkEllQE;IAAwB,sBAAA;ElEqlQ1B;AACF;AkBtiQI;EgDtDA;IACE,sBAAA;ElE+lQJ;EkE7lQE;IACE,uBAAA;ElE+lQJ;EkE7lQE;IAAwB,sBAAA;ElEgmQ1B;AACF;AkBjjQI;EgDtDA;IACE,sBAAA;ElE0mQJ;EkExmQE;IACE,uBAAA;ElE0mQJ;EkExmQE;IAAwB,sBAAA;ElE2mQ1B;AACF;AkB5jQI;EgDtDA;IACE,sBAAA;ElEqnQJ;EkEnnQE;IACE,uBAAA;ElEqnQJ;EkEnnQE;IAAwB,sBAAA;ElEsnQ1B;AACF;AkBvkQI;EgDtDA;IACE,sBAAA;ElEgoQJ;EkE9nQE;IACE,uBAAA;ElEgoQJ;EkE9nQE;IAAwB,sBAAA;ElEioQ1B;AACF;AkBllQI;EgDtDA;IACE,sBAAA;ElE2oQJ;EkEzoQE;IACE,uBAAA;ElE2oQJ;EkEzoQE;IAAwB,sBAAA;ElE4oQ1B;AACF;AmEtpQE;EAAyB,mCAAA;UAAA,2BAAA;AnEypQ3B;;AmEzpQE;EAAyB,oCAAA;UAAA,4BAAA;AnE6pQ3B;;AmE7pQE;EAAyB,oCAAA;UAAA,4BAAA;AnEiqQ3B;;AoEjqQE;EAAsB,yBAAA;ApEqqQxB;;AoErqQE;EAAsB,2BAAA;ApEyqQxB;;AqExqQE;EAAyB,2BAAA;ArE4qQ3B;;AqE5qQE;EAAyB,6BAAA;ArEgrQ3B;;AqEhrQE;EAAyB,6BAAA;ArEorQ3B;;AqEprQE;EAAyB,0BAAA;ArEwrQ3B;;AqExrQE;EAAyB,2BAAA;ArE4rQ3B;;AqEvrQA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a7DiqBkC;ARyhPpC;;AqEvrQA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a7DypBkC;ARiiPpC;;AqEtrQE;EADF;IAEI,gBAAA;IACA,MAAA;IACA,a7DipBgC;ERyiPlC;AACF;;AsEptQA;ECEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AvEstQF;;AuE5sQE;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;AvE8sQJ;;AwE3uQA;EAAa,gEAAA;AxE+uQb;;AwE9uQA;EAAU,4DAAA;AxEkvQV;;AwEjvQA;EAAa,yDAAA;AxEqvQb;;AwEpvQA;EAAe,2BAAA;AxEwvQf;;AyEvvQI;EAAuB,qBAAA;AzE2vQ3B;;AyE3vQI;EAAuB,qBAAA;AzE+vQ3B;;AyE/vQI;EAAuB,qBAAA;AzEmwQ3B;;AyEnwQI;EAAuB,sBAAA;AzEuwQ3B;;AyEvwQI;EAAuB,sBAAA;AzE2wQ3B;;AyE3wQI;EAAuB,sBAAA;AzE+wQ3B;;AyE/wQI;EAAuB,sBAAA;AzEmxQ3B;;AyEnxQI;EAAuB,sBAAA;AzEuxQ3B;;AyEvxQI;EAAuB,uBAAA;AzE2xQ3B;;AyE3xQI;EAAuB,uBAAA;AzE+xQ3B;;AyE3xQA;EAAU,0BAAA;AzE+xQV;;AyE9xQA;EAAU,2BAAA;AzEkyQV;;AyE9xQA;EAAc,2BAAA;AzEkyQd;;AyEjyQA;EAAc,4BAAA;AzEqyQd;;AyEnyQA;EAAU,uBAAA;AzEuyQV;;AyEtyQA;EAAU,wBAAA;AzE0yQV;;A0EnzQQ;EAAgC,oBAAA;A1EuzQxC;;A0EtzQQ;;EAEE,wBAAA;A1EyzQV;;A0EvzQQ;;EAEE,0BAAA;A1E0zQV;;A0ExzQQ;;EAEE,2BAAA;A1E2zQV;;A0EzzQQ;;EAEE,yBAAA;A1E4zQV;;A0E30QQ;EAAgC,2BAAA;A1E+0QxC;;A0E90QQ;;EAEE,+BAAA;A1Ei1QV;;A0E/0QQ;;EAEE,iCAAA;A1Ek1QV;;A0Eh1QQ;;EAEE,kCAAA;A1Em1QV;;A0Ej1QQ;;EAEE,gCAAA;A1Eo1QV;;A0En2QQ;EAAgC,0BAAA;A1Eu2QxC;;A0Et2QQ;;EAEE,8BAAA;A1Ey2QV;;A0Ev2QQ;;EAEE,gCAAA;A1E02QV;;A0Ex2QQ;;EAEE,iCAAA;A1E22QV;;A0Ez2QQ;;EAEE,+BAAA;A1E42QV;;A0E33QQ;EAAgC,uBAAA;A1E+3QxC;;A0E93QQ;;EAEE,2BAAA;A1Ei4QV;;A0E/3QQ;;EAEE,6BAAA;A1Ek4QV;;A0Eh4QQ;;EAEE,8BAAA;A1Em4QV;;A0Ej4QQ;;EAEE,4BAAA;A1Eo4QV;;A0En5QQ;EAAgC,yBAAA;A1Eu5QxC;;A0Et5QQ;;EAEE,6BAAA;A1Ey5QV;;A0Ev5QQ;;EAEE,+BAAA;A1E05QV;;A0Ex5QQ;;EAEE,gCAAA;A1E25QV;;A0Ez5QQ;;EAEE,8BAAA;A1E45QV;;A0E36QQ;EAAgC,0BAAA;A1E+6QxC;;A0E96QQ;;EAEE,8BAAA;A1Ei7QV;;A0E/6QQ;;EAEE,gCAAA;A1Ek7QV;;A0Eh7QQ;;EAEE,iCAAA;A1Em7QV;;A0Ej7QQ;;EAEE,+BAAA;A1Eo7QV;;A0En8QQ;EAAgC,uBAAA;A1Eu8QxC;;A0Et8QQ;;EAEE,2BAAA;A1Ey8QV;;A0Ev8QQ;;EAEE,6BAAA;A1E08QV;;A0Ex8QQ;;EAEE,8BAAA;A1E28QV;;A0Ez8QQ;;EAEE,4BAAA;A1E48QV;;A0E39QQ;EAAgC,qBAAA;A1E+9QxC;;A0E99QQ;;EAEE,yBAAA;A1Ei+QV;;A0E/9QQ;;EAEE,2BAAA;A1Ek+QV;;A0Eh+QQ;;EAEE,4BAAA;A1Em+QV;;A0Ej+QQ;;EAEE,0BAAA;A1Eo+QV;;A0En/QQ;EAAgC,4BAAA;A1Eu/QxC;;A0Et/QQ;;EAEE,gCAAA;A1Ey/QV;;A0Ev/QQ;;EAEE,kCAAA;A1E0/QV;;A0Ex/QQ;;EAEE,mCAAA;A1E2/QV;;A0Ez/QQ;;EAEE,iCAAA;A1E4/QV;;A0E3gRQ;EAAgC,2BAAA;A1E+gRxC;;A0E9gRQ;;EAEE,+BAAA;A1EihRV;;A0E/gRQ;;EAEE,iCAAA;A1EkhRV;;A0EhhRQ;;EAEE,kCAAA;A1EmhRV;;A0EjhRQ;;EAEE,gCAAA;A1EohRV;;A0EniRQ;EAAgC,wBAAA;A1EuiRxC;;A0EtiRQ;;EAEE,4BAAA;A1EyiRV;;A0EviRQ;;EAEE,8BAAA;A1E0iRV;;A0ExiRQ;;EAEE,+BAAA;A1E2iRV;;A0EziRQ;;EAEE,6BAAA;A1E4iRV;;A0E3jRQ;EAAgC,0BAAA;A1E+jRxC;;A0E9jRQ;;EAEE,8BAAA;A1EikRV;;A0E/jRQ;;EAEE,gCAAA;A1EkkRV;;A0EhkRQ;;EAEE,iCAAA;A1EmkRV;;A0EjkRQ;;EAEE,+BAAA;A1EokRV;;A0EnlRQ;EAAgC,2BAAA;A1EulRxC;;A0EtlRQ;;EAEE,+BAAA;A1EylRV;;A0EvlRQ;;EAEE,iCAAA;A1E0lRV;;A0ExlRQ;;EAEE,kCAAA;A1E2lRV;;A0EzlRQ;;EAEE,gCAAA;A1E4lRV;;A0E3mRQ;EAAgC,wBAAA;A1E+mRxC;;A0E9mRQ;;EAEE,4BAAA;A1EinRV;;A0E/mRQ;;EAEE,8BAAA;A1EknRV;;A0EhnRQ;;EAEE,+BAAA;A1EmnRV;;A0EjnRQ;;EAEE,6BAAA;A1EonRV;;A0E5mRQ;EAAwB,4BAAA;A1EgnRhC;;A0E/mRQ;;EAEE,gCAAA;A1EknRV;;A0EhnRQ;;EAEE,kCAAA;A1EmnRV;;A0EjnRQ;;EAEE,mCAAA;A1EonRV;;A0ElnRQ;;EAEE,iCAAA;A1EqnRV;;A0EpoRQ;EAAwB,2BAAA;A1EwoRhC;;A0EvoRQ;;EAEE,+BAAA;A1E0oRV;;A0ExoRQ;;EAEE,iCAAA;A1E2oRV;;A0EzoRQ;;EAEE,kCAAA;A1E4oRV;;A0E1oRQ;;EAEE,gCAAA;A1E6oRV;;A0E5pRQ;EAAwB,wBAAA;A1EgqRhC;;A0E/pRQ;;EAEE,4BAAA;A1EkqRV;;A0EhqRQ;;EAEE,8BAAA;A1EmqRV;;A0EjqRQ;;EAEE,+BAAA;A1EoqRV;;A0ElqRQ;;EAEE,6BAAA;A1EqqRV;;A0EprRQ;EAAwB,0BAAA;A1EwrRhC;;A0EvrRQ;;EAEE,8BAAA;A1E0rRV;;A0ExrRQ;;EAEE,gCAAA;A1E2rRV;;A0EzrRQ;;EAEE,iCAAA;A1E4rRV;;A0E1rRQ;;EAEE,+BAAA;A1E6rRV;;A0E5sRQ;EAAwB,2BAAA;A1EgtRhC;;A0E/sRQ;;EAEE,+BAAA;A1EktRV;;A0EhtRQ;;EAEE,iCAAA;A1EmtRV;;A0EjtRQ;;EAEE,kCAAA;A1EotRV;;A0EltRQ;;EAEE,gCAAA;A1EqtRV;;A0EpuRQ;EAAwB,wBAAA;A1EwuRhC;;A0EvuRQ;;EAEE,4BAAA;A1E0uRV;;A0ExuRQ;;EAEE,8BAAA;A1E2uRV;;A0EzuRQ;;EAEE,+BAAA;A1E4uRV;;A0E1uRQ;;EAEE,6BAAA;A1E6uRV;;A0EvuRI;EAAmB,uBAAA;A1E2uRvB;;A0E1uRI;;EAEE,2BAAA;A1E6uRN;;A0E3uRI;;EAEE,6BAAA;A1E8uRN;;A0E5uRI;;EAEE,8BAAA;A1E+uRN;;A0E7uRI;;EAEE,4BAAA;A1EgvRN;;AkBzvRI;EwDlDI;IAAgC,oBAAA;E1EgzRtC;E0E/yRM;;IAEE,wBAAA;E1EizRR;E0E/yRM;;IAEE,0BAAA;E1EizRR;E0E/yRM;;IAEE,2BAAA;E1EizRR;E0E/yRM;;IAEE,yBAAA;E1EizRR;E0Eh0RM;IAAgC,2BAAA;E1Em0RtC;E0El0RM;;IAEE,+BAAA;E1Eo0RR;E0El0RM;;IAEE,iCAAA;E1Eo0RR;E0El0RM;;IAEE,kCAAA;E1Eo0RR;E0El0RM;;IAEE,gCAAA;E1Eo0RR;E0En1RM;IAAgC,0BAAA;E1Es1RtC;E0Er1RM;;IAEE,8BAAA;E1Eu1RR;E0Er1RM;;IAEE,gCAAA;E1Eu1RR;E0Er1RM;;IAEE,iCAAA;E1Eu1RR;E0Er1RM;;IAEE,+BAAA;E1Eu1RR;E0Et2RM;IAAgC,uBAAA;E1Ey2RtC;E0Ex2RM;;IAEE,2BAAA;E1E02RR;E0Ex2RM;;IAEE,6BAAA;E1E02RR;E0Ex2RM;;IAEE,8BAAA;E1E02RR;E0Ex2RM;;IAEE,4BAAA;E1E02RR;E0Ez3RM;IAAgC,yBAAA;E1E43RtC;E0E33RM;;IAEE,6BAAA;E1E63RR;E0E33RM;;IAEE,+BAAA;E1E63RR;E0E33RM;;IAEE,gCAAA;E1E63RR;E0E33RM;;IAEE,8BAAA;E1E63RR;E0E54RM;IAAgC,0BAAA;E1E+4RtC;E0E94RM;;IAEE,8BAAA;E1Eg5RR;E0E94RM;;IAEE,gCAAA;E1Eg5RR;E0E94RM;;IAEE,iCAAA;E1Eg5RR;E0E94RM;;IAEE,+BAAA;E1Eg5RR;E0E/5RM;IAAgC,uBAAA;E1Ek6RtC;E0Ej6RM;;IAEE,2BAAA;E1Em6RR;E0Ej6RM;;IAEE,6BAAA;E1Em6RR;E0Ej6RM;;IAEE,8BAAA;E1Em6RR;E0Ej6RM;;IAEE,4BAAA;E1Em6RR;E0El7RM;IAAgC,qBAAA;E1Eq7RtC;E0Ep7RM;;IAEE,yBAAA;E1Es7RR;E0Ep7RM;;IAEE,2BAAA;E1Es7RR;E0Ep7RM;;IAEE,4BAAA;E1Es7RR;E0Ep7RM;;IAEE,0BAAA;E1Es7RR;E0Er8RM;IAAgC,4BAAA;E1Ew8RtC;E0Ev8RM;;IAEE,gCAAA;E1Ey8RR;E0Ev8RM;;IAEE,kCAAA;E1Ey8RR;E0Ev8RM;;IAEE,mCAAA;E1Ey8RR;E0Ev8RM;;IAEE,iCAAA;E1Ey8RR;E0Ex9RM;IAAgC,2BAAA;E1E29RtC;E0E19RM;;IAEE,+BAAA;E1E49RR;E0E19RM;;IAEE,iCAAA;E1E49RR;E0E19RM;;IAEE,kCAAA;E1E49RR;E0E19RM;;IAEE,gCAAA;E1E49RR;E0E3+RM;IAAgC,wBAAA;E1E8+RtC;E0E7+RM;;IAEE,4BAAA;E1E++RR;E0E7+RM;;IAEE,8BAAA;E1E++RR;E0E7+RM;;IAEE,+BAAA;E1E++RR;E0E7+RM;;IAEE,6BAAA;E1E++RR;E0E9/RM;IAAgC,0BAAA;E1EigStC;E0EhgSM;;IAEE,8BAAA;E1EkgSR;E0EhgSM;;IAEE,gCAAA;E1EkgSR;E0EhgSM;;IAEE,iCAAA;E1EkgSR;E0EhgSM;;IAEE,+BAAA;E1EkgSR;E0EjhSM;IAAgC,2BAAA;E1EohStC;E0EnhSM;;IAEE,+BAAA;E1EqhSR;E0EnhSM;;IAEE,iCAAA;E1EqhSR;E0EnhSM;;IAEE,kCAAA;E1EqhSR;E0EnhSM;;IAEE,gCAAA;E1EqhSR;E0EpiSM;IAAgC,wBAAA;E1EuiStC;E0EtiSM;;IAEE,4BAAA;E1EwiSR;E0EtiSM;;IAEE,8BAAA;E1EwiSR;E0EtiSM;;IAEE,+BAAA;E1EwiSR;E0EtiSM;;IAEE,6BAAA;E1EwiSR;E0EhiSM;IAAwB,4BAAA;E1EmiS9B;E0EliSM;;IAEE,gCAAA;E1EoiSR;E0EliSM;;IAEE,kCAAA;E1EoiSR;E0EliSM;;IAEE,mCAAA;E1EoiSR;E0EliSM;;IAEE,iCAAA;E1EoiSR;E0EnjSM;IAAwB,2BAAA;E1EsjS9B;E0ErjSM;;IAEE,+BAAA;E1EujSR;E0ErjSM;;IAEE,iCAAA;E1EujSR;E0ErjSM;;IAEE,kCAAA;E1EujSR;E0ErjSM;;IAEE,gCAAA;E1EujSR;E0EtkSM;IAAwB,wBAAA;E1EykS9B;E0ExkSM;;IAEE,4BAAA;E1E0kSR;E0ExkSM;;IAEE,8BAAA;E1E0kSR;E0ExkSM;;IAEE,+BAAA;E1E0kSR;E0ExkSM;;IAEE,6BAAA;E1E0kSR;E0EzlSM;IAAwB,0BAAA;E1E4lS9B;E0E3lSM;;IAEE,8BAAA;E1E6lSR;E0E3lSM;;IAEE,gCAAA;E1E6lSR;E0E3lSM;;IAEE,iCAAA;E1E6lSR;E0E3lSM;;IAEE,+BAAA;E1E6lSR;E0E5mSM;IAAwB,2BAAA;E1E+mS9B;E0E9mSM;;IAEE,+BAAA;E1EgnSR;E0E9mSM;;IAEE,iCAAA;E1EgnSR;E0E9mSM;;IAEE,kCAAA;E1EgnSR;E0E9mSM;;IAEE,gCAAA;E1EgnSR;E0E/nSM;IAAwB,wBAAA;E1EkoS9B;E0EjoSM;;IAEE,4BAAA;E1EmoSR;E0EjoSM;;IAEE,8BAAA;E1EmoSR;E0EjoSM;;IAEE,+BAAA;E1EmoSR;E0EjoSM;;IAEE,6BAAA;E1EmoSR;E0E7nSE;IAAmB,uBAAA;E1EgoSrB;E0E/nSE;;IAEE,2BAAA;E1EioSJ;E0E/nSE;;IAEE,6BAAA;E1EioSJ;E0E/nSE;;IAEE,8BAAA;E1EioSJ;E0E/nSE;;IAEE,4BAAA;E1EioSJ;AACF;AkB3oSI;EwDlDI;IAAgC,oBAAA;E1EisStC;E0EhsSM;;IAEE,wBAAA;E1EksSR;E0EhsSM;;IAEE,0BAAA;E1EksSR;E0EhsSM;;IAEE,2BAAA;E1EksSR;E0EhsSM;;IAEE,yBAAA;E1EksSR;E0EjtSM;IAAgC,2BAAA;E1EotStC;E0EntSM;;IAEE,+BAAA;E1EqtSR;E0EntSM;;IAEE,iCAAA;E1EqtSR;E0EntSM;;IAEE,kCAAA;E1EqtSR;E0EntSM;;IAEE,gCAAA;E1EqtSR;E0EpuSM;IAAgC,0BAAA;E1EuuStC;E0EtuSM;;IAEE,8BAAA;E1EwuSR;E0EtuSM;;IAEE,gCAAA;E1EwuSR;E0EtuSM;;IAEE,iCAAA;E1EwuSR;E0EtuSM;;IAEE,+BAAA;E1EwuSR;E0EvvSM;IAAgC,uBAAA;E1E0vStC;E0EzvSM;;IAEE,2BAAA;E1E2vSR;E0EzvSM;;IAEE,6BAAA;E1E2vSR;E0EzvSM;;IAEE,8BAAA;E1E2vSR;E0EzvSM;;IAEE,4BAAA;E1E2vSR;E0E1wSM;IAAgC,yBAAA;E1E6wStC;E0E5wSM;;IAEE,6BAAA;E1E8wSR;E0E5wSM;;IAEE,+BAAA;E1E8wSR;E0E5wSM;;IAEE,gCAAA;E1E8wSR;E0E5wSM;;IAEE,8BAAA;E1E8wSR;E0E7xSM;IAAgC,0BAAA;E1EgyStC;E0E/xSM;;IAEE,8BAAA;E1EiySR;E0E/xSM;;IAEE,gCAAA;E1EiySR;E0E/xSM;;IAEE,iCAAA;E1EiySR;E0E/xSM;;IAEE,+BAAA;E1EiySR;E0EhzSM;IAAgC,uBAAA;E1EmzStC;E0ElzSM;;IAEE,2BAAA;E1EozSR;E0ElzSM;;IAEE,6BAAA;E1EozSR;E0ElzSM;;IAEE,8BAAA;E1EozSR;E0ElzSM;;IAEE,4BAAA;E1EozSR;E0En0SM;IAAgC,qBAAA;E1Es0StC;E0Er0SM;;IAEE,yBAAA;E1Eu0SR;E0Er0SM;;IAEE,2BAAA;E1Eu0SR;E0Er0SM;;IAEE,4BAAA;E1Eu0SR;E0Er0SM;;IAEE,0BAAA;E1Eu0SR;E0Et1SM;IAAgC,4BAAA;E1Ey1StC;E0Ex1SM;;IAEE,gCAAA;E1E01SR;E0Ex1SM;;IAEE,kCAAA;E1E01SR;E0Ex1SM;;IAEE,mCAAA;E1E01SR;E0Ex1SM;;IAEE,iCAAA;E1E01SR;E0Ez2SM;IAAgC,2BAAA;E1E42StC;E0E32SM;;IAEE,+BAAA;E1E62SR;E0E32SM;;IAEE,iCAAA;E1E62SR;E0E32SM;;IAEE,kCAAA;E1E62SR;E0E32SM;;IAEE,gCAAA;E1E62SR;E0E53SM;IAAgC,wBAAA;E1E+3StC;E0E93SM;;IAEE,4BAAA;E1Eg4SR;E0E93SM;;IAEE,8BAAA;E1Eg4SR;E0E93SM;;IAEE,+BAAA;E1Eg4SR;E0E93SM;;IAEE,6BAAA;E1Eg4SR;E0E/4SM;IAAgC,0BAAA;E1Ek5StC;E0Ej5SM;;IAEE,8BAAA;E1Em5SR;E0Ej5SM;;IAEE,gCAAA;E1Em5SR;E0Ej5SM;;IAEE,iCAAA;E1Em5SR;E0Ej5SM;;IAEE,+BAAA;E1Em5SR;E0El6SM;IAAgC,2BAAA;E1Eq6StC;E0Ep6SM;;IAEE,+BAAA;E1Es6SR;E0Ep6SM;;IAEE,iCAAA;E1Es6SR;E0Ep6SM;;IAEE,kCAAA;E1Es6SR;E0Ep6SM;;IAEE,gCAAA;E1Es6SR;E0Er7SM;IAAgC,wBAAA;E1Ew7StC;E0Ev7SM;;IAEE,4BAAA;E1Ey7SR;E0Ev7SM;;IAEE,8BAAA;E1Ey7SR;E0Ev7SM;;IAEE,+BAAA;E1Ey7SR;E0Ev7SM;;IAEE,6BAAA;E1Ey7SR;E0Ej7SM;IAAwB,4BAAA;E1Eo7S9B;E0En7SM;;IAEE,gCAAA;E1Eq7SR;E0En7SM;;IAEE,kCAAA;E1Eq7SR;E0En7SM;;IAEE,mCAAA;E1Eq7SR;E0En7SM;;IAEE,iCAAA;E1Eq7SR;E0Ep8SM;IAAwB,2BAAA;E1Eu8S9B;E0Et8SM;;IAEE,+BAAA;E1Ew8SR;E0Et8SM;;IAEE,iCAAA;E1Ew8SR;E0Et8SM;;IAEE,kCAAA;E1Ew8SR;E0Et8SM;;IAEE,gCAAA;E1Ew8SR;E0Ev9SM;IAAwB,wBAAA;E1E09S9B;E0Ez9SM;;IAEE,4BAAA;E1E29SR;E0Ez9SM;;IAEE,8BAAA;E1E29SR;E0Ez9SM;;IAEE,+BAAA;E1E29SR;E0Ez9SM;;IAEE,6BAAA;E1E29SR;E0E1+SM;IAAwB,0BAAA;E1E6+S9B;E0E5+SM;;IAEE,8BAAA;E1E8+SR;E0E5+SM;;IAEE,gCAAA;E1E8+SR;E0E5+SM;;IAEE,iCAAA;E1E8+SR;E0E5+SM;;IAEE,+BAAA;E1E8+SR;E0E7/SM;IAAwB,2BAAA;E1EggT9B;E0E//SM;;IAEE,+BAAA;E1EigTR;E0E//SM;;IAEE,iCAAA;E1EigTR;E0E//SM;;IAEE,kCAAA;E1EigTR;E0E//SM;;IAEE,gCAAA;E1EigTR;E0EhhTM;IAAwB,wBAAA;E1EmhT9B;E0ElhTM;;IAEE,4BAAA;E1EohTR;E0ElhTM;;IAEE,8BAAA;E1EohTR;E0ElhTM;;IAEE,+BAAA;E1EohTR;E0ElhTM;;IAEE,6BAAA;E1EohTR;E0E9gTE;IAAmB,uBAAA;E1EihTrB;E0EhhTE;;IAEE,2BAAA;E1EkhTJ;E0EhhTE;;IAEE,6BAAA;E1EkhTJ;E0EhhTE;;IAEE,8BAAA;E1EkhTJ;E0EhhTE;;IAEE,4BAAA;E1EkhTJ;AACF;AkB5hTI;EwDlDI;IAAgC,oBAAA;E1EklTtC;E0EjlTM;;IAEE,wBAAA;E1EmlTR;E0EjlTM;;IAEE,0BAAA;E1EmlTR;E0EjlTM;;IAEE,2BAAA;E1EmlTR;E0EjlTM;;IAEE,yBAAA;E1EmlTR;E0ElmTM;IAAgC,2BAAA;E1EqmTtC;E0EpmTM;;IAEE,+BAAA;E1EsmTR;E0EpmTM;;IAEE,iCAAA;E1EsmTR;E0EpmTM;;IAEE,kCAAA;E1EsmTR;E0EpmTM;;IAEE,gCAAA;E1EsmTR;E0ErnTM;IAAgC,0BAAA;E1EwnTtC;E0EvnTM;;IAEE,8BAAA;E1EynTR;E0EvnTM;;IAEE,gCAAA;E1EynTR;E0EvnTM;;IAEE,iCAAA;E1EynTR;E0EvnTM;;IAEE,+BAAA;E1EynTR;E0ExoTM;IAAgC,uBAAA;E1E2oTtC;E0E1oTM;;IAEE,2BAAA;E1E4oTR;E0E1oTM;;IAEE,6BAAA;E1E4oTR;E0E1oTM;;IAEE,8BAAA;E1E4oTR;E0E1oTM;;IAEE,4BAAA;E1E4oTR;E0E3pTM;IAAgC,yBAAA;E1E8pTtC;E0E7pTM;;IAEE,6BAAA;E1E+pTR;E0E7pTM;;IAEE,+BAAA;E1E+pTR;E0E7pTM;;IAEE,gCAAA;E1E+pTR;E0E7pTM;;IAEE,8BAAA;E1E+pTR;E0E9qTM;IAAgC,0BAAA;E1EirTtC;E0EhrTM;;IAEE,8BAAA;E1EkrTR;E0EhrTM;;IAEE,gCAAA;E1EkrTR;E0EhrTM;;IAEE,iCAAA;E1EkrTR;E0EhrTM;;IAEE,+BAAA;E1EkrTR;E0EjsTM;IAAgC,uBAAA;E1EosTtC;E0EnsTM;;IAEE,2BAAA;E1EqsTR;E0EnsTM;;IAEE,6BAAA;E1EqsTR;E0EnsTM;;IAEE,8BAAA;E1EqsTR;E0EnsTM;;IAEE,4BAAA;E1EqsTR;E0EptTM;IAAgC,qBAAA;E1EutTtC;E0EttTM;;IAEE,yBAAA;E1EwtTR;E0EttTM;;IAEE,2BAAA;E1EwtTR;E0EttTM;;IAEE,4BAAA;E1EwtTR;E0EttTM;;IAEE,0BAAA;E1EwtTR;E0EvuTM;IAAgC,4BAAA;E1E0uTtC;E0EzuTM;;IAEE,gCAAA;E1E2uTR;E0EzuTM;;IAEE,kCAAA;E1E2uTR;E0EzuTM;;IAEE,mCAAA;E1E2uTR;E0EzuTM;;IAEE,iCAAA;E1E2uTR;E0E1vTM;IAAgC,2BAAA;E1E6vTtC;E0E5vTM;;IAEE,+BAAA;E1E8vTR;E0E5vTM;;IAEE,iCAAA;E1E8vTR;E0E5vTM;;IAEE,kCAAA;E1E8vTR;E0E5vTM;;IAEE,gCAAA;E1E8vTR;E0E7wTM;IAAgC,wBAAA;E1EgxTtC;E0E/wTM;;IAEE,4BAAA;E1EixTR;E0E/wTM;;IAEE,8BAAA;E1EixTR;E0E/wTM;;IAEE,+BAAA;E1EixTR;E0E/wTM;;IAEE,6BAAA;E1EixTR;E0EhyTM;IAAgC,0BAAA;E1EmyTtC;E0ElyTM;;IAEE,8BAAA;E1EoyTR;E0ElyTM;;IAEE,gCAAA;E1EoyTR;E0ElyTM;;IAEE,iCAAA;E1EoyTR;E0ElyTM;;IAEE,+BAAA;E1EoyTR;E0EnzTM;IAAgC,2BAAA;E1EszTtC;E0ErzTM;;IAEE,+BAAA;E1EuzTR;E0ErzTM;;IAEE,iCAAA;E1EuzTR;E0ErzTM;;IAEE,kCAAA;E1EuzTR;E0ErzTM;;IAEE,gCAAA;E1EuzTR;E0Et0TM;IAAgC,wBAAA;E1Ey0TtC;E0Ex0TM;;IAEE,4BAAA;E1E00TR;E0Ex0TM;;IAEE,8BAAA;E1E00TR;E0Ex0TM;;IAEE,+BAAA;E1E00TR;E0Ex0TM;;IAEE,6BAAA;E1E00TR;E0El0TM;IAAwB,4BAAA;E1Eq0T9B;E0Ep0TM;;IAEE,gCAAA;E1Es0TR;E0Ep0TM;;IAEE,kCAAA;E1Es0TR;E0Ep0TM;;IAEE,mCAAA;E1Es0TR;E0Ep0TM;;IAEE,iCAAA;E1Es0TR;E0Er1TM;IAAwB,2BAAA;E1Ew1T9B;E0Ev1TM;;IAEE,+BAAA;E1Ey1TR;E0Ev1TM;;IAEE,iCAAA;E1Ey1TR;E0Ev1TM;;IAEE,kCAAA;E1Ey1TR;E0Ev1TM;;IAEE,gCAAA;E1Ey1TR;E0Ex2TM;IAAwB,wBAAA;E1E22T9B;E0E12TM;;IAEE,4BAAA;E1E42TR;E0E12TM;;IAEE,8BAAA;E1E42TR;E0E12TM;;IAEE,+BAAA;E1E42TR;E0E12TM;;IAEE,6BAAA;E1E42TR;E0E33TM;IAAwB,0BAAA;E1E83T9B;E0E73TM;;IAEE,8BAAA;E1E+3TR;E0E73TM;;IAEE,gCAAA;E1E+3TR;E0E73TM;;IAEE,iCAAA;E1E+3TR;E0E73TM;;IAEE,+BAAA;E1E+3TR;E0E94TM;IAAwB,2BAAA;E1Ei5T9B;E0Eh5TM;;IAEE,+BAAA;E1Ek5TR;E0Eh5TM;;IAEE,iCAAA;E1Ek5TR;E0Eh5TM;;IAEE,kCAAA;E1Ek5TR;E0Eh5TM;;IAEE,gCAAA;E1Ek5TR;E0Ej6TM;IAAwB,wBAAA;E1Eo6T9B;E0En6TM;;IAEE,4BAAA;E1Eq6TR;E0En6TM;;IAEE,8BAAA;E1Eq6TR;E0En6TM;;IAEE,+BAAA;E1Eq6TR;E0En6TM;;IAEE,6BAAA;E1Eq6TR;E0E/5TE;IAAmB,uBAAA;E1Ek6TrB;E0Ej6TE;;IAEE,2BAAA;E1Em6TJ;E0Ej6TE;;IAEE,6BAAA;E1Em6TJ;E0Ej6TE;;IAEE,8BAAA;E1Em6TJ;E0Ej6TE;;IAEE,4BAAA;E1Em6TJ;AACF;AkB76TI;EwDlDI;IAAgC,oBAAA;E1Em+TtC;E0El+TM;;IAEE,wBAAA;E1Eo+TR;E0El+TM;;IAEE,0BAAA;E1Eo+TR;E0El+TM;;IAEE,2BAAA;E1Eo+TR;E0El+TM;;IAEE,yBAAA;E1Eo+TR;E0En/TM;IAAgC,2BAAA;E1Es/TtC;E0Er/TM;;IAEE,+BAAA;E1Eu/TR;E0Er/TM;;IAEE,iCAAA;E1Eu/TR;E0Er/TM;;IAEE,kCAAA;E1Eu/TR;E0Er/TM;;IAEE,gCAAA;E1Eu/TR;E0EtgUM;IAAgC,0BAAA;E1EygUtC;E0ExgUM;;IAEE,8BAAA;E1E0gUR;E0ExgUM;;IAEE,gCAAA;E1E0gUR;E0ExgUM;;IAEE,iCAAA;E1E0gUR;E0ExgUM;;IAEE,+BAAA;E1E0gUR;E0EzhUM;IAAgC,uBAAA;E1E4hUtC;E0E3hUM;;IAEE,2BAAA;E1E6hUR;E0E3hUM;;IAEE,6BAAA;E1E6hUR;E0E3hUM;;IAEE,8BAAA;E1E6hUR;E0E3hUM;;IAEE,4BAAA;E1E6hUR;E0E5iUM;IAAgC,yBAAA;E1E+iUtC;E0E9iUM;;IAEE,6BAAA;E1EgjUR;E0E9iUM;;IAEE,+BAAA;E1EgjUR;E0E9iUM;;IAEE,gCAAA;E1EgjUR;E0E9iUM;;IAEE,8BAAA;E1EgjUR;E0E/jUM;IAAgC,0BAAA;E1EkkUtC;E0EjkUM;;IAEE,8BAAA;E1EmkUR;E0EjkUM;;IAEE,gCAAA;E1EmkUR;E0EjkUM;;IAEE,iCAAA;E1EmkUR;E0EjkUM;;IAEE,+BAAA;E1EmkUR;E0EllUM;IAAgC,uBAAA;E1EqlUtC;E0EplUM;;IAEE,2BAAA;E1EslUR;E0EplUM;;IAEE,6BAAA;E1EslUR;E0EplUM;;IAEE,8BAAA;E1EslUR;E0EplUM;;IAEE,4BAAA;E1EslUR;E0ErmUM;IAAgC,qBAAA;E1EwmUtC;E0EvmUM;;IAEE,yBAAA;E1EymUR;E0EvmUM;;IAEE,2BAAA;E1EymUR;E0EvmUM;;IAEE,4BAAA;E1EymUR;E0EvmUM;;IAEE,0BAAA;E1EymUR;E0ExnUM;IAAgC,4BAAA;E1E2nUtC;E0E1nUM;;IAEE,gCAAA;E1E4nUR;E0E1nUM;;IAEE,kCAAA;E1E4nUR;E0E1nUM;;IAEE,mCAAA;E1E4nUR;E0E1nUM;;IAEE,iCAAA;E1E4nUR;E0E3oUM;IAAgC,2BAAA;E1E8oUtC;E0E7oUM;;IAEE,+BAAA;E1E+oUR;E0E7oUM;;IAEE,iCAAA;E1E+oUR;E0E7oUM;;IAEE,kCAAA;E1E+oUR;E0E7oUM;;IAEE,gCAAA;E1E+oUR;E0E9pUM;IAAgC,wBAAA;E1EiqUtC;E0EhqUM;;IAEE,4BAAA;E1EkqUR;E0EhqUM;;IAEE,8BAAA;E1EkqUR;E0EhqUM;;IAEE,+BAAA;E1EkqUR;E0EhqUM;;IAEE,6BAAA;E1EkqUR;E0EjrUM;IAAgC,0BAAA;E1EorUtC;E0EnrUM;;IAEE,8BAAA;E1EqrUR;E0EnrUM;;IAEE,gCAAA;E1EqrUR;E0EnrUM;;IAEE,iCAAA;E1EqrUR;E0EnrUM;;IAEE,+BAAA;E1EqrUR;E0EpsUM;IAAgC,2BAAA;E1EusUtC;E0EtsUM;;IAEE,+BAAA;E1EwsUR;E0EtsUM;;IAEE,iCAAA;E1EwsUR;E0EtsUM;;IAEE,kCAAA;E1EwsUR;E0EtsUM;;IAEE,gCAAA;E1EwsUR;E0EvtUM;IAAgC,wBAAA;E1E0tUtC;E0EztUM;;IAEE,4BAAA;E1E2tUR;E0EztUM;;IAEE,8BAAA;E1E2tUR;E0EztUM;;IAEE,+BAAA;E1E2tUR;E0EztUM;;IAEE,6BAAA;E1E2tUR;E0EntUM;IAAwB,4BAAA;E1EstU9B;E0ErtUM;;IAEE,gCAAA;E1EutUR;E0ErtUM;;IAEE,kCAAA;E1EutUR;E0ErtUM;;IAEE,mCAAA;E1EutUR;E0ErtUM;;IAEE,iCAAA;E1EutUR;E0EtuUM;IAAwB,2BAAA;E1EyuU9B;E0ExuUM;;IAEE,+BAAA;E1E0uUR;E0ExuUM;;IAEE,iCAAA;E1E0uUR;E0ExuUM;;IAEE,kCAAA;E1E0uUR;E0ExuUM;;IAEE,gCAAA;E1E0uUR;E0EzvUM;IAAwB,wBAAA;E1E4vU9B;E0E3vUM;;IAEE,4BAAA;E1E6vUR;E0E3vUM;;IAEE,8BAAA;E1E6vUR;E0E3vUM;;IAEE,+BAAA;E1E6vUR;E0E3vUM;;IAEE,6BAAA;E1E6vUR;E0E5wUM;IAAwB,0BAAA;E1E+wU9B;E0E9wUM;;IAEE,8BAAA;E1EgxUR;E0E9wUM;;IAEE,gCAAA;E1EgxUR;E0E9wUM;;IAEE,iCAAA;E1EgxUR;E0E9wUM;;IAEE,+BAAA;E1EgxUR;E0E/xUM;IAAwB,2BAAA;E1EkyU9B;E0EjyUM;;IAEE,+BAAA;E1EmyUR;E0EjyUM;;IAEE,iCAAA;E1EmyUR;E0EjyUM;;IAEE,kCAAA;E1EmyUR;E0EjyUM;;IAEE,gCAAA;E1EmyUR;E0ElzUM;IAAwB,wBAAA;E1EqzU9B;E0EpzUM;;IAEE,4BAAA;E1EszUR;E0EpzUM;;IAEE,8BAAA;E1EszUR;E0EpzUM;;IAEE,+BAAA;E1EszUR;E0EpzUM;;IAEE,6BAAA;E1EszUR;E0EhzUE;IAAmB,uBAAA;E1EmzUrB;E0ElzUE;;IAEE,2BAAA;E1EozUJ;E0ElzUE;;IAEE,6BAAA;E1EozUJ;E0ElzUE;;IAEE,8BAAA;E1EozUJ;E0ElzUE;;IAEE,4BAAA;E1EozUJ;AACF;AkB9zUI;EwDlDI;IAAgC,oBAAA;E1Eo3UtC;E0En3UM;;IAEE,wBAAA;E1Eq3UR;E0En3UM;;IAEE,0BAAA;E1Eq3UR;E0En3UM;;IAEE,2BAAA;E1Eq3UR;E0En3UM;;IAEE,yBAAA;E1Eq3UR;E0Ep4UM;IAAgC,2BAAA;E1Eu4UtC;E0Et4UM;;IAEE,+BAAA;E1Ew4UR;E0Et4UM;;IAEE,iCAAA;E1Ew4UR;E0Et4UM;;IAEE,kCAAA;E1Ew4UR;E0Et4UM;;IAEE,gCAAA;E1Ew4UR;E0Ev5UM;IAAgC,0BAAA;E1E05UtC;E0Ez5UM;;IAEE,8BAAA;E1E25UR;E0Ez5UM;;IAEE,gCAAA;E1E25UR;E0Ez5UM;;IAEE,iCAAA;E1E25UR;E0Ez5UM;;IAEE,+BAAA;E1E25UR;E0E16UM;IAAgC,uBAAA;E1E66UtC;E0E56UM;;IAEE,2BAAA;E1E86UR;E0E56UM;;IAEE,6BAAA;E1E86UR;E0E56UM;;IAEE,8BAAA;E1E86UR;E0E56UM;;IAEE,4BAAA;E1E86UR;E0E77UM;IAAgC,yBAAA;E1Eg8UtC;E0E/7UM;;IAEE,6BAAA;E1Ei8UR;E0E/7UM;;IAEE,+BAAA;E1Ei8UR;E0E/7UM;;IAEE,gCAAA;E1Ei8UR;E0E/7UM;;IAEE,8BAAA;E1Ei8UR;E0Eh9UM;IAAgC,0BAAA;E1Em9UtC;E0El9UM;;IAEE,8BAAA;E1Eo9UR;E0El9UM;;IAEE,gCAAA;E1Eo9UR;E0El9UM;;IAEE,iCAAA;E1Eo9UR;E0El9UM;;IAEE,+BAAA;E1Eo9UR;E0En+UM;IAAgC,uBAAA;E1Es+UtC;E0Er+UM;;IAEE,2BAAA;E1Eu+UR;E0Er+UM;;IAEE,6BAAA;E1Eu+UR;E0Er+UM;;IAEE,8BAAA;E1Eu+UR;E0Er+UM;;IAEE,4BAAA;E1Eu+UR;E0Et/UM;IAAgC,qBAAA;E1Ey/UtC;E0Ex/UM;;IAEE,yBAAA;E1E0/UR;E0Ex/UM;;IAEE,2BAAA;E1E0/UR;E0Ex/UM;;IAEE,4BAAA;E1E0/UR;E0Ex/UM;;IAEE,0BAAA;E1E0/UR;E0EzgVM;IAAgC,4BAAA;E1E4gVtC;E0E3gVM;;IAEE,gCAAA;E1E6gVR;E0E3gVM;;IAEE,kCAAA;E1E6gVR;E0E3gVM;;IAEE,mCAAA;E1E6gVR;E0E3gVM;;IAEE,iCAAA;E1E6gVR;E0E5hVM;IAAgC,2BAAA;E1E+hVtC;E0E9hVM;;IAEE,+BAAA;E1EgiVR;E0E9hVM;;IAEE,iCAAA;E1EgiVR;E0E9hVM;;IAEE,kCAAA;E1EgiVR;E0E9hVM;;IAEE,gCAAA;E1EgiVR;E0E/iVM;IAAgC,wBAAA;E1EkjVtC;E0EjjVM;;IAEE,4BAAA;E1EmjVR;E0EjjVM;;IAEE,8BAAA;E1EmjVR;E0EjjVM;;IAEE,+BAAA;E1EmjVR;E0EjjVM;;IAEE,6BAAA;E1EmjVR;E0ElkVM;IAAgC,0BAAA;E1EqkVtC;E0EpkVM;;IAEE,8BAAA;E1EskVR;E0EpkVM;;IAEE,gCAAA;E1EskVR;E0EpkVM;;IAEE,iCAAA;E1EskVR;E0EpkVM;;IAEE,+BAAA;E1EskVR;E0ErlVM;IAAgC,2BAAA;E1EwlVtC;E0EvlVM;;IAEE,+BAAA;E1EylVR;E0EvlVM;;IAEE,iCAAA;E1EylVR;E0EvlVM;;IAEE,kCAAA;E1EylVR;E0EvlVM;;IAEE,gCAAA;E1EylVR;E0ExmVM;IAAgC,wBAAA;E1E2mVtC;E0E1mVM;;IAEE,4BAAA;E1E4mVR;E0E1mVM;;IAEE,8BAAA;E1E4mVR;E0E1mVM;;IAEE,+BAAA;E1E4mVR;E0E1mVM;;IAEE,6BAAA;E1E4mVR;E0EpmVM;IAAwB,4BAAA;E1EumV9B;E0EtmVM;;IAEE,gCAAA;E1EwmVR;E0EtmVM;;IAEE,kCAAA;E1EwmVR;E0EtmVM;;IAEE,mCAAA;E1EwmVR;E0EtmVM;;IAEE,iCAAA;E1EwmVR;E0EvnVM;IAAwB,2BAAA;E1E0nV9B;E0EznVM;;IAEE,+BAAA;E1E2nVR;E0EznVM;;IAEE,iCAAA;E1E2nVR;E0EznVM;;IAEE,kCAAA;E1E2nVR;E0EznVM;;IAEE,gCAAA;E1E2nVR;E0E1oVM;IAAwB,wBAAA;E1E6oV9B;E0E5oVM;;IAEE,4BAAA;E1E8oVR;E0E5oVM;;IAEE,8BAAA;E1E8oVR;E0E5oVM;;IAEE,+BAAA;E1E8oVR;E0E5oVM;;IAEE,6BAAA;E1E8oVR;E0E7pVM;IAAwB,0BAAA;E1EgqV9B;E0E/pVM;;IAEE,8BAAA;E1EiqVR;E0E/pVM;;IAEE,gCAAA;E1EiqVR;E0E/pVM;;IAEE,iCAAA;E1EiqVR;E0E/pVM;;IAEE,+BAAA;E1EiqVR;E0EhrVM;IAAwB,2BAAA;E1EmrV9B;E0ElrVM;;IAEE,+BAAA;E1EorVR;E0ElrVM;;IAEE,iCAAA;E1EorVR;E0ElrVM;;IAEE,kCAAA;E1EorVR;E0ElrVM;;IAEE,gCAAA;E1EorVR;E0EnsVM;IAAwB,wBAAA;E1EssV9B;E0ErsVM;;IAEE,4BAAA;E1EusVR;E0ErsVM;;IAEE,8BAAA;E1EusVR;E0ErsVM;;IAEE,+BAAA;E1EusVR;E0ErsVM;;IAEE,6BAAA;E1EusVR;E0EjsVE;IAAmB,uBAAA;E1EosVrB;E0EnsVE;;IAEE,2BAAA;E1EqsVJ;E0EnsVE;;IAEE,6BAAA;E1EqsVJ;E0EnsVE;;IAEE,8BAAA;E1EqsVJ;E0EnsVE;;IAEE,4BAAA;E1EqsVJ;AACF;AkB/sVI;EwDlDI;IAAgC,oBAAA;E1EqwVtC;E0EpwVM;;IAEE,wBAAA;E1EswVR;E0EpwVM;;IAEE,0BAAA;E1EswVR;E0EpwVM;;IAEE,2BAAA;E1EswVR;E0EpwVM;;IAEE,yBAAA;E1EswVR;E0ErxVM;IAAgC,2BAAA;E1EwxVtC;E0EvxVM;;IAEE,+BAAA;E1EyxVR;E0EvxVM;;IAEE,iCAAA;E1EyxVR;E0EvxVM;;IAEE,kCAAA;E1EyxVR;E0EvxVM;;IAEE,gCAAA;E1EyxVR;E0ExyVM;IAAgC,0BAAA;E1E2yVtC;E0E1yVM;;IAEE,8BAAA;E1E4yVR;E0E1yVM;;IAEE,gCAAA;E1E4yVR;E0E1yVM;;IAEE,iCAAA;E1E4yVR;E0E1yVM;;IAEE,+BAAA;E1E4yVR;E0E3zVM;IAAgC,uBAAA;E1E8zVtC;E0E7zVM;;IAEE,2BAAA;E1E+zVR;E0E7zVM;;IAEE,6BAAA;E1E+zVR;E0E7zVM;;IAEE,8BAAA;E1E+zVR;E0E7zVM;;IAEE,4BAAA;E1E+zVR;E0E90VM;IAAgC,yBAAA;E1Ei1VtC;E0Eh1VM;;IAEE,6BAAA;E1Ek1VR;E0Eh1VM;;IAEE,+BAAA;E1Ek1VR;E0Eh1VM;;IAEE,gCAAA;E1Ek1VR;E0Eh1VM;;IAEE,8BAAA;E1Ek1VR;E0Ej2VM;IAAgC,0BAAA;E1Eo2VtC;E0En2VM;;IAEE,8BAAA;E1Eq2VR;E0En2VM;;IAEE,gCAAA;E1Eq2VR;E0En2VM;;IAEE,iCAAA;E1Eq2VR;E0En2VM;;IAEE,+BAAA;E1Eq2VR;E0Ep3VM;IAAgC,uBAAA;E1Eu3VtC;E0Et3VM;;IAEE,2BAAA;E1Ew3VR;E0Et3VM;;IAEE,6BAAA;E1Ew3VR;E0Et3VM;;IAEE,8BAAA;E1Ew3VR;E0Et3VM;;IAEE,4BAAA;E1Ew3VR;E0Ev4VM;IAAgC,qBAAA;E1E04VtC;E0Ez4VM;;IAEE,yBAAA;E1E24VR;E0Ez4VM;;IAEE,2BAAA;E1E24VR;E0Ez4VM;;IAEE,4BAAA;E1E24VR;E0Ez4VM;;IAEE,0BAAA;E1E24VR;E0E15VM;IAAgC,4BAAA;E1E65VtC;E0E55VM;;IAEE,gCAAA;E1E85VR;E0E55VM;;IAEE,kCAAA;E1E85VR;E0E55VM;;IAEE,mCAAA;E1E85VR;E0E55VM;;IAEE,iCAAA;E1E85VR;E0E76VM;IAAgC,2BAAA;E1Eg7VtC;E0E/6VM;;IAEE,+BAAA;E1Ei7VR;E0E/6VM;;IAEE,iCAAA;E1Ei7VR;E0E/6VM;;IAEE,kCAAA;E1Ei7VR;E0E/6VM;;IAEE,gCAAA;E1Ei7VR;E0Eh8VM;IAAgC,wBAAA;E1Em8VtC;E0El8VM;;IAEE,4BAAA;E1Eo8VR;E0El8VM;;IAEE,8BAAA;E1Eo8VR;E0El8VM;;IAEE,+BAAA;E1Eo8VR;E0El8VM;;IAEE,6BAAA;E1Eo8VR;E0En9VM;IAAgC,0BAAA;E1Es9VtC;E0Er9VM;;IAEE,8BAAA;E1Eu9VR;E0Er9VM;;IAEE,gCAAA;E1Eu9VR;E0Er9VM;;IAEE,iCAAA;E1Eu9VR;E0Er9VM;;IAEE,+BAAA;E1Eu9VR;E0Et+VM;IAAgC,2BAAA;E1Ey+VtC;E0Ex+VM;;IAEE,+BAAA;E1E0+VR;E0Ex+VM;;IAEE,iCAAA;E1E0+VR;E0Ex+VM;;IAEE,kCAAA;E1E0+VR;E0Ex+VM;;IAEE,gCAAA;E1E0+VR;E0Ez/VM;IAAgC,wBAAA;E1E4/VtC;E0E3/VM;;IAEE,4BAAA;E1E6/VR;E0E3/VM;;IAEE,8BAAA;E1E6/VR;E0E3/VM;;IAEE,+BAAA;E1E6/VR;E0E3/VM;;IAEE,6BAAA;E1E6/VR;E0Er/VM;IAAwB,4BAAA;E1Ew/V9B;E0Ev/VM;;IAEE,gCAAA;E1Ey/VR;E0Ev/VM;;IAEE,kCAAA;E1Ey/VR;E0Ev/VM;;IAEE,mCAAA;E1Ey/VR;E0Ev/VM;;IAEE,iCAAA;E1Ey/VR;E0ExgWM;IAAwB,2BAAA;E1E2gW9B;E0E1gWM;;IAEE,+BAAA;E1E4gWR;E0E1gWM;;IAEE,iCAAA;E1E4gWR;E0E1gWM;;IAEE,kCAAA;E1E4gWR;E0E1gWM;;IAEE,gCAAA;E1E4gWR;E0E3hWM;IAAwB,wBAAA;E1E8hW9B;E0E7hWM;;IAEE,4BAAA;E1E+hWR;E0E7hWM;;IAEE,8BAAA;E1E+hWR;E0E7hWM;;IAEE,+BAAA;E1E+hWR;E0E7hWM;;IAEE,6BAAA;E1E+hWR;E0E9iWM;IAAwB,0BAAA;E1EijW9B;E0EhjWM;;IAEE,8BAAA;E1EkjWR;E0EhjWM;;IAEE,gCAAA;E1EkjWR;E0EhjWM;;IAEE,iCAAA;E1EkjWR;E0EhjWM;;IAEE,+BAAA;E1EkjWR;E0EjkWM;IAAwB,2BAAA;E1EokW9B;E0EnkWM;;IAEE,+BAAA;E1EqkWR;E0EnkWM;;IAEE,iCAAA;E1EqkWR;E0EnkWM;;IAEE,kCAAA;E1EqkWR;E0EnkWM;;IAEE,gCAAA;E1EqkWR;E0EplWM;IAAwB,wBAAA;E1EulW9B;E0EtlWM;;IAEE,4BAAA;E1EwlWR;E0EtlWM;;IAEE,8BAAA;E1EwlWR;E0EtlWM;;IAEE,+BAAA;E1EwlWR;E0EtlWM;;IAEE,6BAAA;E1EwlWR;E0EllWE;IAAmB,uBAAA;E1EqlWrB;E0EplWE;;IAEE,2BAAA;E1EslWJ;E0EplWE;;IAEE,6BAAA;E1EslWJ;E0EplWE;;IAEE,8BAAA;E1EslWJ;E0EplWE;;IAEE,4BAAA;E1EslWJ;AACF;A2EvpWE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EAEA,oBAAA;EACA,WAAA;EAEA,kCAAA;A3EupWJ;;A4EjqWA;EAAkB,4GAAA;A5EqqWlB;;A4EjqWA;EAAiB,8BAAA;A5EqqWjB;;A4EpqWA;EAAiB,8BAAA;A5EwqWjB;;A4EvqWA;EAAiB,8BAAA;A5E2qWjB;;A4E1qWA;ECTE,gBAAA;EACA,uBAAA;EACA,mBAAA;A7EurWF;;A4ExqWI;EACE,2BAAA;A5E2qWN;;A4EzqWI;EACE,4BAAA;A5E4qWN;;A4E1qWI;EAAwB,6BAAA;A5E8qW5B;;AkB7oWI;E0DvCA;IACE,2BAAA;E5EwrWJ;E4EtrWE;IACE,4BAAA;E5EwrWJ;E4EtrWE;IAAwB,6BAAA;E5EyrW1B;AACF;AkBzpWI;E0DvCA;IACE,2BAAA;E5EmsWJ;E4EjsWE;IACE,4BAAA;E5EmsWJ;E4EjsWE;IAAwB,6BAAA;E5EosW1B;AACF;AkBpqWI;E0DvCA;IACE,2BAAA;E5E8sWJ;E4E5sWE;IACE,4BAAA;E5E8sWJ;E4E5sWE;IAAwB,6BAAA;E5E+sW1B;AACF;AkB/qWI;E0DvCA;IACE,2BAAA;E5EytWJ;E4EvtWE;IACE,4BAAA;E5EytWJ;E4EvtWE;IAAwB,6BAAA;E5E0tW1B;AACF;AkB1rWI;E0DvCA;IACE,2BAAA;E5EouWJ;E4EluWE;IACE,4BAAA;E5EouWJ;E4EluWE;IAAwB,6BAAA;E5EquW1B;AACF;AkBrsWI;E0DvCA;IACE,2BAAA;E5E+uWJ;E4E7uWE;IACE,4BAAA;E5E+uWJ;E4E7uWE;IAAwB,6BAAA;E5EgvW1B;AACF;A4E3uWA;EAAmB,oCAAA;A5E8uWnB;;A4E7uWA;EAAmB,oCAAA;A5EivWnB;;A4EhvWA;EAAmB,qCAAA;A5EovWnB;;A4EhvWA;EAAuB,2BAAA;A5EovWvB;;A4EnvWA;EAAuB,+BAAA;A5EuvWvB;;A4EtvWA;EAAuB,2BAAA;A5E0vWvB;;A4EzvWA;EAAuB,2BAAA;A5E6vWvB;;A4E5vWA;EAAuB,8BAAA;A5EgwWvB;;A4E/vWA;EAAuB,6BAAA;A5EmwWvB;;A4E/vWA;EAAc,sBAAA;A5EmwWd;;A8E9yWE;EACE,yBAAA;A9EizWJ;;ASvyWE;EqELM,yBAAA;A9EgzWR;;A8EtzWE;EACE,yBAAA;A9EyzWJ;;AS/yWE;EqELM,yBAAA;A9EwzWR;;A8E9zWE;EACE,yBAAA;A9Ei0WJ;;ASvzWE;EqELM,yBAAA;A9Eg0WR;;A8Et0WE;EACE,yBAAA;A9Ey0WJ;;AS/zWE;EqELM,yBAAA;A9Ew0WR;;A8E90WE;EACE,yBAAA;A9Ei1WJ;;ASv0WE;EqELM,yBAAA;A9Eg1WR;;A8Et1WE;EACE,yBAAA;A9Ey1WJ;;AS/0WE;EqELM,yBAAA;A9Ew1WR;;A8E91WE;EACE,yBAAA;A9Ei2WJ;;ASv1WE;EqELM,yBAAA;A9Eg2WR;;A8Et2WE;EACE,yBAAA;A9Ey2WJ;;AS/1WE;EqELM,yBAAA;A9Ew2WR;;A8E92WE;EACE,yBAAA;A9Ei3WJ;;ASv2WE;EqELM,yBAAA;A9Eg3WR;;A8Et3WE;EACE,yBAAA;A9Ey3WJ;;AS/2WE;EqELM,yBAAA;A9Ew3WR;;A4E70WA;EAAa,yBAAA;A5Ei1Wb;;A4Eh1WA;EAAc,yBAAA;A5Eo1Wd;;A4El1WA;EAAiB,oCAAA;A5Es1WjB;;A4Er1WA;EAAiB,0CAAA;A5Ey1WjB;;A4Er1WA;EG3DE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;A/Eo5WF;;A4Ez1WA;EAAwB,gCAAA;A5E61WxB;;A4E31WA;EACE,iCAAA;EACA,oCAAA;A5E81WF;;A4Ez1WA;EAAc,yBAAA;A5E61Wd;;AgFl6WA;EACE,8BAAA;AhFq6WF;;AgFl6WA;EACE,6BAAA;AhFq6WF;;AiFr6WE;EACE;;;IAKE,4BAAA;IAEA,2BAAA;EjFq6WJ;EiFj6WI;IACE,0BAAA;EjFm6WN;EiF15WE;IACE,6BAAA;EjF45WJ;EiF94WE;IACE,gCAAA;EjFg5WJ;EiF94WE;;IAEE,yBAAA;IACA,wBAAA;EjFg5WJ;EiF74WE;;IAEE,wBAAA;EjF+4WJ;EiF54WE;;;IAGE,UAAA;IACA,SAAA;EjF84WJ;EiF34WE;;IAEE,uBAAA;EjF64WJ;EiFr4WE;IACE,QzE2iC8B;ER41UlC;EiFr4WE;IACE,2BAAA;EjFu4WJ;EiFr4WE;IACE,2BAAA;EjFu4WJ;EiFn4WE;IACE,aAAA;EjFq4WJ;EiFn4WE;IACE,sBAAA;EjFq4WJ;EiFl4WE;IACE,oCAAA;EjFo4WJ;EiFl4WI;;IAEE,iCAAA;EjFo4WN;EiF/3WI;;IAEE,oCAAA;EjFi4WN;EiF73WE;IACE,cAAA;EjF+3WJ;EiF73WI;;;;IAIE,qB1E1GI;EPy+WV;EiF33WE;IACE,cAAA;IACA,qB1EhHM;EP6+WV;AACF;AkF5/WA;EACI,e3E0LqB;APo0WzB;;AkF9+WA;EACI,gBAAA;EACA,SAAA;EACA,UAAA;AlFi/WJ;;AkF9+WA;EACI,2EAAA;AlFi/WJ;AkFh/WI;EACI,aAAA;AlFk/WR;;AkF/+WA;EACI,eAAA;AlFk/WJ;;AkFh/WA;EACI,gBAAA;AlFm/WJ;;AkFh/WI;EACI,gBAAA;AlFm/WR;;AmFxhXA;EAAkB,uBAAA;AnF4hXlB;;AmF3hXA;EAAkB,uBAAA;AnF+hXlB;;AmF9hXA;EAAkB,uBAAA;AnFkiXlB;;AkBx+WI;EiEvDA;I7E+KE,kBAAA;I6E/KuC,gB5E0KhC;I4E1KyD,uBAAA;EnFsiXpE;EmFriXE;I7E8KE,iBAAA;I6E9KuC,uBAAA;EnFyiX3C;EmFxiXE;I7E6KE,eAAA;I6E7KuC,uBAAA;EnF4iX3C;EmF3iXE;I7E4KE,iBAAA;ENk4WJ;EmF7iXE;I7E2KE,kBAAA;ENq4WJ;EmF/iXE;I7E0KE,kBAAA;ENw4WJ;AACF;AmFhjXI;EACI,qBAAA;AnFkjXR;AmFjjXQ;EACI,kBAAA;AnFmjXZ;;AmF/iXA;EACI,mBAAA;EACA,gBAAA;EACA,uBAAA;AnFkjXJ;;AmFhiXI;EACI,6CAAA;AnFmiXR;AmFjiXI;EACI,6CAAA;AnFmiXR;AmFnhXI;EACI,2BAAA;AnFqhXR;AmF1gXE;;EACE,W5EjEK;AP8kXT;;AkB3hXI;EiEmBI;IACI,qB5E2II;EPi4Wd;AACF;AoFhlXE;EACE,yBAAA;ApFklXJ;AoFhlXE;EACE,yBAAA;ApFklXJ;AoFhlXE;EACE,yBAAA;ApFklXJ;;AqFtmXA;EACI,kBAAA;ArFymXJ;;AqFvmXA;EACI,kB9EqIa;APq+WjB;AqFzmXI;EACI,kB9EqIY;APs+WpB;AqFzmXI;EACI,kB9EiIY;AP0+WpB;AqFzmXI;EACI,mBAAA;ArF2mXR;;AqFxmXA;EACI,YAAA;EACA,eAAA;ArF2mXJ;;AqFzmXA;EACI,YAAA;EACA,WAAA;ArF4mXJ;AqF3mXI;EACI,YAAA;EACA,WAAA;ArF6mXR;AqF3mXI;EACI,YAAA;EACA,WAAA;ArF6mXR;AqF3mXI;EACI,YAAA;EACA,WAAA;ArF6mXR;AqF3mXI;EACI,YAAA;EACA,WAAA;ArF6mXR;AqF3mXI;EACI,YAAA;EACA,WAAA;ArF6mXR;;AqF1mXA;EACI,wCAAA;EACA,cAAA;EACA,cAAA;ArF6mXJ;AqF5mXI;EACI,gBAAA;ArF8mXR;AqF5mXI;EACI,cAAA;ArF8mXR;AqF5mXI;EACI,gBAAA;ArF8mXR;AqF5mXI;EACI,iBAAA;ArF8mXR;AqF5mXI;EACI,iBAAA;ArF8mXR;;AsF7pXE;EAAc,oCAAA;AtFiqXhB;;AsFhqXE;EAAgB,yBAAA;AtFoqXlB;;AsFrqXE;EAAc,oCAAA;AtFyqXhB;;AsFxqXE;EAAgB,yBAAA;AtF4qXlB;;AsF7qXE;EAAc,oCAAA;AtFirXhB;;AsFhrXE;EAAgB,yBAAA;AtForXlB;;AsFrrXE;EAAc,oCAAA;AtFyrXhB;;AsFxrXE;EAAgB,yBAAA;AtF4rXlB;;AsF7rXE;EAAc,oCAAA;AtFisXhB;;AsFhsXE;EAAgB,yBAAA;AtFosXlB;;AsFrsXE;EAAc,oCAAA;AtFysXhB;;AsFxsXE;EAAgB,yBAAA;AtF4sXlB;;AsF7sXE;EAAc,oCAAA;AtFitXhB;;AsFhtXE;EAAgB,yBAAA;AtFotXlB;;AsFrtXE;EAAc,oCAAA;AtFytXhB;;AsFxtXE;EAAgB,yBAAA;AtF4tXlB;;AsF7tXE;EAAc,oCAAA;AtFiuXhB;;AsFhuXE;EAAgB,yBAAA;AtFouXlB;;AsFruXE;EAAc,oCAAA;AtFyuXhB;;AsFxuXE;EAAgB,yBAAA;AtF4uXlB;;AsF7uXE;EAAc,oCAAA;AtFivXhB;;AsFhvXE;EAAgB,yBAAA;AtFovXlB;;AsFrvXE;EAAc,oCAAA;AtFyvXhB;;AsFxvXE;EAAgB,yBAAA;AtF4vXlB;;AsF7vXE;EAAc,oCAAA;AtFiwXhB;;AsFhwXE;EAAgB,yBAAA;AtFowXlB;;AsFrwXE;EAAc,oCAAA;AtFywXhB;;AsFxwXE;EAAgB,yBAAA;AtF4wXlB;;AsF7wXE;EAAc,oCAAA;AtFixXhB;;AsFhxXE;EAAgB,yBAAA;AtFoxXlB;;AsFrxXE;EAAc,oCAAA;AtFyxXhB;;AsFxxXE;EAAgB,yBAAA;AtF4xXlB;;AsF7xXE;EAAc,oCAAA;AtFiyXhB;;AsFhyXE;EAAgB,yBAAA;AtFoyXlB;;AsFryXE;EAAc,oCAAA;AtFyyXhB;;AsFxyXE;EAAgB,yBAAA;AtF4yXlB;;AsF7yXE;EAAc,oCAAA;AtFizXhB;;AsFhzXE;EAAgB,yBAAA;AtFozXlB;;AsFrzXE;EAAc,oCAAA;AtFyzXhB;;AsFxzXE;EAAgB,yBAAA;AtF4zXlB;;AsF7zXE;EAAc,oCAAA;AtFi0XhB;;AsFh0XE;EAAgB,yBAAA;AtFo0XlB;;AsFr0XE;EAAc,oCAAA;AtFy0XhB;;AsFx0XE;EAAgB,yBAAA;AtF40XlB;;AsFx0XE;EACE,oCAAA;AtF20XJ;;AsF50XE;EACE,oCAAA;AtF+0XJ;;AsFh1XE;EACE,oCAAA;AtFm1XJ;;AsFp1XE;EACE,oCAAA;AtFu1XJ;;AsFx1XE;EACE,oCAAA;AtF21XJ;;AsF51XE;EACE,oCAAA;AtF+1XJ;;AsFh2XE;EACE,oCAAA;AtFm2XJ;;AsFp2XE;EACE,oCAAA;AtFu2XJ;;AsFx2XE;EACE,oCAAA;AtF22XJ;;AsFr2XI;EACE,+LAHQ;AtF22Xd;;AsFp2XA;EACE,+CAAA;AtFu2XF;;AsFr2XA;EACE,+CAAA;AtFw2XF;;AsFt2XA;EACE,+CAAA;AtFy2XF;;AsFv2XA;EACE,+CAAA;AtF02XF;;AsFx2XA;EACE,+CAAA;AtF22XF;;AsFz2XA;EACE,+CAAA;AtF42XF;;AsF12XA;EACE,+CAAA;AtF62XF;;AsF32XA;EACE,+CAAA;AtF82XF;;AsF52XA;EACE,+CAAA;AtF+2XF;;AuFr6XI;EACI,yBAAA;AvFw6XR;;AwFv6XE;EACE,sBAAA;AxF06XJ;;AwFx6XE;EACE,0BAAA;AxF26XJ;;AwFz6XE;EACE,0BAAA;AxF46XJ;;AwFn7XE;EACE,sBAAA;AxFs7XJ;;AwFp7XE;EACE,0BAAA;AxFu7XJ;;AwFr7XE;EACE,0BAAA;AxFw7XJ;;AwF/7XE;EACE,uBAAA;AxFk8XJ;;AwFh8XE;EACE,2BAAA;AxFm8XJ;;AwFj8XE;EACE,2BAAA;AxFo8XJ;;AwF38XE;EACE,uBAAA;AxF88XJ;;AwF58XE;EACE,2BAAA;AxF+8XJ;;AwF78XE;EACE,2BAAA;AxFg9XJ;;AwFv9XE;EACE,uBAAA;AxF09XJ;;AwFx9XE;EACE,2BAAA;AxF29XJ;;AwFz9XE;EACE,2BAAA;AxF49XJ;;AwFn+XE;EACE,uBAAA;AxFs+XJ;;AwFp+XE;EACE,2BAAA;AxFu+XJ;;AwFr+XE;EACE,2BAAA;AxFw+XJ;;AwF/+XE;EACE,uBAAA;AxFk/XJ;;AwFh/XE;EACE,2BAAA;AxFm/XJ;;AwFj/XE;EACE,2BAAA;AxFo/XJ;;AwF3/XE;EACE,uBAAA;AxF8/XJ;;AwF5/XE;EACE,2BAAA;AxF+/XJ;;AwF7/XE;EACE,2BAAA;AxFggYJ;;AwFvgYE;EACE,uBAAA;AxF0gYJ;;AwFxgYE;EACE,2BAAA;AxF2gYJ;;AwFzgYE;EACE,2BAAA;AxF4gYJ;;AwFnhYE;EACE,uBAAA;AxFshYJ;;AwFphYE;EACE,2BAAA;AxFuhYJ;;AwFrhYE;EACE,2BAAA;AxFwhYJ;;AwF/hYE;EACE,uBAAA;AxFkiYJ;;AwFhiYE;EACE,2BAAA;AxFmiYJ;;AwFjiYE;EACE,2BAAA;AxFoiYJ;;AwF3iYE;EACE,uBAAA;AxF8iYJ;;AwF5iYE;EACE,2BAAA;AxF+iYJ;;AwF7iYE;EACE,2BAAA;AxFgjYJ;;AwFvjYE;EACE,uBAAA;AxF0jYJ;;AwFxjYE;EACE,2BAAA;AxF2jYJ;;AwFzjYE;EACE,2BAAA;AxF4jYJ;;AwFnkYE;EACE,uBAAA;AxFskYJ;;AwFpkYE;EACE,2BAAA;AxFukYJ;;AwFrkYE;EACE,2BAAA;AxFwkYJ;;AwF/kYE;EACE,uBAAA;AxFklYJ;;AwFhlYE;EACE,2BAAA;AxFmlYJ;;AwFjlYE;EACE,2BAAA;AxFolYJ;;AwF3lYE;EACE,uBAAA;AxF8lYJ;;AwF5lYE;EACE,2BAAA;AxF+lYJ;;AwF7lYE;EACE,2BAAA;AxFgmYJ;;AwFvmYE;EACE,uBAAA;AxF0mYJ;;AwFxmYE;EACE,2BAAA;AxF2mYJ;;AwFzmYE;EACE,2BAAA;AxF4mYJ;;AwFnnYE;EACE,uBAAA;AxFsnYJ;;AwFpnYE;EACE,2BAAA;AxFunYJ;;AwFrnYE;EACE,2BAAA;AxFwnYJ;;AwFrnYA;EACE,0BAAA;AxFwnYF;;AwFtnYA;EACE,0BAAA;AxFynYF;;AwFvnYA;EACE,6BAAA;AxF0nYF;;AwFxnYA;EACE,0BAAA;AxF2nYF;;AwFtnYE;EACE,qBAAA;AxFynYJ;;AwF1nYE;EACE,qBAAA;AxF6nYJ;;AwF9nYE;EACE,qBAAA;AxFioYJ;;AwFloYE;EACE,qBAAA;AxFqoYJ;;AwFtoYE;EACE,qBAAA;AxFyoYJ;;AwF1oYE;EACE,qBAAA;AxF6oYJ;;AwF9oYE;EACE,qBAAA;AxFipYJ;;AwFlpYE;EACE,qBAAA;AxFqpYJ;;AwFtpYE;EACE,qBAAA;AxFypYJ;;AwF1pYE;EACE,qBAAA;AxF6pYJ;;AwF9pYE;EACE,qBAAA;AxFiqYJ;;AwFlqYE;EACE,qBAAA;AxFqqYJ;;AwFtqYE;EACE,qBAAA;AxFyqYJ;;AwF1qYE;EACE,qBAAA;AxF6qYJ;;AwFhqYE;EACE;IACE,2BAAA;ExFmqYJ;EwFlqYI;IACE,uBAAA;ExFoqYN;AACF;AwFzqYE;EACE;IACE,2BAAA;ExF2qYJ;EwF1qYI;IACE,uBAAA;ExF4qYN;AACF;AwFjrYE;EACE;IACE,2BAAA;ExFmrYJ;EwFlrYI;IACE,uBAAA;ExForYN;AACF;AwFzrYE;EACE;IACE,4BAAA;ExF2rYJ;EwF1rYI;IACE,wBAAA;ExF4rYN;AACF;AwFjsYE;EACE;IACE,4BAAA;ExFmsYJ;EwFlsYI;IACE,wBAAA;ExFosYN;AACF;AwF9rYM;EACE,uBAAA;AxFgsYR;;AwFjsYM;EACE,uBAAA;AxFosYR;;AwFrsYM;EACE,uBAAA;AxFwsYR;;AwFzsYM;EACE,wBAAA;AxF4sYR;;AwF7sYM;EACE,wBAAA;AxFgtYR;;AwFxsYA;EACE;IACE,iBAAA;ExF2sYF;AACF;AwFpsYE;EACE,wBAAA;AxFssYJ;;AwFpsYE;EACE,4BAAA;AxFusYJ;;AwFrsYE;EACE,4BAAA;AxFwsYJ;;AwF/sYE;EACE,wBAAA;AxFktYJ;;AwFhtYE;EACE,4BAAA;AxFmtYJ;;AwFjtYE;EACE,4BAAA;AxFotYJ;;AwF3tYE;EACE,wBAAA;AxF8tYJ;;AwF5tYE;EACE,4BAAA;AxF+tYJ;;AwF7tYE;EACE,4BAAA;AxFguYJ;;AwFvuYE;EACE,wBAAA;AxF0uYJ;;AwFxuYE;EACE,4BAAA;AxF2uYJ;;AwFzuYE;EACE,4BAAA;AxF4uYJ;;AwFnvYE;EACE,wBAAA;AxFsvYJ;;AwFpvYE;EACE,4BAAA;AxFuvYJ;;AwFrvYE;EACE,4BAAA;AxFwvYJ;;AwF/vYE;EACE,wBAAA;AxFkwYJ;;AwFhwYE;EACE,4BAAA;AxFmwYJ;;AwFjwYE;EACE,4BAAA;AxFowYJ;;AwF3wYE;EACE,wBAAA;AxF8wYJ;;AwF5wYE;EACE,4BAAA;AxF+wYJ;;AwF7wYE;EACE,4BAAA;AxFgxYJ;;AwFvxYE;EACE,wBAAA;AxF0xYJ;;AwFxxYE;EACE,4BAAA;AxF2xYJ;;AwFzxYE;EACE,4BAAA;AxF4xYJ;;AwFnyYE;EACE,wBAAA;AxFsyYJ;;AwFpyYE;EACE,4BAAA;AxFuyYJ;;AwFryYE;EACE,4BAAA;AxFwyYJ;;AwF/yYE;EACE,wBAAA;AxFkzYJ;;AwFhzYE;EACE,4BAAA;AxFmzYJ;;AwFjzYE;EACE,4BAAA;AxFozYJ;;AwF3zYE;EACE,wBAAA;AxF8zYJ;;AwF5zYE;EACE,4BAAA;AxF+zYJ;;AwF7zYE;EACE,4BAAA;AxFg0YJ;;AwFv0YE;EACE,wBAAA;AxF00YJ;;AwFx0YE;EACE,4BAAA;AxF20YJ;;AwFz0YE;EACE,4BAAA;AxF40YJ;;AwFn1YE;EACE,wBAAA;AxFs1YJ;;AwFp1YE;EACE,4BAAA;AxFu1YJ;;AwFr1YE;EACE,4BAAA;AxFw1YJ;;AwF/1YE;EACE,wBAAA;AxFk2YJ;;AwFh2YE;EACE,4BAAA;AxFm2YJ;;AwFj2YE;EACE,4BAAA;AxFo2YJ;;AwF32YE;EACE,wBAAA;AxF82YJ;;AwF52YE;EACE,4BAAA;AxF+2YJ;;AwF72YE;EACE,4BAAA;AxFg3YJ;;AwFv3YE;EACE,wBAAA;AxF03YJ;;AwFx3YE;EACE,4BAAA;AxF23YJ;;AwFz3YE;EACE,4BAAA;AxF43YJ;;AyF18YI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;AzF68YR;AyF38YI;EACI,kBAAA;EACA,MAAA;EACA,QAAA;AzF68YR;AyF38YI;EACI,kBAAA;EACA,SAAA;EACA,OAAA;AzF68YR;AyF38YI;EACI,kBAAA;EACA,SAAA;EACA,QAAA;AzF68YR;;A0F76YA;EACI,cAAA;A1Fg7YJ;;A2Fp+YA;EACI,kBAAA;EACA,8BAAA;EACA,qBpFqdgC;EoFpdhC,kCpFiKiB;EoFhKjB,sBAAA;EACA,sBAAA;EACA,oBAAA;A3Fu+YJ;A2Ft+YI;EACI,iBAAA;A3Fw+YR;A2Ft+YI;EACI,0BAAA;EACA,kBpF+d+B;APygYvC;A2Ft+YQ;EACI,2BAAA;A3Fw+YZ;A2Fr+YI;EACI,qBAAA;EACA,+BAAA;A3Fu+YR;A2Fr+YI;EACI,wBAAA;EACA,6BAAA;A3Fu+YR;A2Fr+YI;EACI,wBAAA;EACA,8BAAA;A3Fu+YR;A2Fr+YI;EACI,cpFeQ;APw9YhB;A2Fr+YI;EACI,cpFUM;AP69Yd;A2Fr+YI;EACI,eAAA;A3Fu+YR;;A2Fn+YI;EACI,qBAAA;A3Fs+YR;;A2Fv+YI;EACI,qBAAA;A3F0+YR;;A2F3+YI;EACI,qBAAA;A3F8+YR;;A2F/+YI;EACI,qBAAA;A3Fk/YR;;A2Fn/YI;EACI,qBAAA;A3Fs/YR;;A2Fv/YI;EACI,qBAAA;A3F0/YR;;A2F3/YI;EACI,qBAAA;A3F8/YR;;A2F//YI;EACI,qBAAA;A3FkgZR;;A2FngZI;EACI,qBAAA;A3FsgZR;;A2FvgZI;EACI,qBAAA;A3F0gZR;;A2F7/YI;EACI,cAVS;EAWT,qBAAA;A3FggZR;;A2FlgZI;EACI,cAVS;EAWT,qBAAA;A3FqgZR;;A2FvgZI;EACI,cAVS;EAWT,qBAAA;A3F0gZR;;A2F5gZI;EACI,cAVS;EAWT,qBAAA;A3F+gZR;;A2FjhZI;EACI,cAVS;EAWT,qBAAA;A3FohZR;;A2FthZI;EACI,cAVS;EAWT,qBAAA;A3FyhZR;;A2F3hZI;EACI,cAVS;EAWT,qBAAA;A3F8hZR;;A2FhiZI;EACI,cAVS;EAWT,qBAAA;A3FmiZR;;A2FriZI;EACI,cAVS;EAWT,qBAAA;A3FwiZR;;A2F1iZI;EACI,cAVS;EAWT,qBAAA;A3F6iZR;;A2FhiZI;EACI,cAVI;EAWJ,yBAAA;EACA,qBAAA;A3FmiZR;;A2FjiZI;EACI,cAfI;EAgBJ,yBAAA;EACA,qBAAA;A3FoiZR;;A2F5iZI;EACI,cAVI;EAWJ,yBAAA;EACA,qBAAA;A3F+iZR;;A2F7iZI;EACI,cAfI;EAgBJ,yBAAA;EACA,qBAAA;A3FgjZR;;A2FxjZI;EACI,cAVI;EAWJ,yBAAA;EACA,qBAAA;A3F2jZR;;A2FzjZI;EACI,cAfI;EAgBJ,yBAAA;EACA,qBAAA;A3F4jZR;;A2FpkZI;EACI,cAVI;EAWJ,yBAAA;EACA,qBAAA;A3FukZR;;A2FrkZI;EACI,cAfI;EAgBJ,yBAAA;EACA,qBAAA;A3FwkZR;;A2FhlZI;EACI,cAVI;EAWJ,yBAAA;EACA,qBAAA;A3FmlZR;;A2FjlZI;EACI,cAfI;EAgBJ,yBAAA;EACA,qBAAA;A3FolZR;;A2F5lZI;EACI,cAVI;EAWJ,yBAAA;EACA,qBAAA;A3F+lZR;;A2F7lZI;EACI,cAfI;EAgBJ,yBAAA;EACA,qBAAA;A3FgmZR;;A2FxmZI;EACI,cAVI;EAWJ,yBAAA;EACA,qBAAA;A3F2mZR;;A2FzmZI;EACI,cAfI;EAgBJ,yBAAA;EACA,qBAAA;A3F4mZR;;A2FpnZI;EACI,cAVI;EAWJ,yBAAA;EACA,qBAAA;A3FunZR;;A2FrnZI;EACI,cAfI;EAgBJ,yBAAA;EACA,qBAAA;A3FwnZR;;A2FhoZI;EACI,cAVI;EAWJ,yBAAA;EACA,qBAAA;A3FmoZR;;A2FjoZI;EACI,cAfI;EAgBJ,yBAAA;EACA,qBAAA;A3FooZR;;A2F5oZI;EACI,cAVI;EAWJ,yBAAA;EACA,qBAAA;A3F+oZR;;A2F7oZI;EACI,cAfI;EAgBJ,yBAAA;EACA,qBAAA;A3FgpZR;;A2F5oZA;EACI,oBAAA;EACA,mBAAA;EACA,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,epF+DS;APglZb;A2F9oZI;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,qBAAA;EACA,WpFkY4B;EoFjY5B,UpFiY4B;EoFhY5B,gBAAA;EACA,kBAAA;EACA,wBAAA;A3FgpZR;A2F9oZI;EACI,mBAAA;EACA,0BAAA;A3FgpZR;A2F/oZQ;EACI,UAAA;EACA,aAAA;A3FipZZ;A2F9oZI;EACI,kBAAA;A3FgpZR;A2F/oZQ;EACI,WpFoXwB;EoFnXxB,UpFmXwB;EoFlXxB,aAAA;A3FipZZ;A2F/oZQ;EACI,mBAAA;EACA,0BAAA;A3FipZZ;A2FhpZY;EACI,UAAA;A3FkpZhB;A2F9oZI;EACI,kBAAA;A3FgpZR;A2F/oZQ;EACI,YAAA;EACA,WAAA;EACA,aAAA;A3FipZZ;;A2FnoZQ;EACI,cAVA;A3FgpZZ;A2FroZY;EACI,yCAAA;A3FuoZhB;;A2F1oZQ;EACI,cAVA;A3FupZZ;A2F5oZY;EACI,wCAAA;A3F8oZhB;;A2FjpZQ;EACI,cAVA;A3F8pZZ;A2FnpZY;EACI,0CAAA;A3FqpZhB;;A2FxpZQ;EACI,cAVA;A3FqqZZ;A2F1pZY;EACI,yCAAA;A3F4pZhB;;A2F/pZQ;EACI,cAVA;A3F4qZZ;A2FjqZY;EACI,0CAAA;A3FmqZhB;;A2FtqZQ;EACI,cAVA;A3FmrZZ;A2FxqZY;EACI,yCAAA;A3F0qZhB;;A2F7qZQ;EACI,cAVA;A3F0rZZ;A2F/qZY;EACI,wCAAA;A3FirZhB;;A2FprZQ;EACI,cAVA;A3FisZZ;A2FtrZY;EACI,2CAAA;A3FwrZhB;;A2F3rZQ;EACI,cAVA;A3FwsZZ;A2F7rZY;EACI,2CAAA;A3F+rZhB;;A2FlsZQ;EACI,cAVA;A3F+sZZ;A2FpsZY;EACI,2CAAA;A3FssZhB;;AkBlxZI;EyEmFA;IACI,QAAA;IACA,gBAAA;E3FmsZN;AACF;A2FhsZA;EACI;IACI,QAAA;IACA,gBAAA;E3FksZN;AACF;A2F/rZA;EACI;IACI,QAAA;IACA,gBAAA;E3FisZN;AACF;A4F72ZI;EACI,gBAAA;A5F+2ZR;A4F72ZI;EACI,gCAAA;A5F+2ZR;A4F92ZQ;EACI,gBAAA;A5Fg3ZZ;A4F72ZI;EACI,kBAAA;A5F+2ZR;A4F72ZI;EACI,qBAAA;A5F+2ZR;A4F92ZQ;EACI,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,WrF6bW;EqF5bX,SrFgbwB;EqF/axB,arFgbwB;EqF/axB,iBAAA;A5Fg3ZZ;A4F52ZQ;EACI,QAAA;EACA,2BAAA;EACA,qBAAA;EACA,gBAAA;A5F82ZZ;A4F72ZY;EACI,aAAA;A5F+2ZhB;A4F72ZY;EACI,aAAA;A5F+2ZhB;A4F72ZY;EACI,mBAAA;A5F+2ZhB;A4F72ZY;EACI,sBrFmxBG;EqFlxBH,gBCiQL;EDhQK,iBAAA;A5F+2ZhB;A4F32ZI;EACI,qBrFnCI;EqFoCJ,crFJM;APi3Zd;A4F52ZQ;EACI,crFNE;APo3Zd;A4F32ZI;EACI,kBAAA;EACA,iBAAA;EACA,mBrFoFY;APyxZpB;A4F52ZQ;EACI,kBAAA;A5F82ZZ;A4F72ZY;EACI,kBAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;A5F+2ZhB;;A4F12ZA;EACI,mBAAA;A5F62ZJ;;A4Fl2ZI;EACI,WAAA;EACA,mBAVK;A5F+2Zb;;A4Fv2ZI;EACI,WAAA;EACA,mBAVK;A5Fo3Zb;;A4F52ZI;EACI,WAAA;EACA,mBAVK;A5Fy3Zb;;A4Fj3ZI;EACI,WAAA;EACA,mBAVK;A5F83Zb;;A4Ft3ZI;EACI,WAAA;EACA,mBAVK;A5Fm4Zb;;A4F33ZI;EACI,WAAA;EACA,mBAVK;A5Fw4Zb;;A4Fh4ZI;EACI,WAAA;EACA,mBAVK;A5F64Zb;;A4Fr4ZI;EACI,WAAA;EACA,mBAVK;A5Fk5Zb;;A4F14ZI;EACI,cAAA;EACA,mBAVK;A5Fu5Zb;;A4F/4ZI;EACI,cAAA;EACA,mBAVK;A5F45Zb;;A4F94ZA;EACI,eAAA;A5Fi5ZJ;A4Fh5ZI;EACI,mBAAA;A5Fk5ZR;A4Fh5ZI;EACI,crFnDQ;APq8ZhB;A4Fh5ZI;EACI,crFxDM;AP08Zd;;A4Ft4ZA;EACI,8CAAA;EACA,YAAA;EACA,kCAAA;EACA,crFxEU;EqFyEV,gBAAA;EACA,gBrF9GK;APu/ZT;A4Fx4ZI;EACI,gBAAA;A5F04ZR;A4Fx4ZI;EACI,cAAA;A5F04ZR;A4Fx4ZI;EACI,kBAAA;A5F04ZR;A4Fz4ZQ;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;A5F24ZZ;;A4Ft4ZI;EACI,qBAhCI;A5Fy6ZZ;A4Fx4ZQ;EACI,cAlCA;A5F46ZZ;;A4F74ZI;EACI,qBAhCI;A5Fg7ZZ;A4F/4ZQ;EACI,cAlCA;A5Fm7ZZ;;A4Fp5ZI;EACI,qBAhCI;A5Fu7ZZ;A4Ft5ZQ;EACI,cAlCA;A5F07ZZ;;A4F35ZI;EACI,qBAhCI;A5F87ZZ;A4F75ZQ;EACI,cAlCA;A5Fi8ZZ;;A4Fl6ZI;EACI,qBAhCI;A5Fq8ZZ;A4Fp6ZQ;EACI,cAlCA;A5Fw8ZZ;;A4Fz6ZI;EACI,qBAhCI;A5F48ZZ;A4F36ZQ;EACI,cAlCA;A5F+8ZZ;;A4Fh7ZI;EACI,qBAhCI;A5Fm9ZZ;A4Fl7ZQ;EACI,cAlCA;A5Fs9ZZ;;A4Fv7ZI;EACI,qBAhCI;A5F09ZZ;A4Fz7ZQ;EACI,cAlCA;A5F69ZZ;;A4F97ZI;EACI,qBAhCI;A5Fi+ZZ;A4Fh8ZQ;EACI,cAlCA;A5Fo+ZZ;;A4Fr8ZI;EACI,qBAhCI;A5Fw+ZZ;A4Fv8ZQ;EACI,cAlCA;A5F2+ZZ;;A8FnlaI;EACI,evFghB4B;EuF/gB5B,gBvFghB4B;EuF/gB5B,yBvFghB4B;EuF/gB5B,uBvFghB4B;APskZpC;A8FrlaQ;EACI,cvFqCE;APkjad;A8FplaY;EACI,YAAA;A9FslahB;A8FllaY;EACI,sBvF4yBG;EuF3yBH,gBD4NC;A7Fw3ZjB;A8FhlaY;EACI,gBvFyJH;APy7Zb;;A8F1kaQ;EACI,qBAAA;EACA,iBAAA;EACA,cvFWE;APkkad;;A8FtkaY;EACI,qBAAA;A9FykahB;A8FxkagB;EACI,sBAAA;EACA,gBAAA;A9F0kapB;;A8FlkaQ;EACI,evFqGC;APg+Zb;;A+F1naA;EACI,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBxF4KS;EwF3KT,kCxFgKiB;EwF/JjB,cAAA;EACA,YAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;A/F6naJ;A+F5naI;EACI,gBAAA;EACA,aAAA;A/F8naR;A+F5naI;EACI,gBAAA;A/F8naR;A+F5naI;EACI,qBAAA;A/F8naR;A+F5naI;EACI,oBAAA;A/F8naR;A+F5naI;EACI,kBAAA;A/F8naR;A+F5naI;EACI,kBAAA;A/F8naR;A+F5naI;EACI,kBAAA;A/F8naR;A+F5naI;EACC,YAAA;A/F8naL;A+F7naK;EACC,UAAA;A/F+naN;A+F5naI;EACI,aAAA;A/F8naR;A+F5naI;EACI,8BAAA;A/F8naR;;A+FhnaI;EACI,yBAAA;A/FmnaR;;A+FjnaI;EACI,yBAAA;A/FonaR;;A+FxnaI;EACI,yBAAA;A/F2naR;;A+FznaI;EACI,yBAAA;A/F4naR;;A+FhoaI;EACI,yBAAA;A/FmoaR;;A+FjoaI;EACI,yBAAA;A/FooaR;;A+FxoaI;EACI,yBAAA;A/F2oaR;;A+FzoaI;EACI,yBAAA;A/F4oaR;;A+FhpaI;EACI,yBAAA;A/FmpaR;;A+FjpaI;EACI,yBAAA;A/FopaR;;A+FxpaI;EACI,yBAAA;A/F2paR;;A+FzpaI;EACI,yBAAA;A/F4paR;;A+FhqaI;EACI,yBAAA;A/FmqaR;;A+FjqaI;EACI,yBAAA;A/FoqaR;;A+FxqaI;EACI,yBAAA;A/F2qaR;;A+FzqaI;EACI,yBAAA;A/F4qaR;;A+FhraI;EACI,yBAAA;A/FmraR;;A+FjraI;EACI,yBAAA;A/ForaR;;A+FxraI;EACI,yBAAA;A/F2raR;;A+FzraI;EACI,yBAAA;A/F4raR;;A+FhsaI;EACI,yBAAA;A/FmsaR;;A+FjsaI;EACI,yBAAA;A/FosaR;;A+F9raE;EACI,yBAAA;A/FisaN;;AgGnwaA;EACI,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;AhGswaJ;AgGrwaI;ErEiGF,yBAAA;ErB4EI,oBAAA;EqB1EJ,oBpB8JyB;EOtPvB,kBAAA;AdgwaJ;AgGxwaI;ErE8FF,wBAAA;ErB4EI,oBAAA;EqB1EJ,iBpBuN4B;EO/S1B,kBAAA;AdswaJ;AgG1waI;EACI,gBAAA;EACA,oBAAA;AhG4waR;AgG1waI;EACI,qBAAA;EACA,mBAAA;AhG4waR;AgG3waQ;EACI,WAAA;AhG6waZ;AgG1waI;EACI,iBAAA;AhG4waR;AgG1waI;EACI,2BAAA;AhG4waR;AgG1waI;EACI,0BAAA;AhG4waR;AgGzwaQ;EACI,kBAAA;AhG2waZ;AgGxwaI;EACI,uBAAA;AhG0waR;AgGxwaI;EACI,uBAAA;AhG0waR;AgGxwaI;EACI,yBAAA;EACA,ezF0GK;EyFzGL,sBAAA;AhG0waR;AgGtwaQ;EACI,eAAA;EACA,gBAAA;AhGwwaZ;AgGtwaQ;EACI,eAAA;AhGwwaZ;AgGrwaY;EACI,eAAA;AhGuwahB;AgGnwaY;EACI,eAAA;AhGqwahB;AgGjwaY;EACI,cAAA;AhGmwahB;AgG/vaY;EACI,cAAA;EACA,gBAAA;AhGiwahB;AgG9vaQ;EACI,YAAA;EACA,kBAAA;EACA,cAAA;EACA,+BAAA;AhGgwaZ;AgG9vaQ;EACI,YAAA;EACA,kBAAA;EACA,cAAA;EACA,+BAAA;AhGgwaZ;AgG/vaY;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,gBzFiFH;EyFhFG,ezFuDH;EyFtDG,kBAAA;EACA,uBAAA;AhGiwahB;AgG7vaI;EACI,gBAAA;EACA,uBAAA;AhG+vaR;AgG7vaI;EACI,sBAAA;EACA,mBAAA;EACA,YAAA;AhG+vaR;AgG7vaI;EACI,eAAA;EACA,gBzF8DK;EyF7DL,kBAAA;EACA,mBAAA;EACA,czFzEM;APw0ad;AgG7vaI;EACI,aAAA;AhG+vaR;AgG9vaQ;EACI,iBAAA;AhGgwaZ;AgG7vaI;EACI,eAAA;AhG+vaR;AgG7vaI;EACI,qBAAA;EACA,sBAAA;AhG+vaR;AgG7vaI;EACI,gBAAA;AhG+vaR;AgG9vaQ;EACI,oBAAA;AhGgwaZ;AgG7vaI;EACI,WAAA;AhG+vaR;AgG9vaQ;EACI,iBAAA;AhGgwaZ;AgG9vaQ;EACI,YAAA;EACA,iBAAA;EACA,kBAAA;AhGgwaZ;AgG9vaQ;EACI,iBAAA;EACA,kBAAA;AhGgwaZ;;AkB11aI;E8EgGA;IrEpDF,sBAAA;IrB4EI,mBAAA;IqB1EJ,iBpBmKyB;IO3PvB,kBAAA;Ed44aF;EgGhwaM;IACI,sBAAA;EhGkwaV;EgG7vaU;IACI,cAAA;EhG+vad;AACF;AgGrvaA;EACI,kBAAA;EACA,UAAA;EACA,czFtIU;AP63ad;AgGtvaI;EACI,gBAAA;AhGwvaR;AgGtvaI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,yBAAA;EACA,WAAA;EACA,yBzFpLI;EyFqLJ,kBAAA;EACA,UAAA;EACA,oBAAA;AhGwvaR;AgGvvaQ;EACI,yBAAA;AhGyvaZ;AgGvvaQ;EA5BJ,UAAA;EACA,YAAA;EACA,WAAA;AhGsxaJ;AgGxvaI;EAhCA,UAAA;EACA,YAAA;EACA,WAAA;AhG2xaJ;AgG1vaI;EACI,yBzFlMI;AP87aZ;AgGzvaQ;EAvCJ,UAAA;EACA,YAAA;EACA,WAAA;AhGmyaJ;;AgGxuaI;EACI,cAZJ;EAaI,yBAbJ;EAcI,qBAdJ;AhGyvaJ;AgG1uaQ;EACI,WAAA;EACA,yBAjBR;EAkBQ,qBAlBR;AhG8vaJ;;AgGxuaQ;EACI,cAvBR;EAwBQ,mBAxBR;AhGmwaJ;;AgGxvaI;EACI,cAZJ;EAaI,yBAbJ;EAcI,qBAdJ;AhGywaJ;AgG1vaQ;EACI,WAAA;EACA,yBAjBR;EAkBQ,qBAlBR;AhG8waJ;;AgGxvaQ;EACI,cAvBR;EAwBQ,mBAxBR;AhGmxaJ;;AgGxwaI;EACI,cAZJ;EAaI,yBAbJ;EAcI,qBAdJ;AhGyxaJ;AgG1waQ;EACI,WAAA;EACA,yBAjBR;EAkBQ,qBAlBR;AhG8xaJ;;AgGxwaQ;EACI,cAvBR;EAwBQ,mBAxBR;AhGmyaJ;;AgGxxaI;EACI,cAZJ;EAaI,yBAbJ;EAcI,qBAdJ;AhGyyaJ;AgG1xaQ;EACI,WAAA;EACA,yBAjBR;EAkBQ,qBAlBR;AhG8yaJ;;AgGxxaQ;EACI,cAvBR;EAwBQ,mBAxBR;AhGmzaJ;;AgGxyaI;EACI,cAZJ;EAaI,yBAbJ;EAcI,qBAdJ;AhGyzaJ;AgG1yaQ;EACI,WAAA;EACA,yBAjBR;EAkBQ,qBAlBR;AhG8zaJ;;AgGxyaQ;EACI,cAvBR;EAwBQ,mBAxBR;AhGm0aJ;;AgGxzaI;EACI,cAZJ;EAaI,yBAbJ;EAcI,qBAdJ;AhGy0aJ;AgG1zaQ;EACI,WAAA;EACA,yBAjBR;EAkBQ,qBAlBR;AhG80aJ;;AgGxzaQ;EACI,cAvBR;EAwBQ,mBAxBR;AhGm1aJ;;AgGx0aI;EACI,cAZJ;EAaI,yBAbJ;EAcI,qBAdJ;AhGy1aJ;AgG10aQ;EACI,WAAA;EACA,yBAjBR;EAkBQ,qBAlBR;AhG81aJ;;AgGx0aQ;EACI,cAvBR;EAwBQ,mBAxBR;AhGm2aJ;;AgGx1aI;EACI,cAZJ;EAaI,yBAbJ;EAcI,qBAdJ;AhGy2aJ;AgG11aQ;EACI,WAAA;EACA,yBAjBR;EAkBQ,qBAlBR;AhG82aJ;;AgGx1aQ;EACI,cAvBR;EAwBQ,mBAxBR;AhGm3aJ;;AgGx2aI;EACI,cAZJ;EAaI,yBAbJ;EAcI,qBAdJ;AhGy3aJ;AgG12aQ;EACI,WAAA;EACA,yBAjBR;EAkBQ,qBAlBR;AhG83aJ;;AgGx2aQ;EACI,cAvBR;EAwBQ,mBAxBR;AhGm4aJ;;AgGx1aI;EACI,cAbJ;EAcI,yBAdJ;EAeI,yBAAA;AhG21aR;AgG11aQ;EACI,WAAA;EACA,yBAlBR;EAmBQ,qBAnBR;AhG+2aJ;;AgGn2aI;EACI,cAbJ;EAcI,yBAdJ;EAeI,yBAAA;AhGs2aR;AgGr2aQ;EACI,WAAA;EACA,yBAlBR;EAmBQ,qBAnBR;AhG03aJ;;AgG92aI;EACI,cAbJ;EAcI,yBAdJ;EAeI,yBAAA;AhGi3aR;AgGh3aQ;EACI,WAAA;EACA,yBAlBR;EAmBQ,qBAnBR;AhGq4aJ;;AgGz3aI;EACI,cAbJ;EAcI,yBAdJ;EAeI,yBAAA;AhG43aR;AgG33aQ;EACI,WAAA;EACA,yBAlBR;EAmBQ,qBAnBR;AhGg5aJ;;AgGp4aI;EACI,cAbJ;EAcI,yBAdJ;EAeI,yBAAA;AhGu4aR;AgGt4aQ;EACI,WAAA;EACA,yBAlBR;EAmBQ,qBAnBR;AhG25aJ;;AgG/4aI;EACI,cAbJ;EAcI,yBAdJ;EAeI,yBAAA;AhGk5aR;AgGj5aQ;EACI,WAAA;EACA,yBAlBR;EAmBQ,qBAnBR;AhGs6aJ;;AgG15aI;EACI,cAbJ;EAcI,yBAdJ;EAeI,yBAAA;AhG65aR;AgG55aQ;EACI,WAAA;EACA,yBAlBR;EAmBQ,qBAnBR;AhGi7aJ;;AgGr6aI;EACI,cAbJ;EAcI,yBAdJ;EAeI,yBAAA;AhGw6aR;AgGv6aQ;EACI,WAAA;EACA,yBAlBR;EAmBQ,qBAnBR;AhG47aJ;;AgGh7aI;EACI,cAbJ;EAcI,yBAdJ;EAeI,yBAAA;AhGm7aR;AgGl7aQ;EACI,WAAA;EACA,yBAlBR;EAmBQ,qBAnBR;AhGu8aJ;;AgG37aI;EACI,cAbJ;EAcI,yBAdJ;EAeI,yBAAA;AhG87aR;AgG77aQ;EACI,cAAA;EACA,yBAlBR;EAmBQ,qBAnBR;AhGk9aJ;;AgGx7aI;EACI,6BAAA;EACA,yBAAA;AhG27aR;AgGz7aI;EACI,qBzF9QI;APysbZ;AgGz7aI;EACI,qBzFlRI;AP6sbZ;AgGz7aI;EACI,czFrPM;APgrbd;AgGz7aI;EACI,gBzF5RC;APutbT;AgGx7aQ;EACI,WzFhSH;EyFiSG,mBzF7PE;EyF8PF,qBzF9PE;APwrbd;;AgGn7aQ;EACI,UAAA;AhGs7aZ;AgGp7aQ;EACI,eAAA;EACA,gBAAA;AhGs7aZ;AgGp7aQ;EACI,cAAA;EACA,iBAAA;AhGs7aZ;AgGn7aI;EACI,2BAAA;AhGq7aR;;AiGlvbQ;EACI,+BAAA;EACA,oBAAA;EACA,qBAAA;AjGqvbZ;AiGpvbY;EACI,qBAAA;EACA,mBAAA;EACA,oBAAA;AjGsvbhB;AiG/ubgB;EACI,qBAAA;EACA,sBAAA;AjGivbpB;AiG/ubgB;EACI,cAAA;AjGivbpB;AiG/ubgB;EACI,WAAA;AjGivbpB;AiG9ubY;EACI,yBAAA;AjGgvbhB;;AkG3wbA;EACI,oBAAA;AlG8wbJ;;AkG1wbA;EACI,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;AlG6wbJ;AkG5wbI;EACI,aAAA;AlG8wbR;;AkG1wbI;EACI,oBAAA;AlG6wbR;;AkG1wbA;EACI,gBAAA;EACA,yBAAA;EACA,kD3FkhBgC;AP2vapC;;AkG1wbI;EACI,kBAAA;AlG6wbR;AkG5wbQ;EACI,6BAAA;AlG8wbZ;AkG3wbI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,wBAAA;EACA,gCAAA;AlG6wbR;AkG5wbQ;EACI,uBAAA;AlG8wbZ;AkG3wbI;EACI,gCAAA;AlG6wbR;AkG3wbI;EACI,6BAAA;AlG6wbR;AkG1wbQ;EACI,gBAAA;AlG4wbZ;AkG1wbQ;EACI,gBAAA;AlG4wbZ;AkG1wbQ;EACI,eAAA;AlG4wbZ;AkG1wbQ;EACI,gBAAA;AlG4wbZ;AkGzwbI;EACI,gB3FiHK;E2FhHL,c3FjBQ;AP4xbhB;;AkGrwbI;EACI,uBAAA;EACA,sB3FovBW;E2FnvBX,sBAAA;EACA,gBL0FU;EKzFV,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;AlGwwbR;AkGvwbQ;EACI,gBLkFI;A7FurbhB;;AkGlwbY;EACI,gBL2GK;A7F0pbrB;AkGpwbgB;EACI,gBLyGC;A7F6pbrB;AkGjwbY;EACI,gBLkGG;A7FiqbnB;AkGlwbgB;EACI,gBLgGD;A7FoqbnB;AkG/vbY;EACI,gBLiJG;A7FgnbnB;AkGhwbgB;EACI,gBL+ID;A7FmnbnB;AkG7vbY;EACI,gBL0IK;A7FqnbrB;AkG9vbgB;EACI,gBLwIC;A7FwnbrB;AkG3vbY;EACI,gBLgHG;A7F6obnB;AkG5vbgB;EACI,gBL6GH;A7FipbjB;AkGzvbY;EACI,gBL8JC;A7F6lbjB;AkG1vbgB;EACI,gBL4JH;A7FgmbjB;;AkGnvbI;EACI,oBAAA;AlGsvbR;AkGpvbI;EACI,oBAAA;AlGsvbR;AkGpvbI;EACI,e3F4a4B;E2F3a5B,e3F2a4B;AP20apC;AkGrvbQ;EACI,kBAAA;AlGuvbZ;AkGpvbI;EACI,gB3Foa4B;E2Fna5B,gB3Fma4B;APm1apC;AkGrvbQ;EACI,kBAAA;AlGuvbZ;AkGpvbI;EACI,gB3F2Z4B;E2F1Z5B,gB3F0Z4B;AP41apC;AkGrvbQ;EACI,mBAAA;AlGuvbZ;AkGpvbI;EACI,gB3FqZ4B;E2FpZ5B,gB3FoZ4B;APk2apC;AkGrvbQ;EACI,kBAAA;AlGuvbZ;AkGpvbI;EACI,gB3F4Y4B;E2F3Y5B,gB3F2Y4B;AP22apC;AkGrvbQ;EACI,mBAAA;AlGuvbZ;AkGpvbI;EACI,gB3FoY4B;E2FnY5B,gB3FmY4B;APm3apC;AkGrvbQ;EACI,mBAAA;AlGuvbZ;AkGpvbI;EACI,eAAA;EACA,eAAA;AlGsvbR;AkGpvbI;EACI,iBAAA;EACA,cAAA;AlGsvbR;;AkGhvbI;EACI,gBAAA;EACA,kBAAA;AlGmvbR;;AkGhvbA;EACI;IACI,6BAAA;IACA,6BAAA;ElGmvbN;EkGhvbM;IACI,eAAA;IACA,iBAAA;ElGkvbV;EkG/ubU;IACI,cAAA;IACA,iBAAA;ElGivbd;AACF;AkGzubA;EACI,6BAAA;AlG2ubJ;;AkGvubI;EACI,qBAAA;EACA,sBAAA;AlG0ubR;;AmGp9bA;EACI,kDAAA;AnGu9bJ;AmGt9bI;EACI,iDAAA;AnGw9bR;AmGt9bI;EACI,gB5FyJiB;AP+zbzB;AmGt9bI;EACI,mBAAA;AnGw9bR;AmGt9bI;EACI,YAAA;AnGw9bR;AmGt9bI;EACI,mB5F+CY;APy6bpB;AmGt9bI;EACI,yBAAA;AnGw9bR;AmGv9bQ;EACI,qB5F0CQ;AP+6bpB;AmGv9bQ;EACI,oBAAA;AnGy9bZ;AmGt9bI;EACI,gB5F2Y4B;AP6kbpC;AmGv9bQ;EACI,oBAAA;EACA,uBAAA;AnGy9bZ;AmGr9bgB;EACI,gCAAA;AnGu9bpB;AmGl9bI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,6BAAA;AnGo9bR;AmGn9bQ;EACI,uBAAA;AnGq9bZ;AmGn9bQ;EACI,WAAA;AnGq9bZ;AmGj9bQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AnGm9bZ;AmGl9bY;EACI,gBAAA;AnGo9bhB;AmGl9bY;EACI,oBAAA;EACA,uBAAA;AnGo9bhB;AmGj9bQ;EACI,sBAAA;AnGm9bZ;AmGj9bQ;EACI,e5FkFC;E4FjFD,c5F5BE;AP++bd;AmGl9bY;EACI,oBAAA;EACA,sBAAA;AnGo9bhB;AmGh9bY;EACI,e5F2EH;APu4bb;AmG/8bQ;EACI,gB5F4FC;E4F3FD,c5FzCE;AP0/bd;AmG/8bQ;EACI,W5F/EH;APgicT;AmGh9bY;EACI,cAAA;AnGk9bhB;AmG98bI;EACI,c5FnDM;E4FoDN,kC5FqEa;E4FpEb,mBAAA;AnGg9bR;AmG78bQ;EACI,aAAA;EACA,uBAAA;AnG+8bZ;AmG98bY;EACI,eAAA;AnGg9bhB;AmG/8bgB;EACI,kBAAA;EACA,c5F/DN;E4FgEM,eAAA;EACA,cAAA;EACA,cAAA;AnGi9bpB;AmGh9boB;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,mB5F1DJ;E4F2DI,UAAA;AnGk9bxB;AmGh9boB;EACI,c5F7EV;AP+hcd;AmG/8bwB;EACI,UAAA;AnGi9b5B;AmG58boB;EACI,c5FvFV;APqicd;AmG78bwB;EACI,UAAA;AnG+8b5B;AmGz8bQ;EACI,gCAAA;AnG28bZ;AmGx8bI;EACI,eAAA;EACA,c5FpII;AP8kcZ;AmGx8bI;EACI,aAAA;EACA,oBAAA;AnG08bR;AmGx8bI;EACI,aAAA;AnG08bR;AmGx8bI;EACI,eAAA;EACA,qBAAA;EACA,c5FlHM;E4FmHN,aAAA;AnG08bR;AmGx8bQ;EACI,gBAAA;EACA,qBAAA;EACA,oBAAA;EACA,qBAAA;AnG08bZ;;AkBticI;EiFmGQ;IACI,wBAAA;IACA,eAAA;IACA,mBAAA;EnGu8bd;EmGt8bc;IACI,kBAAA;IACA,gCAAA;EnGw8blB;EmGt8bsB;IACI,oBAAA;EnGw8b1B;EmGj8bE;IACI,kBAAA;IACA,mBAAA;IACA,cAAA;IACA,eAAA;IACA,gBAAA;EnGm8bN;AACF;AkBzkcI;EiF0II;IACI,e5FgOwB;EPkublC;EmGj8bU;IACI,oBAAA;IACA,uBAAA;EnGm8bd;EmGj8bU;IACI,iBAAA;IACA,oBAAA;EnGm8bd;EmGh8bM;IACI,oB5FqNwB;I4FpNxB,qB5FoNwB;EP8ublC;AACF;AkB1lcI;EiF6JI;IACI,e5F8MwB;EPkvblC;EmG97bM;IACI,gBAAA;EnGg8bV;AACF;AoG5pcI;EACI,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,MAAA;EACA,wBAAA;EACA,4B7F4YgC;APkxbxC;AoG7pcQ;EACI,2B7F2Y4B;APoxbxC;AoG7pcQ;EACI,4B7FyY4B;APsxbxC;AoG7pcQ;EACI,2B7FuY4B;APwxbxC;AoG7pcQ;EACI,eAAA;EACA,c7FuBE;APwocd;AoG7pcQ;EACI,+BAAA;ApG+pcZ;AoG7pcQ;EACI,UAAA;EACA,WAAA;ApG+pcZ;AoG9pcY;EACI,kB7FuNW;E6FtNX,gCAAA;ApGgqchB;AoG5pcI;EACI,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,QAAA;EACA,8BAAA;EACA,yBAAA;EACA,2BAAA;EACA,c7FDM;AP+pcd;AoG7pcQ;EACI,gCAAA;ApG+pcZ;AoG5pcI;EACI,mBAAA;EACA,gBAAA;EACA,c7FnCI;E6FoCJ,qBAAA;ApG8pcR;AoG7pcQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;ApG+pcZ;AoG9pcY;EACI,gBAAA;ApGgqchB;AoG7pcQ;EACI,oBAAA;ApG+pcZ;AoG7pcQ;EACI,kBAAA;EACA,c7F+Ke;E6F9Kf,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gB7FsGC;E6FrGD,oB7F8Ke;E6F7Kf,c7F1DA;E6F2DA,sB7FnEH;E6FoEG,UAAA;EACA,yBAAA;EACA,gBAAA;E9FqGN,oBAAA;AN2jcN;AoG9pcY;EACI,c7FmLW;E6FlLX,0BAAA;E9FiGV,oBAAA;ANgkcN;AoG9pcY;E9F8FN,kBAAA;E8F5FU,Y7FwKW;E6FvKX,YAAA;ApGgqchB;AoG9pcY;EAEI,eAAA;ApG+pchB;AoG7pcY;EACI,4BAAA;EACA,eAAA;ApG+pchB;AoG7pcY;E9FiFN,oBAAA;E8F/EU,iB7FwKW;E6FvKX,a7FoKW;E6FnKX,iBAAA;EACA,qBAAA;ApG+pchB;AoG7pcY;EAEI,2BAAA;ApG8pchB;AoG5pcY;EAEI,eAAA;ApG6pchB;AoGzpcI;EACI,e7FoCK;E6FnCL,c7F1EM;E6F2EN,kBAAA;EACA,cAAA;ApG2pcR;AoG1pcQ;EACI,e7F+BC;E6F9BD,c7F/EE;AP2ucd;AoG1pcQ;EACI,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,uBAAA;ApG4pcZ;AoGxpcQ;EACI,2B7FkR4B;E6FjR5B,yBAAA;E9F6CN,oBAAA;E8F3CM,iB7FoIe;EO3PvB,kBAAA;AdkxcJ;AoGxpcQ;EACI,eAAA;ApG0pcZ;AoGzpcY;EACI,YAAA;ApG2pchB;AoGxpcQ;EACI,kBAAA;ApG0pcZ;AoGzpcY;EACI,kBAAA;ApG2pchB;AoGxpcQ;EACI,yBAAA;ApG0pcZ;AoGzpcY;EACI,qB7F7IJ;E6F8II,gBAAA;ApG2pchB;AoGxpcQ;EACI,kB7FvJH;APizcT;AoGzpcY;EACI,gBAAA;EACA,qB7FrJJ;APgzcZ;AoGxpcQ;EACI,eAAA;EACA,aAAA;EACA,YAAA;ApG0pcZ;AoGvpcY;EACI,eAAA;EACA,oCAAA;EACA,kBAAA;ApGypchB;AoGtpcQ;EAEI,qB7FxJJ;AP+ycR;AoGtpcY;EACI,4C7FiNwB;APu8bxC;AoGrpcQ;EACI,qB7F9HQ;E6F+HR,4C7FmEe;APolc3B;AoGrpcQ;EACI,YAAA;EACA,UAAA;ApGupcZ;AoGtpcY;EACI,gBAAA;ApGwpchB;AoGppcI;EACI,kBAAA;EACA,sBAAA;ApGspcR;AoGrpcQ;EACI,gBAAA;ApGupcZ;AoGppcI;EACI,4B7FwMgC;AP88bxC;AoGrpcQ;EACI,UAAA;ApGupcZ;AoGrpcQ;EACI,2B7FoM4B;APm9bxC;AoGrpcQ;EACI,4B7FkM4B;APq9bxC;AoGrpcQ;EACI,2B7FgM4B;APu9bxC;AoGlpcY;EACI,yBAAA;EACA,gBAAA;ApGopchB;AoG/ocQ;EACI,oBAAA;ApGipcZ;AoG9ocI;EACI,oBAAA;ApGgpcR;;AoG7ocA;EACI,gBAAA;EACA,wBAAA;ApGgpcJ;AoG/ocI;EACI,kB7FrGY;E6FsGZ,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,c7FvMM;APw1cd;AoGhpcQ;EACI,sBAAA;ApGkpcZ;;AoG9ocA;EACI,kBAAA;ApGipcJ;AoGhpcI;EACI,gBAAA;EACA,wBAAA;ApGkpcR;AoG/ocQ;EACI,qBAAA;EACA,wBAAA;ApGipcZ;AoGhpcY;EACI,kB7F1HI;E6F2HJ,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,c7F5NF;AP82cd;AoGjpcgB;EACI,sBAAA;ApGmpcpB;AoG9ocI;EACI,sB7F2iBW;E6F1iBX,gBP9GU;EO+GV,oBAAA;EACA,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EAEI,UAAA;EAKJ,QAAA;EACA,uCAAA;EACA,wCAAA;ApG2ocR;AoG1ocQ;EACI,sCAAA;EACA,uCAAA;ApG4ocZ;AoG1ocQ;EACI,uCAAA;EACA,wCAAA;ApG4ocZ;;AoGtocI;EACI,YAAA;ApGyocR;AoGvocI;EACI,iB7F4GgC;E6F3GhC,uBAAA;ApGyocR;AoGvocI;EACI,gB7FyGgC;APgicxC;AoGvocI;EACI,iB7FuGgC;APkicxC;AoGvocI;EACI,aAAA;ApGyocR;;AoGlocI;EACI,c7FvSA;E6FwSA,e7F5KK;E6F6KL,kBAAA;ApGqocR;;AoGhocI;EACI,kBAAA;ApGmocR;AoGlocQ;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;ApGoocZ;AoGlocgB;EACI,W7F1UX;E6F2UW,qB7FxRA;E6FyRA,yB7FzRA;AP65cpB;AoGhocQ;EACI,qBAAA;EACA,yBAAA;EACA,yB7FhVA;E6FiVA,gB7F7KC;E6F8KD,c7FjTE;E6FkTF,kBAAA;EACA,2BAAA;EACA,oBAAA;EACA,oBAAA;EACA,kB7F1NK;E6F2NL,oBAAA;EACA,2BAAA;ApGkocZ;AoG9ncQ;EACI,qBAAA;EACA,kBAAA;EACA,oBAAA;ApGgocZ;AoG5ncQ;EACI,mBAAA;ApG8ncZ;AoG1ncQ;EACI,6BAAA;ApG4ncZ;;AqGh/cI;EACI,oBAAA;EACA,kB9F+mBgC;APo4bxC;AqGl/cQ;EACI,qBAAA;ArGo/cZ;AqGn/cY;EACI,kBAAA;EACA,a9F+mBwB;APs4bxC;AqGl/cQ;EACI,e9F8IC;E8F7ID,oB9FknB4B;E8FjnB5B,qBAAA;ArGo/cZ;AqGn/cY;EACI,MAAA;ArGq/chB;AqGn/cY;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,sB9FoyBG;E8FnyBH,W9FhBP;E8FiBO,UAAA;ArGq/chB;AqGp/cgB;EACI,gBRwRH;A7F8tcjB;AqGp/cgB;EACI,gBRmSH;A7FmtcjB;AqGj/cY;EACI,UAAA;ArGm/chB;AqGh/cgB;EACI,YAAA;EACA,c9FKJ;AP6+chB;AqG9+cQ;EACI,oB9FqkB4B;E8FpkB5B,sBAAA;ArGg/cZ;AqG/+cY;EACI,oBAAA;ArGi/chB;AqGh/cgB;EACI,Y9FqkBoB;AP66bxC;AqG/+cY;EACI,e9FiGH;E8FhGG,qB9FwkBwB;E8FvkBxB,cAAA;ArGi/chB;AqGh/cgB;EACI,eAAA;EACA,e9FujBoB;E8FtjBpB,gB9FsjBoB;AP47bxC;AqGh/cgB;EACI,gBAAA;ArGk/cpB;AqG9+cQ;EACI,gB9F+iB4B;E8F9iB5B,kBAAA;ArGg/cZ;AqG/+cY;EACI,kBAAA;ArGi/chB;AqGh/cgB;EACI,U9F+iBoB;APm8bxC;AqG/+cY;EACI,e9F6EH;E8F5EG,qB9FkjBwB;E8FjjBxB,sBAAA;ArGi/chB;AqGh/cgB;EACI,WAAA;EACA,W9FiiBoB;E8FhiBpB,Y9FgiBoB;APk9bxC;AqGh/cgB;EACI,gBAAA;ArGk/cpB;AqG9+cQ;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;ArGg/cZ;AqG9+cQ;EACI,eAAA;EACA,sBAAA;ArGg/cZ;AqG9+cgB;EACI,UAAA;EACA,eAAA;ArGg/cpB;AqG7+cY;EACI,uBAAA;ArG++chB;AqG7+coB;EACI,gBAAA;ArG++cxB;AqG3+cY;EACI,mBAAA;ArG6+chB;AqG3+coB;EACI,YAAA;ArG6+cxB;AqGv+cI;EACI,mBAAA;EACA,gBAAA;ArGy+cR;AqGv+cI;EACI,gB9FzHC;APkmdT;;AqGt+cA;EACI,qBAAA;ArGy+cJ;AqGv+cM;EACE,cAAA;EACA,W9F0fgC;E8FzfhC,qB9F6fgC;AP4+bxC;AqGv+cM;EACE,UAAA;EACA,YAAA;EACA,0BAAA;EACA,W9F2fgC;E8F1fhC,Y9F0fgC;E8FzfhC,qB9FqfgC;APo/bxC;AqGr+cM;EACI,uCAAA;ArGu+cV;AqGp+cI;EACI,wBAAA;ArGs+cR;AqGp+cY;EACI,iBAAA;EACF,iB9Fqe0B;E8Fpe1B,0B9Fwe0B;AP8/bxC;AqGp+cY;EACE,cAAA;EACA,6BAAA;EACA,c9Fue0B;E8Fte1B,e9Fse0B;E8Fre1B,0B9Fie0B;APqgcxC;AqGl+cY;EACI,6CAAA;ArGo+chB;AqGh+cI;EACI,kBAAA;ArGk+cR;AqGh+cY;EACI,WAAA;EACF,W9Fgd0B;E8F/c1B,mB9Fmd0B;AP+gcxC;AqGh+cY;EACE,aAAA;EACA,uBAAA;EACA,c9Fkd0B;E8Fjd1B,e9Fid0B;E8Fhd1B,mB9F4c0B;APshcxC;AqG99cY;EACI,2CAAA;ArGg+chB;AqG59cI;EACI,eAAA;EACA,sBAAA;ArG89cR;AqG59cY;EACI,UAAA;EACA,eAAA;ArG89chB;AqG39cQ;EACI,eAAA;ArG69cZ;AqG39cQ;EACI,2BAAA;ArG69cZ;AqG19cY;EACI,wCAAA;ArG49chB;AqGz9cQ;EACI,yBAAA;ArG29cZ;AqG19cY;EACI,kBAAA;ArG49chB;AqG19cY;EACI,8BAAA;ArG49chB;AqGz9cgB;EACI,8CAAA;ArG29cpB;AqGv9cQ;EACI,mBAAA;ArGy9cZ;AqGx9cY;EACI,YAAA;ArG09chB;AqGx9cY;EACI,wBAAA;ArG09chB;AqGv9cgB;EACI,4CAAA;ArGy9cpB;;AqGj9cA;EACI,eAAA;ArGo9cJ;AqGn9cI;EACI,eAAA;ArGq9cR;;AqG78cI;EACI,kBAAA;EACA,OAAA;EACA,W9FhQC;E8FiQD,e9FlHK;E8FmHL,cAAA;EACA,wBAAA;EACA,mBAAA;EACA,sBAAA;EACA,UAAA;EACA,kB9FrIY;E8FsIZ,mBAAA;ArGg9cR;AqG/8cQ;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,8BAAA;EACA,mCAAA;EACA,UAAA;EACA,oCAAA;EACA,YAAA;ArGi9cZ;;AqG58cI;EACI,UAAA;EACA,QAAA;ArG+8cR;AqG98cQ;EACI,UAAA;EACA,WAAA;EACA,2BAAA;EACA,8BAAA;EACA,YAAA;ArGg9cZ;;AsGtvdQ;EACI,gCAAA;AtGyvdZ;AsGtvdI;EACI,qB/FUI;AP8udZ;AsGrvdQ;EACI,qBjG6NkB;AL0hd9B;AsGrvdQ;EACI,sBjG0NkB;AL6hd9B;AsGnvdI;EACI,gBAAA;AtGqvdR;AsGpvdQ;EACI,oBAAA;EACA,gB/F0JC;AP4ldb;AsGnvdI;EACI,kBAAA;EACA,qBjG6MsB;ALwid9B;AsGlvdQ;EACI,kBjG0MkB;EiGzMlB,mBjGyMkB;AL2id9B;AsG/udY;EACI,eAAA;AtGivdhB;AsG/udY;EACI,gBAAA;AtGivdhB;AsG5udQ;EACI,iBAAA;EACA,oBAAA;AtG8udZ;AsG5udQ;EACI,oBAAA;EACA,uBAAA;AtG8udZ;AsG3udI;EACI,sBAAA;AtG6udR;;AkBzudI;EoFEQ;IACI,oBAAA;EtG2udd;EsGzudU;IACI,qBAAA;EtG2udd;AACF;AuG7ydI;EACI,mBAAA;AvG+ydR;AuG7ydI;EACI,oBAAA;AvG+ydR;AuG7ydI;EACI,cAAA;AvG+ydR;AuG7ydI;EACI,YAAA;EACA,eAAA;AvG+ydR;;AwG3zdA;EACI,qBAAA;AxG8zdJ;AwG7zdI;EACI,oBAAA;EACA,mBAAA;AxG+zdR;AwG9zdQ;EACI,oBAAA;AxGg0dZ;AwG9zdQ;EACI,gBAAA;AxGg0dZ;AwG7zdI;EACI,kCjGwJa;EiGvJb,SAAA;EACA,oBAAA;EACA,gCAAA;AxG+zdR;AwG9zdQ;EACI,mBAAA;EACA,uBAAA;AxGg0dZ;AwG9zdQ;EACI,mBAAA;AxGg0dZ;AwG7zdY;EACI,sBAAA;AxG+zdhB;AwG9zdgB;EACI,gBAAA;AxGg0dpB;AwG9zdgB;EACI,cjG6BA;APmydpB;AwG/zdoB;EACI,UAAA;AxGi0dxB;AwG7zdY;EACI,eAAA;EACA,gBAAA;EACA,cjGKF;EiGJE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,mBAAA;AxG+zdhB;AwG9zdgB;EACI,gBAAA;AxGg0dpB;AwG/zdoB;EACI,mBAAA;AxGi0dxB;AwG9zdgB;EACI,oBAAA;AxGg0dpB;AwG9zdgB;EACI,cjGTJ;APy0dhB;AwG9zdgB;EACI,cjGCA;AP+zdpB;AwG9zdgB;EACI,kBAAA;EACA,WAAA;AxGg0dpB;AwG9zdgB;EACI,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,mBjGVA;EiGWA,UAAA;AxGg0dpB;AwG9zdgB;EACI,cjGdA;EiGeA,YAAA;EACA,6BAAA;AxGg0dpB;AwG/zdoB;EACI,UAAA;AxGi0dxB;AwG3zdI;EACI,oBAAA;AxG6zdR;;AkBt1dI;EsF8BI;IACI,qBAAA;ExG4zdV;EwGzzdU;IACI,sBAAA;ExG2zdd;AACF;AkB/1dI;EsF0CI;IACI,sBAAA;ExGwzdV;EwGrzdU;IACI,sBAAA;ExGuzdd;EwGpzdM;IACI,mBAAA;ExGszdV;AACF;AkB12dI;EsFyDI;IACI,sBAAA;ExGozdV;EwGjzdU;IACI,sBAAA;ExGmzdd;AACF;AkBr2dI;EsFuDA;IACI,kBAAA;IACA,mBAAA;IACA,kBjG6BiB;IiG5BjB,mBjG4BiB;EPqxdvB;AACF;AwG7ydA;EACI,oBAAA;EACA,mBAAA;EACA,2BAAA;AxG+ydJ;;AwG3ydA;EACI,qBAAA;EACA,sBAAA;EACA,kCjGkBiB;AP4xdrB;;AkBr4dI;EsF0FA;IACI,oBAAA;IACA,qBAAA;ExG+ydN;AACF;AkB/3dI;EsFsFI;IACI,sBAAA;ExG4ydV;EwGzydU;IACI,kBAAA;IACA,iBAAA;ExG2ydd;EwG1ydc;IACI,aAAA;ExG4ydlB;AACF;AwGvydA;EAEQ;IACI,sBAAA;ExGwydV;AACF;AwGjydQ;EACI,kBAAA;AxGmydZ;;AyG39dI;EACI,kBAAA;EACA,gBAAA;EACA,kGpGurB4B;ALuycpC;AyG79dQ;EACI,kBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,clG+BE;EkG9BF,UAAA;EACA,oBAAA;AzG+9dZ;AyG39dQ;EACI,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBlGipBwB;EkGhpBxB,sBlGgpBwB;AP60cpC;AyG59dY;EACI,YAAA;AzG89dhB;AyG79dgB;EACI,qBAAA;AzG+9dpB;AyG19dQ;EACI,wBAAA;AzG49dZ;AyG39dY;EACI,qBAAA;EACA,sBAAA;EACA,qBlG8oBqB;EkG7oBrB,sBlG6oBqB;APg1crC;AyG59dgB;EACI,oBAAA;AzG89dpB;AyGz9dQ;EACI,wBAAA;AzG29dZ;AyG19dY;EACI,qBAAA;EACA,sBAAA;EACA,qBlGioBqB;EkGhoBrB,sBlGgoBqB;AP41crC;AyG39dgB;EACI,oBAAA;AzG69dpB;AyGv9dQ;EACI,wBAAA;AzGy9dZ;AyGv9dQ;EACI,aAAA;EACA,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;AzGy9dZ;AyGx9dY;EACI,kBAAA;AzG09dhB;AyGt9dI;EACI,aAAA;EACA,mBAAA;EACA,6BAAA;AzGw9dR;AyGv9dQ;EACE,0BAAA;AzGy9dV;AyGv9dQ;EACI,8BlGglBwB;APy4cpC;AyGv9dQ;EACI,sBlGglBwB;EkG/kBxB,mClG8kBwB;AP24cpC;AyGv9dQ;EACI,uBAAA;AzGy9dZ;AyGx9dY;EACI,8BlGskBoB;APo5cpC;AyGv9dQ;EACI,qBAAA;AzGy9dZ;;AkB9/dI;EuF2CA;IACI,+BAAA;EzGu9dN;EyGt9dM;IACE,4BAAA;EzGw9dR;EyGp9dM;IACI,sBAAA;EzGs9dV;EyGr9dU;IACI,oBAAA;IACA,qBAAA;IACA,oBlGikBqB;IkGhkBrB,qBlGgkBqB;EPu5cnC;EyGt9dc;IACI,oBAAA;EzGw9dlB;EyGr9dU;IACI,wBAAA;EzGu9dd;EyGt9dc;IACI,qBAAA;IACA,sBAAA;IACA,qBlGujBiB;IkGtjBjB,sBlGsjBiB;EPk6cnC;EyGv9dkB;IACI,qBAAA;EzGy9dtB;EyGr9dU;IACI,uBAAA;EzGu9dd;EyGt9dc;IACI,oBAAA;IACA,qBAAA;IACA,oBlG4iBiB;IkG3iBjB,qBlG2iBiB;EP66cnC;EyGv9dkB;IACI,oBAAA;EzGy9dtB;EyGx9dsB;IACI,YlGuiBS;EPm7cnC;EyGr9dU;IACI,wBAAA;EzGu9dd;EyGt9dc;IACI,qBAAA;IACA,sBAAA;IACA,qBlG8hBiB;IkG7hBjB,sBlG6hBiB;EP27cnC;EyGv9dkB;IACI,qBAAA;EzGy9dtB;EyGp9dM;IACI,oBlGuhB4B;EP+7ctC;EyGr9dU;IACI,wBlGshBwB;EPi8ctC;EyGp9dM;IACI,oBlGohB4B;EPk8ctC;EyGr9dU;IACI,wBlGmhBwB;EPo8ctC;AACF;AkBtkeI;EuFqHA;IACI,gBAAA;EzGo9dN;AACF;A0GtoeI;EACI,oBAAA;EACA,mBAAA;EACA,oBAAA;EACA,yBAAA;A1GwoeR;;A0GnoeI;EAEI,oBnG4lB4B;EmG3lB5B,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sCAAA;A1GqoeR;A0GpoeQ;EACI,qBnG6jBwB;EmG5jBxB,0CAAA;A1GsoeZ;A0GpoeQ;EACI,mBnG0jBwB;EmGzjBxB,wCAAA;A1GsoeZ;A0GpoeQ;EACI,yBAAA;EACA,qBAAA;EACA,mBnGqjBwB;EmGpjBxB,uCAAA;A1GsoeZ;A0GpoeQ;EACI,oBAAA;EACA,oBAAA;A1GsoeZ;A0GpoeQ;EACI,6BAAA;EACA,cAAA;A1GsoeZ;A0GnoegB;EACI,kBAAA;EACA,QAAA;A1GqoepB;A0GhoeY;EACI,aAAA;A1GkoehB;;AkBtneI;EwFHY;IACI,cAAA;E1G6nelB;E0Gznec;IACI,sBAAA;E1G2nelB;E0Gvnec;IACI,qBAAA;E1GynelB;AACF;A2G7reI;EACI,YAAA;EACA,cAAA;A3G+reR;A2G7reI;EACI,eAAA;A3G+reR;A2G7reI;EACI,gBAAA;A3G+reR;A2G7reI;EACI,YAAA;A3G+reR;A2G7reI;EACI,oBAAA;A3G+reR;A2G1reI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cpGoBM;EoGnBN,sBAAA;A3G4reR;A2G1reI;EACI,mBAAA;A3G4reR;A2G1reI;EACI,epG0HK;EoGzHL,oBAAA;A3G4reR;A2G1reI;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;A3G4reR;A2G3reQ;EACI,kBtG4qBwB;ALihdpC;A2G1reI;EACI,2BAAA;A3G4reR;A2GzreQ;EACI,gBAAA;EACA,sBAAA;EACA,uBAAA;A3G2reZ;A2G1reY;EACI,iBAAA;A3G4rehB;A2GxreY;EACI,cAAA;A3G0rehB;A2GzregB;EACI,iBAAA;A3G2repB;A2GrreI;EACI,aAAA;EACA,mBAAA;A3GureR;A2GtreQ;EACI,WAAA;EACA,YAAA;EACA,oBAAA;A3GwreZ;A2GtreQ;EACI,WAAA;EAEA,oBAAA;EACA,iBAAA;A3GureZ;A2GrreQ;EACI,YAAA;A3GureZ;;A4GrweI;EACI,oBAAA;EACA,qBAAA;EACA,mBAAA;A5GwweR;;A6G5weA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,ctGyBK;APsveT;A6G9weI;EACI,mBAAA;EACA,oBAAA;A7GgxeR;A6G9weI;EACI,eAAA;A7GgxeR;A6G9weI;EACI,oBAAA;EACA,uBAAA;A7GgxeR;A6G/weQ;EACI,oBAAA;A7GixeZ;A6G/weQ;EACI,oBAAA;A7GixeZ;A6G9weI;EACI,yBAAA;EACA,mBAAA;A7GgxeR;;A6GzweY;EACI,ctG4BI;APgvepB;A6G1weY;EACI,ctGSF;APmwed;A6GxweI;EACI,aAAA;EACA,mBAAA;A7G0weR;;A6GvweA;EACI,oBAAA;A7G0weJ;;A8GvzeA;EACE,sBAAA;EACA,6CAAA;EACA,uPAAA;EAIA,mBAAA;EACA,kBAAA;EACA,mBAAA;A9GuzeF;A8GpzeA;EACE,+EAAA;EACA,iCAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;A9GqzeF;;A8GjzeE;EACE,gBjB1BQ;A7F80eZ;;A8GhzeE;EACE,gBjB9BO;A7Fi1eX;;A8G/yeE;EACE,gBjBlCQ;A7Fo1eZ;;A8G9yeE;EACE,gBjBtCU;A7Fu1ed;;A8G7yeE;EACE,gBjB1CK;A7F01eT;;A8G5yeE;EACE,gBjB9Cc;A7F61elB;;A8G3yeE;EACE,gBjBlDO;A7Fg2eX;;A8G1yeE;EACE,gBjBtDe;A7Fm2enB;;A8GzyeE;EACE,gBjB1Da;A7Fs2ejB;;A8GxyeE;EACE,gBjB9DY;A7Fy2ehB;;A8GvyeE;EACE,gBjBlEQ;A7F42eZ;;A8GtyeE;EACE,gBjBtEO;A7F+2eX;;A8GryeE;EACE,gBjB1EU;A7Fk3ed;;A8GpyeE;EACE,gBjB9EQ;A7Fq3eZ;;A8GnyeE;EACE,gBjBlFW;A7Fw3ef;;A8GlyeE;EACE,gBjBtFM;A7F23eV;;A8GjyeE;EACE,gBjB1FS;A7F83eb;;A8GhyeE;EACE,gBjB9FU;A7Fi4ed;;A8G/xeE;EACE,gBjBlGM;A7Fo4eV;;A8G9xeE;EACE,gBjBtGM;A7Fu4eV;;A8G7xeE;EACE,gBjB1GY;A7F04ehB;;A8G5xeE;EACE,gBjB9GO;A7F64eX;;A8G3xeE;EACE,gBjBlHQ;A7Fg5eZ;;A8G1xeE;EACE,gBjBtHQ;A7Fm5eZ;;A8GzxeE;EACE,gBjB1HQ;A7Fs5eZ;;A8GxxeE;EACE,gBjB9HU;A7Fy5ed;;A8GvxeE;EACE,gBjBlIQ;A7F45eZ;;A8GtxeE;EACE,gBjBtIK;A7F+5eT;;A8GrxeE;EACE,gBjB1IQ;A7Fk6eZ;;A8GpxeE;EACE,gBjB9IQ;A7Fq6eZ;;A8GnxeE;EACE,gBjBlJS;A7Fw6eb;;A8GlxeE;EACE,gBjBtJiB;A7F26erB;;A8GjxeE;EACE,gBjB1JY;A7F86ehB;;A8GhxeE;EACE,gBjB9Jc;A7Fi7elB;;A8G/weE;EACE,gBjBlKS;A7Fo7eb;;A8G9weE;EACE,gBjBtKiB;A7Fu7erB;;A8G7weE;EACE,gBjB1KY;A7F07ehB;;A8G5weE;EACE,gBjB9KqB;A7F67ezB;;A8G3weE;EACE,gBjBlLgB;A7Fg8epB;;A8G1weE;EACE,gBjBtLiB;A7Fm8erB;;A8GzweE;EACE,gBjB1LY;A7Fs8ehB;;A8GxweE;EACE,gBjB9Lc;A7Fy8elB;;A8GvweE;EACE,gBjBlMS;A7F48eb;;A8GtweE;EACE,gBjBtMc;A7F+8elB;;A8GrweE;EACE,gBjB1Mc;A7Fk9elB;;A8GpweE;EACE,gBjB9MQ;A7Fq9eZ;;A8GnweE;EACE,gBjBlNM;A7Fw9eV;;A8GlweE;EACE,gBjBtNgB;A7F29epB;;A8GjweE;EACE,gBjB1Ne;A7F89enB;;A8GhweE;EACE,gBjB9Nc;A7Fi+elB;;A8G/veE;EACE,gBjBlOc;A7Fo+elB;;A8G9veE;EACE,gBjBtOiB;A7Fu+erB;;A8G7veE;EACE,gBjB1OU;A7F0+ed;;A8G5veE;EACE,gBjB9Oa;A7F6+ejB;;A8G3veE;EACE,gBjBlPQ;A7Fg/eZ;;A8G1veE;EACE,gBjBtPY;A7Fm/ehB;;A8GzveE;EACE,gBjB1Pa;A7Fs/ejB;;A8GxveE;EACE,gBjB9PS;A7Fy/eb;;A8GvveE;EACE,gBjBlQW;A7F4/ef;;A8GtveE;EACE,gBjBtQW;A7F+/ef;;A8GrveE;EACE,gBjB1QO;A7FkgfX;;A8GpveE;EACE,gBjB9QiB;A7FqgfrB;;A8GnveE;EACE,gBjBlRY;A7FwgfhB;;A8GlveE;EACE,gBjBtRe;A7F2gfnB;;A8GjveE;EACE,gBjB1Ra;A7F8gfjB;;A8GhveE;EACE,gBjB9RU;A7Fihfd;;A8G/ueE;EACE,gBjBlSW;A7Fohff;;A8G9ueE;EACE,gBjBtSW;A7Fuhff;;A8G7ueE;EACE,gBjB1SgB;A7F0hfpB;;A8G5ueE;EACE,gBjB9Sc;A7F6hflB;;A8G3ueE;EACE,gBjBlTW;A7Fgiff;;A8G1ueE;EACE,gBjBtTgB;A7FmifpB;;A8GzueE;EACE,gBjB1Tc;A7FsiflB;;A8GxueE;EACE,gBjB9Tc;A7FyiflB;;A8GvueE;EACE,gBjBlUW;A7F4iff;;A8GtueE;EACE,gBjBtUe;A7F+ifnB;;A8GrueE;EACE,gBjB1Ue;A7FkjfnB;;A8GpueE;EACE,gBjB9UiB;A7FqjfrB;;A8GnueE;EACE,gBjBlVe;A7FwjfnB;;A8GlueE;EACE,gBjBtVgB;A7F2jfpB;;A8GjueE;EACE,gBjB1Vc;A7F8jflB;;A8GhueE;EACE,gBjB9Vc;A7FikflB;;A8G/teE;EACE,gBjBlWW;A7Fokff;;A8G9teE;EACE,gBjBtWiB;A7FukfrB;;A8G7teE;EACE,gBjB1We;A7F0kfnB;;A8G5teE;EACE,gBjB9WY;A7F6kfhB;;A8G3teE;EACE,gBjBlXe;A7FglfnB;;A8G1teE;EACE,gBjBtXa;A7FmlfjB;;A8GzteE;EACE,gBjB1Xa;A7FslfjB;;A8GxteE;EACE,gBjB9XU;A7Fylfd;;A8GvteE;EACE,gBjBlYS;A7F4lfb;;A8GtteE;EACE,gBjBtYS;A7F+lfb;;A8GrteE;EACE,gBjB1YS;A7Fkmfb;;A8GpteE;EACE,gBjB9YS;A7Fqmfb;;A8GnteE;EACE,gBjBlZS;A7Fwmfb;;A8GlteE;EACE,gBjBtZS;A7F2mfb;;A8GjteE;EACE,gBjB1ZS;A7F8mfb;;A8GhteE;EACE,gBjB9ZU;A7Finfd;;A8G/seE;EACE,gBjBlaiB;A7FonfrB;;A8G9seE;EACE,gBjBtac;A7FunflB;;A8G7seE;EACE,gBjB1aa;A7F0nfjB;;A8G5seE;EACE,gBjB9aQ;A7F6nfZ;;A8G3seE;EACE,gBjBlbU;A7Fgofd;;A8G1seE;EACE,gBjBtbU;A7Fmofd;;A8GzseE;EACE,gBjB1bU;A7Fsofd;;A8GxseE;EACE,gBjB9bc;A7FyoflB;;A8GvseE;EACE,gBjBlcc;A7F4oflB;;A8GtseE;EACE,gBjBtcc;A7F+oflB;;A8GrseE;EACE,gBjB1cc;A7FkpflB;;A8GpseE;EACE,gBjB9cc;A7FqpflB;;A8GnseE;EACE,gBjBldc;A7FwpflB;;A8GlseE;EACE,gBjBtda;A7F2pfjB;;A8GjseE;EACE,gBjB1dc;A7F8pflB;;A8GhseE;EACE,gBjB9dc;A7FiqflB;;A8G/reE;EACE,gBjBlec;A7FoqflB;;A8G9reE;EACE,gBjBtec;A7FuqflB;;A8G7reE;EACE,gBjB1ee;A7F0qfnB;;A8G5reE;EACE,gBjB9ec;A7F6qflB;;A8G3reE;EACE,gBjBlfc;A7FgrflB;;A8G1reE;EACE,gBjBtfc;A7FmrflB;;A8GzreE;EACE,gBjB1fe;A7FsrfnB;;A8GxreE;EACE,gBjB9fe;A7FyrfnB;;A8GvreE;EACE,gBjBlgBe;A7F4rfnB;;A8GtreE;EACE,gBjBtgBc;A7F+rflB;;A8GrreE;EACE,gBjB1gBc;A7FksflB;;A8GpreE;EACE,gBjB9gBc;A7FqsflB;;A8GnreE;EACE,gBjBlhBc;A7FwsflB;;A8GlreE;EACE,gBjBthBa;A7F2sfjB;;A8GjreE;EACE,gBjB1hBc;A7F8sflB;;A8GhreE;EACE,gBjB9hBU;A7Fitfd;;A8G/qeE;EACE,gBjBliBc;A7FotflB;;A8G9qeE;EACE,gBjBtiBc;A7FutflB;;A8G7qeE;EACE,gBjB1iBc;A7F0tflB;;A8G5qeE;EACE,gBjB9iBiB;A7F6tfrB;;A8G3qeE;EACE,gBjBljBkB;A7FguftB;;A8G1qeE;EACE,gBjBtjBc;A7FmuflB;;A8GzqeE;EACE,gBjB1jBc;A7FsuflB;;A8GxqeE;EACE,gBjB9jBc;A7FyuflB;;A8GvqeE;EACE,gBjBlkBc;A7F4uflB;;A8GtqeE;EACE,gBjBtkBc;A7F+uflB;;A8GrqeE;EACE,gBjB1kBe;A7FkvfnB;;A8GpqeE;EACE,gBjB9kBgB;A7FqvfpB;;A8GnqeE;EACE,gBjBllBkB;A7FwvftB;;A8GlqeE;EACE,gBjBtlBmB;A7F2vfvB;;A8GjqeE;EACE,gBjB1lBc;A7F8vflB;;A8GhqeE;EACE,gBjB9lBc;A7FiwflB;;A8G/peE;EACE,gBjBlmBc;A7FowflB;;A8G9peE;EACE,gBjBtmBc;A7FuwflB;;A8G7peE;EACE,gBjB1mBe;A7F0wfnB;;A8G5peE;EACE,gBjB9mBe;A7F6wfnB;;A8G3peE;EACE,gBjBlnBe;A7FgxfnB;;A8G1peE;EACE,gBjBtnBe;A7FmxfnB;;A8GzpeE;EACE,gBjB1nBc;A7FsxflB;;A8GxpeE;EACE,gBjB9nBgB;A7FyxfpB;;A8GvpeE;EACE,gBjBloBc;A7F4xflB;;A8GtpeE;EACE,gBjBtoBkB;A7F+xftB;;A8GrpeE;EACE,gBjB1oBkB;A7FkyftB;;A8GppeE;EACE,gBjB9oBgB;A7FqyfpB;;A8GnpeE;EACE,gBjBlpBc;A7FwyflB;;A8GlpeE;EACE,gBjBtpBe;A7F2yfnB;;A8GjpeE;EACE,gBjB1pBY;A7F8yfhB;;A8GhpeE;EACE,gBjB9pBc;A7FizflB;;A8G/oeE;EACE,gBjBlqBoB;A7FozfxB;;A8G9oeE;EACE,gBjBtqBqB;A7FuzfzB;;A8G7oeE;EACE,gBjB1qBkB;A7F0zftB;;A8G5oeE;EACE,gBjB9qBoB;A7F6zfxB;;A8G3oeE;EACE,gBjBlrByB;A7Fg0f7B;;A8G1oeE;EACE,gBjBtrB0B;A7Fm0f9B;;A8GzoeE;EACE,gBjB1rBuB;A7Fs0f3B;;A8GxoeE;EACE,gBjB9rByB;A7Fy0f7B;;A8GvoeE;EACE,gBjBlsBgB;A7F40fpB;;A8GtoeE;EACE,gBjBtsBiB;A7F+0frB;;A8GroeE;EACE,gBjB1sBc;A7Fk1flB;;A8GpoeE;EACE,gBjB9sBgB;A7Fq1fpB;;A8GnoeE;EACE,gBjBltBqB;A7Fw1fzB;;A8GloeE;EACE,gBjBttBsB;A7F21f1B;;A8GjoeE;EACE,gBjB1tBmB;A7F81fvB;;A8GhoeE;EACE,gBjB9tBqB;A7Fi2fzB;;A8G/neE;EACE,gBjBluBqB;A7Fo2fzB;;A8G9neE;EACE,gBjBtuBsB;A7Fu2f1B;;A8G7neE;EACE,gBjB1uBmB;A7F02fvB;;A8G5neE;EACE,gBjB9uBqB;A7F62fzB;;A8G3neE;EACE,gBjBlvB0B;A7Fg3f9B;;A8G1neE;EACE,gBjBtvB2B;A7Fm3f/B;;A8GzneE;EACE,gBjB1vBwB;A7Fs3f5B;;A8GxneE;EACE,gBjB9vB0B;A7Fy3f9B;;A8GvneE;EACE,gBjBlwBY;A7F43fhB;;A8GtneE;EACE,gBjBtwBa;A7F+3fjB;;A8GrneE;EACE,gBjB1wBU;A7Fk4fd;;A8GpneE;EACE,gBjB9wBY;A7Fq4fhB;;A8GnneE;EACE,gBjBlxBiB;A7Fw4frB;;A8GlneE;EACE,gBjBtxBkB;A7F24ftB;;A8GjneE;EACE,gBjB1xBe;A7F84fnB;;A8GhneE;EACE,gBjB9xBiB;A7Fi5frB;;A8G/meE;EACE,gBjBlyBM;A7Fo5fV;;A8G9meE;EACE,gBjBtyBS;A7Fu5fb;;A8G7meE;EACE,gBjB1yBW;A7F05ff;;A8G5meE;EACE,gBjB9yBW;A7F65ff;;A8G3meE;EACE,gBjBlzBc;A7Fg6flB;;A8G1meE;EACE,gBjBtzBgB;A7Fm6fpB;;A8GzmeE;EACE,gBjB1zBQ;A7Fs6fZ;;A8GxmeE;EACE,gBjB9zBQ;A7Fy6fZ;;A8GvmeE;EACE,gBjBl0BM;A7F46fV;;A8GtmeE;EACE,gBjBt0BkB;A7F+6ftB;;A8GrmeE;EACE,gBjB10BmB;A7Fk7fvB;;A8GpmeE;EACE,gBjB90BgB;A7Fq7fpB;;A8GnmeE;EACE,gBjBl1BkB;A7Fw7ftB;;A8GlmeE;EACE,gBjBt1BuB;A7F27f3B;;A8GjmeE;EACE,gBjB11BwB;A7F87f5B;;A8GhmeE;EACE,gBjB91BqB;A7Fi8fzB;;A8G/leE;EACE,gBjBl2BuB;A7Fo8f3B;;A8G9leE;EACE,gBjBt2Bc;A7Fu8flB;;A8G7leE;EACE,gBjB12Be;A7F08fnB;;A8G5leE;EACE,gBjB92BY;A7F68fhB;;A8G3leE;EACE,gBjBl3Bc;A7Fg9flB;;A8G1leE;EACE,gBjBt3BmB;A7Fm9fvB;;A8GzleE;EACE,gBjB13BoB;A7Fs9fxB;;A8GxleE;EACE,gBjB93BiB;A7Fy9frB;;A8GvleE;EACE,gBjBl4BmB;A7F49fvB;;A8GtleE;EACE,gBjBt4BmB;A7F+9fvB;;A8GrleE;EACE,gBjB14BoB;A7Fk+fxB;;A8GpleE;EACE,gBjB94BiB;A7Fq+frB;;A8GnleE;EACE,gBjBl5BmB;A7Fw+fvB;;A8GlleE;EACE,gBjBt5BwB;A7F2+f5B;;A8GjleE;EACE,gBjB15BsB;A7F8+f1B;;A8GhleE;EACE,gBjB95BwB;A7Fi/f5B;;A8G/keE;EACE,gBjBl6ByB;A7Fo/f7B;;A8G9keE;EACE,gBjBt6Be;A7Fu/fnB;;A8G7keE;EACE,gBjB16BgB;A7F0/fpB;;A8G5keE;EACE,gBjB96Ba;A7F6/fjB;;A8G3keE;EACE,gBjBl7Be;A7FgggBnB;;A8G1keE;EACE,gBjBt7BO;A7FmggBX;;A8GzkeE;EACE,gBjB17BM;A7FsggBV;;A8GxkeE;EACE,gBjB97BU;A7FyggBd;;A8GvkeE;EACE,gBjBl8Ba;A7F4ggBjB;;A8GtkeE;EACE,gBjBt8BY;A7F+ggBhB;;A8GrkeE;EACE,gBjB18Bc;A7FkhgBlB;;A8GpkeE;EACE,gBjB98BU;A7FqhgBd;;A8GnkeE;EACE,gBjBl9Ba;A7FwhgBjB;;A8GlkeE;EACE,gBjBt9BY;A7F2hgBhB;;A8GjkeE;EACE,gBjB19Bc;A7F8hgBlB;;A8GhkeE;EACE,gBjB99Be;A7FiigBnB;;A8G/jeE;EACE,gBjBl+BkB;A7FoigBtB;;A8G9jeE;EACE,gBjBt+BiB;A7FuigBrB;;A8G7jeE;EACE,gBjB1+BmB;A7F0igBvB;;A8G5jeE;EACE,gBjB9+BiB;A7F6igBrB;;A8G3jeE;EACE,gBjBl/BkB;A7FgjgBtB;;A8G1jeE;EACE,gBjBt/Be;A7FmjgBnB;;A8GzjeE;EACE,gBjB1/BiB;A7FsjgBrB;;A8GxjeE;EACE,gBjB9/BY;A7FyjgBhB;;A8GvjeE;EACE,gBjBlgCa;A7F4jgBjB;;A8GtjeE;EACE,gBjBtgCU;A7F+jgBd;;A8GrjeE;EACE,gBjB1gCY;A7FkkgBhB;;A8GpjeE;EACE,gBjB9gCe;A7FqkgBnB;;A8GnjeE;EACE,gBjBlhCgB;A7FwkgBpB;;A8GljeE;EACE,gBjBthCiB;A7F2kgBrB;;A8GjjeE;EACE,gBjB1hCkB;A7F8kgBtB;;A8GhjeE;EACE,gBjB9hCe;A7FilgBnB;;A8G/ieE;EACE,gBjBliCgB;A7FolgBpB;;A8G9ieE;EACE,gBjBtiCa;A7FulgBjB;;A8G7ieE;EACE,gBjB1iCe;A7F0lgBnB;;A8G5ieE;EACE,gBjB9iCiB;A7F6lgBrB;;A8G3ieE;EACE,gBjBljCkB;A7FgmgBtB;;A8G1ieE;EACE,gBjBtjCe;A7FmmgBnB;;A8GzieE;EACE,gBjB1jCiB;A7FsmgBrB;;A8GxieE;EACE,gBjB9jCiB;A7FymgBrB;;A8GvieE;EACE,gBjBlkCgB;A7F4mgBpB;;A8GtieE;EACE,gBjBtkCe;A7F+mgBnB;;A8GrieE;EACE,gBjB1kCkB;A7FkngBtB;;A8GpieE;EACE,gBjB9kCe;A7FqngBnB;;A8GnieE;EACE,gBjBllCgB;A7FwngBpB;;A8GlieE;EACE,gBjBtlCiB;A7F2ngBrB;;A8GjieE;EACE,gBjB1lCkB;A7F8ngBtB;;A8GhieE;EACE,gBjB9lCY;A7FiogBhB;;A8G/heE;EACE,gBjBlmCe;A7FoogBnB;;A8G9heE;EACE,gBjBtmCiB;A7FuogBrB;;A8G7heE;EACE,gBjB1mCoB;A7F0ogBxB;;A8G5heE;EACE,gBjB9mCU;A7F6ogBd;;A8G3heE;EACE,gBjBlnCa;A7FgpgBjB;;A8G1heE;EACE,gBjBtnCe;A7FmpgBnB;;A8GzheE;EACE,gBjB1nCkB;A7FspgBtB;;A8GxheE;EACE,gBjB9nCM;A7FypgBV;;A8GvheE;EACE,gBjBloCU;A7F4pgBd;;A8GtheE;EACE,gBjBtoCa;A7F+pgBjB;;A8GrheE;EACE,gBjB1oCa;A7FkqgBjB;;A8GpheE;EACE,gBjB9oCY;A7FqqgBhB;;A8GnheE;EACE,gBjBlpCU;A7FwqgBd;;A8GlheE;EACE,gBjBtpCQ;A7F2qgBZ;;A8GjheE;EACE,gBjB1pCQ;A7F8qgBZ;;A8GhheE;EACE,gBjB9pCO;A7FirgBX;;A8G/geE;EACE,gBjBlqCU;A7ForgBd;;A8G9geE;EACE,gBjBtqCU;A7FurgBd;;A8G7geE;EACE,gBjB1qCc;A7F0rgBlB;;A8G5geE;EACE,gBjB9qCc;A7F6rgBlB;;A8G3geE;EACE,gBjBlrCS;A7FgsgBb;;A8G1geE;EACE,gBjBtrCU;A7FmsgBd;;A8GzgeE;EACE,gBjB1rCO;A7FssgBX;;A8GxgeE;EACE,gBjB9rCa;A7FysgBjB;;A8GvgeE;EACE,gBjBlsCc;A7F4sgBlB;;A8GtgeE;EACE,gBjBtsCS;A7F+sgBb;;A8GrgeE;EACE,gBjB1sCkB;A7FktgBtB;;A8GpgeE;EACE,gBjB9sCmB;A7FqtgBvB;;A8GngeE;EACE,gBjBltCc;A7FwtgBlB;;A8GlgeE;EACE,gBjBttCI;A7F2tgBR;;A8GjgeE;EACE,gBjB1tCO;A7F8tgBX;;A8GhgeE;EACE,gBjB9tCa;A7FiugBjB;;A8G//dE;EACE,gBjBluCM;A7FougBV;;A8G9/dE;EACE,gBjBtuCa;A7FuugBjB;;A8G7/dE;EACE,gBjB1uCc;A7F0ugBlB;;A8G5/dE;EACE,gBjB9uCS;A7F6ugBb;;A8G3/dE;EACE,gBjBlvCkB;A7FgvgBtB;;A8G1/dE;EACE,gBjBtvCmB;A7FmvgBvB;;A8Gz/dE;EACE,gBjB1vCc;A7FsvgBlB;;A8Gx/dE;EACE,gBjB9vCkB;A7FyvgBtB;;A8Gv/dE;EACE,gBjBlwCiB;A7F4vgBrB;;A8Gt/dE;EACE,gBjBtwCQ;A7F+vgBZ;;A8Gr/dE;EACE,gBjB1wCQ;A7FkwgBZ;;A8Gp/dE;EACE,gBjB9wCQ;A7FqwgBZ;;A8Gn/dE;EACE,gBjBlxCU;A7FwwgBd;;A8Gl/dE;EACE,gBjBtxCa;A7F2wgBjB;;A8Gj/dE;EACE,gBjB1xCa;A7F8wgBjB;;A8Gh/dE;EACE,gBjB9xCa;A7FixgBjB;;A8G/+dE;EACE,gBjBlyCe;A7FoxgBnB;;A8G9+dE;EACE,gBjBtyCS;A7FuxgBb;;A8G7+dE;EACE,gBjB1yCU;A7F0xgBd;;A8G5+dE;EACE,gBjB9yCM;A7F6xgBV;;A8G3+dE;EACE,gBjBlzCO;A7FgygBX;;A8G1+dE;EACE,gBjBtzCY;A7FmygBhB;;A8Gz+dE;EACE,gBjB1zCa;A7FsygBjB;;A8Gx+dE;EACE,gBjB9zCa;A7FyygBjB;;A8Gv+dE;EACE,gBjBl0Cc;A7F4ygBlB;;A8Gt+dE;EACE,gBjBt0CQ;A7F+ygBZ;;A8Gr+dE;EACE,gBjB10CS;A7FkzgBb;;A8Gp+dE;EACE,gBjB90CiB;A7FqzgBrB;;A8Gn+dE;EACE,gBjBl1CkB;A7FwzgBtB;;A8Gl+dE;EACE,gBjBt1CkB;A7F2zgBtB;;A8Gj+dE;EACE,gBjB11CmB;A7F8zgBvB;;A8Gh+dE;EACE,gBjB91Ca;A7Fi0gBjB;;A8G/9dE;EACE,gBjBl2Cc;A7Fo0gBlB;;A8G99dE;EACE,gBjBt2CW;A7Fu0gBf;;A8G79dE;EACE,gBjB12CgB;A7F00gBpB;;A8G59dE;EACE,gBjB92CU;A7F60gBd;;A8G39dE;EACE,gBjBl3CO;A7Fg1gBX;;A8G19dE;EACE,gBjBt3CM;A7Fm1gBV;;A8Gz9dE;EACE,gBjB13CQ;A7Fs1gBZ;;A8Gx9dE;EACE,gBjB93CU;A7Fy1gBd;;A8Gv9dE;EACE,gBjBl4CS;A7F41gBb;;A8Gt9dE;EACE,gBjBt4CM;A7F+1gBV;;A8Gr9dE;EACE,gBjB14CW;A7Fk2gBf;;A8Gp9dE;EACE,gBjB94Ca;A7Fq2gBjB;;A8Gn9dE;EACE,gBjBl5CkB;A7Fw2gBtB;;A8Gl9dE;EACE,gBjBt5CO;A7F22gBX;;A8Gj9dE;EACE,gBjB15CY;A7F82gBhB;;A8Gh9dE;EACE,gBjB95Cc;A7Fi3gBlB;;A8G/8dE;EACE,gBjBl6CmB;A7Fo3gBvB;;A8G98dE;EACE,gBjBt6CM;A7Fu3gBV;;A8G78dE;EACE,gBjB16CW;A7F03gBf;;A8G58dE;EACE,gBjB96Ca;A7F63gBjB;;A8G38dE;EACE,gBjBl7CkB;A7Fg4gBtB;;A8G18dE;EACE,gBjBt7CQ;A7Fm4gBZ;;A8Gz8dE;EACE,gBjB17CS;A7Fs4gBb;;A8Gx8dE;EACE,gBjB97Ca;A7Fy4gBjB;;A8Gv8dE;EACE,gBjBl8Cc;A7F44gBlB;;A8Gt8dE;EACE,gBjBt8CW;A7F+4gBf;;A8Gr8dE;EACE,gBjB18Cc;A7Fk5gBlB;;A8Gp8dE;EACE,gBjB98CS;A7Fq5gBb;;A8Gn8dE;EACE,gBjBl9CQ;A7Fw5gBZ;;A8Gl8dE;EACE,gBjBt9CU;A7F25gBd;;A8Gj8dE;EACE,gBjB19CK;A7F85gBT;;A8Gh8dE;EACE,gBjB99CK;A7Fi6gBT;;A8G/7dE;EACE,gBjBl+CS;A7Fo6gBb;;A8G97dE;EACE,gBjBt+CO;A7Fu6gBX;;A8G77dE;EACE,gBjB1+CW;A7F06gBf;;A8G57dE;EACE,gBjB9+CY;A7F66gBhB;;A8G37dE;EACE,gBjBl/CQ;A7Fg7gBZ;;A8G17dE;EACE,gBjBt/CO;A7Fm7gBX;;A8Gz7dE;EACE,gBjB1/CS;A7Fs7gBb;;A8Gx7dE;EACE,gBjB9/CQ;A7Fy7gBZ;;A8Gv7dE;EACE,gBjBlgDQ;A7F47gBZ;;A8Gt7dE;EACE,gBjBtgDU;A7F+7gBd;;A8Gr7dE;EACE,gBjB1gDc;A7Fk8gBlB;;A8Gp7dE;EACE,gBjB9gDO;A7Fq8gBX;;A8Gn7dE;EACE,gBjBlhDS;A7Fw8gBb;;A8Gl7dE;EACE,gBjBthDQ;A7F28gBZ;;A8Gj7dE;EACE,gBjB1hDS;A7F88gBb;;A8Gh7dE;EACE,gBjB9hDmB;A7Fi9gBvB;;A8G/6dE;EACE,gBjBliDY;A7Fo9gBhB;;A8G96dE;EACE,gBjBtiDc;A7Fu9gBlB;;A8G76dE;EACE,gBjB1iDa;A7F09gBjB;;A8G56dE;EACE,gBjB9iDc;A7F69gBlB;;A8G36dE;EACE,gBjBljDQ;A7Fg+gBZ;;A8G16dE;EACE,gBjBtjDM;A7Fm+gBV;;A8Gz6dE;EACE,gBjB1jDW;A7Fs+gBf;;A8Gx6dE;EACE,gBjB9jDM;A7Fy+gBV;;A8Gv6dE;EACE,gBjBlkDW;A7F4+gBf;;A8Gt6dE;EACE,gBjBtkDU;A7F++gBd;;A8Gr6dE;EACE,gBjB1kDS;A7Fk/gBb;;A8Gp6dE;EACE,gBjB9kDW;A7Fq/gBf;;A8Gn6dE;EACE,gBjBllDe;A7Fw/gBnB;;A8Gl6dE;EACE,gBjBtlDc;A7F2/gBlB;;A8Gj6dE;EACE,gBjB1lDgB;A7F8/gBpB;;A8Gh6dE;EACE,gBjB9lDK;A7FighBT;;A8G/5dE;EACE,gBjBlmDU;A7FoghBd;;A8G95dE;EACE,gBjBtmDM;A7FughBV;;A8G75dE;EACE,gBjB1mDU;A7F0ghBd;;A8G55dE;EACE,gBjB9mDW;A7F6ghBf;;A8G35dE;EACE,gBjBlnDe;A7FghhBnB;;A8G15dE;EACE,gBjBtnDM;A7FmhhBV;;A8Gz5dE;EACE,gBjB1nDU;A7FshhBd;;A8Gx5dE;EACE,gBjB9nDM;A7FyhhBV;;A8Gv5dE;EACE,gBjBloDQ;A7F4hhBZ;;A8Gt5dE;EACE,gBjBtoDW;A7F+hhBf;;A8Gr5dE;EACE,gBjB1oDW;A7FkihBf;;A8Gp5dE;EACE,gBjB9oDO;A7FqihBX;;A8Gn5dE;EACE,gBjBlpDY;A7FwihBhB;;A8Gl5dE;EACE,gBjBtpDa;A7F2ihBjB;;A8Gj5dE;EACE,gBjB1pDY;A7F8ihBhB;;A8Gh5dE;EACE,gBjB9pDW;A7FijhBf;;A8G/4dE;EACE,gBjBlqDM;A7FojhBV;;A8G94dE;EACE,gBjBtqDW;A7FujhBf;;A8G74dE;EACE,gBjB1qDW;A7F0jhBf;;A8G54dE;EACE,gBjB9qDM;A7F6jhBV;;A8G34dE;EACE,gBjBlrDmB;A7FgkhBvB;;A8G14dE;EACE,gBjBtrDc;A7FmkhBlB;;A8Gz4dE;EACE,gBjB1rDuB;A7FskhB3B;;A8Gx4dE;EACE,gBjB9rDkB;A7FykhBtB;;A8Gv4dE;EACE,gBjBlsDqB;A7F4khBzB;;A8Gt4dE;EACE,gBjBtsDgB;A7F+khBpB;;A8Gr4dE;EACE,gBjB1sDe;A7FklhBnB;;A8Gp4dE;EACE,gBjB9sDU;A7FqlhBd;;A8Gn4dE;EACE,gBjBltDoB;A7FwlhBxB;;A8Gl4dE;EACE,gBjBttDe;A7F2lhBnB;;A8Gj4dE;EACE,gBjB1tDM;A7F8lhBV;;A8Gh4dE;EACE,gBjB9tDU;A7FimhBd;;A8G/3dE;EACE,gBjBluDe;A7FomhBnB;;A8G93dE;EACE,gBjBtuDW;A7FumhBf;;A8G73dE;EACE,gBjB1uDa;A7F0mhBjB;;A8G53dE;EACE,gBjB9uDQ;A7F6mhBZ;;A8G33dE;EACE,gBjBlvDS;A7FgnhBb;;A8G13dE;EACE,gBjBtvDc;A7FmnhBlB;;A8Gz3dE;EACE,gBjB1vDO;A7FsnhBX;;A8Gx3dE;EACE,gBjB9vDY;A7FynhBhB;;A8Gv3dE;EACE,gBjBlwDM;A7F4nhBV;;A8Gt3dE;EACE,gBjBtwDW;A7F+nhBf;;A8Gr3dE;EACE,gBjB1wDI;A7FkohBR;;A8Gp3dE;EACE,gBjB9wDQ;A7FqohBZ;;A8Gn3dE;EACE,gBjBlxDS;A7FwohBb;;A8Gl3dE;EACE,gBjBtxDW;A7F2ohBf;;A8Gj3dE;EACE,gBjB1xDQ;A7F8ohBZ;;A8Gh3dE;EACE,gBjB9xDQ;A7FiphBZ;;A8G/2dE;EACE,gBjBlyDS;A7FophBb;;A8G92dE;EACE,gBjBtyDa;A7FuphBjB;;A8G72dE;EACE,gBjB1yDc;A7F0phBlB;;A8G52dE;EACE,gBjB9yDgB;A7F6phBpB;;A8G32dE;EACE,gBjBlzDY;A7FgqhBhB;;A8G12dE;EACE,gBjBtzDa;A7FmqhBjB;;A8Gz2dE;EACE,gBjB1zDK;A7FsqhBT;;A8Gx2dE;EACE,gBjB9zDM;A7FyqhBV;;A8Gv2dE;EACE,gBjBl0Dc;A7F4qhBlB;;A8Gt2dE;EACE,gBjBt0DU;A7F+qhBd;;A8Gr2dE;EACE,gBjB10DiB;A7FkrhBrB;;A8Gp2dE;EACE,gBjB90DkB;A7FqrhBtB;;A8Gn2dE;EACE,gBjBl1DU;A7FwrhBd;;A8Gl2dE;EACE,gBjBt1DW;A7F2rhBf;;A8Gj2dE;EACE,gBjB11DQ;A7F8rhBZ;;A8Gh2dE;EACE,gBjB91DQ;A7FishBZ;;A8G/1dE;EACE,gBjBl2DM;A7FoshBV;;A8G91dE;EACE,gBjBt2DU;A7FushBd;;A8G71dE;EACE,gBjB12DQ;A7F0shBZ;;A8G51dE;EACE,gBjB92DY;A7F6shBhB;;A8G31dE;EACE,gBjBl3DQ;A7FgthBZ;;A8G11dE;EACE,gBjBt3DQ;A7FmthBZ;;A8Gz1dE;EACE,gBjB13DM;A7FsthBV;;A8Gx1dE;EACE,gBjB93DW;A7FythBf;;A8Gv1dE;EACE,gBjBl4DgB;A7F4thBpB;;A8Gt1dE;EACE,gBjBt4DgB;A7F+thBpB;;A8Gr1dE;EACE,gBjB14DqB;A7FkuhBzB;;A8Gp1dE;EACE,gBjB94DO;A7FquhBX;;A8Gn1dE;EACE,gBjBl5DY;A7FwuhBhB;;A8Gl1dE;EACE,gBjBt5DO;A7F2uhBX;;A8Gj1dE;EACE,gBjB15Dc;A7F8uhBlB;;A8Gh1dE;EACE,gBjB95DgB;A7FivhBpB;;A8G/0dE;EACE,gBjBl6DY;A7FovhBhB;;A8G90dE;EACE,gBjBt6DS;A7FuvhBb;;A8G70dE;EACE,gBjB16Dc;A7F0vhBlB;;A8G50dE;EACE,gBjB96DQ;A7F6vhBZ;;A8G30dE;EACE,gBjBl7Da;A7FgwhBjB;;A8G10dE;EACE,gBjBt7DU;A7FmwhBd;;A8Gz0dE;EACE,gBjB17DU;A7FswhBd;;A8Gx0dE;EACE,gBjB97DS;A7FywhBb;;A8Gv0dE;EACE,gBjBl8DQ;A7F4whBZ;;A8Gt0dE;EACE,gBjBt8DY;A7F+whBhB;;A8Gr0dE;EACE,gBjB18DS;A7FkxhBb;;A8Gp0dE;EACE,gBjB98DU;A7FqxhBd;;A8Gn0dE;EACE,gBjBl9DS;A7FwxhBb;;A8Gl0dE;EACE,gBjBt9Da;A7F2xhBjB;;A8Gj0dE;EACE,gBjB19De;A7F8xhBnB;;A8Gh0dE;EACE,gBjB99Dc;A7FiyhBlB;;A8G/zdE;EACE,gBjBl+DiB;A7FoyhBrB;;A8G9zdE;EACE,gBjBt+Dc;A7FuyhBlB;;A8G7zdE;EACE,gBjB1+DU;A7F0yhBd;;A8G5zdE;EACE,gBjB9+DS;A7F6yhBb;;A8G3zdE;EACE,gBjBl/DS;A7FgzhBb;;A8G1zdE;EACE,gBjBt/Dc;A7FmzhBlB;;A8GzzdE;EACE,gBjB1/Dc;A7FszhBlB;;A8GxzdE;EACE,gBjB9/De;A7FyzhBnB;;A8GvzdE;EACE,gBjBlgEK;A7F4zhBT;;A8GtzdE;EACE,gBjBtgES;A7F+zhBb;;A8GrzdE;EACE,gBjB1gEO;A7Fk0hBX;;A8GpzdE;EACE,gBjB9gEQ;A7Fq0hBZ;;A8GnzdE;EACE,gBjBlhEO;A7Fw0hBX;;A8GlzdE;EACE,gBjBthEQ;A7F20hBZ;;A8GjzdE;EACE,gBjB1hEY;A7F80hBhB;;A8GhzdE;EACE,gBjB9hEa;A7Fi1hBjB;;A8G/ydE;EACE,gBjBliEc;A7Fo1hBlB;;A8G9ydE;EACE,gBjBtiEY;A7Fu1hBhB;;A8G7ydE;EACE,gBjB1iEa;A7F01hBjB;;A8G5ydE;EACE,gBjB9iEe;A7F61hBnB;;A8G3ydE;EACE,gBjBljEoB;A7Fg2hBxB;;A8G1ydE;EACE,gBjBtjEM;A7Fm2hBV;;A8GzydE;EACE,gBjB1jEW;A7Fs2hBf;;A8GxydE;EACE,gBjB9jEU;A7Fy2hBd;;A8GvydE;EACE,gBjBlkEM;A7F42hBV;;A8GtydE;EACE,gBjBtkEQ;A7F+2hBZ;;A8GrydE;EACE,gBjB1kEW;A7Fk3hBf;;A8GpydE;EACE,gBjB9kEgB;A7Fq3hBpB;;A8GnydE;EACE,gBjBllES;A7Fw3hBb;;A8GlydE;EACE,gBjBtlEI;A7F23hBR;;A8GjydE;EACE,gBjB1lEY;A7F83hBhB;;A8GhydE;EACE,gBjB9lEK;A7Fi4hBT;;A8G/xdE;EACE,gBjBlmEM;A7Fo4hBV;;A8G9xdE;EACE,gBjBtmEK;A7Fu4hBT;;A8G7xdE;EACE,gBjB1mEU;A7F04hBd;;A8G5xdE;EACE,gBjB9mEU;A7F64hBd;;A8G3xdE;EACE,gBjBlnEe;A7Fg5hBnB;;A8G1xdE;EACE,gBjBtnEc;A7Fm5hBlB;;A8GzxdE;EACE,gBjB1nEW;A7Fs5hBf;;A8GxxdE;EACE,gBjB9nEM;A7Fy5hBV;;A8GvxdE;EACE,gBjBloEc;A7F45hBlB;;A8GtxdE;EACE,gBjBtoEU;A7F+5hBd;;A8GrxdE;EACE,gBjB1oES;A7Fk6hBb;;A8GpxdE;EACE,gBjB9oEc;A7Fq6hBlB;;A8GnxdE;EACE,gBjBlpEK;A7Fw6hBT;;A8GlxdE;EACE,gBjBtpEU;A7F26hBd;;A8GjxdE;EACE,gBjB1pES;A7F86hBb;;A8GhxdE;EACE,gBjB9pEc;A7Fi7hBlB;;A8G/wdE;EACE,gBjBlqEM;A7Fo7hBV;;A8G9wdE;EACE,gBjBtqEY;A7Fu7hBhB;;A8G7wdE;EACE,gBjB1qEW;A7F07hBf;;A8G5wdE;EACE,gBjB9qEa;A7F67hBjB;;A8G3wdE;EACE,gBjBlrEY;A7Fg8hBhB;;A8G1wdE;EACE,gBjBtrEW;A7Fm8hBf;;A8GzwdE;EACE,gBjB1rEW;A7Fs8hBf;;A8GxwdE;EACE,gBjB9rEU;A7Fy8hBd;;A8GvwdE;EACE,gBjBlsEU;A7F48hBd;;A8GtwdE;EACE,gBjBtsEU;A7F+8hBd;;A8GrwdE;EACE,gBjB1sEU;A7Fk9hBd;;A8GpwdE;EACE,gBjB9sEU;A7Fq9hBd;;A8GnwdE;EACE,gBjBltEe;A7Fw9hBnB;;A8GlwdE;EACE,gBjBttEW;A7F29hBf;;A8GjwdE;EACE,gBjB1tEO;A7F89hBX;;A8GhwdE;EACE,gBjB9tEW;A7Fi+hBf;;A8G/vdE;EACE,gBjBluEiB;A7Fo+hBrB;;A8G9vdE;EACE,gBjBtuEgB;A7Fu+hBpB;;A8G7vdE;EACE,gBjB1uEkB;A7F0+hBtB;;A8G5vdE;EACE,gBjB9uEiB;A7F6+hBrB;;A8G3vdE;EACE,gBjBlvEgB;A7Fg/hBpB;;A8G1vdE;EACE,gBjBtvEY;A7Fm/hBhB;;A8GzvdE;EACE,gBjB1vEQ;A7Fs/hBZ;;A8GxvdE;EACE,gBjB9vEc;A7Fy/hBlB;;A8GvvdE;EACE,gBjBlwEa;A7F4/hBjB;;A8GtvdE;EACE,gBjBtwEe;A7F+/hBnB;;A8GrvdE;EACE,gBjB1wEc;A7FkgiBlB;;A8GpvdE;EACE,gBjB9wEa;A7FqgiBjB;;A8GnvdE;EACE,gBjBlxES;A7FwgiBb;;A8GlvdE;EACE,gBjBtxEa;A7F2giBjB;;A8GjvdE;EACE,gBjB1xEc;A7F8giBlB;;A8GhvdE;EACE,gBjB9xEY;A7FihiBhB;;A8G/udE;EACE,gBjBlyEW;A7FohiBf;;A8G9udE;EACE,gBjBtyEa;A7FuhiBjB;;A8G7udE;EACE,gBjB1yEQ;A7F0hiBZ;;A8G5udE;EACE,gBjB9yEM;A7F6hiBV;;A8G3udE;EACE,gBjBlzEW;A7FgiiBf;;A8G1udE;EACE,gBjBtzEQ;A7FmiiBZ;;A8GzudE;EACE,gBjB1zEW;A7FsiiBf;;A8GxudE;EACE,gBjB9zEgB;A7FyiiBpB;;A8GvudE;EACE,gBjBl0ES;A7F4iiBb;;A8GtudE;EACE,gBjBt0EM;A7F+iiBV;;A8GrudE;EACE,gBjB10EQ;A7FkjiBZ;;A8GpudE;EACE,gBjB90EU;A7FqjiBd;;A8GnudE;EACE,gBjBl1EW;A7FwjiBf;;A8GludE;EACE,gBjBt1EY;A7F2jiBhB;;A8GjudE;EACE,gBjB11EW;A7F8jiBf;;A8GhudE;EACE,gBjB91Ea;A7FikiBjB;;A8G/tdE;EACE,gBjBl2Ee;A7FokiBnB;;A8G9tdE;EACE,gBjBt2EgB;A7FukiBpB;;A8G7tdE;EACE,gBjB12EiB;A7F0kiBrB;;A8G5tdE;EACE,gBjB92EmB;A7F6kiBvB;;A8G3tdE;EACE,gBjBl3Ec;A7FgliBlB;;A8G1tdE;EACE,gBjBt3EU;A7FmliBd;;A8GztdE;EACE,gBjB13Ee;A7FsliBnB;;A8GxtdE;EACE,gBjB93EW;A7FyliBf;;A8GvtdE;EACE,gBjBl4Ee;A7F4liBnB;;A8GttdE;EACE,gBjBt4EY;A7F+liBhB;;A8GrtdE;EACE,gBjB14EU;A7FkmiBd;;A8GptdE;EACE,gBjB94Ea;A7FqmiBjB;;A8GntdE;EACE,gBjBl5EW;A7FwmiBf;;A8GltdE;EACE,gBjBt5EY;A7F2miBhB;;A8GjtdE;EACE,gBjB15EM;A7F8miBV;;A8GhtdE;EACE,gBjB95EU;A7FiniBd;;A8G/sdE;EACE,gBjBl6EY;A7FoniBhB;;A8G9sdE;EACE,gBjBt6EiB;A7FuniBrB;;A8G7sdE;EACE,gBjB16Ee;A7F0niBnB;;A8G5sdE;EACE,gBjB96EY;A7F6niBhB;;A8G3sdE;EACE,gBjBl7EW;A7FgoiBf;;A8G1sdE;EACE,gBjBt7Ee;A7FmoiBnB;;A8GzsdE;EACE,gBjB17EU;A7FsoiBd;;A8GxsdE;EACE,gBjB97EY;A7FyoiBhB;;A8GvsdE;EACE,gBjBl8EQ;A7F4oiBZ;;A8GtsdE;EACE,gBjBt8Ea;A7F+oiBjB;;A8GrsdE;EACE,gBjB18EgB;A7FkpiBpB;;A8GpsdE;EACE,gBjB98EO;A7FqpiBX;;A8GnsdE;EACE,gBjBl9EY;A7FwpiBhB;;A8GlsdE;EACE,gBjBt9EK;A7F2piBT;;A8GjsdE;EACE,gBjB19ES;A7F8piBb;;A8GhsdE;EACE,gBjB99EU;A7FiqiBd;;A8G/rdE;EACE,gBjBl+EU;A7FoqiBd;;A8G9rdE;EACE,gBjBt+Ec;A7FuqiBlB;;A8G7rdE;EACE,gBjB1+EgB;A7F0qiBpB;;A8G5rdE;EACE,gBjB9+EqB;A7F6qiBzB;;A8G3rdE;EACE,gBjBl/EO;A7FgriBX;;A8G1rdE;EACE,gBjBt/EO;A7FmriBX;;A8GzrdE;EACE,gBjB1/EO;A7FsriBX;;A8GxrdE;EACE,gBjB9/EK;A7FyriBT;;A8GvrdE;EACE,gBjBlgFK;A7F4riBT;;A8GtrdE;EACE,gBjBtgFY;A7F+riBhB;;A8GrrdE;EACE,gBjB1gFa;A7FksiBjB;;A8GprdE;EACE,gBjB9gFU;A7FqsiBd;;A8GnrdE;EACE,gBjBlhFU;A7FwsiBd;;A8GlrdE;EACE,gBjBthFM;A7F2siBV;;A8GjrdE;EACE,gBjB1hFU;A7F8siBd;;A8GhrdE;EACE,gBjB9hFW;A7FitiBf;;A8G/qdE;EACE,gBjBliFK;A7FotiBT;;A8G9qdE;EACE,gBjBtiFU;A7FutiBd;;A8G7qdE;EACE,gBjB1iFO;A7F0tiBX;;A8G5qdE;EACE,gBjB9iFU;A7F6tiBd;;A8G3qdE;EACE,gBjBljFW;A7FguiBf;;A8G1qdE;EACE,gBjBtjFY;A7FmuiBhB;;A8GzqdE;EACE,gBjB1jFe;A7FsuiBnB;;A8GxqdE;EACE,gBjB9jFgB;A7FyuiBpB;;A8GvqdE;EACE,gBjBlkFY;A7F4uiBhB;;A8GtqdE;EACE,gBjBtkFM;A7F+uiBV;;A8GrqdE;EACE,gBjB1kFU;A7FkviBd;;A8GpqdE;EACE,gBjB9kFW;A7FqviBf;;A8GnqdE;EACE,gBjBllFe;A7FwviBnB;;A8GlqdE;EACE,gBjBtlFQ;A7F2viBZ;;A8GjqdE;EACE,gBjB1lFa;A7F8viBjB;;A8GhqdE;EACE,gBjB9lFM;A7FiwiBV;;A8G/pdE;EACE,gBjBlmFQ;A7FowiBZ;;A8G9pdE;EACE,gBjBtmFW;A7FuwiBf;;A8G7pdE;EACE,gBjB1mFa;A7F0wiBjB;;A8G5pdE;EACE,gBjB9mFS;A7F6wiBb;;A8G3pdE;EACE,gBjBlnFU;A7FgxiBd;;A8G1pdE;EACE,gBjBtnFK;A7FmxiBT;;A8GzpdE;EACE,gBjB1nFc;A7FsxiBlB;;A8GxpdE;EACE,gBjB9nFM;A7FyxiBV;;A8GvpdE;EACE,gBjBloFS;A7F4xiBb;;A8GtpdE;EACE,gBjBtoFc;A7F+xiBlB;;A8GrpdE;EACE,gBjB1oFe;A7FkyiBnB;;A8GppdE;EACE,gBjB9oFY;A7FqyiBhB;;A8GnpdE;EACE,gBjBlpFa;A7FwyiBjB;;A8GlpdE;EACE,gBjBtpFY;A7F2yiBhB;;A8GjpdE;EACE,gBjB1pFY;A7F8yiBhB;;A8GhpdE;EACE,gBjB9pFW;A7FiziBf;;A8G/odE;EACE,gBjBlqFW;A7FoziBf;;A8G9odE;EACE,gBjBtqFM;A7FuziBV;;A8G7odE;EACE,gBjB1qFW;A7F0ziBf;;A8G5odE;EACE,gBjB9qFM;A7F6ziBV;;A8G3odE;EACE,gBjBlrFS;A7Fg0iBb;;A8G1odE;EACE,gBjBtrFM;A7Fm0iBV;;A8GzodE;EACE,gBjB1rFQ;A7Fs0iBZ;;A8GxodE;EACE,gBjB9rFM;A7Fy0iBV;;A8GvodE;EACE,gBjBlsFQ;A7F40iBZ;;A8GtodE;EACE,gBjBtsFW;A7F+0iBf;;A8GrodE;EACE,gBjB1sFS;A7Fk1iBb;;A8GpodE;EACE,gBjB9sFI;A7Fq1iBR;;A8GnodE;EACE,gBjBltFM;A7Fw1iBV;;A8GlodE;EACE,gBjBttFM;A7F21iBV;;A8GjodE;EACE,gBjB1tFe;A7F81iBnB;;A8GhodE;EACE,gBjB9tFU;A7Fi2iBd;;A8G/ndE;EACE,gBjBluFK;A7Fo2iBT;;A8G9ndE;EACE,gBjBtuFK;A7Fu2iBT;;A8G7ndE;EACE,gBjB1uFU;A7F02iBd;;A8G5ndE;EACE,gBjB9uFW;A7F62iBf;;A8G3ndE;EACE,gBjBlvFM;A7Fg3iBV;;A8G1ndE;EACE,gBjBtvFO;A7Fm3iBX;;A8GzndE;EACE,gBjB1vFY;A7Fs3iBhB;;A8GxndE;EACE,gBjB9vFQ;A7Fy3iBZ;;A8GvndE;EACE,gBjBlwFQ;A7F43iBZ;;A8GtndE;EACE,gBjBtwFY;A7F+3iBhB;;A8GrndE;EACE,gBjB1wFY;A7Fk4iBhB;;A8GpndE;EACE,gBjB9wFO;A7Fq4iBX;;A8GnndE;EACE,gBjBlxFO;A7Fw4iBX;;A8GlndE;EACE,gBjBtxFO;A7F24iBX;;A8GjndE;EACE,gBjB1xFY;A7F84iBhB;;A8GhndE;EACE,gBjB9xFS;A7Fi5iBb;;A8G/mdE;EACE,gBjBlyFK;A7Fo5iBT;;A8G9mdE;EACE,gBjBtyFa;A7Fu5iBjB;;A8G7mdE;EACE,gBjB1yFS;A7F05iBb;;A8G5mdE;EACE,gBjB9yFc;A7F65iBlB;;A8G3mdE;EACE,gBjBlzFc;A7Fg6iBlB;;A8G1mdE;EACE,gBjBtzFU;A7Fm6iBd;;A8GzmdE;EACE,gBjB1zFe;A7Fs6iBnB;;A8GxmdE;EACE,gBjB9zFM;A7Fy6iBV;;A8GvmdE;EACE,gBjBl0FO;A7F46iBX;;A8GtmdE;EACE,gBjBt0FU;A7F+6iBd;;A8GrmdE;EACE,gBjB10Fa;A7Fk7iBjB;;A8GpmdE;EACE,gBjB90FY;A7Fq7iBhB;;A8GnmdE;EACE,gBjBl1FY;A7Fw7iBhB;;A8GlmdE;EACE,gBjBt1FiB;A7F27iBrB;;A8GjmdE;EACE,gBjB11FqB;A7F87iBzB;;A8GhmdE;EACE,gBjB91FW;A7Fi8iBf;;A8G/ldE;EACE,gBjBl2FW;A7Fo8iBf;;A8G9ldE;EACE,gBjBt2FY;A7Fu8iBhB;;A8G7ldE;EACE,gBjB12Fe;A7F08iBnB;;A8G5ldE;EACE,gBjB92FkB;A7F68iBtB;;A8G3ldE;EACE,gBjBl3FiB;A7Fg9iBrB;;A8G1ldE;EACE,gBjBt3FiB;A7Fm9iBrB;;A8GzldE;EACE,gBjB13FsB;A7Fs9iB1B;;A8GxldE;EACE,gBjB93FgB;A7Fy9iBpB;;A8GvldE;EACE,gBjBl4Fa;A7F49iBjB;;A8GtldE;EACE,gBjBt4FkB;A7F+9iBtB;;A8GrldE;EACE,gBjB14FQ;A7Fk+iBZ;;A8GpldE;EACE,gBjB94Fa;A7Fq+iBjB;;A8GnldE;EACE,gBjBl5FY;A7Fw+iBhB;;A8GlldE;EACE,gBjBt5FS;A7F2+iBb;;A8GjldE;EACE,gBjB15Fc;A7F8+iBlB;;A8GhldE;EACE,gBjB95FQ;A7Fi/iBZ;;A8G/kdE;EACE,gBjBl6FS;A7Fo/iBb;;A8G9kdE;EACE,gBjBt6FQ;A7Fu/iBZ;;A8G7kdE;EACE,gBjB16FQ;A7F0/iBZ;;A8G5kdE;EACE,gBjB96FM;A7F6/iBV;;A8G3kdE;EACE,gBjBl7FM;A7FggjBV;;A8G1kdE;EACE,gBjBt7FY;A7FmgjBhB;;A8GzkdE;EACE,gBjB17FQ;A7FsgjBZ;;A8GxkdE;EACE,gBjB97FW;A7FygjBf;;A8GvkdE;EACE,gBjBl8FO;A7F4gjBX;;A8GtkdE;EACE,gBjBt8FQ;A7F+gjBZ;;A8GrkdE;EACE,gBjB18FS;A7FkhjBb;;A8GpkdE;EACE,gBjB98FS;A7FqhjBb;;A8GnkdE;EACE,gBjBl9FQ;A7FwhjBZ;;A8GlkdE;EACE,gBjBt9FQ;A7F2hjBZ;;A8GjkdE;EACE,gBjB19FU;A7F8hjBd;;A8GhkdE;EACE,gBjB99FO;A7FiijBX;;A8G/jdE;EACE,gBjBl+FW;A7FoijBf;;A8G9jdE;EACE,gBjBt+FO;A7FuijBX;;A8G7jdE;EACE,gBjB1+FY;A7F0ijBhB;;A8G5jdE;EACE,gBjB9+FgB;A7F6ijBpB;;A8G3jdE;EACE,gBjBl/FO;A7FgjjBX;;A8G1jdE;EACE,gBjBt/FU;A7FmjjBd;;A8GzjdE;EACE,gBjB1/FW;A7FsjjBf;;A8GxjdE;EACE,gBjB9/FS;A7FyjjBb;;A8GvjdE;EACE,gBjBlgGW;A7F4jjBf;;A8GtjdE;EACE,gBjBtgGM;A7F+jjBV;;A8GrjdE;EACE,gBjB1gGe;A7FkkjBnB;;A8GpjdE;EACE,gBjB9gGa;A7FqkjBjB;;A8GnjdE;EACE,gBjBlhGS;A7FwkjBb;;A8GljdE;EACE,gBjBthGM;A7F2kjBV;;A8GjjdE;EACE,gBjB1hGY;A7F8kjBhB;;A8GhjdE;EACE,gBjB9hGQ;A7FiljBZ;;A8G/idE;EACE,gBjBliGW;A7FoljBf;;A8G9idE;EACE,gBjBtiGiB;A7FuljBrB;;A8G7idE;EACE,gBjB1iGa;A7F0ljBjB;;A8G5idE;EACE,gBjB9iGW;A7F6ljBf;;A8G3idE;EACE,gBjBljGM;A7FgmjBV;;A8G1idE;EACE,gBjBtjGI;A7FmmjBR;;A8GzidE;EACE,gBjB1jGO;A7FsmjBX;;A8GxidE;EACE,gBjB9jGO;A7FymjBX;;A8GvidE;EACE,gBjBlkGM;A7F4mjBV;;A8GtidE;EACE,gBjBtkGU;A7F+mjBd;;A8GridE;EACE,gBjB1kGe;A7FknjBnB;;A8GpidE;EACE,gBjB9kGkB;A7FqnjBtB;;A8GnidE;EACE,gBjBllGa;A7FwnjBjB;;A8GlidE;EACE,gBjBtlGc;A7F2njBlB;;A8GjidE;EACE,gBjB1lGS;A7F8njBb;;A8GhidE;EACE,gBjB9lGW;A7FiojBf;;A8G/hdE;EACE,gBjBlmGY;A7FoojBhB;;A8G9hdE;EACE,gBjBtmGO;A7FuojBX;;A8G7hdE;EACE,gBjB1mGS;A7F0ojBb;;A8G5hdE;EACE,gBjB9mGK;A7F6ojBT;;A8G3hdE;EACE,gBjBlnGQ;A7FgpjBZ;;A8G1hdE;EACE,gBjBtnGa;A7FmpjBjB;;A8GzhdE;EACE,gBjB1nGc;A7FspjBlB;;A8GxhdE;EACE,gBjB9nGc;A7FypjBlB;;A8GvhdE;EACE,gBjBloGY;A7F4pjBhB;;A8GthdE;EACE,gBjBtoGU;A7F+pjBd;;A8GrhdE;EACE,gBjB1oGQ;A7FkqjBZ;;A8GphdE;EACE,gBjB9oGmB;A7FqqjBvB;;A8GnhdE;EACE,gBjBlpGmB;A7FwqjBvB;;A8GlhdE;EACE,gBjBtpGa;A7F2qjBjB;;A8GjhdE;EACE,gBjB1pGa;A7F8qjBjB;;A8GhhdE;EACE,gBjB9pGkB;A7FirjBtB;;A8G/gdE;EACE,gBjBlqGa;A7ForjBjB;;A8G9gdE;EACE,gBjBtqGO;A7FurjBX;;A8G7gdE;EACE,gBjB1qGW;A7F0rjBf;;A8G5gdE;EACE,gBjB9qGY;A7F6rjBhB;;A8G3gdE;EACE,gBjBlrGgB;A7FgsjBpB;;A8G1gdE;EACE,gBjBtrGQ;A7FmsjBZ;;A8GzgdE;EACE,gBjB1rGY;A7FssjBhB;;A8GxgdE;EACE,gBjB9rGW;A7FysjBf;;A8GvgdE;EACE,gBjBlsGY;A7F4sjBhB;;A8GtgdE;EACE,gBjBtsGe;A7F+sjBnB;;A8GrgdE;EACE,gBjB1sGa;A7FktjBjB;;A8GpgdE;EACE,gBjB9sGM;A7FqtjBV;;A8GngdE;EACE,gBjBltGW;A7FwtjBf;;A8GlgdE;EACE,gBjBttGgB;A7F2tjBpB;;A8GjgdE;EACE,gBjB1tGW;A7F8tjBf;;A8GhgdE;EACE,gBjB9tGY;A7FiujBhB;;A8G//cE;EACE,gBjBluGO;A7FoujBX;;A8G9/cE;EACE,gBjBtuGY;A7FuujBhB;;A8G7/cE;EACE,gBjB1uGe;A7F0ujBnB;;A8G5/cE;EACE,gBjB9uGU;A7F6ujBd;;A8G3/cE;EACE,gBjBlvGa;A7FgvjBjB;;A8G1/cE;EACE,gBjBtvGW;A7FmvjBf;;A8Gz/cE;EACE,gBjB1vGK;A7FsvjBT;;A8Gx/cE;EACE,gBjB9vGS;A7FyvjBb;;A8Gv/cE;EACE,gBjBlwGM;A7F4vjBV;;A8Gt/cE;EACE,gBjBtwGU;A7F+vjBd;;A8Gr/cE;EACE,gBjB1wGc;A7FkwjBlB;;A8Gp/cE;EACE,gBjB9wGW;A7FqwjBf;;A8Gn/cE;EACE,gBjBlxGU;A7FwwjBd;;A8Gl/cE;EACE,gBjBtxGe;A7F2wjBnB;;A8Gj/cE;EACE,gBjB1xGO;A7F8wjBX;;A8Gh/cE;EACE,gBjB9xGY;A7FixjBhB;;A8G/+cE;EACE,gBjBlyGU;A7FoxjBd;;A8G9+cE;EACE,gBjBtyGS;A7FuxjBb;;A8G7+cE;EACE,gBjB1yGe;A7F0xjBnB;;A8G5+cE;EACE,gBjB9yGc;A7F6xjBlB;;A8G3+cE;EACE,gBjBlzGW;A7FgyjBf;;A8G1+cE;EACE,gBjBtzGgB;A7FmyjBpB;;A8Gz+cE;EACE,gBjB1zGY;A7FsyjBhB;;A8Gx+cE;EACE,gBjB9zGQ;A7FyyjBZ;;A8Gv+cE;EACE,gBjBl0Gc;A7F4yjBlB;;A8Gt+cE;EACE,gBjBt0Ga;A7F+yjBjB;;A8Gr+cE;EACE,gBjB10GiB;A7FkzjBrB;;A8Gp+cE;EACE,gBjB90Ga;A7FqzjBjB;;A8Gn+cE;EACE,gBjBl1GmB;A7FwzjBvB;;A8Gl+cE;EACE,gBjBt1GkB;A7F2zjBtB;;A8Gj+cE;EACE,gBjB11GY;A7F8zjBhB;;A8Gh+cE;EACE,gBjB91GW;A7Fi0jBf;;A8G/9cE;EACE,gBjBl2GW;A7Fo0jBf;;A8G99cE;EACE,gBjBt2Ga;A7Fu0jBjB;;A8G79cE;EACE,gBjB12GO;A7F00jBX;;A8G59cE;EACE,gBjB92GY;A7F60jBhB;;A8G39cE;EACE,gBjBl3GkB;A7Fg1jBtB;;A8G19cE;EACE,gBjBt3Ga;A7Fm1jBjB;;A8Gz9cE;EACE,gBjB13GQ;A7Fs1jBZ;;A8Gx9cE;EACE,gBjB93GW;A7Fy1jBf;;A8Gv9cE;EACE,gBjBl4GO;A7F41jBX;;A8Gt9cE;EACE,gBjBt4GM;A7F+1jBV;;A8Gr9cE;EACE,gBjB14GU;A7Fk2jBd;;A8Gp9cE;EACE,gBjB94Ge;A7Fq2jBnB;;A8Gn9cE;EACE,gBjBl5GW;A7Fw2jBf;;A8Gl9cE;EACE,gBjBt5GgB;A7F22jBpB;;A8Gj9cE;EACE,gBjB15GU;A7F82jBd;;A8Gh9cE;EACE,gBjB95GU;A7Fi3jBd;;A8G/8cE;EACE,gBjBl6GO;A7Fo3jBX;;A8G98cE;EACE,gBjBt6GW;A7Fu3jBf;;A8G78cE;EACE,gBjB16GM;A7F03jBV;;A8G58cE;EACE,gBjB96GO;A7F63jBX;;A8G38cE;EACE,gBjBl7GS;A7Fg4jBb;;A8G18cE;EACE,gBjBt7GO;A7Fm4jBX;;A8Gz8cE;EACE,gBjB17GU;A7Fs4jBd;;A8Gx8cE;EACE,gBjB97Ga;A7Fy4jBjB;;A8Gv8cE;EACE,gBjBl8GU;A7F44jBd;;A8Gt8cE;EACE,gBjBt8GU;A7F+4jBd;;A8Gr8cE;EACE,gBjB18GW;A7Fk5jBf;;A8Gp8cE;EACE,gBjB98GU;A7Fq5jBd;;A8Gn8cE;EACE,gBjBl9GU;A7Fw5jBd;;A8Gl8cE;EACE,gBjBt9GY;A7F25jBhB;;A8Gj8cE;EACE,gBjB19GU;A7F85jBd;;A8Gh8cE;EACE,gBjB99GU;A7Fi6jBd;;A8G/7cE;EACE,gBjBl+GU;A7Fo6jBd;;A8G97cE;EACE,gBjBt+GU;A7Fu6jBd;;A8G77cE;EACE,gBjB1+GU;A7F06jBd;;A8G57cE;EACE,gBjB9+GW;A7F66jBf;;A8G37cE;EACE,gBjBl/GU;A7Fg7jBd;;A8G17cE;EACE,gBjBt/GU;A7Fm7jBd;;A8Gz7cE;EACE,gBjB1/GU;A7Fs7jBd;;A8Gx7cE;EACE,gBjB9/GU;A7Fy7jBd;;A8Gv7cE;EACE,gBjBlgHU;A7F47jBd;;A8Gt7cE;EACE,gBjBtgHU;A7F+7jBd;;A8Gr7cE;EACE,gBjB1gHU;A7Fk8jBd;;A8Gp7cE;EACE,gBjB9gHS;A7Fq8jBb;;A8Gn7cE;EACE,gBjBlhHU;A7Fw8jBd;;A8Gl7cE;EACE,gBjBthHU;A7F28jBd;;A8Gj7cE;EACE,gBjB1hHU;A7F88jBd;;A8Gh7cE;EACE,gBjB9hHU;A7Fi9jBd;;A8G/6cE;EACE,gBjBliHU;A7Fo9jBd;;A8G96cE;EACE,gBjBtiHU;A7Fu9jBd;;A8G76cE;EACE,gBjB1iHU;A7F09jBd;;A8G56cE;EACE,gBjB9iHY;A7F69jBhB;;A8G36cE;EACE,gBjBljHO;A7Fg+jBX;;A8G16cE;EACE,gBjBtjHU;A7Fm+jBd;;A8Gz6cE;EACE,gBjB1jHM;A7Fs+jBV;;A8Gx6cE;EACE,gBjB9jHU;A7Fy+jBd;;A8Gv6cE;EACE,gBjBlkHK;A7F4+jBT;;A8Gt6cE;EACE,gBjBtkHU;A7F++jBd;;A8Gr6cE;EACE,gBjB1kHQ;A7Fk/jBZ;;A8Gp6cE;EACE,gBjB9kHW;A7Fq/jBf;;A8Gn6cE;EACE,gBjBllHc;A7Fw/jBlB;;A8Gl6cE;EACE,gBjBtlHY;A7F2/jBhB;;A8Gj6cE;EACE,gBjB1lHW;A7F8/jBf;;A8Gh6cE;EACE,gBjB9lHQ;A7FigkBZ;;A8G/5cE;EACE,gBjBlmHU;A7FogkBd;;A8G95cE;EACE,gBjBtmHS;A7FugkBb;;A8G75cE;EACE,gBjB1mHU;A7F0gkBd;;A8G55cE;EACE,gBjB9mHc;A7F6gkBlB;;A8G35cE;EACE,gBjBlnHU;A7FghkBd;;A8G15cE;EACE,gBjBtnHS;A7FmhkBb;;A8Gz5cE;EACE,gBjB1nHU;A7FshkBd;;A8Gx5cE;EACE,gBjB9nHY;A7FyhkBhB;;A8Gv5cE;EACE,gBjBloHU;A7F4hkBd;;A8Gt5cE;EACE,gBjBtoHU;A7F+hkBd;;A8Gr5cE;EACE,gBjB1oHW;A7FkikBf;;A8Gp5cE;EACE,gBjB9oHM;A7FqikBV;;A8Gn5cE;EACE,gBjBlpHc;A7FwikBlB;;A8Gl5cE;EACE,gBjBtpHY;A7F2ikBhB;;A8Gj5cE;EACE,gBjB1pHU;A7F8ikBd;;A8Gh5cE;EACE,gBjB9pHK;A7FijkBT;;A8G/4cE;EACE,gBjBlqHU;A7FojkBd;;A8G94cE;EACE,gBjBtqHQ;A7FujkBZ;;A8G74cE;EACE,gBjB1qHkB;A7F0jkBtB;;A8G54cE;EACE,gBjB9qHK;A7F6jkBT;;A8G34cE;EACE,gBjBlrHQ;A7FgkkBZ;;A8G14cE;EACE,gBjBtrHI;A7FmkkBR;;A8Gz4cE;EACE,gBjB1rHO;A7FskkBX;;A8Gx4cE;EACE,gBjB9rHU;A7FykkBd;;A8Gv4cE;EACE,gBjBlsHa;A7F4kkBjB;;A8Gt4cE;EACE,gBjBtsHM;A7F+kkBV;;A8Gr4cE;EACE,gBjB1sHS;A7FklkBb;;A8Gp4cE;EACE,gBjB9sHW;A7FqlkBf;;A8Gn4cE;EACE,gBjBltHW;A7FwlkBf;;A8Gl4cE;EACE,gBjBttHY;A7F2lkBhB;;A8Gj4cE;EACE,gBjB1tHiB;A7F8lkBrB;;A8Gh4cE;EACE,gBjB9tHY;A7FimkBhB;;A8G/3cE;EACE,gBjBluHiB;A7FomkBrB;;A8G93cE;EACE,gBjBtuHW;A7FumkBf;;A8G73cE;EACE,gBjB1uHgB;A7F0mkBpB;;A8G53cE;EACE,gBjB9uHS;A7F6mkBb;;A8G33cE;EACE,gBjBlvHO;A7FgnkBX;;A8G13cE;EACE,gBjBtvHS;A7FmnkBb;;A8Gz3cE;EACE,gBjB1vHO;A7FsnkBX;;A8Gx3cE;EACE,gBjB9vHW;A7FynkBf;;A8Gv3cE;EACE,gBjBlwHM;A7F4nkBV;;A8Gt3cE;EACE,gBjBtwHI;A7F+nkBR;;A8Gr3cE;EACE,gBjB1wHK;A7FkokBT;;A8Gp3cE;EACE,gBjB9wHQ;A7FqokBZ;;A8Gn3cE;EACE,gBjBlxHW;A7FwokBf;;A8Gl3cE;EACE,gBjBtxHM;A7F2okBV;;A8Gj3cE;EACE,gBjB1xHe;A7F8okBnB;;A8Gh3cE;EACE,gBjB9xHc;A7FipkBlB;;A8G/2cE;EACE,gBjBlyHmB;A7FopkBvB;;A8G92cE;EACE,gBjBtyHS;A7FupkBb;;A8G72cE;EACE,gBjB1yHc;A7F0pkBlB;;A8G52cE;EACE,gBjB9yHS;A7F6pkBb;;A8G32cE;EACE,gBjBlzHS;A7FgqkBb;;A8G12cE;EACE,gBjBtzHa;A7FmqkBjB;;A8Gz2cE;EACE,gBjB1zHiB;A7FsqkBrB;;A8Gx2cE;EACE,gBjB9zHQ;A7FyqkBZ;;A8Gv2cE;EACE,gBjBl0HO;A7F4qkBX;;A8Gt2cE;EACE,gBjBt0HW;A7F+qkBf;;A8Gr2cE;EACE,gBjB10HS;A7FkrkBb;;A8Gp2cE;EACE,gBjB90HQ;A7FqrkBZ;;A8Gn2cE;EACE,gBjBl1HY;A7FwrkBhB;;A8Gl2cE;EACE,gBjBt1HQ;A7F2rkBZ;;A8Gj2cE;EACE,gBjB11HO;A7F8rkBX;;A8Gh2cE;EACE,gBjB91HW;A7FiskBf;;A8G/1cE;EACE,gBjBl2HS;A7FoskBb;;A8G91cE;EACE,gBjBt2He;A7FuskBnB;;A8G71cE;EACE,gBjB12HO;A7F0skBX;;A8G51cE;EACE,gBjB92HY;A7F6skBhB;;A8G31cE;EACE,gBjBl3HgB;A7FgtkBpB;;A8G11cE;EACE,gBjBt3HY;A7FmtkBhB;;A8Gz1cE;EACE,gBjB13HY;A7FstkBhB;;A8Gx1cE;EACE,gBjB93HS;A7FytkBb;;A8Gv1cE;EACE,gBjBl4Ha;A7F4tkBjB;;A8Gt1cE;EACE,gBjBt4HO;A7F+tkBX;;A8Gr1cE;EACE,gBjB14HM;A7FkukBV;;A8Gp1cE;EACE,gBjB94HM;A7FqukBV;;A8Gn1cE;EACE,gBjBl5HO;A7FwukBX;;A8Gl1cE;EACE,gBjBt5HQ;A7F2ukBZ;;A8Gj1cE;EACE,gBjB15HW;A7F8ukBf;;A8Gh1cE;EACE,gBjB95HI;A7FivkBR;;A8G/0cE;EACE,gBjBl6HgB;A7FovkBpB;;A8G90cE;EACE,gBjBt6HW;A7FuvkBf;;A8G70cE;EACE,gBjB16HQ;A7F0vkBZ;;A8G50cE;EACE,gBjB96HS;A7F6vkBb;;A8G30cE;EACE,gBjBl7HK;A7FgwkBT;;A8G10cE;EACE,gBjBt7HQ;A7FmwkBZ;;A8Gz0cE;EACE,gBjB17Hc;A7FswkBlB;;A8Gx0cE;EACE,gBjB97He;A7FywkBnB;;A8Gv0cE;EACE,gBjBl8HU;A7F4wkBd;;A8Gt0cE;EACE,gBjBt8HgB;A7F+wkBpB;;A8Gr0cE;EACE,gBjB18HS;A7FkxkBb;;A8Gp0cE;EACE,gBjB98Hc;A7FqxkBlB;;A8Gn0cE;EACE,gBjBl9HQ;A7FwxkBZ;;A8Gl0cE;EACE,gBjBt9Hc;A7F2xkBlB;;A8Gj0cE;EACE,gBjB19HQ;A7F8xkBZ;;A8Gh0cE;EACE,gBjB99Hc;A7FiykBlB;;A8G/zcE;EACE,gBjBl+HQ;A7FoykBZ;;A8G9zcE;EACE,gBjBt+Hc;A7FuykBlB;;A8G7zcE;EACE,gBjB1+He;A7F0ykBnB;;A8G5zcE;EACE,gBjB9+HQ;A7F6ykBZ;;A8G3zcE;EACE,gBjBl/HY;A7FgzkBhB;;A8G1zcE;EACE,gBjBt/He;A7FmzkBnB;;A8GzzcE;EACE,gBjB1/HiB;A7FszkBrB;;A8GxzcE;EACE,gBjB9/HW;A7FyzkBf;;A8GvzcE;EACE,gBjBlgIiB;A7F4zkBrB;;A8GtzcE;EACE,gBjBtgIU;A7F+zkBd;;A8GrzcE;EACE,gBjB1gIgB;A7Fk0kBpB;;A8GpzcE;EACE,gBjB9gIS;A7Fq0kBb;;A8GnzcE;EACE,gBjBlhIe;A7Fw0kBnB;;A8GlzcE;EACE,gBjBthIW;A7F20kBf;;A8GjzcE;EACE,gBjB1hIiB;A7F80kBrB;;A8GhzcE;EACE,gBjB9hIkB;A7Fi1kBtB;;A8G/ycE;EACE,gBjBliIQ;A7Fo1kBZ;;A8G9ycE;EACE,gBjBtiIc;A7Fu1kBlB;;A8G7ycE;EACE,gBjB1iIO;A7F01kBX;;A8G5ycE;EACE,gBjB9iIO;A7F61kBX;;A8G3ycE;EACE,gBjBljIU;A7Fg2kBd;;A8G1ycE;EACE,gBjBtjIgB;A7Fm2kBpB;;A8GzycE;EACE,gBjB1jIU;A7Fs2kBd;;A8GxycE;EACE,gBjB9jIe;A7Fy2kBnB;;A8GvycE;EACE,gBjBlkIU;A7F42kBd;;A8GtycE;EACE,gBjBtkIiB;A7F+2kBrB;;A8GrycE;EACE,gBjB1kIc;A7Fk3kBlB;;A8GpycE;EACE,gBjB9kIS;A7Fq3kBb;;A8GnycE;EACE,gBjBllIc;A7Fw3kBlB;;A8GlycE;EACE,gBjBtlIe;A7F23kBnB;;A8GjycE;EACE,gBjB1lIO;A7F83kBX;;A8GhycE;EACE,gBjB9lIY;A7Fi4kBhB;;A+Gr5mBA;EAAO,cAAA;A/Gy5mBP;;A+Gx5mBA;EAAO,cAAA;A/G45mBP;;A+G35mBA;EAAmB,cAAA;A/G+5mBnB;;A+G95mBA;EAAO,cAAA;A/Gk6mBP;;A+Gj6mBA;EAAa,WAAA;A/Gq6mBb;;A+Gp6mBA;EAAuB,cAAA;A/Gw6mBvB;;A+Gv6mBA;EAAyB,WAAA;A/G26mBzB;;A+G16mBA;EAAO,cAAA;A/G86mBP;;A+G56mBA;EACE,YAAA;EACA,yBAAA;EACA,yBAAA;A/G+6mBF;;A+G76mBA;EAGU,0DAAA;A/Gg7mBV;;A+G76mBA,0DAAA;AACA;EACE,kBAAA;A/Gg7mBF;;A+G96mBA;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,yBAAA;A/Gi7mBF;;AgH58mBE;EACE,aAAA;AhH+8mBJ;AgH98mBI;EACI,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EAEE,oBAAA;AhH+8mBV;AgH18mBQ;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sBzGuyBO;EyGtyBP,gBnBkpBF;EmBjpBE,eAAA;AhH48mBZ;;AiHn+mBA,kDAAA;AAEA;EACE,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;EACA,uBAAA;AjHq+mBF;;AiHl+mBA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AjHq+mBF;;AiHl+mBA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;AjHq+mBF;;AiHl+mBA;EACE,6BAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,iCAAA;AjHq+mBF;;AiHl+mBA;EACE,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA,EAAA,mGAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA,EAAA,kDAAA;EACA,gBAAA,EAAA,0CAAA;EACA,qBAAA;EACA,wBAAA;EAEA,uBAAA;AjHo+mBF;;AiHj+mBA;;EAEE,QAAA;EACA,SAAA;AjHo+mBF;;AiHj+mBA;;EAEE,YAAA;EACA,cAAA;AjHo+mBF;;AiHj+mBA;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,oBAAA;AjHo+mBF;;AiHj+mBA;EACE,8BAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;AjHo+mBF;;AiHj+mBA;EACE,mBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,WAAA;AjHo+mBF;;AiHj+mBA;EACE,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,gBAAA;AjHo+mBF;;AiHj+mBA;EACE,oBAAA;EACA,iBAAA;EACA,yBAAA;AjHo+mBF;;AiHj+mBA;EACE,mBAAA;AjHo+mBF;;AiHj+mBA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,gBAAA;AjHo+mBF;AiHn+mBE;EACE,kBAAA;AjHq+mBJ;;AiHj+mBA;EACE,kBAAA;EACA,WAAA;EACA,mB1GzGY;E0G0GZ,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,+BAAA;AjHo+mBF;;AiHj+mBA;EACE,0DAAA;EACA,YAAA;EACA,6BAAA;AjHo+mBF;;AiHj+mBA;EACE,MAAA;EACA,qBAAA;EACA,sBAAA;AjHo+mBF;AiHn+mBE;EACE,sBAAA;AjHq+mBJ;AiHn+mBE;EACE,6BAAA;AjHq+mBJ;;AiHj+mBA;EACE,QAAA;EACA,WAAA;AjHo+mBF;;AiHj+mBA;EACE,OAAA;EACA,sBAAA;EACA,uBAAA;AjHo+mBF;AiHn+mBE;EACE,uBAAA;AjHq+mBJ;AiHn+mBE;EACE,6BAAA;AjHq+mBJ;;AiHj+mBA;EACE,YAAA;EACA,SAAA;EACA,UAAA;AjHo+mBF;;AiHj+mBA;EACE,WAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;AjHo+mBF;;AiHj+mBA,gBAAA;AACA;EACE,WAAA;EACA,OAAA;AjHo+mBF;;AiHj+mBA;EACE,cAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AjHo+mBF;;AiHj+mBA;EACE,eAAA;EACA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,wBAAA;AjHo+mBF;;AkHjsnBA,kBAAA;AACA;EACI,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,2BAAA;EACA,yBAAA;EAIA,iBAAA;EAEA,mBAAA;EACA,wCAAA;AlHosnBJ;;AkHlsnBA;EACI,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;AlHqsnBJ;AkHnsnBI;EACI,aAAA;AlHqsnBR;AkHlsnBI;EACI,eAAA;EACA,YAAA;AlHosnBR;;AkHjsnBA;;EAMI,+BAAA;AlHosnBJ;;AkHjsnBA;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AlHosnBJ;AkHlsnBI;EAEI,WAAA;EACA,cAAA;AlHmsnBR;AkHhsnBI;EACI,WAAA;AlHksnBR;AkH/rnBI;EACI,kBAAA;AlHisnBR;;AkH9rnBA;EACI,WAAA;EACA,YAAA;EACA,eAAA;EAQA,aAAA;AlH0rnBJ;AkHjsnBI;EACI,cAAA;AlHmsnBR;AkHjsnBI;EACI,aAAA;AlHmsnBR;AkH9rnBI;EACI,oBAAA;AlHgsnBR;AkH7rnBI;EACI,cAAA;AlH+rnBR;AkH5rnBI;EACI,kBAAA;AlH8rnBR;AkH3rnBI;EACI,cAAA;EACA,YAAA;EACA,6BAAA;AlH6rnBR;AkH3rnBI;EACI,aAAA;EACA,YAAA;AlH6rnBR;;AkH1rnBA;EACI,aAAA;AlH6rnBJ;;AkH1rnBA;EACI,wBAAA;EACA,uBAAA;EACA,mBAAA;AlH6rnBJ;AkH5rnBI;EACI,oBAAA;EACA,cAAA;AlH8rnBR;AkH7rnBQ;EACI,yB3GzGA;E2G0GA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;EACA,2BAAA;AlH+rnBZ;AkH9rnBY;EACI,aAAA;AlHgsnBhB;AkH5rnBY;EACI,yB3G1FF;APwxnBd;;AkHxrnBA;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,eApJc;EAqJd,c3G5GU;E2G6GV,gB3GhJK;E2GiJL,2BAAA;EACA,yBAAA;AlH2rnBJ;AkH1rnBI;EACI,c3GhHM;E2GiHN,mB3GxIE;E2GyIF,qB3GjJI;E2GkJJ,UAAA;AlH4rnBR;AkH1rnBI;EACI,eAAA;EACA,c3GtJI;APk1nBZ;AkH3rnBQ;EACI,c3GxJA;E2GyJA,gB3G9JH;E2G+JG,qB3G3JA;APw1nBZ;;AkHzrnBA;EACI,YAAA;AlH4rnBJ;;AkH1rnBA;EACI,WAAA;AlH6rnBJ;;AmH72nBA,+DAAA;AAyDA;EACI;IACI,UAAA;IAKA,2BAAA;EnH42nBN;EmH12nBE;IAEI,UAAA;IAKA,0BAAA;EnH22nBN;EmHz2nBE;IACI,UAAA;IAKA,4BAAA;EnH22nBN;AACF;AmHl0nBA;EACI;IACI,UAAA;IAKA,2BAAA;EnHw2nBN;EmHt2nBE;IACI,UAAA;IAKA,0BAAA;EnHw2nBN;AACF;AmHrznBA;EACI;IAKI,mBAAA;EnHq2nBN;EmHn2nBE;IAKI,qBAAA;EnHq2nBN;EmHn2nBE;IAKI,mBAAA;EnHq2nBN;AACF;AmHl2nBA;;EAEI,sBAAA;AnHo2nBJ;;AmHj2nBA;EACI,iBAAA;EACA,0BAAA;EACA,kB5GrFa;E4GsFb,iBAAA;EACA,kBAAA;AnHo2nBJ;AmHn2nBI;EACI,gBAAA;AnHq2nBR;AmHn2nBI;EACI,2BAAA;EACA,iBAAA;AnHq2nBR;;AmHj2nBA;EACI,eAAA;AnHo2nBJ;;AmHj2nBA;EACI,eAAA;AnHo2nBJ;;AmHj2nBA;;EAEI,eAAA;AnHo2nBJ;;AmHj2nBA;EACI,aAAA;AnHo2nBJ;;AmHj2nBA;EACI,mBAAA;AnHo2nBJ;;AmHj2nBA;EACI,YAAA;AnHo2nBJ;;AmHj2nBA;EACI,kBAAA;EACA,aAAA;AnHo2nBJ;AmHn2nBI;EACI,cAAA;EACA,8BAAA;AnHq2nBR;AmHn2nBI;EACI,eAAA;AnHq2nBR;AmHp2nBQ;EACI,qBAAA;EACA,c5GlNQ;APwjoBpB;AmHn2nBI;EACI,eAAA;EACA,kBAAA;EACA,yBAAA;AnHq2nBR;;AmHj2nBA;EACI,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AnHo2nBJ;;AmHj2nBA;EACI,aAAA;AnHo2nBJ;;AmHj2nBA;EACI,UAAA;AnHo2nBJ;;AmHj2nBA;EACI,mBAAA;EACA,gBAAA;EACA,kDAAA;AnHo2nBJ;;AmHj2nBA;EACI,UAAA;AnHo2nBJ;;AmHj2nBA;EACI,iBAAA;AnHo2nBJ;;AmHj2nBA;EAKI,+BAAA;AnHo2nBJ;;AmHj2nBA;EACI,eAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;AnHo2nBJ;;AmHj2nBA;EACI,0BAAA;AnHo2nBJ;;AmHj2nBA;EACI,UAAA;AnHo2nBJ;;AmHj2nBA;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;AnHo2nBJ;;AmHj2nBA;EACI,kBAAA;EACA,eAAA;AnHo2nBJ;;AmHj2nBA;EACI,mBAAA;AnHo2nBJ;;AmHj2nBA;EACI,0CAAA;EACA,0CAAA;AnHo2nBJ;;AmHj2nBA;EACI,gBAAA;EACA,uBAAA;AnHo2nBJ;;AmHj2nBA;EACI,6BAAA;AnHo2nBJ;;AmHj2nBA;;EAEI,0CAAA;EACA,gBAAA;EACA,kBAAA;AnHo2nBJ;;AmHj2nBA;EAKI,4BAAA;EAEA,iBAAA;AnHo2nBJ;;AmHj2nBA;EACI,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;AnHo2nBJ;;AmHj2nBA;EACI,cAAA;AnHo2nBJ;;AmHj2nBA;EAKI,6DAAA;AnHo2nBJ;;AmHj2nBA;EACI,UAAA;EAKA,sDAAA;AnHo2nBJ;;AmHj2nBA;;EAEI,oBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;AnHo2nBJ;;AmHj2nBA;;EAEI,cAAA;EACA,WAAA;EACA,YAAA;AnHo2nBJ;;AmHj2nBA;EACI,UAAA;EAKA,2BAAA;AnHo2nBJ;;AmHj2nBA;EACI,UAAA;EAKA,gCAAA;AnHo2nBJ;;AmHj2nBA;EAKI,iCAAA;AnHo2nBJ;;AmHj2nBA;EACI,UAAA;EACA,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;AnHo2nBJ;;AmHj2nBA;EACI,gBAAA;EACA,kDAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EAKA,mCAAA;AnHo2nBJ;;AmHj2nBA;EACI,cAAA;AnHo2nBJ;;AmHj2nBA;EACI,UAAA;EACA,oBAAA;AnHo2nBJ;;AmHj2nBA;EACI,oBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,UAAA;EAKA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wDAAA;EACA,oBAAA;EACA,YAAA;AnHo2nBJ;;AmHj2nBA;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,mCAAA;EACA,gCAAA;AnHo2nBJ;;AoH53oBA;EACE,WAAA;EACA,0BAAA;EACA,oCAAA;EACA,iBAAA;ApH+3oBF;;AoH73oBA;;EAEE,kBAAA;ApHg4oBF;;AoH93oBA;;EAEE,mBAAA;ApHi4oBF;;AoH93oBA;EACE,mBAAA;EAEE,gBAAA;EAKF,mBAAA;ApH43oBF;;AoH13oBA;EACE,WAAA;EACA,qBAAA;ApH63oBF;;AoH13oBA;EACE,oBAAA;EACA,mBAAA;ApH63oBF;;AoH33oBA;EACE,mBAAA;EACA,oBAAA;ApH83oBF;;AoHz3oBA;EACE,mBAAA;EACA,mBAAA;ApH43oBF;;AoH13oBA;EACE,qBAAA;ApH63oBF;;AoH13oBA;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;ApH63oBF;;AoH33oBA;EACE,SAAA;EACA,mBAAA;EACA,iBAAA;ApH83oBF;;AoH53oBA;EACE,aAAA;EACA,uBAAA;ApH+3oBF;;AoH73oBA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;ApHg4oBF;;AoH93oBA;EACE,gBAAA;ApHi4oBF;;AoH93oBA;;;;EAKI,mBAAA;ApHg4oBJ;;AoH13oBA;;EAEE,aAAA;ApH63oBF;;AoH33oBA;;;;;EAKE,eAAA;EACA,kBAAA;ApH83oBF;;AoH53oBA;;;;;;;;;EASE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;EACA,YAAA;ApH+3oBF;;AoH73oBA;;;;;EAMI,UAAA;EAKF,YAAA;ApH23oBF;;AoHz3oBA;;;;;EAMI,YAAA;EAKF,YAAA;ApHu3oBF;;AoHr3oBA;;EAEE,UAAA;ApHw3oBF;;AoHt3oBA;;EAEE,UAAA;ApHy3oBF;;AoHt3oBA;EACE,2BAAA;ApHy3oBF;;AoHt3oBA;EACE,gBAAA;EACA,wBAAA;EACA,2BAAA;ApHy3oBF;;AoHv3oBA;;;;;;EAME,aAAA;ApH03oBF;;AoHx3oBA;;EAEE,gBAAA;ApH23oBF;;AoHx3oBA;EACE,uBAAA;ApH23oBF;;AoHz3oBA;EACE,wBAAA;EACA,gBAAA;ApH43oBF;;AoHz3oBA;EACE;;IAEE,kBAAA;EpH43oBF;AACF;AoH13oBA;EAEI,mBAAA;ApH23oBJ;;AoHr3oBA;;;EAGE,QAAA;EAEE,aAAA;ApHu3oBJ;;AoHj3oBA;;;EAGE,QAAA;ApHo3oBF;;AoHj3oBA;;EAGI,oBAAA;ApHm3oBJ;;AoH72oBA;;;EAII,qBAAA;ApH+2oBJ;;AoHz2oBA;;EAEE,sBAAA;ApH42oBF;;AoHz2oBA;EACE,sBAAA;ApH42oBF;;AoHz2oBA;EACE,SAAA;ApH42oBF;;AoH12oBA;EAEI,eAAA;ApH42oBJ;;AoHt2oBA;EAEI,gBAAA;ApHw2oBJ;;AoHl2oBA;EACE;IACE,2BAAA;EpHq2oBF;AACF;AoHj2oBA;;EAEE,eAAA;ApHm2oBF;AoHl2oBE;;EACE,gBvBsDS;EuBrDT,sB7G2iBe;E6GziBb,oBAAA;ApHo2oBN;;AoH11oBE;;EACE,gBvByCU;A7FqzoBd;;AoHz1oBA;EAEI;IACE,2BAAA;EpH21oBJ;EoH11oBI;IACE,aAAA;EpH41oBN;EoH11oBI;IACE,kBAAA;IACA,mBAAA;EpH41oBN;EoHx1oBA;IAEI,4BAAA;EpHy1oBJ;AACF;AoH50oBI;EACE,aAAA;ApH80oBN;;AoHz0oBE;EACE,yBAAA;EACA,kB7G/La;AP2gpBjB;;AoHx0oBA;EAEI,qBAAA;ApH00oBJ;AoHr0oBE;EACE,gB7GnKS;E6GqKP,qBAAA;ApHs0oBN;;AoH3zoBA;EACE,oBAAA;ApH8zoBF;AoH7zoBE;EACE,oBAAA;ApH+zoBJ;AoH7zoBE;EACE,wBAAA;ApH+zoBJ;;AoH5zoBA;EAEI,gCAAA;ApH8zoBJ;;AqH1qpBA;EACE;IACE,yBAAA;ErH6qpBF;AACF;AqHnppBA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,yB9GdQ;E8GeR,6CAAA;EACA,kB9GmGe;E8GlGf,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;ArH6qpBF;;AqH3qpBA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,gCAAA;EACA,sB9GxCO;E8GyCP,kB9GgJU;AP8hpBZ;;AqH5qpBA;EACE,gBAAA;ArH+qpBF;;AqH5qpBA;EACE,kBAAA;EACA,sBAAA;EACA,gBAAA;ArH+qpBF;;AqH5qpBA;EACE,aAAA;ArH+qpBF;;AqH5qpBA;EACE,kBAAA;EACA,a7GymBkC;E6GxmBlC,WAAA;ArH+qpBF;;AqH7qpBA;EACE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,SAAA;ArHgrpBF;AqH/qpBE;EACE,QAAA;EACA,UAAA;ArHirpBJ;;AqH9qpBA;EACE,uBAAA;EACA,qCAAA;ArHirpBF;;AqH/qpBA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;ArHkrpBF;;AqHhrpBA;EACE,mBAAA;ArHmrpBF;;AqHjrpBA;EACE,mBAAA;ArHorpBF;;AqHlrpBA;EACE,mBAAA;ArHqrpBF;;AqHnrpBA;EACE,yBAAA;EAGA,mBAAA;EACA,kBAAA;EACA,eAAA;ArHsrpBF;;AqHprpBA;EAEE,wBAAA;EAAA,mBAAA;ArHurpBF;;AqHrrpBA;EACE,YAAA;ArHwrpBF;;AqHtrpBA;EACE,mBAAA;EAGA,mBAAA;EACA,kBAAA;EACA,eAAA;ArHyrpBF;;AqHvrpBA;EACE,YAAA;ArH0rpBF;;AqHxrpBA;EACE,mBAAA;EAGA,mBAAA;EACA,kBAAA;EACA,eAAA;ArH2rpBF;;AqHzrpBA;EACE,YAAA;ArH4rpBF;;AqH1rpBA;EACE,mBAAA;EAGA,mBAAA;EACA,kBAAA;EACA,eAAA;ArH6rpBF;;AqH3rpBA;EACE,gBAAA;ArH8rpBF;;AqH5rpBA;EACE,eAAA;ArH+rpBF;;AqH7rpBA;EACE,aAAA;ArHgspBF;;AqH7rpBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,a7G2gBkC;E6G1gBlC,uCAAA;EACA,wBAAA;ArHgspBF;;AqH7rpBA;EACE;IACE,WAAA;IACA,WAAA;IACA,kBAAA;IACA,oBAAA;ErHgspBF;EqH9rpBA;IACE,WAAA;ErHgspBF;AACF;AqH9rpBA;;;;;;;EAGE,yBAAA;ArHospBF;;AqHlspBA;;;;;;;EAGE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,8BAAA;EACA,+BAAA;EACA,6CAAA;EACA,gDAAA;EACA,iDAAA;EACA,qDAAA;EACA,kDAAA;ArHyspBF;;AqHlspBE;EACE,aAAA;ArHqspBJ;AqHnspBE;EACE,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,sB9GkmBe;APmmoBnB;;AqHjspBE;EACE,mBAAA;EACA,oBAAA;ArHospBJ;;AqHhspBE;EACE,gBxBqSM;A7F85oBV;AqHjspBE;EACE,gBxBsUU;A7F63oBd;AqHjspBE;EACE,gBxBoUU;A7F+3oBd;AqHjspBE;EACE,gBxBoUW;A7F+3oBf;AqHjspBE;EACE,gBxBifS;A7FktoBb;AqHjspBE;EACE,gBxBjLa;A7Fo3pBjB;AqHjspBE;EACE,kBAAA;EACA,mBAAA;EACA,e9GhGS;E8GiGT,gB9G1ES;E8G2ET,c9G9MU;E8G+MV,oBAAA;ArHmspBJ;AqHjspBM;EACE,c9GlNM;E8GmNN,6BAAA;ArHmspBR;AqHjspBM;EACE,gBxBgDG;EwB/CH,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,sB9GojBW;AP+ooBnB;;AqH7rpBA;EAEI;IACE,sBAAA;IACA,cAAA;IACA,eAAA;ErH+rpBJ;EqH7rpBE;IACE,yCAAA;ErH+rpBJ;EqH7rpBE;IACE,cAAA;ErH+rpBJ;EqH7rpBE;IACE,sBAAA;ErH+rpBJ;AACF;AsH59pBA;EACI,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AtH89pBJ;;AsH59pBA;EACI,2BAAA;EACA,gBAAA;AtH+9pBJ;;AsH79pBA;EACI,iBAAA;AtHg+pBJ;;AsH99pBA;EACI,8BAAA;EACA,yBAAA;EACA,4BAAA;EACA,4BAAA;AtHi+pBJ;AsHh+pBI;EACI,aAAA;EACA,mBAAA;EACA,yCAAA;AtHk+pBR;AsHj+pBQ;EACI,qBAAA;AtHm+pBZ;AsHh+pBI;EACI,8BAAA;AtHk+pBR;;AsH/9pBA;EACI,yBAAA;EACA,8BAAA;EACA,2BAAA;EACA,4BAAA;AtHk+pBJ;;AsHh+pBA;EACI,yBAAA;EACA,oBAAA;AtHm+pBJ;;AsH39pBA;EACI,gBAAA;AtH89pBJ;;AuH7gqBA,sDAAA;ACCE;EACE,mBAAA;EACA,mBAAA;EACA,WC0KgB;EDzKhB,gBC0KkB;EDzKlB,kBAAA;EACA,gBjHEK;EiHDL,+BCiKqB;AzH+2pBzB;AwH9gqBI;EACE,mBAAA;AxHghqBN;AwH7gqBI;EACE,YAAA;EACA,2BAAA;EACA,eC+JqB;ED9JrB,cC+JwB;AzHg3pB9B;AwH5gqBI;EACE,iBCiKsB;EDhKtB,kBCgKsB;ED/JtB,gBCiKyB;AzH62pB/B;AwH3gqBI;EACE,gBAAA;EACA,YC8I2B;ED7I3B,aC8I4B;ED7I5B,gBC8IiC;AzH+3pBvC;AwH1gqBI;EACE,2BAAA;EACA,cC8I0B;AzH83pBhC;AwHzgqBI;EACE,UAAA;EACA,cAAA;EACA,WAAA;EACA,SAAA;AxH2gqBN;AwHzgqBM;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AxH2gqBR;A0H3jqBE;EF4CI;IAOI,iBAAA;ExH4gqBR;AACF;AwHxgqBQ;EACE,UAAA;EACA,WAAA;AxH0gqBV;AwHrgqBQ;EACE,YAAA;EACA,cAAA;AxHugqBV;AwHrgqBU;EAEI,cAAA;AxHsgqBd;AwH//pBU;EAEI,eAAA;AxHggqBd;AwHt/pBI;EACE,2BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AxHw/pBN;AwHv/pBM;EACE,eAAA;AxHy/pBR;AwHr/pBI;EACE,eAAA;EACA,yBAAA;EACA,cC+E0B;AzHw6pBhC;AwHr/pBM;EACE,4DC6E8B;AzH06pBtC;AwHn/pBI;EACE,qBjHhFG;APqkqBT;AwHn/pBM;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;AxHq/pBR;AwHn/pBQ;EACE,WAAA;EAEE,YAAA;EACA,0BAAA;EAMF,yBAAA;EACA,yBAAA;AxH++pBV;AwH5+pBQ;EACE,YAAA;EAEE,cAAA;EACA,0BAAA;EAMF,yBAAA;AxHw+pBV;AwHp+pBM;EACE,UAAA;EACA,WAAA;AxHs+pBR;AwHn+pBM;EACE,MAAA;EAEE,cAAA;EAKF,eAAA;EACA,gBAAA;AxHg+pBR;AwH79pBM;EACE,gBAAA;AxH+9pBR;AwH79pBQ;EACE,YAAA;EAEE,cAAA;EAKF,aAAA;AxH09pBV;AwHv9pBQ;EACE,aAAA;EAEE,eAAA;EAKF,cAAA;AxHo9pBV;AwH98pBU;EACE,qDAAA;AxHg9pBZ;AwH78pBU;EACE,sDAAA;AxH+8pBZ;AwHz8pBI;EACE,gCCtCuB;AzHi/pB7B;AwHx8pBI;EACE,yCCzCuB;AzHm/pB7B;;A2H1pqBA;EAEE,wBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,6BAAA;EACA,4CAAA;EAGA,iCAAA;A3H0pqBF;A2HxpqBE;EACE,4CAAA;A3H0pqBJ;A2HvpqBE;EACE,kCAAA;A3HypqBJ;A2HtpqBE;EACE,uBAAA;A3HwpqBJ;A2HrpqBE;EAEE,uBAAA;EACA,2BAAA;A3HspqBJ;A2HnpqBE;EAEE,uBAAA;EACA,yBAAA;A3HopqBJ;A2HjpqBE;EACE,mBAAA;A3HmpqBJ;A2HhpqBE;EAEE,mBAAA;EACA,2BAAA;A3HipqBJ;A2H9oqBE;EAEE,mBAAA;EACA,yBAAA;A3H+oqBJ;A2H5oqBE;EACE,qBAAA;A3H8oqBJ;A2H3oqBE;EAEE,qBAAA;EACA,2BAAA;A3H4oqBJ;A2HzoqBE;EAEE,qBAAA;EACA,yBAAA;A3H0oqBJ;A2HvoqBE;EAKE,gBAAA;A3HqoqBJ;A2HloqBE;EACE,wBAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;A3HooqBJ;A2HjoqBE;EACE,wBAAA;EACA,SAAA;EACA,qBAAA;EACA,uBAAA;A3HmoqBJ;A2HhoqBE;EACE,SAAA;EACA,sBAAA;A3HkoqBJ;A2HhoqBI;EAGE,mBAAA;A3HgoqBN;A2H7nqBI;EAME,uBAAA;A3H0nqBN;A2HvnqBI;EAME,qBAAA;A3HonqBN;A2HjnqBI;EACE,wBAAA;EACA,SAAA;EACA,qBAAA;EACA,uBAAA;A3HmnqBN;A2HhmqBI;EACE,YAAA;A3HkmqBN;A0HhvqBE;ECmJE;IACE,oBAAA;E3HgmqBJ;AACF;;A2H5lqBA;EACE,wBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBFvJY;EEwJZ,kCFvJc;EEwJd,uBFvJa;EEwJb,6BFvJoB;AzHsvqBtB;A2H9lqBE;EACE,aAAA;A3HgmqBJ;A2H7lqBE;EACE,kBAAA;A3H+lqBJ;;A2H3lqBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;A3H8lqBF;;A2H3lqBA;EACE,4BFrImB;EEsInB,qBAAA;EACA,yBFtIkB;EEuIlB,4BFtIsB;EEuItB,2BAAA;A3H8lqBF;;A2H5lqBA;EACE,8BAAA;A3H+lqBF;;A2H7lqBA;EACE,sBAAA;A3HgmqBF;A2H/lqBE;EACE,4BAAA;A3HimqBJ;A2H7lqBM;EACE,YAAA;A3H+lqBR;A2H5lqBM;EACE,+EAAA;A3H8lqBR;A2H3lqBM;EACE,+EAAA;A3H6lqBR;A2HtlqBM;EACE,iCAAA;EACA,uBAAA;EACA,wBAAA;EACA,4BAAA;EACA,qBAAA;EACA,yEAAA;EACA,2CAAA;EACA,8BAAA;EACA,oCAAA;EACA,wCAAA;EACA,6BAAA;EACA,eAAA;EACA,oCAAA;UAAA,4BAAA;A3HwlqBR;A2HtlqBM;EACE,YAAA;A3HwlqBR;A2HrlqBM;EACE,kBAAA;EACA,iBAAA;A3HulqBR;A2HjlqBQ;EACE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,8DAAA;EACA,yBAAA;EACA,kBAAA;EAEE,gBAAA;EACA,+BAAA;EAMF,4BAAA;A3H6kqBV;;A2HtkqBA;EACE,4BAAA;EACA,2BAAA;EACA,qCAAA;EACA,+BAAA;EACA,+BAAA;EACA,6BAAA;EACA,0BAAA;A3HykqBF;A2HxkqBE;EACE,uBAAA;A3H0kqBJ;A2HxkqBE;EACE,0BAAA;A3H0kqBJ;A2HvkqBE;EACE,SFpI0B;EEqI1B,qBFpIiC;EEqIjC,mBAAA;EACA,oCFrIoC;EEsIpC,WpHhRK;APy1qBT;A2HxkqBI;EACE,wBAAA;EACA,4BAAA;EACA,2BAAA;A3H0kqBN;A2HrkqBE;EACE,SF3IyB;EE4IzB,qBF3IgC;EE4IhC,mBAAA;EACA,oCF5ImC;EE6InC,WpH9RK;APq2qBT;A2HtkqBI;EACE,aFxIuB;AzHgtqB7B;A2HjkqBE;EACE,SAAA;A3HmkqBJ;;A2H/jqBA;EACE,uBAAA;EACA,kBF5MoB;EE6MpB,gBF5MqB;EE6MrB,0BAAA;EACA,cF5MmB;EE6MnB,cF5MuB;AzH8wqBzB;;A2H/jqBA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,cFjNgC;EEkNhC,iCFjNoC;AzHmxqBtC;;A2H/jqBA;EACE,eAAA;EACA,gCAAA;A3HkkqBF;;A2H/jqBA;EACE,kBFpN4B;EEqN5B,UAAA;EAEA,SAAA;EACA,MFvNuB;EEyNrB,QFzNqB;EE8NvB,uBAAA;EACA,YFnOyB;EEoOzB,aFnO0B;EEoO1B,UAAA;EACA,gBAAA;EACA,+BFlO8B;EEmO9B,YFlO0B;EEmO1B,gBFlOiC;EEmOjC,gBFlO2B;EEmO3B,uBFlO8B;EEmO9B,cFlOyB;EEmOzB,kBFlO+B;EEmO/B,gBFlO6B;EEmO7B,gBF7O+B;EE8O/B,eAAA;A3H4jqBF;A2H1jqBE;EACE,0BFpOiC;EEqOjC,kCFnOkC;EEoOlC,yBFrO6B;AzHiyqBjC;A2HzjqBE;EACE,SAAA;A3H2jqBJ;;A2HvjqBA;EACE,2BAAA;EACA,yBAAA;EACA,8BAAA;EACA,8BAAA;A3H0jqBF;;A2HvjqBA;EACE,aAAA;EACA,mBAAA;EACA,kCF3SyC;EE4SzC,2BF3SiC;EE4SjC,gBAAA;EACA,4BF5SoC;EE6SpC,yBF5S+B;EE6S/B,yBF5SmC;EE6SnC,2BF5SqC;AzHs2qBvC;A2HxjqBE;EACE,YAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBFlTiC;EEmTjC,kBAAA;EACA,oCFtTuC;EEuTvC,sBFtTkC;EEuTlC,gBAAA;EACA,kBAAA;EACA,kBAAA;A3H0jqBJ;;A2HtjqBA;EACE,qBAAA;EACA,sBAAA;EACA,sCAAA;EACA,gBAAA;EACA,2CAAA;EACA,+BAAA;EACA,2BAAA;EACA,0BAAA;EACA,oCAAA;UAAA,4BAAA;EACA,gCAAA;A3HyjqBF;A2HxjqBE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;A3H0jqBJ;A2HvjqBE;EACE,gCAAA;EACA,yBAAA;A3HyjqBJ;A2HvjqBI;EACE,kBAAA;EACA,YAAA;A3HyjqBN;A2HtjqBI;EACE,cAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,oCAAA;A3HwjqBN;A2HtjqBM;EACE,cAAA;EACA,wBAAA;A3HwjqBR;A2HrjqBM;EACE,UAAA;EACA,yBAAA;A3HujqBR;A2HljqBI;EAEI,mDAAA;A3HmjqBR;A2HjjqBQ;EACE,qDAAA;A3HmjqBV;A2H7iqBE;EACE,gCAAA;EACA,yBAAA;A3H+iqBJ;A2H5iqBE;EACE,gCAAA;EACA,yBAAA;A3H8iqBJ;A2H3iqBE;EACE,gCAAA;EACA,yBAAA;A3H6iqBJ;A2H1iqBE;EACE,gCAAA;EACA,yBAAA;A3H4iqBJ;A2H1iqBI;EAEE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,wBAAA;EACA,kBAAA;A3H2iqBN;A2HziqBM;EACE,cAAA;EACA,eAAA;EACA,yBAAA;EACA,+BAAA;EACA,8BAAA;A3H2iqBR;A2HxiqBM;EACE,cAAA;EACA,aAAA;EACA,yBAAA;EACA,0BAAA;EACA,8BAAA;A3H0iqBR;A2HtiqBI;EAEE,kBAAA;EACA,UAAA;EACA,YAAA;EACE,aAAA;EACF,uBAAA;EACA,WAAA;EACA,YAAA;EACA,uDAAA;EACA,kBAAA;A3HuiqBN;A2HpiqBI;EAEE,kBAAA;EACA,UAAA;EACA,UAAA;EACE,aAAA;EACF,eAAA;EACA,eAAA;EACA,yBAAA;A3HqiqBN;A2HliqBI;EACE,cAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,oCAAA;A3HoiqBN;A2HliqBM;EACE,YAAA;EACE,aAAA;EACF,eAAA;EACA,wBAAA;A3HoiqBR;A2HjiqBM;EACE,YAAA;EACE,YAAA;EACF,eAAA;EACA,yBAAA;A3HmiqBR;A2H5hqBQ;EACE,+CAAA;A3H8hqBV;A2H3hqBQ;EACE,gDAAA;A3H6hqBV;A2H1hqBQ;EACE,2DAAA;A3H4hqBV;;A4HhlrBA;EAEI;IACE,sBAAA;E5HklrBJ;E4H/krBE;IACE,aAAA;E5HilrBJ;AACF;A4H5krBA;EAGI;IACE,sBAAA;E5H4krBJ;E4HzkrBE;IACE,aAAA;E5H2krBJ;AACF;A4HtkrBA;EAEI;IACE,yCAAA;E5HukrBJ;AACF;A6HxmrBA;EACE;IACE,wDAAA;E7H0mrBF;E6HvmrBA;IACE,kDAAA;E7HymrBF;E6HtmrBA;IACE,wDAAA;E7HwmrBF;E6HrmrBA;IACE,iDAAA;E7HumrBF;AACF;A6HpmrBA;EACE;IACE,mCAAA;IACA,qBAAA;E7HsmrBF;AACF;A6HnmrBA;EACE;IACE,wBAAA;IAEE,yBAAA;IAKF,mBAAA;E7HgmrBF;E6H7lrBA;IACE,uBAAA;IAEE,wBAAA;IAKF,mBAAA;E7H0lrBF;E6HvlrBA;IACE,YAAA;IAEE,wBAAA;IAKF,yBAAA;E7HolrBF;E6HjlrBA;IACE,wBAAA;IAEE,uBAAA;IAKF,uBAAA;E7H8krBF;E6H3krBA;IACE,uBAAA;IAEE,yBAAA;IAKF,wBAAA;E7HwkrBF;AACF;A6HrkrBA;EACE;IACE,uBAAA;IAEE,yBAAA;IAKF,QAAA;E7HkkrBF;E6H/jrBA;IACE,sBAAA;IAEE,0BAAA;IAKF,QAAA;E7H4jrBF;E6HzjrBA;IACE,wBAAA;IAEE,QAAA;IAKF,yBAAA;E7HsjrBF;E6HnjrBA;IACE,wBAAA;IAEE,0BAAA;IAKF,yBAAA;E7HgjrBF;AACF;A8H3qrBA;EACE;IACE,qBAAA;IACA,wCAAA;E9H6qrBF;E8H3qrBA;IACE,qBAAA;E9H6qrBF;E8H3qrBA;IACE,qCAAA;E9H6qrBF;AACF;A8HzqrBA;EACE;IACE,8BAAA;IACA,qBAAA;E9H2qrBF;E8HxqrBA;IACE,gCAAA;IACA,qBAAA;E9H0qrBF;AACF;A8HtqrBA;EACE;IACE,aAAA;IACA,cAAA;IACA,QAAA;E9HwqrBF;E8HrqrBA;IACE,aAAA;IACA,aAAA;IACA,QAAA;E9HuqrBF;E8HpqrBA;IACE,aAAA;IACA,cAAA;IACA,cAAA;E9HsqrBF;E8HnqrBA;IACE,QAAA;IACA,cAAA;IACA,eAAA;E9HqqrBF;E8HlqrBA;IACE,aAAA;IACA,aAAA;IACA,eAAA;E9HoqrBF;AACF;A8HjqrBA;EACE;IACE,YAAA;IACA,cAAA;IACA,QAAA;E9HmqrBF;E8HhqrBA;IACE,YAAA;IACA,cAAA;IACA,QAAA;E9HkqrBF;E8H/prBA;IACE,aAAA;IACA,QAAA;IACA,eAAA;E9HiqrBF;E8H9prBA;IACE,YAAA;IACA,YAAA;IACA,eAAA;E9HgqrBF;AACF;A8H7prBA;EACE;IACE,yBAAA;E9H+prBF;E8H5prBA;IACE,yBAAA;E9H8prBF;E8H3prBA;IACE,0BAAA;E9H6prBF;E8H1prBA;IACE,0BAAA;E9H4prBF;AACF;A8HxprBA;EACE;IACE,mBAAA;IACA,qBAAA;IACA,UAAA;E9H0prBF;E8HvprBA;IACE,mBAAA;IACA,qBAAA;IACA,UAAA;E9HyprBF;E8HtprBA;IACE,oBAAA;IACA,sBAAA;E9HwprBF;E8HrprBA;IACE,aAAA;IACA,mBAAA;IACA,UAAA;E9HuprBF;AACF;A8HpprBA;EACE;IACE,qCAAA;IACA,UAAA;E9HsprBF;E8HnprBA;IACE,mCAAA;IACA,UAAA;E9HqprBF;AACF;A8HlprBA;EACE;IACE,uBAAA;E9HoprBF;E8HjprBA;IACE,yBAAA;E9HmprBF;AACF;A0HxxrBE;EKbI,gBAAA;A/HwyrBN;A+HpyrBE;EACE,uBAAA;A/HsyrBJ;A+HlyrBI;EACE,oBAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,8CAAA;EACA,wCAAA;A/HoyrBN;A+HlyrBM;EACE,qDAAA;A/HoyrBR;A+HjyrBM;EACE,iBAAA;EACA,oBAAA;EACA,sCAAA;A/HmyrBR;A+HhyrBM;EAEE,iBAAA;EAEE,kBAAA;A/HgyrBV;A+HzxrBM;EAEE,iBAAA;EAEE,mBAAA;A/HyxrBV;A+HlxrBM;EACE,mBAAA;EACA,oBAAA;EACA,2CAAA;A/HoxrBR;A+HjxrBM;EAEE,mBAAA;EAEE,kBAAA;EAKF,2BAAA;A/H6wrBR;A+H1wrBM;EAEE,mBAAA;EAEE,mBAAA;EAKF,sCAAA;A/HswrBR;A+HnwrBM;EACE,oBAAA;EACA,oBAAA;EACA,sCAAA;A/HqwrBR;A+HlwrBM;EAEE,oBAAA;EAEE,kBAAA;A/HkwrBV;A+H3vrBM;EAGI,mBAAA;EAKF,oBAAA;A/HuvrBR;A+HlvrBE;ELhGA;IKmGM,6BAAA;E/HmvrBN;E+HjvrBM;IACE,wBAAA;E/HmvrBR;E+HhvrBM;IACE,2BAAA;E/HkvrBR;AACF;AgI72rBI;EACE,6BAAA;AhI+2rBN;AgI72rBM;EACE,MAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;AhI+2rBR;AgI52rBM;EAEE,MAAA;EACA,YAAA;EAEE,QAAA;EACA,UAAA;AhI42rBV;AgIp2rBM;EAEE,MAAA;EACA,YAAA;EAEE,OAAA;EACA,WAAA;AhIo2rBV;AgI51rBM;EAEE,QAAA;EACA,YAAA;EAEE,WAAA;EACA,OAAA;EAMF,2BAAA;AhIu1rBR;AgIp1rBM;EACE,QAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,gCAAA;AhIs1rBR;AgIn1rBM;EAEE,QAAA;EACA,YAAA;EAEE,QAAA;EACA,UAAA;EAMF,2BAAA;AhI80rBR;AgI30rBM;EAEE,SAAA;EACA,SAAA;EAEE,WAAA;EACA,OAAA;AhI20rBV;AgIn0rBM;EACE,SAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;AhIq0rBR;AgIl0rBM;EAEE,SAAA;EACA,SAAA;EAEE,QAAA;EACA,UAAA;AhIk0rBV;AgIvzrBI;EACE,sBAAA;EACA,oBAAA;AhIyzrBN;AgIvzrBM;EACE,SAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;AhIyzrBR;AgItzrBM;EACE,uBAAA;AhIwzrBR;AgIrzrBM;EACE,WAAA;EACA,qBAAA;EACA,cP2CsB;AzH4wrB9B;AgIpzrBM;EACE,yBPwC2B;AzH8wrBnC;;AiIj8rBA;EA4CI,aAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AjIy5rBJ;AiI36rBI;EACI;IAAM,qBAAA;EjI86rBZ;AACF;AiI56rBI;EACI;IAAI,wBAAA;EjI+6rBV;AACF;AiIj6rBI;EAxDJ;IAyDQ,YAAA;IACA,eAAA;EjIo6rBN;AACF;AiIl6rBI;EAAS,qB1HhDD;APq9rBZ;AiIp6rBI;EACE,cAAA;EACA,qB1HLc;AP26rBpB;AiIl6rBI;EACI,eAAA;AjIo6rBR;AiIn6rBQ;EACI,kBAAA;EACA,QAAA;EACA,aAAA;AjIq6rBZ;AiIn6rBQ;EAA4B,aAAA;AjIs6rBpC;AiIr6rBQ;EACI,wCAtEmB;AjI6+rB/B;AiIt6rBY;EA/CJ,0IAAA;EACA,gBAAA;EACA,wBAAA;AjIw9rBR;AiIn6rBY;EAAW,aAAA;AjIs6rBvB;AiIr6rBY;EACI,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,wCAAA;EACA,kBAAA;EACA,4CAAA;AjIu6rBhB;AiIp6rBgB;EACI,cAAA;AjIs6rBpB;AiI95rBI;;EACY,wBAAA;AjIi6rBhB;AiI/5rBI;EACI,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,0BAAA;AjIi6rBR;AiI/5rBQ;EACI,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,wCAvHmB;EAwHnB,c1HnFE;E0HoFF,oBAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,0BAAA;AjIi6rBZ;AiI/5rBY;EACI,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gCAAA;EACA,gCAAA;EACA,iCAAA;AjIi6rBhB;AiI95rBgB;EACI,aAAA;EACA,yBAAA;UAAA,iBAAA;EACA,YAAA;EAEA,YAAA;EACA,YAAA;EACA,gBAAA;AjI+5rBpB;AiI35rBY;EACI,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,OAAA;EAAQ,MAAA;EAAO,QAAA;EAAS,SAAA;EACxB,WAAA;EACA,oBAAA;EACA,sBAAA;EAEA,kCAAA;EACA,yBAAA;AjI+5rBhB;AiIz5rBgB;EAGI,MADO;EAEP,QAFO;EAGP,SAHO;EAIP,OAJO;EAKP,qCAAA;AjIy5rBpB;AiIl5rBc;EACE,eAAA;AjIo5rBhB;AiIh5rBY;EACI,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;AjIk5rBhB;AiI94rBgB;EAAa,eAAA;AjIi5rB7B;AiI54rBoB;EAAQ,YAAA;AjI+4rB5B;AiI94rBoB;EACI,iEAAA;EACA,gBAAA;AjIg5rBxB;AiIz4rBY;EAA4B,aAAA;AjI44rBxC;AiI14rBgB;EA7LR,0IAAA;EACA,gBAAA;EACA,wBAAA;EA6LY,kBAjNW;AjI+lsB/B;AiIx4rBY;EACI,c1HzLF;APmksBd;AiIz4rBgB;EACI,8CAAA;AjI24rBpB;AiIr4rBoB;EACI,8CAAA;AjIu4rBxB;AiIh4rBI;EAGI,QAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAlPuB;EAmPvB,c1HlNQ;E0HoNR,WAZO;EAaP,YAbO;EAcP,4BAAA;EACA,4BAAA;EAEA,yBAAA;AjI83rBR;AiI53rBQ;EACI,kBAAA;EACA,YAAA;EACA,QAAA;AjI83rBZ;AiI33rBQ;EACI,YAAA;EACA,mBAnQmB;AjIgosB/B;AiI13rBgB;EAEI,gBAAA;AjI23rBpB;AiIl3rBY;EAAK,aAAA;AjIq3rBjB;AiIp3rBY;EAAI,eAAA;EAAgB,mBAAA;AjIw3rBhC;AiIl3rBI;EAGI,cAAA;EACA,eAHqB;EAIrB,WAAA;EACA,wCArSuB;EAsSvB,oBAAA;EACA,kBAAA;EACA,qBAAA;EA8DA;;GAAA;AjIuzrBR;AiIn3rBQ;EAAW,qBAAA;EAAsB,QAAA;AjIu3rBzC;AiIr3rBQ;EACE,aAAA;AjIu3rBV;AiIt3rBU;EAhSF,yBAAA;EAEI,YAHiC;EAGf,eAAA;EA8Ra,WAAA;AjI43rB3C;AiIz3rBQ;EAAS,aAAA;AjI43rBjB;AiI33rBY;EApSJ,yBAAA;EAKI,UAAA;EAAW,0BAAA;AjI+psBvB;AiI/3rBgB;EADJ;IAEQ,aAAA;EjIk4rBlB;AACF;AiIh4rBY;EAzSJ,yBAAA;EAEI,YAuS4C;EAvS1B,eAAA;AjI4qsB9B;AiIp4rBgB;EADJ;IAEQ,qBAAA;EjIu4rBlB;AACF;AiIl4rBQ;EACI,+BAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,c1HhSE;E0HiSF,mBAAA;EACA,oBAAA;EACA,UAAA;AjIo4rBZ;AiIl4rBY;EACE,gBAAA;EACA,oBAAA;AjIo4rBd;AiIh4rBQ;EACI;IACI,oBAAA;IACA,kBAAA;EjIk4rBd;AACF;AiI93rBQ;EACI,2BAAA;EACA,qBAAA;EACA,gBAAA,EAAA,mCAAA;EACA,c1HvTE;E0HwTF,YAAA;EACA,oBAAA;EACA,gBAAA;AjIg4rBZ;AiIt3rBQ;EACI,SAAA;AjIw3rBZ;AiIr3rBY;EACI,cAAA;EAAe,iBAAA;AjIw3rB/B;AiIn3rBI;EACI,gBAAA;AjIq3rBR;AiIn3rBQ;EACI,YAxXmB;EAyXnB,SAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AjIq3rBZ;AiIl3rBY;EAAU,aAAA;AjIq3rBtB;AiIh3rBQ;EAEI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,2DAAA;EACA,4BAAA;AjIi3rBZ;AiI72rBY;EACI,4DAAA;AjI+2rBhB;AiI32rBQ;EACI,kBAAA;EACA,MAAA;EACA,YAAA;EACA,SAAA;AjI62rBZ;AiI52rBY;EACI,aAAA;AjI82rBhB;AiI12rBQ;EACI,WAAA;AjI42rBZ;AiIx2rBI;EACI,qBApauB;AjI8wsB/B;AiIr2rBI;EAGI,kBAAA;EACA,aAAA;EACA,0BAAA;EACA,gBAAA;EACA,2CAAA;EACA,kB1HrTS;AP0psBjB;AiIn2rBQ;EACI,aAAA;EACA,2BAAA;EACA,4CAAA;AjIq2rBZ;AiI71rBQ;EACI,4CAAA;EACA,gBAAA;AjI+1rBZ;AiI91rBY;EACI,iBAAA;AjIg2rBhB;AiI51rBQ;EACI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kB1HhVK;E0HiVL,4CAlCI;AjIg4rBhB;AiI71rBY;EACI,cAAA;AjI+1rBhB;AiI11rBY;EACI,gBAAA;EACA,2BAAA;AjI41rBhB;AiIx1rBgB;EACI,0BAAA;AjI01rBpB;AiIr1rBQ;EACI,mBAAA;EACA,wCAvemB;EAwenB,WAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AjIu1rBZ;AiIr1rBY;EACI,mB1H3bI;E0H4bJ,YAAA;AjIu1rBhB;AiIr1rBY;EACI,wBAAA;AjIu1rBhB;AiIn1rBQ;EACE,WAAA;EACA,mB1HrcU;E0HscV,YAAA;EACA,YAAA;AjIq1rBV;;AiI/0rBA;EACI,WAAA;AjIk1rBJ;;AkI11sBA;EACI,sBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AlI61sBJ;;AkI31sBE;EACE,kBAAA;AlI81sBJ;;AkI51sBE;EACE,oBAAA;AlI+1sBJ;;AkI71sBE;EACE,eAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AlIg2sBJ;;AkI91sBE;EACE,SAAA;EACA,UAAA;AlIi2sBJ;;AkI/1sBE;EACE,sBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EAEE,gBAAA;EAKF,qBAAA;EACA,qBAAA;AlI61sBJ;;AkI31sBE;EACE,YAAA;AlI81sBJ;;AkI51sBE;;;;;;;;;;;EAWE,SAAA;EACA,UAAA;EACA,6EAAA;AlI+1sBJ;;AkI71sBE;;EAGI,mBAAA;AlI+1sBN;;AkIz1sBE;;EAEE,qBAAA;AlI41sBJ;;AkI11sBE;EACE,YAAA;AlI61sBJ;;AkI31sBE;;EAEE,oBAAA;AlI81sBJ;;AkI51sBE;;EAEE,mBAAA;AlI+1sBJ;;AkI71sBE;;EAEE,WAAA;EACA,eAAA;EACA,mBAAA;AlIg2sBJ;;AkI91sBE;EACE,YAAA;AlIi2sBJ;;AkI/1sBE;EACE,YAAA;AlIk2sBJ;;AkIh2sBE;EACE,qBAAA;EACA,mBAAA;EACA,YAAA;AlIm2sBJ;;AkIj2sBE;EAEI,mBAAA;EACA,mBAAA;EACA,iBAAA;AlIm2sBN;;AkI31sBE;EAEI,kBAAA;EACA,oBAAA;AlI61sBN;;AkIt1sBE;;EAGI,mBAAA;AlIw1sBN;;AkIl1sBE;;EAGI,oBAAA;AlIo1sBN;;AkI90sBE;EACE,6EAAA;EACA,yBAAA;AlIi1sBJ;;AkI/0sBE;EACE,sCAAA;AlIk1sBJ;;AkIh1sBE;EACE,yBAAA;AlIm1sBJ;;AkIj1sBE;EACE,0CAAA;AlIo1sBJ;;AkIl1sBE;EACE,sEAAA;AlIq1sBJ;;AkIn1sBE;EACE,yBAAA;AlIs1sBJ;;AkIp1sBE;EACE,0CAAA;AlIu1sBJ;;AkIr1sBE;EACE,+DAAA;AlIw1sBJ;;AkIt1sBE;EACE,yBAAA;AlIy1sBJ;;AkIv1sBE;EACE,sCAAA;AlI01sBJ;;AkIx1sBE;EACE,wDAAA;AlI21sBJ;;AkIz1sBE;EACE,yBAAA;AlI41sBJ;;AkI11sBE;EACE,0CAAA;AlI61sBJ;;AkI31sBE;EACE,iDAAA;AlI81sBJ;;AkI51sBE;EACE,yBAAA;AlI+1sBJ;;AkI71sBE;EACE,0CAAA;AlIg2sBJ;;AkI91sBE;EACE,0CAAA;AlIi2sBJ;;AkI/1sBE;EACE,yBAAA;AlIk2sBJ;;AkIh2sBE;EACE,sCAAA;AlIm2sBJ;;AkIj2sBE;EACE,mCAAA;AlIo2sBJ;;AkIl2sBE;EACE,yBAAA;AlIq2sBJ;;AkIn2sBE;EACE,0CAAA;AlIs2sBJ;;AkIp2sBE;EACE,4BAAA;AlIu2sBJ;;AkIr2sBE;EACE,yBAAA;AlIw2sBJ;;AkIt2sBE;EACE,0CAAA;AlIy2sBJ;;AkIv2sBE;EACE,qBAAA;AlI02sBJ;;AkIx2sBE;EACE,yBAAA;AlI22sBJ;;AkIz2sBE;EACE,sCAAA;AlI42sBJ;;AkI12sBE;EACE,iBAAA;AlI62sBJ;;AkI32sBE;EACE,mBAAA;AlI82sBJ;;AkI52sBE;EACE,kBAAA;AlI+2sBJ;;AkI72sBE;EACE,oBAAA;AlIg3sBJ;;AkI92sBE;EACE,iBAAA;AlIi3sBJ;;AkI/2sBE;EACE,mBAAA;AlIk3sBJ;;AkIh3sBE;EACE,kBAAA;AlIm3sBJ;;AkIj3sBE;EACE,oBAAA;AlIo3sBJ;;AkIl3sBE;EACE,iBAAA;AlIq3sBJ;;AkIn3sBE;EACE,oBAAA;AlIs3sBJ;;AkIp3sBE;EACE,kBAAA;AlIu3sBJ;;AkIr3sBE;EACE,qBAAA;AlIw3sBJ;;AkIt3sBE;EACE,kBAAA;AlIy3sBJ;;AkIv3sBE;EACE,oBAAA;AlI03sBJ;;AkIx3sBE;EACE,mBAAA;AlI23sBJ;;AkIz3sBE;EACE,qBAAA;AlI43sBJ;;AkI13sBE;EACE,kBAAA;AlI63sBJ;;AkI33sBE;EACE,oBAAA;AlI83sBJ;;AkI53sBE;EACE,mBAAA;AlI+3sBJ;;AkI73sBE;EACE,qBAAA;AlIg4sBJ;;AkI93sBE;EACE,kBAAA;AlIi4sBJ;;AkI/3sBE;EACE,oBAAA;AlIk4sBJ;;AkIh4sBE;EACE,mBAAA;AlIm4sBJ;;AkIj4sBE;EACE,qBAAA;AlIo4sBJ;;AkIl4sBE;EACE,kBAAA;AlIq4sBJ;;AkIn4sBE;EACE,oBAAA;AlIs4sBJ;;AkIp4sBE;EACE,mBAAA;AlIu4sBJ;;AkIr4sBE;EACE,qBAAA;AlIw4sBJ;;AkIt4sBE;EACE,kBAAA;AlIy4sBJ;;AkIv4sBE;EACE,oBAAA;AlI04sBJ;;AkIx4sBE;EACE,mBAAA;AlI24sBJ;;AkIz4sBE;EACE,qBAAA;AlI44sBJ;;AkI14sBE;EACE,kBAAA;AlI64sBJ;;AkI34sBE;EACE,oBAAA;AlI84sBJ;;AkI54sBE;EACE,mBAAA;AlI+4sBJ;;AkI74sBE;EACE,qBAAA;AlIg5sBJ;;AkI94sBE;EACE,cAAA;EACA,eAAA;AlIi5sBJ;;AkI/4sBE;EACE,cAAA;AlIk5sBJ;;AkIh5sBE;EAEI,kBAAA;AlIk5sBN;;AkI54sBE;EACE,sBAAA;AlI+4sBJ;;AkI74sBE;EACE,yBAAA;AlIg5sBJ;;AkI94sBE;EACE,sBAAA;AlIi5sBJ;;AkI/4sBE;EACE,sBAAA;AlIk5sBJ;;AkIh5sBE;EACE,yBAAA;AlIm5sBJ;;AkIj5sBE;EACE,sBAAA;AlIo5sBJ;;AkIl5sBE;EACE,sBAAA;AlIq5sBJ;;AkIn5sBE;EACE,WAAA;AlIs5sBJ;;AkIp5sBE;EACE,cAAA;AlIu5sBJ;;AkIr5sBE;EACE,WAAA;AlIw5sBJ;;AkIt5sBE;EACE,WAAA;AlIy5sBJ;;AkIv5sBE;EACE,cAAA;AlI05sBJ;;AkIx5sBE;EACE,WAAA;AlI25sBJ;;AkIz5sBE;EACE,WAAA;AlI45sBJ;;AkI15sBE;EACE,4CAAA;AlI65sBJ;;AkI35sBE;EACE,2CAAA;AlI85sBJ;;AkI55sBE;EACE,iBAAA;AlI+5sBJ;;AkI75sBE;EACE,gBAAA;AlIg6sBJ;;AkI95sBE;EACE,gBAAA;AlIi6sBJ;;AkI/5sBE;EACE,cAAA;EACA,mBAAA;AlIk6sBJ;;AkIh6sBE;EACE,kBAAA;AlIm6sBJ;;AkIj6sBE;EACE,mBAAA;AlIo6sBJ;;AkIl6sBE;EACE,iBAAA;AlIq6sBJ;;AkIn6sBE;EACE,yBAAA;EACA,+BAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;AlIs6sBJ;;AkIp6sBE;EACE,WAAA;EACA,WAAA;EACA,cAAA;AlIu6sBJ;;AkIr6sBE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EAEE,WAAA;EAKF,YAAA;EACA,gBAAA;EACA,WAAA;AlIm6sBJ;;AkIj6sBE;EACE,WAAA;EACA,YAAA;AlIo6sBJ;;AkIl6sBE;EACE,aAAA;AlIq6sBJ;;AkIn6sBE;EACE,aAAA;AlIs6sBJ;;AkIp6sBE;;;;;;;EAOE,c3HxZgB;AP+ztBpB;;AkIr6sBE;;;;;;;;;;;;;;EAcE,a3HxagB;APg1tBpB;;AkIt6sBE;;;;;;;;;;;;;;EAcE,e3HxbgB;APi2tBpB;;AkIv6sBE;EACE;IACE,c3H3cQ;EPq3tBZ;EkIx6sBE;;IAEE,a3H/cQ;EPy3tBZ;EkIx6sBE;;IAEE,e3HndQ;EP63tBZ;AACF;AkIv6sBE;EACE,aAAA;AlIy6sBJ;;AkIv6sBE;;EAEE,kBAAA;AlI06sBJ;;AkIx6sBE;EACE,kBAAA;EACA,2BAAA;AlI26sBJ;;AkIz6sBE;EACE,eAAA;EACA,qBAAA;AlI46sBJ;;AkI16sBE;EACE,4BAAA;AlI66sBJ;;AkI36sBE;EACE,qBAAA;EACA,sBAAA;AlI86sBJ;;AkI56sBE;EACE,WAAA;EACA,WAAA;EACA,cAAA;AlI+6sBJ;;AkI76sBE;EACE,UAAA;EACA,e3HpfU;E2HqfV,qBAAA;EACA,sBAAA;EACA,eAAA;AlIg7sBJ;;AkI96sBE;EACE,UAAA;EACA,e3H3fU;E2H4fV,qBAAA;EACA,eAAA;AlIi7sBJ;;AkI/6sBE;;EAEE,a3HjgBU;APm7tBd;;AkIh7sBE;EACE,UAAA;AlIm7sBJ;;AkIj7sBE;EACE,kBAAA;AlIo7sBJ;;AkIl7sBE;;EAEE,eAAA;AlIq7sBJ;;AkIn7sBE;EACE,YAAA;AlIs7sBJ;;AkIp7sBE;EACE,aAAA;AlIu7sBJ;;AkIr7sBE;EACE,eAAA;AlIw7sBJ;;AkIt7sBE;EACE,aAAA;AlIy7sBJ;;AkIv7sBE;EACE,cAAA;AlI07sBJ;;AkIx7sBE;EACE,gBAAA;AlI27sBJ;;AkIz7sBE;EACE,iBAAA;AlI47sBJ;;AkI17sBE;EACE,cAAA;AlI67sBJ;;AkI37sBE;EACE,iBAAA;AlI87sBJ;;AkI57sBE;EACE,iBAAA;AlI+7sBJ;;AkI77sBE;EACE,0BAAA;AlIg8sBJ;;AkI97sBE;EACE,kBAAA;EACA,eAAA;EAEE,8BAAA;EACA,kBAAA;AlIg8sBN;;AkIz7sBE;;EAEE,yBAAA;EACA,kBAAA;AlI47sBJ;;AkI17sBE;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AlI67sBJ;;AkI37sBE;EACE,cAAA;EACA,gBAAA;AlI87sBJ;;AkI57sBE;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;AlI+7sBJ;;AkI77sBE;EACE,eAAA;AlIg8sBJ;;AkI97sBE;EACE,c3HllBU;E2HmlBV,qBAAA;EAEE,WAAA;EAKF,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AlI47sBJ;;AkI17sBE;EACE,eAAA;EACA,qBAAA;EACA,YAAA;EAEE,iBAAA;EACA,kBAAA;EAMF,kBAAA;EACA,WAAA;AlIu7sBJ;AkIt7sBI;EACE,gBAAA;EACA,YAAA;EACA,aAAA;AlIw7sBN;;AkIr7sBE;EACE,qBAAA;EACA,iBAAA;AlIw7sBJ;;AkIt7sBE;EACE,sBAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kB3HniBa;AP49tBjB;;AkIv7sBE;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AlI07sBJ;;AkIx7sBE;EACE,c3HroBW;E2HsoBX,UAAA;AlI27sBJ;;AkIz7sBE;EACE,a3H7oBU;APykuBd;;AkI17sBE;EACE,e3HhpBU;AP6kuBd;;AkI37sBE;EACE,cAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;AlI87sBJ;;AkI57sBE;;EAEE,WAAA;AlI+7sBJ;;AkI77sBE;;EAEE,gBAAA;AlIg8sBJ;;AkI97sBE;;EAGI,UAAA;AlIg8sBN;;AkI17sBE;EACE,gBAAA;AlI67sBJ;;AkI37sBE;EACE,YAAA;EACA,WAAA;EACA,gBAAA;AlI87sBJ;;AkI57sBE;EACE,YAAA;EACA,YAAA;AlI+7sBJ;;AkI77sBE;EACE,6BAAA;EAEE,WAAA;EAKF,YAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AlI27sBJ;;AkIz7sBE;EACE,kBAAA;EACA,gBAAA;EAEE,QAAA;EAKF,QAAA;EACA,WAAA;AlIu7sBJ;;AkIr7sBE;;;;;;EAME,yBAAA;AlIw7sBJ;;AkIt7sBE;EACE,WAAA;AlIy7sBJ;;AkIv7sBE;;EAEE,iBAAA;AlI07sBJ;;AkIx7sBE;;EAEE,oBAAA;AlI27sBJ;;AkIz7sBE;;EAEE,oBAAA;AlI47sBJ;;AkI17sBE;;EAEE,oBAAA;AlI67sBJ;;AkI37sBE;;EAEE,oBAAA;AlI87sBJ;;AkI57sBE;;EAEE,oBAAA;AlI+7sBJ;;AkI77sBE;;EAEE,oBAAA;AlIg8sBJ;;AkI97sBE;EACE,cAAA;AlIi8sBJ;;AkI/7sBE;EACE,gBAAA;AlIk8sBJ;;AkIh8sBE;EACE,iBAAA;AlIm8sBJ;;AkIj8sBE;EACE,cAAA;AlIo8sBJ;;AkIl8sBE;EACE,iBAAA;AlIq8sBJ;;AkIn8sBE;EACE,iBAAA;AlIs8sBJ;;AkIp8sBE;EACE,YAAA;AlIu8sBJ;;AkIr8sBE;;EAEE,qBAAA;AlIw8sBJ;;AkIt8sBE;;EAEE,gBAAA;AlIy8sBJ;;AkIv8sBE;;EAEE,oBAAA;AlI08sBJ;;AkIx8sBE;EACE,4CAAA;AlI28sBJ;;AkIz8sBE;EACE,2CAAA;AlI48sBJ;;AkI18sBE;EACE,WAAA;AlI68sBJ;;AkI38sBE;;EAEE,iBAAA;AlI88sBJ;;AkI58sBE;;EAEE,gBAAA;AlI+8sBJ;;AkI78sBE;;EAEE,gBAAA;AlIg9sBJ;;AkI98sBE;;EAEE,eAAA;AlIi9sBJ;;AkI/8sBE;EACE,eAAA;AlIk9sBJ;;AkIh9sBE;EACE,eAAA;AlIm9sBJ;;AkIj9sBE;EACE,eAAA;AlIo9sBJ;;AkIl9sBE;EACE,sBAAA;AlIq9sBJ;;AkIn9sBE;EACE,sBAAA;AlIs9sBJ;;AkIp9sBE;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;AlIu9sBJ;;AkIr9sBE;EAEI,kBAAA;EAKF,mBAAA;AlIm9sBJ;;AkIj9sBE;EACE,6BAAA;AlIo9sBJ;;AkIl9sBE;EACE,6BAAA;EACA,qD3H7uB0B;APksuB9B;;AkIn9sBE;EACE,qB3Hr3BQ;AP20uBZ;;AkIp9sBE;;EAEE,qB3Hr3BQ;AP40uBZ;;AkIr9sBE;EACE,eAAA;AlIw9sBJ;;AkIt9sBE;EACE,sBAAA;EACA,yBAAA;EACA,4BAAA;EACA,c3Hl2BU;E2Hm2BV,iBAAA;EACA,mBAAA;AlIy9sBJ;;AkIv9sBE;EACE,qBAAA;EACA,iBAAA;EAEE,iBAAA;AlIy9sBN;;AkIn9sBE;EACE,aAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;AlIs9sBJ;;AkIp9sBE;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;AlIu9sBJ;;AkIr9sBE;EACE,eAAA;EAEE,+BAAA;EACA,iBAAA;EACA,kBAAA;AlIu9sBN;;AkI/8sBE;EACE,iBAAA;EAEE,gBAAA;AlIi9sBN;;AkI38sBE;EACE,iBAAA;AlI88sBJ;;AkI58sBE;;EAEE,aAAA;AlI+8sBJ;;AkI78sBE;EACE,qBAAA;AlIg9sBJ;;AkI98sBE;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;AlIi9sBJ;;AkI/8sBE;EACE,sBAAA;AlIk9sBJ;;AkIh9sBE;EACE,yBAAA;AlIm9sBJ;;AkIj9sBE;EACE,uBAAA;AlIo9sBJ;;AkIl9sBE;EACE,c3Hh6BgB;APq3uBpB;;AkIn9sBE;EACE,yBAAA;EACA,0BAAA;AlIs9sBJ;;AmIt7uBA;;;;;EAAA;AAMA;EACE,iFAAA;EACA,eAAA;EACA,qBAAA;EACA,uBAAA;EACA,cAAA;EACA,8BAAA;EACA,2BAAA;EACA,wBAAA;EAGI,gBAAA;EACJ,qBAAA;AnIy7uBF;;AmIv7uBA;EACE,mBAAA;AnI07uBF;;AmIx7uBA;EACE,yBAAA;AnI27uBF;;AmIz7uBA;EACE,yBAAA;AnI47uBF;;AmI17uBA;EACE,gBAAA;EACA,gBAAA;AnI67uBF;;AmI37uBA;EACE,iDAAA;EACA,eAAA;EACA,WAAA;EAEE,mBAAA;EAKF,mBAAA;EACA,kBAAA;EACA,UAAA;AnIy7uBF;;AmIv7uBA;EACE,iDAAA;AnI07uBF;;AmIx7uBA;EAEI,cAAA;EACA,oBAAA;AnI07uBJ;;AmIn7uBA,sBAAA;AACA,wBAAA;AACA;;;;EAAA;AAKA;;EAGE,gBAAA;EAEA,cAAA;EAEE,gBAAA;EAKF,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EAEA,WAAA;EAGA,aAAA;AnI+6uBF;;AmIt6uBA;;;;EAIE,iBAAA;EACA,mBAAA;AnIi7uBF;;AmI/6uBA;EACE;;IAEE,iBAAA;EnIk7uBF;AACF;AmIh7uBA,gBAAA;AACA;EACE,YAAA;EACA,eAAA;EACA,cAAA;AnIk7uBF;;AmIh7uBA;;EAEE,mBAAA;AnIm7uBF;;AmIj7uBA,gBAAA;AACA;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;AnIo7uBF;;AmIl7uBA;;;;EAIE,gBAAA;AnIq7uBF;;AmIn7uBA;EACE,WAAA;AnIs7uBF;;AmIp7uBA;EACE,YAAA;AnIu7uBF;;AmIr7uBA;;;;;;;EAOE,WAAA;AnIw7uBF;;AmIt7uBA;;;;;;EAME,WAAA;AnIy7uBF;;AmIv7uBA;;;;;EAKE,cAAA;EACA,qCAAA;AnI07uBF;;AmIx7uBA;;;EAGE,WAAA;AnI27uBF;;AmIz7uBA;;EAEE,cAAA;AnI47uBF;;AmI17uBA;;;EAGE,WAAA;AnI67uBF;;AmI37uBA;;EAEE,iBAAA;AnI87uBF;;AmI57uBA;EACE,kBAAA;AnI+7uBF;;AmI77uBA;EACE,YAAA;AnIg8uBF;;AmI97uBA,qBAAA;AACA;EACE,yBAAA;EACA,qBAAA;AnIi8uBF;;AmI/7uBA;EACE,uBAAA;EACA,8BAAA;EACA,kBAAA;AnIk8uBF;;AmIh8uBA;EACE,aAAA;AnIm8uBF;;AmIj8uBA;EACE,aAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EAEE,WAAA;EAKF,MAAA;AnI+7uBF;;AmI77uBA;EACE,gBAAA;EACA,oBAAA;EACA,kBAAA;AnIg8uBF;;AmI97uBA;EACE,eAAA;AnIi8uBF;;AmI/7uBA;EACE,YAAA;AnIk8uBF;;AmIh8uBA;EACE,yDAAA;AnIm8uBF;;AmIj8uBA;EAEI,WAAA;AnIm8uBJ;;AmI77uBA;EAEI,YAAA;AnI+7uBJ;;AmIz7uBA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;AnI47uBF;;AmI17uBA;EACE,sBAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AnI67uBF;;AmI37uBA;EACE,oDAAA;EACA,YAAA;EAEE,OAAA;EAKF,kBAAA;EACA,MAAA;EACA,WAAA;AnIy7uBF;;AmIv7uBA;EACE,aAAA;AnI07uBF;;AmIx7uBA;EACE,iFAAA;EACA,uBAAA;AnI27uBF;;AmIz7uBA;EACE,uBAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;AnI47uBF;;AmI17uBA;EACE;IACE,SAAA;EnI67uBF;AACF;AmI37uBA;EACE,oDAAA;EACA,YAAA;EAEE,OAAA;EAKF,kBAAA;EACA,MAAA;EACA,WAAA;AnIw7uBF;;AmIt7uBA;EACE,aAAA;AnIy7uBF;;AmIv7uBA;EACE,qBAAA;EACA,kBAAA;AnI07uBF;;AmIx7uBA;;;;EAIE,cAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;AnI27uBF;;AmIz7uBA;EACE,uBAAA;AnI47uBF;;AmI17uBA;EACE,mBAAA;AnI67uBF;;AmI37uBA;EACE,gBAAA;AnI87uBF;;AmI57uBA;EACE,iBAAA;AnI+7uBF;;AmI77uBA;;;;EAIE,SAAA;EACA,YAAA;EAEE,OAAA;EAKF,kBAAA;EACA,MAAA;EACA,WAAA;AnI27uBF;;AmIz7uBA;EACE,kBAAA;AnI47uBF;;AmI17uBA;EACE,4BAAA;EACA,mCAAA;EACA,kBAAA;AnI67uBF;;AmI37uBA;EAEI,SAAA;AnI67uBJ;;AmIv7uBA;EAEI,UAAA;AnIy7uBJ;;AmIn7uBA;EACE,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;AnIs7uBF;;AmIp7uBA;EACE,yBAAA;AnIu7uBF;;AmIr7uBA;EACE,mBAAA;AnIw7uBF;;AmIt7uBA;EACE,mBAAA;AnIy7uBF;;AmIv7uBA;EACE,mBAAA;AnI07uBF;;AmIx7uBA;EACE,mBAAA;AnI27uBF;;AmIz7uBA;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AnI47uBF;;AmI17uBA;EACE,gBAAA;EACA,+BAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AnI67uBF;;AmI37uBA;EACE,kBAAA;AnI87uBF;;AmI57uBA;EACE,SAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;AnI+7uBF;;AmI77uBA;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EAEE,WAAA;EAKF,SAAA;EACA,UAAA;AnI27uBF;;AmIz7uBA;EACE,yBAAA;EACA,oBAAA;EACA,sBAAA;EACA,WAAA;EACA,wBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EAEE,UAAA;EAKF,eAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,aAAA;AnIu7uBF;;AmIr7uBA;EACE,yBAAA;AnIw7uBF;;AmIt7uBA;EACE,yBAAA;AnIy7uBF;;AmIv7uBA;EACE,yBAAA;AnI07uBF;;AmIx7uBA;EACE,yBAAA;AnI27uBF;;AmIz7uBA;EACE,yBAAA;AnI47uBF;;AmI17uBA;EACE,yBAAA;AnI67uBF;;AmI37uBA;EACE,yBAAA;AnI87uBF;;AmI57uBA;EACE,yBAAA;AnI+7uBF;;AmI77uBA;EACE,oFAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;AnIg8uBF;;AmI97uBA;EACE,gBAAA;EACA,WAAA;AnIi8uBF;;AmI/7uBA;EACE,gBAAA;EACA,WAAA;AnIk8uBF;;AmI57uBA;EACE,gBAAA;EACA,WAAA;AnIo8uBF;;AmIl8uBA;;EAEE,0BAAA;AnIq8uBF;;AmIn8uBA;EACE,0BAAA;EACA,mBAAA;AnIs8uBF;;AmIp8uBA;EACE,0BAAA;AnIu8uBF;;AmIr8uBA;EACE,0BAAA;AnIw8uBF;;AmIt8uBA;EACE,mBAAA;EACA,0BAAA;AnIy8uBF;;AmIv8uBA;;EAEE,aAAA;AnI08uBF;;AmIx8uBA;EACE,yBAAA;AnI28uBF;;AmIz8uBA;EACE,0BAAA;AnI48uBF;;AmI18uBA;;EAEE,oCAAA;AnI68uBF;;AmIv8uBA;;EAEE,gBAAA;AnI+8uBF;;AmI78uBA;;EAEE,2BAAA;EACA,yBAAA;EAGQ,iBAAA;AnIg9uBV;;AmI38uBA;EACE,gBAAA;AnIk9uBF;;AmIh9uBA;EACE,yBAAA;EACA,UAAA;EACA,yBAAA;EAGA,iBAAA;AnIm9uBF;;AmIj9uBA;EACE,kBAAA;AnIo9uBF;;AmIl9uBA;EACE,kBAAA;AnIq9uBF;;AmIn9uBA;EACE,UAAA;AnIs9uBF;;AmIp9uBA;EACE,0DAAA;EACA,uCAAA;EACA,2BAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;AnIu9uBF;;AmIr9uBA;EACE,0DAAA;EACA,uCAAA;EACA,2BAAA;EACA,yBAAA;EACA,eAAA;AnIw9uBF;;AmIt9uBA;EACE,sBAAA;AnIy9uBF;;AmIv9uBA;EACE,WAAA;AnI09uBF;;AmIx9uBA;EACE,qBAAA;AnI29uBF;;AmIz9uBA;;;;EAIE,uBAAA;AnI49uBF;;AmI19uBA;;;;;;;;;;;;;;;;;;;;EAoBE,4BAAA;EACA,uBAAA;EAEE,gBAAA;EAKF,iBAAA;AnIw9uBF;;AmIt9uBA;EACE,0DAAA;AnIy9uBF;;AmIv9uBA;EACE,0DAAA;AnI09uBF;;AmIx9uBA;EACE,0DAAA;AnI29uBF;;AmIz9uBA;EACE,0DAAA;AnI49uBF;;AmI19uBA;EACE,0DAAA;AnI69uBF;;AmI39uBA;EACE,0DAAA;AnI89uBF;;AmI59uBA;EACE,0DAAA;AnI+9uBF;;AmI79uBA;EACE,0DAAA;AnIg+uBF;;AmI99uBA;EACE,0DAAA;AnIi+uBF;;AmI/9uBA;EACE,0DAAA;AnIk+uBF;;AmIh+uBA;EACE,0DAAA;AnIm+uBF;;AmIj+uBA;EACE,0DAAA;AnIo+uBF;;AmIl+uBA;EACE,0DAAA;AnIq+uBF;;AmIn+uBA;EACE,0DAAA;AnIs+uBF;;AmIp+uBA;EACE,uBAAA;AnIu+uBF;;AmIr+uBA;EACE,0DAAA;AnIw+uBF;;AmIt+uBA;EACE,0DAAA;AnIy+uBF;;AmIv+uBA;EACE,0DAAA;AnI0+uBF;;AmIx+uBA;EACE,0DAAA;AnI2+uBF;;AmIz+uBA;EACE,0DAAA;AnI4+uBF;;AmI1+uBA;;;;;;;;;;;;;;;;;;;;EAqBI,gBAAA;AnI4+uBJ;;AmIt+uBA;;;;;;;;;;;;;;;;;;;;EAqBI,4BAAA;EACA,iBAAA;AnIw+uBJ;;AmIj+uBA;;EAEE,gBAAA;AnIo+uBF;;AmIl+uBA;EACE,YAAA;AnIq+uBF;;AmIl+uBE;EACE,yBAAA;AnIq+uBJ;;AmIj+uBA;EACE,kC5HjmBmB;APqkwBrB;;AoI1uwBA;;;;;EAAA;AAMA;EACE,iFAAA;EACA,eAAA;EACA,qBAAA;EACA,uBAAA;EACA,cAAA;EACA,8BAAA;EACA,2BAAA;EACA,wBAAA;EAGI,gBAAA;EACJ,qBAAA;ApI6uwBF;;AoI3uwBA;EACE,mBAAA;ApI8uwBF;;AoI5uwBA;EACE,yBAAA;ApI+uwBF;;AoI7uwBA;EACE,yBAAA;ApIgvwBF;;AoI9uwBA;EACE,gBAAA;EACA,gBAAA;ApIivwBF;;AoI/uwBA;EACE,iDAAA;EACA,eAAA;EACA,WAAA;EAEE,mBAAA;EAKF,mBAAA;EACA,kBAAA;EACA,UAAA;ApI6uwBF;;AoI3uwBA;EACE,iDAAA;ApI8uwBF;;AoI5uwBA;EAEI,cAAA;EACA,oBAAA;ApI8uwBJ;;AoIvuwBA,sBAAA;AACA,wBAAA;AACA;;;;EAAA;AAKA;;EAGE,gBAAA;EAEA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EAEA,WAAA;EAGA,aAAA;ApIwuwBF;;AoI/twBA;;;;EAIE,iBAAA;EACA,mBAAA;ApI0uwBF;;AoIxuwBA;EACE;;IAEE,iBAAA;EpI2uwBF;AACF;AoIzuwBA,gBAAA;AACA;EACE,YAAA;EACA,eAAA;EACA,cAAA;ApI2uwBF;;AoIzuwBA;;EAEE,mBAAA;ApI4uwBF;;AoI1uwBA,gBAAA;AACA;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;ApI6uwBF;;AoI3uwBA;;;;EAIE,gBAAA;ApI8uwBF;;AoI5uwBA;EACE,WAAA;ApI+uwBF;;AoI7uwBA;EACE,YAAA;ApIgvwBF;;AoI9uwBA;;;;;;;EAOE,WAAA;ApIivwBF;;AoI/uwBA;;;;;;EAME,WAAA;ApIkvwBF;;AoIhvwBA;;;;;EAKE,cAAA;EACA,qCAAA;ApImvwBF;;AoIjvwBA;;;EAGE,WAAA;ApIovwBF;;AoIlvwBA;;EAEE,cAAA;ApIqvwBF;;AoInvwBA;;;EAGE,WAAA;ApIsvwBF;;AoIpvwBA;;EAEE,iBAAA;ApIuvwBF;;AoIrvwBA;EACE,kBAAA;ApIwvwBF;;AoItvwBA;EACE,YAAA;ApIyvwBF;;AoIvvwBA,qBAAA;AACA;EACE,yBAAA;EACA,qBAAA;ApI0vwBF;;AoIxvwBA;EACE,uBAAA;EACA,8BAAA;EACA,kBAAA;ApI2vwBF;;AoIzvwBA;EACE,aAAA;ApI4vwBF;;AoI1vwBA;EACE,SAAA;EACA,UAAA;EACA,kBAAA;EAEE,WAAA;EACA,aAAA;EAMF,MAAA;ApIuvwBF;;AoIrvwBA;EAEI,gBAAA;EAKF,oBAAA;EACA,kBAAA;ApImvwBF;;AoIjvwBA;EACE,eAAA;ApIovwBF;;AoIlvwBA;EACE,YAAA;ApIqvwBF;;AoInvwBA;EACE,yDAAA;ApIsvwBF;;AoIpvwBA;EACE,WAAA;ApIuvwBF;;AoIrvwBA;EACE,YAAA;ApIwvwBF;;AoItvwBA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;ApIyvwBF;;AoIvvwBA;EACE,sBAAA;EACA,qBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;ApI0vwBF;;AoIxvwBA;EACE,oDAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;ApI2vwBF;;AoIzvwBA;EACE,aAAA;ApI4vwBF;;AoI1vwBA;EACE,iFAAA;EACA,uBAAA;ApI6vwBF;;AoI3vwBA;EACE,uBAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;ApI8vwBF;;AoI5vwBA;EACE;IACE,SAAA;EpI+vwBF;AACF;AoI7vwBA;EACE,oDAAA;EACA,YAAA;EAEE,OAAA;EAKF,kBAAA;EACA,MAAA;EACA,WAAA;ApI0vwBF;;AoIxvwBA;EACE,aAAA;ApI2vwBF;;AoIzvwBA;EACE,qBAAA;EACA,kBAAA;ApI4vwBF;;AoI1vwBA;;;;EAIE,cAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;ApI6vwBF;;AoI3vwBA;EACE,uBAAA;ApI8vwBF;;AoI5vwBA;EACE,mBAAA;ApI+vwBF;;AoI7vwBA;EACE,gBAAA;ApIgwwBF;;AoI9vwBA;EACE,iBAAA;ApIiwwBF;;AoI/vwBA;;;;EAIE,SAAA;EACA,YAAA;EAEE,OAAA;EAKF,kBAAA;EACA,MAAA;EACA,WAAA;ApI6vwBF;;AoI3vwBA;EACE,kBAAA;ApI8vwBF;;AoI5vwBA;EACE,4BAAA;EACA,mCAAA;EACA,kBAAA;ApI+vwBF;;AoI7vwBA;EAEI,SAAA;ApI+vwBJ;;AoIzvwBA;EAEI,UAAA;ApI2vwBJ;;AoIrvwBA;EACE,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;ApIwvwBF;;AoItvwBA;EACE,yBAAA;ApIyvwBF;;AoIvvwBA;EACE,mBAAA;ApI0vwBF;;AoIxvwBA;EACE,mBAAA;ApI2vwBF;;AoIzvwBA;EACE,mBAAA;ApI4vwBF;;AoI1vwBA;EACE,mBAAA;ApI6vwBF;;AoI3vwBA;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;ApI8vwBF;;AoI5vwBA;EACE,gBAAA;EACA,+BAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;ApI+vwBF;;AoI7vwBA;EACE,kBAAA;ApIgwwBF;;AoI9vwBA;EACE,SAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;ApIiwwBF;;AoI/vwBA;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EAEE,WAAA;EAKF,SAAA;EACA,UAAA;ApI6vwBF;;AoI3vwBA;EACE,yBAAA;EACA,oBAAA;EACA,sBAAA;EACA,WAAA;EACA,wBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EAEE,UAAA;EAKF,eAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,aAAA;ApIyvwBF;;AoIvvwBA;EACE,yBAAA;ApI0vwBF;;AoIxvwBA;EACE,yBAAA;ApI2vwBF;;AoIzvwBA;EACE,yBAAA;ApI4vwBF;;AoI1vwBA;EACE,yBAAA;ApI6vwBF;;AoI3vwBA;EACE,yBAAA;ApI8vwBF;;AoI5vwBA;EACE,yBAAA;ApI+vwBF;;AoI7vwBA;EACE,yBAAA;ApIgwwBF;;AoI9vwBA;EACE,yBAAA;ApIiwwBF;;AoI/vwBA;EACE,oFAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;ApIkwwBF;;AoIhwwBA;EACE,gBAAA;EACA,WAAA;ApImwwBF;;AoIjwwBA;EACE,gBAAA;EACA,WAAA;ApIowwBF;;AoI9vwBA;EACE,gBAAA;EACA,WAAA;ApIswwBF;;AoIpwwBA;;EAEE,0BAAA;ApIuwwBF;;AoIrwwBA;EACE,0BAAA;EACA,mBAAA;ApIwwwBF;;AoItwwBA;EACE,0BAAA;ApIywwBF;;AoIvwwBA;EACE,0BAAA;ApI0wwBF;;AoIxwwBA;EACE,mBAAA;EACA,0BAAA;ApI2wwBF;;AoIzwwBA;;EAEE,aAAA;ApI4wwBF;;AoI1wwBA;EACE,yBAAA;ApI6wwBF;;AoI3wwBA;EACE,0BAAA;ApI8wwBF;;AoI5wwBA;;EAEE,oCAAA;ApI+wwBF;;AoIzwwBA;;EAEE,gBAAA;ApIixwBF;;AoI/wwBA;;EAEE,2BAAA;EACA,yBAAA;EAGQ,iBAAA;ApIkxwBV;;AoI7wwBA;EACE,gBAAA;ApIoxwBF;;AoIlxwBA;EACE,yBAAA;EACA,UAAA;EACA,yBAAA;EAGA,iBAAA;ApIqxwBF;;AoInxwBA;EACE,kBAAA;ApIsxwBF;;AoIpxwBA;EACE,kBAAA;ApIuxwBF;;AoIrxwBA;EACE,UAAA;ApIwxwBF;;AoItxwBA;EACE,0DAAA;EACA,uCAAA;EACA,2BAAA;EACA,yBAAA;EACA,eAAA;EACA,YAAA;ApIyxwBF;;AoIvxwBA;EACE,0DAAA;EACA,uCAAA;EACA,2BAAA;EACA,yBAAA;EACA,eAAA;ApI0xwBF;;AoIxxwBA;EACE,sBAAA;ApI2xwBF;;AoIzxwBA;EACE,WAAA;ApI4xwBF;;AoI1xwBA;EACE,qBAAA;ApI6xwBF;;AoI3xwBA;;;;EAIE,uBAAA;ApI8xwBF;;AoI5xwBA;;;;;;;;;;;;;;;;;;;;EAoBE,4BAAA;EACA,uBAAA;EAEE,gBAAA;EAKF,iBAAA;ApI0xwBF;;AoIxxwBA;EACE,0DAAA;ApI2xwBF;;AoIzxwBA;EACE,0DAAA;ApI4xwBF;;AoI1xwBA;EACE,0DAAA;ApI6xwBF;;AoI3xwBA;EACE,0DAAA;ApI8xwBF;;AoI5xwBA;EACE,0DAAA;ApI+xwBF;;AoI7xwBA;EACE,0DAAA;ApIgywBF;;AoI9xwBA;EACE,0DAAA;ApIiywBF;;AoI/xwBA;EACE,0DAAA;ApIkywBF;;AoIhywBA;EACE,0DAAA;ApImywBF;;AoIjywBA;EACE,0DAAA;ApIoywBF;;AoIlywBA;EACE,0DAAA;ApIqywBF;;AoInywBA;EACE,0DAAA;ApIsywBF;;AoIpywBA;EACE,0DAAA;ApIuywBF;;AoIrywBA;EACE,0DAAA;ApIwywBF;;AoItywBA;EACE,uBAAA;ApIyywBF;;AoIvywBA;EACE,0DAAA;ApI0ywBF;;AoIxywBA;EACE,0DAAA;ApI2ywBF;;AoIzywBA;EACE,0DAAA;ApI4ywBF;;AoI1ywBA;EACE,0DAAA;ApI6ywBF;;AoI3ywBA;EACE,0DAAA;ApI8ywBF;;AoI5ywBA;;;;;;;;;;;;;;;;;;;;EAqBI,gBAAA;ApI8ywBJ;;AoIvywBA;;EAEE,gBAAA;ApI0ywBF;;AoIxywBA;EACE,YAAA;ApI2ywBF;;AoIvywBE;EACE,gBAAA;EACA,aAAA;ApI0ywBJ;;AqIngyBA;;;;;EAAA;AAMA;EACE,yEAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;ArIsgyBF;;AqIngyBE;EACE,8BAAA;ArIsgyBJ;AqIpgyBE;EACE,0CAAA;EACA,eAAA;ArIsgyBJ;AqIpgyBE;EACE,cAAA;ArIsgyBJ;AqIngyBE;EACE,yBAAA;ArIqgyBJ;;AsI/hyBA;;;;;EAAA;AAMA;EACE,uBAAA;EACA,c/HqCY;E+HpCZ,YAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,wCAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;AtIkiyBF;;AsIhiyBA;EACE,mBAAA;EAEA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,oCAAA;EACA,mBAAA;EACA,wBAAA;EAEA,uBAAA;EACA,uBAAA;EACA,oBAAA;AtIiiyBF;;AsI/hyBA;EACE,kDAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;AtIkiyBF;;AsIhiyBA;EAEI,cAAA;EACA,gBAAA;AtIkiyBJ;;AsI3hyBA;EACE,oCAAA;EACA,6BAAA;EACA,2BAAA;EACA,iCAAA;EACA,wBAAA;EACA,iCAAA;EACA,2BAAA;EACA,6BAAA;EACA,8BAAA;AtI8hyBF;;AsI5hyBA;EACE,YAAA;EACA,gBAAA;AtI+hyBF;;AsI7hyBA;EACE,yBAAA;EACA,gBAAA;EACA,gBAAA;AtIgiyBF;;AsI9hyBA;EACE,aAAA;AtIiiyBF;;AsI/hyBA;;EAEE,aAAA;AtIkiyBF;;AsIhiyBA;EACE,SAAA;AtImiyBF;;AsIjiyBA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;AtIoiyBF;;AsIliyBA;EACE,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;AtIqiyBF;;AsIniyBA;EACE,mBAAA;AtIsiyBF;;AsIpiyBA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;AtIuiyBF;;AsIriyBA;EACE,qB/HnGU;E+HoGV,mBAAA;AtIwiyBF;;AsItiyBA;EACE,gBAAA;AtIyiyBF;;AsIviyBA;EACE,yCAAA;EACA,qCAAA;EACA,c/H5EY;APsnyBd;;AsIxiyBA;EACE,qCAAA;AtI2iyBF;;AsIziyBA;EACE,cAAA;AtI4iyBF;;AsI1iyBA;EACE,aAAA;AtI6iyBF;;AsI3iyBA;EACE,cAAA;AtI8iyBF;;AsI5iyBA;EACE,wCAAA;EACA,oCAAA;EACA,c/H7FY;AP4oyBd;;AsI7iyBA;EACE,oCAAA;AtIgjyBF;;AsI9iyBA;EACE,cAAA;AtIijyBF;;AsI/iyBA;EACE,aAAA;AtIkjyBF;;AsIhjyBA;EACE,cAAA;AtImjyBF;;AsIjjyBA;EACE,sCAAA;EACA,kCAAA;EACA,c/H9GY;APkqyBd;;AsIljyBA;EACE,kCAAA;AtIqjyBF;;AsInjyBA;EACE,WAAA;AtIsjyBF;;AsIpjyBA;EACE,UAAA;AtIujyBF;;AsIrjyBA;EACE,WAAA;AtIwjyBF;;AsItjyBA;EACE,yCAAA;EACA,qCAAA;EACA,c/H/HY;APwryBd;;AsIvjyBA;EACE,qCAAA;AtI0jyBF;;AsIxjyBA;EACE,cAAA;AtI2jyBF;;AsIzjyBA;EACE,aAAA;AtI4jyBF;;AsI1jyBA;EACE,cAAA;AtI6jyBF;;AsI3jyBA;;EAEE,aAAA;AtI8jyBF;;AsI5jyBA;EAEI,gBAAA;AtI8jyBJ;;AsIxjyBA;EAEI,iBAAA;AtI0jyBJ;;AsIpjyBA;EAEI,wBAAA;AtIsjyBJ;;AsIhjyBA;EAEI,sBAAA;EACA,iBAAA;AtIkjyBJ;;AsI1iyBA;EACE,aAAA;EACA,cAAA;AtI6iyBF;;AsI3iyBA;EACE,aAAA;EACA,cAAA;AtI8iyBF;;AsI5iyBA;EACE,yBAAA;EACA,sBAAA;EACA,wBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,SAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,0BAAA;EACA,mBAAA;AtI+iyBF;;AsI7iyBA;EACE,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,+BAAA;EACA,mBAAA;AtIgjyBF;;AsI9iyBA;EACE,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;AtIijyBF;;AsI/iyBA;EACE,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;AtIkjyBF;;AsIhjyBA;EACE,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;AtImjyBF;;AsIjjyBA;EACE,yBAAA;EACA,sBAAA;EACA,wBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,c/H9PY;E+H+PZ,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,aAAA;EACA,iBAAA;EACA,qBAAA;EACA,0BAAA;AtIojyBF;;AsIljyBA;EACE,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,8BAAA;AtIqjyBF;;AsInjyBA;EACE,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,c/HpRY;AP00yBd;;AsIpjyBA;EACE,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,c/H3RY;APk1yBd;;AsIrjyBA;EACE,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,c/HlSY;AP01yBd;;AsItjyBA;;;EAGE,YAAA;AtIyjyBF;;AsIvjyBA;;;EAGE,cAAA;EACA,kBAAA;AtI0jyBF;;AsIxjyBA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AtI2jyBF;;AsIzjyBA;EACE,eAAA;AtI4jyBF;;AsI1jyBA;EACE,6BAAA;EACA,yBAAA;EACA,iBAAA;EACA,c/HnUY;APg4yBd;;AsI3jyBA;EACE,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,8BAAA;AtI8jyBF;;AsI5jyBA;EACE,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,c/H/UY;AP84yBd;;AsI7jyBA;EACE,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,c/HrVY;APq5yBd;;AsI9jyBA;EACE,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,c/H3VY;AP45yBd;;AsI/jyBA;EACE,kBAAA;AtIkkyBF;;AsIhkyBA;EACE,c/HjWY;APo6yBd;;AsIjkyBA;EACE,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;AtIokyBF;;AsIlkyBA;EACE,iDAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AtIqkyBF;;AsInkyBA;EACE,mBAAA;EACA,kBAAA;EACA,iCAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AtIskyBF;;AsIpkyBA;EACE,cAAA;EACA,2BAAA;AtIukyBF;;AsIrkyBA;EACE,aAAA;EACA,aAAA;AtIwkyBF;;AsItkyBA;EACE,aAAA;EACA,aAAA;AtIykyBF;;AsIvkyBA;EACE,8BAAA;EACA,mBAAA;AtI0kyBF;;AsIxkyBA;EACE,6BAAA;AtI2kyBF;;AsIzkyBA;EACE,6BAAA;AtI4kyBF;;AsI1kyBA;EACE,6BAAA;AtI6kyBF;;AsI3kyBA;EACE,aAAA;AtI8kyBF;;AsI5kyBA;EACE,cAAA;AtI+kyBF;;AsI7kyBA;EACE,aAAA;AtIglyBF;;AsI9kyBA;EACE,cAAA;AtIilyBF;;AsI/kyBA;EACE,kBAAA;EACA,mCAAA;EACA,YAAA;AtIklyBF;;AsIhlyBA;EAEI,gBAAA;AtIklyBJ;;AsI5kyBA;EAEI,cAAA;AtI8kyBJ;;AsIxkyBA;EAEI,gBAAA;AtI0kyBJ;;AsIpkyBA;EACE,0DAAA;AtIukyBF;;AsIrkyBA;EACE,wBAAA;EACA,qBAAA;AtIwkyBF;;AsItkyBA;EACE,wBAAA;EACA,0BAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;AtIykyBF;;AsIvkyBA;EACE,iCAAA;EACA,gCAAA;EACA,+BAAA;EACA,gCAAA;EACA,8BAAA;EACA,gCAAA;EACA,yBAAA;AtI0kyBF;;AsIxkyBA;EACE,8BAAA;AtI2kyBF;;AsIzkyBA;EACE,oCAAA;EACA,uCAAA;EACA,0BAAA;EACA,0BAAA;EACA,6BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,2BAAA;EACA,+BAAA;EACA,sCAAA;EACA,oCAAA;EAGQ,4BAAA;AtI4kyBV;;AsI1kyBA;EACE,8BAAA;EACA,yBAAA;EACA,0BAAA;EACA,wBAAA;EACA,2BAAA;EACA,yBAAA;EAGQ,4BAAA;AtI6kyBV;;AsI3kyBA;EACE,2BAAA;AtI8kyBF;;AsI5kyBA;EACE,6BAAA;EACA,uBAAA;AtI+kyBF;;AsI7kyBA;EACE,6BAAA;EACA,uBAAA;AtIglyBF;;AsI9kyBA;EACE,iCAAA;EACA,yBAAA;AtIilyBF;;AsI/kyBA;EACE,oCAAA;AtIklyBF;;AsIhlyBA;EACE,oCAAA;EACA,yBAAA;AtImlyBF;;AsIjlyBA;EACE,oCAAA;AtIolyBF;;AsIllyBA;EACE,oCAAA;EACA,yBAAA;AtIqlyBF;;AsInlyBA;EACE,oCAAA;EACA,yBAAA;AtIslyBF;;AsIplyBA;EACE,yBAAA;AtIulyBF;;AsIrlyBA;EACE,yBAAA;AtIwlyBF;;AsItlyBA;EACE,wCAAA;EACA,yCAAA;EACA,8BAAA;AtIylyBF;;AsIvlyBA;;EAEE,8BAAA;EACA,wBAAA;EACA,uBAAA;EACA,kCAAA;EACA,sBAAA;AtI0lyBF;;AsIxlyBA;;EAEE,6BAAA;AtI2lyBF;;AsIzlyBA;EACE,uBAAA;EACA,sBAAA;AtI4lyBF;;AsI1lyBA;EACE,8BAAA;EACA,gCAAA;EACA,oBAAA;EACA,6BAAA;EACA,0BAAA;EACA,6BAAA;EACA,8BAAA;EACA,4BAAA;EACA,+BAAA;EACA,gCAAA;AtI6lyBF;;AsI3lyBA;EACE,uCAAA;EACA,gCAAA;EACA,0BAAA;EACA,uBAAA;EACA,4BAAA;EACA,+BAAA;AtI8lyBF;;AsI5lyBA;EACE,8BAAA;EACA,wBAAA;EACA,2BAAA;AtI+lyBF;;AsI7lyBA;EACE,sBAAA;EACA,uBAAA;EACA,8BAAA;AtIgmyBF;;AsI9lyBA;EACE,wBAAA;AtIimyBF;;AsI/lyBA;EACE,wBAAA;AtIkmyBF;;AsIhmyBA;EACE,wBAAA;AtImmyBF;;AsIjmyBA;EACE,iCAAA;EACA,oCAAA;EACA,6BAAA;EACA,oDAAA;EACA,wBAAA;EACA,yBAAA;EACA,yBAAA;EACA,4BAAA;EACA,2BAAA;EACA,2BAAA;EACA,qBAAA;AtIomyBF;;AsIlmyBA;EACE,8BAAA;EACA,wBAAA;EACA,4BAAA;EACA,oBAAA;EACA,yBAAA;AtIqmyBF;;AsInmyBA;EACE,uBAAA;EACA,8BAAA;EACA,yBAAA;AtIsmyBF;;AsIpmyBA;EACE,8BAAA;AtIumyBF;;AsIrmyBA;EAEI,2BAAA;AtIumyBJ;;AsIjmyBA;EAEI,0CAAA;AtImmyBJ;;AsI7lyBA;EAEI,2BAAA;AtI+lyBJ;;AsIzlyBA;EAEI,2BAAA;AtI2lyBJ;;AsIrlyBA;EAEI,4BAAA;EACA,4BAAA;AtIulyBJ;;AsIhlyBA;EAEI,4BAAA;AtIklyBJ;;AsI5kyBA;EACE,wBAAA;EACA,8BAAA;EACA,wBAAA;EACA,oBAAA;AtI+kyBF;;AsI7kyBA;EACE,sBAAA;EACA,aAAA;EACA,YAAA;AtIglyBF;;AsI9kyBA;EACE,YAAA;AtIilyBF;;AsI/kyBA;;EAEE,YAAA;AtIklyBF;;AsIhlyBA;EACE,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AtImlyBF;;AsIjlyBA;EACE,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AtIolyBF;;AsIllyBA;EACE,sBAAA;EACA,YAAA;EACA,WAAA;AtIqlyBF;;AsInlyBA;EACE,sIAAA;EACA,YAAA;EACA,WAAA;AtIslyBF;;AsIplyBA;;EAEE,WAAA;AtIulyBF;;AsIrlyBA;EACE,iBAAA;EACA,uBAAA;EACA,uBAAA;EACA,WAAA;EACA,WAAA;AtIwlyBF;;AsItlyBA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AtIylyBF;;AsIvlyBA;EACE,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,cAAA;AtI0lyBF;;AsIxlyBA;EACE,UAAA;AtI2lyBF;;AsIzlyBA;EACE,qEAAA;EACA,gCAAA;AtI4lyBF;;AsI1lyBA;EACE,uBAAA;EACA,YAAA;EACA,gBAAA;AtI6lyBF;;AsI3lyBA;EAEI,kBAAA;AtI6lyBJ;;AsIvlyBA;EAEI,kBAAA;AtIylyBJ;;AsInlyBA;EAEI,iBAAA;AtIqlyBJ;;AsI/kyBA;EAEI,mBAAA;AtIilyBJ;;AsI3kyBA;;;EAII,qBAAA;AtI6kyBJ;;AsIvkyBA;EACE,SAAA;EACA,cAAA;AtI0kyBF;;AsIxkyBA;EACE,aAAA;AtI2kyBF;;AsIzkyBA;EACE,YAAA;EACA,6CAAA;EACA,WAAA;AtI4kyBF;;AsI1kyBA;;EAEE,oDAAA;EACA,qBAAA;AtI6kyBF;;AsI3kyBA;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;AtI8kyBF;;AsI5kyBA;EACE,eAAA;AtI+kyBF;;AsI7kyBA;EACE,mBAAA;EACA,6BAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;AtIglyBF;;AsI9kyBA;EACE,YAAA;EACA,WAAA;AtIilyBF;;AsI/kyBA;EACE,mB/H52BU;AP87zBZ;;AsIhlyBA;EAEI,iBAAA;AtIklyBJ;;AsI5kyBA;EACE,gBAAA;EACA,kBAAA;AtI+kyBF;;AsI7kyBA;EACE,eAAA;AtIglyBF;;AsI9kyBA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,6CAAA;EACA,yBAAA;EACA,kBAAA;AtIilyBF;;AsI/kyBA;EACE,mBAAA;EACA,c/Ht2BY;E+Hu2BZ,aAAA;EACA,8BAAA;AtIklyBF;;AsIhlyBA;EACE,4BAAA;EACA,eAAA;AtImlyBF;;AsIjlyBA;EACE,c/H/2BY;E+Hg3BZ,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;AtIolyBF;;AsIllyBA;EACE,YAAA;EACA,mBAAA;EACA,WAAA;AtIqlyBF;;AsInlyBA;EACE,gBAAA;AtIslyBF;;AsIplyBA;EACE,4BAAA;EACA,eAAA;EACA,kBAAA;AtIulyBF;;AsIrlyBA;EACE,SAAA;AtIwlyBF;;AsItlyBA;EACE,iBAAA;EACA,kBAAA;AtIylyBF;;AsIvlyBA;EACE,gBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,OAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;AtI0lyBF;;AsIxlyBA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;AtI2lyBF;;AsIzlyBA;EACE,kBAAA;EACA,WAAA;AtI4lyBF;;AsI1lyBA;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AtI6lyBF;;AsI3lyBA;EACE,yDAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AtI8lyBF;;AsI5lyBA;EACE,gBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,OAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;AtI+lyBF;;AsI7lyBA;EACE,mBAAA;EACA,c/Hn8BY;E+Ho8BZ,aAAA;EACA,sBAAA;EACA,kBAAA;AtIgmyBF;;AsI9lyBA;EACE,oBAAA;AtIimyBF;;AsI/lyBA;EACE,SAAA;EACA,sBAAA;EACA,eAAA;EACA,OAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;AtIkmyBF;;AsIhmyBA;EACE,sBAAA;EACA,4BAAA;EACA,c/Hz9BY;E+H09BZ,kBAAA;AtImmyBF;;AsIjmyBA;EACE,gBAAA;AtIomyBF;;AsIlmyBA;EACE,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;AtIqmyBF;;AsInmyBA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,cAAA;AtIsmyBF;;AsIpmyBA;EACE,WAAA;AtIumyBF;;AsIrmyBA;EAEI,gBAAA;AtIumyBJ;;AsIjmyBA;;;EAII,gBAAA;AtImmyBJ;;AsI7lyBA;EACE,mBAAA;EACA,aAAA;AtIgmyBF;;AsI9lyBA;EACE,2BAAA;AtIimyBF;;AsI/lyBA;EACE,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;AtIkmyBF;;AsIhmyBA;EAEI,iBAAA;AtIkmyBJ;;AsI5lyBA;EAEI,gBAAA;AtI8lyBJ;;AsIxlyBA;EACE,mBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,OAAA;EACA,eAAA;EACA,QAAA;EACA,MAAA;EACA,aAAA;AtI2lyBF;;AsIzlyBA;EACE,2CAAA;EACA,SAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;AtI4lyBF;;AsI1lyBA;EACE,sBAAA;AtI6lyBF;;AsI3lyBA;EACE,sBAAA;EACA,qB/H7lCU;E+H8lCV,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yFAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AtI8lyBF;;AsI5lyBA;EACE;IACE,sBAAA;IACA,gBAAA;IACA,yBAAA;EtI+lyBF;AACF;AsI7lyBA;EACE,aAAA;AtI+lyBF;;AsI7lyBA;EACE,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,c/HzlCY;E+H0lCZ,aAAA;EACA,eAAA;EACA,8BAAA;EACA,wBAAA;EACA,kBAAA;AtIgmyBF;;AsI9lyBA;EACE,UAAA;AtIimyBF;;AsI/lyBA;EACE,YAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;AtIkmyBF;;AsIhmyBA;EACE,gBAAA;AtImmyBF;;AsIjmyBA;EACE,iBAAA;AtIomyBF;;AsIlmyBA;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,oBAAA;AtIqmyBF;;AsInmyBA;EACE,c/H1nCY;E+H2nCZ,aAAA;EACA,SAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,oBAAA;AtIsmyBF;;AsIpmyBA;EACE;IACE,sBAAA;EtIumyBF;AACF;AsIrmyBA;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AtIumyBF;;AsIrmyBA;EACE;IACE,mBAAA;IACA,iCAAA;IACA,gBAAA;IACA,iBAAA;EtIwmyBF;AACF;AsItmyBA;EACE,oCAAA;EACA,4BAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;AtIwmyBF;;AsItmyBA;EACE,yCAAA;AtIymyBF;;AsIvmyBA;EACE,gCAAA;EACA,cAAA;AtI0myBF;;AsIxmyBA;EACE,sBAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;EACA,6BAAA;EACA,iBAAA;EACA,cAAA;EACA,iCAAA;EACA,kBAAA;AtI2myBF;;AsIzmyBA;EACE,gBAAA;EACA,gBAAA;AtI4myBF;;AsI1myBA;EACE,aAAA;AtI6myBF;;AsI3myBA;EACE,gBAAA;AtI8myBF;;AsI5myBA;EACE,gBAAA;EACA,aAAA;AtI+myBF;;AsI7myBA;EACE,cAAA;EACA,eAAA;EACA,qBAAA;AtIgnyBF;;AsI9myBA;;EAEE,cAAA;EACA,qBAAA;AtIinyBF;;AsI/myBA;EACE,cAAA;EACA,qBAAA;AtIknyBF;;AsIhnyBA;EACE,a/HltCY;APq00Bd;;AsIjnyBA;EACE,cAAA;EACA,qBAAA;EACA,mBAAA;EAEQ,oBAAA;EAEA,sBAAA;EAEA,4BAAA;AtIonyBV;;AsIlnyBA;EACE,c/HhuCY;E+HiuCZ,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;AtIqnyBF;;AsInnyBA;EACE,c/H1uCY;E+H2uCZ,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;AtIsnyBF;;AsIpnyBA;EACE,mBAAA;AtIunyBF;;AsIrnyBA;;;EAGE,aAAA;AtIwnyBF;;AsItnyBA;;;EAGE,gBAAA;AtIynyBF;;AsIvnyBA;;;EAGE,gBAAA;EACA,aAAA;AtI0nyBF;;AsIxnyBA;EACE,aAAA;EACA,iBAAA;AtI2nyBF;;AsIznyBA;EACE,gBAAA;AtI4nyBF;;AsI1nyBA;EACE,cAAA;AtI6nyBF;;AsI3nyBA;EACE,kBAAA;AtI8nyBF;;AsI5nyBA;EACE,mBAAA;EACA,sBAAA;EACA,6BAAA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;AtI+nyBF;;AsI7nyBA;;EAEE,aAAA;AtIgoyBF;;AsI9nyBA;EACE,mBAAA;EACA,2CAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;AtIioyBF;;AsI/nyBA;EACE,yBAAA;EACA,WAAA;AtIkoyBF;;AsIhoyBA;EACE,iBAAA;EACA,mBAAA;AtImoyBF;;AsIjoyBA;EACE,gCAAA;AtIooyBF;;AsIloyBA;EACE,mBAAA;AtIqoyBF;;AsInoyBA;EACE,mBAAA;EACA,gBAAA;AtIsoyBF;;AsIpoyBA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;AtIuoyBF;;AsIroyBA;EACE,aAAA;EACA,SAAA;EACA,sBAAA;EACA,6BAAA;AtIwoyBF;;AsItoyBA;EACE,aAAA;EACA,SAAA;EACA,6BAAA;AtIyoyBF;;AsIvoyBA;EACE,SAAA;EACA,6BAAA;EACA,YAAA;AtI0oyBF;;AsIxoyBA;EACE,UAAA;EACA,kBAAA;AtI2oyBF;;AsIzoyBA;EACE,UAAA;EACA,mBAAA;AtI4oyBF;;AsI1oyBA;EACE,wDAAA;AtI6oyBF;;AsI3oyBA;EACE,oBAAA;AtI8oyBF;;AsI5oyBA;EACE,gBAAA;AtI+oyBF;;AsI7oyBA;EACE,4BAAA;AtIgpyBF;;AsI9oyBA;EACE,0BAAA;AtIipyBF;;AsI/oyBA;EACE;IAEI,eAAA;EtIipyBJ;AACF;AsI3oyBA;EACE;IAEI,gBAAA;EtI4oyBJ;AACF;AsItoyBA;;EAGI,gBAAA;AtIuoyBJ;;AsIhoyBA;EACE,aAAA;EACA,SAAA;EACA,6BAAA;AtImoyBF;;AsIjoyBA;EACE,mBAAA;EACA,gBAAA;EACA,0BAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;EACA,iBAAA;EACA,aAAA;AtIooyBF;;AsIloyBA;EACE,4BAAA;EACA,kBAAA;AtIqoyBF;;AsInoyBA;EACE,aAAA;EACA,SAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;AtIsoyBF;;AsIpoyBA;EACE,sBAAA;EACA,SAAA;EACA,sBAAA;EACA,SAAA;EACA,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AtIuoyBF;;AsIroyBA;EACE,kBAAA;AtIwoyBF;;AsItoyBA;EACE,0BAAA;AtIyoyBF;;AsIvoyBA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;AtI0oyBF;;AsIxoyBA;EACE,UAAA;AtI2oyBF;;AsIzoyBA;EACE,gBAAA;EACA,2BAAA;AtI4oyBF;;AsI1oyBA;;EAEE,mBAAA;AtI6oyBF;;AsI3oyBA;EACE,8CAAA;AtI8oyBF;;AsI5oyBA;EACE,UAAA;EACA,kBAAA;AtI+oyBF;;AsI7oyBA;EACE,UAAA;EACA,mBAAA;AtIgpyBF;;AsI9oyBA;EACE,0DAAA;AtIipyBF;;AsI/oyBA;EACE,oBAAA;AtIkpyBF;;AsIhpyBA;EACE,SAAA;EACA,kBAAA;AtImpyBF;;AsIjpyBA;;;EAGE,aAAA;AtIopyBF;;AsIlpyBA;EACE,cAAA;AtIqpyBF;;AsInpyBA;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;AtIspyBF;;AsIppyBA;EACE,UAAA;AtIupyBF;;AsIrpyBA;EACE,YAAA;AtIwpyBF;;AsItpyBA;EACE,WAAA;AtIypyBF;;AsIvpyBA;;;EAII,mBAAA;AtIypyBJ;;AsInpyBA;EAEI,UAAA;AtIqpyBJ;;AsI/oyBA;EACE,eAAA;AtIkpyBF;;AsIhpyBA;EACE,eAAA;AtImpyBF;;AsIjpyBA;EACE,iBAAA;AtIopyBF;;AsIlpyBA;EACE,aAAA;EACA,kBAAA;EACA,UAAA;AtIqpyBF;;AsInpyBA;EACE,WAAA;AtIspyBF;;AsIppyBA;EACE,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;AtIupyBF;;AsIrpyBA;;EAEE,qBAAA;EACA,eAAA;AtIwpyBF;;AsItpyBA;EACE,0RAAA;EACA,iDAAA;EACA,0BAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AtIypyBF;;AsIvpyBA;EACE,mBAAA;AtI0pyBF;;AsIxpyBA;EAEI,kBAAA;AtI0pyBJ;;AsIppyBA;EAEI,SAAA;AtIspyBJ;;AsIhpyBA;;EAEE,4BAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;AtImpyBF;;AsIjpyBA;EACE,cAAA;AtIopyBF;;AsIlpyBA;EAEI,kBAAA;AtIopyBJ;;AsI9oyBA;EACE,aAAA;EACA,SAAA;EACA,sBAAA;EACA,6BAAA;AtIipyBF;;AsI/oyBA;EACE,sBAAA;EACA,kBAAA;AtIkpyBF;;AsIhpyBA;EACE,SAAA;AtImpyBF;;AsIjpyBA;EACE,WAAA;AtIopyBF;;AsIlpyBA;EACE,aAAA;AtIqpyBF;;AsInpyBA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;AtIspyBF;;AsIppyBA;EACE,sBAAA;AtIupyBF;;AsIrpyBA;EACE,iCAAA;AtIwpyBF;;AsItpyBA;EACE,sBAAA;AtIypyBF;;AsIvpyBA;EACE,mBAAA;EACA,aAAA;AtI0pyBF;;AsIxpyBA;EACE,mBAAA;EACA,aAAA;AtI2pyBF;;AsIzpyBA;EACE,aAAA;EACA,SAAA;EACA,sBAAA;EACA,6BAAA;AtI4pyBF;;AsI1pyBA;EACE,SAAA;EACA,6BAAA;AtI6pyBF;;AsI3pyBA;EACE,aAAA;EACA,SAAA;EACA,6BAAA;AtI8pyBF;;AsI5pyBA;EACE,SAAA;EACA,6BAAA;EACA,YAAA;AtI+pyBF;;AsI7pyBA;EAEI,gBAAA;AtI+pyBJ;;AsIxpyBA;;EAEE,aAAA;AtI2pyBF;;AsIzpyBA;;;EAKU,gBAAA;EACR,sBAAA;EACA,qB/H9sDU;E+H+sDV,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,c/HprDY;E+HqrDZ,eAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AtI4pyBF;;AsI1pyBA;;EAEE,yBAAA;EACA,6BAAA;EACA,mBAAA;AtI6pyBF;;AsI3pyBA;;EAEE,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,aAAA;AtI8pyBF;;AsI5pyBA;EACE,eAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AtI+pyBF;;AsI7pyBA;EACE,6BAAA;EACA,SAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;AtIgqyBF;;AsI9pyBA;EACE,cAAA;EACA,a/H9tDY;AP+31Bd;;AsI/pyBA;EAEI,gBAAA;AtIiqyBJ;;AsI3pyBA;EACE,eAAA;EACA,kBAAA;AtI8pyBF;;AsI5pyBA;EAGU,gBAAA;EACR,sBAAA;EACA,qB/HjxDU;E+HkxDV,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,c/HvvDY;E+HwvDZ,eAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AtI+pyBF;;AsI7pyBA;EACE,yBAAA;EACA,6BAAA;EACA,mBAAA;AtIgqyBF;;AsI9pyBA;EACE,aAAA;AtIiqyBF;;AsI/pyBA;EACE,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,aAAA;AtIkqyBF;;AsIhqyBA;EACE,oBAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;AtImqyBF;;AsIjqyBA;;EAGI,mBAAA;AtImqyBJ;;AsI7pyBA;EAEI,UAAA;AtI+pyBJ;;AsIzpyBA;EAGU,oBAAA;EACR,qBAAA;AtI4pyBF;;AsI1pyBA;EACE,SAAA;EACA,YAAA;EACA,OAAA;EACA,SAAA;EACA,gBAAA;EAEI,yBAAA;EACJ,UAAA;EACA,eAAA;EACA,MAAA;EACA,wBAAA;EACA,WAAA;AtI6pyBF;;AsI3pyBA;EACE,aAAA;AtI8pyBF;;AsI5pyBA;EACE,aAAA;AtI+pyBF;;AsI7pyBA;EACE,aAAA;AtIgqyBF;;AsI9pyBA;EACE,gBAAA;EACA,eAAA;AtIiqyBF;;AsI/pyBA;EACE,WAAA;AtIkqyBF;;AsIhqyBA;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;AtImqyBF;;AsIjqyBA;EACE,sBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;AtIoqyBF;;AsIlqyBA;;EAEE,eAAA;AtIqqyBF;;AsInqyBA;EACE,oDAAA;AtIsqyBF;;AsIpqyBA;EACE,SAAA;EACA,6BAAA;AtIuqyBF;;AsIrqyBA;EACE,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;AtIwqyBF;;AsItqyBA;EACE,uBAAA;EACA,YAAA;EAEE,OAAA;EAKF,kBAAA;EACA,MAAA;EACA,WAAA;AtIoqyBF;;AsIlqyBA;EACE,SAAA;EACA,YAAA;EACA,kBAAA;AtIqqyBF;;AsInqyBA;EACE,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,UAAA;AtIsqyBF;;AsIpqyBA;EACE,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,UAAA;AtIuqyBF;;AsIrqyBA;EACE,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,wBAAA;EACA,UAAA;AtIwqyBF;;AsItqyBA;EACE,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,uBAAA;EACA,UAAA;AtIyqyBF;;AsIvqyBA;EAEI,gBAAA;AtIyqyBJ;;AsInqyBA;EAEI,iBAAA;AtIqqyBJ;;AsI/pyBA;EAEI,iBAAA;AtIiqyBJ;;AsI3pyBA;EACE,aAAA;EACA,eAAA;EACA,YAAA;AtI8pyBF;;AsI5pyBA;EACE,qB/Hp9DU;E+Hq9DV,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;AtI+pyBF;;AsI7pyBA;EACE,cAAA;AtIgqyBF;;AsI9pyBA;EACE,yCAAA;EACA,qCAAA;AtIiqyBF;;AsI/pyBA;EACE,4BAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AtIkqyBF;;AsI/pyBA;EAEI,eAAA;AtIiqyBJ;;AsI3pyBA;EACE,sBAAA;EACA,qBAAA;AtI8pyBF;;AsI5pyBA;EACE,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,6CAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;AtI+pyBF;;AsI7pyBA;EACE,UAAA;AtIgqyBF;;AsI9pyBA;EACE,YAAA;AtIiqyBF;;AsI/pyBA;EACE,YAAA;AtIkqyBF;;AsIhqyBA;;;;;;;;;EASE,SAAA;AtImqyBF;;AsIjqyBA;EACE,2BAAA;EACA,wBAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,+BAAA;EACA,gCAAA;AtIoqyBF;;AsIlqyBA;EACE,wCAAA;AtIqqyBF;;AsIlqyBE;EACE,qCAAA;AtIqqyBJ;AsInqyBE;EACE,iCAAA;AtIqqyBJ;;AsIlqyBA,6CAAA;AACA;EACE,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,c/HhhEY;E+HihEZ,aAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,WAAA;AtIqqyBF;;AsInqyBA;EACE,6BAAA;EACA,SAAA;EACA,gBAAA;EACA,8BAAA;EACA,mBAAA;AtIsqyBF;;AsIpqyBA;EACE,mB/HxkEU;E+HykEV,SAAA;EACA,gBAAA;EACA,c/H1iEY;APit2Bd;;AsIrqyBA;EACE,mB/H9kEU;E+H+kEV,SAAA;EACA,gBAAA;EACA,c/HhjEY;APwt2Bd;;AsItqyBA;EACE,mB/HplEU;E+HqlEV,SAAA;EACA,gBAAA;EACA,c/HtjEY;AP+t2Bd;;AsIvqyBA;EACE,eAAA;EACA,mBAAA;EACA,aAAA;AtI0qyBF;;AsIxqyBA;EACE,mBAAA;AtI2qyBF;;AsIzqyBA;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;AtI4qyBF;;AsI1qyBA;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EAEA,aAAA;EACA,eAAA;EACA,mBAAA;EAEI,+DAAA;EACJ,eAAA;EACA,UAAA;EACA,YAAA;EACA,0DAAA;AtI6qyBF;;AsI3qyBA;EACE,eAAA;EACA,mBAAA;AtI8qyBF;;AsI5qyBA;EACE,0BAAA;AtI+qyBF;;AsI7qyBA;EACE,UAAA;AtIgryBF;;AsI9qyBA;EACE,yBAAA;EACA,qBAAA;EACA,c/HrmEY;APsx2Bd;;AsI/qyBA;EACE,c/HxmEY;AP0x2Bd;;AsIhryBA;EACE,cAAA;AtImryBF;;AsIjryBA;EACE,a/H9mEY;APky2Bd;;AsIlryBA;EACE,yBAAA;EACA,qBAAA;EACA,c/HnnEY;APwy2Bd;;AsInryBA;EACE,c/HtnEY;AP4y2Bd;;AsIpryBA;EACE,WAAA;AtIuryBF;;AsIrryBA;EACE,a/H5nEY;APoz2Bd;;AsItryBA;;EAEE,yBAAA;EACA,qBAAA;EACA,c/HloEY;AP2z2Bd;;AsIvryBA;;EAEE,c/HtoEY;APg02Bd;;AsIxryBA;;EAEE,c/H1oEY;APq02Bd;;AsIzryBA;;EAEE,a/H9oEY;AP002Bd;;AsI1ryBA;EACE,yBAAA;EACA,qBAAA;EACA,c/HnpEY;APg12Bd;;AsI3ryBA;EACE,c/HtpEY;APo12Bd;;AsI5ryBA;EACE,c/HzpEY;APw12Bd;;AsI7ryBA;EACE,a/H5pEY;AP412Bd;;AsI9ryBA;EAEM,kBAAA;EACJ,c/HjqEY;E+HkqEZ,eAAA;EACA,uBAAA;EACA,kBAAA;EAEI,oBAAA;EACJ,oBAAA;EACA,eAAA;EAEI,iBAAA;EACJ,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;AtIisyBF;;AsI/ryBA;EACE,SAAA;AtIksyBF;;AsIhsyBA;EACE,gBAAA;AtImsyBF;;AsIjsyBA;EAEM,kBAAA;EACJ,uBAAA;EACA,kBAAA;EAEI,oBAAA;EACJ,oBAAA;EACA,eAAA;EAEI,iBAAA;EAEA,iBAAA;AtIosyBN;;AsIlsyBA;EACE,cAAA;AtIqsyBF;;AsInsyBA;EAEM,iBAAA;EACJ,uBAAA;EACA,kBAAA;EAEI,oBAAA;EACJ,oBAAA;EACA,eAAA;EAEI,iBAAA;EAEA,iBAAA;AtIssyBN;;AsIpsyBA;EACE,uBAAA;EACA,kBAAA;EAEI,oBAAA;EACJ,oBAAA;EACA,eAAA;EAEI,iBAAA;EAEA,oBAAA;AtIusyBN;;AsIrsyBA;EACE,qBAAA;EACA,kBAAA;AtIwsyBF;;AsItsyBA;EACE,2BAAA;AtIysyBF;;AsIvsyBA;EACE,iBAAA;AtI0syBF;;AsIxsyBA;EACE,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;EACA,YAAA;EACA,gBAAA;AtI2syBF;;AsIzsyBA;EACE,uBAAA;AtI4syBF;;AsI1syBA;EACE,6BAAA;EACA,mBAAA;AtI6syBF;;AsI3syBA;;EAEE,mBAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;EACA,QAAA;AtI8syBF;;AsI5syBA;;EAEE,SAAA;EACA,SAAA;AtI+syBF;;AsI7syBA;EACE,sDAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AtIgtyBF;;AsI9syBA;EACE,yDAAA;EACA,iBAAA;EACA,iBAAA;AtIityBF;;AsI/syBA;;EAEE,SAAA;EACA,MAAA;EACA,4BAAA;AtIktyBF;;AsIhtyBA;EACE,sDAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AtImtyBF;;AsIjtyBA;EACE,yDAAA;EACA,iBAAA;EACA,iBAAA;AtIotyBF;;AsIltyBA;;EAEE,OAAA;EACA,oBAAA;EACA,2BAAA;AtIqtyBF;;AsIntyBA;EACE,sDAAA;EACA,iBAAA;EACA,kBAAA;AtIstyBF;;AsIptyBA;EACE,yDAAA;EACA,kBAAA;EACA,kBAAA;AtIutyBF;;AsIrtyBA;;EAEE,UAAA;EACA,oBAAA;EACA,2BAAA;AtIwtyBF;;AsIttyBA;EACE,sDAAA;EACA,iBAAA;EACA,iBAAA;AtIytyBF;;AsIvtyBA;EACE,yDAAA;EACA,kBAAA;EACA,iBAAA;AtI0tyBF;;AsIxtyBA;;EAEE,UAAA;AtI2tyBF;;AsIztyBA;;EAEE,uBAAA;AtI4tyBF;;AsI1tyBA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,0BAAA;EACA,aAAA;AtI6tyBF;;AsI3tyBA;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AtI8tyBF;;AsI5tyBA;EACE,aAAA;EACA,gBAAA;AtI+tyBF;;AsI7tyBA;EACE,aAAA;AtIguyBF;;AsI9tyBA;EACE,aAAA;AtIiuyBF;;AsI/tyBA;EACE,UAAA;AtIkuyBF;;AsIhuyBA;EACE,UAAA;AtImuyBF;;AsIjuyBA;;EAEE,8CAAA;AtIouyBF;;AsIluyBA;EACE,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AtIquyBF;;AsInuyBA;EACE,YAAA;EACA,WAAA;AtIsuyBF;;AsIpuyBA;EACE,mBAAA;EACA,aAAA;EACA,SAAA;EACA,6BAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;AtIuuyBF;;AsIruyBA;EACE,6BAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;AtIwuyBF;;AsItuyBA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,QAAA;EACA,4CAAA;EACA,WAAA;AtIyuyBF;;AsIvuyBA;EACE,cAAA;AtI0uyBF;;AsIxuyBA;EACE,aAAA;AtI2uyBF;;AsIzuyBA;EACE,8DAAA;EACA,uCAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;AtI4uyBF;;AsI1uyBA;EACE,uBAAA;AtI6uyBF;;AsI3uyBA;EACE,uBAAA;AtI8uyBF;;AsI5uyBA;EACE;IAGE,mBAAA;EtI6uyBF;EsI3uyBA;IACE,mBAAA;EtI6uyBF;AACF;AsI3uyBA;EAEI,gBAAA;AtI4uyBJ;;AsItuyBA;EACE,8BAAA;EACA,iCAAA;EACA,wCAAA;EACA,uCAAA;EACA,wBAAA;EACA,yBAAA;EACA,0BAAA;EACA,8BAAA;EACA,uBAAA;EACA,2BAAA;EACA,yBAAA;EACA,6BAAA;EACA,oCAAA;AtIyuyBF;;AsIvuyBA;EACE,wBAAA;EACA,yBAAA;EACA,oCAAA;EACA,2BAAA;AtI0uyBF;;AsIxuyBA;EACE,wBAAA;EACA,yBAAA;EACA,6BAAA;EACA,2BAAA;EACA,kCAAA;EACA,8BAAA;AtI2uyBF;;AsIzuyBA;EACE,0BAAA;EACA,8BAAA;AtI4uyBF;;AsI1uyBA;EACE,cAAA;EACA,gBAAA;AtI6uyBF;;AsI3uyBA;;;EAGE,uCAAA;EACA,gCAAA;AtI8uyBF;;AsI5uyBA;;;;;;EAME,eAAA;EACA,0BAAA;AtI+uyBF;;AsI7uyBA;EACE,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AtIgvyBF;;AsI9uyBA;EACE,yBAAA;EACA,2BAAA;AtIivyBF;;AsI/uyBA;EAEI,iBAAA;AtIivyBJ;;AsIpuyBA;EACE,aAAA;AtIuuyBF;;AsIruyBA;EACE,mBAAA;EACA,0CAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;AtIwuyBF;;AsItuyBA;EACE,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,c/HpiFY;E+HqiFZ,aAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,oBAAA;EACA,WAAA;AtIyuyBF;;AsIvuyBA;EACE,cAAA;EACA,a/HrjFY;AP+x3Bd;;AsIxuyBA;EACE,iBAAA;EACA,kBAAA;EACA,cAAA;AtI2uyBF;;AsIzuyBA;EACE,mB/H9lFU;E+H+lFV,SAAA;EACA,gBAAA;AtI4uyBF;;AsI1uyBA;EACE,mB/HnmFU;E+HomFV,SAAA;EACA,gBAAA;EACA,c/HrkFY;APkz3Bd;;AsI3uyBA;EACE,a/HxkFY;APsz3Bd;;AsI5uyBA;EACE,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,c/H9kFY;AP6z3Bd;;AsI7uyBA;EACE,a/HjlFY;APi03Bd;;AsI9uyBA;;;;EAIE,uBAAA;EACA,SAAA;EACA,gBAAA;EACA,8BAAA;EACA,mBAAA;AtIivyBF;;AsI/uyBA;;;;EAIE,qDAAA;EACA,6BAAA;AtIkvyBF;;AsIhvyBA;;EAEE,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,c/HzmFY;AP413Bd;;AsIjvyBA;;EAEE,eAAA;AtIovyBF;;AsIlvyBA;;EAEE,qDAAA;EACA,a/HlnFY;APu23Bd;;AsInvyBA;EACE,c/HrnFY;AP223Bd;;AsIpvyBA;EACE,a/HxnFY;AP+23Bd;;AsIrvyBA;EACE,eAAA;AtIwvyBF;;AsItvyBA;EACE,YAAA;EACA,WAAA;AtIyvyBF;;AsIvvyBA;EACE,sBAAA;EACA,YAAA;EACA,WAAA;AtI0vyBF;;AsIxvyBA;EAEM,mBAAA;EACJ,aAAA;EACA,WAAA;AtI2vyBF;;AsIzvyBA;EACE,cAAA;EACA,YAAA;AtI4vyBF;;AsI1vyBA;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,wBAAA;EACA,kBAAA;EACA,mBAAA;AtI6vyBF;;AsI3vyBA;EACE,mBAAA;EACA,cAAA;EACA,WAAA;AtI8vyBF;;AsI5vyBA;EACE,eAAA;EACA,mBAAA;EACA,aAAA;AtI+vyBF;;AsI7vyBA;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AtIgwyBF;;AsI9vyBA;EACE,6BAAA;AtIiwyBF;;AsI/vyBA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AtIkwyBF;;AsIhwyBA;EACE,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AtImwyBF;;AsIjwyBA;EACE,mCAAA;AtIowyBF;;AsIlwyBA;EACE,mB/H9tFU;E+H+tFV,gBAAA;EACA,c/H/rFY;APo83Bd;;AsInwyBA;EACE,gBAAA;AtIswyBF;;AsIpwyBA;EACE,WAAA;AtIuwyBF;;AsIrwyBA;EACE,6BAAA;AtIwwyBF;;AsItwyBA;EACE,SAAA;AtIywyBF;;AsIvwyBA;EACE,WAAA;AtI0wyBF;;AsIxwyBA;EACE,WAAA;AtI2wyBF;;AsIzwyBA;;;;EAIE,uBAAA;EACA,gBAAA;EACA,8BAAA;AtI4wyBF;;AsI1wyBA;EACE,sBAAA;AtI6wyBF;;AsI3wyBA;;;EAGE,2BAAA;EACA,2CAAA;EACA,wBAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,uBAAA;AtI8wyBF;;AsI5wyBA;EACE,SAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AtI+wyBF;;AsI7wyBA;EACE,sDAAA;AtIgxyBF;;AsI9wyBA;EACE,iFAAA;AtIixyBF;;AsI/wyBA;;EAEE,wCAAA;EACA,2BAAA;AtIkxyBF;;AsIhxyBA;EACE,iBAAA;EACA,gBAAA;AtImxyBF;;AsIjxyBA;EACE,eAAA;AtIoxyBF;;AsIlxyBA;EACE,iCAAA;AtIqxyBF;;AsInxyBA;;EAEE,wCAAA;AtIsxyBF;;AsIpxyBA;EACE,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;AtIuxyBF;;AsIrxyBA;EACE,0BAAA;AtIwxyBF;;AsItxyBA;EACE,mBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,oBAAA;AtIyxyBF;;AsIvxyBA;EACE,iBAAA;AtI0xyBF;;AsIxxyBA;EACE,cAAA;EACA,iBAAA;AtI2xyBF;;AsIzxyBA;EAEI,+BAAA;AtI2xyBJ;;AsIrxyBA;EACE,qBAAA;EACA,YAAA;EACA,kBAAA;AtIwxyBF;;AsItxyBA;EACE,oCAAA;EACA,6BAAA;EACA,sDAAA;EACA,2CAAA;EACA,0BAAA;EACA,6BAAA;EACA,8BAAA;EACA,2BAAA;EACA,+BAAA;AtIyxyBF;;AsIvxyBA;EACE,kBAAA;AtI0xyBF;;AsIxxyBA;EACE,kCAAA;EACA,mCAAA;EACA,6BAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,2BAAA;AtI2xyBF;;AsIzxyBA;EACE,gCAAA;EACA,kCAAA;EACA,mCAAA;EACA,SAAA;EACA,kBAAA;EACA,MAAA;EACA,2BAAA;AtI4xyBF;;AsI1xyBA;EACE,oCAAA;EACA,8BAAA;EACA,iCAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;AtI6xyBF;;AsI3xyBA;EACE,oCAAA;EACA,+BAAA;EACA,iCAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;AtI8xyBF;;AsI5xyBA;EACE,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AtI+xyBF;;AsI7xyBA;EACE,aAAA;AtIgyyBF;;AsI9xyBA;EACE,gBAAA;AtIiyyBF;;AsI/xyBA;EACE,SAAA;AtIkyyBF;;AsIhyyBA;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;AtImyyBF;;AsIjyyBA,sBAAA;AACA;EACE,qBAAA;AtIoyyBF;;AsIlyyBA;EACE,oCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AtIqyyBF;;AsInyyBA;EACE,eAAA;AtIsyyBF;;AsIpyyBA;EACE,aAAA;EACA,SAAA;EACA,6BAAA;AtIuyyBF;;AsIryyBA;EACE,wBAAA;EACA,oBAAA;EACA,wCAAA;AtIwyyBF;;AsItyyBA;EACE,YAAA;AtIyyyBF;;AsIvyyBA;EACE,YAAA;AtI0yyBF;;AuIzu4BA;;;;;EAAA;AAMA,0BAAA;AACA;EACE,YAAA;EACA,cAAA;AvI4u4BF;;AuI1u4BA;EACE,SAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,wCAAA;EACA,+CAAA;EACA,iBAAA;EACA,mBAAA;AvI6u4BF;;AuI3u4BA;EACE,gBAAA;AvI8u4BF;;AuI5u4BA;EACE,gBAAA;AvI+u4BF;;AuI7u4BA;EACE,gBAAA;AvIgv4BF;;AuI9u4BA;EACE,gBAAA;AvIiv4BF;;AuI/u4BA;EACE,gBAAA;AvIkv4BF;;AuIhv4BA;EACE,gBAAA;AvImv4BF;;AuIjv4BA;EACE,gBAAA;AvIov4BF;;AuIlv4BA;EACE,gBAAA;AvIqv4BF;;AuInv4BA;EACE,gBAAA;AvIsv4BF;;AuIpv4BA;EACE,gBAAA;AvIuv4BF;;AuIrv4BA;EACE,gBAAA;AvIwv4BF;;AuItv4BA;EACE,gBAAA;AvIyv4BF;;AuIvv4BA;EACE,gBAAA;AvI0v4BF;;AuIxv4BA;EACE,gBAAA;AvI2v4BF;;AuIzv4BA;EACE,gBAAA;AvI4v4BF;;AuI1v4BA;EACE,gBAAA;AvI6v4BF;;AuI3v4BA;EACE,gBAAA;AvI8v4BF;;AuI5v4BA;EACE,gBAAA;AvI+v4BF;;AuI7v4BA;;EAEE,gBAAA;AvIgw4BF;;AuI9v4BA;EACE,gBAAA;AvIiw4BF;;AuI/v4BA;EACE,gBAAA;AvIkw4BF;;AuIhw4BA;EACE,gBAAA;AvImw4BF;;AuIjw4BA;EACE,gBAAA;AvIow4BF;;AuIlw4BA;;EAEE,gBAAA;AvIqw4BF;;AuInw4BA;EACE,gBAAA;AvIsw4BF;;AuIpw4BA;EACE,gBAAA;AvIuw4BF;;AuIrw4BA;;EAEE,uBAAA;EACA,cAAA;AvIww4BF;;AuItw4BA;EACE,gBAAA;AvIyw4BF;;AuIvw4BA;EACE,gBAAA;AvI0w4BF;;AuIxw4BA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;AvI2w4BF;;AuIzw4BA;EACE,aAAA;EACA,iBAAA;AvI4w4BF;;AuI1w4BA;EACE,aAAA;EACA,iBAAA;AvI6w4BF;;AuI3w4BA;EACE,aAAA;EACA,iBAAA;AvI8w4BF;;AuI5w4BA;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,iCAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;AvI+w4BF;;AuI7w4BA;EACE,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,8BAAA;AvIgx4BF;;AuI9w4BA;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;AvIix4BF;;AuI/w4BA;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,cAAA;AvIkx4BF;;AuIhx4BA;EACE;IACE,gBAAA;EvImx4BF;AACF;AuIjx4BA;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;AvImx4BF;;AuIjx4BA;EACE,gBAAA;EACA,yCAAA;AvIox4BF;;AuIlx4BA;EACE,UAAA;AvIqx4BF;;AuInx4BA;EACE,mBAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,OAAA;EACA,eAAA;EACA,QAAA;EACA,MAAA;AvIsx4BF;;AuIpx4BA;EACE,kBAAA;AvIux4BF;;AuIrx4BA;EACE,aAAA;EACA,YAAA;AvIwx4BF;;AuItx4BA;EACE,wBAAA;EACA,YAAA;EACA,uBAAA;AvIyx4BF;;AuIvx4BA;EACE,gBAAA;AvI0x4BF;;AuIxx4BA;EACE,gBAAA;AvI2x4BF;;AuIzx4BA;EACE,gBAAA;EACA,aAAA;EACA,cAAA;EACA,UAAA;AvI4x4BF;;AuI1x4BA;EACE,mBAAA;EACA,sBAAA;EACA,gCAAA;EACA,aAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;EACA,qEAAA;AvI6x4BF;;AuI3x4BA;EACE,mBAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;AvI8x4BF;;AuI5x4BA;EACE,mBAAA;EACA,aAAA;EACA,YAAA;EACA,SAAA;AvI+x4BF;;AuI7x4BA;EACE,mBAAA;AvIgy4BF;;AuI9x4BA;EACE,YAAA;AvIiy4BF;;AuI/x4BA;EACE,mBAAA;EACA,oBAAA;AvIky4BF;;AuIhy4BA;EACE,mBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;AvImy4BF;;AuIjy4BA;EACE,mBAAA;EACA,cAAA;AvIoy4BF;;AuIly4BA;;EAEE,mBAAA;EACA,cAAA;AvIqy4BF;;AuIny4BA;EACE,8GAAA;AvIsy4BF;;AuIpy4BA;EACE,mBAAA;EACA,aAAA;EACA,YAAA;EACA,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,8FAAA;EACA,6DAAA;AvIuy4BF;;AuIry4BA;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AvIwy4BF;;AuIty4BA;EACE,aAAA;EACA,YAAA;EACA,iDAAA;EACA,WAAA;AvIyy4BF;;AuIvy4BA;EACE,aAAA;EACA,cAAA;EACA,8BAAA;EACA,WAAA;AvI0y4BF;;AuIxy4BA;EACE,uBAAA;AvI2y4BF;;AuIzy4BA;EACE,aAAA;EACA,YAAA;EACA,kBAAA;AvI4y4BF;;AuI1y4BA;EAEM,kBAAA;EACJ,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AvI6y4BF;;AuI3y4BA;EACE,aAAA;AvI8y4BF;;AuI5y4BA;;EAEE,mBAAA;EACA,aAAA;AvI+y4BF;;AuI7y4BA;;EAEE,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;AvIgz4BF;;AuI9y4BA;;EAEE,kBAAA;AvIiz4BF;;AuI/y4BA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;AvIkz4BF;;AuIhz4BA;EACE,cAAA;AvImz4BF;;AuIjz4BA;;EAEE,kBAAA;EACA,mBAAA;AvIoz4BF;;AuIlz4BA;;EAEE,kBAAA;EACA,mBAAA;AvIqz4BF;;AuInz4BA;EACE,aAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AvIsz4BF;;AuIpz4BA;EACE,mBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;AvIuz4BF;;AuIrz4BA;EACE,mBAAA;EACA,aAAA;EACA,SAAA;EACA,aAAA;EACA,oBAAA;EACA,iBAAA;AvIwz4BF;;AuItz4BA;EACE,iBAAA;EACA,kBAAA;AvIyz4BF;;AuIvz4BA;EACE,mBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;AvI0z4BF;;AuIxz4BA;EACE,oOAAA;EACA,aAAA;EACA,SAAA;EACA,aAAA;EACA,oBAAA;EACA,iBAAA;AvI2z4BF;;AuIzz4BA;EACE,wBAAA;EACA,iBAAA;EACA,aAAA;EACA,oBAAA;EACA,iBAAA;EACA,YAAA;AvI4z4BF;;AuI1z4BA;EACE,wBAAA;EACA,iBAAA;EACA,aAAA;EACA,oBAAA;EACA,iBAAA;EACA,YAAA;AvI6z4BF;;AuI3z4BA;EACE;;;;KAAA;EAKA,mBAAA;EACA,4BAAA;EACA,yBAAA;EACA,0CAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,0DAAA;EACA,YAAA;AvI8z4BF;;AuI5z4BA;EACE,6CAAA;AvI+z4BF;;AuI7z4BA;;EAEE,mBAAA;EACA,aAAA;EACA,YAAA;EACA,SAAA;AvIg04BF;;AuI9z4BA;EACE,sBAAA;EACA,uBAAA;AvIi04BF;;AuI/z4BA;EACE,mBAAA;EACA,aAAA;AvIk04BF;;AuIh04BA;EACE,YAAA;AvIm04BF;;AuIj04BA;EACE,aAAA;AvIo04BF;;AuIl04BA;EACE,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;AvIq04BF;;AuI/z4BA;EACE,wBAAA;EACA,WAAA;AvIu04BF;;AuIr04BA,WAAA;AACA;EACE,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;AvIw04BF;;AuIt04BA;EACE,gCAAA;AvIy04BF;;AuIv04BA;EACE,+BAAA;AvI004BF;;AuIx04BA;EACE,YAAA;AvI204BF;;AuIz04BA;EACE,YAAA;AvI404BF;;AuI104BA,oDAAA;AACA;EACE,iBAAA;AvI604BF;;AuI304BA;EACE;IACE,iBAAA;EvI804BF;AACF;AuI504BA;EACE;IACE,iBAAA;EvI804BF;AACF;AuI504BA,gBAAA;AACA;EACE,uBAAA;EACA,wBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AvI804BF;;AuI504BA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AvI+04BF;;AuI704BA;EACE,sCAAA;AvIg14BF;;AuI904BA;EACE,6BAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AvIi14BF;;AuI/04BA;EACE,cAAA;EACA,gBAAA;EACA,yCAAA;AvIk14BF;;AuIh14BA;EACE,cAAA;EACA,gBAAA;EACA,yCAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AvIm14BF;;AuIj14BA;EACE,yCAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AvIo14BF;;AuIl14BA;;EAEE,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AvIq14BF;;AuIn14BA;;EAEE,2BAAA;AvIs14BF;;AuIp14BA;;EAEE,wBAAA;AvIu14BF;;AuIr14BA;;EAEE,0BAAA;AvIw14BF;;AuIt14BA;EACE,6BAAA;EACA,kBAAA;EACA,mBAAA;EACA,4DAAA;AvIy14BF;AuIv14BA;EACE;;IAEE,eAAA;EvIy14BF;AACF;AuIv14BA;EACE;;IAEE,eAAA;EvIy14BF;AACF;AuIv14BA;EACE,yCAAA;AvIy14BF;;AuIv14BA;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;AvI014BF;;AuIx14BA;EACE,mBAAA;EACA,aAAA;EACA,YAAA;AvI214BF;;AuIz14BA;EACE,sBAAA;EACA,WAAA;AvI414BF;;AuI114BA;EACE,qFAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;AvI614BF;;AuI314BA;EACE;IACE,gBAAA;EvI814BF;AACF;AuI514BA;EACE,aAAA;EACA,gBAAA;AvI814BF;;AuI514BA;EACE,YAAA;AvI+14BF;;AuI714BA;EACE,aAAA;AvIg24BF;;AuI914BA;;;EAAA;AAIA;EACE,aAAA;AvIi24BF;;AuI/14BA;EACE;IACE,WAAA;EvIk24BF;AACF;AwIhg6BA,+BAAA;AAEA;4BAC4B,oCAAA;EAC1B,mBAAA;AxIig6BF;;AwI9/5BA;EACE,yBAAA;EAGQ,iBAAA;EACR,2BAAA;EACA,6CAAA;AxIig6BF;;AwI//5BA;EACE,iCAAA;EACA,aAAA;EACA,sBAAA;EAEA,cAAA;AxIig6BF;;AwI//5BA;;;;EAII,sBAAA;AxIkg6BJ;;AwIhg6BA;EACI,yBAAA;EACA,iBAAA;EACA,cAAA,EAAA,4BAAA;AxImg6BJ;;AwIjg6BA;EACI,kBAAA;AxIog6BJ;;AwIlg6BA;;EAEI,mBAAA;EACA,UAAA;AxIqg6BJ;;AwIlg6BE;EACE,kBjI6Fa;APw65BjB;AwIpg6BI;EACE,sBAAA;AxIsg6BN;AwIpg6BI;EACE,wBAAA;AxIsg6BN;AwIjg6BM;EACE,wBAAA;AxImg6BR;AwIjg6BM;EACE,wBAAA;AxImg6BR;AwI7/5BM;EACE,wBAAA;AxI+/5BR;AwI7/5BM;EACE,wBAAA;AxI+/5BR;;AwI1/5BA;EACI,eAAA;AxI6/5BJ;;AwI3/5BA;EACI,0BAAA;AxI8/5BJ;;AwI5/5BA;EACE,cAAA;EACA,gBAAA;AxI+/5BF;;AwI7/5BA;EACE,cAAA;EACA,iBAAA;AxIgg6BF;;AwI9/5BA;;EAEI,sBAAA;EACA,8CAAA;AxIig6BJ;;AwI//5BA,0FAAA;AACA,sDAAA;AACA,+BAAA;AACA;;EAEI,kBAAA;AxIkg6BJ;;AwI//5BA;EACE,sBAAA;EACA,gEAAA;EACA,mBAAA;EACA,kBAAA;AxIkg6BF;AwI//5BA;EACE,iBAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EAGQ,iBAAA;EAER,+EAAA;EACA,iCAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;AxI+/5BF;;AwI5/5BA;EACE,gBAAA;AxI+/5BF;;AwI5/5BA;EACE,gBAAA;AxI+/5BF;;AwI5/5BA;EACE,gBAAA;AxI+/5BF;;AwI5/5BA;EACE,gBAAA;AxI+/5BF;;AwI5/5BA;EACE,gBAAA;AxI+/5BF;;AwI5/5BA;EACE,gBAAA;AxI+/5BF;;AwI5/5BA;EACE,gBAAA;AxI+/5BF;;AwI5/5BA;;;;;CAAA;AAMA;EAEE,UAAA;AxI8/5BF;;AwI3/5BA;EACI,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;AxI8/5BJ;;AwI5/5BA;EACI,mBAAA;EACA,0CAAA;AxI+/5BJ;;AwI7/5BA;EACI,0BAAA;AxIgg6BJ;;AwI9/5BA;EACI,eAAA;AxIig6BJ;;AwI//5BA;EACI,UAAA;EACA,kBAAA;AxIkg6BJ;;AwIhg6BA;EAEE,UAAA;AxIkg6BF;;AwI//5BA;EACI,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EAGQ,iBAAA;EACR,6BAAA;EACA,6BAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;AxIkg6BJ;;AwIhg6BA;EACI,qBAAA;AxImg6BJ;;AwIjg6BA;EACI,UAAA;EACA,+CAAA;AxIog6BJ;;AwIlg6BA;EACI,aAAA;AxIqg6BJ;;AwIng6BA;EAEE,uBAAA;AxIqg6BF;;AwIlg6BA;EACI,WAAA;EACA,wCAAA;EACA,yBAAA;EACA,oDAAA;EACA,qBAAA;EACA,oDAAA;AxIqg6BJ;;AwIng6BA;EACI,WAAA;EACA,wCAAA;EACA,yBAAA;EACA,0DAAA;EACA,qBAAA;EACA,0DAAA;AxIsg6BJ;;AwIpg6BA,kCAAA,YAAA;EACI,WAAA;EACA,wCAAA;EACA,yBAAA;EACA,oDAAA;EACA,qBAAA;EACA,oDAAA,EAAA,qBAAA;AxIug6BJ;;AwIrg6BA;EACI,+CAAA;AxIwg6BJ;;AwItg6BA;;EAEI,WAAA;EACA,wCAAA;EACA,yBAAA;EACA,2DAAA;EACA,qBAAA;EACA,2DAAA;AxIyg6BJ;;AwIvg6BA;;EAEI,+CAAA;AxI0g6BJ;;AwIxg6BA;EAEE,yBAAA;AxI0g6BF;;AwIvg6BA;EACI,sBAAA;EACA,gBAAA,EAAA,gGAAA;AxI0g6BJ;;AwIxg6BA;EACI,kBAAA;EACA,oBAAA;EACA,sBAAA;AxI2g6BJ;;AwIzg6BA;EACI,kBAAA;EACA,cAAA;AxI4g6BJ;;AwI1g6BA;EACI,UAAA;AxI6g6BJ;;AwI3g6BA;;;EAGI,UAAA;AxI8g6BJ;;AwI5g6BA;EACI,iBAAA;EACA,yBAAA;EACA,4BAAA;AxI+g6BJ;;AwI7g6BA;EACI,0BAAA;EACA,6BAAA;AxIgh6BJ;;AwI9g6BA;EACI,kBAAA;EACA,0BAAA;EACA,6BAAA;AxIih6BJ;;AwI/g6BA;EACI,yBAAA;EACA,4BAAA;AxIkh6BJ;;AwIhh6BA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AxImh6BJ;;AkBvw6BI;EsHuPA;IACE,sBAAA;ExIoh6BJ;AACF;AwIlh6BA;EACI,yBAAA;AxIoh6BJ;AwInh6BI;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AxIqh6BN;AwIph6BM;EACE,aAAA;AxIsh6BR;AwIph6BM;EACE,kBAAA;EACA,kCjI1Ka;EiI2Kb,gBjI/JK;EiIgKL,eAAA;EACA,uBAAA;EACA,cjIvSM;EiIwSN,yBAAA;EACA,0BAAA;AxIsh6BR;AwIrh6BQ;EACE,uBAAA;EACA,cjI5SI;EiI6SJ,yBAAA;AxIuh6BV;AwIrh6BQ;EACI,cjI/SE;EiIgTF,mBjIvUF;EiIwUE,yBAAA;AxIuh6BZ;AwIrh6BQ;EACI,iDAAA;AxIuh6BZ;AwIrh6BQ;EACI,cjIrTI;EiIsTJ,yBAAA;EACA,mBjIhVF;EiIiVE,wDAAA;AxIuh6BZ;AwIph6BM;EACE,uBAAA;AxIsh6BR;AwIrh6BQ;EACE,kCAAA;EACA,2BAAA;AxIuh6BV;;AkB5z6BI;EsH6SA;IACE,8BAAA;IACA,WAAA;ExImh6BJ;EwIlh6BI;IACE,6BAAA;IACA,eAAA;ExIoh6BN;EwInh6BM;IACE,cjIjVI;IiIkVJ,kBAAA;IACA,QAAA;IACA,SAAA;IACA,gCAAA;ExIqh6BR;EwIjh6BM;IACE,YAAA;ExImh6BR;EwI/g6BM;IACE,YAAA;ExIih6BR;EwI7g6BM;IACE,YAAA;ExI+g6BR;EwI3g6BM;IACE,YAAA;ExI6g6BR;EwIzg6BE;IACE,sBAAA;ExI2g6BJ;AACF;AwIvg6BA;EACI,iBAAA;AxIyg6BJ;;AwIvg6BA;EACI,mBAAA;EACA,SAAA;AxI0g6BJ;;AwIxg6BA;EACI,mBAAA,EAAA,kBAAA;AxI2g6BJ;;AwIzg6BA;EACI,oBAAA,EAAA,kBAAA;AxI4g6BJ;;AwI1g6BA,oCAAA,0EAAA;EACI,2BAAA;AxI6g6BJ;;AwI3g6BA;EACI,iCAAA;EACA,kBAAA,EAAA,uCAAA;AxI8g6BJ;;AwI5g6BA;EACI,YAAA;AxI+g6BJ;;AwI7g6BA;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;AxIgh6BJ;;AwI9g6BA;EACI,kBAAA;EACA,gBAAA;EACA,cAAA;EACE,uFAAA;EACA,iCAAA;AxIih6BN;;AwI/g6BA;EACI,YAAA;AxIkh6BJ;;AwIhh6BA,wDAAA,oBAAA;EACI,cAAA;AxImh6BJ;;AwIjh6BA;EACI,sBAAA;EACA,8CAAA,EAAA,+BAAA;AxIoh6BJ;;AwIlh6BA;2BAC+B,+BAAA;EACzB,WAAA,EAAA,0CAAA;EACA,mBAAA;AxIqh6BN;;AwInh6BA,2BAAA,iBAAA;EACM,wBAAA;EACA,yBAAA;EACA,0BAAA;AxIsh6BN;;AwIph6BA;EAEI,yBAAA;EACA,qBAAA;EACA,sBAAA;AxIsh6BJ;;AwInh6BA;EACI,YAAA;AxIsh6BJ;;AwIph6BA,6BAAA,WAAA;EACI,WAAA;AxIuh6BJ;;AwIph6BA;EACM,WAAA,EAAA,wEAAA;AxIuh6BN;;AwIrh6BA;EACM,WAAA;EACE,+FAAA;EACA,qCAAA;AxIwh6BR;;AwIth6BA;EACI,YAAA;AxIyh6BJ;;AwIth6BA;EACM,YAAA,EAAA,oCAAA;AxIyh6BN;;AwIvh6BA;EACI,mBAAA;EACA,oBAAA;AxI0h6BJ;;AwIxh6BA;;EAEI,sBAAA;AxI2h6BJ;;AwIzh6BA;;EAEI,2BAAA,EAAA,qCAAA;AxI4h6BJ;;AwI1h6BA;EAEE,eAAA;AxI4h6BF;;AwIzh6BA;EACI,gBAAA;EACA,yCAAA;EAEA,gBAAA;EACA,UAAA,EAAA,cAAA;EACA,mCAAA;AxI4h6BJ;;AwI1h6BA;EACI,MAAA,EAAA,mDAAA;EACE,kCAAA;AxI6h6BN;;AwI3h6BA;EACI,SAAA,EAAA,wDAAA;AxI8h6BJ;;AwI5h6BA,iCAAA,6BAAA;EACI,WAAA,EAAA,sCAAA;EACA,mBAAA;AxI+h6BJ;;AwI7h6BA,aAAA,8CAAA;EAEE,gBAAA;AxIgi6BF;;AwI9h6BA;EACI,YAAA,EAAA,qDAAA;EACA,kBAAA;AxIii6BJ;;AwI/h6BA;EAEE,+DAAA;AxIii6BF;;AwI9h6BA;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;AxIii6BJ;;AwI/h6BA;EACI,qBAAA,EAAA,uDAAA;EACA,gBAAA;AxIki6BJ;;AwIhi6BA;;;EAGI,qFAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AxImi6BJ;;AwIji6BA;EACI,oCAAA;EACA,kEAAA;AxIoi6BJ;;AwIli6BA;EACI,8BAAA;EACA,wDAAA;EACA,YAAA;EACA,wCAAA;AxIqi6BJ;;AwIni6BA;EACM,aAAA;EACA,iBAAA;EACA,4CAAA;EACA,kBAAA;AxIsi6BN;;AwIpi6BA;EACI,oCAAA;EACA,+DAAA;AxIui6BJ;;AwIri6BA;;EAEI,oCAAA;EACA,gEAAA;AxIwi6BJ;;AwIti6BA,gBAAA;AACA,yGAAA;AACA;EACE,0BAAA;EACA,uBAAA;AxIyi6BF;;AwIti6BA;;EAEE,qBAAA;AxIyi6BF;;AwIvi6BA,WAAA;AACA;;EAEE,eAAA;AxI0i6BF;;AwIxi6BA,uBAAA;AACA,yGAAA;AACA;EACI,kBAAA;EACA,UAAA;AxI2i6BJ;;AwIzi6BA,aAAA;AACA,yGAAA;AACA,6CAAA,UAAA;EACI,aAAA;AxI4i6BJ;;AwI1i6BA,uCAAA,UAAA;EACI,wCAAA;AxI6i6BJ;;AwI3i6BA,aAAA;AACA,yGAAA;AACA,iEAAA;AACA;EACI,aAAA;EACA,kBAAA;EACA,UAAA;AxI8i6BJ;;AwI5i6BA;qBACqB,UAAA,EAAA;;AAGrB;EACI,cAAA;AxI8i6BJ;;AwI5i6BA;EACI,kBAAA;EACA,qEAAA;EACA,iBAAA;EACA,2DAAA;EACA,UAAA;EACA,mDAAA;EACA,WAAA;EACA,oDAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,yCAAA;AxI+i6BJ;;AwI1i6BA;EACM,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AxI6i6BN;;AwI3i6BA,6BAAA;AACA,yGAAA;AACA;EACE,wCAAA;AxI8i6BF;;AwIzi6BA;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AxI4i6BJ;;AwI1i6BA;EAEE,kBAAA;AxI4i6BF;;AwIzi6BA;EACI,WAAA;EACA,+BAAA;EACA,uEAAA;EACA,kBAAA;EACA,UAAA;EAEA,uDAAA;EACA,0EAAA;EACA,0CAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AxI2i6BJ;;AwIzi6BA;;CAAA;AAGA,cAAA,4BAAA;EACE,cAAA;EACA,yBAAA;EACA,yBjIzoBkB;APqr7BpB;;AwIxi6BA;EACI,aAAA,EAAA,6CAAA;AxI2i6BJ;;AwIzi6BA;EACI,eAAA,EAAA,kCAAA;EACA,gBAAA;AxI4i6BJ;;AwI1i6BA,wCAAA,iDAAA;EACI,YAAA;EACA,cAAA;EACA,YAAA,EAAA,iDAAA;AxI6i6BJ;;AwI3i6BA;EACI,qBAAA,EAAA,yCAAA;EACA,mBAAA,EAAA,mCAAA;EACA,OAAA,EAAA,eAAA;EACA,QAAA,EAAA,eAAA;EACA,eAAA,EAAA,kCAAA;EACA,gBAAA;AxI8i6BJ;;AwI5i6BA;EACI,oBAAA;EACA,UAAA;EACA,aAAA;AxI+i6BJ;;AwI7i6BA,wEAAA;AACA;;EAEE,yBAAA;EACA,4BAAA;EACA,oBAAA;AxIgj6BF;;AwI9i6BA;;EAEE,0BAAA;EACA,6BAAA;EACA,qBAAA;AxIij6BF;;AwI/i6BA,aAAA;AACA;EACE,MAAA;EACA,SAAA;EACA,UAAA;EACA,6CAAA;AxIkj6BF;;AwIhj6BA;;EAEE,gBAAA;EACA,UAAA;EACA,uDAAA;AxImj6BF;;AwIjj6BA;;EAEE,gBAAA;EACA,WAAA;EACA,wDAAA;AxIoj6BF;;AwIlj6BA,uBAAA;AACA;EACE,QAAA;EACA,gBAAA;EACA,mEAAA;AxIqj6BF;;AwInj6BA;;EAEE,UAAA;EACA,6DAAA;AxIsj6BF;;AwIpj6BA;;EAEE,WAAA;EACA,8DAAA;AxIuj6BF;;AwInj6BA;EACE,iCAAA;AxIsj6BF;;AwIpj6BA;EACI,eAAA;EACA,MAAA,EAAA,gCAAA;EACA,yCAAA;AxIuj6BJ;;AwIrj6BA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AxIwj6BJ;;AwItj6BA;EACI,aAAA;AxIyj6BJ;;AwIvj6BA;EACI,eAAA;EACA,aAAA;EACA,gBAAA;AxI0j6BJ;;AwIxj6BA;EACI,sBAAA;EACA,8CAAA;EACA,gBAAA;EACA,yCAAA;AxI2j6BJ;;AwIzj6BA;EACI,oCAAA;EACA,gEAAA;AxI4j6BJ;;AwI1j6BA,+CAAA;AACA;;4BAE4B,iCAAA,EAAA;;AAE5B;EACE,WAAA;EACA,WAAA;EACA,cAAA;AxI6j6BF;;AwI5j6BA;EACE,WAAA;EACA,WAAA;EACA,cAAA;AxI+j6BF;;AwI9j6BA,uBAAA,iCAAA;EACI,kBAAA;EACA,UAAA,EAAA,wDAAA;AxIik6BJ;;AwI/j6BA;EACM,yCAAA;AxIkk6BN;;AwIhk6BA;EACI,kBAAA;EACA,gBAAA,EAAA,4FAAA;AxImk6BJ;;AwIjk6BA;EAEE,aAAA;AxImk6BF;;AwIhk6BA;EACI,aAAA;EACA,2BAAA;AxImk6BJ;;AwIjk6BA;EACI,YAAA;AxIok6BJ;;AwIlk6BA;EAEE,iCAAA;AxIok6BF;;AwIjk6BA;EACI,kBAAA;EACA,UAAA;EACA,YAAA;AxIok6BJ;;AwIlk6BA;EAEE,oBAAA;AxIok6BF;;AwIjk6BA;EACI,eAAA,EAAA,mFAAA;AxIok6BJ;;AwIlk6BA;EAEE,wCAAA;AxIok6BF;;AwIjk6BA;EACM,kBAAA;EACA,OAAA;EACA,QAAA;AxIok6BN;;AwIlk6BA;EACM,kBAAA,EAAA,kDAAA;EACA,eAAA,EAAA,gGAAA;AxIqk6BN;;AwInk6BA,+BAAA,iCAAA,EAAA;;AAEA;EACM,kBAAA;AxIsk6BN;;AwIpk6BA;EAEE,kBAAA;AxIsk6BF;;AwInk6BA;EACI,kBAAA;AxIsk6BJ;;AwIpk6BA;EACI,kBAAA;EACA,MAAA,EAAA,oDAAA;EACA,OAAA,EAAA,IAAA;EACA,QAAA,EAAA,IAAA;AxIuk6BJ;;AwIrk6BA;EACI,kBAAA;EACA,MAAA;EACA,SAAA;AxIwk6BJ;;AwItk6BA;EAEE,eAAA;AxIwk6BF;;AwIrk6BA;EAA0C,UAAA;AxIyk6B1C;;AwIxk6BA;EAAsC,UAAA;AxI4k6BtC;;AwI3k6BA;EAAuC,UAAA;AxI+k6BvC;;AwI9k6BA;EAEE,WAAA;AxIgl6BF;;AwI7k6BA;EACI,UAAA;EACA,kCAAA;AxIgl6BJ;;AwI9k6BA;EACI,UAAA;AxIil6BJ;;AwI/k6BA;EAEE,oCAAA;AxIil6BF;;AwI9k6BA;EACI,iBAAA;EACA,iBAAA;AxIil6BJ;;AwI/k6BA;EACI,kBAAA;EACA,UAAA;EACA,eAAA;AxIkl6BJ;;AwIhl6BA;EAEE,+BAAA;AxIkl6BF;;AwI/k6BA;EACI,kBAAA;EACA,UAAA;EACA,MAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,0CAAA;EACA,sEAAA;EACA,cAAA;EACA,4CAAA;AxIkl6BJ;;AwIhl6BA;EAEE,YAAA;AxIkl6BF;;AwI/k6BA;EACI,UAAA;AxIkl6BJ;;AwIhl6BA;EACI,gBAAA;EACA,aAAA;AxIml6BJ;;AwIjl6BA;;EAEE,oBAAA;AxIol6BF;;AwIll6BA;;EAEE,qBAAA;AxIql6BF;;AwInl6BA;EACI,OAAA;EACA,wBAAA;AxIsl6BJ;;AwIpl6BA;EACI,QAAA;EACA,wBAAA;AxIul6BJ;;AwIrl6BA;EACI,gBAAA,EAAA,sDAAA;AxIwl6BJ;;AwItl6BA,oBAAA,qFAAA;EACE,kBAAA,EAAA,iCAAA;EACA,mBAAA;EACA,kBAAA,EAAA,0CAAA;EACA,iBAAA;EACA,4CAAA;AxIyl6BF;;AwIvl6BA,mDAAA;AACA;EACI,iBAAA;AxI0l6BJ;;AwIxl6BA;;EAEI,YAAA;AxI2l6BJ;;AwIzl6BA,mCAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;AxI4l6BF;;AwIzl6BA;EACI,YAAA;EACA,cAAA;EACA,YAAA,EAAA,iDAAA;EACA,gBAAA;EACA,iBAAA;AxI4l6BJ;;AwI1l6BA;;EAEI,8BAAA;AxI6l6BJ;;AwI3l6BA;EACI,oBAAA;EACA,UAAA;EACA,aAAA;AxI8l6BJ;;AwI5l6BA,wBAAA,mBAAA;EACE,kBAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;AxI+l6BF;;AwI7l6BA,2CAAA;AACA;EACI,iBAAA;AxIgm6BJ;;AwI9l6BA;EACI,gBAAA;AxIim6BJ;;AwI7l6BA;;CAAA;AAIA,cAAA,4BAAA;EACE,cAAA;EACA,yBAAA;EACA,yBjIr+BkB;APok8BpB;;AwI3l6BA;EACI,YAAA;AxI8l6BJ;;AwI3l6BA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;AxI8l6BJ;;AwI3l6BA;EACI,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AxI8l6BJ;;AwI3l6BA,wCAAA,uCAAA;EACI,YAAA;EACA,cAAA;EACA,aAAA,EAAA,iDAAA;AxI8l6BJ;;AwI3l6BA,8BAAA,8BAAA;EACI,MAAA;EACA,SAAA;EACA,gBAAA,EAAA,kBAAA;EACA,gBAAA;AxI8l6BJ;;AwI3l6BA;EACI,mBAAA;EACA,yBAAA;EACA,0BAAA;AxI8l6BJ;;AwI3l6BA;EACI,sBAAA;EACA,4BAAA;EACA,6BAAA;AxI8l6BJ;;AwI3l6BA;EACI,oBAAA;EACA,WAAA;EACA,YAAA;AxI8l6BJ;;AwI3l6BA;EAEE,8BAAA;AxI6l6BF;;AwIzl6BA;EACI,gBAAA;AxI4l6BJ;;AwIzl6BA;EACI,gBAAA;AxI4l6BJ;;AwIzl6BA;EAEE,sBAAA;AxI2l6BF;;AwIvl6BA;EACM,WAAA;EACA,8CAAA;EACA,OAAA;EACA,QAAA;AxI0l6BN;;AwIvl6BA;EACM,SAAA;EACA,sDAAA;AxI0l6BN;;AwIvl6BA;EACM,YAAA;EACA,yDAAA;AxI0l6BN;;AwIvl6BA;EAEE,iDAAA;AxIyl6BF;;AwIrl6BA;EACM,SAAA;EACA,iBAAA;EACA,oEAAA;AxIwl6BN;;AwIrl6BA;EACM,SAAA;EACA,4DAAA;AxIwl6BN;;AwIrl6BA;EACM,YAAA;EACA,+DAAA;AxIwl6BN;;AwItl6BA,oCAAA,iDAAA;EACI,UAAA,EAAA,gGAAA;AxIyl6BJ;;AwIvl6BA;EACI,gBAAA,EAAA,mEAAA;AxI0l6BJ;;AwIxl6BA;EACI,kBAAA;EACA,UAAA,EAAA,0CAAA;EACA,gBAAA,EAAA,0DAAA;AxI2l6BJ;;AwIzl6BA,8BAAA,4BAAA;EACI,kBAAA;AxI4l6BJ;;AwIzl6BA;EACM,kBAAA;EACA,UAAA,EAAA,sCAAA;AxI4l6BN;;AwI1l6BA;EACI,kBAAA;EACA,UAAA;AxI6l6BJ;;AwI3l6BA,wBAAA,WAAA;EACI,aAAA;EACA,gBAAA,EAAA,kCAAA;EACA,gBAAA;AxI8l6BJ;;AwI5l6BA;EACM,YAAA,EAAA,kFAAA;AxI+l6BN;;AwI7l6BA;EACI,wBAAA;AxIgm6BJ;;AwI9l6BA;EACI,qBAAA;EACA,mBAAA;AxIim6BJ;;AwI/l6BA;EACI,sBAAA,EAAA,6BAAA;AxIkm6BJ;;AwIhm6BA;EAGE,gFAAA;AxIim6BF;;AwI9l6BA;;EAEI,cAAA;AxIim6BJ;;AwI/l6BA;EAGE,sEAAA;EACA,qDAAA;AxIgm6BF;;AwI7l6BA;EACI,YAAA,EAAA,gCAAA;AxIgm6BJ;;AwI9l6BA;EACI,gBAAA;EACA,aAAA;EACA,mBAAA,EAAA,mBAAA;EACA,yBAAA,EAAA,+CAAA;AxIim6BJ;;AwI/l6BA;EACI,eAAA,EAAA,2CAAA;EACA,cAAA,EAAA,iFAAA;AxIkm6BJ;;AwIhm6BA;EACI,iBAAA;AxImm6BJ;;AwIjm6BA;EACI,gBAAA;AxIom6BJ;;AwIlm6BA;EACE,YAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;AxIqm6BF;;AwInm6BA;EACM,yCAAA;AxIsm6BN;;AwIpm6BA;EACI,gBAAA,EAAA,yBAAA;EACA,kBAAA;AxIum6BJ;;AwIrm6BA;EACE,YAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;AxIwm6BF;;AwItm6BA;EACI,kBAAA,EAAA,wDAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AxIym6BJ;;AwIvm6BA;EACM,YAAA;AxI0m6BN;;AwIxm6BA;;;EAGI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;AxI2m6BJ;;AwIzm6BA;EACI,kBAAA,EAAA,gDAAA;AxI4m6BJ;;AwI1m6BA;EAEE,OAAA;AxI4m6BF;;AwIzm6BA;EACI,UAAA,EAAA,eAAA;AxI4m6BJ;;AwI1m6BA;EAA2C,UAAA;AxI8m6B3C;;AwI7m6BA;EAAuC,UAAA;AxIin6BvC;;AwIhn6BA;EAAwC,UAAA;AxIon6BxC;;AwInn6BA;EACI,kBAAA,EAAA,iCAAA;EACA,OAAA;EACA,QAAA;AxIsn6BJ;;AwIpn6BA;EAEE,cAAA;EACA,4EAAA;EACA,mFAAA;AxIsn6BF;;AwInn6BA;EACI,UAAA;EACA,oEAAA;AxIsn6BJ;;AwIpn6BA;EAEE,kBAAA;AxIsn6BF;;AwInn6BA;EACI,SAAA;EACA,gBAAA,EAAA,mEAAA;EACA,8CAAA;AxIsn6BJ;;AwIpn6BA;EACI,oBAAA;AxIun6BJ;;AwIrn6BA;EACI,oBAAA;AxIwn6BJ;;AwItn6BA;;EAEE,gCAAA;EACA,yDAAA;AxIyn6BF;;AwIvn6BA,qBAAA,2BAAA;EAEE,iBAAA;EAEA,4CAAA;EACA,kBAAA;AxIwn6BF;;AwIrn6BA;EACI,kBAAA;AxIwn6BJ;;AwItn6BA;EACI,mBAAA;EACA,iBAAA;EACA,4CAAA;EACA,kBAAA;AxIyn6BJ;;AwIvn6BA;EACI,mBAAA;EACA,gBAAA;AxI0n6BJ;;AwIxn6BA;EACI,cAAA,EAAA,2CAAA;AxI2n6BJ;;AwIzn6BA;EACI,iBAAA;EACA,4CAAA;AxI4n6BJ;;AwI1n6BA;EACI,kBAAA,EAAA,gCAAA;EACA,MAAA;EACA,WAAA,EAAA,oCAAA;EACA,OAAA;EACA,QAAA;AxI6n6BJ;;AwI3n6BA;EAEE,SAAA;AxI6n6BF;;AwI1n6BA;EACI,kBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,mBAAA;EACA,qBjI10CI;EiI20CJ,qBAAA;AxI6n6BJ;;AwI3n6BA;EAEE,UAAA;AxI6n6BF;;AwI1n6BA;EACI,kBAAA;EACA,UAAA;EACA,gBAAA,EAAA,wCAAA;EACA,mBAAA;EACA,qBjIv1CI;APo98BR;;AwI3n6BA;EACI,OAAA;EAEA,yCAAA;EACA,2BAAA;EACA,6BAAA;EACA,gCAAA;AxI6n6BJ;;AwI3n6BA;EACI,QAAA;EAEA,wCAAA;EACA,2BAAA;EACA,6BAAA;EACA,gCAAA;AxI6n6BJ;;AwIzn6BA;EACE,+BAAA;EACA,uCAAA;AxI4n6BF;;AwI1n6BA;EACI,sBAAA;AxI6n6BJ;;AwI3n6BA;EAEE,2BAAA;AxI6n6BF;;AwI1n6BA;EACI,yBjI93CM;EiI+3CN,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA,EAAA,0CAAA;AxI6n6BJ;;AwI3n6BA;EACI,aAAA;AxI8n6BJ;;AwI5n6BA;EAEE,8BAAA;EACA,yGAAA;AxI8n6BF;;AwI3n6BA;EACI,WAAA;EACA,oBAAA,EAAA,+BAAA;AxI8n6BJ;;AwI5n6BA;EACI,cAAA;EACA,eAAA;AxI+n6BJ;;AwI7n6BA,uCAAA,cAAA;EAEM,gBAAA;EACA,MAAA;EACA,gBAAA;EACA,yCAAA,EAAA,6DAAA;AxIgo6BN;;AwI9n6BA;EACI,UAAA,EAAA,qCAAA;AxIio6BJ;;AwI/n6BA;;EAEE,qBAAA;AxIko6BF;;AwIho6BA;EACE,oBAAA;AxImo6BF;;AwIjo6BA;EAGE,sBAAA;EACA,yGAAA;AxIko6BF;;AwI/n6BA;EACE,WAAA;EACA,WAAA;EACA,cAAA,EAAA,mBAAA;AxIko6BF;;AwIho6BA;EACI,0CAAA;EACA,sEAAA;AxImo6BJ;;AwIjo6BA;;EAEE,WAAA;AxIoo6BF;;AwIlo6BA;;EAEE,YAAA;AxIqo6BF;;AwIno6BA,2CAAA;AACA;EAA0D,gBAAA;AxIuo6B1D;;AwIto6BA;EAA0D,eAAA;AxI0o6B1D;;AwIzo6BA;EACI,eAAA,EAAA,kCAAA;AxI4o6BJ;;AwI1o6BA;EAEE,wBAAA;AxI4o6BF;;AwIzo6BA;;EAEI,mBAAA;EACA,UAAA;AxI4o6BJ;;AwI1o6BA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yBjI56CgB;EiI66ChB,yBAAA;EACA,kBAAA;AxI6o6BJ;;AwI3o6BA;EAEE,sBAAA;AxI6o6BF;;AwI1o6BA;EACI,cAAA;EACA,qBAAA;AxI6o6BJ;;AwI3o6BA;EAEE,sDAAA;AxI6o6BF;;AwI1o6BA;EACI,0BAAA;AxI6o6BJ;;AwIxo6BE;EACE,cAAA,EAAA,+BAAA;AxI2o6BJ;;AwIzo6BE;EACE,WjI3/CK;EiI4/CL,mBjIz8CgB;APql9BpB;AwI3o6BI;EACE,kBjI9/CG;AP2o9BT;;AwIxo6BA;EACE,oBAAA;EACA,qBAAA;AxI2o6BF;AwI1o6BE;EACE,kBAAA;AxI4o6BJ;;AwIxo6BA;EACE,qBAAA;EACA,yBAAA;EACA,oBAAA;AxI2o6BF;;AwItn6BE;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AxIyn6BJ;AwIxn6BI;EACE,6BAAA;AxI0n6BN;;AwIvn6BE;EACE,oCAAA;EACA,gCAAA;AxI0n6BJ;AwIzn6BI;EACE,sBAAA;AxI2n6BN;;AwIvn6BI;EACE,oCAAA;EACA,gCAAA;AxI0n6BN;;AwItn6BI;EACE,oCAAA;EACA,gCAAA;AxIyn6BN;;AwIjp6BE;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AxIop6BJ;AwInp6BI;EACE,6BAAA;AxIqp6BN;;AwIlp6BE;EACE,oCAAA;EACA,gCAAA;AxIqp6BJ;AwIpp6BI;EACE,sBAAA;AxIsp6BN;;AwIlp6BI;EACE,oCAAA;EACA,gCAAA;AxIqp6BN;;AwIjp6BI;EACE,oCAAA;EACA,gCAAA;AxIop6BN;;AwI5q6BE;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AxI+q6BJ;AwI9q6BI;EACE,6BAAA;AxIgr6BN;;AwI7q6BE;EACE,oCAAA;EACA,gCAAA;AxIgr6BJ;AwI/q6BI;EACE,sBAAA;AxIir6BN;;AwI7q6BI;EACE,oCAAA;EACA,gCAAA;AxIgr6BN;;AwI5q6BI;EACE,oCAAA;EACA,gCAAA;AxI+q6BN;;AwIvs6BE;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AxI0s6BJ;AwIzs6BI;EACE,6BAAA;AxI2s6BN;;AwIxs6BE;EACE,oCAAA;EACA,gCAAA;AxI2s6BJ;AwI1s6BI;EACE,sBAAA;AxI4s6BN;;AwIxs6BI;EACE,oCAAA;EACA,gCAAA;AxI2s6BN;;AwIvs6BI;EACE,oCAAA;EACA,gCAAA;AxI0s6BN;;AwIlu6BE;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AxIqu6BJ;AwIpu6BI;EACE,6BAAA;AxIsu6BN;;AwInu6BE;EACE,oCAAA;EACA,gCAAA;AxIsu6BJ;AwIru6BI;EACE,sBAAA;AxIuu6BN;;AwInu6BI;EACE,oCAAA;EACA,gCAAA;AxIsu6BN;;AwIlu6BI;EACE,oCAAA;EACA,gCAAA;AxIqu6BN;;AwI7v6BE;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AxIgw6BJ;AwI/v6BI;EACE,6BAAA;AxIiw6BN;;AwI9v6BE;EACE,oCAAA;EACA,gCAAA;AxIiw6BJ;AwIhw6BI;EACE,sBAAA;AxIkw6BN;;AwI9v6BI;EACE,oCAAA;EACA,gCAAA;AxIiw6BN;;AwI7v6BI;EACE,oCAAA;EACA,gCAAA;AxIgw6BN;;AwIxx6BE;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AxI2x6BJ;AwI1x6BI;EACE,6BAAA;AxI4x6BN;;AwIzx6BE;EACE,oCAAA;EACA,gCAAA;AxI4x6BJ;AwI3x6BI;EACE,sBAAA;AxI6x6BN;;AwIzx6BI;EACE,oCAAA;EACA,gCAAA;AxI4x6BN;;AwIxx6BI;EACE,oCAAA;EACA,gCAAA;AxI2x6BN;;AwInz6BE;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AxIsz6BJ;AwIrz6BI;EACE,6BAAA;AxIuz6BN;;AwIpz6BE;EACE,oCAAA;EACA,gCAAA;AxIuz6BJ;AwItz6BI;EACE,sBAAA;AxIwz6BN;;AwIpz6BI;EACE,oCAAA;EACA,gCAAA;AxIuz6BN;;AwInz6BI;EACE,oCAAA;EACA,gCAAA;AxIsz6BN;;AwI906BE;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AxIi16BJ;AwIh16BI;EACE,6BAAA;AxIk16BN;;AwI/06BE;EACE,oCAAA;EACA,gCAAA;AxIk16BJ;AwIj16BI;EACE,sBAAA;AxIm16BN;;AwI/06BI;EACE,oCAAA;EACA,gCAAA;AxIk16BN;;AwI906BI;EACE,oCAAA;EACA,gCAAA;AxIi16BN;;AwIz26BE;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AxI426BJ;AwI326BI;EACE,6BAAA;AxI626BN;;AwI126BE;EACE,oCAAA;EACA,gCAAA;AxI626BJ;AwI526BI;EACE,sBAAA;AxI826BN;;AwI126BI;EACE,oCAAA;EACA,gCAAA;AxI626BN;;AwIz26BI;EACE,oCAAA;EACA,gCAAA;AxI426BN;;AwIp46BE;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AxIu46BJ;AwIt46BI;EACE,6BAAA;AxIw46BN;;AwIr46BE;EACE,oCAAA;EACA,gCAAA;AxIw46BJ;AwIv46BI;EACE,sBAAA;AxIy46BN;;AwIr46BI;EACE,oCAAA;EACA,gCAAA;AxIw46BN;;AwIp46BI;EACE,oCAAA;EACA,gCAAA;AxIu46BN;;AwI/56BE;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AxIk66BJ;AwIj66BI;EACE,6BAAA;AxIm66BN;;AwIh66BE;EACE,oCAAA;EACA,gCAAA;AxIm66BJ;AwIl66BI;EACE,sBAAA;AxIo66BN;;AwIh66BI;EACE,oCAAA;EACA,gCAAA;AxIm66BN;;AwI/56BI;EACE,oCAAA;EACA,gCAAA;AxIk66BN;;AwI176BE;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AxI676BJ;AwI576BI;EACE,6BAAA;AxI876BN;;AwI376BE;EACE,oCAAA;EACA,gCAAA;AxI876BJ;AwI776BI;EACE,sBAAA;AxI+76BN;;AwI376BI;EACE,oCAAA;EACA,gCAAA;AxI876BN;;AwI176BI;EACE,oCAAA;EACA,gCAAA;AxI676BN;;AwIr96BE;EACE,oCAAA;EACA,gCAAA;EACA,sBAAA;AxIw96BJ;AwIv96BI;EACE,6BAAA;AxIy96BN;;AwIt96BE;EACE,oCAAA;EACA,gCAAA;AxIy96BJ;AwIx96BI;EACE,sBAAA;AxI096BN;;AwIt96BI;EACE,oCAAA;EACA,gCAAA;AxIy96BN;;AwIr96BI;EACE,oCAAA;EACA,gCAAA;AxIw96BN;;AwIj86BE;EACE,oCAAA;EACA,gCAAA;EACA,yBAAA;AxIo86BJ;AwIn86BI;EACE,gCAAA;AxIq86BN;;AwIl86BE;EACE,oCAAA;EACA,yBAAA;EACA,gCAAA;AxIq86BJ;AwIp86BI;EACE,yBAAA;AxIs86BN;;AwIl86BI;EACE,oCAAA;EACA,gCAAA;AxIq86BN;;AwIj86BI;EACE,oCAAA;EACA,gCAAA;AxIo86BN;;AwI796BE;EACE,oCAAA;EACA,gCAAA;EACA,yBAAA;AxIg+6BJ;AwI/96BI;EACE,gCAAA;AxIi+6BN;;AwI996BE;EACE,oCAAA;EACA,yBAAA;EACA,gCAAA;AxIi+6BJ;AwIh+6BI;EACE,yBAAA;AxIk+6BN;;AwI996BI;EACE,oCAAA;EACA,gCAAA;AxIi+6BN;;AwI796BI;EACE,oCAAA;EACA,gCAAA;AxIg+6BN;;AwIz/6BE;EACE,oCAAA;EACA,gCAAA;EACA,yBAAA;AxI4/6BJ;AwI3/6BI;EACE,gCAAA;AxI6/6BN;;AwI1/6BE;EACE,oCAAA;EACA,yBAAA;EACA,gCAAA;AxI6/6BJ;AwI5/6BI;EACE,yBAAA;AxI8/6BN;;AwI1/6BI;EACE,oCAAA;EACA,gCAAA;AxI6/6BN;;AwIz/6BI;EACE,oCAAA;EACA,gCAAA;AxI4/6BN;;AwIrh7BE;EACE,oCAAA;EACA,gCAAA;EACA,yBAAA;AxIwh7BJ;AwIvh7BI;EACE,gCAAA;AxIyh7BN;;AwIth7BE;EACE,oCAAA;EACA,yBAAA;EACA,gCAAA;AxIyh7BJ;AwIxh7BI;EACE,yBAAA;AxI0h7BN;;AwIth7BI;EACE,oCAAA;EACA,gCAAA;AxIyh7BN;;AwIrh7BI;EACE,oCAAA;EACA,gCAAA;AxIwh7BN;;AwIjj7BE;EACE,oCAAA;EACA,gCAAA;EACA,yBAAA;AxIoj7BJ;AwInj7BI;EACE,gCAAA;AxIqj7BN;;AwIlj7BE;EACE,oCAAA;EACA,yBAAA;EACA,gCAAA;AxIqj7BJ;AwIpj7BI;EACE,yBAAA;AxIsj7BN;;AwIlj7BI;EACE,oCAAA;EACA,gCAAA;AxIqj7BN;;AwIjj7BI;EACE,oCAAA;EACA,gCAAA;AxIoj7BN;;AwI7k7BE;EACE,oCAAA;EACA,gCAAA;EACA,yBAAA;AxIgl7BJ;AwI/k7BI;EACE,gCAAA;AxIil7BN;;AwI9k7BE;EACE,oCAAA;EACA,yBAAA;EACA,gCAAA;AxIil7BJ;AwIhl7BI;EACE,yBAAA;AxIkl7BN;;AwI9k7BI;EACE,oCAAA;EACA,gCAAA;AxIil7BN;;AwI7k7BI;EACE,oCAAA;EACA,gCAAA;AxIgl7BN;;AwIzm7BE;EACE,oCAAA;EACA,gCAAA;EACA,yBAAA;AxI4m7BJ;AwI3m7BI;EACE,gCAAA;AxI6m7BN;;AwI1m7BE;EACE,oCAAA;EACA,yBAAA;EACA,gCAAA;AxI6m7BJ;AwI5m7BI;EACE,yBAAA;AxI8m7BN;;AwI1m7BI;EACE,oCAAA;EACA,gCAAA;AxI6m7BN;;AwIzm7BI;EACE,oCAAA;EACA,gCAAA;AxI4m7BN;;AwIro7BE;EACE,oCAAA;EACA,gCAAA;EACA,yBAAA;AxIwo7BJ;AwIvo7BI;EACE,gCAAA;AxIyo7BN;;AwIto7BE;EACE,oCAAA;EACA,yBAAA;EACA,gCAAA;AxIyo7BJ;AwIxo7BI;EACE,yBAAA;AxI0o7BN;;AwIto7BI;EACE,oCAAA;EACA,gCAAA;AxIyo7BN;;AwIro7BI;EACE,oCAAA;EACA,gCAAA;AxIwo7BN;;AwIjq7BE;EACE,oCAAA;EACA,gCAAA;EACA,yBAAA;AxIoq7BJ;AwInq7BI;EACE,gCAAA;AxIqq7BN;;AwIlq7BE;EACE,oCAAA;EACA,yBAAA;EACA,gCAAA;AxIqq7BJ;AwIpq7BI;EACE,yBAAA;AxIsq7BN;;AwIlq7BI;EACE,oCAAA;EACA,gCAAA;AxIqq7BN;;AwIjq7BI;EACE,oCAAA;EACA,gCAAA;AxIoq7BN;;AwI7r7BE;EACE,oCAAA;EACA,gCAAA;EACA,yBAAA;AxIgs7BJ;AwI/r7BI;EACE,gCAAA;AxIis7BN;;AwI9r7BE;EACE,oCAAA;EACA,yBAAA;EACA,gCAAA;AxIis7BJ;AwIhs7BI;EACE,yBAAA;AxIks7BN;;AwI9r7BI;EACE,oCAAA;EACA,gCAAA;AxIis7BN;;AwI7r7BI;EACE,oCAAA;EACA,gCAAA;AxIgs7BN;;AwIzt7BE;EACE,oCAAA;EACA,gCAAA;EACA,yBAAA;AxI4t7BJ;AwI3t7BI;EACE,gCAAA;AxI6t7BN;;AwI1t7BE;EACE,oCAAA;EACA,yBAAA;EACA,gCAAA;AxI6t7BJ;AwI5t7BI;EACE,yBAAA;AxI8t7BN;;AwI1t7BI;EACE,oCAAA;EACA,gCAAA;AxI6t7BN;;AwIzt7BI;EACE,oCAAA;EACA,gCAAA;AxI4t7BN;;AwIrv7BE;EACE,oCAAA;EACA,gCAAA;EACA,yBAAA;AxIwv7BJ;AwIvv7BI;EACE,gCAAA;AxIyv7BN;;AwItv7BE;EACE,oCAAA;EACA,yBAAA;EACA,gCAAA;AxIyv7BJ;AwIxv7BI;EACE,yBAAA;AxI0v7BN;;AwItv7BI;EACE,oCAAA;EACA,gCAAA;AxIyv7BN;;AwIrv7BI;EACE,oCAAA;EACA,gCAAA;AxIwv7BN;;AwIjx7BE;EACE,oCAAA;EACA,gCAAA;EACA,yBAAA;AxIox7BJ;AwInx7BI;EACE,gCAAA;AxIqx7BN;;AwIlx7BE;EACE,oCAAA;EACA,yBAAA;EACA,gCAAA;AxIqx7BJ;AwIpx7BI;EACE,yBAAA;AxIsx7BN;;AwIlx7BI;EACE,oCAAA;EACA,gCAAA;AxIqx7BN;;AwIjx7BI;EACE,oCAAA;EACA,gCAAA;AxIox7BN;;AwI7y7BE;EACE,oCAAA;EACA,gCAAA;EACA,yBAAA;AxIgz7BJ;AwI/y7BI;EACE,gCAAA;AxIiz7BN;;AwI9y7BE;EACE,oCAAA;EACA,yBAAA;EACA,gCAAA;AxIiz7BJ;AwIhz7BI;EACE,yBAAA;AxIkz7BN;;AwI9y7BI;EACE,oCAAA;EACA,gCAAA;AxIiz7BN;;AwI7y7BI;EACE,oCAAA;EACA,gCAAA;AxIgz7BN;;AwI5y7BA;EACE,yBjI7jDkB;EiI8jDlB,kBjIj/Ce;EiIk/Cf,iBAAA;EACA,uBAAA;EACA,ejIn+CW;EiIo+CX,WjIrnDO;EiIsnDP,gBAAA;EACA,qBAAA;AxI+y7BF;;AwI5y7BA;EACE,cjIrlDc;APo4+BhB;;AwI7y7BA;EACE,cjI1lDY;AP04+Bd;;AwI9y7BA;EACE,cjI7lDY;AP84+Bd;;AyI37+BA,8FAAA;AACC;;EAEE,2BAAA;EACA,6CAAA;EACA,yBAAA;EAEA,kBAAA;EAGA,iBAAA;EAEA,sBAAA;AzI87+BH;;AyI57+BC;EACE,kBAAA;AzI+7+BH;;AyI77+BC;;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AzIg8+BH;;AyI97+BC;EAAA;AAEA;EACE,gBAAA;EACA,UAAA;AzIi8+BH;;AyI/7+BC;;EAEE,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,QAAA;EACA,yBAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,qBAAA;AzIk8+BH;;AyIh8+BC;EACE,YAAA;EACA,WAAA;AzIm8+BH;;AyIj8+BC;EACE,WAAA;EACA,UAAA;AzIo8+BH;;AyIl8+BC;EAAA;AAMA;;EAAA;AAGA;EACE,WAAA;AzIi8+BH;;AyI/7+BC;EACE,YAAA;AzIk8+BH;;AyIh8+BC;EAEE,2BAAA;EACA,kBAAA;AzIm8+BH;AyIl8+BG;EACC,aAAA;AzIo8+BJ;;AyIj8+BC;EACE,YAAA;EACA,WAAA;AzIo8+BH;AyIn8+BG;EACE,aAAA;AzIq8+BL;;AyIl8+BC;;EAGE,0BAAA;AzIq8+BH;;AyIn8+BC;EACE,0BAAA;AzIs8+BH;;AyIp8+BC;EAAA;AAEA;EACE,WAAA;AzIu8+BH;;AyIr8+BC;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;AzIw8+BH;;AyIt8+BC;EACE,UAAA;EACA,aAAA;AzIy8+BH;;AyIv8+BC;EACC,WAAA;EACA,YAAA;EACC,SAAA;EACA,UAAA;EACA,2BAAA;AzI08+BH;;AyIp8+BC;;EAAA;AAGA;EACE,mBlI1GS;EkI2GT,kBAAA;AzIu8+BH;;AyIr8+BC;EACE,kBAAA;AzIw8+BH;;AyIt8+BC;EACE,mBlInEiB;AP4g/BpB;;AyIv8+BC;EAAA;AAEA;EACE,iBAAA;AzI08+BH;;AyIx8+BC;EACE,iBAAA;AzI28+BH;;AyIz8+BC;EACE,yBAAA;EACA,kBAAA;EACA,gBlInIM;EkIoIN,eAAA;EACA,iDlIK2B;APu8+B9B;;AyI18+BC;EACE,yEAAA;AzI68+BH;;AyI38+BC;EAAA;AAEC;;EAEE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,mBlI9IQ;EkI+IR,SAAA;EACA,QAAA;EACA,gCAAA;AzI88+BJ;;AyI58+BE;EACE,iBAAA;AzI+8+BJ;;AyI78+BE;EACE,gBAAA;AzIg9+BJ;;AyI98+BC;;EAEE,WAAA;EACA,WAAA;AzIi9+BH;;AyI/8+BC;EACG,gBAAA;AzIk9+BJ;;AyIh9+BE;EACE,eAAA;AzIm9+BJ;;AyIj9+BC;EAAA;AAEA;EACE,mBlIxKS;AP4n/BZ;;AyIl9+BC;;;EAGE,mBAAA;AzIq9+BH;;AyIn9+BC;;EAAA;AAGA;;EAGE,sBAAA;AzIs9+BH;;AyIp9+BC;EACE,kBAAA;EACA,WAAA;AzIu9+BH;;AyIr9+BC;;EAAA;AAGA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;AzIw9+BH;;AyIt9+BC;EACE,WAAA;EACA,eAAA;AzIy9+BH;;AyIv9+BC;;EAAA;AAGA;EACE,kBAAA;EACA,gBAAA;AzI09+BH;;AyIx9+BC;EACE,gBAAA;AzI29+BH;;AyIz9+BC;EACE,gBAAA;AzI49+BH;;AyI19+BC;;EAAA;AAGA;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;AzI69+BH;;AyI39+BC;EAEE,+BAAA;AzI89+BH;;AyIx9+BC;EACE,iBAAA;EACA,UAAA;EACA,WAAA;AzI29+BH;;AyIz9+BC;EACE,YAAA;AzI49+BH;;AyI19+BC;EACE,YAAA;AzI69+BH;;AyI39+BC;;EAAA;AAGA;EACE,eAAA;EACA,YAAA;EACA,MAAA;EACA,UAAA;AzI89+BH;;AyI59+BC;EAEE,6BAAA;EACA,kBAAA;AzI+9+BH;;AyIz9+BC;EACE,UAAA;EACA,WAAA;EACA,gBAAA;AzI49+BH;;AyI19+BC;EACE,WAAA;AzI69+BH;;AyI39+BC;EACE,WAAA;AzI89+BH;;AyI59+BC;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBlIpJiB;EkIqJjB,mBlI5QS;EkI6QT,WlIxRM;EkIyRN,wBAAA;EACA,kBAAA;EACA,mBAAA;EACA,elI3IU;EkI4IV,UAAA;EACA,yBAAA;AzI+9+BH;;AyI79+BE;EACE,YjIqjBgC;AR269BpC;;AyI99+BC;EAEE,6BAAA;EACA,SAAA;EACA,YAAA;AzIi++BH;;AyI/9+BC;EAEE,6BAAA;EACA,QAAA;EACA,WAAA;AzIk++BH;;A0Ixx/BA;EACE,aAAA;EACA,sBAAA;A1I2x/BF;A0Izx/BE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;A1I2x/BJ;A0Ixx/BE;EAEE,gBAAA;A1Iyx/BJ;A0Ixx/BI;EACE,aAAA;A1I0x/BN;A0Itx/BE;;EAEE,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,0BAAA;A1Iwx/BJ;A0Irx/BE;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;A1Iux/BN;A0Ipx/BE;EACI,uBAAA;EACA,0BAAA;EACA,cAAA;A1Isx/BN;A0Ijx/BE;EACE,eAAA;EACA,gBnIkIS;EmIjIT,oBAAA;EACA,8BAAA;EACA,+BAAA;EACA,6BAAA;EACA,gBAAA;EACA,2BAAA;EACA,0BAAA;A1Imx/BJ;A0Ihx/BE;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gCAAA;EACA,sCAAA;A1Ikx/BJ;A0Ivw/BA;EAEU,sBAAA;EAGR,aAAA;EACA,eAAA;EAGQ,mBAAA;A1Iyw/BV;;A0Ivw/BA;EAEU,sBAAA;A1I0w/BV;;A0Ixw/BA;;EAEE,gBAAA;EACA,mBAAA;A1I2w/BF;;A0Izw/BA;;EAEE,oBAAA;EACA,oBAAA;A1I4w/BF;;A0Izw/BA;EACE,YAAA;A1I4w/BF;;A0Izw/BA;;EAEE,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;A1I4w/BF;;A0Izw/BA;EAEE,gBAAA;EACA,8BAAA;A1I2w/BF;A0I1w/BE;EACE,aAAA;A1I4w/BJ;;A0Ixw/BA;EAGE,aAAA;EAGQ,cAAA;EAIA,sBAAA;A1I2w/BV;;A0Ixw/BA;EACE,eAAA;EACA,gBnImCW;EmIlCX,oBAAA;EACA,8BAAA;EACA,+BAAA;EACA,6BAAA;EACA,gBAAA;EACA,2BAAA;EACA,0BAAA;EACA,2BAAA;EACA,WAAA;A1I2w/BF;;A0Izw/BA;EACE,kBAAA;EACA,mBAAA;A1I4w/BF;;A0Izw/BA;EAGE,cAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,0BAAA;A1I4w/BF;A0I3w/BE;EACE,aAAA;A1I6w/BJ;;A0I1w/BA;EACE,cAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gCAAA;EACA,sCAAA;A1I6w/BF;A0Izw/BE;EAGE,aAAA;EACA,kCAAA;A1Iyw/BJ;;A0Itw/BA;EACE,aAAA;EACA,gBAAA;A1Iyw/BF;;A0Itw/BA;;;;;;;;;;;;;;;;;;;;;;;;;CAAA;AA2BA;EACE,oBAAA;EACA,sBAAA;A1Iww/BF;;A0Irw/BA;EACE,kBAAA;EAcA,YAAA;EACA,uBAAA;A1I2v/BF;;A0Izv/BA;EACE,YAAA;EACA,wBAAA;A1I4v/BF;;A0I1v/BA;EACE,YAAA;EACA,mBAAA;A1I6v/BF;;A0I3v/BA;EACE,gBAAA;A1I8v/BF;;A0I5v/BA;EACE,cAAA;A1I+v/BF;;A0I3v/BA;EACE,kBAAA;A1I8v/BF;;A0I5v/BA;EACE,iBAAA;A1I+v/BF;;A0I7v/BA;EACE,yBAAA;EACA,0BAAA;A1Igw/BF;;A0I9v/BA;;EAKU,mBAAA;EACR,SAAA;A1Iiw/BF;;A0I/v/BA;EAGU,aAAA;A1Ikw/BV;;A0Ihw/BA;EACE,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,4BAAA;EACA,6BAAA;A1Imw/BF;;A0Ijw/BA;EACE,yBAAA;EACA,4BAAA;EACA,6BAAA;A1Iow/BF;;A2I7//BA;;;EAGI,wBAAA;A3IgggCJ;;A2I9//BA;EACI,oCAAA;EACA,2BAAA;A3IiggCJ;;A2I///BA;EACI,iCAAA;EACA,oBAAA;EACA,6BAAA;EACA,iCAAA;EACA,0BAAA;EACA,2CAAA;A3IkggCJ;;A2IhggCA;EACI,0BAAA;EACA,yBAAA;EACA,oCAAA;A3ImggCJ;;A2IhggCA;EACI,gCAAA;A3ImggCJ;;A2IjggCA;EACI,yBAAA;EACA,+BAAA;EACA,0CAAA;EACA,0BAAA;EACA,2BAAA;A3IoggCJ;;A2IjggCA;;;EAGI,oCAAA;EAEA,0BAAA;EACA,2BAAA;A3ImggCJ;;A2IjggCA;EACI,iCAAA;EACA,6BAAA;EACA,2BAAA;EACA,oCAAA;EACA,6CAAA;EACA,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;A3IoggCJ;;A2IlggCA;EACE,iCAAA;EACA,6BAAA;EACA,2BAAA;EAEA,6CAAA;EACA,0BAAA;EACA,2BAAA;EACA,0BAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,oCAAA;A3IoggCF;;A2IlggCA;EACI,uBAAA;A3IqggCJ;;A2InggCA;EACI,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,oCAAA;A3IsggCJ;;A2IpggCA;EACI,yBAAA;EACA,8BAAA;A3IuggCJ;;A2IrggCA;EACI,yBAAA;EACA,2BAAA;EACA,gBAAA;EACA,6BAAA;A3IwggCJ;;A2IpggCA;EACI,oCAAA;EACA,6BAAA;EACA,0BAAA;A3IuggCJ;;A2IrggCA;EACI,yBAAA;EACA,0BAAA;EACA,gCAAA;EACA,4BAAA;A3IwggCJ;;A2ItggCA;EACI,kCAAA;A3IyggCJ;;A4InngCA;;;EAGE,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;A5IsngCF;;A4InngCA;EACI,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;A5IsngCJ;;A4InngCA;EACE,iBAAA;EACA,QAAA;EACA,kBAAA;EACA,QAAA;A5IsngCF;;A4IpngCA;EACE,uBAAA;EACA,kBAAA;EACA,6BAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,iBAAA;EACA,UAAA;A5IungCF;;A4IrngCA;EACE,4BAAA;A5IwngCF;;A4IrngCA;EACE,MAAA;EACA,gBAAA;A5IwngCF;;A4ItngCA;EACE,gBAAA;EACA,4BAAA;A5IyngCF;;A4IvngCA;EACE,MAAA;A5I0ngCF;;A4IxngCA;EACE,SAAA;EACA,4BAAA;A5I2ngCF;;A4IxngCA;EACE,SAAA;EACA,mBAAA;A5I2ngCF;;A4IzngCA;EACE,mBAAA;EACA,sBAAA;A5I4ngCF;;A4I1ngCA;EACE,SAAA;A5I6ngCF;;A4I3ngCA;EACE,YAAA;EACA,yBAAA;A5I8ngCF;;A4I3ngCA;EACI,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;A5I8ngCJ;;A4I3ngCA;EACI,eAAA;EACA,UAAA;A5I8ngCJ;;A4I1ngCE;EACE,yCAAA;A5I6ngCJ;A4I3ngCE;EACE,yCAAA;A5I6ngCJ;;A4IzngCA;EACE,qBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;A5I4ngCF;;A4IzngCA;EACE,UAAA;A5I4ngCF;;A4I1ngCA;EACE,cAAA;A5I6ngCF;;A4I3ngCA;;EAEE,iCAAA;EACA,kCAAA;A5I8ngCF;;A4I3ngCA;EACE,kBAAA;EACA,UAAA;EACA,aAAA;A5I8ngCF;;A4I3ngCA;EACE,WAAA;A5I8ngCF;;A4I5ngCA;EACE,iBAAA;A5I+ngCF;;A4I7ngCA;EACE,UAAA;EACA,WAAA;A5IgogCF;;A4I9ngCA;EACE,oBAAA;A5IiogCF;;A4I/ngCA;EACE,iBAAA;A5IkogCF;;A4IhogCA;EACE,UAAA;EACA,WAAA;A5ImogCF;;A4IjogCA;EACE,kBAAA;A5IoogCF;;A4IlogCA;EACE,UAAA;EACA,WAAA;A5IqogCF;;A4IlogCA;EACE,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,iBAAA;A5IqogCF;;A4IlogCA;EACE,mBAAA;EACA,iBAAA;EACA,kBAAA;A5IqogCF;;A4InogCA;EACE,yBAAA;A5IsogCF;;A4IpogCA;EACE,+BAAA;A5IuogCF;;A4IpogCA;;;;;;EAME,qBAAA;EACA,aAAA;A5IuogCF;;A4IpogCA;;;EAGE,aAAA;A5IuogCF;;A4IpogCA;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;A5IuogCF;;A4IpogCA;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;EAEA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EAEA,UAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;A5IqogCF;;A4InogCA;EAEG,qBAAA;A5IqogCH;;A4InogCA;EACI,aAAA;A5IsogCJ;;A4InogCA;EACE,SAAA;A5IsogCF;;A4IpogCA;EACE,UAAA;A5IuogCF;;A4IrogCA;EACE,WAAA;A5IwogCF;;A4ItogCA;EACE,kBAAA;EACA,MAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;A5IyogCF;;A4IvogCA;EACE,QAAA;A5I0ogCF;;A4IxogCA;EACE,SAAA;A5I2ogCF;;A4IzogCA;EACE,qBAAA;A5I4ogCF;;A4IzogCA;EACE,kBAAA;EACA,SAAA;EACA,eAAA;EACA,QAAA;A5I4ogCF;;A4I1ogCA;EACE,UAAA;A5I6ogCF;;A4I3ogCA;EACE,wBAAA;EACA,UAAA;A5I8ogCF;;A4I5ogCA;EACE,WAAA;A5I+ogCF;;A4I7ogCA;EACE,yBAAA;EACA,WAAA;A5IgpgCF;;A4I7ogCA;EACE,WAAA;EACA,YAAA;A5IgpgCF;;A4I7ogCA;EACE,cAAA;EACA,kBAAA;A5IgpgCF;;A4I9ogCA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;A5IipgCF;;A4I/ogCA;EACE,qBAAA;EACA,WAAA;EACA,WAAA;A5IkpgCF;;A4I/ogCA;EACE,cAAA;EACA,kBAAA;A5IkpgCF;;A4IhpgCA;;EAEE,qBAAA;EACA,WAAA;EACA,WAAA;A5ImpgCF;;A4IhpgCA;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;A5ImpgCF;;A4IjpgCA;EACE,qBAAA;A5IopgCF;;A4IlpgCA;EACE,qBAAA;A5IqpgCF;;A4InpgCA;EACE,qBAAA;EACA,iBAAA;A5IspgCF;;A4IppgCA;EACE,WAAA;A5IupgCF;;A4IrpgCA;;EAEE,wBAAA;EACA,SAAA;A5IwpgCF;;A4ItpgCA;EACE,0BAAA;A5IypgCF;;A4IvpgCA;EACE,gBAAA;EACA,qBAAA;A5I0pgCF;;A4IvpgCA;EACE,YAAA;EACA,8BAAA;EACA,WAAA;A5I0pgCF;;A4IxpgCA;EACE,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,MAAA;A5I2pgCF;;A4IzpgCA;EACE,kBAAA;EACA,iBAAA;EACA,kCAAA;A5I4pgCF;;A4I1pgCA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,kCAAA;A5I6pgCF;;A4I3pgCA;EACE,gBAAA;EACA,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;A5I8pgCF;;A4I5pgCA;EACE,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;A5I+pgCF;;A4I7pgCA;EACE,eAAA;EACA,yBAAA;A5IgqgCF;;A4I9pgCA;EACI,crI1WgB;EqI2WhB,yBrIhXgB;EqIiXhB,oBAAA;A5IiqgCJ;;A4I/pgCA;EACI,WrIlaK;EqImaL,yBrIlXgB;APohhCpB;;A4I/pgCA;EACE,WAAA;A5IkqgCF;;A4IhqgCA;EACE,eAAA;EACA,6BAAA;A5ImqgCF;;A4IhqgCA;EACE,WAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;A5ImqgCF;;A4IjqgCA;EACE,eAAA;A5IoqgCF;;A4IlqgCA;EACE,qBAAA;EACA,yBAAA;A5IqqgCF;;A4IlqgCA;;EAEE,mBAAA;EACA,oBAAA;A5IqqgCF;;A4IlqgCA;EACE,mBAAA;EACA,eAAA;A5IqqgCF;;A4IlqgCA;;;EAGE,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;A5IqqgCF;;A4IlqgCA;;;;EAIE,qBAAA;EACA,crItakB;EqIualB,yBrI5akB;APilhCpB;;A4InqgCA;;;;EAIE,WrIheO;EqIieP,yBrIhbkB;APslhCpB;;A4IpqgCA;;EAEE,WAAA;EACA,oBAAA;A5IuqgCF;;A4IrqgCA;;EAEE,eAAA;EACA,6BAAA;A5IwqgCF;;A4IrqgCA;;;;EAIE,eAAA;EACA,oBAAA;A5IwqgCF;;A4ItqgCA;;;;EAIE,qBAAA;EACA,yBAAA;A5IyqgCF;;A4ItqgCA;EACI,crIzfQ;APkqhCZ;;A4ItqgCA;;;;EAIE,crIldkB;EqImdlB,yBrIxdkB;EqIydlB,qBAAA;A5IyqgCF;;A4ItqgCA;;;;EAIE,qBAAA;EACA,yBAAA;EACA,WAAA;A5IyqgCF;;A4IvqgCA;;;;EAIE,yBAAA;A5I0qgCF;;A4IxqgCA;;;;EAIE,cAAA;A5I2qgCF;;A4IzqgCA;;;;EAIE,YAAA;A5I4qgCF;;A4I1qgCA;;;;;;;;;;EAUE,qBAAA;EACA,sBAAA;EACA,oCAAA;A5I6qgCF;;A4I3qgCA;;;;;;;;;;;;EAYI,WrI9jBK;EqI+jBL,oCAAA;A5I8qgCJ;;A4I/pgCA;;;;;;;;;;;;;;;;EAgBI,yBrIzlBQ;AP2vhCZ;;A4IhqgCA;;;;;;;;;;;;;;;;EAgBE,yBAAA;EACA,WAAA;A5ImqgCF;;A4IjqgCA;;;;EAIE,eAAA;EACA,WAAA;A5IoqgCF;;A4IlqgCA;;;;EAIE,6BAAA;A5IqqgCF;;A4IlqgCA;;;;;EAKE,WrItoBO;EqIuoBP,yBrItlBkB;AP2vhCpB;;A4InqgCA;;EAEE,yBAAA;A5IsqgCF;;A4InqgCA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;A5IsqgCF;;A4InqgCA;;;EAGE,6BAAA;EACA,qBAAA;EACA,kBAAA;A5IsqgCF;;A4IpqgCA;;;EAGE,eAAA;A5IuqgCF;;A4IrqgCA;;;;;;EAME,yBAAA;A5IwqgCF;;A4ItqgCA;;;EAGE,yBAAA;EACA,YAAA;EACA,MAAA;A5IyqgCF;;A4ItqgCA;;;EAGE,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;A5IyqgCF;;A4IvqgCA;;;EAGE,eAAA;A5I0qgCF;;A4IxqgCA;;;EAGE,aAAA;EACA,kBAAA;A5I2qgCF;;A4IxqgCA;;;EAGE,iBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;A5I2qgCF;;A4IzqgCA;;;EAGE,8BAAA;EACA,+BAAA;A5I4qgCF;;A4I1qgCA;;;EAGE,yBAAA;EAGA,iBAAA;EACA,iCAAA;EACA,kCAAA;A5I6qgCF;;A4I3qgCA;;;EAGE,sBAAA;A5I8qgCF;;A4I5qgCA;;;EAGE,4BAAA;A5I+qgCF;;A4I7qgCA;;;EAGE,yBAAA;A5IgrgCF;;A4I9qgCA;;;EAGE,kBAAA;EACA,UAAA;A5IirgCF;;A4I9qgCA;EACE,eAAA;EACA,6BAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;A5IirgCF;;A4I/qgCA;EACE,eAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;A5IkrgCF;;A4I/qgCA;EACE,mBAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;A5IkrgCF;;A4I/qgCA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,OAAA;EACA,MAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;A5IkrgCF;;A4IhrgCA;;;EAGE,WAAA;EACA,iBAAA;A5ImrgCF;;A4IjrgCA;EACE;;;IAGE,WAAA;IACA,iBAAA;E5IorgCF;AACF;A4IlrgCA;;EAEE,kBAAA;A5IorgCF;;A4IlrgCA;EACI,aAAA;EACA,mBAAA;A5IqrgCJ;;A6I5/hCA,uBAAA;AAiCA;EACE,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EAEA,mBCrCoC;EDsCpC,YCrCoC;A9ImgiCtC;;A6I19hCA;EACE,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,wBAAA;EACA,mCAAA;A7I69hCF;;A6Iz9hCA;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,cAAA;EACA,sBAAA;A7I49hCF;;A6Iv9hCE;EACE,WAAA;EACA,qBAAA;EACA,YAAA;EACA,sBAAA;A7I09hCJ;;A6In9hCI;EACE,aAAA;A7Is9hCN;;A6Ih9hCA;EACE,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,cAAA;EAEE,gBAAA;EAKF,aAAA;A7I88hCF;;A6I18hCE;;EACE,WAAA;EACA,YAAA;A7I88hCJ;;A6Iz8hCA;EACE,gBAAA;A7I48hCF;;A6Iz8hCE;EAGE,gBAAA;A7I48hCJ;;A6Iz8hCA;EACE,eAAA;EAGA,eAAA;A7I48hCF;;A6Iz8hCE;EACE,YAAA;A7I48hCJ;;A6Ix8hCA;;;;EAIE,yBAAA;EAEA,iBAAA;A7I28hCF;;A6It8hCE;EACE,aAAA;A7Iy8hCJ;;A6Iv7hCE;EACE,wBAAA;A7I07hCJ;;A6Ih7hCA;EACE,WC3JoC;ED4JpC,kBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;A7Im7hCF;A6Il7hCE;EACE,WCrKkC;A9IyliCtC;A6In7hCI;EACE,WCtKgC;A9I2liCtC;;A6I96hCE;EACE,aAAA;A7Ii7hCJ;;A6I36hCE;EACE,aAAA;A7I86hCJ;;A6Ix6hCE;EACE,iBAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EACA,wBAAA;EACA,cAAA;EACA,aAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,0BAAA;A7I26hCJ;A6Iz6hCE;EACI,UAAA;EACA,SAAA;A7I26hCN;;A6Iv6hCE;EACE,iBAAA;EACA,eAAA;EACA,SAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,UAAA;EACA,aAAA;EACA,iDtI5F0B;EsI6F1B,0BAAA;A7I06hCJ;A6Ix6hCE;EACI,UAAA;EACA,SAAA;A7I06hCN;;A6Ip6hCA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EAEA,kBAAA;EAEE,QAAA;EAKF,MAAA;EACA,qBAAA;EACA,kBAAA;EAEA,+BAAA;EACA,WCzPoC;ED2PpC,kBAAA;EACA,eAAA;EACA,0CAAA;EAEA,sBtIxQO;EsIyQP,kBAAA;A7I85hCF;A6I75hCE;EAEE,UAAA;A7I85hCJ;A6I35hCE;EACE,QAAA;A7I65hCJ;A6I35hCE;EACE,kBAAA;EACA,sBtI+hBe;EsI9hBf,gBhDYU;EgDXV,ctIlPU;AP+oiCd;;A6Iz5hCE;EACE,WChRkC;A9I4qiCtC;;A6Iv5hCE;;EACE,WtIjSK;AP4riCT;;A6It5hCA;EACE,kBAAA;EACA,MAAA;EAEE,QAAA;EAKF,WCnSoC;EDoSpC,eAAA;EACA,iBAAA;EACA,mBAAA;A7Io5hCF;;A6I/4hCE;EACE,kBAAA;EACA,aCjTkC;EDkTlC,SAAA;EACA,QAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,6CAAA;A7Ik5hCJ;A6Ij5hCI;EACE,iBAAA;A7Im5hCN;A6Ij5hCI;EAEE,UAAA;A7Ik5hCN;A6Ih5hCI;EAEE,WAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EAEE,OAAA;EAKF,MAAA;EACA,gBAAA;EAEE,iBAAA;EAKF,gCAAA;A7Iu4hCN;A6Ip4hCI;EAEE,sBAAA;EACA,yBAAA;EACA,QAAA;A7Iq4hCN;A6Il4hCI;EACE,sBAAA;EACA,yBAAA;EACA,YAAA;A7Io4hCN;;A6I/3hCE;EAEI,OAAA;A7Ii4hCN;A6Ih4hCM;EACE,6BAAA;EACA,iBAAA;A7Ik4hCR;A6Ih4hCM;EACE,iBAAA;EACA,gCAAA;A7Ik4hCR;;A6Il3hCE;EAEI,QAAA;A7Io3hCN;A6In3hCM;EACE,4BAAA;EACA,iBAAA;A7Iq3hCR;A6In3hCM;EACE,+BAAA;A7Iq3hCR;;A6Ij2hCE;EACE,iBCpZkC;EDqZlC,oBCrZkC;A9IyviCtC;A6In2hCI;EACE,cAAA;EACA,WAAA;EACA,gBCvZgC;A9I4viCtC;;A6I/1hCE;EACE,WAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;A7Ik2hCJ;A6Ij2hCI;EACE,kBAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,sCC9bgC;ED+bhC,gBC3agC;ED4ahC,kBtI3Tc;AP8piCpB;;A6Iz1hCE,wBAAA;AAEE;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,sBAAA;EAEA,cAAA;EACA,kBtIhVc;AP0qiCpB;;A6It1hCE,gCAAA;AACA;EACE,cAAA;A7Iy1hCJ;A6Ix1hCI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SCrcgC;EDschC,YCrcgC;EDschC,cAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,sCCvegC;EDwehC,gBC9cgC;A9IwyiCtC;A6Ix1hCI;EACE,cC1cgC;ED2chC,cAAA;EACA,eAAA;EACA,iBAAA;A7I01hCN;A6Ix1hCI;EACE,SAAA;A7I01hCN;;A6Iv1hCE;EACE,iBAAA;EACA,kBAAA;EACA,SAAA;EAEE,OAAA;EAKF,WAAA;EACA,YAAA;A7Iq1hCJ;;A6In1hCE;EAEI,gBAAA;EAKF,iBAAA;EACA,cCzekC;ED0elC,qBAAA;EAEE,mBAAA;A7Ig1hCN;;A6Ix0hCI;EACE,eAAA;A7I20hCN;;A6Ir0hCM;EACE,eAAA;A7Iw0hCR;;A6Ij0hCI;EACE;;IAAA;EAIE;IACE,eAAA;IACA,gBAAA;E7Im0hCR;E6Ih0hCQ;IACE,UAAA;E7Ik0hCV;E6I7zhCQ;IACE,MAAA;IACA,SAAA;E7I+zhCV;E6I7zhCQ;IACE,eAAA;IAEE,gBAAA;E7I8zhCZ;E6IvzhCM;IACE,8BAAA;IACA,SAAA;IACA,SAAA;IACA,SAAA;IACA,gBAAA;IACA,eAAA;IACA,sBAAA;E7IyzhCR;E6IxzhCQ;IACE,UAAA;E7I0zhCV;E6IvzhCM;IAEI,UAAA;IAKF,QAAA;E7IozhCR;E6IlzhCM;IACE,MAAA;IAEE,QAAA;IAKF,WAAA;IACA,YAAA;IACA,iBAAA;IACA,8BAAA;IACA,eAAA;IACA,kBAAA;IACA,UAAA;E7I+yhCR;AACF;A6ItyhCA;EACE;IAEE,sBAAA;E7IwyhCF;E6ItyhCA;IAEE,mBAAA;E7IwyhCF;E6ItyhCA;IAEE,sBAAA;E7IwyhCF;E6ItyhCA;IACE,iBCxnBkC;IDynBlC,kBCznBkC;E9Ii6iCpC;AACF;A+Iz6iCA;EACC;IACC,UAAA;E/I26iCA;E+Ix6iCD;IACC,UAAA;E/I06iCA;AACF;A+Iv6iCA;EACC;IACC,8BAAA;E/Iy6iCA;E+It6iCD;IACC,0BAAA;E/Iw6iCA;AACF;A+Ir6iCA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCA5BgB;EA6BhB,gBAAA;EACA,eAAA;EACA,UAAA;EACA,mCAjCoB;EAkCpB,wBAnCiB;EAoCjB,2BAAA;EAKA,iCAAA;A/Iu6iCD;;A+Ip6iCA;EACC,UAAA;A/Iu6iCD;A+Ir6iCC;EAKC,8BAAA;A/Iu6iCF;;A+In6iCA;EACC,gBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACG,aAAA;EACA,uBAAA;EACH,sBAAA;A/Is6iCD;;A+In6iCA;EACC,aAAA;EACG,uBAAA;EACA,mBAAA;EACH,WAAA;EACA,YAAA;A/Is6iCD;A+Ip6iCI;EAPJ;IAQQ,kBAAA;IACA,sBAAA;E/Iu6iCN;AACF;;A+Ip6iCA;EACC,WAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,mCArFoB;EAsFpB,wBAvFiB;EAwFjB,iCAAA;EAKA,0BAAA;EAKA,mCAAA;A/Iu6iCD;A+Ir6iCC;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;A/Iu6iCF;;A+In6iCA;EACC,kBAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;A/Is6iCD;A+Ip6iCI;EAZJ;IAaQ,MAAA;IACA,YAAA;E/Iu6iCN;AACF;A+Ir6iCC;EACC,wBAAA;A/Iu6iCF;A+Ip6iCC;EACC,yBAAA;A/Is6iCF;A+In6iCC;EAEC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;A/Io6iCF;;AgJrjjCA;EACE,4BAAA;EACA,8BAAA;EACA,8BAAA;EACA,iCAAA;EACA,iCAAA;EACA,+BAAA;EACA,sDAAA;EACA,sDAAA;EACA,4DAAA;EACA,4DAAA;EACA,wDAAA;EACA,6BAAA;EACA,iCAAA;EACA,iCAAA;EACA,kCAAA;EACA,kCAAA;EACA,wBAAA;EACA,oCAAA;EACA,gCAAA;EACA,gCAAA;EACA,mCAAA;EACA,mCAAA;EACA,iCAAA;EACA,iCAAA;EACA,4CAAA;EACA;;;;;;;;GAAA;EASA,uCAAA;EACA,0DAAA;EACA,gEAAA;EACA,gEAAA;EACA,4DAAA;AhJwjjCF;;AgJnjjCA;EACE,gCAAA;EACA,gEAAA;EACA,eAAA;EACA,sBAAA;EACA,WAAA;EACA,6BAAA;AhJsjjCF;;AgJpjjCA;EACE,QAAA;EACA,SAAA;AhJujjCF;;AgJrjjCA;EACE,QAAA;EACA,SAAA;EACA,2BAAA;AhJwjjCF;;AgJtjjCA;EACE,QAAA;EACA,UAAA;AhJyjjCF;;AgJvjjCA;EACE,WAAA;EACA,SAAA;AhJ0jjCF;;AgJxjjCA;EACE,WAAA;EACA,SAAA;EACA,2BAAA;AhJ2jjCF;;AgJzjjCA;EACE,WAAA;EACA,UAAA;AhJ4jjCF;;AgJzjjCA;EACE;IACE,YAAA;IACA,UAAA;IACA,OAAA;IACA,SAAA;EhJ4jjCF;EgJ1jjCA;IACE,MAAA;IACA,wBAAA;EhJ4jjCF;EgJ1jjCA;IACE,SAAA;IACA,wBAAA;EhJ4jjCF;EgJ1jjCA;IACE,QAAA;IACA,aAAA;EhJ4jjCF;AACF;AgJ1jjCA;EACE,kBAAA;EACA,4CAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBzIlGO;EyImGP,6EAAA;EAEA,aAAA;EAEI,8BAAA;EACJ,4CAAA;EACA,gBAAA;EACA,wCAAA;EACA,kCAAA;EACA,qCAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;AhJ4jjCF;;AgJ1jjCA;EACE,cAAA;AhJ6jjCF;;AgJ3jjCA;EACE,cAAA;EAEI,cAAA;EACJ,YAAA;EAEA,aAAA;EACA,mBAAA;EACA,mBAAA;EAEI,mBAAA;AhJ8jjCN;AgJ7jjCE;EACE,oBAAA;AhJ+jjCJ;;AgJ3jjCA;EACE,sBAAA;EACA,eAAA;AhJ8jjCF;AgJ7jjCE;EACI,WzIxIG;APusjCT;;AgJ3jjCA;EAEM,SAAA;AhJ8jjCN;;AgJ5jjCA;EAEU,uBAAA;EACR,WAAA;EAEI,cAAA;EAEJ,aAAA;AhJ+jjCF;;AgJ5jjCA;EACE,yBAAA;EACA,wBAAA;AhJ+jjCF;;AgJ5jjCA;EACE,yBAAA;EACA,wBAAA;AhJ+jjCF;;AgJ5jjCA;EACE,kBAAA;EAEI,WAAA;EAKJ,QAAA;EACA,2BAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,eAAA;AhJ0jjCF;AgJzjjCE;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,czIrJQ;EyIsJR,sBzI0nBa;EyIznBb,gBnDwGK;EmDvGL,eAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;AhJ2jjCN;AgJ1jjCM;EACI,czI3LE;APuvjCZ;;AgJvjjCA;EACE;IACE,gBAAA;IACA,gBAAA;EhJ0jjCF;AACF;AgJxjjCA;EACE,sCAAA;EACA,qBzIvLM;EyI2LN,sBAAA;AhJujjCF;AgJ1jjCE;EACI,czIzLE;APqvjCR;AgJzjjCE;EACE,kBAAA;EAEI,WAAA;EAKJ,QAAA;EACA,2BAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,eAAA;AhJsjjCJ;AgJrjjCI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,czIjOI;EyIkOJ,sBzI4kBW;EyI3kBX,gBnD0DG;EmDzDH,eAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;AhJujjCR;AgJpjjCE;EACE,gBAAA;AhJsjjCJ;;AgJnjjCA;EACE,sBAAA;AhJsjjCF;;AgJpjjCA;EACE,uCAAA;AhJujjCF;;AgJrjjCA;EACE,uCAAA;AhJwjjCF;;AgJtjjCA;EACE,qBzIvOM;APgyjCR;AgJxjjCE;EACI,czIzOE;APmyjCR;;AgJvjjCA;EACE,qBzI9OO;APwyjCT;AgJzjjCE;EACE,czIhPK;AP2yjCT;;AgJxjjCA;EACE,qBzIrPO;APgzjCT;AgJ1jjCE;EACE,czIvPK;APmzjCT;;AgJzjjCA;EACE,qBzI5PM;APwzjCR;AgJ3jjCE;EACI,czI9PE;AP2zjCR;;AgJzjjCA;EACE,gDAAA;AhJ4jjCF;;AgJ1jjCA;EACE,+CAAA;AhJ6jjCF;;AgJ3jjCA;EACE,+CAAA;AhJ8jjCF;;AgJ5jjCA;EACE,kDAAA;AhJ+jjCF;;AgJ7jjCA;EACE,kDAAA;AhJgkjCF;;AgJ9jjCA;EACE,gDAAA;AhJikjCF;;AgJ/jjCA;EACE,6CAAA;AhJkkjCF;;AgJ/jjCA;EACE,czIzQY;EyI0QZ,uBAAA;EACA,sBzIqgBiB;EyIpgBjB,aAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EAEI,sBAAA;AhJkkjCN;AgJjkjCE;EACE,wBAAA;AhJmkjCJ;;AgJhkjCA;EACE,WAAA;EACA,YAAA;AhJmkjCF;;AgJjkjCA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AhJokjCF;;AgJlkjCA;EACE,UAAA;AhJqkjCF;;AgJlkjCA;EACE;IACE,oBAAA;EhJqkjCF;EgJnkjCA;IACE,oBAAA;EhJqkjCF;AACF;AgJnkjCA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,gCAAA;EACA,YAAA;EACA,sBAAA;AhJqkjCF;;AgJnkjCA;EACE,oDAAA;AhJskjCF;;AgJpkjCA;EACE,0BAAA;AhJukjCF;;AgJrkjCA;EACE,QAAA;EACA,aAAA;EACA,uBAAA;AhJwkjCF;;AgJrkjCA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sDAAA;EACA,iDAAA;EACA,+CAAA;AhJwkjCF;;AgJnkjCA;EACE;IACE,8DAAA;EhJskjCF;EgJpkjCA;IACE,UAAA;IACA,oCAAA;EhJskjCF;EgJpkjCA;IACE,UAAA;IACA,mCAAA;EhJskjCF;EgJpkjCA;IACE,kCAAA;EhJskjCF;EgJpkjCA;IACE,kCAAA;EhJskjCF;EgJpkjCA;IACE,eAAA;EhJskjCF;AACF;AgJpkjCA;EACE;IACE,UAAA;IACA,mCAAA;EhJskjCF;EgJpkjCA;IACE,UAAA;IACA,oCAAA;EhJskjCF;AACF;AgJpkjCA;EACE;IACE,8DAAA;EhJskjCF;EgJpkjCA;IACE,UAAA;IACA,qCAAA;EhJskjCF;EgJpkjCA;IACE,UAAA;IACA,kCAAA;EhJskjCF;EgJpkjCA;IACE,mCAAA;EhJskjCF;EgJpkjCA;IACE,iCAAA;EhJskjCF;EgJpkjCA;IACE,eAAA;EhJskjCF;AACF;AgJpkjCA;EACE;IACE,UAAA;IACA,kCAAA;EhJskjCF;EgJpkjCA;IACE,UAAA;IACA,qCAAA;EhJskjCF;AACF;AgJpkjCA;EACE;IACE,8DAAA;EhJskjCF;EgJpkjCA;IACE,UAAA;IACA,oCAAA;EhJskjCF;EgJpkjCA;IACE,UAAA;IACA,mCAAA;EhJskjCF;EgJpkjCA;IACE,kCAAA;EhJskjCF;EgJpkjCA;IACE,kCAAA;EhJskjCF;EgJpkjCA;IACE,+BAAA;EhJskjCF;AACF;AgJpkjCA;EACE;IACE,mCAAA;EhJskjCF;EgJpkjCA;IACE,UAAA;IACA,kCAAA;EhJskjCF;EgJpkjCA;IACE,UAAA;IACA,qCAAA;EhJskjCF;AACF;AgJpkjCA;EACE;IACE,8DAAA;EhJskjCF;EgJpkjCA;IACE,UAAA;IACA,qCAAA;EhJskjCF;EgJpkjCA;IACE,UAAA;IACA,kCAAA;EhJskjCF;EgJpkjCA;IACE,mCAAA;EhJskjCF;EgJpkjCA;IACE,iCAAA;EhJskjCF;EgJpkjCA;IACE,eAAA;EhJskjCF;AACF;AgJpkjCA;EACE;IACE,kCAAA;EhJskjCF;EgJpkjCA;IACE,UAAA;IACA,mCAAA;EhJskjCF;EgJpkjCA;IACE,UAAA;IACA,oCAAA;EhJskjCF;AACF;AgJpkjCA;EACE,sCAAA;AhJskjCF;;AgJpkjCA;EACE,uCAAA;AhJukjCF;;AgJrkjCA;EACE,sCAAA;AhJwkjCF;;AgJtkjCA;EACE,oCAAA;AhJykjCF;;AgJtkjCA;EACE,uCAAA;AhJykjCF;;AgJvkjCA;EACE,wCAAA;AhJ0kjCF;;AgJxkjCA;EACE,qCAAA;AhJ2kjCF;;AgJzkjCA;EACE,uCAAA;AhJ4kjCF;;AgJzkjCA;EACE;IACE,UAAA;IACA,iCAAA;EhJ4kjCF;EgJ1kjCA;IACE,UAAA;EhJ4kjCF;AACF;AgJ1kjCA;EACE;IACE,UAAA;EhJ4kjCF;EgJ1kjCA;IACE,UAAA;IACA,iCAAA;EhJ4kjCF;EgJ1kjCA;IACE,UAAA;EhJ4kjCF;AACF;AgJ1kjCA;EACE,gCAAA;AhJ4kjCF;;AgJzkjCA;EACE,iCAAA;AhJ4kjCF;;AgJzkjCA;EACE;IACE,sDAAA;IACA,kCAAA;IACA,UAAA;EhJ4kjCF;EgJ1kjCA;IACE,uDAAA;IACA,kCAAA;EhJ4kjCF;EgJ1kjCA;IACE,sDAAA;IACA,UAAA;EhJ4kjCF;EgJ1kjCA;IACE,sDAAA;EhJ4kjCF;EgJ1kjCA;IACE,6BAAA;EhJ4kjCF;AACF;AgJ1kjCA;EACE;IACE,6BAAA;EhJ4kjCF;EgJ1kjCA;IACE,uDAAA;IACA,UAAA;EhJ4kjCF;EgJ1kjCA;IACE,sDAAA;IACA,UAAA;EhJ4kjCF;AACF;AgJ1kjCA;EACE,gCAAA;AhJ4kjCF;;AgJzkjCA;EACE,iCAAA;AhJ4kjCF;;AgJzkjCA;EACE;IACE,kCAAA;IACA,mBAAA;EhJ4kjCF;EgJ1kjCA;IACE,+BAAA;EhJ4kjCF;AACF;AgJ1kjCA;EACE;IACE,mCAAA;IACA,mBAAA;EhJ4kjCF;EgJ1kjCA;IACE,+BAAA;EhJ4kjCF;AACF;AgJ1kjCA;EACE;IACE,kCAAA;IACA,mBAAA;EhJ4kjCF;EgJ1kjCA;IACE,+BAAA;EhJ4kjCF;AACF;AgJ1kjCA;EACE;IACE,mCAAA;IACA,mBAAA;EhJ4kjCF;EgJ1kjCA;IACE,+BAAA;EhJ4kjCF;AACF;AgJ1kjCA;EACE;IACE,+BAAA;EhJ4kjCF;EgJ1kjCA;IACE,kBAAA;IACA,kCAAA;EhJ4kjCF;AACF;AgJ1kjCA;EACE;IACE,+BAAA;EhJ4kjCF;EgJ1kjCA;IACE,kBAAA;IACA,mCAAA;EhJ4kjCF;AACF;AgJ1kjCA;EACE;IACE,+BAAA;EhJ4kjCF;EgJ1kjCA;IACE,kBAAA;IACA,mCAAA;EhJ4kjCF;AACF;AgJ1kjCA;EACE;IACE,+BAAA;EhJ4kjCF;EgJ1kjCA;IACE,kBAAA;IACA,oCAAA;EhJ4kjCF;AACF;AgJ1kjCA;EACE,qCAAA;AhJ4kjCF;;AgJ1kjCA;EACE,sCAAA;AhJ6kjCF;;AgJ3kjCA;EACE,qCAAA;AhJ8kjCF;;AgJ5kjCA;EACE,mCAAA;AhJ+kjCF;;AgJ5kjCA;EACE,sCAAA;AhJ+kjCF;;AgJ7kjCA;EACE,uCAAA;AhJgljCF;;AgJ9kjCA;EACE,oCAAA;AhJiljCF;;AgJ/kjCA;EACE,sCAAA;AhJkljCF;;AgJ/kjCA;EACE;IACE,uBAAA;EhJkljCF;EgJhljCA;IACE,yBAAA;EhJkljCF;AACF;AgJ/kjCA,4CAAA;AC9sBA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AjJgykCJ;;AiJ7xkCA;EACI,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gCAAA;EACA,kBAAA;EACA,YAAA;AjJgykCJ;;AiJ7xkCA;EACI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;AjJgykCJ;;AiJ7xkCA;EACI,WAAA;EACA,YAAA;AjJgykCJ;;AiJ7xkCA;EACI,SAAA;AjJgykCJ;;AiJ7xkCA;EACI,SAAA;AjJgykCJ;;AiJ7xkCA;EACI,YAAA;EACA,aAAA;EACA,YAAA;AjJgykCJ;;AiJ7xkCA;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,qEAAA;AjJgykCJ;;AiJ7xkCA;EACI,iBAAA;EACA,eAAA;EACA,kBAAA;AjJgykCJ;;AiJ7xkCA;EACI,kBAAA;AjJgykCJ;;AiJ7xkCA;EACI,SAAA;EACA,QAAA;AjJgykCJ;;AiJ7xkCA;EACI,MAAA;EACA,QAAA;AjJgykCJ;;AiJ7xkCA;EACI,iBAAA;EACA,YAAA;EACA,kBAAA;AjJgykCJ;;AiJ7xkCA;EACI,WAAA;EACA,qBAAA;EACA,wBAAA;AjJgykCJ;;AiJ7xkCA;EACI,WAAA;AjJgykCJ;;AiJ7xkCA;EACI,qBAAA;EACA,YAAA;AjJgykCJ;;AiJ7xkCA;EACI,WAAA;AjJgykCJ;;AiJ7xkCA;EACI,YAAA;AjJgykCJ;;AiJ7xkCA;EACI,YAAA;EACA,WAAA;EACA,qBAAA;EACA,sBAAA;AjJgykCJ;;AiJ7xkCA;EACI,eAAA;AjJgykCJ;;AiJ7xkCA;EACI,kBAAA;AjJgykCJ;;AiJ7xkCA;EACI,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,iBAAA;AjJgykCJ;;AkJ35kCA,yBAAA;AACA;;;EAGE,cAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,sBAAA;AlJ85kCF;;AkJ55kCA;EACE,mBAAA;AlJ+5kCF;;AkJ75kCA;EACE,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,SAAA;EACA,mBAAA;AlJg6kCF;;AkJ95kCA;EACE,UAAA;AlJi6kCF;;AkJ/5kCA;;;;;EAKE,qBAAA;EACA,cAAA;AlJk6kCF;;AkJh6kCA;EACE,qBAAA;EACA,qBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;AlJm6kCF;;AkJj6kCA;EACE,qBAAA;EACA,qBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;AlJo6kCF;;AkJl6kCA;EACE,eAAA;AlJq6kCF;;AkJn6kCA;EACE,eAAA;AlJs6kCF;;AkJp6kCA;EACE,cAAA;AlJu6kCF;;AkJr6kCA;;EAEE,aAAA;AlJw6kCF;;AkJt6kCA;EACE,iBAAA;AlJy6kCF;;AkJv6kCA;;EAEE,aAAA;AlJ06kCF;;AkJx6kCA;;EAEE,aAAA;AlJ26kCF;;AkJz6kCA;EACE,oBAAA;AlJ46kCF;;AkJ16kCA;EACE,gBAAA;EACA,eAAA;AlJ66kCF;;AkJ36kCA;EACE,cAAA;AlJ86kCF;;AkJ56kCA;EACE,eAAA;AlJ+6kCF;;AkJ76kCA;EACE,kBAAA;EACA,qBAAA;EACA,eAAA;AlJg7kCF;;AkJ96kCA;EACE,eAAA;AlJi7kCF;;AkJ/6kCA;;EAEE,kBAAA;AlJk7kCF;;AkJh7kCA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,OAAA;EACA,yBAAA;EAGA,iBAAA;AlJm7kCF;;AkJj7kCA;EACE,yBAAA;EACA,wCAAA;EACA,2BAAA;EACA,oDAAA;AlJo7kCF;;AkJl7kCA;EACE,aAAA;AlJq7kCF;;AkJn7kCA;;EAEE,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,sB3ItHO;E2IuHP,kB3ISe;E2IRf,yBAAA;EACA,kD3IuakC;E2ItalC,gB3I0bkC;AP4/jCpC;;AkJp7kCA;EACE,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;AlJu7kCF;;AkJr7kCA;EACE,UAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AlJw7kCF;;AkJt7kCA;EACE,gBAAA;AlJy7kCF;;AkJv7kCA;EACE,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gB3IqBW;E2IpBX,c3I/GY;APyilCd;;AkJx7kCA;EACE,kBAAA;EACA,c3IpGkB;E2IqGlB,mB3I3IQ;E2I4IR,gBAAA;AlJ27kCF;;AkJz7kCA;EACE,0DAAA;EACA,iCAAA;EACA,4BAAA;AlJ47kCF;;AkJ17kCA;EACE,UAAA;AlJ67kCF;;AkJ37kCA;EACE,kBAAA;EACA,c3IlHkB;E2ImHlB,mB3IzJQ;E2I0JR,gBAAA;AlJ87kCF;;AkJ57kCA;;EAEE,iBAAA;EACA,SAAA;EACA,6BAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,mBAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,gBAAA;EACA,aAAA;AlJ+7kCF;;AkJ77kCA;;EAEE,aAAA;EACA,6BAAA;EACA,SAAA;EACA,iBAAA;AlJg8kCF;;AkJ97kCA;EACE,uBAAA;AlJi8kCF;;AkJ/7kCA;EACE,qBAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AlJk8kCF;;AkJh8kCA;EACE,YAAA;EACA,kBAAA;AlJm8kCF;;AkJj8kCA;EACE,qBAAA;EACA,UAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;AlJo8kCF;;AkJl8kCA;EACE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;AlJq8kCF;;AkJn8kCA;EACE,UAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AlJs8kCF;;AkJp8kCA;EACE,0DAAA;EACA,gCAAA;EACA,4BAAA;AlJu8kCF;;AkJr8kCA;EACE,mBAAA;EACA,cAAA;EACA,+BAAA;AlJw8kCF;;AkJt8kCA;EACE,WAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AlJy8kCF;;AkJv8kCA;EACE,kBAAA;AlJ08kCF;;AkJx8kCA;EACE,mBAAA;EACA,wBAAA;EACA,mBAAA;AlJ28kCF;;AkJz8kCA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,iCAAA;EACA,oCAAA;EACA,sBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;AlJ48kCF;;AkJ18kCA;EACE,iBAAA;EACA,SAAA;EACA,YAAA;AlJ68kCF;;AkJ38kCA;;EAEE,qBAAA;EACA,qBAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AlJ88kCF;;AkJ58kCA;EACE,iBAAA;AlJ+8kCF;;AkJ78kCA;EACE,eAAA;AlJg9kCF;;AkJ98kCA;EACE,mBAAA;AlJi9kCF;;AkJ/8kCA;;EAEE,4BAAA;EACA,6BAAA;AlJk9kCF;;AkJh9kCA;;;EAGE,+DAAA;AlJm9kCF;;AkJj9kCA;EACE,8BAAA;EACA,6BAAA;AlJo9kCF;AkJn9kCE;EACE,8BAAA;AlJq9kCJ;;AkJl9kCA;EACE,8BAAA;EACA,6BAAA;AlJq9kCF;AkJp9kCE;EACE,mBAAA;AlJs9kCJ;;AkJn9kCA;EACE,8BAAA;EACA,6BAAA;AlJs9kCF;AkJr9kCE;EACE,8BAAA;AlJu9kCJ;;AkJp9kCA;EACE,wBAAA;AlJu9kCF;;AkJr9kCA;EACE,kCAAA;EACA,yBAAA;AlJw9kCF;AkJv9kCE;EACE,yBAAA;AlJy9kCJ;;AkJt9kCA;EACE,kCAAA;EACA,2BAAA;AlJy9kCF;;AkJv9kCA;EACE,mBAAA;AlJ09kCF;;AkJx9kCA;EACE,YAAA;EACA,2DAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,+BAAA;EACA,2BAAA;AlJ29kCF;;AkJz9kCA;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;AlJ49kCF;;AkJ19kCA;EACE,aAAA;AlJ69kCF;;AkJ39kCA;EACE,uBAAA;EACA,gBAAA;AlJ89kCF;;AkJ59kCA;EACE,mBAAA;AlJ+9kCF;;AkJ79kCA;EACE,uBAAA;AlJg+kCF;;AkJ99kCA;EACE,mBAAA;AlJi+kCF;;AkJ/9kCA;EACE,eAAA;EACA,qBAAA;EACA,oEAAA;AlJk+kCF;;AkJh+kCA;;EAEE,uBAAA;EACA,gBAAA;EACA,gBAAA;AlJm+kCF;;AkJj+kCA;EAGE,sBAAA;AlJo+kCF;;AkJl+kCA;EACE,8BAAA;AlJq+kCF;AkJp+kCE;EACE,8BAAA;AlJs+kCJ;;AkJn+kCA;EACE,8BAAA;AlJs+kCF;AkJr+kCE;EACE,8BAAA;AlJu+kCJ;;AkJp+kCA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AlJu+kCF;;AkJr+kCA;EACE,iBAAA;EACA,YAAA;AlJw+kCF;;AkJt+kCA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AlJy+kCF;;AkJv+kCA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AlJ0+kCF;;AkJx+kCA;EACE,kBAAA;AlJ2+kCF;;AkJz+kCA;EACE,YAAA;AlJ4+kCF;;AkJ1+kCA;;EAEE,qEAAA;AlJ6+kCF;;AkJ3+kCA;EACE,2CAAA;EACA,sCAAA;AlJ8+kCF;;AkJ5+kCA;EACE,kCAAA;AlJ++kCF;;AkJ7+kCA;EACE,2CAAA;AlJg/kCF;;AkJ9+kCA;EACE,2CAAA;AlJi/kCF;;AkJ/+kCA;EACE,0CAAA;AlJk/kCF;;AkJh/kCA;EACE,2CAAA;AlJm/kCF;;AkJj/kCA;;EAEE,kCAAA;AlJo/kCF;;AkJl/kCA;EACE,0CAAA;AlJq/kCF;;AkJn/kCA;EACE,yCAAA;AlJs/kCF;;AkJp/kCA;EACE,kCAAA;AlJu/kCF;;AkJr/kCA;EACE,kCAAA;AlJw/kCF;;AkJt/kCA;EACE,8BAAA;AlJy/kCF;;AkJv/kCA;EACE,2CAAA;AlJ0/kCF;;AkJx/kCA;EACE,4CAAA;AlJ2/kCF;;AkJz/kCA;;EAEE,2CAAA;AlJ4/kCF;;AkJ1/kCA;;EAEE,4CAAA;AlJ6/kCF;;AkJ3/kCA;EACE,2CAAA;AlJ8/kCF;;AkJ5/kCA;EACE,4CAAA;AlJ+/kCF;;AkJ3/kCE;;EAEE,qEAAA;AlJ8/kCJ;AkJ5/kCE;EACE,2CAAA;EACA,sCAAA;AlJ8/kCJ;AkJ5/kCE;EACE,kCAAA;AlJ8/kCJ;AkJ5/kCE;EACE,2CAAA;AlJ8/kCJ;AkJ5/kCE;EACE,2CAAA;AlJ8/kCJ;AkJ5/kCE;EACE,0CAAA;AlJ8/kCJ;AkJ5/kCE;EACE,2CAAA;AlJ8/kCJ;AkJ5/kCE;;EAEE,kCAAA;AlJ8/kCJ;AkJ5/kCE;EACE,0CAAA;AlJ8/kCJ;AkJ5/kCE;EACE,yCAAA;AlJ8/kCJ;AkJ5/kCE;EACE,kCAAA;AlJ8/kCJ;AkJ5/kCE;EACE,kCAAA;AlJ8/kCJ;AkJ5/kCE;EACE,8BAAA;AlJ8/kCJ;AkJ5/kCE;EACE,2CAAA;AlJ8/kCJ;AkJ5/kCE;EACE,4CAAA;AlJ8/kCJ;AkJ5/kCE;;EAEE,2CAAA;AlJ8/kCJ;AkJ5/kCE;;EAEE,4CAAA;AlJ8/kCJ;AkJ5/kCE;EACE,2CAAA;AlJ8/kCJ;AkJ5/kCE;EACE,4CAAA;AlJ8/kCJ;;AkJz/kCA;EACE,YAAA;EACA,gDAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,+BAAA;EACA,2BAAA;AlJ4/kCF;;AkJ1/kCA;EACE,0BAAA;AlJ6/kCF;;AkJ3/kCA;EACE,0DAAA;EACA,6BAAA;EACA,2BAAA;AlJ8/kCF;;AkJ5/kCA;EACE,uBAAA;AlJ+/kCF;;AkJ7/kCA;EACE,iCAAA;AlJgglCF;;AkJ9/kCA;EACE,iCAAA;AlJiglCF;;AkJ//kCA;EACE,gCAAA;AlJkglCF;;AkJhglCA;;EAEE,kCAAA;AlJmglCF;;AkJjglCA;EACE,gCAAA;AlJoglCF;;AkJlglCA;EACE,+BAAA;AlJqglCF;;AkJnglCA;EACE,wCAAA;EACA,mCAAA;EACA,0BAAA;EACA,iCAAA;AlJsglCF;AkJrglCE;EACE,iCAAA;AlJuglCJ;AkJrglCE;EACE,0BAAA;AlJuglCJ;;AkJpglCA;EACE,uFAAA;AlJuglCF;AkJtglCE;EACE,uFAAA;AlJwglCJ;;AkJrglCA;EACE,sFAAA;AlJwglCF;AkJvglCE;EACE,sFAAA;AlJyglCJ;;AkJtglCA;EACE,qFAAA;AlJyglCF;AkJxglCE;EACE,qFAAA;AlJ0glCJ;;AkJvglCA;EACE,cAAA;EACA,eAAA;AlJ0glCF;;AkJxglCA;EACE,iBAAA;EACA,cAAA;AlJ2glCF;;AkJzglCA;;EAEE,qEAAA;EACA,4BAAA;EACA,6BAAA;AlJ4glCF;AkJ3glCE;;EACE,qEAAA;EACA,4BAAA;EACA,6BAAA;AlJ8glCJ;;AkJ3glCA;EACE,uBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AlJ8glCF;;AkJ5glCA;EACE,+BAAA;AlJ+glCF;;AkJ7glCA;EACE,gCAAA;AlJghlCF;;AkJ7glCE;EACE,+BAAA;AlJghlCJ;AkJ9glCE;EACE,gCAAA;AlJghlCJ;;AkJ7glCA;EACE,gBAAA;AlJghlCF;;AkJ9glCA;EACE,wBAAA;EACA,uBAAA;EACA,gBAAA;AlJihlCF;;AkJ/glCA;EACE,0DAAA;AlJkhlCF;;AkJhhlCA;EACE,uBAAA;AlJmhlCF;;AkJjhlCA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AlJohlCF;;AkJlhlCA;EACE,iBAAA;EACA,YAAA;AlJqhlCF;;AkJnhlCA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AlJshlCF;;AkJphlCA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AlJuhlCF;;AkJrhlCA;EACE,kBAAA;AlJwhlCF;;AkJthlCA;EACE,YAAA;AlJyhlCF;;AkJvhlCA;;EAEE,qEAAA;AlJ0hlCF;;AkJxhlCA;EACE,gCAAA;EACA,2BAAA;AlJ2hlCF;;AkJzhlCA;EACE,uBAAA;AlJ4hlCF;;AkJ1hlCA;EACE,gCAAA;AlJ6hlCF;;AkJ3hlCA;EACE,gCAAA;AlJ8hlCF;;AkJ5hlCA;EACE,+BAAA;AlJ+hlCF;;AkJ7hlCA;EACE,2CAAA;AlJgilCF;;AkJ9hlCA;;EAEE,uBAAA;AlJiilCF;;AkJ/hlCA;EACE,+BAAA;AlJkilCF;;AkJhilCA;EACE,8BAAA;AlJmilCF;;AkJjilCA;EACE,uBAAA;AlJoilCF;;AkJlilCA;EACE,uBAAA;AlJqilCF;;AkJnilCA;EACE,mBAAA;AlJsilCF;;AkJpilCA;EACE,gCAAA;AlJuilCF;;AkJrilCA;EACE,iCAAA;AlJwilCF;;AkJtilCA;;EAEE,2CAAA;AlJyilCF;;AkJvilCA;;EAEE,4CAAA;AlJ0ilCF;;AkJxilCA;EACE,gCAAA;AlJ2ilCF;;AkJzilCA;EACE,iCAAA;AlJ4ilCF;;AkJzilCE;;EAEE,qEAAA;AlJ4ilCJ;AkJ1ilCE;EACE,gCAAA;EACA,2BAAA;AlJ4ilCJ;AkJ1ilCE;EACE,uBAAA;AlJ4ilCJ;AkJ1ilCE;EACE,gCAAA;AlJ4ilCJ;AkJ1ilCE;EACE,gCAAA;AlJ4ilCJ;AkJ1ilCE;EACE,+BAAA;AlJ4ilCJ;AkJ1ilCE;EACE,2CAAA;AlJ4ilCJ;AkJ1ilCE;;EAEE,uBAAA;AlJ4ilCJ;AkJ1ilCE;EACE,+BAAA;AlJ4ilCJ;AkJ1ilCE;EACE,8BAAA;AlJ4ilCJ;AkJ1ilCE;EACE,uBAAA;AlJ4ilCJ;AkJ1ilCE;EACE,uBAAA;AlJ4ilCJ;AkJ1ilCE;EACE,mBAAA;AlJ4ilCJ;AkJ1ilCE;EACE,gCAAA;AlJ4ilCJ;AkJ1ilCE;EACE,iCAAA;AlJ4ilCJ;AkJ1ilCE;;EAEE,gCAAA;AlJ4ilCJ;AkJ1ilCE;;EAEE,iCAAA;AlJ4ilCJ;AkJ1ilCE;EACE,gCAAA;AlJ4ilCJ;AkJ1ilCE;EACE,iCAAA;AlJ4ilCJ;;AkJzilCA;EACE,YAAA;EACA,gDAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,+BAAA;EACA,2BAAA;AlJ4ilCF;;AkJ1ilCA;EACE,0BAAA;AlJ6ilCF;;AkJ3ilCA;EACE,0DAAA;EACA,6BAAA;EACA,2BAAA;AlJ8ilCF;;AkJ5ilCA;EACE,uBAAA;AlJ+ilCF;;AkJ7ilCA;EACE,iCAAA;AlJgjlCF;;AkJ9ilCA;EACE,iCAAA;AlJijlCF;;AkJ/ilCA;EACE,gCAAA;AlJkjlCF;;AkJhjlCA;;EAEE,uBAAA;AlJmjlCF;;AkJjjlCA;EACE,gCAAA;AlJojlCF;;AkJljlCA;EACE,+BAAA;AlJqjlCF;;AkJnjlCA;EACE,wCAAA;EACA,iCAAA;EACA,mCAAA;AlJsjlCF;;AkJpjlCA;EACE,4EAAA;AlJujlCF;AkJtjlCE;EACE,4EAAA;AlJwjlCJ;;AkJrjlCA;EACE,2EAAA;AlJwjlCF;AkJvjlCE;EACE,sFAAA;AlJyjlCJ;;AkJtjlCA;EACE,0EAAA;AlJyjlCF;AkJxjlCE;EACE,qFAAA;AlJ0jlCJ;;AkJvjlCA;EACE,cAAA;EACA,eAAA;AlJ0jlCF;;AkJxjlCA;EACE,iBAAA;EACA,cAAA;AlJ2jlCF;;AkJzjlCA;;EAEE,0DAAA;EACA,4BAAA;EACA,6BAAA;AlJ4jlCF;AkJ3jlCE;;EACE,qEAAA;EACA,4BAAA;EACA,6BAAA;AlJ8jlCJ;;AkJ3jlCA;EACE,uBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AlJ8jlCF;;AkJ5jlCA;EACE,+BAAA;AlJ+jlCF;;AkJ7jlCA;EACE,gCAAA;AlJgklCF;;AkJ7jlCE;EACE,+BAAA;AlJgklCJ;AkJ9jlCE;EACE,gCAAA;AlJgklCJ;;AkJ7jlCA;EACE,gBAAA;AlJgklCF;;AkJ9jlCA;EACE,wBAAA;EACA,uBAAA;EACA,gBAAA;AlJiklCF;;AkJ/jlCA;EACE,0DAAA;AlJkklCF;;AkJhklCA;EACE,uBAAA;AlJmklCF;;AkJjklCA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AlJoklCF;;AkJlklCA;EACE,iBAAA;EACA,YAAA;AlJqklCF;;AkJnklCA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AlJsklCF;;AkJpklCA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AlJuklCF;;AkJrklCA;EACE,kBAAA;AlJwklCF;;AkJtklCA;EACE,YAAA;AlJyklCF;;AkJvklCA;;EAEE,qEAAA;AlJ0klCF;;AkJxklCA;EACE,+BAAA;EACA,2BAAA;AlJ2klCF;;AkJzklCA;EACE,uBAAA;AlJ4klCF;;AkJ1klCA;EACE,+BAAA;AlJ6klCF;;AkJ3klCA;EACE,8BAAA;AlJ8klCF;;AkJ5klCA;EACE,8BAAA;AlJ+klCF;;AkJ7klCA;EACE,0CAAA;AlJgllCF;;AkJ9klCA;;EAEE,uBAAA;AlJillCF;;AkJ/klCA;EACE,8BAAA;AlJkllCF;;AkJhllCA;EACE,4BAAA;AlJmllCF;;AkJjllCA;EACE,uBAAA;AlJollCF;;AkJlllCA;EACE,uBAAA;AlJqllCF;;AkJnllCA;EACE,mBAAA;AlJsllCF;;AkJpllCA;EACE,+BAAA;AlJullCF;;AkJrllCA;EACE,iCAAA;AlJwllCF;;AkJtllCA;;EAEE,+BAAA;AlJyllCF;;AkJvllCA;;EAEE,iCAAA;AlJ0llCF;;AkJxllCA;EACE,+BAAA;AlJ2llCF;;AkJzllCA;EACE,iCAAA;AlJ4llCF;;AkJzllCE;;EAEE,qEAAA;AlJ4llCJ;AkJ1llCE;EACE,+BAAA;EACA,2BAAA;AlJ4llCJ;AkJ1llCE;EACE,uBAAA;AlJ4llCJ;AkJ1llCE;EACE,+BAAA;AlJ4llCJ;AkJ1llCE;EACE,8BAAA;AlJ4llCJ;AkJ1llCE;EACE,8BAAA;AlJ4llCJ;AkJ1llCE;EACE,0CAAA;AlJ4llCJ;AkJ1llCE;;EAEE,uBAAA;AlJ4llCJ;AkJ1llCE;EACE,8BAAA;AlJ4llCJ;AkJ1llCE;EACE,4BAAA;AlJ4llCJ;AkJ1llCE;EACE,uBAAA;AlJ4llCJ;AkJ1llCE;EACE,uBAAA;AlJ4llCJ;AkJ1llCE;EACE,mBAAA;AlJ4llCJ;AkJ1llCE;EACE,+BAAA;AlJ4llCJ;AkJ1llCE;EACE,iCAAA;AlJ4llCJ;AkJ1llCE;;EAEE,+BAAA;AlJ4llCJ;AkJ1llCE;;EAEE,iCAAA;AlJ4llCJ;AkJ1llCE;EACE,+BAAA;AlJ4llCJ;AkJ1llCE;EACE,iCAAA;AlJ4llCJ;;AkJzllCA;EACE,YAAA;EACA,gDAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,+BAAA;EACA,2BAAA;AlJ4llCF;;AkJ1llCA;EACE,0BAAA;AlJ6llCF;;AkJ3llCA;EACE,0DAAA;EACA,6BAAA;EACA,2BAAA;AlJ8llCF;;AkJ5llCA;EACE,uBAAA;AlJ+llCF;;AkJ7llCA;EACE,iCAAA;AlJgmlCF;;AkJ9llCA;EACE,gCAAA;AlJimlCF;;AkJ/llCA;EACE,gCAAA;AlJkmlCF;;AkJhmlCA;;EAEE,uBAAA;AlJmmlCF;;AkJjmlCA;EACE,gCAAA;AlJomlCF;;AkJlmlCA;EACE,8BAAA;AlJqmlCF;;AkJnmlCA;EACE,wCAAA;EACA,iCAAA;EACA,mCAAA;AlJsmlCF;;AkJpmlCA;EACE,4EAAA;AlJumlCF;AkJtmlCE;EACE,4EAAA;AlJwmlCJ;;AkJrmlCA;EACE,0EAAA;AlJwmlCF;AkJvmlCE;EACE,0EAAA;AlJymlCJ;;AkJtmlCA;EACE,yEAAA;AlJymlCF;AkJxmlCE;EACE,yEAAA;AlJ0mlCJ;;AkJvmlCA;EACE,cAAA;EACA,eAAA;AlJ0mlCF;;AkJxmlCA;EACE,iBAAA;EACA,cAAA;AlJ2mlCF;;AkJzmlCA;;EAEE,0DAAA;EACA,4BAAA;EACA,6BAAA;AlJ4mlCF;AkJ3mlCE;;EACE,0DAAA;EACA,4BAAA;EACA,6BAAA;AlJ8mlCJ;;AkJ3mlCA;EACE,uBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AlJ8mlCF;;AkJ5mlCA;EACE,8BAAA;AlJ+mlCF;;AkJ7mlCA;EACE,gCAAA;AlJgnlCF;;AkJ7mlCE;EACE,8BAAA;AlJgnlCJ;AkJ9mlCE;EACE,gCAAA;AlJgnlCJ;;AkJ7mlCA;EACE,gBAAA;AlJgnlCF;;AkJ9mlCA;EACE,wBAAA;EACA,uBAAA;EACA,gBAAA;AlJinlCF;;AkJ/mlCA;EACE,0DAAA;AlJknlCF;;AkJhnlCA;EACE,uBAAA;AlJmnlCF;;AkJjnlCA;EACE;IACE,iBAAA;IACA,iBAAA;IACA,gBAAA;IACA,0BAAA;ElJonlCF;EkJlnlCA;IACE,uBAAA;IACA,WAAA;IACA,YAAA;ElJonlCF;EkJlnlCA;IACE,0DAAA;IACA,6BAAA;IACA,4BAAA;ElJonlCF;EkJnnlCE;IACE,0DAAA;IACA,6BAAA;IACA,4BAAA;ElJqnlCJ;EkJlnlCA;IACE,0DAAA;IACA,iCAAA;IACA,4BAAA;ElJonlCF;EkJnnlCE;IACE,0DAAA;IACA,iCAAA;IACA,4BAAA;ElJqnlCJ;EkJlnlCA;IACE,uBAAA;IACA,sBAAA;IACA,yBAAA;IACA,iBAAA;ElJonlCF;AACF;AkJlnlCA;EACE;IACE;;;KAAA;ElJunlCF;EkJlnlCA;IACE,qEAAA;ElJonlCF;EkJnnlCE;IACE,qEAAA;ElJqnlCJ;EkJlnlCA;;IAEE,uBAAA;ElJonlCF;EkJlnlCA;IACE,gBAAA;IACA,iBAAA;IACA,iBAAA;IACA,eAAA;IACA,mBAAA;ElJonlCF;EkJlnlCA;IACE,iBAAA;IACA,YAAA;ElJonlCF;EkJlnlCA;;IAEE,WAAA;IACA,YAAA;IACA,iBAAA;ElJonlCF;EkJlnlCA;IACE,cAAA;ElJonlCF;EkJlnlCA;IACE,cAAA;IACA,kBAAA;IACA,uBAAA;ElJonlCF;EkJlnlCA;IACE,eAAA;ElJonlCF;EkJlnlCA;;;IAGE,uCAAA;ElJonlCF;EkJlnlCA;;IAEE,uBAAA;ElJonlCF;EkJlnlCA;IACE,mCAAA;ElJonlCF;EkJlnlCA;IACE,uCAAA;ElJonlCF;EkJlnlCA;IACE,uCAAA;ElJonlCF;EkJlnlCA;IACE,gCAAA;ElJonlCF;EkJlnlCA;;IAEE,gCAAA;ElJonlCF;EkJlnlCA;;;;IAIE,4BAAA;ElJonlCF;EkJlnlCA;;IAEE,6BAAA;ElJonlCF;EkJjnlCE;;;IAGE,4BAAA;ElJmnlCJ;EkJjnlCE;;IAEE,uBAAA;ElJmnlCJ;EkJjnlCE;IACE,mCAAA;ElJmnlCJ;EkJjnlCE;IACE,uCAAA;ElJmnlCJ;EkJjnlCE;IACE,uCAAA;ElJmnlCJ;EkJjnlCE;IACE,gCAAA;ElJmnlCJ;EkJjnlCE;;IAEE,gCAAA;ElJmnlCJ;EkJjnlCE;;;;IAIE,4BAAA;ElJmnlCJ;EkJjnlCE;;IAEE,6BAAA;ElJmnlCJ;EkJhnlCA;IACE,iBAAA;IACA,gBAAA;IACA,0BAAA;ElJknlCF;EkJhnlCA;IACE,kCAAA;ElJknlCF;EkJhnlCA;IACE,yDAAA;IACA,yDAAA;IACA,8BAAA;IACA,uBAAA;ElJknlCF;EkJhnlCA;IACE,kCAAA;ElJknlCF;EkJhnlCA;IACE,8BAAA;ElJknlCF;EkJhnlCA;IACE,oDAAA;ElJknlCF;EkJhnlCA;IACE,mDAAA;IACA,aAAA;ElJknlCF;EkJhnlCA;IACE,gBAAA;ElJknlCF;EkJhnlCA;;;;;IAKE,qEAAA;IACA,uCAAA;ElJknlCF;EkJhnlCA;IACE,4BAAA;IACA,2BAAA;ElJknlCF;EkJhnlCA;IACE,uBAAA;ElJknlCF;EkJhnlCA;IACE,iCAAA;ElJknlCF;EkJhnlCA;IACE,iCAAA;ElJknlCF;EkJhnlCA;IACE,6BAAA;IACA,sBAAA;IACA,wBAAA;ElJknlCF;EkJhnlCA;IACE,kFAAA;IACA,uCAAA;ElJknlCF;EkJhnlCA;IACE,qFAAA;IACA,uCAAA;ElJknlCF;EkJ/mlCE;;;;;IAKE,0DAAA;IACA,4BAAA;ElJinlCJ;EkJ/mlCE;IACE,4BAAA;IACA,2BAAA;ElJinlCJ;EkJ/mlCE;IACE,uBAAA;ElJinlCJ;EkJ/mlCE;IACE,iCAAA;ElJinlCJ;EkJ/mlCE;IACE,iCAAA;ElJinlCJ;EkJ/mlCE;IACE,6BAAA;IACA,sBAAA;IACA,wBAAA;ElJinlCJ;EkJ/mlCE;IACE,uEAAA;IACA,4BAAA;ElJinlCJ;EkJ/mlCE;IACE,0EAAA;IACA,4BAAA;ElJinlCJ;EkJ9mlCA;IACE,cAAA;IACA,eAAA;ElJgnlCF;AACF;AmJrjoCA;EACE,cAAA;EACA,oBAAA;AnJujoCF;;AmJrjoCA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;AnJwjoCF;;AmJrjoCA;EACE,sBAAA;AnJwjoCF;;AmJrjoCA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,mDAAA;EACA,cAAA;EACA,WAAA;AnJwjoCF;;AmJtjoCA;EACE,YAAA;AnJyjoCF;;AmJtjoCA;EACE,uBAAA;AnJyjoCF;;AmJtjoCA;EACE,gBAAA;EAEE,mBAAA;AnJwjoCJ;;AmJjjoCA;EACE,gB5IpCO;E4IqCP,yBAAA;EACA,6BAAA;EACA,kB5IyFe;E4IxFf,uBAAA;EACA,mBAAA;AnJojoCF;;AmJljoCA;EACE,yB5IOkB;AP8ioCpB;;AmJnjoCA;EACE,yB5I1BO;APgloCT;;AmJpjoCA;EACE,yB5I5BM;APmloCR;;AmJrjoCA;EACE,yB5IjCO;APyloCT;;AmJtjoCA;EACE,yB5IrCM;AP8loCR;;AmJvjoCA;EACE,yB5IhDU;AP0moCZ;;AmJxjoCA;EACE,aAAA;EACA,mBAAA;AnJ2joCF;AmJ1joCE;EACE,oBAAA;EACA,gBAAA;EAEE,qBAAA;EAKF,c5IrCU;AP4loCd;;AmJpjoCA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AnJujoCF;;AmJpjoCA;EAEI,YAAA;AnJsjoCJ;;AmJhjoCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AnJmjoCF;;AmJjjoCA;EACE,iBAAA;EACA,mBAAA;AnJojoCF;AmJnjoCE;EACE,kB5I4Ba;E4I3Bb,0BAAA;AnJqjoCJ;;AmJjjoCA;EACE,WAAA;EACA,cAAA;EACA,WAAA;AnJojoCF;;AmJjjoCA;EACE,kB5IgBe;E4Iff,yBAAA;EACA,qBAAA;EACA,sBAAA;EACA,gB5IpHO;E4IsHP,YAAA;EACA,mDAAA;AnJmjoCF;AmJljoCE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AnJojoCJ;AmJnjoCI;EACE,kBAAA;AnJqjoCN;AmJnjoCI;EACE,oBAAA;EACA,gBAAA;EAEE,qBAAA;AnJojoCR;AmJ7ioCE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AnJ+ioCJ;AmJ9ioCI;EACE,iBAAA;AnJgjoCN;AmJ7ioCE;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,mBAAA;AnJ+ioCJ;AmJ9ioCI;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AnJgjoCN;AmJ/ioCM;EACE,iBAAA;AnJijoCR;AmJ/ioCM;EACE,mBAAA;AnJijoCR;AmJ/ioCM;EACE,oBAAA;EACA,kBAAA;EACA,c5IlIM;APmroCd;AmJhjoCQ;EACE,mBAAA;AnJkjoCV;AmJhjoCQ;EAEI,oBAAA;AnJijoCZ;;AmJlioCA;EACE,SAAA;AnJqioCF;;AmJlioCA;EACE,uBAAA;EACA,uBAAA;AnJqioCF;;AmJlioCA,iBAAA;AACA;EACE,0BAAA;EACA,oBAAA;EACA,wBAAA;AnJqioCF;;AmJlioCA;EACE,wBAAA;AnJqioCF;;AmJlioCA;EACE,oCAAA;EAGA,4BAAA;AnJqioCF;;AmJlioCA;EACE,uBAAA;EACA,kCAAA;AnJqioCF;;AmJlioCA;EACE,gB5I3NO;E4I4NP,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EAEE,WAAA;EACA,iBAAA;AnJoioCJ;;AmJ5hoCA;EACE,YAAA;AnJ+hoCF;;AmJ5hoCA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,4BAAA;AnJ+hoCF;;AmJ5hoCA;;EAEE,gBAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,4BAAA;AnJ+hoCF;;AmJ5hoCA;EACE,QAAA;AnJ+hoCF;;AmJ5hoCA;EACE,WAAA;AnJ+hoCF;;AmJ5hoCA;EACE,c5I1NkB;E4I2NlB,gB5I9QO;E4I+QP,0BAAA;EACA,qBAAA;EACA,wBAAA;AnJ+hoCF;AmJ9hoCE;EACE,W5InRK;E4IoRL,mB5IjOgB;E4IkOhB,yBAAA;AnJgioCJ;AmJ9hoCE;EACE,aAAA;EACA,gBAAA;AnJgioCJ;;AoJ9zoCA,iBAAA;ACJA;EACI,gB9I6sBgC;APynnCpC;AqJr0oCI;EACI,gBAAA;ArJu0oCR;;AqJn0oCI;EACI,aAAA;ArJs0oCR;AqJn0oCQ;EACI,aAAA;ArJq0oCZ;AqJl0oCI;EACI,kBAAA;ArJo0oCR;AqJl0oCI;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;ArJo0oCR;AqJl0oCI;EACI,iBAAA;ArJo0oCR;AqJn0oCQ;EACI,uCAAA;EACA,aAAA;EACA,mBAAA;ArJq0oCZ;;AkBryoCI;EmIzBI;IACI,kBAAA;ErJk0oCV;EqJj0oCU;IACI,kBAAA;IACA,mBAAA;ErJm0oCd;AACF;AkB/yoCI;EmIbQ;IACI,iBAAA;IACA,oBAAA;ErJ+zoCd;EqJ7zoCU;IACI,kBAAA;IACA,mBAAA;ErJ+zoCd;AACF;AqJ3zoCA;EAEQ;IACI,iBAAA;IACA,oBAAA;ErJ4zoCV;EqJ1zoCM;IACI,kBAAA;IACA,mBAAA;ErJ4zoCV;AACF;AqJvzoCA;EACI,YAAA;ArJyzoCJ;;AqJtzoCI;EACI,qBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;ArJyzoCR;;AsJt4oCI;EACI,kBAAA;EACA,qBAAA;EACA,mBAAA;AtJy4oCR;AsJv4oCI;EACI,UAAA;AtJy4oCR;AsJx4oCQ;EACI,UAAA;AtJ04oCZ;AsJv4oCI;EACI,UAAA;AtJy4oCR;AsJx4oCQ;EACI,UAAA;AtJ04oCZ;AsJv4oCI;EACI,gB/I4rB4B;AP6snCpC;AsJx4oCQ;EACI,gB/I4rBwB;AP8snCpC;AsJx4oCQ;EACI,gB/IwrBwB;APktnCpC;AsJx4oCQ;EACI,gB/IurBwB;APmtnCpC;AsJx4oCQ;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;AtJ04oCZ;;AsJ73oCI;EACI,mB/I3BE;E+I4BF,gCAAA;EACA,cAAA;EACA,kDAAA;EACA,aAAA;AtJg4oCR;AsJ93oCY;EACI,mB/I/BP;E+IgCO,qB/IwtBiB;APwqnCjC;AsJ73oCQ;EACI,gB/IpDH;APm7oCT;AsJ53oCY;EACI,mB/I8sBoB;E+I7sBpB,qB/IgtBc;AP8qnC9B;AsJ33oCQ;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,gB/IooBwB;APyvnCpC;AsJ53oCY;EAEI,kBAAA;AtJ63oChB;AsJ13oCQ;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AtJ43oCZ;AsJ33oCY;EACI,kBAAA;AtJ63oChB;AsJ13oCQ;EACI,mBAAA;EACA,yBAAA;AtJ43oCZ;AsJ13oCQ;EACI,uBAAA;AtJ43oCZ;AsJ13oCQ;EACI,iBAAA;EACA,iB/IsqBwB;E+IrqBxB,oB/IqqBwB;APutnCpC;AsJ13oCQ;EACI,cAAA;EACA,iB/IiqBwB;E+IhqBxB,oB/IgqBwB;AP4tnCpC;AsJz3oCY;EACI,c/I7DA;APw7oChB;AsJz3oCY;EACI,c/InEF;AP87oCd;AsJx3oCQ;EACI,aAAA;AtJ03oCZ;AsJz3oCY;EACI,6BAAA;EACA,YAAA;AtJ23oChB;AsJv3oCoB;EACI,W/IlHf;AP2+oCT;AsJr3oCoB;EACI,W/IvHf;AP8+oCT;AsJh3oCQ;EACI,aAAA;EACA,mBAAA;EACA,cAAA;AtJk3oCZ;AsJj3oCY;EACI,cAAA;AtJm3oChB;AsJl3oCgB;EACI,cAAA;AtJo3oCpB;AsJj3oCY;EACI,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,c/IzGF;E+I0GE,iBAAA;AtJm3oChB;AsJj3oCoB;EACI,cAAA;AtJm3oCxB;AsJ/2oCoB;EACI,c/IvGJ;APw9oCpB;AsJ92oCwB;EACI,W/I1JnB;AP0gpCT;AsJ52oCgB;EACI,gBAAA;AtJ82oCpB;AsJ52oCgB;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,yBAAA;EACA,WAAA;EACA,yB/IvKR;E+IwKQ,kBAAA;EACA,UAAA;EACA,oBAAA;AtJ82oCpB;AsJ52oCwB;EACI,yBAAA;AtJ82oC5B;AsJ12oCwB;EACI,yBAAA;AtJ42oC5B;AsJz2oCoB;EAvJhB,UAAA;EACA,YAAA;EACA,WAAA;AtJmgpCJ;AsJ12oCgB;EA3JZ,UAAA;EACA,YAAA;EACA,WAAA;AtJwgpCJ;;AsJx2oCA;EAGY;IACI,cAAA;EtJy2oCd;EsJx2oCc;IACI,cAAA;EtJ02oClB;EsJr2oCE;IACI,aAAA;EtJu2oCN;AACF;AsJr2oCA;EACI;IACI,aAAA;EtJu2oCN;AACF;AkB1gpCI;EoIwKI;IACI,eAAA;EtJq2oCV;EsJp2oCU;IACI,aAAA;IACA,mBAAA;IACA,YAAA;EtJs2oCd;EsJl2oCU;IACI,eAAA;EtJo2oCd;EsJn2oCc;IACI,eAAA;EtJq2oClB;AACF;AkB1hpCI;EoI6LQ;IACI,kBAAA;IACA,mBAAA;EtJg2oCd;AACF;AsJ51oCA;EAGY;IACI,kBAAA;IACA,mBAAA;EtJ41oCd;AACF;AsJt1oCI;EACI,eAAA;EACA,OAAA;EACA,4BAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EACA,gB/I5QC;APompCT;AsJv1oCQ;EACI,cAAA;EACA,gBAAA;EACA,gBAAA;AtJy1oCZ;AsJv1oCQ;EACI,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;AtJy1oCZ;AsJv1oCQ;EACI,wBAAA;AtJy1oCZ;AsJt1oCI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,gCAAA;AtJw1oCR;AsJv1oCQ;EACI,UAAA;AtJy1oCZ;AsJv1oCQ;EACI,UAAA;AtJy1oCZ;AsJv1oCQ;EACI,c/IzQE;APkmpCd;AsJx1oCY;EACI,yB/I3SJ;APqopCZ;;AkBtlpCI;EoImQI;IAII,gBAAA;IACA,uBAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;IACA,WAAA;IACA,UAAA;IACA,iBAAA;IACA,mCAAA;EtJo1oCV;EsJ/1oCU;IACI,aAAA;EtJi2oCd;AACF;AsJh1oCQ;EACI,aAAA;EACA,mBAAA;EACA,cAAA;AtJk1oCZ;AsJh1oCQ;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AtJk1oCZ;AsJj1oCY;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,c/IzSI;E+I0SJ,kCAAA;AtJm1oChB;AsJh1oCQ;EACI,gBAAA;AtJk1oCZ;AsJj1oCY;EACI,e/IpNH;E+IqNG,uBAAA;AtJm1oChB;AsJj1oCY;EACI,e/IrNH;APwipCb;AsJh1oCQ;EACI,kBAAA;AtJk1oCZ;AsJj1oCY;EACI,oBAAA;AtJm1oChB;AsJj1oCY;EACI,cAAA;EACA,WAAA;AtJm1oChB;AsJl1oCgB;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,gBzD7NF;EyD8NE,sB/I0bD;AP05nCnB;AsJj1oCY;EACI,WAAA;EACA,gCAAA;AtJm1oChB;AsJj1oCY;EACI,WAAA;EACA,MAAA;EACA,wBAAA;EACA,0BAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,gB/IxYP;AP2tpCT;AsJh1oCQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;AtJk1oCZ;AsJj1oCY;EACI,eAAA;EACA,gB/I3OH;AP8jpCb;AsJj1oCY;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AtJm1oChB;AsJ/0oCY;EACI,gCAAA;AtJi1oChB;AsJ/0oCY;EACI,kBAAA;AtJi1oChB;;AsJ50oCA;EAIgB;IACI,iBAAA;IACA,cAAA;EtJ40oClB;AACF;AkBvspCI;EoImYI;IACI,aAAA;EtJu0oCV;EsJt0oCU;IACI,aAAA;EtJw0oCd;AACF;AuJxwpCI;EACI,kBAAA;EACA,mBhJiBE;EgJhBF,YAAA;EACA,iBAAA;EACA,MAAA;EACA,OAAA;EACA,4BAAA;EACA,+BAAA;EACA,aAAA;EACA,YhJ0sB4B;EgJzsB5B,kDAAA;EACA,kDAAA;AvJ0wpCR;AuJzwpCQ;EACI,8BAAA;AvJ2wpCZ;AuJ1wpCY;EACI,2BAAA;AvJ4wpChB;AuJzwpCQ;EACI,gBhJdH;EgJeG,2BhJZA;APuxpCZ;AuJvwpCY;EACI,mBhJJP;EgJKO,2BhJktBoB;APujoCpC;AuJrwpCY;EACI,mBhJ+sBW;EgJ9sBX,2BhJ+sBc;APwjoC9B;AuJpwpCQ;EACI,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,iChJ6rBwB;EgJ5rBxB,YAAA;EACA,sCAAA;AvJswpCZ;AuJpwpCQ;EACI,gBAAA;EACA,WAAA;EACA,gBAAA;AvJswpCZ;AuJpwpCQ;EACI,wBAAA;AvJswpCZ;AuJpwpCQ;EACI,eAAA;EACA,iBAAA;AvJswpCZ;AuJpwpCQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;EACA,YhJopBwB;EgJnpBxB,YhJssBwB;APgkoCpC;AuJpwpCQ;EACI,kBAAA;EACA,cAAA;AvJswpCZ;AuJpwpCQ;EACI,6BAAA;AvJswpCZ;AuJrwpCY;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;AvJuwpChB;AuJpwpCQ;EACI,yBhJ9DF;EgJ+DE,gBAAA;EACA,6BAAA;AvJswpCZ;AuJrwpCY;EACI,gBhJ/EP;APs1pCT;AuJpwpCgB;EACI,yBhJnEX;APy0pCT;AuJlwpCgB;EACI,yBhJipBO;APmnoC3B;AuJhwpCQ;EACI,kBAAA;AvJkwpCZ;AuJjwpCY;EACI,kCAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AvJmwpChB;AuJhwpCY;EACI,gBAAA;EACA,WAAA;AvJkwpChB;AuJ/vpCQ;EACI,aAAA;EACA,sBAAA;EACA,0BAAA;AvJiwpCZ;AuJhwpCY;EACI,mBAAA;EACA,oBAAA;AvJkwpChB;AuJjwpCgB;EACI,YAAA;AvJmwpCpB;AuJ/vpCgB;EAAO,WAAA;AvJkwpCvB;AuJ7vpCgB;EACI,chJ7EA;AP40pCpB;AuJ3vpCQ;EACI,gBAAA;EACA,WAAA;AvJ6vpCZ;AuJ5vpCY;EACI,uBAAA;EACA,sBAAA;AvJ8vpChB;AuJ5vpCY;EACI,WAAA;EACA,kBAAA;AvJ8vpChB;AuJ7vpCgB;EACI,iBAAA;EACA,mBAAA;EACA,chJ1GN;APy2pCd;AuJ5vpCY;EACI,yBAAA;AvJ8vpChB;;AuJzvpCA;EACI;IACI,UAAA;EvJ4vpCN;EuJ3vpCG;IACG,UAAA;EvJ6vpCN;AACF;AkBx1pCI;EqIiGQ;IACI,uBAAA;EvJ0vpCd;AACF;AkB12pCI;EqIqHA;IACI,iBAAA;IACA,sBAAA;EvJwvpCN;EuJtvpCE;IACI,gBAAA;IACA,wBAAA;IACA,YhJ+hB4B;EPytoClC;EuJvvpCM;IACI,mBhJ6hBwB;EP4toClC;EuJxvpCU;IACI,WhJ2hBoB;EP+toClC;EuJtvpCU;IACI,WhJuhBoB;EPiuoClC;EuJvvpCc;IACI,UAAA;IACA,+BAAA;EvJyvpClB;EuJxvpCkB;IACI,UAAA;IACA,UAAA;EvJ0vpCtB;EuJvvpCc;IACI,kBAAA;IACA,UAAA;EvJyvpClB;EuJvvpCc;IACI,UAAA;EvJyvpClB;EuJtvpCkB;IACI,UAAA;EvJwvpCtB;EuJpvpCU;IACI,kBhJggBoB;EPsvoClC;EuJrvpCc;IACI,UhJ8fgB;EPyvoClC;EuJnvpCM;IACI,aAAA;EvJqvpCV;AACF;AkBz5pCI;EqI0KI;IACI,wBAAA;EvJkvpCV;AACF;AwJp4pCA;EACE,iBAAA;AxJs4pCF;AwJr4pCE;EACE,oCAAA;AxJu4pCJ;;AwJl4pCI;EACE,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,6CAAA;AxJq4pCN;AwJl4pCE;EACE,iBAAA;AxJo4pCJ;AwJn4pCI;EACE,cAAA;AxJq4pCN;AwJn4pCI;EACE,kBAAA;AxJq4pCN;AwJl4pCE;EACE,eAAA;AxJo4pCJ;AwJl4pCE;EACE,oCAAA;EACA,cAvFmB;EAwFnB,kCjJgDiB;EiJ/CjB,gBjJ2DS;EiJ1DT,eAjHW;EAkHX,sBA/GW;EAgHX,oBA/Ga;EAgHb,oBAlHW;EAmHX,kBAhHe;AxJo/pCnB;AwJn4pCI;EACE,cAhGiB;EAiGjB,mBjJlHM;APu/pCZ;AwJp4pCM;EACE,cAnGe;EAoGf,mBjJrHI;AP2/pCZ;AwJn4pCQ;EACE,mBAAA;AxJq4pCV;AwJj4pCQ;EACE,mBAAA;AxJm4pCV;AwJh4pCM;EACE,cAjHe;AxJm/pCvB;AwJ93pCI;EACE,WjJ1IG;EiJ2IH,mBjJxFc;APw9pCpB;AwJ/3pCM;EACE,sBAAA;EACA,mBjJ3FY;AP49pCpB;AwJ93pCQ;EACE,mBAAA;AxJg4pCV;AwJ53pCQ;EACE,mBAAA;AxJ83pCV;AwJ33pCM;EACE,WjJ3JC;APwhqCT;AwJz3pCM;EACE,oCAAA;EACA,kCjJLa;EiJMb,gBjJIK;EiJHL,ejJjBK;EiJkBL,sBAvJW;EAwJX,oBAvJa;EAwJb,oBAvKO;EAwKP,cAlJc;AxJ6gqCtB;AwJx3pCI;EACE,eAAA;AxJ03pCN;AwJz3pCM;EAEE,cA1Je;AxJohqCvB;AwJz3pCQ;EACE,cA5Ja;AxJuhqCvB;AwJv3pCI;EACE,cjJjJQ;AP0gqCd;AwJt3pCM;EACE,cAAA;AxJw3pCR;AwJn3pCM;EACE,cAzKgB;AxJ8hqCxB;AwJl3pCQ;EACE,WjJnMD;APujqCT;AwJh3pCI;EACE,cjJrKQ;EiJsKR,mBAAA;AxJk3pCN;AwJ/2pCE;EACE,mBAAA;EACA,sBAAA;EACA,WjJulBgC;EiJtlBhC,cAAA;EACA,YAAA;EACA,cAAA;EACA,cjJhLU;APiiqCd;AwJ/2pCM;EACE,cAAA;AxJi3pCR;AwJ92pCI;;EAEE,WjJ2kB8B;APqyoCpC;AwJ92pCI;EACE,eAhMgB;EAiMhB,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,6CAAA;AxJg3pCN;AwJ92pCI;EACE,yBAAA;AxJg3pCN;AwJ92pCQ;EACE,WjJxOD;APwlqCT;AwJ52pCI;EAEE,sBAAA;AxJ62pCN;AwJ32pCQ;EACE,WjJjPD;AP8lqCT;AwJz2pCI;EACE,cjJnNQ;AP8jqCd;AwJz2pCQ;EACE,cjJ1MU;APqjqCpB;AwJt2pCE;EACE,YAAA;EACA,qBAAA;AxJw2pCJ;AwJt2pCE;EACE,kBjJjIgB;EiJkIhB,iBAAA;EACA,ejJtHS;EiJuHT,cjJrNgB;EiJsNhB,mBjJ1NgB;EiJ2NhB,kBAAA;EACA,QAAA;EACA,WjJscgC;EiJlchC,2BAAA;AxJq2pCJ;AwJx2pCI;EACE,WAAA;AxJ02pCN;AwJt2pCM;EACE,cjJjOY;EiJkOZ,mBAAA;AxJw2pCR;AwJp2pCM;EACE,cjJxOY;EiJyOZ,mBAAA;AxJs2pCR;AwJn2pCI;EACE,cjJ3Oc;EiJ4Od,mBjJhPc;APqlqCpB;AwJl2pCE;EACE,gBAAA;EACA,2CAAA;AxJo2pCJ;AwJl2pCE;EACE,4BAAA;EACA,cjJnQU;APumqCd;AwJl2pCM;EACE,cAAA;AxJo2pCR;AwJj2pCI;EACE,mBAAA;AxJm2pCN;AwJj2pCI;EACE,cAAA;EACA,mBAAA;AxJm2pCN;AwJj2pCI;EACE,ejJnKO;EiJoKP,gBjJ/IO;APk/pCb;AwJh2pCE;EACE,iBAAA;EACA,gCAAA;AxJk2pCJ;AwJh2pCM;EACE,uCArSiB;AxJuoqCzB;AwJ91pCM;EACE,uCA1SiB;AxJ0oqCzB;AwJ71pCI;EACE,iBAAA;AxJ+1pCN;AwJ31pCI;EACE,SAAA;EACA,gBAAA;EACA,4BAAA;AxJ61pCN;AwJ11pCE;EACE,uBAAA;AxJ41pCJ;AwJ31pCI;EACE,aAAA;AxJ61pCN;AwJ31pCI;EACE,cAAA;AxJ61pCN;AwJ31pCI;EACE,kBAAA;AxJ61pCN;AwJ51pCM;EACE,cjJxSY;APsoqCpB;AwJ51pCU;EACE,WjJ9VH;AP4rqCT;AwJ11pCM;EAEE,6BAAA;AxJ21pCR;AwJx1pCI;EACE,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;AxJ01pCN;AwJz1pCM;EACE,oBAAA;AxJ21pCR;AwJx1pCI;EACE,cjJ9Tc;APwpqCpB;AwJx1pCQ;EACE,WjJpXD;AP8sqCT;AwJr1pCI;EACE,yBjJvUc;AP8pqCpB;AwJr1pCI;EACE,WAAA;EACA,gBAAA;AxJu1pCN;AwJt1pCM;EACE,gBAAA;EACA,gBAAA;AxJw1pCR;AwJn1pCE;EACE,kBAAA;AxJq1pCJ;AwJp1pCI;EACE,kBAAA;EACA,sBjJyaa;EiJxab,QAAA;EACA,gB3DnPa;E2DoPb,cAAA;EACA,2BAAA;EACA,eAAA;EACA,cjJ7WQ;EiJ8WR,8DAAA;AxJs1pCN;AwJp1pCQ;EAEE,+BAAA;AxJq1pCV;AwJj1pCI;EAIE,wCAAA;EACA,yBAAA;AxJg1pCN;AwJp1pCM;EACE,yCAAA;AxJs1pCR;AwJj1pCI;EACE,eAnYgB;EAoYhB,sBAAA;EACA,sBAAA;EACA,cjJhYQ;EiJiYR,6CAAA;AxJm1pCN;AwJh1pCE;EACE,qBAAA;EACA,iBApYiB;EAqYjB,oBAtYkB;EAuYlB,cjJzYU;EiJ0YV,cAAA;AxJk1pCJ;AwJ/0pCI;EACE,cjJ9Xc;AP+sqCpB;;AkB/sqCI;EsIsYI;IACE,UAAA;IACA,uBAAA;ExJ60pCR;EwJ30pCM;IAEE,gBAAA;IACA,UAAA;IACA,oBAAA;ExJ40pCR;EwJ10pCM;IACE,wBAAA;ExJ40pCR;EwJ10pCM;IACE,oBAAA;ExJ40pCR;EwJ10pCM;IACE,kBAAA;ExJ40pCR;EwJ30pCQ;IACE,UAAA;ExJ60pCV;EwJ10pCU;IACE,kBAAA;IACA,WAAA;IACA,WAAA;IACA,WAAA;IACA,OAAA;IACA,QAAA;IACA,yBjJldF;EP8xqCV;EwJh0pCc;IACE,yBjJuQY;EP2jpC5B;EwJpzpCc;IACE,yBjJqPkB;EPikpClC;EwJ7ypCI;IACE,kCAAA;ExJ+ypCN;EwJ7ypCI;IACE,mBAAA;ExJ+ypCN;AACF;AwJxypCA;EACE,aAAA;AxJ0ypCF;AwJxypCI;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,uBAAA;EACA,cjJ5eQ;EiJ6eR,kCjJpXe;EiJqXf,gBjJ1WO;APopqCb;AwJzypCM;EACE,cA7fgB;AxJwyqCxB;AwJxypCQ;EACE,cjJxeU;APkxqCpB;AwJtypCI;EACE,eA/dmB;EAgenB,cjJ1ec;APkxqCpB;AwJvypCM;EACE,eAAA;AxJyypCR;AwJtypCI;EACE,ejJnZO;EiJoZP,qBAregB;AxJ6wqCtB;;AwJ7xpCQ;EAEE,oBAAA;AxJ+xpCV;AwJ7xpCQ;EACE,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,iBAAA;EACA,8BAAA;AxJ+xpCV;AwJ9xpCU;EACE,oBAAA;AxJgypCZ;AwJpxpCY;EACE,uCAAA;AxJsxpCd;;AyJr2qCI;EACI,gBAAA;EACA,gBlJMC;EkJLD,6BAAA;EACA,iBAAA;EACA,kDAAA;AzJw2qCR;AyJv2qCQ;EACI,mBlJ8xBwB;AP2kpCpC;AyJv2qCQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AzJy2qCZ;AyJv2qCQ;EACI,clJ2BE;AP80qCd;AyJx2qCY;EACI,cAAA;AzJ02qChB;AyJz2qCgB;EACI,clJuCA;APo0qCpB;;AkBp0qCI;EuI/BI;IACI,kBAAA;EzJu2qCV;AACF;AkB10qCI;EuIvBQ;IACI,kBAAA;IACA,mBAAA;EzJo2qCd;AACF;AyJh2qCA;EAGY;IACI,kBAAA;IACA,mBAAA;EzJg2qCd;AACF;A0Jj5qCI;EACI,kBAAA;EACA,aAAA;A1Jm5qCR;A0Jl5qCQ;EACI,iBAAA;A1Jo5qCZ;A0Jl5qCQ;EACI,kBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;A1Jo5qCZ;AkBn2qCI;EwIhDQ;IAEQ,YAAA;E1Jq5qClB;AACF;A0Jl5qCQ;EACI,YAAA;EACA,cAAA;A1Jo5qCZ;;AkB/1qCI;EwI9CI;IACI,YAAA;E1Ji5qCV;AACF;AkBr2qCI;EwIvCA;IAEQ,eAAA;E1J84qCV;AACF;AkB12qCI;EwIlCA;IAEQ,eAAA;E1J84qCV;AACF;AkB/2qCI;EwI7BA;IAEQ,eAAA;E1J84qCV;AACF;AkBp3qCI;EwIxBA;IAEQ,eAAA;E1J84qCV;AACF;AkBz3qCI;EwInBA;IAEQ,eAAA;E1J84qCV;AACF;;AoJh8qCA,kBAAA;AOPA;EACI,WAAA;EACA,eAAA;A3J28qCJ;;A2Jz8qCA;EACI,qBAAA;A3J48qCJ;;A2J18qCA;EACI,gBAAA;A3J68qCJ;;A2J38qCA;EACC,6BAAA;A3J88qCD;;A2J58qCA;EACI,aAAA;A3J+8qCJ;;A4J39qCI;EACI,oBAAA;A5J89qCR;A4J79qCQ;EACI,qBAAA;A5J+9qCZ;;A4J59qCI;EACI,yBAAA;EACA,0BAAA;A5J+9qCR;A4J99qCQ;EACI,0BAAA;EACA,2BAAA;A5Jg+qCZ;;A4J79qCI;EACI,wBAAA;EACA,2BAAA;A5Jg+qCR;A4J/9qCQ;EACI,yBAAA;EACA,4BAAA;A5Ji+qCZ;;A4Jp/qCI;EACI,6BAAA;A5Ju/qCR;A4Jt/qCQ;EACI,6BAAA;A5Jw/qCZ;;A4Jr/qCI;EACI,kCAAA;EACA,mCAAA;A5Jw/qCR;A4Jv/qCQ;EACI,kCAAA;EACA,mCAAA;A5Jy/qCZ;;A4Jt/qCI;EACI,iCAAA;EACA,oCAAA;A5Jy/qCR;A4Jx/qCQ;EACI,iCAAA;EACA,oCAAA;A5J0/qCZ;;A4J7grCI;EACI,4BAAA;A5JghrCR;A4J/grCQ;EACI,4BAAA;A5JihrCZ;;A4J9grCI;EACI,iCAAA;EACA,kCAAA;A5JihrCR;A4JhhrCQ;EACI,iCAAA;EACA,kCAAA;A5JkhrCZ;;A4J/grCI;EACI,gCAAA;EACA,mCAAA;A5JkhrCR;A4JjhrCQ;EACI,gCAAA;EACA,mCAAA;A5JmhrCZ;;A4JtirCI;EACI,0BAAA;A5JyirCR;A4JxirCQ;EACI,0BAAA;A5J0irCZ;;A4JvirCI;EACI,+BAAA;EACA,gCAAA;A5J0irCR;A4JzirCQ;EACI,+BAAA;EACA,gCAAA;A5J2irCZ;;A4JxirCI;EACI,8BAAA;EACA,iCAAA;A5J2irCR;A4J1irCQ;EACI,8BAAA;EACA,iCAAA;A5J4irCZ;;A4J/jrCI;EACI,2BAAA;A5JkkrCR;A4JjkrCQ;EACI,2BAAA;A5JmkrCZ;;A4JhkrCI;EACI,gCAAA;EACA,iCAAA;A5JmkrCR;A4JlkrCQ;EACI,gCAAA;EACA,iCAAA;A5JokrCZ;;A4JjkrCI;EACI,+BAAA;EACA,kCAAA;A5JokrCR;A4JnkrCQ;EACI,+BAAA;EACA,kCAAA;A5JqkrCZ;;A4JxlrCI;EACI,4BAAA;A5J2lrCR;A4J1lrCQ;EACI,4BAAA;A5J4lrCZ;;A4JzlrCI;EACI,iCAAA;EACA,kCAAA;A5J4lrCR;A4J3lrCQ;EACI,iCAAA;EACA,kCAAA;A5J6lrCZ;;A4J1lrCI;EACI,gCAAA;EACA,mCAAA;A5J6lrCR;A4J5lrCQ;EACI,gCAAA;EACA,mCAAA;A5J8lrCZ;;A4JjnrCI;EACI,wBAAA;A5JonrCR;A4JnnrCQ;EACI,wBAAA;A5JqnrCZ;;A4JlnrCI;EACI,6BAAA;EACA,8BAAA;A5JqnrCR;A4JpnrCQ;EACI,6BAAA;EACA,8BAAA;A5JsnrCZ;;A4JnnrCI;EACI,4BAAA;EACA,+BAAA;A5JsnrCR;A4JrnrCQ;EACI,4BAAA;EACA,+BAAA;A5JunrCZ;;A4JlnrCA;EACI,WAAA;EACA,cAAA;EACA,YrJkIqB;APm/qCzB;;A4JlnrCI;EACI,SvJmGE;ALkhrCV;;A4JtnrCI;EACI,gBvJmGE;ALshrCV;;A4J1nrCI;EACI,evJmGE;AL0hrCV;;A4J9nrCI;EACI,YvJmGE;AL8hrCV;;A4JlorCI;EACI,cvJmGE;ALkirCV;;A4JtorCI;EACI,evJmGE;ALsirCV;;A4J1orCI;EACI,YvJmGE;AL0irCV;;A4JvorCI;EACI,eAHD;A5J6orCP;;A4J3orCI;EACI,eAHD;A5JiprCP;;A4J/orCI;EACI,YAHD;A5JqprCP;;A4JnprCI;EACI,cAHD;A5JyprCP;;A4JhprCI;EACI,YAAA;A5JmprCR;;A4JpprCI;EACI,YAAA;A5JuprCR;;A4JxprCI;EACI,YAAA;A5J2prCR;;A4J5prCI;EACI,YAAA;A5J+prCR;;A4JhqrCI;EACI,YAAA;A5JmqrCR;;A4JpqrCI;EACI,YAAA;A5JuqrCR;;A4JxqrCI;EACI,YAAA;A5J2qrCR;;A4J5qrCI;EACI,YAAA;A5J+qrCR;;A4JhrrCI;EACI,YAAA;A5JmrrCR;;A4JprrCI;EACI,aAAA;A5JurrCR;;A6JjurCQ;EACI,UAAA;EACA,WAAA;A7JourCZ;;A6JturCQ;EACI,qBAAA;EACA,WAAA;A7JyurCZ;;A6J3urCQ;EACI,UAAA;EACA,WAAA;A7J8urCZ;;AoJ3urCA,oBAAA;AUTI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;A9JwvrCR;A8JtvrCI;EACI,oBAAA;EACA,mBAAA;A9JwvrCR;A8JvvrCQ;EACI,iBAAA;A9JyvrCZ;;A+J9trCA;EACI,kBxJmGa;EwJlGb,gBxJ9BK;AP+vrCT;A+JhurCI;EACI,sBAAA;A/JkurCR;A+JhurCI;EACI,kBxJ6FS;APqorCjB;A+J9trCY;EACI,gCAAA;A/JgurChB;A+J9trCY;EACI,gCAAA;A/JgurChB;A+J5trCY;EACI,6BAAA;A/J8trChB;A+J1trCI;EACI,kCAAA;EACA,cAAA;EACA,kBAAA;A/J4trCR;A+J3trCQ;EACI,gBAAA;EACA,eAAA;EACA,cxJrBI;EwJsBJ,gBAAA;A/J6trCZ;A+J1trCY;EACI,cxJ5BF;APwvrCd;A+JxtrCI;EACI,6BAAA;A/J0trCR;A+JxtrCI;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,eAAA;EACA,cxJtCQ;EwJuCR,2BAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;A/J0trCR;A+JztrCQ;EACI,gBlEsEI;EkErEJ,sBxJ8tBO;EwJ7tBP,gBAAA;A/J2trCZ;A+J1trCY;EACI,gBlEmEE;A7FyprClB;;A+JvtrCA;EAEQ;IACI,oBAAA;E/JytrCV;E+JvtrCM;IACI,4BAAA;E/JytrCV;E+JvtrCM;IACI,aAAA;E/JytrCV;AACF;A+JptrCA;EACI,YAAA;A/JstrCJ;A+JrtrCI;EACI,QAAA;A/JutrCR;A+JttrCQ;EACI,gBlE+MD;A7FygrCX;A+JrtrCI;EACI,gCAAA;EACA,uBAAA;A/JutrCR;A+JttrCQ;EACI,iBAAA;EACA,cxJtEQ;AP8xrCpB;A+JrtrCY;EACI,cxJzFF;APgzrCd;A+JptrCgB;EACI,gBlE8LV;A7FwhrCV;A+JjtrCI;EACI,0BAAA;EACA,uBAAA;A/JmtrCR;;A+J/srCA;EAGY;IACI,gCAAA;E/JgtrCd;E+J9srCU;IACI,0BAAA;E/JgtrCd;AACF;A+J1srCA;EACI,YAAA;A/J4srCJ;A+J3srCI;EACI,OAAA;EACA,WAAA;A/J6srCR;A+J5srCQ;EACI,gBlEgKD;A7F8irCX;A+J3srCI;EACI,gCAAA;EACA,uBAAA;A/J6srCR;A+J5srCQ;EACI,iBAAA;EACA,cxJrHQ;APm0rCpB;A+J3srCY;EACI,cxJxIF;APq1rCd;A+J1srCgB;EACI,gBlE+IV;A7F6jrCV;A+JvsrCI;EACI,0BAAA;EACA,uBAAA;A/JysrCR;;A+JrsrCA;EAGY;IACI,gCAAA;E/JssrCd;E+JpsrCU;IACI,gCAAA;E/JssrCd;AACF;AgKz4rCA;EACI,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AhK24rCJ;AgKz4rCQ;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gBzJdH;EyJeG,WAAA;EACA,sBAAA;AhK24rCZ;AgKx4rCI;EACI,kBAAA;AhK04rCR;AgKz4rCQ;EACI,kBAAA;AhK24rCZ;;AgKt4rCI;EACI,WAnCJ;EAoCI,UApCJ;AhK66rCJ;;AgK34rCI;EACI,WAnCJ;EAoCI,UApCJ;AhKk7rCJ;;AgKh5rCI;EACI,WAnCJ;EAoCI,UApCJ;AhKu7rCJ;;AgKr5rCI;EACI,YAnCJ;EAoCI,WApCJ;AhK47rCJ;;AgK15rCI;EACI,YAnCJ;EAoCI,WApCJ;AhKi8rCJ;;AgK/5rCI;EACI,YAnCJ;EAoCI,WApCJ;AhKs8rCJ;;AgK95rCI;EACI,mBAAA;AhKi6rCR;;AgKl6rCI;EACI,mBAAA;AhKq6rCR;;AgKt6rCI;EACI,mBAAA;AhKy6rCR;;AgK16rCI;EACI,mBAAA;AhK66rCR;;AgK96rCI;EACI,mBAAA;AhKi7rCR;;AgKl7rCI;EACI,mBAAA;AhKq7rCR;;AgKt7rCI;EACI,mBAAA;AhKy7rCR;;AgK17rCI;EACI,mBAAA;AhK67rCR;;AgK97rCI;EACI,mBAAA;AhKi8rCR;;AgKl8rCI;EACI,mBAAA;AhKq8rCR;;AiKv+rCI;EACI,mB1JoOoB;APswrC5B;AiKx+rCI;EACI,kBAAA;EACA,oBAAA;EACA,mBAAA;AjK0+rCR;AiKz+rCQ;EACI,sBAAA;AjK2+rCZ;AiKz+rCQ;EACI,kBAAA;EACA,OAAA;EACA,e1JqIC;E0JpID,mBAAA;EACA,sB1JoyBO;E0JnyBP,gBpEySK;A7FksrCjB;AiKz+rCQ;EACI,c1JgBE;AP29rCd;AiKz+rCQ;EACI,kBAAA;AjK2+rCZ;AiKv+rCQ;EACI,c1JwBQ;E0JvBR,gBpEsRM;A7FmtrClB;AiKt+rCY;EACI,c1JmBI;E0JlBJ,gBpEgRO;A7FwtrCvB;AiKn+rCQ;EACI,6BAAA;EACA,gBpEgQM;A7FqurClB;AiKl+rCI;EACI,gBAAA;EACA,gBAAA;AjKo+rCR;AiKn+rCQ;EACI,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;AjKq+rCZ;AiKn+rCQ;EACI,sBAAA;EACA,gBAAA;AjKq+rCZ;AiKj+rCQ;EACI,kBAAA;AjKm+rCZ;AiKl+rCY;EACI,uBAAA;AjKo+rChB;AiKl+rCY;EACI,kBAAA;AjKo+rChB;AiK/9rCQ;EACI,oBAAA;AjKi+rCZ;AiKh+rCY;EACI,uBAAA;AjKk+rChB;AiKh+rCY;EACI,e1JqEH;AP65rCb;AiK79rCQ;EACI,c1J9CE;E0J+CF,gBAAA;AjK+9rCZ;AiK99rCY;EACI,gBpEkOJ;A7F8vrCZ;AiK79rCgB;EACI,c1JlDJ;APihsChB;AiK99rCoB;EACI,gBpEkbd;EoEjbc,c1JxCJ;APwgsCpB;AiK79rCgB;EACI,c1J3DN;AP0hsCd;AiK99rCoB;EACI,gBpEkNF;EoEjNE,c1J7Ef;AP6isCT;AiKz9rCQ;EACI,c1JtEE;E0JuEF,cAAA;EACA,gBAAA;EACA,iBAAA;AjK29rCZ;AiK19rCY;EACI,c1J5DI;APwhsCpB;AiKv9rCQ;EACI,gB1JkDC;APu6rCb;AiKr9rCQ;EACI,qBAAA;EACA,gBAAA;AjKu9rCZ;AiKt9rCY;EACI,iBAAA;EACA,kBAAA;AjKw9rChB;;AiK/8rCQ;EACI,c5JtGG;ALwjsCf;;AiKn9rCQ;EACI,c5JtGG;AL4jsCf;;AiKv9rCQ;EACI,c5JtGG;ALgksCf;;AiK39rCQ;EACI,c5JtGG;ALoksCf;;AiK/9rCQ;EACI,c5JtGG;ALwksCf;;AiKn+rCQ;EACI,c5JtGG;AL4ksCf;;AiKv+rCQ;EACI,c5JtGG;ALglsCf;;AiK3+rCQ;EACI,c5JtGG;ALolsCf;;AiK/+rCQ;EACI,c5JtGG;ALwlsCf;;AiKn/rCQ;EACI,c5JtGG;AL4lsCf;;AkKnosCA;EACI,6BAAA;AlKsosCJ;;AkKposCA;EACI,gCAAA;AlKuosCJ;;AkKrosCA;EACI,iBAAA;AlKwosCJ;;AkKrosCI;EACI,gBrEqSS;EqEpST,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,sB3JwyBW;APg2qCnB;;AkKlosCA;EACI,iBAAA;AlKqosCJ;AkKjosCI;EACI,gBAAA;AlKmosCR;AkKjosCI;EACI,cAAA;AlKmosCR;AkKlosCQ;EACI,cAAA;EACA,oBAAA;EACA,qBAAA;AlKoosCZ;AkKlosCQ;EACI,yBAAA;EACA,c3JII;E2JHJ,gBAAA;EACA,e3J4GC;E2J3GD,mBAAA;AlKoosCZ;AkKlosCQ;EACI,aAAA;EACA,mBAAA;EACA,c3JNE;E2JOF,e3JsGC;E2JrGD,kBAAA;AlKoosCZ;AkKnosCY;EACI,c3JKI;E2JJJ,mB3JlCN;APuqsCV;AkKlosCQ;EACI,cAAA;EACA,mBAAA;AlKoosCZ;AkKrnsCI;EACI,iBAAA;AlKunsCR;AkKtnsCQ;EACI,mBAAA;AlKwnsCZ;AkKrnsCI;EACI,gBAAA;AlKunsCR;AkKrnsCI;EACI,kBAAA;EACA,wBAAA;EACA,mBAAA;AlKunsCR;AkK3msCA;EACI,kBAAA;AlK6msCJ;AkKzmsCI;EACI,gBAAA;AlK2msCR;AkKzmsCI;EACI,aAAA;EACA,mBAAA;EACA,c3JlEM;E2JmEN,e3J0CK;E2JzCL,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AlK2msCR;AkK1msCQ;EACI,c3J1DQ;APsqsCpB;AkK1msCQ;EACI,mBAAA;EACA,aAAA;EACA,cAAA;AlK4msCZ;;AkKjmsCI;EACI,iBAAA;AlKomsCR;AkKnmsCQ;EACI,mBAAA;AlKqmsCZ;AkKlmsCI;EACI,gBAAA;AlKomsCR;AkKlmsCI;EACI,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,e3JMK;E2JLL,gB3J4BK;E2J3BL,c3JxGM;E2JyGN,oBAAA;EACA,mBAAA;EACA,kBAAA;AlKomsCR;AkKnmsCQ;EACI,c3J9FQ;E2J+FR,mB3JrIF;AP0usCV;AkKnmsCQ;EACI,mBAAA;EACA,cAAA;EACA,YAAA;AlKqmsCZ;AkK/lsCI;EACI,oBAAA;EACA,c3J5HM;E2J6HN,YAAA;AlKimsCR;AkK/lsCI;EACI,wBAAA;EACA,c3JjIM;APkusCd;AkK9lsCQ;EACI,gB3JFC;APkmsCb;AkK7lsCI;EACI,oBAAA;AlK+lsCR;AkK3lsCQ;EACI,c3J9HQ;AP2tsCpB;;AkKxlsCA;EACI,iBAAA;EACA,gBAAA;AlK2lsCJ;AkKvlsCI;EACI,iBAAA;AlKylsCR;AkKxlsCQ;EACI,mBAAA;AlK0lsCZ;AkKvlsCI;EACI,gBAAA;AlKylsCR;AkKvlsCI;EACI,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,e3JzDK;E2J0DL,gB3JnCK;E2JoCL,c3JvKM;E2JwKN,oBAAA;EACA,mBAAA;EACA,kBAAA;AlKylsCR;AkKxlsCQ;EACI,c3J7JQ;E2J8JR,mB3JpMF;AP8xsCV;AkKxlsCQ;EACI,mBAAA;EACA,cAAA;EACA,YAAA;AlK0lsCZ;AkKplsCI;EACI,oBAAA;EACA,c3J3LM;E2J4LN,YAAA;AlKslsCR;AkKplsCI;EACI,wBAAA;EACA,c3JhMM;APsxsCd;AkKnlsCQ;EACI,gB3JjEC;APspsCb;AkKllsCI;EACI,oBAAA;AlKolsCR;AkKjlsCQ;EACI,c3J5LQ;AP+wsCpB;;AkK3ksCA;EACI,kBAAA;AlK8ksCJ;AkK7ksCI;EACI,gBAAA;AlK+ksCR;AkK7ksCI;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,gBAAA;EACA,c3J9NM;E2J+NN,oBAAA;EACA,mBAAA;AlK+ksCR;AkK9ksCQ;EACK,kBAAA;EACD,eAAA;EACA,sB3J2iBO;E2J1iBP,cAAA;EACA,gBrEjHO;EqEkHP,c3JxOE;E2JyOF,qBAAA;AlKglsCZ;AkK9ksCQ;EACI,mBAAA;EACA,cAAA;EACA,YAAA;EACA,c3J/OE;E2JgPF,gBAAA;AlKglsCZ;AkK7ksCI;EACK,c3JpOW;APmzsCpB;AkK7ksCI;EACI,cAAA;AlK+ksCR;;AkBtzsCI;EgJ6OI;IACI,oBAAA;ElK6ksCV;AACF;AkKlksCI;EACI,iBAAA;AlKoksCR;AkKnksCQ;EACI,mBAAA;AlKqksCZ;AkKlksCI;EACI,gBAAA;AlKoksCR;AkKlksCI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,c3JtRM;E2JuRN,oBAAA;EACA,mBAAA;EACA,kBAAA;AlKoksCR;AkKnksCQ;EACI,c3J5QQ;E2J6QR,mB3JnTF;APw3sCV;AkKnksCQ;EACI,mBAAA;EACA,cAAA;EACA,YAAA;EACA,c3JnRQ;APw1sCpB;AkKlksCI;EACI,c3JvRY;E2JwRZ,mB3J9TE;APk4sCV;AkK5jsCQ;EACI,uBAAA;EACA,qBAAA;EACA,sBAAA;AlK8jsCZ;;AkKvjsCQ;EACI,+BAAA;EACA,gCAAA;EACA,aAAA;AlK0jsCZ;AkKxjsCQ;EACI,kBAAA;AlK0jsCZ;;AkKhksCQ;EACI,+BAAA;EACA,gCAAA;EACA,aAAA;AlKmksCZ;AkKjksCQ;EACI,kBAAA;AlKmksCZ;;AkKzksCQ;EACI,+BAAA;EACA,gCAAA;EACA,aAAA;AlK4ksCZ;AkK1ksCQ;EACI,kBAAA;AlK4ksCZ;;AkKnksCI;EACI,gB3JvMK;AP6wsCb;;AmKv7sCI;EACI,aAAA;AnK07sCR;AmKz7sCQ;EACI,cAAA;AnK27sCZ;AmK17sCY;EACI,aAAA;AnK47sChB;AmK17sCY;EACI,cAAA;AnK47sChB;AmKx7sCY;EACI,cAAA;AnK07sChB;AmKx7sCY;EACI,aAAA;AnK07sChB;;AmKn7sCA;EACI,kBAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,c5JOU;AP+6sCd;AmKr7sCI;EACI,gBAAA;AnKu7sCR;AmKp7sCQ;EACI,oBAAA;AnKs7sCZ;;AmKh7sCA;EACI,kBAAA;EACA,U5JyVoC;E4JxVpC,Q5JwVoC;E4JvVpC,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,c5JIgB;E4JHhB,kBAAA;EACA,sBAAA;EACA,gB5JlDK;E4JmDL,kB5J6Ea;APs2sCjB;AmKl7sCI;EACI,2B5JwVgC;AP4lsCxC;AmKl7sCI;EACI,4B5JsVgC;AP8lsCxC;AmKl7sCI;EACI,2B5JoVgC;APgmsCxC;AmKl7sCI;EACI,oBAAA;AnKo7sCR;;AmK76sCI;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,4BAAA;EACA,SAAA;EACA,UAAA;AnKg7sCR;AmK96sCI;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,kB5J2CS;E4J1CT,0BAAA;EACA,iBAAA;AnKg7sCR;AmK96sCI;EACI,cAAA;EACA,kBAAA;AnKg7sCR;AmK96sCI;EACI,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;AnKg7sCR;AmK/6sCQ;EACI,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AnKi7sCZ;AmKh7sCY;EACI,WAAA;EACA,cAAA;EACA,kB5JkBC;APg6sCjB;AmK76sCgB;EACI,WAAA;AnK+6sCpB;AmK76sCgB;EACI,aAAA;AnK+6sCpB;AmK16sCI;EACI,kBAAA;EACA,c5J1FM;E4J2FN,oBAAA;EACA,gB5JuCK;E4JtCL,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AnK46sCR;AmK16sCI;EACI,iBAAA;EACA,oBAAA;EACA,mBAAA;AnK46sCR;AmK36sCQ;EACI,e5JKC;E4JJD,c5JzGE;APshtCd;AmK56sCY;EACI,mBAAA;AnK86sChB;AmK16sCY;EACI,sB5JgqBG;AP4wrCnB;AmK16sCY;EACI,mBAAA;AnK46sChB;AmKx6sCY;EACI,c5JvIP;APijtCT;AmKz6sCgB;EACI,gBtE+NJ;A7F4ssChB;AmKt6sCY;EACI,c5J9IP;APsjtCT;AmKv6sCgB;EACI,gBtE4IG;A7F6xsCvB;AmKp6sCY;EACI,c5JxJR;AP8jtCR;AmKr6sCgB;EACI,gBtE0HG;A7F6ysCvB;AmKl6sCI;EACI,aAAA;EACA,8BAAA;EACA,8BAAA;EACA,qBAAA;EACA,iBAAA;AnKo6sCR;AmKn6sCQ;EACI,eAAA;AnKq6sCZ;;AmK95sCQ;EACI,0BAAA;AnKi6sCZ;AmK95sCI;EACI,yBAAA;EACA,aAAA;EACA,0BAAA;EACA,uBAAA;AnKg6sCR;AmK/5sCQ;EACI,eAAA;AnKi6sCZ;AmKh6sCY;EACI,c5JzKF;AP2ktCd;AmKh6sCY;EACI,qBAAA;AnKk6sChB;AmK95sCI;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AnKg6sCR;AmK/5sCQ;EACI,gBAAA;EACA,mBAAA;AnKi6sCZ;AmK75sCQ;EACI,oBAAA;AnK+5sCZ;AmK55sCI;EACI,iBAAA;AnK85sCR;;AmKx5sCA;EAGI,qBAAA;AnK25sCJ;;AmKz5sCA;;EAEI,wBAAA;AnK45sCJ;;AmKx5sCI;EACI,sBAAA;EACA,uBAAA;EACA,kBAAA;AnK25sCR;AmK15sCQ;EACI,qB5JpPA;APgptCZ;AmK15sCQ;EACI,kBAAA;EACA,MAAA;AnK45sCZ;AmKz5sCI;EACI,QAAA;EACA,yBAAA;EACA,4BAAA;AnK25sCR;AmKz5sCI;EACI,OAAA;EACA,0BAAA;EACA,6BAAA;AnK25sCR;;AmKt5sCA;EACI,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,yB5JpQM;E4JqQN,yBAAA;EACA,kBAAA;EACA,kB5JpJa;AP6itCjB;AmKx5sCI;EACI,eAAA;EACA,0BAAA;EACA,6BAAA;AnK05sCR;AmKx5sCI;EACI,cAAA;EACA,yBAAA;EACA,4BAAA;AnK05sCR;;AoK5rtCA;EACI,kC7JgKiB;E6J/JjB,iB7J0MoB;E6JzMpB,gB7J0KS;APqhtCb;;AoK5rtCA;EACI;IACI,kB7JqMgB;EP0/sCtB;AACF;AqK1stCA;EACE,e9JqJW;E8JpJX,gBAAA;EACA,qBAAA;EACA,c9JsCY;E8JrCZ,yBAAA;EACA,gB9JyKW;E8JxKX,oFhK2J4B;ALijtC9B;AqK3stCE;EACE,c9JiCU;AP4qtCd;AqK1stCI;EACE,cAAA;ArK4stCN;AqKxstCI;EACE,c9JoCc;APsqtCpB;AqKvstCE;EACE,oFhK4I0B;EgK3I1B,gB9JwJS;E8JvJT,gBAAA;EACA,sBAAA;EACA,e9J4HS;E8J3HT,c9JeU;E8JdV,yBAAA;ArKystCJ;AqKvstCM;EACE,c9JWM;AP8rtCd;AqKrstCM;EACE,c9JkBY;APqrtCpB;AqKnstCE;EACE,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,c9JLU;AP0stCd;AqKpstCI;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,mB9JbQ;APmttCd;AqKpstCI;EACE,WAAA;ArKsstCN;AqKpstCI;EACE,UAAA;ArKsstCN;;AqKlstCA;EACE,e9J0FW;E8JzFX,gB9J2GW;E8J1GX,gBAAA;EACA,uBAAA;ArKqstCF;AqKpstCE;EACE,kBAAA;EACA,cAAA;ArKsstCJ;;AqKlstCA;EACE,mBAAA;EACA,gBAAA;EACA,c9JjCc;E8JkCd,cAAA;ArKqstCF;AqKpstCE;EACE,e9JsES;APgotCb;AqKpstCE;EACE,c9JzCU;E8J0CV,gBAAA;ArKsstCJ;AqKpstCE;EACE,mBAAA;EACA,gBAAA;EACA,c9J7CY;E8J8CZ,cAAA;ArKsstCJ;AqKpstCM;EACE,W9JvFC;AP6xtCT;AqKpstCM;EACE,c9JpDQ;AP0vtChB;AqKjstCI;EACE,c9J1FM;AP6xtCZ;AqKlstCM;EACE,c9J3FI;AP+xtCZ;AqK/rtCI;EACE,W9JxGG;APyytCT;AqKhstCM;EACE,c9J3DY;AP6vtCpB;AqK7rtCI;EACE,c9J1EU;APywtChB;AqK9rtCM;EACE,c9J9EM;AP8wtCd;;AqK3rtCA;EACE,cAAA;EACA,e9JwBW;E8JvBX,c9JvFY;APqxtCd;AqK7rtCE;EACE,oBAAA;ArK+rtCJ;AqK7rtCE;EACE,e9JiBS;AP8qtCb;AqK7rtCE;EACE,c9J/FU;AP8xtCd;AqK9rtCI;EACE,c9JrFc;APqxtCpB;AqK9rtCI;EACE,c9JpGQ;APoytCd;AqK7rtCE;EACE,eAAA;ArK+rtCJ;AqK7rtCE;EACE,c9J1GU;E8J2GV,gBAAA;ArK+rtCJ;AqK7rtCM;EACE,c9JnGY;APkytCpB;AqK7rtCM;EACE,c9JjHM;APgztCd;AqK3rtCE;EACE,mBAAA;ArK6rtCJ;AqK1rtCI;EACE,c9J/Gc;AP2ytCpB;AqK1rtCI;EACE,c9J9HQ;AP0ztCd;;AqKtrtCE;EACE,c9JpIU;AP6ztCd;;AqKrrtCE;EACE,mBAAA;ArKwrtCJ;;AqKrrtCA;EACE,c9JpCU;AP4ttCZ;;AqKtrtCA;EACE,e9JtCW;AP+ttCb;;AqKvrtCA;EACE,e9JxCW;APkutCb;;AqKxrtCA;EACE,e9J1CW;APqutCb;;AqKzrtCA;EACE,e9J5CW;APwutCb;;AqK1rtCA;EACE,e9J9CW;AP2utCb;;AqK3rtCA;EACE,e9JhDW;AP8utCb;;AqK5rtCA;EACE,e9JlDW;APivtCb;;AqK7rtCA;EACE,eAAA;ArKgstCF;;AqK9rtCA;EACE,eAAA;ArKistCF;;AqK/rtCA;EACE,eAAA;ArKkstCF;;AqKhstCA;EACE,eAAA;ArKmstCF;;AqKjstCA;EACE,eAAA;ArKostCF;;AqKlstCA;EACE,eAAA;ArKqstCF;;AqKlstCA;EACE,e9J5EW;E8J6EX,kBAAA;EACA,c9J3LY;APg4tCd;;AsK36tCI;EACI,gBAAA;AtK86tCR;AsK56tCY;EACI,gBAAA;AtK86tChB;AsKz6tCgB;EACI,8B/J8HH;AP6ytCjB;AsKz6tCgB;EACI,+B/J2HH;APgztCjB;AsKv6tCgB;EACI,2B/JsHH;APmztCjB;AsKv6tCgB;EACI,4B/JmHH;APsztCjB;AsKp6tCI;EACI,gBAAA;AtKs6tCR;AsKp6tCI;EACI,gBAAA;AtKs6tCR;AsKl6tCY;EACI,gCAAA;AtKo6tChB;;AkB/3tCI;EoJ7BQ;IACI,oBAAA;IACA,qBAAA;EtKg6tCd;AACF;AkBn5tCI;EoJNQ;IACI,+BAAA;EtK45tCd;EsK15tCkB;IACI,mBAAA;EtK45tCtB;AACF;AkB35tCI;EoJOI;IACI,eAAA;EtKu5tCV;AACF;AsKj5tCA;EACI,YAAA;EACA,sB/JpEK;E+JqEL,iBAAA;EACA,cAAA;AtKm5tCJ;AsKl5tCI;EACI,SAAA;EACA,+BAAA;AtKo5tCR;AsKl5tCI;EACI,UAAA;EACA,8BAAA;AtKo5tCR;AsKl5tCI;EACI,aAAA;AtKo5tCR;AsKn5tCQ;EACI,YAAA;AtKq5tCZ;;AkBv6tCI;EoJyBI;IACI,iBAAA;EtKk5tCV;AACF;AkB76tCI;EoJiCI;IACI,iBAAA;EtK+4tCV;AACF;AkBl7tCI;EoJyCI;IACI,iBAAA;EtK44tCV;AACF;AkBv7tCI;EoJiDI;IACI,iBAAA;EtKy4tCV;AACF;AkBz8tCI;EoJsEA;IACI,gBAAA;IACA,cAAA;EtKs4tCN;AACF;AkB/8tCI;EoJ4EA;IACI,YAAA;EtKs4tCN;AACF;AuK9guCA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EAGA,gBhKmKS;EgKlKT,iBAAA;EACA,cAAA;EAEA,kBAAA;AvK6guCJ;AuK5guCI;EACI,iBAAA;EACA,kBAAA;AvK8guCR;AuK5guCI;EACI,oBAAA;AvK8guCR;AuK5guCI;EACI,kBAAA;AvK8guCR;AuK3guCQ;EACI,mBAAA;AvK6guCZ;AuK3guCQ;EACI,oBAAA;AvK6guCZ;AuK1guCI;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,kBAAA;EACA,uCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WhKvCC;EgKwCD,UAAA;EACA,wBAAA;AvK4guCR;AuKzguCQ;EACI,UAAA;AvK2guCZ;AuKxguCI;EACI,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AvK0guCR;AuKxguCI;EACI,kBhKyES;APi8tCjB;AuKzguCQ;EACI,kBhKuEK;APo8tCjB;AuKzguCQ;EACI,WAAA;EACA,YAAA;AvK2guCZ;;AuKrguCA;EACI,wCAAA;AvKwguCJ;AuKvguCI;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EACA,sBAAA;AvKyguCR;AuKxguCQ;EACI,MAAA;EACA,QAAA;AvK0guCZ;AuKxguCQ;EACI,SAAA;EACA,OAAA;AvK0guCZ;;AuKrguCA;EACI,kBAAA;AvKwguCJ;AuKvguCI;EACI,cAAA;AvKyguCR;;AuKnguCI;EACI,aAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AvKsguCR;AuKrguCQ;EACI,WAAA;EACA,UAAA;AvKuguCZ;AuKpguCI;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AvKsguCR;AuKrguCQ;EACI,WAAA;EACA,UAAA;AvKuguCZ;AuKpguCI;EACI,YAAA;EACA,WAAA;EACA,eAAA;AvKsguCR;AuKrguCQ;EACI,WAAA;EACA,UAAA;AvKuguCZ;AuKpguCI;EACI,YAAA;EACA,WAAA;EACA,eAAA;AvKsguCR;AuKrguCQ;EACI,YAAA;EACA,WAAA;AvKuguCZ;AuKpguCI;EACI,YAAA;EACA,WAAA;EACA,cAAA;EACA,gBhK+BK;APu+tCb;AuKrguCQ;EACI,YAAA;EACA,WAAA;AvKuguCZ;;AuK5+tCI;EACI,cAvBY;AvKsguCpB;;AuKh/tCI;EACI,cAvBY;AvK0guCpB;;AuKp/tCI;EACI,cAvBY;AvK8guCpB;;AuKx/tCI;EACI,cAvBY;AvKkhuCpB;;AuK5/tCI;EACI,cAvBY;AvKshuCpB;;AuKhguCI;EACI,cAvBY;AvK0huCpB;;AuKpguCI;EACI,cAvBY;AvK8huCpB;;AuKxguCI;EACI,cAvBY;AvKkiuCpB;;AuK5guCI;EACI,cAvBY;AvKsiuCpB;;AuKhhuCI;EACI,cAvBY;AvK0iuCpB;;AuKphuCI;EACI,cAvBY;AvK8iuCpB;;AuKxhuCI;EACI,cAvBY;AvKkjuCpB;;AuK5huCI;EACI,cAvBY;AvKsjuCpB;;AuKhiuCI;EACI,cAvBY;AvK0juCpB;;AuKpiuCI;EACI,cAvBY;AvK8juCpB;;AuKxiuCI;EACI,cAvBY;AvKkkuCpB;;AuK5iuCI;EACI,cAvBY;AvKskuCpB;;AuKviuCI;EACI,aAAA;EACA,mBAAA;AvK0iuCR;AuKziuCQ;EACI,qBAAA;EACA,wBAAA;AvK2iuCZ;AuKziuCQ;EACI,chKrJE;APgsuCd;AuKziuCQ;EACI,kBAAA;EACA,WAAA;EACA,SAAA;AvK2iuCZ;AuKxiuCI;EACC,aAAA;EACG,mBAAA;EACA,kBAAA;AvK0iuCR;AuKxiuCI;EACI,ehKvDK;EgKwDL,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,wBAAA;AvK0iuCR;AuKziuCQ;EACI,chKzLJ;APouuCR;AuKziuCQ;EACI,chK1LH;APquuCT;AuKxiuCI;EACI,chK/KM;EgKgLN,ehKnEK;EgKoEL,iBAAA;EACA,gBhK9CK;APwluCb;AuKxiuCY;EACI,cAAA;AvK0iuChB;AuKtiuCY;EACI,chK/KI;APutuCpB;AuKpiuCI;EACI,iBAAA;EACA,eAAA;EACA,chKlMM;APwuuCd;AuKniuCQ;EACI,mBAAA;EACA,uBAAA;AvKqiuCZ;AuKliuCY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AvKoiuChB;AuKhiuCY;EACI,kBAAA;AvKkiuChB;AuKhiuCY;EACI,aAAA;AvKkiuChB;AuKjiuCgB;EACI,UAAA;AvKmiuCpB;AuKliuCoB;EACI,UAAA;AvKoiuCxB;AuKhiuCY;EACI,WAAA;EACA,eAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,yBAAA;AvKkiuChB;AuK/huCQ;EACI,eAAA;EACA,gCAAA;AvKiiuCZ;AuK/huCgB;EACI,gBAAA;EACA,iBAAA;AvKiiuCpB;AuK9huCY;EACI,cAAA;EACA,mBAAA;AvKgiuChB;AuK9huCY;EACI,iBAAA;EACA,aAAA;AvKgiuChB;AuK7huCQ;EACI,oBAAA;AvK+huCZ;AuK5huCI;EACI,iBAAA;EACA,cAAA;EACA,4BAAA;EACA,chKhPY;AP8wuCpB;AuK7huCQ;EACI,eAAA;AvK+huCZ;AuK7huCQ;EACI,ehKrJC;EgKsJD,chKrQE;EgKsQF,gBhKlIC;APiquCb;AuK9huCY;EACI,gBhKtIH;APsquCb;AuK7huCQ;EACI,ehK/JC;EgKgKD,chK9QE;AP6yuCd;AuK9huCY;EACI,chK/QF;AP+yuCd;AuK9huCY;EACI,gBAAA;AvKgiuChB;;AuKthuCA;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AvKyhuCJ;AuKxhuCI;EACI,cAAA;AvK0huCR;AuKxhuCI;EACI,8BAAA;AvK0huCR;AuKzhuCQ;EACI,uBAAA;AvK2huCZ;AuKzhuCQ;EACI,mBAAA;AvK2huCZ;;AuKnhuCI;EACI,eAAA;AvKshuCR;AuKphuCI;EACI,mBAAA;AvKshuCR;;AuKhhuCA;EACI,aAAA;AvKmhuCJ;AuKlhuCI;EACI,aAAA;EACA,eAAA;AvKohuCR;AuKlhuCI;EACI,aAAA;EACA,0BAAA;AvKohuCR;AuKlhuCI;EACI,cAAA;EACA,iBAAA;EACA,chK1UM;AP81uCd;AuKjhuCQ;EACI,cAAA;AvKmhuCZ;AuKhhuCI;EACI,mBAAA;EACA,gBAAA;EACA,gBhKhNK;EgKiNL,chKpVM;APs2uCd;AuKhhuCI;EACI,ehK3OK;EgK4OL,chKzVM;AP22uCd;AuKhhuCI;EACI,oBAAA;EACA,WAAA;EACA,iBAAA;EACA,sBAAA;AvKkhuCR;;AuK3guCI;EACI,chKtWM;EgKuWN,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AvK8guCR;AuK7guCQ;EACI,chK7WE;EgK8WF,eAAA;EACA,cAAA;EACA,oBAAA;EACA,qBAAA;AvK+guCZ;;AuKxguCA;EACI,aAAA;AvK2guCJ;AuK1guCI;EACI,sBAAA;AvK4guCR;AuK3guCQ;EACI,iBAAA;AvK6guCZ;AuK3guCQ;EACI,kBAAA;AvK6guCZ;AuK3guCQ;EACI,oBAAA;AvK6guCZ;;AuKtguCI;EACI,aAAA;EACA,mBAAA;AvKyguCR;AuKvguCI;EACI,kBAAA;EACA,chKhZM;EgKiZN,mBAAA;EACA,oBAAA;AvKyguCR;AuKxguCQ;EACI,chKpYQ;AP84uCpB;;AuKnguCA;EACI,aAAA;EACA,eAAA;EACA,8BAAA;EACA,kBAAA;AvKsguCJ;AuKrguCI;EACI,aAAA;EACA,mBAAA;EACA,chKhaQ;EgKiaR,gBhK/RK;EgKgSL,eAAA;AvKuguCR;AuKtguCQ;EACI,iBAAA;EACA,qBAAA;EACA,chKzZQ;APi6uCpB;AuKrguCI;EACI,iBAAA;AvKuguCR;AuKrguCI;EACI,ehKlUK;EgKmUL,gBhK7SK;EgK8SL,chKlbM;EgKmbN,yBAAA;EACA,kBAAA;AvKuguCR;AuKrguCI;EACI,WAAA;EACA,gBAAA;AvKuguCR;;AwKz+uCQ;EACI,kBAAA;AxK4+uCZ;AwKz+uCI;EACI,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AxK2+uCR;AwK1+uCQ;EACI,cjK+BE;EiK9BF,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,qBAAA;AxK4+uCZ;AwK1+uCQ;EACI,gCAAA;AxK4+uCZ;AwKx+uCY;EACI,cjKmBF;APu9uCd;AwKx+uCY;EACI,cjKkBA;APw9uChB;AwKt+uCI;EACI,uBAAA;EACA,sBAAA;EACA,yBjKxBI;EiKyBJ,kBjKoGS;APo4uCjB;AwKv+uCQ;EACI,gBAAA;EAIA,6BAAA;AxKs+uCZ;AwKz+uCY;EACI,gBAAA;AxK2+uChB;AwKv+uCQ;EACI,cjKDE;AP0+uCd;AwKt+uCI;EACI,YAAA;AxKw+uCR;AwKv+uCQ;EACI,qBAAA;EACA,sBAAA;AxKy+uCZ;AwKv+uCQ;EACI,YAAA;EACA,iBAAA;AxKy+uCZ;AwKt+uCI;EACI,cjKjBM;EiKkBN,WAAA;EACA,cAAA;AxKw+uCR;AwKt+uCI;EACI,cjKrBM;EiKsBN,oBAAA;AxKw+uCR;AwKt+uCI;EACI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,qBAAA;AxKw+uCR;AwKv+uCQ;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,yBAAA;EACA,WAAA;EACA,yBjK3EA;EiK4EA,kBAAA;EACA,UAAA;EACA,oBAAA;AxKy+uCZ;AwKx+uCY;EACI,UAAA;EACA,YAAA;EACA,WAAA;AxK0+uChB;AwKv+uCQ;EACI,YAAA;AxKy+uCZ;AwKt+uCY;EACI,aAAA;AxKw+uChB;;AwKj+uCI;EACI,gBAAA;AxKo+uCR;AwKj+uCQ;EACI,eAAA;EACA,gBAAA;EACA,uBAAA;AxKm+uCZ;AwKj+uCQ;EACI,gCAAA;AxKm+uCZ;AwKj+uCQ;EACI,4BjK7GA;APglvCZ;AwKj+uCQ;EACI,cjKjFE;APojvCd;AwKj+uCQ;EACI,cjKrFE;APwjvCd;;AkBxivCI;EsJ6EQ;IACI,gBAAA;ExK+9uCd;EwK59uCc;IACI,mBAAA;ExK89uClB;EwK19uCM;IACI,uBAAA;ExK49uCV;EwK19uCM;IACI,aAAA;IACA,mBAAA;ExK49uCV;EwK39uCU;IACI,YAAA;IACA,iBAAA;IACA,yBAAA;ExK69uCd;EwKz9uCU;IACI,UAAA;ExK29uCd;AACF;AwKt9uCA;EAGY;IACI,eAAA;ExKs9uCd;EwKp9uCU;IACI,WAAA;ExKs9uCd;AACF;AwKj9uCA;EACI,oBAAA;EACA,uBAAA;AxKm9uCJ;;AwKh9uCA;EACI,qBAAA;EACA,wBAAA;AxKm9uCJ;;AyK1ovCI;EACI,iBAAA;EACA,cAAA;AzK6ovCR;AyK3ovCI;EACI,aAAA;EACA,mBAAA;EACA,wBAAA;AzK6ovCR;AyK3ovCI;EACI,cAAA;EACA,qBAAA;AzK6ovCR;AyK3ovCI;EACI,elKyIK;EkKxIL,clK2BM;APknvCd;AyK5ovCQ;EACI,clK2BI;APmnvChB;AyK3ovCI;EACI,elKgIK;EkK/HL,clKmBM;AP0nvCd;;AyKxovCI;EACI,iBAAA;EACA,cAAA;AzK2ovCR;;A0KxqvCI;EACI,WnKKC;APsqvCT;A0KzqvCI;EACI,cnKwCQ;APmovChB;A0KzqvCI;EACI,aAAA;EACA,mBAAA;EACA,enK8IK;AP6hvCb;A0K1qvCQ;EACI,gBAAA;EACA,cAAA;A1K4qvCZ;A0KzqvCI;EACI,WAAA;A1K2qvCR;A0K1qvCQ;EACI,gBAAA;A1K4qvCZ;A0KzqvCI;EACI,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBnK+BY;EmK9BZ,WnKrBC;EmKsBD,eAAA;EACA,YAAA;EACA,WAAA;A1K2qvCR;A0K1qvCQ;EACI,YAAA;EACA,WAAA;EACA,eAAA;A1K4qvCZ;A0K1qvCQ;EACI,YAAA;EACA,WAAA;EACA,eAAA;A1K4qvCZ;A0K1qvCQ;EACI,YAAA;EACA,WAAA;EACA,eAAA;A1K4qvCZ;A0K1qvCQ;EACI,YAAA;EACA,WAAA;EACA,eAAA;A1K4qvCZ;A0KzqvCI;EACI,kBAAA;EACA,oBAAA;A1K2qvCR;A0K1qvCQ;EACI,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,WAAA;A1K4qvCZ;A0KzqvCY;EACI,mBnKvCR;APktvCR;A0KvqvCY;EACI,mBnK/CR;APwtvCR;A0KrqvCY;EACI,mBnKlDP;APytvCT;A0KnqvCY;EACI,mBnKxDP;AP6tvCT;A0KjqvCY;EACI,mBnK5DP;AP+tvCT;A0K/pvCY;EACI,mBnKnDF;APotvCd;A0K7pvCY;EACI,aAAA;A1K+pvChB;A0K3pvCI;EACI,oBAAA;EACA,mBAAA;EACA,2BAAA;EACA,cAAA;A1K6pvCR;A0K5pvCQ;EACI,kBAAA;EACA,sBAAA;A1K8pvCZ;A0K7pvCY;EACI,mBAAA;A1K+pvChB;A0K3pvCQ;EACI,oBAAA;EACA,qBAAA;EACA,cAAA;A1K6pvCZ;A0K5pvCY;EACI,kBAAA;A1K8pvChB;A0K7pvCgB;EACI,kBAAA;EACA,oBAAA;A1K+pvCpB;;A0K7ovCI;EACI,mBAZM;A1K4pvCd;;A0KjpvCI;EACI,mBAZM;A1KgqvCd;;A0KrpvCI;EACI,mBAZM;A1KoqvCd;;A0KzpvCI;EACI,mBAZM;A1KwqvCd;;A0K7pvCI;EACI,mBAZM;A1K4qvCd;;A0KjqvCI;EACI,gBAZM;A1KgrvCd;;A0KrovCI;EACI,cA5BU;A1KoqvClB;;A0KzovCI;EACI,cA5BU;A1KwqvClB;;A0K7ovCI;EACI,cA5BU;A1K4qvClB;;A0KjpvCI;EACI,cA5BU;A1KgrvClB;;A0KrpvCI;EACI,cA5BU;A1KorvClB;;A0KzpvCI;EACI,cA5BU;A1KwrvClB;;A0K7pvCI;EACI,cA5BU;A1K4rvClB;;A0KjqvCI;EACI,cA5BU;A1KgsvClB;;A0KrqvCI;EACI,cA5BU;A1KosvClB;;A0KzqvCI;EACI,cA5BU;A1KwsvClB;;A0K7qvCI;EACI,cA5BU;A1K4svClB;;A0KjrvCI;EACI,cA5BU;A1KgtvClB;;A0KrrvCI;EACI,cA5BU;A1KotvClB;;A0KzrvCI;EACI,cA5BU;A1KwtvClB;;A0K7rvCI;EACI,cA5BU;A1K4tvClB;;A0KjsvCI;EACI,cA5BU;A1KguvClB;;A0KrsvCI;EACI,cA5BU;A1KouvClB;;A0KzsvCI;EACI,cA5BU;A1KwuvClB;;A0K7svCI;EACI,cA5BU;A1K4uvClB;;A0KjtvCI;EACI,cA5BU;A1KgvvClB;;A0KrtvCI;EACI,cA5BU;A1KovvClB;;A0KztvCI;EACI,cA5BU;A1KwvvClB;;A0KrtvCA;EACI,aAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBnKvIgB;EmKwIhB,cnKrIgB;EmKsIhB,oBAAA;EACA,enKxCS;APgwvCb;A0KvtvCI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,enK3CK;APowvCb;;A2K75vCA;EACI,wBAAA;A3Kg6vCJ;;AkBv2vCI;EyJ7CI;IACI,8BAAA;E3Kw5vCV;AACF;AkB72vCI;EyJ7CI;IACI,8BAAA;E3K65vCV;AACF;AkBl3vCI;EyJ7CI;IACI,8BAAA;E3Kk6vCV;AACF;AkBv3vCI;EyJ7CI;IACI,8BAAA;E3Ku6vCV;AACF;AkB53vCI;EyJ7CI;IACI,8BAAA;E3K46vCV;AACF;AkBj4vCI;EyJ7CI;IACI,8BAAA;E3Ki7vCV;AACF;A2K96vCA;EACI;IACI,8BAAA;E3Kg7vCN;AACF;A2K96vCA;EACI;IACI,8BAAA;E3Kg7vCN;AACF;A2K76vCA;EACI,sBAAA;A3K+6vCJ;;A2K56vCI;EACI,iBAAA;A3K+6vCR;A2K76vCI;EACI,sBAAA;A3K+6vCR;A2K56vCQ;EACI,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,cpKLE;EoKMF,sBAAA;EACA,mBAAA;A3K86vCZ;A2K76vCY;EACI,iBAAA;A3K+6vChB;A2K36vCY;EACI,cpK9BR;EoK+BQ,mBAAA;A3K66vChB;A2Kz6vCY;EACI,cpKlCP;EoKmCO,mBAAA;A3K26vChB;;AkBn6vCI;EyJAI;IACI,aAAA;E3Ku6vCV;E2Kr6vCM;IACI,aAAA;IACA,eAAA;IACA,WAAA;IACA,kBAAA;IACA,uBAAA;E3Ku6vCV;E2Kt6vCU;IACI,6BAAA;E3Kw6vCd;E2Kt6vCU;IACI,UAAA;IACA,SAAA;E3Kw6vCd;E2Kv6vCc;IACI,UAAA;E3Ky6vClB;E2Kt6vCU;IACI,YAAA;E3Kw6vCd;E2Kt6vCU;IACI,WAAA;E3Kw6vCd;E2Kt6vCU;IACI,UAAA;IACA,gBAAA;IACA,YAAA;E3Kw6vCd;E2Kt6vCU;IACI,UAAA;IACA,gBAAA;IACA,YAAA;E3Kw6vCd;E2Kt6vCU;IACI,kBAAA;IACA,WAAA;IACA,QAAA;IACA,2BAAA;IACA,UAAA;E3Kw6vCd;E2Kr6vCM;IACI,UAAA;E3Ku6vCV;AACF;A4K1hwCI;EACI,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBrK+HS;EqK9HT,iDrKwIsB;EqKvItB,2BAAA;A5K4hwCR;A4K3hwCQ;EACI,UAAA;EACA,QAAA;A5K6hwCZ;A4K3hwCQ;EACI,SAAA;EACA,SAAA;A5K6hwCZ;A4K3hwCQ;EACI,yBAAA;EACA,UAAA;EACA,mBAAA;EACA,wBAAA;A5K6hwCZ;A4K1hwCI;EACI,eAAA;EACA,MAAA;EACA,aAAA;EACA,gBAAA;EACA,4BAAA;EACA,gCAAA;A5K4hwCR;A4K3hwCQ;EACI,OAAA;EACA,4BAAA;A5K6hwCZ;A4K3hwCQ;EACI,QAAA;EACA,2BAAA;A5K6hwCZ;A4K3hwCQ;EACI,kCAAA;A5K6hwCZ;A4K1hwCI;EACI,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,iCAAA;EACA,aAAA;EACA,sCAAA;A5K4hwCR;;A4KvhwCI;EACI,aAAA;A5K0hwCR;A4KzhwCQ;EACI,cAAA;A5K2hwCZ;;A4KrhwCI;EACI,cAAA;A5KwhwCR;A4KthwCI;EACI,aAAA;A5KwhwCR;;A4KphwCI;EACI,aAAA;A5KuhwCR;A4KrhwCI;EACI,cAAA;A5KuhwCR;;A4KnhwCA;EACI,gBAAA;A5KshwCJ;;AkBhjwCI;E0JkCI;IACI,aAAA;E5KkhwCV;E4KjhwCU;IACI,yBAAA;E5KmhwCd;AACF;AkB5iwCI;E0J+BI;IACI,kBAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;IACA,WAAA;IACA,YAAA;IACA,0BAAA;IACA,gBrKvGH;IqKwGG,kBAAA;IACA,mBAAA;IACA,0CAAA;E5KghwCV;E4K9gwCM;IACI,iBAAA;IACA,oBAAA;E5KghwCV;E4K/gwCU;IACI,iBAAA;E5KihwCd;AACF;AkBlkwCI;E0J0DI;IACI,gBAAA;E5K2gwCV;E4KxgwCU;IACI,qBAAA;IACA,uBAAA;IACA,MAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;E5K0gwCd;E4KxgwCU;IACI,kBAAA;E5K0gwCd;E4KxgwCkB;IACI,UAAA;E5K0gwCtB;E4KvgwCsB;IACI,UAAA;E5KygwC1B;AACF;AkBrmwCI;E0JoGA;IACI,UAAA;E5KogwCN;E4KlgwCU;IACI,aAAA;E5KogwCd;E4KngwCc;IACI,UAAA;IACA,UAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;IACA,gBAAA;IACA,uBAAA;E5KqgwClB;E4KngwCc;IACI,aAAA;E5KqgwClB;AACF;AkBznwCI;E0J6HI;IACI,gBAAA;IACA,UAAA;IACA,mBAAA;IACA,mCAAA;IACA,gBAAA;IACA,uBAAA;IACA,gBAAA;IACA,qBAAA;E5K+/vCV;E4K9/vCU;IACI,cAAA;E5KggwCd;AACF;AkBxowCI;E0J6HI;IACI,gBAAA;IACA,UAAA;IACA,mBAAA;IACA,mCAAA;IACA,gBAAA;IACA,uBAAA;IACA,gBAAA;IACA,qBAAA;E5K8gwCV;E4K7gwCU;IACI,cAAA;E5K+gwCd;AACF;AkBvpwCI;E0J6HI;IACI,gBAAA;IACA,UAAA;IACA,mBAAA;IACA,mCAAA;IACA,gBAAA;IACA,uBAAA;IACA,gBAAA;IACA,qBAAA;E5K6hwCV;E4K5hwCU;IACI,cAAA;E5K8hwCd;AACF;AkBtqwCI;E0J6HI;IACI,gBAAA;IACA,UAAA;IACA,mBAAA;IACA,mCAAA;IACA,gBAAA;IACA,uBAAA;IACA,gBAAA;IACA,qBAAA;E5K4iwCV;E4K3iwCU;IACI,cAAA;E5K6iwCd;AACF;AkBrrwCI;E0J6HI;IACI,gBAAA;IACA,UAAA;IACA,mBAAA;IACA,mCAAA;IACA,gBAAA;IACA,uBAAA;IACA,gBAAA;IACA,qBAAA;E5K2jwCV;E4K1jwCU;IACI,cAAA;E5K4jwCd;AACF;AkBpswCI;E0J6HI;IACI,gBAAA;IACA,UAAA;IACA,mBAAA;IACA,mCAAA;IACA,gBAAA;IACA,uBAAA;IACA,gBAAA;IACA,qBAAA;E5K0kwCV;E4KzkwCU;IACI,cAAA;E5K2kwCd;AACF;A6K7wwCA;EACI,oBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;A7K+wwCJ;A6K7wwCM;EACE,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kCtKsJa;EsKrJb,gBtKiKK;EsKhKL,eAAA;EACA,ctK0BM;APqvwCd;A6K9wwCQ;EACI,mBtKwCQ;EsKvCR,WAAA;A7KgxwCZ;A6K9wwCQ;EACI,aAAA;A7KgxwCZ;A6K7wwCM;EACM,UAAA;EACA,aAAA;A7K+wwCZ;A6K9wwCY;EACI,eAAA;A7KgxwChB;A6K9wwCY;EACI,cAAA;A7KgxwChB;;AkBtvwCI;E2JnBA;IACI,qBAAA;E7K6wwCN;AACF;A6KxwwCA;EACI,oBAAA;EACA,kBtKuFa;EsKtFb,YAAA;A7K0wwCJ;A6KxwwCQ;EACI,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kCtK0GS;EsKzGT,gBtKqHC;EsKpHD,eAAA;EACA,ctKlBE;EsKmBF,yBAAA;A7K0wwCZ;A6KzwwCY;EACI,ctKpBF;EsKqBE,mBtK5CN;EsK6CM,yBAAA;A7K2wwChB;A6KxwwCY;EACI,ctKxBA;EsKyBA,yBAAA;EACA,mBtKnDN;EsKoDM,wDAAA;A7K0wwChB;A6KxwwCY;EACI,aAAA;A7K0wwChB;A6KvwwCQ;EACI,UAAA;EACA,SAAA;A7KywwCZ;A6KxwwCY;EACI,eAAA;A7K0wwChB;A6KzwwCgB;EACI,0BAAA;A7K2wwCpB;A6KxwwCY;EACI,cAAA;A7K0wwChB;A6KzwwCgB;EACI,0BAAA;A7K2wwCpB;A6KxwwCY;EACI,iBAAA;A7K0wwChB;;A8Kv2wCI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;A9K02wCR;A8Kz2wCQ;EACI,gBAAA;A9K22wCZ;A8Kz2wCQ;EACI,uBAAA;A9K22wCZ;A8Kv2wCgB;EACI,WvKRX;APi3wCT;;A8K/1wCI;EACI,qBAAA;A9Kk2wCR;A8Kh2wCI;EACI,uBAAA;A9Kk2wCR;A8Kh2wCI;EACI,mBAAA;EACA,gBAAA;EACA,gBvK2IK;EuK1IL,kBAAA;EACA,cvKMM;EuKLN,oBAAA;EACA,mBAAA;A9Kk2wCR;A8Kj2wCQ;EACI,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,qBAAA;A9Km2wCZ;;A8K31wCA;EACI,aAAA;A9K81wCJ;A8K71wCI;EACI,aAAA;A9K+1wCR;;A8K51wCA;EACI,aAAA;A9K+1wCJ;;A8K71wCA;EACI,aAAA;A9Kg2wCJ;;A8K91wCA;EACI,aAAA;A9Ki2wCJ;;A8K/1wCA;EACI,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBvKiEa;APiywCjB;A8Kj2wCI;EACI,gBAAA;EACA,kBAAA;EACA,QAAA;A9Km2wCR;A8Kl2wCQ;EACI,YAAA;A9Ko2wCZ;;AkBt3wCI;E4JwBA;IACI,aAAA;E9Kk2wCN;E8Kj2wCM;IACI,aAAA;E9Km2wCV;E8Kh2wCE;IACI,aAAA;E9Kk2wCN;E8Kh2wCE;IACI,aAAA;E9Kk2wCN;E8Kh2wCE;IACI,aAAA;E9Kk2wCN;AACF;A8K31wCQ;EACI,kBAAA;A9K61wCZ;A8K31wCQ;EACI,qBAAA;A9K61wCZ;A8Kz1wCQ;EACI,qBAAA;A9K21wCZ;;A8Kl1wCI;EACI,iBAAA;A9Kq1wCR;;A+K78wCQ;EACI,kBAAA;A/Kg9wCZ;A+K98wCQ;EACI,qBAAA;A/Kg9wCZ;A+K98wCQ;EACI,iBAAA;A/Kg9wCZ;A+K58wCQ;EACI,qBAAA;A/K88wCZ;A+K58wCQ;EACI,iBAAA;EACA,gBAAA;A/K88wCZ;A+K58wCQ;EACI,exKoIC;AP00wCb;A+K38wCI;EACI,kBAAA;A/K68wCR;A+K58wCQ;EACI,gBAAA;A/K88wCZ;A+K58wCQ;EACI,gBAAA;A/K88wCZ;A+K58wCQ;EACI,mBAAA;A/K88wCZ;;A+Kz8wCI;EACI,gBAAA;A/K48wCR;;AkBz7wCI;E6JZQ;IACI,kBAAA;E/Ky8wCd;E+Kv8wCU;IACI,mBAAA;E/Ky8wCd;AACF;A+Kp8wCA;EACI,eAAA;A/Ks8wCJ;;AgL9/wCI;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,gBzKDC;EyKED,wBAAA;EACA,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;AhLigxCR;AgLhgxCQ;EACI,UAAA;EACA,UAAA;EACA,oBAAA;AhLkgxCZ;AgLhgxCQ;EACI,iBAAA;EACA,UAAA;EACA,WAAA;AhLkgxCZ;AgL//wCI;EACI,oBAAA;EACA,UAAA;AhLigxCR;AgLhgxCQ;EACI,UAAA;AhLkgxCZ;AgL//wCI;EACI,kBAAA;EACA,WAAA;AhLigxCR;AgLhgxCO;EACK,kCzK+W4B;EyK9W5B,mCzK8W4B;APopwCxC;AgLjgxCY;EACI,iCzK6WwB;EyK5WxB,kCzK4WwB;APupwCxC;AgL//wCI;EACI,kBAAA;EACA,QAAA;AhLigxCR;AgLhgxCQ;EACI,gBAAA;AhLkgxCZ;AgL//wCI;EACI,OAAA;EACA,oCAAA;AhLigxCR;AgL//wCI;EACI,QAAA;EACA,kCAAA;AhLigxCR;AgLhgxCQ;EACI,czKDQ;APmgxCpB;;AgL7/wCA;EACI,kBAAA;EACA,sBAAA;AhLggxCJ;AgL9/wCQ;EACI,YAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;AhLggxCZ;AgL9/wCQ;EACI,qBAAA;EACA,qBAAA;EACA,qBAAA;AhLggxCZ;;AiL3kxCQ;EACI,iB1K0Ja;APo7wCzB;AiL7kxCY;EACI,mBAAA;AjL+kxChB;AiL5kxCQ;EACI,mBAAA;AjL8kxCZ;AiL7kxCY;EACI,iBAAA;AjL+kxChB;AiL5kxCQ;EACI,aAAA;AjL8kxCZ;AiL7kxCY;EACI,sBAAA;AjL+kxChB;AiL5kxCQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AjL8kxCZ;AiL7kxCY;EACI,gBAAA;AjL+kxChB;AiL5kxCQ;EACI,gBAAA;EACA,mBAAA;AjL8kxCZ;AiL5kxCQ;EACI,kBAAA;EACA,uBAAA;AjL8kxCZ;AiL7kxCY;EACI,iBAAA;AjL+kxChB;AiL7kxCY;EACI,mBAAA;AjL+kxChB;AiL7kxCY;EACI,eAAA;EACA,mBAAA;EACA,qBAAA;EACA,c1KHF;E0KIE,gB1K+HH;E0K9HG,kBAAA;AjL+kxChB;AiL9kxCgB;EACI,cAAA;EACA,oBAAA;EACA,mBAAA;AjLglxCpB;AiL/kxCoB;EACI,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;AjLilxCxB;AiL9kxCgB;EACI,kBAAA;EACA,WAAA;EACA,SAAA;AjLglxCpB;AiL7kxCY;EACI,uBAAA;AjL+kxChB;AiL7kxCY;EACI,oBAAA;AjL+kxChB;AiL7kxCY;EACI,sBAAA;AjL+kxChB;AiL7kxCY;EACI,iBAAA;AjL+kxChB;AiL5kxCgB;EACI,uBAAA;AjL8kxCpB;AiL3kxCY;EACI,kBAAA;AjL6kxChB;AiL5kxCgB;EACI,kBAAA;AjL8kxCpB;AiL1kxCQ;EACI,aAAA;EACA,mBAAA;AjL4kxCZ;AiL3kxCY;EACI,oBAAA;AjL6kxChB;AiL1kxCQ;EACI,c1KtDE;APkoxCd;AiL3kxCY;EACI,c1KtDA;APmoxChB;AiL3kxCY;EACI,sBAAA;AjL6kxChB;AiLzkxCY;EACI,iBAAA;AjL2kxChB;AiL1kxCgB;EACI,mBAAA;AjL4kxCpB;AiLxkxCgB;EACI,mBAAA;AjL0kxCpB;AiLrkxCY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AjLukxChB;AiLtkxCgB;EACI,gBAAA;AjLwkxCpB;AiLtkxCgB;EACI,qBAAA;AjLwkxCpB;;AkB7oxCI;E+J+EY;IACI,sBAAA;EjLkkxClB;EiL9jxCc;IACI,iBAAA;EjLgkxClB;EiL/jxCkB;IACI,mBAAA;EjLikxCtB;AACF;AkBzpxCI;E+JkGY;IACI,sBAAA;EjL0jxClB;EiLvjxCkB;IACI,uBAAA;EjLyjxCtB;EiLpjxCM;IACI,mBAAA;EjLsjxCV;EiLrjxCU;IACI,iBAAA;EjLujxCd;EiLrjxCU;IACI,oBAAA;EjLujxCd;EiLnjxCU;IACI,eAAA;EjLqjxCd;AACF;AkBhqxCI;E+JkHI;IACI,UAAA;IACA,iBAAA;EjLijxCV;AACF;AkBnrxCI;E+J0IQ;IACI,aAAA;IACA,8BAAA;IACA,mBAAA;EjL4ixCd;AACF;AiLvixCA;EACI,sBAAA;EACA,gCAAA;AjLyixCJ;;AkLvvxCI;EACI,kBAAA;AlL0vxCR;;AmLxvxCI;EACI,qBAAA;AnL2vxCR;;AmLtvxCA;EACI,cAAA;AnLyvxCJ;AmLxvxCI;EACI,sB5K6yBW;AP68vCnB;AmLzvxCQ;EACI,WAAA;AnL2vxCZ;AmLxvxCI;EACI,yBAAA;AnL0vxCR;AmLzvxCQ;EACI,gBtFmOO;A7FwhxCnB;AmLxvxCI;EACI,yBAAA;AnL0vxCR;AmLzvxCQ;EACI,gBtF8NS;A7F6hxCrB;;AmLnvxCI;EACI,kBAAA;EACA,gCAAA;AnLsvxCR;;AmLnvxCA;EACI,uBAAA;EACA,wBAAA;EACA,4BAAA;AnLsvxCJ;;AmLpvxCA;EACI,sBAAA;EACA,6BAAA;AnLuvxCJ;;AmLrvxCA;EACI,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,2BAAA;EACA,6CAAA;EACA,yBAAA;EACA,yBAAA;EACA,OAAA;EACA,YAAA;AnLwvxCJ;AmLvvxCI;EACI,aAAA;AnLyvxCR;;AmLnvxCA;EACI,iBAAA;AnLsvxCJ;;AkB/vxCI;EiKaI;IACI,4BAAA;EnLsvxCV;AACF;AmLhvxCI;EACI,gCAAA;AnLkvxCR;AmLjvxCQ;EACI,wBAAA;AnLmvxCZ;AmLhvxCI;EACI,wBAAA;AnLkvxCR;AmLjvxCQ;EACI,gCAAA;AnLmvxCZ;;AmL3uxCI;EACI,eAAA;AnL8uxCR;AmL7uxCQ;EACI,cAAA;AnL+uxCZ;AmL5uxCI;EACI,e5KgDK;AP8rxCb;AmL3uxCQ;EACI,qB5K/FA;E4KgGA,mD5K0Q4B;APm+wCxC;;AmLtuxCI;EACI,aAAA;EACA,mBAAA;AnLyuxCR;AmLvuxCI;EACI,WAAA;EACA,oBAAA;EACA,cAAA;AnLyuxCR;AmLxuxCQ;EACI,eAAA;EACA,c5KnEQ;AP6yxCpB;AmLxuxCgB;EACI,cAAA;AnL0uxCpB;AmLtuxCQ;EACI,WAAA;AnLwuxCZ;AmLruxCI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AnLuuxCR;AmLtuxCQ;EACI,e5KWC;E4KVD,gBAAA;EACA,c5KpGE;E4KqGF,gB5K8BC;E4K7BD,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;AnLwuxCZ;AmLvuxCY;EACI,c5K5GF;E4K6GE,gB5KsBH;APmtxCb;AmLtuxCgB;EACI,cAAA;AnLwuxCpB;AmLvuxCoB;EACI,+BAAA;AnLyuxCxB;AmLpuxCgB;EACI,cAAA;AnLsuxCpB;AmLruxCoB;EACI,+BAAA;AnLuuxCxB;AmLluxCQ;EACI,c5KjIE;E4KkIF,oBAAA;AnLouxCZ;AmLluxCgB;EACI,c5KrIN;APy2xCd;AmLhuxCgB;EACI,c5K9HA;APg2xCpB;AmL5txCQ;EACI,c5KjIQ;AP+1xCpB;;AmLptxCY;EACI,gCAAA;AnLutxChB;AmLntxCI;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,c5K9LI;E4K+LJ,oBAAA;AnLqtxCR;AmLptxCQ;EACI,c5KlMA;E4KmMA,mB5KxMA;AP85xCZ;AmLntxCI;EACI,eAAA;AnLqtxCR;AmLntxCI;EACI,WAAA;EACA,kBAAA;AnLqtxCR;;AmLhtxCI;EACI,kB5KzFS;AP4yxCjB;AmLltxCQ;EACI,gBAAA;AnLotxCZ;AmLhtxCQ;EACI,gB5KKgB;AP6sxC5B;AmL9sxCQ;EACI,oBAAA;AnLgtxCZ;;AmL3sxCA;EACI,sBAAA;AnL8sxCJ;;AmLzsxCA;EACI,kBAAA;AnL4sxCJ;;AmLzsxCA;EACI,kBAAA;AnL4sxCJ;;AmL1sxCA;EACI,iBAAA;AnL6sxCJ;;AmL1sxCA;EACI;IACI,iBAAA;IACA,mBAAA;EnL6sxCN;AACF;AmLrsxCQ;EACI,mBAAA;AnLusxCZ;AmLpsxCI;EACI,qBAAA;EACA,mB5KhQE;E4KiQF,kB5K9IS;APo1xCjB;AmLpsxCI;EACI,e5KjIK;E4KkIL,c5K/OM;E4KgPN,mBAAA;AnLssxCR;AmLrsxCQ;EACI,c5KjPE;APw7xCd;AmLrsxCQ;EACI,oBAAA;AnLusxCZ;AmLpsxCI;EACI,eAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AnLssxCR;AmLpsxCI;EACI,qBAAA;AnLssxCR;;AkBr7xCI;EiKqPI;IACI,uBAAA;EnLosxCV;EmLlsxCM;IACI,YAAA;IACA,qBAAA;IACA,mBAAA;EnLosxCV;AACF;AmLhsxCA;EAEQ;IACI,cAAA;IACA,eAAA;EnLisxCV;AACF;AmL7rxCA;EACI,kB5K7La;AP43xCjB;;AmL5rxCA;EACI,kBAAA;EACA,gBAAA;EACA,kB5KnMa;APk4xCjB;AmL9rxCI;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,aAAA;EACA,yEAAA;AnLgsxCR;AmL9rxCI;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,W5KnVC;E4KoVD,kBAAA;AnLgsxCR;AmL/rxCQ;EACI,W5KtVH;APuhyCT;AmL/rxCQ;EACI,eAAA;AnLisxCZ;;AoLniyCA;EACI,kBAAA;ApLsiyCJ;AoLriyCI;EACI,YAAA;EACA,eAAA;ApLuiyCR;AoLtiyCQ;EACI,kBAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;ApLwiyCZ;AoLniyCY;EACI,iBAAA;ApLqiyChB;;AqLnjyCI;EACI,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,uBAAA;ArLsjyCR;AqLpjyCI;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;ArLsjyCR;AqLrjyCQ;EACI,kBAAA;ArLujyCZ;AqLrjyCQ;EACI,mBAAA;ArLujyCZ;AqLtjyCY;EACI,uBAAA;ArLwjyChB;AqLpjyCI;EACI,mBAAA;ArLsjyCR;AqLpjyCI;EACI,mBAAA;ArLsjyCR;AqLrjyCQ;EACI,aAAA;EACA,8BAAA;EACA,qBAAA;ArLujyCZ;AqLrjyCQ;EACI,aAAA;EACA,mBAAA;EACA,c9KUE;AP6iyCd;AqLtjyCY;EACI,eAAA;EACA,mBAAA;EACA,qBAAA;ArLwjyChB;AqLrjyCQ;EACI,c9KGE;E8KFF,gB9KqIC;APk7xCb;AqLpjyCI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;ArLsjyCR;AqLpjyCI;EACI,aAAA;EACA,mBAAA;ArLsjyCR;AqLnjyCQ;EACI,aAAA;EACA,mBAAA;ArLqjyCZ;AqLpjyCY;EACI,YAAA;EACA,oBAAA;ArLsjyChB;;AkBvjyCI;EmKWY;IACI,YAAA;IACA,kBAAA;ErLgjyClB;AACF;AsL1nyCA;EACI,kBAAA;AtL4nyCJ;AsL3nyCI;EACI,uBAAA;AtL6nyCR;AsL5nyCQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;EACA,oBAAA;AtL8nyCZ;AsL5nyCgB;EACI,c/KgCN;AP8lyCd;AsL5nyCgB;EACI,c/K8BN;APgmyCd;AsLznyCI;EACI,kBAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AtL2nyCR;AsLznyCI;EACI,kBAAA;EACA,aAAA;EACA,eAAA;AtL2nyCR;AsLznyCI;EACI,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AtL2nyCR;AsLznyCI;EACI,aAAA;EACA,6BAAA;EACA,kBAAA;EACA,sBAAA;AtL2nyCR;AsLznyCY;EACI,cAAA;AtL2nyChB;AsL1nyCgB;EACI,mBAAA;EACA,c/KHL;AP+nyCf;AsL1nyCgB;EACI,mBAAA;EACA,c/KXN;APuoyCd;AsLvnyCI;EACI,aAAA;EACA,uBAAA;EACA,uBAAA;AtLynyCR;;AoJ3qyCA,eAAA;AmCTI;EACI,gBAAA;AvLwryCR;AuLtryCI;EACI,oBAAA;AvLwryCR;AuLtryCI;EACI,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AvLwryCR;AuLtryCI;EACI,qBAAA;EACA,sBAAA;AvLwryCR;AuLtryCI;EACI,aAAA;AvLwryCR;;AkBjpyCI;EqKjCI;IACI,UAAA;EvLsryCV;AACF;AkBvpyCI;EqKzBQ;IACI,kBAAA;EvLmryCd;AACF;AwLrtyCI;EACI,kBAAA;AxLutyCR;AwLrtyCI;EACI,oBAAA;EACA,cAAA;AxLutyCR;AwLrtyCI;EACI,gBAAA;EACA,gBjLqKK;EiLpKL,qDAAA;EACA,6BAAA;EACA,oCAAA;EACA,YAAA;AxLutyCR;AwLrtyCI;EACI,oBAAA;AxLutyCR;AwLrtyCI;EACI,eAAA;AxLutyCR;;AkBjryCI;EsKhCI;IACI,gBAAA;ExLqtyCV;EwLntyCM;IACI,oBAAA;IACA,gBAAA;ExLqtyCV;AACF;AyLpvyCA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,clLkBK;EkLjBL,oCAAA;EACA,kBlL2Ha;EkL1Hb,UAAA;EACA,oBAAA;EACA,wBAAA;AzLsvyCJ;AyLrvyCI;EACI,UAAA;AzLuvyCR;;AoJ1vyCA,cAAA;AsCbQ;EACI,+CAAA;A1L2wyCZ;A0LxwyCI;EACI,8CAAA;A1L0wyCR;A0LxwyCI;EACI,oBAAA;EACA,qBAAA;A1L0wyCR;A0LxwyCI;EACI,oBAAA;EACA,qBAAA;EACA,qBAAA;A1L0wyCR;A0LxwyCI;EACI,+CAAA;A1L0wyCR;A0LxwyCI;EACI,+CAAA;A1L0wyCR;;A0LtwyCA;EACI,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;A1LywyCJ;;A0LrwyCI;EACI,cnLJC;AP4wyCT;A0LtwyCI;EACI,cnLNA;AP8wyCR;A0LtwyCI;EACI,cnLdA;APsxyCR;;A0LpwyCA;EACI,cAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A1LuwyCJ;A0LtwyCI;EACI,iBAAA;A1LwwyCR;A0LtwyCI;EACI,kBAAA;A1LwwyCR;A0LtwyCI;EACI,cnLlBM;AP0xyCd;A0LtwyCI;EACI,cnLNY;AP8wyCpB;;A0LnwyCA;EACI,kBAAA;A1LswyCJ;A0LrwyCI;EACI,kBAAA;EACA,WAAA;EACA,2BAAA;EACA,qBAAA;EACA,cAAA;EACA,QAAA;A1LuwyCR;A0LrwyCI;EACI,QAAA;EACA,WAAA;EACA,cAAA;EACA,sBnL5EC;EmL6ED,yBAAA;A1LuwyCR;A0LrwyCI;EACI,YAAA;EACA,WAAA;EACA,iCAAA;EACA,yBnL9EI;APq1yCZ;A0LpwyCQ;EACI,yBnLpCQ;EmLqCR,qBnLrCQ;AP2yyCpB;A0LpwyCQ;EACI,0BAAA;EACA,sBnL5FH;APk2yCT;;A0LjwyCA;EACI,cAAA;A1LowyCJ;;A2L52yCI;EACI,cAAA;EACA,cpLuCM;APw0yCd;A2L92yCQ;EACI,epLkJC;EoLjJD,gBpLwKC;EoLvKD,yBAAA;EACA,qBAAA;A3Lg3yCZ;A2L92yCQ;EACI,oBAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;A3Lg3yCZ;A2L72yCI;EACI,cpLyBM;APs1yCd;A2L92yCQ;EACI,iBAAA;EACA,gBpLyJC;EoLxJD,WAAA;A3Lg3yCZ;A2L72yCI;EACI,aAAA;EACA,iBAAA;A3L+2yCR;A2L52yCQ;EACI,mBAAA;A3L82yCZ;;AkBn1yCI;EyKrBI;IACI,kBAAA;E3L42yCV;E2L12yCM;IACI,aAAA;IACA,eAAA;IACA,yBAAA;IACA,gBAAA;E3L42yCV;E2L12yCM;IACI,UAAA;IACA,kBAAA;E3L42yCV;E2L12yCc;IACI,aAAA;E3L42yClB;AACF;A2Ln2yCI;EACI,mBAAA;EACA,gBpLgHK;APqvyCb;;A2L71yCI;EACI,aAAA;EACA,qBAAA;A3Lg2yCR;A2L91yCI;EACI,kBAAA;EACA,YAAA;EACA,kBAAA;A3Lg2yCR;A2L91yCI;EACI,mBAAA;EACA,cpLxCM;APw4yCd;A2L/1yCQ;EACI,kBAAA;EACA,kBAAA;A3Li2yCZ;A2L/1yCQ;EACI,kBAAA;A3Li2yCZ;A2L91yCI;EACI,kBAAA;A3Lg2yCR;A2L/1yCQ;EACI,eAAA;EACA,mBAAA;A3Li2yCZ;A2L/1yCQ;EACI,kBAAA;A3Li2yCZ;A2L71yCQ;EACI,kBAAA;EACA,gBpLuEC;EoLtED,cpL5DI;EoL6DJ,mBAAA;EACA,mBAAA;A3L+1yCZ;A2L91yCY;EACI,gBpLgEH;APgyyCb;;A4L98yCI;EACI,aAAA;A5Li9yCR;A4Lh9yCQ;EACI,YAAA;A5Lk9yCZ;A4L/8yCI;EACI,aAAA;A5Li9yCR;;A4L58yCI;EACI,aAAA;EACA,aAAA;EACA,iBAAA;A5L+8yCR;A4L98yCQ;EAII,aAAA;A5L68yCZ;A4Lh9yCY;EACI,QAAA;A5Lk9yChB;A4L/8yCY;EACI,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBrLgCI;EqL/BJ,mBrL+BI;EoB4ClB,2BAAA;ErB4EI,oBAAA;EqB1EJ,oBpB8IyB;EOtOvB,kBAAA;Adg+yCJ;A4Ll9yCY;EACI,aAAA;A5Lo9yChB;;A4L78yCI;EACI,aAAA;A5Lg9yCR;A4L78yCQ;EACI,mBAAA;A5L+8yCZ;A4L78yCgB;EACI,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;A5L+8yCpB;A4L98yCoB;EACI,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,crLfV;AP+9yCd;A4L98yCoB;EACI,eAAA;EACA,crLnBV;EqLoBU,gBAAA;A5Lg9yCxB;A4L98yCoB;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EAEI,OAAA;EAKJ,SAAA;EACA,WAAA;EACA,oBAAA;EACA,mBrLlEZ;AP6gzCZ;A4Lx8yCwB;EACI,WAAA;EACA,mBrLxBR;EqLyBQ,WAAA;A5L08yC5B;A4Lx8yCwB;EACI,crL5BR;APs+yCpB;A4Lt8yCwB;EACI,WAAA;EACA,mBrLjFhB;APyhzCZ;A4Lt8yCwB;EACI,crLrDd;AP6/yCd;A4Ln8yCY;EACI,aAAA;A5Lq8yChB;A4L/7yCY;EACI,eAAA;A5Li8yChB;A4L/7yCoB;EACI,oBAAA;A5Li8yCxB;;AkBt/yCI;E0K+DI;IACI,aAAA;IACA,eAAA;E5L27yCV;E4L17yCU;IACI,UAAA;IACA,mBAAA;E5L47yCd;E4L37yCc;IACI,WAAA;E5L67yClB;E4L57yCkB;IACI,mBAAA;E5L87yCtB;E4L17yCU;IACI,UAAA;E5L47yCd;AACF;A6LlkzCI;EACI,etLmJK;EsLlJL,gBtL2KK;EsL1KL,yBAAA;EACA,sBAAA;EACA,mBtLaE;APujzCV;A6LnkzCQ;EACI,ctLiCE;EsLhCF,yBAAA;A7LqkzCZ;A6LnkzCQ;EACI,gBAAA;A7LqkzCZ;A6LpkzCY;EACI,2BAAA;A7LskzChB;A6LpkzCY;EACI,4BAAA;A7LskzChB;A6LlkzCI;EACI,etLkIK;APk8yCb;A6LnkzCQ;EACI,wBAAA;EACA,sBAAA;A7LqkzCZ;A6LpkzCY;EACI,mBAAA;EACA,sBAAA;A7LskzChB;A6LjkzCQ;EACI,cAAA;A7LmkzCZ;A6LjkzCQ;EACI,gBtLwIC;AP27yCb;A6L/jzCQ;EACI,gBtLmIC;EsLlID,ctLDE;APkkzCd;A6L9jzCI;EACI,qBAAA;A7LgkzCR;A6L1jzCQ;EACI,ctLbE;APykzCd;A6L3jzCY;EACI,etL+FH;AP89yCb;A6LzjzCI;EACI,WAAA;EACA,iBAAA;A7L2jzCR;A6L1jzCQ;EACI,oBAAA;EACA,uBAAA;A7L4jzCZ;A6LxjzCK;EACO,mBAAA;A7L0jzCZ;A6LxjzCK;EACO,iBAAA;A7L0jzCZ;;A6LtjzCA;EAEQ;IACI,aAAA;IACA,WAAA;E7LwjzCV;E6LvjzCU;IACI,YAAA;IACA,mBAAA;IACA,sBAAA;E7LyjzCd;E6LvjzCU;IACI,YAAA;IACA,YAAA;IACA,cAAA;IACA,iBAAA;E7LyjzCd;E6LrjzCM;IACI,eAAA;IACA,iBAAA;IACA,oBAAA;E7LujzCV;E6LtjzCU;IACI,gCAAA;E7LwjzCd;E6LrjzCM;IACI,YAAA;IACA,iBAAA;E7LujzCV;E6LrjzCM;IACI,eAAA;IACA,iCAAA;IACA,uBAAA;E7LujzCV;E6LrjzCM;IACI,UAAA;E7LujzCV;E6LpjzCU;IACI,etLiCH;EPqhzCX;E6LrjzCc;IACI,oBAAA;E7LujzClB;E6LjjzCU;IACI,YAAA;IACA,oBAAA;IACA,oBAAA;IACA,mBAAA;E7LmjzCd;AACF;A6L9izCA;EAEQ;IACI,etLaC;EPkizCX;E6L7izCM;IACI,WAAA;E7L+izCV;E6L9izCU;IACI,qBAAA;E7LgjzCd;E6L7izCM;IACI,UAAA;E7L+izCV;E6L5izCU;IACI,UAAA;E7L8izCd;E6L5izCU;IACI,aAAA;E7L8izCd;E6L5izCU;IACI,kBAAA;IACA,oBAAA;IACA,cAAA;IACA,WAAA;E7L8izCd;E6L7izCc;IACI,QAAA;IACA,qBAAA;E7L+izClB;AACF;A6LzizCA;EAEQ;IACI,qBAAA;IACA,sBAAA;E7L0izCV;E6LvizCM;IACI,sBAAA;E7LyizCV;E6LvizCM;IACI,sBAAA;E7LyizCV;E6LvizCM;IACI,sBAAA;E7LyizCV;E6LvizCM;IACI,UAAA;E7LyizCV;E6LtizCU;IACI,sBAAA;IACA,qBAAA;E7LwizCd;E6LtizCU;IACI,qBAAA;E7LwizCd;AACF;A8L3uzCI;EACI,evLsJK;APulzCb;A8L5uzCQ;EACI,qBAAA;EACA,sBAAA;A9L8uzCZ;A8L3uzCI;EACI,cAAA;A9L6uzCR;A8L5uzCQ;EACI,gBvLkKC;AP4kzCb;A8L1uzCQ;EACI,cAAA;A9L4uzCZ;A8L1uzCQ;EACI,gBvL0JC;APklzCb;A8LxuzCQ;EACI,cvLoBI;APstzChB;A8LzuzCY;EACF,cAAA;A9L2uzCV;A8LtuzCQ;EACI,cvLSE;AP+tzCd;A8LvuzCY;EACF,cAAA;A9LyuzCV;A8L/tzCK;EACC,sBAAA;A9LiuzCN;A8L/tzCQ;EACI,qBAAA;EACA,iBAAA;A9LiuzCZ;A8L7tzCK;EACO,mBAAA;A9L+tzCZ;A8L5tzCI;EACI,eAAA;A9L8tzCR;A8L5tzCI;EACI,mBvL1CE;APwwzCV;A8L7tzCQ;EACC,evLuFI;EuLtFJ,gBvL8GI;EuL7GJ,yBAAA;EACA,sBAAA;EACG,cvL1BE;EuL2BF,yBAAA;A9L+tzCZ;;A8L1tzCA;EAEQ;IACI,aAAA;E9L4tzCV;E8L3tzCU;IACI,YAAA;E9L6tzCd;E8L1tzCM;IACI,iBAAA;E9L4tzCV;AACF;A8LztzCA;EAEQ;IACI,evL8DC;EP4pzCX;E8LxtzCM;IACI,UAAA;E9L0tzCV;E8LxtzCM;IACI,UAAA;E9L0tzCV;E8LxtzCM;IACI,WAAA;IACA,eAAA;E9L0tzCV;E8LztzCU;IACI,oBAAA;E9L2tzCd;AACF;A8LvtzCA;EAEQ;IACI,cAAA;E9LwtzCV;E8LttzCM;IACI,UAAA;E9LwtzCV;E8LttzCM;IACI,gBAAA;E9LwtzCV;E8LttzCM;IACI,qBAAA;E9LwtzCV;E8LvtzCU;IACI,kBAAA;E9LytzCd;E8LrtzCI;IACU,oBAAA;E9LutzCd;AACF;A8LntzCA;EAEQ;IACI,gBAAA;E9LotzCV;E8LltzCM;IACI,cAAA;E9LotzCV;AACF;A+L31zCQ;EACI,mBAAA;EACA,sBAAA;A/L61zCZ;;A+Lz1zCA;EAGY;IACI,mBAAA;IACA,sBAAA;E/L01zCd;E+Lz1zCc;IACI,cAAA;IACA,iBAAA;E/L21zClB;AACF;AgM52zCA;EACC,oBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AhM82zCD;AgM72zCC;EACC,mBAAA;AhM+2zCF;AgM72zCC;EACC,sBAAA;AhM+2zCF;AgM72zCC;EACC,czL6BY;APk1zCd;AgM72zCC;EACC,gBAAA;EACA,kBAAA;EACA,qBAAA;AhM+2zCF;AgM92zCE;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;AhMg3zCH;AgM/2zCG;EACC,eAAA;EACA,gBAAA;EACA,czLiBY;EyLhBZ,gBAAA;AhMi3zCJ;AgMh3zCI;EACC,eAAA;AhMk3zCL;AgM/2zCG;EACC,eAAA;EACA,gBAAA;EACA,czLKU;AP42zCd;AgM92zCE;EACC,aAAA;EACA,8BAAA;EACA,czLDW;EyLEX,eAAA;AhMg3zCH;;AkBl2zCI;E8KND;IACC,uBAAA;IACA,wBAAA;EhM42zCF;EgMz2zCE;IACC,uBAAA;IACA,wBAAA;EhM22zCH;AACF;AiMt6zCI;EACI,cAAA;EACA,WAAA;EACA,e1LoJK;E0LnJL,c1LqCM;APm4zCd;AiMv6zCQ;EACI,c1LoCE;APq4zCd;AiMv6zCQ;EACI,e1L6IC;E0L5ID,gB1LmKC;APswzCb;AiMv6zCQ;EACI,gB1LgKC;E0L/JD,c1L8BI;E0L7BJ,cAAA;EACA,gBAAA;AjMy6zCZ;AiMx6zCY;EACI,c1LwBF;E0LvBE,cAAA;EACA,gBAAA;AjM06zChB;AiMv6zCQ;EACI,gBAAA;AjMy6zCZ;AiMt6zCY;EACI,c1LcF;E0LbE,gB1L+IH;APyxzCb;AiMr6zCQ;EACI,e1LoHC;APmzzCb;AiMr6zCQ;EACI,aAAA;EACA,mBAAA;AjMu6zCZ;AiMt6zCY;EACI,c1LKA;APm6zChB;AiMt6zCY;EACI,YAAA;EACA,kB1L6FI;AP20zCpB;AiMv6zCgB;EACI,sBAAA;AjMy6zCpB;AiMr6zCQ;EACI,aAAA;EACA,mBAAA;AjMu6zCZ;AiMt6zCY;EACI,WAAA;EACA,kB1LgFC;E0L/ED,kBAAA;AjMw6zChB;AiMt6zCY;EACI,gB1LoHH;E0LnHG,mBAAA;EACA,c1LhBA;APw7zChB;AiMr6zCQ;EACI,mBAAA;EACA,cAAA;EACA,sBAAA;AjMu6zCZ;AiMt6zCY;EACI,c1LXI;APm7zCpB;AiMp6zCI;EACI,kDAAA;EACA,kBAAA;AjMs6zCR;AiMr6zCQ;EACI,mBAAA;EACA,kDAAA;AjMu6zCZ;AiMp6zCI;EACI,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,oBAAA;AjMs6zCR;AiMr6zCQ;EACI,qBAAA;AjMu6zCZ;AiMr6zCQ;EACI,sBAAA;AjMu6zCZ;AiMr6zCQ;EACI,kBAAA;AjMu6zCZ;AiMr6zCQ;EACI,WAAA;AjMu6zCZ;AiMt6zCY;EACI,sBAAA;AjMw6zChB;AiMr6zCQ;EACI,iDAAA;AjMu6zCZ;AiMr6zCQ;EACI,mBAAA;EACA,sBAAA;EACA,c1LjEE;E0LkEF,gBAAA;EACA,iDAAA;AjMu6zCZ;AiMr6zCQ;EACI,iBAAA;AjMu6zCZ;AiMt6zCY;EACI,cAAA;AjMw6zChB;AiMp6zCY;EACI,wBAAA;AjMs6zChB;AiMl6zCI;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AjMo6zCR;AiMn6zCQ;EACI,cAAA;AjMq6zCZ;AiMn6zCQ;EACI,WAAA;AjMq6zCZ;AiMj6zCQ;EACI,UAAA;EACA,qBAAA;AjMm6zCZ;AiMl6zCY;EACI,UAAA;EACA,mBAAA;AjMo6zChB;AiM95zCY;EACI,gBAAA;AjMg6zChB;AiM75zCQ;EACI,gBAAA;EACA,yBAAA;EACA,qBAAA;AjM+5zCZ;AiM75zCgB;EACI,gB1LtJX;E0LuJW,YAAA;EACA,kDAAA;AjM+5zCpB;AiM95zCoB;EACI,0BAAA;AjMg6zCxB;AiM95zCoB;EACI,0BAAA;AjMg6zCxB;AiM75zCgB;EACI,gB1LjKX;APgk0CT;AiM55zCY;EACI,oBAAA;EACA,uBAAA;AjM85zChB;;AkBjh0CI;E+K4HQ;IACI,cAAA;EjMy5zCd;EiMt5zCc;IACI,oBAAA;EjMw5zClB;EiMt5zCc;IACI,qBAAA;EjMw5zClB;AACF;AkB7h0CI;E+K4II;IACI,e1L9CC;EPk8zCX;EiMn5zCU;IACI,e1LjDH;EPs8zCX;EiMn5zCU;IACI,e1LrDH;EP08zCX;AACF;AiM14zCY;EACI,qBAAA;EACA,wBAAA;AjM44zChB;;AiMh4zCY;EACI,oBAAA;EACA,uBAAA;AjMm4zChB;;AiMv3zCY;EACI,mBAAA;EACA,sBAAA;AjM03zChB;;AkMln0CA;EACI,c3L2CU;E2L1CV,gBAAA;AlMqn0CJ;AkMpn0CI;EACI,mBAAA;AlMsn0CR;AkMpn0CI;EACI,e3LoJK;E2LnJL,c3LoCM;E2LnCN,mBAAA;AlMsn0CR;AkMpn0CI;EACI,kBAAA;EACA,aAAA;EACA,uBAAA;AlMsn0CR;AkMrn0CQ;EACI,sBAAA;AlMun0CZ;AkMtn0CY;EACI,kBAAA;EACA,yBAAA;EACA,UAAA;EACA,mB3LPJ;E2LQI,WAAA;EACA,SAAA;EACA,SAAA;AlMwn0ChB;AkMpn0CI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AlMsn0CR;AkMpn0CY;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,gB3LhCP;E2LiCO,WAAA;EACA,QAAA;EACA,SAAA;AlMsn0ChB;AkMln0CI;EACI,kBAAA;EACA,c3LNM;E2LON,WAAA;EAEI,oBAAA;EAKJ,cAAA;EACA,iBAAA;AlM+m0CR;AkM9m0CQ;EAEQ,QAAA;EACA,qBAAA;EAMJ,sBAAA;EACA,c3L1BE;E2L2BF,qBAAA;EACA,kBAAA;EACA,QAAA;AlM0m0CZ;AkMvm0CI;EAEQ,iBAAA;AlMwm0CZ;AkMlm0CI;EACI,e3LuEK;E2LtEL,c3LvCQ;E2LwCR,sBAAA;AlMom0CR;AkMlm0CI;EACI,c3L9CM;APkp0Cd;AkMnm0CQ;EACI,sBAAA;AlMqm0CZ;AkMlm0CI;EACI,cAAA;EACA,e3LwDK;E2LvDL,c3LtDM;AP0p0Cd;;AkB1o0CI;EgL0CA;IACI,kBAAA;ElMom0CN;AACF;AkMlm0CA;EAEQ;IACI,eAAA;ElMmm0CV;EkMjm0CM;IACI,WAAA;ElMmm0CV;EkMjm0CM;IAEQ,yBAAA;ElMkm0Cd;AACF;AmMjt0CA;EACI,kBAAA;AnMmt0CJ;AmMlt0CI;EACI,gBATU;EAUV,kB5L+HS;E4L9HT,gB5LFC;APst0CT;AmMlt0CI;EACI,kBAAA;EACN,cAAA;EACM,YAAA;AnMot0CR;AmMlt0CI;EACI,sBAjBgB;AnMqu0CxB;AmMnt0CQ;EACI,gBAAA;AnMqt0CZ;AmMjt0CC;EACC,e5L+HW;APol0Cb;AmMlt0CE;EACC,gBAAA;AnMot0CH;AmMnt0CG;EACC,c5L8BgB;E4L7BhB,e5L0HS;E4LzHT,yBAAA;EACA,aAAA;AnMqt0CJ;AmMlt0CI;EACC,iBAAA;AnMot0CL;AmMjt0CG;EACC,6BAAA;AnMmt0CJ;AmMlt0CI;EACC,aAAA;EACG,mBAAA;EACA,oBAAA;EACA,uBAAA;AnMot0CR;AmMlt0CI;EACC,gB5L+HQ;E4L9HR,oBAAA;EACG,uBAAA;AnMot0CR;AmMlt0CI;EACC,6BAAA;EACA,oBAAA;EACG,uBAAA;AnMot0CR;AmM7s0CC;EACO,sBA9DgB;EA+DhB,aAAA;EACA,8BAAA;EACA,sBAAA;AnM+s0CR;AmM7s0CI;EACC,YAAA;EACA,mBArEmB;AnMox0CxB;AmM9s0CQ;EACI,yBAAA;EACA,c5LdQ;AP8t0CpB;AmM7s0CY;EACI,kBAAA;AnM+s0ChB;AmM7s0CY;EACC,e5LyEA;E4LxEG,gB5L8FH;E4L7FG,c5LtCF;APqv0Cd;AmM9s0CgB;EACI,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;EACA,c5L7CN;AP6v0Cd;AmM9s0CgB;EACX,qBAAA;AnMgt0CL;AmM1s0CK;EACC,mBAAA;AnM4s0CN;AmMzs0CM;EACU,iBAAA;EAOA,gBAAA;AnMqs0ChB;AmM3s0CgB;EACI,cAAA;AnM6s0CpB;AmM3s0CgB;EACI,iBAAA;AnM6s0CpB;AmMxs0CM;EACC,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,c5L3Da;E4L4DhB,oBAAA;AnM0s0CJ;AmMzs0CO;EACI,qBAAA;EACN,mBAAA;EACA,c5LhFS;AP2x0Cd;AmMrs0CI;EACI,gBAAA;EACA,iBAAA;AnMus0CR;AmMts0CQ;EACI,UAAA;EACA,uBAAA;AnMws0CZ;;AkBnx0CI;EiLkFC;IACI,aA9Ic;EnMm10CrB;EmMns0CG;IACC,mBAAA;EnMqs0CJ;EmMns0CG;IACC,cAAA;EnMqs0CJ;EmMns0CG;IACC,mB5LqCO;EPgq0CX;AACF;AoM710CA;EACI,kBAAA;EACA,YAAA;ApM+10CJ;AoM910CI;EACI,kBAAA;EACA,aAAA;EACA,WAAA;ApMg20CR;AoM910CI;EACI,kBAAA;EACA,uBAAA;EACA,gCAAA;ApMg20CR;AoM710CQ;EACI,sBAAA;ApM+10CZ;AoM710CQ;EACI,uBAAA;ApM+10CZ;AoM510CI;EACI,6BAAA;ApM810CR;AoM310CQ;EACI,aAAA;EACA,kBAAA;ApM610CZ;AoM110CI;EACI,kBAAA;EACA,kBAAA;ApM410CR;AoM110CI;EACF,kBAAA;EACA,qBAAA;ApM410CF;AoM310CE;EACC,eAAA;ApM610CH;AoM110CC;EACC,mBAAA;EACM,cAAA;ApM410CR;AoM310CQ;EACC,iBAAA;EACA,gB7LkII;E6LjIJ,c7LHK;APg20Cd;;AqM740CA;EACI,S9LywBgC;E8LxwBhC,sB9LOK;E8LNL,YAAA;EACA,0BAAA;EACA,eAAA;ArMg50CJ;AqM/40CI;EACI,YAAA;ArMi50CR;;AqM740CA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,c9LcK;APk40CT;AqM/40CI;EACI,mBAAA;ArMi50CR;AqM/40CI;EACI,eAAA;ArMi50CR;;AqM540CI;EACI,gBAAA;EACA,YAAA;ArM+40CR;AqM740CI;EACI,kBAAA;ArM+40CR;AqM740CI;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;ArM+40CR;AqM940CQ;EACI,gBAAA;ArMg50CZ;AqM740CI;EACI,aAAA;EACA,eAAA;EACA,uBAAA;ArM+40CR;AqM940CQ;EACI,gBAAA;ArMg50CZ;AqM940CQ;EACI,c9LPE;APu50Cd;AqM/40CY;EACI,c9LOI;AP040CpB;AqM940CQ;EACI,kBAAA;ArMg50CZ;AqM540CQ;EACI,c9LfI;AP650ChB;AqM540CQ;EACI,gBAAA;ArM840CZ;AqM340CI;EACI,kBAAA;EACA,eAAA;EACA,SAAA;EACA,2BAAA;EACA,0BAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,UAAA;ArM640CR;AqM540CQ;EACI,UAAA;ArM840CZ;AqM540CQ;EACI,mBAAA;ArM840CZ;AqM740CY;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,c9L1CF;E8L2CE,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;ArM+40ChB;AqM940CgB;EACI,c9LjCA;APi70CpB;AqM340CI;EACI,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,kB9LmCS;E8LlCT,yBAAA;ArM640CR;AqM540CQ;EACI,0BAAA;EACA,2BAAA;ArM840CZ;AqM540CQ;EACI,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;ArM840CZ;AqM740CY;EACI,cAAA;ArM+40ChB;AqM940CgB;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,sGAAA;EACA,kB9LgBH;E8LfG,yBAAA;EACA,eAAA;ArMg50CpB;AqM740CoB;EACI,qB9LnEJ;E8LoEI,eAAA;ArM+40CxB;AqMz40CI;EACI,aAAA;EACA,mBAAA;ArM240CR;AqM140CQ;EACI,mBAAA;EACA,c9L/FE;AP2+0Cd;AqMz40CI;EACI,kBAAA;ArM240CR;AqMz40CI;EACI,gBAAA;ArM240CR;AqM140CQ;EACI,mBAAA;ArM440CZ;;AqMv40CA;EAGY;IACI,YAAA;ErMw40Cd;AACF;AkB1+0CI;EmL0GQ;IACI,YAAA;ErMm40Cd;AACF;AkB/+0CI;EmLmHQ;IACI,YAAA;ErM+30Cd;AACF;AsM9i1CI;EACI,kBAAA;EACA,UAAA;AtMgj1CR;;AuMnj1CA;EACC,cAAA;AvMsj1CD;AuMrj1CC;EACC,aAAA;EACA,eAAA;AvMuj1CF;AuMrj1CC;EACC,cAAA;EACA,kBAAA;EACA,chMqCc;APkh1ChB;AuMtj1CE;EACC,mBAAA;AvMwj1CH;AuMtj1CE;EACC,mBAAA;EACA,chM4BW;AP4h1Cd;AuMrj1CC;EACC,chMwBY;EgMvBZ,ehMoIW;APm70Cb;AuMtj1CE;EACC,oBAAA;AvMwj1CH;;AuMnj1CA;EACC,YAAA;EACA,YAAA;AvMsj1CD;AuMrj1CC;EACC,aAAA;AvMuj1CF;;AkB//0CI;EqLlDF;IACC,aAAA;EvMqj1CD;AACF;AuM/i1CA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;AvMij1CD;AuMhj1CC;EACC,kBAAA;EAEC,kBAAA;EACA,mBAAA;AvMij1CH;AuM3i1CE;EACC,iBAAA;EAEC,OAAA;EAKD,kBAAA;EACA,chMzBW;APik1Cd;AuMti1CE;EACC,ehMmFU;EgMlFV,gBhMuGU;EgMtGV,uBAAA;AvMwi1CH;AuMti1CE;EACC,chMjCW;EgMkCX,ehM4EU;EgM3EV,oBAAA;AvMwi1CH;AuMvi1CG;EACC,chMrBgB;AP8j1CpB;;AuMji1CC;EACC,aAAA;AvMoi1CF;AuMli1CI;EACI,gCAAA;EACA,6BAAA;EACA,kBhM0CS;AP0/0CjB;AuMni1CQ;EACL,iBAAA;EACA,gBhM+EU;APs90Cb;AuMpi1CG;EACC,gBhM2ES;AP290Cb;AuMni1CQ;EACL,ehMiDU;EgMhDV,chM7DW;EgM8DX,sBAAA;AvMqi1CH;AuMpi1CG;EACC,chM7DY;APmm1ChB;AuMni1CQ;EACL,ehM2CU;EgM1CV,gBAAA;EACA,chMtEW;EgMuEX,gBhM6DU;APw+0Cb;AuMpi1CY;EACR,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBhMnGM;EgMoGN,oBAAA;EACA,mBAAA;EACA,uBAAA;EAEC,oBAAA;AvMqi1CL;AuM9h1CQ;EACL,qBAAA;AvMgi1CH;AuM/h1CG;EACC,chM1GK;AP2o1CT;AuM9h1CQ;EACL,qBAAA;AvMgi1CH;AuM/h1CG;EACC,chMlFgB;APmn1CpB;;AkBnn1CI;EqL0FF;IACC,aAAA;EvM6h1CD;AACF;AuMvh1CC;EACC,aAAA;EACA,mBAAA;EACA,gBAAA;AvMyh1CF;AuMxh1CE;EACC,gCAAA;AvM0h1CH;AuMvh1CC;EACC,iBAAA;AvMyh1CF;AuMxh1CE;EACC,cAAA;EACA,ehMjBU;EgMkBV,chM/HW;EgMgIX,gBAAA;AvM0h1CH;;AkB1o1CI;EqLsHF;IACC,aAAA;IACA,oBAAA;EvMwh1CD;AACF;AuMlh1CC;EACC,aAAA;EACA,gBAAA;AvMoh1CF;AuMnh1CE;EACC,gCAAA;AvMqh1CH;AuMlh1CC;EACC,YAAA;EACA,iBAAA;AvMoh1CF;AuMnh1CE;EACC,mBAAA;EACA,gBhMtBU;EgMuBV,chMzJa;EgM0Jb,aAAA;EACA,8BAAA;EACA,mBAAA;AvMqh1CH;AuMnh1CE;EACC,gBAAA;EACA,mBAAA;AvMqh1CH;AuMnh1CE;EACC,cAAA;EACA,ehM1DU;EgM2DV,chMxKW;AP6r1Cd;;AkB7q1CI;EqL8JF;IACC,aAAA;IACA,uBAAA;EvMmh1CD;AACF;AwM/u1CA;EACC,aAAA;EACG,sBAAA;EACA,iBAAA;AxMiv1CJ;AwMhv1CC;EACC,aAAA;EACA,cAAA;AxMkv1CF;AwMhv1CC;EACC,aAAA;EACA,8BAAA;EACA,oBAAA;EACM,YAAA;EACA,YAAA;EACA,eAAA;AxMkv1CR;AwM/u1CE;EACC,iBAAA;AxMiv1CH;AwM/u1CE;EACC,eAAA;EACA,cjMqBW;EiMpBX,qBAAA;AxMiv1CH;AwM/u1CE;EACC,mBAAA;EACA,cjMmBa;EiMlBb,gBjMmJU;AP8l1Cb;AwM/u1CE;EACC,sBAAA;AxMiv1CH;;AwM1u1CA;EACI,gBAAA;AxM6u1CJ;AwM5u1CC;EACC,YAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AxM8u1CF;AwM5u1CC;EACC,aAAA;AxM8u1CF;AwM5u1CC;EACC,aAAA;EACA,eAAA;EACM,oBAAA;EACA,4BAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;AxM8u1CR;AwM5u1CC;EACC,UAAA;AxM8u1CF;AwM7u1CE;EACC,aAAA;EACA,mBAAA;EACA,cjMpBW;EiMqBX,ejMwFU;APup1Cb;AwM9u1CG;EACC,oBAAA;AxMgv1CJ;AwM7u1CE;EACC,mBAAA;EACS,cjMzBI;EiM0Bb,oBAAA;AxM+u1CH;AwM9u1CG;EACC,ejM8ES;EiM7ET,cjMhCU;APgx1Cd;;AkBnv1CI;EsLWI;IACI,WAAA;ExM4u1CV;EwMzu1CU;IACI,aAAA;IACA,eAAA;IACA,gCAAA;IACA,mBAAA;ExM2u1Cd;EwMzu1CU;IACI,8BAAA;IACA,yBAAA;IACA,4BAAA;ExM2u1Cd;EwMzu1CU;IACI,UAAA;ExM2u1Cd;EwMzu1CU;IACI,UAAA;ExM2u1Cd;EwMzu1CU;IACI,aAAA;ExM2u1Cd;EwMzu1CU;IACI,UAAA;ExM2u1Cd;EwMzu1CU;IACI,WAAA;IACZ,qBAAA;ExM2u1CF;AACF;AwMvu1CA;EAGY;IACI,eAAA;ExMuu1Cd;AACF;AwMju1CC;EACO,aAAA;EACA,eAAA;AxMmu1CR;AwMju1CC;EACC,ejMmBW;EiMlBX,gBjMyCW;EiMxCX,cjM5FY;EiM6FZ,uBAAA;AxMmu1CF;AwMlu1CE;EACC,gBjMoCU;APgs1Cb;AwMju1CC;EACC,cjMhGc;EiMiGd,iBAAA;EACA,gBAAA;EACA,sBAAA;AxMmu1CF;AwMlu1CE;EACC,mBAAA;AxMou1CH;AwMju1CC;EACC,ejMEW;EiMDX,sBAAA;AxMmu1CF;AwMju1CC;EACC,ejMHW;EiMIX,cjMjHY;APo11Cd;;AwM/t1CA;EAEQ;IACI,kBAAA;IACA,oBAAA;ExMiu1CV;EwMhu1CU;IACI,mBAAA;ExMku1Cd;AACF;AwM3t1CC;EACC,UAAA;AxM6t1CF;AwM3t1CC;EACC,aAAA;EACA,gBAAA;AxM6t1CF;;AwMzt1CA;EAEQ;IACI,UAAA;ExM2t1CV;AACF;AwMrt1CC;EACC,eAAA;AxMut1CF;AwMrt1CC;EACC,aAAA;EACA,mBAAA;AxMut1CF;;AwMjt1CC;EACC,aAAA;EACM,8BAAA;EACA,qBAAA;AxMot1CR;AwMlt1CC;EACC,YAAA;AxMot1CF;AwMlt1CC;EACO,YAAA;EACA,oBAAA;EACA,uBAAA;AxMot1CR;AwMnt1CE;EACC,gBAAA;AxMqt1CH;AwMlt1CC;EACC,iBAAA;EACA,mBAAA;AxMot1CF;;AwMjt1CA;EAEQ;IACI,UAAA;ExMmt1CV;AACF;AwMht1CA;EAEQ;IACI,YAAA;ExMit1CV;AACF;AwM3s1CA;EACC,ejM3FY;EiM4FZ,cjMzMa;APs51Cd;AwM5s1CC;EACC,kBAAA;EACA,aAAA;EACA,8BAAA;AxM8s1CF;;AwMxs1CC;EACC,aAAA;EACA,cAAA;AxM2s1CF;AwMzs1CC;EACC,mBAAA;AxM2s1CF;AwM1s1CE;EACC,kBAAA;AxM4s1CH;AwM1s1CE;EACC,cjM7NW;APy61Cd;AwM1s1CE;EACC,cjM7Na;EiM8Nb,iBAAA;AxM4s1CH;AwM1s1CE;EACC,iBAAA;EACA,cjMrOW;APi71Cd;AwM1s1CE;EACC,WAAA;EACA,uBAAA;AxM4s1CH;;AyM/91CI;EACI,eAAA;EACA,gBlM4KK;EkM3KL,clM0CQ;APw71ChB;AyMj+1CQ;EACI,iBAAA;AzMm+1CZ;AyMj+1CQ;EACI,mBAAA;AzMm+1CZ;AyMh+1CY;EACI,WlMLP;APu+1CT;AyM991CI;EACI,mBAAA;AzMg+1CR;AyM991CY;EACI,clMkCI;AP871CpB;AyM591CI;EACI,mBAAA;EACA,gBlMoJK;AP001Cb;AyM591CY;EACI,WlMtBP;APo/1CT;AyM191CI;EACI,kBAAA;AzM491CR;AyM391CQ;EACI,mBAAA;AzM691CZ;AyM391CQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AzM691CZ;AyM591CY;EACI,SAAA;EACA,mBAAA;AzM891ChB;AyM191CI;EACI,aAAA;AzM491CR;AyM191CI;EACI,aAAA;AzM491CR;AyM191CI;EACI,YAAA;AzM491CR;AyM191CI;EACI,aAAA;EACA,sBAAA;AzM491CR;AyM391CQ;EACI,aAAA;EACA,YAAA;EACA,oBAAA;AzM691CZ;AyM391CQ;EACI,YAAA;EACA,eAAA;AzM691CZ;AyM591CY;EACI,aAAA;EACA,8BAAA;EACA,kBAAA;AzM891ChB;AyM591CY;EACI,aAAA;EACA,mBAAA;AzM891ChB;AyM791CgB;EACI,oBAAA;AzM+91CpB;AyMz91CQ;EACI,aAAA;AzM291CZ;AyMz91CQ;EACI,mBAAA;AzM291CZ;AyMv91CQ;EACI,YAAA;EACA,YAAA;EACA,iBAAA;AzMy91CZ;AyMr91CQ;EACI,aAAA;EACA,YAAA;EACA,mBAAA;AzMu91CZ;AyMr91CQ;EACI,aAAA;EACA,uBAAA;EACA,eAAA;AzMu91CZ;AyMt91CY;EACI,qBAAA;AzMw91ChB;AyMt91CY;EACI,aAAA;EACA,mBAAA;EACA,clMvEF;AP+h2Cd;AyMv91CgB;EACI,oBAAA;AzMy91CpB;AyMn91CQ;EACI,aAAA;AzMq91CZ;AyMn91CQ;EACI,aAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;AzMq91CZ;AyMp91CY;EACI,qBAAA;AzMs91ChB;AyMp91CY;EACI,aAAA;EACA,mBAAA;EACA,clM7FF;APmj2Cd;AyMr91CgB;EACI,oBAAA;AzMu91CpB;;AyMj91CA;EAGY;IACI,eAAA;EzMk91Cd;EyM981CU;IACI,aAAA;EzMg91Cd;AACF;AkB/i2CI;EuLuGQ;IACI,aAAA;IACA,YAAA;IACA,oBAAA;EzM281Cd;AACF;AyMr81CI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AzMu81CR;AyMr81CI;EACI,WAAA;EACA,kBAAA;AzMu81CR;AyMt81CQ;EACI,kBAAA;AzMw81CZ;AyMr81CI;EACI,iBAAA;EACA,iBAAA;AzMu81CR;AyMr81CI;EACI,oBAAA;EACA,clMjJQ;EkMkJR,sBAAA;AzMu81CR;AyMr81CI;EACI,oBAAA;EACA,clMzJM;EkM0JN,kBAAA;AzMu81CR;;AyMl81CI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;AzMq81CR;AyMn81CI;EACI,oBAAA;EACA,clMvKM;AP4m2Cd;AyMn81CI;EACI,kBAAA;EACA,clMxKQ;EkMyKR,gBlMvCK;AP4+1Cb;AyMn81CI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AzMq81CR;;AyMj81CA;EACI,aAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBlMnGa;EkMoGb,gBlMpOK;APwq2CT;AyMn81CI;EACI,aAAA;EACA,YAAA;AzMq81CR;AyMn81CI;EACI,mBAAA;AzMq81CR;AyMn81CI;EACI,eAAA;EACA,gBAAA;AzMq81CR;AyMn81CI;EACI,cAAA;EACA,WAAA;EACA,kBAAA;AzMq81CR;AyMl81CQ;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;AzMo81CZ;AyMh81CQ;EACI,iBAAA;AzMk81CZ;;AkB7o2CI;EuLgNA;IACI,eAAA;EzMi81CN;EyMh81CM;IACI,aAAA;IACA,oBAAA;EzMk81CV;EyMh81CM;IACI,mBAAA;EzMk81CV;EyM/71CU;IACI,qBAAA;IACA,qBAAA;EzMi81Cd;AACF;AyM771CA;EAEQ;IACI,WAAA;IACA,kBAAA;EzM871CV;EyM571CM;IACI,kBAAA;IACA,kBAAA;EzM871CV;EyM571CM;IACI,mBAAA;IACA,kBAAA;EzM871CV;AACF;AyM171CA;EACI,SlM2dgC;EkM1dhC,sBlMvSK;EkMwSL,YAAA;EACA,0BAAA;EACA,eAAA;AzM471CJ;AyM371CI;EACI,YAAA;AzM671CR;;A0M9u2CQ;EACI,cnMuCE;EmMtCF,enMoJC;EmMnJD,gBnMyKC;APwk2Cb;A0M9u2CI;EACI,aAAA;EACA,qBAAA;A1Mgv2CR;A0M/u2CQ;EAEQ,mBAAA;A1Mgv2ChB;A0M1u2CQ;EACI,iBAAA;EACA,cnMwBI;APot2ChB;A0M3u2CY;EACI,cnMoBF;APyt2Cd;;AkBxp2CI;EwL5EQ;IACI,eAAA;IACA,gBnM4IH;EP4l2CX;E0Mvu2Cc;IACI,gBnMyIP;EPgm2CX;E0Mtu2CU;IACI,eAAA;E1Mwu2Cd;AACF;A0Mlu2CI;EACI,qBAAA;EACA,sBAAA;A1Mou2CR;;AkB3t2CI;EwLHI;IACI,oBAAA;IACA,qBAAA;E1Mku2CV;AACF;A0M7t2CQ;EACI,kBAAA;EACA,enMuFC;EmMtFD,gBnM4GC;APmn2Cb;;AkBvu2CI;EwLeQ;IAEQ,sBAAA;E1M2t2ClB;AACF;AkB7u2CI;EwL6BQ;IAEQ,sBAAA;E1Mkt2ClB;AACF;AkBlv2CI;EwL2CQ;IAEQ,sBAAA;E1Mys2ClB;AACF;A0M/r2CI;EACI,aAAA;EACA,qBAAA;EACA,8BAAA;A1Mis2CR;A0Mhs2CQ;EAEQ,kBAAA;EAKJ,YAAA;A1M6r2CZ;A0M5r2CY;EACI,enMuBH;EmMtBG,cnMtFF;EmMuFE,yBAAA;EACA,uBAAA;EACA,qBAAA;A1M8r2ChB;A0M5r2CY;EACI,oBAAA;EACA,gBAAA;EACA,cnM3FA;APyx2ChB;A0M7r2CgB;EACI,cnM/FN;AP8x2Cd;A0M3r2CQ;EACI,aAAA;EACA,cAAA;EACA,YAAA;A1M6r2CZ;A0M3r2CQ;EACI,YAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;A1M6r2CZ;;A0Mxr2CA;EACI;IACI,mBAAA;E1M2r2CN;E0M1r2CM;IACI,eAAA;IACA,cAAA;E1M4r2CV;E0M1r2CM;IACI,YAAA;IACA,YAAA;E1M4r2CV;AACF;AkBtv2CI;EwLgEI;IACI,kBAAA;IACA,gBnMCC;EPwr2CX;E0Mxr2CU;IACI,gBnMHH;EP6r2CX;AACF;A0Mpr2CA;EACI,uBAAA;A1Msr2CJ;A0Mrr2CI;EACI,iBAAA;A1Mur2CR;A0Mrr2CI;EACI,gCAAA;A1Mur2CR;A0Mrr2CI;EACI,cnMtJM;EmMuJN,enMzCK;EmM0CL,gBnMpBK;EmMqBL,sBAAA;A1Mur2CR;A0Mrr2CI;EACI,enMhDK;EmMiDL,cnM7JM;EmM8JN,yBAAA;EACA,mBAAA;EACA,qBAAA;A1Mur2CR;A0Mrr2CI;EACI,kBAAA;EACA,gBAAA;EACA,cnMlKQ;APy12ChB;A0Mtr2CQ;EACI,cnMtKE;AP812Cd;A0Mrr2CI;EACI,aAAA;A1Mur2CR;A0Mrr2CI;EACI,UAAA;A1Mur2CR;A0Mrr2CI;EACI,UAAA;A1Mur2CR;A0Mtr2CQ;EACI,aAAA;EACA,qBAAA;A1Mwr2CZ;A0Mtr2CQ;EAEQ,oBAAA;A1Mur2ChB;;A0M7q2CI;EACI,iBAAA;EACA,YAAA;A1Mgr2CR;;A2M/52CI;EACI,kBAAA;EACA,cpMyCM;EoMxCN,oBAAA;A3Mk62CR;A2Mj62CQ;EACI,cpM+BF;APo42CV;A2Mj62CgB;EACI,UAAA;A3Mm62CpB;A2M752CgB;EACI,UAAA;A3M+52CpB;A2M152CI;EACI,UAAA;EACA,kBAAA;EACA,OAAA;EACA,cpMYE;EoMXF,UAAA;EACA,wBAAA;A3M452CR;;A4Mh72CA;EACI,YAAA;EACA,gBAAA;EACA,cAAA;A5Mm72CJ;A4Ml72CI;EACI,qBAAA;A5Mo72CR;A4Mn72CQ;EACI,cAAA;A5Mq72CZ;A4Ml72CQ;EAEQ,iBAAA;A5Mm72ChB;A4M562CI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;A5M862CR;A4M762CQ;EAEQ,iBAAA;EAKJ,mBAAA;A5M062CZ;A4Mz62CY;EACI,crMIF;EqMHE,gBrMsIH;APqy2Cb;A4Mx62CQ;EACI,crMDE;EqMEF,erM2GC;AP+z2Cb;A4Mt62CQ;EACI,mBrM7BF;EqM8BE,gBAAA;EACA,kBrMoFK;APo12CjB;A4Mr62CI;EACI,mBAAA;EACA,yBAAA;EACA,mBrMrCE;EqMsCF,kBrM6ES;EqM5ET,qBAAA;EACA,erM4FK;AP202Cb;A4Mr62CI;EACI,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;A5Mu62CR;A4Mt62CQ;EACI,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,crM7BE;EqM8BF,erMgFC;EqM/ED,gBAAA;A5Mw62CZ;A4Mv62CY;EACI,crMhCF;APy82Cd;A4Mv62CY;EACI,crMpBI;AP672CpB;A4Mv62CY;EACI,kBAAA;EACA,WAAA;EACA,mBrMxEJ;EqMyEI,WAAA;EACA,YAAA;EACA,QAAA;A5My62ChB;A4Mv62CY;EACI,WAAA;A5My62ChB;A4Mv62CY;EACI,UAAA;A5My62ChB;A4Mr62CI;EACI,6BAAA;A5Mu62CR;A4Mt62CQ;EAEQ,oBAAA;EACA,qBAAA;A5Mu62ChB;A4Mh62CQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;A5Mk62CZ;A4Mh62CQ;EACI,aAAA;EACA,mBAAA;A5Mk62CZ;A4Mj62CY;EACI,crM7EF;EqM+EM,qBAAA;A5Mk62CpB;A4M352CQ;EACI,uBAAA;A5M652CZ;A4M552CY;EACI,gCAAA;A5M852ChB;A4M552CY;EACI,mBAAA;A5M852ChB;A4M552CY;EACI,gBAAA;A5M852ChB;A4M752CgB;EACI,iBAAA;A5M+52CpB;A4M552CY;EACI,aAAA;A5M852ChB;A4M352CQ;EACI,gBAAA;EACA,6BAAA;EACA,aAAA;EACA,8BAAA;A5M652CZ;A4M352CQ;EACI,oBAAA;EACA,mBAAA;A5M652CZ;A4M352CQ;EACI,oBAAA;A5M652CZ;A4M352CQ;EACI,aAAA;A5M652CZ;A4M552CY;EAEQ,8BAAA;EAKJ,cAAA;EACA,crM/HF;APwh3Cd;A4Mv52CY;EACI,WAAA;A5My52ChB;A4Mv52CY;EACI,aAAA;A5My52ChB;A4Mx52CgB;EACI,aAAA;A5M052CpB;A4Mv52CY;EACI,oBAAA;EACA,mBAAA;EACA,crM1IA;APmi3ChB;A4Mx52CgB;EACI,crM/HA;APyh3CpB;A4Mt52CQ;EACI,kBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;A5Mw52CZ;A4Mt52CQ;EACI,qBAAA;A5Mw52CZ;A4Mt52CQ;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EAEI,QAAA;EAKJ,MAAA;EACA,mBAAA;A5Mm52CZ;A4Mj52CgB;EACI,erMhEP;EqMiEO,crM9KN;EqM+KM,cAAA;EACA,mBAAA;EACA,yBAAA;A5Mm52CpB;A4Ml52CoB;EACI,crMnKJ;APuj3CpB;A4M942CY;EACI,oCAAA;EACA,gBrMvDH;EqMwDG,crM3LF;EqM4LE,kBrMhGC;APg/2CjB;A4M142CY;EACI,aAAA;A5M442ChB;A4Mz42CQ;EACI,crMvME;EqMwMF,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;A5M242CZ;A4M142CY;EACI,cAAA;A5M442ChB;A4Mz42CQ;EACI,gBAAA;A5M242CZ;A4M142CY;EACI,aAAA;EACA,qBAAA;EACA,oBAAA;A5M442ChB;A4M342CgB;EACI,WAAA;EACA,iBAAA;EACA,crM1NN;EqM2NM,erM9GP;EqMgHW,qBAAA;A5M442CxB;A4Mt42CgB;EACI,erMtHP;AP8/2Cb;A4Mv42CoB;EACI,crMrOV;AP8m3Cd;A4Mn42CI;EACI,aAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;A5Mq42CR;A4Mp42CQ;EAEQ,kBAAA;EAKJ,oBAAA;EACA,crMxPE;APyn3Cd;A4M/32CQ;EACI,kBAAA;EAEI,sBAAA;A5Mg42ChB;A4Mz32CI;EACI,aAAA;EACA,YAAA;A5M232CR;A4M132CQ;EACI,gBAAA;A5M432CZ;A4M132CQ;EACI,mBAAA;A5M432CZ;A4Mz32CI;EAEQ,iBAAA;EAKJ,8BAAA;A5Ms32CR;A4Mn32CQ;EACI,gBAAA;A5Mq32CZ;A4Mn32CQ;EACI,eAAA;A5Mq32CZ;A4Mj32CQ;EACI,aAAA;A5Mm32CZ;A4M/22CQ;EACI,aAAA;EACA,mBAAA;A5Mi32CZ;;A4M522CI;EACI,aAAA;A5M+22CR;;A4M322CA;EACI,WAAA;EACA,YAAA;A5M822CJ;;AkBro3CI;E0L2RI;IACI,eAAA;E5M822CV;E4M722CU;IACI,erM7MH;IqM+MO,oBAAA;E5M822ClB;E4Mx22CU;IACI,kBAAA;IAEI,sBAAA;E5My22ClB;AACF;AkBnp3CI;E0LoTI;IACI,8BAAA;IAEI,oBAAA;E5Mi22Cd;E4M512CU;IACI,8BAAA;E5M812Cd;E4M512CU;IACI,erMjPH;IqMkPG,crM9VF;IqMgWM,qBAAA;E5M612ClB;E4Mv12CU;IACI,erMzPH;EPkl3CX;E4Mr12CU;IAEQ,oBAAA;E5Ms12ClB;E4Mh12CU;IACI,eAAA;IACA,mBAAA;E5Mk12Cd;E4Mh12CU;IACI,gBrMpPH;EPsk3CX;E4M902CU;IACI,aAAA;E5Mg12Cd;E4M702CM;IACI,YAAA;IACA,WAAA;E5M+02CV;E4M502CU;IACI,erMzRH;IqM0RG,mBAAA;E5M802Cd;E4M302Cc;IACI,erM9RP;EP2m3CX;E4M302Cc;IAEQ,6BAAA;E5M402CtB;AACF;AkB5s3CI;E0L6YI;IACI,yBAAA;IACA,yBAAA;IACA,kBrMnUK;EPqo3Cf;E4Mj02CU;IACI,iBAAA;E5Mm02Cd;E4Mj02CU;IACI,sBAAA;E5Mm02Cd;E4Mj02CkB;IACI,iBAAA;E5Mm02CtB;E4M/z2CU;IACI,oBAAA;E5Mi02Cd;E4Mh02Cc;IACI,eAAA;E5Mk02ClB;E4M9z2CM;IACI,qBAAA;E5Mg02CV;E4M9z2CM;IACI,iBAAA;E5Mg02CV;E4M7z2CU;IACI,erM7UH;EP4o3CX;E4M5z2CM;IACI,8BAAA;E5M8z2CV;AACF;AkB9u3CI;E0LsbI;IACI,uBAAA;E5M2z2CV;E4Mzz2CM;IACI,oBAAA;E5M2z2CV;E4Mzz2CM;IACI,gBAAA;E5M2z2CV;E4Mzz2CM;IACI,4BAAA;E5M2z2CV;AACF;A6Mvz3CI;EACI,mBAAA;EACA,yBAAA;EACA,kBtMqIS;APor3CjB;A6Mvz3CI;EACI,qBAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;A7Myz3CR;A6Mvz3CI;EACI,YAAA;EACA,mBAAA;EACA,sBAAA;A7Myz3CR;A6Mxz3CQ;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,ctMyBE;APiy3Cd;A6Mxz3CQ;EACI,iBAAA;EACA,ctMoCQ;EsMnCR,qBAAA;A7M0z3CZ;A6Mpz3CI;EACI,6BAAA;EACA,mBtMXE;EsMYF,wBAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;A7Msz3CR;A6Mpz3CI;EACI,gBtMwIK;EsMvIL,ctMMQ;APgz3ChB;A6Mnz3CQ;EACI,ctMDE;EsMEF,oBAAA;A7Mqz3CZ;A6Mlz3CY;EACI,ctMUI;AP0y3CpB;;A6M9y3CA;EAEQ;IACI,etM8FC;EPkt3CX;E6M9y3CM;IACI,etM2FC;EPqt3CX;AACF;A8Mp23CI;EACI,kBAAA;EACA,gCAAA;EACA,kBAAA;EACA,mBvMOE;EuMNF,UAAA;A9Ms23CR;A8Mr23CQ;EACI,eAAA;EACA,YAAA;EACA,gCAAA;A9Mu23CZ;A8Mr23CQ;EACI,mCAAA;A9Mu23CZ;A8Mp23CI;EACI,aAAA;EACA,kBAAA;A9Ms23CR;A8Mr23CQ;EACI,kBAAA;A9Mu23CZ;A8Mt23CY;EACI,oBAAA;EACA,kBAAA;EACA,cvMUF;EuMTE,gBvM6IH;EuM5IG,mBAAA;EACA,mBAAA;EACA,eAAA;A9Mw23ChB;A8Mv23CgB;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,mBvMiBA;EuMhBA,YAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;A9My23CpB;A8Mv23CgB;EACI,mBAAA;EACA,mBAAA;A9My23CpB;A8Mv23CgB;EACI,cvMKA;APo23CpB;A8Mr23CgB;EACI,cAAA;A9Mu23CpB;A8Mt23CoB;EACI,UAAA;A9Mw23CxB;;A8Mh23CA;EACI,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,uCAAA;EACA,uCAAA;EACA,gBvMnEK;APs63CT;A8Ml23CI;EACI,mBvMxDE;EuMyDF,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;A9Mo23CR;A8Mn23CQ;EACI,oCAAA;EACA,2BAAA;EACA,8BAAA;A9Mq23CZ;A8Mj23CI;EAEI,gBAAA;EACA,YAAA;EACA,cAAA;A9Mk23CR;A8Mh23CI;EACI,aAAA;EACA,wBAAA;EAIA,eAAA;A9M+13CR;A8Ml23CQ;EACI,gCAAA;A9Mo23CZ;A8Mj23CQ;EACI,gBvMlGH;EuMmGG,eAAA;A9Mm23CZ;A8Mh23CI;EACI,4BAAA;EACA,oBAAA;EACA,YAAA;A9Mk23CR;A8Mh23CI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;A9Mk23CR;A8Mh23CI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;A9Mk23CR;A8Mj23CQ;EACI,gBAAA;A9Mm23CZ;A8M/13CI;EACI,oBAAA;EACA,mBAAA;EACA,cvMzFM;EuM0FN,evMmBK;AP803Cb;A8Mh23CQ;EACI,oBAAA;A9Mk23CZ;A8Mj23CY;EACI,gBvMsCH;EuMrCG,cvM5FA;AP+73ChB;A8M/13CI;EACI,oBAAA;EACA,mBAAA;EACA,cvMtGM;EuMuGN,evMMK;AP213Cb;A8M/13CY;EACI,mBAAA;A9Mi23ChB;A8M913CQ;EACI,oBAAA;A9Mg23CZ;A8M713CI;EACI,4BAAA;EACA,YAAA;EACA,qBAAA;A9M+13CR;A8M913CQ;EACI,evMNC;EuMOD,sBAAA;A9Mg23CZ;A8M713CQ;EACI,evMbC;EuMcD,cvM5HE;EuM6HF,gBAAA;EACA,gBAAA;A9M+13CZ;A8M913CY;EACI,cvM/HF;EuMgIE,gBvMGH;AP613Cb;A8M513CI;EACI,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;A9M813CR;A8M713CQ;EACI,iBAAA;A9M+13CZ;A8M713CQ;EACI,mBAAA;A9M+13CZ;A8M713CQ;EACI,iBAAA;EACA,eAAA;EACA,kBAAA;A9M+13CZ;A8M513CI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;EACA,UAAA;EAAW,oBAAA;EACX,UAAA;A9M+13CR;A8M913CQ;EACI,UAAA;EACA,oBAAA;A9Mg23CZ;A8M713CI;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,sCAAA;EACA,gBvMpNC;EuMqND,YAAA;A9M+13CR;A8M913CQ;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,gEAAA;EACA,yBAAA;EACA,sBvMlOH;EuMmOG,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,cvMnME;EuMoMF,YAAA;A9Mg23CZ;A8M/13CY;EACI,eAAA;EACA,0BAAA;A9Mi23ChB;A8M913CQ;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,iCvM8ewB;EuM7exB,YAAA;EACA,WAAA;EACA,sCAAA;A9Mg23CZ;A8M913CQ;EACI,eAAA;A9Mg23CZ;A8M713CI;EACI,kBAAA;EACA,wBAAA;EACA,gCAAA;A9M+13CR;A8M913CQ;EACI,qBAAA;A9Mg23CZ;A8M913CQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;A9Mg23CZ;A8M713CI;EACI,eAAA;A9M+13CR;A8M713CI;EACI,kBAAA;A9M+13CR;A8M913CQ;EACI,kBAAA;EACA,cvM7OE;AP6k4Cd;A8M/13CY;EACI,oBAAA;EACA,mBAAA;A9Mi23ChB;A8Mh23CgB;EACI,cvMlOA;EuMmOA,qBAAA;A9Mk23CpB;A8M513CI;EACI,aAAA;EACA,kBAAA;A9M813CR;A8M713CQ;EACI,kBAAA;A9M+13CZ;;AkB/j4CI;E4LwOI;IACI,YAAA;IACA,kBvM1KK;IuM2KL,gCAAA;IACA,gCAAA;E9M213CV;AACF;AkBrl4CI;E4LgQI;IACI,eAAA;E9Mw13CV;E8Mv13CU;IACI,iBAAA;E9My13Cd;E8Mt13CM;IACI,qBAAA;E9Mw13CV;E8Mt13CM;IACI,qBAAA;E9Mw13CV;E8Mv13CU;IACI,mBAAA;E9My13Cd;AACF;AkB1k4CI;E4LyPQ;IACI,oBAAA;IACA,uBAAA;E9Mo13Cd;AACF;AkB5m4CI;E4L8RI;IACI,kBAAA;E9Mi13CV;E8Mh13CU;IACI,mBAAA;E9Mk13Cd;E8M/03CM;IACI,wBAAA;E9Mi13CV;E8M/03CM;IACI,oBAAA;E9Mi13CV;E8Mh13CU;IACI,gBAAA;IACA,gBAAA;E9Mk13Cd;E8M/03CM;IACI,YAAA;IACA,+BAAA;E9Mi13CV;E8M/03CM;IACI,gBAAA;IACA,UAAA;IACA,oBAAA;E9Mi13CV;E8M/03CM;IACI,8BAAA;E9Mi13CV;E8Mh13CU;IACI,kBAAA;IACA,aAAA;E9Mk13Cd;AACF;AkB9o4CI;E4LkUI;IACI,YAAA;E9M+03CV;AACF;AkBto4CI;E4L6TI;IACI,YAAA;E9M403CV;E8M303CU;IACI,YAAA;E9M603Cd;AACF;A8Mz03CA;EAGY;IACI,YAAA;E9My03Cd;AACF;AkBhq4CI;E4L6VI;IACI,oBAAA;E9Ms03CV;AACF;A8Mn03CA;EAGY;IACI,oBAAA;E9Mm03Cd;AACF;A+Mpu4CA;EACI,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,cxMsCU;EwMrCV,gBxMEK;EwMDL,yBAAA;EACA,qBAAA;EACA,gBxMqKS;EwMpKT,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,kBxM4HgB;AP0m4CpB;A+Mru4CI;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,mBAAA;A/Muu4CR;A+Mru4CI;EACI,WAAA;EACA,yDAAA;EACA,2BAAA;A/Muu4CR;A+Mru4CI;EACI,WAAA;EACA,2BAAA;EACA,sDAAA;A/Muu4CR;;A+Mnu4CA;EACI,gBAAA;EACA,mBAAA;EACA,uBAAA;A/Msu4CJ;A+Mru4CI;EACI,aAAA;EACA,mBAAA;A/Muu4CR;A+Mru4CI;EACI,qBAAA;A/Muu4CR;A+Mru4CI;EACI,eAAA;EACA,cxMNM;AP6u4Cd;A+Mtu4CQ;EACI,cxMPE;AP+u4Cd;A+Mtu4CQ;EACI,cxMRI;APgv4ChB;A+Mvu4CY;EACI,gBxMuHH;APkn4Cb;;A+Mnu4CA;EACI,kBAAA;EACA,qBAAA;EACA,iCAAA;A/Msu4CJ;A+Mru4CI;EACI,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EACA,iCAAA;A/Muu4CR;A+Mtu4CQ;EACI,UAAA;EACA,yBxMrDF;AP6x4CV;A+Mru4CI;EACI,yBxMzDE;APgy4CV;;A+Mnu4CA;EACI,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,uCAAA;EACA,uCAAA;EACA,gBxMhFK;APsz4CT;A+Mru4CI;EACI,kBAAA;EACA,gBxMnFC;EwMoFD,YA7FgB;EA8FhB,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,cAAA;EACA,+BAAA;EACA,4BAAA;EACA,WAAA;EACA,iCAAA;A/Muu4CR;A+Mtu4CQ;EACI,WAAA;EACA,kBAAA;A/Mwu4CZ;A+Mtu4CQ;EACI,eAAA;A/Mwu4CZ;A+Mru4CI;EACI,cAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;A/Muu4CR;A+Mtu4CQ;EACI,YAAA;EACA,aAAA;EACA,sBAAA;A/Mwu4CZ;A+Mtu4CQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,4BAAA;A/Mwu4CZ;A+Mvu4CY;EACI,eAAA;EACA,gBAAA;A/Myu4ChB;A+Mvu4CY;EACI,cxMzFF;EwM0FE,mBAAA;A/Myu4ChB;A+Mru4CI;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,wBAAA;EACA,gCAAA;EACA,gBAAA;A/Muu4CR;A+Mtu4CQ;EACI,eAAA;EACA,gBAAA;A/Mwu4CZ;A+Mtu4CQ;EACI,aAAA;EACA,mBAAA;A/Mwu4CZ;A+Mru4CY;EACI,kBAAA;A/Muu4ChB;A+Mnu4CY;EACI,0BAAA;A/Mqu4ChB;A+Mpu4CgB;EACI,kBAAA;A/Msu4CpB;A+Mnu4CY;EACI,mCAAA;A/Mqu4ChB;A+Mlu4CQ;EACI,aAAA;EACA,sBAAA;A/Mou4CZ;A+Mhu4CI;EACI,kBAAA;EACA,oBAAA;EACA,gCAAA;A/Mku4CR;A+Mju4CQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;A/Mmu4CZ;A+Mhu4CY;EACI,aAAA;EACA,mBAAA;A/Mku4ChB;A+Mhu4CY;EACI,iBAAA;A/Mku4ChB;A+Mju4CgB;EACI,mBAAA;A/Mmu4CpB;A+M/t4CgB;EACI,mBAAA;A/Miu4CpB;A+M1t4CQ;EACI,aAAA;A/M4t4CZ;A+M3t4CY;EACI,mBxM1LN;EwM2LM,kBxMtEI;APmy4CpB;A+M3t4CY;EACI,mBxM9JI;EwM+JJ,kBxM1EI;APuy4CpB;A+Mzt4CQ;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBxMrFK;APgz4CjB;A+M1t4CY;EACI,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,cxMvLF;APm54Cd;A+M1t4CY;EACI,iBAAA;EACA,kBAAA;EACA,uBAAA;A/M4t4ChB;A+Mzt4CgB;EACI,cxMhLA;AP244CpB;A+Mvt4CQ;EACI,mBAAA;EACA,cxMrME;EwMsMF,gBxMnEC;EwMoED,mBAAA;A/Myt4CZ;A+Mxt4CY;EACI,cxM1LI;APo54CpB;A+Mrt4CQ;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBxMtHK;EwMuHL,aAAA;EACA,iCAAA;A/Mut4CZ;A+Mtt4CY;EACI,aAAA;EACA,uBAAA;EACA,YAAA;A/Mwt4ChB;A+Mtt4CY;EACI,UAAA;A/Mwt4ChB;A+Mvt4CgB;EACI,cxM7NN;EwM8NM,kBAAA;A/Myt4CpB;A+Mtt4CY;EACI,mBxMzPN;APi94CV;A+Mvt4CgB;EACI,UAAA;A/Myt4CpB;A+Mtt4CY;EACI,mBxM7NI;APq74CpB;A+Mnt4CQ;EACI,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,cxMjPE;EwMkPF,gBxM/GC;APo04Cb;A+Mlt4CI;EACI,qBAAA;EACA,sBAAA;A/Mot4CR;A+Mlt4CI;EACI,oBAAA;A/Mot4CR;A+Mlt4CI;EACI,uBAAA;A/Mot4CR;A+Mlt4CI;EACI,gBAAA;EACA,mBxMxRE;EwMyRF,sBAAA;A/Mot4CR;A+Mnt4CQ;EACI,qBAAA;A/Mqt4CZ;A+Mpt4CY;EACI,cAAA;EACA,qBAAA;A/Mst4ChB;A+Mlt4CI;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;A/Mot4CR;A+Mlt4CI;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;A/Mot4CR;A+Mlt4CI;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBxMlUC;EwMmUD,qBAAA;EACA,iCAAA;EACA,eAAA;A/Mot4CR;A+Mnt4CQ;EACI,gCAAA;A/Mqt4CZ;A+Mnt4CQ;EACI,mBxM7TF;APkh5CV;A+Mnt4CQ;EACI,oCAAA;A/Mqt4CZ;A+Mnt4CQ;EACI,cAAA;EACA,cAAA;A/Mqt4CZ;A+Mpt4CY;EACI,eAAA;A/Mst4ChB;A+Mnt4CQ;EACI,WAAA;EACA,oBAAA;A/Mqt4CZ;A+Mnt4CQ;EACI,YAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;A/Mqt4CZ;A+Mlt4CY;EACI,4BAAA;A/Mot4ChB;A+Mnt4CgB;EACI,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBxMlMP;APu54Cb;A+Mpt4CoB;EACI,gBxMnMX;APy54Cb;A+Mjt4CQ;EACI,cAAA;A/Mmt4CZ;A+Mjt4CQ;EACI,WAAA;EACA,iBAAA;A/Mmt4CZ;A+Mjt4CQ;EACI,cAAA;EACA,kBAAA;A/Mmt4CZ;A+Mht4CY;EACI,kBAAA;A/Mkt4ChB;A+Mjt4CgB;EACI,aAAA;A/Mmt4CpB;A+Mjt4CgB;EACI,cAAA;EACA,mBAAA;A/Mmt4CpB;A+M/s4CQ;EACI,gBAAA;EACA,iBAAA;EACA,iBAAA;A/Mit4CZ;A+M/s4CQ;EACI,kBAAA;EACA,UAAA;A/Mit4CZ;A+M/s4CQ;EACI,kBAAA;A/Mit4CZ;A+M9s4CI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;A/Mgt4CR;A+M/s4CQ;EACI,eAAA;A/Mit4CZ;A+M9s4CI;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,gBxMpaC;EwMqaD,UAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;A/Mgt4CR;A+M/s4CQ;EACI,UAAA;EACA,mBAAA;EACA,mBAAA;A/Mit4CZ;A+M7s4CQ;EACI,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;A/M+s4CZ;A+M9s4CY;EACI,sBAAA;A/Mgt4ChB;A+M7s4CQ;EACI,qBAAA;A/M+s4CZ;A+M7s4CQ;EACI,kBAAA;A/M+s4CZ;A+M9s4CY;EACI,cAAA;EACA,mBAAA;EACA,sBAAA;A/Mgt4ChB;A+M7s4CgB;EACI,kBAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBxM1cR;APyp5CZ;;AkB1m5CI;E6LoaI;IACI,qBAAA;IACA,sBAAA;E/M0s4CV;E+Mvs4CU;IACI,0BAAA;E/Mys4Cd;E+Mrs4CU;IACI,sBAAA;E/Mus4Cd;E+Mrs4CU;IACI,uBAAA;E/Mus4Cd;E+Mts4Cc;IACI,iBAAA;E/Mws4ClB;E+Mts4Cc;IACI,gBAAA;IACA,aAAA;IACA,cAAA;E/Mws4ClB;E+Mrs4CU;IACI,oBAAA;E/Mus4Cd;AACF;AkBro5CI;E6LqcQ;IACI,YAAA;E/Mms4Cd;AACF;AkB1o5CI;E6L6cI;IACI,gBAAA;IACA,eAAA;IACA,gBAAA;IACA,2BAAA;E/Mgs4CV;E+M9r4CM;IACI,kBAAA;IACA,mBAAA;E/Mgs4CV;E+M9r4CM;IACI,iBAAA;E/Mgs4CV;E+M9r4CM;IACI,oBAAA;E/Mgs4CV;E+M7r4CU;IACI,qBAAA;IACA,sBAAA;E/M+r4Cd;E+M5r4CM;IACI,qBAAA;IACA,sBAAA;E/M8r4CV;E+M3r4CU;IACI,2BAAA;E/M6r4Cd;E+M1r4CM;IACI,6BAAA;E/M4r4CV;E+Mzr4CU;IACI,oBAAA;E/M2r4Cd;E+Mzr4CU;IACI,qBAAA;IACA,sBAAA;E/M2r4Cd;AACF;AkBjr5CI;E6L6fI;IACI,YAAA;E/Mur4CV;E+Mpr4CU;IACI,YAAA;E/Msr4Cd;E+Mpr4CU;IACI,kBAAA;E/Msr4Cd;AACF;AkB5r5CI;E6L6gBQ;IACI,YAAA;E/Mkr4Cd;E+Mhr4CU;IACI,iBAAA;E/Mkr4Cd;AACF;AkBvr5CI;E6L6gBQ;IACI,aAAA;E/M6q4Cd;AACF;AkB5r5CI;E6LshBI;IACI,eAAA;E/Myq4CV;E+Mxq4CU;IACI,cAAA;E/M0q4Cd;E+Mxq4CU;IACI,kBAAA;IACA,mBAAA;IACA,eAAA;IACA,0BAAA;E/M0q4Cd;E+Mzq4Cc;IACI,cAAA;E/M2q4ClB;E+Mxq4CU;IACI,aAAA;E/M0q4Cd;E+Mxq4CU;IACI,YAAA;E/M0q4Cd;E+Mzq4Cc;IACI,YAAA;IACA,WAAA;IACA,exM5dP;EPuo5CX;E+Mxq4CU;IACI,kBAAA;IACA,WAAA;IACA,SAAA;E/M0q4Cd;E+Mxq4CU;IACI,kBAAA;IACA,WAAA;IACA,iBAAA;IACA,YAAA;E/M0q4Cd;E+Mxq4CU;IACI,kBAAA;IACA,UAAA;IACA,SAAA;E/M0q4Cd;E+Mvq4CM;IACI,aAAA;E/Myq4CV;E+Mtq4CE;IACI,aAAA;E/Mwq4CN;AACF;AkB9u5CI;E6L4kBQ;IACI,UAAA;E/Mqq4Cd;E+Mnq4CU;IACI,WAAA;E/Mqq4Cd;E+Mnq4CU;IACI,UAAA;E/Mqq4Cd;E+Mhq4Cc;IACI,mBAAA;E/Mkq4ClB;E+M/p4CU;IACI,sBAAA;IACA,yBAAA;E/Miq4Cd;E+Mhq4Cc;IACI,eAAA;E/Mkq4ClB;AACF;A+M7p4CA;EAGY;IACI,sBAAA;IACA,yBAAA;E/M6p4Cd;E+M5p4Cc;IACI,eAAA;E/M8p4ClB;AACF;AkB7v5CI;E6LumBI;IACI,YAAA;E/Myp4CV;E+Mvp4CM;IACG,oBAAA;IACA,qBAAA;E/Myp4CT;E+Mvp4CM;IACI,qBAAA;IACA,sBAAA;E/Myp4CV;AACF;AgNz15CA;EACI,kBAAA;EACA,yBzMWM;EyMVN,uCAAA;AhN215CJ;AgN115CI;EACI,eAAA;EACA,YAfoB;EAgBpB,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBzMVC;EyMWD,cAAA;EACA,OAAA;EACA,4BAAA;EACA,+BAAA;EACA,WAAA;EACA,SzMivB4B;EyMhvB5B,iCAAA;EACA,8BAAA;EACA,8BAAA;EACA,gBAAA;AhN415CR;AgN315CQ;EACI,WAAA;AhN615CZ;AgN315CQ;EACI,eAAA;AhN615CZ;AgN315CQ;EACI,YAAA;AhN615CZ;AgN315CQ;EACI,YAAA;EACA,aAAA;EACA,sBAAA;AhN615CZ;AgN315CQ;EACI,mBAAA;EACA,mBAAA;AhN615CZ;AgN115CI;EACI,aAAA;AhN415CR;AgN315CQ;EACI,aAAA;AhN615CZ;AgN315CQ;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBzM8EK;AP+w5CjB;AgN515CY;EACI,mBzMvCN;EyMwCM,kBzM6EI;APix5CpB;AgN515CY;EACI,mBzMXI;EyMYJ,kBzMyEI;APqx5CpB;AgN515CY;EACI,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,WAAA;EACA,czM7BF;AP235Cd;AgN515CY;EACI,iBAAA;EACA,kBAAA;AhN815ChB;AgN315CgB;EACI,czMrBA;APk35CpB;AgNz15CQ;EACI,mBAAA;EACA,czM1CE;EyM2CF,gBzMwFC;EyMvFD,mBAAA;AhN215CZ;AgN115CY;EACI,czM/BI;AP235CpB;AgNz15CQ;EACI,qBAAA;EACA,qBAAA;EACA,qBAAA;AhN215CZ;AgN115CY;EACI,qBAAA;EACA,8BAAA;AhN415ChB;AgNz15CgB;EACI,mBAAA;AhN215CpB;AgN115CoB;EACI,uBAAA;AhN415CxB;AgN315CwB;EACI,czMhDR;AP645CpB;AgNz15CgB;EACI,cAAA;EACA,qBAAA;AhN215CpB;AgNt15CI;EACI,gBAAA;AhNw15CR;AgNv15CQ;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,czMhFE;EyMiFF,mBAAA;AhNy15CZ;AgNx15CY;EACI,kBAAA;EACA,qBAAA;AhN015ChB;AgNv15CQ;EACI,ezMoBC;EyMnBD,gBzM0CC;EyMzCD,czM3FE;EyM4FF,gBAAA;AhNy15CZ;AgNt15CI;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;AhNw15CR;AgNv15CQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,wBAAA;EACA,gCAAA;EACA,sBzM/IH;EyMgJG,UAAA;EACA,kBAAA;EACA,MAAA;EACA,4BzMnBK;AP425CjB;AgNv15CQ;EACI,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;AhNy15CZ;AgNv15CQ;EACI,iBAAA;AhNy15CZ;AgNt15CI;EACI,aAAA;EACA,mBAAA;EACA,YAAA;AhNw15CR;AgNt15CI;EACI,sBAAA;AhNw15CR;AgNv15CQ;EACI,gBAAA;EACA,ezMvBC;EyMwBD,czMtIE;AP+95Cd;AgNv15CQ;EACI,mBAAA;AhNy15CZ;AgNt15CI;EACI,6BAAA;EACA,6BAAA;AhNw15CR;AgNv15CQ;EACI,WAAA;AhNy15CZ;AgNt15CY;EACI,wBAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;AhNw15ChB;AgNv15CgB;EACI,kBAAA;EACA,aAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,czM7JN;APs/5Cd;AgNp15CI;EACI,iBAAA;AhNs15CR;AgNr15CQ;EACI,gBAAA;EACA,iBAAA;AhNu15CZ;;AkB9+5CI;E8L8JQ;IACI,oBAAA;IACA,uBAAA;EhNo15Cd;EgNj15CM;IACI,oBAAA;EhNm15CV;AACF;AkBx/5CI;E8LyKA;IACI,mBAtOoB;EhNwj6C1B;EgNj15CM;IACI,eAAA;IACA,gBAAA;IACA,YA1OgB;IA2OhB,kBAAA;IACA,OAAA;IACA,2BzMpGK;IyMqGL,8BzMrGK;IyMsGL,MAAA;IACA,gBAAA;IACA,gBAAA;EhNm15CV;EgNl15CU;IACI,YAAA;EhNo15Cd;EgNh15CU;IACI,wBAAA;IACA,UAAA;EhNk15Cd;EgNh15CU;IACI,gBAAA;EhNk15Cd;AACF;AkBnh6CI;E8LsMA;IACI,mBAlQoB;EhNkl6C1B;EgN/05CM;IACI,yBAAA;EhNi15CV;EgN/05CM;IACI,YAvQgB;EhNwl6C1B;AACF;AgN705CA;EACI;IACI,mBA9QoB;EhN6l6C1B;EgN905CM;IACI,YAhRgB;EhNgm6C1B;AACF;AkB1g6CI;E8LgMI;IACI,YAAA;EhN605CV;EgN305CM;IACI,qBAAA;IACA,sBAAA;EhN605CV;EgN305CM;IACI,qBAAA;EhN605CV;AACF;AgNv05CI;EACI,ezM/IK;EyMgJL,czM7PM;APsk6Cd;AgNv05CI;EACI,gBzM5HK;EyM6HL,ezMnJK;EyMoJL,czMlQM;AP2k6Cd;AgNt05CQ;EACI,UAAA;AhNw05CZ;AgNr05CI;EACI,iBAAA;EACA,cAAA;AhNu05CR;AgNt05CQ;EACI,cAAA;EACA,qBAAA;EACA,cAAA;AhNw05CZ;AgNt05CQ;EACI,WA3TiB;EA4TjB,qBAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;AhNw05CZ;AgNr05CI;EACI,aAAA;EACA,mBAAA;AhNu05CR;AgNt05CQ;EACI,oBAAA;EACA,iBAAA;AhNw05CZ;AgNr05CI;EACI,gBzM9JK;EyM+JL,czMhSQ;EyMiSR,kBAAA;EACA,gBAAA;AhNu05CR;AgNt05CQ;EACI,qBAAA;EACA,qBAAA;AhNw05CZ;AgNv05CY;EACI,sBAAA;EACA,qBAAA;EACA,qBAAA;EACA,sBAAA;AhNy05ChB;AgNv05CY;EACI,czM7SA;APsn6ChB;AgNx05CgB;EACI,czMlSA;AP4m6CpB;AgNt05CQ;EACI,ezM1MC;EyM2MD,czMxTE;APgo6Cd;AgNt05CQ;EACI,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,wBAAA;EACA,gBAAA;EACA,QAAA;EACA,2BAAA;AhNw05CZ;AgNv05CY;EACI,UAAA;AhNy05ChB;AgNv05CY;EACI,mBAAA;EACA,czMvTI;APgo6CpB;AgNr05CI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AhNu05CR;AgNt05CQ;EACI,kBAAA;EACA,mBAAA;EACA,ezMrOC;EyMsOD,czMnVE;AP2p6Cd;AgNv05CY;EACI,gBnHnWP;EmHoWO,sBzM0bG;EyMzbH,kBAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,YAAA;AhNy05ChB;AgNr05CI;EACI,qBAAA;EACA,cAAA;EACA,cAAA;AhNu05CR;AgNr05CY;EACI,czMvVI;AP8p6CpB;AgNp05CQ;EACI,kBAAA;AhNs05CZ;AgNr05CY;EACI,mBAAA;AhNu05ChB;AgNl05CQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;AhNo05CZ;AgNl05CQ;EACI,uBAAA;AhNo05CZ;AgNn05CY;EACI,gCAAA;AhNq05ChB;AgNn05CY;EACI,mBAAA;AhNq05ChB;AgNn05CY;EACI,gBAAA;AhNq05ChB;AgNp05CgB;EACI,iBAAA;AhNs05CpB;AgNl05CQ;EACI,aAAA;AhNo05CZ;AgNn05CY;EACI,8BAAA;EACA,cAAA;EACA,czM7YF;APkt6Cd;AgNn05CY;EACI,WAAA;AhNq05ChB;AgNl05CQ;EACI,kBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AhNo05CZ;AgNl05CQ;EACI,cAAA;AhNo05CZ;AgNh05CQ;EACI,aAAA;EACA,eAAA;EACA,kBAAA;AhNk05CZ;AgNh05CQ;EACI,ezMvTC;APyn6Cb;AgNj05CY;EACI,czMvaF;EyMwaE,WAAA;AhNm05ChB;AgNj05CY;EACI,czM1aF;AP6u6Cd;AgNj05CY;EACI,UAAA;AhNm05ChB;;AgN9z5CA;EAGY;IACI,iBAAA;IACA,mBAAA;EhN+z5Cd;EgN5z5Cc;IACI,YAAA;IACA,cAAA;EhN8z5ClB;AACF;AkB5u6CI;E8LwbgB;IACI,iBAAA;EhNuz5CtB;AACF;AgN7y5CQ;EACI,UAAA;EACA,wBAAA;AhN+y5CZ;AgN5y5CY;EACI,UAAA;AhN8y5ChB;AgN3y5CQ;EACI,kBAAA;AhN6y5CZ;AgN5y5CY;EACI,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;AhN8y5ChB;AgN3y5CQ;EACI,WAAA;EACA,kBAAA;AhN6y5CZ;AgN1y5CI;EACI,2BAAA;AhN4y5CR;AgN1y5CY;EACI,gBzM3WH;EyM4WG,oBAAA;EACA,gBAAA;AhN4y5ChB;AgN3y5CgB;EACI,eAAA;AhN6y5CpB;AgN3y5CgB;EACI,qBAAA;AhN6y5CpB;AgNzy5CQ;EACI,gBAAA;EACA,gBAAA;AhN2y5CZ;AgNxy5CI;EACI,wBAAA;AhN0y5CR;AgNty5CI;EACI,cAAA;EACA,WAAA;AhNwy5CR;AgNvy5CQ;EACI,kBAAA;AhNyy5CZ;AgNxy5CY;EACI,mBzM/fI;APyy6CpB;AgNzy5CiB;EACG,uBAAA;AhN2y5CpB;AgNxy5CY;EACI,wBAAA;EACA,YAAA;EACA,sBzMrjBP;AP+16CT;AgNzy5CgB;EACI,qBAAA;AhN2y5CpB;AgNzy5CgB;EACI,qBAAA;EACA,wBAAA;AhN2y5CpB;AgNty5CoB;EACI,2BzMjcP;APyu6CjB;AgNty5CoB;EACI,4BzMpcP;AP4u6CjB;AgNly5CoB;EACI,8BzM3cP;AP+u6CjB;AgNly5CoB;EACI,+BzM9cP;APkv6CjB;AgN/x5CgB;EACI,gCAAA;AhNiy5CpB;AgN9x5CY;EACI,kBAAA;AhNgy5ChB;AgN7x5CgB;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;AhN+x5CpB;AgN3x5CgB;EACI,wBAAA;AhN6x5CpB;AgNzx5CgB;EACI,kBAAA;EACA,kBAAA;AhN2x5CpB;AgNrx5CgB;EACI,YAAA;AhNux5CpB;AgN/w5CQ;EACI,sBAAA;EACA,WAAA;EACA,aAAA;AhNix5CZ;AgNhx5CY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;AhNkx5ChB;AgNjx5CgB;EACI,aAAA;AhNmx5CpB;AgNhx5CY;EACI,WAAA;EACA,qBAAA;EACA,kBAAA;AhNkx5ChB;AgN/w5CQ;EACI,aAAA;EACA,eAAA;EACA,YAAA;AhNix5CZ;AgNhx5CY;EACI,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;AhNkx5ChB;AgNhx5CY;EACI,kBAAA;AhNkx5ChB;AgN/w5CQ;EACI,aAAA;EACA,kBAAA;EACA,WAAA;EACA,gBzMlqBH;EyMmqBG,kBzMniBK;APoz6CjB;AgNhx5CY;EACI,aAAA;AhNkx5ChB;AgN3w5CQ;EACI,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,uBAAA;AhN6w5CZ;AgN5w5CY;EACI,cAAA;EACA,UAAA;AhN8w5ChB;AgN5w5CY;EACI,aAAA;EACA,sBAAA;AhN8w5ChB;AgN5w5CY;EACI,cAAA;EACA,SAAA;EACA,WAAA;AhN8w5ChB;AgN7w5CgB;EACI,WApsBS;EAqsBT,iBAAA;AhN+w5CpB;AgN3w5CgB;EACI,+BAAA;AhN6w5CpB;AgN3w5CgB;EACI,oBAAA;EACA,qBAAA;AhN6w5CpB;AgN1w5CY;EACI,0BAAA;EACA,qBAAA;EACA,uBAAA;AhN4w5ChB;AgN3w5CgB;EACI,aAAA;AhN6w5CpB;AgN1w5CY;EACI,iBAAA;AhN4w5ChB;AgN1w5CY;EACI,aAAA;AhN4w5ChB;AgN1w5CY;EACI,sBAAA;AhN4w5ChB;AgN1w5CY;EACI,YAAA;EACA,UAAA;AhN4w5ChB;AgNrw5CQ;EACI,kBAAA;EACA,sBAAA;EACA,WAAA;AhNuw5CZ;AgNtw5CY;EACI,cAAA;EACA,WAAA;EACA,qBAAA;AhNww5ChB;AgNtw5CY;EACI,2BAAA;AhNww5ChB;AgNrw5CgB;EACI,mBAAA;AhNuw5CpB;AgNnw5CgB;EACI,kBAAA;EACA,kBAAA;AhNqw5CpB;AgNlw5CY;EACI,UAAA;EACA,QAAA;AhNow5ChB;AgNlw5CY;EACI,aAAA;EACA,cAAA;AhNow5ChB;AgNlw5CY;EACI,aAAA;AhNow5ChB;AgN9v5CQ;EACI,6BAAA;EACA,ezM9nBC;EyM+nBD,sBAAA;EACA,yBAAA;EACA,eAAA;EACA,SAAA;AhNgw5CZ;AgN9v5CQ;EACI,gBAAA;AhNgw5CZ;;AkBr96CI;E8L4tBI;IACI,ezM5oBC;EPy46CX;EgN5v5CU;IACI,ezM/oBH;EP646CX;AACF;AkB996CI;E8LquBA;IACI,kBAAA;EhN4v5CN;AACF;AkBh/6CI;E8LyvBQ;IACI,0BAAA;EhN0v5Cd;EgNtv5CU;IACI,wBAAA;EhNwv5Cd;AACF;AgNnv5CA;EAGY;IACI,uBAAA;EhNmv5Cd;AACF;AkB7/6CI;E8LkxBQ;IACI,uBAAA;EhN8u5Cd;EgN1u5CU;IACI,uBAAA;EhN4u5Cd;AACF;AkBrg7CI;E8LiyBQ;IACI,uBAAA;EhNuu5Cd;EgNnu5CU;IACI,0BAAA;EhNqu5Cd;AACF;AgNhu5CA;EAGY;IACI,0BAAA;EhNgu5Cd;EgN5t5CU;IACI,uBAAA;EhN8t5Cd;AACF;AgNzt5CA;EAEQ;IACI,wBAAA;EhN0t5CV;AACF;AgNvt5CA;EAGY;IACI,WAj4Ba;EhNwl7C3B;EgNrt5CU;IACI,wBAAA;EhNut5Cd;EgNrt5CU;IACI,qBAAA;EhNut5Cd;AACF;AgNnt5CA;EAGY;IACI,WAAA;EhNmt5Cd;AACF;AgN5s5CI;EACI,sBAAA;AhN8s5CR;AgN3s5CQ;EACI,mBAAA;EACA,oBAAA;AhN6s5CZ;AgN1s5CI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,kBzM9xBS;EyM+xBT,yBAAA;EACA,gBAAA;AhN4s5CR;AgN1s5CI;EACI,WAAA;EACA,qBAAA;EACA,cAAA;AhN4s5CR;AgN1s5CI;EACI,gBzMjwBK;EyMkwBL,czMn4BQ;EyMo4BR,YAAA;EACA,sBAAA;AhN4s5CR;AgN1s5CI;EACI,aAAA;EACA,qBAAA;AhN4s5CR;AgN3s5CQ;EACI,mBAAA;AhN6s5CZ;AgN3s5CQ;EACI,ezMpyBC;EyMqyBD,iBAAA;EACA,czMn5BE;EyMo5BF,gBzMjxBC;AP896Cb;AgN1s5CI;EACI,ezM3yBK;EyM4yBL,czMz5BM;EyM05BN,gBzMvxBK;APm+6Cb;AgN1s5CI;EACI,0BAAA;AhN4s5CR;AgN1s5CI;EACI,iBAAA;AhN4s5CR;;AiNlo7CI;;EAEE,c1MoCc;APim7CpB;;AiN/n7CI;EACE,YAAA;EACA,WAAA;EACA,eAAA;AjNko7CN;AiNho7CI;;;;;EAEE,oBAAA;AjNqo7CN;;AiN9n7CE;EACE,kBAAA;EACA,kB1M2Fa;E0M1Fb,iCAAA;AjNio7CJ;AiNho7CI;EACE,yB1MrCM;APuq7CZ;AiNjo7CM;EACE,yB1M7BE;APgq7CV;AiNjo7CM;EACE,UAAA;EACA,uBAAA;EACA,wBAAA;AjNmo7CR;AiNho7CI;EACE,yB1MtCI;APwq7CV;AiNjo7CM;EACE,yB1MlDI;APqr7CZ;AiN/n7CE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AjNio7CJ;AiN/n7CE;EACE,YAAA;EACA,WAAA;AjNio7CJ;AiNho7CI;EACE,oBAAA;AjNko7CN;AiN/n7CE;EACE,2BAAA;AjNio7CJ;AiN/n7CE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AjNio7CJ;AiNho7CI;EACE,oBAAA;EACA,gBAAA;EACA,gB1MsFO;E0MrFP,c1M9CQ;APgr7Cd;AiNjo7CM;EACE,gB1MoFK;E0MnFL,c1M/CQ;APkr7ChB;AiNho7CI;EACE,e1MuDO;E0MtDP,c1MvDQ;APyr7Cd;AiN/n7CE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AjNio7CJ;AiNho7CI;EACE,0BAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,e1M2CO;E0M1CP,c1MpEQ;APss7Cd;AiNjo7CM;EACE,gB1M8DK;E0M7DL,c1MtEM;APys7Cd;AiNho7CI;EACE,aAAA;EACA,+BAAA;AjNko7CN;AiNjo7CM;EACE,c1M9DY;APis7CpB;AiNjo7CM;EACE,c1MjEY;APos7CpB;AiN/n7CE;EACE,yB1MtHQ;E0MuHR,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;EACA,oBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;AjNio7CJ;AiN9n7CI;EACE,6BAAA;EACA,kBAAA;AjNgo7CN;AiN9n7CI;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AjNgo7CN;AiN/n7CM;EACE,gBAAA;AjNio7CR;AiN/n7CM;EACE,oBAAA;AjNio7CR;AiN9n7CQ;EACE,0BAAA;AjNgo7CV;AiN3n7CM;EACE,wBAAA;AjN6n7CR;AiN1n7CI;EACE,gBAAA;AjN4n7CN;AiN3n7CM;EACE,gBAAA;AjN6n7CR;AiN1n7CI;EACE,eAAA;AjN4n7CN;AiN3n7CM;EACE,eAAA;AjN6n7CR;AiN3n7CM;EACE,qBAAA;EACA,e1M7BK;E0M8BL,gB1MRK;E0MSL,c1M5IM;APyw7Cd;AiN1n7CI;EACE,aAAA;EACA,gBAAA;AjN4n7CN;AiN3n7CM;EACE,aAAA;EACA,gBAAA;AjN6n7CR;AiN5n7CQ;EACE,qBAAA;AjN8n7CV;AiN5n7CQ;EACE,kB1M7DO;AP2r7CjB;AiNxn7CI;EACE,aAAA;EACA,mBAAA;AjN0n7CN;AiNzn7CM;EACE,gB1MhCK;E0MiCL,e1MvDK;E0MwDL,sBAAA;EACA,c1MtKM;APiy7Cd;AiNxn7CM;EACE,c1MvKO;APiy7Cf;AiNrn7CE;EACE,yBAAA;AjNun7CJ;AiNtn7CI;EACE,kBAAA;AjNwn7CN;AiNtn7CI;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;AjNwn7CN;AiNpn7CM;EACE,kBAAA;EACA,wBAAA;EACA,kB1MhGY;E0MiGZ,iCAAA;AjNsn7CR;AiNrn7CQ;EACE,WAAA;EACA,aAAA;EACA,mBAAA;AjNun7CV;AiNrn7CQ;EACE,yB1MvOE;AP817CZ;AiNtn7CU;EACE,UAAA;EACA,uBAAA;EACA,wBAAA;AjNwn7CZ;AiNpn7CM;EACE,iBAAA;EACA,e1MpGK;E0MqGL,c1MlNM;APw07Cd;AiNpn7CM;EACE,kBAAA;EACA,MAAA;EACA,cAAA;EACA,SAAA;EACA,WAAA;EACA,yB1M1PI;E0M2PJ,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,UAAA;EACA,oBAAA;AjNsn7CR;;AiNjn7CA;EACE,aAAA;EACA,qBAAA;EACA,YAAA;AjNon7CF;AiNnn7CE;EACE,YAAA;AjNqn7CJ;AiNnn7CE;EACE,mBAAA;AjNqn7CJ;AiNnn7CE;EACE,qBAAA;AjNqn7CJ;AiNpn7CI;EACE,gBAAA;AjNsn7CN;AiNnn7CE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AjNqn7CJ;AiNnn7CM;EACE,UAAA;AjNqn7CR;AiNjn7CM;EACE,mBAAA;AjNmn7CR;AiN/m7CE;EACE,sB1MvSK;E0MwSL,kB1MrKgB;E0MsKhB,wBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;AjNin7CJ;AiNhn7CI;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,cAAA;EACA,oBAAA;AjNkn7CN;AiNjn7CM;EACE,gBAAA;AjNmn7CR;AiNhn7CI;EACE,yB1MvTM;E0MwTN,c1MvRQ;APy47Cd;AiNhn7CI;EACE,yB1M3Qc;E0M4Qd,W1M/TG;APi77CT;AiN/m7CE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;AjNin7CJ;AiNhn7CI;EACE,kBAAA;EACA,mBAAA;EACA,e1MzLO;E0M0LP,c1MvSQ;APy57Cd;AiNjn7CM;EACE,gBpHvTC;EoHwTD,sB1MseW;E0MreX,kBAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,YAAA;AjNmn7CR;AiN/m7CE;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;AjNin7CJ;AiNhn7CI;EACE,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,c1M7TQ;E0M8TR,e1MjNO;E0MkNP,gBAAA;AjNkn7CN;AiNjn7CM;EAEE,kBAAA;EACA,WAAA;EACA,mB1MlWI;E0MmWJ,WAAA;EACA,YAAA;EACA,QAAA;AjNkn7CR;AiNhn7CM;EACE,WAAA;AjNkn7CR;AiNhn7CM;EACE,UAAA;AjNkn7CR;AiN1m7CQ;EACE,kB1MzXD;E0M0XC,gBAAA;AjN4m7CV;AiN1m7CQ;;EAEE,sB1M9XD;AP0+7CT;AiNxm7CQ;EACE,4BAAA;AjN0m7CV;AiNtm7CQ;EACE,2B1MxQO;APg37CjB;AiNpm7CQ;EACE,8B1M7QO;APm37CjB;AiNjm7CE;EACE,yBAAA;AjNmm7CJ;AiNlm7CI;EACE,yB1MvVqB;E0MwVrB,W1MrZG;APy/7CT;AiNlm7CI;EACE,yBAAA;AjNom7CN;AiNlm7CI;EACE,2BAAA;AjNom7CN;AiNlm7CQ;EACE,qB1MhXU;E0MiXV,gBAAA;AjNom7CV;AiNlm7CQ;;EAEE,sB1MpaD;APwg8CT;AiNhm7CQ;EACE,6BAAA;AjNkm7CV;AiN9l7CQ;EACE,4B1M9SO;AP847CjB;AiN5l7CQ;EACE,+B1MnTO;APi57CjB;AiNvl7CE;EACE,aAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,sB1M/bK;APwh8CT;AiNxl7CI;EACE,cAAA;AjN0l7CN;AiNxl7CI;EACE,aAAA;EACA,mBAAA;AjN0l7CN;AiNxl7CI;EACE,c1MrZc;E0MsZd,kBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AjN0l7CN;AiNzl7CM;EACE,cAAA;AjN2l7CR;;AiNrl7CA;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;AjNwl7CF;AiNvl7CE;EACE,iBAAA;AjNyl7CJ;AiNvl7CE;EACE,UAAA;AjNyl7CJ;AiNvl7CE;EACE,YAAA;EACA,WAAA;AjNyl7CJ;AiNxl7CI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,YAAA;EACA,mB1MreM;E0MseN,sBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,wBAAA;AjN0l7CN;;AkBrh8CI;E+LicF;IACE,eAAA;EjNwl7CF;AACF;AiNtl7CA;EACE;IACE,mBAAA;EjNwl7CF;EiNtl7CI;IACE,eAAA;EjNwl7CN;EiNtl7CI;IACE,gBAAA;EjNwl7CN;AACF;AiNll7CE;EACE,wBAAA;AjNol7CJ;AiNll7CE;EACE,wBAAA;EACA,cAAA;EACA,oBAAA;EACA,gB1MvWS;E0MwWT,c1M3eU;E0M4eV,kB1M9YgB;APk+7CpB;AiNnl7CI;EAEE,c1Mhec;E0Mied,mB1Mvec;AP2j8CpB;;AiN9k7CE;EACE,yBAAA;AjNil7CJ;AiNhl7CI;EACE,mBAAA;AjNkl7CN;AiNhl7CI;EACE,kBAAA;AjNkl7CN;AiNjl7CM;EACE,qBAAA;EACA,sBAAA;AjNml7CR;AiN/k7CM;EACE,kBAAA;EACA,wBAAA;EACA,kB1MxaY;E0MyaZ,iCAAA;AjNil7CR;AiNhl7CQ;EACE,WAAA;EACA,aAAA;EACA,mBAAA;AjNkl7CV;AiNhl7CQ;EACE,yB1M/iBE;APio8CZ;AiNjl7CU;EACE,UAAA;EACA,uBAAA;EACA,wBAAA;AjNml7CZ;AiN/k7CM;EACE,iBAAA;EACA,e1M5aK;E0M6aL,c1M1hBM;AP2m8Cd;AiN/k7CM;EACE,eAAA;EACA,kBAAA;EACA,MAAA;EACA,cAAA;EACA,SAAA;EACA,aAAA;EACA,yB1MnkBI;E0MokBJ,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,UAAA;EACA,oBAAA;AjNil7CR;AiNhl7CQ;EACE,mBAAA;AjNkl7CV;AiN7k7CE;EACE,wBAAA;EACA,aAAA;EACA,mBAAA;AjN+k7CJ;AiN9k7CI;EACE,gB1MhbO;E0MibP,e1MvcO;APuh8Cb;;AiNzk7CA;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,8BAAA;EACA,uCAAA;EACA,gB1MrmBO;APir8CT;AiN3k7CE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,YAAA;EACA,yB1MzmBQ;APsr8CZ;AiN5k7CI;EACE,qBAAA;AjN8k7CN;AiN3k7CE;EACE,gB1MlnBK;E0MmnBL,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;AjN6k7CJ;AiN5k7CI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kCAAA;AjN8k7CN;AiN3k7CM;EACE,mBAAA;EACA,c1M7lBQ;AP0q8ChB;AiN3k7CM;EACE,YAAA;EACA,WAAA;AjN6k7CR;AiN5k7CQ;EACE,iBAAA;AjN8k7CV;AiN1k7CQ;EACE,mBAAA;EACA,c1M5mBI;E0M6mBJ,iBAAA;AjN4k7CV;AiNxk7CI;EACE,aAAA;EACA,mBAAA;AjN0k7CN;AiNxk7CI;EACE,gBAAA;EACA,YAAA;EACA,cAAA;AjN0k7CN;AiNxk7CI;EACE,kBAAA;EACA,sBAAA;EACA,mBAAA;AjN0k7CN;AiNzk7CM;EACE,yB1MrpBE;E0MspBF,qB1MtpBE;APiu8CV;AiN1k7CQ;EACE,c1MloBI;AP8s8Cd;AiNvk7CE;EACE,0BAAA;AjNyk7CJ;AiNxk7CI;EACE,sBAAA;AjN0k7CN;AiNvk7CE;EACE,iBAAA;AjNyk7CJ;AiNxk7CI;EACE,oBAAA;AjN0k7CN;AiNvk7CE;EACE,gB1MvrBK;E0MwrBL,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;EACA,UAAA;EACA,oBAAA;EACA,UAAA;AjNyk7CJ;AiNxk7CI;EACE,UAAA;EACA,oBAAA;AjN0k7CN;AiNvk7CE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;EACA,gCAAA;EACA,sB1MjtBK;AP0x8CT;AiNxk7CI;EACE,UAAA;AjN0k7CN;AiNzk7CM;EACE,oBAAA;AjN2k7CR;AiNxk7CQ;EACE,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AjN0k7CV;AiNtk7CI;EAEE,aAAA;EACA,mBAAA;EACA,iBAAA;AjNuk7CN;AiNtk7CM;EACE,iBAAA;AjNwk7CR;AiNrk7CQ;EACE,kBAAA;AjNuk7CV;AiNnk7CI;EACE,kBAAA;EACA,sBAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,4BAAA;EACA,oBAAA;AjNqk7CN;AiNpk7CM;EACE,UAAA;EACA,oBAAA;EACA,eAAA;AjNsk7CR;AiNlk7CE;EACE,0CAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AjNok7CJ;AiNlk7CE;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,sB1M3wBK;AP+08CT;AiNnk7CI;EACE,iBAAA;EACA,YAAA;AjNqk7CN;AiNpk7CM;EACE,gBAAA;EACA,mBAAA;AjNsk7CR;AiNnk7CI;EAEE,aAAA;EACA,mBAAA;AjNok7CN;AiNlk7CQ;EACE,iBAAA;AjNok7CV;AiNhk7CI;EACE,kBAAA;EACA,UAAA;AjNkk7CN;AiNjk7CM;EACE,gBAAA;AjNmk7CR;AiNlk7CQ;EACE,YAAA;EACA,yBAAA;AjNok7CV;AiN/j7CE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,2BAAA;EACA,YA3yBiB;EA4yBjB,YAAA;EACA,gBAAA;EACA,sCAAA;EACA,gB1MnzBK;E0MozBL,YAAA;AjNik7CJ;AiNhk7CI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,iC1M1F8B;E0M2F9B,YAAA;EACA,WAAA;EACA,sCAAA;AjNkk7CN;AiNhk7CI;EACE,eAAA;AjNkk7CN;;AkBn08CI;E+LuwBF;IACE,YAAA;IACA,kB1MzsBa;I0M0sBb,uCAAA;IACA,uCAAA;EjNgk7CF;EiN/j7CE;IACE,wBAAA;EjNik7CJ;EiNhk7CI;IACE,4BAAA;EjNkk7CN;EiNjk7CM;IACE,YAAA;IACA,WAAA;EjNmk7CR;EiNjk7CM;IACE,kCAAA;EjNmk7CR;AACF;AkBt28CI;E+L4yBE;IAEE,iBAAA;EjN4j7CN;EiN3j7CM;IACE,iBAAA;EjN6j7CR;AACF;AiNxj7CA;EAGM;IAEE,qBAr3Be;IAs3Bf,sBAt3Be;EjN668CrB;EiNpj7CE;IACE,0BAAA;EjNsj7CJ;EiNpj7CE;IACE,iBAAA;EjNsj7CJ;EiNpj7CE;IAGE,qBA93BgB;IA+3BhB,sBA/3BgB;EjNm78CpB;EiNjj7CI;IACE,kBAAA;EjNmj7CN;AACF;AiN9i7CA;EAEI;IACE,YAz4Ba;IA04Bb,+BAAA;EjN+i7CJ;EiN7i7CE;IACE,gBAAA;IACA,UAAA;IACA,oBAAA;EjN+i7CJ;EiN9i7CI;IACE,aAAA;EjNgj7CN;AACF;AiN5i7CA;EAGM;IACE,eAAA;IACA,aAAA;EjN4i7CN;EiNzi7CE;IACE,oBAAA;IACA,uBAAA;EjN2i7CJ;AACF;AiNvi7CA;EAEI;IACE,YAAA;IACA,+BAAA;EjNwi7CJ;AACF;AiNri7CA;EAEI;IACE,WAAA;EjNsi7CJ;AACF;AkBp68CI;E+Lm4BA;IAGE,qBA/7BkB;IAg8BlB,sBAh8BkB;EjNk+8CtB;EiNhi7CE;IACE,eAAA;EjNki7CJ;EiNhi7CE;IACE,YA/7BgB;EjNi+8CpB;EiNhi7CE;IACE,wBAAA;EjNki7CJ;EiN7h7CI;IAEE,sBAAA;IACA,qBAAA;EjN8h7CN;AACF;AkBv78CI;E+L+5BA;IACE,YAj9BgB;EjN4+8CpB;EiNxh7CI;IACE,oBAl9BgB;EjN4+8CtB;EiNvh7CE;IACE,YAt9BkB;IAu9BlB,8BAAA;EjNyh7CJ;AACF;AkBt78CI;E+Lm6BA;IACE,YAAA;EjNsh7CJ;EiNrh7CI;IACE,YAAA;EjNuh7CN;AACF;AiNlh7CA;EAEI;IACE,YA1+BkB;EjN6/8CtB;AACF;AkN1g9CA;EACI,cAAA;EACA,c3MwCU;E2MvCV,wBAAA;EACA,8BAAA;AlN4g9CJ;;AkNzg9CA;EACI,aAAA;EACA,uBAAA;AlN4g9CJ;;AkNxg9CI;EACI,gBAAA;EACA,cAAA;AlN2g9CR;AkNzg9CI;EACI,cAAA;EACA,WAAA;EACA,WAAA;AlN2g9CR;;AkNvg9CA;EAEQ;IACI,eAAA;IACA,eAAA;ElNyg9CV;AACF;AkNrg9CA;EACI,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,gBAAA;EACA,kB3MiGa;APs68CjB;;AkNpg9CA;EACI,kBAAA;EACA,gBAAA;EACA,gB3MrCK;E2MsCL,kB3M0Fa;AP668CjB;AkNtg9CI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;AlNwg9CR;AkNtg9CI;EACI,gBAAA;AlNwg9CR;AkNtg9CI;EACI,gBAAA;EACA,yB3M7CI;E2M8CJ,0BAAA;AlNwg9CR;AkNtg9CI;EACI,gBAAA;AlNwg9CR;AkNtg9CI;EACI,mB3M3CE;E2M4CF,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AlNwg9CR;AkNtg9CI;EACI,mBAAA;AlNwg9CR;AkNtg9CI;EACI,sB3MnEC;AP2k9CT;AkNvg9CQ;EACI,qB3MhEA;E2MiEA,gBAAA;AlNyg9CZ;AkNrg9CQ;EACI,e3MoEC;E2MnED,qBAAA;EACA,yBAAA;EACA,c3M3CE;E2M4CF,gB3MwFC;E2MvFD,cAAA;AlNug9CZ;;AkN//8CQ;EACI,aAAA;EACA,eAAA;EACA,aAAA;AlNkg9CZ;AkNhg9CQ;EACI,eAAA;EACA,aAAA;EACA,cAAA;AlNkg9CZ;AkNhg9CQ;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;AlNkg9CZ;AkNjg9CY;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;AlNmg9ChB;AkNlg9CgB;EACI,yBAAA;EACA,gBAAA;AlNog9CpB;AkNhg9CgB;EACI,UAAA;AlNkg9CpB;AkN7/8CQ;EACI,mBAAA;AlN+/8CZ;AkN9/8CY;EACI,eAAA;AlNgg9ChB;AkN9/8CY;EACI,qBAAA;AlNgg9ChB;AkN//8CgB;EACI,WAAA;AlNig9CpB;AkN7/8CQ;EACI,c3MlGE;E2MmGF,eAAA;AlN+/8CZ;;AkN1/8CI;EACI,cAAA;EACA,uBAAA;AlN6/8CR;AkN3/8CI;EACI,e3MCK;AP4/8Cb;AkN3/8CI;EACI,6BAAA;EACA,gBAAA;EACA,mBAAA;AlN6/8CR;AkN5/8CQ;EACI,mBAAA;AlN8/8CZ;AkN5/8CQ;EACI,kBAAA;AlN8/8CZ;AkN3/8CI;EACI,aAAA;EACA,eAAA;EACA,gBAAA;AlN6/8CR;AkN3/8CI;EACI,gBAAA;AlN6/8CR;AkN1/8CQ;EACI,aAAA;EACA,eAAA;EACA,gBAAA;AlN4/8CZ;AkN1/8CQ;EACI,UAAA;EACA,gBAAA;AlN4/8CZ;AkN3/8CY;EACI,WAAA;AlN6/8ChB;AkN3/8CY;EACI,aAAA;AlN6/8ChB;;AkNt/8CQ;EACI,e3M3CC;E2M4CD,eAAA;EACA,kBAAA;EACA,yB3MhLF;APyq9CV;AkNr/8CI;EACI,eAAA;AlNu/8CR;AkNt/8CQ;EACI,cAAA;EACA,aAAA;EACA,cAAA;AlNw/8CZ;AkNr/8CI;EACI,yBAAA;AlNu/8CR;AkNr/8CI;EACI,YAAA;EACA,yB3M3MI;E2M4MJ,sBAAA;AlNu/8CR;AkNr/8CI;EACI,YAAA;AlNu/8CR;AkNt/8CQ;EACI,WAAA;EACA,yB3MlNA;E2MmNA,oBAAA;AlNw/8CZ;AkNp/8CQ;EACI,YAAA;EACA,aAAA;EACA,yB3M1NA;E2M2NA,qBAAA;AlNs/8CZ;AkNp/8CQ;EACI,oBAAA;EACA,YAAA;EACA,WAAA;AlNs/8CZ;AkNr/8CY;EACI,cAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sB3MzOP;APgu9CT;AkNl/8CQ;EACI,mB3MzFa;AP6k9CzB;;AkN9+8CI;EACI,kBAAA;EACA,wBAAA;EACA,kC3M5Fa;E2M6Fb,gB3MlFK;APmk9Cb;AkN/+8CI;EACI,gBAAA;AlNi/8CR;;AkB1r9CI;EgM8MI;IACI,UAAA;ElNg/8CV;EkN/+8CU;IACI,UAAA;ElNi/8Cd;EkN/+8CU;IACI,aAAA;ElNi/8Cd;AACF;AkBts9CI;EgM2NI;IACI,oBAAA;ElN8+8CV;AACF;AkB9r9CI;EgMsNQ;IACI,cAAA;IACA,SAAA;IACA,sBAAA;ElN2+8Cd;EkNz+8CU;IACI,iBAAA;ElN2+8Cd;EkN1+8Cc;IACI,gCAAA;ElN4+8ClB;EkN1+8Cc;IACI,0CAAA;ElN4+8ClB;EkNz+8CU;IACI,uBAAA;ElN2+8Cd;EkNz+8CU;IACI,aAAA;ElN2+8Cd;AACF;AkN/98CA;EACI,eAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EAEI,QAAA;EACA,0BAAA;EACA,eAAA;EACA,mDAAA;AlNg+8CR;AkNv98CQ;EACI,6BAAA;AlNy98CZ;AkNv98CQ;EACI,aAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AlNy98CZ;;AkNr98CA;EACI,yCAAA;EACA,c3MjUI;APyx9CR;;AkNt98CA;EACI,yCAAA;EACA,c3MvUK;APgy9CT;;AkNv98CA;EACI,0CAAA;EACA,c3MtUK;APgy9CT;;AkNx98CA;EACI,yCAAA;EACA,c3MzUI;APoy9CR;;AkB5w9CI;EgMoTA;IACI,QAAA;ElN498CN;EkN198CU;IACI,eAAA;IACA,YAAA;IACA,WAAA;ElN498Cd;EkN198CU;IACI,eAAA;ElN498Cd;AACF;AkNv98CI;EACI,eAAA;EAEI,QAAA;EAKJ,MAAA;EACA,YAAA;EACA,6BAAA;EACA,iBAAA;EACA,aAAA;EACA,aAAA;EACA,sB3MpYC;E2MqYD,iD3M3PsB;E2M4PtB,mBAAA;AlNo98CR;AkNn98CQ;EACI,aAAA;EACA,kCAAA;AlNq98CZ;AkNn98CQ;EACI,2CAAA;AlNq98CZ;AkNl98CI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,yBAAA;EACA,gCAAA;AlNo98CR;AkNn98CQ;EACI,eAAA;EACA,qBAAA;AlNq98CZ;AkNl98CI;EACI,cAAA;EACA,8BAAA;AlNo98CR;AkNl98CI;EACI,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,c3MhYM;E2MiYN,gBAAA;EACA,0BAAA;AlNo98CR;AkNn98CQ;EACI,cAAA;EACA,c3MtYE;E2MuYF,eAAA;AlNq98CZ;AkNl98CI;EACI,yBAAA;EACA,gCAAA;AlNo98CR;AkNn98CQ;EACI,cAAA;AlNq98CZ;AkNn98CgB;EACI,c3MjYA;APs19CpB;AkNh98CI;EACI,yBAAA;EACA,0BAAA;EACA,yBAAA;AlNk98CR;AkNj98CQ;EACI,sBAAA;AlNm98CZ;AkNh98CI;EACI,mB3MrbE;E2MsbF,oBAAA;AlNk98CR;;AkBl29CI;EgMsZI;IACI,uBAAA;ElNg98CV;EkN988CM;IACI,uBAAA;ElNg98CV;EkN988CM;IACI,oBAAA;ElNg98CV;AACF;AkB929CI;EgMqaQ;IACI,YAAA;ElN488Cd;EkN188CkB;IACI,aAAA;IACA,eAAA;ElN488CtB;EkN388CsB;IACI,UAAA;ElN688C1B;EkN588C0B;IACI,+BAAA;ElN888C9B;AACF;AkNl88CI;EACI,cAAA;EACA,8BAAA;AlNo88CR;AkNl88CI;EACI,6BAAA;AlNo88CR;AkNl88CI;EACI,6BAAA;AlNo88CR;AkNn88CQ;EACI,gCAAA;AlNq88CZ;AkNn88CQ;EACI,mBAAA;EACA,yBAAA;EACA,c3M1dE;E2M2dF,mBAAA;EACA,gB3MxVC;E2MyVD,eAAA;AlNq88CZ;AkNl88CI;EACI,UAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;AlNo88CR;AkNn88CQ;EACI,mBAAA;AlNq88CZ;AkNl88CI;EACI,UAAA;EACA,kBAAA;EACA,eAAA;AlNo88CR;AkNn88CQ;EACI,eAAA;AlNq88CZ;AkNn88CQ;EACI,eAAA;AlNq88CZ;AkNn88CQ;EACI,oBAAA;AlNq88CZ;AkNp88CY;EACI,YAAA;AlNs88ChB;AkNn88CQ;EACI,UAAA;AlNq88CZ;AkNn88CQ;EACI,UAAA;AlNq88CZ;AkNn88CQ;EACI,gBAAA;EACA,c3MhgBE;E2MigBF,eAAA;EACA,sBAAA;AlNq88CZ;AkNp88CY;EACI,eAAA;AlNs88ChB;AkNp88CY;EACI,c3MxgBF;AP889Cd;AkNn88CQ;EACI,gB3M/iBH;E2MgjBG,WAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;AlNq88CZ;AkNp88CY;EACI,qB3MljBJ;APw/9CZ;AkNp88CY;EACI,cAAA;EACA,mB3M1hBF;E2M2hBE,YAAA;EACA,kBAAA;AlNs88ChB;AkNr88CgB;EACI,8BAAA;AlNu88CpB;AkNr88CgB;EACI,8BAAA;AlNu88CpB;AkNr88CgB;EACI,8BAAA;AlNu88CpB;AkNr88CgB;EACI,8BAAA;AlNu88CpB;AkNr88CgB;EACI,iGAAA;AlNu88CpB;AkNr88CgB;EACI,iGAAA;AlNu88CpB;AkNr88CgB;EACI,2HAAA;AlNu88CpB;AkNr88CgB;EACI,2HAAA;AlNu88CpB;AkNr88CgB;EACI,2HAAA;AlNu88CpB;AkNr88CgB;EACI,2HAAA;AlNu88CpB;AkNr88CgB;EACI,2HAAA;AlNu88CpB;AkNr88CgB;EACI,2HAAA;AlNu88CpB;AkNr88CgB;EACI,2HAAA;AlNu88CpB;AkNp88CY;EACI,qB3MpmBJ;AP0i+CZ;AkNp88CY;EACI,qB3M1jBI;E2M2jBJ,4CAAA;AlNs88ChB;AkNr88CgB;EACI,sB3MmMD;E2MlMC,gBrHtUH;EqHuUG,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,W3MtnBX;E2MunBW,mBAAA;AlNu88CpB;AkNr88CgB;EACI,c3M1mBX;APij+CT;AkNp88CY;EACI,gBAAA;EACA,YAAA;AlNs88ChB;AkNr88CgB;EACI,aAAA;AlNu88CpB;AkNp88CY;EACI,gCAAA;AlNs88ChB;AkNr88CgB;EACI,gCAAA;AlNu88CpB;AkNp88CY;EACI,c3MrmBA;E2MsmBA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;AlNs88ChB;AkNr88CgB;EACI,c3MrnBN;AP4j+Cd;AkNr88CgB;EACI,c3MvmBA;E2MwmBA,gBAAA;AlNu88CpB;;AkNh88CA;EAEQ;IACI,kBAAA;IACA,mBAAA;ElNk88CV;AACF;AkN578CI;EACI,eAAA;EACA,SAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;EACA,gCAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gDAAA;EACA,aAAA;AlN878CR;AkN778CQ;EACI,6BAAA;EACA,YAAA;EACA,oBAAA;AlN+78CZ;AkN778CQ;EACI,mBAAA;AlN+78CZ;AkN578CI;EACI,c3M7pBQ;E2M8pBR,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,oCAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;AlN878CR;AkN778CQ;EACI,W3MltBH;E2MmtBG,mB3M/qBE;AP8m+Cd;AkN778CQ;EACI,iCAAA;EACA,W3MvtBH;APsp+CT;AkN978CY;EACI,iCAAA;AlNg88ChB;AkN578CI;EACI,aAAA;EACA,wCAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;AlN878CR;AkN778CQ;EACI,0BAAA;AlN+78CZ;AkN578CI;EACI,kC3M5kBa;E2M6kBb,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,c3M1tBA;E2M2tBA,sBAAA;AlN878CR;AkN778CQ;EACI,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;AlN+78CZ;AkN778CQ;EACI,W3MvvBH;APsr+CT;AkN578CI;EACI,eAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,2BAAA;EACA,8CAAA;EACA,WAAA;EACA,mB3MlvBA;E2MmvBA,cAAA;AlN878CR;AkN778CQ;EACI,WAAA;AlN+78CZ;AkN778CQ;EACI,mBAAA;AlN+78CZ;AkN778CQ;EACI,YAAA;EACA,wBAAA;EACA,sBAAA;AlN+78CZ;AkN778CQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;AlN+78CZ;AkN578CQ;EACI,eAAA;EACA,YAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AlN878CZ;AkN378CQ;EACI,YAAA;EACA,mBAAA;EACA,yBAAA;AlN678CZ;;AkNx78CA;EACI;IACI,aAAA;ElN278CN;AACF;AkNx78CI;EACI,yBAtgBO;AlNg89Cf;AkNx78CI;EACI,yB3M3yBC;APqu+CT;AkNx78CI;EACI,qBA3gBY;AlNq89CpB;AkNx78CI;EACI,c3MhyBM;AP0t+Cd;AkNx78CI;EACI,qBAjhBY;AlN289CpB;;AmNrw+CI;;;;;EAKI,yBAAA;AnNww+CR;AmNtw+CI;EACI,6BAAA;EACA,gCAAA;AnNww+CR;AmNvw+CQ;EACI,8BAAA;AnNyw+CZ;AmNvw+CQ;EACI,+BAAA;AnNyw+CZ;AmNtw+CI;EACI,8BAAA;EACA,+BAAA;EACA,gCAAA;AnNww+CR;AmNtw+CI;EACI,yBAAA;AnNww+CR;;AoNzx+CA,iBAAA;AAkDA;EACE,8BAAA;EACA,c7MjBY;AP4v+Cd;AoN1u+CE;EAIE,8BAAA;ApNyu+CJ;;AoNpu+CI;EACE,UAAA;ApNuu+CN;AoNru+CI;EACE,UAAA;ApNuu+CN;AoNnu+CE;;;;;;;;;;;;;;;EAeE,W7MpFK;APyz+CT;AoNnu+CE;;;EAGE,yBAAA;ApNqu+CJ;AoNnu+CE;;;;EAIE,yBAAA;ApNqu+CJ;AoNnu+CE;EACE,sBAAA;ApNqu+CJ;AoNnu+CE;EACE,yBAAA;ApNqu+CJ;AoNhu+CE;;EAEE,yBAAA;ApNku+CJ;AoNhu+CE;EACE,yBAAA;ApNku+CJ;AoNhu+CE;EACE,yBAAA;ApNku+CJ;AoNhu+CE;EACE,oCAAA;ApNku+CJ;AoNhu+CE;EACE,oCAAA;ApNku+CJ;AoNhu+CE;EACE,oCAAA;ApNku+CJ;AoNhu+CE;EACE,oCAAA;ApNku+CJ;AoNhu+CE;EACE,oCAAA;ApNku+CJ;AoNhu+CE;EACE,wCAAA;ApNku+CJ;AoNxs+CI;EACE,oCAAA;ApN0s+CN;AoN3s+CI;EACE,oCAAA;ApN6s+CN;AoN9s+CI;EACE,oCAAA;ApNgt+CN;AoNjt+CI;EACE,oCAAA;ApNmt+CN;AoNpt+CI;EACE,oCAAA;ApNst+CN;AoNvt+CI;EACE,oCAAA;ApNyt+CN;AoN1t+CI;EACE,oCAAA;ApN4t+CN;AoN7t+CI;EACE,oCAAA;ApN+t+CN;AoNhu+CI;EACE,oCAAA;ApNku+CN;AoNnu+CI;EACE,oCAAA;ApNqu+CN;AoNtu+CI;EACE,oCAAA;ApNwu+CN;AoNzu+CI;EACE,oCAAA;ApN2u+CN;AoN5u+CI;EACE,oCAAA;ApN8u+CN;AoN/u+CI;EACE,oCAAA;ApNiv+CN;AoNlv+CI;EACE,oCAAA;ApNov+CN;AoNrv+CI;EACE,oCAAA;ApNuv+CN;AoNxv+CI;EACE,oCAAA;ApN0v+CN;AoN3v+CI;EACE,oCAAA;ApN6v+CN;AoN5u+CI;EACE,cAZF;EAaE,yBAbF;EAcE,qBAdF;ApN4v+CJ;AoN5u+CM;EACE,yBAjBJ;ApN+v+CJ;AoN3u+CM;EACE,cAAA;ApN6u+CR;AoN1u+CI;EACE,WAAA;EACA,mBA1BF;ApNsw+CJ;AoN3u+CM;EACE,WAAA;ApN6u+CR;AoN1u+CI;EACE,qBAhCF;ApN4w+CJ;AoNjw+CI;EACE,cAZF;EAaE,yBAbF;EAcE,qBAdF;ApNix+CJ;AoNjw+CM;EACE,yBAjBJ;ApNox+CJ;AoNhw+CM;EACE,cAAA;ApNkw+CR;AoN/v+CI;EACE,WAAA;EACA,mBA1BF;ApN2x+CJ;AoNhw+CM;EACE,WAAA;ApNkw+CR;AoN/v+CI;EACE,qBAhCF;ApNiy+CJ;AoNtx+CI;EACE,cAZF;EAaE,yBAbF;EAcE,qBAdF;ApNsy+CJ;AoNtx+CM;EACE,yBAjBJ;ApNyy+CJ;AoNrx+CM;EACE,cAAA;ApNux+CR;AoNpx+CI;EACE,WAAA;EACA,mBA1BF;ApNgz+CJ;AoNrx+CM;EACE,WAAA;ApNux+CR;AoNpx+CI;EACE,qBAhCF;ApNsz+CJ;AoN3y+CI;EACE,cAZF;EAaE,yBAbF;EAcE,qBAdF;ApN2z+CJ;AoN3y+CM;EACE,yBAjBJ;ApN8z+CJ;AoN1y+CM;EACE,cAAA;ApN4y+CR;AoNzy+CI;EACE,WAAA;EACA,mBA1BF;ApNq0+CJ;AoN1y+CM;EACE,WAAA;ApN4y+CR;AoNzy+CI;EACE,qBAhCF;ApN20+CJ;AoNh0+CI;EACE,cAZF;EAaE,yBAbF;EAcE,qBAdF;ApNg1+CJ;AoNh0+CM;EACE,yBAjBJ;ApNm1+CJ;AoN/z+CM;EACE,cAAA;ApNi0+CR;AoN9z+CI;EACE,WAAA;EACA,mBA1BF;ApN01+CJ;AoN/z+CM;EACE,WAAA;ApNi0+CR;AoN9z+CI;EACE,qBAhCF;ApNg2+CJ;AoNr1+CI;EACE,cAZF;EAaE,yBAbF;EAcE,qBAdF;ApNq2+CJ;AoNr1+CM;EACE,yBAjBJ;ApNw2+CJ;AoNp1+CM;EACE,cAAA;ApNs1+CR;AoNn1+CI;EACE,WAAA;EACA,mBA1BF;ApN+2+CJ;AoNp1+CM;EACE,WAAA;ApNs1+CR;AoNn1+CI;EACE,qBAhCF;ApNq3+CJ;AoN12+CI;EACE,cAZF;EAaE,yBAbF;EAcE,qBAdF;ApN03+CJ;AoN12+CM;EACE,yBAjBJ;ApN63+CJ;AoNz2+CM;EACE,cAAA;ApN22+CR;AoNx2+CI;EACE,cAAA;EACA,mBA1BF;ApNo4+CJ;AoNz2+CM;EACE,cAAA;ApN22+CR;AoNx2+CI;EACE,qBAhCF;ApN04+CJ;AoN/3+CI;EACE,cAZF;EAaE,yBAbF;EAcE,qBAdF;ApN+4+CJ;AoN/3+CM;EACE,yBAjBJ;ApNk5+CJ;AoN93+CM;EACE,cAAA;ApNg4+CR;AoN73+CI;EACE,WAAA;EACA,mBA1BF;ApNy5+CJ;AoN93+CM;EACE,WAAA;ApNg4+CR;AoN73+CI;EACE,qBAhCF;ApN+5+CJ;AoNp5+CI;EACE,cAZF;EAaE,yBAbF;EAcE,qBAdF;ApNo6+CJ;AoNp5+CM;EACE,yBAjBJ;ApNu6+CJ;AoNn5+CM;EACE,cAAA;ApNq5+CR;AoNl5+CI;EACE,cAAA;EACA,mBA1BF;ApN86+CJ;AoNn5+CM;EACE,cAAA;ApNq5+CR;AoNl5+CI;EACE,qBAhCF;ApNo7+CJ;AoNp4+CI;EACE,cAZQ;EAaR,yBAAA;EACA,qBAAA;ApNs4+CN;AoNp4+CI;EACE,cAjBQ;EAkBR,yBAAA;EACA,qBAAA;ApNs4+CN;AoN94+CI;EACE,cAZQ;EAaR,yBAAA;EACA,qBAAA;ApNg5+CN;AoN94+CI;EACE,cAjBQ;EAkBR,yBAAA;EACA,qBAAA;ApNg5+CN;AoNx5+CI;EACE,cAZQ;EAaR,yBAAA;EACA,qBAAA;ApN05+CN;AoNx5+CI;EACE,cAjBQ;EAkBR,yBAAA;EACA,qBAAA;ApN05+CN;AoNl6+CI;EACE,cAZQ;EAaR,yBAAA;EACA,qBAAA;ApNo6+CN;AoNl6+CI;EACE,cAjBQ;EAkBR,yBAAA;EACA,qBAAA;ApNo6+CN;AoN56+CI;EACE,cAZQ;EAaR,yBAAA;EACA,qBAAA;ApN86+CN;AoN56+CI;EACE,cAjBQ;EAkBR,yBAAA;EACA,qBAAA;ApN86+CN;AoNt7+CI;EACE,cAZQ;EAaR,yBAAA;EACA,qBAAA;ApNw7+CN;AoNt7+CI;EACE,cAjBQ;EAkBR,yBAAA;EACA,qBAAA;ApNw7+CN;AoNh8+CI;EACE,cAZQ;EAaR,yBAAA;EACA,qBAAA;ApNk8+CN;AoNh8+CI;EACE,cAjBQ;EAkBR,yBAAA;EACA,qBAAA;ApNk8+CN;AoN18+CI;EACE,cAZQ;EAaR,yBAAA;EACA,qBAAA;ApN48+CN;AoN18+CI;EACE,cAjBQ;EAkBR,yBAAA;EACA,qBAAA;ApN48+CN;AoNp9+CI;EACE,cAZQ;EAaR,yBAAA;EACA,qBAAA;ApNs9+CN;AoNp9+CI;EACE,cAjBQ;EAkBR,yBAAA;EACA,qBAAA;ApNs9+CN;AoN99+CI;EACE,cAZQ;EAaR,yBAAA;EACA,qBAAA;ApNg++CN;AoN99+CI;EACE,cAjBQ;EAkBR,yBAAA;EACA,qBAAA;ApNg++CN;AoN59+CE;;;EAGE,c7M9NQ;AP4r/CZ;AoN39+CE;EACE,c7MrOQ;E6MsOR,qB7MtOQ;APms/CZ;AoN39+CE;EACE,c7MtOQ;E6MuOR,qB7MpOQ;APis/CZ;AoN39+CE;;EAEE,6BAAA;ApN69+CJ;AoN39+CE;EACE,c7M7OQ;AP0s/CZ;AoN19+CE;;;;EAEE,c7MtPQ;E6MuPR,mB7MjPQ;E6MkPR,qB7MlPQ;APgt/CZ;AoN59+CE;EACE,c7MnPQ;E6MoPR,mB7M3PQ;E6M4PR,qB7M5PQ;AP0t/CZ;AoN19+CE;EACE,c7MlQQ;E6MmQR,mB7M7PQ;E6M8PR,qB7M9PQ;AP0t/CZ;AoN19+CM;EAKE,mBAAA;EACA,qBAAA;EACA,c7M7QI;APqu/CZ;AoNp9+CE;EACE,c7M1QQ;E6M2QR,mB7MlRQ;E6MmRR,qB7MnRQ;APyu/CZ;AoNp9+CM;EAKE,gB7M9RC;E6M+RD,kB7M/RC;E6MgSD,c7MrRI;APuu/CZ;AoN98+CE;EACE,qB7MjSQ;E6MkSR,c7MlSQ;APkv/CZ;AoN/8+CI;EACE,mB7MpSM;E6MqSN,c7M9RM;AP+u/CZ;AoN98+CE;EACE,qBAAA;EACA,cAAA;ApNg9+CJ;AoN/8+CI;EACE,mBAAA;EACA,W7MjTG;APkw/CT;AoN98+CE;EACE,qB7M7SQ;E6M8SR,c7MhTQ;APgw/CZ;AoN/8+CI;EACE,mB7MhTM;E6MiTN,W7MzTG;AP0w/CT;AoN/7+CI;EACE,cAbF;EAcE,yBAdF;EAeE,yBAAA;ApNi8+CN;AoNh8+CM;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;ApNk8+CR;AoNz8+CI;EACE,cAbF;EAcE,yBAdF;EAeE,yBAAA;ApN28+CN;AoN18+CM;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;ApN48+CR;AoNn9+CI;EACE,cAbF;EAcE,yBAdF;EAeE,yBAAA;ApNq9+CN;AoNp9+CM;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;ApNs9+CR;AoN79+CI;EACE,cAbF;EAcE,yBAdF;EAeE,yBAAA;ApN+9+CN;AoN99+CM;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;ApNg++CR;AoNv++CI;EACE,cAbF;EAcE,yBAdF;EAeE,yBAAA;ApNy++CN;AoNx++CM;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;ApN0++CR;AoNj/+CI;EACE,cAbF;EAcE,yBAdF;EAeE,yBAAA;ApNm/+CN;AoNl/+CM;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;ApNo/+CR;AoN3/+CI;EACE,cAbF;EAcE,yBAdF;EAeE,yBAAA;ApN6/+CN;AoN5/+CM;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;ApN8/+CR;AoNrg/CI;EACE,cAbF;EAcE,yBAdF;EAeE,yBAAA;ApNug/CN;AoNtg/CM;EACE,YAAA;EACA,yBAAA;EACA,qBAAA;ApNwg/CR;AoN/g/CI;EACE,cAbF;EAcE,yBAdF;EAeE,yBAAA;ApNih/CN;AoNhh/CM;EACE,YAAA;EACA,yBAAA;EACA,qBAAA;ApNkh/CR;AoNzh/CI;EACE,cAbF;EAcE,yBAdF;EAeE,yBAAA;ApN2h/CN;AoN1h/CM;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;ApN4h/CR;AoN3g/CI;EACE,cAZF;EAaE,yBAbF;EAcE,qBAdF;ApN2h/CJ;AoN5g/CM;EACE,WAAA;EACA,yBAjBJ;EAkBI,qBAlBJ;ApNgi/CJ;AoNzg/CM;;EACE,cAxBJ;EAyBI,mBAzBJ;ApNqi/CJ;AoN1h/CI;EACE,cAZF;EAaE,yBAbF;EAcE,qBAdF;ApN0i/CJ;AoN3h/CM;EACE,WAAA;EACA,yBAjBJ;EAkBI,qBAlBJ;ApN+i/CJ;AoNxh/CM;;EACE,cAxBJ;EAyBI,mBAzBJ;ApNoj/CJ;AoNzi/CI;EACE,cAZF;EAaE,yBAbF;EAcE,qBAdF;ApNyj/CJ;AoN1i/CM;EACE,WAAA;EACA,yBAjBJ;EAkBI,qBAlBJ;ApN8j/CJ;AoNvi/CM;;EACE,cAxBJ;EAyBI,mBAzBJ;ApNmk/CJ;AoNxj/CI;EACE,cAZF;EAaE,yBAbF;EAcE,qBAdF;ApNwk/CJ;AoNzj/CM;EACE,WAAA;EACA,yBAjBJ;EAkBI,qBAlBJ;ApN6k/CJ;AoNtj/CM;;EACE,cAxBJ;EAyBI,mBAzBJ;ApNkl/CJ;AoNvk/CI;EACE,cAZF;EAaE,yBAbF;EAcE,qBAdF;ApNul/CJ;AoNxk/CM;EACE,WAAA;EACA,yBAjBJ;EAkBI,qBAlBJ;ApN4l/CJ;AoNrk/CM;;EACE,cAxBJ;EAyBI,mBAzBJ;ApNim/CJ;AoNtl/CI;EACE,cAZF;EAaE,yBAbF;EAcE,qBAdF;ApNsm/CJ;AoNvl/CM;EACE,WAAA;EACA,yBAjBJ;EAkBI,qBAlBJ;ApN2m/CJ;AoNpl/CM;;EACE,cAxBJ;EAyBI,mBAzBJ;ApNgn/CJ;AoNrm/CI;EACE,cAZF;EAaE,yBAbF;EAcE,qBAdF;ApNqn/CJ;AoNtm/CM;EACE,cAAA;EACA,yBAjBJ;EAkBI,qBAlBJ;ApN0n/CJ;AoNnm/CM;;EACE,cAxBJ;EAyBI,mBAzBJ;ApN+n/CJ;AoNpn/CI;EACE,cAZF;EAaE,yBAbF;EAcE,qBAdF;ApNoo/CJ;AoNrn/CM;EACE,cAAA;EACA,yBAjBJ;EAkBI,qBAlBJ;ApNyo/CJ;AoNln/CM;;EACE,cAxBJ;EAyBI,mBAzBJ;ApN8o/CJ;AoNno/CI;EACE,cAZF;EAaE,yBAbF;EAcE,qBAdF;ApNmp/CJ;AoNpo/CM;EACE,WAAA;EACA,yBAjBJ;EAkBI,qBAlBJ;ApNwp/CJ;AoNjo/CM;;EACE,cAxBJ;EAyBI,mBAzBJ;ApN6p/CJ;AoN/n/CE;;;;;;;;;;;EAKE,mB7MnXQ;E6MoXR,qB7MpXQ;E6MqXR,W7M7XK;APoggDT;AoNpo/CE;;;EAGE,mBAxYW;ApN8ggDf;AoNpo/CE;;;;EAEE,6DAAA;ApNwo/CJ;AoNro/CE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAgEE,gCAAA;ApNuo/CJ;AoNpo/CE;;;;;;EAME,8CAAA;ApNso/CJ;AoNpo/CE;EACE,c7MnbU;APyjgDd;AoNpo/CE;;EAEE,qBAAA;EACA,mBAAA;ApNso/CJ;AoNno/CE;;;;;;;;;;;;;;;;;;;;;;EAsBE,mB7MpeK;APymgDT;AoNno/CE;;;;;;EAME,mBAAA;ApNqo/CJ;AoNno/CE;EACE,qBApgBW;ApNyogDf;AoNno/CE;;;;EAIE,mBA1gBW;ApN+ogDf;AoNno/CE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA4CE,8BAAA;ApN4o/CJ;AoNzo/CE;EACE,iCAAA;ApN2o/CJ;AoNxo/CE;;EAEE,qCAAA;ApN0o/CJ;AoNxo/CE;EACE,yBAAA;ApN0o/CJ;AoNxo/CE;EACE,4CAAA;ApN0o/CJ;AoNxo/CE;;EAEE,qBA1kBgB;ApNotgDpB;AoNvo/CE;;EAEE,yBA/kBgB;ApNwtgDpB;AoNvo/CE;;EAEE,yBAplBW;ApN6tgDf;AoNto/CE;;EAEE,4BAxlBgB;ApNgugDpB;AoNto/CE;;EAEE,4BA7lBW;ApNqugDf;AoNro/CE;;EAEE,2BAjmBgB;ApNwugDpB;AoNro/CE;;EAEE,2BAtmBW;ApN6ugDf;AoNpo/CE;;EAEE,0BA1mBgB;ApNgvgDpB;AoNpo/CE;;EAEE,0BA/mBW;ApNqvgDf;AoNpo/CE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,sBAAA;ApN2o/CJ;AoNzo/CE;EACE,4BAAA;ApN2o/CJ;AoN1o/CI;EACE,wBAAA;ApN4o/CN;AoNxo/CE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAgCE,yBAAA;ApN8o/CJ;AoN5o/CE;EACE,c7M5oBU;AP0xgDd;AoN5o/CE;;;;EAIE,c7MnpBU;APiygDd;AoN7o/CI;;;;EACE,c7MroBc;APuxgDpB;AoN/o/CE;EACE,c7MvrBQ;E6MwrBR,mBAAA;ApNip/CJ;AoN9o/CI;EACE,c7MnpBc;APmygDpB;AoN5o/CI;EACE,c7MtpBc;APoygDpB;AoN3o/CE;;;;;;;;EAQE,yBAAA;ApN6o/CJ;AoN3o/CE;;;;EAIE,qBA3tBgB;ApNw2gDpB;AoN3o/CE;;;;;;;EAOE,oCAAA;ApN6o/CJ;AoN3o/CE;;;;;EAKE,oCAAA;ApN6o/CJ;AoN3o/CE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsBE,gCAAA;ApNyp/CJ;AoNvp/CE;EACE,oCAAA;ApNyp/CJ;AoNvp/CE;EACE,iCAAA;ApNyp/CJ;AoNvp/CE;EACE,oCAAA;EACA,gCAAA;ApNyp/CJ;AoNtp/CE;;;EAGE,yBAtxBgB;ApN86gDpB;AoNrp/CE;EACE,yBAAA;EACA,qBAAA;EACA,6CAAA;ApNup/CJ;AoNtp/CI;EACE,yB7MpuBc;AP43gDpB;AoNpp/CE;;;EAGE,c7M5vBU;APk5gDd;AoNrp/CI;;;EACE,mBAAA;ApNyp/CN;AoNrp/CE;EACE,oCAAA;ApNup/CJ;AoNpp/CE;;;;;;;;EAQE,c7M7wBU;APm6gDd;AoNpp/CE;;;EAGE,a7MlxBU;APw6gDd;AoNpp/CE;EACE,e7MrxBU;AP26gDd;AoNpp/CE;;;;;;;;;;;;;;;;;;;;;;;EAuBE,c7M/yBU;APq8gDd;AoNpp/CE;;EAEE,c7MpzBU;AP08gDd;AoNpp/CE;EACE,c7MtzBU;AP48gDd;AoNrp/CI;EACE,c7MvyBc;AP87gDpB;AoNrp/CI;EACE,W7M71BG;APo/gDT;AoNpp/CE;;EAEE,c7M/zBU;APq9gDd;AoNrp/CI;;;EAEE,c7MlzBc;AP08gDpB;AoNrp/CE;;EAEE,W7M12BK;APighDT;AoNrp/CE;;EAEE,8CAAA;ApNup/CJ;AoNrp/CE;;;;EAIE,mBAAA;ApNup/CJ;AoNpp/CE;;;;;;EAME,W7M73BK;APmhhDT;AoNnp/CE;;;;EAIE,c7Mh2BU;APq/gDd;AoNjp/CE;;;EAGE,yBAAA;ApNmp/CJ;AoNhp/CE;EACE,yB7M/3BK;APihhDT;AoN/o/CE;;;;;;;;;EASE,W7M35BK;AP4ihDT;AoN9o/CE;EACE,qBAAA;ApNgp/CJ;AoN5o/CE;;EAEE,W7Mr6BK;APmjhDT;AoN5o/CE;;;;;EAKE,gCAAA;ApN8o/CJ;AoN5o/CE;;;;;EAKE,mB7Mn6BK;APijhDT;AoN1o/CE;;;;;;;;EAQE,W7M/7BK;AP2khDT;AoN1o/CE;;EAEE,c7Mh6BU;AP4ihDd;AoNzo/CE;;;;;;;;;EASE,c7M76BU;APwjhDd;AoNxo/CE;;;;EAIE,c7Mn6BgB;AP6ihDpB;AoNvo/CE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA+BE,gCAAA;ApNyo/CJ;AoNvo/CE;;;;;EAKE,qB7Mr/BQ;AP8nhDZ;AoNvo/CE;;EAEE,gCAAA;ApNyo/CJ;AoNvo/CE;EACE,kCAAA;ApNyo/CJ;AoNto/CE;;;;;;;;EAQE,mBArhCgB;ApN6phDpB;AoNro/CE;;;;;;;;;;;;;;;;;;;;EAoBE,mBA7iCW;ApNorhDf;AoNpo/CE;EACE,8BAAA;ApNso/CJ;AoNpo/CE;;;;;;;;;;;EAWE,8BAAA;ApNso/CJ;AoNpo/CE;EACE,mBAAA;ApNso/CJ;AoNno/CE;;;;;;;;;;;;;;;;;EAiBE,mB7MhkCK;APqshDT;AoNno/CE;;EAEE,c7MnjCU;APwrhDd;AoNno/CE;;;;EAIE,c7MvjCU;AP4rhDd;AoNno/CE;EACE,W7M7lCK;APkuhDT;AoNno/CE;;EAEE,cAAA;ApNqo/CJ;AoNno/CE;;;;EAIE,c7MrkCU;AP0shDd;AoNno/CE;EACE,c7MvjCgB;AP4rhDpB;AoNno/CE;EACE,mBAnnCiB;ApNwvhDrB;AoN/n/CM;EACE,c7MllCM;E6MmlCN,qBAznCY;ApN0vhDpB;AoNho/CQ;EACE,c7MrlCI;E6MslCJ,qBA5nCU;ApN8vhDpB;AoNho/CQ;EAEE,W7M5nCD;E6M6nCC,mB7M7mCD;E6M8mCC,qBAloCU;ApNmwhDpB;AoN/n/CQ;EACE,8CAAA;ApNio/CV;AoN/n/CQ;EACE,c7MjlCU;E6MklCV,qBAzoCU;EA0oCV,mB7MtnCD;E6MunCC,qDAAA;ApNio/CV;AoN5n/CE;EACE,c7M3mCU;APyuhDd;AoN5n/CE;EACE,c7M7mCU;AP2uhDd;AoN5n/CE;;EAEE,W7MppCK;APkxhDT;AoN5n/CE;EACE,mB7MvoCK;APqwhDT;AoN5n/CE;;EAEE,mCAAA;ApN8n/CJ;AoNzm/CI;EACE,oCAAA;EACA,gCAAA;ApN2m/CN;AoNzm/CI;EACE,oCAAA;EACA,gCAAA;ApN2m/CN;AoNxm/CM;EACE,oCAAA;ApN0m/CR;AoNtm/CM;EACE,oCAAA;ApNwm/CR;AoNvn/CI;EACE,oCAAA;EACA,gCAAA;ApNyn/CN;AoNvn/CI;EACE,oCAAA;EACA,gCAAA;ApNyn/CN;AoNtn/CM;EACE,oCAAA;ApNwn/CR;AoNpn/CM;EACE,oCAAA;ApNsn/CR;AoNro/CI;EACE,oCAAA;EACA,gCAAA;ApNuo/CN;AoNro/CI;EACE,oCAAA;EACA,gCAAA;ApNuo/CN;AoNpo/CM;EACE,oCAAA;ApNso/CR;AoNlo/CM;EACE,oCAAA;ApNoo/CR;AoNnp/CI;EACE,oCAAA;EACA,gCAAA;ApNqp/CN;AoNnp/CI;EACE,oCAAA;EACA,gCAAA;ApNqp/CN;AoNlp/CM;EACE,oCAAA;ApNop/CR;AoNhp/CM;EACE,oCAAA;ApNkp/CR;AoNjq/CI;EACE,oCAAA;EACA,gCAAA;ApNmq/CN;AoNjq/CI;EACE,oCAAA;EACA,gCAAA;ApNmq/CN;AoNhq/CM;EACE,oCAAA;ApNkq/CR;AoN9p/CM;EACE,oCAAA;ApNgq/CR;AoN/q/CI;EACE,oCAAA;EACA,gCAAA;ApNir/CN;AoN/q/CI;EACE,oCAAA;EACA,gCAAA;ApNir/CN;AoN9q/CM;EACE,oCAAA;ApNgr/CR;AoN5q/CM;EACE,oCAAA;ApN8q/CR;AoN7r/CI;EACE,oCAAA;EACA,gCAAA;ApN+r/CN;AoN7r/CI;EACE,oCAAA;EACA,gCAAA;ApN+r/CN;AoN5r/CM;EACE,oCAAA;ApN8r/CR;AoN1r/CM;EACE,oCAAA;ApN4r/CR;AoN3s/CI;EACE,oCAAA;EACA,gCAAA;ApN6s/CN;AoN3s/CI;EACE,oCAAA;EACA,gCAAA;ApN6s/CN;AoN1s/CM;EACE,oCAAA;ApN4s/CR;AoNxs/CM;EACE,oCAAA;ApN0s/CR;AoNzt/CI;EACE,oCAAA;EACA,gCAAA;ApN2t/CN;AoNzt/CI;EACE,oCAAA;EACA,gCAAA;ApN2t/CN;AoNxt/CM;EACE,oCAAA;ApN0t/CR;AoNtt/CM;EACE,oCAAA;ApNwt/CR;AoNvu/CI;EACE,oCAAA;EACA,gCAAA;ApNyu/CN;AoNvu/CI;EACE,oCAAA;EACA,gCAAA;ApNyu/CN;AoNtu/CM;EACE,oCAAA;ApNwu/CR;AoNpu/CM;EACE,oCAAA;ApNsu/CR;AoNrv/CI;EACE,oCAAA;EACA,gCAAA;ApNuv/CN;AoNrv/CI;EACE,oCAAA;EACA,gCAAA;ApNuv/CN;AoNpv/CM;EACE,oCAAA;ApNsv/CR;AoNlv/CM;EACE,oCAAA;ApNov/CR;AoNnw/CI;EACE,oCAAA;EACA,gCAAA;ApNqw/CN;AoNnw/CI;EACE,oCAAA;EACA,gCAAA;ApNqw/CN;AoNlw/CM;EACE,oCAAA;ApNow/CR;AoNhw/CM;EACE,oCAAA;ApNkw/CR;AoNjx/CI;EACE,oCAAA;EACA,gCAAA;ApNmx/CN;AoNjx/CI;EACE,oCAAA;EACA,gCAAA;ApNmx/CN;AoNhx/CM;EACE,oCAAA;ApNkx/CR;AoN9w/CM;EACE,oCAAA;ApNgx/CR;AoN/x/CI;EACE,oCAAA;EACA,gCAAA;ApNiy/CN;AoN/x/CI;EACE,oCAAA;EACA,gCAAA;ApNiy/CN;AoN9x/CM;EACE,oCAAA;ApNgy/CR;AoN5x/CM;EACE,oCAAA;ApN8x/CR;AoNxx/CE;;;;;;;EAOE,qBAhtCgB;ApN0+hDpB;AoNxx/CE;EACE,gCAAA;ApN0x/CJ;AoNvx/CE;;;EAEE,8BAAA;ApN0x/CJ;AoNxx/CE;EACE,yBA3tCgB;EA4tChB,4BA5tCgB;ApNs/hDpB;AoNzx/CI;EACE,0BA9tCc;ApNy/hDpB;AoNzx/CI;EACE,2BAjuCc;ApN4/hDpB;AoNxx/CE;EACE,oCAAA;ApN0x/CJ;AoNxx/CE;EACE,yB7MjrCgB;AP28hDpB;AoNxx/CE;EACE,yB7MltCK;AP4+hDT;AoNxx/CE;EACE,yB7MptCI;AP8+hDR;AoNxx/CE;EACE,yB7MztCK;APm/hDT;AoNxx/CE;EACE,yB7M7tCI;APu/hDR;AoNtx/CI;;;;;;;EAOE,qBA/vCc;ApNuhiDpB;AoNtx/CI;EACE,yBAlwCc;EAmwCd,4BAnwCc;ApN2hiDpB;AoNvx/CM;EACE,0BArwCY;ApN8hiDpB;AoNvx/CM;EACE,2BAxwCY;ApNiiiDpB;AoNtx/CI;;EAEE,uBAAA;ApNwx/CN;AoNnx/CI;EACE,qBAAA;ApNqx/CN;AoNnx/CI;EACE,qBAAA;ApNqx/CN;AoNlx/CE;EACE,8BAAA;ApNox/CJ;AoNlx/CE;;EAEE,iCAAA;ApNox/CJ;AoNlx/CE;EACE,+BAAA;ApNox/CJ;AoNlx/CE;EACE,YAAA;EACA,8BAAA;ApNox/CJ;AoNhx/CE;;;;;;EAME,mBAAA;ApNkx/CJ;AoN/w/CE;;;;;;;;EAGE,wCAAA;ApNsx/CJ;AoNnx/CE;;EAEE,gCAAA;ApNqx/CJ;AoNnx/CE;EACE,yBA7zCgB;ApNkliDpB;AoNnx/CE;EACE,mBAAA;EACA,kDAAA;ApNqx/CJ;AoNlx/CE;;;EAGE,yBAx0CW;ApN4liDf;AoNlx/CE;;;;;EAKE,W7M10CK;AP8liDT;AoNlx/CE;;EAEE,c7M9yCU;APkkiDd;AoN/w/CI;;EAEE,qBAAA;ApNix/CN;AoN/w/CI;EACE,0BAAA;EACA,2BAAA;EACA,yBAAA;ApNix/CN;AoN9w/CI;EACE,4BAAA;ApNgx/CN;AoN3w/CE;EACE,yBAAA;EACA,qBAAA;ApN6w/CJ;AoN3w/CE;EACE,gCAAA;ApN6w/CJ;AoN3w/CE;EACE,yBAh3CW;ApN6niDf;AoN3w/CE;EACE,yBAAA;ApN6w/CJ;AoN3w/CE;EACE,qBAr3CgB;ApNkoiDpB;AoN3w/CE;EACE,mB7Mp2CK;APiniDT;AoNzw/CM;EACE,qBAAA;ApN2w/CR;AoNxw/CI;EACE,yB7Ml3CM;AP4niDZ;AoNtw/CI;EACE,yBAv4CS;EAw4CT,qBAAA;ApNww/CN;AoNlw/CQ;EACE,kCAAA;ApNow/CV;AoN5v/CM;EACE,yB7Mn4CC;APioiDT;AoN3v/CQ;EACE,yB7Mp2CU;APimiDpB;AoNvv/CE;;EAEE,W7M/5CK;E6Mg6CL,mBAr6CW;EAs6CX,qBAr6CgB;ApN8piDpB;AoNxv/CI;;EACE,W7Mn6CG;E6Mo6CH,mB7Mj3Cc;E6Mk3Cd,qB7Ml3Cc;AP6miDpB;AoNvv/CI;;EAEE,c7Mt6CM;AP+piDZ;AoNxv/CM;;EACE,c7Mx6CI;E6My6CJ,mBAn7CO;EAo7CP,qBAn7CY;ApN8qiDpB;AoNrv/CE;EACE,qBA17CgB;ApNiriDpB;AoNrv/CE;EACE,W7Mz7CK;APgriDT;AoNlv/CI;EACE,W7M/7CG;APmriDT;AoNlv/CI;EACE,qBAt8Cc;ApN0riDpB;AoNjv/CU;EACE,qBA18CQ;ApN6riDpB;AoNhv/CY;EACE,qB7Mv5CM;APyoiDpB;AoN3u/CE;EACE,yBAv9CW;EAw9CX,qBAv9CgB;ApNosiDpB;AoN3u/CE;EACE,qBA19CgB;ApNusiDpB;AoN3u/CE;EACE,mB7Mz8CK;E6M08CL,kDAAA;ApN6u/CJ;AoN3u/CE;EACE,mBAAA;ApN6u/CJ;AoN3u/CE;;EAEE,mBAAA;ApN6u/CJ;AoN3u/CE;EACE,qBAAA;EACA,mBAAA;ApN6u/CJ;AoN3u/CE;EACE,yEACE;ApN4u/CN;;AoNtu/CA;EAGM;IACE,yBAAA;EpNuu/CN;AACF;AoNlu/CA;EAgIE,eAAA;ApNqm/CF;AoNpu/CE;EACE,yBAAA;ApNsu/CJ;AoNpu/CE;EACE,yBAAA;ApNsu/CJ;AoNpu/CE;EACE,yBAAA;ApNsu/CJ;AoNpu/CE;EACE,yBAAA;ApNsu/CJ;AoNpu/CE;EACE,yBAAA;ApNsu/CJ;AoNpu/CE;EACE,yBAAA;ApNsu/CJ;AoNpu/CE;EACE,yBAAA;ApNsu/CJ;AoNpu/CE;EACE,yBAAA;ApNsu/CJ;AoNnu/CE;EACE,iCAAA;EACA,oBAAA;EACA,6BAAA;EACA,iCAAA;EACA,0BAAA;EACA,2CAAA;ApNqu/CJ;AoNnu/CE;EACE,0BAAA;EACA,yBAAA;EACA,oCAAA;EACA,oCAAA;ApNqu/CJ;AoNlu/CE;EACE,gCAAA;ApNou/CJ;AoNlu/CE;EACE,yBAAA;EACA,+BAAA;EACA,0CAAA;EACA,0BAAA;EACA,2BAAA;ApNou/CJ;AoNju/CE;;;;EAIE,oCAAA;EAEA,0BAAA;EACA,2BAAA;ApNku/CJ;AoNhu/CE;EACE,oCAAA;EACA,6BAAA;EACA,2BAAA;EACA,oCAAA;EACA,6CAAA;EACA,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;ApNku/CJ;AoNhu/CE;EACE,oCAAA;EACA,6BAAA;EACA,2BAAA;EAEA,6CAAA;EACA,0BAAA;EACA,2BAAA;EACA,0BAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,oCAAA;ApNiu/CJ;AoN/t/CE;EACE,uBAAA;ApNiu/CJ;AoN/t/CE;EACE,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,oCAAA;ApNiu/CJ;AoN/t/CE;EACE,cAAA;EACA,8BAAA;ApNiu/CJ;AoN/t/CE;EACE,yBAAA;EACA,2BAAA;EACA,gBAAA;EACA,6BAAA;ApNiu/CJ;AoN/t/CE;EACE,yBAAA;ApNiu/CJ;AoN9t/CE;EACE,oCAAA;EACA,6BAAA;EACA,0BAAA;ApNgu/CJ;AoN9t/CE;EACE,yBAAA;EACA,0BAAA;EACA,gCAAA;EACA,4BAAA;ApNgu/CJ;AoN9t/CE;EACE,kCAAA;ApNgu/CJ;AoN1t/CM;EACE,cAAA;EtMtlDJ,2BAAA;EACA,8BAAA;AdmziDJ;AoNzt/CM;EtMzmDF,4BAAA;EACA,+BAAA;Adq0iDJ;AoNxt/CI;EACE,UAAA;EACA,yBAAA;EACA,oCAAA;EACA,gCAAA;ApN0t/CN;AoNvt/CI;EACE,c7M1oDM;E6M2oDN,oBAAA;EACA,YAAA;EACA,sB7MlpDG;E6MmpDH,qB7M/oDM;APw2iDZ;AoNtt/CE;EACE,oCAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;ApNwt/CJ;AoNtt/CE;EACE,kBAAA;EACA,oCAAA;EACA,kCAAA;ApNwt/CJ;AoNtt/CE;EAKE,WAAA;EACA,oCAAA;ApNot/CJ;AoNlt/CE;EAKE,yBAAA;EACA,oCAAA;ApNgt/CJ;AoN9s/CE;EAKE,yBAAA;EACA,oCAAA;ApN4s/CJ;AoN1s/CE;EACE,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,c7M/pDU;E6MgqDV,iBAAA;ApN4s/CJ;AoN1s/CE;EACE,mB7MrrDK;APi4iDT;AoN1s/CE;EACE,kBAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;EACA,QAAA;ApN4s/CJ;AoN1s/CE;;;;EAIE,yBAAA;EACA,oCAAA;ApN4s/CJ;AoN1s/CE;;;;EAIE,c7MtrDU;E6MurDV,yBA/tDW;EAguDX,qBAAA;ApN4s/CJ;AoN1s/CE;;;;;;EAME,qBAAA;EACA,sBAAA;EACA,oCAAA;ApN4s/CJ;AoN1s/CE;;;;;;EAME,yBAAA;EACA,oCAAA;ApN4s/CJ;AoN1s/CE;;;;;;;;;;;;EAYE,qBAAA;EACA,sBAAA;EACA,oCAAA;ApN4s/CJ;AoN1s/CE;;;;;;;;;;;;;;EAcE,yBAAA;EACA,oCAAA;ApN4s/CJ;AoN1s/CE;;;;;;;;;;;;;;;;EAwBE,yB7MtvDgB;E6MuvDhB,WAAA;ApNos/CJ;AoNls/CE;;;;;;;;EAQE,yB7MjwDgB;E6MkwDhB,WAAA;ApNos/CJ;AoNhs/CE;;;EAGE,mBAj0DW;EAk0DX,yBAAA;EACA,qBAl0DgB;ApNogjDpB;AoNhs/CE;EACE,yBAAA;ApNks/CJ;AoN9r/CE;EACE,oCAAA;EACA,6BAAA;EACA,2BAAA;EACA,gCAAA;ApNgs/CJ;AoN9r/CE;EACE,oCAAA;EACA,2BAAA;EACA,gCAAA;ApNgs/CJ;AoN9r/CE;EACE,oCAAA;EACA,2BAAA;EACA,qBAAA;EACA,c7MlzDU;APk/iDd;AoN9r/CE;EACE,oCAAA;ApNgs/CJ;AoN9r/CE;EACE,8BAAA;ApNgs/CJ;AoN9r/CE;EACE,yBAAA;ApNgs/CJ;AoN3r/CE;EACE,8BAAA;EACA,sBAAA;ApN6r/CJ;;AA5/iDA,aAAA","sourcesContent":["// SET RTL OPTION\n$rtl: false;\n\n// Included Global Variables and Functions\n@import \"dashlite_variables\";\n\n// Included Fonts\n/** 01. FONTS */\n@import \"core/fonts/dmsans\";\n\n// Included Bootstarp\n@import \"extend/bootstrap/variables\";\n@import \"extend/bootstrap/bootstrap\";\n@import \"extend/bootstrap/extend\";\n\n// Include Other Vendors\n@import \"vendors/bundle\";\n\n// Include Core Dashlite Style\n@import \"core/style\";\n\n////////////////////////// DO NOT REMOVE ABOVE ///////////////////////\n\n////// GLOBAL INCLUDED\n@import \"global/style\";\n\n//////  APPLICATONS - Common Uses\n@import \"apps/asterisk\"; \n@import \"apps/reply-comment\"; \n@import \"apps/attach\"; \n\n//////  Apps\n@import \"apps/messages\";  \t\t// - Support Messages\n@import \"apps/inbox\";  \t\t\t//- Inbox/ Mail App\n@import \"apps/file-manager\";  \t// - File Manager\n@import \"apps/chats\";  \t\t\t// - Chats\n\n///////  PREVIEW PURPOSE \n@import \"core/preview\";\n\n///////  UI/MODE OVERRIDE\n@import \"core/mode-override\";\n\n///////  DARK MODE SKIN\n@import \"core/dark-skin\";\n\n/*! END @iO */\n////////////////////////// END STYLESHEET ////////////////////////////","@font-face {\n    font-family: 'DM Sans';\n    src: url('#{$font-url}/DMSans-Bold.eot');\n    src: local('DM Sans Bold'), local('DMSans-Bold'),\n        url('#{$font-url}/DMSans-Bold.eot#iefix') format('embedded-opentype'),\n        url('#{$font-url}/DMSans-Bold.woff2') format('woff2'),\n        url('#{$font-url}/DMSans-Bold.woff') format('woff'),\n        url('#{$font-url}/DMSans-Bold.ttf') format('truetype');\n    font-weight: bold;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'DM Sans';\n    src: url('#{$font-url}/DMSans-Medium.eot');\n    src: local('DM Sans Medium'), local('DMSans-Medium'),\n        url('#{$font-url}/DMSans-Medium.eot#iefix') format('embedded-opentype'),\n        url('#{$font-url}/DMSans-Medium.woff2') format('woff2'),\n        url('#{$font-url}/DMSans-Medium.woff') format('woff'),\n        url('#{$font-url}/DMSans-Medium.ttf') format('truetype');\n    font-weight: 500;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'DM Sans';\n    src: url('#{$font-url}/DMSans-Regular.eot');\n    src: local('DM Sans Regular'), local('DMSans-Regular'),\n        url('#{$font-url}/DMSans-Regular.eot#iefix') format('embedded-opentype'),\n        url('#{$font-url}/DMSans-Regular.woff2') format('woff2'),\n        url('#{$font-url}/DMSans-Regular.woff') format('woff'),\n        url('#{$font-url}/DMSans-Regular.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}","/**\n * Bootstrap (https://getbootstrap.com/) \n */\n\n// @import \"node_modules/bootstrap/scss/functions\"; // @included from extend/bootstrap/variables for reuse functions\n// @import \"node_modules/bootstrap/scss/variables\"; // @included from extend/bootstrap/variables for callback\n\n/// RTL OVERRIDE NOTE\n/// '_override_base/**' related files/folder is used to over-ride based code which is rtl alternet purpose.\n\n@import \"node_modules/bootstrap/scss/mixins\";\n@import \"node_modules/bootstrap/scss/root\";\n\n// @import \"node_modules/bootstrap/scss/reboot\";\n@import \"_override_base/reboot\";\t\t\t\t\n// @import \"node_modules/bootstrap/scss/type\n@import \"_override_base/type\";\t\t\t\t\t\n\n@import \"node_modules/bootstrap/scss/images\";\n@import \"node_modules/bootstrap/scss/code\";\n@import \"node_modules/bootstrap/scss/grid\";\n@import \"node_modules/bootstrap/scss/tables\";\n\n// @import \"node_modules/bootstrap/scss/forms\";\n@import \"_override_base/forms\"; \t\t\t\t\n\n@import \"node_modules/bootstrap/scss/buttons\";\n@import \"node_modules/bootstrap/scss/transitions\";\n\n// @import \"node_modules/bootstrap/scss/dropdown\";\n@import \"_override_base/dropdown\"; \t\t\t\t\n// @import \"node_modules/bootstrap/scss/button-group\";\n@import \"_override_base/button-group\"; \t\t\t\n// @import \"node_modules/bootstrap/scss/input-group\";\n@import \"_override_base/input-group\"; \t\t\t\n// @import \"node_modules/bootstrap/scss/custom-forms\";\n@import \"_override_base/custom-forms\"; \t\t\t\n\n@import \"node_modules/bootstrap/scss/nav\";\n\n// @import \"node_modules/bootstrap/scss/navbar\";\n@import \"_override_base/navbar\";\t\t\t\t\n// @import \"node_modules/bootstrap/scss/card\";\n@import \"_override_base/card\";\t\t\t\t\t\n// @import \"node_modules/bootstrap/scss/breadcrumb\";\n@import \"_override_base/breadcrumb\";\t\t\t\n// @import \"node_modules/bootstrap/scss/pagination\";\n@import \"_override_base/pagination\";\t\t\t\n\n@import \"node_modules/bootstrap/scss/badge\";\n@import \"node_modules/bootstrap/scss/jumbotron\";\n\n// @import \"node_modules/bootstrap/scss/alert\"; \n@import \"_override_base/alert\";\t\t\t\t\t\n\n@import \"node_modules/bootstrap/scss/progress\";\n@import \"node_modules/bootstrap/scss/media\";\n\n// @import \"node_modules/bootstrap/scss/list-group\";\n@import \"_override_base/list-group\";\t\t\t\n// @import \"node_modules/bootstrap/scss/close\";\n@import \"_override_base/close\";\t\t\t\t\t\n\n@import \"node_modules/bootstrap/scss/toasts\";\n\n// @import \"node_modules/bootstrap/scss/modal\";\n@import \"_override_base/modal\";\t\t\t\t\t\n\n@import \"node_modules/bootstrap/scss/tooltip\";\n@import \"node_modules/bootstrap/scss/popover\";\n@import \"node_modules/bootstrap/scss/carousel\";\n@import \"node_modules/bootstrap/scss/spinners\";\n\n// @import \"node_modules/bootstrap/scss/utilities\"; // @separately loading as below\n\n@import \"node_modules/bootstrap/scss/utilities/align\";\n@import \"node_modules/bootstrap/scss/utilities/background\";\n// @import \"node_modules/bootstrap/scss/utilities/borders\";\n@import \"_override_base/utilities/borders\";\t\t\t\t\t\t\t\t\n\n@import \"node_modules/bootstrap/scss/utilities/clearfix\";\n@import \"node_modules/bootstrap/scss/utilities/display\";\n@import \"node_modules/bootstrap/scss/utilities/embed\";\n@import \"node_modules/bootstrap/scss/utilities/flex\";\n// @import \"node_modules/bootstrap/scss/utilities/float\";\n@import \"_override_base/utilities/float\";\t\t\t\t\t\t\t\t\n\n@import \"node_modules/bootstrap/scss/utilities/interactions\";\n@import \"node_modules/bootstrap/scss/utilities/overflow\";\n@import \"node_modules/bootstrap/scss/utilities/position\";\n@import \"node_modules/bootstrap/scss/utilities/screenreaders\";\n@import \"node_modules/bootstrap/scss/utilities/shadows\";\n@import \"node_modules/bootstrap/scss/utilities/sizing\";\n\n// @import \"node_modules/bootstrap/scss/utilities/spacing\";\n@import \"_override_base/utilities/spacing\";\t\t\t\t\t\t\t\t\n\n@import \"node_modules/bootstrap/scss/utilities/stretched-link\";\n\n// @import \"node_modules/bootstrap/scss/utilities/text\";\n@import \"_override_base/utilities/text\";\t\t\t\t\t\t\t\t\n\n@import \"node_modules/bootstrap/scss/utilities/visibility\";\n@import \"node_modules/bootstrap/scss/print\";\n",":root {\n  // Custom variable values only support SassScript inside `#{}`.\n  @each $color, $value in $colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $bp, $value in $grid-breakpoints {\n    --breakpoint-#{$bp}: #{$value};\n  }\n\n  // Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --font-family-sans-serif: #{inspect($font-family-sans-serif)};\n  --font-family-monospace: #{inspect($font-family-monospace)};\n}\n","// stylelint-disable at-rule-no-vendor-prefix, declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n// Document\n//\n// 1. Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n// 2. Change the default font family in all browsers.\n// 3. Correct the line height in all browsers.\n// 4. Prevent adjustments of font size after orientation changes in IE on Windows Phone and in iOS.\n// 5. Change the default tap highlight to be completely transparent in iOS.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box; // 1\n}\n\nhtml {\n  font-family: sans-serif; // 2\n  line-height: 1.15; // 3\n  -webkit-text-size-adjust: 100%; // 4\n  -webkit-tap-highlight-color: rgba($black, 0); // 5\n}\n\n// Shim for \"new\" HTML5 structural elements to display correctly (IE10, older browsers)\n// TODO: remove in v5\n// stylelint-disable-next-line selector-list-comma-newline-after\narticle,\naside,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nnav,\nsection {\n  display: block;\n}\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Set an explicit initial text-align value so that we can later use\n//    the `inherit` value on things like `<th>` elements.\n\nbody {\n  margin: 0; // 1\n  font-family: $font-family-base;\n  @include font-size($font-size-base);\n  font-weight: $font-weight-base;\n  line-height: $line-height-base;\n  color: $body-color;\n  text-align: left; // 3\n  background-color: $body-bg; // 2\n}\n\n// Future-proof rule: in browsers that support :focus-visible, suppress the focus outline\n// on elements that programmatically receive focus but wouldn't normally show a visible\n// focus outline. In general, this would mean that the outline is only applied if the\n// interaction that led to the element receiving programmatic focus was a keyboard interaction,\n// or the browser has somehow determined that the user is primarily a keyboard user and/or\n// wants focus outlines to always be presented.\n//\n// See https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-visible\n// and https://developer.paciellogroup.com/blog/2018/03/focus-visible-and-backwards-compatibility/\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\n  outline: 0 !important;\n}\n\n// Content grouping\n//\n// 1. Add the correct box sizing in Firefox.\n// 2. Show the overflow in Edge and IE.\n\nhr {\n  box-sizing: content-box; // 1\n  height: 0; // 1\n  overflow: visible; // 2\n}\n\n//\n// Typography\n//\n\n// Remove top margins from headings\n//\n// By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n// margin for easier control within type scales as it avoids margin collapsing.\n// stylelint-disable-next-line selector-list-comma-newline-after\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin-top: 0;\n  margin-bottom: $headings-margin-bottom;\n}\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n// Abbreviations\n//\n// 1. Duplicate behavior to the data-* attribute for our tooltip plugin\n// 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n// 3. Add explicit cursor to indicate changed behavior.\n// 4. Remove the bottom border in Firefox 39-.\n// 5. Prevent the text-decoration to be skipped.\n\nabbr[title],\nabbr[data-original-title] {\n  // 1\n  text-decoration: underline; // 2\n  cursor: help; // 3\n  border-bottom: 0; // 4\n  text-decoration-skip-ink: none; // 5\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0; // Undo browser default\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: $font-weight-bolder; // Add the correct font weight in Chrome, Edge, and Safari\n}\n\nsmall {\n  @include font-size(80%); // Add the correct font size in all browsers\n}\n\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n//\n\nsub,\nsup {\n  position: relative;\n  @include font-size(75%);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\nsup {\n  top: -0.5em;\n}\n\n//\n// Links\n//\n\na {\n  color: $link-color;\n  text-decoration: $link-decoration;\n  background-color: transparent; // Remove the gray background on active links in IE 10.\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]) {\n  color: inherit;\n  text-decoration: none;\n\n  @include hover() {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n//\n// Code\n//\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-monospace;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\npre {\n  // Remove browser default top margin\n  margin-top: 0;\n  // Reset browser default of `1em` to use `rem`s\n  margin-bottom: 1rem;\n  // Don't allow content to break outside\n  overflow: auto;\n  // Disable auto-hiding scrollbar in IE & legacy Edge to avoid overlap,\n  // making it impossible to interact with the content\n  -ms-overflow-style: scrollbar;\n}\n\n//\n// Figures\n//\n\nfigure {\n  // Apply a consistent margin strategy (matches our type styles).\n  margin: 0 0 1rem;\n}\n\n//\n// Images and content\n//\n\nimg {\n  vertical-align: middle;\n  border-style: none; // Remove the border on images inside links in IE 10-.\n}\n\nsvg {\n  // Workaround for the SVG overflow bug in IE10/11 is still required.\n  // See https://github.com/twbs/bootstrap/issues/26878\n  overflow: hidden;\n  vertical-align: middle;\n}\n\n//\n// Tables\n//\n\ntable {\n  border-collapse: collapse; // Prevent double borders\n}\n\ncaption {\n  padding-top: $table-cell-padding;\n  padding-bottom: $table-cell-padding;\n  color: $table-caption-color;\n  text-align: left;\n  caption-side: bottom;\n}\n\nth {\n  // Matches default `<td>` alignment by inheriting from the `<body>`, or the\n  // closest parent with a set `text-align`.\n  text-align: inherit;\n}\n\n//\n// Forms\n//\n\nlabel {\n  // Allow labels to use `margin` for spacing.\n  display: inline-block;\n  margin-bottom: $label-margin-bottom;\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24093\nbutton {\n  // stylelint-disable-next-line property-blacklist\n  border-radius: 0;\n}\n\n// Work around a Firefox/IE bug where the transparent `button` background\n// results in a loss of the default `button` focus styles.\n//\n// Credit: https://github.com/suitcss/base/\nbutton:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // Remove the margin in Firefox and Safari\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible; // Show the overflow in Edge\n}\n\nbutton,\nselect {\n  text-transform: none; // Remove the inheritance of text transform in Firefox\n}\n\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n// Remove the inheritance of word-wrap in Safari.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24990\nselect {\n  word-wrap: normal;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n}\n\n@if $enable-pointer-cursor-for-buttons {\n  button,\n  [type=\"button\"],\n  [type=\"reset\"],\n  [type=\"submit\"] {\n    &:not(:disabled) {\n      cursor: pointer;\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box; // 1. Add the correct box sizing in IE 10-\n  padding: 0; // 2. Remove the padding in IE 10-\n}\n\ntextarea {\n  overflow: auto; // Remove the default vertical scrollbar in IE.\n  // Textareas should really only resize vertically so they don't break their (horizontal) containers.\n  resize: vertical;\n}\n\nfieldset {\n  // Browsers set a default `min-width: min-content;` on fieldsets,\n  // unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n  // So we reset that to ensure fieldsets behave more like a standard block element.\n  // See https://github.com/twbs/bootstrap/issues/12359\n  // and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n  min-width: 0;\n  // Reset the default outline behavior of fieldsets so they don't affect page layout.\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\n// 1. Correct the text wrapping in Edge and IE.\n// 2. Correct the color inheritance from `fieldset` elements in IE.\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%; // 1\n  padding: 0;\n  margin-bottom: 0.5rem;\n  @include font-size(1.5rem);\n  line-height: inherit;\n  color: inherit; // 2\n  white-space: normal; // 1\n}\n\nprogress {\n  vertical-align: baseline; // Add the correct vertical alignment in Chrome, Firefox, and Opera.\n}\n\n// Correct the cursor style of increment and decrement buttons in Chrome.\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=\"search\"] {\n  // This overrides the extra rounded corners on search inputs in iOS so that our\n  // `.form-control` class can properly style them. Note that this cannot simply\n  // be added to `.form-control` as it's not specific enough. For details, see\n  // https://github.com/twbs/bootstrap/issues/11586.\n  outline-offset: -2px; // 2. Correct the outline style in Safari.\n  -webkit-appearance: none;\n}\n\n//\n// Remove the inner padding in Chrome and Safari on macOS.\n//\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n//\n// 1. Correct the inability to style clickable types in iOS and Safari.\n// 2. Change font properties to `inherit` in Safari.\n//\n\n::-webkit-file-upload-button {\n  font: inherit; // 2\n  -webkit-appearance: button; // 1\n}\n\n//\n// Correct element displays\n//\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item; // Add the correct display in all browsers\n  cursor: pointer;\n}\n\ntemplate {\n  display: none; // Add the correct display in IE\n}\n\n// Always hide an element with the `hidden` HTML attribute (from PureCSS).\n// Needed for proper display in IE 10-.\n[hidden] {\n  display: none !important;\n}\n","// Include Core Bootstrap functions //\n// Do not remove\n@import \"node_modules/bootstrap/scss/functions\";\n@import \"node_modules/bootstrap/scss/variables\";\n\n// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n$gray-100: $light-100;\n$gray-200: $light-200;\n$gray-300: $light-300;\n$gray-400: $light-400;\n$gray-500: $light-500;\n$gray-600: $light-600;\n$gray-700: $light-700;\n$gray-800: $light-800;\n$gray-900: $light-900;\n\n$grays: ();\n$grays: map-merge(\n  (\n    \"100\": $gray-100,\n    \"200\": $gray-200,\n    \"300\": $gray-300,\n    \"400\": $gray-400,\n    \"500\": $gray-500,\n    \"600\": $gray-600,\n    \"700\": $gray-700,\n    \"800\": $gray-800,\n    \"900\": $gray-900\n  ),\n  $grays\n);\n\n$primary:             $accent-color;\n$secondary:           $base-color;\n$secondary-light:     $base-text;\n\n$theme-colors: ();\n// stylelint-disable-next-line scss/dollar-variable-default\n$theme-colors: map-merge(\n  (\n    \"primary\":    $primary,\n    \"secondary\":  $secondary,\n    \"success\":    $success,\n    \"info\":       $info,\n    \"warning\":    $warning,\n    \"danger\":     $danger,\n    \"dark\":       $base-dark,\n    \"gray\":       $light-500,\n    \"light\":      $light-200,\n    \"lighter\":    $lighter\n  ),\n  $theme-colors\n);\n\n$component-active-color:      $white;\n$component-active-bg:         theme-color(\"primary\");\n\n// // Set a specific color jumpsd\n$theme-color-interval:      8%;\n$yiq-contrasted-threshold:  190;\n\n$yiq-text-dark:             $darker;\n$yiq-text-light:            $white;\n\n\n// // Link\n// //\n\n$link-decoration:                         none;\n$link-hover-decoration:                   underline;\n\n$emphasized-link-hover-darken-percentage: 15%;\n\n// // // Paragraphs\n// // //\n\n$paragraph-margin-bottom:   $para-margin;\n\n\n// // Grid breakpoints\n// //\n\n$grid-breakpoints: (\n  xs:  0,\n  mb:  420px,\n  sm:  576px,\n  md:  768px,\n  lg:  992px,\n  xl:  1200px,\n  xxl: 1540px\n);\n\n// @include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n// @include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// // Grid containers\n// //\n// // Define the maximum width of `.container` for different screen sizes.\n\n$container-max-widths: (\n  mb:  420px,\n  sm:  540px,\n  md:  720px,\n  lg:  960px,\n  xl:  1140px,\n  xxl: 1440px\n);\n\n// @include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-gutter-width:           $gutter-width;\n\n\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n$spacers: ();\n$spacers: map-merge(\n  (\n    0: 0,\n    1: ($spacer * .375),\n    2: ($spacer * .75),\n    3: $spacer,\n    4: ($spacer * 1.5),\n    5: ($spacer * 2.75),\n    'gs': $gutter-width\n\n    // 0: 0,\n    // 1: ($spacer * .25),\n    // 2: ($spacer * .5),\n    // 3: $spacer,\n    // 4: ($spacer * 1.5),\n    // 5: ($spacer * 3)\n  ),\n  $spacers\n);\n\n// // Components\n// //\n// // Define common padding and border radius sizes and more.\n\n$line-height-lg:              $lh-lg;\n$line-height-sm:              $lh-sm;\n\n// // Typography\n// //\n// // Font, line-height, and color for body text, headings, and more.\n\n// // stylelint-disable value-keyword-case\n$font-family-sans-serif:      $base-font-family, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif;\n$font-family-base:            $font-family-sans-serif;\n\n$font-size-base:              $fs-base; // Assumes the browser default, typically `16px`\n$font-size-lg:                $fs-lg;\n$font-size-sm:                $fs-sm;\n\n$font-weight-light:           $fw-light;\n$font-weight-normal:          $fw-normal;\n$font-weight-bold:            $fw-bold;\n\n$font-weight-base:            $font-weight-normal;\n$line-height-base:            $base-line-height;\n\n\n$h1-font-size:                $h1-fs;\n$h2-font-size:                $h2-fs;\n$h3-font-size:                $h3-fs;\n$h4-font-size:                $h4-fs;\n$h5-font-size:                $h5-fs;\n$h6-font-size:                $h6-fs;\n\n$headings-margin-bottom:      $h-margin-bottom;\n$headings-font-family:        $h-font-family;\n$headings-font-weight:        $h-font-weight;\n$headings-line-height:        $h-line-height;\n$headings-color:              $h-color; \n\n$display1-size:               6rem;\n$display2-size:               5.5rem;\n$display3-size:               4.5rem;\n$display4-size:               3.5rem;\n\n$display1-weight:             300;\n$display2-weight:             300;\n$display3-weight:             300;\n$display4-weight:             300;\n$display-line-height:         $headings-line-height;\n\n$lead-font-size:              $lead-fs;\n$lead-font-weight:            $lead-fw;\n\n$small-font-size:             $small-fs;\n\n$text-muted:                  $text-off;\n\n$blockquote-small-color:      $quote-small-color;\n$blockquote-small-font-size:  $quote-small-font-size;\n$blockquote-font-size:        $quote-font-size;\n\n$dt-font-weight:              $font-weight-bold;\n\n$kbd-box-shadow:              inset 0 -.1rem 0 rgba($black, .25);\n$nested-kbd-font-weight:      $font-weight-bold;\n\n$list-inline-padding:         .5rem;\n\n$hr-border-color:             $hr-color;\n$hr-border-width:             $hr-width;\n$hr-margin-y:                 $hr-margin;\n\n\n// // Tables\n// //\n// // Customizes the `.table` component with basic values, each used across all table variations.\n\n$table-cell-padding:          .5rem;\n$table-cell-padding-sm:       .25rem;\n$table-cell-padding-x-sm:     1.25rem;\n$table-cell-padding-bordered: 1rem;\n\n$table-accent-bg:             $lighter;\n$table-hover-bg:              $lighter;\n$table-head-bg:               $lighter;\n$table-head-color:            $base-color;\n\n$table-dark-bg:               $light-800;\n$table-dark-accent-bg:        $light-700;\n$table-dark-hover-bg:         $light-700;\n$table-dark-border-color:     $light-600;\n\n$table-caption-color:         $base-light;\n\n// $table-color:                 $body-color !default;\n// $table-bg:                    null !default;\n// $table-hover-color:           $lighter;\n$table-active-bg:             $lighter;\n\n// $table-border-width:          $border-width !default;\n// $table-border-color:          $border-color !default;\n\n\n// $table-dark-color:            $white !default;\n// $table-dark-hover-color:      $table-dark-color !default;\n\n// $table-striped-order:         odd !default;\n\n\n// $table-bg-level:              -9 !default;\n// $table-border-level:          -6 !default;\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n$input-btn-padding-y:         $field-padding-y;\n$input-btn-padding-x:         $field-padding-x;\n$input-btn-font-family:       $field-font-family;\n$input-btn-font-size:         $field-font-size;\n$input-btn-line-height:       $field-line-height;\n\n$input-btn-focus-width:       $field-focus-width;\n$input-btn-focus-color:       $field-focus-color;\n$input-btn-focus-box-shadow:  $field-focus-box-shadow;\n\n$input-btn-padding-y-sm:      $field-padding-y-sm;\n$input-btn-padding-x-sm:      $field-padding-x-sm;\n$input-btn-font-size-sm:      $field-font-size-sm;\n$input-btn-line-height-sm:    $field-line-height-sm;\n\n$input-btn-padding-y-lg:      $field-padding-y-lg;\n$input-btn-padding-x-lg:      $field-padding-x-lg;\n$input-btn-font-size-lg:      $field-font-size-lg;\n$input-btn-line-height-lg:    $field-line-height-lg;\n\n$input-btn-border-width:      $field-border-width;\n\n\n// // Forms\n\n$label-margin-bottom:                   $field-margin-bottom;\n\n\n// $form-text-margin-top:                  .25rem !default;\n\n// $form-check-input-gutter:               1.25rem !default;\n// $form-check-input-margin-y:             .3rem !default;\n// $form-check-input-margin-x:             .25rem !default;\n\n// $form-check-inline-margin-x:            .75rem !default;\n// $form-check-inline-input-margin-x:      .3125rem !default;\n\n// $form-grid-gutter-width:                10px !default;\n// $form-group-margin-bottom:              1rem !default;\n\n// $input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                     $light;\n// $input-group-addon-border-color:        $input-border-color !default;\n\n// $custom-forms-transition:               background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$custom-control-gutter:                    $checkbox-radio-switch-text-gap;\n// $custom-control-spacer-x:               1rem !default;\n// $custom-control-cursor:                 null !default;\n\n$custom-control-indicator-size:            $checkbox-radio-switch-size;\n$custom-control-indicator-bg:              $input-bg;\n\n// $custom-control-indicator-bg-size:      50% 50% !default;\n// $custom-control-indicator-box-shadow:   $input-box-shadow !default;\n$custom-control-indicator-border-color:    $input-border-color;\n$custom-control-indicator-border-width:    $checkbox-radio-switch-border;\n\n// $custom-control-label-color:            null !default;\n\n// $custom-control-indicator-disabled-bg:          $input-disabled-bg !default;\n// $custom-control-label-disabled-color:           $gray-600 !default;\n\n$custom-control-indicator-checked-color:            $component-active-color;\n$custom-control-indicator-checked-bg:               $component-active-bg;\n$custom-control-indicator-checked-disabled-bg:      rgba(theme-color(\"primary\"), .8);\n$custom-control-indicator-checked-box-shadow:       none;\n$custom-control-indicator-checked-border-color:     $custom-control-indicator-checked-bg;\n\n// $custom-control-indicator-focus-box-shadow:     $input-focus-box-shadow !default;\n// $custom-control-indicator-focus-border-color:   $input-focus-border-color !default;\n\n$custom-control-indicator-active-color:         $component-active-color;\n$custom-control-indicator-active-bg:            $component-active-bg;\n$custom-control-indicator-active-box-shadow:    none;\n$custom-control-indicator-active-border-color:  $custom-control-indicator-active-bg;\n\n// $custom-checkbox-indicator-border-radius:       $border-radius !default;\n// $custom-checkbox-indicator-icon-checked:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/></svg>\") !default;\n\n// $custom-checkbox-indicator-indeterminate-bg:           $component-active-bg !default;\n// $custom-checkbox-indicator-indeterminate-color:        $custom-control-indicator-checked-color !default;\n// $custom-checkbox-indicator-icon-indeterminate:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'><path stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/></svg>\") !default;\n// $custom-checkbox-indicator-indeterminate-box-shadow:   none !default;\n// $custom-checkbox-indicator-indeterminate-border-color: $custom-checkbox-indicator-indeterminate-bg !default;\n\n// $custom-radio-indicator-border-radius:          50% !default;\n// $custom-radio-indicator-icon-checked:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'><circle r='3' fill='#{$custom-control-indicator-checked-color}'/></svg>\") !default;\n\n$custom-switch-width:                           $switch-width;\n$custom-switch-indicator-border-radius:         $switch-indicator-border-radius;\n$custom-switch-indicator-size:                  $switch-indicator-size;\n\n// $custom-select-padding-y:           $input-padding-y !default;\n// $custom-select-padding-x:           $input-padding-x !default;\n// $custom-select-font-family:         $input-font-family !default;\n// $custom-select-font-size:           $input-font-size !default;\n// $custom-select-height:              $input-height !default;\n// $custom-select-indicator-padding:   1rem !default; // Extra padding to account for the presence of the background-image based indicator\n// $custom-select-font-weight:         $input-font-weight !default;\n// $custom-select-line-height:         $input-line-height !default;\n// $custom-select-color:               $input-color !default;\n// $custom-select-disabled-color:      $gray-600 !default;\n// $custom-select-bg:                  $input-bg !default;\n// $custom-select-disabled-bg:         $gray-200 !default;\n// $custom-select-bg-size:             8px 10px !default; // In pixels because image dimensions\n// $custom-select-indicator-color:     $gray-800 !default;\n// $custom-select-indicator:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'><path fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>\") !default;\n// $custom-select-background:          escape-svg($custom-select-indicator) no-repeat right $custom-select-padding-x center / $custom-select-bg-size !default; // Used so we can have multiple background elements (e.g., arrow and feedback icon)\n\n// $custom-select-feedback-icon-padding-right: add(1em * .75, (2 * $custom-select-padding-y * .75) + $custom-select-padding-x + $custom-select-indicator-padding) !default;\n// $custom-select-feedback-icon-position:      center right ($custom-select-padding-x + $custom-select-indicator-padding) !default;\n// $custom-select-feedback-icon-size:          $input-height-inner-half $input-height-inner-half !default;\n\n// $custom-select-border-width:        $input-border-width !default;\n// $custom-select-border-color:        $input-border-color !default;\n// $custom-select-border-radius:       $border-radius !default;\n// $custom-select-box-shadow:          inset 0 1px 2px rgba($black, .075) !default;\n\n// $custom-select-focus-border-color:  $input-focus-border-color !default;\n// $custom-select-focus-width:         $input-focus-width !default;\n// $custom-select-focus-box-shadow:    0 0 0 $custom-select-focus-width $input-btn-focus-color !default;\n\n// $custom-select-padding-y-sm:        $input-padding-y-sm !default;\n// $custom-select-padding-x-sm:        $input-padding-x-sm !default;\n// $custom-select-font-size-sm:        $input-font-size-sm !default;\n// $custom-select-height-sm:           $input-height-sm !default;\n\n// $custom-select-padding-y-lg:        $input-padding-y-lg !default;\n// $custom-select-padding-x-lg:        $input-padding-x-lg !default;\n// $custom-select-font-size-lg:        $input-font-size-lg !default;\n// $custom-select-height-lg:           $input-height-lg !default;\n\n// $custom-range-track-width:          100% !default;\n// $custom-range-track-height:         .5rem !default;\n// $custom-range-track-cursor:         pointer !default;\n// $custom-range-track-bg:             $gray-300 !default;\n// $custom-range-track-border-radius:  1rem !default;\n// $custom-range-track-box-shadow:     inset 0 .25rem .25rem rgba($black, .1) !default;\n\n// $custom-range-thumb-width:                   1rem !default;\n// $custom-range-thumb-height:                  $custom-range-thumb-width !default;\n// $custom-range-thumb-bg:                      $component-active-bg !default;\n// $custom-range-thumb-border:                  0 !default;\n// $custom-range-thumb-border-radius:           1rem !default;\n// $custom-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n// $custom-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n// $custom-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in IE/Edge\n// $custom-range-thumb-active-bg:               lighten($component-active-bg, 35%) !default;\n// $custom-range-thumb-disabled-bg:             $gray-500 !default;\n\n// $custom-file-height:                $input-height !default;\n// $custom-file-height-inner:          $input-height-inner !default;\n// $custom-file-focus-border-color:    $input-focus-border-color !default;\n// $custom-file-focus-box-shadow:      $input-focus-box-shadow !default;\n// $custom-file-disabled-bg:           $input-disabled-bg !default;\n\n// $custom-file-padding-y:             $input-padding-y !default;\n// $custom-file-padding-x:             $input-padding-x !default;\n// $custom-file-line-height:           $input-line-height !default;\n// $custom-file-font-family:           $input-font-family !default;\n// $custom-file-font-weight:           $input-font-weight !default;\n// $custom-file-color:                 $input-color !default;\n// $custom-file-bg:                    $input-bg !default;\n// $custom-file-border-width:          $input-border-width !default;\n// $custom-file-border-color:          $input-border-color !default;\n// $custom-file-border-radius:         $input-border-radius !default;\n// $custom-file-box-shadow:            $input-box-shadow !default;\n// $custom-file-button-color:          $custom-file-color !default;\n$custom-file-button-bg:                $input-group-addon-bg;\n// $custom-file-text: (\n//   en: \"Browse\"\n// ) !default;\n\n\n// // Form validation\n\n// $form-feedback-margin-top:          $form-text-margin-top !default;\n// $form-feedback-font-size:           $small-font-size !default;\n// $form-feedback-valid-color:         theme-color(\"success\") !default;\n// $form-feedback-invalid-color:       theme-color(\"danger\") !default;\n\n// $form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n// $form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n// $form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n// $form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}' viewBox='0 0 12 12'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n\n// $form-validation-states: () !default;\n// // stylelint-disable-next-line scss/dollar-variable-default\n// $form-validation-states: map-merge(\n//   (\n//     \"valid\": (\n//       \"color\": $form-feedback-valid-color,\n//       \"icon\": $form-feedback-icon-valid\n//     ),\n//     \"invalid\": (\n//       \"color\": $form-feedback-invalid-color,\n//       \"icon\": $form-feedback-icon-invalid\n//     ),\n//   ),\n//   $form-validation-states\n// );\n\n// // Z-index master list\n// //\n// // Warning: Avoid customizing these values. They're used for a bird's eye view\n// // of components dependent on the z-axis and are designed to all work together.\n\n// $zindex-dropdown:                   1000 !default;\n// $zindex-sticky:                     1020 !default;\n// $zindex-fixed:                      1030 !default;\n// $zindex-modal-backdrop:             1040 !default;\n// $zindex-modal:                      1050 !default;\n// $zindex-popover:                    1060 !default;\n// $zindex-tooltip:                    1070 !default;\n\n\n// // Navs\n\n// $nav-link-padding-y:                .5rem !default;\n// $nav-link-padding-x:                1rem !default;\n// $nav-link-disabled-color:           $gray-600 !default;\n\n// $nav-tabs-border-color:             $gray-300 !default;\n// $nav-tabs-border-width:             $border-width !default;\n// $nav-tabs-border-radius:            $border-radius !default;\n// $nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n// $nav-tabs-link-active-color:        $gray-700 !default;\n// $nav-tabs-link-active-bg:           $body-bg !default;\n// $nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n// $nav-pills-border-radius:           $border-radius !default;\n// $nav-pills-link-active-color:       $component-active-color !default;\n// $nav-pills-link-active-bg:          $component-active-bg !default;\n\n// $nav-divider-color:                 $gray-200 !default;\n// $nav-divider-margin-y:              math.div($spacer , 2) !default;\n\n\n// // Navbar\n\n// $navbar-padding-y:                  math.div($spacer , 2) !default;\n// $navbar-padding-x:                  $spacer !default;\n\n// $navbar-nav-link-padding-x:         .5rem !default;\n\n// $navbar-brand-font-size:            $font-size-lg !default;\n// // Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n// $nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n// $navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n// $navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) / 2 !default;\n\n// $navbar-toggler-padding-y:          .25rem !default;\n// $navbar-toggler-padding-x:          .75rem !default;\n// $navbar-toggler-font-size:          $font-size-lg !default;\n// $navbar-toggler-border-radius:      $btn-border-radius !default;\n\n// $navbar-dark-color:                 rgba($white, .5) !default;\n// $navbar-dark-hover-color:           rgba($white, .75) !default;\n// $navbar-dark-active-color:          $white !default;\n// $navbar-dark-disabled-color:        rgba($white, .25) !default;\n// $navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n// $navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n// $navbar-light-color:                rgba($black, .5) !default;\n// $navbar-light-hover-color:          rgba($black, .7) !default;\n// $navbar-light-active-color:         rgba($black, .9) !default;\n// $navbar-light-disabled-color:       rgba($black, .3) !default;\n// $navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n// $navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n// $navbar-light-brand-color:                $navbar-light-active-color !default;\n// $navbar-light-brand-hover-color:          $navbar-light-active-color !default;\n// $navbar-dark-brand-color:                 $navbar-dark-active-color !default;\n// $navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\n\n\n// // Dropdowns\n// //\n// // Dropdown menu container and contents.\n\n// $dropdown-min-width:                10rem !default;\n// $dropdown-padding-y:                .5rem !default;\n// $dropdown-spacer:                   .125rem !default;\n// $dropdown-font-size:                $font-size-base !default;\n// $dropdown-color:                    $body-color !default;\n// $dropdown-bg:                       $white !default;\n// $dropdown-border-color:             rgba($black, .15) !default;\n// $dropdown-border-radius:            $border-radius !default;\n// $dropdown-border-width:             $border-width !default;\n// $dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n// $dropdown-divider-bg:               $gray-200 !default;\n// $dropdown-divider-margin-y:         $nav-divider-margin-y !default;\n// $dropdown-box-shadow:               0 .5rem 1rem rgba($black, .175) !default;\n\n// $dropdown-link-color:               $gray-900 !default;\n// $dropdown-link-hover-color:         darken($gray-900, 5%) !default;\n// $dropdown-link-hover-bg:            $gray-100 !default;\n\n// $dropdown-link-active-color:        $component-active-color !default;\n// $dropdown-link-active-bg:           $component-active-bg !default;\n\n// $dropdown-link-disabled-color:      $gray-600 !default;\n\n// $dropdown-item-padding-y:           .25rem !default;\n// $dropdown-item-padding-x:           1.5rem !default;\n\n// $dropdown-header-color:             $gray-600 !default;\n\n// // Jumbotron\n\n// $jumbotron-padding:                 2rem !default;\n// $jumbotron-color:                   null !default;\n// $jumbotron-bg:                      $gray-200 !default;\n\n\n// // Cards\n\n// $card-spacer-y:                     .75rem !default;\n// $card-spacer-x:                     1.25rem !default;\n// $card-border-width:                 $border-width !default;\n// $card-border-radius:                $border-radius !default;\n// $card-border-color:                 rgba($black, .125) !default;\n// $card-inner-border-radius:             subtract($card-border-radius, $card-border-width);\n// $card-cap-bg:                          rgba($black, .07);\n// $card-cap-color:                    null !default;\n// $card-height:                       null !default;\n// $card-color:                        null !default;\n// $card-bg:                           $white !default;\n\n// $card-img-overlay-padding:          1.25rem !default;\n\n// $card-group-margin:                 $grid-gutter-width / 2 !default;\n// $card-deck-margin:                  $card-group-margin !default;\n\n// $card-columns-count:                3 !default;\n// $card-columns-gap:                  1.25rem !default;\n// $card-columns-margin:               $card-spacer-y !default;\n\n\n// // Tooltips\n\n// $tooltip-font-size:                 $font-size-sm !default;\n// $tooltip-max-width:                 200px !default;\n// $tooltip-color:                     $white !default;\n// $tooltip-bg:                        $black !default;\n// $tooltip-border-radius:             $border-radius !default;\n// $tooltip-opacity:                   .9 !default;\n// $tooltip-padding-y:                 .25rem !default;\n// $tooltip-padding-x:                 .5rem !default;\n// $tooltip-margin:                    0 !default;\n\n// $tooltip-arrow-width:               .8rem !default;\n// $tooltip-arrow-height:              .4rem !default;\n// $tooltip-arrow-color:               $tooltip-bg !default;\n\n// // Form tooltips must come after regular tooltips\n// $form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n// $form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n// $form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n// $form-feedback-tooltip-line-height:   $line-height-base !default;\n// $form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n// $form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n\n\n// // Popovers\n\n// $popover-font-size:                 $font-size-sm !default;\n// $popover-bg:                        $white !default;\n// $popover-max-width:                 276px !default;\n// $popover-border-width:              $border-width !default;\n// $popover-border-color:              rgba($black, .2) !default;\n// $popover-border-radius:             $border-radius-lg !default;\n// $popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width) !default;\n// $popover-box-shadow:                0 .25rem .5rem rgba($black, .2) !default;\n\n// $popover-header-bg:                 darken($popover-bg, 3%) !default;\n// $popover-header-color:              $headings-color !default;\n// $popover-header-padding-y:          .5rem !default;\n// $popover-header-padding-x:          .75rem !default;\n\n// $popover-body-color:                $body-color !default;\n// $popover-body-padding-y:            $popover-header-padding-y !default;\n// $popover-body-padding-x:            $popover-header-padding-x !default;\n\n// $popover-arrow-width:               1rem !default;\n// $popover-arrow-height:              .5rem !default;\n// $popover-arrow-color:               $popover-bg !default;\n\n// $popover-arrow-outer-color:         fade-in($popover-border-color, .05) !default;\n\n\n// // Toasts\n\n// $toast-max-width:                   350px !default;\n// $toast-padding-x:                   .75rem !default;\n// $toast-padding-y:                   .25rem !default;\n// $toast-font-size:                   .875rem !default;\n// $toast-color:                       null !default;\n// $toast-background-color:            rgba($white, .85) !default;\n// $toast-border-width:                1px !default;\n// $toast-border-color:                rgba(0, 0, 0, .1) !default;\n// $toast-border-radius:               .25rem !default;\n// $toast-box-shadow:                  0 .25rem .75rem rgba($black, .1) !default;\n\n// $toast-header-color:                $gray-600 !default;\n// $toast-header-background-color:     rgba($white, .85) !default;\n// $toast-header-border-color:         rgba(0, 0, 0, .05) !default;\n\n\n// // Modals\n\n// // Padding applied to the modal body\n// $modal-inner-padding:               1rem !default;\n\n// // Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\n// $modal-footer-margin-between:       .5rem !default;\n\n// $modal-dialog-margin:               .5rem !default;\n// $modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n// $modal-title-line-height:           $line-height-base !default;\n\n// $modal-content-color:               null !default;\n// $modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, 0);\n$modal-content-border-width:        0;\n$modal-content-border-radius:       $border-radius-lg;\n// $modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       0px 0px 1px 0px rgba($base-500, 0.2),0px 8px 15.52px 0.48px rgba($base-dark, 0.15);\n$modal-content-box-shadow-sm-up:    $modal-content-box-shadow-xs;\n\n$modal-backdrop-bg:                 $base-color;\n$modal-backdrop-opacity:            .5;\n// $modal-header-border-color:         $border-color !default;\n// $modal-footer-border-color:         $modal-header-border-color !default;\n// $modal-header-border-width:         $modal-content-border-width !default;\n// $modal-footer-border-width:         $modal-header-border-width !default;\n// $modal-header-padding-y:            1rem !default;\n// $modal-header-padding-x:            1rem !default;\n// $modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-xl:                          980px;\n$modal-lg:                          720px;\n$modal-md:                          520px;\n$modal-sm:                          360px;\n\n\n// // Progress bars\n\n$progress-height:                   .5rem;\n$progress-font-size:                $fx-sz-12;\n$progress-bg:                       $lighter;\n$progress-border-radius:            2px;\n// $progress-box-shadow:               inset 0 .1rem .1rem rgba($black, .1) !default;\n// $progress-bar-color:                $white !default;\n$progress-bar-bg:                      theme-color(\"primary\");\n// $progress-bar-animation-timing:     1s linear infinite !default;\n// $progress-bar-transition:           width .6s ease !default;\n\n\n// // List group\n\n// $list-group-color:                  null !default;\n// $list-group-bg:                     $white !default;\n// $list-group-border-color:           rgba($black, .125) !default;\n// $list-group-border-width:           $border-width !default;\n// $list-group-border-radius:          $border-radius !default;\n\n// $list-group-item-padding-y:         .75rem !default;\n// $list-group-item-padding-x:         1.25rem !default;\n\n// $list-group-hover-bg:               $gray-100 !default;\n// $list-group-active-color:           $component-active-color !default;\n// $list-group-active-bg:              $component-active-bg !default;\n// $list-group-active-border-color:    $list-group-active-bg !default;\n\n// $list-group-disabled-color:         $gray-600 !default;\n// $list-group-disabled-bg:            $list-group-bg !default;\n\n// $list-group-action-color:           $gray-700 !default;\n// $list-group-action-hover-color:     $list-group-action-color !default;\n\n// $list-group-action-active-color:    $body-color !default;\n// $list-group-action-active-bg:       $gray-200 !default;\n\n\n// // Image thumbnails\n\n// $thumbnail-padding:                 .25rem !default;\n// $thumbnail-bg:                      $body-bg !default;\n// $thumbnail-border-width:            $border-width !default;\n// $thumbnail-border-color:            $gray-300 !default;\n// $thumbnail-border-radius:           $border-radius !default;\n// $thumbnail-box-shadow:              0 1px 2px rgba($black, .075) !default;\n\n\n// // Figures\n\n// $figure-caption-font-size:          90% !default;\n// $figure-caption-color:              $gray-600 !default;\n\n\n// // Carousel\n\n// $carousel-control-color:             $white !default;\n// $carousel-control-width:             15% !default;\n// $carousel-control-opacity:           .5 !default;\n// $carousel-control-hover-opacity:     .9 !default;\n// $carousel-control-transition:        opacity .15s ease !default;\n\n// $carousel-indicator-width:           30px !default;\n// $carousel-indicator-height:          3px !default;\n// $carousel-indicator-hit-area-height: 10px !default;\n// $carousel-indicator-spacer:          3px !default;\n// $carousel-indicator-active-bg:       $white !default;\n// $carousel-indicator-transition:      opacity .6s ease !default;\n\n// $carousel-caption-width:             70% !default;\n// $carousel-caption-color:             $white !default;\n\n// $carousel-control-icon-width:        20px !default;\n\n// $carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/></svg>\") !default;\n// $carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/></svg>\") !default;\n\n// $carousel-transition-duration:       .6s !default;\n// $carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n\n// // Spinners\n\n// $spinner-width:         2rem !default;\n// $spinner-height:        $spinner-width !default;\n// $spinner-border-width:  .25em !default;\n\n// $spinner-width-sm:        1rem !default;\n// $spinner-height-sm:       $spinner-width-sm !default;\n// $spinner-border-width-sm: .2em !default;\n\n\n// // Close\n\n// $close-font-size:                   $font-size-base * 1.5 !default;\n// $close-font-weight:                 $font-weight-bold !default;\n// $close-color:                       $black !default;\n// $close-text-shadow:                 0 1px 0 $white !default;\n\n\n// // Code\n\n// $code-font-size:                    87.5% !default;\n// $code-color:                        $pink !default;\n\n// $kbd-padding-y:                     .2rem !default;\n// $kbd-padding-x:                     .4rem !default;\n// $kbd-font-size:                     $code-font-size !default;\n// $kbd-color:                         $white !default;\n// $kbd-bg:                            $gray-900 !default;\n\n// $pre-color:                         $gray-900 !default;\n// $pre-scrollable-max-height:         340px !default;\n\n\n// // Utilities\n\n// $displays: none, inline, inline-block, block, table, table-row, table-cell, flex, inline-flex !default;\n// $overflows: auto, hidden !default;\n// $positions: static, relative, absolute, fixed, sticky !default;\n\n\n// // Printing\n\n// $print-page-size:                   a3 !default;\n// $print-body-min-width:              map-get($grid-breakpoints, \"lg\") !default;\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated responsive font sizes\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/v8.x/LICENSE)\n\n// Configuration\n\n// Base font size\n$rfs-base-font-size: 1.25rem !default;\n$rfs-font-size-unit: rem !default;\n\n@if $rfs-font-size-unit != rem and $rfs-font-size-unit != px {\n  @error \"`#{$rfs-font-size-unit}` is not a valid unit for $rfs-font-size-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where font-size starts decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize font size based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != \"number\" or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-responsive-font-sizes to false\n$enable-responsive-font-sizes: true !default;\n\n// Cache $rfs-base-font-size unit\n$rfs-base-font-size-unit: unit($rfs-base-font-size);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-font-size for calculations\n@if $rfs-base-font-size-unit == \"px\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, $rfs-base-font-size * 0 + 1);\n}\n@else if $rfs-base-font-size-unit == \"rem\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, divide($rfs-base-font-size * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == \"px\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == \"rem\" or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-disable-class {\n  @if $rfs-class == \"disable\" {\n    // Adding an extra class increases specificity, which prevents the media query to override the font size\n    &,\n    .disable-responsive-font-size &,\n    &.disable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-enable-class {\n  @if $rfs-class == \"enable\" {\n    .enable-responsive-font-size &,\n    &.enable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query($mq-value) {\n  @if $rfs-two-dimensional {\n    @media (max-width: #{$mq-value}), (max-height: #{$mq-value}) {\n      @content;\n    }\n  }\n  @else {\n    @media (max-width: #{$mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Responsive font size mixin\n@mixin rfs($fs, $important: false) {\n  // Cache $fs unit\n  $fs-unit: if(type-of($fs) == \"number\", unit($fs), false);\n\n  // Add !important suffix if needed\n  $rfs-suffix: if($important, \" !important\", \"\");\n\n  // If $fs isn't a number (like inherit) or $fs has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n  @if not $fs-unit or $fs-unit != \"\" and $fs-unit != \"px\" and $fs-unit != \"rem\" or $fs == 0 {\n    font-size: #{$fs}#{$rfs-suffix};\n  }\n  @else {\n    // Remove unit from $fs for calculations\n    @if $fs-unit == \"px\" {\n      $fs: divide($fs, $fs * 0 + 1);\n    }\n    @else if $fs-unit == \"rem\" {\n      $fs: divide($fs, divide($fs * 0 + 1, $rfs-rem-value));\n    }\n\n    // Set default font size\n    $rfs-static: if($rfs-font-size-unit == rem, #{divide($fs, $rfs-rem-value)}rem, #{$fs}px);\n\n    // Only add the media query if the font size is bigger than the minimum font size\n    @if $fs <= $rfs-base-font-size or not $enable-responsive-font-sizes {\n      font-size: #{$rfs-static}#{$rfs-suffix};\n    }\n    @else {\n      // Calculate the minimum font size for $fs\n      $fs-min: $rfs-base-font-size + divide($fs - $rfs-base-font-size, $rfs-factor);\n\n      // Calculate difference between $fs and the minimum font size\n      $fs-diff: $fs - $fs-min;\n\n      // Base font-size formatting\n      $min-width: if($rfs-font-size-unit == rem, #{divide($fs-min, $rfs-rem-value)}rem, #{$fs-min}px);\n\n      // Use `vmin` if two-dimensional is enabled\n      $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n      // Calculate the variable width between 0 and $rfs-breakpoint\n      $variable-width: #{divide($fs-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n      // Set the calculated font-size\n      $rfs-fluid: calc(#{$min-width} + #{$variable-width}) #{$rfs-suffix};\n\n      // Breakpoint formatting\n      $mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n\n      @include _rfs-disable-class {\n        font-size: #{$rfs-static}#{$rfs-suffix};\n      }\n\n      @include _rfs-media-query($mq-value) {\n        @include _rfs-enable-class {\n          font-size: $rfs-fluid;\n        }\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n    }\n  }\n}\n\n// The font-size & responsive-font-size mixins use RFS to rescale the font size\n@mixin font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n\n@mixin responsive-font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n","////////////////////////////////////////////////////////\n////////     CORE DASHLITE VARIABLES    ///// //////////\n////////////////////////////////////////////////////////\n\n@use 'sass:math';\n$font-url: '../../../fonts';\n\n/////////    COLORS    ///////////\n//////////////////////////////////////\n$white:\t\t#fff;\n$black: \t#000;\n\n$light-100: #ebeef2; \n$light-200: #e5e9f2; \n$light-300: #dbdfea; \n$light-400: #b7c2d0; \n$light-500: #8091a7; \n$light-600: #3c4d62;\n$light-700: #344357;\n$light-800: #2b3748;\n$light-900: #1f2b3a;\n\n$lighter:\t#f5f6fa; \n$light:\t\t$light-100;\n$dark:\t\t$light-900;\n$darker:\t#101924;\n\n\n$red: \t\t#e85347;\n$yellow:\t#f4bd0e;\n$green: \t#1ee0ac; \n$cyan:\t\t#09c2de;\n$blue:\t\t#559bfb;\n$azure:\t\t#1676fb;\n$indigo:\t#2c3782;\n$purple:\t#816bff;\n$pink:\t\t#ff63a5;\n$orange: \t#ffa353;\n$teal:\t\t#20c997;\n\n// Base/Default color @used for text\n$base-100:  \t\t#ecf2ff;\n$base-200:  \t\t#dfe9fe;\n$base-300:  \t\t#b6c6e3;\n$base-400:  \t\t#8094ae;\n$base-500:  \t\t#526484;\n\n$base-color:  \t\t#364a63;\n$base-dark:  \t\t#1c2b46;\n$base-text:  \t\t$base-500;\n$base-light:  \t\t$base-400;\n$base-dim:  \t\tmix($base-color,$white, 8%);\n\n// Base/Default color @used for text\n$accent-100:        #f0eaff;\n$accent-200:        #e7dcff;\n$accent-300:        #d4c2ff;\n$accent-400:        #b695ff;\n$accent-500:        #9d72ff;\n\n$accent-color:      #4461F2;\n$accent-light:      $accent-300;\n$accent-dark:       #3a2272;\n$accent-dim:  \t    #e3e7fe;\n\n\n$body-bg:\t\t\t$lighter;\n$body-color:\t\t$base-text;\n\n$link-color:        \t\t$accent-500;\n$link-hover-color:  \t\tdarken($link-color, 10%);\n$chat-color:               #86D97B;\n\n$shadow-color: \t\t\t\t$light-800;\n$shadow-color-light: \t\t$light-600;\n$shadow-color-dark: \t\t$light-900;\n$shadow-color-accent: \t\t$accent-dark;\n\n// Status Color\n$success:                   $green;\n$warning:                   $yellow;\n$danger:                    $red;\n$info:                      $cyan;\n\n// Brand Colors\n$brand-color-bitcoin:       #f9841e;\n$brand-color-ethereum:      #6174b9;\n$brand-color-facebook:      #3b5998;\n$brand-color-google:        #de5246;\n\n$extend-mix:                #fff;\n$extend-colors: (\n    \"blue\":            $blue,\n    \"azure\":           $azure,\n    \"indigo\":          $indigo,\n    \"purple\":          $purple,\n    \"pink\":            $pink,\n    \"orange\":          $orange,\n    \"teal\":            $teal,\n    \"blue-dim\":        mix($blue, $extend-mix, 13%),\n    \"azure-dim\":       mix($azure, $extend-mix, 13%),\n    \"indigo-dim\":      mix($indigo, $extend-mix, 13%),\n    \"purple-dim\":      mix($purple, $extend-mix, 13%),\n    \"pink-dim\":        mix($pink, $extend-mix, 13%),\n    \"orange-dim\":      mix($orange, $extend-mix, 13%),\n    \"teal-dim\":        mix($teal, $extend-mix, 13%),\n    // for bootstrap\n    \"primary-dim\":     mix($accent-color, $extend-mix, 13%),\n    \"success-dim\":     mix($success, $extend-mix, 13%),\n    \"info-dim\":        mix($info, $extend-mix, 13%),\n    \"warning-dim\":     mix($warning, $extend-mix, 13%),\n    \"danger-dim\":      mix($danger, $extend-mix, 13%),\n    \"secondary-dim\":   #e5ecf5,\n    \"dark-dim\":        #d9e1ef,\n    \"gray-dim\":        #edf2f9\n);\n\n/////////    GLOBAL UTILITY    //////////\n/////////////////////////////////////////\n\n$bg-light:\t\t\t$light-100;\n$bg-light-alt:\t\t$light-300;\n\n$bg-dark:\t\t\t$light-600;\n$bg-dark-alt:\t\t$light-800;\n\n$border-light:\t\t$light-200;\n$border-light-alt:\t$light-400;\n\n$border-dark:\t\t$light-600;\n$border-dark-alt:\t$light-700;\n\n$spacer: \t\t\t1rem;\n\n$border-width:\t\t1px;\n$border-color:\t\t$light-300;\n\n$border-radius: \t4px;\n$border-radius-lg: \t5px;\n$border-radius-sm: \t3px;\n$border-radius-xl:  8px;\n$border-radius-xxl: 12px;\n\n$rounded:           50%;\n$rounded-pill:      1.5rem;\n\n$box-shadow-sm:               0 .125rem .25rem rgba($shadow-color, .15);\n$box-shadow:                  0 3px 12px 1px rgba($shadow-color, .15);\n$box-shadow-lg:               0 1rem 3rem rgba($shadow-color, .25);\n\n$fx-sz-9:\t\t\t9px;\n$fx-sz-10:\t\t\t10px;\n$fx-sz-11:\t\t\t11px;\n$fx-sz-12:\t\t\t12px;\n$fx-sz-13:\t\t\t13px;\n$fx-sz-14:\t\t\t14px;\n$fx-sz-15:\t\t\t15px;\n$fx-sz-16:\t\t\t16px; \n\n$gutter-width:           28px;\n$stretch-gap-x:          (4px + math.div($gutter-width,2));\n\n/////////    TYPTOGRAPHY    //////////\n//////////////////////////////////////\n\n$base-font-family: \t\t\"DM Sans\", sans-serif;\n$base-line-height:\t\t1.65;\n$alt-font-family: \t\t$base-font-family;\n\n$lg-base:\t\t\t\t$base-line-height;\n$lh-rg:\t\t\t\t\t$base-line-height;\n$lh-lg:\t\t\t\t\t1.5;\n$lh-sm:\t\t\t\t\t1.5;\n\n$fw-300: \t\t\t\t300;\n$fw-400: \t\t\t\t400;\n$fw-500: \t\t\t\t500;\n$fw-700: \t\t\t\t700;\n\n$fw-base: \t\t\t\t$fw-400;\n$fw-normal: \t\t\t$fw-400;\n$fw-bold: \t\t\t\t$fw-700;\n$fw-light: \t\t\t\t$fw-300;\n$fw-medium: \t\t\t$fw-500;\n\n$fs-base-dsk:            16px;\n$fs-base-tab:            16px;\n$fs-base-mob:            16px;\n\n$fs-base:\t\t\t\t0.775rem; // $fs-base-px is `16px`\n$fs-lg:\t\t\t\t\t1.25rem;\n$fs-sm:\t\t\t\t\t.75rem;\n\n$h1-fs:\t\t\t\t\t2rem;\n$h2-fs:\t\t\t\t\t1.75rem;\n$h3-fs:\t\t\t\t\t1.5rem;\n$h4-fs:\t\t\t\t\t1.25rem;\n$h5-fs:\t\t\t\t\t1.15rem;\n$h6-fs:\t\t\t\t\t1rem;\n// desktop\n$h1-fs-lg:\t\t\t\t3.75rem;\n$h2-fs-lg:\t\t\t\t2.5rem;\n$h3-fs-lg:\t\t\t\t2rem;\n$h4-fs-lg:\t\t\t\t1.5rem;\n$h5-fs-lg:\t\t\t\t1.25rem;\n$h6-fs-lg:\t\t\t\t1.05rem;\n\n$page-title-ff:         $alt-font-family;\n$page-title-fs:         1.5rem;\n$page-title-fs-lg:      1.75rem;\n$page-title-fw:         $fw-bold;\n\n$h-margin-bottom:\t\tmath.div($spacer , 2);\n$h-font-family:  \t\t$alt-font-family;\n$h-font-weight:  \t\t$fw-bold;\n$h-line-height:  \t\t1.1;\n$h-color:\t\t\t\t$base-color; \n\n$lead-fs:\t\t\t\t$fs-base * 1.15;\n$lead-fs-dsk:\t\t\t$fs-base * 1.25;\n$lead-fw:\t\t\t\t$fw-normal;\n\n$small-fs:\t\t\t\t85%;\n\n$text-off:\t\t\t\t$base-light;\n\n\n$quote-small-color:      $base-300;\n$quote-small-font-size:  $small-fs;\n$quote-font-size:        $fs-base * 1.25;\n\n\n$mark-padding:      \t\t.2em;\n$mark-bg:           \t\t#fcf8e3;\n\n$hr-color: \t\t\t\t\t$light-400;\n$hr-width: \t\t\t\t\t1px;\n$hr-margin:\t\t\t\t\t$spacer;\n$para-margin:               1rem;\n\n\n/////////    FORMS GLOBAL    /////////////////\n//////////////////////////////////////////////\n\n$field-padding-y:         \t0.4375rem;\n$field-padding-x:         \t1rem;\n$field-font-family:       \tnull;\n$field-font-size:         \t$fx-sz-13;\n$field-line-height:       \t1.25rem;\n$field-font-weight:\t\t\t$fw-base;\n\n$field-focus-width:       \t.2rem;\n$field-focus-color:       \t$accent-color;\n$field-focus-shadow:  \t    0 0 0 3px;\n$field-focus-box-shadow:  \t$field-focus-shadow rgba($field-focus-color, .1);\n\n$field-padding-y-sm:      \t.25rem;\n$field-padding-x-sm:      \t1rem;\n$field-font-size-sm:      \t$fx-sz-12;\n$field-line-height-sm:    \t1.25rem;\n\n$field-padding-y-lg:      \t.6875rem;\n$field-padding-x-lg:      \t1rem;\n$field-font-size-lg:      \t$fx-sz-15;\n$field-line-height-lg:    \t1.25rem;\n\n$field-padding-y-xl:      \t0.625rem;\n$field-padding-x-xl:      \t1.25rem;\n$field-font-size-xl:      \t$fx-sz-15;\n$field-line-height-xl:    \t2rem;\n\n$field-border-width:      \t$border-width;\n\n$field-margin-bottom:      \t16px;\n$field-margin-bottom-lg:    20px;\n$field-margin-bottom-sm:    12px;\n\n$field-bg: \t\t\t\t\t$white;\n$field-bg-disable:\t\t\t$lighter;\n$field-color:               $light-600;\n$field-border-color:        $light-300;\n\n$field-error-color:         $danger;\n$field-error-border-color:  $danger;\n\n$field-placeholder-color:\t$base-300;\n$field-plaintext-color:\t\t$base-color;\n\n$field-border-radius:\t\t$border-radius;\n$field-border-radius-sm:\t$border-radius-sm;\n$field-border-radius-lg:\t$border-radius-lg;\n$field-border-radius-xl:\t$border-radius-lg;\n\n/////////    BUTTONS    /////////////////\n/////////////////////////////////////////\n\n$btn-padding-y:               $field-padding-y;\n$btn-padding-x:               $field-padding-x * 1.125;\n$btn-font-family:             $alt-font-family;\n$btn-font-size:               $fx-sz-13;\n$btn-line-height:             $field-line-height;\n$btn-white-space:             null; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $field-padding-y-sm;\n$btn-padding-x-sm:            $field-padding-x-sm * 0.75;\n$btn-font-size-sm:            $fx-sz-12;\n$btn-line-height-sm:          $field-line-height-sm;\n\n$btn-padding-y-lg:            $field-padding-y-lg;\n$btn-padding-x-lg:            $field-padding-x-lg * 1.5;\n$btn-font-size-lg:            $fx-sz-15;\n$btn-line-height-lg:          $field-line-height-lg;\n\n$btn-padding-y-xl:            $field-padding-y-xl;\n$btn-padding-x-xl:            2rem;\n$btn-font-size-xl:            18px;\n$btn-line-height-xl:          $field-line-height-xl;\n\n$btn-padding-y-xs:            .125rem;\n$btn-padding-x-xs:            .5rem;\n$btn-font-size-xs:            0.6875rem;\n$btn-line-height-xs:          1rem;\n\n$btn-border-width:            $field-border-width;\n\n$btn-font-weight:             $fw-bold;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($darker, .075);\n$btn-focus-width:             $field-focus-width;\n$btn-focus-box-shadow:        $field-focus-box-shadow;\n$btn-disabled-opacity:        .5;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($darker, .125);\n\n$btn-link-disabled-color:     $field-bg-disable;\n\n$btn-block-spacing-y:         .5rem;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $field-border-radius;\n$btn-border-radius-lg:        $field-border-radius-lg;\n$btn-border-radius-sm:        $field-border-radius-sm;\n$btn-border-radius-xs:        3px;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\n\n/////////    FORMS    /////////////////\n///////////////////////////////////////\n\n$input-padding-y:                       $field-padding-y;\n$input-padding-x:                       $field-padding-x;\n$input-font-family:                     $field-font-family;\n$input-font-size:                       $field-font-size;\n$input-font-weight:                     $field-font-weight;\n$input-line-height:                     $field-line-height; \n\n$input-padding-y-sm:                    $field-padding-y-sm;\n$input-padding-x-sm:                    $field-padding-x-sm;\n$input-font-size-sm:                    $field-font-size-sm;\n$input-line-height-sm:                  $field-line-height-sm;\n\n$input-padding-y-lg:                    $field-padding-y-lg;\n$input-padding-x-lg:                    $field-padding-x-lg;\n$input-font-size-lg:                    $field-font-size-lg;\n$input-line-height-lg:                  $field-line-height-lg;\n\n$input-padding-y-xl:                    $field-padding-y-xl;\n$input-padding-x-xl:                    $field-padding-x-xl;\n$input-font-size-xl:                    $field-font-size-xl;\n$input-line-height-xl:                  $field-line-height-xl;\n\n$input-bg:                              $field-bg;\n$input-disabled-bg:                     $field-bg-disable; \n\n$input-color:                           $field-color;\n$input-border-color:                    $field-border-color;\n$input-border-width:                    $field-border-width;\n$input-box-shadow:                      inset 0 1px 1px rgba($darker, .075);\n\n$input-border-radius:                   $field-border-radius;\n$input-border-radius-xl:                $field-border-radius-xl;\n$input-border-radius-lg:                $field-border-radius-lg;\n$input-border-radius-sm:                $field-border-radius-sm;\n\n$input-focus-bg:                        $field-bg;\n$input-focus-border-color:              $field-focus-color;\n$input-focus-color:                     $field-color;\n$input-focus-width:                     $field-focus-width;\n$input-focus-box-shadow:                $field-focus-box-shadow;\n\n$input-error-color:                     $field-color;\n$input-error-border-color:              $field-error-border-color;\n$input-error-focus-box-shadow:          $field-focus-shadow rgba($field-error-border-color, .1);\n\n$input-placeholder-color:               $field-placeholder-color;\n$input-plaintext-color:                 $field-plaintext-color;\n\n$input-height-border:                   $input-border-width * 2;\n\n$input-height-inner:                    $input-line-height + $input-padding-y * 2;\n$input-height-inner-sm:                 $input-line-height-sm + $input-padding-y-sm * 2;\n$input-height-inner-lg:                 $input-line-height-lg + $input-padding-y-lg * 2;\n$input-height-inner-xl:                 $input-line-height-xl + $input-padding-y-xl * 2;\n$input-height-inner-half:               add($input-line-height * .5, $input-padding-y);\n$input-height-inner-quarter:            add($input-line-height * .25, math.div($input-padding-y , 2));\n\n$input-height:                          calc(#{$input-height-inner} + #{$input-height-border});\n$input-height-sm:                       calc(#{$input-height-inner-sm} + #{$input-height-border});\n$input-height-lg:                       calc(#{$input-height-inner-lg} + #{$input-height-border});\n$input-height-xl:                       calc(#{$input-height-inner-xl} + #{$input-height-border});\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\n\n$textarea-min-height:                   122px;\n$textarea-min-height-sm:                92px;\n$textarea-min-height-lg:                208px;\n\n\n/////////    CARDS    ////////////////\n///////////////////////////////////////\n\n$card-spacer-y:                     .75rem;\n$card-spacer-x:                     1.25rem;\n$card-spacer-sm-x:                  1.5rem;\n$card-spacer-large:                 2.5rem;\n\n$card-border-width:                 0;\n$card-border-radius:                $border-radius;\n$card-border-color:                 rgba($black, .125);\n$card-inner-border-radius:          ($card-border-radius - 1);\n$card-cap-bg:                       rgba($black, .07);\n$card-cap-color:                    null;\n$card-color:                        null;\n$card-bg:                           $white;\n\n$card-img-overlay-padding:          1.25rem;\n\n$card-group-margin:                 math.div($gutter-width , 2);\n$card-deck-margin:                  $card-group-margin;\n\n$card-columns-count:                3;\n$card-columns-gap:                  1.25rem;\n$card-columns-margin:               $card-spacer-y;\n\n// IO \n$card-bordered-color: \t\t\t\t$light-300;\n$card-stretch-gap-x: \t\t\t\t$stretch-gap-x;\n\n\n/////////    ALERTS    ////////////////\n///////////////////////////////////////\n\n$alert-padding-y:                   1rem;\n$alert-padding-x:                   1.25rem;\n$alert-margin-bottom:               2rem;\n$alert-border-radius:               $border-radius;\n$alert-link-font-weight:            $fw-bold;\n$alert-border-width:                $border-width;\n\n$alert-bg-level:                    -11;\n$alert-border-level:                -8;\n$alert-color-level:                 2;\n\n// // IO\n$alert-icon-width:\t\t\t\t\t2rem;\n$alert-pro-icon-width:\t\t\t\t2.75rem;\n\n\n/////////    BADGES    ////////////////\n///////////////////////////////////////\n\n$badge-font-size:                   .675rem;\n$badge-line-height:                 1.125rem;\n$badge-font-weight:                 $fw-medium;\n$badge-padding-y:                   0;\n$badge-padding-x:                   .375rem;\n$badge-border-radius:               $border-radius-sm;\n\n$badge-transition:                  $btn-transition;\n$badge-focus-width:                 $field-focus-width;\n\n$badge-pill-padding-x:              .5rem;\n$badge-pill-border-radius:          10rem;\n\n$badge-dot-width:                   6px;\n$badge-dot-gap:                     6px;\n\n$badge-dot-width-sm:                8px;        \n$badge-dot-gap-sm:                  8px;\n\n// IO\n\n$badge-font-size-sm:                   .75rem;\n$badge-padding-y-sm:                   .3125rem;\n$badge-padding-x-sm:                   .75rem;\n$badge-pill-padding-x-sm:              .875rem;\n\n$badge-font-size-md:                   .8125rem;\n$badge-padding-y-md:                   .47rem;\n$badge-padding-x-md:                   1rem;\n\n$badge-font-size-lg:                   .93rem;\n$badge-padding-y-lg:                   .75rem;\n$badge-padding-x-lg:                   1.25rem;\n\n$badge-font-size-xl:                   1.125rem;\n$badge-padding-y-xl:                   .875rem;\n$badge-padding-x-xl:                   1.5rem;\n\n\n\n/////////    BREADCRUMB    ////////////////\n///////////////////////////////////////////\n\n$breadcrumb-font-size:              null;\n\n$breadcrumb-padding-y:              .25rem;\n$breadcrumb-padding-x:              0;\n$breadcrumb-item-padding:           .5rem;\n\n$breadcrumb-margin-bottom:          0;\n\n$breadcrumb-bg:                     transparent;\n$breadcrumb-divider-color:          $light-500;\n$breadcrumb-active-color:           $light-400;\n$breadcrumb-divider:                quote(\"/\");\n\n$breadcrumb-border-radius:          $border-radius;\n\n// IO\n$breadcrumb-font-size:              11px;\n$breadcrumb-font-weight:            500;\n$breadcrumb-font-case:              uppercase;\n$breadcrumb-letter-spacing:         0.05rem;\n$breadcrumb-not-hover-color: \t\t$base-light;\n\n\n\n/////////    DROPDOWNS    /////////////////\n///////////////////////////////////////////\n\n$dropdown-min-width:                180px;\n$dropdown-padding-y:                0;\n$dropdown-spacer:                   .125rem;\n$dropdown-font-size:                13px;\n$dropdown-color:                    $body-color;\n$dropdown-bg:                       $white;\n$dropdown-border-color:             $light-200;\n$dropdown-border-radius:            $border-radius;\n$dropdown-border-width:             $border-width;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width});\n$dropdown-divider-bg:               $light-200;\n$dropdown-divider-margin-y:         12px;\n$dropdown-box-shadow:               0 3px 12px 1px rgba($accent-dark, .15);\n\n$dropdown-link-color:               $base-color;\n$dropdown-link-hover-color:         $accent-color;\n$dropdown-link-hover-bg:            $light-100;\n\n$dropdown-link-active-color:        $accent-color;\n$dropdown-link-active-bg:           $light-300;\n\n$dropdown-link-disabled-color:      $light-100;\n\n$dropdown-item-padding-y:           8px;\n$dropdown-item-padding-x:           14px;\n\n$dropdown-header-color:             $light-500;\n\n// IO\n$dropdown-width-xl:                 360px;\n$dropdown-width-lg:                 320px;\n$dropdown-width-md:                 280px;\n$dropdown-width-sm:                 140px;\n$dropdown-width-xs:                 120px;\n$dropdown-width-xxs:                70px;\n\n\n\n/////////    PAGINATION    ////////////////\n///////////////////////////////////////////\n\n$pagination-padding-y:              .5625rem;\n$pagination-padding-x:              .625rem;\n$pagination-padding-y-sm:           .4375rem;\n$pagination-padding-x-sm:           .5rem;\n$pagination-padding-y-lg:           .5625rem;\n$pagination-padding-x-lg:           .75rem;\n$pagination-padding-y-xl:           .875rem;\n$pagination-padding-x-xl:           .75rem;\n$pagination-line-height:            1rem;\n$pagination-line-height-sm:         .875rem;\n$pagination-line-height-lg:         1.5rem;\n$pagination-line-height-xl:         1.5rem;\n\n$pagination-color:                  $base-text;\n$pagination-bg:                     $white;\n$pagination-border-width:           $border-width;\n$pagination-border-color:           $light-200;\n\n$pagination-focus-box-shadow:       none;\n$pagination-focus-outline:          0;\n\n$pagination-hover-color:            $link-hover-color;\n$pagination-hover-bg:               $light-100;\n$pagination-hover-border-color:     $light-200;\n\n$pagination-active-color:           $white;\n$pagination-active-bg:              $accent-color;\n$pagination-active-border-color:    $pagination-active-bg;\n\n$pagination-disabled-color:         $light-300;\n$pagination-disabled-bg:            $white;\n$pagination-disabled-border-color:  $light-200;\n\n// IO\n$pagination-font-size:              .8125rem;\n\n$tooltip-font-size:                 $fx-sz-13;\n$tooltip-bg:                        $dark;\n$tooltip-border-radius:             $border-radius-sm;\n$tooltip-padding-x:                 .75rem;\n$tooltip-arrow-color:               $tooltip-bg;\n\n\n/////////    Custom Controls    ///////////////\n///////////////////////////////////////\n$checkbox-radio-switch-size:            1.5rem;\n$checkbox-radio-switch-size-sm:         1.125rem;\n$checkbox-radio-switch-size-lg:         2rem;\n$checkbox-radio-switch-border:          2px;\n\n$checkbox-radio-switch-text-gap:        .75rem;\n$checkbox-radio-switch-text-gap-sm:     .5rem;\n$checkbox-radio-switch-text-gap-lg:     1rem;\n\n$checkbox-radio-switch-font-size:       $fx-sz-14;\n$checkbox-radio-switch-font-size-sm:    $fx-sz-12;\n$checkbox-radio-switch-font-size-lg:    $fx-sz-15;\n\n$checkbox-radio-switch-line-height:     1.25rem;\n$checkbox-radio-switch-line-height-sm:  1.125rem;\n$checkbox-radio-switch-line-height-lg:  1.375rem;\n\n$switch-width:                          $checkbox-radio-switch-size * 2;\n$switch-width-sm:                       $checkbox-radio-switch-size-sm * 1.75;\n$switch-width-lg:                       $checkbox-radio-switch-size-lg * 2;\n\n$switch-indicator-border-radius:        math.div($switch-width , 2);\n$switch-indicator-border-radius-sm:     math.div($switch-width-sm , 2);\n$switch-indicator-border-radius-lg:     math.div($switch-width-lg , 2);\n\n$switch-indicator-size:                 1rem;\n$switch-indicator-size-sm:              0.65rem;\n$switch-indicator-size-lg:              1.25rem;\n\n//calc ver\n$switch-border-calc:                    $checkbox-radio-switch-border*2;\n$switch-border-calc-1-5x:               $checkbox-radio-switch-border*3;\n$switch-border-calc-2x:                 $checkbox-radio-switch-border*4;\n$switch-border-calc-3x:                 $checkbox-radio-switch-border*6;\n$switch-indicator-active-clac:          $switch-width - $switch-indicator-size;  \n$switch-indicator-active-clac-sm:       $switch-width-sm - $switch-indicator-size-sm;  \n$switch-indicator-active-clac-lg:       $switch-width-lg - $switch-indicator-size-lg;  \n\n$switch-indicator-active-position:      calc(#{$switch-indicator-active-clac} - #{$switch-border-calc-2x});\n$switch-indicator-active-position-sm:   calc(#{$switch-indicator-active-clac-sm} - #{$switch-border-calc-2x});\n$switch-indicator-active-position-lg:   calc(#{$switch-indicator-active-clac-lg} - #{$switch-border-calc-3x});\n\n$switch-indicator-active-position-right:      calc((-#{$switch-indicator-active-clac} + #{$switch-border-calc-2x}));\n$switch-indicator-active-position-right-sm:      calc((-#{$switch-indicator-active-clac-sm} + #{$switch-border-calc-2x}));\n$switch-indicator-active-position-right-lg:      calc((-#{$switch-indicator-active-clac-lg} + #{$switch-border-calc-3x}));\n\n/////////    Modals    ///////////////\n///////////////////////////////////////\n$modal-fade-transform:              translate(0, -30px);\n$modal-fade-transform-revarse:      translate(0, -10px);\n$modal-show-transform:              none !important;\n$modal-transition:                  transform .3s ease-out;\n$modal-scale-transform:             scale(.95) ;\n\n$modal-inner-padding:               1.25rem;\n$modal-header-padding-y:            1rem;\n$modal-header-padding-x:            $modal-inner-padding;\n\n\n\n$modal-custom-padding:               1.5rem;\n$modal-custom-padding-sm:            1.25rem;\n$modal-custom-padding-md:            2.25rem;\n$modal-custom-padding-lg:            3.75rem;\n\n$modal-body-custom-padding-x:        1.5rem;\n$modal-body-custom-padding-x-sm:     1.25rem;\n$modal-body-custom-padding-x-md:     2.5rem;\n$modal-body-custom-padding-x-lg:     3.75rem;\n\n$modal-header-custom-padding-xy:        1rem $modal-custom-padding;\n$modal-header-custom-padding-xy-sm:     0.75rem $modal-body-custom-padding-x-sm;\n\n$modal-footer-custom-padding-xy:        1rem $modal-custom-padding;\n$modal-footer-custom-padding-xy-sm:     0.75rem $modal-body-custom-padding-x-sm;\n\n\n// $modal-body-padding-md-y:              3.75rem;\n\n// $modal-body-padding-lg-y:              3.75rem;\n\n// $modal-header-padding-md-y:            3.75rem;\n// $modal-header-padding-lg-y:            3.75rem;\n\n// $modal-footer-padding-md-y:            3.75rem;\n// $modal-footer-padding-lg-y:            3.75rem;\n\n\n/////////    LAYOUTS    ///////////////\n///////////////////////////////////////\n\n$min-body-width:                    320px;\n\n// Logo\n$logo-height:                       45px;\n$logo-height-sm:                    28px;\n$logo-height-lg:                    60px;\n$logo-height-icon:                  33px;\n\n// Sidebar\n$sidebar-width-normal:              260px;\n$sidebar-width-compact:             74px;\n$sidebar-gap-x:                     24px;\n\n$sidebar-width-fat:                 400px;\n$sidebar-width-fat-tablet:          340px;\n$sidebar-gap-x-fat:                 32px;\n$sidebar-gap-x-fat-tablet:          16px;\n$sidebar-fat-transition-name:       ease;\n$sidebar-fat-transition-duration:   450ms;\n\n// Apps Sidebar\n$sidebar-width-apps:                 80px;\n$sidebar-gap-x-apps:                 24px;\n$sidebar-apps-transition-name:       ease;\n$sidebar-apps-transition-duration:   450ms;\n\n$sidebar-transition-name:           ease;\n$sidebar-transition-duration:       450ms;\n$sidebar-overlay:                   rgba($darker,.4); \n\n$sidebar-bg-color:\t\t\t\t\t$lighter;\n$sidebar-border-color:              $light-200;\n\n$sidebar-bg-dark-color:\t\t\t    $darker;\n$sidebar-border-dark-color:         lighten($sidebar-bg-dark-color, 10%);\n\n$sidebar-bg-theme-color:\t\t\tdarken($accent-dark,2%);\n$sidebar-border-theme-color:\t\tlighten($sidebar-bg-theme-color, 10%);\n\n$sidebar-bg-light-color:            $white;\n$sidebar-border-light-color:        $light;\n\n$sidebar-toogle-btn-color:\t\t\t$base-500;\n\n// Content\n$content-gap-x:                     20px - math.div($gutter-width,2);\n$content-gap-x-sm:                  36px - math.div($gutter-width,2);\n$content-gap-y:                     24px;\n$content-sidebar-width:             280px;\n\n$content-sidebar-bg-color:\t\t\t$white;\n$content-sidebar-border-color:\t\t$border-light;\n\n// // Content\n\n// // Headers\n$header-main-gap-x:                 $content-gap-x;\n$header-main-gap-x-sm:              $content-gap-x-sm; \n$header-main-gap-y:                 14px;\n$header-main-border-width:          1px;\n$header-height:                     ($header-main-gap-y*2 + $logo-height + $header-main-border-width);\n$header-min-width:                  $min-body-width; \n\n$header-bg-color:                   $lighter;\n$header-bg-dark-color:              $darker;\n$header-bg-theme-color:             darken($accent-dark,2%); \n$header-border-bottom:\t\t\t\t$border-light;\n$header-border-dark-bottom:\t\t    lighten($header-bg-dark-color, 10%);\n$header-border-theme-bottom:\t\tlighten($header-bg-theme-color, 10%);\n$header-toogle-btn-color:\t\t\t$base-500;\n$header-toogle-btn-focus-color:\t\t$accent-color;\n$header-toogle-btn-border:\t\t\t$btn-border-width solid transparent;\n$header-toogle-btn-lh:\t\t\t\t$btn-line-height-sm;\n\n$header-toogle-btn-icon-width:\t\t$btn-line-height-sm + $btn-padding-y-sm*2;\n\n$header-col-width-small:            120px;\n$header-col-width-safe:             math.div($header-col-width-small,2);\n$header-col-width:                  calc(50% - #{$header-col-width-safe});\n\n//Footer\n$footer-main-gap-x:                 $content-gap-x;\n$footer-main-gap-x-sm:              $content-gap-x-sm; \n$footer-main-gap-y:                 20px;\n$footer-main-border-width:          1px;\n$footer-min-width:                  $min-body-width; \n\n$footer-bg-color:                   $white;\n$footer-bg-dark-color:              darken($accent-dark,1%);\n$footer-border-bottom:\t\t\t\t$border-light;\n\n\n// Aside\n$aside-bg:                          $white;\n$aside-content-body-height-calc:    ($content-gap-y + 8 + $header-height);\n\n\n$menu-icon-width:                   36px;\n$menu-icon-width-sm:                32px;\n\n\n//////  CONFIGURATION VARIABLE  //////\n$dark_option:           true;\n$dark_theme_option:     true;\n$gd_investment:         true;\n\n///////////////////////////////////////////////\n\n/////////    THIRD-PARTY VARIABLE    //////////\n///////////////////////////////////////////////\n$nk-dashlite-font: \"Nioicon\";\n$nk-dashlite-font-url: \"../../../fonts\";\n@import \"vendors/nioicon/variables\";","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n\n$grays: () !default;\n$grays: map-merge(\n  (\n    \"100\": $gray-100,\n    \"200\": $gray-200,\n    \"300\": $gray-300,\n    \"400\": $gray-400,\n    \"500\": $gray-500,\n    \"600\": $gray-600,\n    \"700\": $gray-700,\n    \"800\": $gray-800,\n    \"900\": $gray-900\n  ),\n  $grays\n);\n\n$blue:    #007bff !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #e83e8c !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #28a745 !default;\n$teal:    #20c997 !default;\n$cyan:    #17a2b8 !default;\n\n$colors: () !default;\n$colors: map-merge(\n  (\n    \"blue\":       $blue,\n    \"indigo\":     $indigo,\n    \"purple\":     $purple,\n    \"pink\":       $pink,\n    \"red\":        $red,\n    \"orange\":     $orange,\n    \"yellow\":     $yellow,\n    \"green\":      $green,\n    \"teal\":       $teal,\n    \"cyan\":       $cyan,\n    \"white\":      $white,\n    \"gray\":       $gray-600,\n    \"gray-dark\":  $gray-800\n  ),\n  $colors\n);\n\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-800 !default;\n\n$theme-colors: () !default;\n$theme-colors: map-merge(\n  (\n    \"primary\":    $primary,\n    \"secondary\":  $secondary,\n    \"success\":    $success,\n    \"info\":       $info,\n    \"warning\":    $warning,\n    \"danger\":     $danger,\n    \"light\":      $light,\n    \"dark\":       $dark\n  ),\n  $theme-colors\n);\n\n// Set a specific jump point for requesting color jumps\n$theme-color-interval:      8% !default;\n\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\n$yiq-contrasted-threshold:  150 !default;\n\n// Customize the light and dark text colors for use in our YIQ color contrast function.\n$yiq-text-dark:             $gray-900 !default;\n$yiq-text-light:            $white !default;\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                                true !default;\n$enable-rounded:                              true !default;\n$enable-shadows:                              false !default;\n$enable-gradients:                            false !default;\n$enable-transitions:                          true !default;\n$enable-prefers-reduced-motion-media-query:   true !default;\n$enable-hover-media-query:                    false !default; // Deprecated, no longer affects any compiled CSS\n$enable-grid-classes:                         true !default;\n$enable-pointer-cursor-for-buttons:           true !default;\n$enable-print-styles:                         true !default;\n$enable-responsive-font-sizes:                false !default;\n$enable-validation-icons:                     true !default;\n$enable-deprecation-messages:                 true !default;\n\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n$spacer: 1rem !default;\n$spacers: () !default;\n$spacers: map-merge(\n  (\n    0: 0,\n    1: ($spacer * .25),\n    2: ($spacer * .5),\n    3: $spacer,\n    4: ($spacer * 1.5),\n    5: ($spacer * 3)\n  ),\n  $spacers\n);\n\n// This variable affects the `.h-*` and `.w-*` classes.\n$sizes: () !default;\n$sizes: map-merge(\n  (\n    25: 25%,\n    50: 50%,\n    75: 75%,\n    100: 100%,\n    auto: auto\n  ),\n  $sizes\n);\n\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              theme-color(\"primary\") !default;\n$link-decoration:                         none !default;\n$link-hover-color:                        darken($link-color, 15%) !default;\n$link-hover-decoration:                   underline !default;\n// Darken percentage for links with `.text-*` class (e.g. `.text-success`)\n$emphasized-link-hover-darken-percentage: 15% !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px\n) !default;\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px\n) !default;\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           30px !default;\n$grid-row-columns:            6 !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$line-height-lg:              1.5 !default;\n$line-height-sm:              1.5 !default;\n\n$border-width:                1px !default;\n$border-color:                $gray-300 !default;\n\n$border-radius:               .25rem !default;\n$border-radius-lg:            .3rem !default;\n$border-radius-sm:            .2rem !default;\n\n$rounded-pill:                50rem !default;\n\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n\n$component-active-color:      $white !default;\n$component-active-bg:         theme-color(\"primary\") !default;\n\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n\n$embed-responsive-aspect-ratios: () !default;\n$embed-responsive-aspect-ratios: join(\n  (\n    (21 9),\n    (16 9),\n    (4 3),\n    (1 1),\n  ),\n  $embed-responsive-aspect-ratios\n);\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n$font-family-base:            $font-family-sans-serif !default;\n// stylelint-enable value-keyword-case\n\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-lg:                $font-size-base * 1.25 !default;\n$font-size-sm:                $font-size-base * .875 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n$line-height-base:            1.5 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              null !default;\n\n$display1-size:               6rem !default;\n$display2-size:               5.5rem !default;\n$display3-size:               4.5rem !default;\n$display4-size:               3.5rem !default;\n\n$display1-weight:             300 !default;\n$display2-weight:             300 !default;\n$display3-weight:             300 !default;\n$display4-weight:             300 !default;\n$display-line-height:         $headings-line-height !default;\n\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$text-muted:                  $gray-600 !default;\n\n$blockquote-small-color:      $gray-600 !default;\n$blockquote-small-font-size:  $small-font-size !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n\n$hr-border-color:             rgba($black, .1) !default;\n$hr-border-width:             $border-width !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$kbd-box-shadow:              inset 0 -.1rem 0 rgba($black, .25) !default;\n$nested-kbd-font-weight:      $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n\n$hr-margin-y:                 $spacer !default;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n$table-cell-padding:          .75rem !default;\n$table-cell-padding-sm:       .3rem !default;\n\n$table-color:                 $body-color !default;\n$table-bg:                    null !default;\n$table-accent-bg:             rgba($black, .05) !default;\n$table-hover-color:           $table-color !default;\n$table-hover-bg:              rgba($black, .075) !default;\n$table-active-bg:             $table-hover-bg !default;\n\n$table-border-width:          $border-width !default;\n$table-border-color:          $border-color !default;\n\n$table-head-bg:               $gray-200 !default;\n$table-head-color:            $gray-700 !default;\n$table-th-font-weight:        null !default;\n\n$table-dark-color:            $white !default;\n$table-dark-bg:               $gray-800 !default;\n$table-dark-accent-bg:        rgba($white, .05) !default;\n$table-dark-hover-color:      $table-dark-color !default;\n$table-dark-hover-bg:         rgba($white, .075) !default;\n$table-dark-border-color:     lighten($table-dark-bg, 7.5%) !default;\n\n$table-striped-order:         odd !default;\n\n$table-caption-color:         $text-muted !default;\n\n$table-bg-level:              -9 !default;\n$table-border-level:          -6 !default;\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:       .2rem !default;\n$input-btn-focus-color:       rgba($component-active-bg, .25) !default;\n$input-btn-focus-box-shadow:  0 0 0 $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n$input-btn-line-height-sm:    $line-height-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n$input-btn-line-height-lg:    $line-height-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n$btn-line-height-sm:          $input-btn-line-height-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n$btn-line-height-lg:          $input-btn-line-height-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-disabled-color:     $gray-600 !default;\n\n$btn-block-spacing-y:         .5rem !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n\n// Forms\n\n$label-margin-bottom:                   .5rem !default;\n\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n$input-line-height-sm:                  $input-btn-line-height-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n$input-line-height-lg:                  $input-btn-line-height-lg !default;\n\n$input-bg:                              $white !default;\n$input-disabled-bg:                     $gray-200 !default;\n\n$input-color:                           $gray-700 !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      inset 0 1px 1px rgba($black, .075) !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              lighten($component-active-bg, 25%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height-sm * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height-lg * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-text-margin-top:                  .25rem !default;\n\n$form-check-input-gutter:               1.25rem !default;\n$form-check-input-margin-y:             .3rem !default;\n$form-check-input-margin-x:             .25rem !default;\n\n$form-check-inline-margin-x:            .75rem !default;\n$form-check-inline-input-margin-x:      .3125rem !default;\n\n$form-grid-gutter-width:                10px !default;\n$form-group-margin-bottom:              1rem !default;\n\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n\n$custom-forms-transition:               background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$custom-control-gutter:                 .5rem !default;\n$custom-control-spacer-x:               1rem !default;\n$custom-control-cursor:                 null !default;\n\n$custom-control-indicator-size:         1rem !default;\n$custom-control-indicator-bg:           $input-bg !default;\n\n$custom-control-indicator-bg-size:      50% 50% !default;\n$custom-control-indicator-box-shadow:   $input-box-shadow !default;\n$custom-control-indicator-border-color: $gray-500 !default;\n$custom-control-indicator-border-width: $input-border-width !default;\n\n$custom-control-label-color:            null !default;\n\n$custom-control-indicator-disabled-bg:          $input-disabled-bg !default;\n$custom-control-label-disabled-color:           $gray-600 !default;\n\n$custom-control-indicator-checked-color:        $component-active-color !default;\n$custom-control-indicator-checked-bg:           $component-active-bg !default;\n$custom-control-indicator-checked-disabled-bg:  rgba(theme-color(\"primary\"), .5) !default;\n$custom-control-indicator-checked-box-shadow:   null !default;\n$custom-control-indicator-checked-border-color: $custom-control-indicator-checked-bg !default;\n\n$custom-control-indicator-focus-box-shadow:     $input-focus-box-shadow !default;\n$custom-control-indicator-focus-border-color:   $input-focus-border-color !default;\n\n$custom-control-indicator-active-color:         $component-active-color !default;\n$custom-control-indicator-active-bg:            lighten($component-active-bg, 35%) !default;\n$custom-control-indicator-active-box-shadow:    null !default;\n$custom-control-indicator-active-border-color:  $custom-control-indicator-active-bg !default;\n\n$custom-checkbox-indicator-border-radius:       $border-radius !default;\n$custom-checkbox-indicator-icon-checked:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/></svg>\") !default;\n\n$custom-checkbox-indicator-indeterminate-bg:           $component-active-bg !default;\n$custom-checkbox-indicator-indeterminate-color:        $custom-control-indicator-checked-color !default;\n$custom-checkbox-indicator-icon-indeterminate:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'><path stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/></svg>\") !default;\n$custom-checkbox-indicator-indeterminate-box-shadow:   null !default;\n$custom-checkbox-indicator-indeterminate-border-color: $custom-checkbox-indicator-indeterminate-bg !default;\n\n$custom-radio-indicator-border-radius:          50% !default;\n$custom-radio-indicator-icon-checked:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'><circle r='3' fill='#{$custom-control-indicator-checked-color}'/></svg>\") !default;\n\n$custom-switch-width:                           $custom-control-indicator-size * 1.75 !default;\n$custom-switch-indicator-border-radius:         $custom-control-indicator-size * .5 !default;\n$custom-switch-indicator-size:                  subtract($custom-control-indicator-size, $custom-control-indicator-border-width * 4) !default;\n\n$custom-select-padding-y:           $input-padding-y !default;\n$custom-select-padding-x:           $input-padding-x !default;\n$custom-select-font-family:         $input-font-family !default;\n$custom-select-font-size:           $input-font-size !default;\n$custom-select-height:              $input-height !default;\n$custom-select-indicator-padding:   1rem !default; // Extra padding to account for the presence of the background-image based indicator\n$custom-select-font-weight:         $input-font-weight !default;\n$custom-select-line-height:         $input-line-height !default;\n$custom-select-color:               $input-color !default;\n$custom-select-disabled-color:      $gray-600 !default;\n$custom-select-bg:                  $input-bg !default;\n$custom-select-disabled-bg:         $gray-200 !default;\n$custom-select-bg-size:             8px 10px !default; // In pixels because image dimensions\n$custom-select-indicator-color:     $gray-800 !default;\n$custom-select-indicator:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'><path fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>\") !default;\n$custom-select-background:          escape-svg($custom-select-indicator) right $custom-select-padding-x center / $custom-select-bg-size no-repeat !default; // Used so we can have multiple background elements (e.g., arrow and feedback icon)\n\n$custom-select-feedback-icon-padding-right: add(1em * .75, (2 * $custom-select-padding-y * .75) + $custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-position:      center right ($custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-size:          $input-height-inner-half $input-height-inner-half !default;\n\n$custom-select-border-width:        $input-border-width !default;\n$custom-select-border-color:        $input-border-color !default;\n$custom-select-border-radius:       $border-radius !default;\n$custom-select-box-shadow:          inset 0 1px 2px rgba($black, .075) !default;\n\n$custom-select-focus-border-color:  $input-focus-border-color !default;\n$custom-select-focus-width:         $input-focus-width !default;\n$custom-select-focus-box-shadow:    0 0 0 $custom-select-focus-width $input-btn-focus-color !default;\n\n$custom-select-padding-y-sm:        $input-padding-y-sm !default;\n$custom-select-padding-x-sm:        $input-padding-x-sm !default;\n$custom-select-font-size-sm:        $input-font-size-sm !default;\n$custom-select-height-sm:           $input-height-sm !default;\n\n$custom-select-padding-y-lg:        $input-padding-y-lg !default;\n$custom-select-padding-x-lg:        $input-padding-x-lg !default;\n$custom-select-font-size-lg:        $input-font-size-lg !default;\n$custom-select-height-lg:           $input-height-lg !default;\n\n$custom-range-track-width:          100% !default;\n$custom-range-track-height:         .5rem !default;\n$custom-range-track-cursor:         pointer !default;\n$custom-range-track-bg:             $gray-300 !default;\n$custom-range-track-border-radius:  1rem !default;\n$custom-range-track-box-shadow:     inset 0 .25rem .25rem rgba($black, .1) !default;\n\n$custom-range-thumb-width:                   1rem !default;\n$custom-range-thumb-height:                  $custom-range-thumb-width !default;\n$custom-range-thumb-bg:                      $component-active-bg !default;\n$custom-range-thumb-border:                  0 !default;\n$custom-range-thumb-border-radius:           1rem !default;\n$custom-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$custom-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$custom-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in IE/Edge\n$custom-range-thumb-active-bg:               lighten($component-active-bg, 35%) !default;\n$custom-range-thumb-disabled-bg:             $gray-500 !default;\n\n$custom-file-height:                $input-height !default;\n$custom-file-height-inner:          $input-height-inner !default;\n$custom-file-focus-border-color:    $input-focus-border-color !default;\n$custom-file-focus-box-shadow:      $input-focus-box-shadow !default;\n$custom-file-disabled-bg:           $input-disabled-bg !default;\n\n$custom-file-padding-y:             $input-padding-y !default;\n$custom-file-padding-x:             $input-padding-x !default;\n$custom-file-line-height:           $input-line-height !default;\n$custom-file-font-family:           $input-font-family !default;\n$custom-file-font-weight:           $input-font-weight !default;\n$custom-file-color:                 $input-color !default;\n$custom-file-bg:                    $input-bg !default;\n$custom-file-border-width:          $input-border-width !default;\n$custom-file-border-color:          $input-border-color !default;\n$custom-file-border-radius:         $input-border-radius !default;\n$custom-file-box-shadow:            $input-box-shadow !default;\n$custom-file-button-color:          $custom-file-color !default;\n$custom-file-button-bg:             $input-group-addon-bg !default;\n$custom-file-text: (\n  en: \"Browse\"\n) !default;\n\n\n// Form validation\n\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $small-font-size !default;\n$form-feedback-valid-color:         theme-color(\"success\") !default;\n$form-feedback-invalid-color:       theme-color(\"danger\") !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}' viewBox='0 0 12 12'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n\n$form-validation-states: () !default;\n$form-validation-states: map-merge(\n  (\n    \"valid\": (\n      \"color\": $form-feedback-valid-color,\n      \"icon\": $form-feedback-icon-valid\n    ),\n    \"invalid\": (\n      \"color\": $form-feedback-invalid-color,\n      \"icon\": $form-feedback-icon-invalid\n    ),\n  ),\n  $form-validation-states\n);\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-modal-backdrop:             1040 !default;\n$zindex-modal:                      1050 !default;\n$zindex-popover:                    1060 !default;\n$zindex-tooltip:                    1070 !default;\n\n\n// Navs\n\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-divider-color:                 $gray-200 !default;\n$nav-divider-margin-y:              $spacer * .5 !default;\n\n\n// Navbar\n\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  $spacer !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n\n$navbar-nav-scroll-max-height:      75vh !default;\n\n$navbar-dark-color:                 rgba($white, .5) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n$navbar-light-color:                rgba($black, .5) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n$navbar-light-brand-color:                $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:          $navbar-light-active-color !default;\n$navbar-dark-brand-color:                 $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    $body-color !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             rgba($black, .15) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n$dropdown-divider-bg:               $gray-200 !default;\n$dropdown-divider-margin-y:         $nav-divider-margin-y !default;\n$dropdown-box-shadow:               0 .5rem 1rem rgba($black, .175) !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         darken($gray-900, 5%) !default;\n$dropdown-link-hover-bg:            $gray-200 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-500 !default;\n\n$dropdown-item-padding-y:           .25rem !default;\n$dropdown-item-padding-x:           1.5rem !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x !default;\n\n\n// Pagination\n\n$pagination-padding-y:              .5rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n$pagination-line-height:            1.25 !default;\n\n$pagination-color:                  $link-color !default;\n$pagination-bg:                     $white !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            $link-hover-color !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n$pagination-border-radius-sm:       $border-radius-sm !default;\n$pagination-border-radius-lg:       $border-radius-lg !default;\n\n\n// Jumbotron\n\n$jumbotron-padding:                 2rem !default;\n$jumbotron-color:                   null !default;\n$jumbotron-bg:                      $gray-200 !default;\n\n\n// Cards\n\n$card-spacer-y:                     .75rem !default;\n$card-spacer-x:                     1.25rem !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius !default;\n$card-border-color:                 rgba($black, .125) !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n\n$card-img-overlay-padding:          1.25rem !default;\n\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n$card-deck-margin:                  $card-group-margin !default;\n\n$card-columns-count:                3 !default;\n$card-columns-gap:                  1.25rem !default;\n$card-columns-margin:               $card-spacer-y !default;\n\n\n// Tooltips\n\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $white !default;\n$tooltip-bg:                        $black !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 .25rem !default;\n$tooltip-padding-x:                 .5rem !default;\n$tooltip-margin:                    0 !default;\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n$tooltip-arrow-color:               $tooltip-bg !default;\n\n// Form tooltips must come after regular tooltips\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   $line-height-base !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n\n\n// Popovers\n\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              $border-width !default;\n$popover-border-color:              rgba($black, .2) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width) !default;\n$popover-box-shadow:                0 .25rem .5rem rgba($black, .2) !default;\n\n$popover-header-bg:                 darken($popover-bg, 3%) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          .75rem !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $popover-header-padding-y !default;\n$popover-body-padding-x:            $popover-header-padding-x !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n$popover-arrow-color:               $popover-bg !default;\n\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05) !default;\n\n\n// Toasts\n\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .25rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba($white, .85) !default;\n$toast-border-width:                1px !default;\n$toast-border-color:                rgba(0, 0, 0, .1) !default;\n$toast-border-radius:               .25rem !default;\n$toast-box-shadow:                  0 .25rem .75rem rgba($black, .1) !default;\n\n$toast-header-color:                $gray-600 !default;\n$toast-header-background-color:     rgba($white, .85) !default;\n$toast-header-border-color:         rgba(0, 0, 0, .05) !default;\n\n\n// Badges\n\n$badge-font-size:                   75% !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-padding-y:                   .25em !default;\n$badge-padding-x:                   .4em !default;\n$badge-border-radius:               $border-radius !default;\n\n$badge-transition:                  $btn-transition !default;\n$badge-focus-width:                 $input-btn-focus-width !default;\n\n$badge-pill-padding-x:              .6em !default;\n// Use a higher than normal value to ensure completely rounded edges when\n// customizing padding or font-size on labels.\n$badge-pill-border-radius:          10rem !default;\n\n\n// Modals\n\n// Padding applied to the modal body\n$modal-inner-padding:               1rem !default;\n\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       0 .25rem .5rem rgba($black, .5) !default;\n$modal-content-box-shadow-sm-up:    0 .5rem 1rem rgba($black, .5) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n$modal-header-border-color:         $border-color !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n$modal-header-padding-y:            1rem !default;\n$modal-header-padding-x:            1rem !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-xl:                          1140px !default;\n$modal-lg:                          800px !default;\n$modal-md:                          500px !default;\n$modal-sm:                          300px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n$alert-padding-y:                   .75rem !default;\n$alert-padding-x:                   1.25rem !default;\n$alert-margin-bottom:               1rem !default;\n$alert-border-radius:               $border-radius !default;\n$alert-link-font-weight:            $font-weight-bold !default;\n$alert-border-width:                $border-width !default;\n\n$alert-bg-level:                    -10 !default;\n$alert-border-level:                -9 !default;\n$alert-color-level:                 6 !default;\n\n\n// Progress bars\n\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               inset 0 .1rem .1rem rgba($black, .1) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   theme-color(\"primary\") !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n\n\n// List group\n\n$list-group-color:                  null !default;\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         .75rem !default;\n$list-group-item-padding-x:         1.25rem !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n\n\n// Image thumbnails\n\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            $gray-300 !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              0 1px 2px rgba($black, .075) !default;\n\n\n// Figures\n\n$figure-caption-font-size:          90% !default;\n$figure-caption-color:              $gray-600 !default;\n\n\n// Breadcrumbs\n\n$breadcrumb-font-size:              null !default;\n\n$breadcrumb-padding-y:              .75rem !default;\n$breadcrumb-padding-x:              1rem !default;\n$breadcrumb-item-padding:           .5rem !default;\n\n$breadcrumb-margin-bottom:          1rem !default;\n\n$breadcrumb-bg:                     $gray-200 !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n\n$breadcrumb-border-radius:          $border-radius !default;\n\n\n// Carousel\n\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n\n$carousel-control-icon-width:        20px !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n\n// Spinners\n\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n\n\n// Close\n\n$close-font-size:                   $font-size-base * 1.5 !default;\n$close-font-weight:                 $font-weight-bold !default;\n$close-color:                       $black !default;\n$close-text-shadow:                 0 1px 0 $white !default;\n\n\n// Code\n\n$code-font-size:                    87.5% !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .2rem !default;\n$kbd-padding-x:                     .4rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         $white !default;\n$kbd-bg:                            $gray-900 !default;\n\n$pre-color:                         $gray-900 !default;\n$pre-scrollable-max-height:         340px !default;\n\n\n// Utilities\n\n$displays: none, inline, inline-block, block, table, table-row, table-cell, flex, inline-flex !default;\n$overflows: auto, hidden !default;\n$positions: static, relative, absolute, fixed, sticky !default;\n$user-selects: all, auto, none !default;\n\n\n// Printing\n\n$print-page-size:                   a3 !default;\n$print-body-min-width:              map-get($grid-breakpoints, \"lg\") !default;\n","// Hover mixin and `$enable-hover-media-query` are deprecated.\n//\n// Originally added during our alphas and maintained during betas, this mixin was\n// designed to prevent `:hover` stickiness on iOS-an issue where hover styles\n// would persist after initial touch.\n//\n// For backward compatibility, we've kept these mixins and updated them to\n// always return their regular pseudo-classes instead of a shimmed media query.\n//\n// Issue: https://github.com/twbs/bootstrap/issues/25195\n\n@mixin hover() {\n  &:hover { @content; }\n}\n\n@mixin hover-focus() {\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin plain-hover-focus() {\n  &,\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin hover-focus-active() {\n  &:hover,\n  &:focus,\n  &:active {\n    @content;\n  }\n}\n","// stylelint-disable declaration-no-important, selector-list-comma-newline-after\n\n//\n// Headings\n//\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1, .h1 { @include font-size($h1-font-size); }\nh2, .h2 { @include font-size($h2-font-size); }\nh3, .h3 { @include font-size($h3-font-size); }\nh4, .h4 { @include font-size($h4-font-size); }\nh5, .h5 { @include font-size($h5-font-size); }\nh6, .h6 { @include font-size($h6-font-size); }\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n.display-1 {\n  @include font-size($display1-size);\n  font-weight: $display1-weight;\n  line-height: $display-line-height;\n}\n.display-2 {\n  @include font-size($display2-size);\n  font-weight: $display2-weight;\n  line-height: $display-line-height;\n}\n.display-3 {\n  @include font-size($display3-size);\n  font-weight: $display3-weight;\n  line-height: $display-line-height;\n}\n.display-4 {\n  @include font-size($display4-size);\n  font-weight: $display4-weight;\n  line-height: $display-line-height;\n}\n\n\n//\n// Horizontal rules\n//\n\nhr {\n  margin-top: $hr-margin-y;\n  margin-bottom: $hr-margin-y;\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n}\n\n\n//\n// Emphasis\n//\n\nsmall,\n.small {\n  @include font-size($small-font-size);\n  font-weight: $font-weight-normal;\n}\n\nmark,\n.mark {\n  padding: $mark-padding;\n  background-color: $mark-bg;\n}\n\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size(90%);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $spacer;\n  @include font-size($blockquote-font-size);\n}\n\n.blockquote-footer {\n  display: block;\n  @include font-size($blockquote-small-font-size);\n  color: $blockquote-small-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled() {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid() {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n\n\n// Retina image\n//\n// Short retina mixin for setting background-image and -size.\n\n@mixin img-retina($file-1x, $file-2x, $width-1x, $height-1x) {\n  background-image: url($file-1x);\n\n  // Autoprefixer takes care of adding -webkit-min-device-pixel-ratio and -o-min-device-pixel-ratio,\n  // but doesn't convert dppx=>dpi.\n  // There's no such thing as unprefixed min-device-pixel-ratio since it's nonstandard.\n  // Compatibility info: https://caniuse.com/css-media-resolution\n  @media only screen and (min-resolution: 192dpi), // IE9-11 don't support dppx\n    only screen and (min-resolution: 2dppx) { // Standardized\n    background-image: url($file-2x);\n    background-size: $width-1x $height-1x;\n  }\n  @include deprecate(\"`img-retina()`\", \"v4.3.0\", \"v5\");\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-right-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-left-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n","// Inline code\ncode {\n  @include font-size($code-font-size);\n  color: $code-color;\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\n// User input typically entered via keyboard\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n  @include box-shadow($kbd-box-shadow);\n\n  kbd {\n    padding: 0;\n    @include font-size(100%);\n    font-weight: $nested-kbd-font-weight;\n    @include box-shadow(none);\n  }\n}\n\n// Blocks of code\npre {\n  display: block;\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\n// Enable scrollable blocks of code\n.pre-scrollable {\n  max-height: $pre-scrollable-max-height;\n  overflow-y: scroll;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-grid-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n  }\n\n  // Remove the negative margin from default .row, then the horizontal padding\n  // from all immediate children columns (to prevent runaway style inheritance).\n  .no-gutters {\n    margin-right: 0;\n    margin-left: 0;\n\n    > .col,\n    > [class*=\"col-\"] {\n      padding-right: 0;\n      padding-left: 0;\n    }\n  }\n}\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","/// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-container($gutter: $grid-gutter-width) {\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$gutter * .5;\n  margin-left: -$gutter * .5;\n}\n\n// For each breakpoint, define the maximum width of the container in a media query\n@mixin make-container-max-widths($max-widths: $container-max-widths, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint, $container-max-width in $max-widths {\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      max-width: $container-max-width;\n    }\n  }\n  @include deprecate(\"The `make-container-max-widths` mixin\", \"v4.5.2\", \"v5\");\n}\n\n@mixin make-col-ready($gutter: $grid-gutter-width) {\n  position: relative;\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we use `flex` values\n  // later on to override this initial width.\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n}\n\n@mixin make-col($size, $columns: $grid-columns) {\n  flex: 0 0 percentage(divide($size, $columns));\n  // Add a `max-width` to ensure content within each column does not blow out\n  // the width of the column. Applies to IE10+ and Firefox. Chrome and Safari\n  // do not appear to require this.\n  max-width: percentage(divide($size, $columns));\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%; // Reset earlier grid tiers\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// numberof columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 divide(100%, $count);\n    max-width: divide(100%, $count);\n  }\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n != null and $n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $max: breakpoint-max($name, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($name, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  // Common properties for all breakpoints\n  %grid-column {\n    position: relative;\n    width: 100%;\n    padding-right: $gutter * .5;\n    padding-left: $gutter * .5;\n  }\n\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @if $columns > 0 {\n      // Allow columns to stretch full width below their breakpoints\n      @for $i from 1 through $columns {\n        .col#{$infix}-#{$i} {\n          @extend %grid-column;\n        }\n      }\n    }\n\n    .col#{$infix},\n    .col#{$infix}-auto {\n      @extend %grid-column;\n    }\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%;\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n      }\n\n      .order#{$infix}-first { order: -1; }\n\n      .order#{$infix}-last { order: $columns + 1; }\n\n      @for $i from 0 through $columns {\n        .order#{$infix}-#{$i} { order: $i; }\n      }\n\n      @if $columns > 0 {\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  width: 100%;\n  margin-bottom: $spacer;\n  color: $table-color;\n  background-color: $table-bg; // Reset for nesting within parents with `background-color`.\n\n  th,\n  td {\n    padding: $table-cell-padding;\n    vertical-align: top;\n    border-top: $table-border-width solid $table-border-color;\n  }\n\n  thead th {\n    vertical-align: bottom;\n    border-bottom: (2 * $table-border-width) solid $table-border-color;\n  }\n\n  tbody + tbody {\n    border-top: (2 * $table-border-width) solid $table-border-color;\n  }\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  th,\n  td {\n    padding: $table-cell-padding-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n\n.table-bordered {\n  border: $table-border-width solid $table-border-color;\n\n  th,\n  td {\n    border: $table-border-width solid $table-border-color;\n  }\n\n  thead {\n    th,\n    td {\n      border-bottom-width: 2 * $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  th,\n  td,\n  thead th,\n  tbody + tbody {\n    border: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n.table-striped {\n  tbody tr:nth-of-type(#{$table-striped-order}) {\n    background-color: $table-accent-bg;\n  }\n}\n\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  tbody tr {\n    @include hover() {\n      color: $table-hover-color;\n      background-color: $table-hover-bg;\n    }\n  }\n}\n\n\n// Table backgrounds\n//\n// Exact selectors below required to override `.table-striped` and prevent\n// inheritance to nested tables.\n\n@each $color, $value in $theme-colors {\n  @include table-row-variant($color, theme-color-level($color, $table-bg-level), theme-color-level($color, $table-border-level));\n}\n\n@include table-row-variant(active, $table-active-bg);\n\n\n// Dark styles\n//\n// Same table markup, but inverted color scheme: dark background and light text.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.table {\n  .thead-dark {\n    th {\n      color: $table-dark-color;\n      background-color: $table-dark-bg;\n      border-color: $table-dark-border-color;\n    }\n  }\n\n  .thead-light {\n    th {\n      color: $table-head-color;\n      background-color: $table-head-bg;\n      border-color: $table-border-color;\n    }\n  }\n}\n\n.table-dark {\n  color: $table-dark-color;\n  background-color: $table-dark-bg;\n\n  th,\n  td,\n  thead th {\n    border-color: $table-dark-border-color;\n  }\n\n  &.table-bordered {\n    border: 0;\n  }\n\n  &.table-striped {\n    tbody tr:nth-of-type(#{$table-striped-order}) {\n      background-color: $table-dark-accent-bg;\n    }\n  }\n\n  &.table-hover {\n    tbody tr {\n      @include hover() {\n        color: $table-dark-hover-color;\n        background-color: $table-dark-hover-bg;\n      }\n    }\n  }\n}\n\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n.table-responsive {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n\n        // Prevent double border on horizontal scroll due to use of `display: block;`\n        > .table-bordered {\n          border: 0;\n        }\n      }\n    }\n  }\n}\n","// Tables\n\n@mixin table-row-variant($state, $background, $border: null) {\n  // Exact selectors below required to override `.table-striped` and prevent\n  // inheritance to nested tables.\n  .table-#{$state} {\n    &,\n    > th,\n    > td {\n      background-color: $background;\n    }\n\n    @if $border != null {\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $border;\n      }\n    }\n  }\n\n  // Hover states for `.table-hover`\n  // Note: this is not available for cells or rows within `thead` or `tfoot`.\n  .table-hover {\n    $hover-background: darken($background, 5%);\n\n    .table-#{$state} {\n      @include hover() {\n        background-color: $hover-background;\n\n        > td,\n        > th {\n          background-color: $hover-background;\n        }\n      }\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Textual form controls\n//\n@use 'sass:math';\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: $input-height;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  // Unstyle the caret on `<select>`s in IE10+.\n  &::-ms-expand {\n    background-color: transparent;\n    border: 0;\n  }\n\n  // Remove select outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $input-color;\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  @include form-control-focus($ignore-warning: true);\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled and read-only inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled,\n  &[readonly] {\n    background-color: $input-disabled-bg;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n}\n\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n  &.form-control {\n    appearance: none; // Fix appearance for date inputs in Safari\n  }\n}\n\n// Removing default icons for dates and time\ninput[type=\"date\"]::-webkit-calendar-picker-indicator, input[type=\"time\"]::-webkit-calendar-picker-indicator {\n  background: transparent;\n  bottom: 0;\n  color: transparent;\n  cursor: pointer;\n  height: auto;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: auto;\n}\n\nselect.form-control {\n  &:focus::-ms-value {\n    // Suppress the nested default white text on blue background highlight given to\n    // the selected option text when the (still closed) <select> receives focus\n    // in IE and (under certain conditions) Edge, as it looks bad and cannot be made to\n    // match the appearance of the native widget.\n    // See https://github.com/twbs/bootstrap/issues/19398.\n    color: $input-color;\n    background-color: $input-bg;\n  }\n}\n\n// Make file inputs better match text inputs by forcing them to new lines.\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n\n//\n// Labels\n//\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<label>/<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  line-height: $input-line-height;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n}\n\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  @include font-size($input-font-size);\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.form-control-lg {\n  height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n// stylelint-disable-next-line no-duplicate-selectors\nselect.form-control {\n  &[size],\n  &[multiple] {\n    height: auto;\n  }\n}\n\ntextarea.form-control {\n  height: auto;\n}\n\n// Form groups\n//\n// Designed to help with the organization and spacing of vertical forms. For\n// horizontal forms, use the predefined grid classes.\n\n.form-group {\n  margin-bottom: $form-group-margin-bottom;\n}\n\n.form-text {\n  display: block;\n  margin-top: $form-text-margin-top;\n}\n\n\n// Form grid\n//\n// Special replacement for our grid system's `.row` for tighter form layouts.\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: math.div(-$form-grid-gutter-width , 2);\n  margin-left: math.div(-$form-grid-gutter-width , 2);\n\n  > .col,\n  > [class*=\"col-\"] {\n    padding-right: math.div($form-grid-gutter-width , 2);\n    padding-left: math.div($form-grid-gutter-width , 2);\n  }\n}\n\n\n// Checkboxes and radios\n//\n// Indent the labels to position radios/checkboxes as hanging controls.\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: $form-check-input-gutter;\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: $form-check-input-margin-y;\n  margin-left: -$form-check-input-gutter;\n  // Use [disabled] and :disabled for workaround https://github.com/twbs/bootstrap/issues   /28247\n  &[disabled] ~ .form-check-label,\n  &:disabled ~ .form-check-label {\n    color: $text-muted;\n  }\n}\n\n.form-check-label {\n  margin-bottom: 0; // Override default `<label>` bottom margin\n}\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0; // Override base .form-check\n  margin-right: $form-check-inline-margin-x;\n  // Undo .form-check-input defaults and add some `margin-right`.\n  .form-check-input {\n    position: static;\n    margin-top: 0;\n    margin-right: $form-check-inline-input-margin-x;\n    margin-left: 0;\n  }\n}\n\n\n// Form validation\n//\n// Provide feedback to users when form field values are valid or invalid. Works\n// primarily for client-side validation via scoped `:invalid` and `:valid`\n// pseudo-classes but also includes `.is-invalid` and `.is-valid` classes for\n// server side validation.\n\n@each $state, $data in $form-validation-states {\n  @include form-validation-state($state, map-get($data, color), map-get($data, icon));\n}\n\n// Inline forms\n//\n// Make forms appear inline(-block) by adding the `.form-inline` class. Inline\n// forms begin stacked on extra small (mobile) devices and then go inline when\n// viewports reach <768px.\n//\n// Requires wrapping inputs and labels with `.form-group` for proper display of\n// default HTML form controls and our custom form controls (e.g., input groups).\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center; // Prevent shorter elements from growing to same height as others (e.g., small buttons growing to normal sized button height)\n\n  // Because we use flex, the initial sizing of checkboxes is collapsed and\n  // doesn't occupy the full-width (which is what we want for xs grid tier),\n  // so we force that here.\n  .form-check {\n    width: 100%;\n  }\n\n  // Kick in the inline\n  @include media-breakpoint-up(sm) {\n    label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 0;\n    }\n\n    // Inline-block all the things for \"inline\"\n    .form-group {\n      display: flex;\n      flex: 0 0 auto;\n      flex-flow: row wrap;\n      align-items: center;\n      margin-bottom: 0;\n    }\n\n    // Allow folks to *not* use `.form-group`\n    .form-control {\n      display: inline-block;\n      width: auto; // Prevent labels from stacking above inputs in `.form-group`\n      vertical-align: middle;\n    }\n\n    // Make static controls behave like regular ones\n    .form-control-plaintext {\n      display: inline-block;\n    }\n\n    .input-group,\n    .custom-select {\n      width: auto;\n    }\n\n    // Remove default margin on radios/checkboxes that were used for stacking, and\n    // then undo the floating of radios and checkboxes to match.\n    .form-check {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: auto;\n      padding-left: 0;\n    }\n    .form-check-input {\n      position: relative;\n      flex-shrink: 0;\n      margin-top: 0;\n      margin-right: $form-check-input-margin-x;\n      margin-left: 0;\n    }\n\n    .custom-control {\n      align-items: center;\n      justify-content: center;\n    }\n    .custom-control-label {\n      margin-bottom: 0;\n    }\n  }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-prefers-reduced-motion-media-query and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Form control focus state\n//\n// Generate a customized focus state and for any input with the specified color,\n// which defaults to the `$input-focus-border-color` variable.\n//\n// We highly encourage you to not customize the default value, but instead use\n// this to tweak colors on an as-needed basis. This aesthetic change is based on\n// WebKit's default styles, but applicable to a wider range of browsers. Its\n// usability and accessibility should be taken into account with any change.\n//\n// Example usage: change the default blue border and shadow to white for better\n// contrast against a dark gray background.\n@mixin form-control-focus($ignore-warning: false) {\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n  @include deprecate(\"The `form-control-focus()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n\n// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state($state, $color, $icon) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: color-yiq($color);\n    background-color: rgba($color, $form-feedback-tooltip-opacity);\n    @include border-radius($form-feedback-tooltip-border-radius);\n\n    // See https://github.com/twbs/bootstrap/pull/31557\n    // Align tooltip to form elements\n    .form-row > .col > &,\n    .form-row > [class*=\"col-\"] > & {\n      left: $form-grid-gutter-width * .5;\n    }\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner !important; // stylelint-disable-line declaration-no-important\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  select.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-padding-x * 4 !important; // stylelint-disable-line declaration-no-important\n        background-position: right $input-padding-x * 2 center;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .custom-select {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $custom-select-feedback-icon-padding-right !important; // stylelint-disable-line declaration-no-important\n        background: $custom-select-background, $custom-select-bg escape-svg($icon) $custom-select-feedback-icon-position / $custom-select-feedback-icon-size no-repeat;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      ~ .form-check-label {\n        color: $color;\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n    }\n  }\n\n  .custom-control-input {\n    @include form-validation-state-selector($state) {\n      ~ .custom-control-label {\n        color: $color;\n\n        &::before {\n          border-color: $color;\n        }\n      }\n\n      &:checked {\n        ~ .custom-control-label::before {\n          border-color: lighten($color, 10%);\n          @include gradient-bg(lighten($color, 10%));\n        }\n      }\n\n      &:focus {\n        ~ .custom-control-label::before {\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n\n        &:not(:checked) ~ .custom-control-label::before {\n          border-color: $color;\n        }\n      }\n    }\n  }\n\n  // custom file\n  .custom-file-input {\n    @include form-validation-state-selector($state) {\n      ~ .custom-file-label {\n        border-color: $color;\n      }\n\n      &:focus {\n        ~ .custom-file-label {\n          border-color: $color;\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n      }\n    }\n  }\n}\n","// Gradients\n\n@mixin gradient-bg($color) {\n  @if $enable-gradients {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x;\n  } @else {\n    background-color: $color;\n  }\n}\n\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n  background-repeat: repeat-x;\n}\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.btn {\n  display: inline-block;\n  font-family: $btn-font-family;\n  font-weight: $btn-font-weight;\n  color: $body-color;\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: $btn-border-width solid transparent;\n  @include button-size($btn-padding-y, $btn-padding-x, $btn-font-size, $btn-line-height, $btn-border-radius);\n  @include transition($btn-transition);\n\n  @include hover() {\n    color: $body-color;\n    text-decoration: none;\n  }\n\n  &:focus,\n  &.focus {\n    outline: 0;\n    box-shadow: $btn-focus-box-shadow;\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    opacity: $btn-disabled-opacity;\n    @include box-shadow(none);\n  }\n\n  &:not(:disabled):not(.disabled) {\n    cursor: if($enable-pointer-cursor-for-buttons, pointer, null);\n\n    &:active,\n    &.active {\n      @include box-shadow($btn-active-box-shadow);\n\n      &:focus {\n        @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\n      }\n    }\n  }\n}\n\n// Future-proof disabling of clicks on `<a>` elements\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n\n//\n// Alternate buttons\n//\n\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  font-weight: $font-weight-normal;\n  color: $link-color;\n  text-decoration: $link-decoration;\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus,\n  &.focus {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $btn-link-disabled-color;\n    pointer-events: none;\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-line-height-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-line-height-sm, $btn-border-radius-sm);\n}\n\n\n//\n// Block button\n//\n\n.btn-block {\n  display: block;\n  width: 100%;\n\n  // Vertically space out multiple block buttons\n  + .btn-block {\n    margin-top: $btn-block-spacing-y;\n  }\n}\n\n// Specificity overrides\ninput[type=\"submit\"],\ninput[type=\"reset\"],\ninput[type=\"button\"] {\n  &.btn-block {\n    width: 100%;\n  }\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n@mixin button-variant($background, $border, $hover-background: darken($background, 7.5%), $hover-border: darken($border, 10%), $active-background: darken($background, 10%), $active-border: darken($border, 12.5%)) {\n  color: color-yiq($background);\n  @include gradient-bg($background);\n  border-color: $border;\n  @include box-shadow($btn-box-shadow);\n\n  @include hover() {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n  }\n\n  &:focus,\n  &.focus {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n    @if $enable-shadows {\n      @include box-shadow($btn-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5));\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n    }\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    color: color-yiq($background);\n    background-color: $background;\n    border-color: $border;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    @if $enable-gradients {\n      background-image: none; // Remove the gradient for the pressed/active state\n    }\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n      }\n    }\n  }\n}\n\n@mixin button-outline-variant($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\n  color: $color;\n  border-color: $color;\n\n  @include hover() {\n    color: $color-hover;\n    background-color: $active-background;\n    border-color: $active-border;\n  }\n\n  &:focus,\n  &.focus {\n    box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $color;\n    background-color: transparent;\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n      }\n    }\n  }\n}\n\n// Button sizes\n@mixin button-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  padding: $padding-y $padding-x;\n  @include font-size($font-size);\n  line-height: $line-height;\n  // Manually declare to provide an override to the browser default\n  @include border-radius($border-radius, 0);\n}\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.width {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: $zindex-dropdown;\n  display: none; // none by default, but block on \"open\" of the menu\n  float: left;\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  min-width: $dropdown-min-width;\n  padding: $dropdown-padding-y 0;\n  margin: $dropdown-spacer 0 0; // override default ul\n  @include font-size($dropdown-font-size);\n  color: $dropdown-color;\n  list-style: none;\n  background-color: $dropdown-bg;\n  background-clip: padding-box;\n  border: $dropdown-border-width solid $dropdown-border-color;\n  @include border-radius($dropdown-border-radius);\n  @include box-shadow($dropdown-box-shadow);\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-left {\n      right: auto;\n      left: 0;\n    }\n\n    .dropdown-menu#{$infix}-right {\n      right: 0;\n      left: auto;\n    }\n  }\n}\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropright {\n  .dropdown-menu {\n    top: 0;\n    margin-top: 0;\n    right: auto;\n    left: 100%;\n    margin-left: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(right);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropleft {\n  .dropdown-menu {\n    top: 0;\n    margin-top: 0;\n    right: 100%;\n    left: auto;\n    margin-right: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(left);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n// When enabled Popper.js, reset basic dropdown position\n// stylelint-disable-next-line no-duplicate-selectors\n.dropdown-menu {\n  &[x-placement^=\"top\"],\n  &[x-placement^=\"right\"],\n  &[x-placement^=\"bottom\"],\n  &[x-placement^=\"left\"] {\n    right: auto;\n    bottom: auto;\n  }\n}\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  @include nav-divider($dropdown-divider-bg, $dropdown-divider-margin-y, true);\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: $dropdown-link-color;\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  // Prevent dropdown overflow if there's no padding\n  // See https://github.com/twbs/bootstrap/pull/27703\n  @if $dropdown-padding-y == 0 {\n    &:first-child {\n      @include border-top-radius($dropdown-inner-border-radius);\n    }\n\n    &:last-child {\n      @include border-bottom-radius($dropdown-inner-border-radius);\n    }\n  }\n\n  @include hover-focus() {\n    color: $dropdown-link-hover-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-hover-bg);\n  }\n\n  &.active,\n  &:active {\n    color: $dropdown-link-active-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-active-bg);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $dropdown-link-disabled-color;\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: $dropdown-header-padding;\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: $dropdown-header-color;\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  color: $dropdown-link-color;\n}\n","@mixin caret-down() {\n  border-top: $caret-width solid;\n  border-right: $caret-width solid transparent;\n  border-bottom: 0;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-up() {\n  border-top: 0;\n  border-right: $caret-width solid transparent;\n  border-bottom: $caret-width solid;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-right() {\n  border-top: $caret-width solid transparent;\n  border-right: 0;\n  border-bottom: $caret-width solid transparent;\n  border-left: $caret-width solid;\n}\n\n@mixin caret-left() {\n  border-top: $caret-width solid transparent;\n  border-right: $caret-width solid;\n  border-bottom: $caret-width solid transparent;\n}\n\n@mixin caret($direction: down) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $caret-spacing;\n      vertical-align: $caret-vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down();\n      } @else if $direction == up {\n        @include caret-up();\n      } @else if $direction == right {\n        @include caret-right();\n      }\n    }\n\n    @if $direction == left {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $caret-spacing;\n        vertical-align: $caret-vertical-align;\n        content: \"\";\n        @include caret-left();\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n","// Horizontal dividers\n//\n// Dividers (basically an hr) within dropdowns and nav lists\n\n@mixin nav-divider($color: $nav-divider-color, $margin-y: $nav-divider-margin-y, $ignore-warning: false) {\n  height: 0;\n  margin: $margin-y 0;\n  overflow: hidden;\n  border-top: 1px solid $color;\n  @include deprecate(\"The `nav-divider()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n\n    // Bring the hover, focused, and \"active\" buttons to the front to overlay\n    // the borders properly\n    @include hover() {\n      z-index: 1;\n    }\n    &:focus,\n    &:active,\n    &.active {\n      z-index: 1;\n    }\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  // Prevent double borders when buttons are next to each other\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-right-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-left-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropright &::after {\n    margin-left: 0;\n  }\n\n  .dropleft &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n\n\n// Checkbox and radio options\n//\n// In order to support the browser's form validation feedback, powered by the\n// `required` attribute, we have to \"hide\" the inputs via `clip`. We cannot use\n// `display: none;` or `visibility: hidden;` as that also hides the popover.\n// Simply visually hiding the inputs via `opacity` would leave them clickable in\n// certain cases which is prevented by using `clip` and `pointer-events`.\n// This way, we ensure a DOM element is visible to position the popover from.\n//\n// See https://github.com/twbs/bootstrap/pull/12794 and\n// https://github.com/twbs/bootstrap/pull/14559 for more information.\n\n.btn-group-toggle {\n  > .btn,\n  > .btn-group > .btn {\n    margin-bottom: 0; // Override default `<label>` value\n\n    input[type=\"radio\"],\n    input[type=\"checkbox\"] {\n      position: absolute;\n      clip: rect(0, 0, 0, 0);\n      pointer-events: none;\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .custom-select,\n  > .custom-file {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n    margin-bottom: 0;\n\n    + .form-control,\n    + .custom-select,\n    + .custom-file {\n      margin-left: -$input-border-width;\n    }\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .custom-select:focus,\n  > .custom-file .custom-file-input:focus ~ .custom-file-label {\n    z-index: 3;\n  }\n\n  // Bring the custom file input above the label\n  > .custom-file .custom-file-input:focus {\n    z-index: 4;\n  }\n\n  > .form-control,\n  > .custom-select {\n    &:not(:last-child) { \n      @include border-right-radius(0); \n    }\n    &:not(:first-child) { \n      @include border-left-radius(0); \n    }\n  }\n\n  // Custom file inputs have more complex markup, thus requiring different\n  // border-radius overrides.\n  > .custom-file {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child) .custom-file-label,\n    &:not(:last-child) .custom-file-label::after { \n      @include border-right-radius(0); \n    }\n    &:not(:first-child) .custom-file-label { \n      @include border-left-radius(0);\n    }\n  }\n}\n\n\n// Prepend and append\n//\n// While it requires one extra layer of HTML for each, dedicated prepend and\n// append elements allow us to 1) be less clever, 2) simplify our selectors, and\n// 3) support HTML5 form validation.\n\n.input-group-prepend,\n.input-group-append {\n  display: flex;\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 3;\n    }\n  }\n\n  .btn + .btn,\n  .btn + .input-group-text,\n  .input-group-text + .input-group-text,\n  .input-group-text + .btn {\n    margin-left: -$input-border-width;\n  }\n}\n\n.input-group-prepend {\n  margin-right: -$input-border-width; \n}\n.input-group-append { \n  margin-left: -$input-border-width; \n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-padding-y $input-padding-x;\n  margin-bottom: 0; // Allow use of <label> elements by overriding our default margin-bottom\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $font-weight-normal;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n\n  // Nuke default margins from checkboxes and radios to vertically center within.\n  input[type=\"radio\"],\n  input[type=\"checkbox\"] {\n    margin-top: 0;\n  }\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: $input-height-lg;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: $input-height-sm;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: $custom-select-padding-x + $custom-select-indicator-padding;\n}\n\n\n// Prepend and append rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group > .input-group-append:not(:last-child) > .btn,\n.input-group > .input-group-append:not(:last-child) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  @include border-right-radius(0);\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  @include border-left-radius(0);\n}\n","// Embedded icons from Open Iconic.\n// Released under MIT and copyright 2014 Waybury.\n// https://useiconic.com/open\n@use 'sass:math';\n\n// Checkboxes and radios\n//\n// Base class takes care of all the key behavioral aspects.\n\n.custom-control {\n  position: relative;\n  z-index: 1;\n  display: block;\n  min-height: $font-size-base * $line-height-base;\n  padding-left: $custom-control-gutter + $custom-control-indicator-size;\n}\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: $custom-control-spacer-x;\n}\n\n.custom-control-input {\n  position: absolute;\n  left: 0;\n  z-index: -1; // Put the input behind the label so it doesn't overlay text\n  width: $custom-control-indicator-size;\n  height: math.div(($font-size-base * $line-height-base + $custom-control-indicator-size) , 2);\n  opacity: 0;\n\n  &:checked ~ .custom-control-label::before {\n    color: $custom-control-indicator-checked-color;\n    border-color: $custom-control-indicator-checked-border-color;\n    @include gradient-bg($custom-control-indicator-checked-bg);\n    @include box-shadow($custom-control-indicator-checked-box-shadow);\n  }\n\n  &:focus ~ .custom-control-label::before {\n    // the mixin is not used here to make sure there is feedback\n    @if $enable-shadows {\n      box-shadow: $input-box-shadow, $input-focus-box-shadow;\n    } @else {\n      box-shadow: $custom-control-indicator-focus-box-shadow;\n    }\n  }\n\n  &:focus:not(:checked) ~ .custom-control-label::before {\n    border-color: $custom-control-indicator-focus-border-color;\n  }\n\n  &:not(:disabled):active ~ .custom-control-label::before {\n    color: $custom-control-indicator-active-color;\n    background-color: $custom-control-indicator-active-bg;\n    border-color: $custom-control-indicator-active-border-color;\n    @include box-shadow($custom-control-indicator-active-box-shadow);\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .custom-control-label {\n      color: $custom-control-label-disabled-color;\n\n      &::before {\n        background-color: $custom-control-indicator-disabled-bg;\n      }\n    }\n  }\n}\n\n// Custom control indicators\n//\n// Build the custom controls out of pseudo-elements.\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  color: $custom-control-label-color;\n  vertical-align: top;\n  cursor: $custom-control-cursor;\n  &:before,&:after{\n    z-index: 1;\n  }\n  // Background-color and (when enabled) gradient\n  &::before {\n    position: absolute;\n    top: math.div(($font-size-base * $line-height-base - $custom-control-indicator-size) , 2);\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    pointer-events: none;\n    content: \"\";\n    background-color: $custom-control-indicator-bg;\n    border: $custom-control-indicator-border-color solid $custom-control-indicator-border-width;\n    @include box-shadow($custom-control-indicator-box-shadow);\n  }\n\n  // Foreground (icon)\n  &::after {\n    position: absolute;\n    top: math.div(($font-size-base * $line-height-base - $custom-control-indicator-size) , 2);\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    content: \"\";\n    background: no-repeat 50% / #{$custom-control-indicator-bg-size};\n  }\n}\n\n\n// Checkboxes\n//\n// Tweak just a few things for checkboxes.\n\n.custom-checkbox {\n  .custom-control-label::before {\n    @include border-radius($custom-checkbox-indicator-border-radius);\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:indeterminate ~ .custom-control-label {\n    &::before {\n      border-color: $custom-checkbox-indicator-indeterminate-border-color;\n      @include gradient-bg($custom-checkbox-indicator-indeterminate-bg);\n      @include box-shadow($custom-checkbox-indicator-indeterminate-box-shadow);\n    }\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-indeterminate);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n    &:indeterminate ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n// Radios\n//\n// Tweak just a few things for radios.\n\n.custom-radio {\n  .custom-control-label::before {\n    // stylelint-disable-next-line property-blacklist\n    border-radius: $custom-radio-indicator-border-radius;\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-radio-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// switches\n//\n// Tweak a few things for switches\n\n.custom-switch {\n  padding-left: $custom-switch-width + $custom-control-gutter;\n  .custom-control-label {\n    &::before {\n      left: -($custom-switch-width + $custom-control-gutter);\n      width: $custom-switch-width;\n      pointer-events: all;\n      // stylelint-disable-next-line property-blacklist\n      border-radius: $custom-switch-indicator-border-radius;\n    }\n\n    &::after {\n      top: add(math.div(($font-size-base * $line-height-base - $custom-control-indicator-size) , 2), $custom-control-indicator-border-width * 2);\n      left: add(-($custom-switch-width + $custom-control-gutter), $custom-control-indicator-border-width * 2);\n      width: $custom-switch-indicator-size;\n      height: $custom-switch-indicator-size;\n      background-color: $custom-control-indicator-border-color;\n      // stylelint-disable-next-line property-blacklist\n      border-radius: $custom-switch-indicator-border-radius;\n      @include transition(transform .15s ease-in-out, $custom-forms-transition);\n    }\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-color: $custom-control-indicator-bg;\n      transform: translateX($custom-switch-width - $custom-control-indicator-size);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n//\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: $custom-select-height;\n  padding: $custom-select-padding-y ($custom-select-padding-x + $custom-select-indicator-padding) $custom-select-padding-y $custom-select-padding-x;\n  font-family: $custom-select-font-family;\n  @include font-size($custom-select-font-size);\n  font-weight: $custom-select-font-weight;\n  line-height: $custom-select-line-height;\n  color: $custom-select-color;\n  vertical-align: middle;\n  background: $custom-select-bg $custom-select-background;\n  border: $custom-select-border-width solid $custom-select-border-color;\n  @include border-radius($custom-select-border-radius, 0);\n  @include box-shadow($custom-select-box-shadow);\n  appearance: none;\n\n  &:focus {\n    border-color: $custom-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($custom-select-box-shadow, $custom-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $custom-select-focus-box-shadow;\n    }\n\n    &::-ms-value {\n      // For visual consistency with other platforms/browsers,\n      // suppress the default white text on blue background highlight given to\n      // the selected option text when the (still closed) <select> receives focus\n      // in IE and (under certain conditions) Edge.\n      // See https://github.com/twbs/bootstrap/issues/19398.\n      color: $input-color;\n      background-color: $input-bg;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    height: auto;\n    padding-right: $custom-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $custom-select-disabled-color;\n    background-color: $custom-select-disabled-bg;\n  }\n\n  // Hides the default caret in IE11\n  &::-ms-expand {\n    display: none;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $custom-select-color;\n  }\n}\n\n.custom-select-sm {\n  height: $custom-select-height-sm;\n  padding-top: $custom-select-padding-y-sm;\n  padding-bottom: $custom-select-padding-y-sm;\n  padding-left: $custom-select-padding-x-sm;\n  @include font-size($custom-select-font-size-sm);\n}\n\n.custom-select-lg {\n  height: $custom-select-height-lg;\n  padding-top: $custom-select-padding-y-lg;\n  padding-bottom: $custom-select-padding-y-lg;\n  padding-left: $custom-select-padding-x-lg;\n  @include font-size($custom-select-font-size-lg);\n}\n\n\n// File\n//\n// Custom file input.\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: $custom-file-height;\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: $custom-file-height;\n  margin: 0;\n  opacity: 0;\n\n  &:focus ~ .custom-file-label {\n    border-color: $custom-file-focus-border-color;\n    box-shadow: $custom-file-focus-box-shadow;\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .custom-file-label,\n  &:disabled ~ .custom-file-label {\n    background-color: $custom-file-disabled-bg;\n  }\n\n  @each $lang, $value in $custom-file-text {\n    &:lang(#{$lang}) ~ .custom-file-label::after {\n      content: $value;\n    }\n  }\n\n  ~ .custom-file-label[data-browse]::after {\n    content: attr(data-browse);\n  }\n}\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: $custom-file-height;\n  padding: $custom-file-padding-y $custom-file-padding-x;\n  font-family: $custom-file-font-family;\n  font-weight: $custom-file-font-weight;\n  line-height: $custom-file-line-height;\n  color: $custom-file-color;\n  background-color: $custom-file-bg;\n  border: $custom-file-border-width solid $custom-file-border-color;\n  @include border-radius($custom-file-border-radius);\n  @include box-shadow($custom-file-box-shadow);\n\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 3;\n    display: block;\n    height: $custom-file-height-inner;\n    padding: $custom-file-padding-y $custom-file-padding-x;\n    line-height: $custom-file-line-height;\n    color: $custom-file-button-color;\n    content: \"Browse\";\n    @include gradient-bg($custom-file-button-bg);\n    border-left: inherit;\n    @include border-radius(0 $custom-file-border-radius $custom-file-border-radius 0);\n  }\n}\n\n// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.custom-range {\n  width: 100%;\n  height: add($custom-range-thumb-height, $custom-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: none;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-ms-thumb            { box-shadow: $custom-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: math.div(($custom-range-track-height - $custom-range-thumb-height) , 2); // Webkit specific\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent; // Why?\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent;\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: 0; // Edge specific\n    margin-right: $custom-range-thumb-focus-box-shadow-width; // Workaround that overflowed box-shadow is hidden.\n    margin-left: $custom-range-thumb-focus-box-shadow-width;  // Workaround that overflowed box-shadow is hidden.\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-ms-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: transparent;\n    border-color: transparent;\n    border-width: math.div($custom-range-thumb-height , 2);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-fill-lower {\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &::-ms-fill-upper {\n    margin-right: 15px; // arbitrary?\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &:disabled {\n    &::-webkit-slider-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-webkit-slider-runnable-track {\n      cursor: default;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-track {\n      cursor: default;\n    }\n\n    &::-ms-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n  }\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  @include transition($custom-forms-transition);\n}\n\n//image control\n.image-control{\n  &.custom-control{\n    padding-left: 0;\n  }\n  .custom-control-input:checked ~ .custom-control-label{\n    &:before{\n      border-color: $white;\n    }\n    img{\n      opacity: .8;\n    }\n  }\n  .custom-control-label {\n    padding-top: 0;\n    border-radius: $border-radius;\n    overflow: hidden;\n    background-color: $dark;\n    img{\n      transition:opacity .3s ease;\n    }\n    &:before,&:after{\n      z-index: 9;\n    }\n    &::before {\n      border-width: 1px;\n      top: 1rem;\n      left: 1rem;\n    }\n    &::after {\n      top: 1rem;\n      left: 1rem;\n    }\n  }\n  &:hover{\n    .custom-control-label{\n      img{\n        opacity: .8;\n      }\n    }\n  }\n}\n\n//btn control\n.custom-control-pro{\n  padding-left: 0;\n  position: relative;\n  &.no-control{\n    &.checked{\n      z-index: 3;\n    }\n    &.focused{\n      z-index: 2;\n    }\n    .custom-control-label {\n      padding: ($btn-padding-y - 0.0625) $btn-padding-x;\n      border-width: 2px;\n    }\n    .custom-control-input {\n      &:checked ~ .custom-control-label {\n        border-color: $custom-control-indicator-checked-border-color;\n        @include box-shadow($custom-control-indicator-checked-box-shadow);\n        z-index: 2;\n      }\n      &:not(:disabled):active ~ .custom-control-label {\n        border-color: $custom-control-indicator-active-border-color;\n        @include box-shadow($custom-control-indicator-active-box-shadow);\n      }\n    \n      // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n      &[disabled],\n      &:disabled {\n        ~ .custom-control-label {\n          color: $custom-control-label-disabled-color;\n        }\n      }\n    }\n  }\n  &-block{\n    &.custom-control{\n      display: flex;\n    }\n    .custom-control-label{\n      width: 100%;\n    }\n  }\n  .custom-control-label {\n    border: 1px solid $border-light;\n    padding: $btn-padding-x $btn-padding-x $btn-padding-x ($custom-control-gutter + $custom-control-indicator-size + $btn-padding-x);\n    font-size: $btn-font-size;\n    line-height: $btn-line-height;\n    border-radius: $btn-border-radius;\n    @include transition($btn-transition);\n    display: inline-flex;\n    align-items: center;\n    background-color: $white;\n    &::before,&::after {\n      top: 50%;\n      transform: translateY(-50%);\n      left: $btn-padding-x;\n    }\n\n    // With Icon\n    .icon{\n        font-size: 1.4em;\n        line-height: inherit;\n        &-lg{\n          font-size: 2.2em;\n        }\n    }\n    > span{\n        // display: inline-block;\n        white-space: nowrap;\n        &:only-child{\n            width: 100%;\n        }\n    }\n    .icon + span,span + .icon{\n      padding-left: 8px;\n    }\n  }\n  &.custom-control-sm{\n    padding-left: 0;\n    .custom-control-label {\n      padding: (.75rem - 0.0625) $btn-padding-x (.75rem - 0.0625) ($checkbox-radio-switch-text-gap + $checkbox-radio-switch-size-sm + $btn-padding-x);\n      font-size: $btn-font-size;\n      line-height: $btn-line-height;\n      border-radius: $btn-border-radius;\n      &::before,&::after {\n        top: 50%;\n        transform: translateY(-50%);\n        left: $btn-padding-x;\n      }\n    }\n  }\n  &-icon{\n    &.custom-control-pro{\n      .custom-control-label{\n        padding-left: 0;\n        padding-right: 0;\n        .icon{\n          text-align: center;\n          width: $btn-line-height + $btn-padding-y*2;\n        }\n      }\n    }\n  }\n}\n.custom-control {\n  &.color-control{\n    padding: 4px !important;\n    .custom-control-label{\n      &::before{\n        opacity: 0;\n        display: block;\n        left: -4px;\n        right: -4px;\n        top: -4px;\n        bottom: -4px;\n        border-radius: 50%;\n        border: 2px solid $primary !important;\n        background: transparent !important;\n        transition: .3s ease;\n      }\n      &::after {\n        display: none;\n      }\n    }\n    .custom-control-input:checked ~{\n      .custom-control-label{\n        &::before{\n          opacity: 1;\n        }\n      }\n    }\n  }\n}\n.no-control{\n  padding-left: 0;\n  .custom-control-label {\n    &::before,&::after {\n      display: none;\n    }\n  }\n}\n\n\n.form-control-slider{\n  margin-top: 0.25rem;\n  margin-bottom: 0.25rem;\n}\n\n// group\n.custom-control{\n  &-group{\n    display: inline-flex;\n    align-items: center;\n    flex-wrap: wrap;\n    margin: -(math.div($spacer,2) * .75);\n    > *{\n      padding: (math.div($spacer,2) * .75);\n    }\n  }\n  &-stacked{\n    margin: 0;\n    > *{\n      padding: 0;\n      margin: -1px;\n    }\n    &:not(.custom-control-vertical){\n      > *{\n        &:not(:first-child) .custom-control-label{\n          border-top-left-radius: 0;\n          border-bottom-left-radius: 0;\n        }\n        &:not(:last-child) .custom-control-label{\n          border-top-right-radius: 0;\n          border-bottom-right-radius: 0;\n        }\n      }\n    }\n  }\n  &-vertical{\n    flex-direction: column;\n    align-items: start;\n    > *{\n      width: 100%;\n    }\n    .custom-control{\n      display: flex;\n      .custom-control-label{\n        width: 100%;\n      }\n    }\n    &.custom-control-stacked{\n      > *{\n        &:not(:first-child) .custom-control-label{\n          border-top-left-radius: 0;\n          border-top-right-radius: 0;\n        }\n        &:not(:last-child) .custom-control-label{\n          border-bottom-left-radius: 0;\n          border-bottom-right-radius: 0;\n        }\n      }\n    }\n  }\n}","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: $nav-link-padding-y $nav-link-padding-x;\n  text-decoration: if($link-decoration == none, null, none);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: $nav-link-disabled-color;\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  border-bottom: $nav-tabs-border-width solid $nav-tabs-border-color;\n\n  .nav-link {\n    margin-bottom: -$nav-tabs-border-width;\n    background-color: transparent;\n    border: $nav-tabs-border-width solid transparent;\n    @include border-top-radius($nav-tabs-border-radius);\n\n    @include hover-focus() {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: $nav-tabs-link-hover-border-color;\n    }\n\n    &.disabled {\n      color: $nav-link-disabled-color;\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: $nav-tabs-link-active-color;\n    background-color: $nav-tabs-link-active-bg;\n    border-color: $nav-tabs-link-active-border-color;\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: -$nav-tabs-border-width;\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  .nav-link {\n    background: none;\n    border: 0;\n    @include border-radius($nav-pills-border-radius);\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: $nav-pills-link-active-color;\n    background-color: $nav-pills-link-active-bg;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Contents\n//\n// Navbar\n// Navbar brand\n// Navbar nav\n// Navbar text\n// Navbar divider\n// Responsive navbar\n// Navbar position\n// Navbar themes\n\n\n// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: $navbar-padding-y $navbar-padding-x;\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .container,\n  .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: $navbar-brand-padding-y;\n  padding-bottom: $navbar-brand-padding-y;\n  margin-right: $navbar-padding-x;\n  @if($rtl==false){\n  }\n  @if($rtl==true){\n    margin-left: $navbar-padding-x;\n  }\n  @include font-size($navbar-brand-font-size);\n  line-height: inherit;\n  white-space: nowrap;\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .dropdown-menu {\n    position: static;\n    float: none;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  display: inline-block;\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\n  @include font-size($navbar-toggler-font-size);\n  line-height: 1;\n  background-color: transparent; // remove default button style\n  border: $border-width solid transparent; // remove default button style\n  @include border-radius($navbar-toggler-border-radius);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: no-repeat center center;\n  background-size: 100% 100%;\n}\n\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        %container-navbar-expand-#{$breakpoint} {\n          padding-right: 0;\n          padding-left: 0;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-navbar-expand-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-navbar-expand-#{$breakpoint};\n          }\n        }\n      }\n\n      @include media-breakpoint-up($next) {\n        flex-flow: row nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: $navbar-nav-link-padding-x;\n            padding-left: $navbar-nav-link-padding-x;\n          }\n        }\n\n        // For nesting containers, have to redeclare for alignment purposes\n        %container-nesting-#{$breakpoint} {\n          flex-wrap: nowrap;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-nesting-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-nesting-#{$breakpoint};\n          }\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n\n          // Changes flex-bases to auto because of an IE10 bug\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n// Dark links against a light background\n.navbar-light {\n  .navbar-brand {\n    color: $navbar-light-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-light-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-light-color;\n\n      @include hover-focus() {\n        color: $navbar-light-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-light-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-light-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-light-color;\n    border-color: $navbar-light-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-light-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-light-color;\n    a {\n      color: $navbar-light-active-color;\n\n      @include hover-focus() {\n        color: $navbar-light-active-color;\n      }\n    }\n  }\n}\n\n// White links against a dark background\n.navbar-dark {\n  .navbar-brand {\n    color: $navbar-dark-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-dark-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-dark-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-dark-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-dark-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-dark-color;\n    border-color: $navbar-dark-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-dark-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-dark-color;\n    a {\n      color: $navbar-dark-active-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-active-color;\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n@use 'sass:math';\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: $card-height;\n  word-wrap: break-word;\n  background-color: $card-bg;\n  background-clip: border-box;\n  border: $card-border-width solid $card-border-color;\n  @include border-radius($card-border-radius);\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius($card-inner-border-radius);\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius($card-inner-border-radius);\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  // Workaround for the image size bug in IE\n  // See: https://github.com/twbs/bootstrap/pull/28855\n  min-height: 1px;\n  padding: $card-spacer-x;\n  color: $card-color;\n}\n\n.card-title {\n  margin-bottom: $card-spacer-y;\n}\n\n.card-subtitle {\n  margin-top: math.div(-$card-spacer-y , 2);\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  @include hover() {\n    text-decoration: none;\n  }\n\n  + .card-link {\n    margin-left: $card-spacer-x;\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: $card-spacer-y $card-spacer-x;\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-bottom: $card-border-width solid $card-border-color;\n\n  &:first-child {\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\n  }\n}\n\n.card-footer {\n  padding: $card-spacer-y $card-spacer-x;\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-top: $card-border-width solid $card-border-color;\n\n  &:last-child {\n    @include border-radius(0 0 $card-inner-border-radius $card-inner-border-radius);\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: math.div(-$card-spacer-x , 2);\n  margin-bottom: -$card-spacer-y;\n  margin-left: math.div(-$card-spacer-x , 2);\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: math.div(-$card-spacer-x , 2);\n  margin-left: math.div(-$card-spacer-x , 2);\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: $card-img-overlay-padding;\n  @include border-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  flex-shrink: 0; // For IE: https://github.com/twbs/bootstrap/issues/29396\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius($card-inner-border-radius);\n}\n\n\n// Card deck\n\n.card-deck {\n  .card {\n    margin-bottom: $card-deck-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    margin-right: -$card-deck-margin;\n    margin-left: -$card-deck-margin;\n\n    .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-right: $card-deck-margin;\n      margin-bottom: 0; // Override the default\n      margin-left: $card-deck-margin;\n    }\n  }\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: $card-group-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-right-radius(0);\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-blacklist\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-blacklist\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-left-radius(0);\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-blacklist\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-blacklist\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n//\n// Columns\n//\n\n.card-columns {\n  .card {\n    margin-bottom: $card-columns-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    column-count: $card-columns-count;\n    column-gap: $card-columns-gap;\n    orphans: 1;\n    widows: 1;\n\n    .card {\n      display: inline-block; // Don't let them vertically span multiple columns\n      width: 100%; // Don't let their width change\n    }\n  }\n}\n\n\n//\n// Accordion\n//\n\n.accordion {\n  overflow-anchor: none;\n\n  > .card {\n    overflow: hidden;\n\n    &:not(:last-of-type) {\n      border-bottom: 0;\n      @include border-bottom-radius(0);\n    }\n\n    &:not(:first-of-type) {\n      @include border-top-radius(0);\n    }\n\n    > .card-header {\n      @include border-radius(0);\n      margin-bottom: -$card-border-width;\n    }\n  }\n}\n",".breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: $breadcrumb-padding-y $breadcrumb-padding-x;\n  margin-bottom: $breadcrumb-margin-bottom;\n  @include font-size($breadcrumb-font-size);\n  list-style: none;\n  background-color: $breadcrumb-bg;\n  @include border-radius($breadcrumb-border-radius);\n}\n\n.breadcrumb-item {\n  display: flex;\n\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: $breadcrumb-item-padding;\n    &::before {\n      display: inline-block; // Suppress underlining of the separator in modern browsers\n      padding-right: $breadcrumb-item-padding;\n      color: $breadcrumb-divider-color;\n      content: escape-svg($breadcrumb-divider);\n    }\n  }\n\n  // IE9-11 hack to properly handle hyperlink underlines for breadcrumbs built\n  // without `<ul>`s. The `::before` pseudo-element generates an element\n  // *within* the .breadcrumb-item and thereby inherits the `text-decoration`.\n  //\n  // To trick IE into suppressing the underline, we give the pseudo-element an\n  // underline and then immediately remove it.\n  + .breadcrumb-item:hover::before {\n    text-decoration: underline;\n  }\n  // stylelint-disable-next-line no-duplicate-selectors\n  + .breadcrumb-item:hover::before {\n    text-decoration: none;\n  }\n\n  &.active {\n    color: $breadcrumb-active-color;\n  }\n}\n",".pagination {\n  display: flex;\n  @include list-unstyled();\n  @include border-radius();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: $pagination-padding-y $pagination-padding-x;\n  margin-left: -$pagination-border-width;\n  line-height: $pagination-line-height;\n  color: $pagination-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $pagination-bg;\n  border: $pagination-border-width solid $pagination-border-color;\n\n  &:hover {\n    z-index: 2;\n    color: $pagination-hover-color;\n    text-decoration: none;\n    background-color: $pagination-hover-bg;\n    border-color: $pagination-hover-border-color;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: $pagination-focus-outline;\n    box-shadow: $pagination-focus-box-shadow;\n  }\n}\n\n.page-item {\n  &:first-child {\n    .page-link {\n      margin-left: 0;\n      @include border-left-radius($border-radius);\n    }\n  }\n  &:last-child {\n    .page-link {\n      @include border-right-radius($border-radius);\n    }\n  }\n\n  &.active .page-link {\n    z-index: 1;\n    color: $pagination-active-color;\n    background-color: $pagination-active-bg;\n    border-color: $pagination-active-border-color;\n  }\n\n  &.disabled .page-link {\n    color: $pagination-disabled-color;\n    pointer-events: none;\n    cursor: auto;\n    background-color: $pagination-disabled-bg;\n    border-color: $pagination-disabled-border-color;\n  }\n}\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size(\n    $pagination-padding-y-lg,\n    $pagination-padding-x-lg,\n    $font-size-lg,\n    $line-height-lg,\n    $border-radius-lg\n  );\n}\n\n.pagination-sm {\n  @include pagination-size(\n    $pagination-padding-y-sm,\n    $pagination-padding-x-sm,\n    $font-size-sm,\n    $line-height-sm,\n    $border-radius-sm\n  );\n}\n","// Pagination\n\n@mixin pagination-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  .page-link {\n    padding: $padding-y $padding-x;\n    @include font-size($font-size);\n    line-height: $line-height;\n  }\n\n  .page-item {\n    &:first-child {\n      .page-link {\n        @include border-left-radius($border-radius);\n      }\n    }\n    &:last-child {\n      .page-link {\n        @include border-right-radius($border-radius);\n      }\n    }\n  }\n}\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  display: inline-block;\n  padding: $badge-padding-y $badge-padding-x;\n  @include font-size($badge-font-size);\n  font-weight: $badge-font-weight;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius($badge-border-radius);\n  @include transition($badge-transition);\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      text-decoration: none;\n    }\n  }\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n// Pill badges\n//\n// Make them extra rounded with a modifier to replace v3's badges.\n\n.badge-pill {\n  padding-right: $badge-pill-padding-x;\n  padding-left: $badge-pill-padding-x;\n  @include border-radius($badge-pill-border-radius);\n}\n\n// Colors\n//\n// Contextual variations (linked badges get darker on :hover).\n\n@each $color, $value in $theme-colors {\n  .badge-#{$color} {\n    @include badge-variant($value);\n  }\n}\n","@mixin badge-variant($bg) {\n  color: color-yiq($bg);\n  background-color: $bg;\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      color: color-yiq($bg);\n      background-color: darken($bg, 10%);\n    }\n\n    &:focus,\n    &.focus {\n      outline: 0;\n      box-shadow: 0 0 0 $badge-focus-width rgba($bg, .5);\n    }\n  }\n}\n",".jumbotron {\n  padding: $jumbotron-padding ($jumbotron-padding * .5);\n  margin-bottom: $jumbotron-padding;\n  color: $jumbotron-color;\n  background-color: $jumbotron-bg;\n  @include border-radius($border-radius-lg);\n\n  @include media-breakpoint-up(sm) {\n    padding: ($jumbotron-padding * 2) $jumbotron-padding;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  @include border-radius(0);\n}\n","//\n// Base styles\n//\n\n.alert {\n  position: relative;\n  padding: $alert-padding-y $alert-padding-x;\n  margin-bottom: $alert-margin-bottom;\n  border: $alert-border-width solid transparent;\n  @include border-radius($alert-border-radius);\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $close-font-size + $alert-padding-x * 2;\n  // Adjust close link position\n  .close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    padding: $alert-padding-y $alert-padding-x;\n    color: inherit;\n  }\n}\n\n\n// Alternate styles\n//\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $color, $value in $theme-colors {\n  .alert-#{$color} {\n    @include alert-variant(theme-color-level($color, $alert-bg-level), theme-color-level($color, $alert-border-level), theme-color-level($color, $alert-color-level));\n  }\n}\n","@mixin alert-variant($background, $border, $color) {\n  color: $color;\n  @include gradient-bg($background);\n  border-color: $border;\n\n  hr {\n    border-top-color: darken($border, 5%);\n  }\n\n  .alert-link {\n    color: darken($color, 10%);\n  }\n}\n","// Disable animation if transitions are disabled\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    from { background-position: $progress-height 0; }\n    to { background-position: 0 0; }\n  }\n}\n\n.progress {\n  display: flex;\n  height: $progress-height;\n  overflow: hidden; // force rounded corners by cropping it\n  line-height: 0;\n  @include font-size($progress-font-size);\n  background-color: $progress-bg;\n  @include border-radius($progress-border-radius);\n  @include box-shadow($progress-box-shadow);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: $progress-bar-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $progress-bar-bg;\n  @include transition($progress-bar-transition);\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: $progress-height $progress-height;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-prefers-reduced-motion-media-query {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n",".media {\n  display: flex;\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1;\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius($list-group-border-radius);\n}\n\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: $list-group-action-color;\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  @include hover-focus() {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: $list-group-action-hover-color;\n    text-decoration: none;\n    background-color: $list-group-hover-bg;\n  }\n\n  &:active {\n    color: $list-group-action-active-color;\n    background-color: $list-group-action-active-bg;\n  }\n}\n\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: $list-group-item-padding-y $list-group-item-padding-x;\n  color: $list-group-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $list-group-bg;\n  border: $list-group-border-width solid $list-group-border-color;\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $list-group-disabled-color;\n    pointer-events: none;\n    background-color: $list-group-disabled-bg;\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: $list-group-active-color;\n    background-color: $list-group-active-bg;\n    border-color: $list-group-active-border-color;\n  }\n\n  & + & {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: -$list-group-border-width;\n      border-top-width: $list-group-border-width;\n    }\n  }\n}\n\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child {\n          @include border-bottom-left-radius($list-group-border-radius);\n          @include border-top-right-radius(0);\n        }\n\n        &:last-child {\n          @include border-top-right-radius($list-group-border-radius);\n          @include border-bottom-left-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        & + .list-group-item {\n          border-top-width: $list-group-border-width;\n          border-left-width: 0;\n          &.active {\n            margin-left: -$list-group-border-width;\n            border-left-width: $list-group-border-width;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 $list-group-border-width;\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// Contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $color, $value in $theme-colors {\n  @include list-group-item-variant($color, theme-color-level($color, -9), theme-color-level($color, 6));\n}\n","// List Groups\n\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      @include hover-focus() {\n        color: $color;\n        background-color: darken($background, 5%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n",".close {\n  float: right;\n  @include font-size($close-font-size);\n  font-weight: $close-font-weight;\n  line-height: 1;\n  color: $close-color;\n  text-shadow: $close-text-shadow;\n  opacity: .5;\n\n  // Override <a>'s hover style\n  @include hover() {\n    color: $close-color;\n    text-decoration: none;\n  }\n\n  &:not(:disabled):not(.disabled) {\n    @include hover-focus() {\n      opacity: .75;\n    }\n  }\n}\n\n// Additional properties for button version\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n// stylelint-disable-next-line selector-no-qualifying-type\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n}\n\n// Future-proof disabling of clicks on `<a>` elements\n\n// stylelint-disable-next-line selector-no-qualifying-type\na.close.disabled {\n  pointer-events: none;\n}\n",".toast {\n  // Prevents from shrinking in IE11, when in a flex container\n  // See https://github.com/twbs/bootstrap/issues/28341\n  flex-basis: $toast-max-width;\n  max-width: $toast-max-width;\n  @include font-size($toast-font-size);\n  color: $toast-color;\n  background-color: $toast-background-color;\n  background-clip: padding-box;\n  border: $toast-border-width solid $toast-border-color;\n  box-shadow: $toast-box-shadow;\n  opacity: 0;\n  @include border-radius($toast-border-radius);\n\n  &:not(:last-child) {\n    margin-bottom: $toast-padding-x;\n  }\n\n  &.showing {\n    opacity: 1;\n  }\n\n  &.show {\n    display: block;\n    opacity: 1;\n  }\n\n  &.hide {\n    display: none;\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: $toast-padding-y $toast-padding-x;\n  color: $toast-header-color;\n  background-color: $toast-header-background-color;\n  background-clip: padding-box;\n  border-bottom: $toast-border-width solid $toast-header-border-color;\n  @include border-top-radius(subtract($toast-border-radius, $toast-border-width));\n}\n\n.toast-body {\n  padding: $toast-padding-x; // apply to both vertical and horizontal\n}\n","// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n@use 'sass:math';\n\n.modal-open {\n  // Kill the scroll on the body\n  overflow: hidden;\n\n  .modal {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n}\n\n// Container that the modal scrolls within\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: $modal-dialog-margin;\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  display: flex; // IE10/11\n  max-height: subtract(100%, $modal-dialog-margin * 2);\n\n  .modal-content {\n    max-height: subtract(100vh, $modal-dialog-margin * 2); // IE10/11\n    overflow: hidden;\n  }\n\n  .modal-header,\n  .modal-footer {\n    flex-shrink: 0;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: subtract(100%, $modal-dialog-margin * 2);\n\n  // Ensure `modal-dialog-centered` extends the full height of the view (IE10/11)\n  &::before {\n    display: block; // IE10\n    height: subtract(100vh, $modal-dialog-margin * 2);\n    height: min-content; // Reset height to 0 except on IE\n    content: \"\";\n  }\n\n  // Ensure `.modal-body` shows scrollbar (IE10/11)\n  &.modal-dialog-scrollable {\n    flex-direction: column;\n    justify-content: center;\n    height: 100%;\n\n    .modal-content {\n      max-height: none;\n    }\n\n    &::before {\n      content: none;\n    }\n  }\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: $modal-content-color;\n  pointer-events: auto;\n  background-color: $modal-content-bg;\n  background-clip: padding-box;\n  border: $modal-content-border-width solid $modal-content-border-color;\n  @include border-radius($modal-content-border-radius);\n  @include box-shadow($modal-content-box-shadow-xs);\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal-backdrop;\n  width: 100vw;\n  height: 100vh;\n  background-color: $modal-backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $modal-backdrop-opacity; }\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  align-items: flex-start; // so the close btn always stays on the upper right corner\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: $modal-header-padding;\n  border-bottom: $modal-header-border-width solid $modal-header-border-color;\n  @include border-top-radius($modal-content-inner-border-radius);\n\n  .close {\n    padding: $modal-header-padding;\n    // auto on the left force icon to the right even when there is no .modal-title\n    margin: (-$modal-header-padding-y) (-$modal-header-padding-x) (-$modal-header-padding-y) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: $modal-title-line-height;\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: $modal-inner-padding;\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: $modal-inner-padding - math.div($modal-footer-margin-between , 2);\n  border-top: $modal-footer-border-width solid $modal-footer-border-color;\n  @include border-bottom-radius($modal-content-inner-border-radius);\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: math.div($modal-footer-margin-between , 2);\n  }\n}\n\n// Measure scrollbar width for padding body during modal show/hide\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: $modal-md;\n    margin: $modal-dialog-margin-y-sm-up auto;\n  }\n\n  .modal-dialog-scrollable {\n    max-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    .modal-content {\n      max-height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n    }\n  }\n\n  .modal-dialog-centered {\n    min-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    &::before {\n      height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n      height: min-content;\n    }\n  }\n\n  .modal-content {\n    @include box-shadow($modal-content-box-shadow-sm-up);\n  }\n\n  .modal-sm { max-width: $modal-sm; }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    max-width: $modal-lg;\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl { max-width: $modal-xl; }\n}\n","// Base class\n.tooltip {\n  position: absolute;\n  z-index: $zindex-tooltip;\n  display: block;\n  margin: $tooltip-margin;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($tooltip-font-size);\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: $tooltip-opacity; }\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $tooltip-arrow-width;\n    height: $tooltip-arrow-height;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    bottom: 0;\n\n    &::before {\n      top: 0;\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-top-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-right {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    left: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      right: 0;\n      border-width: ($tooltip-arrow-width * .5) $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-right-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-bottom {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    top: 0;\n\n    &::before {\n      bottom: 0;\n      border-width: 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-bottom-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-left {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    right: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      left: 0;\n      border-width: ($tooltip-arrow-width * .5) 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-left-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-tooltip-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-tooltip-left;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: $tooltip-max-width;\n  padding: $tooltip-padding-y $tooltip-padding-x;\n  color: $tooltip-color;\n  text-align: center;\n  background-color: $tooltip-bg;\n  @include border-radius($tooltip-border-radius);\n}\n","@mixin reset-text() {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: $zindex-popover;\n  display: block;\n  max-width: $popover-max-width;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($popover-font-size);\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: $popover-bg;\n  background-clip: padding-box;\n  border: $popover-border-width solid $popover-border-color;\n  @include border-radius($popover-border-radius);\n  @include box-shadow($popover-box-shadow);\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $popover-arrow-width;\n    height: $popover-arrow-height;\n    margin: 0 $popover-border-radius;\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-popover-top {\n  margin-bottom: $popover-arrow-height;\n\n  > .arrow {\n    bottom: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      bottom: 0;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      bottom: $popover-border-width;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-right {\n  margin-left: $popover-arrow-height;\n\n  > .arrow {\n    left: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      left: 0;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      left: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-bottom {\n  margin-top: $popover-arrow-height;\n\n  > .arrow {\n    top: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      top: 0;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      top: $popover-border-width;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-color;\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: $popover-arrow-width;\n    margin-left: -$popover-arrow-width * .5;\n    content: \"\";\n    border-bottom: $popover-border-width solid $popover-header-bg;\n  }\n}\n\n.bs-popover-left {\n  margin-right: $popover-arrow-height;\n\n  > .arrow {\n    right: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      right: 0;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      right: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-popover-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-popover-left;\n  }\n}\n\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: $popover-header-padding-y $popover-header-padding-x;\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size($font-size-base);\n  color: $popover-header-color;\n  background-color: $popover-header-bg;\n  border-bottom: $popover-border-width solid darken($popover-header-bg, 5%);\n  @include border-top-radius($popover-inner-border-radius);\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: $popover-body-padding-y $popover-body-padding-x;\n  color: $popover-body-color;\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-left and .carousel-item-right is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-left and .active.carousel-item-right is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-left and .carousel-item-prev.carousel-item-right\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-left),\n.active.carousel-item-right {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-right),\n.active.carousel-item-left {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-left,\n  .carousel-item-prev.carousel-item-right {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-left,\n  .active.carousel-item-right {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  @include hover-focus() {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(90deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n.carousel-control-next {\n  right: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(270deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background: 50% / 100% 100% no-repeat;\n}\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n\n// Optional indicator pips\n//\n// Add an ordered list with the following class and add a list item for each\n// slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0; // override <ol> default\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  li {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: .5;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: 1;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: 20px;\n  left: (100% - $carousel-caption-width) * .5;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n","@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n","//\n// Rotating border\n//\n\n@keyframes spinner-border {\n  to { transform: rotate(360deg); }\n}\n\n.spinner-border {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  border: $spinner-border-width solid currentcolor;\n  border-right-color: transparent;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: .75s linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n  border-width: $spinner-border-width-sm;\n}\n\n//\n// Growing circle\n//\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.spinner-grow {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  background-color: currentcolor;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  opacity: 0;\n  animation: .75s linear infinite spinner-grow;\n}\n\n.spinner-grow-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n}\n\n@if $enable-prefers-reduced-motion-media-query {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      animation-duration: 1.5s;\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.align-baseline    { vertical-align: baseline !important; } // Browser default\n.align-top         { vertical-align: top !important; }\n.align-middle      { vertical-align: middle !important; }\n.align-bottom      { vertical-align: bottom !important; }\n.align-text-bottom { vertical-align: text-bottom !important; }\n.align-text-top    { vertical-align: text-top !important; }\n","// stylelint-disable declaration-no-important\n\n// Contextual backgrounds\n\n@mixin bg-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    background-color: $color !important;\n  }\n  a#{$parent},\n  button#{$parent} {\n    @include hover-focus() {\n      background-color: darken($color, 10%) !important;\n    }\n  }\n  @include deprecate(\"The `bg-variant` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n\n@mixin bg-gradient-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x !important;\n  }\n  @include deprecate(\"The `bg-gradient-variant` mixin\", \"v4.5.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n@each $color, $value in $theme-colors {\n  @include bg-variant(\".bg-#{$color}\", $value, true);\n}\n\n@if $enable-gradients {\n  @each $color, $value in $theme-colors {\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value, true);\n  }\n}\n\n.bg-white {\n  background-color: $white !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n","// stylelint-disable property-blacklist, declaration-no-important\n\n//\n// Border\n//\n\n.border         { border: $border-width solid $border-color !important; }\n.border-top     { border-top: $border-width solid $border-color !important; }\n.border-right   { \n  border-right: $border-width solid $border-color !important; \n}\n.border-bottom  { border-bottom: $border-width solid $border-color !important; }\n.border-left    { \n  border-left: $border-width solid $border-color !important; \n}\n\n.border-0        { border: 0 !important; }\n.border-top-0    { border-top: 0 !important; }\n.border-right-0  { \n  border-right: 0 !important; \n}\n.border-bottom-0 { border-bottom: 0 !important; \n}\n.border-left-0   { \n  border-left: 0 !important; \n}\n\n@each $color, $value in $theme-colors {\n  .border-#{$color} {\n    border-color: $value !important;\n  }\n}\n\n.border-white {\n  border-color: $white !important;\n}\n\n//\n// Border-radius\n//\n\n.rounded-sm {\n  border-radius: $border-radius-sm !important;\n}\n\n.rounded {\n  border-radius: $border-radius !important;\n}\n\n.rounded-top {\n  border-top-left-radius: $border-radius !important;\n  border-top-right-radius: $border-radius !important;\n}\n\n.rounded-right {\n  border-top-right-radius: $border-radius !important;\n  border-bottom-right-radius: $border-radius !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-left {\n  border-top-left-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-lg {\n  border-radius: $border-radius-lg !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: $rounded-pill !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Utilities for common `display` values\n//\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $value in $displays {\n      .d#{$infix}-#{$value} { display: $value !important; }\n    }\n  }\n}\n\n\n//\n// Utilities for toggling `display` in print\n//\n\n@media print {\n  @each $value in $displays {\n    .d-print-#{$value} { display: $value !important; }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n\n  &::before {\n    display: block;\n    content: \"\";\n  }\n\n  .embed-responsive-item,\n  iframe,\n  embed,\n  object,\n  video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n  }\n}\n\n@each $embed-responsive-aspect-ratio in $embed-responsive-aspect-ratios {\n  $embed-responsive-aspect-ratio-x: nth($embed-responsive-aspect-ratio, 1);\n  $embed-responsive-aspect-ratio-y: nth($embed-responsive-aspect-ratio, 2);\n\n  .embed-responsive-#{$embed-responsive-aspect-ratio-x}by#{$embed-responsive-aspect-ratio-y} {\n    &::before {\n      padding-top: percentage(divide($embed-responsive-aspect-ratio-y, $embed-responsive-aspect-ratio-x));\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n// Flex variation\n//\n// Custom styles for additional flex alignment options.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .flex#{$infix}-row            { flex-direction: row !important; }\n    .flex#{$infix}-column         { flex-direction: column !important; }\n    .flex#{$infix}-row-reverse    { flex-direction: row-reverse !important; }\n    .flex#{$infix}-column-reverse { flex-direction: column-reverse !important; }\n\n    .flex#{$infix}-wrap         { flex-wrap: wrap !important; }\n    .flex#{$infix}-nowrap       { flex-wrap: nowrap !important; }\n    .flex#{$infix}-wrap-reverse { flex-wrap: wrap-reverse !important; }\n    .flex#{$infix}-fill         { flex: 1 1 auto !important; }\n    .flex#{$infix}-grow-0       { flex-grow: 0 !important; }\n    .flex#{$infix}-grow-1       { flex-grow: 1 !important; }\n    .flex#{$infix}-shrink-0     { flex-shrink: 0 !important; }\n    .flex#{$infix}-shrink-1     { flex-shrink: 1 !important; }\n\n    .justify-content#{$infix}-start   { justify-content: flex-start !important; }\n    .justify-content#{$infix}-end     { justify-content: flex-end !important; }\n    .justify-content#{$infix}-center  { justify-content: center !important; }\n    .justify-content#{$infix}-between { justify-content: space-between !important; }\n    .justify-content#{$infix}-around  { justify-content: space-around !important; }\n\n    .align-items#{$infix}-start    { align-items: flex-start !important; }\n    .align-items#{$infix}-end      { align-items: flex-end !important; }\n    .align-items#{$infix}-center   { align-items: center !important; }\n    .align-items#{$infix}-baseline { align-items: baseline !important; }\n    .align-items#{$infix}-stretch  { align-items: stretch !important; }\n\n    .align-content#{$infix}-start   { align-content: flex-start !important; }\n    .align-content#{$infix}-end     { align-content: flex-end !important; }\n    .align-content#{$infix}-center  { align-content: center !important; }\n    .align-content#{$infix}-between { align-content: space-between !important; }\n    .align-content#{$infix}-around  { align-content: space-around !important; }\n    .align-content#{$infix}-stretch { align-content: stretch !important; }\n\n    .align-self#{$infix}-auto     { align-self: auto !important; }\n    .align-self#{$infix}-start    { align-self: flex-start !important; }\n    .align-self#{$infix}-end      { align-self: flex-end !important; }\n    .align-self#{$infix}-center   { align-self: center !important; }\n    .align-self#{$infix}-baseline { align-self: baseline !important; }\n    .align-self#{$infix}-stretch  { align-self: stretch !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .float#{$infix}-left  { \n      float: left !important; \n    }\n    .float#{$infix}-right { \n      float: right !important;\n    }\n    .float#{$infix}-none  { float: none !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $user-selects {\n  .user-select-#{$value} { user-select: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $overflows {\n  .overflow-#{$value} { overflow: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n// Common values\n@each $position in $positions {\n  .position-#{$position} { position: $position !important; }\n}\n\n// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.sticky-top {\n  @supports (position: sticky) {\n    position: sticky;\n    top: 0;\n    z-index: $zindex-sticky;\n  }\n}\n","//\n// Screenreaders\n//\n\n.sr-only {\n  @include sr-only();\n}\n\n.sr-only-focusable {\n  @include sr-only-focusable();\n}\n","// Only display content to screen readers\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin sr-only() {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n// Use in conjunction with .sr-only to only display content when it's focused.\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n//\n// Credit: HTML5 Boilerplate\n\n@mixin sr-only-focusable() {\n  &:active,\n  &:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.shadow-sm { box-shadow: $box-shadow-sm !important; }\n.shadow { box-shadow: $box-shadow !important; }\n.shadow-lg { box-shadow: $box-shadow-lg !important; }\n.shadow-none { box-shadow: none !important; }\n","// stylelint-disable declaration-no-important\n\n// Width and height\n\n@each $prop, $abbrev in (width: w, height: h) {\n  @each $size, $length in $sizes {\n    .#{$abbrev}-#{$size} { #{$prop}: $length !important; }\n  }\n}\n\n.mw-100 { max-width: 100% !important; }\n.mh-100 { max-height: 100% !important; }\n\n// Viewport additional helpers\n\n.min-vw-100 { min-width: 100vw !important; }\n.min-vh-100 { min-height: 100vh !important; }\n\n.vw-100 { width: 100vw !important; }\n.vh-100 { height: 100vh !important; }\n","// stylelint-disable declaration-no-important\n\n// Margin and Padding\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $prop, $abbrev in (margin: m, padding: p) {\n      @each $size, $length in $spacers {\n        .#{$abbrev}#{$infix}-#{$size} { #{$prop}: $length !important; }\n        .#{$abbrev}t#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-top: $length !important;\n        }\n        .#{$abbrev}r#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-right: $length !important;\n        }\n        .#{$abbrev}b#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-bottom: $length !important;\n        }\n        .#{$abbrev}l#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-left: $length !important;\n        }\n      }\n    }\n\n    // Negative margins (e.g., where `.mb-n1` is negative version of `.mb-1`)\n    @each $size, $length in $spacers {\n      @if $size != 0 {\n        .m#{$infix}-n#{$size} { margin: -$length !important; }\n        .mt#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-top: -$length !important;\n        }\n        .mr#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-right: -$length !important;\n        }\n        .mb#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-bottom: -$length !important;\n        }\n        .ml#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-left: -$length !important;\n        }\n      }\n    }\n\n    // Some special margin utils\n    .m#{$infix}-auto { margin: auto !important; }\n    .mt#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-top: auto !important;\n    }\n    .mr#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-right: auto !important;\n    }\n    .mb#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-bottom: auto !important;\n    }\n    .ml#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-left: auto !important;\n    }\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    // Just in case `pointer-events: none` is set on a parent\n    pointer-events: auto;\n    content: \"\";\n    // IE10 bugfix, see https://stackoverflow.com/questions/16947967/ie10-hover-pseudo-class-doesnt-work-without-background-color\n    background-color: rgba(0, 0, 0, 0);\n  }\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Text\n//\n\n.text-monospace { font-family: $font-family-monospace !important; }\n\n// Alignment\n\n.text-justify  { text-align: justify !important; }\n.text-wrap     { white-space: normal !important; }\n.text-nowrap   { white-space: nowrap !important; }\n.text-truncate { @include text-truncate(); }\n\n// Responsive alignment\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .text#{$infix}-left   { \n      text-align: left !important;\n     }\n    .text#{$infix}-right  { \n      text-align: right !important;\n     }\n    .text#{$infix}-center { text-align: center !important; }\n  }\n}\n\n// Transformation\n\n.text-lowercase  { text-transform: lowercase !important; }\n.text-uppercase  { text-transform: uppercase !important; }\n.text-capitalize { text-transform: capitalize !important; }\n\n// Weight and italics\n\n.font-weight-light   { font-weight: $font-weight-light !important; }\n.font-weight-lighter { font-weight: $font-weight-lighter !important; }\n.font-weight-normal  { font-weight: $font-weight-normal !important; }\n.font-weight-bold    { font-weight: $font-weight-bold !important; }\n.font-weight-bolder  { font-weight: $font-weight-bolder !important; }\n.font-italic         { font-style: italic !important; }\n\n// Contextual colors\n\n.text-white { color: $white !important; }\n\n@each $color, $value in $theme-colors {\n  @include text-emphasis-variant(\".text-#{$color}\", $value, true);\n}\n\n.text-body { color: $body-color !important; }\n.text-muted { color: $text-muted !important; }\n\n.text-black-50 { color: rgba($black, .5) !important; }\n.text-white-50 { color: rgba($white, .5) !important; }\n\n// Misc\n\n.text-hide {\n  @include text-hide($ignore-warning: true);\n}\n\n.text-decoration-none { text-decoration: none !important; }\n\n.text-break {\n  word-break: break-word !important; // IE & < Edge 18\n  overflow-wrap: break-word !important;\n}\n\n// Reset\n\n.text-reset { color: inherit !important; }\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n","// stylelint-disable declaration-no-important\n\n// Typography\n\n@mixin text-emphasis-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    color: $color !important;\n  }\n  @if $emphasized-link-hover-darken-percentage != 0 {\n    a#{$parent} {\n      @include hover-focus() {\n        color: darken($color, $emphasized-link-hover-darken-percentage) !important;\n      }\n    }\n  }\n  @include deprecate(\"`text-emphasis-variant()`\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// CSS image replacement\n@mixin text-hide($ignore-warning: false) {\n  // stylelint-disable-next-line font-family-no-missing-generic-family-keyword\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n\n  @include deprecate(\"`text-hide()`\", \"v4.1.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Visibility utilities\n//\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type\n\n// Source: https://github.com/h5bp/main.css/blob/master/src/_print.css\n\n// ==========================================================================\n// Print styles.\n// Inlined to avoid the additional HTTP request:\n// https://www.phpied.com/delay-loading-your-print-css/\n// ==========================================================================\n\n@if $enable-print-styles {\n  @media print {\n    *,\n    *::before,\n    *::after {\n      // Bootstrap specific; comment out `color` and `background`\n      //color: $black !important; // Black prints faster\n      text-shadow: none !important;\n      //background: transparent !important;\n      box-shadow: none !important;\n    }\n\n    a {\n      &:not(.btn) {\n        text-decoration: underline;\n      }\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //a[href]::after {\n    //  content: \" (\" attr(href) \")\";\n    //}\n\n    abbr[title]::after {\n      content: \" (\" attr(title) \")\";\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //\n    // Don't show links that are fragment identifiers,\n    // or use the `javascript:` pseudo protocol\n    //\n\n    //a[href^=\"#\"]::after,\n    //a[href^=\"javascript:\"]::after {\n    // content: \"\";\n    //}\n\n    pre {\n      white-space: pre-wrap !important;\n    }\n    pre,\n    blockquote {\n      border: $border-width solid $gray-500; // Bootstrap custom code; using `$border-width` instead of 1px\n      page-break-inside: avoid;\n    }\n\n    tr,\n    img {\n      page-break-inside: avoid;\n    }\n\n    p,\n    h2,\n    h3 {\n      orphans: 3;\n      widows: 3;\n    }\n\n    h2,\n    h3 {\n      page-break-after: avoid;\n    }\n\n    // Bootstrap specific changes start\n\n    // Specify a size and min-width to make printing closer across browsers.\n    // We don't set margin here because it breaks `size` in Chrome. We also\n    // don't use `!important` on `size` as it breaks in Chrome.\n    @page {\n      size: $print-page-size;\n    }\n    body {\n      min-width: $print-body-min-width !important;\n    }\n    .container {\n      min-width: $print-body-min-width !important;\n    }\n\n    // Bootstrap components\n    .navbar {\n      display: none;\n    }\n    .badge {\n      border: $border-width solid $black;\n    }\n\n    .table {\n      border-collapse: collapse !important;\n\n      td,\n      th {\n        background-color: $white !important;\n      }\n    }\n\n    .table-bordered {\n      th,\n      td {\n        border: 1px solid $gray-300 !important;\n      }\n    }\n\n    .table-dark {\n      color: inherit;\n\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $table-border-color;\n      }\n    }\n\n    .table .thead-dark th {\n      color: inherit;\n      border-color: $table-border-color;\n    }\n\n    // Bootstrap specific changes end\n  }\n}\n","html{\n    font-size: $fs-base-mob;\n}\n@if($fs-base-mob < $fs-base-tab) {\n    @include media-breakpoint-up(lg){\n        html{\n            font-size: $fs-base-tab;\n        }\n    }    \n}\n@if($fs-base-tab < $fs-base-dsk) {\n    @include media-breakpoint-up(lg){\n        html{\n            font-size: $fs-base-dsk;\n        }\n    }\n}\nol, ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\na{\n    transition: color .4s, background-color .4s, border .4s, box-shadow .4s;\n    &:focus{\n        outline: none;\n    }\n}\nimg{\n    max-width: 100%;\n}\nstrong{\n    font-weight: 500;\n}\nh1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6, p{\n    &:last-child{\n        margin-bottom: 0;\n    }\n}","h1, .h1, h2, .h2 {letter-spacing: -0.03em;}\nh3, .h3, h4, .h4 {letter-spacing: -0.02em;}\nh5, .h5, h6, .h6 {letter-spacing: -0.01em;}\n\n@include media-breakpoint-up(lg){\n    h1, .h1 { @include font-size($h1-fs-lg); font-weight: $fw-normal; letter-spacing: -0.04em;}\n    h2, .h2 { @include font-size($h2-fs-lg); letter-spacing: -0.03em;}\n    h3, .h3 { @include font-size($h3-fs-lg); letter-spacing: -0.03em;}\n    h4, .h4 { @include font-size($h4-fs-lg); }\n    h5, .h5 { @include font-size($h5-fs-lg); }\n    h6, .h6 { @include font-size($h6-fs-lg); }\n}\n.list-inline{\n    li{\n        display: inline-block;\n        &:not(:last-child){\n            margin-right: 1rem;\n        }\n    }\n}\n.ellipsis{\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis\n}\n.text-ellipsis{\n    @extend .ellipsis;\n}\n.ccap{\n    @extend .text-capitalize;\n}\n.lcap{\n    @extend .text-lowercase;\n}\n.ucap{\n    @extend .text-uppercase;\n}\n.ff {\n    &-mono {\n        @extend .text-monospace\n    }\n    &-base {\n        font-family: $base-font-family !important;\n    }\n    &-alt {\n        font-family: $alt-font-family !important;\n    }\n    &-italic {\n        @extend .font-italic;\n    }\n}\n.fw{\n    &-light{\n        @extend .font-weight-light;\n        &er{\n            @extend .font-weight-lighter;\n        }\n    }\n    &-normal{\n        @extend .font-weight-normal;\n    }\n    &-medium{\n        font-weight: $fw-medium !important;\n    }\n    &-bold{\n        @extend .font-weight-bold;\n        &er{\n            @extend .font-weight-bolder;\n        }\n    }\n}\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  .text-white &{\n    color: $white;\n  }\n}\n@if($lead-fs < $lead-fs-dsk) {\n    @include media-breakpoint-up(lg){\n        .lead{\n            font-size: $lead-fs-dsk;\n        }\n    }\n}\n","@mixin text-color-class($class, $color) {\n    #{$class} {\n      color: $color !important;\n    }\n    @if $emphasized-link-hover-darken-percentage != 0 {\n      a#{$class} {\n        &:hover,&:focus {\n          color: darken($color, $emphasized-link-hover-darken-percentage) !important;\n        }\n      }\n    }\n}\n.text{\n  &-soft{\n    color: $base-light !important;\n  }\n  &-base{\n    color: $base-text !important;\n  }\n  &-head{\n    color: $base-color !important;\n  }\n}\n",".circle {\n    border-radius: 50%;\n}\n.round{\n    border-radius: $border-radius;\n    &-sm{\n        border-radius: $border-radius-sm;\n    }\n    &-lg{\n        border-radius: $border-radius-lg;\n    }\n    &-xl{\n        border-radius: $border-radius-lg * 2;\n    }\n}\nsvg{\n    height: 100%;\n    max-width: 100%;\n}\n.sq{\n    height: 40px;\n    width: 40px;\n    &-xs{\n        height: 18px;\n        width: 18px;\n    }\n    &-sm{\n        height: 24px;\n        width: 24px;\n    }\n    &-md{\n        height: 32px;\n        width: 32px;\n    }\n    &-lg{\n        height: 60px;\n        width: 60px;\n    }\n    &-xl{\n        height: 80px;\n        width: 80px;\n    }\n}\n.divider {\n    border-top: 1px solid $border-light !important;\n    margin: $gutter-width 0;\n    display: block;\n    &.xs {\n        margin: .5rem 0;\n    }\n    &.sm {\n        margin: 1rem 0;\n    }\n    &.md {\n        margin: 1.5rem 0;\n    }\n    &.lg {\n        margin: 2.25rem 0;\n    }\n    &.xl {\n        margin: 2.75rem 0;\n    }\n    \n}","@mixin bg-class($class, $color) {\n    #{$class} {\n      background-color: $color !important;\n    }\n    a#{$class},\n    button#{$class} {\n      &:hover,&:focus{\n        background-color: darken($color, 10%) !important;\n      }\n    }\n}\n\n@each $name, $color in $extend-colors{\n  .bg-#{$name} {background-color: $color !important;}\n  .text-#{$name} {color: $color !important;}\n}\n\n@each $color, $value in $grays {\n  .bg-gray-#{$color} {\n    background-color: $value !important;\n  }\n}\n\n$bg-abstract: linear-gradient(to right, #2c3782 calc(60% - 150px), #39469f calc(60% - 150px), #39469f 60%, #4856b5 60%, #4856b5 calc(60% + 150px),#5b6ac6 calc(60% + 150px),#5b6ac6 100%);\n.bg{\n    &-abstract{\n      background-image: $bg-abstract;\n    }\n}\n\n.bg-white-1 {\n  background: rgba($white, 0.1) !important;\n}\n.bg-white-2 {\n  background: rgba($white, 0.2) !important;\n}\n.bg-white-3 {\n  background: rgba($white, 0.3) !important;\n}\n.bg-white-4 {\n  background: rgba($white, 0.4) !important;\n}\n.bg-white-5 {\n  background: rgba($white, 0.5) !important;\n}\n.bg-white-6 {\n  background: rgba($white, 0.6) !important;\n}\n.bg-white-7 {\n  background: rgba($white, 0.7) !important;\n}\n.bg-white-8 {\n  background: rgba($white, 0.8) !important;\n}\n.bg-white-9 {\n  background: rgba($white, 0.9) !important;\n}",".border{\n    &-transparent{\n        border-color: transparent;\n    }\n}","$fixed-widths: 80px, 90px, 100px, 110px, 120px, 125px, 130px, 140px, 150px, 175px, 200px, 220px, 225px, 250px, 300px, 350px, 400px, 550px;\n  \n@each $size in $fixed-widths {\n  .w-#{$size} {\n    width: $size !important;\n  }\n  .w-min-#{$size} {\n    min-width: $size !important;\n  }\n  .w-max-#{$size} {\n    max-width: $size !important;\n  }\n}\n.w-max-100 {\n  max-width: 100% !important;\n}\n.w-min-100 {\n  min-width: 100% !important;\n}\n.w-max-auto {\n  max-width: inherit !important;\n}\n.w-min-auto {\n  min-width: auto !important;\n}\n\n$pc-widths: 15 15%, 20 20%, 30 30%, 35 35%, 40 40%, 45 45%, 55 55%, 60 60%, 65 65%, 70 70%, 80 80%, 85 85%, 90 90%, 95 95%;\n@each $name, $size in $pc-widths {\n  .w-#{$name} {\n    width: $size !important;\n  }\n}\n\n// width by name \n$wide-sizes:  \n  xs      520px     576px, \n  sm      720px     768px, \n  md      960px     992px, \n  lg      1140px    1200px, \n  xl      1240px    1280px;\n//$name   $wide     $point\n@each $name, $wide, $point in $wide-sizes {\n  @media (min-width:#{$point}){\n    .wide-#{$name} {\n      max-width: $wide !important;\n      &-fix {\n        width: $wide !important;\n      }\n    }\n  }\n}\n@each $name, $wide in $wide-sizes {\n    .wide-#{$name} {\n      &-fix {\n        width: $wide !important;\n      }\n    }\n}\n\n.wide-xs-fix, .wide-sm-fix, .wide-md-fix, .wide-lg-fix {\n @extend .w-max-100;\n}\n@media (min-width: 1200px) and (max-width: 1660px){\n  .wide-fit {\n    max-width: 1140px;\n  }\n}\n\n\n$fixed-heights: 100px, 150px, 175px, 200px, 225px, 250px, 275px, 300px, 325px, 350px, 375px, 400px, 425px, 450px, 475px, 500px;\n\n@each $size in $fixed-heights {\n  .h-#{$size} {\n    height: $size !important;\n  }\n  .h-min-#{$size} {\n    min-height: $size !important;\n  }\n  .h-max-#{$size} {\n    max-height: $size !important;\n  }\n}",".absolute{\n    &-top-left{\n        position: absolute;\n        top: 0;\n        left: 0;\n    }\n    &-top-right{\n        position: absolute;\n        top: 0;\n        right: 0;\n    }\n    &-bottom-left{\n        position: absolute;\n        bottom: 0;\n        left: 0;\n    }\n    &-bottom-right{\n        position: absolute;\n        bottom: 0;\n        right: 0;\n    }\n}\n.pos-rel {\n    @extend .position-relative;\n}\n.pos-abs {\n    @extend .position-absolute;\n}",".align-start{\n    @extend .d-flex;\n    @extend .align-items-start;\n}\n.align-end{\n    @extend .d-flex;\n    @extend .align-items-end;\n}\n.align-center{\n    @extend .d-flex;\n    @extend .align-items-center;\n}\n.justify-start{\n    @extend .d-flex;\n    @extend .justify-content-start;\n}\n.justify-end{\n    @extend .d-flex;\n    @extend .justify-content-end;\n}\n.justify-center{\n    @extend .d-flex;\n    @extend .justify-content-center;\n}\n.justify-between{\n    @extend .d-flex;\n    @extend .justify-content-between;\n}\n.justify-around{\n    @extend .d-flex;\n    @extend .justify-content-around;\n}\n.between-start{\n    @extend .d-flex;\n    @extend .justify-content-between;\n    @extend .align-items-start;\n}\n.between-center{\n    @extend .d-flex;\n    @extend .justify-content-between;\n    @extend .align-items-center;\n}\n.center{\n    @extend .d-flex;\n    @extend .justify-content-center;\n    @extend .align-items-center;\n}\n.stretch{\n    @extend .d-flex;\n    @extend .align-items-stretch;\n}\n.shrink-0{\n    flex-shrink: 0;\n}",".badge{\n    position: relative;\n    border: 1px solid currentColor;\n    line-height: $badge-line-height;\n    font-family: $base-font-family;\n    letter-spacing: 0.01em;\n    vertical-align: middle;\n    display: inline-flex;\n    .icon + span,span + .icon{\n        padding-left: 4px;\n    }\n    &-sm{\n        padding: $badge-padding-y-sm $badge-padding-x-sm;\n        font-size:$badge-font-size-sm;\n\n        &.badge-pill{\n            padding: $badge-padding-y-sm $badge-pill-padding-x-sm;\n        }\n    }\n    &-md{\n        padding: $badge-padding-y-md $badge-padding-x-md;\n        font-size:$badge-font-size-md !important;\n    }\n    &-lg{\n        padding: $badge-padding-y-lg $badge-padding-x-lg;\n        font-size:$badge-font-size-lg !important;\n    }\n    &-xl{\n        padding: $badge-padding-y-xl $badge-padding-x-xl;\n        font-size:$badge-font-size-xl !important;\n    }\n    &-light {\n        color: $secondary;\n    }\n    &-lighter {\n        color: $secondary-light;\n    }\n    .icon{\n        font-size: 1rem;\n    }\n}\n@each $name, $value in $theme-colors {\n    .badge-#{$name} {\n        border-color: $value;\n    }\n}\n\n$outline-badges: map-merge(\n    $theme-colors,\n    (\n        \"light\":       $light-400,\n        \"lighter\":     $light-200\n    )\n);\n\n@each $name, $value in $outline-badges {\n    .badge-outline-#{$name} {\n        color: $value;\n        border-color: mix($value, $white, 60%);\n    }\n}\n$dim-mix:           #fff;\n$dim-badge: map-merge(\n    $theme-colors,\n    (\n        \"light\":       $light-400,\n        \"lighter\":     $light-200\n    )\n);\n\n@each $name, $color in $dim-badge {\n    .badge-dim.badge-#{$name} {\n        color: $color;\n        background-color: mix($color, $dim-mix, 11%);\n        border-color: mix($color, $dim-mix, 11%);\n    }\n    .badge-dim.badge-outline-#{$name} {\n        color: $color;\n        background-color: mix($color, $dim-mix, 11%);\n        border-color: mix($color, $dim-mix, 40%);\n    }\n}\n\n.badge-dot{\n    display: inline-flex;\n    align-items: center;\n    background-color: transparent;\n    border:none;\n    padding-left: $badge-dot-width + $badge-dot-gap;\n    padding-right: 0;\n    font-size: $fx-sz-12;\n    &:before{\n        position: absolute;\n        content: \"\";\n        left: 0;\n        top: 50%;\n        transform: translateY(-50%);\n        display: inline-block; \n        height: $badge-dot-width;\n        width: $badge-dot-width;\n        margin-top: -1px;\n        border-radius:50%;\n        background: currentColor;\n    }\n    &.has-bg{\n        border-radius: 20px;\n        padding:3px ($badge-dot-width + $badge-dot-gap) 3px ($badge-dot-width + $badge-dot-gap)*2;\n        &:before{\n            left: ($badge-dot-width + $badge-dot-gap);\n            margin-top: 0;\n        }\n    }\n    &.badge-sm, &.badge-md {\n        padding-left: $badge-dot-width-sm + $badge-dot-gap-sm;\n        &:before{\n            height: $badge-dot-width-sm;\n            width: $badge-dot-width-sm;\n            margin-top: 0;\n        }\n        &.has-bg{\n            border-radius: 20px;\n            padding:5px ($badge-dot-width-sm + $badge-dot-gap-sm)*.75 5px ($badge-dot-width-sm + $badge-dot-gap-sm)*1.75;\n            &:before{\n                left: ($badge-dot-width-sm + $badge-dot-gap-sm)*.75;\n            }\n        }\n    }\n    &.badge-lg, &.badge-xl{\n        padding-left: ($badge-dot-width * 2) + ($badge-dot-gap-sm + 4);\n        &:before{\n            height: ($badge-dot-width * 2);\n            width: ($badge-dot-width * 2);\n            margin-top: 0;\n        }\n    }\n}\n\n$dot-badge: map-merge(\n    $theme-colors,\n    (\n        \"light\":       $light-400,\n        \"lighter\":     $light-200\n    )\n);\n@each $name, $color in $dot-badge {\n    .badge-dot{\n        &.badge-#{$name} {\n            color: $color;\n            &.has-bg{\n                background-color: rgba($color,.15);\n            }\n        }\n    }\n}\n\n@include media-breakpoint-down(sm){\n    .badge-dot-sm {\n        width: 0;\n        overflow: hidden;\n    }\n}\n\n@media (max-width: 413px) {\n    .badge-dot-mb {\n        width: 0;\n        overflow: hidden;\n    }\n}\n\n@media (max-width: 369px) {\n    .badge-dot-xs {\n        width: 0;\n        overflow: hidden;\n    }\n}",".alert{\n    &:last-child{\n        margin-bottom: 0;\n    }\n    &-link {\n        box-shadow: 0 1px 0 currentColor;\n        &:hover {\n            box-shadow: none;\n        }\n    }\n    h5, h6, .title {\n        font-size: ($h6-font-size * 1.05);\n    }\n    &.alert-icon{\n        padding-left: $alert-padding-x + $alert-icon-width;\n        > .icon{\n            position: absolute;\n            font-size: 1.25rem;\n            line-height: 1;\n            width: $alert-icon-width;\n            top: $alert-padding-y;\n            left: $alert-padding-x;\n            margin-left:-1px;\n        }\n    }\n    &-dismissible{\n        .close{\n            top: 50%;\n            transform: translateY(-50%);\n            transition: .3s ease;\n            margin-top: -1px;\n            [aria-hidden=\"true\"]{\n                display:none;\n            }\n            &:focus{\n                outline: none;\n            }\n            &:hover{\n                color: currentColor;\n            }\n            &:after{\n                font-family: $nk-dashlite-font;\n                content: $ni-cross;\n                font-size: 1.1rem;\n            }\n        }\n    }\n    &-light, &-lighter, &-gray {\n        border-color: $border-light;\n        color: $base-text;\n        .alert-link {\n            color: $base-text;\n        }\n    }\n    &-alt{\n        position: relative;\n        padding: .875rem;\n        border-radius: $border-radius-xxl;\n        &.alert-icon{\n            padding-left: 4rem;\n            > .icon{\n                position: absolute;\n                font-size: 2rem;\n                line-height: 1;\n                width: 4rem;\n                top: 50%;\n                left: 0;\n                transform: translateY(-50%);\n                text-align: center;\n                opacity: 0.5;\n            }\n        }\n    }\n}\na.alert:hover{\n    color: currentColor;\n}\n\n$alert-fill: map-merge(\n    $theme-colors,\n    (\n        \"light\": $light-200,\n        \"lighter\": $light-100,\n    )\n);\n@each $state, $bg in $alert-fill {\n    .alert-fill.alert-#{$state}{\n        color: color-yiq($bg);\n        background: $bg;\n        \n    }\n}\n.alert-fill {\n    border-width: 0;\n    .alert-link, .icon, h4, h5, h6 {\n        color: currentColor;\n    }\n    &.alert-light{\n        color: $secondary;\n    }\n    &.alert-lighter{\n        color: $secondary-light;\n    }\n}\n\n$alert-pro: map-merge(\n    $theme-colors,\n    (\n        \"light\":       $light-400,\n        \"lighter\":     $light-400\n    )\n);\n\n.alert-pro{\n    box-shadow: 0 4px 15px 0 rgba($dark,.1);\n    border: none;\n    border-left: 4px solid transparent;\n    color: $base-text;\n    line-height: 1.5;\n    background: $white;\n    &.no-shadow {\n        box-shadow: none;\n    }\n    &.no-border {\n        border-left: 0;\n    }\n    &.alert-icon {\n        padding-left: $alert-padding-x + $alert-pro-icon-width;\n        > .icon {\n            font-size: 1.75rem;\n            top: 50%;\n            transform: translateY(-50%);\n        }\n    }\n}\n@each $state, $color in $alert-pro {\n    .alert-pro.alert-#{$state}{\n        border-color: $color;\n        > .icon {\n            color: $color;\n        }\n    }\n}\n","$icomoon-font-family: \"Nioicon\" !default;\n$icomoon-font-path: $nk-dashlite-font-url !default;\n\n$ni-centos: \"\\ece6\";\n$ni-covid: \"\\ece7\";\n$ni-fedora: \"\\ece8\";\n$ni-hot-fill: \"\\ece9\";\n$ni-hot: \"\\ecea\";\n$ni-linux-server: \"\\eceb\";\n$ni-linux: \"\\ecec\";\n$ni-note-add-fill: \"\\eced\";\n$ni-repeat-fill: \"\\ecee\";\n$ni-tranx-fill: \"\\ecef\";\n$ni-ubuntu: \"\\ecf0\";\n$ni-virus: \"\\ecf1\";\n$ni-b-chrome: \"\\ec63\";\n$ni-b-edge: \"\\ec64\";\n$ni-b-firefox: \"\\ec94\";\n$ni-b-ie: \"\\ec95\";\n$ni-b-opera: \"\\ec96\";\n$ni-b-safari: \"\\ec97\";\n$ni-b-si: \"\\ec98\";\n$ni-b-uc: \"\\ec99\";\n$ni-brick-fill: \"\\ec9a\";\n$ni-brick: \"\\ec9b\";\n$ni-col-3s: \"\\ec9c\";\n$ni-col-4s: \"\\ec9d\";\n$ni-col-2s: \"\\ec9e\";\n$ni-comments: \"\\ec9f\";\n$ni-dot-sq: \"\\eca0\";\n$ni-dot: \"\\eca1\";\n$ni-footer: \"\\eca2\";\n$ni-header: \"\\eca3\";\n$ni-heading: \"\\eca4\";\n$ni-layout-alt-fill: \"\\eca5\";\n$ni-layout-alt: \"\\eca6\";\n$ni-layout-fill1: \"\\eca7\";\n$ni-layout1: \"\\eca8\";\n$ni-list-index-fill: \"\\eca9\";\n$ni-list-index: \"\\ecaa\";\n$ni-list-thumb-alt-fill: \"\\ecab\";\n$ni-list-thumb-alt: \"\\ecac\";\n$ni-list-thumb-fill: \"\\ecad\";\n$ni-list-thumb: \"\\ecae\";\n$ni-masonry-fill: \"\\ecaf\";\n$ni-masonry: \"\\ecb0\";\n$ni-menu-circled: \"\\ecb1\";\n$ni-menu-squared: \"\\ecb2\";\n$ni-notice: \"\\ecb3\";\n$ni-pen2: \"\\ecb4\";\n$ni-property-blank: \"\\ecb5\";\n$ni-propert-blank: \"\\ecb5\";\n$ni-property-add: \"\\ecb6\";\n$ni-property-alt: \"\\ecb7\";\n$ni-property-remove: \"\\ecb8\";\n$ni-property: \"\\ecb9\";\n$ni-puzzle-fill: \"\\ecba\";\n$ni-puzzle: \"\\ecbb\";\n$ni-quote-left: \"\\ecbc\";\n$ni-quote-right: \"\\ecbd\";\n$ni-row-mix: \"\\ecbe\";\n$ni-row-view1: \"\\ecbf\";\n$ni-sidebar-r: \"\\ecc0\";\n$ni-text2: \"\\ecc1\";\n$ni-tile-thumb-fill: \"\\ecc2\";\n$ni-tile-thumb: \"\\ecc3\";\n$ni-view-col-fill: \"\\ecc4\";\n$ni-view-col-sq: \"\\ecc5\";\n$ni-view-col: \"\\ecc6\";\n$ni-view-col2: \"\\ecc7\";\n$ni-view-col3: \"\\ecc8\";\n$ni-view-cols-fill: \"\\ecc9\";\n$ni-view-cols-sq: \"\\ecca\";\n$ni-view-cols: \"\\eccb\";\n$ni-view-grid-fill: \"\\eccc\";\n$ni-view-grid-sq: \"\\eccd\";\n$ni-view-grid-wd: \"\\ecce\";\n$ni-view-grid: \"\\eccf\";\n$ni-view-grid2-wd: \"\\ecd0\";\n$ni-view-grid3-wd: \"\\ecd1\";\n$ni-view-group-fill: \"\\ecd2\";\n$ni-view-group-wd: \"\\ecd3\";\n$ni-view-list-fill: \"\\ecd4\";\n$ni-view-list-sq: \"\\ecd5\";\n$ni-view-list-wd: \"\\ecd6\";\n$ni-view-list: \"\\ecd7\";\n$ni-view-panel-fill: \"\\ecd8\";\n$ni-view-panel-sq: \"\\ecd9\";\n$ni-view-panel: \"\\ecda\";\n$ni-view-row-fill: \"\\ecdb\";\n$ni-view-row-sq: \"\\ecdc\";\n$ni-view-row-wd: \"\\ecdd\";\n$ni-view-row: \"\\ecde\";\n$ni-view-x1: \"\\ecdf\";\n$ni-view-x2: \"\\ece0\";\n$ni-view-x3: \"\\ece1\";\n$ni-view-x4: \"\\ece2\";\n$ni-view-x5: \"\\ece3\";\n$ni-view-x6: \"\\ece4\";\n$ni-view-x7: \"\\ece5\";\n$ni-dashlite: \"\\eb91\";\n$ni-dashlite-circle: \"\\ec56\";\n$ni-dashlite-alt: \"\\ec57\";\n$ni-master-card: \"\\ec58\";\n$ni-paypal: \"\\ec59\";\n$ni-visa-alt: \"\\ec5a\";\n$ni-coin-eur: \"\\ec5b\";\n$ni-coin-gbp: \"\\ec5c\";\n$ni-sign-ada-alt: \"\\ec5d\";\n$ni-sign-bch-alt: \"\\ec5e\";\n$ni-sign-bgp-alt: \"\\ec5f\";\n$ni-sign-bnb-alt: \"\\ec60\";\n$ni-sign-brl-alt: \"\\ec61\";\n$ni-sign-btc-alt: \"\\ec62\";\n$ni-sign-cc-alt: \"\\ec65\";\n$ni-sign-cc-alt2: \"\\ec66\";\n$ni-sign-chf-alt: \"\\ec67\";\n$ni-sign-cny-alt: \"\\ec68\";\n$ni-sign-czk-alt: \"\\ec69\";\n$ni-sign-dash-alt: \"\\ec6a\";\n$ni-sign-dkk-alt: \"\\ec6b\";\n$ni-sign-eos-alt: \"\\ec6c\";\n$ni-sign-eth-alt: \"\\ec6d\";\n$ni-sign-eur-alt2: \"\\ec6e\";\n$ni-sign-euro-alt: \"\\ec6f\";\n$ni-sign-gbp-alt2: \"\\ec70\";\n$ni-sign-hkd-alt: \"\\ec71\";\n$ni-sign-idr-alt: \"\\ec72\";\n$ni-sign-inr-alt: \"\\ec73\";\n$ni-sign-jpy-alt: \"\\ec74\";\n$ni-sign-kr-alt: \"\\ec75\";\n$ni-sign-ltc-alt: \"\\ec76\";\n$ni-sign-ltc: \"\\ec77\";\n$ni-sign-mxn-alt: \"\\ec78\";\n$ni-sign-mxr-alt: \"\\ec79\";\n$ni-sign-myr-alt: \"\\ec7a\";\n$ni-sign-paypal-alt: \"\\ec7b\";\n$ni-sign-paypal-full: \"\\ec7c\";\n$ni-sign-php-alt: \"\\ec7d\";\n$ni-sign-pln-alt: \"\\ec7e\";\n$ni-sign-rub-alt: \"\\ec7f\";\n$ni-sign-sek-alt: \"\\ec80\";\n$ni-sign-sgd-alt: \"\\ec81\";\n$ni-sign-kobo-alt: \"\\ec82\";\n$ni-sign-steem-alt: \"\\ec83\";\n$ni-sign-steller-alt: \"\\ec84\";\n$ni-sign-stripe-fulll: \"\\ec85\";\n$ni-sign-thb-alt: \"\\ec86\";\n$ni-sign-trx-alt: \"\\ec87\";\n$ni-sign-try-alt: \"\\ec88\";\n$ni-sign-usd-alt: \"\\ec89\";\n$ni-sign-usd-alt2: \"\\ec8a\";\n$ni-sign-usdc-alt: \"\\ec8b\";\n$ni-sign-usdt-alt: \"\\ec8c\";\n$ni-sign-visa-alt: \"\\ec8d\";\n$ni-sign-vnd-alt: \"\\ec8e\";\n$ni-sign-waves-alt: \"\\ec8f\";\n$ni-sign-xem-alt: \"\\ec90\";\n$ni-sign-xrp-new-alt: \"\\ec91\";\n$ni-sign-xrp-old-alt: \"\\ec92\";\n$ni-sign-zcash-alt: \"\\ec93\";\n$ni-chevron-left: \"\\e9cc\";\n$ni-chevron-right: \"\\e9d3\";\n$ni-chevron-up: \"\\e9da\";\n$ni-chevron-down: \"\\e9c5\";\n$ni-chevron-left-round: \"\\e9cb\";\n$ni-chevron-right-round: \"\\e9d2\";\n$ni-chevron-up-round: \"\\e9d9\";\n$ni-chevron-down-round: \"\\e9c4\";\n$ni-chevron-left-round-fill: \"\\e9ca\";\n$ni-chevron-right-round-fill: \"\\e9d1\";\n$ni-chevron-up-round-fill: \"\\e9d8\";\n$ni-chevron-down-round-fill: \"\\e9c3\";\n$ni-chevron-left-c: \"\\e9c6\";\n$ni-chevron-right-c: \"\\e9cd\";\n$ni-chevron-up-c: \"\\e9d4\";\n$ni-chevron-down-c: \"\\e9bf\";\n$ni-chevron-left-fill-c: \"\\e9c9\";\n$ni-chevron-right-fill-c: \"\\e9d0\";\n$ni-chevron-up-fill-c: \"\\e9d7\";\n$ni-chevron-down-fill-c: \"\\e9c2\";\n$ni-chevron-left-circle: \"\\e9c8\";\n$ni-chevron-right-circle: \"\\e9cf\";\n$ni-chevron-up-circle: \"\\e9d6\";\n$ni-chevron-down-circle: \"\\e9c1\";\n$ni-chevron-left-circle-fill: \"\\e9c7\";\n$ni-chevron-right-circle-fill: \"\\e9ce\";\n$ni-chevron-up-circle-fill: \"\\e9d5\";\n$ni-chevron-down-circle-fill: \"\\e9c0\";\n$ni-caret-left: \"\\e99b\";\n$ni-caret-right: \"\\e99d\";\n$ni-caret-up: \"\\e99f\";\n$ni-caret-down: \"\\e999\";\n$ni-caret-left-fill: \"\\e99a\";\n$ni-caret-right-fill: \"\\e99c\";\n$ni-caret-up-fill: \"\\e99e\";\n$ni-caret-down-fill: \"\\e998\";\n$ni-sort: \"\\ebbf\";\n$ni-sort-up: \"\\ebbd\";\n$ni-sort-down: \"\\ebb9\";\n$ni-sort-fill: \"\\ebba\";\n$ni-sort-up-fill: \"\\ebbc\";\n$ni-sort-down-fill: \"\\ebb8\";\n$ni-sort-v: \"\\ebbe\";\n$ni-swap-v: \"\\ebdc\";\n$ni-swap: \"\\ebdd\";\n$ni-arrow-left-round: \"\\e937\";\n$ni-arrow-right-round: \"\\e942\";\n$ni-arrow-up-round: \"\\e94f\";\n$ni-arrow-down-round: \"\\e92c\";\n$ni-arrow-left-round-fill: \"\\e936\";\n$ni-arrow-right-round-fill: \"\\e941\";\n$ni-arrow-up-round-fill: \"\\e94e\";\n$ni-arrow-down-round-fill: \"\\e92b\";\n$ni-arrow-left-c: \"\\e932\";\n$ni-arrow-right-c: \"\\e93d\";\n$ni-arrow-up-c: \"\\e948\";\n$ni-arrow-down-c: \"\\e925\";\n$ni-arrow-left-fill-c: \"\\e935\";\n$ni-arrow-right-fill-c: \"\\e940\";\n$ni-arrow-up-fill-c: \"\\e94b\";\n$ni-arrow-down-fill-c: \"\\e928\";\n$ni-arrow-left-circle: \"\\e934\";\n$ni-arrow-right-circle: \"\\e93f\";\n$ni-arrow-up-circle: \"\\e94a\";\n$ni-arrow-down-circle: \"\\e927\";\n$ni-arrow-left-circle-fill: \"\\e933\";\n$ni-arrow-up-circle-fill: \"\\e949\";\n$ni-arrow-down-circle-fill: \"\\e926\";\n$ni-arrow-right-circle-fill: \"\\e93e\";\n$ni-chevrons-left: \"\\e9dc\";\n$ni-chevrons-right: \"\\e9dd\";\n$ni-chevrons-up: \"\\e9de\";\n$ni-chevrons-down: \"\\e9db\";\n$ni-first: \"\\ea59\";\n$ni-last: \"\\eab8\";\n$ni-back-ios: \"\\e958\";\n$ni-forward-ios: \"\\ea6d\";\n$ni-upword-ios: \"\\ec20\";\n$ni-downward-ios: \"\\ea23\";\n$ni-back-alt: \"\\e955\";\n$ni-forward-alt: \"\\ea69\";\n$ni-upword-alt: \"\\ec1f\";\n$ni-downward-alt: \"\\ea22\";\n$ni-back-alt-fill: \"\\e954\";\n$ni-forward-alt-fill: \"\\ea68\";\n$ni-upword-alt-fill: \"\\ec1e\";\n$ni-downward-alt-fill: \"\\ea21\";\n$ni-arrow-long-left: \"\\e93a\";\n$ni-arrow-long-right: \"\\e93b\";\n$ni-arrow-long-up: \"\\e93c\";\n$ni-arrow-long-down: \"\\e939\";\n$ni-arrow-left: \"\\e938\";\n$ni-arrow-right: \"\\e943\";\n$ni-arrow-up: \"\\e950\";\n$ni-arrow-down: \"\\e92d\";\n$ni-arrow-up-left: \"\\e94c\";\n$ni-arrow-up-right: \"\\e94d\";\n$ni-arrow-down-left: \"\\e929\";\n$ni-arrow-down-right: \"\\e92a\";\n$ni-arrow-to-left: \"\\e945\";\n$ni-arrow-to-right: \"\\e946\";\n$ni-arrow-to-up: \"\\e947\";\n$ni-arrow-to-down: \"\\e944\";\n$ni-arrow-from-left: \"\\e92f\";\n$ni-arrow-from-right: \"\\e930\";\n$ni-arrow-from-up: \"\\e931\";\n$ni-arrow-from-down: \"\\e92e\";\n$ni-curve-down-left: \"\\ea0b\";\n$ni-curve-up-right: \"\\ea12\";\n$ni-curve-up-left: \"\\ea11\";\n$ni-curve-down-right: \"\\ea0c\";\n$ni-curve-left-up: \"\\ea0e\";\n$ni-curve-right-up: \"\\ea10\";\n$ni-curve-left-down: \"\\ea0d\";\n$ni-curve-right-down: \"\\ea0f\";\n$ni-back-arrow: \"\\e957\";\n$ni-forward-arrow: \"\\ea6b\";\n$ni-back-arrow-fill: \"\\e956\";\n$ni-forward-arrow-fill: \"\\ea6a\";\n$ni-navigate: \"\\eb0f\";\n$ni-navigate-up: \"\\eb0e\";\n$ni-navigate-fill: \"\\eb0c\";\n$ni-navigate-up-fill: \"\\eb0d\";\n$ni-send: \"\\eb6f\";\n$ni-send-alt: \"\\eb6e\";\n$ni-unfold-less: \"\\ec15\";\n$ni-unfold-more: \"\\ec16\";\n$ni-exchange-v: \"\\ea32\";\n$ni-exchange: \"\\ea33\";\n$ni-expand: \"\\ea34\";\n$ni-shrink: \"\\eb83\";\n$ni-focus: \"\\ea5e\";\n$ni-maximize: \"\\eadf\";\n$ni-minimize: \"\\eaf2\";\n$ni-maximize-alt: \"\\eade\";\n$ni-minimize-alt: \"\\eaf1\";\n$ni-shuffle: \"\\eb84\";\n$ni-cross-sm: \"\\ea05\";\n$ni-cross: \"\\ea06\";\n$ni-cross-round: \"\\ea04\";\n$ni-cross-circle: \"\\ea01\";\n$ni-cross-c: \"\\e9ff\";\n$ni-cross-round-fill: \"\\ea03\";\n$ni-cross-circle-fill: \"\\ea00\";\n$ni-cross-fill-c: \"\\ea02\";\n$ni-na: \"\\eb0b\";\n$ni-check: \"\\e9be\";\n$ni-check-thick: \"\\e9bd\";\n$ni-done: \"\\ea1c\";\n$ni-check-round: \"\\e9bc\";\n$ni-check-circle: \"\\e9b8\";\n$ni-check-c: \"\\e9b5\";\n$ni-check-round-fill: \"\\e9bb\";\n$ni-check-circle-fill: \"\\e9b7\";\n$ni-check-fill-c: \"\\e9b9\";\n$ni-check-circle-cut: \"\\e9b6\";\n$ni-check-round-cut: \"\\e9ba\";\n$ni-bullet: \"\\e981\";\n$ni-circle: \"\\e9e0\";\n$ni-square: \"\\ebca\";\n$ni-square-c: \"\\ebc7\";\n$ni-bullet-fill: \"\\e980\";\n$ni-circle-fill: \"\\e9df\";\n$ni-square-fill: \"\\ebc9\";\n$ni-square-fill-c: \"\\ebc8\";\n$ni-plus-sm: \"\\eb43\";\n$ni-minus-sm: \"\\eaf9\";\n$ni-plus: \"\\eb44\";\n$ni-minus: \"\\eafa\";\n$ni-plus-round: \"\\eb42\";\n$ni-minus-round: \"\\eaf8\";\n$ni-plus-circle: \"\\eb3d\";\n$ni-minus-circle: \"\\eaf5\";\n$ni-plus-c: \"\\eb3b\";\n$ni-minus-c: \"\\eaf3\";\n$ni-plus-round-fill: \"\\eb41\";\n$ni-plus-circle-fill: \"\\eb3c\";\n$ni-minus-round-fill: \"\\eaf7\";\n$ni-minus-circle-fill: \"\\eaf4\";\n$ni-plus-fill-c: \"\\eb3e\";\n$ni-minus-fill-c: \"\\eaf6\";\n$ni-plus-medi: \"\\eb40\";\n$ni-plus-medi-fill: \"\\eb3f\";\n$ni-equal-sm: \"\\ea30\";\n$ni-equal: \"\\ea31\";\n$ni-calc: \"\\e982\";\n$ni-search: \"\\eb6c\";\n$ni-zoom-out: \"\\ec55\";\n$ni-zoom-in: \"\\ec54\";\n$ni-play: \"\\eb3a\";\n$ni-play-fill: \"\\eb39\";\n$ni-play-circle: \"\\eb38\";\n$ni-play-circle-fill: \"\\eb37\";\n$ni-pause: \"\\eb26\";\n$ni-pause-fill: \"\\eb25\";\n$ni-pause-circle: \"\\eb24\";\n$ni-pause-circle-fill: \"\\eb23\";\n$ni-stop: \"\\ebd6\";\n$ni-stop-fill: \"\\ebd5\";\n$ni-stop-circle: \"\\ebd4\";\n$ni-stop-circle-fill: \"\\ebd3\";\n$ni-rewind: \"\\eb62\";\n$ni-forward: \"\\ea6e\";\n$ni-rewind-fill: \"\\eb61\";\n$ni-forward-fill: \"\\ea6c\";\n$ni-step-back: \"\\ebd1\";\n$ni-step-forward: \"\\ebd2\";\n$ni-vol-off: \"\\ec40\";\n$ni-vol-no: \"\\ec3f\";\n$ni-vol-half: \"\\ec3e\";\n$ni-vol: \"\\ec41\";\n$ni-mic: \"\\eaef\";\n$ni-mic-off: \"\\eaee\";\n$ni-video: \"\\ec39\";\n$ni-video-off: \"\\ec38\";\n$ni-video-fill: \"\\ec37\";\n$ni-loader: \"\\ead2\";\n$ni-power: \"\\eb47\";\n$ni-signout: \"\\ebb2\";\n$ni-signin: \"\\ebb1\";\n$ni-upload: \"\\ec1d\";\n$ni-download: \"\\ea20\";\n$ni-alert-circle: \"\\e90d\";\n$ni-alert: \"\\e910\";\n$ni-caution: \"\\e9a3\";\n$ni-report: \"\\eb5e\";\n$ni-alert-c: \"\\e90b\";\n$ni-alert-circle-fill: \"\\e90c\";\n$ni-alert-fill: \"\\e90f\";\n$ni-caution-fill: \"\\e9a2\";\n$ni-report-fill: \"\\eb5c\";\n$ni-alert-fill-c: \"\\e90e\";\n$ni-info-i: \"\\eaa8\";\n$ni-info: \"\\eaa9\";\n$ni-info-fill: \"\\eaa7\";\n$ni-help: \"\\ea98\";\n$ni-help-fill: \"\\ea97\";\n$ni-archived: \"\\e924\";\n$ni-archive: \"\\e922\";\n$ni-unarchive: \"\\ec12\";\n$ni-archived-fill: \"\\e923\";\n$ni-archive-fill: \"\\e921\";\n$ni-unarchive-fill: \"\\ec11\";\n$ni-bag: \"\\e95a\";\n$ni-bag-fill: \"\\e959\";\n$ni-bell: \"\\e965\";\n$ni-bell-off: \"\\e964\";\n$ni-bell-fill: \"\\e962\";\n$ni-bell-off-fill: \"\\e963\";\n$ni-wifi: \"\\ec4b\";\n$ni-wifi-off: \"\\ec4a\";\n$ni-live: \"\\ead1\";\n$ni-signal: \"\\ebb0\";\n$ni-bluetooth: \"\\e96d\";\n$ni-blank-alt: \"\\e967\";\n$ni-blank: \"\\e968\";\n$ni-blank-fill: \"\\e969\";\n$ni-blankf-fill: \"\\e969\";\n$ni-block-over: \"\\e96a\";\n$ni-book-read: \"\\e970\";\n$ni-book: \"\\e971\";\n$ni-book-fill: \"\\e96f\";\n$ni-bulb-fill: \"\\e97e\";\n$ni-bulb: \"\\e97f\";\n$ni-calendar-alt-fill: \"\\e983\";\n$ni-calendar-alt: \"\\e984\";\n$ni-calendar-booking-fill: \"\\e985\";\n$ni-calendar-booking: \"\\e986\";\n$ni-calendar-check-fill: \"\\e987\";\n$ni-calendar-check: \"\\e988\";\n$ni-calendar-fill: \"\\e989\";\n$ni-calendar: \"\\e98a\";\n$ni-calender-date-fill: \"\\e98b\";\n$ni-calender-date: \"\\e98c\";\n$ni-call: \"\\e990\";\n$ni-call-alt: \"\\e98e\";\n$ni-call-alt-fill: \"\\e98d\";\n$ni-call-fill: \"\\e98f\";\n$ni-camera-fill: \"\\e991\";\n$ni-camera: \"\\e992\";\n$ni-capsule: \"\\e994\";\n$ni-capsule-fill: \"\\e993\";\n$ni-cards: \"\\e997\";\n$ni-cards-fill: \"\\e996\";\n$ni-cart: \"\\e9a1\";\n$ni-cart-fill: \"\\e9a0\";\n$ni-cc: \"\\e9ae\";\n$ni-cc-alt: \"\\e9a5\";\n$ni-cc-alt2: \"\\e9a7\";\n$ni-cc-secure: \"\\e9ac\";\n$ni-cc-new: \"\\e9a9\";\n$ni-cc-off: \"\\e9aa\";\n$ni-cc-fill: \"\\e9a8\";\n$ni-cc-alt-fill: \"\\e9a4\";\n$ni-cc-alt2-fill: \"\\e9a6\";\n$ni-cc-secure-fill: \"\\e9ab\";\n$ni-msg-circle: \"\\eb07\";\n$ni-chat-circle: \"\\e9b2\";\n$ni-msg: \"\\eb09\";\n$ni-chat: \"\\e9b4\";\n$ni-question-alt: \"\\eb4b\";\n$ni-question: \"\\eb4c\";\n$ni-msg-circle-fill: \"\\eb06\";\n$ni-chat-circle-fill: \"\\e9b1\";\n$ni-msg-fill: \"\\eb08\";\n$ni-chat-fill: \"\\e9b3\";\n$ni-clip-h: \"\\e9e1\";\n$ni-clip-v: \"\\e9e2\";\n$ni-clip: \"\\e9e3\";\n$ni-link-alt: \"\\eac5\";\n$ni-unlink: \"\\ec18\";\n$ni-unlink-alt: \"\\ec17\";\n$ni-link-h: \"\\eac7\";\n$ni-link-v: \"\\eac8\";\n$ni-link: \"\\eac9\";\n$ni-clipboard: \"\\e9e7\";\n$ni-clipboad-check: \"\\e9e5\";\n$ni-clipboard-fill: \"\\e9e6\";\n$ni-clipboad-check-fill: \"\\e9e4\";\n$ni-clock: \"\\e9e9\";\n$ni-clock-fill: \"\\e9e8\";\n$ni-cloud: \"\\e9eb\";\n$ni-upload-cloud: \"\\ec1c\";\n$ni-download-cloud: \"\\ea1f\";\n$ni-cloud-fill: \"\\e9ea\";\n$ni-contact: \"\\e9f9\";\n$ni-contact-fill: \"\\e9f8\";\n$ni-coffee: \"\\e9f0\";\n$ni-coffee-fill: \"\\e9ef\";\n$ni-box-view: \"\\e976\";\n$ni-col-view: \"\\e9f5\";\n$ni-sidebar: \"\\eb86\";\n$ni-layout: \"\\eabe\";\n$ni-table-view: \"\\ebdf\";\n$ni-layout2: \"\\eabf\";\n$ni-row-view: \"\\eb63\";\n$ni-dot-box: \"\\ea1e\";\n$ni-layout-fill: \"\\eabd\";\n$ni-box-view-fill: \"\\e975\";\n$ni-sidebar-fill: \"\\eb85\";\n$ni-table-view-fill: \"\\ebde\";\n$ni-dot-box-fill: \"\\ea1d\";\n$ni-template: \"\\ebee\";\n$ni-browser: \"\\e97a\";\n$ni-toolbar: \"\\ec02\";\n$ni-browser-fill: \"\\e979\";\n$ni-toolbar-fill: \"\\ec01\";\n$ni-template-fill: \"\\ebed\";\n$ni-box: \"\\e977\";\n$ni-package: \"\\eb20\";\n$ni-layer: \"\\eaba\";\n$ni-layers: \"\\eabc\";\n$ni-panel: \"\\eb22\";\n$ni-server: \"\\eb71\";\n$ni-layer-fill: \"\\eab9\";\n$ni-layers-fill: \"\\eabb\";\n$ni-package-fill: \"\\eb1f\";\n$ni-panel-fill: \"\\eb21\";\n$ni-server-fill: \"\\eb70\";\n$ni-color-palette: \"\\e9f7\";\n$ni-color-palette-fill: \"\\e9f6\";\n$ni-copy: \"\\e9fb\";\n$ni-copy-fill: \"\\e9fa\";\n$ni-crop-alt: \"\\e9fd\";\n$ni-crop: \"\\e9fe\";\n$ni-target: \"\\ebe7\";\n$ni-crosshair: \"\\ea08\";\n$ni-crosshair-fill: \"\\ea07\";\n$ni-db-fill: \"\\ea15\";\n$ni-db: \"\\ea16\";\n$ni-hard-drive: \"\\ea90\";\n$ni-cpu: \"\\e9fc\";\n$ni-disk: \"\\ea1b\";\n$ni-pen: \"\\eb2b\";\n$ni-edit-alt: \"\\ea29\";\n$ni-pen-fill: \"\\eb2a\";\n$ni-edit-alt-fill: \"\\ea28\";\n$ni-pen-alt-fill: \"\\eb29\";\n$ni-edit-fill: \"\\ea2a\";\n$ni-edit: \"\\ea2b\";\n$ni-external-alt: \"\\ea35\";\n$ni-external: \"\\ea36\";\n$ni-eye-alt: \"\\ea38\";\n$ni-eye-alt-fill: \"\\ea37\";\n$ni-eye: \"\\ea3c\";\n$ni-eye-fill: \"\\ea39\";\n$ni-eye-off: \"\\ea3b\";\n$ni-eye-off-fill: \"\\ea3a\";\n$ni-file: \"\\ea53\";\n$ni-file-minus: \"\\ea49\";\n$ni-file-plus: \"\\ea4c\";\n$ni-file-remove: \"\\ea4e\";\n$ni-file-check: \"\\ea41\";\n$ni-file-code: \"\\ea42\";\n$ni-file-docs: \"\\ea44\";\n$ni-file-img: \"\\ea47\";\n$ni-file-doc: \"\\ea43\";\n$ni-file-pdf: \"\\ea4a\";\n$ni-file-xls: \"\\ea51\";\n$ni-file-zip: \"\\ea52\";\n$ni-file-download: \"\\ea45\";\n$ni-file-text: \"\\ea50\";\n$ni-files: \"\\ea55\";\n$ni-file-fill: \"\\ea46\";\n$ni-file-minus-fill: \"\\ea48\";\n$ni-file-plus-fill: \"\\ea4b\";\n$ni-file-remove-fill: \"\\ea4d\";\n$ni-file-check-fill: \"\\ea40\";\n$ni-file-text-fill: \"\\ea4f\";\n$ni-files-fill: \"\\ea54\";\n$ni-folder: \"\\ea65\";\n$ni-folder-minus: \"\\ea62\";\n$ni-folder-plus: \"\\ea63\";\n$ni-folder-remove: \"\\ea64\";\n$ni-folder-check: \"\\ea5f\";\n$ni-folder-list: \"\\ea61\";\n$ni-folders: \"\\ea67\";\n$ni-folder-fill: \"\\ea60\";\n$ni-folders-fill: \"\\ea66\";\n$ni-filter-alt: \"\\ea56\";\n$ni-sort-line: \"\\ebbb\";\n$ni-filter-fill: \"\\ea57\";\n$ni-filter: \"\\ea58\";\n$ni-flag: \"\\ea5b\";\n$ni-flag-fill: \"\\ea5a\";\n$ni-notify: \"\\eb16\";\n$ni-dashboard: \"\\ea14\";\n$ni-dashboard-fill: \"\\ea13\";\n$ni-grid-sq: \"\\ea89\";\n$ni-grid: \"\\ea8a\";\n$ni-grid-c: \"\\ea83\";\n$ni-grid-alt: \"\\ea7e\";\n$ni-grid-plus: \"\\ea88\";\n$ni-grid-add-c: \"\\ea7b\";\n$ni-grid-fill: \"\\ea85\";\n$ni-grid-fill-c: \"\\ea84\";\n$ni-grid-alt-fill: \"\\ea7d\";\n$ni-grid-plus-fill: \"\\ea87\";\n$ni-grid-add-fill-c: \"\\ea7c\";\n$ni-grid-box-alt-fill: \"\\ea7f\";\n$ni-grid-box-alt: \"\\ea80\";\n$ni-grid-box: \"\\ea82\";\n$ni-grid-box-fill: \"\\ea81\";\n$ni-grid-line: \"\\ea86\";\n$ni-menu-alt-left: \"\\eae6\";\n$ni-menu-alt-r: \"\\eae7\";\n$ni-menu-alt: \"\\eae8\";\n$ni-menu-center: \"\\eae9\";\n$ni-menu-left: \"\\eaea\";\n$ni-menu-right: \"\\eaeb\";\n$ni-menu: \"\\eaec\";\n$ni-trend-up: \"\\ec0a\";\n$ni-trend-down: \"\\ec09\";\n$ni-line-chart-down: \"\\eac2\";\n$ni-line-chart-up: \"\\eac3\";\n$ni-line-chart: \"\\eac4\";\n$ni-bar-chart: \"\\e95e\";\n$ni-bar-chart-alt: \"\\e95c\";\n$ni-chart-up: \"\\e9b0\";\n$ni-chart-down: \"\\e9af\";\n$ni-growth: \"\\ea8c\";\n$ni-growth-fill: \"\\ea8b\";\n$ni-bar-chart-fill: \"\\e95d\";\n$ni-bar-c: \"\\e95b\";\n$ni-bar-fill-c: \"\\e95f\";\n$ni-pie: \"\\eb30\";\n$ni-pie-alt: \"\\eb2e\";\n$ni-pie-fill: \"\\eb2f\";\n$ni-activity: \"\\e906\";\n$ni-activity-alt: \"\\e903\";\n$ni-activity-round: \"\\e905\";\n$ni-activity-round-fill: \"\\e904\";\n$ni-meter: \"\\eaed\";\n$ni-speed: \"\\ebc5\";\n$ni-happy: \"\\ea8e\";\n$ni-sad: \"\\eb66\";\n$ni-meh: \"\\eae5\";\n$ni-happy-fill: \"\\ea8f\";\n$ni-happyf-fill: \"\\ea8f\";\n$ni-sad-fill: \"\\eb65\";\n$ni-meh-fill: \"\\eae4\";\n$ni-home: \"\\ea9c\";\n$ni-home-alt: \"\\ea9a\";\n$ni-home-fill: \"\\ea9b\";\n$ni-img: \"\\eaa0\";\n$ni-img-fill: \"\\ea9f\";\n$ni-inbox: \"\\eaa6\";\n$ni-inbox-in: \"\\eaa3\";\n$ni-inbox-out: \"\\eaa5\";\n$ni-inbox-fill: \"\\eaa1\";\n$ni-inbox-in-fill: \"\\eaa2\";\n$ni-inbox-out-fill: \"\\eaa4\";\n$ni-link-group: \"\\eac6\";\n$ni-lock: \"\\ead7\";\n$ni-lock-alt: \"\\ead5\";\n$ni-lock-fill: \"\\ead6\";\n$ni-lock-alt-fill: \"\\ead4\";\n$ni-unlock: \"\\ec1a\";\n$ni-unlock-fill: \"\\ec19\";\n$ni-mail: \"\\eada\";\n$ni-emails: \"\\ea2e\";\n$ni-mail-fill: \"\\ead9\";\n$ni-emails-fill: \"\\ea2d\";\n$ni-map-pin: \"\\eadc\";\n$ni-location: \"\\ead3\";\n$ni-map: \"\\eadd\";\n$ni-map-pin-fill: \"\\eadb\";\n$ni-list: \"\\ead0\";\n$ni-list-ol: \"\\eace\";\n$ni-align-center: \"\\e911\";\n$ni-align-justify: \"\\e912\";\n$ni-align-left: \"\\e913\";\n$ni-align-right: \"\\e914\";\n$ni-list-check: \"\\eacc\";\n$ni-list-round: \"\\eacf\";\n$ni-card-view: \"\\e995\";\n$ni-list-fill: \"\\eacd\";\n$ni-save: \"\\eb68\";\n$ni-save-fill: \"\\eb67\";\n$ni-move: \"\\eb04\";\n$ni-scissor: \"\\eb6b\";\n$ni-text: \"\\ebf2\";\n$ni-text-a: \"\\ebf0\";\n$ni-bold: \"\\e96e\";\n$ni-italic: \"\\eaad\";\n$ni-underline: \"\\ec13\";\n$ni-percent: \"\\eb2c\";\n$ni-at: \"\\e952\";\n$ni-hash: \"\\ea91\";\n$ni-code: \"\\e9ee\";\n$ni-code-download: \"\\e9ed\";\n$ni-terminal: \"\\ebef\";\n$ni-cmd: \"\\e9ec\";\n$ni-sun: \"\\ebd9\";\n$ni-sun-fill: \"\\ebd8\";\n$ni-moon-fill: \"\\eafe\";\n$ni-moon: \"\\eaff\";\n$ni-light: \"\\eac1\";\n$ni-light-fill: \"\\eac0\";\n$ni-more-v: \"\\eb03\";\n$ni-more-h: \"\\eb01\";\n$ni-more-h-alt: \"\\eb00\";\n$ni-more-v-alt: \"\\eb02\";\n$ni-music: \"\\eb0a\";\n$ni-movie: \"\\eb05\";\n$ni-offer: \"\\eb18\";\n$ni-offer-fill: \"\\eb17\";\n$ni-opt-alt: \"\\eb1a\";\n$ni-opt: \"\\eb1e\";\n$ni-opt-dot-alt: \"\\eb1b\";\n$ni-opt-dot: \"\\eb1d\";\n$ni-opt-dot-fill: \"\\eb1c\";\n$ni-opt-alt-fill: \"\\eb19\";\n$ni-user-alt: \"\\ec24\";\n$ni-user-alt-fill: \"\\ec23\";\n$ni-user: \"\\ec33\";\n$ni-users: \"\\ec35\";\n$ni-user-add: \"\\ec22\";\n$ni-user-remove: \"\\ec31\";\n$ni-user-check: \"\\ec27\";\n$ni-user-cross: \"\\ec2b\";\n$ni-account-setting: \"\\e902\";\n$ni-account-setting-alt: \"\\e900\";\n$ni-user-list: \"\\ec2f\";\n$ni-user-fill: \"\\ec2d\";\n$ni-users-fill: \"\\ec34\";\n$ni-user-add-fill: \"\\ec21\";\n$ni-user-remove-fill: \"\\ec30\";\n$ni-user-check-fill: \"\\ec26\";\n$ni-user-cross-fill: \"\\ec2a\";\n$ni-account-setting-fill: \"\\e901\";\n$ni-user-list-fill: \"\\ec2e\";\n$ni-user-circle: \"\\ec28\";\n$ni-user-circle-fill: \"\\ec29\";\n$ni-user-c: \"\\ec25\";\n$ni-user-fill-c: \"\\ec2c\";\n$ni-user-round: \"\\ec32\";\n$ni-printer: \"\\eb31\";\n$ni-printer-fill: \"\\eb48\";\n$ni-laptop: \"\\eab6\";\n$ni-monitor: \"\\eafd\";\n$ni-tablet: \"\\ebe0\";\n$ni-mobile: \"\\eafb\";\n$ni-undo: \"\\ec14\";\n$ni-redo: \"\\eb51\";\n$ni-reload-alt: \"\\eb54\";\n$ni-reload: \"\\eb55\";\n$ni-regen-alt: \"\\eb52\";\n$ni-regen: \"\\eb53\";\n$ni-invest: \"\\eaac\";\n$ni-history: \"\\ea99\";\n$ni-histroy: \"\\ea99\";\n$ni-update: \"\\ec1b\";\n$ni-repeat: \"\\eb57\";\n$ni-repeat-v: \"\\eb56\";\n$ni-tranx: \"\\ec03\";\n$ni-reply-all: \"\\eb59\";\n$ni-reply: \"\\eb5b\";\n$ni-reply-fill: \"\\eb5a\";\n$ni-reply-all-fill: \"\\eb58\";\n$ni-notes: \"\\eb15\";\n$ni-note-add: \"\\eb13\";\n$ni-notes-alt: \"\\eb14\";\n$ni-article: \"\\e951\";\n$ni-text-rich: \"\\ebf1\";\n$ni-todo: \"\\ebfe\";\n$ni-report-profit: \"\\eb5d\";\n$ni-reports-alt: \"\\eb5f\";\n$ni-reports: \"\\eb60\";\n$ni-task: \"\\ebea\";\n$ni-note-add-c: \"\\eb11\";\n$ni-task-c: \"\\ebe8\";\n$ni-todo-fill: \"\\ebfd\";\n$ni-note-add-fill-c: \"\\eb12\";\n$ni-task-fill-c: \"\\ebe9\";\n$ni-scan-fill: \"\\eb69\";\n$ni-scan: \"\\eb6a\";\n$ni-qr: \"\\eb4a\";\n$ni-money: \"\\eafc\";\n$ni-coins: \"\\e9f4\";\n$ni-coin: \"\\e9f3\";\n$ni-coin-alt: \"\\e9f2\";\n$ni-coin-alt-fill: \"\\e9f1\";\n$ni-setting-alt-fill: \"\\eb72\";\n$ni-setting-alt: \"\\eb73\";\n$ni-setting-fill: \"\\eb74\";\n$ni-setting: \"\\eb75\";\n$ni-share-alt: \"\\eb76\";\n$ni-share-fill: \"\\eb77\";\n$ni-share: \"\\eb78\";\n$ni-network: \"\\eb10\";\n$ni-rss: \"\\eb64\";\n$ni-shield: \"\\eb82\";\n$ni-shield-star: \"\\eb81\";\n$ni-shield-check: \"\\eb7c\";\n$ni-shield-alert: \"\\eb7a\";\n$ni-shield-off: \"\\eb7f\";\n$ni-security: \"\\eb6d\";\n$ni-policy: \"\\eb46\";\n$ni-shield-alert-fill: \"\\eb79\";\n$ni-shield-check-fill: \"\\eb7b\";\n$ni-shield-fill: \"\\eb7d\";\n$ni-shield-half: \"\\eb7e\";\n$ni-shield-star-fill: \"\\eb80\";\n$ni-policy-fill: \"\\eb45\";\n$ni-spark: \"\\ebc4\";\n$ni-spark-off: \"\\ebc3\";\n$ni-spark-fill: \"\\ebc1\";\n$ni-spark-off-fill: \"\\ebc2\";\n$ni-wallet: \"\\ec47\";\n$ni-wallet-alt: \"\\ec42\";\n$ni-wallet-in: \"\\ec44\";\n$ni-wallet-out: \"\\ec45\";\n$ni-wallet-saving: \"\\ec46\";\n$ni-wallet-fill: \"\\ec43\";\n$ni-star: \"\\ebd0\";\n$ni-star-half: \"\\ebce\";\n$ni-star-half-fill: \"\\ebcd\";\n$ni-star-fill: \"\\ebcc\";\n$ni-star-round: \"\\ebcf\";\n$ni-heart: \"\\ea95\";\n$ni-heart-fill: \"\\ea94\";\n$ni-swap-alt-fill: \"\\ebda\";\n$ni-swap-alt: \"\\ebdb\";\n$ni-thumbs-down: \"\\ebf3\";\n$ni-thumbs-up: \"\\ebf4\";\n$ni-tag: \"\\ebe4\";\n$ni-tag-alt: \"\\ebe2\";\n$ni-tags: \"\\ebe6\";\n$ni-tag-fill: \"\\ebe3\";\n$ni-tag-alt-fill: \"\\ebe1\";\n$ni-tags-fill: \"\\ebe5\";\n$ni-bookmark: \"\\e973\";\n$ni-bookmark-fill: \"\\e972\";\n$ni-label: \"\\eab5\";\n$ni-label-fill: \"\\eab4\";\n$ni-priority: \"\\eb36\";\n$ni-piority: \"\\eb36\";\n$ni-priority-fill: \"\\eb35\";\n$ni-piority-fill: \"\\eb35\";\n$ni-label-alt: \"\\eab3\";\n$ni-label-alt-fill: \"\\eab2\";\n$ni-ticket-alt: \"\\ebf6\";\n$ni-ticket: \"\\ebfc\";\n$ni-ticket-minus: \"\\ebf9\";\n$ni-ticket-plus: \"\\ebfb\";\n$ni-ticket-alt-fill: \"\\ebf5\";\n$ni-ticket-fill: \"\\ebf7\";\n$ni-ticket-minus-fill: \"\\ebf8\";\n$ni-ticket-plus-fill: \"\\ebfa\";\n$ni-toggle-off: \"\\ebff\";\n$ni-toggle-on: \"\\ec00\";\n$ni-trash-alt: \"\\ec04\";\n$ni-trash-empty: \"\\ec06\";\n$ni-trash: \"\\ec08\";\n$ni-trash-fill: \"\\ec07\";\n$ni-trash-empty-fill: \"\\ec05\";\n$ni-delete-fill: \"\\ea17\";\n$ni-delete: \"\\ea18\";\n$ni-alarm-alt: \"\\e909\";\n$ni-alarm: \"\\e90a\";\n$ni-bugs: \"\\e97b\";\n$ni-building: \"\\e97d\";\n$ni-building-fill: \"\\e97c\";\n$ni-headphone: \"\\ea93\";\n$ni-headphone-fill: \"\\ea92\";\n$ni-aperture: \"\\e91b\";\n$ni-help-alt: \"\\ea96\";\n$ni-award: \"\\e953\";\n$ni-briefcase: \"\\e978\";\n$ni-gift: \"\\ea6f\";\n$ni-globe: \"\\ea74\";\n$ni-umbrela: \"\\ec10\";\n$ni-truck: \"\\ec0b\";\n$ni-sign-usd: \"\\eba7\";\n$ni-sign-dollar: \"\\eba7\";\n$ni-sign-mxn: \"\\eb99\";\n$ni-sign-sgd: \"\\eba0\";\n$ni-sign-euro: \"\\eb94\";\n$ni-sign-eur: \"\\eb94\";\n$ni-sign-gbp: \"\\eb89\";\n$ni-sign-pound: \"\\eb89\";\n$ni-sign-thb: \"\\eba4\";\n$ni-sign-inr: \"\\eb97\";\n$ni-sign-jpy: \"\\eb98\";\n$ni-sign-yen: \"\\eb98\";\n$ni-sign-cny: \"\\eb8e\";\n$ni-sign-kobo: \"\\eba1\";\n$ni-sign-chf: \"\\eb8d\";\n$ni-sign-vnd: \"\\ebaa\";\n$ni-sign-php: \"\\eb9c\";\n$ni-sign-brl: \"\\eb8b\";\n$ni-sign-idr: \"\\eb96\";\n$ni-sign-czk: \"\\eb8f\";\n$ni-sign-hkd: \"\\eb95\";\n$ni-sign-kr: \"\\eb9f\";\n$ni-sign-dkk: \"\\eb9f\";\n$ni-sign-nok: \"\\eb9f\";\n$ni-sign-sek: \"\\eb9f\";\n$ni-sign-rub: \"\\eb9e\";\n$ni-sign-myr: \"\\eb9b\";\n$ni-sign-pln: \"\\eb9d\";\n$ni-sign-try: \"\\eba6\";\n$ni-sign-waves: \"\\ebab\";\n$ni-waves: \"\\ebab\";\n$ni-sign-trx: \"\\eba5\";\n$ni-tron: \"\\eba5\";\n$ni-sign-xem: \"\\ebac\";\n$ni-nem: \"\\ebac\";\n$ni-sign-mxr: \"\\eb9a\";\n$ni-monero: \"\\eb9a\";\n$ni-sign-usdc: \"\\eba8\";\n$ni-sign-steller: \"\\eba3\";\n$ni-sign-steem: \"\\eba2\";\n$ni-sign-usdt: \"\\eba9\";\n$ni-tether: \"\\eba9\";\n$ni-sign-btc: \"\\eb8c\";\n$ni-bitcoin: \"\\eb8c\";\n$ni-sign-bch: \"\\eb88\";\n$ni-bitcoin-cash: \"\\eb88\";\n$ni-sign-bnb: \"\\eb8a\";\n$ni-binance: \"\\eb8a\";\n$ni-sign-ada: \"\\eb87\";\n$ni-sign-zcash: \"\\ebaf\";\n$ni-sign-eth: \"\\eb93\";\n$ni-ethereum: \"\\eb93\";\n$ni-sign-dash: \"\\eb90\";\n$ni-dash: \"\\eb90\";\n$ni-sign-xrp-old: \"\\ebae\";\n$ni-ripple-old: \"\\ebae\";\n$ni-sign-eos: \"\\eb92\";\n$ni-eos: \"\\eb92\";\n$ni-sign-xrp: \"\\ebad\";\n$ni-ripple: \"\\ebad\";\n$ni-american-express: \"\\e918\";\n$ni-jcb: \"\\eaae\";\n$ni-cc-jcb: \"\\eaae\";\n$ni-mc: \"\\eae0\";\n$ni-cc-mc: \"\\eae0\";\n$ni-discover: \"\\ea1a\";\n$ni-cc-discover: \"\\ea1a\";\n$ni-visa: \"\\ec3d\";\n$ni-cc-visa: \"\\ec3d\";\n$ni-cc-paypal: \"\\eb27\";\n$ni-cc-stripe: \"\\e9ad\";\n$ni-amazon-pay: \"\\e916\";\n$ni-amazon-pay-fill: \"\\e915\";\n$ni-google-pay: \"\\ea77\";\n$ni-google-pay-fill: \"\\ea76\";\n$ni-apple-pay: \"\\e91d\";\n$ni-apple-pay-fill: \"\\e91c\";\n$ni-angular: \"\\e91a\";\n$ni-react: \"\\eb4d\";\n$ni-laravel: \"\\eab7\";\n$ni-html5: \"\\ea9e\";\n$ni-css3-fill: \"\\ea09\";\n$ni-css3: \"\\ea0a\";\n$ni-js: \"\\eab0\";\n$ni-php: \"\\eb2d\";\n$ni-python: \"\\eb49\";\n$ni-bootstrap: \"\\e974\";\n$ni-ebay: \"\\ea27\";\n$ni-google-wallet: \"\\ea79\";\n$ni-google-drive: \"\\ea75\";\n$ni-google-play-store: \"\\ea78\";\n$ni-android: \"\\e919\";\n$ni-blogger-fill: \"\\e96b\";\n$ni-blogger: \"\\e96c\";\n$ni-hangout: \"\\ea8d\";\n$ni-apple-store: \"\\e91f\";\n$ni-apple-store-ios: \"\\e91e\";\n$ni-stripe: \"\\ebd7\";\n$ni-apple: \"\\e920\";\n$ni-microsoft: \"\\eaf0\";\n$ni-windows: \"\\ec4c\";\n$ni-amazon: \"\\e917\";\n$ni-paypal-alt: \"\\eb28\";\n$ni-airbnb: \"\\e908\";\n$ni-adobe: \"\\e907\";\n$ni-mailchimp: \"\\ead8\";\n$ni-dropbox: \"\\ea26\";\n$ni-digital-ocean: \"\\ea19\";\n$ni-slack: \"\\ebb5\";\n$ni-slack-hash: \"\\ebb4\";\n$ni-stack-overflow: \"\\ebcb\";\n$ni-soundcloud: \"\\ebc0\";\n$ni-blackberry: \"\\e966\";\n$ni-spotify: \"\\ebc6\";\n$ni-kickstarter: \"\\eab1\";\n$ni-houzz: \"\\ea9d\";\n$ni-vine: \"\\ec3c\";\n$ni-yelp: \"\\ec4f\";\n$ni-yoast: \"\\ec50\";\n$ni-envato: \"\\ea2f\";\n$ni-wordpress: \"\\ec4e\";\n$ni-wp: \"\\ec4e\";\n$ni-wordpress-fill: \"\\ec4d\";\n$ni-elementor: \"\\ea2c\";\n$ni-joomla: \"\\eaaf\";\n$ni-megento: \"\\eae3\";\n$ni-git: \"\\ea70\";\n$ni-github: \"\\ea73\";\n$ni-github-round: \"\\ea72\";\n$ni-github-circle: \"\\ea71\";\n$ni-dribbble: \"\\ea25\";\n$ni-dribbble-round: \"\\ea24\";\n$ni-behance: \"\\e961\";\n$ni-behance-fill: \"\\e960\";\n$ni-flickr: \"\\ea5d\";\n$ni-flickr-round: \"\\ea5c\";\n$ni-medium: \"\\eae2\";\n$ni-medium-round: \"\\eae1\";\n$ni-reddit: \"\\eb50\";\n$ni-reddit-round: \"\\eb4f\";\n$ni-reddit-circle: \"\\eb4e\";\n$ni-google: \"\\ea7a\";\n$ni-facebook-f: \"\\ea3e\";\n$ni-facebook-fill: \"\\ea3f\";\n$ni-facebook-circle: \"\\ea3d\";\n$ni-instagram: \"\\eaab\";\n$ni-instagram-round: \"\\eaaa\";\n$ni-linkedin: \"\\eacb\";\n$ni-linkedin-round: \"\\eaca\";\n$ni-twitter: \"\\ec0f\";\n$ni-twitter-round: \"\\ec0e\";\n$ni-pinterest: \"\\eb34\";\n$ni-pinterest-round: \"\\eb33\";\n$ni-pinterest-circle: \"\\eb32\";\n$ni-tumblr: \"\\ec0d\";\n$ni-tumblr-round: \"\\ec0c\";\n$ni-skype: \"\\ebb3\";\n$ni-viber: \"\\ec36\";\n$ni-whatsapp: \"\\ec49\";\n$ni-whatsapp-round: \"\\ec48\";\n$ni-snapchat: \"\\ebb7\";\n$ni-snapchat-fill: \"\\ebb6\";\n$ni-telegram: \"\\ebec\";\n$ni-telegram-circle: \"\\ebeb\";\n$ni-youtube-line: \"\\ec52\";\n$ni-youtube: \"\\ec52\";\n$ni-youtube-fill: \"\\ec53\";\n$ni-youtube-round: \"\\ec51\";\n$ni-vimeo: \"\\ec3b\";\n$ni-vimeo-fill: \"\\ec3a\";\n\n",".breadcrumb{\n    &-item{\n        font-size: $breadcrumb-font-size;\n        font-weight: $breadcrumb-font-weight;\n        text-transform: $breadcrumb-font-case;\n        letter-spacing: $breadcrumb-letter-spacing;\n        a:not(:hover){\n            color: $breadcrumb-not-hover-color;\n        }\n        + .breadcrumb-item::before{\n            .breadcrumb-pipe &{\n                content: '|';\n            }\n        }\n        + .breadcrumb-item::before{\n            .breadcrumb-arrow &{\n                font-family: $nk-dashlite-font;\n                content: $ni-forward-ios;\n            }\n        }\n        &.active {\n            &:not(:only-child) {\n                font-weight: $fw-normal;\n            }\n        }\n    }\n}\n\n.breadcrumb-alt{\n    .breadcrumb{\n        &-item{\n            text-transform: unset;\n            letter-spacing: 0;\n            color: $base-light;\n        }\n    }\n}\n.breadcrumb-xs{\n    .breadcrumb{\n        &-item{\n            + .breadcrumb-item {\n                padding-left: 0.25rem;\n                &:before{\n                    padding-right: 0.25rem;\n                    font-size: 0.8em;\n                }\n            }\n        }\n    }\n}\n.breadcrumb-sm{\n    .breadcrumb{\n        &-item{\n            font-size: $fx-sz-13;\n        }\n    }\n}",".link{\n    display: inline-flex;\n    align-items: center;\n    font-size: 0.85rem;\n    font-weight: $fw-medium;\n    font-family: $base-font-family;\n    line-height: 1;\n    border:none;\n    background: transparent;\n    transition: all .3s ease;\n    white-space: nowrap;\n    &:focus{\n        box-shadow: none;\n        outline: none;\n    }\n    .icon{\n        font-size: 1.3em;\n    }\n    span,.icon{\n        display: inline-block;\n    }\n    .icon-circle{\n        display: inline-flex;\n    }\n    .icon + span, span + .icon{\n        padding-left: 10px;\n    }\n    &-md{\n        font-size: 1.25rem;\n    }\n    &-sm{\n        font-size: .75rem;\n    }\n    &-dim {\n    \topacity: .7;\n    \t&:hover {\n    \t\topacity: 1;\n    \t}\n    }\n    &-block{\n        display: flex;\n    }\n    &-between{\n        justify-content: space-between;\n    }\n}\n\n$link-colors: map-merge(\n    $theme-colors,\n    (\n        \"light\":       $base-light,\n        \"lighter\":     $light-400,\n        \"text\":        $base-text\n    )\n);\n\n@each $state, $color in $link-colors {\n    .link-#{$state}{\n        color:$color !important;\n    }\n    .link-on-#{$state}:hover{\n        color:$color !important;\n    }\n}\n\n.link {\n\t&-danger, &-warning, &-success, &-info {\n\t\t&:hover{\n\t\t    color: $base-text !important;\n\t\t}\n\t}\n}","// BUTTONS\n/////////////////////////\n.btn{\n    position: relative;\n    letter-spacing: 0.02em;\n    display: inline-flex;\n    align-items: center;\n    &-xl {\n        @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-line-height-lg, $btn-border-radius-lg);\n    }\n    &-xs{\n        @include button-size($btn-padding-y-xs, $btn-padding-x-xs, $btn-font-size-xs, $btn-line-height-xs, $btn-border-radius-xs);\n    }\n    // With Icon\n    .icon{\n        font-size: 1.4em;\n        line-height: inherit;\n    }\n    > span{\n        display: inline-block;\n        white-space: nowrap;\n        &:only-child{\n            width: 100%;\n        }\n    }\n    .icon + span,span + .icon{\n        padding-left: 8px;\n    }\n    .dd-indc{\n        transform: translateX(-8px);\n    }\n    span + .dd-indc{\n        transform: translateX(8px);\n    }\n    &-lg{\n        .icon + span,span + .icon{\n            padding-left: 12px;\n        }\n    }\n    &-round{\n        border-radius: add($btn-line-height, + $btn-padding-y*2, + $btn-border-width*2);\n    }\n    &-block{\n        justify-content: center;\n    }\n    &-ucap,&.ucap{\n        text-transform: uppercase;\n        font-size: $fx-sz-12;\n        letter-spacing: 0.05em;\n    }\n    // Only Icon Button\n    &-icon{\n        &:not([class*=\"btn-icon-break\"]){\n            padding-left: 0;\n            padding-right: 0;\n        }\n        .icon{\n            width: $btn-line-height + $btn-padding-y*2;\n        }\n        &.btn-xl{\n            .icon{\n                width: $btn-line-height-lg + $btn-padding-y-lg*2;\n            }\n        }\n        &.btn-lg{\n            .icon{\n                width: $btn-line-height-lg + $btn-padding-y-lg*2;\n            }\n        }\n        &.btn-sm{\n            .icon{\n                width: $btn-line-height-sm + $btn-padding-y-sm*2;\n            }\n        }\n        &.btn-xs{\n            .icon{\n                width: $btn-line-height-xs + $btn-padding-y-xs*2;\n                font-size: 1.1em;\n            }\n        }\n        .dot{\n            top: .35rem;\n            position: absolute;\n            right: .35rem;\n            transform: translate(50%, -50%);\n        }\n        .badge{\n            top: .25rem;\n            position: absolute;\n            right: .25rem;\n            transform: translate(50%, -50%);\n            &-circle{\n                border-radius: 50%;\n                height: 1.125rem;\n                width: 1.125rem;\n                padding:0;\n                font-weight: $fw-bold;\n                font-size: $fx-sz-11;\n                text-align: center;\n                justify-content: center;\n            }\n        }\n    }\n    &-mw{\n        min-width: 120px;\n        justify-content: center;\n    }\n    &-wrap{\n        flex-direction: column;\n        align-items: center;\n        flex-grow: 0;\n    }\n    &-extext{\n        font-size: 12px;\n        font-weight: $fw-medium;\n        text-align: center;\n        margin-top: 0.25rem;\n        color: $base-light;\n    }\n    &-wider{\n        display: flex;\n        .icon + span,span + .icon{\n            margin-left: auto;\n        }\n    }\n    &-auto{\n        min-width: auto;\n    }\n    &-pd-auto {\n        padding-left: 0.25rem;\n        padding-right: 0.25rem;\n    }\n    .spinner-border,.spinner-grow{\n        margin: .125rem;\n        + span{\n            margin-left: 0.25rem;\n        }\n    }\n    &-indc{\n        width: 100%;\n        .icon{\n            font-size: 1.43em;\n        }\n        .indc{\n            opacity: .6;\n            margin-left: -8px;\n            margin-right: auto;\n        }\n        span + .indc{\n            margin-left: auto;\n            margin-right: -8px;\n        }\n    }\n}\n\n@include media-breakpoint-up(md){\n    .btn-xl {\n        @include button-size($btn-padding-y-xl, $btn-padding-x-xl, $btn-font-size-xl, $btn-line-height-xl, $btn-border-radius-lg);\n        &.btn-round{\n            border-radius: add($btn-line-height-xl, + $btn-padding-y-xl*2, + $btn-border-width*2);\n        }\n    }\n    .btn-icon{\n        &.btn-xl{\n            .icon{\n                width: $btn-line-height-xl + $btn-padding-y-xl*2;\n            }\n        }\n    }\n}\n//btn trigger\n@mixin btn-trigger-active {\n    opacity: 1;\n    height: 120%;\n    width: 120%;\n}\n.btn-trigger{\n    position: relative;\n    z-index: 1;\n    color: $base-text;\n    &:focus{\n        box-shadow: none;\n    }\n    &:before{\n        position: absolute;\n        z-index: -1;\n        height: 20px;\n        width: 20px;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        transform-origin: 50% 50%;\n        content: '';\n        background-color: $light-200;\n        border-radius: 50%;\n        opacity: 0;\n        transition: all .3s;\n        .is-dark &{\n            background-color: darken($accent-dark,10%);\n        }\n        .show > &{\n            @include btn-trigger-active();\n        }\n    }\n    &:hover:before, &:focus:before, &.active:not(.revarse):before{\n        @include btn-trigger-active();\n    }\n    &.active:hover:before{\n        background-color: $light-300;\n    }\n    a:hover &{\n        &:before{\n            @include btn-trigger-active();\n        }\n    }\n}\n\n\n/// Pale/Dim Button\n$dim-mix:           #fff;\n\n$dim-outline-btns:\n    \"primary\"     $primary          mix($primary, $dim-mix, 11%)            mix($primary, $dim-mix, 40%),\n    \"success\"     $success          mix($success, $dim-mix, 11%)            mix($success, $dim-mix, 40%),\n    \"warning\"     $warning          mix($warning, $dim-mix, 11%)            mix($warning, $dim-mix, 40%),\n    \"info\"        $info             mix($info, $dim-mix, 11%)               mix($info, $dim-mix, 40%),\n    \"danger\"      $danger           mix($danger, $dim-mix, 11%)             mix($danger, $dim-mix, 40%),\n    \"secondary\"   $secondary        mix($secondary, $dim-mix, 11%)          mix($secondary, $dim-mix, 35%),\n    \"gray\"        $light-600        mix($light-500, $dim-mix, 11%)          mix($light-500, $dim-mix, 35%),\n    \"dark\"        $dark             mix($dark, $dim-mix, 11%)               mix($dark, $dim-mix, 35%),\n    \"light\"       $secondary-light  $lighter                                $light-300;\n\n@each $name, $color, $background, $border in $dim-outline-btns {\n    .btn-dim.btn-outline-#{$name} {\n        color: $color;\n        background-color: $background;\n        border-color: $border;\n        &:not(:disabled):not(.disabled):hover {\n            color: color-yiq($color);\n            background-color: $color;\n            border-color: $color;\n        }\n    }\n    .btn-white.btn-outline-#{$name}, .btn-trans.btn-outline-#{$name} {\n        &:not(.btn-dim):not(:disabled):not(.disabled):hover {\n            color: $color;\n            background: $background;\n        }\n    }\n}\n\n\n$dim-btns:\n    \"primary\"     $primary                  mix($primary, $dim-mix, 11%),\n    \"secondary\"   $secondary                mix($secondary, $dim-mix, 11%),\n    \"success\"     $success                  mix($success, $dim-mix, 11%),\n    \"warning\"     $warning                  mix($warning, $dim-mix, 11%),\n    \"info\"        $info                     mix($info, $dim-mix, 11%),\n    \"danger\"      $danger                   mix($danger, $dim-mix, 11%),\n    \"gray\"        $gray-600                 mix($gray-600, $dim-mix, 11%),\n    \"dark\"        $dark                     mix($dark, $dim-mix, 11%),\n    \"light\"       $light-500                mix($light-500, $dim-mix, 11%),\n    \"lighter\"     $light-400                mix($light-400, $dim-mix, 11%);\n\n@each $name, $color, $background in $dim-btns {\n    .btn-dim.btn-#{$name} {\n        color: $color;\n        background-color: $background;\n        border-color: transparent;\n        &:not(:disabled):not(.disabled):hover {\n            color: color-yiq($color);\n            background-color: $color;\n            border-color: $color;\n        }\n    }\n}\n\n// OVERRIDE DEFAUTL COLOR\n.btn {\n    &-trans.btn {\n        background-color: transparent;\n        border-color: transparent;\n    }\n    &-outline-light {\n        border-color: $light-300;\n    }\n    &-outline-lighter {\n        border-color: $light-200;\n    }\n    &-outline-light, &-outline-lighter {\n        color: $secondary-light;\n    }\n    &-white, &-white.btn-dim {\n        background: $white;\n    }\n    &-white.btn-outline-light {\n        &:not(.btn-dim):not(:disabled):not(.disabled):hover {\n            color: $white;\n            background: $base-text;\n            border-color: $base-text;\n        }\n    }\n}\n\n.btn{\n    &-p{\n        &-0{\n            padding: 0;\n        }\n        &x-0{\n            padding-left: 0;\n            padding-right: 0;\n        }\n        &y-0{\n            padding-top: 0;\n            padding-bottom: 0;\n        }\n    }\n    &-nofocus{\n        box-shadow: none !important;\n    }\n}",".btn{\n    &-toolbar{\n        &-sep{\n            border-right: 1px solid $border-light;\n            margin-left: .75rem;\n            margin-right: .75rem;\n            .card-tools & {\n                padding: 0 !important;\n                margin-left: .5rem;\n                margin-right: .5rem;\n            }\n        }\n    }\n    &-group {\n        &.is-tags {\n            .btn-xs {\n                &:first-child {\n                    padding-left: 0.25rem;\n                    padding-right: 0.25rem;\n                }\n                &:last-child {\n                    margin-left: 0;\n                }\n                .icon {\n                    width: 1rem;\n                }\n            }\n            .btn-dim:not(:disabled):not(.disabled):hover {\n                border-color: transparent;\n            }\n        }\n    }\n}","@use 'sass:math';\n.dropup, .dropright, .dropdown, .dropleft{\n    display: inline-flex;\n}\n\n// Dropdown Menu\n.dropdown-toggle{\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    margin-bottom: 0;\n    &:not([class*=\"indicator\"]):after{\n        display: none;\n    }\n}\n.clickable{\n    * {\n        pointer-events: none;\n    }\n}\n.dropdown-menu{\n    overflow: hidden;\n    border: $dropdown-border-width solid $dropdown-border-color;\n    box-shadow: $dropdown-box-shadow;\n}\n.dropdown{\n    &-inner{\n        padding: 0 1.75rem;\n        + .dropdown-inner{\n            border-top: $dropdown-border-width solid $border-light;\n        }\n    }\n    &-head,&-foot{\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 0.75rem 1.25rem;\n        border-bottom: $dropdown-border-width solid $border-light;\n        &.center{\n            justify-content: center;\n        }\n    }\n    &-head{\n        border-bottom: $dropdown-border-width solid $border-light;\n    }\n    &-foot{\n        border-top: $dropdown-border-width solid $border-light;\n    }\n    &-body{\n        &-sm {\n            padding: .75rem;\n        }\n        &-rg {\n            padding: 1.25rem;\n        }\n        &-md {\n            padding: 1.5rem;\n        }\n        &-lg {\n            padding: 2.25rem;\n        }\n    }\n    &-title {\n        font-weight: $fw-medium;\n        color: $base-color;\n    }\n}\n  \n//Indicators\n[class*=\"dropdown-indicator\"]{\n    &:after{\n        border: none !important;\n        font-family: $nk-dashlite-font;\n        vertical-align: middle;\n        content: $ni-chevron-down;\n        margin-left: 1.8rem;\n        line-height: 1;\n        display: inline-flex;\n        align-items: center;\n        font-size: 14px;\n        .dropup &{\n            content: $ni-chevron-up;\n        }\n    }\n}\n.dropdown{\n    &-indicator{\n        &-caret{\n            &:after{\n                content: $ni-caret-down-fill;\n                .dropup &{\n                    content: $ni-caret-down-fill;\n                }\n            }\n        }\n        &-caret-up{\n            &:after{\n                content: $ni-caret-up-fill;\n                .dropup &{\n                    content: $ni-caret-up-fill;\n                }\n            }\n        }\n        &-up{\n            &:after{\n                content: $ni-arrow-long-up;\n                .dropup &{\n                    content: $ni-arrow-long-up;\n                }\n            }\n        }\n        &-down{\n            &:after{\n                content: $ni-arrow-long-down;\n                .dropup &{\n                    content: $ni-arrow-long-down;\n                }\n            }\n        }\n        &-dubble{\n            &:after{\n                content: $ni-chevrons-down;\n                .dropup &{\n                    content: $ni-chevrons-up;\n                }\n            }\n        }\n        &-unfold{\n            &:after{\n                content: $ni-unfold-more;\n                .dropup &{\n                    content: $ni-unfold-more;\n                }\n            }\n        }\n    }\n}\n\n//Sizes\n.dropdown-menu{\n    &-center{\n        left: 50% !important;\n    }\n    &-bottom{\n        bottom: 0 !important;\n    }\n    &-xxs{\n        min-width: $dropdown-width-xxs;\n        max-width: $dropdown-width-xxs;\n        &.dropdown-menu-center{\n            margin-left: math.div(-$dropdown-width-xxs,2);\n        }\n    }\n    &-xs{\n        min-width: $dropdown-width-xs;\n        max-width: $dropdown-width-xs;\n        &.dropdown-menu-center{\n            margin-left: math.div(-$dropdown-width-xs,2);\n        }\n    }\n    &-md{\n        min-width: $dropdown-width-md;\n        max-width: $dropdown-width-md;\n        &.dropdown-menu-center{\n            margin-left: math.div(-$dropdown-width-md,2);\n        }\n    }\n    &-sm{\n        min-width: $dropdown-width-sm;\n        max-width: $dropdown-width-sm;\n        &.dropdown-menu-center{\n            margin-left: math.div(-$dropdown-width-sm,2);\n        }\n    }\n    &-lg{\n        min-width: $dropdown-width-lg;\n        max-width: $dropdown-width-lg;\n        &.dropdown-menu-center{\n            margin-left: math.div(-$dropdown-width-lg,2);\n        }\n    }\n    &-xl{\n        min-width: $dropdown-width-xl;\n        max-width: $dropdown-width-xl;\n        &.dropdown-menu-center{\n            margin-left: math.div(-$dropdown-width-xl,2);\n        }\n    }\n    &-auto{\n        min-width: 100%;\n        max-width: 100%;\n    }\n    &-mxh{\n        max-height: 400px;\n        overflow: auto;\n    }\n}\n\n// Header Dropdown\n.nk-quick-nav{\n    .dropdown-menu{\n        margin-top: 11px;\n        margin-right: -6px;\n    }\n}\n@media (max-width:420px){\n    .dropdown-menu-xl,.dropdown-menu-lg,.dropdown-menu-md{\n        min-width: calc(100vw - 40px);\n        max-width: calc(100vw - 40px);\n    }\n    .nk-quick-nav{\n        .dropdown-menu-xl,.dropdown-menu-lg,.dropdown-menu-md{\n            margin-right: 0;\n            margin-left: 16px;\n        }\n        li:last-child {\n            .dropdown-menu-xl,.dropdown-menu-lg,.dropdown-menu-md{\n                margin-left: 0;\n                margin-right: 3px;\n            }\n        }\n    }\n}\n\n\n\n// Style s1\n.dropdown-menu-s1 {\n    border-top:3px solid $primary;\n}\n\n.dropdown-toggle-split {\n    > .icon {\n        margin-left: -0.25rem;\n        margin-right: -0.25rem;\n    }\n}",".card{\n    box-shadow: 0px 1px 3px 0px rgba($base-color, 0.05);\n    .card{\n        box-shadow: 0px 1px 6px 1px rgba($base-color, 0.10);\n    }\n    + .card:not(.card .card + .card){\n        margin-top: $gutter-width; \n    }\n    + .nk-block-head{\n        padding-top: 2.5rem;\n    }\n    &-full {\n        height: 100%;\n    }\n    &.is-dark{\n        background: $accent-dark;\n    }\n    &-bordered{\n        border: 1px solid $card-bordered-color;\n        &.is-dark{\n            border-color: $accent-dark;\n        }\n        &.dashed{\n            border-style: dashed;\n        }\n    }\n    &-inner{\n        padding: $card-spacer-x;\n        &-sm{\n            padding-top: .75rem;\n            padding-bottom: .75rem;\n        }\n        &-group{\n            .card-inner{\n                &:not(:last-child){\n                    border-bottom: 1px solid $card-bordered-color;\n                }\n            }\n        }\n    }\n    &-head{\n        display: flex;\n        align-items: center;\n        flex-wrap: wrap;\n        justify-content: space-between;\n        margin: -.25rem -0.5rem 1rem;\n        > *{\n            padding: 0.25rem .5rem;\n        } \n        > .title:only-child{\n            width: 100%;\n        }\n    }\n    &-title {\n        &-group {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            position: relative;\n            .card-title {\n                margin-bottom: 0\n            }\n            &:only-child, .card-search {\n                margin-top: -.25rem;\n                margin-bottom: -.25rem;\n            }\n        }\n        h6.title:not(:last-child){\n            margin-bottom: 0.25rem;\n        }\n        p{\n            font-size: $fx-sz-12;\n            color: $base-light;\n            .icon{\n                line-height: inherit;\n                vertical-align: middle;\n            }\n        }\n        &-sm{\n            .title{\n                font-size: $fx-sz-14;\n            }\n        }\n        small{\n            font-weight: $fw-medium;\n            color: $base-light;\n        }\n        .is-dark &{\n            color: $white;\n            .title{\n                color: inherit;\n            }\n        }\n    }\n    &-subtitle {\n        color: $base-light;\n        font-family: $base-font-family;\n        font-weight: normal;\n    }\n    &-tools{\n        &-nav{\n            display: flex;\n            margin: -6px -10px -5px;\n            li{\n                padding: 0 10px;\n                a{\n                    position: relative;\n                    color: $base-light;\n                    padding: 10px 0;\n                    display: block;\n                    line-height: 1;\n                    &:before{\n                        position: absolute;\n                        bottom: 0;\n                        left: 0;\n                        right: 0;\n                        height: 2px;\n                        content: '';\n                        background: $accent-color;\n                        opacity: 0;\n                    }\n                    &:hover,&.active{\n                        color: $base-text;\n                    }\n                    &.active{\n                        &::before{\n                            opacity: 1;\n                        }\n                    }\n                }\n                &.active{\n                    a{\n                        color: $base-text;\n                        &::before{\n                            opacity: 1;\n                        }\n                    }\n                }\n            }\n        }\n        &.mr-n1 {\n            margin-right: -0.5rem !important;\n        }\n    }\n    &-hint{\n        font-size: 1rem;\n        color: $border-color;\n    }\n    &-tools{\n        display: flex;\n        margin-right: 0.5rem\n    }\n    &-tools-wrapper{\n        display: flex;\n    }\n    &-note{\n        font-size: 12px;\n        line-height: 1.125rem;\n        color:$base-light;\n        display: flex;\n        \n        .icon{\n            font-size: 1.2em;\n            line-height: 1.125rem;\n            margin-right: 0.5rem;\n            display: inline-block;\n        }\n    }\n}\n@include media-breakpoint-down(mb){\n    .card-head{\n        &.ui-v2{\n            .card-tools{\n                width: calc(100% + 20px);\n                margin: 0 -10px;\n                padding-top: .5rem;\n                &-nav{\n                    padding: 0 .75rem;\n                    border-bottom: 1px solid $border-light;\n                    li{\n                        a{\n                            padding-bottom: 1rem;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .card-stretch {\n        margin-left: - $card-stretch-gap-x;\n        margin-right: - $card-stretch-gap-x;\n        border-left: 0;\n        border-right: 0;\n        border-radius: 0;\n    }\n}\n@include media-breakpoint-up(sm){\n    .card{\n        &-inner{\n            padding: $card-spacer-sm-x;\n            &-sm{\n                padding-top: .75rem;\n                padding-bottom: .75rem;\n            }\n            &-md{\n                padding-top: 1rem;\n                padding-bottom: 1rem;\n            }\n        }\n        &-header {\n            padding-left: $card-spacer-sm-x;\n            padding-right: $card-spacer-sm-x;\n        }\n    }\n}\n@include media-breakpoint-up(md){\n    .card{\n        &-inner-lg{\n            padding: $card-spacer-large;\n        }\n        &-inner-xl{\n            padding: ($card-spacer-large * 1.5);\n        }\n    }\n}","@use 'sass:math';\n.form{\n    &-icon{\n        position: absolute;\n        display: inline-flex;\n        justify-content: center;\n        align-items: center;\n        top: 0;\n        width: add($field-padding-x, + 24px);\n        height: $input-height;\n        &.sm{\n            height: $input-height-sm;\n        }\n        &.lg{\n            height: $input-height-lg;\n        }\n        &.xl{\n            height: $input-height-xl;\n        }\n        .icon{\n            font-size: 16px;\n            color: $base-light;\n        }\n        + .form-control{\n            padding-left: add($field-padding-x, + 24px);\n        }\n        &-right{\n            left: auto;\n            right: - $field-border-width;\n            + .form-control{\n                padding-left: $input-padding-x;\n                padding-right:  add($field-padding-x, + 24px);\n            }\n        }\n    }\n    &-info{\n        position: absolute;\n        display: inline-flex;\n        justify-content: center;\n        align-items: center;\n        top: 50%;\n        right: 0;\n        border-left: 1px solid $border-color;\n        padding: .125rem 1.25rem;\n        transform: translateY(-50%);\n        color: $base-light;\n        + .form-control{\n            padding-right: add($field-padding-x, + 24px);\n        }\n    }\n    &-label{\n        font-size: 0.875rem;\n        font-weight: 500;\n        color: $light-700;\n        margin-bottom: .5rem;\n        &-group{\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            margin-bottom: .5rem;\n            .form-label {\n                margin-bottom: 0;\n            }\n        }\n        + .form-note{\n            margin-top: -0.35rem;\n        }\n        &-outlined{\n            position: absolute;\n            top: $input-padding-y;\n            left: math.div($input-padding-x,1.5);\n            transform-origin: left;\n            padding: 0 math.div($input-padding-x,2.5);\n            font-weight: $input-font-weight;\n            line-height: $input-line-height;\n            color: $input-color;\n            background-color: $white;\n            z-index: 1;\n            transition: all .3s ease;\n            margin-bottom: 0;\n            @include font-size($input-font-size);\n            .form-control-lg ~ &{\n                top: $input-padding-y-lg;\n                padding: 0 math.div($input-padding-x,2.65);\n                @include font-size($input-font-size-lg);\n            }\n            .form-control-sm ~ &{\n                @include font-size($input-font-size-sm);\n                top: $input-padding-y-sm;\n                left: math.div($input-padding-x,2.5);\n            }\n            .focused .form-control-sm ~ &,\n            .form-select.form-control-sm ~ &{\n                font-size: 11px;\n            }\n            .focused &,.form-select ~ &{\n                top: add(-($input-padding-y), -2px);\n                font-size: 11px;\n            }\n            .form-control-xl ~ &{\n                @include font-size($input-font-size-xl);\n                line-height: $input-line-height-xl;\n                top: $input-padding-y-xl;\n                padding: 0 math.div($input-padding-x-xl,2.5);\n                left: math.div($input-padding-x-xl,1.5);\n            }\n            .focused .form-control-xl ~ &,\n            .form-select.form-control-xl ~ &{\n                top: add(-($input-padding-y-xl), -5px);\n            }\n            .focused .form-control-lg ~ &,.focused .form-control-xl ~ &,\n            .form-select.form-control-lg ~ &,.form-select.form-control-xl ~ &{\n                font-size: 12px;\n            }\n        }\n    }\n    &-note{\n        font-size: $fx-sz-12;\n        color: $base-light;\n        font-style: italic;\n        display: block;\n        &-alt{\n            font-size: $fx-sz-12;\n            color: $base-light;\n        }\n        &-group{\n            display: flex;\n            justify-content: space-between;\n            margin-top: 0.5rem;\n            margin-bottom: -0.25rem;\n        }\n    }\n    &-control{\n        &-xl {\n            height: $input-height-xl;\n            padding: $input-padding-y-xl $input-padding-x-xl;\n            @include font-size($input-font-size-xl);\n            line-height: $input-line-height-xl;\n            @include border-radius($input-border-radius-xl);\n        }\n        &-outlined{\n            cursor: pointer;\n            .focused &{\n                cursor: auto;\n            }\n        }\n        &-wrap,&-group{\n            position: relative;\n            + .form-note{\n                margin-top: 0.5rem;\n            }\n        }\n        &-noborder{\n            border-color: transparent;\n            &:focus{\n                border-color: $input-border-color;\n                box-shadow: none;\n            }\n        }\n        &-solid{\n            border-color: $input-bg;\n            &:focus{\n                box-shadow: none;\n                border-color: $input-border-color;\n            }\n        }\n        &-number{\n            font-size: 20px;\n            padding: 20px;\n            height: 74px;\n        }\n        &-password{\n            &-big{\n                font-size: 44px;\n                height: calc(#{$field-padding-x}*2 + #{$field-line-height} + #{$field-border-width});\n                padding: $field-padding-x 1rem;\n            }\n        }\n        &.error{\n            // color: $input-error-color;\n            border-color: $input-error-border-color;\n            &:focus{\n                box-shadow: $input-error-focus-box-shadow;\n            }\n        }\n        &.focus{\n            border-color: $input-focus-border-color;\n            box-shadow: $input-focus-box-shadow;\n        }\n        &-simple{\n            border: none;\n            padding: 0;\n            &:focus{\n                box-shadow: none;\n            }\n        }\n    }\n    &-group{\n        position: relative;\n        margin-bottom: 1.25rem;\n        &:last-child{\n            margin-bottom: 0;\n        }\n    }\n    &-select{\n        height: $input-height;\n        &:not(.form-control){\n            opacity: 0;\n        }\n        &-sm,&[data-ui*=\"sm\"]{\n            height: $input-height-sm;\n        }\n        &-lg,&[data-ui*=\"lg\"]{\n            height: $input-height-lg;\n        }\n        &-xl,&[data-ui*=\"xl\"]{\n            height: $input-height-xl;\n        }\n    }\n    &-focus{\n        &-none{\n            &:focus{\n                border-color: transparent;\n                box-shadow: none;\n            }\n        }\n    }\n    &-action {\n        .btn + .btn {\n            margin-left: 1.25rem;\n        }\n    }\n    &-round{\n        border-radius: 100px;\n    }\n}\n.custom-select{\n    appearance: none;\n    -webkit-appearance: none;\n    option{\n        border-radius: $border-radius-sm;\n        padding: 5px .5rem;\n        margin: 2px -.5rem;\n        cursor: pointer;\n        color: $base-text;\n        &:last-child{\n            margin-bottom: -0.5rem;\n        }\n    }\n}\n.form-control-select{\n    position: relative;\n    .form-control{\n        appearance: none;\n        -webkit-appearance: none;\n    }\n    &-multiple{\n        .custom-select{\n            padding-top: 0.375rem;\n            padding-bottom: 0.875rem;\n            option{\n                border-radius: $border-radius-sm;\n                padding: 5px .5rem;\n                margin: 2px -.5rem;\n                cursor: pointer;\n                color: $base-text;\n                &:last-child{\n                    margin-bottom: -0.5rem;\n                }\n            }\n        }\n    }\n    &:after{\n        font-family: $nk-dashlite-font;\n        content:$ni-chevron-down;\n        pointer-events: none;\n        position: absolute;\n        display: inline-flex;\n        justify-content: center;\n        align-items: center;\n        @if($rtl==false){\n            right: 1px;\n        }\n        @if($rtl==true){\n            left: 1px;\n        }\n        top: 1px;\n        width: calc(#{$input-height} - 2px);\n        height: calc(#{$input-height} - 2px);\n        &.sm:after{\n            width: calc(#{$input-height-sm} - 2px);\n            height: calc(#{$input-height-sm} - 2px);\n        }\n        &.lg:after{\n            width: calc(#{$input-height-lg} - 2px);\n            height: calc(#{$input-height-lg} - 2px);\n        }\n    }\n}\n\ntextarea{\n    &.no-resize{\n        resize: none;\n    }\n    &.form-control{\n        min-height: $textarea-min-height;\n        padding-top: $input-padding-y*1.5;\n    }\n    &.textarea-sm{\n        min-height: $textarea-min-height-sm;\n    }\n    &.textarea-lg{\n        min-height: $textarea-min-height-lg;\n    }\n    &.textarea-auto{\n        min-height: 0;\n    }\n}\n\n// validation\n\n.custom-file-input,.form-control,.input-group{\n    ~ .error, ~ .invalid{\n        color: $field-error-color;\n        font-size: $fx-sz-11;\n        font-style: italic;\n    }\n}\n\n.custom-btn{\n    &-check{\n        position: relative;\n        input{\n            position: absolute;\n            opacity: 0;\n            height: 1px;\n            width: 1px;\n            &:checked ~{\n                label{\n                    color: $white;\n                    border-color: $accent-color;\n                    background-color: $accent-color;\n                }\n            }\n        }\n        label{\n            display: inline-block;\n            border:2px solid $light;\n            background-color: $light;\n            font-weight: $fw-medium;\n            color: $base-text;\n            text-align: center;\n            padding: 0.4375rem 1.125rem;\n            font-size: 0.8125rem;\n            line-height: 1.25rem;\n            border-radius: $border-radius;\n            transition: all .3s;\n            margin-bottom: 0 !important;\n        }\n    }\n    &-sm{\n        label{\n            padding: 0.25rem 1rem;\n            font-size: 0.75rem;\n            line-height: 1.25rem;\n        }\n    }\n    &-round{\n        label{\n            border-radius: 60px;\n        }\n    }\n    &-outline{\n        label{\n            background-color: transparent;\n        }\n    }\n}","@use 'sass:math';\n.custom{\n    &-control{\n        display: inline-flex;\n        min-height: $checkbox-radio-switch-size;\n        &.notext{\n            margin-left: -$checkbox-radio-switch-text-gap;\n            .custom-control-label{\n                position: relative;\n                left: $checkbox-radio-switch-text-gap;\n            }\n        }\n        &-label{\n            font-size: $checkbox-radio-switch-font-size;\n            line-height: $checkbox-radio-switch-line-height;\n            padding-top: math.div(($checkbox-radio-switch-size - $checkbox-radio-switch-line-height),2);\n            &::before,&::after {\n                top: 0;\n            }\n            &:after{\n                display: inline-flex;\n                align-items: center;\n                justify-content: center;\n                background-image: none !important;\n                font-family: $nk-dashlite-font;\n                color: $custom-control-indicator-checked-color;\n                opacity: 0;\n                .custom-checkbox &{\n                    content: $ni-check-thick;\n                }\n                .custom-radio &{\n                    content: $ni-bullet-fill;\n                }\n            }\n        }\n        .custom-control-input{\n            &:checked ~ .custom-control-label::after{\n                opacity: 1;\n            }\n            &[disabled],&:disabled{\n                ~ .custom-control-label{\n                    opacity: .7;\n                    color: $base-color;\n                }\n            }\n        }\n        &-sm{\n            min-height: $checkbox-radio-switch-size-sm;\n            padding-left: $checkbox-radio-switch-text-gap-sm + $checkbox-radio-switch-size-sm;\n            &.notext{\n                margin-left: -$checkbox-radio-switch-text-gap-sm;\n                .custom-control-label{\n                    left: $checkbox-radio-switch-text-gap-sm;\n                }\n            }\n            .custom-control-label {\n                font-size: $checkbox-radio-switch-font-size-sm;\n                line-height: $checkbox-radio-switch-line-height-sm;\n                padding-top: 0;\n                &::before,&::after {\n                    left: -($checkbox-radio-switch-text-gap-sm + $checkbox-radio-switch-size-sm);\n                    width: $checkbox-radio-switch-size-sm;\n                    height: $checkbox-radio-switch-size-sm;\n                }\n                &:after{\n                    font-size: 0.9em;\n                }\n            }\n        }\n        &-lg{\n            min-height: $checkbox-radio-switch-size-lg;\n            padding-left: $checkbox-radio-switch-text-gap-lg + $checkbox-radio-switch-size-lg;\n            &.notext{\n                margin-left: -$checkbox-radio-switch-text-gap-lg;\n                .custom-control-label{\n                    left: $checkbox-radio-switch-text-gap-lg;\n                }\n            }\n            .custom-control-label {\n                font-size: $checkbox-radio-switch-font-size-lg;\n                line-height: $checkbox-radio-switch-line-height-lg;\n                padding-top: math.div(($checkbox-radio-switch-size-lg - $checkbox-radio-switch-line-height-lg),2);\n                &::before,&::after {\n                    left: -($checkbox-radio-switch-text-gap-lg + $checkbox-radio-switch-size-lg);\n                    width: $checkbox-radio-switch-size-lg;\n                    height: $checkbox-radio-switch-size-lg;\n                }\n                &:after{\n                    font-size: 1.2em;\n                }\n            }\n        }\n        &-input{\n            position: absolute;\n            height: 1px;\n            width: 1px;\n            opacity: 0;\n        }\n        &.is-right{\n            padding-left: 0;\n            padding-right: $checkbox-radio-switch-text-gap + $checkbox-radio-switch-size;\n            .custom-control-label{\n                &:before,&:after{\n                    left: auto;\n                    right: - ($checkbox-radio-switch-text-gap + $checkbox-radio-switch-size);\n                }\n            }\n            &.custom-control-sm{\n                padding-right: $checkbox-radio-switch-text-gap-sm + $checkbox-radio-switch-size-sm;\n                .custom-control-label{\n                    &:before,&:after{\n                        right: - ($checkbox-radio-switch-text-gap-sm + $checkbox-radio-switch-size-sm);\n                    }\n                }\n            }\n            &.custom-control-lg{\n                padding-right: $checkbox-radio-switch-text-gap-lg + $checkbox-radio-switch-size-lg;\n                .custom-control-label{\n                    &:before,&:after{\n                        right: - ($checkbox-radio-switch-text-gap-lg + $checkbox-radio-switch-size-lg);\n                    }\n                }\n            }\n        }\n    }\n    &-file-label{\n        white-space: nowrap;\n        overflow: hidden;\n    }\n    &-select{\n        background: $field-bg;\n    }\n}\n.custom-switch {\n    padding-left: $switch-width + $checkbox-radio-switch-text-gap;\n    .custom-control-label {\n      &::before {\n        left: -($switch-width + $checkbox-radio-switch-text-gap);\n        width: $switch-width;\n        border-radius: $switch-indicator-border-radius;\n      }\n      &::after {\n        opacity: 1;\n        top: math.div(($checkbox-radio-switch-size - $switch-indicator-size),2);\n        left: add(-($switch-width + $checkbox-radio-switch-text-gap), $custom-control-indicator-border-width * 2);\n        width: $switch-indicator-size;\n        height: $switch-indicator-size;\n        border-radius: $switch-indicator-border-radius;\n      }\n    }\n    .custom-control-input:checked ~ .custom-control-label {\n      &::after {\n          transform: translateX($switch-indicator-active-position);\n      }\n    }\n    &.custom-control-sm{\n        padding-left: $switch-width-sm + $checkbox-radio-switch-text-gap-sm;\n        .custom-control-label {\n            &::before {\n                left: -($switch-width-sm + $checkbox-radio-switch-text-gap-sm);\n              width: $switch-width-sm;\n              border-radius: $switch-indicator-border-radius-sm;\n            }\n            &::after {\n              top: math.div(($checkbox-radio-switch-size-sm - $switch-indicator-size-sm),2);\n              left: add(-($switch-width-sm + $checkbox-radio-switch-text-gap-sm), $switch-border-calc);\n              width: $switch-indicator-size-sm;\n              height: $switch-indicator-size-sm;\n              border-radius: $switch-indicator-border-radius-sm;\n            }\n        }\n        .custom-control-input:checked ~ .custom-control-label {\n            &::after {\n                transform:translateX($switch-indicator-active-position-sm);\n            }\n        }\n    }\n    &.custom-control-lg{\n        padding-left: $switch-width-lg + $checkbox-radio-switch-text-gap-lg;\n        .custom-control-label {\n            &::before {\n                left: -($switch-width-lg + $checkbox-radio-switch-text-gap-lg);\n              width: $switch-width-lg;\n              border-radius: $switch-indicator-border-radius-lg;\n            }\n            &::after {\n              top: math.div(($checkbox-radio-switch-size-lg - $switch-indicator-size-lg),2);\n              left: add(-($switch-width-lg + $checkbox-radio-switch-text-gap-lg), $switch-border-calc-1-5x);\n              width: $switch-indicator-size-lg;\n              height: $switch-indicator-size-lg;\n              border-radius: $switch-indicator-border-radius-lg;\n            }\n        }\n        .custom-control-input:checked ~ .custom-control-label {\n            &::after {\n                transform:translateX($switch-indicator-active-position-lg);\n            }\n        }\n    }\n    &.is-right{\n        padding-left: 0;\n        padding-right: $switch-width + $checkbox-radio-switch-text-gap;\n        .custom-control-label{\n            &:before,&:after{\n                left: auto;\n                right: - ($checkbox-radio-switch-text-gap + $checkbox-radio-switch-size);\n            }\n        }\n        .custom-control-label::before {\n            right: - ($switch-width + $checkbox-radio-switch-text-gap);\n        }\n        .custom-control-label::after {\n            right: add(-($switch-width + $checkbox-radio-switch-text-gap), $switch-border-calc);\n        }\n        .custom-control-input:checked ~ .custom-control-label {\n            &::after {\n                transform: translateX($switch-indicator-active-position-right);\n            }\n        }\n        &.custom-control-sm{\n            padding-right: $switch-width-sm + $checkbox-radio-switch-text-gap-sm;\n            .custom-control-label::before {\n                right: - ($switch-width-sm + $checkbox-radio-switch-text-gap-sm);\n            }\n            .custom-control-label::after {\n                right: add(-($switch-width-sm + $checkbox-radio-switch-text-gap-sm), $switch-border-calc);\n            }\n            .custom-control-input:checked ~ .custom-control-label {\n                &::after {\n                    transform: translateX($switch-indicator-active-position-right-sm);\n                }\n            }\n        }\n        &.custom-control-lg{\n            padding-right: $switch-width-lg + $checkbox-radio-switch-text-gap-lg;\n            .custom-control-label::before {\n                right: - ($switch-width-lg + $checkbox-radio-switch-text-gap-lg);\n            }\n            .custom-control-label::after {\n                right: add(-($switch-width-lg + $checkbox-radio-switch-text-gap-lg), $switch-border-calc-1-5x);\n            }\n            .custom-control-input:checked ~ .custom-control-label {\n                &::after {\n                    transform: translateX($switch-indicator-active-position-right-lg);\n                }\n            }\n        }\n    }\n}\n  \n\nlabel{\n    cursor: pointer;\n    input[type=\"radio\"]:checked ~ &{\n        cursor: default;\n    }\n}\n\n\n//validation\n\n.is-alter .form-control ~, .is-alter .input-group ~, .custom-control{\n    .invalid{\n        position: absolute;\n        left: 0;\n        color: $white;\n        font-size: $fx-sz-11;\n        line-height: 1;\n        bottom: calc(100% + 4px);\n        background: lighten($danger, 8%);\n        padding: .3rem .5rem;\n        z-index: 1;\n        border-radius: $border-radius-sm;\n        white-space: nowrap;\n        &:before{\n            position: absolute;\n            content: '';\n            height: 0;\n            width: 0;\n            border-left: 6px solid lighten($danger, 8%); \n            border-right: 6px solid transparent;\n            left: 10px;\n            border-bottom: 6px solid transparent;\n            bottom: -6px;\n        }\n    }\n}\n.is-alter .form-control ~, .is-alter .input-group ~{\n    .invalid{\n        left: auto;\n        right: 0;\n        &::before{\n            left: auto;\n            right: 10px;\n            border-right-color: lighten($danger, 8%); \n            border-left-color:transparent;\n            bottom: -4px;\n        }\n    }\n}",".table {\n    thead tr:last-child{\n        th{\n            border-bottom: $table-border-width solid $table-border-color;\n        }\n    }\n    &-dark thead tr:last-child th, thead.thead-dark tr:last-child th {\n        border-color: $table-dark-border-color;\n    }\n    td,th{\n        &:first-child{\n            padding-left: $table-cell-padding-x-sm;\n        }\n        &:last-child{\n            padding-right: $table-cell-padding-x-sm;\n        }\n    }\n\n    th {\n        line-height: 1.1;\n        &.overline-title {\n            line-height: 1.25rem;\n            font-weight: $fw-medium;\n        }\n    }\n    caption {\n        font-style: italic;\n        padding-left: $table-cell-padding-x-sm;\n    }\n    &-bordered {\n        td, th {\n            padding-left: $table-cell-padding-bordered;\n            padding-right: $table-cell-padding-bordered;\n        }\n    }\n    &-plain {\n        td, th{\n            &:first-child{\n                padding-left: 0;\n            }\n            &:last-child{\n                padding-right: 0;\n            }\n        }\n    }\n    &-lg {\n        td {\n            padding-top: ($table-cell-padding * 2);\n            padding-bottom: ($table-cell-padding * 2);\n        }\n        th {\n            padding-top: ($table-cell-padding * 1.5);\n            padding-bottom: ($table-cell-padding * 1.5);\n        }\n    }\n    &-vm td, &-vm th, td.vm, th.vm{\n        vertical-align: middle;\n    }\n}\n@include media-breakpoint-up(sm){\n    .table {\n        &-lg td, &-lg th {\n            &:first-child{\n                padding-left: ($table-cell-padding-sm + $table-cell-padding-x-sm);\n            }\n            &:last-child{\n                padding-right: ($table-cell-padding-sm + $table-cell-padding-x-sm);\n            }\n        }\n    }\n}",".media{\n    &-center{\n        align-items: center;\n    }\n    &-object{\n        display: inline-flex;\n    }\n    > *:first-child{\n        flex-shrink: 0;\n    }\n    > *:last-child{\n        flex-grow: 1;\n        max-width: 100%;\n    }\n}",".nav{\n    margin: -.5rem -1rem;\n    .nav-link{\n        display: inline-flex;\n        align-items: center;\n        .icon + span, span + .icon{\n            margin-left: 0.75rem;\n        }\n        .icon{\n            font-size: 1.3em;\n        }\n    }\n    &-tabs{\n        font-family: $alt-font-family;\n        margin: 0;\n        font-size:0.8125rem;\n        border-bottom: 1px solid $border-color;\n        &-s2{\n            border-bottom: none;\n            justify-content: center;\n        }\n        + .tab-content{\n            margin-top: 1.25rem;\n        }\n        .nav{\n            &-item{\n                padding-right:1.25rem;\n                &:last-child{\n                    padding-right: 0;\n                }\n                &.active .nav-link{\n                    color: $primary;\n                    &:after{\n                        opacity: 1;\n                    }\n                }\n            }\n            &-link{\n                padding: 1rem 0;\n                font-weight: 700;\n                color: $base-text;\n                position: relative;\n                border: none;\n                outline: none;\n                display: inline-flex;\n                align-items: center;\n                .icon{\n                    font-size: 1.4em;\n                    + span{\n                        margin-left: 0.5rem;\n                    }\n                }\n                .badge{\n                    margin-left: 0.25rem;\n                }\n                &:hover{\n                    color: $base-color;\n                }\n                &:focus{\n                    color: $primary;\n                }\n                &:before,&:after{\n                    position: absolute;\n                    content: '';\n                }\n                &:after{\n                    left: 0;\n                    right: 0;\n                    bottom: 0;\n                    height: 3px;\n                    background: $primary;\n                    opacity: 0;\n                }\n                &.active{\n                    color: $primary;\n                    border: none;\n                    background-color: transparent;\n                    &:after{\n                        opacity: 1;\n                    }\n                }\n            }\n        }\n    }\n    &-sm{\n        font-size: 0.8125rem;\n    }\n}\n@include media-breakpoint-up(md){\n    .nav-tabs{\n        .nav-item{\n            padding-right:1.5rem;\n        }\n        &-sm{\n            .nav-item{\n                padding-right:1.25rem;\n            }\n        }\n    }\n}\n@include media-breakpoint-up(lg){\n    .nav-tabs{\n        .nav-item{\n            padding-right:1.75rem;\n        }\n        &-sm{\n            .nav-item{\n                padding-right:1.25rem;\n            }\n        }\n        .nav-link{\n            font-size: 0.875rem;\n        }\n    }\n}\n@include media-breakpoint-up(xl){\n    .nav-tabs{\n        .nav-item{\n            padding-right:2.25rem;\n        }\n        &-sm{\n            .nav-item{\n                padding-right:1.25rem;\n            }\n        }\n    }\n}\n@include media-breakpoint-down(mb){\n    .nav-tabs.is-stretch{\n        margin-left: -$stretch-gap-x;\n        margin-right: -$stretch-gap-x;\n        padding-left: $stretch-gap-x;\n        padding-right:$stretch-gap-x;\n    }\n}\n\n//Trigger\n.nav-item-trigger{\n    display: inline-flex;\n    align-items: center;\n    margin:-1px -.5rem 0 auto;\n}\n\n// Card Nav\n.nav-tabs-card{\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n    font-family: $base-font-family;\n}\n@include media-breakpoint-up(sm){\n    .nav-tabs-card{\n        padding-left: 1.5rem;\n        padding-right: 1.5rem;\n    }\n}\n\n// ICON\n@include media-breakpoint-down(sm){\n    .nav-tabs-mb-icon{\n        .nav-item{\n            padding-right: .75rem;\n        }\n        .nav-link{\n            .icon{\n                font-size: 1.25rem;\n                padding: 0 .5rem;\n                + span{\n                    display: none;\n                }\n            }\n        }\n    }\n}\n@media (max-width:359px){\n    .nav-tabs-mb-icon{\n        .nav-item{\n            padding-right: .35rem;\n        }\n    }\n}\n\n//Medium\n.is-medium{\n    &.nav-tabs{\n        .nav-link{\n            padding: .75rem 0;\n        }\n    }\n}",".modal{\n    &-content{\n        position: relative;\n        min-height: 40px;\n        box-shadow: $modal-content-box-shadow-xs;\n        > .close{\n            position: absolute;\n            top: .75rem;\n            right: .75rem;\n            height: 2.25rem;\n            width: 2.25rem;\n            display: inline-flex;\n            justify-content: center;\n            align-items: center;\n            color: $base-text;\n            z-index: 1;\n            transition: all .3s;\n        }\n    }\n    &-body{\n        .stretched{\n            border-radius: 0;\n            margin-left: - $modal-inner-padding;\n            margin-right: - $modal-inner-padding;\n            padding-left: $modal-inner-padding;\n            padding-right: $modal-inner-padding;\n            &.alert{\n                border: none;\n                &-icon{\n                    padding-left: $modal-inner-padding + $alert-icon-width;\n                }\n            }\n        }\n\n        &-md{\n            padding: ($modal-custom-padding-md - 0.5) $modal-body-custom-padding-x-sm;\n            .stretched{\n                margin-left: - $modal-body-custom-padding-x-sm;\n                margin-right: - $modal-body-custom-padding-x-sm;\n                padding-left: $modal-body-custom-padding-x-sm;\n                padding-right: $modal-body-custom-padding-x-sm;\n                &.alert-icon{\n                    padding-left: $modal-body-custom-padding-x-md + $alert-icon-width;\n                }\n            }\n        }\n\n        &-lg{\n            padding: $modal-custom-padding-md $modal-body-custom-padding-x-sm;\n            .stretched{\n                margin-left: - $modal-body-custom-padding-x-sm;\n                margin-right: - $modal-body-custom-padding-x-sm;\n                padding-left: $modal-body-custom-padding-x-sm;\n                padding-right: $modal-body-custom-padding-x-sm;\n                &.alert-icon{\n                    padding-left: $modal-body-custom-padding-x-md + $alert-icon-width;\n                }\n            }\n        }\n    }\n    &-footer{\n        &-stretch{\n            justify-content: stretch;\n        }\n        &-between{\n            display: flex;\n            width: 100%;\n            align-items: center;\n            justify-content: space-between;\n            flex-wrap: wrap;\n            margin: -.25rem 0;\n            > div{\n                padding: .25rem 0;\n            }\n        }\n    }\n    &-dialog{\n        display: flex;\n        align-items: center;\n        min-height: subtract(100%, $modal-dialog-margin * 2);\n        &::before {\n          height: subtract(100vh, $modal-dialog-margin * 2);\n        }\n        .modal.fade &{\n            transform: $modal-fade-transform-revarse;\n        }\n        .modal.zoom &{\n            transform: $modal-scale-transform;\n            transition: $modal-transition;\n        }\n        &-top{\n            align-items: flex-start;\n            .modal.fade &{\n                transform: $modal-fade-transform;\n            }\n        }\n        &-bottom{\n            align-items: flex-end;\n        }\n    }\n}\n\n@include media-breakpoint-up(sm){\n    .modal-dialog{\n        min-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n        &::before {\n          height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n        }\n    }\n    .modal{\n        &-body{\n            padding: $modal-custom-padding $modal-body-custom-padding-x;\n            .stretched{\n                margin-left: - $modal-body-custom-padding-x;\n                margin-right: - $modal-body-custom-padding-x;\n                padding-left: $modal-body-custom-padding-x;\n                padding-right: $modal-body-custom-padding-x;\n                &.alert-icon{\n                    padding-left: $modal-body-custom-padding-x + $alert-icon-width;\n                }\n            }\n            &-sm{\n                padding: $modal-custom-padding-sm $modal-body-custom-padding-x-sm;\n                .stretched{\n                    margin-left: - $modal-body-custom-padding-x-sm;\n                    margin-right: - $modal-body-custom-padding-x-sm;\n                    padding-left: $modal-body-custom-padding-x-sm;\n                    padding-right: $modal-body-custom-padding-x-sm;\n                    &.alert-icon{\n                        padding-left: $modal-body-custom-padding-x-sm + $alert-icon-width;\n                    }\n                }\n            }\n            &-md{\n                padding: $modal-custom-padding-md $modal-body-custom-padding-x-md;\n                .stretched{\n                    margin-left: - $modal-body-custom-padding-x-md;\n                    margin-right: - $modal-body-custom-padding-x-md;\n                    padding-left: $modal-body-custom-padding-x-md;\n                    padding-right: $modal-body-custom-padding-x-md;\n                    &.alert-icon{\n                        padding-left: $modal-body-custom-padding-x-md + $alert-icon-width;\n                        > .icon{\n                            left: $modal-body-custom-padding-x-md;\n                        }\n                    }\n                }\n            }\n            &-lg{\n                padding: $modal-custom-padding-lg $modal-body-custom-padding-x-lg;\n                .stretched{\n                    margin-left: - $modal-body-custom-padding-x-lg;\n                    margin-right: - $modal-body-custom-padding-x-lg;\n                    padding-left: $modal-body-custom-padding-x-lg;\n                    padding-right: $modal-body-custom-padding-x-lg;\n                    &.alert-icon{\n                        padding-left: $modal-body-custom-padding-x-lg + $alert-icon-width;\n                    }\n                }\n            }\n        }\n        &-header{\n            padding: $modal-header-custom-padding-xy;\n            &-sm {\n                padding: $modal-header-custom-padding-xy-sm;\n            }\n        }\n        &-footer{\n            padding: $modal-footer-custom-padding-xy;\n            &-sm {\n                padding: $modal-footer-custom-padding-xy-sm;\n            }\n        }\n    }\n}\n\n@include media-breakpoint-up(md){\n    .modal-md{\n        max-width: 600px;\n    }\n}",".pagination{\n    &-goto{\n        display: inline-flex;\n        align-items: center;\n        font-size: .8125rem;\n        text-transform: uppercase;\n    }\n}\n\n.page{\n    &-link{\n        // @include border-radius($border-radius);\n        font-size: $pagination-font-size;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        min-width: calc(#{$pagination-line-height} + #{$pagination-padding-y*2} + #{$pagination-border-width*2});\n        .pagination-sm &{\n            line-height: $pagination-line-height-sm;\n            min-width: calc(#{$pagination-line-height-sm} + #{$pagination-padding-y-sm*2} + #{$pagination-border-width*2});\n        }\n        .pagination-lg &{\n            line-height: $pagination-line-height-lg;\n            min-width: calc(#{$pagination-line-height-lg} + #{$pagination-padding-y-lg*2} + #{$pagination-border-width*2});\n        }\n        .pagination-xl &{\n            padding: $pagination-padding-y-xl $pagination-padding-x-xl;\n            font-size: $pagination-font-size*1.7;\n            line-height: $pagination-line-height-xl;\n            min-width: calc(#{$pagination-line-height-xl} + #{$pagination-padding-y-xl*2} + #{$pagination-border-width*2});\n        }\n        .icon{\n            font-size: .8125rem;\n            line-height: inherit;\n        }\n        &:not([href]){\n            background-color: transparent;\n            color: inherit;\n            // height: 100%;\n            .icon{\n                &:before{\n                    position: relative;\n                    top: 1px;\n                }\n            }\n        }\n        &-prev,&-next{\n            span{\n                display: none;\n            }\n        }\n    }\n}\n@include media-breakpoint-up(sm){\n    .page{\n        &-link{\n            &-prev,&-next{\n                span{\n                    display: block;\n                }\n            }\n            &-prev{\n                .icon{\n                    padding-right: 0.25rem;\n                }\n            }\n            &-next{\n                .icon{\n                    padding-left: 0.25rem;\n                }\n            }\n        }\n    }\n}",".progress{\n    &-bar{\n        height: 100%;\n        line-height: 1;\n    }\n    &-sm{\n        height:.25rem;\n    }\n    &-md{\n        height:.375rem;\n    }\n    &-lg{\n        height:1rem;\n    }\n    &-pill{\n        border-radius: 100px;\n        .progress-bar{\n            @extend .progress-pill;\n        }\n    }\n    &-text{\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        color: $base-light;\n        margin-bottom: 0.25rem;\n    }\n    &-label{\n        font-size: 0.875rem;\n    }\n    &-amount{\n        font-size: $fx-sz-12;\n        padding-left: .5rem;\n    }\n    &-alt{\n        display: flex;\n        align-items: center;\n        overflow: visible;\n        .progress-bar{\n            border-radius: $progress-border-radius;\n        }\n    }\n    &-reverse{\n        flex-direction: row-reverse;\n    }\n    &-bordered{\n        .progress-bar{\n            margin-top: -2px;\n            border:2px solid $white;\n            box-sizing: content-box;\n            &:not(:first-child){\n                margin-left: -4px;\n            }\n        }\n        &.progress-reverse {\n            .progress-bar{\n                margin-left: 0;\n                &:not(:last-child){\n                    margin-left: -5px;\n                }\n            }\n        }\n    }\n    //@e-290\n    &-rating{\n        display: flex;\n        align-items: center;\n        &-title{\n            width: 48px;\n            flex-grow: 0;\n            line-height: 1.25rem;\n        }\n        &-percent{\n            width: 40px;\n            // flex-grow: 0;\n            line-height: 1.25rem;\n            text-align: right;\n        }\n        .progress{\n            flex-grow: 1;\n        }\n    }\n}",".toast{\n    .close{\n        display: inline-flex;\n        margin-right: -0.5rem;\n        margin-left: 0.5rem;\n    }\n}",".rating{\n    display: flex;\n    align-items: center;\n    margin: 0 -.125rem;\n    color: $warning;\n    > * {\n        padding: 0 .125rem;\n        display: inline-flex;\n    }\n    .icon{\n        font-size: 1rem;\n    }\n    &-wrap{\n        display: inline-flex;\n        align-items: flex-start;\n        .amount{\n            line-height: 1.25rem;\n        }\n        .rating + span,span + .rating{\n            margin-left: .75rem;\n        }\n    }\n    &-pill{\n        padding: .35rem .875rem;\n        border-radius: 3rem;\n    }\n}\n\n.rating{\n    &-card {\n        &-description{\n            .icon{\n                color: $primary;\n            }\n            li{\n                color: $base-400;\n            }\n        }\n    }\n    &-progress{\n        display: flex;\n        align-items: center;\n    }\n}\n.icon + span,span + .icon{\n    margin-left: 0.25rem;\n}","@font-face {\n  font-family: '#{$icomoon-font-family}';\n  src:  url('#{$icomoon-font-path}/#{$icomoon-font-family}.eot');\n  src:  url('#{$icomoon-font-path}/#{$icomoon-font-family}.eot#iefix') format('embedded-opentype'),\n    url('#{$icomoon-font-path}/#{$icomoon-font-family}.ttf') format('truetype'),\n    url('#{$icomoon-font-path}/#{$icomoon-font-family}.woff') format('woff'),\n    url('#{$icomoon-font-path}/#{$icomoon-font-family}.svg##{$icomoon-font-family}') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n.ni {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: '#{$icomoon-font-family}' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.ni-centos {\n  &:before {\n    content: $ni-centos; \n  }\n}\n.ni-covid {\n  &:before {\n    content: $ni-covid; \n  }\n}\n.ni-fedora {\n  &:before {\n    content: $ni-fedora; \n  }\n}\n.ni-hot-fill {\n  &:before {\n    content: $ni-hot-fill; \n  }\n}\n.ni-hot {\n  &:before {\n    content: $ni-hot; \n  }\n}\n.ni-linux-server {\n  &:before {\n    content: $ni-linux-server; \n  }\n}\n.ni-linux {\n  &:before {\n    content: $ni-linux; \n  }\n}\n.ni-note-add-fill {\n  &:before {\n    content: $ni-note-add-fill; \n  }\n}\n.ni-repeat-fill {\n  &:before {\n    content: $ni-repeat-fill; \n  }\n}\n.ni-tranx-fill {\n  &:before {\n    content: $ni-tranx-fill; \n  }\n}\n.ni-ubuntu {\n  &:before {\n    content: $ni-ubuntu; \n  }\n}\n.ni-virus {\n  &:before {\n    content: $ni-virus; \n  }\n}\n.ni-b-chrome {\n  &:before {\n    content: $ni-b-chrome; \n  }\n}\n.ni-b-edge {\n  &:before {\n    content: $ni-b-edge; \n  }\n}\n.ni-b-firefox {\n  &:before {\n    content: $ni-b-firefox; \n  }\n}\n.ni-b-ie {\n  &:before {\n    content: $ni-b-ie; \n  }\n}\n.ni-b-opera {\n  &:before {\n    content: $ni-b-opera; \n  }\n}\n.ni-b-safari {\n  &:before {\n    content: $ni-b-safari; \n  }\n}\n.ni-b-si {\n  &:before {\n    content: $ni-b-si; \n  }\n}\n.ni-b-uc {\n  &:before {\n    content: $ni-b-uc; \n  }\n}\n.ni-brick-fill {\n  &:before {\n    content: $ni-brick-fill; \n  }\n}\n.ni-brick {\n  &:before {\n    content: $ni-brick; \n  }\n}\n.ni-col-3s {\n  &:before {\n    content: $ni-col-3s; \n  }\n}\n.ni-col-4s {\n  &:before {\n    content: $ni-col-4s; \n  }\n}\n.ni-col-2s {\n  &:before {\n    content: $ni-col-2s; \n  }\n}\n.ni-comments {\n  &:before {\n    content: $ni-comments; \n  }\n}\n.ni-dot-sq {\n  &:before {\n    content: $ni-dot-sq; \n  }\n}\n.ni-dot {\n  &:before {\n    content: $ni-dot; \n  }\n}\n.ni-footer {\n  &:before {\n    content: $ni-footer; \n  }\n}\n.ni-header {\n  &:before {\n    content: $ni-header; \n  }\n}\n.ni-heading {\n  &:before {\n    content: $ni-heading; \n  }\n}\n.ni-layout-alt-fill {\n  &:before {\n    content: $ni-layout-alt-fill; \n  }\n}\n.ni-layout-alt {\n  &:before {\n    content: $ni-layout-alt; \n  }\n}\n.ni-layout-fill1 {\n  &:before {\n    content: $ni-layout-fill1; \n  }\n}\n.ni-layout1 {\n  &:before {\n    content: $ni-layout1; \n  }\n}\n.ni-list-index-fill {\n  &:before {\n    content: $ni-list-index-fill; \n  }\n}\n.ni-list-index {\n  &:before {\n    content: $ni-list-index; \n  }\n}\n.ni-list-thumb-alt-fill {\n  &:before {\n    content: $ni-list-thumb-alt-fill; \n  }\n}\n.ni-list-thumb-alt {\n  &:before {\n    content: $ni-list-thumb-alt; \n  }\n}\n.ni-list-thumb-fill {\n  &:before {\n    content: $ni-list-thumb-fill; \n  }\n}\n.ni-list-thumb {\n  &:before {\n    content: $ni-list-thumb; \n  }\n}\n.ni-masonry-fill {\n  &:before {\n    content: $ni-masonry-fill; \n  }\n}\n.ni-masonry {\n  &:before {\n    content: $ni-masonry; \n  }\n}\n.ni-menu-circled {\n  &:before {\n    content: $ni-menu-circled; \n  }\n}\n.ni-menu-squared {\n  &:before {\n    content: $ni-menu-squared; \n  }\n}\n.ni-notice {\n  &:before {\n    content: $ni-notice; \n  }\n}\n.ni-pen2 {\n  &:before {\n    content: $ni-pen2; \n  }\n}\n.ni-property-blank {\n  &:before {\n    content: $ni-property-blank; \n  }\n}\n.ni-propert-blank {\n  &:before {\n    content: $ni-propert-blank; \n  }\n}\n.ni-property-add {\n  &:before {\n    content: $ni-property-add; \n  }\n}\n.ni-property-alt {\n  &:before {\n    content: $ni-property-alt; \n  }\n}\n.ni-property-remove {\n  &:before {\n    content: $ni-property-remove; \n  }\n}\n.ni-property {\n  &:before {\n    content: $ni-property; \n  }\n}\n.ni-puzzle-fill {\n  &:before {\n    content: $ni-puzzle-fill; \n  }\n}\n.ni-puzzle {\n  &:before {\n    content: $ni-puzzle; \n  }\n}\n.ni-quote-left {\n  &:before {\n    content: $ni-quote-left; \n  }\n}\n.ni-quote-right {\n  &:before {\n    content: $ni-quote-right; \n  }\n}\n.ni-row-mix {\n  &:before {\n    content: $ni-row-mix; \n  }\n}\n.ni-row-view1 {\n  &:before {\n    content: $ni-row-view1; \n  }\n}\n.ni-sidebar-r {\n  &:before {\n    content: $ni-sidebar-r; \n  }\n}\n.ni-text2 {\n  &:before {\n    content: $ni-text2; \n  }\n}\n.ni-tile-thumb-fill {\n  &:before {\n    content: $ni-tile-thumb-fill; \n  }\n}\n.ni-tile-thumb {\n  &:before {\n    content: $ni-tile-thumb; \n  }\n}\n.ni-view-col-fill {\n  &:before {\n    content: $ni-view-col-fill; \n  }\n}\n.ni-view-col-sq {\n  &:before {\n    content: $ni-view-col-sq; \n  }\n}\n.ni-view-col {\n  &:before {\n    content: $ni-view-col; \n  }\n}\n.ni-view-col2 {\n  &:before {\n    content: $ni-view-col2; \n  }\n}\n.ni-view-col3 {\n  &:before {\n    content: $ni-view-col3; \n  }\n}\n.ni-view-cols-fill {\n  &:before {\n    content: $ni-view-cols-fill; \n  }\n}\n.ni-view-cols-sq {\n  &:before {\n    content: $ni-view-cols-sq; \n  }\n}\n.ni-view-cols {\n  &:before {\n    content: $ni-view-cols; \n  }\n}\n.ni-view-grid-fill {\n  &:before {\n    content: $ni-view-grid-fill; \n  }\n}\n.ni-view-grid-sq {\n  &:before {\n    content: $ni-view-grid-sq; \n  }\n}\n.ni-view-grid-wd {\n  &:before {\n    content: $ni-view-grid-wd; \n  }\n}\n.ni-view-grid {\n  &:before {\n    content: $ni-view-grid; \n  }\n}\n.ni-view-grid2-wd {\n  &:before {\n    content: $ni-view-grid2-wd; \n  }\n}\n.ni-view-grid3-wd {\n  &:before {\n    content: $ni-view-grid3-wd; \n  }\n}\n.ni-view-group-fill {\n  &:before {\n    content: $ni-view-group-fill; \n  }\n}\n.ni-view-group-wd {\n  &:before {\n    content: $ni-view-group-wd; \n  }\n}\n.ni-view-list-fill {\n  &:before {\n    content: $ni-view-list-fill; \n  }\n}\n.ni-view-list-sq {\n  &:before {\n    content: $ni-view-list-sq; \n  }\n}\n.ni-view-list-wd {\n  &:before {\n    content: $ni-view-list-wd; \n  }\n}\n.ni-view-list {\n  &:before {\n    content: $ni-view-list; \n  }\n}\n.ni-view-panel-fill {\n  &:before {\n    content: $ni-view-panel-fill; \n  }\n}\n.ni-view-panel-sq {\n  &:before {\n    content: $ni-view-panel-sq; \n  }\n}\n.ni-view-panel {\n  &:before {\n    content: $ni-view-panel; \n  }\n}\n.ni-view-row-fill {\n  &:before {\n    content: $ni-view-row-fill; \n  }\n}\n.ni-view-row-sq {\n  &:before {\n    content: $ni-view-row-sq; \n  }\n}\n.ni-view-row-wd {\n  &:before {\n    content: $ni-view-row-wd; \n  }\n}\n.ni-view-row {\n  &:before {\n    content: $ni-view-row; \n  }\n}\n.ni-view-x1 {\n  &:before {\n    content: $ni-view-x1; \n  }\n}\n.ni-view-x2 {\n  &:before {\n    content: $ni-view-x2; \n  }\n}\n.ni-view-x3 {\n  &:before {\n    content: $ni-view-x3; \n  }\n}\n.ni-view-x4 {\n  &:before {\n    content: $ni-view-x4; \n  }\n}\n.ni-view-x5 {\n  &:before {\n    content: $ni-view-x5; \n  }\n}\n.ni-view-x6 {\n  &:before {\n    content: $ni-view-x6; \n  }\n}\n.ni-view-x7 {\n  &:before {\n    content: $ni-view-x7; \n  }\n}\n.ni-dashlite {\n  &:before {\n    content: $ni-dashlite; \n  }\n}\n.ni-dashlite-circle {\n  &:before {\n    content: $ni-dashlite-circle; \n  }\n}\n.ni-dashlite-alt {\n  &:before {\n    content: $ni-dashlite-alt; \n  }\n}\n.ni-master-card {\n  &:before {\n    content: $ni-master-card; \n  }\n}\n.ni-paypal {\n  &:before {\n    content: $ni-paypal; \n  }\n}\n.ni-visa-alt {\n  &:before {\n    content: $ni-visa-alt; \n  }\n}\n.ni-coin-eur {\n  &:before {\n    content: $ni-coin-eur; \n  }\n}\n.ni-coin-gbp {\n  &:before {\n    content: $ni-coin-gbp; \n  }\n}\n.ni-sign-ada-alt {\n  &:before {\n    content: $ni-sign-ada-alt; \n  }\n}\n.ni-sign-bch-alt {\n  &:before {\n    content: $ni-sign-bch-alt; \n  }\n}\n.ni-sign-bgp-alt {\n  &:before {\n    content: $ni-sign-bgp-alt; \n  }\n}\n.ni-sign-bnb-alt {\n  &:before {\n    content: $ni-sign-bnb-alt; \n  }\n}\n.ni-sign-brl-alt {\n  &:before {\n    content: $ni-sign-brl-alt; \n  }\n}\n.ni-sign-btc-alt {\n  &:before {\n    content: $ni-sign-btc-alt; \n  }\n}\n.ni-sign-cc-alt {\n  &:before {\n    content: $ni-sign-cc-alt; \n  }\n}\n.ni-sign-cc-alt2 {\n  &:before {\n    content: $ni-sign-cc-alt2; \n  }\n}\n.ni-sign-chf-alt {\n  &:before {\n    content: $ni-sign-chf-alt; \n  }\n}\n.ni-sign-cny-alt {\n  &:before {\n    content: $ni-sign-cny-alt; \n  }\n}\n.ni-sign-czk-alt {\n  &:before {\n    content: $ni-sign-czk-alt; \n  }\n}\n.ni-sign-dash-alt {\n  &:before {\n    content: $ni-sign-dash-alt; \n  }\n}\n.ni-sign-dkk-alt {\n  &:before {\n    content: $ni-sign-dkk-alt; \n  }\n}\n.ni-sign-eos-alt {\n  &:before {\n    content: $ni-sign-eos-alt; \n  }\n}\n.ni-sign-eth-alt {\n  &:before {\n    content: $ni-sign-eth-alt; \n  }\n}\n.ni-sign-eur-alt2 {\n  &:before {\n    content: $ni-sign-eur-alt2; \n  }\n}\n.ni-sign-euro-alt {\n  &:before {\n    content: $ni-sign-euro-alt; \n  }\n}\n.ni-sign-gbp-alt2 {\n  &:before {\n    content: $ni-sign-gbp-alt2; \n  }\n}\n.ni-sign-hkd-alt {\n  &:before {\n    content: $ni-sign-hkd-alt; \n  }\n}\n.ni-sign-idr-alt {\n  &:before {\n    content: $ni-sign-idr-alt; \n  }\n}\n.ni-sign-inr-alt {\n  &:before {\n    content: $ni-sign-inr-alt; \n  }\n}\n.ni-sign-jpy-alt {\n  &:before {\n    content: $ni-sign-jpy-alt; \n  }\n}\n.ni-sign-kr-alt {\n  &:before {\n    content: $ni-sign-kr-alt; \n  }\n}\n.ni-sign-ltc-alt {\n  &:before {\n    content: $ni-sign-ltc-alt; \n  }\n}\n.ni-sign-ltc {\n  &:before {\n    content: $ni-sign-ltc; \n  }\n}\n.ni-sign-mxn-alt {\n  &:before {\n    content: $ni-sign-mxn-alt; \n  }\n}\n.ni-sign-mxr-alt {\n  &:before {\n    content: $ni-sign-mxr-alt; \n  }\n}\n.ni-sign-myr-alt {\n  &:before {\n    content: $ni-sign-myr-alt; \n  }\n}\n.ni-sign-paypal-alt {\n  &:before {\n    content: $ni-sign-paypal-alt; \n  }\n}\n.ni-sign-paypal-full {\n  &:before {\n    content: $ni-sign-paypal-full; \n  }\n}\n.ni-sign-php-alt {\n  &:before {\n    content: $ni-sign-php-alt; \n  }\n}\n.ni-sign-pln-alt {\n  &:before {\n    content: $ni-sign-pln-alt; \n  }\n}\n.ni-sign-rub-alt {\n  &:before {\n    content: $ni-sign-rub-alt; \n  }\n}\n.ni-sign-sek-alt {\n  &:before {\n    content: $ni-sign-sek-alt; \n  }\n}\n.ni-sign-sgd-alt {\n  &:before {\n    content: $ni-sign-sgd-alt; \n  }\n}\n.ni-sign-kobo-alt {\n  &:before {\n    content: $ni-sign-kobo-alt; \n  }\n}\n.ni-sign-steem-alt {\n  &:before {\n    content: $ni-sign-steem-alt; \n  }\n}\n.ni-sign-steller-alt {\n  &:before {\n    content: $ni-sign-steller-alt; \n  }\n}\n.ni-sign-stripe-fulll {\n  &:before {\n    content: $ni-sign-stripe-fulll; \n  }\n}\n.ni-sign-thb-alt {\n  &:before {\n    content: $ni-sign-thb-alt; \n  }\n}\n.ni-sign-trx-alt {\n  &:before {\n    content: $ni-sign-trx-alt; \n  }\n}\n.ni-sign-try-alt {\n  &:before {\n    content: $ni-sign-try-alt; \n  }\n}\n.ni-sign-usd-alt {\n  &:before {\n    content: $ni-sign-usd-alt; \n  }\n}\n.ni-sign-usd-alt2 {\n  &:before {\n    content: $ni-sign-usd-alt2; \n  }\n}\n.ni-sign-usdc-alt {\n  &:before {\n    content: $ni-sign-usdc-alt; \n  }\n}\n.ni-sign-usdt-alt {\n  &:before {\n    content: $ni-sign-usdt-alt; \n  }\n}\n.ni-sign-visa-alt {\n  &:before {\n    content: $ni-sign-visa-alt; \n  }\n}\n.ni-sign-vnd-alt {\n  &:before {\n    content: $ni-sign-vnd-alt; \n  }\n}\n.ni-sign-waves-alt {\n  &:before {\n    content: $ni-sign-waves-alt; \n  }\n}\n.ni-sign-xem-alt {\n  &:before {\n    content: $ni-sign-xem-alt; \n  }\n}\n.ni-sign-xrp-new-alt {\n  &:before {\n    content: $ni-sign-xrp-new-alt; \n  }\n}\n.ni-sign-xrp-old-alt {\n  &:before {\n    content: $ni-sign-xrp-old-alt; \n  }\n}\n.ni-sign-zcash-alt {\n  &:before {\n    content: $ni-sign-zcash-alt; \n  }\n}\n.ni-chevron-left {\n  &:before {\n    content: $ni-chevron-left; \n  }\n}\n.ni-chevron-right {\n  &:before {\n    content: $ni-chevron-right; \n  }\n}\n.ni-chevron-up {\n  &:before {\n    content: $ni-chevron-up; \n  }\n}\n.ni-chevron-down {\n  &:before {\n    content: $ni-chevron-down; \n  }\n}\n.ni-chevron-left-round {\n  &:before {\n    content: $ni-chevron-left-round; \n  }\n}\n.ni-chevron-right-round {\n  &:before {\n    content: $ni-chevron-right-round; \n  }\n}\n.ni-chevron-up-round {\n  &:before {\n    content: $ni-chevron-up-round; \n  }\n}\n.ni-chevron-down-round {\n  &:before {\n    content: $ni-chevron-down-round; \n  }\n}\n.ni-chevron-left-round-fill {\n  &:before {\n    content: $ni-chevron-left-round-fill; \n  }\n}\n.ni-chevron-right-round-fill {\n  &:before {\n    content: $ni-chevron-right-round-fill; \n  }\n}\n.ni-chevron-up-round-fill {\n  &:before {\n    content: $ni-chevron-up-round-fill; \n  }\n}\n.ni-chevron-down-round-fill {\n  &:before {\n    content: $ni-chevron-down-round-fill; \n  }\n}\n.ni-chevron-left-c {\n  &:before {\n    content: $ni-chevron-left-c; \n  }\n}\n.ni-chevron-right-c {\n  &:before {\n    content: $ni-chevron-right-c; \n  }\n}\n.ni-chevron-up-c {\n  &:before {\n    content: $ni-chevron-up-c; \n  }\n}\n.ni-chevron-down-c {\n  &:before {\n    content: $ni-chevron-down-c; \n  }\n}\n.ni-chevron-left-fill-c {\n  &:before {\n    content: $ni-chevron-left-fill-c; \n  }\n}\n.ni-chevron-right-fill-c {\n  &:before {\n    content: $ni-chevron-right-fill-c; \n  }\n}\n.ni-chevron-up-fill-c {\n  &:before {\n    content: $ni-chevron-up-fill-c; \n  }\n}\n.ni-chevron-down-fill-c {\n  &:before {\n    content: $ni-chevron-down-fill-c; \n  }\n}\n.ni-chevron-left-circle {\n  &:before {\n    content: $ni-chevron-left-circle; \n  }\n}\n.ni-chevron-right-circle {\n  &:before {\n    content: $ni-chevron-right-circle; \n  }\n}\n.ni-chevron-up-circle {\n  &:before {\n    content: $ni-chevron-up-circle; \n  }\n}\n.ni-chevron-down-circle {\n  &:before {\n    content: $ni-chevron-down-circle; \n  }\n}\n.ni-chevron-left-circle-fill {\n  &:before {\n    content: $ni-chevron-left-circle-fill; \n  }\n}\n.ni-chevron-right-circle-fill {\n  &:before {\n    content: $ni-chevron-right-circle-fill; \n  }\n}\n.ni-chevron-up-circle-fill {\n  &:before {\n    content: $ni-chevron-up-circle-fill; \n  }\n}\n.ni-chevron-down-circle-fill {\n  &:before {\n    content: $ni-chevron-down-circle-fill; \n  }\n}\n.ni-caret-left {\n  &:before {\n    content: $ni-caret-left; \n  }\n}\n.ni-caret-right {\n  &:before {\n    content: $ni-caret-right; \n  }\n}\n.ni-caret-up {\n  &:before {\n    content: $ni-caret-up; \n  }\n}\n.ni-caret-down {\n  &:before {\n    content: $ni-caret-down; \n  }\n}\n.ni-caret-left-fill {\n  &:before {\n    content: $ni-caret-left-fill; \n  }\n}\n.ni-caret-right-fill {\n  &:before {\n    content: $ni-caret-right-fill; \n  }\n}\n.ni-caret-up-fill {\n  &:before {\n    content: $ni-caret-up-fill; \n  }\n}\n.ni-caret-down-fill {\n  &:before {\n    content: $ni-caret-down-fill; \n  }\n}\n.ni-sort {\n  &:before {\n    content: $ni-sort; \n  }\n}\n.ni-sort-up {\n  &:before {\n    content: $ni-sort-up; \n  }\n}\n.ni-sort-down {\n  &:before {\n    content: $ni-sort-down; \n  }\n}\n.ni-sort-fill {\n  &:before {\n    content: $ni-sort-fill; \n  }\n}\n.ni-sort-up-fill {\n  &:before {\n    content: $ni-sort-up-fill; \n  }\n}\n.ni-sort-down-fill {\n  &:before {\n    content: $ni-sort-down-fill; \n  }\n}\n.ni-sort-v {\n  &:before {\n    content: $ni-sort-v; \n  }\n}\n.ni-swap-v {\n  &:before {\n    content: $ni-swap-v; \n  }\n}\n.ni-swap {\n  &:before {\n    content: $ni-swap; \n  }\n}\n.ni-arrow-left-round {\n  &:before {\n    content: $ni-arrow-left-round; \n  }\n}\n.ni-arrow-right-round {\n  &:before {\n    content: $ni-arrow-right-round; \n  }\n}\n.ni-arrow-up-round {\n  &:before {\n    content: $ni-arrow-up-round; \n  }\n}\n.ni-arrow-down-round {\n  &:before {\n    content: $ni-arrow-down-round; \n  }\n}\n.ni-arrow-left-round-fill {\n  &:before {\n    content: $ni-arrow-left-round-fill; \n  }\n}\n.ni-arrow-right-round-fill {\n  &:before {\n    content: $ni-arrow-right-round-fill; \n  }\n}\n.ni-arrow-up-round-fill {\n  &:before {\n    content: $ni-arrow-up-round-fill; \n  }\n}\n.ni-arrow-down-round-fill {\n  &:before {\n    content: $ni-arrow-down-round-fill; \n  }\n}\n.ni-arrow-left-c {\n  &:before {\n    content: $ni-arrow-left-c; \n  }\n}\n.ni-arrow-right-c {\n  &:before {\n    content: $ni-arrow-right-c; \n  }\n}\n.ni-arrow-up-c {\n  &:before {\n    content: $ni-arrow-up-c; \n  }\n}\n.ni-arrow-down-c {\n  &:before {\n    content: $ni-arrow-down-c; \n  }\n}\n.ni-arrow-left-fill-c {\n  &:before {\n    content: $ni-arrow-left-fill-c; \n  }\n}\n.ni-arrow-right-fill-c {\n  &:before {\n    content: $ni-arrow-right-fill-c; \n  }\n}\n.ni-arrow-up-fill-c {\n  &:before {\n    content: $ni-arrow-up-fill-c; \n  }\n}\n.ni-arrow-down-fill-c {\n  &:before {\n    content: $ni-arrow-down-fill-c; \n  }\n}\n.ni-arrow-left-circle {\n  &:before {\n    content: $ni-arrow-left-circle; \n  }\n}\n.ni-arrow-right-circle {\n  &:before {\n    content: $ni-arrow-right-circle; \n  }\n}\n.ni-arrow-up-circle {\n  &:before {\n    content: $ni-arrow-up-circle; \n  }\n}\n.ni-arrow-down-circle {\n  &:before {\n    content: $ni-arrow-down-circle; \n  }\n}\n.ni-arrow-left-circle-fill {\n  &:before {\n    content: $ni-arrow-left-circle-fill; \n  }\n}\n.ni-arrow-up-circle-fill {\n  &:before {\n    content: $ni-arrow-up-circle-fill; \n  }\n}\n.ni-arrow-down-circle-fill {\n  &:before {\n    content: $ni-arrow-down-circle-fill; \n  }\n}\n.ni-arrow-right-circle-fill {\n  &:before {\n    content: $ni-arrow-right-circle-fill; \n  }\n}\n.ni-chevrons-left {\n  &:before {\n    content: $ni-chevrons-left; \n  }\n}\n.ni-chevrons-right {\n  &:before {\n    content: $ni-chevrons-right; \n  }\n}\n.ni-chevrons-up {\n  &:before {\n    content: $ni-chevrons-up; \n  }\n}\n.ni-chevrons-down {\n  &:before {\n    content: $ni-chevrons-down; \n  }\n}\n.ni-first {\n  &:before {\n    content: $ni-first; \n  }\n}\n.ni-last {\n  &:before {\n    content: $ni-last; \n  }\n}\n.ni-back-ios {\n  &:before {\n    content: $ni-back-ios; \n  }\n}\n.ni-forward-ios {\n  &:before {\n    content: $ni-forward-ios; \n  }\n}\n.ni-upword-ios {\n  &:before {\n    content: $ni-upword-ios; \n  }\n}\n.ni-downward-ios {\n  &:before {\n    content: $ni-downward-ios; \n  }\n}\n.ni-back-alt {\n  &:before {\n    content: $ni-back-alt; \n  }\n}\n.ni-forward-alt {\n  &:before {\n    content: $ni-forward-alt; \n  }\n}\n.ni-upword-alt {\n  &:before {\n    content: $ni-upword-alt; \n  }\n}\n.ni-downward-alt {\n  &:before {\n    content: $ni-downward-alt; \n  }\n}\n.ni-back-alt-fill {\n  &:before {\n    content: $ni-back-alt-fill; \n  }\n}\n.ni-forward-alt-fill {\n  &:before {\n    content: $ni-forward-alt-fill; \n  }\n}\n.ni-upword-alt-fill {\n  &:before {\n    content: $ni-upword-alt-fill; \n  }\n}\n.ni-downward-alt-fill {\n  &:before {\n    content: $ni-downward-alt-fill; \n  }\n}\n.ni-arrow-long-left {\n  &:before {\n    content: $ni-arrow-long-left; \n  }\n}\n.ni-arrow-long-right {\n  &:before {\n    content: $ni-arrow-long-right; \n  }\n}\n.ni-arrow-long-up {\n  &:before {\n    content: $ni-arrow-long-up; \n  }\n}\n.ni-arrow-long-down {\n  &:before {\n    content: $ni-arrow-long-down; \n  }\n}\n.ni-arrow-left {\n  &:before {\n    content: $ni-arrow-left; \n  }\n}\n.ni-arrow-right {\n  &:before {\n    content: $ni-arrow-right; \n  }\n}\n.ni-arrow-up {\n  &:before {\n    content: $ni-arrow-up; \n  }\n}\n.ni-arrow-down {\n  &:before {\n    content: $ni-arrow-down; \n  }\n}\n.ni-arrow-up-left {\n  &:before {\n    content: $ni-arrow-up-left; \n  }\n}\n.ni-arrow-up-right {\n  &:before {\n    content: $ni-arrow-up-right; \n  }\n}\n.ni-arrow-down-left {\n  &:before {\n    content: $ni-arrow-down-left; \n  }\n}\n.ni-arrow-down-right {\n  &:before {\n    content: $ni-arrow-down-right; \n  }\n}\n.ni-arrow-to-left {\n  &:before {\n    content: $ni-arrow-to-left; \n  }\n}\n.ni-arrow-to-right {\n  &:before {\n    content: $ni-arrow-to-right; \n  }\n}\n.ni-arrow-to-up {\n  &:before {\n    content: $ni-arrow-to-up; \n  }\n}\n.ni-arrow-to-down {\n  &:before {\n    content: $ni-arrow-to-down; \n  }\n}\n.ni-arrow-from-left {\n  &:before {\n    content: $ni-arrow-from-left; \n  }\n}\n.ni-arrow-from-right {\n  &:before {\n    content: $ni-arrow-from-right; \n  }\n}\n.ni-arrow-from-up {\n  &:before {\n    content: $ni-arrow-from-up; \n  }\n}\n.ni-arrow-from-down {\n  &:before {\n    content: $ni-arrow-from-down; \n  }\n}\n.ni-curve-down-left {\n  &:before {\n    content: $ni-curve-down-left; \n  }\n}\n.ni-curve-up-right {\n  &:before {\n    content: $ni-curve-up-right; \n  }\n}\n.ni-curve-up-left {\n  &:before {\n    content: $ni-curve-up-left; \n  }\n}\n.ni-curve-down-right {\n  &:before {\n    content: $ni-curve-down-right; \n  }\n}\n.ni-curve-left-up {\n  &:before {\n    content: $ni-curve-left-up; \n  }\n}\n.ni-curve-right-up {\n  &:before {\n    content: $ni-curve-right-up; \n  }\n}\n.ni-curve-left-down {\n  &:before {\n    content: $ni-curve-left-down; \n  }\n}\n.ni-curve-right-down {\n  &:before {\n    content: $ni-curve-right-down; \n  }\n}\n.ni-back-arrow {\n  &:before {\n    content: $ni-back-arrow; \n  }\n}\n.ni-forward-arrow {\n  &:before {\n    content: $ni-forward-arrow; \n  }\n}\n.ni-back-arrow-fill {\n  &:before {\n    content: $ni-back-arrow-fill; \n  }\n}\n.ni-forward-arrow-fill {\n  &:before {\n    content: $ni-forward-arrow-fill; \n  }\n}\n.ni-navigate {\n  &:before {\n    content: $ni-navigate; \n  }\n}\n.ni-navigate-up {\n  &:before {\n    content: $ni-navigate-up; \n  }\n}\n.ni-navigate-fill {\n  &:before {\n    content: $ni-navigate-fill; \n  }\n}\n.ni-navigate-up-fill {\n  &:before {\n    content: $ni-navigate-up-fill; \n  }\n}\n.ni-send {\n  &:before {\n    content: $ni-send; \n  }\n}\n.ni-send-alt {\n  &:before {\n    content: $ni-send-alt; \n  }\n}\n.ni-unfold-less {\n  &:before {\n    content: $ni-unfold-less; \n  }\n}\n.ni-unfold-more {\n  &:before {\n    content: $ni-unfold-more; \n  }\n}\n.ni-exchange-v {\n  &:before {\n    content: $ni-exchange-v; \n  }\n}\n.ni-exchange {\n  &:before {\n    content: $ni-exchange; \n  }\n}\n.ni-expand {\n  &:before {\n    content: $ni-expand; \n  }\n}\n.ni-shrink {\n  &:before {\n    content: $ni-shrink; \n  }\n}\n.ni-focus {\n  &:before {\n    content: $ni-focus; \n  }\n}\n.ni-maximize {\n  &:before {\n    content: $ni-maximize; \n  }\n}\n.ni-minimize {\n  &:before {\n    content: $ni-minimize; \n  }\n}\n.ni-maximize-alt {\n  &:before {\n    content: $ni-maximize-alt; \n  }\n}\n.ni-minimize-alt {\n  &:before {\n    content: $ni-minimize-alt; \n  }\n}\n.ni-shuffle {\n  &:before {\n    content: $ni-shuffle; \n  }\n}\n.ni-cross-sm {\n  &:before {\n    content: $ni-cross-sm; \n  }\n}\n.ni-cross {\n  &:before {\n    content: $ni-cross; \n  }\n}\n.ni-cross-round {\n  &:before {\n    content: $ni-cross-round; \n  }\n}\n.ni-cross-circle {\n  &:before {\n    content: $ni-cross-circle; \n  }\n}\n.ni-cross-c {\n  &:before {\n    content: $ni-cross-c; \n  }\n}\n.ni-cross-round-fill {\n  &:before {\n    content: $ni-cross-round-fill; \n  }\n}\n.ni-cross-circle-fill {\n  &:before {\n    content: $ni-cross-circle-fill; \n  }\n}\n.ni-cross-fill-c {\n  &:before {\n    content: $ni-cross-fill-c; \n  }\n}\n.ni-na {\n  &:before {\n    content: $ni-na; \n  }\n}\n.ni-check {\n  &:before {\n    content: $ni-check; \n  }\n}\n.ni-check-thick {\n  &:before {\n    content: $ni-check-thick; \n  }\n}\n.ni-done {\n  &:before {\n    content: $ni-done; \n  }\n}\n.ni-check-round {\n  &:before {\n    content: $ni-check-round; \n  }\n}\n.ni-check-circle {\n  &:before {\n    content: $ni-check-circle; \n  }\n}\n.ni-check-c {\n  &:before {\n    content: $ni-check-c; \n  }\n}\n.ni-check-round-fill {\n  &:before {\n    content: $ni-check-round-fill; \n  }\n}\n.ni-check-circle-fill {\n  &:before {\n    content: $ni-check-circle-fill; \n  }\n}\n.ni-check-fill-c {\n  &:before {\n    content: $ni-check-fill-c; \n  }\n}\n.ni-check-circle-cut {\n  &:before {\n    content: $ni-check-circle-cut; \n  }\n}\n.ni-check-round-cut {\n  &:before {\n    content: $ni-check-round-cut; \n  }\n}\n.ni-bullet {\n  &:before {\n    content: $ni-bullet; \n  }\n}\n.ni-circle {\n  &:before {\n    content: $ni-circle; \n  }\n}\n.ni-square {\n  &:before {\n    content: $ni-square; \n  }\n}\n.ni-square-c {\n  &:before {\n    content: $ni-square-c; \n  }\n}\n.ni-bullet-fill {\n  &:before {\n    content: $ni-bullet-fill; \n  }\n}\n.ni-circle-fill {\n  &:before {\n    content: $ni-circle-fill; \n  }\n}\n.ni-square-fill {\n  &:before {\n    content: $ni-square-fill; \n  }\n}\n.ni-square-fill-c {\n  &:before {\n    content: $ni-square-fill-c; \n  }\n}\n.ni-plus-sm {\n  &:before {\n    content: $ni-plus-sm; \n  }\n}\n.ni-minus-sm {\n  &:before {\n    content: $ni-minus-sm; \n  }\n}\n.ni-plus {\n  &:before {\n    content: $ni-plus; \n  }\n}\n.ni-minus {\n  &:before {\n    content: $ni-minus; \n  }\n}\n.ni-plus-round {\n  &:before {\n    content: $ni-plus-round; \n  }\n}\n.ni-minus-round {\n  &:before {\n    content: $ni-minus-round; \n  }\n}\n.ni-plus-circle {\n  &:before {\n    content: $ni-plus-circle; \n  }\n}\n.ni-minus-circle {\n  &:before {\n    content: $ni-minus-circle; \n  }\n}\n.ni-plus-c {\n  &:before {\n    content: $ni-plus-c; \n  }\n}\n.ni-minus-c {\n  &:before {\n    content: $ni-minus-c; \n  }\n}\n.ni-plus-round-fill {\n  &:before {\n    content: $ni-plus-round-fill; \n  }\n}\n.ni-plus-circle-fill {\n  &:before {\n    content: $ni-plus-circle-fill; \n  }\n}\n.ni-minus-round-fill {\n  &:before {\n    content: $ni-minus-round-fill; \n  }\n}\n.ni-minus-circle-fill {\n  &:before {\n    content: $ni-minus-circle-fill; \n  }\n}\n.ni-plus-fill-c {\n  &:before {\n    content: $ni-plus-fill-c; \n  }\n}\n.ni-minus-fill-c {\n  &:before {\n    content: $ni-minus-fill-c; \n  }\n}\n.ni-plus-medi {\n  &:before {\n    content: $ni-plus-medi; \n  }\n}\n.ni-plus-medi-fill {\n  &:before {\n    content: $ni-plus-medi-fill; \n  }\n}\n.ni-equal-sm {\n  &:before {\n    content: $ni-equal-sm; \n  }\n}\n.ni-equal {\n  &:before {\n    content: $ni-equal; \n  }\n}\n.ni-calc {\n  &:before {\n    content: $ni-calc; \n  }\n}\n.ni-search {\n  &:before {\n    content: $ni-search; \n  }\n}\n.ni-zoom-out {\n  &:before {\n    content: $ni-zoom-out; \n  }\n}\n.ni-zoom-in {\n  &:before {\n    content: $ni-zoom-in; \n  }\n}\n.ni-play {\n  &:before {\n    content: $ni-play; \n  }\n}\n.ni-play-fill {\n  &:before {\n    content: $ni-play-fill; \n  }\n}\n.ni-play-circle {\n  &:before {\n    content: $ni-play-circle; \n  }\n}\n.ni-play-circle-fill {\n  &:before {\n    content: $ni-play-circle-fill; \n  }\n}\n.ni-pause {\n  &:before {\n    content: $ni-pause; \n  }\n}\n.ni-pause-fill {\n  &:before {\n    content: $ni-pause-fill; \n  }\n}\n.ni-pause-circle {\n  &:before {\n    content: $ni-pause-circle; \n  }\n}\n.ni-pause-circle-fill {\n  &:before {\n    content: $ni-pause-circle-fill; \n  }\n}\n.ni-stop {\n  &:before {\n    content: $ni-stop; \n  }\n}\n.ni-stop-fill {\n  &:before {\n    content: $ni-stop-fill; \n  }\n}\n.ni-stop-circle {\n  &:before {\n    content: $ni-stop-circle; \n  }\n}\n.ni-stop-circle-fill {\n  &:before {\n    content: $ni-stop-circle-fill; \n  }\n}\n.ni-rewind {\n  &:before {\n    content: $ni-rewind; \n  }\n}\n.ni-forward {\n  &:before {\n    content: $ni-forward; \n  }\n}\n.ni-rewind-fill {\n  &:before {\n    content: $ni-rewind-fill; \n  }\n}\n.ni-forward-fill {\n  &:before {\n    content: $ni-forward-fill; \n  }\n}\n.ni-step-back {\n  &:before {\n    content: $ni-step-back; \n  }\n}\n.ni-step-forward {\n  &:before {\n    content: $ni-step-forward; \n  }\n}\n.ni-vol-off {\n  &:before {\n    content: $ni-vol-off; \n  }\n}\n.ni-vol-no {\n  &:before {\n    content: $ni-vol-no; \n  }\n}\n.ni-vol-half {\n  &:before {\n    content: $ni-vol-half; \n  }\n}\n.ni-vol {\n  &:before {\n    content: $ni-vol; \n  }\n}\n.ni-mic {\n  &:before {\n    content: $ni-mic; \n  }\n}\n.ni-mic-off {\n  &:before {\n    content: $ni-mic-off; \n  }\n}\n.ni-video {\n  &:before {\n    content: $ni-video; \n  }\n}\n.ni-video-off {\n  &:before {\n    content: $ni-video-off; \n  }\n}\n.ni-video-fill {\n  &:before {\n    content: $ni-video-fill; \n  }\n}\n.ni-loader {\n  &:before {\n    content: $ni-loader; \n  }\n}\n.ni-power {\n  &:before {\n    content: $ni-power; \n  }\n}\n.ni-signout {\n  &:before {\n    content: $ni-signout; \n  }\n}\n.ni-signin {\n  &:before {\n    content: $ni-signin; \n  }\n}\n.ni-upload {\n  &:before {\n    content: $ni-upload; \n  }\n}\n.ni-download {\n  &:before {\n    content: $ni-download; \n  }\n}\n.ni-alert-circle {\n  &:before {\n    content: $ni-alert-circle; \n  }\n}\n.ni-alert {\n  &:before {\n    content: $ni-alert; \n  }\n}\n.ni-caution {\n  &:before {\n    content: $ni-caution; \n  }\n}\n.ni-report {\n  &:before {\n    content: $ni-report; \n  }\n}\n.ni-alert-c {\n  &:before {\n    content: $ni-alert-c; \n  }\n}\n.ni-alert-circle-fill {\n  &:before {\n    content: $ni-alert-circle-fill; \n  }\n}\n.ni-alert-fill {\n  &:before {\n    content: $ni-alert-fill; \n  }\n}\n.ni-caution-fill {\n  &:before {\n    content: $ni-caution-fill; \n  }\n}\n.ni-report-fill {\n  &:before {\n    content: $ni-report-fill; \n  }\n}\n.ni-alert-fill-c {\n  &:before {\n    content: $ni-alert-fill-c; \n  }\n}\n.ni-info-i {\n  &:before {\n    content: $ni-info-i; \n  }\n}\n.ni-info {\n  &:before {\n    content: $ni-info; \n  }\n}\n.ni-info-fill {\n  &:before {\n    content: $ni-info-fill; \n  }\n}\n.ni-help {\n  &:before {\n    content: $ni-help; \n  }\n}\n.ni-help-fill {\n  &:before {\n    content: $ni-help-fill; \n  }\n}\n.ni-archived {\n  &:before {\n    content: $ni-archived; \n  }\n}\n.ni-archive {\n  &:before {\n    content: $ni-archive; \n  }\n}\n.ni-unarchive {\n  &:before {\n    content: $ni-unarchive; \n  }\n}\n.ni-archived-fill {\n  &:before {\n    content: $ni-archived-fill; \n  }\n}\n.ni-archive-fill {\n  &:before {\n    content: $ni-archive-fill; \n  }\n}\n.ni-unarchive-fill {\n  &:before {\n    content: $ni-unarchive-fill; \n  }\n}\n.ni-bag {\n  &:before {\n    content: $ni-bag; \n  }\n}\n.ni-bag-fill {\n  &:before {\n    content: $ni-bag-fill; \n  }\n}\n.ni-bell {\n  &:before {\n    content: $ni-bell; \n  }\n}\n.ni-bell-off {\n  &:before {\n    content: $ni-bell-off; \n  }\n}\n.ni-bell-fill {\n  &:before {\n    content: $ni-bell-fill; \n  }\n}\n.ni-bell-off-fill {\n  &:before {\n    content: $ni-bell-off-fill; \n  }\n}\n.ni-wifi {\n  &:before {\n    content: $ni-wifi; \n  }\n}\n.ni-wifi-off {\n  &:before {\n    content: $ni-wifi-off; \n  }\n}\n.ni-live {\n  &:before {\n    content: $ni-live; \n  }\n}\n.ni-signal {\n  &:before {\n    content: $ni-signal; \n  }\n}\n.ni-bluetooth {\n  &:before {\n    content: $ni-bluetooth; \n  }\n}\n.ni-blank-alt {\n  &:before {\n    content: $ni-blank-alt; \n  }\n}\n.ni-blank {\n  &:before {\n    content: $ni-blank; \n  }\n}\n.ni-blank-fill {\n  &:before {\n    content: $ni-blank-fill; \n  }\n}\n.ni-blankf-fill {\n  &:before {\n    content: $ni-blankf-fill; \n  }\n}\n.ni-block-over {\n  &:before {\n    content: $ni-block-over; \n  }\n}\n.ni-book-read {\n  &:before {\n    content: $ni-book-read; \n  }\n}\n.ni-book {\n  &:before {\n    content: $ni-book; \n  }\n}\n.ni-book-fill {\n  &:before {\n    content: $ni-book-fill; \n  }\n}\n.ni-bulb-fill {\n  &:before {\n    content: $ni-bulb-fill; \n  }\n}\n.ni-bulb {\n  &:before {\n    content: $ni-bulb; \n  }\n}\n.ni-calendar-alt-fill {\n  &:before {\n    content: $ni-calendar-alt-fill; \n  }\n}\n.ni-calendar-alt {\n  &:before {\n    content: $ni-calendar-alt; \n  }\n}\n.ni-calendar-booking-fill {\n  &:before {\n    content: $ni-calendar-booking-fill; \n  }\n}\n.ni-calendar-booking {\n  &:before {\n    content: $ni-calendar-booking; \n  }\n}\n.ni-calendar-check-fill {\n  &:before {\n    content: $ni-calendar-check-fill; \n  }\n}\n.ni-calendar-check {\n  &:before {\n    content: $ni-calendar-check; \n  }\n}\n.ni-calendar-fill {\n  &:before {\n    content: $ni-calendar-fill; \n  }\n}\n.ni-calendar {\n  &:before {\n    content: $ni-calendar; \n  }\n}\n.ni-calender-date-fill {\n  &:before {\n    content: $ni-calender-date-fill; \n  }\n}\n.ni-calender-date {\n  &:before {\n    content: $ni-calender-date; \n  }\n}\n.ni-call {\n  &:before {\n    content: $ni-call; \n  }\n}\n.ni-call-alt {\n  &:before {\n    content: $ni-call-alt; \n  }\n}\n.ni-call-alt-fill {\n  &:before {\n    content: $ni-call-alt-fill; \n  }\n}\n.ni-call-fill {\n  &:before {\n    content: $ni-call-fill; \n  }\n}\n.ni-camera-fill {\n  &:before {\n    content: $ni-camera-fill; \n  }\n}\n.ni-camera {\n  &:before {\n    content: $ni-camera; \n  }\n}\n.ni-capsule {\n  &:before {\n    content: $ni-capsule; \n  }\n}\n.ni-capsule-fill {\n  &:before {\n    content: $ni-capsule-fill; \n  }\n}\n.ni-cards {\n  &:before {\n    content: $ni-cards; \n  }\n}\n.ni-cards-fill {\n  &:before {\n    content: $ni-cards-fill; \n  }\n}\n.ni-cart {\n  &:before {\n    content: $ni-cart; \n  }\n}\n.ni-cart-fill {\n  &:before {\n    content: $ni-cart-fill; \n  }\n}\n.ni-cc {\n  &:before {\n    content: $ni-cc; \n  }\n}\n.ni-cc-alt {\n  &:before {\n    content: $ni-cc-alt; \n  }\n}\n.ni-cc-alt2 {\n  &:before {\n    content: $ni-cc-alt2; \n  }\n}\n.ni-cc-secure {\n  &:before {\n    content: $ni-cc-secure; \n  }\n}\n.ni-cc-new {\n  &:before {\n    content: $ni-cc-new; \n  }\n}\n.ni-cc-off {\n  &:before {\n    content: $ni-cc-off; \n  }\n}\n.ni-cc-fill {\n  &:before {\n    content: $ni-cc-fill; \n  }\n}\n.ni-cc-alt-fill {\n  &:before {\n    content: $ni-cc-alt-fill; \n  }\n}\n.ni-cc-alt2-fill {\n  &:before {\n    content: $ni-cc-alt2-fill; \n  }\n}\n.ni-cc-secure-fill {\n  &:before {\n    content: $ni-cc-secure-fill; \n  }\n}\n.ni-msg-circle {\n  &:before {\n    content: $ni-msg-circle; \n  }\n}\n.ni-chat-circle {\n  &:before {\n    content: $ni-chat-circle; \n  }\n}\n.ni-msg {\n  &:before {\n    content: $ni-msg; \n  }\n}\n.ni-chat {\n  &:before {\n    content: $ni-chat; \n  }\n}\n.ni-question-alt {\n  &:before {\n    content: $ni-question-alt; \n  }\n}\n.ni-question {\n  &:before {\n    content: $ni-question; \n  }\n}\n.ni-msg-circle-fill {\n  &:before {\n    content: $ni-msg-circle-fill; \n  }\n}\n.ni-chat-circle-fill {\n  &:before {\n    content: $ni-chat-circle-fill; \n  }\n}\n.ni-msg-fill {\n  &:before {\n    content: $ni-msg-fill; \n  }\n}\n.ni-chat-fill {\n  &:before {\n    content: $ni-chat-fill; \n  }\n}\n.ni-clip-h {\n  &:before {\n    content: $ni-clip-h; \n  }\n}\n.ni-clip-v {\n  &:before {\n    content: $ni-clip-v; \n  }\n}\n.ni-clip {\n  &:before {\n    content: $ni-clip; \n  }\n}\n.ni-link-alt {\n  &:before {\n    content: $ni-link-alt; \n  }\n}\n.ni-unlink {\n  &:before {\n    content: $ni-unlink; \n  }\n}\n.ni-unlink-alt {\n  &:before {\n    content: $ni-unlink-alt; \n  }\n}\n.ni-link-h {\n  &:before {\n    content: $ni-link-h; \n  }\n}\n.ni-link-v {\n  &:before {\n    content: $ni-link-v; \n  }\n}\n.ni-link {\n  &:before {\n    content: $ni-link; \n  }\n}\n.ni-clipboard {\n  &:before {\n    content: $ni-clipboard; \n  }\n}\n.ni-clipboad-check {\n  &:before {\n    content: $ni-clipboad-check; \n  }\n}\n.ni-clipboard-fill {\n  &:before {\n    content: $ni-clipboard-fill; \n  }\n}\n.ni-clipboad-check-fill {\n  &:before {\n    content: $ni-clipboad-check-fill; \n  }\n}\n.ni-clock {\n  &:before {\n    content: $ni-clock; \n  }\n}\n.ni-clock-fill {\n  &:before {\n    content: $ni-clock-fill; \n  }\n}\n.ni-cloud {\n  &:before {\n    content: $ni-cloud; \n  }\n}\n.ni-upload-cloud {\n  &:before {\n    content: $ni-upload-cloud; \n  }\n}\n.ni-download-cloud {\n  &:before {\n    content: $ni-download-cloud; \n  }\n}\n.ni-cloud-fill {\n  &:before {\n    content: $ni-cloud-fill; \n  }\n}\n.ni-contact {\n  &:before {\n    content: $ni-contact; \n  }\n}\n.ni-contact-fill {\n  &:before {\n    content: $ni-contact-fill; \n  }\n}\n.ni-coffee {\n  &:before {\n    content: $ni-coffee; \n  }\n}\n.ni-coffee-fill {\n  &:before {\n    content: $ni-coffee-fill; \n  }\n}\n.ni-box-view {\n  &:before {\n    content: $ni-box-view; \n  }\n}\n.ni-col-view {\n  &:before {\n    content: $ni-col-view; \n  }\n}\n.ni-sidebar {\n  &:before {\n    content: $ni-sidebar; \n  }\n}\n.ni-layout {\n  &:before {\n    content: $ni-layout; \n  }\n}\n.ni-table-view {\n  &:before {\n    content: $ni-table-view; \n  }\n}\n.ni-layout2 {\n  &:before {\n    content: $ni-layout2; \n  }\n}\n.ni-row-view {\n  &:before {\n    content: $ni-row-view; \n  }\n}\n.ni-dot-box {\n  &:before {\n    content: $ni-dot-box; \n  }\n}\n.ni-layout-fill {\n  &:before {\n    content: $ni-layout-fill; \n  }\n}\n.ni-box-view-fill {\n  &:before {\n    content: $ni-box-view-fill; \n  }\n}\n.ni-sidebar-fill {\n  &:before {\n    content: $ni-sidebar-fill; \n  }\n}\n.ni-table-view-fill {\n  &:before {\n    content: $ni-table-view-fill; \n  }\n}\n.ni-dot-box-fill {\n  &:before {\n    content: $ni-dot-box-fill; \n  }\n}\n.ni-template {\n  &:before {\n    content: $ni-template; \n  }\n}\n.ni-browser {\n  &:before {\n    content: $ni-browser; \n  }\n}\n.ni-toolbar {\n  &:before {\n    content: $ni-toolbar; \n  }\n}\n.ni-browser-fill {\n  &:before {\n    content: $ni-browser-fill; \n  }\n}\n.ni-toolbar-fill {\n  &:before {\n    content: $ni-toolbar-fill; \n  }\n}\n.ni-template-fill {\n  &:before {\n    content: $ni-template-fill; \n  }\n}\n.ni-box {\n  &:before {\n    content: $ni-box; \n  }\n}\n.ni-package {\n  &:before {\n    content: $ni-package; \n  }\n}\n.ni-layer {\n  &:before {\n    content: $ni-layer; \n  }\n}\n.ni-layers {\n  &:before {\n    content: $ni-layers; \n  }\n}\n.ni-panel {\n  &:before {\n    content: $ni-panel; \n  }\n}\n.ni-server {\n  &:before {\n    content: $ni-server; \n  }\n}\n.ni-layer-fill {\n  &:before {\n    content: $ni-layer-fill; \n  }\n}\n.ni-layers-fill {\n  &:before {\n    content: $ni-layers-fill; \n  }\n}\n.ni-package-fill {\n  &:before {\n    content: $ni-package-fill; \n  }\n}\n.ni-panel-fill {\n  &:before {\n    content: $ni-panel-fill; \n  }\n}\n.ni-server-fill {\n  &:before {\n    content: $ni-server-fill; \n  }\n}\n.ni-color-palette {\n  &:before {\n    content: $ni-color-palette; \n  }\n}\n.ni-color-palette-fill {\n  &:before {\n    content: $ni-color-palette-fill; \n  }\n}\n.ni-copy {\n  &:before {\n    content: $ni-copy; \n  }\n}\n.ni-copy-fill {\n  &:before {\n    content: $ni-copy-fill; \n  }\n}\n.ni-crop-alt {\n  &:before {\n    content: $ni-crop-alt; \n  }\n}\n.ni-crop {\n  &:before {\n    content: $ni-crop; \n  }\n}\n.ni-target {\n  &:before {\n    content: $ni-target; \n  }\n}\n.ni-crosshair {\n  &:before {\n    content: $ni-crosshair; \n  }\n}\n.ni-crosshair-fill {\n  &:before {\n    content: $ni-crosshair-fill; \n  }\n}\n.ni-db-fill {\n  &:before {\n    content: $ni-db-fill; \n  }\n}\n.ni-db {\n  &:before {\n    content: $ni-db; \n  }\n}\n.ni-hard-drive {\n  &:before {\n    content: $ni-hard-drive; \n  }\n}\n.ni-cpu {\n  &:before {\n    content: $ni-cpu; \n  }\n}\n.ni-disk {\n  &:before {\n    content: $ni-disk; \n  }\n}\n.ni-pen {\n  &:before {\n    content: $ni-pen; \n  }\n}\n.ni-edit-alt {\n  &:before {\n    content: $ni-edit-alt; \n  }\n}\n.ni-pen-fill {\n  &:before {\n    content: $ni-pen-fill; \n  }\n}\n.ni-edit-alt-fill {\n  &:before {\n    content: $ni-edit-alt-fill; \n  }\n}\n.ni-pen-alt-fill {\n  &:before {\n    content: $ni-pen-alt-fill; \n  }\n}\n.ni-edit-fill {\n  &:before {\n    content: $ni-edit-fill; \n  }\n}\n.ni-edit {\n  &:before {\n    content: $ni-edit; \n  }\n}\n.ni-external-alt {\n  &:before {\n    content: $ni-external-alt; \n  }\n}\n.ni-external {\n  &:before {\n    content: $ni-external; \n  }\n}\n.ni-eye-alt {\n  &:before {\n    content: $ni-eye-alt; \n  }\n}\n.ni-eye-alt-fill {\n  &:before {\n    content: $ni-eye-alt-fill; \n  }\n}\n.ni-eye {\n  &:before {\n    content: $ni-eye; \n  }\n}\n.ni-eye-fill {\n  &:before {\n    content: $ni-eye-fill; \n  }\n}\n.ni-eye-off {\n  &:before {\n    content: $ni-eye-off; \n  }\n}\n.ni-eye-off-fill {\n  &:before {\n    content: $ni-eye-off-fill; \n  }\n}\n.ni-file {\n  &:before {\n    content: $ni-file; \n  }\n}\n.ni-file-minus {\n  &:before {\n    content: $ni-file-minus; \n  }\n}\n.ni-file-plus {\n  &:before {\n    content: $ni-file-plus; \n  }\n}\n.ni-file-remove {\n  &:before {\n    content: $ni-file-remove; \n  }\n}\n.ni-file-check {\n  &:before {\n    content: $ni-file-check; \n  }\n}\n.ni-file-code {\n  &:before {\n    content: $ni-file-code; \n  }\n}\n.ni-file-docs {\n  &:before {\n    content: $ni-file-docs; \n  }\n}\n.ni-file-img {\n  &:before {\n    content: $ni-file-img; \n  }\n}\n.ni-file-doc {\n  &:before {\n    content: $ni-file-doc; \n  }\n}\n.ni-file-pdf {\n  &:before {\n    content: $ni-file-pdf; \n  }\n}\n.ni-file-xls {\n  &:before {\n    content: $ni-file-xls; \n  }\n}\n.ni-file-zip {\n  &:before {\n    content: $ni-file-zip; \n  }\n}\n.ni-file-download {\n  &:before {\n    content: $ni-file-download; \n  }\n}\n.ni-file-text {\n  &:before {\n    content: $ni-file-text; \n  }\n}\n.ni-files {\n  &:before {\n    content: $ni-files; \n  }\n}\n.ni-file-fill {\n  &:before {\n    content: $ni-file-fill; \n  }\n}\n.ni-file-minus-fill {\n  &:before {\n    content: $ni-file-minus-fill; \n  }\n}\n.ni-file-plus-fill {\n  &:before {\n    content: $ni-file-plus-fill; \n  }\n}\n.ni-file-remove-fill {\n  &:before {\n    content: $ni-file-remove-fill; \n  }\n}\n.ni-file-check-fill {\n  &:before {\n    content: $ni-file-check-fill; \n  }\n}\n.ni-file-text-fill {\n  &:before {\n    content: $ni-file-text-fill; \n  }\n}\n.ni-files-fill {\n  &:before {\n    content: $ni-files-fill; \n  }\n}\n.ni-folder {\n  &:before {\n    content: $ni-folder; \n  }\n}\n.ni-folder-minus {\n  &:before {\n    content: $ni-folder-minus; \n  }\n}\n.ni-folder-plus {\n  &:before {\n    content: $ni-folder-plus; \n  }\n}\n.ni-folder-remove {\n  &:before {\n    content: $ni-folder-remove; \n  }\n}\n.ni-folder-check {\n  &:before {\n    content: $ni-folder-check; \n  }\n}\n.ni-folder-list {\n  &:before {\n    content: $ni-folder-list; \n  }\n}\n.ni-folders {\n  &:before {\n    content: $ni-folders; \n  }\n}\n.ni-folder-fill {\n  &:before {\n    content: $ni-folder-fill; \n  }\n}\n.ni-folders-fill {\n  &:before {\n    content: $ni-folders-fill; \n  }\n}\n.ni-filter-alt {\n  &:before {\n    content: $ni-filter-alt; \n  }\n}\n.ni-sort-line {\n  &:before {\n    content: $ni-sort-line; \n  }\n}\n.ni-filter-fill {\n  &:before {\n    content: $ni-filter-fill; \n  }\n}\n.ni-filter {\n  &:before {\n    content: $ni-filter; \n  }\n}\n.ni-flag {\n  &:before {\n    content: $ni-flag; \n  }\n}\n.ni-flag-fill {\n  &:before {\n    content: $ni-flag-fill; \n  }\n}\n.ni-notify {\n  &:before {\n    content: $ni-notify; \n  }\n}\n.ni-dashboard {\n  &:before {\n    content: $ni-dashboard; \n  }\n}\n.ni-dashboard-fill {\n  &:before {\n    content: $ni-dashboard-fill; \n  }\n}\n.ni-grid-sq {\n  &:before {\n    content: $ni-grid-sq; \n  }\n}\n.ni-grid {\n  &:before {\n    content: $ni-grid; \n  }\n}\n.ni-grid-c {\n  &:before {\n    content: $ni-grid-c; \n  }\n}\n.ni-grid-alt {\n  &:before {\n    content: $ni-grid-alt; \n  }\n}\n.ni-grid-plus {\n  &:before {\n    content: $ni-grid-plus; \n  }\n}\n.ni-grid-add-c {\n  &:before {\n    content: $ni-grid-add-c; \n  }\n}\n.ni-grid-fill {\n  &:before {\n    content: $ni-grid-fill; \n  }\n}\n.ni-grid-fill-c {\n  &:before {\n    content: $ni-grid-fill-c; \n  }\n}\n.ni-grid-alt-fill {\n  &:before {\n    content: $ni-grid-alt-fill; \n  }\n}\n.ni-grid-plus-fill {\n  &:before {\n    content: $ni-grid-plus-fill; \n  }\n}\n.ni-grid-add-fill-c {\n  &:before {\n    content: $ni-grid-add-fill-c; \n  }\n}\n.ni-grid-box-alt-fill {\n  &:before {\n    content: $ni-grid-box-alt-fill; \n  }\n}\n.ni-grid-box-alt {\n  &:before {\n    content: $ni-grid-box-alt; \n  }\n}\n.ni-grid-box {\n  &:before {\n    content: $ni-grid-box; \n  }\n}\n.ni-grid-box-fill {\n  &:before {\n    content: $ni-grid-box-fill; \n  }\n}\n.ni-grid-line {\n  &:before {\n    content: $ni-grid-line; \n  }\n}\n.ni-menu-alt-left {\n  &:before {\n    content: $ni-menu-alt-left; \n  }\n}\n.ni-menu-alt-r {\n  &:before {\n    content: $ni-menu-alt-r; \n  }\n}\n.ni-menu-alt {\n  &:before {\n    content: $ni-menu-alt; \n  }\n}\n.ni-menu-center {\n  &:before {\n    content: $ni-menu-center; \n  }\n}\n.ni-menu-left {\n  &:before {\n    content: $ni-menu-left; \n  }\n}\n.ni-menu-right {\n  &:before {\n    content: $ni-menu-right; \n  }\n}\n.ni-menu {\n  &:before {\n    content: $ni-menu; \n  }\n}\n.ni-trend-up {\n  &:before {\n    content: $ni-trend-up; \n  }\n}\n.ni-trend-down {\n  &:before {\n    content: $ni-trend-down; \n  }\n}\n.ni-line-chart-down {\n  &:before {\n    content: $ni-line-chart-down; \n  }\n}\n.ni-line-chart-up {\n  &:before {\n    content: $ni-line-chart-up; \n  }\n}\n.ni-line-chart {\n  &:before {\n    content: $ni-line-chart; \n  }\n}\n.ni-bar-chart {\n  &:before {\n    content: $ni-bar-chart; \n  }\n}\n.ni-bar-chart-alt {\n  &:before {\n    content: $ni-bar-chart-alt; \n  }\n}\n.ni-chart-up {\n  &:before {\n    content: $ni-chart-up; \n  }\n}\n.ni-chart-down {\n  &:before {\n    content: $ni-chart-down; \n  }\n}\n.ni-growth {\n  &:before {\n    content: $ni-growth; \n  }\n}\n.ni-growth-fill {\n  &:before {\n    content: $ni-growth-fill; \n  }\n}\n.ni-bar-chart-fill {\n  &:before {\n    content: $ni-bar-chart-fill; \n  }\n}\n.ni-bar-c {\n  &:before {\n    content: $ni-bar-c; \n  }\n}\n.ni-bar-fill-c {\n  &:before {\n    content: $ni-bar-fill-c; \n  }\n}\n.ni-pie {\n  &:before {\n    content: $ni-pie; \n  }\n}\n.ni-pie-alt {\n  &:before {\n    content: $ni-pie-alt; \n  }\n}\n.ni-pie-fill {\n  &:before {\n    content: $ni-pie-fill; \n  }\n}\n.ni-activity {\n  &:before {\n    content: $ni-activity; \n  }\n}\n.ni-activity-alt {\n  &:before {\n    content: $ni-activity-alt; \n  }\n}\n.ni-activity-round {\n  &:before {\n    content: $ni-activity-round; \n  }\n}\n.ni-activity-round-fill {\n  &:before {\n    content: $ni-activity-round-fill; \n  }\n}\n.ni-meter {\n  &:before {\n    content: $ni-meter; \n  }\n}\n.ni-speed {\n  &:before {\n    content: $ni-speed; \n  }\n}\n.ni-happy {\n  &:before {\n    content: $ni-happy; \n  }\n}\n.ni-sad {\n  &:before {\n    content: $ni-sad; \n  }\n}\n.ni-meh {\n  &:before {\n    content: $ni-meh; \n  }\n}\n.ni-happy-fill {\n  &:before {\n    content: $ni-happy-fill; \n  }\n}\n.ni-happyf-fill {\n  &:before {\n    content: $ni-happyf-fill; \n  }\n}\n.ni-sad-fill {\n  &:before {\n    content: $ni-sad-fill; \n  }\n}\n.ni-meh-fill {\n  &:before {\n    content: $ni-meh-fill; \n  }\n}\n.ni-home {\n  &:before {\n    content: $ni-home; \n  }\n}\n.ni-home-alt {\n  &:before {\n    content: $ni-home-alt; \n  }\n}\n.ni-home-fill {\n  &:before {\n    content: $ni-home-fill; \n  }\n}\n.ni-img {\n  &:before {\n    content: $ni-img; \n  }\n}\n.ni-img-fill {\n  &:before {\n    content: $ni-img-fill; \n  }\n}\n.ni-inbox {\n  &:before {\n    content: $ni-inbox; \n  }\n}\n.ni-inbox-in {\n  &:before {\n    content: $ni-inbox-in; \n  }\n}\n.ni-inbox-out {\n  &:before {\n    content: $ni-inbox-out; \n  }\n}\n.ni-inbox-fill {\n  &:before {\n    content: $ni-inbox-fill; \n  }\n}\n.ni-inbox-in-fill {\n  &:before {\n    content: $ni-inbox-in-fill; \n  }\n}\n.ni-inbox-out-fill {\n  &:before {\n    content: $ni-inbox-out-fill; \n  }\n}\n.ni-link-group {\n  &:before {\n    content: $ni-link-group; \n  }\n}\n.ni-lock {\n  &:before {\n    content: $ni-lock; \n  }\n}\n.ni-lock-alt {\n  &:before {\n    content: $ni-lock-alt; \n  }\n}\n.ni-lock-fill {\n  &:before {\n    content: $ni-lock-fill; \n  }\n}\n.ni-lock-alt-fill {\n  &:before {\n    content: $ni-lock-alt-fill; \n  }\n}\n.ni-unlock {\n  &:before {\n    content: $ni-unlock; \n  }\n}\n.ni-unlock-fill {\n  &:before {\n    content: $ni-unlock-fill; \n  }\n}\n.ni-mail {\n  &:before {\n    content: $ni-mail; \n  }\n}\n.ni-emails {\n  &:before {\n    content: $ni-emails; \n  }\n}\n.ni-mail-fill {\n  &:before {\n    content: $ni-mail-fill; \n  }\n}\n.ni-emails-fill {\n  &:before {\n    content: $ni-emails-fill; \n  }\n}\n.ni-map-pin {\n  &:before {\n    content: $ni-map-pin; \n  }\n}\n.ni-location {\n  &:before {\n    content: $ni-location; \n  }\n}\n.ni-map {\n  &:before {\n    content: $ni-map; \n  }\n}\n.ni-map-pin-fill {\n  &:before {\n    content: $ni-map-pin-fill; \n  }\n}\n.ni-list {\n  &:before {\n    content: $ni-list; \n  }\n}\n.ni-list-ol {\n  &:before {\n    content: $ni-list-ol; \n  }\n}\n.ni-align-center {\n  &:before {\n    content: $ni-align-center; \n  }\n}\n.ni-align-justify {\n  &:before {\n    content: $ni-align-justify; \n  }\n}\n.ni-align-left {\n  &:before {\n    content: $ni-align-left; \n  }\n}\n.ni-align-right {\n  &:before {\n    content: $ni-align-right; \n  }\n}\n.ni-list-check {\n  &:before {\n    content: $ni-list-check; \n  }\n}\n.ni-list-round {\n  &:before {\n    content: $ni-list-round; \n  }\n}\n.ni-card-view {\n  &:before {\n    content: $ni-card-view; \n  }\n}\n.ni-list-fill {\n  &:before {\n    content: $ni-list-fill; \n  }\n}\n.ni-save {\n  &:before {\n    content: $ni-save; \n  }\n}\n.ni-save-fill {\n  &:before {\n    content: $ni-save-fill; \n  }\n}\n.ni-move {\n  &:before {\n    content: $ni-move; \n  }\n}\n.ni-scissor {\n  &:before {\n    content: $ni-scissor; \n  }\n}\n.ni-text {\n  &:before {\n    content: $ni-text; \n  }\n}\n.ni-text-a {\n  &:before {\n    content: $ni-text-a; \n  }\n}\n.ni-bold {\n  &:before {\n    content: $ni-bold; \n  }\n}\n.ni-italic {\n  &:before {\n    content: $ni-italic; \n  }\n}\n.ni-underline {\n  &:before {\n    content: $ni-underline; \n  }\n}\n.ni-percent {\n  &:before {\n    content: $ni-percent; \n  }\n}\n.ni-at {\n  &:before {\n    content: $ni-at; \n  }\n}\n.ni-hash {\n  &:before {\n    content: $ni-hash; \n  }\n}\n.ni-code {\n  &:before {\n    content: $ni-code; \n  }\n}\n.ni-code-download {\n  &:before {\n    content: $ni-code-download; \n  }\n}\n.ni-terminal {\n  &:before {\n    content: $ni-terminal; \n  }\n}\n.ni-cmd {\n  &:before {\n    content: $ni-cmd; \n  }\n}\n.ni-sun {\n  &:before {\n    content: $ni-sun; \n  }\n}\n.ni-sun-fill {\n  &:before {\n    content: $ni-sun-fill; \n  }\n}\n.ni-moon-fill {\n  &:before {\n    content: $ni-moon-fill; \n  }\n}\n.ni-moon {\n  &:before {\n    content: $ni-moon; \n  }\n}\n.ni-light {\n  &:before {\n    content: $ni-light; \n  }\n}\n.ni-light-fill {\n  &:before {\n    content: $ni-light-fill; \n  }\n}\n.ni-more-v {\n  &:before {\n    content: $ni-more-v; \n  }\n}\n.ni-more-h {\n  &:before {\n    content: $ni-more-h; \n  }\n}\n.ni-more-h-alt {\n  &:before {\n    content: $ni-more-h-alt; \n  }\n}\n.ni-more-v-alt {\n  &:before {\n    content: $ni-more-v-alt; \n  }\n}\n.ni-music {\n  &:before {\n    content: $ni-music; \n  }\n}\n.ni-movie {\n  &:before {\n    content: $ni-movie; \n  }\n}\n.ni-offer {\n  &:before {\n    content: $ni-offer; \n  }\n}\n.ni-offer-fill {\n  &:before {\n    content: $ni-offer-fill; \n  }\n}\n.ni-opt-alt {\n  &:before {\n    content: $ni-opt-alt; \n  }\n}\n.ni-opt {\n  &:before {\n    content: $ni-opt; \n  }\n}\n.ni-opt-dot-alt {\n  &:before {\n    content: $ni-opt-dot-alt; \n  }\n}\n.ni-opt-dot {\n  &:before {\n    content: $ni-opt-dot; \n  }\n}\n.ni-opt-dot-fill {\n  &:before {\n    content: $ni-opt-dot-fill; \n  }\n}\n.ni-opt-alt-fill {\n  &:before {\n    content: $ni-opt-alt-fill; \n  }\n}\n.ni-user-alt {\n  &:before {\n    content: $ni-user-alt; \n  }\n}\n.ni-user-alt-fill {\n  &:before {\n    content: $ni-user-alt-fill; \n  }\n}\n.ni-user {\n  &:before {\n    content: $ni-user; \n  }\n}\n.ni-users {\n  &:before {\n    content: $ni-users; \n  }\n}\n.ni-user-add {\n  &:before {\n    content: $ni-user-add; \n  }\n}\n.ni-user-remove {\n  &:before {\n    content: $ni-user-remove; \n  }\n}\n.ni-user-check {\n  &:before {\n    content: $ni-user-check; \n  }\n}\n.ni-user-cross {\n  &:before {\n    content: $ni-user-cross; \n  }\n}\n.ni-account-setting {\n  &:before {\n    content: $ni-account-setting; \n  }\n}\n.ni-account-setting-alt {\n  &:before {\n    content: $ni-account-setting-alt; \n  }\n}\n.ni-user-list {\n  &:before {\n    content: $ni-user-list; \n  }\n}\n.ni-user-fill {\n  &:before {\n    content: $ni-user-fill; \n  }\n}\n.ni-users-fill {\n  &:before {\n    content: $ni-users-fill; \n  }\n}\n.ni-user-add-fill {\n  &:before {\n    content: $ni-user-add-fill; \n  }\n}\n.ni-user-remove-fill {\n  &:before {\n    content: $ni-user-remove-fill; \n  }\n}\n.ni-user-check-fill {\n  &:before {\n    content: $ni-user-check-fill; \n  }\n}\n.ni-user-cross-fill {\n  &:before {\n    content: $ni-user-cross-fill; \n  }\n}\n.ni-account-setting-fill {\n  &:before {\n    content: $ni-account-setting-fill; \n  }\n}\n.ni-user-list-fill {\n  &:before {\n    content: $ni-user-list-fill; \n  }\n}\n.ni-user-circle {\n  &:before {\n    content: $ni-user-circle; \n  }\n}\n.ni-user-circle-fill {\n  &:before {\n    content: $ni-user-circle-fill; \n  }\n}\n.ni-user-c {\n  &:before {\n    content: $ni-user-c; \n  }\n}\n.ni-user-fill-c {\n  &:before {\n    content: $ni-user-fill-c; \n  }\n}\n.ni-user-round {\n  &:before {\n    content: $ni-user-round; \n  }\n}\n.ni-printer {\n  &:before {\n    content: $ni-printer; \n  }\n}\n.ni-printer-fill {\n  &:before {\n    content: $ni-printer-fill; \n  }\n}\n.ni-laptop {\n  &:before {\n    content: $ni-laptop; \n  }\n}\n.ni-monitor {\n  &:before {\n    content: $ni-monitor; \n  }\n}\n.ni-tablet {\n  &:before {\n    content: $ni-tablet; \n  }\n}\n.ni-mobile {\n  &:before {\n    content: $ni-mobile; \n  }\n}\n.ni-undo {\n  &:before {\n    content: $ni-undo; \n  }\n}\n.ni-redo {\n  &:before {\n    content: $ni-redo; \n  }\n}\n.ni-reload-alt {\n  &:before {\n    content: $ni-reload-alt; \n  }\n}\n.ni-reload {\n  &:before {\n    content: $ni-reload; \n  }\n}\n.ni-regen-alt {\n  &:before {\n    content: $ni-regen-alt; \n  }\n}\n.ni-regen {\n  &:before {\n    content: $ni-regen; \n  }\n}\n.ni-invest {\n  &:before {\n    content: $ni-invest; \n  }\n}\n.ni-history {\n  &:before {\n    content: $ni-history; \n  }\n}\n.ni-histroy {\n  &:before {\n    content: $ni-histroy; \n  }\n}\n.ni-update {\n  &:before {\n    content: $ni-update; \n  }\n}\n.ni-repeat {\n  &:before {\n    content: $ni-repeat; \n  }\n}\n.ni-repeat-v {\n  &:before {\n    content: $ni-repeat-v; \n  }\n}\n.ni-tranx {\n  &:before {\n    content: $ni-tranx; \n  }\n}\n.ni-reply-all {\n  &:before {\n    content: $ni-reply-all; \n  }\n}\n.ni-reply {\n  &:before {\n    content: $ni-reply; \n  }\n}\n.ni-reply-fill {\n  &:before {\n    content: $ni-reply-fill; \n  }\n}\n.ni-reply-all-fill {\n  &:before {\n    content: $ni-reply-all-fill; \n  }\n}\n.ni-notes {\n  &:before {\n    content: $ni-notes; \n  }\n}\n.ni-note-add {\n  &:before {\n    content: $ni-note-add; \n  }\n}\n.ni-notes-alt {\n  &:before {\n    content: $ni-notes-alt; \n  }\n}\n.ni-article {\n  &:before {\n    content: $ni-article; \n  }\n}\n.ni-text-rich {\n  &:before {\n    content: $ni-text-rich; \n  }\n}\n.ni-todo {\n  &:before {\n    content: $ni-todo; \n  }\n}\n.ni-report-profit {\n  &:before {\n    content: $ni-report-profit; \n  }\n}\n.ni-reports-alt {\n  &:before {\n    content: $ni-reports-alt; \n  }\n}\n.ni-reports {\n  &:before {\n    content: $ni-reports; \n  }\n}\n.ni-task {\n  &:before {\n    content: $ni-task; \n  }\n}\n.ni-note-add-c {\n  &:before {\n    content: $ni-note-add-c; \n  }\n}\n.ni-task-c {\n  &:before {\n    content: $ni-task-c; \n  }\n}\n.ni-todo-fill {\n  &:before {\n    content: $ni-todo-fill; \n  }\n}\n.ni-note-add-fill-c {\n  &:before {\n    content: $ni-note-add-fill-c; \n  }\n}\n.ni-task-fill-c {\n  &:before {\n    content: $ni-task-fill-c; \n  }\n}\n.ni-scan-fill {\n  &:before {\n    content: $ni-scan-fill; \n  }\n}\n.ni-scan {\n  &:before {\n    content: $ni-scan; \n  }\n}\n.ni-qr {\n  &:before {\n    content: $ni-qr; \n  }\n}\n.ni-money {\n  &:before {\n    content: $ni-money; \n  }\n}\n.ni-coins {\n  &:before {\n    content: $ni-coins; \n  }\n}\n.ni-coin {\n  &:before {\n    content: $ni-coin; \n  }\n}\n.ni-coin-alt {\n  &:before {\n    content: $ni-coin-alt; \n  }\n}\n.ni-coin-alt-fill {\n  &:before {\n    content: $ni-coin-alt-fill; \n  }\n}\n.ni-setting-alt-fill {\n  &:before {\n    content: $ni-setting-alt-fill; \n  }\n}\n.ni-setting-alt {\n  &:before {\n    content: $ni-setting-alt; \n  }\n}\n.ni-setting-fill {\n  &:before {\n    content: $ni-setting-fill; \n  }\n}\n.ni-setting {\n  &:before {\n    content: $ni-setting; \n  }\n}\n.ni-share-alt {\n  &:before {\n    content: $ni-share-alt; \n  }\n}\n.ni-share-fill {\n  &:before {\n    content: $ni-share-fill; \n  }\n}\n.ni-share {\n  &:before {\n    content: $ni-share; \n  }\n}\n.ni-network {\n  &:before {\n    content: $ni-network; \n  }\n}\n.ni-rss {\n  &:before {\n    content: $ni-rss; \n  }\n}\n.ni-shield {\n  &:before {\n    content: $ni-shield; \n  }\n}\n.ni-shield-star {\n  &:before {\n    content: $ni-shield-star; \n  }\n}\n.ni-shield-check {\n  &:before {\n    content: $ni-shield-check; \n  }\n}\n.ni-shield-alert {\n  &:before {\n    content: $ni-shield-alert; \n  }\n}\n.ni-shield-off {\n  &:before {\n    content: $ni-shield-off; \n  }\n}\n.ni-security {\n  &:before {\n    content: $ni-security; \n  }\n}\n.ni-policy {\n  &:before {\n    content: $ni-policy; \n  }\n}\n.ni-shield-alert-fill {\n  &:before {\n    content: $ni-shield-alert-fill; \n  }\n}\n.ni-shield-check-fill {\n  &:before {\n    content: $ni-shield-check-fill; \n  }\n}\n.ni-shield-fill {\n  &:before {\n    content: $ni-shield-fill; \n  }\n}\n.ni-shield-half {\n  &:before {\n    content: $ni-shield-half; \n  }\n}\n.ni-shield-star-fill {\n  &:before {\n    content: $ni-shield-star-fill; \n  }\n}\n.ni-policy-fill {\n  &:before {\n    content: $ni-policy-fill; \n  }\n}\n.ni-spark {\n  &:before {\n    content: $ni-spark; \n  }\n}\n.ni-spark-off {\n  &:before {\n    content: $ni-spark-off; \n  }\n}\n.ni-spark-fill {\n  &:before {\n    content: $ni-spark-fill; \n  }\n}\n.ni-spark-off-fill {\n  &:before {\n    content: $ni-spark-off-fill; \n  }\n}\n.ni-wallet {\n  &:before {\n    content: $ni-wallet; \n  }\n}\n.ni-wallet-alt {\n  &:before {\n    content: $ni-wallet-alt; \n  }\n}\n.ni-wallet-in {\n  &:before {\n    content: $ni-wallet-in; \n  }\n}\n.ni-wallet-out {\n  &:before {\n    content: $ni-wallet-out; \n  }\n}\n.ni-wallet-saving {\n  &:before {\n    content: $ni-wallet-saving; \n  }\n}\n.ni-wallet-fill {\n  &:before {\n    content: $ni-wallet-fill; \n  }\n}\n.ni-star {\n  &:before {\n    content: $ni-star; \n  }\n}\n.ni-star-half {\n  &:before {\n    content: $ni-star-half; \n  }\n}\n.ni-star-half-fill {\n  &:before {\n    content: $ni-star-half-fill; \n  }\n}\n.ni-star-fill {\n  &:before {\n    content: $ni-star-fill; \n  }\n}\n.ni-star-round {\n  &:before {\n    content: $ni-star-round; \n  }\n}\n.ni-heart {\n  &:before {\n    content: $ni-heart; \n  }\n}\n.ni-heart-fill {\n  &:before {\n    content: $ni-heart-fill; \n  }\n}\n.ni-swap-alt-fill {\n  &:before {\n    content: $ni-swap-alt-fill; \n  }\n}\n.ni-swap-alt {\n  &:before {\n    content: $ni-swap-alt; \n  }\n}\n.ni-thumbs-down {\n  &:before {\n    content: $ni-thumbs-down; \n  }\n}\n.ni-thumbs-up {\n  &:before {\n    content: $ni-thumbs-up; \n  }\n}\n.ni-tag {\n  &:before {\n    content: $ni-tag; \n  }\n}\n.ni-tag-alt {\n  &:before {\n    content: $ni-tag-alt; \n  }\n}\n.ni-tags {\n  &:before {\n    content: $ni-tags; \n  }\n}\n.ni-tag-fill {\n  &:before {\n    content: $ni-tag-fill; \n  }\n}\n.ni-tag-alt-fill {\n  &:before {\n    content: $ni-tag-alt-fill; \n  }\n}\n.ni-tags-fill {\n  &:before {\n    content: $ni-tags-fill; \n  }\n}\n.ni-bookmark {\n  &:before {\n    content: $ni-bookmark; \n  }\n}\n.ni-bookmark-fill {\n  &:before {\n    content: $ni-bookmark-fill; \n  }\n}\n.ni-label {\n  &:before {\n    content: $ni-label; \n  }\n}\n.ni-label-fill {\n  &:before {\n    content: $ni-label-fill; \n  }\n}\n.ni-priority {\n  &:before {\n    content: $ni-priority; \n  }\n}\n.ni-piority {\n  &:before {\n    content: $ni-piority; \n  }\n}\n.ni-priority-fill {\n  &:before {\n    content: $ni-priority-fill; \n  }\n}\n.ni-piority-fill {\n  &:before {\n    content: $ni-piority-fill; \n  }\n}\n.ni-label-alt {\n  &:before {\n    content: $ni-label-alt; \n  }\n}\n.ni-label-alt-fill {\n  &:before {\n    content: $ni-label-alt-fill; \n  }\n}\n.ni-ticket-alt {\n  &:before {\n    content: $ni-ticket-alt; \n  }\n}\n.ni-ticket {\n  &:before {\n    content: $ni-ticket; \n  }\n}\n.ni-ticket-minus {\n  &:before {\n    content: $ni-ticket-minus; \n  }\n}\n.ni-ticket-plus {\n  &:before {\n    content: $ni-ticket-plus; \n  }\n}\n.ni-ticket-alt-fill {\n  &:before {\n    content: $ni-ticket-alt-fill; \n  }\n}\n.ni-ticket-fill {\n  &:before {\n    content: $ni-ticket-fill; \n  }\n}\n.ni-ticket-minus-fill {\n  &:before {\n    content: $ni-ticket-minus-fill; \n  }\n}\n.ni-ticket-plus-fill {\n  &:before {\n    content: $ni-ticket-plus-fill; \n  }\n}\n.ni-toggle-off {\n  &:before {\n    content: $ni-toggle-off; \n  }\n}\n.ni-toggle-on {\n  &:before {\n    content: $ni-toggle-on; \n  }\n}\n.ni-trash-alt {\n  &:before {\n    content: $ni-trash-alt; \n  }\n}\n.ni-trash-empty {\n  &:before {\n    content: $ni-trash-empty; \n  }\n}\n.ni-trash {\n  &:before {\n    content: $ni-trash; \n  }\n}\n.ni-trash-fill {\n  &:before {\n    content: $ni-trash-fill; \n  }\n}\n.ni-trash-empty-fill {\n  &:before {\n    content: $ni-trash-empty-fill; \n  }\n}\n.ni-delete-fill {\n  &:before {\n    content: $ni-delete-fill; \n  }\n}\n.ni-delete {\n  &:before {\n    content: $ni-delete; \n  }\n}\n.ni-alarm-alt {\n  &:before {\n    content: $ni-alarm-alt; \n  }\n}\n.ni-alarm {\n  &:before {\n    content: $ni-alarm; \n  }\n}\n.ni-bugs {\n  &:before {\n    content: $ni-bugs; \n  }\n}\n.ni-building {\n  &:before {\n    content: $ni-building; \n  }\n}\n.ni-building-fill {\n  &:before {\n    content: $ni-building-fill; \n  }\n}\n.ni-headphone {\n  &:before {\n    content: $ni-headphone; \n  }\n}\n.ni-headphone-fill {\n  &:before {\n    content: $ni-headphone-fill; \n  }\n}\n.ni-aperture {\n  &:before {\n    content: $ni-aperture; \n  }\n}\n.ni-help-alt {\n  &:before {\n    content: $ni-help-alt; \n  }\n}\n.ni-award {\n  &:before {\n    content: $ni-award; \n  }\n}\n.ni-briefcase {\n  &:before {\n    content: $ni-briefcase; \n  }\n}\n.ni-gift {\n  &:before {\n    content: $ni-gift; \n  }\n}\n.ni-globe {\n  &:before {\n    content: $ni-globe; \n  }\n}\n.ni-umbrela {\n  &:before {\n    content: $ni-umbrela; \n  }\n}\n.ni-truck {\n  &:before {\n    content: $ni-truck; \n  }\n}\n.ni-sign-usd {\n  &:before {\n    content: $ni-sign-usd; \n  }\n}\n.ni-sign-dollar {\n  &:before {\n    content: $ni-sign-dollar; \n  }\n}\n.ni-sign-mxn {\n  &:before {\n    content: $ni-sign-mxn; \n  }\n}\n.ni-sign-sgd {\n  &:before {\n    content: $ni-sign-sgd; \n  }\n}\n.ni-sign-euro {\n  &:before {\n    content: $ni-sign-euro; \n  }\n}\n.ni-sign-eur {\n  &:before {\n    content: $ni-sign-eur; \n  }\n}\n.ni-sign-gbp {\n  &:before {\n    content: $ni-sign-gbp; \n  }\n}\n.ni-sign-pound {\n  &:before {\n    content: $ni-sign-pound; \n  }\n}\n.ni-sign-thb {\n  &:before {\n    content: $ni-sign-thb; \n  }\n}\n.ni-sign-inr {\n  &:before {\n    content: $ni-sign-inr; \n  }\n}\n.ni-sign-jpy {\n  &:before {\n    content: $ni-sign-jpy; \n  }\n}\n.ni-sign-yen {\n  &:before {\n    content: $ni-sign-yen; \n  }\n}\n.ni-sign-cny {\n  &:before {\n    content: $ni-sign-cny; \n  }\n}\n.ni-sign-kobo {\n  &:before {\n    content: $ni-sign-kobo; \n  }\n}\n.ni-sign-chf {\n  &:before {\n    content: $ni-sign-chf; \n  }\n}\n.ni-sign-vnd {\n  &:before {\n    content: $ni-sign-vnd; \n  }\n}\n.ni-sign-php {\n  &:before {\n    content: $ni-sign-php; \n  }\n}\n.ni-sign-brl {\n  &:before {\n    content: $ni-sign-brl; \n  }\n}\n.ni-sign-idr {\n  &:before {\n    content: $ni-sign-idr; \n  }\n}\n.ni-sign-czk {\n  &:before {\n    content: $ni-sign-czk; \n  }\n}\n.ni-sign-hkd {\n  &:before {\n    content: $ni-sign-hkd; \n  }\n}\n.ni-sign-kr {\n  &:before {\n    content: $ni-sign-kr; \n  }\n}\n.ni-sign-dkk {\n  &:before {\n    content: $ni-sign-dkk; \n  }\n}\n.ni-sign-nok {\n  &:before {\n    content: $ni-sign-nok; \n  }\n}\n.ni-sign-sek {\n  &:before {\n    content: $ni-sign-sek; \n  }\n}\n.ni-sign-rub {\n  &:before {\n    content: $ni-sign-rub; \n  }\n}\n.ni-sign-myr {\n  &:before {\n    content: $ni-sign-myr; \n  }\n}\n.ni-sign-pln {\n  &:before {\n    content: $ni-sign-pln; \n  }\n}\n.ni-sign-try {\n  &:before {\n    content: $ni-sign-try; \n  }\n}\n.ni-sign-waves {\n  &:before {\n    content: $ni-sign-waves; \n  }\n}\n.ni-waves {\n  &:before {\n    content: $ni-waves; \n  }\n}\n.ni-sign-trx {\n  &:before {\n    content: $ni-sign-trx; \n  }\n}\n.ni-tron {\n  &:before {\n    content: $ni-tron; \n  }\n}\n.ni-sign-xem {\n  &:before {\n    content: $ni-sign-xem; \n  }\n}\n.ni-nem {\n  &:before {\n    content: $ni-nem; \n  }\n}\n.ni-sign-mxr {\n  &:before {\n    content: $ni-sign-mxr; \n  }\n}\n.ni-monero {\n  &:before {\n    content: $ni-monero; \n  }\n}\n.ni-sign-usdc {\n  &:before {\n    content: $ni-sign-usdc; \n  }\n}\n.ni-sign-steller {\n  &:before {\n    content: $ni-sign-steller; \n  }\n}\n.ni-sign-steem {\n  &:before {\n    content: $ni-sign-steem; \n  }\n}\n.ni-sign-usdt {\n  &:before {\n    content: $ni-sign-usdt; \n  }\n}\n.ni-tether {\n  &:before {\n    content: $ni-tether; \n  }\n}\n.ni-sign-btc {\n  &:before {\n    content: $ni-sign-btc; \n  }\n}\n.ni-bitcoin {\n  &:before {\n    content: $ni-bitcoin; \n  }\n}\n.ni-sign-bch {\n  &:before {\n    content: $ni-sign-bch; \n  }\n}\n.ni-bitcoin-cash {\n  &:before {\n    content: $ni-bitcoin-cash; \n  }\n}\n.ni-sign-bnb {\n  &:before {\n    content: $ni-sign-bnb; \n  }\n}\n.ni-binance {\n  &:before {\n    content: $ni-binance; \n  }\n}\n.ni-sign-ada {\n  &:before {\n    content: $ni-sign-ada; \n  }\n}\n.ni-sign-zcash {\n  &:before {\n    content: $ni-sign-zcash; \n  }\n}\n.ni-sign-eth {\n  &:before {\n    content: $ni-sign-eth; \n  }\n}\n.ni-ethereum {\n  &:before {\n    content: $ni-ethereum; \n  }\n}\n.ni-sign-dash {\n  &:before {\n    content: $ni-sign-dash; \n  }\n}\n.ni-dash {\n  &:before {\n    content: $ni-dash; \n  }\n}\n.ni-sign-xrp-old {\n  &:before {\n    content: $ni-sign-xrp-old; \n  }\n}\n.ni-ripple-old {\n  &:before {\n    content: $ni-ripple-old; \n  }\n}\n.ni-sign-eos {\n  &:before {\n    content: $ni-sign-eos; \n  }\n}\n.ni-eos {\n  &:before {\n    content: $ni-eos; \n  }\n}\n.ni-sign-xrp {\n  &:before {\n    content: $ni-sign-xrp; \n  }\n}\n.ni-ripple {\n  &:before {\n    content: $ni-ripple; \n  }\n}\n.ni-american-express {\n  &:before {\n    content: $ni-american-express; \n  }\n}\n.ni-jcb {\n  &:before {\n    content: $ni-jcb; \n  }\n}\n.ni-cc-jcb {\n  &:before {\n    content: $ni-cc-jcb; \n  }\n}\n.ni-mc {\n  &:before {\n    content: $ni-mc; \n  }\n}\n.ni-cc-mc {\n  &:before {\n    content: $ni-cc-mc; \n  }\n}\n.ni-discover {\n  &:before {\n    content: $ni-discover; \n  }\n}\n.ni-cc-discover {\n  &:before {\n    content: $ni-cc-discover; \n  }\n}\n.ni-visa {\n  &:before {\n    content: $ni-visa; \n  }\n}\n.ni-cc-visa {\n  &:before {\n    content: $ni-cc-visa; \n  }\n}\n.ni-cc-paypal {\n  &:before {\n    content: $ni-cc-paypal; \n  }\n}\n.ni-cc-stripe {\n  &:before {\n    content: $ni-cc-stripe; \n  }\n}\n.ni-amazon-pay {\n  &:before {\n    content: $ni-amazon-pay; \n  }\n}\n.ni-amazon-pay-fill {\n  &:before {\n    content: $ni-amazon-pay-fill; \n  }\n}\n.ni-google-pay {\n  &:before {\n    content: $ni-google-pay; \n  }\n}\n.ni-google-pay-fill {\n  &:before {\n    content: $ni-google-pay-fill; \n  }\n}\n.ni-apple-pay {\n  &:before {\n    content: $ni-apple-pay; \n  }\n}\n.ni-apple-pay-fill {\n  &:before {\n    content: $ni-apple-pay-fill; \n  }\n}\n.ni-angular {\n  &:before {\n    content: $ni-angular; \n  }\n}\n.ni-react {\n  &:before {\n    content: $ni-react; \n  }\n}\n.ni-laravel {\n  &:before {\n    content: $ni-laravel; \n  }\n}\n.ni-html5 {\n  &:before {\n    content: $ni-html5; \n  }\n}\n.ni-css3-fill {\n  &:before {\n    content: $ni-css3-fill; \n  }\n}\n.ni-css3 {\n  &:before {\n    content: $ni-css3; \n  }\n}\n.ni-js {\n  &:before {\n    content: $ni-js; \n  }\n}\n.ni-php {\n  &:before {\n    content: $ni-php; \n  }\n}\n.ni-python {\n  &:before {\n    content: $ni-python; \n  }\n}\n.ni-bootstrap {\n  &:before {\n    content: $ni-bootstrap; \n  }\n}\n.ni-ebay {\n  &:before {\n    content: $ni-ebay; \n  }\n}\n.ni-google-wallet {\n  &:before {\n    content: $ni-google-wallet; \n  }\n}\n.ni-google-drive {\n  &:before {\n    content: $ni-google-drive; \n  }\n}\n.ni-google-play-store {\n  &:before {\n    content: $ni-google-play-store; \n  }\n}\n.ni-android {\n  &:before {\n    content: $ni-android; \n  }\n}\n.ni-blogger-fill {\n  &:before {\n    content: $ni-blogger-fill; \n  }\n}\n.ni-blogger {\n  &:before {\n    content: $ni-blogger; \n  }\n}\n.ni-hangout {\n  &:before {\n    content: $ni-hangout; \n  }\n}\n.ni-apple-store {\n  &:before {\n    content: $ni-apple-store; \n  }\n}\n.ni-apple-store-ios {\n  &:before {\n    content: $ni-apple-store-ios; \n  }\n}\n.ni-stripe {\n  &:before {\n    content: $ni-stripe; \n  }\n}\n.ni-apple {\n  &:before {\n    content: $ni-apple; \n  }\n}\n.ni-microsoft {\n  &:before {\n    content: $ni-microsoft; \n  }\n}\n.ni-windows {\n  &:before {\n    content: $ni-windows; \n  }\n}\n.ni-amazon {\n  &:before {\n    content: $ni-amazon; \n  }\n}\n.ni-paypal-alt {\n  &:before {\n    content: $ni-paypal-alt; \n  }\n}\n.ni-airbnb {\n  &:before {\n    content: $ni-airbnb; \n  }\n}\n.ni-adobe {\n  &:before {\n    content: $ni-adobe; \n  }\n}\n.ni-mailchimp {\n  &:before {\n    content: $ni-mailchimp; \n  }\n}\n.ni-dropbox {\n  &:before {\n    content: $ni-dropbox; \n  }\n}\n.ni-digital-ocean {\n  &:before {\n    content: $ni-digital-ocean; \n  }\n}\n.ni-slack {\n  &:before {\n    content: $ni-slack; \n  }\n}\n.ni-slack-hash {\n  &:before {\n    content: $ni-slack-hash; \n  }\n}\n.ni-stack-overflow {\n  &:before {\n    content: $ni-stack-overflow; \n  }\n}\n.ni-soundcloud {\n  &:before {\n    content: $ni-soundcloud; \n  }\n}\n.ni-blackberry {\n  &:before {\n    content: $ni-blackberry; \n  }\n}\n.ni-spotify {\n  &:before {\n    content: $ni-spotify; \n  }\n}\n.ni-kickstarter {\n  &:before {\n    content: $ni-kickstarter; \n  }\n}\n.ni-houzz {\n  &:before {\n    content: $ni-houzz; \n  }\n}\n.ni-vine {\n  &:before {\n    content: $ni-vine; \n  }\n}\n.ni-yelp {\n  &:before {\n    content: $ni-yelp; \n  }\n}\n.ni-yoast {\n  &:before {\n    content: $ni-yoast; \n  }\n}\n.ni-envato {\n  &:before {\n    content: $ni-envato; \n  }\n}\n.ni-wordpress {\n  &:before {\n    content: $ni-wordpress; \n  }\n}\n.ni-wp {\n  &:before {\n    content: $ni-wp; \n  }\n}\n.ni-wordpress-fill {\n  &:before {\n    content: $ni-wordpress-fill; \n  }\n}\n.ni-elementor {\n  &:before {\n    content: $ni-elementor; \n  }\n}\n.ni-joomla {\n  &:before {\n    content: $ni-joomla; \n  }\n}\n.ni-megento {\n  &:before {\n    content: $ni-megento; \n  }\n}\n.ni-git {\n  &:before {\n    content: $ni-git; \n  }\n}\n.ni-github {\n  &:before {\n    content: $ni-github; \n  }\n}\n.ni-github-round {\n  &:before {\n    content: $ni-github-round; \n  }\n}\n.ni-github-circle {\n  &:before {\n    content: $ni-github-circle; \n  }\n}\n.ni-dribbble {\n  &:before {\n    content: $ni-dribbble; \n  }\n}\n.ni-dribbble-round {\n  &:before {\n    content: $ni-dribbble-round; \n  }\n}\n.ni-behance {\n  &:before {\n    content: $ni-behance; \n  }\n}\n.ni-behance-fill {\n  &:before {\n    content: $ni-behance-fill; \n  }\n}\n.ni-flickr {\n  &:before {\n    content: $ni-flickr; \n  }\n}\n.ni-flickr-round {\n  &:before {\n    content: $ni-flickr-round; \n  }\n}\n.ni-medium {\n  &:before {\n    content: $ni-medium; \n  }\n}\n.ni-medium-round {\n  &:before {\n    content: $ni-medium-round; \n  }\n}\n.ni-reddit {\n  &:before {\n    content: $ni-reddit; \n  }\n}\n.ni-reddit-round {\n  &:before {\n    content: $ni-reddit-round; \n  }\n}\n.ni-reddit-circle {\n  &:before {\n    content: $ni-reddit-circle; \n  }\n}\n.ni-google {\n  &:before {\n    content: $ni-google; \n  }\n}\n.ni-facebook-f {\n  &:before {\n    content: $ni-facebook-f; \n  }\n}\n.ni-facebook-fill {\n  &:before {\n    content: $ni-facebook-fill; \n  }\n}\n.ni-facebook-circle {\n  &:before {\n    content: $ni-facebook-circle; \n  }\n}\n.ni-instagram {\n  &:before {\n    content: $ni-instagram; \n  }\n}\n.ni-instagram-round {\n  &:before {\n    content: $ni-instagram-round; \n  }\n}\n.ni-linkedin {\n  &:before {\n    content: $ni-linkedin; \n  }\n}\n.ni-linkedin-round {\n  &:before {\n    content: $ni-linkedin-round; \n  }\n}\n.ni-twitter {\n  &:before {\n    content: $ni-twitter; \n  }\n}\n.ni-twitter-round {\n  &:before {\n    content: $ni-twitter-round; \n  }\n}\n.ni-pinterest {\n  &:before {\n    content: $ni-pinterest; \n  }\n}\n.ni-pinterest-round {\n  &:before {\n    content: $ni-pinterest-round; \n  }\n}\n.ni-pinterest-circle {\n  &:before {\n    content: $ni-pinterest-circle; \n  }\n}\n.ni-tumblr {\n  &:before {\n    content: $ni-tumblr; \n  }\n}\n.ni-tumblr-round {\n  &:before {\n    content: $ni-tumblr-round; \n  }\n}\n.ni-skype {\n  &:before {\n    content: $ni-skype; \n  }\n}\n.ni-viber {\n  &:before {\n    content: $ni-viber; \n  }\n}\n.ni-whatsapp {\n  &:before {\n    content: $ni-whatsapp; \n  }\n}\n.ni-whatsapp-round {\n  &:before {\n    content: $ni-whatsapp-round; \n  }\n}\n.ni-snapchat {\n  &:before {\n    content: $ni-snapchat; \n  }\n}\n.ni-snapchat-fill {\n  &:before {\n    content: $ni-snapchat-fill; \n  }\n}\n.ni-telegram {\n  &:before {\n    content: $ni-telegram; \n  }\n}\n.ni-telegram-circle {\n  &:before {\n    content: $ni-telegram-circle; \n  }\n}\n.ni-youtube-line {\n  &:before {\n    content: $ni-youtube-line; \n  }\n}\n.ni-youtube {\n  &:before {\n    content: $ni-youtube; \n  }\n}\n.ni-youtube-fill {\n  &:before {\n    content: $ni-youtube-fill; \n  }\n}\n.ni-youtube-round {\n  &:before {\n    content: $ni-youtube-round; \n  }\n}\n.ni-vimeo {\n  &:before {\n    content: $ni-vimeo; \n  }\n}\n.ni-vimeo-fill {\n  &:before {\n    content: $ni-vimeo-fill; \n  }\n}\n\n",".com { color: #93a1a1; }\n.lit { color: #195f91; }\n.pun, .opn, .clo { color: #93a1a1; }\n.fun { color: #dc322f; }\n.str, .atv { color: #D14; }\n.kwd, .linenums .tag { color: #1e347b; }\n.typ, .atn, .dec, .var { color: teal; }\n.pln { color: #48484c; }\n\n.prettyprint {\n  padding: 8px;\n  background-color: #f7f7f9;\n  border: 1px solid #e1e1e8;\n}\n.prettyprint.linenums {\n  -webkit-box-shadow: inset 40px 0 0 #fbfbfc, inset 41px 0 0 #ececf0;\n     -moz-box-shadow: inset 40px 0 0 #fbfbfc, inset 41px 0 0 #ececf0;\n          box-shadow: inset 40px 0 0 #fbfbfc, inset 41px 0 0 #ececf0;\n}\n\n/* Specify class=linenums on a pre to get line numbering */\nol.linenums {\n  margin: 0 0 0 33px;\n} \nol.linenums li {\n  padding-left: 12px;\n  color: #bebec5;\n  line-height: 18px;\n  text-shadow: 0 1px 0 #fff;\n}",".dnd{\n  &-handle{\n    display: flex;\n    .handle{\n        position: relative;\n        font-size: 1.125rem;\n        cursor: move;\n        height: 1.25rem;\n        width: 1.25rem;\n        @if($rtl==false){\n          margin-right: .5rem;\n        }\n        @if($rtl==true){\n          margin-left: .5rem;\n        }\n        &:after{\n            position: absolute;\n            top:0;\n            left:0;\n            right: 0;\n            bottom: 0;\n            font-family: $nk-dashlite-font;\n            content: $ni-move;\n            font-size: 1rem;\n        }\n    }\n} \n}\n\n\n","/** SimpleBar.js - v5.1.0 | License MIT License  */\n\n[data-simplebar] {\n  position: relative;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-content: flex-start;\n  align-items: flex-start;\n}\n\n.simplebar-wrapper {\n  overflow: hidden;\n  width: inherit;\n  height: inherit;\n  max-width: inherit;\n  max-height: inherit;\n}\n\n.simplebar-mask {\n  direction: inherit;\n  position: absolute;\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: auto !important;\n  height: auto !important;\n  z-index: 0;\n}\n\n.simplebar-offset {\n  direction: inherit !important;\n  box-sizing: inherit !important;\n  resize: none !important;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  padding: 0;\n  margin: 0;\n  -webkit-overflow-scrolling: touch;\n}\n\n.simplebar-content-wrapper {\n  direction: inherit;\n  box-sizing: border-box !important;\n  position: relative;\n  display: block;\n  height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */\n  width: auto;\n  visibility: visible;\n  max-width: 100%; /* Not required for horizontal scroll to trigger */\n  max-height: 100%; /* Needed for vertical scroll to trigger */\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n\n  overflow: hidden scroll;\n}\n\n.simplebar-content-wrapper::-webkit-scrollbar,\n.simplebar-hide-scrollbar::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.simplebar-content:before,\n.simplebar-content:after {\n  content: ' ';\n  display: table;\n}\n\n.simplebar-placeholder {\n  max-height: 100%;\n  max-width: 100%;\n  width: 100%;\n  pointer-events: none;\n}\n\n.simplebar-height-auto-observer-wrapper {\n  box-sizing: inherit !important;\n  height: 100%;\n  width: 100%;\n  max-width: 1px;\n  position: relative;\n  float: left;\n  max-height: 1px;\n  overflow: hidden;\n  z-index: -1;\n  padding: 0;\n  margin: 0;\n  pointer-events: none;\n  flex-grow: inherit;\n  flex-shrink: 0;\n  flex-basis: 0;\n}\n\n.simplebar-height-auto-observer {\n  box-sizing: inherit;\n  display: block;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 1000%;\n  width: 1000%;\n  min-height: 1px;\n  min-width: 1px;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: -1;\n}\n\n.simplebar-track {\n  z-index: 1;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n[data-simplebar].simplebar-dragging .simplebar-content {\n  pointer-events: none;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n[data-simplebar].simplebar-dragging .simplebar-track {\n  pointer-events: all;\n}\n\n.simplebar-scrollbar {\n  position: absolute;\n  left: 0;\n  right: 0;\n  min-height: 10px;\n  .hidden-scrollbar{\n    visibility: hidden;\n  }\n}\n\n.simplebar-scrollbar:before {\n  position: absolute;\n  content: '';\n  background: $base-light;\n  border-radius: 7px;\n  left: 2px;\n  right: 2px;\n  opacity: 0;\n  transition: opacity 0.2s linear;\n}\n\n.simplebar-scrollbar.simplebar-visible:before {\n  /* When hovered, remove all transitions from drag handle */\n  opacity: 0.5;\n  transition: opacity 0s linear;\n}\n\n.simplebar-track.simplebar-vertical {\n  top: 0;\n  width: 8px !important;\n  transition: width .1s;\n  &.simplebar-hover{ \n    width: 10px !important;\n  }\n  .nk-sidebar{\n    visibility: hidden !important;\n  }\n}\n\n.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {\n  top: 2px;\n  bottom: 2px;\n}\n\n.simplebar-track.simplebar-horizontal {\n  left: 0;\n  height: 8px !important;\n  transition: height .1s;\n  &.simplebar-hover{ \n    height: 10px !important;\n  }\n  .nk-sidebar &, .nk-sidebar-fat &, .nk-apps-sidebar &{\n    visibility: hidden !important;\n  }\n}\n\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {\n  height: 100%;\n  left: 2px;\n  right: 2px;\n}\n\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar {\n  right: auto;\n  left: 0;\n  top: 2px;\n  height: 7px;\n  min-height: 0;\n  min-width: 10px;\n  width: auto;\n}\n\n/* Rtl support */\n[data-simplebar-direction='rtl'] .simplebar-track.simplebar-vertical {\n  right: auto;\n  left: 0;\n}\n\n.hs-dummy-scrollbar-size {\n  direction: rtl;\n  position: fixed;\n  opacity: 0;\n  visibility: hidden;\n  height: 500px;\n  width: 500px;\n  overflow-y: hidden;\n  overflow-x: scroll;\n}\n\n.simplebar-hide-scrollbar {\n  position: fixed;\n  left: 0;\n  visibility: hidden;\n  overflow-y: scroll;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}","$slick-bg-lighter: $light-400 !default;\n$slick-bg-light: $base-300 !default;\n$slick-tc-color: $light-600 !default;\n$slick-font-size: 24px;\n$slick-arrow-border-color:  $border-light;\n$slick-arrow-border-hover:  $border-color;\n\n$slick-dots-bg :            $light-300;\n$slick-dots-bg-active:      $base-light;\n\n/** Slick Slider */\n.slick-slider {\n    position: relative;\n    display: block;\n    box-sizing: border-box;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -ms-touch-action: pan-y;\n    touch-action: pan-y;\n    -webkit-tap-highlight-color: transparent;\n}\n.slick-list {\n    position: relative;\n    overflow: hidden;\n    display: block;\n    margin: 0;\n    padding: 0;\n\n    &:focus {\n        outline: none;\n    }\n\n    &.dragging {\n        cursor: pointer;\n        cursor: hand;\n    }\n}\n.slick-slider .slick-track,\n.slick-slider .slick-list {\n    -webkit-transform: translate3d(0, 0, 0);\n    -moz-transform: translate3d(0, 0, 0);\n    -ms-transform: translate3d(0, 0, 0);\n    -o-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n}\n\n.slick-track {\n    position: relative;\n    left: 0;\n    top: 0;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n\n    &:before,\n    &:after {\n        content: \"\";\n        display: table;\n    }\n\n    &:after {\n        clear: both;\n    }\n\n    .slick-loading & {\n        visibility: hidden;\n    }\n}\n.slick-slide {\n    float: left;\n    height: 100%;\n    min-height: 1px;\n    img {\n        display: block;\n    }\n    &.slick-loading img {\n        display: none;\n    }\n\n    display: none;\n\n    &.dragging img {\n        pointer-events: none;\n    }\n\n    .slick-initialized & {\n        display: block;\n    }\n\n    .slick-loading & {\n        visibility: hidden;\n    }\n\n    .slick-vertical & {\n        display: block;\n        height: auto;\n        border: 1px solid transparent;\n    }\n    &:focus{\n        outline: none;\n        border: none;\n    }\n}\n.slick-arrow.slick-hidden {\n    display: none;\n}\n\n.slick-dots{\n    display: flex !important;\n    justify-content: center;\n    padding-top: 1.5rem;\n    li{\n        display: inline-flex;\n        padding: 0 6px;\n        button{\n            background-color: $slick-dots-bg;\n            border: none;\n            border-radius: 20px;\n            text-indent: -99999px;\n            height: 8px;\n            width: 8px;\n            padding: 0;\n            overflow: hidden;\n            transition: all .4s linear;\n            &:focus{\n                outline: none;\n            }\n        }\n        &.slick-active{\n            button{\n                background-color: $slick-dots-bg-active;\n            }\n        }\n    }\n}\n\n.slick-next, .slick-prev{\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    height: 44px;\n    width: 44px;\n    z-index: 9;\n    font-size: $slick-font-size;\n    color: $base-light;\n    background: $white;\n    transition: all .4s linear;\n    border: 1px solid $slick-arrow-border-color;\n    &:hover{\n        color: $base-text;\n        background: $lighter;\n        border-color: $slick-arrow-border-hover;\n        opacity: 1;\n    }\n    .slick-disabled &{\n        cursor: default;\n        color: $light-300;\n        &:hover{\n            color: $light-300;\n            background: $white;\n            border-color: $slick-arrow-border-color;\n        }\n    }\n}\n.slick-next{\n    right: -10px;\n}\n.slick-prev{\n    left: -10px;\n}","/* The MIT License Copyright (c) 2012 Matias Meno <m@tias.me> */\n @-webkit-keyframes passing-through {\n    0% {\n        opacity: 0;\n        -webkit-transform: translateY(40px);\n        -moz-transform: translateY(40px);\n        -ms-transform: translateY(40px);\n        -o-transform: translateY(40px);\n        transform: translateY(40px);\n    }\n    30%,\n    70% {\n        opacity: 1;\n        -webkit-transform: translateY(0px);\n        -moz-transform: translateY(0px);\n        -ms-transform: translateY(0px);\n        -o-transform: translateY(0px);\n        transform: translateY(0px);\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translateY(-40px);\n        -moz-transform: translateY(-40px);\n        -ms-transform: translateY(-40px);\n        -o-transform: translateY(-40px);\n        transform: translateY(-40px);\n    }\n}\n\n@-moz-keyframes passing-through {\n    0% {\n        opacity: 0;\n        -webkit-transform: translateY(40px);\n        -moz-transform: translateY(40px);\n        -ms-transform: translateY(40px);\n        -o-transform: translateY(40px);\n        transform: translateY(40px);\n    }\n    30%,\n    70% {\n        opacity: 1;\n        -webkit-transform: translateY(0px);\n        -moz-transform: translateY(0px);\n        -ms-transform: translateY(0px);\n        -o-transform: translateY(0px);\n        transform: translateY(0px);\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translateY(-40px);\n        -moz-transform: translateY(-40px);\n        -ms-transform: translateY(-40px);\n        -o-transform: translateY(-40px);\n        transform: translateY(-40px);\n    }\n}\n\n@keyframes passing-through {\n    0% {\n        opacity: 0;\n        -webkit-transform: translateY(40px);\n        -moz-transform: translateY(40px);\n        -ms-transform: translateY(40px);\n        -o-transform: translateY(40px);\n        transform: translateY(40px);\n    }\n    30%,\n    70% {\n        opacity: 1;\n        -webkit-transform: translateY(0px);\n        -moz-transform: translateY(0px);\n        -ms-transform: translateY(0px);\n        -o-transform: translateY(0px);\n        transform: translateY(0px);\n    }\n    100% {\n        opacity: 0;\n        -webkit-transform: translateY(-40px);\n        -moz-transform: translateY(-40px);\n        -ms-transform: translateY(-40px);\n        -o-transform: translateY(-40px);\n        transform: translateY(-40px);\n    }\n}\n\n@-webkit-keyframes slide-in {\n    0% {\n        opacity: 0;\n        -webkit-transform: translateY(40px);\n        -moz-transform: translateY(40px);\n        -ms-transform: translateY(40px);\n        -o-transform: translateY(40px);\n        transform: translateY(40px);\n    }\n    30% {\n        opacity: 1;\n        -webkit-transform: translateY(0px);\n        -moz-transform: translateY(0px);\n        -ms-transform: translateY(0px);\n        -o-transform: translateY(0px);\n        transform: translateY(0px);\n    }\n}\n\n@-moz-keyframes slide-in {\n    0% {\n        opacity: 0;\n        -webkit-transform: translateY(40px);\n        -moz-transform: translateY(40px);\n        -ms-transform: translateY(40px);\n        -o-transform: translateY(40px);\n        transform: translateY(40px);\n    }\n    30% {\n        opacity: 1;\n        -webkit-transform: translateY(0px);\n        -moz-transform: translateY(0px);\n        -ms-transform: translateY(0px);\n        -o-transform: translateY(0px);\n        transform: translateY(0px);\n    }\n}\n\n@keyframes slide-in {\n    0% {\n        opacity: 0;\n        -webkit-transform: translateY(40px);\n        -moz-transform: translateY(40px);\n        -ms-transform: translateY(40px);\n        -o-transform: translateY(40px);\n        transform: translateY(40px);\n    }\n    30% {\n        opacity: 1;\n        -webkit-transform: translateY(0px);\n        -moz-transform: translateY(0px);\n        -ms-transform: translateY(0px);\n        -o-transform: translateY(0px);\n        transform: translateY(0px);\n    }\n}\n\n@-webkit-keyframes pulse {\n    0% {\n        -webkit-transform: scale(1);\n        -moz-transform: scale(1);\n        -ms-transform: scale(1);\n        -o-transform: scale(1);\n        transform: scale(1);\n    }\n    10% {\n        -webkit-transform: scale(1.1);\n        -moz-transform: scale(1.1);\n        -ms-transform: scale(1.1);\n        -o-transform: scale(1.1);\n        transform: scale(1.1);\n    }\n    20% {\n        -webkit-transform: scale(1);\n        -moz-transform: scale(1);\n        -ms-transform: scale(1);\n        -o-transform: scale(1);\n        transform: scale(1);\n    }\n}\n\n@-moz-keyframes pulse {\n    0% {\n        -webkit-transform: scale(1);\n        -moz-transform: scale(1);\n        -ms-transform: scale(1);\n        -o-transform: scale(1);\n        transform: scale(1);\n    }\n    10% {\n        -webkit-transform: scale(1.1);\n        -moz-transform: scale(1.1);\n        -ms-transform: scale(1.1);\n        -o-transform: scale(1.1);\n        transform: scale(1.1);\n    }\n    20% {\n        -webkit-transform: scale(1);\n        -moz-transform: scale(1);\n        -ms-transform: scale(1);\n        -o-transform: scale(1);\n        transform: scale(1);\n    }\n}\n\n@keyframes pulse {\n    0% {\n        -webkit-transform: scale(1);\n        -moz-transform: scale(1);\n        -ms-transform: scale(1);\n        -o-transform: scale(1);\n        transform: scale(1);\n    }\n    10% {\n        -webkit-transform: scale(1.1);\n        -moz-transform: scale(1.1);\n        -ms-transform: scale(1.1);\n        -o-transform: scale(1.1);\n        transform: scale(1.1);\n    }\n    20% {\n        -webkit-transform: scale(1);\n        -moz-transform: scale(1);\n        -ms-transform: scale(1);\n        -o-transform: scale(1);\n        transform: scale(1);\n    }\n}\n\n.dropzone,\n.dropzone * {\n    box-sizing: border-box;\n}\n\n.dropzone {\n    min-height: 150px;\n    border: 1px dashed $border-light;\n    border-radius: $border-radius;\n    background: white;\n    padding: 20px 20px;\n    &.small{\n        min-height: 86px;\n    }\n    &.custom{\n        min-height: 1rem !important;\n        padding: 5px 10px;\n    }\n}\n\n.dropzone.dz-clickable {\n    cursor: pointer;\n}\n\n.dropzone.dz-clickable * {\n    cursor: default;\n}\n\n.dropzone.dz-clickable .dz-message,\n.dropzone.dz-clickable .dz-message * {\n    cursor: pointer;\n}\n\n.dropzone.dz-started .dz-message {\n    display: none;\n}\n\n.dropzone.dz-drag-hover {\n    border-style: solid;\n}\n\n.dropzone.dz-drag-hover .dz-message {\n    opacity: 0.5;\n}\n\n.dropzone .dz-message {\n    text-align: center;\n    margin: 1em 0;\n    span{\n        display: block;\n        color: rgba($base-text,.6);\n    }\n    &-text{\n        font-size: 13px;\n        span{\n            display: inline-block;\n            color: $accent-color;\n        }\n    }\n    &-or{\n        font-size: 16px;\n        margin-bottom: 4px;\n        text-transform: uppercase;\n    }\n}\n\n.dropzone .dz-preview {\n    position: relative;\n    display: inline-block;\n    vertical-align: top;\n    margin: 16px;\n    min-height: 100px;\n}\n\n.dropzone .dz-preview:hover {\n    z-index: 1000;\n}\n\n.dropzone .dz-preview:hover .dz-details {\n    opacity: 1;\n}\n\n.dropzone .dz-preview.dz-file-preview .dz-image {\n    border-radius: 20px;\n    background: #999;\n    background: linear-gradient(to bottom, #eee, #ddd);\n}\n\n.dropzone .dz-preview.dz-file-preview .dz-details {\n    opacity: 1;\n}\n\n.dropzone .dz-preview.dz-image-preview {\n    background: white;\n}\n\n.dropzone .dz-preview.dz-image-preview .dz-details {\n    -webkit-transition: opacity 0.2s linear;\n    -moz-transition: opacity 0.2s linear;\n    -ms-transition: opacity 0.2s linear;\n    -o-transition: opacity 0.2s linear;\n    transition: opacity 0.2s linear;\n}\n\n.dropzone .dz-preview .dz-remove {\n    font-size: 14px;\n    text-align: center;\n    display: block;\n    cursor: pointer;\n    border: none;\n}\n\n.dropzone .dz-preview .dz-remove:hover {\n    text-decoration: underline;\n}\n\n.dropzone .dz-preview:hover .dz-details {\n    opacity: 1;\n}\n\n.dropzone .dz-preview .dz-details {\n    z-index: 20;\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: 0;\n    font-size: 13px;\n    min-width: 100%;\n    max-width: 100%;\n    padding: 2em 1em;\n    text-align: center;\n    color: rgba(0, 0, 0, 0.9);\n    line-height: 150%;\n}\n\n.dropzone .dz-preview .dz-details .dz-size {\n    margin-bottom: 1em;\n    font-size: 16px;\n}\n\n.dropzone .dz-preview .dz-details .dz-filename {\n    white-space: nowrap;\n}\n\n.dropzone .dz-preview .dz-details .dz-filename:hover span {\n    border: 1px solid rgba(200, 200, 200, 0.8);\n    background-color: rgba(255, 255, 255, 0.8);\n}\n\n.dropzone .dz-preview .dz-details .dz-filename:not(:hover) {\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.dropzone .dz-preview .dz-details .dz-filename:not(:hover) span {\n    border: 1px solid transparent;\n}\n\n.dropzone .dz-preview .dz-details .dz-filename span,\n.dropzone .dz-preview .dz-details .dz-size span {\n    background-color: rgba(255, 255, 255, 0.4);\n    padding: 0 0.4em;\n    border-radius: 3px;\n}\n\n.dropzone .dz-preview:hover .dz-image img {\n    -webkit-transform: scale(1.05, 1.05);\n    -moz-transform: scale(1.05, 1.05);\n    -ms-transform: scale(1.05, 1.05);\n    -o-transform: scale(1.05, 1.05);\n    transform: scale(1.05, 1.05);\n    -webkit-filter: blur(8px);\n    filter: blur(8px);\n}\n\n.dropzone .dz-preview .dz-image {\n    border-radius: 20px;\n    overflow: hidden;\n    width: 120px;\n    height: 120px;\n    position: relative;\n    display: block;\n    z-index: 10;\n}\n\n.dropzone .dz-preview .dz-image img {\n    display: block;\n}\n\n.dropzone .dz-preview.dz-success .dz-success-mark {\n    -webkit-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n    -moz-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n    -ms-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n    -o-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n    animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\n}\n\n.dropzone .dz-preview.dz-error .dz-error-mark {\n    opacity: 1;\n    -webkit-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n    -moz-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n    -ms-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n    -o-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n    animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\n}\n\n.dropzone .dz-preview .dz-success-mark,\n.dropzone .dz-preview .dz-error-mark {\n    pointer-events: none;\n    opacity: 0;\n    z-index: 500;\n    position: absolute;\n    display: block;\n    top: 50%;\n    left: 50%;\n    margin-left: -27px;\n    margin-top: -27px;\n}\n\n.dropzone .dz-preview .dz-success-mark svg,\n.dropzone .dz-preview .dz-error-mark svg {\n    display: block;\n    width: 54px;\n    height: 54px;\n}\n\n.dropzone .dz-preview.dz-processing .dz-progress {\n    opacity: 1;\n    -webkit-transition: all 0.2s linear;\n    -moz-transition: all 0.2s linear;\n    -ms-transition: all 0.2s linear;\n    -o-transition: all 0.2s linear;\n    transition: all 0.2s linear;\n}\n\n.dropzone .dz-preview.dz-complete .dz-progress {\n    opacity: 0;\n    -webkit-transition: opacity 0.4s ease-in;\n    -moz-transition: opacity 0.4s ease-in;\n    -ms-transition: opacity 0.4s ease-in;\n    -o-transition: opacity 0.4s ease-in;\n    transition: opacity 0.4s ease-in;\n}\n\n.dropzone .dz-preview:not(.dz-processing) .dz-progress {\n    -webkit-animation: pulse 6s ease infinite;\n    -moz-animation: pulse 6s ease infinite;\n    -ms-animation: pulse 6s ease infinite;\n    -o-animation: pulse 6s ease infinite;\n    animation: pulse 6s ease infinite;\n}\n\n.dropzone .dz-preview .dz-progress {\n    opacity: 1;\n    z-index: 1000;\n    pointer-events: none;\n    position: absolute;\n    height: 16px;\n    left: 50%;\n    top: 50%;\n    margin-top: -8px;\n    width: 80px;\n    margin-left: -40px;\n    background: rgba(255, 255, 255, 0.9);\n    -webkit-transform: scale(1);\n    border-radius: 8px;\n    overflow: hidden;\n}\n\n.dropzone .dz-preview .dz-progress .dz-upload {\n    background: #333;\n    background: linear-gradient(to bottom, #666, #444);\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: 0;\n    -webkit-transition: width 300ms ease-in-out;\n    -moz-transition: width 300ms ease-in-out;\n    -ms-transition: width 300ms ease-in-out;\n    -o-transition: width 300ms ease-in-out;\n    transition: width 300ms ease-in-out;\n}\n\n.dropzone .dz-preview.dz-error .dz-error-message {\n    display: block;\n}\n\n.dropzone .dz-preview.dz-error:hover .dz-error-message {\n    opacity: 1;\n    pointer-events: auto;\n}\n\n.dropzone .dz-preview .dz-error-message {\n    pointer-events: none;\n    z-index: 1000;\n    position: absolute;\n    display: block;\n    display: none;\n    opacity: 0;\n    -webkit-transition: opacity 0.3s ease;\n    -moz-transition: opacity 0.3s ease;\n    -ms-transition: opacity 0.3s ease;\n    -o-transition: opacity 0.3s ease;\n    transition: opacity 0.3s ease;\n    border-radius: 8px;\n    font-size: 13px;\n    top: 130px;\n    left: -10px;\n    width: 140px;\n    background: #be2626;\n    background: linear-gradient(to bottom, #be2626, #a92222);\n    padding: 0.5em 1.2em;\n    color: white;\n}\n\n.dropzone .dz-preview .dz-error-message:after {\n    content: '';\n    position: absolute;\n    top: -6px;\n    left: 64px;\n    width: 0;\n    height: 0;\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-bottom: 6px solid #be2626;\n}","$datatable-collapsed-unfold : $ni-plus-sm !default;\n$datatable-collapsed-fold : $ni-minus-sm !default;\n\ntable.dataTable {\n  clear: both;\n  max-width: none !important;\n  border-collapse: separate !important;\n  border-spacing: 0;\n}\ntable.dataTable td.dataTables_empty,\ntable.dataTable th.dataTables_empty {\n  text-align: center;\n}\ntable.dataTable.nowrap th,\ntable.dataTable.nowrap td {\n  white-space: nowrap;\n}\n\ndiv.dataTables_wrapper div.dataTables_length label {\n  font-weight: normal;\n  @if($rtl==false){\n    text-align: left;\n  }\n  @if($rtl==true){\n    text-align: right;\n  }\n  white-space: nowrap;\n}\ndiv.dataTables_wrapper div.dataTables_length select {\n  width: auto;\n  display: inline-block;\n  @extend .custom-select;\n}\ndiv.dataTables_wrapper div.dataTables_length label{\n  display: inline-flex;\n  align-items: center;\n}\ndiv.dataTables_wrapper div.dataTables_length span{\n  margin-left: .5rem;\n  margin-right: .5rem;\n}\ndiv.dataTables_wrapper div.dataTables_filter {\n\n}\ndiv.dataTables_wrapper div.dataTables_filter label {\n  font-weight: normal;\n  white-space: nowrap;\n}\ndiv.dataTables_wrapper div.dataTables_filter input {\n  display: inline-block;\n  @extend .form-control;\n}\ndiv.dataTables_wrapper div.dataTables_info {\n  padding: .5rem 0;\n  white-space: nowrap;\n  font-size: .75rem;\n}\ndiv.dataTables_wrapper div.dataTables_paginate {\n  margin: 0;\n  white-space: nowrap;\n  text-align: right;\n}\ndiv.dataTables_wrapper div.dataTables_paginate ul.pagination {\n  margin: 2px 0;\n  justify-content: center;\n}\ndiv.dataTables_wrapper div.dataTables_processing {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-left: -100px;\n  width: 200px;\n  margin-top: -26px;\n  text-align: center;\n  padding: 1em 0;\n}\ndiv.dataTables_wrapper label {\n  margin-bottom: 0;\n}\n\ntable.dataTable thead > tr > th.sorting_asc, table.dataTable thead > tr > th.sorting_desc, table.dataTable thead > tr > th.sorting,\ntable.dataTable thead > tr > td.sorting_asc,\ntable.dataTable thead > tr > td.sorting_desc,\ntable.dataTable thead > tr > td.sorting {\n  @if($rtl==false){\n    padding-right: 30px;\n  }\n  @if($rtl==true){\n    padding-left: 30px;\n  }\n}\ntable.dataTable thead > tr > th:active,\ntable.dataTable thead > tr > td:active {\n  outline: none;\n}\ntable.dataTable thead .sorting,\ntable.dataTable thead .sorting_asc,\ntable.dataTable thead .sorting_desc,\ntable.dataTable thead .sorting_asc_disabled,\ntable.dataTable thead .sorting_desc_disabled {\n  cursor: pointer;\n  position: relative;\n}\ntable.dataTable thead .sorting:before, table.dataTable thead .sorting:after,\ntable.dataTable thead .sorting_asc:before,\ntable.dataTable thead .sorting_asc:after,\ntable.dataTable thead .sorting_desc:before,\ntable.dataTable thead .sorting_desc:after,\ntable.dataTable thead .sorting_asc_disabled:before,\ntable.dataTable thead .sorting_asc_disabled:after,\ntable.dataTable thead .sorting_desc_disabled:before,\ntable.dataTable thead .sorting_desc_disabled:after {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  display: block;\n  opacity: 0.3;\n}\ntable.dataTable thead .sorting:before,\ntable.dataTable thead .sorting_asc:before,\ntable.dataTable thead .sorting_desc:before,\ntable.dataTable thead .sorting_asc_disabled:before,\ntable.dataTable thead .sorting_desc_disabled:before {\n  @if($rtl==false){\n    right: 1em;\n  }\n  @if($rtl==true){\n    left: 1em;\n  }\n  content: \"\\2191\";\n}\ntable.dataTable thead .sorting:after,\ntable.dataTable thead .sorting_asc:after,\ntable.dataTable thead .sorting_desc:after,\ntable.dataTable thead .sorting_asc_disabled:after,\ntable.dataTable thead .sorting_desc_disabled:after {\n  @if($rtl==false){\n    right: 0.5em;\n  }\n  @if($rtl==true){\n    left: 0.5em;\n  }\n  content: \"\\2193\";\n}\ntable.dataTable thead .sorting_asc:before,\ntable.dataTable thead .sorting_desc:after {\n  opacity: 1;\n}\ntable.dataTable thead .sorting_asc_disabled:before,\ntable.dataTable thead .sorting_desc_disabled:after {\n  opacity: 0;\n}\n\ndiv.dataTables_scrollHead table.dataTable {\n  margin-bottom: 0 !important;\n}\n\ndiv.dataTables_scrollBody table {\n  border-top: none;\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\ndiv.dataTables_scrollBody table thead .sorting:before,\ndiv.dataTables_scrollBody table thead .sorting_asc:before,\ndiv.dataTables_scrollBody table thead .sorting_desc:before,\ndiv.dataTables_scrollBody table thead .sorting:after,\ndiv.dataTables_scrollBody table thead .sorting_asc:after,\ndiv.dataTables_scrollBody table thead .sorting_desc:after {\n  display: none;\n}\ndiv.dataTables_scrollBody table tbody tr:first-child th,\ndiv.dataTables_scrollBody table tbody tr:first-child td {\n  border-top: none;\n}\n\ndiv.dataTables_scrollFoot > .dataTables_scrollFootInner {\n  box-sizing: content-box;\n}\ndiv.dataTables_scrollFoot > .dataTables_scrollFootInner > table {\n  margin-top: 0 !important;\n  border-top: none;\n}\n\n@media screen and (max-width: 767px) {\n  div.dataTables_wrapper div.dataTables_info,\n  div.dataTables_wrapper div.dataTables_paginate {\n    text-align: center;\n  }\n}\ntable.dataTable.table-sm > thead > tr > th {\n  @if($rtl==false){\n    padding-right: 20px;\n  }\n  @if($rtl==true){\n    padding-left: 20px;\n  }\n}\ntable.dataTable.table-sm .sorting:before,\ntable.dataTable.table-sm .sorting_asc:before,\ntable.dataTable.table-sm .sorting_desc:before {\n  top: 5px;\n  @if($rtl==false){\n    right: 0.85em;\n  }\n  @if($rtl==true){\n    left: 0.85em;\n  }\n}\ntable.dataTable.table-sm .sorting:after,\ntable.dataTable.table-sm .sorting_asc:after,\ntable.dataTable.table-sm .sorting_desc:after {\n  top: 5px;\n}\n\ntable.table-bordered.dataTable th,\ntable.table-bordered.dataTable td {\n  @if($rtl==false){\n    border-left-width: 0;\n  }\n  @if($rtl==true){\n    border-right-width: 0;\n  }\n}\ntable.table-bordered.dataTable th:last-child, table.table-bordered.dataTable th:last-child,\ntable.table-bordered.dataTable td:last-child,\ntable.table-bordered.dataTable td:last-child {\n  @if($rtl==false){\n    border-right-width: 0;\n  }\n  @if($rtl==true){\n    border-left-width: 0;\n  }\n}\ntable.table-bordered.dataTable tbody th,\ntable.table-bordered.dataTable tbody td {\n  border-bottom-width: 0;\n}\n\ndiv.dataTables_scrollHead table.table-bordered {\n  border-bottom-width: 0;\n}\n\ndiv.table-responsive > div.dataTables_wrapper > div.row {\n  margin: 0;\n}\ndiv.table-responsive > div.dataTables_wrapper > div.row > div[class^=\"col-\"]:first-child {\n  @if($rtl==false){\n    padding-left: 0;\n  }\n  @if($rtl==true){\n    padding-right: 0;\n  }\n}\ndiv.table-responsive > div.dataTables_wrapper > div.row > div[class^=\"col-\"]:last-child {\n  @if($rtl==false){\n    padding-right: 0;\n  }\n  @if($rtl==true){\n    padding-left: 0;\n  }\n}\n@media (min-width:768px){\n  div.dataTables_wrapper div.dataTables_paginate ul.pagination {\n    justify-content: flex-start;\n  }\n}\n\n\ntable.dataTable.dtr-inline.collapsed>tbody>tr:not(.child)>td:first-child,\ntable.dataTable.dtr-inline.collapsed>tbody>tr:not(.child)>th:first-child{\n  cursor: pointer;\n  &:before{\n    content: $datatable-collapsed-unfold;\n    font-family: $nk-dashlite-font;\n    @if($rtl==false){\n      margin-right: 0.4rem;\n    }\n    @if($rtl==true){\n      margin-left: 0.4rem;\n    }\n  }\n}\n\ntable.dataTable.dtr-inline.collapsed>tbody>tr.parent>td:first-child,\ntable.dataTable.dtr-inline.collapsed>tbody>tr.parent>th:first-child{\n  &:before{\n    content: $datatable-collapsed-fold;\n  }\n}\n\n\n@media (max-width:575px){\n  div.dataTables_wrapper div.dataTables_paginate{\n    ul.pagination{\n      justify-content: flex-start;\n      li:not(.previous):not(.next){\n        display: none;\n      }\n      .page-link{\n        padding-left: 1rem;\n        padding-right: 1rem;\n      }\n    }\n  }\n  div.dataTables_wrapper div.dataTables_info{\n    @if($rtl==false){\n      text-align: right !important;\n    }\n    @if($rtl==true){\n      text-align: left !important;\n    }\n  }\n}\n\n.dataTable{\n  // tr{\n  //   white-space: nowrap;\n  // }\n  td{\n    // white-space: nowrap;\n    &:focus{\n      outline: none;\n    }\n  }\n}\n.datatable{\n  &-wrap{\n    border: 1px solid $border-light;\n    border-radius: $border-radius;\n  }\n}\n\n.dtr-details{\n  @if($rtl==false){\n    padding-left: 0.25rem;\n  }\n  @if($rtl==true){\n    padding-right: 0.25rem;\n  }\n  .dtr-title{\n    font-weight: $fw-bold;\n    @if($rtl==false){\n      margin-right: 0.25rem;\n    }\n    @if($rtl==true){\n      margin-left: 0.25rem;\n    }\n  }\n}\n\n\n//////\n\n.nk-tb-col-check,.nk-tb-col-tools{\n  pointer-events: none;\n  > *{\n    pointer-events: auto;\n  }\n  &:before,&:after{\n    display: none !important;\n  }\n}\n.nk-tb-col-check{\n  @if($rtl==false){\n    padding-right: .5rem !important;\n  }\n  @if($rtl==true){\n    padding-left: .5rem !important;\n  }\n}\n\n@import \"buttons.bootstrap4\";","@keyframes dtb-spinner {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@-o-keyframes dtb-spinner {\n  100% {\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-ms-keyframes dtb-spinner {\n  100% {\n    -ms-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes dtb-spinner {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-moz-keyframes dtb-spinner {\n  100% {\n    -moz-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\ndiv.dt-button-info {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  width: 400px;\n  margin-top: -100px;\n  margin-left: -200px;\n  background-color: $lighter;\n  box-shadow: 0 0 0 200vh rgba($dark,.3);\n  border-radius: $border-radius;\n  text-align: center;\n  z-index: 2020;\n  overflow: hidden;\n  border: 1px solid $border-light;\n}\ndiv.dt-button-info h2 {\n  padding: 2rem;\n  margin: 0;\n  font-weight: normal;\n  border-bottom: 1px solid $border-light;\n  background-color: $white;\n  font-size: $h2-fs;\n}\ndiv.dt-button-info > div {\n  padding: 1.25rem;\n}\n\ndiv.dt-button-collection-title {\n  text-align: center;\n  padding: 0.3em 0 0.5em;\n  font-size: 0.9em;\n}\n\ndiv.dt-button-collection-title:empty {\n  display: none;\n}\n\ndiv.dt-button-collection {\n  position: absolute;\n  z-index: $zindex-dropdown;\n  width: 100%;\n}\ndiv.dt-button-collection div.dropdown-menu {\n  display: block;\n  z-index: $zindex-dropdown + 1;\n  min-width: 100px;\n  top: 10px;\n  .dropdown-position-right &{\n    right: 0;\n    left: auto;\n  }\n}\ndiv.dt-button-collection div.dt-button-collection-title {\n  background-color: white;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n}\ndiv.dt-button-collection.fixed {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  margin-left: -75px;\n  border-radius: 0;\n}\ndiv.dt-button-collection.fixed.two-column {\n  margin-left: -200px;\n}\ndiv.dt-button-collection.fixed.three-column {\n  margin-left: -225px;\n}\ndiv.dt-button-collection.fixed.four-column {\n  margin-left: -300px;\n}\ndiv.dt-button-collection > :last-child {\n  display: block !important;\n  -webkit-column-gap: 8px;\n  -moz-column-gap: 8px;\n  -ms-column-gap: 8px;\n  -o-column-gap: 8px;\n  column-gap: 8px;\n}\ndiv.dt-button-collection > :last-child > * {\n  -webkit-column-break-inside: avoid;\n  break-inside: avoid;\n}\ndiv.dt-button-collection.two-column {\n  width: 400px;\n}\ndiv.dt-button-collection.two-column > :last-child {\n  padding-bottom: 1px;\n  -webkit-column-count: 2;\n  -moz-column-count: 2;\n  -ms-column-count: 2;\n  -o-column-count: 2;\n  column-count: 2;\n}\ndiv.dt-button-collection.three-column {\n  width: 450px;\n}\ndiv.dt-button-collection.three-column > :last-child {\n  padding-bottom: 1px;\n  -webkit-column-count: 3;\n  -moz-column-count: 3;\n  -ms-column-count: 3;\n  -o-column-count: 3;\n  column-count: 3;\n}\ndiv.dt-button-collection.four-column {\n  width: 600px;\n}\ndiv.dt-button-collection.four-column > :last-child {\n  padding-bottom: 1px;\n  -webkit-column-count: 4;\n  -moz-column-count: 4;\n  -ms-column-count: 4;\n  -o-column-count: 4;\n  column-count: 4;\n}\ndiv.dt-button-collection .dt-button {\n  border-radius: 0;\n}\ndiv.dt-button-collection.fixed {\n  max-width: none;\n}\ndiv.dt-button-collection.fixed:before, div.dt-button-collection.fixed:after {\n  display: none;\n}\n\ndiv.dt-button-background {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: $zindex-dropdown;\n  background-color: rgba($dark,.3);\n  display: none !important;\n}\n\n@media screen and (max-width: 767px) {\n  div.dt-buttons {\n    float: none;\n    width: 100%;\n    text-align: center;\n    margin-bottom: 0.5em;\n  }\n  div.dt-buttons a.btn {\n    float: none;\n  }\n}\ndiv.dt-buttons button.btn.processing,\ndiv.dt-buttons div.btn.processing,\ndiv.dt-buttons a.btn.processing {\n  color: rgba(0, 0, 0, 0.2);\n}\ndiv.dt-buttons button.btn.processing:after,\ndiv.dt-buttons div.btn.processing:after,\ndiv.dt-buttons a.btn.processing:after {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 16px;\n  height: 16px;\n  margin: -8px 0 0 -8px;\n  box-sizing: border-box;\n  display: block;\n  content: \" \";\n  border: 2px solid #282828;\n  border-radius: 50%;\n  border-left-color: transparent;\n  border-right-color: transparent;\n  animation: dtb-spinner 1500ms infinite linear;\n  -o-animation: dtb-spinner 1500ms infinite linear;\n  -ms-animation: dtb-spinner 1500ms infinite linear;\n  -webkit-animation: dtb-spinner 1500ms infinite linear;\n  -moz-animation: dtb-spinner 1500ms infinite linear;\n}\n\n.dt-buttons .btn-secondary{\n  @extend .btn-outline-light;\n  @extend .btn-white;\n  @extend .btn-icon;\n  span{\n    display: none;\n  }\n  &:before{\n    font-size: 1.125rem;\n    font-weight: normal;\n    font-style: normal;\n    width: $btn-line-height + $btn-padding-y*2;\n    font-family: $nk-dashlite-font;\n  }\n}\n.dt-export{\n  &-title{\n    margin-left: 0.5rem;\n    margin-right: 0.5rem;\n  }\n}\n.buttons{\n  &-copy:before{\n    content: $ni-copy;\n  }\n  &-pdf:before{\n    content: $ni-file-pdf;\n  }\n  &-excel:before{\n    content: $ni-file-xls;\n  }\n  &-csv:before{\n    content: $ni-file-text;\n  }\n  &-print:before{\n    content: $ni-printer;\n  }\n  &-colvis:before{\n    content: $ni-view-col-sq;\n  }\n  &-columnVisibility{\n    position: relative;\n    padding-right: $dropdown-item-padding-x*3;\n    font-size: $fx-sz-12;\n    font-weight: $fw-medium;\n    color: $base-text;\n    transition: all .4s;\n    &.active{\n      &:not(:hover){\n        color: $base-text;\n        background-color: transparent;\n      }\n      &:after{\n        content: $ni-check;\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        right: 1rem;\n        font-family: $nk-dashlite-font;\n      }\n    }\n  }\n}\n\n@media (max-width: 600px) {\n  .with-export {\n    > .col-5, > .col-7, > .col-sm-4, > .col-sm-8 {\n      width: 100% !important;\n      flex: 0 0 100%;\n      max-width: 100%;\n    }\n    .datatable-filter .justify-content-end {\n      justify-content: space-between !important;\n    }\n    .dataTables_filter label {\n      display: block;\n    }\n    .dataTables_filter .form-control {\n      width: 100% !important;\n    }\n  }\n}",".rdt_Table{\n    margin: 1rem 0px;\n    border: 1px solid #e5e9f2;\n    border-radius: 4px;\n    background: #fff ;\n}\n.rdt_TableHeadRow {\n    min-height: 40px !important;\n    background: #fff;\n}\n.rdt_TableCol > input[type=\"checkbox\"] {\n    margin-left: 10px;\n}\n.rdt_TableCol{\n    padding-right: 10px !important;\n    color: #526484 !important;\n    font-weight: bold !important;\n    font-size: 0.90rem !important;\n    .rdt_TableCol_Sortable {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between !important;\n        &:hover,&:focus {\n            opacity: 1 !important;\n        }\n    }\n    &:last-child {\n        padding-right: 10px !important;\n    }\n}\n.rdt_TableRow{\n    color: #526484 !important;\n    font-size: .875rem !important;\n    font-weight: 400 !important;\n    line-height: 1.65 !important;\n}\n.dtr-details {\n    color: #526484 !important;\n    margin: 0 !important;\n}\n// .rdt_TableHeadRow > .rdt_TableCol_Sortable{\n//     color: #526484 !important;\n//     font-size: 1rem !important;\n//     font-weight: bold !important;\n//     line-height: 1.1 !important;\n// }\n.rdt_TableHeadRow > .rdt_TableCol > .custom-control {\n    margin-left: 0px;\n}\n","/** SweetAlert2 | github.com/sweetalert2/sweetalert2 */\n\n@import 'scss/theming';\n@import 'scss/polyfills';\n@import 'scss/animations';\n\nbody {\n  @include sweetalert2-body();\n  @include sweetalert2-toasts-body();\n}\n",".swal2-popup {\n  &.swal2-toast {\n    flex-direction: row;\n    align-items: center;\n    width: $swal2-toast-width;\n    padding: $swal2-toast-padding;\n    overflow-y: hidden;\n    background: $swal2-toast-background;\n    box-shadow: $swal2-toast-box-shadow;\n\n    .swal2-header {\n      flex-direction: row;\n    }\n\n    .swal2-title {\n      flex-grow: 1;\n      justify-content: flex-start;\n      margin: $swal2-toast-title-margin;\n      font-size: $swal2-toast-title-font-size;\n    }\n\n    .swal2-footer {\n      margin: $swal2-toast-footer-margin;\n      padding: $swal2-toast-footer-margin;\n      font-size: $swal2-toast-footer-font-size;\n    }\n\n    .swal2-close {\n      position: static;\n      width: $swal2-toast-close-button-width;\n      height: $swal2-toast-close-button-height;\n      line-height: $swal2-toast-close-button-line-height;\n    }\n\n    .swal2-content {\n      justify-content: flex-start;\n      font-size: $swal2-toast-content-font-size;\n    }\n\n    .swal2-icon {\n      width: 2em;\n      min-width: 2em;\n      height: 2em;\n      margin: 0;\n\n      .swal2-icon-content {\n        display: flex;\n        align-items: center;\n        font-size: 1.8em;\n        font-weight: bold;\n\n        @include ie {\n          font-size: .25em;\n        }\n      }\n\n      &.swal2-success {\n        .swal2-success-ring {\n          width: 2em;\n          height: 2em;\n        }\n      }\n\n      &.swal2-error {\n        [class^='swal2-x-mark-line'] {\n          top: .875em;\n          width: 1.375em;\n\n          &[class$='left'] {\n            @if($rtl==false){\n              left: .3125em;\n            }\n            @if($rtl==true){\n              right: .3125em;\n            }\n          }\n\n          &[class$='right'] {\n            @if($rtl==false){\n              right: .3125em;\n            }\n            @if($rtl==true){\n              left: .3125em;\n            }\n          }\n        }\n      }\n    }\n\n    .swal2-actions {\n      flex-basis: auto !important;\n      width: auto;\n      height: auto;\n      margin: 0 .3125em;\n      .btn{\n        margin: 0 .5em;\n      }\n    }\n\n    .swal2-styled {\n      margin: 0 .5em;\n      padding: .3125em .625em;\n      font-size: $swal2-toast-buttons-font-size;\n\n      &:focus {\n        box-shadow: $swal2-toast-button-focus-box-shadow;\n      }\n    }\n\n    .swal2-success {\n      border-color: $swal2-success;\n\n      [class^='swal2-success-circular-line'] { // Emulate moving circular line\n        position: absolute;\n        width: 1.6em;\n        height: 3em;\n        transform: rotate(45deg);\n        border-radius: 50%;\n\n        &[class$='left'] {\n          top: -.8em;\n          @if($rtl==false){\n            left: -.5em;\n            border-radius: 4em 0 0 4em;\n          }\n          @if($rtl==true){\n            right: -.5em;\n            border-radius: 0 4em 4em 0;\n          }\n          transform: rotate(-45deg);\n          transform-origin: 2em 2em;\n        }\n        \n        &[class$='right'] {\n          top: -.25em;\n          @if($rtl==false){\n            left: .9375em;\n            border-radius: 0 4em 4em 0;\n          }\n          @if($rtl==true){\n            right: .9375em;\n            border-radius: 4em 0 0 4em;\n          }\n          transform-origin: 0 1.5em;\n        }\n      }\n\n      .swal2-success-ring {\n        width: 2em;\n        height: 2em;\n      }\n\n      .swal2-success-fix {\n        top: 0;\n        @if($rtl==false){\n          left: .4375em;\n        }\n        @if($rtl==true){\n          right: .4375em;\n        }\n        width: .4375em;\n        height: 2.6875em;\n      }\n\n      [class^='swal2-success-line'] {\n        height: .3125em;\n\n        &[class$='tip'] {\n          top: 1.125em;\n          @if($rtl==false){\n            left: .1875em;\n          }\n          @if($rtl==true){\n            right: .1875em;\n          }\n          width: .75em;\n        }\n\n        &[class$='long'] {\n          top: .9375em;\n          @if($rtl==false){\n            right: .1875em;\n          }\n          @if($rtl==true){\n            left: .1875em;\n          }\n          width: 1.375em;\n        }\n      }\n\n      &.swal2-icon-show {\n        @if $swal2-icon-animations {\n          .swal2-success-line-tip {\n            animation: swal2-toast-animate-success-line-tip .75s;\n          }\n\n          .swal2-success-line-long {\n            animation: swal2-toast-animate-success-line-long .75s;\n          }\n        }\n      }\n    }\n\n    &.swal2-show {\n      animation: $swal2-toast-show-animation;\n    }\n\n    &.swal2-hide {\n      animation: $swal2-toast-hide-animation;\n    }\n  }\n}\n","$swal2-white:         $white !default;\n$swal2-black:         $dark !default;\n$swal2-outline-color: rgba($primary, .4) !default;\n\n// CONTAINER\n$swal2-container-padding: .625em !default;\n\n// BOX MODEL\n$swal2-width: 480px !important;\n$swal2-padding: 2.75rem 2.5rem !important;\n$swal2-border: none !important;\n$swal2-border-radius: $border-radius !important;\n$swal2-box-shadow: $white !important;\n\n// ANIMATIONS\n$swal2-show-animation: swal2-show .3s !important;\n$swal2-hide-animation: swal2-hide .15s forwards !important;\n\n// BACKGROUND\n$swal2-background: $swal2-white !default;\n\n// TYPOGRAPHY\n$swal2-font: inherit !default;\n$swal2-font-size: 1rem !default;\n\n// BACKDROP\n$swal2-backdrop: rgba($base-dark, .4) !default;\n$swal2-backdrop-transition: background-color .1s !default;\n\n// ICONS\n$swal2-icon-size: 5em !default;\n$swal2-icon-animations: true !default;\n$swal2-icon-margin: -.5rem auto 1.5rem !default;\n$swal2-icon-zoom: null !default;\n$swal2-success: $success !default;\n$swal2-success-border: rgba($swal2-success, .3) !default;\n$swal2-error: $danger !default;\n$swal2-warning: $warning !default;\n$swal2-info: $info !default;\n$swal2-question: $base-text !default; \n$swal2-icon-font-family: inherit !default;\n\n// IMAGE\n$swal2-image-margin: 0 auto 1.5rem !default;\n\n// TITLE\n$swal2-title-margin: 0 0 .4em !important;\n$swal2-title-color: $base-color !important;\n$swal2-title-font-size: 1.5rem !important;\n\n// CONTENT\n$swal2-content-justify-content: center !default;\n$swal2-content-margin: 0 0 1rem !default;\n$swal2-content-pading: 0 !default;\n$swal2-content-color: $base-light !default;\n$swal2-content-font-size: .875rem !default;\n$swal2-content-font-weight: normal !default;\n$swal2-content-line-height: normal !default;\n$swal2-content-text-align: center !default;\n$swal2-content-word-wrap: break-word !default;\n\n// INPUT\n$swal2-input-margin: 1rem auto !important;\n$swal2-input-width: 100% !important;\n$swal2-input-height: 2.75rem !important;\n$swal2-input-padding: 0 1rem !important;\n$swal2-input-border: 1px solid $border-color !important;\n$swal2-input-border-radius: $border-radius !important;\n$swal2-input-box-shadow: none !important;\n$swal2-input-focus-border: 1px solid $accent-color !important;\n$swal2-input-focus-outline: none !important;\n$swal2-input-focus-box-shadow: 0 0 0 3px rgba($accent-color,.1) !important;\n$swal2-input-font-size: 0.875rem !important;\n$swal2-input-background: inherit !important;\n$swal2-input-color: inherit !important;\n$swal2-input-transition: border-color .3s, box-shadow .3s !important;\n\n// TEXTAREA SPECIFIC VARIABLES\n$swal2-textarea-height: 6.75em !default;\n$swal2-textarea-padding: .75em !default;\n\n// VALIDATION MESSAGE\n$swal2-validation-message-justify-content: center !important;\n$swal2-validation-message-padding: .625em !important;\n$swal2-validation-message-background: lighten($swal2-black, 94) !important;\n$swal2-validation-message-color: lighten($swal2-black, 40) !important;\n$swal2-validation-message-font-size: 1em !important;\n$swal2-validation-message-font-weight: 300 !important;\n$swal2-validation-message-icon-background: $swal2-error !important;\n$swal2-validation-message-icon-color: $swal2-white !important;\n$swal2-validation-message-icon-zoom: null !important;\n\n// PROGRESS STEPS\n$swal2-progress-steps-background: inherit !default;\n$swal2-progress-steps-margin: 0 0 1.25em !default;\n$swal2-progress-steps-padding: 0 !default;\n$swal2-progress-steps-font-weight: 600 !default;\n$swal2-progress-steps-distance: 2.5em !default;\n$swal2-progress-step-width: 2em;\n$swal2-progress-step-height: 2em;\n$swal2-progress-step-border-radius: 2em;\n$swal2-progress-step-background: #add8e6 !default;\n$swal2-progress-step-color: $swal2-white !default;\n$swal2-active-step-background: #3085d6 !default;\n$swal2-active-step-color: $swal2-white !default;\n\n// FOOTER\n$swal2-footer-margin: 1.25em 0 0 !default;\n$swal2-footer-padding: 1em 0 0 !default;\n$swal2-footer-border-color: #eee !default;\n$swal2-footer-color: lighten($swal2-black, 33) !default;\n$swal2-footer-font-size: 1em !default;\n\n// TIMER POGRESS BAR\n$swal2-timer-progress-bar-height: .25em;\n$swal2-timer-progress-bar-background: rgba($swal2-black, .2) !default;\n\n// CLOSE BUTTON\n$swal2-close-button-width: 1.2em !default;\n$swal2-close-button-height: 1.2em !default;\n$swal2-close-button-line-height: 1.2 !default;\n$swal2-close-button-position: absolute !default;\n$swal2-close-button-gap: 0 !default;\n$swal2-close-button-transition: color .1s ease-out !default;\n$swal2-close-button-border: none !default;\n$swal2-close-button-border-radius: 0 !default;\n$swal2-close-button-outline: initial !default;\n$swal2-close-button-background: transparent !default;\n$swal2-close-button-color: lighten($swal2-black, 80) !default;\n$swal2-close-button-font-family: serif !default;\n$swal2-close-button-font-size: 2.5em !default;\n\n// CLOSE BUTTON:HOVER\n$swal2-close-button-hover-transform: none !important;\n$swal2-close-button-hover-color: $swal2-error !important;\n$swal2-close-button-hover-background: transparent !important;\n\n// ACTIONS\n$swal2-actions-flex-wrap: wrap !default;\n$swal2-actions-align-items: center !default;\n$swal2-actions-justify-content: center !default;\n$swal2-actions-width: 100% !default;\n$swal2-actions-margin: 1.5rem auto 0 !default;\n\n// CONFIRM BUTTON\n$swal2-confirm-button-border: 0 !default;\n$swal2-confirm-button-border-radius: .25em !default;\n$swal2-confirm-button-background-color: $success !important;\n$swal2-confirm-button-color: $swal2-white !default;\n$swal2-confirm-button-font-size: 1.0625em !default;\n\n// CANCEL BUTTON\n$swal2-cancel-button-border: 0 !default;\n$swal2-cancel-button-border-radius: .25em !default;\n$swal2-cancel-button-background-color: $danger !important;\n$swal2-cancel-button-color: $swal2-white !default;\n$swal2-cancel-button-font-size: 1.0625em !default;\n\n// COMMON VARIABLES FOR CONFIRM AND CANCEL BUTTONS\n$swal2-button-darken-hover: rgba($swal2-black, .1) !default;\n$swal2-button-darken-active: rgba($swal2-black, .2) !default;\n$swal2-button-focus-outline: none !default;\n$swal2-button-focus-background-color: null !default;\n$swal2-button-focus-box-shadow: 0 0 0 .2rem $swal2-outline-color !default;\n\n// TOASTS\n$swal2-toast-show-animation: swal2-toast-show .5s !default;\n$swal2-toast-hide-animation: swal2-toast-hide .1s forwards !default;\n$swal2-toast-border: none !default;\n$swal2-toast-box-shadow: 0 0 .625em #d9d9d9 !default;\n$swal2-toast-background: $swal2-white !default;\n$swal2-toast-close-button-width: .8em !default;\n$swal2-toast-close-button-height: .8em !default;\n$swal2-toast-close-button-line-height: .8 !default;\n$swal2-toast-width: auto !default;\n$swal2-toast-padding: .625em !default;\n$swal2-toast-title-margin: 0 .6em !default;\n$swal2-toast-title-font-size: 1em !default;\n$swal2-toast-content-font-size: 1em !default;\n$swal2-toast-input-font-size: 1em !default;\n$swal2-toast-validation-font-size: 1em !important;\n$swal2-toast-buttons-font-size: 1em !default;\n$swal2-toast-button-focus-box-shadow: 0 0 0 1px $swal2-background, 0 0 0 3px $swal2-outline-color !default;\n$swal2-toast-footer-margin: .5em 0 0 !default;\n$swal2-toast-footer-padding: .5em 0 0 !default;\n$swal2-toast-footer-font-size: .8em !default;\n","@mixin ie {\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    @content;\n  }\n}\n\n// https://stackoverflow.com/a/30250161\n@mixin not($ignor-list...) {\n  @if (length($ignor-list) == 1) {\n    $ignor-list: nth($ignor-list, 1);\n  }\n\n  $not-output: '';\n\n  @each $not in $ignor-list {\n    $not-output: $not-output + ':not(#{$not})'; // stylelint-disable-line scss/no-duplicate-dollar-variables\n  }\n\n  &#{$not-output} {\n    @content;\n  }\n}\n",".swal2-container {\n  // centering\n  display: flex !important;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding: $swal2-container-padding !important;\n  overflow-x: hidden !important;\n  transition: $swal2-backdrop-transition !important;\n\n  // sweetalert2/issues/905\n  -webkit-overflow-scrolling: touch;\n\n  &.swal2-backdrop-show {\n    background: $swal2-backdrop !important;\n  }\n\n  &.swal2-backdrop-hide {\n    background: transparent !important;\n  }\n\n  &.swal2-top {\n    align-items: flex-start;\n  }\n\n  &.swal2-top-start,\n  &.swal2-top-left {\n    align-items: flex-start;\n    justify-content: flex-start;\n  }\n\n  &.swal2-top-end,\n  &.swal2-top-right {\n    align-items: flex-start;\n    justify-content: flex-end;\n  }\n\n  &.swal2-center {\n    align-items: center;\n  }\n\n  &.swal2-center-start,\n  &.swal2-center-left {\n    align-items: center;\n    justify-content: flex-start;\n  }\n\n  &.swal2-center-end,\n  &.swal2-center-right {\n    align-items: center;\n    justify-content: flex-end;\n  }\n\n  &.swal2-bottom {\n    align-items: flex-end;\n  }\n\n  &.swal2-bottom-start,\n  &.swal2-bottom-left {\n    align-items: flex-end;\n    justify-content: flex-start;\n  }\n\n  &.swal2-bottom-end,\n  &.swal2-bottom-right {\n    align-items: flex-end;\n    justify-content: flex-end;\n  }\n\n  &.swal2-bottom > :first-child,\n  &.swal2-bottom-start > :first-child,\n  &.swal2-bottom-left > :first-child,\n  &.swal2-bottom-end > :first-child,\n  &.swal2-bottom-right > :first-child {\n    margin-top: auto;\n  }\n\n  &.swal2-grow-fullscreen > .swal2-modal {\n    display: flex !important;\n    flex: 1;\n    align-self: stretch;\n    justify-content: center;\n  }\n\n  &.swal2-grow-row > .swal2-modal {\n    display: flex !important;\n    flex: 1;\n    align-content: center;\n    justify-content: center;\n  }\n\n  &.swal2-grow-column {\n    flex: 1;\n    flex-direction: column;\n\n    &.swal2-top,\n    &.swal2-center,\n    &.swal2-bottom {\n      align-items: center;\n    }\n\n    &.swal2-top-start,\n    &.swal2-center-start,\n    &.swal2-bottom-start,\n    &.swal2-top-left,\n    &.swal2-center-left,\n    &.swal2-bottom-left {\n      align-items: flex-start;\n    }\n\n    &.swal2-top-end,\n    &.swal2-center-end,\n    &.swal2-bottom-end,\n    &.swal2-top-right,\n    &.swal2-center-right,\n    &.swal2-bottom-right {\n      align-items: flex-end;\n    }\n\n    & > .swal2-modal {\n      display: flex !important;\n      flex: 1;\n      align-content: center;\n      justify-content: center;\n    }\n  }\n\n  @include not('.swal2-top',\n  '.swal2-top-start',\n  '.swal2-top-end',\n  '.swal2-top-left',\n  '.swal2-top-right',\n  '.swal2-center-start',\n  '.swal2-center-end',\n  '.swal2-center-left',\n  '.swal2-center-right',\n  '.swal2-bottom',\n  '.swal2-bottom-start',\n  '.swal2-bottom-end',\n  '.swal2-bottom-left',\n  '.swal2-bottom-right',\n  '.swal2-grow-fullscreen') {\n    & > .swal2-modal {\n      margin: auto;\n    }\n  }\n\n  @include ie {\n    .swal2-modal {\n      margin: 0 !important;\n    }\n  }\n}\n\n.swal2-popup {\n  display: flex !important; \n  box-sizing: border-box;\n  flex-direction: column;\n  justify-content: center;\n  width: $swal2-width;\n  padding: $swal2-padding;\n  border: $swal2-border;\n  border-radius: $swal2-border-radius;\n  &:focus {\n    outline: none;\n  }\n\n  &.swal2-loading {\n    overflow-y: hidden;\n  }\n}\n\n.swal2-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.swal2-title {\n  margin: $swal2-title-margin;\n  padding: 0 !important;\n  color: $swal2-title-color;\n  font-size: $swal2-title-font-size;\n  font-weight: 700 !important;\n}\n.swal2-html-container{\n  margin-bottom: 1rem !important\n}\n.swal2-actions {\n  width: $swal2-actions-width !important;\n  .btn{\n    margin: 0 .75rem !important;\n  }\n  &:not(.swal2-loading) {\n    .swal2-styled {\n      &[disabled] {\n        opacity: .4;\n      }\n\n      &:hover {\n        background-image: linear-gradient($swal2-button-darken-hover, $swal2-button-darken-hover);\n      }\n\n      &:active {\n        background-image: linear-gradient($swal2-button-darken-active, $swal2-button-darken-active);\n      }\n    }\n  }\n\n  &.swal2-loading {\n    .swal2-styled {\n      &.swal2-confirm {\n        box-sizing: border-box !important; \n        width: 2.5em !important;\n        height: 2.5em !important;\n        margin: .46875em !important;\n        padding: 0 !important;\n        animation: swal2-rotate-loading 1.5s linear 0s infinite normal !important;\n        border: .25em solid transparent !important;\n        border-radius: 100% !important;\n        border-color: transparent !important;\n        background-color: transparent !important;\n        color: transparent !important;\n        cursor: default;\n        user-select: none !important;\n      }\n      &:focus{\n        border: none;\n      }\n\n      &.swal2-cancel {\n        margin-right: 30px;\n        margin-left: 30px;\n      }\n    }\n\n    :not(.swal2-styled) {\n      &.swal2-confirm {\n        &::after {\n          content: '';\n          display: inline-block;\n          width: 15px;\n          height: 15px;\n          animation: swal2-rotate-loading 1.5s linear 0s infinite normal;\n          border: 3px solid lighten($swal2-black, 60);\n          border-radius: 50%;\n          @if($rtl==false){\n            margin-left: 5px;\n            border-right-color: transparent;\n          }\n          @if($rtl==true){\n            margin-right: 5px;\n            border-left-color: transparent;\n          }\n          box-shadow: 1px 1px 1px $swal2-white;\n        }\n      }\n    }\n  }\n}\n\n.swal2-styled {\n  margin: 0 .75rem !important;\n  box-shadow: none !important;\n  padding: 0.6875rem 1.25rem !important;\n  font-size: 0.9375rem !important;\n  line-height: 1.25rem !important;\n  border-radius: 5px !important;\n  min-width: 90px !important;\n  .swal2-loading & {\n    min-width: 0 !important;\n  }\n  &:not([disabled]) {\n    cursor: pointer !important;\n  }\n\n  &.swal2-confirm {\n    border: $swal2-confirm-button-border;\n    border-radius: $swal2-confirm-button-border-radius;\n    background: initial;\n    background-color: $swal2-confirm-button-background-color;\n    color: $swal2-confirm-button-color;\n    &:focus {\n      outline: $swal2-button-focus-outline !important;\n      background-color: $swal2-button-focus-background-color !important;\n      box-shadow: none !important;\n      // box-shadow: 0 0 0 .2rem rgba($swal2-confirm-button-background-color,.5);\n    }\n  }\n\n  &.swal2-cancel {\n    border: $swal2-cancel-button-border;\n    border-radius: $swal2-cancel-button-border-radius;\n    background: initial;\n    background-color: $swal2-cancel-button-background-color;\n    color: $swal2-cancel-button-color;\n    &:focus {\n      outline: $swal2-button-focus-outline;\n      background-color: $swal2-button-focus-background-color;\n      // box-shadow: 0 0 0 .2rem rgba($swal2-cancel-button-background-color,.5);\n    }\n  }\n\n\n  &::-moz-focus-inner {\n    border: 0;\n  }\n}\n\n.swal2-footer {\n  justify-content: center;\n  margin: $swal2-footer-margin;\n  padding: $swal2-footer-padding;\n  border-top: 1px solid $swal2-footer-border-color;\n  color: $swal2-footer-color;\n  font-size: $swal2-footer-font-size;\n}\n\n.swal2-timer-progress-bar {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: $swal2-timer-progress-bar-height;\n  background: $swal2-timer-progress-bar-background;\n}\n\n.swal2-image {\n  max-width: 100%;\n  margin: $swal2-image-margin !important;\n}\n\n.swal2-close {\n  position: $swal2-close-button-position;\n  z-index: 2;\n\n  /* 1617 */\n  top: $swal2-close-button-gap;\n  @if($rtl==false){\n    right: $swal2-close-button-gap;\n  }\n  @if($rtl==true){\n    left: $swal2-close-button-gap;\n  }\n  justify-content: center;\n  width: $swal2-close-button-width;\n  height: $swal2-close-button-height;\n  padding: 0;\n  overflow: hidden;\n  transition: $swal2-close-button-transition;\n  border: $swal2-close-button-border;\n  border-radius: $swal2-close-button-border-radius;\n  outline: $swal2-close-button-outline;\n  background: $swal2-close-button-background;\n  color: $swal2-close-button-color;\n  font-family: $swal2-close-button-font-family;\n  font-size: $swal2-close-button-font-size;\n  line-height: $swal2-close-button-line-height;\n  cursor: pointer;\n\n  &:hover {\n    transform: $swal2-close-button-hover-transform;\n    background: $swal2-close-button-hover-background;\n    color: $swal2-close-button-hover-color;\n  }\n\n  &::-moz-focus-inner {\n    border: 0;\n  }\n}\n\n.swal2-html-container {\n  margin: $swal2-content-margin !important;\n  color: $swal2-content-color !important;\n  font-size: $swal2-content-font-size !important;\n  font-weight: $swal2-content-font-weight !important;\n}\n\n.swal2-validation-message {\n  display: none;\n  align-items: center;\n  justify-content: $swal2-validation-message-justify-content;\n  padding: $swal2-validation-message-padding;\n  overflow: hidden;\n  background: $swal2-validation-message-background;\n  color: $swal2-validation-message-color;\n  font-size: $swal2-validation-message-font-size;\n  font-weight: $swal2-validation-message-font-weight;\n\n  &::before {\n    content: '!';\n    display: inline-block;\n    width: 1.5em;\n    min-width: 1.5em;\n    height: 1.5em;\n    margin: 0 .625em;\n    zoom: $swal2-validation-message-icon-zoom;\n    border-radius: 50%;\n    background-color: $swal2-validation-message-icon-background;\n    color: $swal2-validation-message-icon-color;\n    font-weight: 600;\n    line-height: 1.5em;\n    text-align: center;\n  }\n}\n\n.swal2-icon {\n  width: $swal2-icon-size !important;\n  height: $swal2-icon-size !important;\n  margin: $swal2-icon-margin !important;\n  zoom: $swal2-icon-zoom !important;\n  border: .25em solid transparent !important;\n  font-family: $swal2-icon-font-family !important;\n  line-height: $swal2-icon-size !important;\n  cursor: default !important;\n  user-select: none !important;\n  transform: scale(.8) !important;\n  .swal2-icon-content {\n    display: flex;\n    align-items: center;\n    font-size: 3.75em;\n  }\n\n  &.swal2-error {\n    border-color: $swal2-error !important;\n    color: $swal2-error !important;\n\n    .swal2-x-mark {\n      position: relative;\n      flex-grow: 1;\n    }\n\n    [class^='swal2-x-mark-line'] {\n      display: block;\n      position: absolute;\n      top: 2.3125em;\n      width: 2.9375em;\n      height: .3125em;\n      border-radius: .125em;\n      background-color: $swal2-error !important;\n\n      &[class$='left'] {\n        left: 1.0625em;\n        transform: rotate(45deg);\n      }\n\n      &[class$='right'] {\n        right: 1em;\n        transform: rotate(-45deg);\n      }\n    }\n\n    // Error icon animation\n    &.swal2-icon-show {\n      @if $swal2-icon-animations {\n        animation: swal2-animate-error-icon .5s !important; \n\n        .swal2-x-mark {\n          animation: swal2-animate-error-x-mark .5s !important;\n        }\n      }\n    }\n  }\n\n  &.swal2-warning {\n    border-color: lighten($swal2-warning, 7) !important;\n    color: $swal2-warning !important;\n  }\n\n  &.swal2-info {\n    border-color: lighten($swal2-info, 20) !important;\n    color: $swal2-info !important;\n  }\n\n  &.swal2-question {\n    border-color: lighten($swal2-question, 20) !important;\n    color: $swal2-question !important;\n  }\n\n  &.swal2-success {\n    border-color: $swal2-success !important;\n    color: $swal2-success !important;\n\n    [class^='swal2-success-circular-line'] {\n      // Emulate moving circular line\n      position: absolute;\n      width: 3.75em;\n      height: 7.5em;\n      transform: rotate(45deg);\n      border-radius: 50%;\n\n      &[class$='left'] {\n        top: -.4375em;\n        left: -2.0635em;\n        transform: rotate(-45deg);\n        transform-origin: 3.75em 3.75em;\n        border-radius: 7.5em 0 0 7.5em;\n      }\n\n      &[class$='right'] {\n        top: -.6875em;\n        left: 1.875em;\n        transform: rotate(-45deg);\n        transform-origin: 0 3.75em;\n        border-radius: 0 7.5em 7.5em 0;\n      }\n    }\n\n    .swal2-success-ring {\n      // Ring\n      position: absolute;\n      z-index: 2;\n      top: -.25em;\n        left: -.25em;\n      box-sizing: content-box;\n      width: 100%;\n      height: 100%;\n      border: .25em solid $swal2-success-border !important;\n      border-radius: 50%;\n    }\n\n    .swal2-success-fix {\n      // Hide corners left from animation\n      position: absolute;\n      z-index: 1;\n      top: .5em;\n        left: 1.625em;\n      width: .4375em;\n      height: 5.625em;\n      transform: rotate(-45deg);\n    }\n\n    [class^='swal2-success-line'] {\n      display: block;\n      position: absolute;\n      z-index: 2;\n      height: .3125em;\n      border-radius: .125em;\n      background-color: $swal2-success !important;\n\n      &[class$='tip'] {\n        top: 2.875em;\n          left: .875em;\n        width: 1.5625em;\n        transform: rotate(45deg);\n      }\n\n      &[class$='long'] {\n        top: 2.375em;\n          right: .5em;\n        width: 2.9375em;\n        transform: rotate(-45deg);\n      }\n    }\n\n    // Success icon animation\n    &.swal2-icon-show {\n      @if $swal2-icon-animations {\n        .swal2-success-line-tip {\n          animation: swal2-animate-success-line-tip .75s;\n        }\n\n        .swal2-success-line-long {\n          animation: swal2-animate-success-line-long .75s;\n        }\n\n        .swal2-success-circular-line-right {\n          animation: swal2-rotate-success-circular-line 4.25s ease-in;\n        }\n      }\n    }\n  }\n}\n\n","@import '../variables';\n\n// Microsoft Edge\n@supports (-ms-accelerator: true) {\n  .swal2-range {\n    input {\n      width: 100% !important;\n    }\n\n    output {\n      display: none;\n    }\n  }\n}\n\n// IE11\n@media all and (-ms-high-contrast: none),\n  (-ms-high-contrast: active) {\n  .swal2-range {\n    input {\n      width: 100% !important;\n    }\n\n    output {\n      display: none;\n    }\n  }\n}\n\n// Firefox\n@-moz-document url-prefix() {\n  .swal2-close {\n    &:focus {\n      outline: 2px solid $swal2-outline-color;\n    }\n  }\n}\n","// Animations\n@keyframes swal2-toast-show {\n  0% {\n    transform: translateY(-.625em) rotateZ(2deg) !important;\n  }\n\n  33% {\n    transform: translateY(0) rotateZ(-2deg) !important;\n  }\n\n  66% {\n    transform: translateY(.3125em) rotateZ(2deg) !important;\n  }\n\n  100% {\n    transform: translateY(0) rotateZ(0deg) !important;\n  }\n}\n\n@keyframes swal2-toast-hide {\n  100% {\n    transform: rotateZ(1deg) !important;\n    opacity: 0 !important;\n  }\n}\n\n@keyframes swal2-toast-animate-success-line-tip {\n  0% {\n    top: .5625em !important;\n    @if($rtl==false){\n      left: .0625em !important;\n    }\n    @if($rtl==true){\n      right: .0625em;\n    }\n    width: 0 !important;\n  }\n\n  54% {\n    top: .125em !important;\n    @if($rtl==false){\n      left: .125em !important;\n    }\n    @if($rtl==true){\n      right: .125em !important;\n    }\n    width: 0 !important;\n  }\n\n  70% {\n    top: .625em;\n    @if($rtl==false){\n      left: -.25em !important;\n    }\n    @if($rtl==true){\n      right: -.25em !important;\n    }\n    width: 1.625em !important; \n  }\n\n  84% {\n    top: 1.0625em !important;\n    @if($rtl==false){\n      left: .75em !important;\n    }\n    @if($rtl==true){\n      right: .75em !important;\n    }\n    width: .5em !important;\n  }\n\n  100% {\n    top: 1.125em !important;\n    @if($rtl==false){\n      left: .1875em !important;\n    }\n    @if($rtl==true){\n      right: .1875em;\n    }\n    width: .75em !important;\n  }\n}\n\n@keyframes swal2-toast-animate-success-line-long {\n  0% {\n    top: 1.625em !important;\n    @if($rtl==false){\n      right: 1.375em !important;\n    }\n    @if($rtl==true){\n      left: 1.375em;\n    }\n    width: 0;\n  }\n\n  65% {\n    top: 1.25em !important;\n    @if($rtl==false){\n      right: .9375em !important;\n    }\n    @if($rtl==true){\n      left: .9375em;\n    }\n    width: 0;\n  }\n\n  84% {\n    top: .9375em !important;\n    @if($rtl==false){\n      right: 0;\n    }\n    @if($rtl==true){\n      left: 0;\n    }\n    width: 1.125em !important;\n  }\n\n  100% {\n    top: .9375em !important;\n    @if($rtl==false){\n      right: .1875em !important;\n    }\n    @if($rtl==true){\n      left: .1875em;\n    }\n    width: 1.375em !important;\n  }\n}\n","@import 'toasts-animations';\n\n// Appearance animation\n@keyframes swal2-show {\n  0% {\n    opacity: 0 !important;\n    transform: translate(0, 20px) !important;\n  }\n  40% {\n    opacity: 1 !important;\n  }\n  100% {\n    transform: translate(0, 0) !important;\n  }\n}\n\n// Disppearance animation\n@keyframes swal2-hide {\n  0% {\n    transform: scale(1) !important;\n    opacity: 1 !important;\n  }\n\n  100% {\n    transform: scale(.7) !important;\n    opacity: 0 !important;\n  }\n}\n\n// Success icon animations\n@keyframes swal2-animate-success-line-tip {\n  0% {\n    top: 1.1875em;\n    left: .0625em;\n    width: 0;\n  }\n\n  54% {\n    top: 1.0625em;\n    left: .125em;\n    width: 0;\n  }\n\n  70% {\n    top: 2.1875em;\n    left: -.375em;\n    width: 3.125em;\n  }\n\n  84% {\n    top: 3em;\n    left: 1.3125em;\n    width: 1.0625em;\n  }\n\n  100% {\n    top: 2.8125em;\n    left: .875em;\n    width: 1.5625em;\n  }\n}\n\n@keyframes swal2-animate-success-line-long {\n  0% {\n    top: 3.375em;\n    right: 2.875em;\n    width: 0;\n  }\n\n  65% {\n    top: 3.375em;\n    right: 2.875em;\n    width: 0;\n  }\n\n  84% {\n    top: 2.1875em;\n    right: 0;\n    width: 3.4375em;\n  }\n\n  100% {\n    top: 2.375em;\n    right: .5em;\n    width: 2.9375em;\n  }\n}\n\n@keyframes swal2-rotate-success-circular-line {\n  0% {\n    transform: rotate(-45deg);\n  }\n\n  5% {\n    transform: rotate(-45deg);\n  }\n\n  12% {\n    transform: rotate(-405deg);\n  }\n\n  100% {\n    transform: rotate(-405deg);\n  }\n}\n\n// Error icon animations\n@keyframes swal2-animate-error-x-mark {\n  0% {\n    margin-top: 1.625em;\n    transform: scale(.4);\n    opacity: 0;\n  }\n\n  50% {\n    margin-top: 1.625em;\n    transform: scale(.4);\n    opacity: 0;\n  }\n\n  80% {\n    margin-top: -.375em;\n    transform: scale(1.15);\n  }\n\n  100% {\n    margin-top: 0;\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n@keyframes swal2-animate-error-icon {\n  0% {\n    transform: scale(.8) rotateX(100deg);\n    opacity: 0;\n  }\n\n  100% {\n    transform: scale(.8) rotateX(0deg);\n    opacity: 1;\n  }\n}\n\n@keyframes swal2-rotate-loading {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n","@import 'toasts-body';\n\n@mixin sweetalert2-body() {\n  &.swal2-shown {\n    @include not('.swal2-no-backdrop', '.swal2-toast-shown') {\n      overflow: hidden; // not overflow-y because of Sarari, #1253\n    }\n  }\n\n  &.swal2-height-auto {\n    height: auto !important; // #781 #1107\n  }\n\n  &.swal2-no-backdrop {\n    .swal2-container {\n      top: auto !important;\n      right: auto !important;\n      bottom: auto !important;\n      left: auto !important;\n      max-width: calc(100% - #{$swal2-container-padding} * 2) !important;\n      background-color: transparent !important;\n\n      & > .swal2-modal {\n        box-shadow: 0 0 10px $swal2-backdrop !important;\n      }\n\n      &.swal2-top {\n        top: 0 !important;\n        left: 50% !important;\n        transform: translateX(-50%) !important;\n      }\n\n      &.swal2-top-start,\n      &.swal2-top-left {\n        top: 0 !important;\n        @if($rtl==false){\n          left: 0 !important;\n        }\n        @if($rtl==true){\n          right: 0 !important;\n        }\n      }\n\n      &.swal2-top-end,\n      &.swal2-top-right {\n        top: 0 !important;\n        @if($rtl==false){\n          right: 0 !important;\n        }\n        @if($rtl==true){\n          left: 0 !important;\n        }\n      }\n\n      &.swal2-center {\n        top: 50% !important;\n        left: 50% !important;\n        transform: translate(-50%, -50%) !important;\n      }\n\n      &.swal2-center-start,\n      &.swal2-center-left {\n        top: 50% !important;\n        @if($rtl==false){\n          left: 0 !important;\n        }\n        @if($rtl==true){\n          right: 0 !important;\n        }\n        transform: translateY(-50%);\n      }\n\n      &.swal2-center-end,\n      &.swal2-center-right {\n        top: 50% !important;\n        @if($rtl==false){\n          right: 0 !important;\n        }\n        @if($rtl==true){\n          left: 0 !important;\n        }\n        transform: translateY(-50%) !important;\n      }\n\n      &.swal2-bottom {\n        bottom: 0 !important;\n        left: 50% !important;\n        transform: translateX(-50%) !important;\n      }\n\n      &.swal2-bottom-start,\n      &.swal2-bottom-left {\n        bottom: 0 !important;\n        @if($rtl==false){\n          left: 0 !important;\n        }\n        @if($rtl==true){\n          right: 0;\n        }\n      }\n\n      &.swal2-bottom-end,\n      &.swal2-bottom-right {\n        @if($rtl==false){\n          right: 0 !important;\n        }\n        @if($rtl==true){\n          left: 0;\n        }\n        bottom: 0 !important;\n      }\n    }\n  }\n\n  @media print {\n    &.swal2-shown {\n      @include not('.swal2-no-backdrop', '.swal2-toast-shown') {\n        overflow-y: scroll !important;\n\n        > [aria-hidden='true'] {\n          display: none !important;\n        }\n\n        .swal2-container {\n          position: static !important;\n        }\n      }\n    }\n  }\n}\n","@mixin sweetalert2-toasts-body() {\n  &.swal2-toast-shown {\n    .swal2-container {\n      background-color: transparent;\n\n      &.swal2-top {\n        top: 0;\n        right: auto;\n        bottom: auto;\n        left: 50%;\n        transform: translateX(-50%);\n      }\n\n      &.swal2-top-end,\n      &.swal2-top-right {\n        top: 0;\n        bottom: auto;\n        @if($rtl==false){\n          right: 0;\n          left: auto;\n        }\n        @if($rtl==true){\n          left: 0;\n          right: auto;\n        }\n      }\n\n      &.swal2-top-start,\n      &.swal2-top-left {\n        top: 0;\n        bottom: auto;\n        @if($rtl==false){\n          left: 0;\n          right: auto;\n        }\n        @if($rtl==true){\n          right: 0;\n          left: auto;\n        }\n      }\n\n      &.swal2-center-start,\n      &.swal2-center-left {\n        top: 50%;\n        bottom: auto;\n        @if($rtl==false){\n          right: auto;\n          left: 0;\n        }\n        @if($rtl==true){\n          left: auto;\n          right: 0;\n        }\n        transform: translateY(-50%);\n      }\n\n      &.swal2-center {\n        top: 50%;\n        right: auto;\n        bottom: auto;\n        left: 50%;\n        transform: translate(-50%, -50%);\n      }\n\n      &.swal2-center-end,\n      &.swal2-center-right {\n        top: 50%;\n        bottom: auto;\n        @if($rtl==false){\n          right: 0;\n          left: auto;\n        }\n        @if($rtl==true){\n          left: 0;\n          right: auto;\n        }\n        transform: translateY(-50%);\n      }\n\n      &.swal2-bottom-start,\n      &.swal2-bottom-left {\n        top: auto;\n        bottom: 0;\n        @if($rtl==false){\n          right: auto;\n          left: 0;\n        }\n        @if($rtl==true){\n          left: auto;\n          right: 0;\n        }\n      }\n\n      &.swal2-bottom {\n        top: auto;\n        right: auto;\n        bottom: 0;\n        left: 50%;\n        transform: translateX(-50%);\n      }\n\n      &.swal2-bottom-end,\n      &.swal2-bottom-right {\n        top: auto;\n        bottom: 0;\n        @if($rtl==false){\n          right: 0;\n          left: auto;\n        }\n        @if($rtl==true){\n          left: 0;\n          right: auto;\n        }\n      }\n    }\n  }\n\n  &.swal2-toast-column {\n    .swal2-toast {\n      flex-direction: column;\n      align-items: stretch;\n\n      .swal2-actions {\n        flex: 1;\n        align-self: stretch;\n        height: 2.2em;\n        margin-top: .3125em;\n      }\n\n      .swal2-loading {\n        justify-content: center;\n      }\n\n      .swal2-input {\n        height: 2em;\n        margin: .3125em auto;\n        font-size: $swal2-toast-input-font-size;\n      }\n\n      .swal2-validation-message {\n        font-size: $swal2-toast-validation-font-size;\n      }\n    }\n  }\n}\n","@use 'sass:math';\n.tagify{\n    // SCSS \"default\" allows overriding variables BEFORE they are set in the below lines of code\n    $self: &;\n    $tags-border-color       : $border-light !default;\n    $tags-hover-border-color : $border-color !default;\n    $tags-focus-border-color : $accent-color !default;\n    $tagMargin               : 5px !default;\n    $tag-pad                 : 0.25rem 0.5rem .25rem .675rem !default;\n    $tag-text-color          : $base-text !default;\n    $tag-text-color--edit    : $base-text !default;\n    $tag-bg                  : $white !default;\n    $tag-hover               : $lighter !default;\n    $tag-remove              : mix($base-color,$white, 70%) !default;\n    $tag-remove-btn-bg       : none !default;\n    $tag-remove-btn-bg--hover: darken($tag-remove, 8) !default;\n    $tag-invalid-color       : $tag-remove !default;\n    $tag-invalid-bg          : rgba($tag-remove, .5) !default;\n    $tag-inset-shadow-size   : 1.1em !default;\n    $placeholder-color       : $tag-text-color !default;\n\n    @mixin placeholder( $show:true, $opacity:.7 ){\n        transition:.2s ease-out;\n        @if $show == true {\n            opacity:$opacity; transform:none;\n        }\n        @else {\n            opacity:0; transform:translatex(6px);\n        }\n    }\n\n    @mixin tagReadonlyBG{\n        background: linear-gradient(45deg, $tag-bg 25%, transparent 25%, transparent 50%, $tag-bg 50%, $tag-bg 75%, transparent 75%, transparent) 0/5px 5px;\n        box-shadow: none;\n        filter: brightness(.95);\n    }\n\n    @keyframes tags--bump{\n        30% { transform: scale(1.2); }\n    }\n\n    @keyframes rotateLoader {\n        to{ transform: rotate(1turn) }\n    }\n\n    display       : flex;\n    align-items   : flex-start;\n    flex-wrap     : wrap;\n    border        : 1px solid $tags-border-color;\n    padding       : 3px;\n    line-height   : 1.1;\n    cursor        : text;\n    outline       : none;\n    position      : relative;\n    transition    : .1s;\n    font-size     : 14px;\n\n    @media (max-width:576px) {\n        padding: 4px;\n        font-size: 12px;\n    }\n\n    &:hover{ border-color:$tags-hover-border-color; }\n    &.tagify--focus{\n      transition:0s;\n      border-color: $tags-focus-border-color;\n    }\n\n    // Global \"read-only\" mode (no input button)\n    &[readonly]{\n        cursor: default;\n        > #{ $self }__input{\n            visibility: hidden;\n            width: 0;\n            margin: $tagMargin 0;\n        }\n        #{ $self }__tag__removeBtn{ display:none; }\n        #{ $self }__tag > div{\n            padding: $tag-pad;\n            &::before{\n                @include tagReadonlyBG;\n            }\n        }\n    }\n\n    &--loading{\n        #{ $self }__input{\n            &::before{ content:none; }\n            &::after{\n                content: '';\n                vertical-align: middle;\n                margin: -2px 0 -2px .5em;\n                opacity: 1;\n                width: .7em;\n                height: .7em;\n                border: 3px solid;\n                border-color: #EEE #BBB #888 transparent;\n                border-radius: 50%;\n                animation: rotateLoader .4s infinite linear;\n            }\n            &:empty{\n                &::after{\n                    margin-left:0;\n                }\n            }\n        }\n    }\n\n    ///////////////////////////////////////////\n    // Hides originals\n    + input,\n    + textarea{ display:none !important; }\n\n    &__tag{\n        display    : inline-flex;\n        align-items: center;\n        margin     : 2px;\n        position   : relative;\n        z-index    : 1;\n        outline    : none;\n        cursor     : default;\n        transition : .13s ease-out;\n\n        > div{  // :not([contenteditable])\n            vertical-align : top;\n            box-sizing     : border-box;\n            max-width      : 100%;\n            padding        : $tag-pad;\n            color          : $tag-text-color;\n            line-height    : inherit;\n            border-radius  : 15px;\n            user-select    : none;\n            transition     : .13s ease-out;\n\n            > *{\n                white-space    : nowrap;\n                overflow       : hidden;\n                text-overflow  : ellipsis;\n                display        : inline-block;\n                vertical-align : top;\n                min-width      : var(--tag--min-width);\n                max-width      : var(--tag--max-width);\n                transition     : .8s ease, .1s color;\n\n\n                &[contenteditable]{\n                    outline: none;\n                    user-select: text;\n                    cursor: text;\n                    // fix: sometimes the caret after the last character wasn't visible (when setting {backspace:\"edit\"})\n                    margin: -2px;\n                    padding: 2px;\n                    max-width: 350px;\n                }\n            }\n\n            &::before{\n                content: '';\n                position: absolute;\n                border-radius: inherit;\n                left:0; top:0; right:0; bottom:0;\n                z-index: -1;\n                pointer-events:none;\n                transition: 120ms ease;\n                // animation : tags--bump .3s ease-out 1;\n                box-shadow: 0 0 0 $tag-inset-shadow-size $tag-bg inset;\n                border:1px solid $border-light;\n            }\n        }\n\n        &:hover:not([readonly]){\n            div{ \n                &::before{\n                    $size: math.div(-$tagMargin,2);\n                    $size: 0;\n                    top:$size; \n                    right:$size; \n                    bottom:$size; \n                    left:$size;\n                    box-shadow: 0 0 0 $tag-inset-shadow-size $tag-hover inset;\n                }\n            }\n        }\n\n        &#{ $self }{\n            &--noAnim{\n              > div::before{\n                animation:none;\n              }\n            }\n\n            &--hide{\n                width          : 0 !important;\n                padding-left   : 0;\n                padding-right  : 0;\n                margin-left    : 0;\n                margin-right   : 0;\n                opacity        : 0;\n                transform      : scale(0);\n                transition     : .3s;\n                pointer-events : none;\n            }\n\n            &--mark{\n                div::before{ animation:none; }\n            }\n\n            &--notAllowed:not(.tagify__tag--editable){\n                div{\n                    > span{ opacity:.5; } // filter:blur(.2px);\n                    &::before{\n                        box-shadow: 0 0 0 $tag-inset-shadow-size $tag-invalid-bg inset !important;\n                        transition: .2s;\n                    }\n                }\n            }\n        }\n\n        &[readonly]{\n            #{ $self }__tag__removeBtn{ display:none; }\n            > div{// padding: $tag-pad;\n                &::before{\n                    @include tagReadonlyBG;\n                    border-color   : $tag-remove-btn-bg;\n                }\n            }\n        }\n\n        &--editable{\n            > div{\n                color : $tag-text-color--edit;\n                &::before{\n                    box-shadow: 0 0 0 2px $tag-hover inset !important;\n                }\n            }\n\n            &.tagify--invalid{\n                > div{\n                    &::before{\n                        box-shadow: 0 0 0 2px $tag-invalid-color inset !important;\n                    }\n                }\n            }\n        }\n    }\n\n    &__tag__removeBtn{\n        $size: 14px;\n\n        order          : 5;\n        display        : inline-flex;\n        align-items    : center;\n        justify-content: center;\n        border-radius  : 50px;\n        cursor         : pointer;\n        font           : #{$size} Serif;\n        background     : $tag-remove-btn-bg;\n        color          : $base-color;\n\n        width          : $size;\n        height         : $size;\n        margin-right   : math.div($size,3);\n        margin-left    : math.div(-$size,3);\n\n        transition     : .2s ease-out;\n\n        &::after{\n            position: relative;\n            content: \"\\00D7\";\n            top:1px;\n        }\n\n        &:hover{\n            color:white;\n            background:$tag-remove-btn-bg--hover;\n            + div{\n                // > span{ opacity:.5; }\n                &::before{\n                    // box-shadow: 0 0 0 $tag-inset-shadow-size rgba($tag-remove, .3) inset !important;\n                    transition:.2s;\n                }\n            }\n        }\n    }\n\n\n    &:not(#{$self}--mix){\n        #{ $self }__input{\n            br { display:none; }\n            * { display:inline; white-space:nowrap; }\n        }\n    }\n\n    ///////////////////////////////////////////\n    // Holds the placeholder & the tags input\n    &__input{\n        $placeholder-width : 60px;\n        @mixin placeholder-show{ opacity:.5; transform:none; };\n        display: block;\n        min-width: $placeholder-width;\n        margin: 2px;\n        padding: $tag-pad;\n        line-height: inherit;\n        position: relative;\n        white-space: pre-line; // #160 Line break (\\n) as delimeter\n\n        &::before{ display:inline-block; width:0; }\n\n        &:empty{\n          display: flex; // https://bugzilla.mozilla.org/show_bug.cgi?id=904846#c45\n          &::before{ @include placeholder; width:auto; }\n        }\n\n        &:focus{ outline:none;\n            &::before{ @include placeholder(false);\n                @supports ( -moz-appearance:none ){\n                    display:none;\n                }\n            }\n            &:empty::before{ @include placeholder(true, .5);\n                @supports ( -moz-appearance:none ){\n                    display:inline-block;\n                }\n            }\n        }\n       // &:empty:focus{ padding:$tag-pad; }\n\n        &::before{\n            content: attr(data-placeholder);\n            line-height: 1.8;\n            position: absolute;\n            top: 0;\n            z-index: 1;\n            color: $placeholder-color;\n            white-space: nowrap;\n            pointer-events: none;\n            opacity: 0;\n\n            #{ $self }--mix &{\n              position: static;\n              line-height: inherit;\n            }\n        }\n\n        @supports ( -moz-appearance:none ){\n            &::before{\n                line-height: inherit;\n                position:relative;\n            }\n        }\n\n        // tries to suggest the rest of the value from the first item in the whitelist which matches it\n        &::after{\n            content: attr(data-suggest);\n            display: inline-block;\n            white-space: pre; /* allows spaces at the beginning */\n            color: $tag-text-color;\n            opacity: .3;\n            pointer-events:none;\n            max-width: 100px;\n        }\n\n        // &--invalid{\n        //     // color: $invalid-input-color;\n        // }\n\n        /*\n            in \"mix mode\" the tags are inside the \"input\" element\n        */\n        #{ $self }__tag{\n            margin: 0;  // a developer can choose to have automatic horizontal margin (\"1ch\" advised) between tags or use manual keyboard spaces\n            // line-height: 1.1;\n\n            > div{\n                padding-top:0; padding-bottom:0;\n            }\n        }\n    }\n\n    &--mix {\n        line-height: 1.7;\n\n        #{ $self }__input{\n            padding: $tagMargin;\n            margin: 0;\n            width: 100%;\n            height: 100%;\n            line-height: inherit;\n\n            // no suggested-complete are shown in mix-mode while higilighting dropdown options\n            &::after{ content:none; }\n        }\n    }\n\n    &--select{\n        &::after{\n            $size: 16px;\n            content: '>';\n            opacity: .5;\n            position: absolute;\n            top: 50%;\n            right: 0;\n            bottom: 0;\n            font: $size monospace;\n            line-height: math.div($size,2);\n            height: math.div($size,2);\n            pointer-events: none;\n            transform: translate(-150%, -50%) scaleX(1.2) rotate(90deg);\n            transition: .2s ease-in-out;\n        }\n\n        &[aria-expanded=true]{\n            &::after{\n                transform: translate(-150%, -50%) rotate(270deg) scaleY(1.2);\n            }\n        }\n\n        #{$self}__tag{\n            position: absolute;\n            top: 0;\n            right: 1.8em;\n            bottom: 0;\n            div{\n                display: none;\n            }\n        }\n\n        #{$self}__input{\n            width: 100%;\n        }\n    }\n\n    &--invalid{\n        border-color : $tag-invalid-color;\n    }\n\n    // Since the dropdown is an external element, which is positioned directly on the body element\n    // it cannot ingerit the CSS variables applied on the \".Tagify\" element\n    &__dropdown{\n        $dropdown: &;\n        $trans: .25s cubic-bezier(0,1,.5,1);\n        position: absolute;\n        z-index: 9999;\n        transform: translateY(4px);\n        overflow: hidden;\n        box-shadow: 0 1px 4px rgba($base-color, .1);\n        border-radius: $border-radius;\n\n        &[placement=\"top\"]{\n            margin-top: 0;\n            transform: translateY(-4px);\n            box-shadow: 0 -1px 4px rgba($base-color, .1);\n            // #{$dropdown}__wrapper{\n            //     border-top-width: 1px;\n            //     border-bottom-width: 0;\n            // }\n        }\n\n        // when the dropdown shows next to the caret while typing\n        &--text{\n            box-shadow: 0 0 0 3px rgba($tags-focus-border-color, .1);\n            font-size: .9em;\n            #{$dropdown}__wrapper{\n                border-width: 1px;\n            }\n        }\n\n        &__wrapper{\n            max-height: 300px;\n            overflow: hidden;\n            background: white;\n            border: 1px solid $border-light;\n            padding: .25rem;\n            border-radius: $border-radius;\n            transition: $trans;\n            &:hover{\n                overflow: auto;\n            }\n        }\n\n        &--initial{\n            #{$dropdown}__wrapper{\n                max-height: 20px;\n                transform: translateY(-1em);\n            }\n\n            &[placement=\"top\"]{\n                #{$dropdown}__wrapper{\n                    transform: translateY(2em);\n                }\n            }\n        }\n\n        &__item{\n            box-sizing: inherit;\n            padding: $tag-pad;\n            margin: 1px;\n            cursor: pointer;\n            border-radius: 2px;\n            position: relative;\n            outline: none;\n\n            &--active{\n                background: $tags-focus-border-color;\n                color: white;\n            }\n            &:active{\n                filter: brightness(105%);\n            }\n        }\n\n        &__createTagBtn{\n          width: 100%;\n          background: $tags-focus-border-color;\n          color: white;\n          border: none;\n        }\n    }\n}\n\n// React Tagify\n.tags-input{\n    width: 100%;\n}\n","// Quill Editor v1.3.7\n\n.ql-container {\n    box-sizing: border-box;\n    font-size: 13px;\n    height: 100%;\n    margin: 0px;\n    position: relative;\n    min-height: 160px;\n  }\n  .ql-container.ql-disabled .ql-tooltip {\n    visibility: hidden;\n  }\n  .ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {\n    pointer-events: none;\n  }\n  .ql-clipboard {\n    left: -100000px;\n    height: 1px;\n    overflow-y: hidden;\n    position: absolute;\n    top: 50%;\n  }\n  .ql-clipboard p {\n    margin: 0;\n    padding: 0;\n  }\n  .ql-editor {\n    box-sizing: border-box;\n    line-height: 1.42;\n    height: 100%;\n    outline: none;\n    overflow-y: auto;\n    padding: 12px 15px;\n    tab-size: 4;\n    -moz-tab-size: 4;\n    @if($rtl==false){\n      text-align: left;\n    }\n    @if($rtl==true){\n      text-align: right;\n    }\n    white-space: pre-wrap;\n    word-wrap: break-word;\n  }\n  .ql-editor > * {\n    cursor: text;\n  }\n  .ql-editor p,\n  .ql-editor ol,\n  .ql-editor ul,\n  .ql-editor pre,\n  .ql-editor blockquote,\n  .ql-editor h1,\n  .ql-editor h2,\n  .ql-editor h3,\n  .ql-editor h4,\n  .ql-editor h5,\n  .ql-editor h6 {\n    margin: 0;\n    padding: 0;\n    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol,\n  .ql-editor ul {\n    @if($rtl==false){\n      padding-left: 1.5em;\n    }\n    @if($rtl==true){\n      padding-right: 1.5em;\n    }\n  }\n  .ql-editor ol > li,\n  .ql-editor ul > li {\n    list-style-type: none;\n  }\n  .ql-editor ul > li::before {\n    content: '\\2022';\n  }\n  .ql-editor ul[data-checked=true],\n  .ql-editor ul[data-checked=false] {\n    pointer-events: none;\n  }\n  .ql-editor ul[data-checked=true] > li *,\n  .ql-editor ul[data-checked=false] > li * {\n    pointer-events: all;\n  }\n  .ql-editor ul[data-checked=true] > li::before,\n  .ql-editor ul[data-checked=false] > li::before {\n    color: #777;\n    cursor: pointer;\n    pointer-events: all;\n  }\n  .ql-editor ul[data-checked=true] > li::before {\n    content: '\\2611';\n  }\n  .ql-editor ul[data-checked=false] > li::before {\n    content: '\\2610';\n  }\n  .ql-editor li::before {\n    display: inline-block;\n    white-space: nowrap;\n    width: 1.2em;\n  }\n  .ql-editor li:not(.ql-direction-rtl)::before {\n    @if($rtl==false){\n      margin-left: -1.5em;\n      margin-right: 0.3em;\n      text-align: right;\n    }\n    @if($rtl==true){\n      margin-right: -1.5em;\n      margin-left: 0.3em;\n      text-align: left;\n    }\n  }\n  .ql-editor li.ql-direction-rtl::before {\n    @if($rtl==false){\n      margin-left: 0.3em;\n      margin-right: -1.5em;\n    }\n    @if($rtl==true){\n      margin-right: 0.3em;\n      margin-left: -1.5em;\n    }\n  }\n  .ql-editor ol li:not(.ql-direction-rtl),\n  .ql-editor ul li:not(.ql-direction-rtl) {\n    @if($rtl==false){\n      padding-left: 1.5em;\n    }\n    @if($rtl==true){\n      padding-right: 1.5em;\n    }\n  }\n  .ql-editor ol li.ql-direction-rtl,\n  .ql-editor ul li.ql-direction-rtl {\n    @if($rtl==false){\n      padding-right: 1.5em;\n    }\n    @if($rtl==true){\n      padding-left: 1.5em;\n    }\n  }\n  .ql-editor ol li {\n    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n    counter-increment: list-0;\n  }\n  .ql-editor ol li:before {\n    content: counter(list-0, decimal) '. ';\n  }\n  .ql-editor ol li.ql-indent-1 {\n    counter-increment: list-1;\n  }\n  .ql-editor ol li.ql-indent-1:before {\n    content: counter(list-1, lower-alpha) '. ';\n  }\n  .ql-editor ol li.ql-indent-1 {\n    counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-2 {\n    counter-increment: list-2;\n  }\n  .ql-editor ol li.ql-indent-2:before {\n    content: counter(list-2, lower-roman) '. ';\n  }\n  .ql-editor ol li.ql-indent-2 {\n    counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-3 {\n    counter-increment: list-3;\n  }\n  .ql-editor ol li.ql-indent-3:before {\n    content: counter(list-3, decimal) '. ';\n  }\n  .ql-editor ol li.ql-indent-3 {\n    counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-4 {\n    counter-increment: list-4;\n  }\n  .ql-editor ol li.ql-indent-4:before {\n    content: counter(list-4, lower-alpha) '. ';\n  }\n  .ql-editor ol li.ql-indent-4 {\n    counter-reset: list-5 list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-5 {\n    counter-increment: list-5;\n  }\n  .ql-editor ol li.ql-indent-5:before {\n    content: counter(list-5, lower-roman) '. ';\n  }\n  .ql-editor ol li.ql-indent-5 {\n    counter-reset: list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-6 {\n    counter-increment: list-6;\n  }\n  .ql-editor ol li.ql-indent-6:before {\n    content: counter(list-6, decimal) '. ';\n  }\n  .ql-editor ol li.ql-indent-6 {\n    counter-reset: list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-7 {\n    counter-increment: list-7;\n  }\n  .ql-editor ol li.ql-indent-7:before {\n    content: counter(list-7, lower-alpha) '. ';\n  }\n  .ql-editor ol li.ql-indent-7 {\n    counter-reset: list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-8 {\n    counter-increment: list-8;\n  }\n  .ql-editor ol li.ql-indent-8:before {\n    content: counter(list-8, lower-roman) '. ';\n  }\n  .ql-editor ol li.ql-indent-8 {\n    counter-reset: list-9;\n  }\n  .ql-editor ol li.ql-indent-9 {\n    counter-increment: list-9;\n  }\n  .ql-editor ol li.ql-indent-9:before {\n    content: counter(list-9, decimal) '. ';\n  }\n  .ql-editor .ql-indent-1:not(.ql-direction-rtl) {\n    padding-left: 3em;\n  }\n  .ql-editor li.ql-indent-1:not(.ql-direction-rtl) {\n    padding-left: 4.5em;\n  }\n  .ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {\n    padding-right: 3em;\n  }\n  .ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {\n    padding-right: 4.5em;\n  }\n  .ql-editor .ql-indent-2:not(.ql-direction-rtl) {\n    padding-left: 6em;\n  }\n  .ql-editor li.ql-indent-2:not(.ql-direction-rtl) {\n    padding-left: 7.5em;\n  }\n  .ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {\n    padding-right: 6em;\n  }\n  .ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {\n    padding-right: 7.5em;\n  }\n  .ql-editor .ql-indent-3:not(.ql-direction-rtl) {\n    padding-left: 9em;\n  }\n  .ql-editor li.ql-indent-3:not(.ql-direction-rtl) {\n    padding-left: 10.5em;\n  }\n  .ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {\n    padding-right: 9em;\n  }\n  .ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {\n    padding-right: 10.5em;\n  }\n  .ql-editor .ql-indent-4:not(.ql-direction-rtl) {\n    padding-left: 12em;\n  }\n  .ql-editor li.ql-indent-4:not(.ql-direction-rtl) {\n    padding-left: 13.5em;\n  }\n  .ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {\n    padding-right: 12em;\n  }\n  .ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {\n    padding-right: 13.5em;\n  }\n  .ql-editor .ql-indent-5:not(.ql-direction-rtl) {\n    padding-left: 15em;\n  }\n  .ql-editor li.ql-indent-5:not(.ql-direction-rtl) {\n    padding-left: 16.5em;\n  }\n  .ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {\n    padding-right: 15em;\n  }\n  .ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {\n    padding-right: 16.5em;\n  }\n  .ql-editor .ql-indent-6:not(.ql-direction-rtl) {\n    padding-left: 18em;\n  }\n  .ql-editor li.ql-indent-6:not(.ql-direction-rtl) {\n    padding-left: 19.5em;\n  }\n  .ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {\n    padding-right: 18em;\n  }\n  .ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {\n    padding-right: 19.5em;\n  }\n  .ql-editor .ql-indent-7:not(.ql-direction-rtl) {\n    padding-left: 21em;\n  }\n  .ql-editor li.ql-indent-7:not(.ql-direction-rtl) {\n    padding-left: 22.5em;\n  }\n  .ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {\n    padding-right: 21em;\n  }\n  .ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {\n    padding-right: 22.5em;\n  }\n  .ql-editor .ql-indent-8:not(.ql-direction-rtl) {\n    padding-left: 24em;\n  }\n  .ql-editor li.ql-indent-8:not(.ql-direction-rtl) {\n    padding-left: 25.5em;\n  }\n  .ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {\n    padding-right: 24em;\n  }\n  .ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {\n    padding-right: 25.5em;\n  }\n  .ql-editor .ql-indent-9:not(.ql-direction-rtl) {\n    padding-left: 27em;\n  }\n  .ql-editor li.ql-indent-9:not(.ql-direction-rtl) {\n    padding-left: 28.5em;\n  }\n  .ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {\n    padding-right: 27em;\n  }\n  .ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {\n    padding-right: 28.5em;\n  }\n  .ql-editor .ql-video {\n    display: block;\n    max-width: 100%;\n  }\n  .ql-editor .ql-video.ql-align-center {\n    margin: 0 auto;\n  }\n  .ql-editor .ql-video.ql-align-right {\n    @if($rtl==false){\n      margin: 0 0 0 auto;\n    }\n    @if($rtl==true){\n      margin: 0 auto 0 0;\n    }\n  }\n  .ql-editor .ql-bg-black {\n    background-color: #000;\n  }\n  .ql-editor .ql-bg-red {\n    background-color: #e60000;\n  }\n  .ql-editor .ql-bg-orange {\n    background-color: #f90;\n  }\n  .ql-editor .ql-bg-yellow {\n    background-color: #ff0;\n  }\n  .ql-editor .ql-bg-green {\n    background-color: #008a00;\n  }\n  .ql-editor .ql-bg-blue {\n    background-color: #06c;\n  }\n  .ql-editor .ql-bg-purple {\n    background-color: #93f;\n  }\n  .ql-editor .ql-color-white {\n    color: #fff;\n  }\n  .ql-editor .ql-color-red {\n    color: #e60000;\n  }\n  .ql-editor .ql-color-orange {\n    color: #f90;\n  }\n  .ql-editor .ql-color-yellow {\n    color: #ff0;\n  }\n  .ql-editor .ql-color-green {\n    color: #008a00;\n  }\n  .ql-editor .ql-color-blue {\n    color: #06c;\n  }\n  .ql-editor .ql-color-purple {\n    color: #93f;\n  }\n  .ql-editor .ql-font-serif {\n    font-family: Georgia, Times New Roman, serif;\n  }\n  .ql-editor .ql-font-monospace {\n    font-family: Monaco, Courier New, monospace;\n  }\n  .ql-editor .ql-size-small {\n    font-size: 0.75em;\n  }\n  .ql-editor .ql-size-large {\n    font-size: 1.5em;\n  }\n  .ql-editor .ql-size-huge {\n    font-size: 2.5em;\n  }\n  .ql-editor .ql-direction-rtl {\n    direction: rtl;\n    text-align: inherit;\n  }\n  .ql-editor .ql-align-center {\n    text-align: center;\n  }\n  .ql-editor .ql-align-justify {\n    text-align: justify;\n  }\n  .ql-editor .ql-align-right {\n    text-align: right;\n  }\n  .ql-editor.ql-blank::before {\n    color: rgba(0,0,0,0.6);\n    content: attr(data-placeholder);\n    font-style: italic;\n    left: 15px;\n    pointer-events: none;\n    position: absolute;\n    right: 15px;\n  }\n  .ql-toolbar:after{\n    clear: both;\n    content: '';\n    display: table;\n  }\n  .ql-toolbar button {\n    background: none;\n    border: none;\n    cursor: pointer;\n    display: inline-block;\n    @if($rtl==false){\n      float: left;\n    }\n    @if($rtl==true){\n      float: right;\n    }\n    height: 24px;\n    padding: 3px 5px;\n    width: 28px;\n  }\n  .ql-toolbar button svg {\n    float: left;\n    height: 100%;\n  }\n  .ql-toolbar button:active:hover {\n    outline: none;\n  }\n  .ql-toolbar input.ql-image[type=file] {\n    display: none;\n  }\n  .ql-toolbar button:hover,\n  .ql-toolbar button:focus,\n  .ql-toolbar button.ql-active,\n  .ql-toolbar .ql-picker-label:hover,\n  .ql-toolbar .ql-picker-label.ql-active,\n  .ql-toolbar .ql-picker-item:hover,\n  .ql-toolbar .ql-picker-item.ql-selected {\n    color: $accent-color;\n  }\n  .ql-toolbar button:hover .ql-fill,\n  .ql-toolbar button:focus .ql-fill,\n  .ql-toolbar button.ql-active .ql-fill,\n  .ql-toolbar .ql-picker-label:hover .ql-fill,\n  .ql-toolbar .ql-picker-label.ql-active .ql-fill,\n  .ql-toolbar .ql-picker-item:hover .ql-fill,\n  .ql-toolbar .ql-picker-item.ql-selected .ql-fill,\n  .ql-toolbar button:hover .ql-stroke.ql-fill,\n  .ql-toolbar button:focus .ql-stroke.ql-fill,\n  .ql-toolbar button.ql-active .ql-stroke.ql-fill,\n  .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,\n  .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,\n  .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,\n  .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {\n    fill: $accent-color;\n  }\n  .ql-toolbar button:hover .ql-stroke,\n  .ql-toolbar button:focus .ql-stroke,\n  .ql-toolbar button.ql-active .ql-stroke,\n  .ql-toolbar .ql-picker-label:hover .ql-stroke,\n  .ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n  .ql-toolbar .ql-picker-item:hover .ql-stroke,\n  .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,\n  .ql-toolbar button:hover .ql-stroke-miter,\n  .ql-toolbar button:focus .ql-stroke-miter,\n  .ql-toolbar button.ql-active .ql-stroke-miter,\n  .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,\n  .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,\n  .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,\n  .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {\n    stroke: $accent-color;\n  }\n  @media (pointer: coarse) {\n    .ql-toolbar button:hover:not(.ql-active) {\n      color: $base-text;\n    }\n    .ql-toolbar button:hover:not(.ql-active) .ql-fill,\n    .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {\n      fill: $base-text;\n    }\n    .ql-toolbar button:hover:not(.ql-active) .ql-stroke,\n    .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {\n      stroke: $base-text;\n    }\n  }\n  \n  .ql-hidden {\n    display: none;\n  }\n  .ql-out-bottom,\n  .ql-out-top {\n    visibility: hidden;\n  }\n  .ql-tooltip {\n    position: absolute;\n    transform: translateY(10px);\n  }\n  .ql-tooltip a {\n    cursor: pointer;\n    text-decoration: none;\n  }\n  .ql-tooltip.ql-flip {\n    transform: translateY(-10px);\n  }\n  .ql-formats {\n    display: inline-block;\n    vertical-align: middle;\n  }\n  .ql-formats:after {\n    clear: both;\n    content: '';\n    display: table;\n  }\n  .ql-stroke {\n    fill: none;\n    stroke: $base-text;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    stroke-width: 2;\n  }\n  .ql-stroke-miter {\n    fill: none;\n    stroke: $base-text;\n    stroke-miterlimit: 10;\n    stroke-width: 2;\n  }\n  .ql-fill,\n  .ql-stroke.ql-fill {\n    fill: $base-text;\n  }\n  .ql-empty {\n    fill: none;\n  }\n  .ql-even {\n    fill-rule: evenodd;\n  }\n  .ql-thin,\n  .ql-stroke.ql-thin {\n    stroke-width: 1;\n  }\n  .ql-transparent {\n    opacity: 0.4;\n  }\n  .ql-direction svg:last-child {\n    display: none;\n  }\n  .ql-direction.ql-active svg:last-child {\n    display: inline;\n  }\n  .ql-direction.ql-active svg:first-child {\n    display: none;\n  }\n  .ql-editor h1 {\n    font-size: 2em;\n  }\n  .ql-editor h2 {\n    font-size: 1.5em;\n  }\n  .ql-editor h3 {\n    font-size: 1.17em;\n  }\n  .ql-editor h4 {\n    font-size: 1em;\n  }\n  .ql-editor h5 {\n    font-size: 0.83em;\n  }\n  .ql-editor h6 {\n    font-size: 0.67em;\n  }\n  .ql-editor a {\n    text-decoration: underline;\n  }\n  .ql-editor blockquote {\n    margin-bottom: 5px;\n    margin-top: 5px;\n    @if($rtl==false){\n      border-left: 4px solid $border-color;\n      padding-left: 16px;\n    }\n    @if($rtl==true){\n      border-right: 4px solid $border-color;\n      padding-right: 16px;\n    }\n  }\n  .ql-editor code,\n  .ql-editor pre {\n    background-color: #f0f0f0;\n    border-radius: 3px;\n  }\n  .ql-editor pre {\n    white-space: pre-wrap;\n    margin-bottom: 5px;\n    margin-top: 5px;\n    padding: 5px 10px;\n  }\n  .ql-editor code {\n    font-size: 85%;\n    padding: 2px 4px;\n  }\n  .ql-editor pre.ql-syntax {\n    background-color: #23241f;\n    color: #f8f8f2;\n    overflow: visible;\n  }\n  .ql-editor img {\n    max-width: 100%;\n  }\n  .ql-picker {\n    color: $base-text;\n    display: inline-block;\n    @if($rtl==false){\n      float: left;\n    }\n    @if($rtl==true){\n      float: right;\n    }\n    font-size: 14px;\n    font-weight: 500;\n    height: 24px;\n    position: relative;\n    vertical-align: middle;\n  }\n  .ql-picker-label {\n    cursor: pointer;\n    display: inline-block;\n    height: 100%;\n    @if($rtl==false){\n      padding-left: 8px;\n      padding-right: 2px;\n    }\n    @if($rtl==true){\n      padding-left: 2px;\n      padding-right: 8px;\n    }\n    position: relative;\n    width: 100%;\n    &:focus{\n      box-shadow: none;\n      border: none;\n      outline: none;\n    }\n  }\n  .ql-picker-label::before {\n    display: inline-block;\n    line-height: 22px;\n  }\n  .ql-picker-options {\n    background-color: #fff;\n    display: none;\n    min-width: 100%;\n    padding: 4px 16px;\n    position: absolute;\n    white-space: nowrap;\n    border-radius: $border-radius;\n  }\n  .ql-picker-options .ql-picker-item {\n    cursor: pointer;\n    display: block;\n    padding-bottom: 5px;\n    padding-top: 5px;\n  }\n  .ql-picker.ql-expanded .ql-picker-label {\n    color: $base-dark;\n    z-index: 2;\n  }\n  .ql-picker.ql-expanded .ql-picker-label .ql-fill {\n    fill: $base-light;\n  }\n  .ql-picker.ql-expanded .ql-picker-label .ql-stroke {\n    stroke: $base-light;\n  }\n  .ql-picker.ql-expanded .ql-picker-options {\n    display: block;\n    margin-top: -1px;\n    top: 100%;\n    z-index: 1;\n  }\n  .ql-color-picker,\n  .ql-icon-picker {\n    width: 28px;\n  }\n  .ql-color-picker .ql-picker-label,\n  .ql-icon-picker .ql-picker-label {\n    padding: 2px 4px;\n  }\n  .ql-color-picker .ql-picker-label svg,\n  .ql-icon-picker .ql-picker-label svg {\n    @if($rtl==false){\n      right: 4px;\n    }\n    @if($rtl==true){\n      left: 4px;\n    }\n  }\n  .ql-icon-picker .ql-picker-options {\n    padding: 4px 0px;\n  }\n  .ql-icon-picker .ql-picker-item {\n    height: 24px;\n    width: 24px;\n    padding: 2px 4px;\n  }\n  .ql-color-picker .ql-picker-options {\n    padding: 8px;\n    width: 158px;\n  }\n  .ql-color-picker .ql-picker-item {\n    border: 1px solid transparent;\n    @if($rtl==false){\n      float: left;\n    }\n    @if($rtl==true){\n      float: right;\n    }\n    height: 16px;\n    margin: 2px;\n    padding: 0px;\n    width: 16px;\n  }\n  .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {\n    position: absolute;\n    margin-top: -9px;\n    @if($rtl==false){\n      right: 0;\n    }\n    @if($rtl==true){\n      left: 0;\n    }\n    top: 50%;\n    width: 18px;\n  }\n  .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before,\n  .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before,\n  .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before,\n  .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before,\n  .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before,\n  .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before {\n    content: attr(data-label);\n  }\n  .ql-picker.ql-header {\n    width: 98px;\n  }\n  .ql-picker.ql-header .ql-picker-label::before,\n  .ql-picker.ql-header .ql-picker-item::before {\n    content: 'Normal';\n  }\n  .ql-picker.ql-header .ql-picker-label[data-value=\"1\"]::before,\n  .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before {\n    content: 'Heading 1';\n  }\n  .ql-picker.ql-header .ql-picker-label[data-value=\"2\"]::before,\n  .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before {\n    content: 'Heading 2';\n  }\n  .ql-picker.ql-header .ql-picker-label[data-value=\"3\"]::before,\n  .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before {\n    content: 'Heading 3';\n  }\n  .ql-picker.ql-header .ql-picker-label[data-value=\"4\"]::before,\n  .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before {\n    content: 'Heading 4';\n  }\n  .ql-picker.ql-header .ql-picker-label[data-value=\"5\"]::before,\n  .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before {\n    content: 'Heading 5';\n  }\n  .ql-picker.ql-header .ql-picker-label[data-value=\"6\"]::before,\n  .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before {\n    content: 'Heading 6';\n  }\n  .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before {\n    font-size: 2em;\n  }\n  .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before {\n    font-size: 1.5em;\n  }\n  .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before {\n    font-size: 1.17em;\n  }\n  .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before {\n    font-size: 1em;\n  }\n  .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before {\n    font-size: 0.83em;\n  }\n  .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before {\n    font-size: 0.67em;\n  }\n  .ql-picker.ql-font {\n    width: 108px;\n  }\n  .ql-picker.ql-font .ql-picker-label::before,\n  .ql-picker.ql-font .ql-picker-item::before {\n    content: 'Sans Serif';\n  }\n  .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,\n  .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {\n    content: 'Serif';\n  }\n  .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,\n  .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {\n    content: 'Monospace';\n  }\n  .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {\n    font-family: Georgia, Times New Roman, serif;\n  }\n  .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {\n    font-family: Monaco, Courier New, monospace;\n  }\n  .ql-picker.ql-size {\n    width: 98px;\n  }\n  .ql-picker.ql-size .ql-picker-label::before,\n  .ql-picker.ql-size .ql-picker-item::before {\n    content: 'Normal';\n  }\n  .ql-picker.ql-size .ql-picker-label[data-value=small]::before,\n  .ql-picker.ql-size .ql-picker-item[data-value=small]::before {\n    content: 'Small';\n  }\n  .ql-picker.ql-size .ql-picker-label[data-value=large]::before,\n  .ql-picker.ql-size .ql-picker-item[data-value=large]::before {\n    content: 'Large';\n  }\n  .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,\n  .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {\n    content: 'Huge';\n  }\n  .ql-picker.ql-size .ql-picker-item[data-value=small]::before {\n    font-size: 10px;\n  }\n  .ql-picker.ql-size .ql-picker-item[data-value=large]::before {\n    font-size: 18px;\n  }\n  .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {\n    font-size: 32px;\n  }\n  .ql-color-picker.ql-background .ql-picker-item {\n    background-color: #fff;\n  }\n  .ql-color-picker.ql-color .ql-picker-item {\n    background-color: #000;\n  }\n  .ql-toolbar{\n    border: 1px solid $border-light;\n    border-radius: $border-radius $border-radius 0 0;\n    box-sizing: border-box;\n    padding: 8px;\n    padding-bottom: 0;\n  }\n  .ql-toolbar .ql-formats {\n    @if($rtl==false){\n      margin-right: 15px;\n    }\n    @if($rtl==true){\n      margin-left: 15px;\n    }\n    padding-bottom: 8px;\n  }\n  .ql-toolbar .ql-picker-label {\n    border: 1px solid transparent;\n  }\n  .ql-toolbar .ql-picker-options {\n    border: 1px solid transparent;\n    box-shadow:$box-shadow-sm;\n  }\n  .ql-toolbar .ql-picker.ql-expanded .ql-picker-options {\n    border-color: $border-light;\n  }\n  .ql-toolbar .ql-color-picker .ql-picker-item.ql-selected,\n  .ql-toolbar .ql-color-picker .ql-picker-item:hover {\n    border-color: $border-dark;\n  }\n  .ql-toolbar + .ql-container {\n    border-top: 0px;\n  }\n  .ql-tooltip {\n    background-color: #fff;\n    border: 1px solid $border-light;\n    box-shadow: 0px 0px 5px #ddd;\n    color: $base-text;\n    padding: 5px 12px;\n    white-space: nowrap;\n  }\n  .ql-tooltip::before {\n    content: \"Visit URL:\";\n    line-height: 26px;\n    @if($rtl==false){\n      margin-right: 8px;\n    }\n    @if($rtl==true){\n      margin-left: 8px;\n    }\n  }\n  .ql-tooltip input[type=text] {\n    display: none;\n    border: 1px solid $border-light;\n    font-size: 13px;\n    height: 26px;\n    margin: 0px;\n    padding: 3px 5px;\n    width: 170px;\n  }\n  .ql-tooltip a.ql-preview {\n    display: inline-block;\n    max-width: 200px;\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n    vertical-align: top;\n  }\n  .ql-tooltip a.ql-action::after {\n    content: 'Edit';\n    @if($rtl==false){\n      border-right: 1px solid $border-light;\n      margin-left: 16px;\n      padding-right: 8px;\n    }\n    @if($rtl==true){\n      border-left: 1px solid $border-light;\n      margin-right: 16px;\n      padding-left: 8px;\n    }\n  }\n  .ql-tooltip a.ql-remove::before {\n    content: 'Remove';\n    @if($rtl==false){\n      margin-left: 8px;\n    }\n    @if($rtl==true){\n      margin-right: 8px;\n    }\n  }\n  .ql-tooltip a {\n    line-height: 26px;\n  }\n  .ql-tooltip.ql-editing a.ql-preview,\n  .ql-tooltip.ql-editing a.ql-remove {\n    display: none;\n  }\n  .ql-tooltip.ql-editing input[type=text] {\n    display: inline-block;\n  }\n  .ql-tooltip.ql-editing a.ql-action::after {\n    border-right: 0px;\n    content: 'Save';\n    padding-right: 0px;\n  }\n  .ql-tooltip[data-mode=link]::before {\n    content: \"Enter link:\";\n  }\n  .ql-tooltip[data-mode=formula]::before {\n    content: \"Enter formula:\";\n  }\n  .ql-tooltip[data-mode=video]::before {\n    content: \"Enter video:\";\n  }\n  a {\n    color: $accent-color;\n  }\n  .ql-container{\n    border: 1px solid $border-light;\n    border-radius: 0 0 $border-radius $border-radius;\n  }\n  ","/**\n * Copyright (c) Tiny Technologies, Inc. All rights reserved.\n * Licensed under the LGPL or a commercial license.\n * For LGPL see License.txt in the project root for license information.\n * For commercial licenses see https://www.tiny.cloud/\n */\n.mce-content-body .mce-item-anchor {\n  background: transparent url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D'8'%20height%3D'12'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%3E%3Cpath%20d%3D'M0%200L8%200%208%2012%204.09117821%209%200%2012z'%2F%3E%3C%2Fsvg%3E%0A\") no-repeat center;\n  cursor: default;\n  display: inline-block;\n  height: 12px !important;\n  padding: 0 2px;\n  -webkit-user-modify: read-only;\n  -moz-user-modify: read-only;\n  -webkit-user-select: all;\n  -moz-user-select: all;\n  -ms-user-select: all;\n      user-select: all;\n  width: 8px !important;\n}\n.mce-content-body .mce-item-anchor[data-mce-selected] {\n  outline-offset: 1px;\n}\n.tox-comments-visible .tox-comment {\n  background-color: #fff0b7;\n}\n.tox-comments-visible .tox-comment--active {\n  background-color: #ffe168;\n}\n.tox-checklist > li:not(.tox-checklist--hidden) {\n  list-style: none;\n  margin: 0.25em 0;\n}\n.tox-checklist > li:not(.tox-checklist--hidden)::before {\n  content: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%3E%3Cg%20id%3D%22checklist-unchecked%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%3Crect%20id%3D%22Rectangle%22%20width%3D%2215%22%20height%3D%2215%22%20x%3D%22.5%22%20y%3D%22.5%22%20fill-rule%3D%22nonzero%22%20stroke%3D%22%234C4C4C%22%20rx%3D%222%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E%0A\");\n  cursor: pointer;\n  height: 1em;\n  @if($rtl==false){\n    margin-left: -1.5em;\n  }\n  @if($rtl==true){\n    margin-right: -1.5em;\n  }\n  margin-top: 0.125em;\n  position: absolute;\n  width: 1em;\n}\n.tox-checklist li:not(.tox-checklist--hidden).tox-checklist--checked::before {\n  content: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%3E%3Cg%20id%3D%22checklist-checked%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%3Crect%20id%3D%22Rectangle%22%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22%234099FF%22%20fill-rule%3D%22nonzero%22%20rx%3D%222%22%2F%3E%3Cpath%20id%3D%22Path%22%20fill%3D%22%23FFF%22%20fill-rule%3D%22nonzero%22%20d%3D%22M11.5703186%2C3.14417309%20C11.8516238%2C2.73724603%2012.4164781%2C2.62829933%2012.83558%2C2.89774797%20C13.260121%2C3.17069355%2013.3759736%2C3.72932262%2013.0909105%2C4.14168582%20L7.7580587%2C11.8560195%20C7.43776896%2C12.3193404%206.76483983%2C12.3852142%206.35607322%2C11.9948725%20L3.02491697%2C8.8138662%20C2.66090143%2C8.46625845%202.65798871%2C7.89594698%203.01850234%2C7.54483354%20C3.373942%2C7.19866177%203.94940006%2C7.19592841%204.30829608%2C7.5386474%20L6.85276923%2C9.9684299%20L11.5703186%2C3.14417309%20Z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E%0A\");\n}\n[dir=rtl] .tox-checklist > li:not(.tox-checklist--hidden)::before {\n  @if($rtl==false){\n    margin-left: 0;\n    margin-right: -1.5em;\n  }\n  @if($rtl==true){\n    margin-right: 0;\n    margin-left: -1.5em;\n  }\n}\n/* stylelint-disable */\n/* http://prismjs.com/ */\n/**\n * prism.js default theme for JavaScript, CSS and HTML\n * Based on dabblet (http://dabblet.com)\n * @author Lea Verou\n */\ncode[class*=\"language-\"],\npre[class*=\"language-\"] {\n  //color: black;\n  background: none;\n  //text-shadow: 0 1px white;\n  font-size: 1em;\n  @if($rtl==false){\n    text-align: left;\n  }\n  @if($rtl==true){\n    text-align: right;\n  }\n  white-space: pre;\n  word-spacing: normal;\n  word-break: normal;\n  word-wrap: normal;\n  line-height: 1.5;\n  -moz-tab-size: 4;\n  tab-size: 4;\n  -webkit-hyphens: none;\n  -ms-hyphens: none;\n  hyphens: none;\n}\npre[class*=\"language-\"]::-moz-selection,\npre[class*=\"language-\"] ::-moz-selection,\ncode[class*=\"language-\"]::-moz-selection,\ncode[class*=\"language-\"] ::-moz-selection {\n  text-shadow: none;\n  background: #b3d4fc;\n}\npre[class*=\"language-\"]::selection,\npre[class*=\"language-\"] ::selection,\ncode[class*=\"language-\"]::selection,\ncode[class*=\"language-\"] ::selection {\n  text-shadow: none;\n  background: #b3d4fc;\n}\n@media print {\n  code[class*=\"language-\"],\n  pre[class*=\"language-\"] {\n    text-shadow: none;\n  }\n}\n/* Code blocks */\npre[class*=\"language-\"] {\n  padding: 1em;\n  margin: 0.5em 0;\n  overflow: auto;\n}\n:not(pre) > code[class*=\"language-\"],\npre[class*=\"language-\"] {\n  background: #f5f2f0;\n}\n/* Inline code */\n:not(pre) > code[class*=\"language-\"] {\n  padding: 0.1em;\n  border-radius: 0.3em;\n  white-space: normal;\n}\n.token.comment,\n.token.prolog,\n.token.doctype,\n.token.cdata {\n  color: slategray;\n}\n.token.punctuation {\n  color: #999;\n}\n.namespace {\n  opacity: 0.7;\n}\n.token.property,\n.token.tag,\n.token.boolean,\n.token.number,\n.token.constant,\n.token.symbol,\n.token.deleted {\n  color: #905;\n}\n.token.selector,\n.token.attr-name,\n.token.string,\n.token.char,\n.token.builtin,\n.token.inserted {\n  color: #690;\n}\n.token.operator,\n.token.entity,\n.token.url,\n.language-css .token.string,\n.style .token.string {\n  color: #9a6e3a;\n  background: hsla(0, 0%, 100%, 0.5);\n}\n.token.atrule,\n.token.attr-value,\n.token.keyword {\n  color: #07a;\n}\n.token.function,\n.token.class-name {\n  color: #DD4A68;\n}\n.token.regex,\n.token.important,\n.token.variable {\n  color: #e90;\n}\n.token.important,\n.token.bold {\n  font-weight: bold;\n}\n.token.italic {\n  font-style: italic;\n}\n.token.entity {\n  cursor: help;\n}\n/* stylelint-enable */\n.mce-content-body {\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n}\n.mce-content-body .mce-visual-caret {\n  background-color: black;\n  background-color: currentColor;\n  position: absolute;\n}\n.mce-content-body .mce-visual-caret-hidden {\n  display: none;\n}\n.mce-content-body *[data-mce-caret] {\n  left: -1000px;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  @if($rtl==false){\n    right: auto;\n  }\n  @if($rtl==true){\n    left: auto;\n  }\n  top: 0;\n}\n.mce-content-body .mce-offscreen-selection {\n  left: -2000000px;\n  max-width: 1000000px;\n  position: absolute;\n}\n.mce-content-body *[contentEditable=false] {\n  cursor: default;\n}\n.mce-content-body *[contentEditable=true] {\n  cursor: text;\n}\n.tox-cursor-format-painter {\n  cursor: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%3E%0A%20%20%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%3Cpath%20fill%3D%22%23000%22%20fill-rule%3D%22nonzero%22%20d%3D%22M15%2C6%20C15%2C5.45%2014.55%2C5%2014%2C5%20L6%2C5%20C5.45%2C5%205%2C5.45%205%2C6%20L5%2C10%20C5%2C10.55%205.45%2C11%206%2C11%20L14%2C11%20C14.55%2C11%2015%2C10.55%2015%2C10%20L15%2C9%20L16%2C9%20L16%2C12%20L9%2C12%20L9%2C19%20C9%2C19.55%209.45%2C20%2010%2C20%20L11%2C20%20C11.55%2C20%2012%2C19.55%2012%2C19%20L12%2C14%20L18%2C14%20L18%2C7%20L15%2C7%20L15%2C6%20Z%22%2F%3E%0A%20%20%20%20%3Cpath%20fill%3D%22%23000%22%20fill-rule%3D%22nonzero%22%20d%3D%22M1%2C1%20L8.25%2C1%20C8.66421356%2C1%209%2C1.33578644%209%2C1.75%20L9%2C1.75%20C9%2C2.16421356%208.66421356%2C2.5%208.25%2C2.5%20L2.5%2C2.5%20L2.5%2C8.25%20C2.5%2C8.66421356%202.16421356%2C9%201.75%2C9%20L1.75%2C9%20C1.33578644%2C9%201%2C8.66421356%201%2C8.25%20L1%2C1%20Z%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A\"), default;\n}\n.mce-content-body figure.align-left {\n  @if($rtl==false){\n    float: left;\n  }\n  @if($rtl==true){\n    float: right;\n  }\n}\n.mce-content-body figure.align-right {\n  @if($rtl==false){\n    float: right;\n  }\n  @if($rtl==true){\n    float: left;\n  }\n}\n.mce-content-body figure.image.align-center {\n  display: table;\n  margin-left: auto;\n  margin-right: auto;\n}\n.mce-preview-object {\n  border: 1px solid gray;\n  display: inline-block;\n  line-height: 0;\n  margin: 0 2px 0 2px;\n  position: relative;\n}\n.mce-preview-object .mce-shim {\n  background: url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7);\n  height: 100%;\n  @if($rtl==false){\n    left: 0;\n  }\n  @if($rtl==true){\n    right: 0;\n  }\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n.mce-preview-object[data-mce-selected=\"2\"] .mce-shim {\n  display: none;\n}\n.mce-object {\n  background: transparent url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%3E%3Cpath%20d%3D%22M4%203h16a1%201%200%200%201%201%201v16a1%201%200%200%201-1%201H4a1%201%200%200%201-1-1V4a1%201%200%200%201%201-1zm1%202v14h14V5H5zm4.79%202.565l5.64%204.028a.5.5%200%200%201%200%20.814l-5.64%204.028a.5.5%200%200%201-.79-.407V7.972a.5.5%200%200%201%20.79-.407z%22%2F%3E%3C%2Fsvg%3E%0A\") no-repeat center;\n  border: 1px dashed #aaa;\n}\n.mce-pagebreak {\n  border: 1px dashed #aaa;\n  cursor: default;\n  display: block;\n  height: 5px;\n  margin-top: 15px;\n  page-break-before: always;\n  width: 100%;\n}\n@media print {\n  .mce-pagebreak {\n    border: 0;\n  }\n}\n.tiny-pageembed .mce-shim {\n  background: url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7);\n  height: 100%;\n  @if($rtl==false){\n    left: 0;\n  }\n  @if($rtl==true){\n    right: 0;\n  }\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n.tiny-pageembed[data-mce-selected=\"2\"] .mce-shim {\n  display: none;\n}\n.tiny-pageembed {\n  display: inline-block;\n  position: relative;\n}\n.tiny-pageembed--21by9,\n.tiny-pageembed--16by9,\n.tiny-pageembed--4by3,\n.tiny-pageembed--1by1 {\n  display: block;\n  overflow: hidden;\n  padding: 0;\n  position: relative;\n  width: 100%;\n}\n.tiny-pageembed--21by9 {\n  padding-top: 42.857143%;\n}\n.tiny-pageembed--16by9 {\n  padding-top: 56.25%;\n}\n.tiny-pageembed--4by3 {\n  padding-top: 75%;\n}\n.tiny-pageembed--1by1 {\n  padding-top: 100%;\n}\n.tiny-pageembed--21by9 iframe,\n.tiny-pageembed--16by9 iframe,\n.tiny-pageembed--4by3 iframe,\n.tiny-pageembed--1by1 iframe {\n  border: 0;\n  height: 100%;\n  @if($rtl==false){\n    left: 0;\n  }\n  @if($rtl==true){\n    right: 0;\n  }\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n.mce-content-body[data-mce-placeholder] {\n  position: relative;\n}\n.mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before {\n  color: rgba(34, 47, 62, 0.7);\n  content: attr(data-mce-placeholder);\n  position: absolute;\n}\n.mce-content-body:not([dir=rtl])[data-mce-placeholder]:not(.mce-visualblocks)::before {\n  @if($rtl==false){\n    left: 1px;\n  }\n  @if($rtl==true){\n    right: 1px;\n  }\n}\n.mce-content-body[dir=rtl][data-mce-placeholder]:not(.mce-visualblocks)::before {\n  @if($rtl==false){\n    right: 1px;\n  }\n  @if($rtl==true){\n    left: 1px;\n  }\n}\n.mce-content-body div.mce-resizehandle {\n  background-color: #4099ff;\n  border-color: #4099ff;\n  border-style: solid;\n  border-width: 1px;\n  box-sizing: border-box;\n  height: 10px;\n  position: absolute;\n  width: 10px;\n  z-index: 10000;\n}\n.mce-content-body div.mce-resizehandle:hover {\n  background-color: #4099ff;\n}\n.mce-content-body div.mce-resizehandle:nth-of-type(1) {\n  cursor: nwse-resize;\n}\n.mce-content-body div.mce-resizehandle:nth-of-type(2) {\n  cursor: nesw-resize;\n}\n.mce-content-body div.mce-resizehandle:nth-of-type(3) {\n  cursor: nwse-resize;\n}\n.mce-content-body div.mce-resizehandle:nth-of-type(4) {\n  cursor: nesw-resize;\n}\n.mce-content-body .mce-clonedresizable {\n  opacity: 0.5;\n  outline: 1px dashed black;\n  position: absolute;\n  z-index: 10000;\n}\n.mce-content-body .mce-resize-helper {\n  background: #555;\n  background: rgba(0, 0, 0, 0.75);\n  border: 1px;\n  border-radius: 3px;\n  color: white;\n  display: none;\n  font-size: 12px;\n  line-height: 14px;\n  margin: 5px 10px;\n  padding: 5px;\n  position: absolute;\n  white-space: nowrap;\n  z-index: 10001;\n}\n.tox-rtc-user-selection {\n  position: relative;\n}\n.tox-rtc-user-cursor {\n  bottom: 0;\n  cursor: default;\n  position: absolute;\n  top: 0;\n  width: 2px;\n}\n.tox-rtc-user-cursor::before {\n  background-color: inherit;\n  border-radius: 50%;\n  content: '';\n  display: block;\n  height: 8px;\n  position: absolute;\n  @if($rtl==false){\n    right: -3px;\n  }\n  @if($rtl==true){\n    left: -3px;\n  }\n  top: -3px;\n  width: 8px;\n}\n.tox-rtc-user-cursor:hover::after {\n  background-color: inherit;\n  border-radius: 100px;\n  box-sizing: border-box;\n  color: #fff;\n  content: attr(data-user);\n  display: block;\n  font-size: 12px;\n  font-weight: bold;\n  @if($rtl==false){\n    left: -5px;\n  }\n  @if($rtl==true){\n    right: -5px;\n  }\n  min-height: 8px;\n  min-width: 8px;\n  padding: 0 12px;\n  position: absolute;\n  top: -11px;\n  white-space: nowrap;\n  z-index: 1000;\n}\n.tox-rtc-user-selection--1 .tox-rtc-user-cursor {\n  background-color: #2dc26b;\n}\n.tox-rtc-user-selection--2 .tox-rtc-user-cursor {\n  background-color: #e03e2d;\n}\n.tox-rtc-user-selection--3 .tox-rtc-user-cursor {\n  background-color: #f1c40f;\n}\n.tox-rtc-user-selection--4 .tox-rtc-user-cursor {\n  background-color: #3598db;\n}\n.tox-rtc-user-selection--5 .tox-rtc-user-cursor {\n  background-color: #b96ad9;\n}\n.tox-rtc-user-selection--6 .tox-rtc-user-cursor {\n  background-color: #e67e23;\n}\n.tox-rtc-user-selection--7 .tox-rtc-user-cursor {\n  background-color: #aaa69d;\n}\n.tox-rtc-user-selection--8 .tox-rtc-user-cursor {\n  background-color: #f368e0;\n}\n.tox-rtc-remote-image {\n  background: #eaeaea url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2236%22%20height%3D%2212%22%20viewBox%3D%220%200%2036%2012%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%3Ccircle%20cx%3D%226%22%20cy%3D%226%22%20r%3D%223%22%20fill%3D%22rgba(0%2C%200%2C%200%2C%20.2)%22%3E%0A%20%20%20%20%3Canimate%20attributeName%3D%22r%22%20values%3D%223%3B5%3B3%22%20calcMode%3D%22linear%22%20dur%3D%221s%22%20repeatCount%3D%22indefinite%22%20%2F%3E%0A%20%20%3C%2Fcircle%3E%0A%20%20%3Ccircle%20cx%3D%2218%22%20cy%3D%226%22%20r%3D%223%22%20fill%3D%22rgba(0%2C%200%2C%200%2C%20.2)%22%3E%0A%20%20%20%20%3Canimate%20attributeName%3D%22r%22%20values%3D%223%3B5%3B3%22%20calcMode%3D%22linear%22%20begin%3D%22.33s%22%20dur%3D%221s%22%20repeatCount%3D%22indefinite%22%20%2F%3E%0A%20%20%3C%2Fcircle%3E%0A%20%20%3Ccircle%20cx%3D%2230%22%20cy%3D%226%22%20r%3D%223%22%20fill%3D%22rgba(0%2C%200%2C%200%2C%20.2)%22%3E%0A%20%20%20%20%3Canimate%20attributeName%3D%22r%22%20values%3D%223%3B5%3B3%22%20calcMode%3D%22linear%22%20begin%3D%22.66s%22%20dur%3D%221s%22%20repeatCount%3D%22indefinite%22%20%2F%3E%0A%20%20%3C%2Fcircle%3E%0A%3C%2Fsvg%3E%0A\") no-repeat center center;\n  border: 1px solid #ccc;\n  min-height: 240px;\n  min-width: 320px;\n}\n.mce-match-marker {\n  background: #aaa;\n  color: #fff;\n}\n.mce-match-marker-selected {\n  background: #39f;\n  color: #fff;\n}\n.mce-match-marker-selected::-moz-selection {\n  background: #39f;\n  color: #fff;\n}\n.mce-match-marker-selected::selection {\n  background: #39f;\n  color: #fff;\n}\n.mce-content-body img[data-mce-selected],\n.mce-content-body table[data-mce-selected] {\n  outline: 3px solid #b4d7ff;\n}\n.mce-content-body hr[data-mce-selected] {\n  outline: 3px solid #b4d7ff;\n  outline-offset: 1px;\n}\n.mce-content-body *[contentEditable=false] *[contentEditable=true]:focus {\n  outline: 3px solid #b4d7ff;\n}\n.mce-content-body *[contentEditable=false] *[contentEditable=true]:hover {\n  outline: 3px solid #b4d7ff;\n}\n.mce-content-body *[contentEditable=false][data-mce-selected] {\n  cursor: not-allowed;\n  outline: 3px solid #b4d7ff;\n}\n.mce-content-body.mce-content-readonly *[contentEditable=true]:focus,\n.mce-content-body.mce-content-readonly *[contentEditable=true]:hover {\n  outline: none;\n}\n.mce-content-body *[data-mce-selected=\"inline-boundary\"] {\n  background-color: #b4d7ff;\n}\n.mce-content-body .mce-edit-focus {\n  outline: 3px solid #b4d7ff;\n}\n.mce-content-body td[data-mce-selected],\n.mce-content-body th[data-mce-selected] {\n  background-color: #b4d7ff !important;\n}\n.mce-content-body td[data-mce-selected]::-moz-selection,\n.mce-content-body th[data-mce-selected]::-moz-selection {\n  background: none;\n}\n.mce-content-body td[data-mce-selected]::selection,\n.mce-content-body th[data-mce-selected]::selection {\n  background: none;\n}\n.mce-content-body td[data-mce-selected] *,\n.mce-content-body th[data-mce-selected] * {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.mce-content-body img::-moz-selection {\n  background: none;\n}\n.mce-content-body img::selection {\n  background: none;\n}\n.ephox-snooker-resizer-bar {\n  background-color: #b4d7ff;\n  opacity: 0;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.ephox-snooker-resizer-cols {\n  cursor: col-resize;\n}\n.ephox-snooker-resizer-rows {\n  cursor: row-resize;\n}\n.ephox-snooker-resizer-bar.ephox-snooker-resizer-bar-dragging {\n  opacity: 1;\n}\n.mce-spellchecker-word {\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D'4'%20height%3D'4'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%3E%3Cpath%20stroke%3D'%23ff0000'%20fill%3D'none'%20stroke-linecap%3D'round'%20stroke-opacity%3D'.75'%20d%3D'M0%203L2%201%204%203'%2F%3E%3C%2Fsvg%3E%0A\");\n  background-position: 0 calc(100% + 1px);\n  background-repeat: repeat-x;\n  background-size: auto 6px;\n  cursor: default;\n  height: 2rem;\n}\n.mce-spellchecker-grammar {\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D'4'%20height%3D'4'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%3E%3Cpath%20stroke%3D'%2300A835'%20fill%3D'none'%20stroke-linecap%3D'round'%20d%3D'M0%203L2%201%204%203'%2F%3E%3C%2Fsvg%3E%0A\");\n  background-position: 0 calc(100% + 1px);\n  background-repeat: repeat-x;\n  background-size: auto 6px;\n  cursor: default;\n}\n.mce-toc {\n  border: 1px solid gray;\n}\n.mce-toc h2 {\n  margin: 4px;\n}\n.mce-toc li {\n  list-style-type: none;\n}\n.mce-item-table,\n.mce-item-table td,\n.mce-item-table th,\n.mce-item-table caption {\n  border: 1px dashed #bbb;\n}\n.mce-visualblocks p,\n.mce-visualblocks h1,\n.mce-visualblocks h2,\n.mce-visualblocks h3,\n.mce-visualblocks h4,\n.mce-visualblocks h5,\n.mce-visualblocks h6,\n.mce-visualblocks div:not([data-mce-bogus]),\n.mce-visualblocks section,\n.mce-visualblocks article,\n.mce-visualblocks blockquote,\n.mce-visualblocks address,\n.mce-visualblocks pre,\n.mce-visualblocks figure,\n.mce-visualblocks figcaption,\n.mce-visualblocks hgroup,\n.mce-visualblocks aside,\n.mce-visualblocks ul,\n.mce-visualblocks ol,\n.mce-visualblocks dl {\n  background-repeat: no-repeat;\n  border: 1px dashed #bbb;\n  @if($rtl==false){\n    margin-left: 3px;\n  }\n  @if($rtl==true){\n    margin-right: 3px;\n  }\n  padding-top: 10px;\n}\n.mce-visualblocks p {\n  background-image: url(data:image/gif;base64,R0lGODlhCQAJAJEAAAAAAP///7u7u////yH5BAEAAAMALAAAAAAJAAkAAAIQnG+CqCN/mlyvsRUpThG6AgA7);\n}\n.mce-visualblocks h1 {\n  background-image: url(data:image/gif;base64,R0lGODlhDQAKAIABALu7u////yH5BAEAAAEALAAAAAANAAoAAAIXjI8GybGu1JuxHoAfRNRW3TWXyF2YiRUAOw==);\n}\n.mce-visualblocks h2 {\n  background-image: url(data:image/gif;base64,R0lGODlhDgAKAIABALu7u////yH5BAEAAAEALAAAAAAOAAoAAAIajI8Hybbx4oOuqgTynJd6bGlWg3DkJzoaUAAAOw==);\n}\n.mce-visualblocks h3 {\n  background-image: url(data:image/gif;base64,R0lGODlhDgAKAIABALu7u////yH5BAEAAAEALAAAAAAOAAoAAAIZjI8Hybbx4oOuqgTynJf2Ln2NOHpQpmhAAQA7);\n}\n.mce-visualblocks h4 {\n  background-image: url(data:image/gif;base64,R0lGODlhDgAKAIABALu7u////yH5BAEAAAEALAAAAAAOAAoAAAIajI8HybbxInR0zqeAdhtJlXwV1oCll2HaWgAAOw==);\n}\n.mce-visualblocks h5 {\n  background-image: url(data:image/gif;base64,R0lGODlhDgAKAIABALu7u////yH5BAEAAAEALAAAAAAOAAoAAAIajI8HybbxIoiuwjane4iq5GlW05GgIkIZUAAAOw==);\n}\n.mce-visualblocks h6 {\n  background-image: url(data:image/gif;base64,R0lGODlhDgAKAIABALu7u////yH5BAEAAAEALAAAAAAOAAoAAAIajI8HybbxIoiuwjan04jep1iZ1XRlAo5bVgAAOw==);\n}\n.mce-visualblocks div:not([data-mce-bogus]) {\n  background-image: url(data:image/gif;base64,R0lGODlhEgAKAIABALu7u////yH5BAEAAAEALAAAAAASAAoAAAIfjI9poI0cgDywrhuxfbrzDEbQM2Ei5aRjmoySW4pAAQA7);\n}\n.mce-visualblocks section {\n  background-image: url(data:image/gif;base64,R0lGODlhKAAKAIABALu7u////yH5BAEAAAEALAAAAAAoAAoAAAI5jI+pywcNY3sBWHdNrplytD2ellDeSVbp+GmWqaDqDMepc8t17Y4vBsK5hDyJMcI6KkuYU+jpjLoKADs=);\n}\n.mce-visualblocks article {\n  background-image: url(data:image/gif;base64,R0lGODlhKgAKAIABALu7u////yH5BAEAAAEALAAAAAAqAAoAAAI6jI+pywkNY3wG0GBvrsd2tXGYSGnfiF7ikpXemTpOiJScasYoDJJrjsG9gkCJ0ag6KhmaIe3pjDYBBQA7);\n}\n.mce-visualblocks blockquote {\n  background-image: url(data:image/gif;base64,R0lGODlhPgAKAIABALu7u////yH5BAEAAAEALAAAAAA+AAoAAAJPjI+py+0Knpz0xQDyuUhvfoGgIX5iSKZYgq5uNL5q69asZ8s5rrf0yZmpNkJZzFesBTu8TOlDVAabUyatguVhWduud3EyiUk45xhTTgMBBQA7);\n}\n.mce-visualblocks address {\n  background-image: url(data:image/gif;base64,R0lGODlhLQAKAIABALu7u////yH5BAEAAAEALAAAAAAtAAoAAAI/jI+pywwNozSP1gDyyZcjb3UaRpXkWaXmZW4OqKLhBmLs+K263DkJK7OJeifh7FicKD9A1/IpGdKkyFpNmCkAADs=);\n}\n.mce-visualblocks pre {\n  background-image: url(data:image/gif;base64,R0lGODlhFQAKAIABALu7uwAAACH5BAEAAAEALAAAAAAVAAoAAAIjjI+ZoN0cgDwSmnpz1NCueYERhnibZVKLNnbOq8IvKpJtVQAAOw==);\n}\n.mce-visualblocks figure {\n  background-image: url(data:image/gif;base64,R0lGODlhJAAKAIAAALu7u////yH5BAEAAAEALAAAAAAkAAoAAAI0jI+py+2fwAHUSFvD3RlvG4HIp4nX5JFSpnZUJ6LlrM52OE7uSWosBHScgkSZj7dDKnWAAgA7);\n}\n.mce-visualblocks figcaption {\n  border: 1px dashed #bbb;\n}\n.mce-visualblocks hgroup {\n  background-image: url(data:image/gif;base64,R0lGODlhJwAKAIABALu7uwAAACH5BAEAAAEALAAAAAAnAAoAAAI3jI+pywYNI3uB0gpsRtt5fFnfNZaVSYJil4Wo03Hv6Z62uOCgiXH1kZIIJ8NiIxRrAZNMZAtQAAA7);\n}\n.mce-visualblocks aside {\n  background-image: url(data:image/gif;base64,R0lGODlhHgAKAIABAKqqqv///yH5BAEAAAEALAAAAAAeAAoAAAItjI+pG8APjZOTzgtqy7I3f1yehmQcFY4WKZbqByutmW4aHUd6vfcVbgudgpYCADs=);\n}\n.mce-visualblocks ul {\n  background-image: url(data:image/gif;base64,R0lGODlhDQAKAIAAALu7u////yH5BAEAAAEALAAAAAANAAoAAAIXjI8GybGuYnqUVSjvw26DzzXiqIDlVwAAOw==);\n}\n.mce-visualblocks ol {\n  background-image: url(data:image/gif;base64,R0lGODlhDQAKAIABALu7u////yH5BAEAAAEALAAAAAANAAoAAAIXjI8GybH6HHt0qourxC6CvzXieHyeWQAAOw==);\n}\n.mce-visualblocks dl {\n  background-image: url(data:image/gif;base64,R0lGODlhDQAKAIABALu7u////yH5BAEAAAEALAAAAAANAAoAAAIXjI8GybEOnmOvUoWznTqeuEjNSCqeGRUAOw==);\n}\n.mce-visualblocks:not([dir=rtl]) p,\n.mce-visualblocks:not([dir=rtl]) h1,\n.mce-visualblocks:not([dir=rtl]) h2,\n.mce-visualblocks:not([dir=rtl]) h3,\n.mce-visualblocks:not([dir=rtl]) h4,\n.mce-visualblocks:not([dir=rtl]) h5,\n.mce-visualblocks:not([dir=rtl]) h6,\n.mce-visualblocks:not([dir=rtl]) div:not([data-mce-bogus]),\n.mce-visualblocks:not([dir=rtl]) section,\n.mce-visualblocks:not([dir=rtl]) article,\n.mce-visualblocks:not([dir=rtl]) blockquote,\n.mce-visualblocks:not([dir=rtl]) address,\n.mce-visualblocks:not([dir=rtl]) pre,\n.mce-visualblocks:not([dir=rtl]) figure,\n.mce-visualblocks:not([dir=rtl]) figcaption,\n.mce-visualblocks:not([dir=rtl]) hgroup,\n.mce-visualblocks:not([dir=rtl]) aside,\n.mce-visualblocks:not([dir=rtl]) ul,\n.mce-visualblocks:not([dir=rtl]) ol,\n.mce-visualblocks:not([dir=rtl]) dl {\n  @if($rtl==false){\n    margin-left: 3px;\n  }\n  @if($rtl==true){\n    margin-right: 3px;\n  }\n}\n.mce-visualblocks[dir=rtl] p,\n.mce-visualblocks[dir=rtl] h1,\n.mce-visualblocks[dir=rtl] h2,\n.mce-visualblocks[dir=rtl] h3,\n.mce-visualblocks[dir=rtl] h4,\n.mce-visualblocks[dir=rtl] h5,\n.mce-visualblocks[dir=rtl] h6,\n.mce-visualblocks[dir=rtl] div:not([data-mce-bogus]),\n.mce-visualblocks[dir=rtl] section,\n.mce-visualblocks[dir=rtl] article,\n.mce-visualblocks[dir=rtl] blockquote,\n.mce-visualblocks[dir=rtl] address,\n.mce-visualblocks[dir=rtl] pre,\n.mce-visualblocks[dir=rtl] figure,\n.mce-visualblocks[dir=rtl] figcaption,\n.mce-visualblocks[dir=rtl] hgroup,\n.mce-visualblocks[dir=rtl] aside,\n.mce-visualblocks[dir=rtl] ul,\n.mce-visualblocks[dir=rtl] ol,\n.mce-visualblocks[dir=rtl] dl {\n  @if($rtl==false){\n    background-position-x: right;\n    margin-right: 3px;\n  }\n  @if($rtl==true){\n    background-position-x: left;\n    margin-left: 3px;\n  }\n}\n.mce-nbsp,\n.mce-shy {\n  background: #aaa;\n}\n.mce-shy::after {\n  content: '-';\n}\n.mce-content-body{\n  table {\n    border-collapse: collapse;\n  }\n}\n\n.tox-edit-area{\n  font-family: $base-font-family;\n}","/**\n * Copyright (c) Tiny Technologies, Inc. All rights reserved.\n * Licensed under the LGPL or a commercial license.\n * For LGPL see License.txt in the project root for license information.\n * For commercial licenses see https://www.tiny.cloud/\n */\n.mce-content-body .mce-item-anchor {\n  background: transparent url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D'8'%20height%3D'12'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%3E%3Cpath%20d%3D'M0%200L8%200%208%2012%204.09117821%209%200%2012z'%2F%3E%3C%2Fsvg%3E%0A\") no-repeat center;\n  cursor: default;\n  display: inline-block;\n  height: 12px !important;\n  padding: 0 2px;\n  -webkit-user-modify: read-only;\n  -moz-user-modify: read-only;\n  -webkit-user-select: all;\n  -moz-user-select: all;\n  -ms-user-select: all;\n      user-select: all;\n  width: 8px !important;\n}\n.mce-content-body .mce-item-anchor[data-mce-selected] {\n  outline-offset: 1px;\n}\n.tox-comments-visible .tox-comment {\n  background-color: #fff0b7;\n}\n.tox-comments-visible .tox-comment--active {\n  background-color: #ffe168;\n}\n.tox-checklist > li:not(.tox-checklist--hidden) {\n  list-style: none;\n  margin: 0.25em 0;\n}\n.tox-checklist > li:not(.tox-checklist--hidden)::before {\n  content: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%3E%3Cg%20id%3D%22checklist-unchecked%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%3Crect%20id%3D%22Rectangle%22%20width%3D%2215%22%20height%3D%2215%22%20x%3D%22.5%22%20y%3D%22.5%22%20fill-rule%3D%22nonzero%22%20stroke%3D%22%234C4C4C%22%20rx%3D%222%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E%0A\");\n  cursor: pointer;\n  height: 1em;\n  @if($rtl==false){\n    margin-left: -1.5em;\n  }\n  @if($rtl==true){\n    margin-right: -1.5em;\n  }\n  margin-top: 0.125em;\n  position: absolute;\n  width: 1em;\n}\n.tox-checklist li:not(.tox-checklist--hidden).tox-checklist--checked::before {\n  content: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%3E%3Cg%20id%3D%22checklist-checked%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%3Crect%20id%3D%22Rectangle%22%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22%234099FF%22%20fill-rule%3D%22nonzero%22%20rx%3D%222%22%2F%3E%3Cpath%20id%3D%22Path%22%20fill%3D%22%23FFF%22%20fill-rule%3D%22nonzero%22%20d%3D%22M11.5703186%2C3.14417309%20C11.8516238%2C2.73724603%2012.4164781%2C2.62829933%2012.83558%2C2.89774797%20C13.260121%2C3.17069355%2013.3759736%2C3.72932262%2013.0909105%2C4.14168582%20L7.7580587%2C11.8560195%20C7.43776896%2C12.3193404%206.76483983%2C12.3852142%206.35607322%2C11.9948725%20L3.02491697%2C8.8138662%20C2.66090143%2C8.46625845%202.65798871%2C7.89594698%203.01850234%2C7.54483354%20C3.373942%2C7.19866177%203.94940006%2C7.19592841%204.30829608%2C7.5386474%20L6.85276923%2C9.9684299%20L11.5703186%2C3.14417309%20Z%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E%0A\");\n}\n[dir=rtl] .tox-checklist > li:not(.tox-checklist--hidden)::before {\n  @if($rtl==false){\n    margin-left: 0;\n    margin-right: -1.5em;\n  }\n  @if($rtl==true){\n    margin-right: 0;\n    margin-left: -1.5em;\n  }\n}\n/* stylelint-disable */\n/* http://prismjs.com/ */\n/**\n * prism.js default theme for JavaScript, CSS and HTML\n * Based on dabblet (http://dabblet.com)\n * @author Lea Verou\n */\ncode[class*=\"language-\"],\npre[class*=\"language-\"] {\n // color: black;\n  background: none;\n  //text-shadow: 0 1px white;\n  font-size: 1em;\n  text-align: left;\n  white-space: pre;\n  word-spacing: normal;\n  word-break: normal;\n  word-wrap: normal;\n  line-height: 1.5;\n  -moz-tab-size: 4;\n  tab-size: 4;\n  -webkit-hyphens: none;\n  -ms-hyphens: none;\n  hyphens: none;\n}\npre[class*=\"language-\"]::-moz-selection,\npre[class*=\"language-\"] ::-moz-selection,\ncode[class*=\"language-\"]::-moz-selection,\ncode[class*=\"language-\"] ::-moz-selection {\n  text-shadow: none;\n  background: #b3d4fc;\n}\npre[class*=\"language-\"]::selection,\npre[class*=\"language-\"] ::selection,\ncode[class*=\"language-\"]::selection,\ncode[class*=\"language-\"] ::selection {\n  text-shadow: none;\n  background: #b3d4fc;\n}\n@media print {\n  code[class*=\"language-\"],\n  pre[class*=\"language-\"] {\n    text-shadow: none;\n  }\n}\n/* Code blocks */\npre[class*=\"language-\"] {\n  padding: 1em;\n  margin: 0.5em 0;\n  overflow: auto;\n}\n:not(pre) > code[class*=\"language-\"],\npre[class*=\"language-\"] {\n  background: #f5f2f0;\n}\n/* Inline code */\n:not(pre) > code[class*=\"language-\"] {\n  padding: 0.1em;\n  border-radius: 0.3em;\n  white-space: normal;\n}\n.token.comment,\n.token.prolog,\n.token.doctype,\n.token.cdata {\n  color: slategray;\n}\n.token.punctuation {\n  color: #999;\n}\n.namespace {\n  opacity: 0.7;\n}\n.token.property,\n.token.tag,\n.token.boolean,\n.token.number,\n.token.constant,\n.token.symbol,\n.token.deleted {\n  color: #905;\n}\n.token.selector,\n.token.attr-name,\n.token.string,\n.token.char,\n.token.builtin,\n.token.inserted {\n  color: #690;\n}\n.token.operator,\n.token.entity,\n.token.url,\n.language-css .token.string,\n.style .token.string {\n  color: #9a6e3a;\n  background: hsla(0, 0%, 100%, 0.5);\n}\n.token.atrule,\n.token.attr-value,\n.token.keyword {\n  color: #07a;\n}\n.token.function,\n.token.class-name {\n  color: #DD4A68;\n}\n.token.regex,\n.token.important,\n.token.variable {\n  color: #e90;\n}\n.token.important,\n.token.bold {\n  font-weight: bold;\n}\n.token.italic {\n  font-style: italic;\n}\n.token.entity {\n  cursor: help;\n}\n/* stylelint-enable */\n.mce-content-body {\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n}\n.mce-content-body .mce-visual-caret {\n  background-color: black;\n  background-color: currentColor;\n  position: absolute;\n}\n.mce-content-body .mce-visual-caret-hidden {\n  display: none;\n}\n.mce-content-body *[data-mce-caret] {\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  @if($rtl==false){\n    right: auto;\n    left: -1000px;\n  }\n  @if($rtl==true){\n    left: auto;\n    right: -1000px;\n  }\n  top: 0;\n}\n.mce-content-body .mce-offscreen-selection {\n  @if($rtl==false){\n    left: -2000000px;\n  }\n  @if($rtl==true){\n    right: -2000000px;\n  }\n  max-width: 1000000px;\n  position: absolute;\n}\n.mce-content-body *[contentEditable=false] {\n  cursor: default;\n}\n.mce-content-body *[contentEditable=true] {\n  cursor: text;\n}\n.tox-cursor-format-painter {\n  cursor: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%3E%0A%20%20%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%3Cpath%20fill%3D%22%23000%22%20fill-rule%3D%22nonzero%22%20d%3D%22M15%2C6%20C15%2C5.45%2014.55%2C5%2014%2C5%20L6%2C5%20C5.45%2C5%205%2C5.45%205%2C6%20L5%2C10%20C5%2C10.55%205.45%2C11%206%2C11%20L14%2C11%20C14.55%2C11%2015%2C10.55%2015%2C10%20L15%2C9%20L16%2C9%20L16%2C12%20L9%2C12%20L9%2C19%20C9%2C19.55%209.45%2C20%2010%2C20%20L11%2C20%20C11.55%2C20%2012%2C19.55%2012%2C19%20L12%2C14%20L18%2C14%20L18%2C7%20L15%2C7%20L15%2C6%20Z%22%2F%3E%0A%20%20%20%20%3Cpath%20fill%3D%22%23000%22%20fill-rule%3D%22nonzero%22%20d%3D%22M1%2C1%20L8.25%2C1%20C8.66421356%2C1%209%2C1.33578644%209%2C1.75%20L9%2C1.75%20C9%2C2.16421356%208.66421356%2C2.5%208.25%2C2.5%20L2.5%2C2.5%20L2.5%2C8.25%20C2.5%2C8.66421356%202.16421356%2C9%201.75%2C9%20L1.75%2C9%20C1.33578644%2C9%201%2C8.66421356%201%2C8.25%20L1%2C1%20Z%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E%0A\"), default;\n}\n.mce-content-body figure.align-left {\n  float: left;\n}\n.mce-content-body figure.align-right {\n  float: right;\n}\n.mce-content-body figure.image.align-center {\n  display: table;\n  margin-left: auto;\n  margin-right: auto;\n}\n.mce-preview-object {\n  border: 1px solid gray;\n  display: inline-block;\n  line-height: 0;\n  margin: 0 2px 0 2px;\n  position: relative;\n}\n.mce-preview-object .mce-shim {\n  background: url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7);\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n.mce-preview-object[data-mce-selected=\"2\"] .mce-shim {\n  display: none;\n}\n.mce-object {\n  background: transparent url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%3E%3Cpath%20d%3D%22M4%203h16a1%201%200%200%201%201%201v16a1%201%200%200%201-1%201H4a1%201%200%200%201-1-1V4a1%201%200%200%201%201-1zm1%202v14h14V5H5zm4.79%202.565l5.64%204.028a.5.5%200%200%201%200%20.814l-5.64%204.028a.5.5%200%200%201-.79-.407V7.972a.5.5%200%200%201%20.79-.407z%22%2F%3E%3C%2Fsvg%3E%0A\") no-repeat center;\n  border: 1px dashed #aaa;\n}\n.mce-pagebreak {\n  border: 1px dashed #aaa;\n  cursor: default;\n  display: block;\n  height: 5px;\n  margin-top: 15px;\n  page-break-before: always;\n  width: 100%;\n}\n@media print {\n  .mce-pagebreak {\n    border: 0;\n  }\n}\n.tiny-pageembed .mce-shim {\n  background: url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7);\n  height: 100%;\n  @if($rtl==false){\n    left: 0;\n  }\n  @if($rtl==true){\n    right: 0;\n  }\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n.tiny-pageembed[data-mce-selected=\"2\"] .mce-shim {\n  display: none;\n}\n.tiny-pageembed {\n  display: inline-block;\n  position: relative;\n}\n.tiny-pageembed--21by9,\n.tiny-pageembed--16by9,\n.tiny-pageembed--4by3,\n.tiny-pageembed--1by1 {\n  display: block;\n  overflow: hidden;\n  padding: 0;\n  position: relative;\n  width: 100%;\n}\n.tiny-pageembed--21by9 {\n  padding-top: 42.857143%;\n}\n.tiny-pageembed--16by9 {\n  padding-top: 56.25%;\n}\n.tiny-pageembed--4by3 {\n  padding-top: 75%;\n}\n.tiny-pageembed--1by1 {\n  padding-top: 100%;\n}\n.tiny-pageembed--21by9 iframe,\n.tiny-pageembed--16by9 iframe,\n.tiny-pageembed--4by3 iframe,\n.tiny-pageembed--1by1 iframe {\n  border: 0;\n  height: 100%;\n  @if($rtl==false){\n    left: 0;\n  }\n  @if($rtl==true){\n    right: 0;\n  }\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n.mce-content-body[data-mce-placeholder] {\n  position: relative;\n}\n.mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before {\n  color: rgba(34, 47, 62, 0.7);\n  content: attr(data-mce-placeholder);\n  position: absolute;\n}\n.mce-content-body:not([dir=rtl])[data-mce-placeholder]:not(.mce-visualblocks)::before {\n  @if($rtl==false){\n    left: 1px;\n  }\n  @if($rtl==true){\n    right: 1px;\n  }\n}\n.mce-content-body[dir=rtl][data-mce-placeholder]:not(.mce-visualblocks)::before {\n  @if($rtl==false){\n    right: 1px;\n  }\n  @if($rtl==true){\n    left: 1px;\n  }\n}\n.mce-content-body div.mce-resizehandle {\n  background-color: #4099ff;\n  border-color: #4099ff;\n  border-style: solid;\n  border-width: 1px;\n  box-sizing: border-box;\n  height: 10px;\n  position: absolute;\n  width: 10px;\n  z-index: 10000;\n}\n.mce-content-body div.mce-resizehandle:hover {\n  background-color: #4099ff;\n}\n.mce-content-body div.mce-resizehandle:nth-of-type(1) {\n  cursor: nwse-resize;\n}\n.mce-content-body div.mce-resizehandle:nth-of-type(2) {\n  cursor: nesw-resize;\n}\n.mce-content-body div.mce-resizehandle:nth-of-type(3) {\n  cursor: nwse-resize;\n}\n.mce-content-body div.mce-resizehandle:nth-of-type(4) {\n  cursor: nesw-resize;\n}\n.mce-content-body .mce-clonedresizable {\n  opacity: 0.5;\n  outline: 1px dashed black;\n  position: absolute;\n  z-index: 10000;\n}\n.mce-content-body .mce-resize-helper {\n  background: #555;\n  background: rgba(0, 0, 0, 0.75);\n  border: 1px;\n  border-radius: 3px;\n  color: white;\n  display: none;\n  font-size: 12px;\n  line-height: 14px;\n  margin: 5px 10px;\n  padding: 5px;\n  position: absolute;\n  white-space: nowrap;\n  z-index: 10001;\n}\n.tox-rtc-user-selection {\n  position: relative;\n}\n.tox-rtc-user-cursor {\n  bottom: 0;\n  cursor: default;\n  position: absolute;\n  top: 0;\n  width: 2px;\n}\n.tox-rtc-user-cursor::before {\n  background-color: inherit;\n  border-radius: 50%;\n  content: '';\n  display: block;\n  height: 8px;\n  position: absolute;\n  @if($rtl==false){\n    right: -3px;\n  }\n  @if($rtl==true){\n    left: -3px;\n  }\n  top: -3px;\n  width: 8px;\n}\n.tox-rtc-user-cursor:hover::after {\n  background-color: inherit;\n  border-radius: 100px;\n  box-sizing: border-box;\n  color: #fff;\n  content: attr(data-user);\n  display: block;\n  font-size: 12px;\n  font-weight: bold;\n  @if($rtl==false){\n    left: -5px;\n  }\n  @if($rtl==true){\n    right: -5px;\n  }\n  min-height: 8px;\n  min-width: 8px;\n  padding: 0 12px;\n  position: absolute;\n  top: -11px;\n  white-space: nowrap;\n  z-index: 1000;\n}\n.tox-rtc-user-selection--1 .tox-rtc-user-cursor {\n  background-color: #2dc26b;\n}\n.tox-rtc-user-selection--2 .tox-rtc-user-cursor {\n  background-color: #e03e2d;\n}\n.tox-rtc-user-selection--3 .tox-rtc-user-cursor {\n  background-color: #f1c40f;\n}\n.tox-rtc-user-selection--4 .tox-rtc-user-cursor {\n  background-color: #3598db;\n}\n.tox-rtc-user-selection--5 .tox-rtc-user-cursor {\n  background-color: #b96ad9;\n}\n.tox-rtc-user-selection--6 .tox-rtc-user-cursor {\n  background-color: #e67e23;\n}\n.tox-rtc-user-selection--7 .tox-rtc-user-cursor {\n  background-color: #aaa69d;\n}\n.tox-rtc-user-selection--8 .tox-rtc-user-cursor {\n  background-color: #f368e0;\n}\n.tox-rtc-remote-image {\n  background: #eaeaea url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2236%22%20height%3D%2212%22%20viewBox%3D%220%200%2036%2012%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%3Ccircle%20cx%3D%226%22%20cy%3D%226%22%20r%3D%223%22%20fill%3D%22rgba(0%2C%200%2C%200%2C%20.2)%22%3E%0A%20%20%20%20%3Canimate%20attributeName%3D%22r%22%20values%3D%223%3B5%3B3%22%20calcMode%3D%22linear%22%20dur%3D%221s%22%20repeatCount%3D%22indefinite%22%20%2F%3E%0A%20%20%3C%2Fcircle%3E%0A%20%20%3Ccircle%20cx%3D%2218%22%20cy%3D%226%22%20r%3D%223%22%20fill%3D%22rgba(0%2C%200%2C%200%2C%20.2)%22%3E%0A%20%20%20%20%3Canimate%20attributeName%3D%22r%22%20values%3D%223%3B5%3B3%22%20calcMode%3D%22linear%22%20begin%3D%22.33s%22%20dur%3D%221s%22%20repeatCount%3D%22indefinite%22%20%2F%3E%0A%20%20%3C%2Fcircle%3E%0A%20%20%3Ccircle%20cx%3D%2230%22%20cy%3D%226%22%20r%3D%223%22%20fill%3D%22rgba(0%2C%200%2C%200%2C%20.2)%22%3E%0A%20%20%20%20%3Canimate%20attributeName%3D%22r%22%20values%3D%223%3B5%3B3%22%20calcMode%3D%22linear%22%20begin%3D%22.66s%22%20dur%3D%221s%22%20repeatCount%3D%22indefinite%22%20%2F%3E%0A%20%20%3C%2Fcircle%3E%0A%3C%2Fsvg%3E%0A\") no-repeat center center;\n  border: 1px solid #ccc;\n  min-height: 240px;\n  min-width: 320px;\n}\n.mce-match-marker {\n  background: #aaa;\n  color: #fff;\n}\n.mce-match-marker-selected {\n  background: #39f;\n  color: #fff;\n}\n.mce-match-marker-selected::-moz-selection {\n  background: #39f;\n  color: #fff;\n}\n.mce-match-marker-selected::selection {\n  background: #39f;\n  color: #fff;\n}\n.mce-content-body img[data-mce-selected],\n.mce-content-body table[data-mce-selected] {\n  outline: 3px solid #b4d7ff;\n}\n.mce-content-body hr[data-mce-selected] {\n  outline: 3px solid #b4d7ff;\n  outline-offset: 1px;\n}\n.mce-content-body *[contentEditable=false] *[contentEditable=true]:focus {\n  outline: 3px solid #b4d7ff;\n}\n.mce-content-body *[contentEditable=false] *[contentEditable=true]:hover {\n  outline: 3px solid #b4d7ff;\n}\n.mce-content-body *[contentEditable=false][data-mce-selected] {\n  cursor: not-allowed;\n  outline: 3px solid #b4d7ff;\n}\n.mce-content-body.mce-content-readonly *[contentEditable=true]:focus,\n.mce-content-body.mce-content-readonly *[contentEditable=true]:hover {\n  outline: none;\n}\n.mce-content-body *[data-mce-selected=\"inline-boundary\"] {\n  background-color: #b4d7ff;\n}\n.mce-content-body .mce-edit-focus {\n  outline: 3px solid #b4d7ff;\n}\n.mce-content-body td[data-mce-selected],\n.mce-content-body th[data-mce-selected] {\n  background-color: #b4d7ff !important;\n}\n.mce-content-body td[data-mce-selected]::-moz-selection,\n.mce-content-body th[data-mce-selected]::-moz-selection {\n  background: none;\n}\n.mce-content-body td[data-mce-selected]::selection,\n.mce-content-body th[data-mce-selected]::selection {\n  background: none;\n}\n.mce-content-body td[data-mce-selected] *,\n.mce-content-body th[data-mce-selected] * {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.mce-content-body img::-moz-selection {\n  background: none;\n}\n.mce-content-body img::selection {\n  background: none;\n}\n.ephox-snooker-resizer-bar {\n  background-color: #b4d7ff;\n  opacity: 0;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.ephox-snooker-resizer-cols {\n  cursor: col-resize;\n}\n.ephox-snooker-resizer-rows {\n  cursor: row-resize;\n}\n.ephox-snooker-resizer-bar.ephox-snooker-resizer-bar-dragging {\n  opacity: 1;\n}\n.mce-spellchecker-word {\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D'4'%20height%3D'4'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%3E%3Cpath%20stroke%3D'%23ff0000'%20fill%3D'none'%20stroke-linecap%3D'round'%20stroke-opacity%3D'.75'%20d%3D'M0%203L2%201%204%203'%2F%3E%3C%2Fsvg%3E%0A\");\n  background-position: 0 calc(100% + 1px);\n  background-repeat: repeat-x;\n  background-size: auto 6px;\n  cursor: default;\n  height: 2rem;\n}\n.mce-spellchecker-grammar {\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D'4'%20height%3D'4'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%3E%3Cpath%20stroke%3D'%2300A835'%20fill%3D'none'%20stroke-linecap%3D'round'%20d%3D'M0%203L2%201%204%203'%2F%3E%3C%2Fsvg%3E%0A\");\n  background-position: 0 calc(100% + 1px);\n  background-repeat: repeat-x;\n  background-size: auto 6px;\n  cursor: default;\n}\n.mce-toc {\n  border: 1px solid gray;\n}\n.mce-toc h2 {\n  margin: 4px;\n}\n.mce-toc li {\n  list-style-type: none;\n}\n.mce-item-table,\n.mce-item-table td,\n.mce-item-table th,\n.mce-item-table caption {\n  border: 1px dashed #bbb;\n}\n.mce-visualblocks p,\n.mce-visualblocks h1,\n.mce-visualblocks h2,\n.mce-visualblocks h3,\n.mce-visualblocks h4,\n.mce-visualblocks h5,\n.mce-visualblocks h6,\n.mce-visualblocks div:not([data-mce-bogus]),\n.mce-visualblocks section,\n.mce-visualblocks article,\n.mce-visualblocks blockquote,\n.mce-visualblocks address,\n.mce-visualblocks pre,\n.mce-visualblocks figure,\n.mce-visualblocks figcaption,\n.mce-visualblocks hgroup,\n.mce-visualblocks aside,\n.mce-visualblocks ul,\n.mce-visualblocks ol,\n.mce-visualblocks dl {\n  background-repeat: no-repeat;\n  border: 1px dashed #bbb;\n  @if($rtl==false){\n    margin-left: 3px;\n  }\n  @if($rtl==true){\n    margin-right: 3px;\n  }\n  padding-top: 10px;\n}\n.mce-visualblocks p {\n  background-image: url(data:image/gif;base64,R0lGODlhCQAJAJEAAAAAAP///7u7u////yH5BAEAAAMALAAAAAAJAAkAAAIQnG+CqCN/mlyvsRUpThG6AgA7);\n}\n.mce-visualblocks h1 {\n  background-image: url(data:image/gif;base64,R0lGODlhDQAKAIABALu7u////yH5BAEAAAEALAAAAAANAAoAAAIXjI8GybGu1JuxHoAfRNRW3TWXyF2YiRUAOw==);\n}\n.mce-visualblocks h2 {\n  background-image: url(data:image/gif;base64,R0lGODlhDgAKAIABALu7u////yH5BAEAAAEALAAAAAAOAAoAAAIajI8Hybbx4oOuqgTynJd6bGlWg3DkJzoaUAAAOw==);\n}\n.mce-visualblocks h3 {\n  background-image: url(data:image/gif;base64,R0lGODlhDgAKAIABALu7u////yH5BAEAAAEALAAAAAAOAAoAAAIZjI8Hybbx4oOuqgTynJf2Ln2NOHpQpmhAAQA7);\n}\n.mce-visualblocks h4 {\n  background-image: url(data:image/gif;base64,R0lGODlhDgAKAIABALu7u////yH5BAEAAAEALAAAAAAOAAoAAAIajI8HybbxInR0zqeAdhtJlXwV1oCll2HaWgAAOw==);\n}\n.mce-visualblocks h5 {\n  background-image: url(data:image/gif;base64,R0lGODlhDgAKAIABALu7u////yH5BAEAAAEALAAAAAAOAAoAAAIajI8HybbxIoiuwjane4iq5GlW05GgIkIZUAAAOw==);\n}\n.mce-visualblocks h6 {\n  background-image: url(data:image/gif;base64,R0lGODlhDgAKAIABALu7u////yH5BAEAAAEALAAAAAAOAAoAAAIajI8HybbxIoiuwjan04jep1iZ1XRlAo5bVgAAOw==);\n}\n.mce-visualblocks div:not([data-mce-bogus]) {\n  background-image: url(data:image/gif;base64,R0lGODlhEgAKAIABALu7u////yH5BAEAAAEALAAAAAASAAoAAAIfjI9poI0cgDywrhuxfbrzDEbQM2Ei5aRjmoySW4pAAQA7);\n}\n.mce-visualblocks section {\n  background-image: url(data:image/gif;base64,R0lGODlhKAAKAIABALu7u////yH5BAEAAAEALAAAAAAoAAoAAAI5jI+pywcNY3sBWHdNrplytD2ellDeSVbp+GmWqaDqDMepc8t17Y4vBsK5hDyJMcI6KkuYU+jpjLoKADs=);\n}\n.mce-visualblocks article {\n  background-image: url(data:image/gif;base64,R0lGODlhKgAKAIABALu7u////yH5BAEAAAEALAAAAAAqAAoAAAI6jI+pywkNY3wG0GBvrsd2tXGYSGnfiF7ikpXemTpOiJScasYoDJJrjsG9gkCJ0ag6KhmaIe3pjDYBBQA7);\n}\n.mce-visualblocks blockquote {\n  background-image: url(data:image/gif;base64,R0lGODlhPgAKAIABALu7u////yH5BAEAAAEALAAAAAA+AAoAAAJPjI+py+0Knpz0xQDyuUhvfoGgIX5iSKZYgq5uNL5q69asZ8s5rrf0yZmpNkJZzFesBTu8TOlDVAabUyatguVhWduud3EyiUk45xhTTgMBBQA7);\n}\n.mce-visualblocks address {\n  background-image: url(data:image/gif;base64,R0lGODlhLQAKAIABALu7u////yH5BAEAAAEALAAAAAAtAAoAAAI/jI+pywwNozSP1gDyyZcjb3UaRpXkWaXmZW4OqKLhBmLs+K263DkJK7OJeifh7FicKD9A1/IpGdKkyFpNmCkAADs=);\n}\n.mce-visualblocks pre {\n  background-image: url(data:image/gif;base64,R0lGODlhFQAKAIABALu7uwAAACH5BAEAAAEALAAAAAAVAAoAAAIjjI+ZoN0cgDwSmnpz1NCueYERhnibZVKLNnbOq8IvKpJtVQAAOw==);\n}\n.mce-visualblocks figure {\n  background-image: url(data:image/gif;base64,R0lGODlhJAAKAIAAALu7u////yH5BAEAAAEALAAAAAAkAAoAAAI0jI+py+2fwAHUSFvD3RlvG4HIp4nX5JFSpnZUJ6LlrM52OE7uSWosBHScgkSZj7dDKnWAAgA7);\n}\n.mce-visualblocks figcaption {\n  border: 1px dashed #bbb;\n}\n.mce-visualblocks hgroup {\n  background-image: url(data:image/gif;base64,R0lGODlhJwAKAIABALu7uwAAACH5BAEAAAEALAAAAAAnAAoAAAI3jI+pywYNI3uB0gpsRtt5fFnfNZaVSYJil4Wo03Hv6Z62uOCgiXH1kZIIJ8NiIxRrAZNMZAtQAAA7);\n}\n.mce-visualblocks aside {\n  background-image: url(data:image/gif;base64,R0lGODlhHgAKAIABAKqqqv///yH5BAEAAAEALAAAAAAeAAoAAAItjI+pG8APjZOTzgtqy7I3f1yehmQcFY4WKZbqByutmW4aHUd6vfcVbgudgpYCADs=);\n}\n.mce-visualblocks ul {\n  background-image: url(data:image/gif;base64,R0lGODlhDQAKAIAAALu7u////yH5BAEAAAEALAAAAAANAAoAAAIXjI8GybGuYnqUVSjvw26DzzXiqIDlVwAAOw==);\n}\n.mce-visualblocks ol {\n  background-image: url(data:image/gif;base64,R0lGODlhDQAKAIABALu7u////yH5BAEAAAEALAAAAAANAAoAAAIXjI8GybH6HHt0qourxC6CvzXieHyeWQAAOw==);\n}\n.mce-visualblocks dl {\n  background-image: url(data:image/gif;base64,R0lGODlhDQAKAIABALu7u////yH5BAEAAAEALAAAAAANAAoAAAIXjI8GybEOnmOvUoWznTqeuEjNSCqeGRUAOw==);\n}\n.mce-visualblocks p,\n.mce-visualblocks h1,\n.mce-visualblocks h2,\n.mce-visualblocks h3,\n.mce-visualblocks h4,\n.mce-visualblocks h5,\n.mce-visualblocks h6,\n.mce-visualblocks div:not([data-mce-bogus]),\n.mce-visualblocks section,\n.mce-visualblocks article,\n.mce-visualblocks blockquote,\n.mce-visualblocks address,\n.mce-visualblocks pre,\n.mce-visualblocks figure,\n.mce-visualblocks figcaption,\n.mce-visualblocks hgroup,\n.mce-visualblocks aside,\n.mce-visualblocks ul,\n.mce-visualblocks ol,\n.mce-visualblocks dl {\n  @if($rtl==false){\n    margin-left: 3px;\n  }\n  @if($rtl==true){\n    margin-right: 3px;\n    background-position-x: right;\n  }\n}\n.mce-nbsp,\n.mce-shy {\n  background: #aaa;\n}\n.mce-shy::after {\n  content: '-';\n}\n\n.tinymce-inline{\n  &:focus{\n    box-shadow: none;\n    outline: none;\n  }\n}","/**\n * Copyright (c) Tiny Technologies, Inc. All rights reserved.\n * Licensed under the LGPL or a commercial license.\n * For LGPL see License.txt in the project root for license information.\n * For commercial licenses see https://www.tiny.cloud/\n */\n.tinymce-mobile-unfocused-selections .tinymce-mobile-unfocused-selection {\n  /* Note: this file is used inside the content, so isn't part of theming */\n  background-color: green;\n  display: inline-block;\n  opacity: 0.5;\n  position: absolute;\n}\n.mce-content-body{\n  body {\n    -webkit-text-size-adjust: none;\n  }\n  body img {\n    /* this is related to the content margin */\n    max-width: 96vw;\n  }\n  body table img {\n    max-width: 95%;\n  }\n  \n  table {\n    border-collapse: collapse;\n  }\n}\n","/*\n * Copyright (c) Tiny Technologies, Inc. All rights reserved.\n * Licensed under the LGPL or a commercial license.\n * For LGPL see License.txt in the project root for license information.\n * For commercial licenses see https://www.tiny.cloud/\n */\n.tox {\n  box-sizing: content-box;\n  color: $base-text;\n  cursor: auto;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: normal;\n  line-height: normal;\n  -webkit-tap-highlight-color: transparent;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  vertical-align: initial;\n  white-space: normal;\n}\n.tox *:not(svg):not(rect) {\n  box-sizing: inherit;\n  //color: inherit;\n  cursor: inherit;\n  direction: inherit;\n  font-size: inherit;\n  font-style: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  -webkit-tap-highlight-color: inherit;\n  text-align: inherit;\n  text-decoration: inherit;\n  //text-shadow: inherit;\n  text-transform: inherit;\n  vertical-align: inherit;\n  white-space: inherit;\n}\n.tox *:not(svg):not(rect) {\n  /* stylelint-disable-line no-duplicate-selectors */\n  background: transparent;\n  border: 0;\n  float: none;\n  height: auto;\n  margin: 0;\n  max-width: none;\n  outline: 0;\n  padding: 0;\n  position: static;\n  width: auto;\n}\n.tox {\n  @if($rtl==false){\n    direction: ltr;\n    text-align: left;\n  }\n  @if($rtl==true){\n    direction: rtl;\n    text-align: right;\n  }\n}\n.tox-tinymce {\n  border: 1px solid $border-light !important;\n  border-radius: $border-radius !important;\n  box-shadow: none !important;\n  box-sizing: border-box !important;\n  display: flex !important;\n  flex-direction: column !important;\n  overflow: hidden !important;\n  position: relative !important;\n  visibility: inherit !important;\n}\n.tox-tinymce-inline {\n  border: none;\n  box-shadow: none;\n}\n.tox-tinymce-inline .tox-editor-header {\n  border: 1px solid $border-light;\n  border-radius: 0;\n  box-shadow: none;\n}\n.tox-tinymce-aux {\n  z-index: 1300;\n}\n.tox-tinymce *:focus,\n.tox-tinymce-aux *:focus {\n  outline: none;\n}\nbutton::-moz-focus-inner {\n  border: 0;\n}\n.tox .accessibility-issue__header {\n  align-items: center;\n  display: flex;\n  margin-bottom: 4px;\n}\n.tox .accessibility-issue__description {\n  align-items: stretch;\n  border: 1px solid $border-light;\n  border-radius: 3px;\n  display: flex;\n  justify-content: space-between;\n}\n.tox .accessibility-issue__description > div {\n  padding-bottom: 4px;\n}\n.tox .accessibility-issue__description > div > div {\n  align-items: center;\n  display: flex;\n  margin-bottom: 4px;\n}\n.tox .accessibility-issue__description > *:last-child:not(:only-child) {\n  border-color: $border-light;\n  border-style: solid;\n}\n.tox .accessibility-issue__repair {\n  margin-top: 16px;\n}\n.tox .tox-dialog__body-content .accessibility-issue--info .accessibility-issue__description {\n  background-color: rgba(32, 122, 183, 0.1);\n  border-color: rgba(32, 122, 183, 0.4);\n  color: $base-text;\n}\n.tox .tox-dialog__body-content .accessibility-issue--info .accessibility-issue__description > *:last-child {\n  border-color: rgba(32, 122, 183, 0.4);\n}\n.tox .tox-dialog__body-content .accessibility-issue--info .tox-form__group h2 {\n  color: #207ab7;\n}\n.tox .tox-dialog__body-content .accessibility-issue--info .tox-icon svg {\n  fill: #207ab7;\n}\n.tox .tox-dialog__body-content .accessibility-issue--info a .tox-icon {\n  color: #207ab7;\n}\n.tox .tox-dialog__body-content .accessibility-issue--warn .accessibility-issue__description {\n  background-color: rgba(255, 165, 0, 0.1);\n  border-color: rgba(255, 165, 0, 0.5);\n  color: $base-text;\n}\n.tox .tox-dialog__body-content .accessibility-issue--warn .accessibility-issue__description > *:last-child {\n  border-color: rgba(255, 165, 0, 0.5);\n}\n.tox .tox-dialog__body-content .accessibility-issue--warn .tox-form__group h2 {\n  color: #cc8500;\n}\n.tox .tox-dialog__body-content .accessibility-issue--warn .tox-icon svg {\n  fill: #cc8500;\n}\n.tox .tox-dialog__body-content .accessibility-issue--warn a .tox-icon {\n  color: #cc8500;\n}\n.tox .tox-dialog__body-content .accessibility-issue--error .accessibility-issue__description {\n  background-color: rgba(204, 0, 0, 0.1);\n  border-color: rgba(204, 0, 0, 0.4);\n  color: $base-text;\n}\n.tox .tox-dialog__body-content .accessibility-issue--error .accessibility-issue__description > *:last-child {\n  border-color: rgba(204, 0, 0, 0.4);\n}\n.tox .tox-dialog__body-content .accessibility-issue--error .tox-form__group h2 {\n  color: #c00;\n}\n.tox .tox-dialog__body-content .accessibility-issue--error .tox-icon svg {\n  fill: #c00;\n}\n.tox .tox-dialog__body-content .accessibility-issue--error a .tox-icon {\n  color: #c00;\n}\n.tox .tox-dialog__body-content .accessibility-issue--success .accessibility-issue__description {\n  background-color: rgba(120, 171, 70, 0.1);\n  border-color: rgba(120, 171, 70, 0.4);\n  color: $base-text;\n}\n.tox .tox-dialog__body-content .accessibility-issue--success .accessibility-issue__description > *:last-child {\n  border-color: rgba(120, 171, 70, 0.4);\n}\n.tox .tox-dialog__body-content .accessibility-issue--success .tox-form__group h2 {\n  color: #78AB46;\n}\n.tox .tox-dialog__body-content .accessibility-issue--success .tox-icon svg {\n  fill: #78AB46;\n}\n.tox .tox-dialog__body-content .accessibility-issue--success a .tox-icon {\n  color: #78AB46;\n}\n.tox .tox-dialog__body-content .accessibility-issue__header h1,\n.tox .tox-dialog__body-content .tox-form__group .accessibility-issue__description h2 {\n  margin-top: 0;\n}\n.tox .tox-dialog__body-content .accessibility-issue__header .tox-button {\n  @if($rtl==false){\n    margin-left: 4px;\n  }\n  @if($rtl==true){\n    margin-right: 4px;\n  }\n}\n.tox .tox-dialog__body-content .accessibility-issue__header > *:nth-last-child(2) {\n  @if($rtl==false){\n    margin-left: auto;\n  }\n  @if($rtl==true){\n    margin-right: auto;\n  }\n}\n.tox .tox-dialog__body-content .accessibility-issue__description {\n  @if($rtl==false){\n    padding: 4px 4px 4px 8px;\n  }\n  @if($rtl==true){\n    padding: 4px 8px 4px 4px;\n  }\n}\n.tox .tox-dialog__body-content .accessibility-issue__description > *:last-child {\n  @if($rtl==false){\n    border-left-width: 1px;\n    padding-left: 4px;\n  }\n  @if($rtl==true){\n    border-right-width: 1px;\n    padding-right: 4px;\n  }\n}\n\n.tox .tox-anchorbar {\n  display: flex;\n  flex: 0 0 auto;\n}\n.tox .tox-bar {\n  display: flex;\n  flex: 0 0 auto;\n}\n.tox .tox-button {\n  background-color: #207ab7;\n  background-image: none;\n  background-position: 0 0;\n  background-repeat: repeat;\n  border-color: #207ab7;\n  border-radius: 3px;\n  border-style: solid;\n  border-width: 1px;\n  box-shadow: none;\n  box-sizing: border-box;\n  color: #fff;\n  cursor: pointer;\n  display: inline-block;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: bold;\n  letter-spacing: normal;\n  line-height: 24px;\n  margin: 0;\n  outline: none;\n  padding: 4px 16px;\n  text-align: center;\n  text-decoration: none;\n  text-transform: capitalize;\n  white-space: nowrap;\n}\n.tox .tox-button[disabled] {\n  background-color: #207ab7;\n  background-image: none;\n  border-color: #207ab7;\n  box-shadow: none;\n  color: rgba(255, 255, 255, 0.5);\n  cursor: not-allowed;\n}\n.tox .tox-button:focus:not(:disabled) {\n  background-color: #1c6ca1;\n  background-image: none;\n  border-color: #1c6ca1;\n  box-shadow: none;\n  color: #fff;\n}\n.tox .tox-button:hover:not(:disabled) {\n  background-color: #1c6ca1;\n  background-image: none;\n  border-color: #1c6ca1;\n  box-shadow: none;\n  color: #fff;\n}\n.tox .tox-button:active:not(:disabled) {\n  background-color: #185d8c;\n  background-image: none;\n  border-color: #185d8c;\n  box-shadow: none;\n  color: #fff;\n}\n.tox .tox-button--secondary {\n  background-color: #f0f0f0;\n  background-image: none;\n  background-position: 0 0;\n  background-repeat: repeat;\n  border-color: #f0f0f0;\n  border-radius: 3px;\n  border-style: solid;\n  border-width: 1px;\n  box-shadow: none;\n  color: $base-text;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: bold;\n  letter-spacing: normal;\n  outline: none;\n  padding: 4px 16px;\n  text-decoration: none;\n  text-transform: capitalize;\n}\n.tox .tox-button--secondary[disabled] {\n  background-color: #f0f0f0;\n  background-image: none;\n  border-color: #f0f0f0;\n  box-shadow: none;\n  color: rgba($base-text, 0.5);\n}\n.tox .tox-button--secondary:focus:not(:disabled) {\n  background-color: #e3e3e3;\n  background-image: none;\n  border-color: #e3e3e3;\n  box-shadow: none;\n  color: $base-text;\n}\n.tox .tox-button--secondary:hover:not(:disabled) {\n  background-color: #e3e3e3;\n  background-image: none;\n  border-color: #e3e3e3;\n  box-shadow: none;\n  color: $base-text;\n}\n.tox .tox-button--secondary:active:not(:disabled) {\n  background-color: #d6d6d6;\n  background-image: none;\n  border-color: #d6d6d6;\n  box-shadow: none;\n  color: $base-text;\n}\n.tox .tox-button--icon,\n.tox .tox-button.tox-button--icon,\n.tox .tox-button.tox-button--secondary.tox-button--icon {\n  padding: 4px;\n}\n.tox .tox-button--icon .tox-icon svg,\n.tox .tox-button.tox-button--icon .tox-icon svg,\n.tox .tox-button.tox-button--secondary.tox-button--icon .tox-icon svg {\n  display: block;\n  fill: currentColor;\n}\n.tox .tox-button-link {\n  background: 0;\n  border: none;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: inline-block;\n  font-size: 16px;\n  font-weight: normal;\n  line-height: 1.3;\n  margin: 0;\n  padding: 0;\n  white-space: nowrap;\n}\n.tox .tox-button-link--sm {\n  font-size: 14px;\n}\n.tox .tox-button--naked {\n  background-color: transparent;\n  border-color: transparent;\n  box-shadow: unset;\n  color: $base-text;\n}\n.tox .tox-button--naked[disabled] {\n  background-color: #f0f0f0;\n  border-color: #f0f0f0;\n  box-shadow: none;\n  color: rgba($base-text, 0.5);\n}\n.tox .tox-button--naked:hover:not(:disabled) {\n  background-color: #e3e3e3;\n  border-color: #e3e3e3;\n  box-shadow: none;\n  color: $base-text;\n}\n.tox .tox-button--naked:focus:not(:disabled) {\n  background-color: #e3e3e3;\n  border-color: #e3e3e3;\n  box-shadow: none;\n  color: $base-text;\n}\n.tox .tox-button--naked:active:not(:disabled) {\n  background-color: #d6d6d6;\n  border-color: #d6d6d6;\n  box-shadow: none;\n  color: $base-text;\n}\n.tox .tox-button--naked .tox-icon svg {\n  fill: currentColor;\n}\n.tox .tox-button--naked.tox-button--icon:hover:not(:disabled) {\n  color: $base-text;\n}\n.tox .tox-checkbox {\n  align-items: center;\n  border-radius: 3px;\n  cursor: pointer;\n  display: flex;\n  height: 36px;\n  min-width: 36px;\n}\n.tox .tox-checkbox__input {\n  /* Hide from view but visible to screen readers */\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  top: auto;\n  width: 1px;\n}\n.tox .tox-checkbox__icons {\n  align-items: center;\n  border-radius: 3px;\n  box-shadow: 0 0 0 2px transparent;\n  box-sizing: content-box;\n  display: flex;\n  height: 24px;\n  justify-content: center;\n  padding: calc(4px - 1px);\n  width: 24px;\n}\n.tox .tox-checkbox__icons .tox-checkbox-icon__unchecked svg {\n  display: block;\n  fill: rgba(34, 47, 62, 0.3);\n}\n.tox .tox-checkbox__icons .tox-checkbox-icon__indeterminate svg {\n  display: none;\n  fill: #207ab7;\n}\n.tox .tox-checkbox__icons .tox-checkbox-icon__checked svg {\n  display: none;\n  fill: #207ab7;\n}\n.tox .tox-checkbox--disabled {\n  color: rgba($base-text, 0.5);\n  cursor: not-allowed;\n}\n.tox .tox-checkbox--disabled .tox-checkbox__icons .tox-checkbox-icon__checked svg {\n  fill: rgba($base-text, 0.5);\n}\n.tox .tox-checkbox--disabled .tox-checkbox__icons .tox-checkbox-icon__unchecked svg {\n  fill: rgba($base-text, 0.5);\n}\n.tox .tox-checkbox--disabled .tox-checkbox__icons .tox-checkbox-icon__indeterminate svg {\n  fill: rgba($base-text, 0.5);\n}\n.tox input.tox-checkbox__input:checked + .tox-checkbox__icons .tox-checkbox-icon__unchecked svg {\n  display: none;\n}\n.tox input.tox-checkbox__input:checked + .tox-checkbox__icons .tox-checkbox-icon__checked svg {\n  display: block;\n}\n.tox input.tox-checkbox__input:indeterminate + .tox-checkbox__icons .tox-checkbox-icon__unchecked svg {\n  display: none;\n}\n.tox input.tox-checkbox__input:indeterminate + .tox-checkbox__icons .tox-checkbox-icon__indeterminate svg {\n  display: block;\n}\n.tox input.tox-checkbox__input:focus + .tox-checkbox__icons {\n  border-radius: 3px;\n  box-shadow: inset 0 0 0 1px #207ab7;\n  padding: calc(4px - 1px);\n}\n.tox .tox-checkbox__label {\n  @if($rtl==false){\n    margin-left: 4px;\n  }\n  @if($rtl==true){\n    margin-right: 4px;\n  }\n}\n.tox .tox-checkbox__input {\n  @if($rtl==false){\n    left: -10000px;\n  }\n  @if($rtl==true){\n    right: -10000px;\n  }\n}\n.tox .tox-bar .tox-checkbox {\n  @if($rtl==false){\n    margin-left: 4px;\n  }\n  @if($rtl==true){\n    margin-right: 4px;\n  }\n}\n.tox {\n  /* stylelint-disable-next-line no-descending-specificity */\n}\n.tox .tox-collection--toolbar .tox-collection__group {\n  display: flex !important;\n  padding: 0 !important;\n}\n.tox .tox-collection--grid .tox-collection__group {\n  display: flex !important;\n  flex-wrap: wrap !important;\n  max-height: 208px !important;\n  overflow-x: hidden !important;\n  overflow-y: auto !important;\n  padding: 0 !important;\n}\n.tox .tox-collection--list .tox-collection__group {\n  border-bottom-width: 0 !important;\n  border-color: $border-light !important;\n  border-left-width: 0 !important;\n  border-right-width: 0 !important;\n  border-style: solid !important;\n  border-top-width: 1px !important;\n  padding: 4px 0 !important;\n}\n.tox .tox-collection--list .tox-collection__group:first-child {\n  border-top-width: 0 !important;\n}\n.tox .tox-collection__group-heading {\n  background-color: #e6e6e6 !important;\n  color: rgba(34, 47, 62, 0.7) !important;\n  cursor: default !important;\n  font-size: 12px !important;\n  font-style: normal !important;\n  font-weight: normal !important;\n  margin-bottom: 4px !important;\n  margin-top: -4px !important;\n  padding: 4px 8px !important;\n  text-transform: none !important;\n  -webkit-touch-callout: none !important;\n  -webkit-user-select: none !important;\n     -moz-user-select: none !important;\n      -ms-user-select: none !important;\n          user-select: none !important;\n}\n.tox .tox-collection__item {\n  align-items: center !important;\n  color: $base-text !important;\n  cursor: pointer !important;\n  display: flex !important;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none !important;\n}\n.tox .tox-collection--list .tox-collection__item {\n  padding: 4px 8px !important;\n}\n.tox .tox-collection--toolbar .tox-collection__item {\n  border-radius: 3px !important;\n  padding: 4px !important;\n}\n.tox .tox-collection--grid .tox-collection__item {\n  border-radius: 3px !important;\n  padding: 4px !important;\n}\n.tox .tox-collection--list .tox-collection__item--enabled {\n  background-color: #fff !important;\n  color: $base-text !important;\n}\n.tox .tox-collection--list .tox-collection__item--active {\n  background-color: $light !important;\n}\n.tox .tox-collection--toolbar .tox-collection__item--enabled {\n  background-color: #c8cbcf !important;\n  color: $base-text !important;\n}\n.tox .tox-collection--toolbar .tox-collection__item--active {\n  background-color: $light !important;\n}\n.tox .tox-collection--grid .tox-collection__item--enabled {\n  background-color: #c8cbcf !important;\n  color: $base-text !important;\n}\n.tox .tox-collection--grid .tox-collection__item--active:not(.tox-collection__item--state-disabled) {\n  background-color: $light !important;\n  color: $base-text !important;\n}\n.tox .tox-collection--list .tox-collection__item--active:not(.tox-collection__item--state-disabled) {\n  color: $base-text !important;\n}\n.tox .tox-collection--toolbar .tox-collection__item--active:not(.tox-collection__item--state-disabled) {\n  color: $base-text !important;\n}\n.tox .tox-collection__item--state-disabled {\n  background-color: transparent !important;\n  color: rgba($base-text, 0.5) !important;\n  cursor: not-allowed !important;\n}\n.tox .tox-collection__item-icon,\n.tox .tox-collection__item-checkmark {\n  align-items: center !important;\n  display: flex !important; \n  height: 24px !important;\n  justify-content: center !important;\n  width: 24px !important;\n}\n.tox .tox-collection__item-icon svg,\n.tox .tox-collection__item-checkmark svg {\n  fill: currentColor !important;\n}\n.tox .tox-collection--toolbar-lg .tox-collection__item-icon {\n  height: 48px !important;\n  width: 48px !important;\n}\n.tox .tox-collection__item-label {\n  color: currentColor !important;\n  display: inline-block !important;\n  flex: 1 !important;\n  -ms-flex-preferred-size: auto;\n  font-size: 14px !important;\n  font-style: normal !important;\n  font-weight: normal !important;\n  line-height: 24px !important;\n  text-transform: none !important;\n  word-break: break-all !important;\n}\n.tox .tox-collection__item-accessory {\n  color: rgba(34, 47, 62, 0.7) !important;\n  display: inline-block !important;\n  font-size: 14px !important;\n  height: 24px !important;\n  line-height: 24px !important;\n  text-transform: none !important;\n}\n.tox .tox-collection__item-caret {\n  align-items: center !important;\n  display: flex !important;\n  min-height: 24px !important;\n}\n.tox .tox-collection__item-caret::after {\n  content: '' !important;\n  font-size: 0 !important;\n  min-height: inherit !important;\n}\n.tox .tox-collection__item-caret svg {\n  fill: $base-text !important;\n}\n.tox .tox-collection--list .tox-collection__item:not(.tox-collection__item--enabled) .tox-collection__item-checkmark svg {\n  display: none !important;\n}\n.tox .tox-collection--list .tox-collection__item:not(.tox-collection__item--enabled) .tox-collection__item-accessory + .tox-collection__item-checkmark {\n  display: none !important;\n}\n.tox .tox-collection--horizontal {\n  background-color: #fff !important;\n  border: 1px solid $border-light !important;\n  border-radius: 3px !important;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15) !important;\n  display: flex !important;\n  flex: 0 0 auto !important;\n  flex-shrink: 0 !important;\n  flex-wrap: nowrap !important;\n  margin-bottom: 0 !important;\n  overflow-x: auto !important;\n  padding: 0 !important;\n}\n.tox .tox-collection--horizontal .tox-collection__group {\n  align-items: center !important;\n  display: flex !important;\n  flex-wrap: nowrap !important;\n  margin: 0 !important;\n  padding: 0 4px !important;\n}\n.tox .tox-collection--horizontal .tox-collection__item {\n  height: 34px !important;\n  margin: 2px 0 3px 0 !important;\n  padding: 0 4px !important;\n}\n.tox .tox-collection--horizontal .tox-collection__item-label {\n  white-space: nowrap !important;\n}\n.tox .tox-collection--horizontal .tox-collection__item-caret {\n  @if($rtl==false){\n    margin-left: 4px !important;\n  }\n  @if($rtl==true){\n    margin-right: 4px !important;\n  }\n}\n.tox .tox-collection--horizontal .tox-collection__group:not(:last-of-type) {\n  @if($rtl==false){\n    border-right: 1px solid $border-light !important;\n  }\n  @if($rtl==true){\n    border-left: 1px solid $border-light !important;\n  }\n}\n.tox .tox-collection--list .tox-collection__item > *:not(:first-child) {\n  @if($rtl==false){\n    margin-left: 8px !important;\n  }\n  @if($rtl==true){\n    margin-right: 8px !important;\n  }\n}\n.tox .tox-collection--list .tox-collection__item-label:first-child {\n  @if($rtl==false){\n    margin-left: 4px !important;\n  }\n  @if($rtl==true){\n    margin-right: 4px !important;\n  }\n}\n.tox .tox-collection__item-accessory {\n  @if($rtl==false){\n    margin-left: 16px !important;\n    text-align: right !important;\n  }\n  @if($rtl==true){\n    margin-right: 16px !important;\n    text-align: left !important;\n  }\n}\n.tox .tox-collection .tox-collection__item-caret {\n  @if($rtl==false){\n    margin-left: 16px !important;\n  }\n  @if($rtl==true){\n    margin-right: 16px !important;\n  }\n}\n.tox .tox-color-picker-container {\n  display: flex !important;\n  flex-direction: row !important;\n  height: 225px !important;\n  margin: 0 !important;\n}\n.tox .tox-sv-palette {\n  box-sizing: border-box;\n  display: flex;\n  height: 100%;\n}\n.tox .tox-sv-palette-spectrum {\n  height: 100%;\n}\n.tox .tox-sv-palette,\n.tox .tox-sv-palette-spectrum {\n  width: 225px;\n}\n.tox .tox-sv-palette-thumb {\n  background: none;\n  border: 1px solid black;\n  border-radius: 50%;\n  box-sizing: content-box;\n  height: 12px;\n  position: absolute;\n  width: 12px;\n}\n.tox .tox-sv-palette-inner-thumb {\n  border: 1px solid white;\n  border-radius: 50%;\n  height: 10px;\n  position: absolute;\n  width: 10px;\n}\n.tox .tox-hue-slider {\n  box-sizing: border-box;\n  height: 100%;\n  width: 25px;\n}\n.tox .tox-hue-slider-spectrum {\n  background: linear-gradient(to bottom, #f00, #ff0080, #f0f, #8000ff, #00f, #0080ff, #0ff, #00ff80, #0f0, #80ff00, #ff0, #ff8000, #f00);\n  height: 100%;\n  width: 100%;\n}\n.tox .tox-hue-slider,\n.tox .tox-hue-slider-spectrum {\n  width: 20px;\n}\n.tox .tox-hue-slider-thumb {\n  background: white;\n  border: 1px solid black;\n  box-sizing: content-box;\n  height: 4px;\n  width: 100%;\n}\n.tox .tox-rgb-form {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.tox .tox-rgb-form div {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 5px;\n  width: inherit;\n}\n.tox .tox-rgb-form input {\n  width: 6em;\n}\n.tox .tox-rgb-form input.tox-invalid {\n  /* Need !important to override Chrome's focus styling unfortunately */\n  border: 1px solid red !important;\n}\n.tox .tox-rgb-form .tox-rgba-preview {\n  border: 1px solid black;\n  flex-grow: 2;\n  margin-bottom: 0;\n}\n.tox .tox-sv-palette {\n  @if($rtl==false){\n    margin-right: 15px;\n  }\n  @if($rtl==true){\n    margin-left: 15px;\n  }\n}\n.tox .tox-hue-slider {\n  @if($rtl==false){\n    margin-right: 15px;\n  }\n  @if($rtl==true){\n    margin-left: 15px;\n  }\n}\n.tox .tox-hue-slider-thumb {\n  @if($rtl==false){\n    margin-left: -1px;\n  }\n  @if($rtl==true){\n    margin-right: -1px;\n  }\n}\n.tox .tox-rgb-form label {\n  @if($rtl==false){\n    margin-right: 0.5em;\n  }\n  @if($rtl==true){\n    margin-left: 0.5em;\n  }\n}\n.tox .tox-toolbar .tox-swatches,\n.tox .tox-toolbar__primary .tox-swatches,\n.tox .tox-toolbar__overflow .tox-swatches {\n  @if($rtl==false){\n    margin: 2px 0 3px 4px;\n  }\n  @if($rtl==true){\n    margin: 2px 4px 3px 0;\n  }\n}\n.tox .tox-collection--list .tox-collection__group .tox-swatches-menu {\n  border: 0;\n  margin: -4px 0;\n}\n.tox .tox-swatches__row {\n  display: flex;\n}\n.tox .tox-swatch {\n  height: 30px;\n  transition: transform 0.15s, box-shadow 0.15s;\n  width: 30px;\n}\n.tox .tox-swatch:hover,\n.tox .tox-swatch:focus {\n  box-shadow: 0 0 0 1px rgba(127, 127, 127, 0.3) inset;\n  transform: scale(0.8);\n}\n.tox .tox-swatch--remove {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n.tox .tox-swatch--remove svg path {\n  stroke: #e74c3c;\n}\n.tox .tox-swatches__picker-btn {\n  align-items: center;\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  display: flex;\n  height: 30px;\n  justify-content: center;\n  outline: none;\n  padding: 0;\n  width: 30px;\n}\n.tox .tox-swatches__picker-btn svg {\n  height: 24px;\n  width: 24px;\n}\n.tox .tox-swatches__picker-btn:hover {\n  background: $light;\n}\n.tox .tox-swatches__picker-btn {\n  @if($rtl==false){\n    margin-left: auto;\n  }\n  @if($rtl==true){\n    margin-right: auto;\n  }\n}\n.tox .tox-comment-thread {\n  background: #fff;\n  position: relative;\n}\n.tox .tox-comment-thread > *:not(:first-child) {\n  margin-top: 8px;\n}\n.tox .tox-comment {\n  background: #fff;\n  border: 1px solid $border-light;\n  border-radius: 3px;\n  box-shadow: 0 4px 8px 0 rgba(34, 47, 62, 0.1);\n  padding: 8px 8px 16px 8px;\n  position: relative;\n}\n.tox .tox-comment__header {\n  align-items: center;\n  color: $base-text;\n  display: flex;\n  justify-content: space-between;\n}\n.tox .tox-comment__date {\n  color: rgba(34, 47, 62, 0.7);\n  font-size: 12px;\n}\n.tox .tox-comment__body {\n  color: $base-text;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1.3;\n  margin-top: 8px;\n  position: relative;\n  text-transform: initial;\n}\n.tox .tox-comment__body textarea {\n  resize: none;\n  white-space: normal;\n  width: 100%;\n}\n.tox .tox-comment__expander {\n  padding-top: 8px;\n}\n.tox .tox-comment__expander p {\n  color: rgba(34, 47, 62, 0.7);\n  font-size: 14px;\n  font-style: normal;\n}\n.tox .tox-comment__body p {\n  margin: 0;\n}\n.tox .tox-comment__buttonspacing {\n  padding-top: 16px;\n  text-align: center;\n}\n.tox .tox-comment-thread__overlay::after {\n  background: #fff;\n  bottom: 0;\n  content: \"\";\n  display: flex;\n  left: 0;\n  opacity: 0.9;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 5;\n}\n.tox .tox-comment__reply {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  margin-top: 8px;\n}\n.tox .tox-comment__reply > *:first-child {\n  margin-bottom: 8px;\n  width: 100%;\n}\n.tox .tox-comment__edit {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  margin-top: 16px;\n}\n.tox .tox-comment__gradient::after {\n  background: linear-gradient(rgba(255, 255, 255, 0), #fff);\n  bottom: 0;\n  content: \"\";\n  display: block;\n  height: 5em;\n  margin-top: -40px;\n  position: absolute;\n  width: 100%;\n}\n.tox .tox-comment__overlay {\n  background: #fff;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  left: 0;\n  opacity: 0.9;\n  position: absolute;\n  right: 0;\n  text-align: center;\n  top: 0;\n  z-index: 5;\n}\n.tox .tox-comment__loading-text {\n  align-items: center;\n  color: $base-text;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n.tox .tox-comment__loading-text > div {\n  padding-bottom: 16px;\n}\n.tox .tox-comment__overlaytext {\n  bottom: 0;\n  flex-direction: column;\n  font-size: 14px;\n  left: 0;\n  padding: 1em;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 10;\n}\n.tox .tox-comment__overlaytext p {\n  background-color: #fff;\n  box-shadow: 0 0 8px 8px #fff;\n  color: $base-text;\n  text-align: center;\n}\n.tox .tox-comment__overlaytext div:nth-of-type(2) {\n  font-size: 0.8em;\n}\n.tox .tox-comment__busy-spinner {\n  align-items: center;\n  background-color: #fff;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 20;\n}\n.tox .tox-comment__scroll {\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 1;\n  overflow: auto;\n}\n.tox .tox-conversations {\n  margin: 8px;\n}\n.tox .tox-comment__edit {\n  @if($rtl==false){\n    margin-left: 8px;\n  }\n  @if($rtl==true){\n    margin-right: 8px;\n  }\n}\n.tox .tox-comment__buttonspacing > *:last-child,\n.tox .tox-comment__edit > *:last-child,\n.tox .tox-comment__reply > *:last-child {\n  @if($rtl==false){\n    margin-left: 8px;\n  }\n  @if($rtl==true){\n    margin-right: 8px;\n  }\n}\n.tox .tox-user {\n  align-items: center;\n  display: flex;\n}\n.tox .tox-user__avatar svg {\n  fill: rgba(34, 47, 62, 0.7);\n}\n.tox .tox-user__name {\n  color: rgba(34, 47, 62, 0.7);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n.tox .tox-user__avatar svg {\n  @if($rtl==false){\n    margin-right: 8px;\n  }\n  @if($rtl==true){\n    margin-left: 8px;\n  }\n}\n.tox .tox-user__avatar + .tox-user__name {\n  @if($rtl==false){\n    margin-left: 8px;\n  }\n  @if($rtl==true){\n    margin-right: 8px;\n  }\n}\n.tox .tox-dialog-wrap {\n  align-items: center;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 1100;\n}\n.tox .tox-dialog-wrap__backdrop {\n  background-color: rgba(255, 255, 255, 0.75);\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 1;\n}\n.tox .tox-dialog-wrap__backdrop--opaque {\n  background-color: #fff;\n}\n.tox .tox-dialog {\n  background-color: #fff;\n  border-color: $border-light;\n  border-radius: 3px;\n  border-style: solid;\n  border-width: 1px;\n  box-shadow: 0 16px 16px -10px rgba(34, 47, 62, 0.15), 0 0 40px 1px rgba(34, 47, 62, 0.15);\n  display: flex;\n  flex-direction: column;\n  max-height: 100%;\n  max-width: 480px;\n  overflow: hidden;\n  position: relative;\n  width: 95vw;\n  z-index: 2;\n}\n@media only screen and (max-width:767px) {\n  body:not(.tox-force-desktop) .tox .tox-dialog {\n    align-self: flex-start;\n    margin: 8px auto;\n    width: calc(100vw - 16px);\n  }\n}\n.tox .tox-dialog-inline {\n  z-index: 1100;\n}\n.tox .tox-dialog__header {\n  align-items: center;\n  background-color: #fff;\n  border-bottom: none;\n  color: $base-text;\n  display: flex;\n  font-size: 16px;\n  justify-content: space-between;\n  padding: 8px 16px 0 16px;\n  position: relative;\n}\n.tox .tox-dialog__header .tox-button {\n  z-index: 1;\n}\n.tox .tox-dialog__draghandle {\n  cursor: grab;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n.tox .tox-dialog__draghandle:active {\n  cursor: grabbing;\n}\n.tox .tox-dialog__dismiss {\n  margin-left: auto;\n}\n.tox .tox-dialog__title {\n  font-size: 20px;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1.3;\n  margin: 0;\n  text-transform: none;\n}\n.tox .tox-dialog__body {\n  color: $base-text;\n  display: flex;\n  flex: 1;\n  -ms-flex-preferred-size: auto;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1.3;\n  min-width: 0;\n  text-align: left;\n  text-transform: none;\n}\n@media only screen and (max-width:767px) {\n  body:not(.tox-force-desktop) .tox .tox-dialog__body {\n    flex-direction: column;\n  }\n}\n.tox .tox-dialog__body-nav {\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  padding: 16px 16px;\n}\n@media only screen and (max-width:767px) {\n  body:not(.tox-force-desktop) .tox .tox-dialog__body-nav {\n    flex-direction: row;\n    -webkit-overflow-scrolling: touch;\n    overflow-x: auto;\n    padding-bottom: 0;\n  }\n}\n.tox .tox-dialog__body-nav-item {\n  border-bottom: 2px solid transparent;\n  color: rgba(34, 47, 62, 0.7);\n  display: inline-block;\n  font-size: 14px;\n  line-height: 1.3;\n  margin-bottom: 8px;\n  text-decoration: none;\n  white-space: nowrap;\n}\n.tox .tox-dialog__body-nav-item:focus {\n  background-color: rgba(32, 122, 183, 0.1);\n}\n.tox .tox-dialog__body-nav-item--active {\n  border-bottom: 2px solid #207ab7;\n  color: #207ab7;\n}\n.tox .tox-dialog__body-content {\n  box-sizing: border-box;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  -ms-flex-preferred-size: auto;\n  max-height: 650px;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  padding: 16px 16px;\n}\n.tox .tox-dialog__body-content > * {\n  margin-bottom: 0;\n  margin-top: 16px;\n}\n.tox .tox-dialog__body-content > *:first-child {\n  margin-top: 0;\n}\n.tox .tox-dialog__body-content > *:last-child {\n  margin-bottom: 0;\n}\n.tox .tox-dialog__body-content > *:only-child {\n  margin-bottom: 0;\n  margin-top: 0;\n}\n.tox .tox-dialog__body-content a {\n  color: #207ab7;\n  cursor: pointer;\n  text-decoration: none;\n}\n.tox .tox-dialog__body-content a:hover,\n.tox .tox-dialog__body-content a:focus {\n  color: #185d8c;\n  text-decoration: none;\n}\n.tox .tox-dialog__body-content a:active {\n  color: #185d8c;\n  text-decoration: none;\n}\n.tox .tox-dialog__body-content svg {\n  fill: $base-text;\n}\n.tox .tox-dialog__body-content ul {\n  display: block;\n  list-style-type: disc;\n  margin-bottom: 16px;\n  -webkit-margin-end: 0;\n          margin-inline-end: 0;\n  -webkit-margin-start: 0;\n          margin-inline-start: 0;\n  -webkit-padding-start: 2.5rem;\n          padding-inline-start: 2.5rem;\n}\n.tox .tox-dialog__body-content .tox-form__group h1 {\n  color: $base-text;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: bold;\n  letter-spacing: normal;\n  margin-bottom: 16px;\n  margin-top: 2rem;\n  text-transform: none;\n}\n.tox .tox-dialog__body-content .tox-form__group h2 {\n  color: $base-text;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: bold;\n  letter-spacing: normal;\n  margin-bottom: 16px;\n  margin-top: 2rem;\n  text-transform: none;\n}\n.tox .tox-dialog__body-content .tox-form__group p {\n  margin-bottom: 16px;\n}\n.tox .tox-dialog__body-content .tox-form__group h1:first-child,\n.tox .tox-dialog__body-content .tox-form__group h2:first-child,\n.tox .tox-dialog__body-content .tox-form__group p:first-child {\n  margin-top: 0;\n}\n.tox .tox-dialog__body-content .tox-form__group h1:last-child,\n.tox .tox-dialog__body-content .tox-form__group h2:last-child,\n.tox .tox-dialog__body-content .tox-form__group p:last-child {\n  margin-bottom: 0;\n}\n.tox .tox-dialog__body-content .tox-form__group h1:only-child,\n.tox .tox-dialog__body-content .tox-form__group h2:only-child,\n.tox .tox-dialog__body-content .tox-form__group p:only-child {\n  margin-bottom: 0;\n  margin-top: 0;\n}\n.tox .tox-dialog--width-lg {\n  height: 650px;\n  max-width: 1200px;\n}\n.tox .tox-dialog--width-md {\n  max-width: 800px;\n}\n.tox .tox-dialog--width-md .tox-dialog__body-content {\n  overflow: auto;\n}\n.tox .tox-dialog__body-content--centered {\n  text-align: center;\n}\n.tox .tox-dialog__footer {\n  align-items: center;\n  background-color: #fff;\n  border-top: 1px solid $border-light;\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 16px;\n}\n.tox .tox-dialog__footer-start,\n.tox .tox-dialog__footer-end {\n  display: flex;\n}\n.tox .tox-dialog__busy-spinner {\n  align-items: center;\n  background-color: rgba(255, 255, 255, 0.75);\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 3;\n}\n.tox .tox-dialog__table {\n  border-collapse: collapse;\n  width: 100%;\n}\n.tox .tox-dialog__table thead th {\n  font-weight: bold;\n  padding-bottom: 8px;\n}\n.tox .tox-dialog__table tbody tr {\n  border-bottom: 1px solid $border-light;\n}\n.tox .tox-dialog__table tbody tr:last-child {\n  border-bottom: none;\n}\n.tox .tox-dialog__table td {\n  padding-bottom: 8px;\n  padding-top: 8px;\n}\n.tox .tox-dialog__popups {\n  position: absolute;\n  width: 100%;\n  z-index: 1100;\n}\n.tox .tox-dialog__body-iframe {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  -ms-flex-preferred-size: auto;\n}\n.tox .tox-dialog__body-iframe .tox-navobj {\n  display: flex;\n  flex: 1;\n  -ms-flex-preferred-size: auto;\n}\n.tox .tox-dialog__body-iframe .tox-navobj :nth-child(2) {\n  flex: 1;\n  -ms-flex-preferred-size: auto;\n  height: 100%;\n}\n.tox .tox-dialog-dock-fadeout {\n  opacity: 0;\n  visibility: hidden;\n}\n.tox .tox-dialog-dock-fadein {\n  opacity: 1;\n  visibility: visible;\n}\n.tox .tox-dialog-dock-transition {\n  transition: visibility 0s linear 0.3s, opacity 0.3s ease;\n}\n.tox .tox-dialog-dock-transition.tox-dialog-dock-fadein {\n  transition-delay: 0s;\n}\nbody.tox-dialog__disable-scroll {\n  overflow: hidden;\n}\n.tox.tox-platform-ie {\n  /* IE11 CSS styles go here */\n}\n.tox.tox-platform-ie .tox-dialog-wrap {\n  position: -ms-device-fixed;\n}\n@media only screen and (max-width:767px) {\n  body:not(.tox-force-desktop) .tox .tox-dialog__body-nav {\n    @if($rtl==false){\n      margin-right: 0;\n    }\n    @if($rtl==true){\n      margin-left: 0;\n    }\n  }\n}\n@media only screen and (max-width:767px) {\n  body:not(.tox-force-desktop) .tox .tox-dialog__body-nav-item:not(:first-child) {\n    @if($rtl==false){\n      margin-left: 8px;\n    }\n    @if($rtl==true){\n      margin-right: 8px;\n    }\n  }\n}\n.tox .tox-dialog__footer .tox-dialog__footer-start > *,\n.tox .tox-dialog__footer .tox-dialog__footer-end > * {\n  @if($rtl==false){\n    margin-left: 8px;\n  }\n  @if($rtl==true){\n    margin-right: 8px;\n  }\n}\n\n.tox .tox-dropzone-container {\n  display: flex;\n  flex: 1;\n  -ms-flex-preferred-size: auto;\n}\n.tox .tox-dropzone {\n  align-items: center;\n  background: #fff;\n  border: 2px dashed $border-light;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  justify-content: center;\n  min-height: 100px;\n  padding: 10px;\n}\n.tox .tox-dropzone p {\n  color: rgba(34, 47, 62, 0.7);\n  margin: 0 0 16px 0;\n}\n.tox .tox-edit-area {\n  display: flex;\n  flex: 1;\n  -ms-flex-preferred-size: auto;\n  overflow: hidden;\n  position: relative;\n}\n.tox .tox-edit-area__iframe {\n  background-color: #fff;\n  border: 0;\n  box-sizing: border-box;\n  flex: 1;\n  -ms-flex-preferred-size: auto;\n  height: 100%;\n  position: absolute;\n  width: 100%;\n}\n.mce-content-body {\n  font-family: arial;\n}\n.tox.tox-inline-edit-area {\n  border: 1px dotted $border-light;\n}\n.tox .tox-editor-container {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  overflow: hidden;\n}\n.tox .tox-editor-header {\n  z-index: 1;\n}\n.tox:not(.tox-tinymce-inline) .tox-editor-header {\n  box-shadow: none;\n  transition: box-shadow 0.5s;\n}\n.tox.tox-tinymce--toolbar-bottom .tox-editor-header,\n.tox.tox-tinymce-inline .tox-editor-header {\n  margin-bottom: -1px;\n}\n.tox.tox-tinymce--toolbar-sticky-on .tox-editor-header {\n  box-shadow: 0 4px 4px -3px rgba(0, 0, 0, 0.25);\n}\n.tox-editor-dock-fadeout {\n  opacity: 0;\n  visibility: hidden;\n}\n.tox-editor-dock-fadein {\n  opacity: 1;\n  visibility: visible;\n}\n.tox-editor-dock-transition {\n  transition: visibility 0s linear 0.25s, opacity 0.25s ease;\n}\n.tox-editor-dock-transition.tox-editor-dock-fadein {\n  transition-delay: 0s;\n}\n.tox .tox-control-wrap {\n  flex: 1;\n  position: relative;\n}\n.tox .tox-control-wrap:not(.tox-control-wrap--status-invalid) .tox-control-wrap__status-icon-invalid,\n.tox .tox-control-wrap:not(.tox-control-wrap--status-unknown) .tox-control-wrap__status-icon-unknown,\n.tox .tox-control-wrap:not(.tox-control-wrap--status-valid) .tox-control-wrap__status-icon-valid {\n  display: none;\n}\n.tox .tox-control-wrap svg {\n  display: block;\n}\n.tox .tox-control-wrap__status-icon-wrap {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.tox .tox-control-wrap__status-icon-invalid svg {\n  fill: #c00;\n}\n.tox .tox-control-wrap__status-icon-unknown svg {\n  fill: orange;\n}\n.tox .tox-control-wrap__status-icon-valid svg {\n  fill: green;\n}\n.tox .tox-control-wrap--status-invalid .tox-textfield,\n.tox .tox-control-wrap--status-unknown .tox-textfield,\n.tox .tox-control-wrap--status-valid .tox-textfield {\n  @if($rtl==false){\n    padding-right: 32px;\n  }\n  @if($rtl==true){\n    padding-left: 32px;\n  }\n}\n.tox .tox-control-wrap__status-icon-wrap {\n  @if($rtl==false){\n    right: 4px;\n  }\n  @if($rtl==true){\n    left: 4px;\n  }\n}\n.tox .tox-autocompleter {\n  max-width: 25em;\n}\n.tox .tox-autocompleter .tox-menu {\n  max-width: 25em;\n}\n.tox .tox-autocompleter .tox-autocompleter-highlight {\n  font-weight: bold;\n}\n.tox .tox-color-input {\n  display: flex;\n  position: relative;\n  z-index: 1;\n}\n.tox .tox-color-input .tox-textfield {\n  z-index: -1;\n}\n.tox .tox-color-input span {\n  border-color: rgba(34, 47, 62, 0.2);\n  border-radius: 3px;\n  border-style: solid;\n  border-width: 1px;\n  box-shadow: none;\n  box-sizing: border-box;\n  height: 24px;\n  position: absolute;\n  top: 6px;\n  width: 24px;\n}\n.tox .tox-color-input span:hover:not([aria-disabled=true]),\n.tox .tox-color-input span:focus:not([aria-disabled=true]) {\n  border-color: #207ab7;\n  cursor: pointer;\n}\n.tox .tox-color-input span::before {\n  background-image: linear-gradient(45deg, rgba(0, 0, 0, 0.25) 25%, transparent 25%), linear-gradient(-45deg, rgba(0, 0, 0, 0.25) 25%, transparent 25%), linear-gradient(45deg, transparent 75%, rgba(0, 0, 0, 0.25) 75%), linear-gradient(-45deg, transparent 75%, rgba(0, 0, 0, 0.25) 75%);\n  background-position: 0 0, 0 6px, 6px -6px, -6px 0;\n  background-size: 12px 12px;\n  border: 1px solid #fff;\n  border-radius: 3px;\n  box-sizing: border-box;\n  content: '';\n  height: 24px;\n  left: -1px;\n  position: absolute;\n  top: -1px;\n  width: 24px;\n  z-index: -1;\n}\n.tox .tox-color-input span[aria-disabled=true] {\n  cursor: not-allowed;\n}\n.tox .tox-color-input .tox-textfield {\n  @if($rtl==false){\n    padding-left: 36px;\n  }\n  @if($rtl==true){\n    padding-right: 36px;\n  }\n}\n.tox .tox-color-input span {\n  @if($rtl==false){\n    left: 6px;\n  }\n  @if($rtl==true){\n    right: 6px;\n  }\n}\n.tox .tox-label,\n.tox .tox-toolbar-label {\n  color: rgba(34, 47, 62, 0.7);\n  display: block;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: normal;\n  line-height: 1.3;\n  padding: 0 8px 0 0;\n  text-transform: none;\n  white-space: nowrap;\n}\n.tox .tox-toolbar-label {\n  padding: 0 8px;\n}\n.tox .tox-label {\n  @if($rtl==false){\n    padding: 0 0 0 8px;\n  }\n  @if($rtl==true){\n    padding: 0 8px 0 0;\n  }\n}\n.tox .tox-form {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  -ms-flex-preferred-size: auto;\n}\n.tox .tox-form__group {\n  box-sizing: border-box;\n  margin-bottom: 4px;\n}\n.tox .tox-form-group--maximize {\n  flex: 1;\n}\n.tox .tox-form__group--error {\n  color: #c00;\n}\n.tox .tox-form__group--collection {\n  display: flex;\n}\n.tox .tox-form__grid {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n.tox .tox-form__grid--2col > .tox-form__group {\n  width: calc(50% - (8px / 2));\n}\n.tox .tox-form__grid--3col > .tox-form__group {\n  width: calc(100% / 3 - (8px / 2));\n}\n.tox .tox-form__grid--4col > .tox-form__group {\n  width: calc(25% - (8px / 2));\n}\n.tox .tox-form__controls-h-stack {\n  align-items: center;\n  display: flex;\n}\n.tox .tox-form__group--inline {\n  align-items: center;\n  display: flex;\n}\n.tox .tox-form__group--stretched {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  -ms-flex-preferred-size: auto;\n}\n.tox .tox-form__group--stretched .tox-textarea {\n  flex: 1;\n  -ms-flex-preferred-size: auto;\n}\n.tox .tox-form__group--stretched .tox-navobj {\n  display: flex;\n  flex: 1;\n  -ms-flex-preferred-size: auto;\n}\n.tox .tox-form__group--stretched .tox-navobj :nth-child(2) {\n  flex: 1;\n  -ms-flex-preferred-size: auto;\n  height: 100%;\n}\n.tox .tox-form__controls-h-stack > *:not(:first-child) {\n  @if($rtl==false){\n    margin-left: 4px;\n  }\n  @if($rtl==true){\n    margin-right: 4px;\n  }\n}\n\n.tox .tox-lock.tox-locked .tox-lock-icon__unlock,\n.tox .tox-lock:not(.tox-locked) .tox-lock-icon__lock {\n  display: none;\n}\n.tox .tox-textfield,\n.tox .tox-toolbar-textfield,\n.tox .tox-textarea {\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  background-color: #fff;\n  border-color: $border-light;\n  border-radius: 3px;\n  border-style: solid;\n  border-width: 1px;\n  box-shadow: none;\n  box-sizing: border-box;\n  color: $base-text;\n  font-size: 16px;\n  line-height: 24px;\n  margin: 0;\n  min-height: 34px;\n  outline: none;\n  padding: 5px 4.75px;\n  resize: none;\n  width: 100%;\n}\n.tox .tox-textfield[disabled],\n.tox .tox-textarea[disabled] {\n  background-color: #f2f2f2;\n  color: rgba(34, 47, 62, 0.85);\n  cursor: not-allowed;\n}\n.tox .tox-textfield:focus,\n.tox .tox-textarea:focus {\n  background-color: #fff;\n  border-color: #207ab7;\n  box-shadow: none;\n  outline: none;\n}\n.tox .tox-toolbar-textfield {\n  border-width: 0;\n  margin-bottom: 3px;\n  margin-top: 2px;\n  max-width: 250px;\n}\n.tox .tox-naked-btn {\n  background-color: transparent;\n  border: 0;\n  border-color: transparent;\n  box-shadow: unset;\n  color: #207ab7;\n  cursor: pointer;\n  display: block;\n  margin: 0;\n  padding: 0;\n}\n.tox .tox-naked-btn svg {\n  display: block;\n  fill: $base-text;\n}\n.tox .tox-toolbar-textfield + * {\n  @if($rtl==false){\n    margin-left: 4px;\n  }\n  @if($rtl==true){\n    margin-right: 4px;\n  }\n}\n.tox .tox-selectfield {\n  cursor: pointer;\n  position: relative;\n}\n.tox .tox-selectfield select {\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  background-color: #fff;\n  border-color: $border-light;\n  border-radius: 3px;\n  border-style: solid;\n  border-width: 1px;\n  box-shadow: none;\n  box-sizing: border-box;\n  color: $base-text;\n  font-size: 16px;\n  line-height: 24px;\n  margin: 0;\n  min-height: 34px;\n  outline: none;\n  padding: 5px 4.75px;\n  resize: none;\n  width: 100%;\n}\n.tox .tox-selectfield select[disabled] {\n  background-color: #f2f2f2;\n  color: rgba(34, 47, 62, 0.85);\n  cursor: not-allowed;\n}\n.tox .tox-selectfield select::-ms-expand {\n  display: none;\n}\n.tox .tox-selectfield select:focus {\n  background-color: #fff;\n  border-color: #207ab7;\n  box-shadow: none;\n  outline: none;\n}\n.tox .tox-selectfield svg {\n  pointer-events: none;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.tox .tox-selectfield select[size=\"0\"],\n.tox .tox-selectfield select[size=\"1\"] {\n  @if($rtl==false){\n    padding-right: 24px;\n  }\n  @if($rtl==true){\n    padding-left: 24px;\n  }\n}\n.tox .tox-selectfield svg {\n  @if($rtl==false){\n    right: 8px;\n  }\n  @if($rtl==true){\n    left: 8px;\n  }\n}\n.tox .tox-textarea {\n  -webkit-appearance: textarea;\n     -moz-appearance: textarea;\n          appearance: textarea;\n  white-space: pre-wrap;\n}\n.tox-fullscreen {\n  border: 0;\n  height: 100%;\n  left: 0;\n  margin: 0;\n  overflow: hidden;\n  -ms-scroll-chaining: none;\n      overscroll-behavior: none;\n  padding: 0;\n  position: fixed;\n  top: 0;\n  touch-action: pinch-zoom;\n  width: 100%;\n}\n.tox-fullscreen .tox.tox-tinymce.tox-fullscreen .tox-statusbar__resize-handle {\n  display: none;\n}\n.tox-fullscreen .tox.tox-tinymce.tox-fullscreen {\n  z-index: 1200;\n}\n.tox-fullscreen .tox.tox-tinymce-aux {\n  z-index: 1201;\n}\n.tox .tox-help__more-link {\n  list-style: none;\n  margin-top: 1em;\n}\n.tox .tox-image-tools {\n  width: 100%;\n}\n.tox .tox-image-tools__toolbar {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n.tox .tox-image-tools__image {\n  background-color: #666;\n  height: 380px;\n  overflow: auto;\n  position: relative;\n  width: 100%;\n}\n.tox .tox-image-tools__image,\n.tox .tox-image-tools__image + .tox-image-tools__toolbar {\n  margin-top: 8px;\n}\n.tox .tox-image-tools__image-bg {\n  background: url(data:image/gif;base64,R0lGODdhDAAMAIABAMzMzP///ywAAAAADAAMAAACFoQfqYeabNyDMkBQb81Uat85nxguUAEAOw==);\n}\n.tox .tox-image-tools__toolbar > .tox-spacer {\n  flex: 1;\n  -ms-flex-preferred-size: auto;\n}\n.tox .tox-croprect-block {\n  background: black;\n  filter: alpha(opacity=50);\n  opacity: 0.5;\n  position: absolute;\n  zoom: 1;\n}\n.tox .tox-croprect-handle {\n  border: 2px solid white;\n  height: 20px;\n  @if($rtl==false){\n    left: 0;\n  }\n  @if($rtl==true){\n    right: 0;\n  }\n  position: absolute;\n  top: 0;\n  width: 20px;\n}\n.tox .tox-croprect-handle-move {\n  border: 0;\n  cursor: move;\n  position: absolute;\n}\n.tox .tox-croprect-handle-nw {\n  cursor: nw-resize;\n  border-width: 2px 0 0 2px;\n  left: 100px;\n  margin: -2px 0 0 -2px;\n  top: 100px;\n}\n.tox .tox-croprect-handle-ne {\n  border-width: 2px 2px 0 0;\n  cursor: ne-resize;\n  left: 200px;\n  margin: -2px 0 0 -20px;\n  top: 100px;\n}\n.tox .tox-croprect-handle-sw {\n  border-width: 0 0 2px 2px;\n  cursor: sw-resize;\n  left: 100px;\n  margin: -20px 2px 0 -2px;\n  top: 200px;\n}\n.tox .tox-croprect-handle-se {\n  border-width: 0 2px 2px 0;\n  cursor: se-resize;\n  left: 200px;\n  margin: -20px 0 0 -20px;\n  top: 200px;\n}\n.tox .tox-image-tools__toolbar > .tox-slider:not(:first-of-type) {\n  @if($rtl==false){\n    margin-left: 8px;\n  }\n  @if($rtl==true){\n    margin-right: 8px;\n  }\n}\n.tox .tox-image-tools__toolbar > .tox-button + .tox-slider {\n  @if($rtl==false){\n    margin-left: 32px;\n  }\n  @if($rtl==true){\n    margin-right: 32px;\n  }\n}\n.tox .tox-image-tools__toolbar > .tox-slider + .tox-button {\n  @if($rtl==false){\n    margin-left: 32px;\n  }\n  @if($rtl==true){\n    margin-right: 32px;\n  }\n}\n.tox .tox-insert-table-picker {\n  display: flex;\n  flex-wrap: wrap;\n  width: 170px;\n}\n.tox .tox-insert-table-picker > div {\n  border-color: $border-light;\n  border-style: solid;\n  border-width: 0 1px 1px 0;\n  box-sizing: border-box;\n  height: 17px;\n  width: 17px;\n}\n.tox .tox-collection--list .tox-collection__group .tox-insert-table-picker {\n  margin: -4px 0;\n}\n.tox .tox-insert-table-picker .tox-insert-table-picker__selected {\n  background-color: rgba(32, 122, 183, 0.5);\n  border-color: rgba(32, 122, 183, 0.5);\n}\n.tox .tox-insert-table-picker__label {\n  color: rgba(34, 47, 62, 0.7);\n  display: block;\n  font-size: 14px;\n  padding: 4px;\n  text-align: center;\n  width: 100%;\n}\n\n.tox .tox-insert-table-picker > div:nth-child(10n) {\n  @if($rtl==false){\n    border-right: 0;\n  }\n  @if($rtl==true){\n    border-left: 0;\n  }\n}\n.tox {\n  /* stylelint-disable */\n  /* stylelint-enable */\n}\n.tox .tox-menu {\n  background-color: #fff;\n  border: 1px solid $border-light;\n  border-radius: 3px;\n  box-shadow: 0 4px 8px 0 rgba(34, 47, 62, 0.1);\n  display: inline-block;\n  overflow: hidden;\n  vertical-align: top;\n  z-index: 1150;\n}\n.tox .tox-menu.tox-collection.tox-collection--list {\n  padding: 0;\n}\n.tox .tox-menu.tox-collection.tox-collection--toolbar {\n  padding: 4px;\n}\n.tox .tox-menu.tox-collection.tox-collection--grid {\n  padding: 4px;\n}\n.tox .tox-menu__label h1,\n.tox .tox-menu__label h2,\n.tox .tox-menu__label h3,\n.tox .tox-menu__label h4,\n.tox .tox-menu__label h5,\n.tox .tox-menu__label h6,\n.tox .tox-menu__label p,\n.tox .tox-menu__label blockquote,\n.tox .tox-menu__label code {\n  margin: 0;\n}\n.tox .tox-menubar {\n  background: #fff !important;\n  display: flex !important;\n  flex: 0 0 auto !important;\n  flex-shrink: 0 !important;\n  flex-wrap: wrap !important;\n  padding: 0 4px 0 4px !important;\n  border-bottom: 1px solid $border-light;\n}\n.tox.tox-tinymce:not(.tox-tinymce-inline) .tox-editor-header:not(:first-child) .tox-menubar {\n  border-top: 1px solid $border-light !important;\n}\n.tox-tinymce-inline .tox-editor-header .tox-toolbar{\n  &:first-child{\n    border-radius: $border-radius $border-radius 0 0 !important;\n  }\n  &:last-child{\n    border-radius: $border-radius $border-radius !important;\n  }\n}\n/* Deprecated. Remove in next major release */\n.tox .tox-mbtn {\n  align-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 3px;\n  box-shadow: none;\n  color: $base-text;\n  display: flex;\n  flex: 0 0 auto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: normal;\n  height: 34px;\n  justify-content: center;\n  margin: 2px 0 3px 0;\n  outline: none;\n  overflow: hidden;\n  padding: 0 4px;\n  text-transform: none;\n  width: auto;\n}\n.tox .tox-mbtn[disabled] {\n  background-color: transparent;\n  border: 0;\n  box-shadow: none;\n  color: rgba($base-text, 0.5);\n  cursor: not-allowed;\n}\n.tox .tox-mbtn:focus:not(:disabled) {\n  background: $light;\n  border: 0;\n  box-shadow: none;\n  color: $base-text;\n}\n.tox .tox-mbtn--active {\n  background: $light;\n  border: 0;\n  box-shadow: none;\n  color: $base-text;\n}\n.tox .tox-mbtn:hover:not(:disabled):not(.tox-mbtn--active) {\n  background: $light;\n  border: 0;\n  box-shadow: none;\n  color: $base-text;\n}\n.tox .tox-mbtn__select-label {\n  cursor: default;\n  font-weight: normal;\n  margin: 0 4px;\n}\n.tox .tox-mbtn[disabled] .tox-mbtn__select-label {\n  cursor: not-allowed;\n}\n.tox .tox-mbtn__select-chevron {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  width: 16px;\n  display: none;\n}\n.tox .tox-notification {\n  border-radius: 3px;\n  border-style: solid;\n  border-width: 1px;\n  box-shadow: none;\n  box-sizing: border-box;\n  display: -ms-grid;\n  display: grid;\n  font-size: 14px;\n  font-weight: normal;\n  -ms-grid-columns: minmax(40px, 1fr) auto minmax(40px, 1fr);\n      grid-template-columns: minmax(40px, 1fr) auto minmax(40px, 1fr);\n  margin-top: 4px;\n  opacity: 0;\n  padding: 4px;\n  transition: transform 100ms ease-in, opacity 150ms ease-in;\n}\n.tox .tox-notification p {\n  font-size: 14px;\n  font-weight: normal;\n}\n.tox .tox-notification a {\n  text-decoration: underline;\n}\n.tox .tox-notification--in {\n  opacity: 1;\n}\n.tox .tox-notification--success {\n  background-color: #e4eeda;\n  border-color: #d7e6c8;\n  color: $base-text;\n}\n.tox .tox-notification--success p {\n  color: $base-text;\n}\n.tox .tox-notification--success a {\n  color: #547831;\n}\n.tox .tox-notification--success svg {\n  fill: $base-text;\n}\n.tox .tox-notification--error {\n  background-color: #f8dede;\n  border-color: #f2bfbf;\n  color: $base-text;\n}\n.tox .tox-notification--error p {\n  color: $base-text;\n}\n.tox .tox-notification--error a {\n  color: #c00;\n}\n.tox .tox-notification--error svg {\n  fill: $base-text;\n}\n.tox .tox-notification--warn,\n.tox .tox-notification--warning {\n  background-color: #fffaea;\n  border-color: #ffe89d;\n  color: $base-text;\n}\n.tox .tox-notification--warn p,\n.tox .tox-notification--warning p {\n  color: $base-text;\n}\n.tox .tox-notification--warn a,\n.tox .tox-notification--warning a {\n  color: $base-text;\n}\n.tox .tox-notification--warn svg,\n.tox .tox-notification--warning svg {\n  fill: $base-text;\n}\n.tox .tox-notification--info {\n  background-color: #d9edf7;\n  border-color: #779ecb;\n  color: $base-text;\n}\n.tox .tox-notification--info p {\n  color: $base-text;\n}\n.tox .tox-notification--info a {\n  color: $base-text;\n}\n.tox .tox-notification--info svg {\n  fill: $base-text;\n}\n.tox .tox-notification__body {\n  -ms-grid-row-align: center;\n      align-self: center;\n  color: $base-text;\n  font-size: 14px;\n  -ms-grid-column-span: 1;\n  grid-column-end: 3;\n  -ms-grid-column: 2;\n      grid-column-start: 2;\n  -ms-grid-row-span: 1;\n  grid-row-end: 2;\n  -ms-grid-row: 1;\n      grid-row-start: 1;\n  text-align: center;\n  white-space: normal;\n  word-break: break-all;\n  word-break: break-word;\n}\n.tox .tox-notification__body > * {\n  margin: 0;\n}\n.tox .tox-notification__body > * + * {\n  margin-top: 1rem;\n}\n.tox .tox-notification__icon {\n  -ms-grid-row-align: center;\n      align-self: center;\n  -ms-grid-column-span: 1;\n  grid-column-end: 2;\n  -ms-grid-column: 1;\n      grid-column-start: 1;\n  -ms-grid-row-span: 1;\n  grid-row-end: 2;\n  -ms-grid-row: 1;\n      grid-row-start: 1;\n  -ms-grid-column-align: end;\n      justify-self: end;\n}\n.tox .tox-notification__icon svg {\n  display: block;\n}\n.tox .tox-notification__dismiss {\n  -ms-grid-row-align: start;\n      align-self: start;\n  -ms-grid-column-span: 1;\n  grid-column-end: 4;\n  -ms-grid-column: 3;\n      grid-column-start: 3;\n  -ms-grid-row-span: 1;\n  grid-row-end: 2;\n  -ms-grid-row: 1;\n      grid-row-start: 1;\n  -ms-grid-column-align: end;\n      justify-self: end;\n}\n.tox .tox-notification .tox-progress-bar {\n  -ms-grid-column-span: 3;\n  grid-column-end: 4;\n  -ms-grid-column: 1;\n      grid-column-start: 1;\n  -ms-grid-row-span: 1;\n  grid-row-end: 3;\n  -ms-grid-row: 2;\n      grid-row-start: 2;\n  -ms-grid-column-align: center;\n      justify-self: center;\n}\n.tox .tox-pop {\n  display: inline-block;\n  position: relative;\n}\n.tox .tox-pop--resizing {\n  transition: width 0.1s ease;\n}\n.tox .tox-pop--resizing .tox-toolbar {\n  flex-wrap: nowrap;\n}\n.tox .tox-pop__dialog {\n  background-color: #fff;\n  border: 1px solid $border-light;\n  border-radius: 3px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);\n  min-width: 0;\n  overflow: hidden;\n}\n.tox .tox-pop__dialog > *:not(.tox-toolbar) {\n  margin: 4px 4px 4px 8px;\n}\n.tox .tox-pop__dialog .tox-toolbar {\n  background-color: transparent;\n  margin-bottom: -1px;\n}\n.tox .tox-pop::before,\n.tox .tox-pop::after {\n  border-style: solid;\n  content: '';\n  display: block;\n  height: 0;\n  position: absolute;\n  width: 0;\n}\n.tox .tox-pop.tox-pop--bottom::before,\n.tox .tox-pop.tox-pop--bottom::after {\n  left: 50%;\n  top: 100%;\n}\n.tox .tox-pop.tox-pop--bottom::after {\n  border-color: #fff transparent transparent transparent;\n  border-width: 8px;\n  margin-left: -8px;\n  margin-top: -1px;\n}\n.tox .tox-pop.tox-pop--bottom::before {\n  border-color: $border-light transparent transparent transparent;\n  border-width: 9px;\n  margin-left: -9px;\n}\n.tox .tox-pop.tox-pop--top::before,\n.tox .tox-pop.tox-pop--top::after {\n  left: 50%;\n  top: 0;\n  transform: translateY(-100%);\n}\n.tox .tox-pop.tox-pop--top::after {\n  border-color: transparent transparent #fff transparent;\n  border-width: 8px;\n  margin-left: -8px;\n  margin-top: 1px;\n}\n.tox .tox-pop.tox-pop--top::before {\n  border-color: transparent transparent $border-light transparent;\n  border-width: 9px;\n  margin-left: -9px;\n}\n.tox .tox-pop.tox-pop--left::before,\n.tox .tox-pop.tox-pop--left::after {\n  left: 0;\n  top: calc(50% - 1px);\n  transform: translateY(-50%);\n}\n.tox .tox-pop.tox-pop--left::after {\n  border-color: transparent #fff transparent transparent;\n  border-width: 8px;\n  margin-left: -15px;\n}\n.tox .tox-pop.tox-pop--left::before {\n  border-color: transparent $border-light transparent transparent;\n  border-width: 10px;\n  margin-left: -19px;\n}\n.tox .tox-pop.tox-pop--right::before,\n.tox .tox-pop.tox-pop--right::after {\n  left: 100%;\n  top: calc(50% + 1px);\n  transform: translateY(-50%);\n}\n.tox .tox-pop.tox-pop--right::after {\n  border-color: transparent transparent transparent #fff;\n  border-width: 8px;\n  margin-left: -1px;\n}\n.tox .tox-pop.tox-pop--right::before {\n  border-color: transparent transparent transparent $border-light;\n  border-width: 10px;\n  margin-left: -1px;\n}\n.tox .tox-pop.tox-pop--align-left::before,\n.tox .tox-pop.tox-pop--align-left::after {\n  left: 20px;\n}\n.tox .tox-pop.tox-pop--align-right::before,\n.tox .tox-pop.tox-pop--align-right::after {\n  left: calc(100% - 20px);\n}\n.tox .tox-sidebar-wrap {\n  display: flex;\n  flex-direction: row;\n  flex-grow: 1;\n  -ms-flex-preferred-size: 0;\n  min-height: 0;\n}\n.tox .tox-sidebar {\n  background-color: #fff;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n.tox .tox-sidebar__slider {\n  display: flex;\n  overflow: hidden;\n}\n.tox .tox-sidebar__pane-container {\n  display: flex;\n}\n.tox .tox-sidebar__pane {\n  display: flex;\n}\n.tox .tox-sidebar--sliding-closed {\n  opacity: 0;\n}\n.tox .tox-sidebar--sliding-open {\n  opacity: 1;\n}\n.tox .tox-sidebar--sliding-growing,\n.tox .tox-sidebar--sliding-shrinking {\n  transition: width 0.5s ease, opacity 0.5s ease;\n}\n.tox .tox-selector {\n  background-color: #4099ff;\n  border-color: #4099ff;\n  border-style: solid;\n  border-width: 1px;\n  box-sizing: border-box;\n  display: inline-block;\n  height: 10px;\n  position: absolute;\n  width: 10px;\n}\n.tox.tox-platform-touch .tox-selector {\n  height: 12px;\n  width: 12px;\n}\n.tox .tox-slider {\n  align-items: center;\n  display: flex;\n  flex: 1;\n  -ms-flex-preferred-size: auto;\n  height: 24px;\n  justify-content: center;\n  position: relative;\n}\n.tox .tox-slider__rail {\n  background-color: transparent;\n  border: 1px solid $border-light;\n  border-radius: 3px;\n  height: 10px;\n  min-width: 120px;\n  width: 100%;\n}\n.tox .tox-slider__handle {\n  background-color: #207ab7;\n  border: 2px solid #185d8c;\n  border-radius: 3px;\n  box-shadow: none;\n  height: 24px;\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  width: 14px;\n}\n.tox .tox-source-code {\n  overflow: auto;\n}\n.tox .tox-spinner {\n  display: flex;\n}\n.tox .tox-spinner > div {\n  animation: tam-bouncing-dots 1.5s ease-in-out 0s infinite both;\n  background-color: rgba(34, 47, 62, 0.7);\n  border-radius: 100%;\n  height: 8px;\n  width: 8px;\n}\n.tox .tox-spinner > div:nth-child(1) {\n  animation-delay: -0.32s;\n}\n.tox .tox-spinner > div:nth-child(2) {\n  animation-delay: -0.16s;\n}\n@keyframes tam-bouncing-dots {\n  0%,\n  80%,\n  100% {\n    transform: scale(0);\n  }\n  40% {\n    transform: scale(1);\n  }\n}\n.tox .tox-spinner > div:not(:first-child) {\n  @if($rtl==false){\n    margin-left: 4px;\n  }\n  @if($rtl==true){\n    margin-right: 4px;\n  }\n}\n.tox .tox-statusbar {\n  align-items: center !important;\n  background-color: #fff !important;\n  border-top: 1px solid $border-light !important;\n  color: rgba(34, 47, 62, 0.7) !important;\n  display: flex !important;\n  flex: 0 0 auto !important;\n  font-size: 12px !important;\n  font-weight: normal !important;\n  height: 18px !important;\n  overflow: hidden !important;\n  padding: 0 8px !important;\n  position: relative !important;\n  text-transform: uppercase !important;\n}\n.tox .tox-statusbar__text-container {\n  display: flex !important;\n  flex: 1 1 auto !important;\n  justify-content: flex-end !important;\n  overflow: hidden !important;\n}\n.tox .tox-statusbar__path {\n  display: flex !important;\n  flex: 1 1 auto !important;\n  margin-right: auto !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  white-space: nowrap !important;\n}\n.tox .tox-statusbar__path > * {\n  display: inline !important;\n  white-space: nowrap !important;\n}\n.tox .tox-statusbar__wordcount {\n  flex: 0 0 auto;\n  margin-left: 1ch;\n}\n.tox .tox-statusbar a,\n.tox .tox-statusbar__path-item,\n.tox .tox-statusbar__wordcount {\n  color: rgba(34, 47, 62, 0.7) !important; \n  text-decoration: none !important;\n}\n.tox .tox-statusbar a:hover:not(:disabled):not([aria-disabled=true]),\n.tox .tox-statusbar__path-item:hover:not(:disabled):not([aria-disabled=true]),\n.tox .tox-statusbar__wordcount:hover:not(:disabled):not([aria-disabled=true]),\n.tox .tox-statusbar a:focus:not(:disabled):not([aria-disabled=true]),\n.tox .tox-statusbar__path-item:focus:not(:disabled):not([aria-disabled=true]),\n.tox .tox-statusbar__wordcount:focus:not(:disabled):not([aria-disabled=true]) {\n  cursor: pointer;\n  text-decoration: underline;\n}\n.tox .tox-statusbar__resize-handle {\n  align-items: flex-end;\n  align-self: stretch;\n  cursor: nwse-resize;\n  display: flex;\n  flex: 0 0 auto;\n  justify-content: flex-end;\n  margin-left: auto;\n  margin-right: -8px;\n  padding-left: 1ch;\n}\n.tox .tox-statusbar__resize-handle svg {\n  display: block !important;\n  fill: rgba(34, 47, 62, 0.7);\n}\n.tox .tox-statusbar__path > * {\n  @if($rtl==false){\n    margin-right: 4px;\n  }\n  @if($rtl==true){\n    margin-left: 4px;\n  }\n}\n.tox .tox-statusbar {\n  @if($rtl==false){\n  }\n  @if($rtl==true){\n    flex-direction: row-reverse;\n  }\n}\n.tox .tox-throbber {\n  z-index: 1400;\n}\n.tox .tox-throbber__busy-spinner {\n  align-items: center;\n  background-color: rgba(255, 255, 255, 0.6);\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.tox .tox-tbtn {\n  align-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 3px;\n  box-shadow: none;\n  color: $base-text;\n  display: flex;\n  flex: 0 0 auto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: normal;\n  height: 34px;\n  justify-content: center;\n  margin: 2px 0 3px 0;\n  outline: none;\n  overflow: hidden;\n  padding: 0;\n  text-transform: none;\n  width: 34px;\n}\n.tox .tox-tbtn svg {\n  display: block;\n  fill: $base-text;\n}\n.tox .tox-tbtn.tox-tbtn-more {\n  padding-left: 5px;\n  padding-right: 5px;\n  width: inherit;\n}\n.tox .tox-tbtn:focus {\n  background: $light;\n  border: 0;\n  box-shadow: none;\n}\n.tox .tox-tbtn:hover {\n  background: $light;\n  border: 0;\n  box-shadow: none;\n  color: $base-text;\n}\n.tox .tox-tbtn:hover svg {\n  fill: $base-text;\n}\n.tox .tox-tbtn:active {\n  background: #c8cbcf;\n  border: 0;\n  box-shadow: none;\n  color: $base-text;\n}\n.tox .tox-tbtn:active svg {\n  fill: $base-text;\n}\n.tox .tox-tbtn--disabled,\n.tox .tox-tbtn--disabled:hover,\n.tox .tox-tbtn:disabled,\n.tox .tox-tbtn:disabled:hover {\n  background: transparent;\n  border: 0;\n  box-shadow: none;\n  color: rgba($base-text, 0.5);\n  cursor: not-allowed;\n}\n.tox .tox-tbtn--disabled svg,\n.tox .tox-tbtn--disabled:hover svg,\n.tox .tox-tbtn:disabled svg,\n.tox .tox-tbtn:disabled:hover svg {\n  /* stylelint-disable-line no-descending-specificity */\n  fill: rgba($base-text, 0.5);\n}\n.tox .tox-tbtn--enabled,\n.tox .tox-tbtn--enabled:hover {\n  background: #c8cbcf;\n  border: 0;\n  box-shadow: none;\n  color: $base-text;\n}\n.tox .tox-tbtn--enabled > *,\n.tox .tox-tbtn--enabled:hover > * {\n  transform: none;\n}\n.tox .tox-tbtn--enabled svg,\n.tox .tox-tbtn--enabled:hover svg {\n  /* stylelint-disable-line no-descending-specificity */\n  fill: $base-text;\n}\n.tox .tox-tbtn:focus:not(.tox-tbtn--disabled) {\n  color: $base-text;\n}\n.tox .tox-tbtn:focus:not(.tox-tbtn--disabled) svg {\n  fill: $base-text;\n}\n.tox .tox-tbtn:active > * {\n  transform: none;\n}\n.tox .tox-tbtn--md {\n  height: 51px;\n  width: 51px;\n}\n.tox .tox-tbtn--lg {\n  flex-direction: column;\n  height: 68px;\n  width: 68px;\n}\n.tox .tox-tbtn--return {\n  -ms-grid-row-align: stretch;\n      align-self: stretch;\n  height: unset;\n  width: 16px;\n}\n.tox .tox-tbtn--labeled {\n  padding: 0 4px;\n  width: unset;\n}\n.tox .tox-tbtn__vlabel {\n  display: block;\n  font-size: 10px;\n  font-weight: normal;\n  letter-spacing: -0.025em;\n  margin-bottom: 4px;\n  white-space: nowrap;\n}\n.tox .tox-tbtn--select {\n  margin: 2px 0 3px 0;\n  padding: 0 4px;\n  width: auto;\n}\n.tox .tox-tbtn__select-label {\n  cursor: default;\n  font-weight: normal;\n  margin: 0 4px;\n}\n.tox .tox-tbtn__select-chevron {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  width: 16px;\n}\n.tox .tox-tbtn__select-chevron svg {\n  fill: rgba($base-text, 0.5);\n}\n.tox .tox-tbtn--bespoke .tox-tbtn__select-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 7em;\n}\n.tox .tox-split-button {\n  border: 0;\n  border-radius: 3px;\n  box-sizing: border-box;\n  display: flex;\n  margin: 2px 0 3px 0;\n  overflow: hidden;\n}\n.tox .tox-split-button:hover {\n  box-shadow: 0 0 0 1px $light inset;\n}\n.tox .tox-split-button:focus {\n  background: $light;\n  box-shadow: none;\n  color: $base-text;\n}\n.tox .tox-split-button > * {\n  border-radius: 0;\n}\n.tox .tox-split-button__chevron {\n  width: 16px;\n}\n.tox .tox-split-button__chevron svg {\n  fill: rgba($base-text, 0.5);\n}\n.tox .tox-split-button .tox-tbtn {\n  margin: 0;\n}\n.tox.tox-platform-touch .tox-split-button .tox-tbtn:first-child {\n  width: 30px;\n}\n.tox.tox-platform-touch .tox-split-button__chevron {\n  width: 20px;\n}\n.tox .tox-split-button.tox-tbtn--disabled:hover,\n.tox .tox-split-button.tox-tbtn--disabled:focus,\n.tox .tox-split-button.tox-tbtn--disabled .tox-tbtn:hover,\n.tox .tox-split-button.tox-tbtn--disabled .tox-tbtn:focus {\n  background: transparent;\n  box-shadow: none;\n  color: rgba($base-text, 0.5);\n}\n.tox .tox-toolbar-overlord {\n  background-color: #fff;\n}\n.tox .tox-toolbar,\n.tox .tox-toolbar__primary,\n.tox .tox-toolbar__overflow {\n  background: #fff !important;\n  border-bottom: 1px solid $border-light !important;\n  display: flex !important;\n  flex: 0 0 auto !important;\n  flex-shrink: 0 !important;\n  flex-wrap: wrap !important;\n  padding: 0 0 !important;\n}\n.tox .tox-toolbar__overflow.tox-toolbar__overflow--closed {\n  height: 0;\n  opacity: 0;\n  padding-bottom: 0;\n  padding-top: 0;\n  visibility: hidden;\n}\n.tox .tox-toolbar__overflow--growing {\n  transition: height 0.3s ease, opacity 0.2s linear 0.1s;\n}\n.tox .tox-toolbar__overflow--shrinking {\n  transition: opacity 0.3s ease, height 0.2s linear 0.1s, visibility 0s linear 0.3s;\n}\n.tox .tox-menubar + .tox-toolbar,\n.tox .tox-menubar + .tox-toolbar-overlord .tox-toolbar__primary {\n  border-top: 1px solid $border-light !important;\n  margin-top: -1px !important;\n}\n.tox .tox-toolbar--scrolling {\n  flex-wrap: nowrap;\n  overflow-x: auto;\n}\n.tox .tox-pop .tox-toolbar {\n  border-width: 0;\n}\n.tox .tox-toolbar--no-divider {\n  background-image: none !important;\n}\n.tox-tinymce:not(.tox-tinymce-inline) .tox-editor-header:not(:first-child) .tox-toolbar:first-child,\n.tox-tinymce:not(.tox-tinymce-inline) .tox-editor-header:not(:first-child) .tox-toolbar-overlord:first-child .tox-toolbar__primary {\n  border-top: 1px solid $border-light !important;\n}\n.tox.tox-tinymce-aux .tox-toolbar__overflow {\n  background-color: #fff;\n  border: 1px solid $border-light;\n  border-radius: 3px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);\n}\n.tox[dir=rtl] .tox-tbtn__icon-rtl svg {\n  transform: rotateY(180deg);\n}\n.tox .tox-toolbar__group {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  margin: 0 0;\n  padding: 0 4px 0 4px;\n}\n.tox .tox-toolbar__group--pull-right {\n  margin-left: auto;\n}\n.tox .tox-toolbar--scrolling .tox-toolbar__group {\n  flex-shrink: 0;\n  flex-wrap: nowrap;\n}\n.tox .tox-toolbar__group:not(:last-of-type) {\n  @if($rtl==false){\n    border-right: 1px solid $border-light;\n  }\n  @if($rtl==true){\n    border-left: 1px solid $border-light;\n  }\n}\n.tox .tox-tooltip {\n  display: inline-block;\n  padding: 8px;\n  position: relative;\n}\n.tox .tox-tooltip__body {\n  background-color: $base-text !important;\n  border-radius: 3px !important;\n  box-shadow: 0 2px 4px rgba(34, 47, 62, 0.3) !important;\n  color: rgba(255, 255, 255, 0.75) !important;\n  font-size: 14px !important;\n  font-style: normal !important;\n  font-weight: normal !important;\n  padding: 4px 8px !important;\n  text-transform: none !important;\n}\n.tox .tox-tooltip__arrow {\n  position: absolute;\n}\n.tox .tox-tooltip--down .tox-tooltip__arrow {\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-top: 8px solid $base-text;\n  bottom: 0;\n  left: 50%;\n  position: absolute;\n  transform: translateX(-50%);\n}\n.tox .tox-tooltip--up .tox-tooltip__arrow {\n  border-bottom: 8px solid $base-text;\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  left: 50%;\n  position: absolute;\n  top: 0;\n  transform: translateX(-50%);\n}\n.tox .tox-tooltip--right .tox-tooltip__arrow {\n  border-bottom: 8px solid transparent;\n  border-left: 8px solid $base-text;\n  border-top: 8px solid transparent;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.tox .tox-tooltip--left .tox-tooltip__arrow {\n  border-bottom: 8px solid transparent;\n  border-right: 8px solid $base-text;\n  border-top: 8px solid transparent;\n  left: 0;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.tox .tox-well {\n  border: 1px solid $border-light;\n  border-radius: 3px;\n  padding: 8px;\n  width: 100%;\n}\n.tox .tox-well > *:first-child {\n  margin-top: 0;\n}\n.tox .tox-well > *:last-child {\n  margin-bottom: 0;\n}\n.tox .tox-well > *:only-child {\n  margin: 0;\n}\n.tox .tox-custom-editor {\n  border: 1px solid $border-light;\n  border-radius: 3px;\n  display: flex;\n  flex: 1;\n  position: relative;\n}\n/* stylelint-disable */\n.tox {\n  /* stylelint-enable */\n}\n.tox .tox-dialog-loading::before {\n  background-color: rgba(0, 0, 0, 0.5);\n  content: \"\";\n  height: 100%;\n  position: absolute;\n  width: 100%;\n  z-index: 1000;\n}\n.tox .tox-tab {\n  cursor: pointer;\n}\n.tox .tox-dialog__content-js {\n  display: flex;\n  flex: 1;\n  -ms-flex-preferred-size: auto;\n}\n.tox .tox-dialog__body-content .tox-collection {\n  display: flex !important;\n  flex: 1 !important;\n  -ms-flex-preferred-size: auto !important;\n}\n.tox .tox-image-tools-edit-panel {\n  height: 60px;\n}\n.tox .tox-image-tools__sidebar {\n  height: 60px;\n}\n","/**\n * Copyright (c) Tiny Technologies, Inc. All rights reserved.\n * Licensed under the LGPL or a commercial license.\n * For LGPL see License.txt in the project root for license information.\n * For commercial licenses see https://www.tiny.cloud/\n */\n/* RESET all the things! */\n.tinymce-mobile-outer-container {\n  all: initial;\n  display: block;\n}\n.tinymce-mobile-outer-container * {\n  border: 0;\n  box-sizing: initial;\n  cursor: inherit;\n  float: none;\n  line-height: 1;\n  margin: 0;\n  outline: 0;\n  padding: 0;\n  -webkit-tap-highlight-color: transparent;\n  /* TBIO-3691, stop the gray flicker on touch. */\n  text-shadow: none;\n  white-space: nowrap;\n}\n.tinymce-mobile-icon-arrow-back::before {\n  content: \"\\e5cd\";\n}\n.tinymce-mobile-icon-image::before {\n  content: \"\\e412\";\n}\n.tinymce-mobile-icon-cancel-circle::before {\n  content: \"\\e5c9\";\n}\n.tinymce-mobile-icon-full-dot::before {\n  content: \"\\e061\";\n}\n.tinymce-mobile-icon-align-center::before {\n  content: \"\\e234\";\n}\n.tinymce-mobile-icon-align-left::before {\n  content: \"\\e236\";\n}\n.tinymce-mobile-icon-align-right::before {\n  content: \"\\e237\";\n}\n.tinymce-mobile-icon-bold::before {\n  content: \"\\e238\";\n}\n.tinymce-mobile-icon-italic::before {\n  content: \"\\e23f\";\n}\n.tinymce-mobile-icon-unordered-list::before {\n  content: \"\\e241\";\n}\n.tinymce-mobile-icon-ordered-list::before {\n  content: \"\\e242\";\n}\n.tinymce-mobile-icon-font-size::before {\n  content: \"\\e245\";\n}\n.tinymce-mobile-icon-underline::before {\n  content: \"\\e249\";\n}\n.tinymce-mobile-icon-link::before {\n  content: \"\\e157\";\n}\n.tinymce-mobile-icon-unlink::before {\n  content: \"\\eca2\";\n}\n.tinymce-mobile-icon-color::before {\n  content: \"\\e891\";\n}\n.tinymce-mobile-icon-previous::before {\n  content: \"\\e314\";\n}\n.tinymce-mobile-icon-next::before {\n  content: \"\\e315\";\n}\n.tinymce-mobile-icon-large-font::before,\n.tinymce-mobile-icon-style-formats::before {\n  content: \"\\e264\";\n}\n.tinymce-mobile-icon-undo::before {\n  content: \"\\e166\";\n}\n.tinymce-mobile-icon-redo::before {\n  content: \"\\e15a\";\n}\n.tinymce-mobile-icon-removeformat::before {\n  content: \"\\e239\";\n}\n.tinymce-mobile-icon-small-font::before {\n  content: \"\\e906\";\n}\n.tinymce-mobile-icon-readonly-back::before,\n.tinymce-mobile-format-matches::after {\n  content: \"\\e5ca\";\n}\n.tinymce-mobile-icon-small-heading::before {\n  content: \"small\";\n}\n.tinymce-mobile-icon-large-heading::before {\n  content: \"large\";\n}\n.tinymce-mobile-icon-small-heading::before,\n.tinymce-mobile-icon-large-heading::before {\n  font-family: sans-serif;\n  font-size: 80%;\n}\n.tinymce-mobile-mask-edit-icon::before {\n  content: \"\\e254\";\n}\n.tinymce-mobile-icon-back::before {\n  content: \"\\e5c4\";\n}\n.tinymce-mobile-icon-heading::before {\n  /* TODO: Translate */\n  content: \"Headings\";\n  font-family: sans-serif;\n  font-size: 80%;\n  font-weight: bold;\n}\n.tinymce-mobile-icon-h1::before {\n  content: \"H1\";\n  font-weight: bold;\n}\n.tinymce-mobile-icon-h2::before {\n  content: \"H2\";\n  font-weight: bold;\n}\n.tinymce-mobile-icon-h3::before {\n  content: \"H3\";\n  font-weight: bold;\n}\n.tinymce-mobile-outer-container .tinymce-mobile-disabled-mask {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  background: rgba(51, 51, 51, 0.5);\n  height: 100%;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n.tinymce-mobile-outer-container .tinymce-mobile-disabled-mask .tinymce-mobile-content-container {\n  align-items: center;\n  border-radius: 50%;\n  display: flex;\n  flex-direction: column;\n  font-family: sans-serif;\n  font-size: 1em;\n  justify-content: space-between;\n}\n.tinymce-mobile-outer-container .tinymce-mobile-disabled-mask .tinymce-mobile-content-container .mixin-menu-item {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  border-radius: 50%;\n  height: 2.1em;\n  width: 2.1em;\n}\n.tinymce-mobile-outer-container .tinymce-mobile-disabled-mask .tinymce-mobile-content-container .tinymce-mobile-content-tap-section {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  font-size: 1em;\n}\n@media only screen and (min-device-width:700px) {\n  .tinymce-mobile-outer-container .tinymce-mobile-disabled-mask .tinymce-mobile-content-container .tinymce-mobile-content-tap-section {\n    font-size: 1.2em;\n  }\n}\n.tinymce-mobile-outer-container .tinymce-mobile-disabled-mask .tinymce-mobile-content-container .tinymce-mobile-content-tap-section .tinymce-mobile-mask-tap-icon {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  border-radius: 50%;\n  height: 2.1em;\n  width: 2.1em;\n  background-color: white;\n  color: #207ab7;\n}\n.tinymce-mobile-outer-container .tinymce-mobile-disabled-mask .tinymce-mobile-content-container .tinymce-mobile-content-tap-section .tinymce-mobile-mask-tap-icon::before {\n  content: \"\\e900\";\n  font-family: 'tinymce-mobile', sans-serif;\n}\n.tinymce-mobile-outer-container .tinymce-mobile-disabled-mask .tinymce-mobile-content-container .tinymce-mobile-content-tap-section:not(.tinymce-mobile-mask-tap-icon-selected) .tinymce-mobile-mask-tap-icon {\n  z-index: 2;\n}\n.tinymce-mobile-android-container.tinymce-mobile-android-maximized {\n  background: #ffffff;\n  border: none;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n}\n.tinymce-mobile-android-container:not(.tinymce-mobile-android-maximized) {\n  position: relative;\n}\n.tinymce-mobile-android-container .tinymce-mobile-editor-socket {\n  display: flex;\n  flex-grow: 1;\n}\n.tinymce-mobile-android-container .tinymce-mobile-editor-socket iframe {\n  display: flex !important;\n  flex-grow: 1;\n  height: auto !important;\n}\n.tinymce-mobile-android-scroll-reload {\n  overflow: hidden;\n}\n:not(.tinymce-mobile-readonly-mode) > .tinymce-mobile-android-selection-context-toolbar {\n  margin-top: 23px;\n}\n.tinymce-mobile-toolstrip {\n  background: #fff;\n  display: flex;\n  flex: 0 0 auto;\n  z-index: 1;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar {\n  align-items: center;\n  background-color: #fff;\n  border-bottom: 1px solid #cccccc;\n  display: flex;\n  flex: 1;\n  height: 2.5em;\n  width: 100%;\n  /* Make it no larger than the toolstrip, so that it needs to scroll */\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar:not(.tinymce-mobile-context-toolbar) .tinymce-mobile-toolbar-group {\n  align-items: center;\n  display: flex;\n  height: 100%;\n  flex-shrink: 1;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar:not(.tinymce-mobile-context-toolbar) .tinymce-mobile-toolbar-group > div {\n  align-items: center;\n  display: flex;\n  height: 100%;\n  flex: 1;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar:not(.tinymce-mobile-context-toolbar) .tinymce-mobile-toolbar-group.tinymce-mobile-exit-container {\n  background: #f44336;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar:not(.tinymce-mobile-context-toolbar) .tinymce-mobile-toolbar-group.tinymce-mobile-toolbar-scrollable-group {\n  flex-grow: 1;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar:not(.tinymce-mobile-context-toolbar) .tinymce-mobile-toolbar-group .tinymce-mobile-toolbar-group-item {\n  padding-left: 0.5em;\n  padding-right: 0.5em;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar:not(.tinymce-mobile-context-toolbar) .tinymce-mobile-toolbar-group .tinymce-mobile-toolbar-group-item.tinymce-mobile-toolbar-button {\n  align-items: center;\n  display: flex;\n  height: 80%;\n  margin-left: 2px;\n  margin-right: 2px;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar:not(.tinymce-mobile-context-toolbar) .tinymce-mobile-toolbar-group .tinymce-mobile-toolbar-group-item.tinymce-mobile-toolbar-button.tinymce-mobile-toolbar-button-selected {\n  background: #c8cbcf;\n  color: #cccccc;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar:not(.tinymce-mobile-context-toolbar) .tinymce-mobile-toolbar-group:first-of-type,\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar:not(.tinymce-mobile-context-toolbar) .tinymce-mobile-toolbar-group:last-of-type {\n  background: #207ab7;\n  color: #eceff1;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar {\n  /* Note, this file is imported inside .tinymce-mobile-context-toolbar, so that prefix is on everything here. */\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group {\n  align-items: center;\n  display: flex;\n  height: 100%;\n  flex: 1;\n  padding-bottom: 0.4em;\n  padding-top: 0.4em;\n  /* Make any buttons appearing on the left and right display in the centre (e.g. color edges) */\n  /* For widgets like the colour picker, use the whole height */\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serialised-dialog {\n  display: flex;\n  min-height: 1.5em;\n  overflow: hidden;\n  padding-left: 0;\n  padding-right: 0;\n  position: relative;\n  width: 100%;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serialised-dialog .tinymce-mobile-serialised-dialog-chain {\n  display: flex;\n  height: 100%;\n  transition: left cubic-bezier(0.4, 0, 1, 1) 0.15s;\n  width: 100%;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serialised-dialog .tinymce-mobile-serialised-dialog-chain .tinymce-mobile-serialised-dialog-screen {\n  display: flex;\n  flex: 0 0 auto;\n  justify-content: space-between;\n  width: 100%;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serialised-dialog .tinymce-mobile-serialised-dialog-chain .tinymce-mobile-serialised-dialog-screen input {\n  font-family: Sans-serif;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serialised-dialog .tinymce-mobile-serialised-dialog-chain .tinymce-mobile-serialised-dialog-screen .tinymce-mobile-input-container {\n  display: flex;\n  flex-grow: 1;\n  position: relative;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serialised-dialog .tinymce-mobile-serialised-dialog-chain .tinymce-mobile-serialised-dialog-screen .tinymce-mobile-input-container .tinymce-mobile-input-container-x {\n  -ms-grid-row-align: center;\n      align-self: center;\n  background: inherit;\n  border: none;\n  border-radius: 50%;\n  color: #888;\n  font-size: 0.6em;\n  font-weight: bold;\n  height: 100%;\n  padding-right: 2px;\n  position: absolute;\n  right: 0;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serialised-dialog .tinymce-mobile-serialised-dialog-chain .tinymce-mobile-serialised-dialog-screen .tinymce-mobile-input-container.tinymce-mobile-input-container-empty .tinymce-mobile-input-container-x {\n  display: none;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serialised-dialog .tinymce-mobile-serialised-dialog-chain .tinymce-mobile-serialised-dialog-screen .tinymce-mobile-icon-previous,\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serialised-dialog .tinymce-mobile-serialised-dialog-chain .tinymce-mobile-serialised-dialog-screen .tinymce-mobile-icon-next {\n  align-items: center;\n  display: flex;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serialised-dialog .tinymce-mobile-serialised-dialog-chain .tinymce-mobile-serialised-dialog-screen .tinymce-mobile-icon-previous::before,\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serialised-dialog .tinymce-mobile-serialised-dialog-chain .tinymce-mobile-serialised-dialog-screen .tinymce-mobile-icon-next::before {\n  align-items: center;\n  display: flex;\n  font-weight: bold;\n  height: 100%;\n  padding-left: 0.5em;\n  padding-right: 0.5em;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serialised-dialog .tinymce-mobile-serialised-dialog-chain .tinymce-mobile-serialised-dialog-screen .tinymce-mobile-icon-previous.tinymce-mobile-toolbar-navigation-disabled::before,\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serialised-dialog .tinymce-mobile-serialised-dialog-chain .tinymce-mobile-serialised-dialog-screen .tinymce-mobile-icon-next.tinymce-mobile-toolbar-navigation-disabled::before {\n  visibility: hidden;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-dot-item {\n  color: #cccccc;\n  font-size: 10px;\n  line-height: 10px;\n  margin: 0 2px;\n  padding-top: 3px;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-dot-item.tinymce-mobile-dot-active {\n  color: #c8cbcf;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-icon-large-font::before,\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-icon-large-heading::before {\n  margin-left: 0.5em;\n  margin-right: 0.9em;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-icon-small-font::before,\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-icon-small-heading::before {\n  margin-left: 0.9em;\n  margin-right: 0.5em;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-slider {\n  display: flex;\n  flex: 1;\n  margin-left: 0;\n  margin-right: 0;\n  padding: 0.28em 0;\n  position: relative;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-slider .tinymce-mobile-slider-size-container {\n  align-items: center;\n  display: flex;\n  flex-grow: 1;\n  height: 100%;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-slider .tinymce-mobile-slider-size-container .tinymce-mobile-slider-size-line {\n  background: #cccccc;\n  display: flex;\n  flex: 1;\n  height: 0.2em;\n  margin-bottom: 0.3em;\n  margin-top: 0.3em;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-slider.tinymce-mobile-hue-slider-container {\n  padding-left: 2em;\n  padding-right: 2em;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-slider.tinymce-mobile-hue-slider-container .tinymce-mobile-slider-gradient-container {\n  align-items: center;\n  display: flex;\n  flex-grow: 1;\n  height: 100%;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-slider.tinymce-mobile-hue-slider-container .tinymce-mobile-slider-gradient-container .tinymce-mobile-slider-gradient {\n  background: linear-gradient(to right, hsl(0, 100%, 50%) 0%, hsl(60, 100%, 50%) 17%, hsl(120, 100%, 50%) 33%, hsl(180, 100%, 50%) 50%, hsl(240, 100%, 50%) 67%, hsl(300, 100%, 50%) 83%, hsl(0, 100%, 50%) 100%);\n  display: flex;\n  flex: 1;\n  height: 0.2em;\n  margin-bottom: 0.3em;\n  margin-top: 0.3em;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-slider.tinymce-mobile-hue-slider-container .tinymce-mobile-hue-slider-black {\n  /* Not part of theming */\n  background: black;\n  height: 0.2em;\n  margin-bottom: 0.3em;\n  margin-top: 0.3em;\n  width: 1.2em;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-slider.tinymce-mobile-hue-slider-container .tinymce-mobile-hue-slider-white {\n  /* Not part of theming */\n  background: white;\n  height: 0.2em;\n  margin-bottom: 0.3em;\n  margin-top: 0.3em;\n  width: 1.2em;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-slider .tinymce-mobile-slider-thumb {\n  /* vertically centering trick (margin: auto, top: 0, bottom: 0). On iOS and Safari, if you leave\n     * out these values, then it shows the thumb at the top of the spectrum. This is probably because it is\n     * absolutely positioned with only a left value, and not a top. Note, on Chrome it seems to be fine without\n     * this approach.\n    */\n  align-items: center;\n  background-clip: padding-box;\n  background-color: #455a64;\n  border: 0.5em solid rgba(136, 136, 136, 0);\n  border-radius: 3em;\n  bottom: 0;\n  color: #fff;\n  display: flex;\n  height: 0.5em;\n  justify-content: center;\n  left: -10px;\n  margin: auto;\n  position: absolute;\n  top: 0;\n  transition: border 120ms cubic-bezier(0.39, 0.58, 0.57, 1);\n  width: 0.5em;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-slider .tinymce-mobile-slider-thumb.tinymce-mobile-thumb-active {\n  border: 0.5em solid rgba(136, 136, 136, 0.39);\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serializer-wrapper,\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group > div {\n  align-items: center;\n  display: flex;\n  height: 100%;\n  flex: 1;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-serializer-wrapper {\n  flex-direction: column;\n  justify-content: center;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-toolbar-group-item {\n  align-items: center;\n  display: flex;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-toolbar-group-item:not(.tinymce-mobile-serialised-dialog) {\n  height: 100%;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group .tinymce-mobile-dot-container {\n  display: flex;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group input {\n  background: #ffffff;\n  border: none;\n  border-radius: 0;\n  color: #455a64;\n  flex-grow: 1;\n  font-size: 0.85em;\n  padding-bottom: 0.1em;\n  padding-left: 5px;\n  padding-top: 0.1em;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group input::-webkit-input-placeholder {\n  /* WebKit, Blink, Edge */\n  color: #888;\n}\n.tinymce-mobile-toolstrip .tinymce-mobile-toolbar.tinymce-mobile-context-toolbar .tinymce-mobile-toolbar-group input::placeholder {\n  /* WebKit, Blink, Edge */\n  color: #888;\n}\n/* dropup */\n.tinymce-mobile-dropup {\n  background: white;\n  display: flex;\n  overflow: hidden;\n  width: 100%;\n}\n.tinymce-mobile-dropup.tinymce-mobile-dropup-shrinking {\n  transition: height 0.3s ease-out;\n}\n.tinymce-mobile-dropup.tinymce-mobile-dropup-growing {\n  transition: height 0.3s ease-in;\n}\n.tinymce-mobile-dropup.tinymce-mobile-dropup-closed {\n  flex-grow: 0;\n}\n.tinymce-mobile-dropup.tinymce-mobile-dropup-open:not(.tinymce-mobile-dropup-growing) {\n  flex-grow: 1;\n}\n/* TODO min-height for device size and orientation */\n.tinymce-mobile-ios-container .tinymce-mobile-dropup:not(.tinymce-mobile-dropup-closed) {\n  min-height: 200px;\n}\n@media only screen and (orientation: landscape) {\n  .tinymce-mobile-dropup:not(.tinymce-mobile-dropup-closed) {\n    min-height: 200px;\n  }\n}\n@media only screen and (min-device-width : 320px) and (max-device-width : 568px) and (orientation : landscape) {\n  .tinymce-mobile-ios-container .tinymce-mobile-dropup:not(.tinymce-mobile-dropup-closed) {\n    min-height: 150px;\n  }\n}\n/* styles menu */\n.tinymce-mobile-styles-menu {\n  font-family: sans-serif;\n  outline: 4px solid black;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n}\n.tinymce-mobile-styles-menu [role=\"menu\"] {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  position: absolute;\n  width: 100%;\n}\n.tinymce-mobile-styles-menu [role=\"menu\"].transitioning {\n  transition: transform 0.5s ease-in-out;\n}\n.tinymce-mobile-styles-menu .tinymce-mobile-styles-item {\n  border-bottom: 1px solid #ddd;\n  color: #455a64;\n  cursor: pointer;\n  display: flex;\n  padding: 1em 1em;\n  position: relative;\n}\n.tinymce-mobile-styles-menu .tinymce-mobile-styles-collapser .tinymce-mobile-styles-collapse-icon::before {\n  color: #455a64;\n  content: \"\\e314\";\n  font-family: 'tinymce-mobile', sans-serif;\n}\n.tinymce-mobile-styles-menu .tinymce-mobile-styles-item.tinymce-mobile-styles-item-is-menu::after {\n  color: #455a64;\n  content: \"\\e315\";\n  font-family: 'tinymce-mobile', sans-serif;\n  padding-left: 1em;\n  padding-right: 1em;\n  position: absolute;\n  right: 0;\n}\n.tinymce-mobile-styles-menu .tinymce-mobile-styles-item.tinymce-mobile-format-matches::after {\n  font-family: 'tinymce-mobile', sans-serif;\n  padding-left: 1em;\n  padding-right: 1em;\n  position: absolute;\n  right: 0;\n}\n.tinymce-mobile-styles-menu .tinymce-mobile-styles-separator,\n.tinymce-mobile-styles-menu .tinymce-mobile-styles-collapser {\n  align-items: center;\n  background: #fff;\n  border-top: #455a64;\n  color: #455a64;\n  display: flex;\n  min-height: 2.5em;\n  padding-left: 1em;\n  padding-right: 1em;\n}\n.tinymce-mobile-styles-menu [data-transitioning-destination=\"before\"][data-transitioning-state],\n.tinymce-mobile-styles-menu [data-transitioning-state=\"before\"] {\n  transform: translate(-100%);\n}\n.tinymce-mobile-styles-menu [data-transitioning-destination=\"current\"][data-transitioning-state],\n.tinymce-mobile-styles-menu [data-transitioning-state=\"current\"] {\n  transform: translate(0%);\n}\n.tinymce-mobile-styles-menu [data-transitioning-destination=\"after\"][data-transitioning-state],\n.tinymce-mobile-styles-menu [data-transitioning-state=\"after\"] {\n  transform: translate(100%);\n}\n@font-face {\n  font-family: 'tinymce-mobile';\n  font-style: normal;\n  font-weight: normal;\n  src: url('../../../../fonts/tinymce-mobile.woff?8x92w3') format('woff');\n}\n@media (min-device-width: 700px) {\n  .tinymce-mobile-outer-container,\n  .tinymce-mobile-outer-container input {\n    font-size: 25px;\n  }\n}\n@media (max-device-width: 700px) {\n  .tinymce-mobile-outer-container,\n  .tinymce-mobile-outer-container input {\n    font-size: 18px;\n  }\n}\n.tinymce-mobile-icon {\n  font-family: 'tinymce-mobile', sans-serif;\n}\n.mixin-flex-and-centre {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n.mixin-flex-bar {\n  align-items: center;\n  display: flex;\n  height: 100%;\n}\n.tinymce-mobile-outer-container .tinymce-mobile-editor-socket iframe {\n  background-color: #fff;\n  width: 100%;\n}\n.tinymce-mobile-editor-socket .tinymce-mobile-mask-edit-icon {\n  /* Note, on the iPod touch in landscape, this isn't visible when the navbar appears */\n  background-color: #207ab7;\n  border-radius: 50%;\n  bottom: 1em;\n  color: white;\n  font-size: 1em;\n  height: 2.1em;\n  position: fixed;\n  right: 2em;\n  width: 2.1em;\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n@media only screen and (min-device-width:700px) {\n  .tinymce-mobile-editor-socket .tinymce-mobile-mask-edit-icon {\n    font-size: 1.2em;\n  }\n}\n.tinymce-mobile-outer-container:not(.tinymce-mobile-fullscreen-maximized) .tinymce-mobile-editor-socket {\n  height: 300px;\n  overflow: hidden;\n}\n.tinymce-mobile-outer-container:not(.tinymce-mobile-fullscreen-maximized) .tinymce-mobile-editor-socket iframe {\n  height: 100%;\n}\n.tinymce-mobile-outer-container:not(.tinymce-mobile-fullscreen-maximized) .tinymce-mobile-toolstrip {\n  display: none;\n}\n/*\n  Note, that if you don't include this (::-webkit-file-upload-button), the toolbar width gets\n  increased and the whole body becomes scrollable. It's important!\n */\ninput[type=\"file\"]::-webkit-file-upload-button {\n  display: none;\n}\n@media only screen and (min-device-width : 320px) and (max-device-width : 568px) and (orientation : landscape) {\n  .tinymce-mobile-ios-container .tinymce-mobile-editor-socket .tinymce-mobile-mask-edit-icon {\n    bottom: 50%;\n  }\n}\n","\n/* classes attached to <body> */\n\n.fc-not-allowed,\n.fc-not-allowed .fc-event { /* override events' custom cursors */\n  cursor: not-allowed;\n}\n\n.fc-unselectable {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n.fc {\n  /* layout of immediate children */\n  display: flex;\n  flex-direction: column;\n\n  font-size: 1em\n}\n.fc,\n  .fc *,\n  .fc *:before,\n  .fc *:after {\n    box-sizing: border-box;\n  }\n.fc table {\n    border-collapse: collapse;\n    border-spacing: 0;\n    font-size: 1em; /* normalize cross-browser */\n  }\n.fc th {\n    text-align: center;\n  }\n.fc th,\n  .fc td {\n    vertical-align: top;\n    padding: 0;\n  }\n.fc {\n  .table-bordered{\n    border-radius: $border-radius;\n    thead th,thead td{\n      border-bottom-width:0;\n    }\n    thead > tr > th,thead > tr > td{\n      border-bottom-width:1px;\n    }\n  }\n  thead tr:first-child {\n    td, th{\n      &:first-child{\n        border-radius: $border-radius 0 0 0;\n      }\n      &:last-child{\n        border-radius: 0 $border-radius 0 0;\n      }\n    }\n  }\n  tbody tr:last-child {\n    td, th{\n      &:first-child{\n        border-radius: 0 0 0 $border-radius;\n      }\n      &:last-child{\n        border-radius: 0 0 $border-radius 0;\n      }\n    }\n  }\n}\n.fc a[data-navlink] {\n    cursor: pointer;\n  }\n.fc a[data-navlink]:hover {\n    text-decoration: underline;\n  }\n.fc-direction-ltr {\n  direction: ltr;\n  text-align: left;\n}\n.fc-direction-rtl {\n  direction: rtl;\n  text-align: right;\n}\n.fc-theme-standard td,\n  .fc-theme-standard th {\n    border: 1px solid #ddd;\n    border: 1px solid var(--fc-border-color, #ddd);\n  }\n/* for FF, which doesn't expand a 100% div within a table cell. use absolute positioning */\n/* inner-wrappers are responsible for being absolute */\n/* TODO: best place for this? */\n.fc-liquid-hack td,\n  .fc-liquid-hack th {\n    position: relative;\n  }\n\n@font-face {\n  font-family: 'fcicons';\n  src: url(\"data:application/x-font-ttf;charset=utf-8;base64,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\") format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n\n.fc-icon,.fa {\n  /* added for fc */\n  display: inline-block;\n  width: 1em;\n  height: 1em;\n  text-align: center;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'fcicons' !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.fc-icon-chevron-left:before,.fa-chevron-left:before {\n  content: \"\\e900\";\n}\n\n.fc-icon-chevron-right:before,.fa-chevron-right:before {\n  content: \"\\e901\";\n}\n\n.fc-icon-chevrons-left:before,.fa-chevrons-left:before  {\n  content: \"\\e902\";\n}\n\n.fc-icon-chevrons-right:before,.fa-chevrons-right:before {\n  content: \"\\e903\";\n}\n\n.fc-icon-minus-square:before,.fa-minus-square:before {\n  content: \"\\e904\";\n}\n\n.fc-icon-plus-square:before,.fa-plus-square:before {\n  content: \"\\e905\";\n}\n\n.fc-icon-x:before,.fa-times:before {\n  content: \"\\e906\";\n}\n\n/*\nLots taken from Flatly (MIT): https://bootswatch.com/4/flatly/bootstrap.css\n\nThese styles only apply when the standard-theme is activated.\nWhen it's NOT activated, the fc-button classes won't even be in the DOM.\n*/\n.fc {\n\n  /* reset */\n\n}\n.fc .fc-button {\n    border-radius: 0;\n    overflow: visible;\n    text-transform: none;\n    margin: 0;\n    font-family: inherit;\n    font-size: inherit;\n    line-height: inherit;\n  }\n.fc .fc-button:focus {\n    outline: 1px dotted;\n    outline: 5px auto -webkit-focus-ring-color;\n  }\n.fc .fc-button {\n    -webkit-appearance: button;\n  }\n.fc .fc-button:not(:disabled) {\n    cursor: pointer;\n  }\n.fc .fc-button::-moz-focus-inner {\n    padding: 0;\n    border-style: none;\n  }\n.fc {\n\n  /* theme */\n\n}\n.fc .fc-button {\n    display: inline-block;\n    font-weight: 400;\n    text-align: center;\n    vertical-align: middle;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n    background-color: transparent;\n    border: 1px solid transparent;\n    padding: 0.4em 0.65em;\n    font-size: 1em;\n    line-height: 1.5;\n    border-radius: 0.25em;\n  }\n.fc .fc-button:hover {\n    text-decoration: none;\n  }\n.fc .fc-button:focus {\n    outline: 0;\n    box-shadow: 0 0 0 0.2rem rgba(44, 62, 80, 0.25);\n  }\n.fc .fc-button:disabled {\n    opacity: 0.65;\n  }\n.fc {\n\n  /* \"primary\" coloring */\n\n}\n.fc .fc-button-primary {\n    color: #fff;\n    color: var(--fc-button-text-color, #fff);\n    background-color: #2C3E50;\n    background-color: var(--fc-button-bg-color, #2C3E50);\n    border-color: #2C3E50;\n    border-color: var(--fc-button-border-color, #2C3E50);\n  }\n.fc .fc-button-primary:hover {\n    color: #fff;\n    color: var(--fc-button-text-color, #fff);\n    background-color: #1e2b37;\n    background-color: var(--fc-button-hover-bg-color, #1e2b37);\n    border-color: #1a252f;\n    border-color: var(--fc-button-hover-border-color, #1a252f);\n  }\n.fc .fc-button-primary:disabled { /* not DRY */\n    color: #fff;\n    color: var(--fc-button-text-color, #fff);\n    background-color: #2C3E50;\n    background-color: var(--fc-button-bg-color, #2C3E50);\n    border-color: #2C3E50;\n    border-color: var(--fc-button-border-color, #2C3E50); /* overrides :hover */\n  }\n.fc .fc-button-primary:focus {\n    box-shadow: 0 0 0 0.2rem rgba(76, 91, 106, 0.5);\n  }\n.fc .fc-button-primary:not(:disabled):active,\n  .fc .fc-button-primary:not(:disabled).fc-button-active {\n    color: #fff;\n    color: var(--fc-button-text-color, #fff);\n    background-color: #1a252f;\n    background-color: var(--fc-button-active-bg-color, #1a252f);\n    border-color: #151e27;\n    border-color: var(--fc-button-active-border-color, #151e27);\n  }\n.fc .fc-button-primary:not(:disabled):active:focus,\n  .fc .fc-button-primary:not(:disabled).fc-button-active:focus {\n    box-shadow: 0 0 0 0.2rem rgba(76, 91, 106, 0.5);\n  }\n.fc {\n\n  /* icons within buttons */\n\n}\n.fc .fc-button .fc-icon {\n    vertical-align: middle;\n    font-size: 1.5em; /* bump up the size (but don't make it bigger than line-height of button, which is 1.5em also) */\n  }\n.fc .fc-button-group {\n    position: relative;\n    display: inline-flex;\n    vertical-align: middle;\n  }\n.fc .fc-button-group > .fc-button {\n    position: relative;\n    flex: 1 1 auto;\n  }\n.fc .fc-button-group > .fc-button:hover {\n    z-index: 1;\n  }\n.fc .fc-button-group > .fc-button:focus,\n  .fc .fc-button-group > .fc-button:active,\n  .fc .fc-button-group > .fc-button.fc-button-active {\n    z-index: 1;\n  }\n.fc-direction-ltr .fc-button-group > .fc-button:not(:first-child) {\n    margin-left: -1px;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n.fc-direction-ltr .fc-button-group > .fc-button:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n.fc-direction-rtl .fc-button-group > .fc-button:not(:first-child) {\n    margin-right: -1px;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n.fc-direction-rtl .fc-button-group > .fc-button:not(:last-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n.fc .fc-toolbar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  @include media-breakpoint-down(sm){\n    .fc .fc-toolbar {\n      flex-direction: column;\n    }\n  }\n.fc .fc-toolbar.fc-header-toolbar {\n    margin: -.5rem 0 .75rem;\n    .fc-toolbar-chunk{\n      display: flex;\n      align-items: center;\n      padding: .5rem 0;\n      &:empty{\n        display: none;\n      }\n      .btn{\n        position: relative;\n        font-family: $base-font-family;\n        font-weight: $fw-bold;\n        font-size: 12px;\n        background: transparent;\n        color: $base-light;\n        border: 1px solid $border-color;\n        text-transform: capitalize;\n        &:disabled{\n          background: transparent;\n          color: $base-light;\n          border: 1px solid $border-color;\n        }\n        &:hover, &:focus {\n            color: $base-text;\n            background: $lighter;\n            border: 1px solid $border-color;\n        }\n        &:focus {\n            box-shadow: 0 0 0 0.2rem rgba($border-color, 0.5);\n        }\n        &.active {\n            color: $base-color;\n            border: 1px solid $border-color;\n            background: $lighter;\n            box-shadow: inset 0 0 4px -1px rgba($base-light, .25);\n        }\n      }\n      .fc-prev-button,.fc-next-button{\n        border: none !important;\n        &:hover, &:focus {\n          background: transparent !important;\n          box-shadow: none !important;\n        }\n      }\n    }\n}\n\n@include media-breakpoint-down(sm){\n  .fc .fc-toolbar.fc-header-toolbar {\n    .fc-toolbar-chunk{\n      justify-content: space-between;\n      width: 100%;\n      .fc-dayGridMonth-button,.fc-timeGridWeek-button,.fc-timeGridDay-button,.fc-listWeek-button{\n        color: transparent !important;\n        width: $btn-line-height + $btn-padding-y*2;\n        &:before{\n          color: $base-light;\n          position: absolute;\n          top: 50%;\n          left: 50%;\n          transform: translate(-50%,-50%);\n        }\n      }\n      .fc-dayGridMonth-button{\n        &:before{\n          content: 'M';\n        }\n      }\n      .fc-timeGridWeek-button{\n        &:before{\n          content: 'W';\n        }\n      }\n      .fc-timeGridDay-button{\n        &:before{\n          content: 'D';\n        }\n      }\n      .fc-listWeek-button{\n        &:before{\n          content: 'L';\n        }\n      }\n    }\n    .fc-toolbar-title + .btn-group{\n      margin-right: -0.75rem;\n    }\n  }\n}\n\n.fc .fc-toolbar.fc-footer-toolbar {\n    margin-top: 1.5em;\n  }\n.fc .fc-toolbar-title {\n    font-size: 1.125rem;\n    margin: 0;\n  }\n.fc-direction-ltr .fc-toolbar > * > :not(:first-child) {\n    margin-left: .75em; /* space between */\n  }\n.fc-direction-rtl .fc-toolbar > * > :not(:first-child) {\n    margin-right: .75em; /* space between */\n  }\n.fc-direction-rtl .fc-toolbar-ltr { /* when the toolbar-chunk positioning system is explicitly left-to-right */\n    flex-direction: row-reverse;\n  }\n.fc .fc-scroller {\n    -webkit-overflow-scrolling: touch;\n    position: relative; /* for abs-positioned elements within */\n  }\n.fc .fc-scroller-liquid {\n    height: 100%;\n  }\n.fc .fc-scroller-liquid-absolute {\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0;\n  }\n.fc .fc-scroller-harness {\n    position: relative;\n    overflow: hidden;\n    direction: ltr;\n      /* hack for chrome computing the scroller's right/left wrong for rtl. undone below... */\n      /* TODO: demonstrate in codepen */\n  }\n.fc .fc-scroller-harness-liquid {\n    height: 100%;\n  }\n.fc-direction-rtl .fc-scroller-harness > .fc-scroller { /* undo above hack */\n    direction: rtl;\n  }\n.fc-theme-standard .fc-scrollgrid {\n    border: 1px solid #ddd;\n    border: 1px solid var(--fc-border-color, #ddd); /* bootstrap does this. match */\n  }\n.fc .fc-scrollgrid,\n    .fc .fc-scrollgrid table { /* all tables (self included) */\n      width: 100%; /* because tables don't normally do this */\n      table-layout: fixed;\n    }\n.fc .fc-scrollgrid table { /* inner tables */\n      border-top-style: hidden;\n      border-left-style: hidden;\n      border-right-style: hidden;\n    }\n.fc .fc-scrollgrid {\n\n    border-collapse: separate;\n    border-right-width: 0;\n    border-bottom-width: 0;\n\n  }\n.fc .fc-scrollgrid-liquid {\n    height: 100%;\n  }\n.fc .fc-scrollgrid-section { /* a <tr> */\n    height: 1px /* better than 0, for firefox */\n\n  }\n.fc .fc-scrollgrid-section > td {\n      height: 1px; /* needs a height so inner div within grow. better than 0, for firefox */\n    }\n.fc .fc-scrollgrid-section table {\n      height: 1px;\n        /* for most browsers, if a height isn't set on the table, can't do liquid-height within cells */\n        /* serves as a min-height. harmless */\n    }\n.fc .fc-scrollgrid-section-liquid {\n    height: auto\n\n  }\n.fc .fc-scrollgrid-section-liquid > td {\n      height: 100%; /* better than `auto`, for firefox */\n    }\n.fc .fc-scrollgrid-section > * {\n    border-top-width: 0;\n    border-left-width: 0;\n  }\n.fc .fc-scrollgrid-section-header > *,\n  .fc .fc-scrollgrid-section-footer > * {\n    border-bottom-width: 0;\n  }\n.fc .fc-scrollgrid-section-body table,\n  .fc .fc-scrollgrid-section-footer table {\n    border-bottom-style: hidden; /* head keeps its bottom border tho */\n  }\n.fc {\n\n  /* stickiness */\n\n}\n.fc .fc-scrollgrid-section-sticky > * {\n    background: #fff;\n    background: var(--fc-page-bg-color, #fff);\n    position: -webkit-sticky;\n    position: sticky;\n    z-index: 2; /* TODO: var */\n    /* TODO: box-shadow when sticking */\n  }\n.fc .fc-scrollgrid-section-header.fc-scrollgrid-section-sticky > * {\n    top: 0; /* because border-sharing causes a gap at the top */\n      /* TODO: give safari -1. has bug */\n  }\n.fc .fc-scrollgrid-section-footer.fc-scrollgrid-section-sticky > * {\n    bottom: 0; /* known bug: bottom-stickiness doesn't work in safari */\n  }\n.fc .fc-scrollgrid-sticky-shim { /* for horizontal scrollbar */\n    height: 1px; /* needs height to create scrollbars */\n    margin-bottom: -1px;\n  }\n.fc-sticky { /* no .fc wrap because used as child of body */\n  position: -webkit-sticky;\n  position: sticky;\n}\n.fc .fc-view-harness {\n    flex-grow: 1; /* because this harness is WITHIN the .fc's flexbox */\n    position: relative;\n  }\n.fc {\n\n  /* when the harness controls the height, make the view liquid */\n\n}\n.fc .fc-view-harness-active > .fc-view {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n.fc .fc-col-header-cell-cushion {\n    display: inline-block; /* x-browser for when sticky (when multi-tier header) */\n    padding: 2px 4px;\n  }\n.fc .fc-bg-event,\n  .fc .fc-non-business,\n  .fc .fc-highlight {\n    /* will always have a harness with position:relative/absolute, so absolutely expand */\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n  }\n.fc .fc-non-business {\n    background: rgba(215, 215, 215, 0.3);\n    background: var(--fc-non-business-color, rgba(215, 215, 215, 0.3));\n  }\n.fc .fc-bg-event {\n    background: rgb(143, 223, 130);\n    background: var(--fc-bg-event-color, rgb(143, 223, 130));\n    opacity: 0.3;\n    opacity: var(--fc-bg-event-opacity, 0.3)\n  }\n.fc .fc-bg-event .fc-event-title {\n      margin: .5em;\n      font-size: .85em;\n      font-size: var(--fc-small-font-size, .85em);\n      font-style: italic;\n    }\n.fc .fc-highlight {\n    background: rgba(188, 232, 241, 0.3);\n    background: var(--fc-highlight-color, rgba(188, 232, 241, 0.3));\n  }\n.fc .fc-cell-shaded,\n  .fc .fc-day-disabled {\n    background: rgba(208, 208, 208, 0.3);\n    background: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));\n  }\n/* link resets */\n/* ---------------------------------------------------------------------------------------------------- */\n.fc .fc-event{\n  padding: .125rem .375rem;\n  margin: .5rem .375rem;\n}\n\na.fc-event,\na.fc-event:hover {\n  text-decoration: none;\n}\n/* cursor */\n.fc-event[href],\n.fc-event.fc-event-draggable {\n  cursor: pointer;\n}\n/* event text content */\n/* ---------------------------------------------------------------------------------------------------- */\n.fc-event .fc-event-main {\n    position: relative;\n    z-index: 2;\n  }\n/* dragging */\n/* ---------------------------------------------------------------------------------------------------- */\n.fc-event-dragging:not(.fc-event-selected) { /* MOUSE */\n    opacity: 0.75;\n  }\n.fc-event-dragging.fc-event-selected { /* TOUCH */\n    box-shadow: 0 2px 7px rgba(0, 0, 0, 0.3);\n  }\n/* resizing */\n/* ---------------------------------------------------------------------------------------------------- */\n/* (subclasses should hone positioning for touch and non-touch) */\n.fc-event .fc-event-resizer {\n    display: none;\n    position: absolute;\n    z-index: 4;\n  }\n.fc-event:hover, /* MOUSE */\n.fc-event-selected { /* TOUCH */\n\n}\n.fc-event:hover .fc-event-resizer, .fc-event-selected .fc-event-resizer {\n    display: block;\n  }\n.fc-event-selected .fc-event-resizer {\n    border-radius: 4px;\n    border-radius: calc(var(--fc-event-resizer-dot-total-width, 8px) / 2);\n    border-width: 1px;\n    border-width: var(--fc-event-resizer-dot-border-width, 1px);\n    width: 8px;\n    width: var(--fc-event-resizer-dot-total-width, 8px);\n    height: 8px;\n    height: var(--fc-event-resizer-dot-total-width, 8px);\n    border-style: solid;\n    border-color: inherit;\n    background: #fff;\n    background: var(--fc-page-bg-color, #fff)\n\n    /* expand hit area */\n\n  }\n.fc-event-selected .fc-event-resizer:before {\n      content: '';\n      position: absolute;\n      top: -20px;\n      left: -20px;\n      right: -20px;\n      bottom: -20px;\n    }\n/* selecting (always TOUCH) */\n/* ---------------------------------------------------------------------------------------------------- */\n.fc-event-selected {\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2)\n\n  /* expand hit area (subclasses should expand) */\n\n}\n.fc-event-selected:before {\n    content: \"\";\n    position: absolute;\n    z-index: 3;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n  }\n.fc-event-selected {\n\n  /* dimmer effect */\n\n}\n.fc-event-selected:after {\n    content: \"\";\n    background: rgba(0, 0, 0, 0.25);\n    background: var(--fc-event-selected-overlay-color, rgba(0, 0, 0, 0.25));\n    position: absolute;\n    z-index: 1;\n\n    /* assume there's a border on all sides. overcome it. */\n    /* sometimes there's NOT a border, in which case the dimmer will go over */\n    /* an adjacent border, which looks fine. */\n    top: -1px;\n    left: -1px;\n    right: -1px;\n    bottom: -1px;\n  }\n/*\nA HORIZONTAL event\n*/\n.fc-h-event { /* allowed to be top-level */\n  display: block;\n  border: 1px solid $accent-color;\n  background-color: $accent-color;\n\n}\n\n.fc-h-event .fc-event-main-frame {\n    display: flex; /* for make fc-event-title-container expand */\n  }\n.fc-h-event .fc-event-time {\n    max-width: 100%; /* clip overflow on this element */\n    overflow: hidden;\n  }\n.fc-h-event .fc-event-title-container { /* serves as a container for the sticky cushion */\n    flex-grow: 1;\n    flex-shrink: 1;\n    min-width: 0; /* important for allowing to shrink all the way */\n  }\n.fc-h-event .fc-event-title {\n    display: inline-block; /* need this to be sticky cross-browser */\n    vertical-align: top; /* for not messing up line-height */\n    left: 0;  /* for sticky */\n    right: 0; /* for sticky */\n    max-width: 100%; /* clip overflow on this element */\n    overflow: hidden;\n  }\n.fc-h-event.fc-event-selected:before {\n    /* expand hit area */\n    top: -10px;\n    bottom: -10px;\n  }\n/* adjust border and border-radius (if there is any) for non-start/end */\n.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-start),\n.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-end) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-left-width: 0;\n}\n.fc-direction-ltr .fc-daygrid-block-event:not(.fc-event-end),\n.fc-direction-rtl .fc-daygrid-block-event:not(.fc-event-start) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-right-width: 0;\n}\n/* resizers */\n.fc-h-event:not(.fc-event-selected) .fc-event-resizer {\n  top: 0;\n  bottom: 0;\n  width: 8px;\n  width: var(--fc-event-resizer-thickness, 8px);\n}\n.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start,\n.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end {\n  cursor: w-resize;\n  left: -4px;\n  left: calc(var(--fc-event-resizer-thickness, 8px) / -2);\n}\n.fc-direction-ltr .fc-h-event:not(.fc-event-selected) .fc-event-resizer-end,\n.fc-direction-rtl .fc-h-event:not(.fc-event-selected) .fc-event-resizer-start {\n  cursor: e-resize;\n  right: -4px;\n  right: calc(var(--fc-event-resizer-thickness, 8px) / -2);\n}\n/* resizers for TOUCH */\n.fc-h-event.fc-event-selected .fc-event-resizer {\n  top: 50%;\n  margin-top: -4px;\n  margin-top: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);\n}\n.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-start,\n.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-end {\n  left: -4px;\n  left: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);\n}\n.fc-direction-ltr .fc-h-event.fc-event-selected .fc-event-resizer-end,\n.fc-direction-rtl .fc-h-event.fc-event-selected .fc-event-resizer-start {\n  right: -4px;\n  right: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);\n}\n\n\n:root {\n  --fc-daygrid-event-dot-width: 8px;\n}\n.fc .fc-popover {\n    position: fixed;\n    top: 0; /* for when not positioned yet */\n    box-shadow: 0 2px 6px rgba(0,0,0,.15);\n  }\n.fc .fc-popover-header {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    padding: 3px 4px;\n  }\n.fc .fc-popover-title {\n    margin: 0 2px;\n  }\n.fc .fc-popover-close {\n    cursor: pointer;\n    opacity: 0.65;\n    font-size: 1.1em;\n  }\n.fc-theme-standard .fc-popover {\n    border: 1px solid #ddd;\n    border: 1px solid var(--fc-border-color, #ddd);\n    background: #fff;\n    background: var(--fc-page-bg-color, #fff);\n  }\n.fc-theme-standard .fc-popover-header {\n    background: rgba(208, 208, 208, 0.3);\n    background: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));\n  }\n/* help things clear margins of inner content */\n.fc-daygrid-day-frame,\n.fc-daygrid-day-events,\n.fc-daygrid-event-harness { /* for event top/bottom margins */\n}\n.fc-daygrid-day-frame:before, .fc-daygrid-day-events:before, .fc-daygrid-event-harness:before {\n  content: \"\";\n  clear: both;\n  display: table; }\n.fc-daygrid-day-frame:after, .fc-daygrid-day-events:after, .fc-daygrid-event-harness:after {\n  content: \"\";\n  clear: both;\n  display: table; }\n.fc .fc-daygrid-body { /* a <div> that wraps the table */\n    position: relative;\n    z-index: 1; /* container inner z-index's because <tr>s can't do it */\n  }\n.fc .fc-daygrid-day.fc-day-today {\n      background-color: rgba($accent-color, 0.07);\n    }\n.fc .fc-daygrid-day-frame {\n    position: relative;\n    min-height: 100%; /* seems to work better than `height` because sets height after rows/cells naturally do it */\n  }\n.fc {\n\n  /* cell top */\n\n}\n.fc .fc-daygrid-day-top {\n    display: flex;\n    flex-direction: row-reverse;\n  }\n.fc .fc-day-other .fc-daygrid-day-top {\n    opacity: 0.5;\n  }\n.fc {\n\n  /* day number (within cell top) */\n\n}\n.fc .fc-daygrid-day-number {\n    position: relative;\n    z-index: 4;\n    padding: 4px;\n  }\n.fc {\n\n  /* event container */\n\n}\n.fc .fc-daygrid-day-events {\n    margin-top: 1px; /* needs to be margin, not padding, so that available cell height can be computed */\n  }\n.fc {\n\n  /* positioning for balanced vs natural */\n\n}\n.fc .fc-daygrid-body-balanced .fc-daygrid-day-events {\n      position: absolute;\n      left: 0;\n      right: 0;\n    }\n.fc .fc-daygrid-body-unbalanced .fc-daygrid-day-events {\n      position: relative; /* for containing abs positioned event harnesses */\n      min-height: 2em; /* in addition to being a min-height during natural height, equalizes the heights a little bit */\n    }\n.fc .fc-daygrid-body-natural { /* can coexist with -unbalanced */\n  }\n.fc .fc-daygrid-body-natural .fc-daygrid-day-events {\n      margin-bottom: 1em;\n    }\n.fc {\n\n  /* event harness */\n\n}\n.fc .fc-daygrid-event-harness {\n    position: relative;\n  }\n.fc .fc-daygrid-event-harness-abs {\n    position: absolute;\n    top: 0; /* fallback coords for when cannot yet be computed */\n    left: 0; /* */\n    right: 0; /* */\n  }\n.fc .fc-daygrid-bg-harness {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n  }\n.fc {\n\n  /* bg content */\n\n}\n.fc .fc-daygrid-day-bg .fc-non-business { z-index: 1 }\n.fc .fc-daygrid-day-bg .fc-bg-event { z-index: 2 }\n.fc .fc-daygrid-day-bg .fc-highlight { z-index: 3 }\n.fc {\n\n  /* events */\n\n}\n.fc .fc-daygrid-event {\n    z-index: 6;\n    margin: .375rem .5rem !important;\n  }\n.fc .fc-daygrid-event.fc-event-mirror {\n    z-index: 7;\n  }\n.fc {\n\n  /* cell bottom (within day-events) */\n\n}\n.fc .fc-daygrid-day-bottom {\n    font-size: .85em;\n    margin: 2px 3px 0;\n  }\n.fc .fc-daygrid-more-link {\n    position: relative;\n    z-index: 4;\n    cursor: pointer;\n  }\n.fc {\n\n  /* week number (within frame) */\n\n}\n.fc .fc-daygrid-week-number {\n    position: absolute;\n    z-index: 5;\n    top: 0;\n    padding: 2px;\n    min-width: 1.5em;\n    text-align: center;\n    background-color: rgba(208, 208, 208, 0.3);\n    background-color: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));\n    color: #808080;\n    color: var(--fc-neutral-text-color, #808080);\n  }\n.fc {\n\n  /* popover */\n\n}\n.fc .fc-more-popover {\n    z-index: 8;\n  }\n.fc .fc-more-popover .fc-popover-body {\n    min-width: 220px;\n    padding: 10px;\n  }\n.fc-direction-ltr .fc-daygrid-event.fc-event-start,\n.fc-direction-rtl .fc-daygrid-event.fc-event-end {\n  margin-left: .25rem;\n}\n.fc-direction-ltr .fc-daygrid-event.fc-event-end,\n.fc-direction-rtl .fc-daygrid-event.fc-event-start {\n  margin-right: .25rem;\n}\n.fc-direction-ltr .fc-daygrid-week-number {\n    left: 0;\n    border-radius: 0 0 3px 0;\n  }\n.fc-direction-rtl .fc-daygrid-week-number {\n    right: 0;\n    border-radius: 0 0 0 3px;\n  }\n.fc-liquid-hack .fc-daygrid-day-frame {\n    position: static; /* will cause inner absolute stuff to expand to <td> */\n  }\n.fc-daygrid-event { /* make root-level, because will be dragged-and-dropped outside of a component root */\n  position: relative; /* for z-indexes assigned later */\n  white-space: nowrap;\n  border-radius: 3px; /* dot event needs this to when selected */\n  font-size: .85em;\n  font-size: var(--fc-small-font-size, .85em);\n}\n/* --- the rectangle (\"block\") style of event --- */\n.fc-daygrid-block-event .fc-event-time {\n    font-weight: bold;\n  }\n.fc-daygrid-block-event .fc-event-time,\n  .fc-daygrid-block-event .fc-event-title {\n    padding: 1px;\n  }\n/* --- the dot style of event --- */\n.fc-daygrid-dot-event {\n  display: flex;\n  align-items: center;\n  padding: .25rem .25rem;\n\n}\n.fc-daygrid-dot-event .fc-event-title {\n    flex-grow: 1;\n    flex-shrink: 1;\n    min-width: 0; /* important for allowing to shrink all the way */\n    overflow: hidden;\n    font-weight: bold;\n  }\n.fc-daygrid-dot-event:hover,\n  .fc-daygrid-dot-event.fc-event-mirror {\n    background: rgba(0, 0, 0, 0.1);\n  }\n.fc-daygrid-dot-event.fc-event-selected:before {\n    /* expand hit area */\n    top: -10px;\n    bottom: -10px;\n  }\n.fc-daygrid-event-dot { /* the actual dot */\n  margin: -2px 4px 0;\n  box-sizing: content-box;\n  width: 0;\n  height: 0;\n  border: 3px solid $accent-color;\n  border-radius: 4px;\n}\n/* --- spacing between time and title --- */\n.fc-direction-ltr .fc-daygrid-event .fc-event-time {\n    margin-right: 3px;\n  }\n.fc-direction-rtl .fc-daygrid-event .fc-event-time {\n    margin-left: 3px;\n  }\n\n\n/*\nA VERTICAL event\n*/\n\n.fc-v-event { /* allowed to be top-level */\n  display: block;\n  border: 1px solid $accent-color;\n  background-color: $accent-color;\n\n}\n\n.fc-v-event .fc-event-main {\n    height: 100%;\n  }\n\n.fc-v-event .fc-event-main-frame {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n  }\n\n.fc-v-event .fc-event-time {\n    flex-grow: 0;\n    flex-shrink: 0;\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n.fc-v-event .fc-event-title-container { /* a container for the sticky cushion */\n    flex-grow: 1;\n    flex-shrink: 1;\n    min-height: 0; /* important for allowing to shrink all the way */\n  }\n\n.fc-v-event .fc-event-title { /* will have fc-sticky on it */\n    top: 0;\n    bottom: 0;\n    max-height: 100%; /* clip overflow */\n    overflow: hidden;\n  }\n\n.fc-v-event:not(.fc-event-start) {\n    border-top-width: 0;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n\n.fc-v-event:not(.fc-event-end) {\n    border-bottom-width: 0;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n.fc-v-event.fc-event-selected:before {\n    /* expand hit area */\n    left: -10px;\n    right: -10px;\n  }\n\n.fc-v-event {\n\n  /* resizer (mouse AND touch) */\n\n}\n\n.fc-v-event .fc-event-resizer-start {\n    cursor: n-resize;\n  }\n\n.fc-v-event .fc-event-resizer-end {\n    cursor: s-resize;\n  }\n\n.fc-v-event {\n\n  /* resizer for MOUSE */\n\n}\n\n.fc-v-event:not(.fc-event-selected) .fc-event-resizer {\n      height: 8px;\n      height: var(--fc-event-resizer-thickness, 8px);\n      left: 0;\n      right: 0;\n    }\n\n.fc-v-event:not(.fc-event-selected) .fc-event-resizer-start {\n      top: -4px;\n      top: calc(var(--fc-event-resizer-thickness, 8px) / -2);\n    }\n\n.fc-v-event:not(.fc-event-selected) .fc-event-resizer-end {\n      bottom: -4px;\n      bottom: calc(var(--fc-event-resizer-thickness, 8px) / -2);\n    }\n\n.fc-v-event {\n\n  /* resizer for TOUCH (when event is \"selected\") */\n\n}\n\n.fc-v-event.fc-event-selected .fc-event-resizer {\n      left: 50%;\n      margin-left: -4px;\n      margin-left: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);\n    }\n\n.fc-v-event.fc-event-selected .fc-event-resizer-start {\n      top: -4px;\n      top: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);\n    }\n\n.fc-v-event.fc-event-selected .fc-event-resizer-end {\n      bottom: -4px;\n      bottom: calc(var(--fc-event-resizer-dot-total-width, 8px) / -2);\n    }\n.fc .fc-timegrid .fc-daygrid-body { /* the all-day daygrid within the timegrid view */\n    z-index: 2; /* put above the timegrid-body so that more-popover is above everything. TODO: better solution */\n  }\n.fc .fc-timegrid-divider {\n    padding: 0 0 2px; /* browsers get confused when you set height. use padding instead */\n  }\n.fc .fc-timegrid-body {\n    position: relative;\n    z-index: 1; /* scope the z-indexes of slots and cols */\n    min-height: 100%; /* fill height always, even when slat table doesn't grow */\n  }\n.fc .fc-timegrid-axis-chunk { /* for advanced ScrollGrid */\n    position: relative /* offset parent for now-indicator-container */\n\n  }\n.fc .fc-timegrid-axis-chunk > table {\n      position: relative;\n      z-index: 1; /* above the now-indicator-container */\n    }\n.fc .fc-timegrid-slots {\n    position: relative;\n    z-index: 1;\n  }\n.fc .fc-timegrid-slot { /* a <td> */\n    height: 1.5em;\n    border-bottom: 0; /* each cell owns its top border */\n    padding: .25rem;\n  }\n.fc .fc-timegrid-slot:empty:before {\n      content: '\\00a0'; /* make sure there's at least an empty space to create height for height syncing */\n    }\n.fc .fc-timegrid-slot-minor {\n    border-top-style: dotted;\n  }\n.fc .fc-timegrid-slot-label-cushion {\n    display: inline-block;\n    white-space: nowrap;\n  }\n.fc .fc-timegrid-slot-label {\n    vertical-align: middle; /* vertical align the slots */\n  }\n.fc {\n\n\n  /* slots AND axis cells (top-left corner of view including the \"all-day\" text) */\n\n}\n.fc .fc-timegrid-axis-cushion,\n  .fc .fc-timegrid-slot-label-cushion {\n    padding: 0 4px;\n  }\n.fc {\n\n\n  /* axis cells (top-left corner of view including the \"all-day\" text) */\n  /* vertical align is more complicated, uses flexbox */\n\n}\n.fc .fc-timegrid-axis-frame-liquid {\n    height: 100%; /* will need liquid-hack in FF */\n  }\n.fc .fc-timegrid-axis-frame {\n    overflow: hidden;\n    display: flex;\n    align-items: center; /* vertical align */\n    justify-content: flex-end; /* horizontal align. matches text-align below */\n  }\n.fc .fc-timegrid-axis-cushion {\n    max-width: 60px; /* limits the width of the \"all-day\" text */\n    flex-shrink: 0; /* allows text to expand how it normally would, regardless of constrained width */\n  }\n.fc-direction-ltr .fc-timegrid-slot-label-frame {\n    text-align: right;\n  }\n.fc-direction-rtl .fc-timegrid-slot-label-frame {\n    text-align: left;\n  }\n.fc-liquid-hack .fc-timegrid-axis-frame-liquid {\n  height: auto;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  }\n.fc .fc-timegrid-col.fc-day-today {\n      background-color: rgba($accent-color, 0.07);\n    }\n.fc .fc-timegrid-col-frame {\n    min-height: 100%; /* liquid-hack is below */\n    position: relative;\n  }\n.fc-liquid-hack .fc-timegrid-col-frame {\n  height: auto;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  }\n.fc-media-screen .fc-timegrid-cols {\n    position: absolute; /* no z-index. children will decide and go above slots */\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0\n  }\n.fc-media-screen .fc-timegrid-cols > table {\n      height: 100%;\n    }\n.fc-media-screen .fc-timegrid-col-bg,\n  .fc-media-screen .fc-timegrid-col-events,\n  .fc-media-screen .fc-timegrid-now-indicator-container {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n  }\n.fc-media-screen .fc-timegrid-event-harness {\n    position: absolute; /* top/left/right/bottom will all be set by JS */\n  }\n.fc {\n\n  /* bg */\n\n}\n.fc .fc-timegrid-col-bg {\n    z-index: 2; /* TODO: kill */\n  }\n.fc .fc-timegrid-col-bg .fc-non-business { z-index: 1 }\n.fc .fc-timegrid-col-bg .fc-bg-event { z-index: 2 }\n.fc .fc-timegrid-col-bg .fc-highlight { z-index: 3 }\n.fc .fc-timegrid-bg-harness {\n    position: absolute; /* top/bottom will be set by JS */\n    left: 0;\n    right: 0;\n  }\n.fc {\n\n  /* fg events */\n  /* (the mirror segs are put into a separate container with same classname, */\n  /* and they must be after the normal seg container to appear at a higher z-index) */\n\n}\n.fc .fc-timegrid-col-events {\n    z-index: 3;\n    /* child event segs have z-indexes that are scoped within this div */\n  }\n.fc {\n\n  /* now indicator */\n\n}\n.fc .fc-timegrid-now-indicator-container {\n    bottom: 0;\n    overflow: hidden; /* don't let overflow of lines/arrows cause unnecessary scrolling */\n    /* z-index is set on the individual elements */\n  }\n.fc-direction-ltr .fc-timegrid-col-events {\n    margin: 0 2.5% 0 2px;\n  }\n.fc-direction-rtl .fc-timegrid-col-events {\n    margin: 0 2px 0 2.5%;\n  }\n.fc-timegrid-event-harness-inset .fc-timegrid-event,\n.fc-timegrid-event.fc-event-mirror {\n  box-shadow: 0px 0px 0px 1px #fff;\n  box-shadow: 0px 0px 0px 1px var(--fc-page-bg-color, #fff);\n}\n.fc-timegrid-event { /* events need to be root */\n\n  font-size: .85em;\n\n  font-size: var(--fc-small-font-size, .85em);\n  border-radius: 3px\n\n}\n.fc-timegrid-event .fc-event-main {\n    padding: 1px 1px 0;\n  }\n.fc-timegrid-event .fc-event-time {\n    white-space: nowrap;\n    font-size: .85em;\n    font-size: var(--fc-small-font-size, .85em);\n    margin-bottom: 1px;\n  }\n.fc-timegrid-event-condensed .fc-event-main-frame {\n    flex-direction: row;\n    overflow: hidden;\n  }\n.fc-timegrid-event-condensed .fc-event-time:after {\n    content: '\\00a0-\\00a0'; /* dash surrounded by non-breaking spaces */\n  }\n.fc-timegrid-event-condensed .fc-event-title {\n    font-size: .85em;\n    font-size: var(--fc-small-font-size, .85em)\n  }\n.fc-media-screen .fc-timegrid-event {\n    position: absolute; /* absolute WITHIN the harness */\n    top: 0;\n    bottom: 1px; /* stay away from bottom slot line */\n    left: 0;\n    right: 0;\n  }\n.fc {\n\n  /* line */\n\n}\n.fc .fc-timegrid-now-indicator-line {\n    position: absolute;\n    z-index: 4;\n    left: 0;\n    right: 0;\n    border-style: solid;\n    border-color: $danger;\n    border-width: 1px 0 0;\n  }\n.fc {\n\n  /* arrow */\n\n}\n.fc .fc-timegrid-now-indicator-arrow {\n    position: absolute;\n    z-index: 4;\n    margin-top: -5px; /* vertically center on top coordinate */\n    border-style: solid;\n    border-color: $danger;\n  }\n.fc-direction-ltr .fc-timegrid-now-indicator-arrow {\n    left: 0;\n\n    /* triangle pointing right. TODO: mixin */\n    border-width: 5px 0 5px 6px;\n    border-top-color: transparent;\n    border-bottom-color: transparent;\n  }\n.fc-direction-rtl .fc-timegrid-now-indicator-arrow {\n    right: 0;\n\n    /* triangle pointing left. TODO: mixin */\n    border-width: 5px 6px 5px 0;\n    border-top-color: transparent;\n    border-bottom-color: transparent;\n  }\n\n\n:root {\n  --fc-list-event-dot-width: 10px;\n  --fc-list-event-hover-bg-color: #f5f5f5;\n}\n.fc-theme-standard .fc-list {\n    border: 1px solid #ddd;\n  }\n.fc {\n\n  /* message when no events */\n\n}\n.fc .fc-list-empty {\n    background-color: $lighter;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center; /* vertically aligns fc-list-empty-inner */\n  }\n.fc .fc-list-empty-cushion {\n    margin: 5em 0;\n  }\n.fc {\n\n  /* table within the scroller */\n  /* ---------------------------------------------------------------------------------------------------- */\n\n}\n.fc .fc-list-table {\n    width: 100%;\n    border-style: hidden; /* kill outer border on theme */\n  }\n.fc .fc-list-table tr > * {\n    border-left: 0;\n    border-right: 0;\n  }\n.fc .fc-list-sticky .fc-list-day > * { /* the cells */\n      position: -webkit-sticky;\n      position: sticky;\n      top: 0;\n      background: #fff;\n      background: var(--fc-page-bg-color, #fff); /* for when headers are styled to be transparent and sticky */\n    }\n.fc .fc-list-table th {\n    padding: 0; /* uses an inner-wrapper instead... */\n  }\n.fc .fc-list-table td,\n.fc .fc-list-day-cushion {\n  padding: .75rem 1rem;\n}\n.fc .fc-list-table th .fc-list-day-cushion{\n  padding: .5rem 1rem;\n}\n.fc {\n\n\n  /* date heading rows */\n  /* ---------------------------------------------------------------------------------------------------- */\n\n}\n.fc .fc-list-day-cushion:after {\n  content: \"\";\n  clear: both;\n  display: table; /* clear floating */\n    }\n.fc-theme-standard .fc-list-day-cushion {\n    background-color: rgba(208, 208, 208, 0.3);\n    background-color: var(--fc-neutral-bg-color, rgba(208, 208, 208, 0.3));\n  }\n.fc-direction-ltr .fc-list-day-text,\n.fc-direction-rtl .fc-list-day-side-text {\n  float: left;\n}\n.fc-direction-ltr .fc-list-day-side-text,\n.fc-direction-rtl .fc-list-day-text {\n  float: right;\n}\n/* make the dot closer to the event title */\n.fc-direction-ltr .fc-list-table .fc-list-event-graphic { padding-right: 0 }\n.fc-direction-rtl .fc-list-table .fc-list-event-graphic { padding-left: 0 }\n.fc .fc-list-event.fc-event-forced-url {\n    cursor: pointer; /* whole row will seem clickable */\n  }\n.fc {\n\n  /* shrink certain cols */\n\n}\n.fc .fc-list-event-graphic,\n  .fc .fc-list-event-time {\n    white-space: nowrap;\n    width: 1px;\n  }\n.fc .fc-list-event-dot {\n    display: inline-block;\n    width: 10px;\n    height: 10px;\n    background-color: $accent-color;\n    border:2px solid $accent-color;\n    border-radius: 5px;\n  }\n.fc {\n\n  /* reset <a> styling */\n\n}\n.fc .fc-list-event-title a {\n    color: inherit;\n    text-decoration: none;\n  }\n.fc {\n\n  /* underline link when hovering over any part of row */\n\n}\n.fc .fc-list-event.fc-event-forced-url:hover a {\n    text-decoration: underline;\n  }\n\n\n\n  .fc-theme-bootstrap a:not([href]) {\n    color: inherit; /* natural color for navlinks */\n  }\n  .fc a.fc-event:not([href]){\n    color: $white;\n    background: $accent-color;\n    .fc-daygrid-event-dot{\n      border-color: $white;\n    }\n  }\n  //\n\n.fc-prev-button,.fc-next-button{\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  > .fa{\n    font-size: 1.25rem;\n  }\n}\n\nspan[class*=\"fc-event\"] .dot{\n  display: inline-block;\n  border: 1px solid $accent-color;\n  margin-right: 0.5rem;\n}\n\n$colors: (\n    \"primary\"         $accent-color,\n    \"success\"         $success,\n    \"info\"            $info,\n    \"warning\"         $warning,\n    \"danger\"          $danger,\n    \"secondary\"       $secondary,\n    \"dark\"            $dark,\n    \"blue\"            $blue,\n    \"azure\"           $azure,\n    \"indigo\"          $indigo,\n    \"purple\"          $purple,\n    \"pink\"            $pink,\n    \"orange\"          $orange,\n    \"teal\"            $teal,\n);\n\n@each $name, $color in $colors{\n  a.fc-event-#{$name} {\n    background-color: $color !important;\n    border-color: $color !important;\n    color: color-yiq($color) !important;\n    .fc-daygrid-event-dot,.fc-list-event-dot{\n      border-color: color-yiq($color) !important;\n    }\n  }\n  .modal-header.fc-event-#{$name}{\n    background-color: $color !important;\n    border-color: $color !important;\n    .close,.modal-title{\n      color: color-yiq($color) !important;\n    }\n  }\n  span.fc-event-#{$name} {\n    .dot{\n      background-color: $color !important;\n      border-color: $color !important;\n    }\n  }\n  .fc-event-#{$name}:not(a) {\n    .fc-list-event-dot{\n      background-color: $color !important;\n      border-color: $color !important;\n    }\n  }\n}\n\n$colors: (\n    \"primary-dim\"     mix($accent-color, $extend-mix, 13%)          $accent-color,\n    \"success-dim\"     mix($success, $extend-mix, 13%)               $success,\n    \"info-dim\"        mix($info, $extend-mix, 13%)                  $info,\n    \"warning-dim\"     mix($warning, $extend-mix, 13%)               $warning,\n    \"danger-dim\"      mix($danger, $extend-mix, 13%)                $danger,\n    \"secondary-dim\"   #e5ecf5                                     $secondary,\n    \"dark-dim\"        #d9e1ef                                     $dark,\n    \"blue-dim\"        mix($blue, $extend-mix, 13%)                  $blue,\n    \"azure-dim\"       mix($azure, $extend-mix, 13%)                 $azure,\n    \"indigo-dim\"      mix($indigo, $extend-mix, 13%)                $indigo,\n    \"purple-dim\"      mix($purple, $extend-mix, 13%)                $purple,\n    \"pink-dim\"        mix($pink, $extend-mix, 13%)                  $pink,\n    \"orange-dim\"      mix($orange, $extend-mix, 13%)                $orange,\n    \"teal-dim\"        mix($teal, $extend-mix, 13%)                  $teal,\n);\n\n@each $name, $color, $dot in $colors{\n  a.fc-event-#{$name} {\n    background-color: $color !important;\n    border-color: $color !important;\n    color: $dot !important;\n    .fc-daygrid-event-dot,.fc-list-event-dot{\n      border-color: $dot !important;\n    }\n  }\n  .modal-header.fc-event-#{$name}{\n    background-color: $color !important;\n    color: $dot !important;\n    border-color: darken($color,5%) !important;\n    .close,.modal-title{\n      color: $dot !important;\n    }\n  }\n  span.fc-event-#{$name} {\n    .dot{\n      background-color: $color !important;\n      border-color: $dot !important;\n    }\n  }\n  .fc-event-#{$name}:not(a) {\n    .fc-list-event-dot{\n      background-color: $color !important;\n      border-color: lighten($dot,10%) !important;\n    }\n  }\n}\n.fc-draggable{\n  background-color: $accent-color;\n  border-radius: $border-radius;\n  margin: .75rem 0;\n  padding: .25rem .5rem;\n  font-size: $fx-sz-13;\n  color: $white;\n  list-style: none;\n  display: inline-block;\n}\n\n.fc-day{\n  color: $base-color;\n}\n.fc-day-other{\n  color: $base-text;\n}\n.fc-col-header-cell{\n  color: $base-text;\n}","/** nouislider - 14.1.1 - 12/15/2019 | These styles are required for noUiSlider to function. */\n .noUi-target,\n .noUi-target * {\n   -webkit-touch-callout: none;\n   -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n   -webkit-user-select: none;\n   -ms-touch-action: none;\n   touch-action: none;\n   -ms-user-select: none;\n   -moz-user-select: none;\n   user-select: none;\n   -moz-box-sizing: border-box;\n   box-sizing: border-box;\n }\n .noUi-target {\n   position: relative;\n }\n .noUi-base,\n .noUi-connects {\n   width: 100%;\n   height: 100%;\n   position: relative;\n   z-index: 1;\n }\n /* Wrapper for all connect elements.\n  */\n .noUi-connects {\n   overflow: hidden;\n   z-index: 0;\n }\n .noUi-connect,\n .noUi-origin {\n   will-change: transform;\n   position: absolute;\n   z-index: 1;\n   top: 0;\n   right: 0;\n   -ms-transform-origin: 0 0;\n   -webkit-transform-origin: 0 0;\n   -webkit-transform-style: preserve-3d;\n   transform-origin: 0 0;\n   transform-style: flat;\n }\n .noUi-connect {\n   height: 100%;\n   width: 100%;\n }\n .noUi-origin {\n   height: 10%;\n   width: 10%;\n }\n /* Offset direction\n  */\n//  .noUi-txt-dir-rtl.noUi-horizontal .noUi-origin {\n//    left: 0;\n//    right: auto;\n//  }\n /* Give origins 0 height/width so they don't interfere with clicking the\n  * connect elements.\n  */\n .noUi-vertical .noUi-origin {\n   width: 100%;\n }\n .noUi-horizontal .noUi-origin {\n   height: 100%;\n }\n .noUi-handle {\n   -webkit-backface-visibility: hidden;\n   backface-visibility: hidden;\n   position: absolute;\n   &:focus{\n    outline: none;\n  }\n }\n .noUi-touch-area {\n   height: 100%;\n   width: 100%;\n   &:focus{\n     outline: none;\n   }\n }\n .noUi-state-tap .noUi-connect,\n .noUi-state-tap .noUi-origin {\n   -webkit-transition: transform 0.3s;\n   transition: transform 0.3s;\n }\n .noUi-state-drag * {\n   cursor: inherit !important;\n }\n /* Slider size and handle placement;\n  */\n .noUi-horizontal {\n   height: 8px;\n }\n .noUi-horizontal .noUi-handle {\n   width: 28px;\n   height: 28px;\n   right: -14px;\n   top: 50%;\n   transform: translateY(-50%);\n }\n .noUi-vertical {\n   width: 8px;\n   height: 200px;\n }\n .noUi-vertical .noUi-handle {\n  width: 28px;\n  height: 28px;\n   left: 50%;\n   top: -14px;\n   transform: translateX(-50%);\n }\n//  .noUi-txt-dir-rtl.noUi-horizontal .noUi-handle {\n//    left: -14px;\n//    right: auto;\n//  }\n /* Styling;\n  * Giving the connect element a border radius causes issues with using transform: scale\n  */\n .noUi-target {\n   background: $border-color;\n   border-radius: 4px;\n }\n .noUi-connects {\n   border-radius: 3px;\n }\n .noUi-connect {\n   background: $accent-color;\n }\n /* Handles and cursors;\n  */\n .noUi-draggable {\n   cursor: ew-resize;\n }\n .noUi-vertical .noUi-draggable {\n   cursor: ns-resize;\n }\n .noUi-handle {\n   border: 1px solid $border-color;\n   border-radius: 50%;\n   background: $white;\n   cursor: default;\n   box-shadow: $box-shadow;\n }\n .noUi-active {\n   box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #DDD, 0 3px 6px -3px #BBB;\n }\n /* Handle stripes;\n  */\n  .noUi-handle:before,\n  .noUi-handle:after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    height: 10px;\n    width: 1px;\n    background: $border-color;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%,-50%);\n  }\n  .noUi-horizontal .noUi-handle:before {\n    margin-left: -2px;\n  }\n  .noUi-horizontal .noUi-handle:after {\n    margin-left: 2px;\n  }\n .noUi-vertical .noUi-handle:before,\n .noUi-vertical .noUi-handle:after {\n   width: 10px;\n   height: 1px;\n }\n .noUi-vertical .noUi-handle:before {\n    margin-top: -2px;\n  }\n  .noUi-vertical .noUi-handle:after {\n    margin-top: 2px;\n  }\n /* Disabled state;\n  */\n [disabled] .noUi-connect {\n   background: $border-light;\n }\n [disabled].noUi-target,\n [disabled].noUi-handle,\n [disabled] .noUi-handle {\n   cursor: not-allowed;\n }\n /* Base;\n  *\n  */\n .noUi-pips,\n .noUi-pips * {\n   -moz-box-sizing: border-box;\n   box-sizing: border-box;\n }\n .noUi-pips {\n   position: absolute;\n   color: #999;\n }\n /* Values;\n  *\n  */\n .noUi-value {\n   position: absolute;\n   white-space: nowrap;\n   text-align: center;\n }\n .noUi-value-sub {\n   color: #ccc;\n   font-size: 10px;\n }\n /* Markings;\n  *\n  */\n .noUi-marker {\n   position: absolute;\n   background: #CCC;\n }\n .noUi-marker-sub {\n   background: #AAA;\n }\n .noUi-marker-large {\n   background: #AAA;\n }\n /* Horizontal layout;\n  *\n  */\n .noUi-pips-horizontal {\n   padding: 10px 0;\n   height: 80px;\n   top: 100%;\n   left: 0;\n   width: 100%;\n }\n .noUi-value-horizontal {\n   -webkit-transform: translate(-50%, 50%);\n   transform: translate(-50%, 50%);\n }\n//  .noUi-rtl .noUi-value-horizontal {\n//    -webkit-transform: translate(50%, 50%);\n//    transform: translate(50%, 50%);\n//  }\n .noUi-marker-horizontal.noUi-marker {\n   margin-left: -1px;\n   width: 2px;\n   height: 5px;\n }\n .noUi-marker-horizontal.noUi-marker-sub {\n   height: 10px;\n }\n .noUi-marker-horizontal.noUi-marker-large {\n   height: 15px;\n }\n /* Vertical layout;\n  *\n  */\n .noUi-pips-vertical {\n   padding: 0 10px;\n   height: 100%;\n   top: 0;\n   left: 100%;\n }\n .noUi-value-vertical {\n   -webkit-transform: translate(0, -50%);\n   transform: translate(0, -50%);\n   padding-left: 25px;\n }\n//  .noUi-rtl .noUi-value-vertical {\n//    -webkit-transform: translate(0, 50%);\n//    transform: translate(0, 50%);\n//  }\n .noUi-marker-vertical.noUi-marker {\n   width: 5px;\n   height: 2px;\n   margin-top: -1px;\n }\n .noUi-marker-vertical.noUi-marker-sub {\n   width: 10px;\n }\n .noUi-marker-vertical.noUi-marker-large {\n   width: 15px;\n }\n .noUi-tooltip {\n   display: block;\n   position: absolute;\n   border: 1px solid #D9D9D9;\n   border-radius: $tooltip-border-radius;\n   background: $tooltip-bg;\n   color: $tooltip-color;\n   padding: $tooltip-padding-y $tooltip-padding-x;\n   text-align: center;\n   white-space: nowrap;\n   font-size: $tooltip-font-size;\n   opacity: 0;\n   transition: all .3s ease;\n  }\n  .noUi-handle:hover .noUi-tooltip{\n    opacity: $tooltip-opacity;\n  }\n .noUi-horizontal .noUi-tooltip {\n   -webkit-transform: translate(-50%, 0);\n   transform: translate(-50%, 0);\n   left: 50%;\n   bottom: 120%;\n }\n .noUi-vertical .noUi-tooltip {\n   -webkit-transform: translate(0, -50%);\n   transform: translate(0, -50%);\n   top: 50%;\n   right: 120%;\n } ",".dual-listbox {\n  display: flex;\n  flex-direction: column;\n\n  .dual-listbox__container {\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n\n  .dual-listbox__search {\n    @extend .form-control;\n    max-width: 300px;\n    &--hidden{\n      display: none;\n    }\n  }\n\n  .dual-listbox__available,\n  .dual-listbox__selected {\n    border: 1px solid $border-light;\n    height: 300px;\n    overflow-y: auto;\n    padding: 0;\n    width: 300px;\n    margin-top: 0;\n    border-radius: 0 0 $input-border-radius $input-border-radius;\n  }\n\n  .dual-listbox__buttons, .rdl-actions-right, .rdl-actions-left {\n      display: flex;\n      flex-direction: column;\n      margin: 3px 10px;\n  }\n\n  .dual-listbox__button {\n      justify-content: center;\n      text-transform: capitalize;\n      display: block;\n      @extend .btn;\n      @extend .btn-light;\n  }\n\n  .dual-listbox__title {\n    font-size: 1rem;\n    font-weight: $fw-medium;\n    padding: .5rem 1rem;\n    border-left: 1px solid $border-light;\n    border-right: 1px solid $border-light;\n    border-top: 1px solid $border-light;\n    margin-top: 1rem;\n    -webkit-margin-before: 1rem;\n    border-radius: $input-border-radius $input-border-radius 0 0;\n  }\n\n  .dual-listbox__item {\n    display: block;\n    padding: .5rem 1rem;\n    cursor: pointer;\n    user-select: none;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    border-bottom: 1px solid $border-light;\n    transition: background-color 0.2s ease;\n    &:hover{\n      @extend .bg-light;\n    }\n    &:active,\n    &.dual-listbox__item--selected {\n      @extend .bg-primary-dim;\n    }\n  }\n}\n\n.react-dual-listbox {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-wrap: wrap;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.react-dual-listbox * {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.react-dual-listbox input:disabled,\n.react-dual-listbox select:disabled {\n  background: #eee;\n  cursor: not-allowed;\n}\n.react-dual-listbox button,\n.react-dual-listbox select {\n  line-height: 1.42857;\n  font-family: inherit;\n}\n\n.rdl-selected:focus-visible {\n  border: none;\n}\n\n.rdl-filter,\n.rdl-control {\n  display: block;\n  border: 1px solid #ccc;\n  border-radius: 2px;\n  padding: 8px 12px;\n  width: 100%;\n  color: #333;\n  font-size: 14px;\n}\n\n.rdl-filter {\n  @extend .form-control;\n  max-width: 300px;\n  margin-bottom: 10px !important;\n  &--hidden{\n    display: none;\n  }\n}\n\n.rdl-control-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n      -ms-flex: 1 0 auto;\n          flex: 1 0 auto;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n\n.rdl-control-label {\n  font-size: 1rem;\n  font-weight: $fw-medium;\n  padding: .5rem 1rem;\n  border-left: 1px solid $border-light;\n  border-right: 1px solid $border-light;\n  border-top: 1px solid $border-light;\n  margin-top: 1rem;\n  -webkit-margin-before: 1rem;\n  border-radius: $input-border-radius $input-border-radius 0 0;\n  margin-bottom: 0 !important;\n  width: 100%;\n}\n.rdl-control-label.rdl-sr-only {\n  position: absolute;\n  clip: rect(0 0 0 0);\n}\n\n.rdl-control {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  border: 1px solid $border-light;\n  height: 300px;\n  overflow-y: auto;\n  padding: 0;\n  width: 300px;\n  margin-top: 0;\n  border-radius: 0 0 $input-border-radius $input-border-radius;\n  &:focus {\n    outline: none;\n  }\n}\n.rdl-control > option {\n  display: block;\n  padding: .5rem 1rem;\n  cursor: pointer;\n  user-select: none;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  border-bottom: 1px solid $border-light;\n  transition: background-color 0.2s ease;\n  &:hover{\n    @extend .bg-lighter;\n  }\n  &:active,\n  &:focus {\n    @extend .bg-primary-dim;\n    outline: none;\n    background: transparent !important;\n  }\n}\n.rdl-control optgroup {\n  font: inherit;\n  font-weight: 700;\n}\n\n/*\n.rdl-actions {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 auto;\n          flex: 0 0 auto;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  margin: 0 10px;\n  padding: 10px 0px;\n}\n/*\n.rdl-has-header .rdl-actions {\n  padding-top: 31px;\n}\n.rdl-has-filter .rdl-actions {\n  padding-top: 44px;\n}\n.rdl-has-header.rdl-has-filter .rdl-actions {\n  padding-top: 75px;\n}\n*/\n\n.rdl-actions {\n  display: inline-flex;\n  flex-direction: column;\n}\n\n.rdl-move {\n  margin-bottom: 5px;\n  //border: 1px solid #ccc;\n  // border-radius: 2px;\n  // margin-bottom: 5px;\n  // justify-content: center;\n  // text-transform: capitalize;\n  // position: relative;\n  // letter-spacing: 0.02em;\n  // display: inline-flex;\n  // align-items: center;\n  // cursor: pointer;\n  // padding: .4375rem 1.125rem;\n  // color: #333;\n  // font-size: 12px;\n  border: none;\n  background: transparent;\n}\n.rdl-move:focus{\n  border: none;\n  outline: none !important;\n}\n.rdl-move:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.rdl-move:last-child {\n  margin-bottom: 0;\n}\n.rdl-move i {\n  margin: 0 -1px;\n}\n\n\n.rdl-align-top .rdl-available {\n  margin-right: 10px;\n}\n.rdl-align-top .rdl-selected {\n  margin-left: 10px;\n}\n.rdl-align-top .rdl-control {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.rdl-align-top .rdl-actions-left,\n.rdl-align-top .rdl-actions-right {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  margin: 0;\n}\n.rdl-align-top .rdl-list-box .rdl-move {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 1 50%;\n          flex: 0 1 50%;\n}\n.rdl-align-top .rdl-list-box .rdl-move:first-child {\n  margin-bottom: 0;\n  border-right: 0;\n  border-top-right-radius: 0;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rdl-align-top .rdl-list-box .rdl-move:last-child {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}","$react-select-color:                 $base-text !default;\n$react-select-placeholder-color:     $base-light !default;\n$react-select-bg-color:              $white !default;\n\n$react-select-dropdown-item-active:  $light !default;\n$react-select-dropdown-item-disabled:rgba($base-light,.7) !default;\n\n$react-select-border-width:          1px !default;\n$react-select-border-color:          $input-border-color !default;\n$react-select-focus-border-color:    $input-focus-border-color !default;\n$react-select-open-border-color:     darken($input-border-color, 12%) !default;\n$react-select-box-shadow:            none !default;\n$react-select-focus-box-shadow:      $input-focus-box-shadow !default;\n$react-select-transition:            all .3s !default;\n$react-select-border-radius:         $border-radius !default;\n\n$react-select-font-family:           $base-font-family !default;\n$react-select-font-weight:           $input-font-weight !default;\n\n$react-select-padding-x:             $input-padding-x !default;\n$react-select-padding-y:             $input-padding-y !default;\n$react-select-font-size:             $input-font-size !default;\n$react-select-line-height:           $input-line-height !default;\n$react-select-input-height:          $input-height !default;\n\n$react-select-padding-x-sm:          $input-padding-x-sm !default;\n$react-select-padding-y-sm:          $input-padding-y-sm !default;\n$react-select-font-size-sm:          $input-font-size-sm !default;\n$react-select-line-height-sm:        $input-line-height-sm !default;\n$react-select-input-height-sm:       $input-height-sm !default;\n\n$react-select-padding-x-lg:          $input-padding-x-lg !default;\n$react-select-padding-y-lg:          $input-padding-y-lg !default;\n$react-select-font-size-lg:          $input-font-size-lg !default;\n$react-select-line-height-lg:        $input-line-height-lg !default;\n$react-select-input-height-lg:       $input-height-lg !default;\n\n$react-select-padding-x-xl:          $input-padding-x-xl !default;\n$react-select-padding-y-xl:          $input-padding-y-xl !default;\n$react-select-font-size-xl:          $input-font-size-xl !default;\n$react-select-line-height-xl:        $input-line-height-xl !default;\n$react-select-input-height-xl:       $input-height-xl !default;\n\n$react-select-arrow-font-family:     $nk-dashlite-font !default;\n$react-select-arrow-down:            $ni-chevron-down !default;\n$react-select-arrow-up:              $ni-chevron-up !default;\n\n.css-tlfecz-indicatorContainer,\n.css-1gtu0rj-indicatorContainer,\n.css-1okebmr-indicatorSeparator {\n    display: none !important;\n}\n.css-1pahdxg-control {\n    border-color: transparent !important;\n    box-shadow: none !important;\n}\n.react-select-container {\n    box-sizing: border-box !important;\n    margin: 0 !important;\n    position: relative !important;\n    vertical-align: middle !important;\n    cursor: pointer !important;\n    min-height: calc(2.125rem + 2px) !important;\n}\n.react-select__control{\n    cursor: pointer !important;\n    color: #526484 !important;\n    border: 1px solid #dbdfea !important;\n    //padding: 0 .35rem !important;\n}\n.react-select__control:hover {\n    border-color: #dbdfea !important;\n}\n.react-select__single-value {\n    color: #526484 !important;\n    line-height: 1.25rem !important;\n    font-family: Roboto,sans-serif !important;\n    font-size: 13px !important;\n    font-weight: 400 !important;\n}\n\n.react-select__control--is-focused,\n.react-select__control--menu-is-open,\n.react-select__control + .react-select__control--is-focused, .react-select__control + .react-select__control--menu-is-open {\n    border: 1px solid #dbdfea !important;\n    //border-color: $accent-color !important;\n    cursor: pointer !important;\n    box-shadow: none !important;\n}\n.react-select__menu {\n    background-color: $react-select-bg-color !important;\n    border-radius: $react-select-border-radius !important;\n    box-shadow: $react-select-box-shadow !important;\n    border: $react-select-border-width solid $react-select-border-color !important;\n    font-family: $react-select-font-family !important;\n    font-size: $react-select-font-size !important;\n    font-weight: $react-select-font-weight !important; \n    display: block !important;\n    padding: 6px !important;\n    z-index: 1000 !important;\n}\n.react-select__option {\n  background-color: $react-select-bg-color !important;\n  border-radius: $react-select-border-radius !important;\n  box-shadow: $react-select-box-shadow !important;\n  //border: $react-select-border-width solid $react-select-border-color !important;;\n  font-family: $react-select-font-family !important;\n  font-size: $react-select-font-size !important;\n  font-weight: $react-select-font-weight !important;\n  cursor: pointer !important;\n  display: block !important;\n  font-weight: normal;\n  display: block;\n  white-space: nowrap;\n  min-height: 1.2em;\n  color :  #526484;\n  padding: 0.375rem .75rem !important;\n}\n.react-select__option:not(:last-child) {\n    margin-bottom: 0.125rem;\n}\n.react-select__option:hover {\n    font-weight: normal;\n    display: block;\n    white-space: nowrap;\n    background-color: #ebeef2 !important;\n}\n.react-select__option--is-selected {\n    color :  #526484 !important;\n    background: #ebeef2 !important;\n}\n.react-select__placeholder { \n    color: #8094ae !important;\n    font-size: small !important;\n    margin-left: 5px;\n    padding: 0 .35rem !important;\n}\n\n// Multivalue\n.react-select__multi-value {\n    background-color: #ebeef2 !important;\n    border-radius: 3px !important;\n    cursor: pointer !important;\n}\n.react-select__multi-value__remove {\n    color: #526484 !important;\n    cursor: pointer !important;\n    display: inline-block !important;\n    font-weight: bold !important;\n}\n.react-select__multi-value__remove:hover{\n    background: transparent !important;\n}","$datepicker-dropdown-border-before: rgba(0, 0, 0, 0.2);\n\n$datepicker-day-focused-hover-bg: $bg-light;\n\n$datepicker-old-new-color: $light-300;\n$datepicker-disabled-color: $light-300;\n$datepicker-highlighted-bg: $bg-light;\n\n$datepicker-today-bg: $accent-200;\n$datepicker-today-hover-bg: $accent-500;\n$datepicker-today-active-bg: $accent-color;\n$datepicker-today-color: $accent-color;\n$datepicker-today-hover-color:$white;\n$datepicker-today-active-hover-color:$white;\n\n$datepicker-range-bg: $light-300;\n\n$datepicker-range-today-bg: $accent-400;\n$datepicker-range-today-hover-bg: $accent-500;\n$datepicker-range-today-active-bg: $accent-color;\n\n$datepicker-selected-bg: $light-600;\n$datepicker-selected-color: $white;\n$datepicker-selected-hover-bg: $light-700;\n$datepicker-selected-active-bg: $light-800;\n\n$datepicker-active-bg: $accent-500;\n$datepicker-active-color:$white;\n$datepicker-active-hover-bg: $accent-color;\n$datepicker-active-active-bg: $accent-color;\n\n$datepicker-hover-bg: $accent-color;\n$datepicker-hover-color: $white;\n\n$datepicker-span-active-bg: $accent-500;\n$datepicker-span-active-color: $white;\n$datepicker-span-active-hover-bg: $accent-color;\n$datepicker-span-active-active-bg: $accent-color;\n$datepicker-span-old-new-color: $light-300;\n\n$datepicker-switch-hover-bg: $bg-light;\n\n$input-daterange-add-on-bg: $bg-light;\n\n\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker__navigation-icon::before {\n  border-color: #ccc;\n  border-style: solid;\n  border-width: 3px 3px 0 0;\n  content: \"\";\n  display: block;\n  height: 9px;\n  position: absolute;\n  top: 6px;\n  width: 9px;\n}\n\n.react-datepicker-popper {\n    background-color: #fff;\n    padding: 10px;\n    border-radius: 4px;\n    direction: ltr;\n    border: 1px solid $light-300;\n    box-shadow: none;\n    min-width: 240px;\n    font-size: .8125rem;\n}\n\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {\n  margin-left: -4px;\n  right:0;\n  position: absolute;\n  width: 0;\n}\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {\n  box-sizing: content-box;\n  position: absolute;\n  border: 8px solid transparent;\n  height: 0;\n  width: 1px;\n  content: \"\";\n  z-index: -1;\n  border-width: 8px;\n  left: -8px;\n}\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {\n  border-bottom-color: #aeaeae;\n}\n\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle {\n  top: 0;\n  margin-top: -8px;\n}\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {\n  border-top: none;\n  border-bottom-color: #f0f0f0;\n}\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::after {\n  top: 0;\n}\n.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle::before {\n  top: -1px;\n  border-bottom-color: #aeaeae;\n}\n\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle {\n  bottom: 0;\n  margin-bottom: -8px;\n}\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after {\n  border-bottom: none;\n  border-top-color: #fff;\n}\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::after {\n  bottom: 0;\n}\n.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle::before {\n  bottom: -1px;\n  border-top-color: #aeaeae;\n}\n\n.react-datepicker {\n    display: inline-block;\n    position: relative;\n    background-color: #fff;\n    border: 1px solid #aeaeae;\n    border-radius: 0.3rem;\n    margin-top: 5px;\n}\n\n.date-picker-range > .react-datepicker-wrapper {\n    display: inline;\n    width: 45%;\n}\n\n.date-picker-range {\n  .start-m input{\n    border-radius: 3px 0px 0px 3px !important;\n  }\n  .end-m input{\n    border-radius: 0px 3px 3px 0px !important;\n  }\n}\n\n.react-datepicker-wrapper {\n  display: inline-block;\n  padding: 0;\n  border: 0;\n  width: 100%;\n}\n\n.react-datepicker--time-only .react-datepicker__triangle {\n  left: 35px;\n}\n.react-datepicker--time-only .react-datepicker__time-container {\n  border-left: 0;\n}\n.react-datepicker--time-only .react-datepicker__time,\n.react-datepicker--time-only .react-datepicker__time-box {\n  border-bottom-left-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.react-datepicker__triangle {\n  position: absolute;\n  left: 50px;\n  display: none;\n}\n\n.react-datepicker-popper {\n  z-index: 10;\n}\n.react-datepicker-popper[data-placement^=bottom] {\n  padding-top: 10px;\n}\n.react-datepicker-popper[data-placement=bottom-end] .react-datepicker__triangle, .react-datepicker-popper[data-placement=top-end] .react-datepicker__triangle {\n  left: auto;\n  right: 50px;\n}\n.react-datepicker-popper[data-placement^=top] {\n  padding-bottom: 10px;\n}\n.react-datepicker-popper[data-placement^=right] {\n  padding-left: 8px;\n}\n.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle {\n  left: auto;\n  right: 42px;\n}\n.react-datepicker-popper[data-placement^=left] {\n  padding-right: 8px;\n}\n.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle {\n  left: 42px;\n  right: auto;\n}\n\n.react-datepicker__header {\n  text-align: center;\n  position: relative;\n  font-size: .8125rem;\n  color: #526484;\n  font-weight: bold;\n}\n\n.react-datepicker__header--time {\n  padding-bottom: 8px;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n.react-datepicker__header--time:not(.react-datepicker__header--time--only) {\n  border-top-left-radius: 0;\n}\n.react-datepicker__header:not(.react-datepicker__header--has-time-select) {\n  border-top-right-radius: 0.3rem;\n}\n\n.react-datepicker__year-dropdown-container--select,\n.react-datepicker__month-dropdown-container--select,\n.react-datepicker__month-year-dropdown-container--select,\n.react-datepicker__year-dropdown-container--scroll,\n.react-datepicker__month-dropdown-container--scroll,\n.react-datepicker__month-year-dropdown-container--scroll {\n  display: inline-block;\n  margin: 0 2px;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n  margin-top: 0;\n}\n\n.react-datepicker-time__header {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.react-datepicker__navigation {\n  background: none;\n  display: flex;\n  justify-content: center;\n  //align-items: center;\n  text-align: center;\n  cursor: pointer;\n  position: absolute;\n  border: none;\n  //padding: 1px;\n  z-index: 1;\n  height: 27px;\n  width: 27px;\n  margin: 0.1rem 0.5rem;\n  text-indent: -999em;\n  overflow: hidden;\n}\n.react-datepicker__navigation:hover {\n  // background: $datepicker-switch-hover-bg;\n   border-radius: 0.3rem;\n}\n.react-datepicker__navigation:focus, .react-datepicker__navigation:focus-visible {\n    outline: none;\n}\n\n.react-datepicker__navigation--previous {\n  left: 2px;\n}\n.react-datepicker__navigation--next {\n  right: 2px;\n}\n.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n  right: 85px;\n}\n.react-datepicker__navigation--years {\n  position: relative;\n  top: 0;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.react-datepicker__navigation--years-previous {\n  top: 4px;\n}\n.react-datepicker__navigation--years-upcoming {\n  top: -4px;\n}\n.react-datepicker__navigation:hover *::before {\n  border-color: #a6a6a6;\n}\n\n.react-datepicker__navigation-icon {\n  position: relative;\n  top: -1px;\n  font-size: 12px;\n  width: 0;\n}\n.react-datepicker__navigation-icon--next {\n  left: -2px;\n}\n.react-datepicker__navigation-icon--next::before {\n  transform: rotate(45deg);\n  left: -7px;\n}\n.react-datepicker__navigation-icon--previous {\n  right: -2px;\n}\n.react-datepicker__navigation-icon--previous::before {\n  transform: rotate(225deg);\n  right: -7px;\n}\n\n.react-datepicker__month-container {\n  float: left;\n  padding: 0px;\n}\n\n.react-datepicker__year {\n  margin: 0.4rem;\n  text-align: center;\n}\n.react-datepicker__year-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  max-width: 208px;\n}\n.react-datepicker__year .react-datepicker__year-text {\n  display: inline-block;\n  width: 4rem;\n  margin: 2px;\n}\n\n.react-datepicker__month {\n  margin: 0.4rem;\n  text-align: center;\n}\n.react-datepicker__month .react-datepicker__month-text,\n.react-datepicker__month .react-datepicker__quarter-text {\n  display: inline-block;\n  width: 5rem;\n  margin: 2px;\n}\n\n.react-datepicker__input-time-container {\n  clear: both;\n  width: 100%;\n  float: left;\n  margin: 5px 0 10px 15px;\n  text-align: left;\n}\n.react-datepicker__input-time-container .react-datepicker-time__caption {\n  display: inline-block;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container {\n  display: inline-block;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input {\n  display: inline-block;\n  margin-left: 10px;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input {\n  width: auto;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-inner-spin-button,\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type=time] {\n  -moz-appearance: textfield;\n}\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter {\n  margin-left: 5px;\n  display: inline-block;\n}\n\n.react-datepicker__time-container {\n  float: right;\n  border-left: 1px solid #aeaeae;\n  width: 85px;\n}\n.react-datepicker__time-container--with-today-button {\n  display: inline;\n  border: 1px solid #aeaeae;\n  border-radius: 0.3rem;\n  position: absolute;\n  right: -72px;\n  top: 0;\n}\n.react-datepicker__time-container .react-datepicker__time {\n  position: relative;\n  background: white;\n  border-bottom-right-radius: 0.3rem;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {\n  overflow-x: hidden;\n  margin: 0 auto;\n  text-align: center;\n  border-bottom-right-radius: 0.3rem;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {\n  list-style: none;\n  margin: 0;\n  height: calc(195px + (1.7rem / 2));\n  overflow-y: scroll;\n  padding-right: 0;\n  padding-left: 0;\n  width: 100%;\n  box-sizing: content-box;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {\n  height: 30px;\n  padding: 5px 10px;\n  white-space: nowrap;\n  transition: all 0.3s;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {\n  cursor: pointer;\n  background-color: #f0f0f0;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n    color: $datepicker-today-color;\n    background-color: $datepicker-today-bg;\n    transition: all 0.3s;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {\n    color: $datepicker-today-hover-color;\n    background-color: $datepicker-today-hover-bg;\n\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled {\n  color: #ccc;\n}\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover {\n  cursor: default;\n  background-color: transparent;\n}\n\n.react-datepicker__week-number {\n  color: #ccc;\n  display: inline-block;\n  width: 1.7rem;\n  line-height: 1.7rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n.react-datepicker__week-number.react-datepicker__week-number--clickable {\n  cursor: pointer;\n}\n.react-datepicker__week-number.react-datepicker__week-number--clickable:hover {\n  border-radius: 0.3rem;\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__day-names,\n.react-datepicker__week {\n  white-space: nowrap;\n  transition: all 0.3s;\n}\n\n.react-datepicker__day-names {\n  margin-bottom: -8px;\n  margin-top: 5px;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n  display: inline-block;\n  width: 1.7rem;\n  line-height: 1.7rem;\n  text-align: center;\n  margin: 0.166rem;\n  transition: all 0.3s;\n}\n\n.react-datepicker__month--selected, .react-datepicker__month--in-selecting-range, .react-datepicker__month--in-range,\n.react-datepicker__quarter--selected,\n.react-datepicker__quarter--in-selecting-range,\n.react-datepicker__quarter--in-range {\n  border-radius: 0.3rem;\n  color: $datepicker-today-color;\n  background-color: $datepicker-today-bg;\n}\n.react-datepicker__month--selected:hover, .react-datepicker__month--in-selecting-range:hover, .react-datepicker__month--in-range:hover,\n.react-datepicker__quarter--selected:hover,\n.react-datepicker__quarter--in-selecting-range:hover,\n.react-datepicker__quarter--in-range:hover {\n  color: $datepicker-today-hover-color;\n  background-color: $datepicker-today-hover-bg;\n}\n.react-datepicker__month--disabled,\n.react-datepicker__quarter--disabled {\n  color: #ccc;\n  pointer-events: none;\n}\n.react-datepicker__month--disabled:hover,\n.react-datepicker__quarter--disabled:hover {\n  cursor: default;\n  background-color: transparent;\n}\n\n.react-datepicker__day,\n.react-datepicker__month-text,\n.react-datepicker__quarter-text,\n.react-datepicker__year-text {\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.react-datepicker__day:hover,\n.react-datepicker__month-text:hover,\n.react-datepicker__quarter-text:hover,\n.react-datepicker__year-text:hover {\n  border-radius: 0.3rem;\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__day--outside-month {\n    color: $datepicker-old-new-color; \n}\n\n.react-datepicker__day--today, \n.react-datepicker__month-text--today,\n.react-datepicker__quarter-text--today,\n.react-datepicker__year-text--today {\n  color: $datepicker-today-color;\n  background-color: $datepicker-today-bg;\n  border-radius: 0.3rem;\n}\n\n.react-datepicker__day--highlighted,\n.react-datepicker__month-text--highlighted,\n.react-datepicker__quarter-text--highlighted,\n.react-datepicker__year-text--highlighted {\n  border-radius: 0.3rem;\n  background-color: #3dcc4a;\n  color: #fff;\n}\n.react-datepicker__day--highlighted:hover,\n.react-datepicker__month-text--highlighted:hover,\n.react-datepicker__quarter-text--highlighted:hover,\n.react-datepicker__year-text--highlighted:hover {\n  background-color: #32be3f;\n}\n.react-datepicker__day--highlighted-custom-1,\n.react-datepicker__month-text--highlighted-custom-1,\n.react-datepicker__quarter-text--highlighted-custom-1,\n.react-datepicker__year-text--highlighted-custom-1 {\n  color: magenta;\n}\n.react-datepicker__day--highlighted-custom-2,\n.react-datepicker__month-text--highlighted-custom-2,\n.react-datepicker__quarter-text--highlighted-custom-2,\n.react-datepicker__year-text--highlighted-custom-2 {\n  color: green;\n}\n.react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--selected,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--selected,\n.react-datepicker__year-text--in-selecting-range,\n.react-datepicker__year-text--in-range {\n  border-radius: 0.3rem;\n  color: #fff !important;\n  background-color: $datepicker-today-hover-bg !important;\n}\n.react-datepicker__day--today:hover,\n.react-datepicker__year-text--today:hover,\n.react-datepicker__day--selected:hover, .react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover,\n.react-datepicker__month-text--selected:hover,\n.react-datepicker__month-text--in-selecting-range:hover,\n.react-datepicker__month-text--in-range:hover,\n.react-datepicker__quarter-text--selected:hover,\n.react-datepicker__quarter-text--in-selecting-range:hover,\n.react-datepicker__quarter-text--in-range:hover,\n.react-datepicker__year-text--selected:hover,\n.react-datepicker__year-text--in-selecting-range:hover,\n.react-datepicker__year-text--in-range:hover {\n    color: $datepicker-today-hover-color;\n    background-color: $datepicker-today-hover-bg !important;\n\n}\n// .react-datepicker__day--keyboard-selected,\n// .react-datepicker__month-text--keyboard-selected,\n// .react-datepicker__quarter-text--keyboard-selected,\n// .react-datepicker__year-text--keyboard-selected {\n\n// }\n// .react-datepicker__day--keyboard-selected:hover,\n// .react-datepicker__month-text--keyboard-selected:hover,\n// .react-datepicker__quarter-text--keyboard-selected:hover,\n// .react-datepicker__year-text--keyboard-selected:hover {\n//   background-color: #1d5d90;\n// }\n.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range),\n.react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range),\n.react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range),\n.react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range) {\n    background-color: $datepicker-range-bg;\n}\n.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__month--selecting-range .react-datepicker__month-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__month--selecting-range .react-datepicker__quarter-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range),\n.react-datepicker__month--selecting-range .react-datepicker__year-text--in-range:not(.react-datepicker__day--in-selecting-range,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__year-text--in-selecting-range) {\n  background-color: #f0f0f0;\n  color: #000;\n}\n.react-datepicker__day--disabled,\n.react-datepicker__month-text--disabled,\n.react-datepicker__quarter-text--disabled,\n.react-datepicker__year-text--disabled {\n  cursor: default;\n  color: #ccc;\n}\n.react-datepicker__day--disabled:hover,\n.react-datepicker__month-text--disabled:hover,\n.react-datepicker__quarter-text--disabled:hover,\n.react-datepicker__year-text--disabled:hover {\n  background-color: transparent;\n}\n\n.react-datepicker__month-text.react-datepicker__month--selected:hover, .react-datepicker__month-text.react-datepicker__month--in-range:hover, .react-datepicker__month-text.react-datepicker__quarter--selected:hover, .react-datepicker__month-text.react-datepicker__quarter--in-range:hover,\n.react-datepicker__quarter-text.react-datepicker__month--selected:hover,\n.react-datepicker__quarter-text.react-datepicker__month--in-range:hover,\n.react-datepicker__quarter-text.react-datepicker__quarter--selected:hover,\n.react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover {\n  color: $datepicker-today-hover-color;\n  background-color: $datepicker-today-hover-bg;\n}\n.react-datepicker__month-text:hover,\n.react-datepicker__quarter-text:hover {\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__input-container {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n\n.react-datepicker__year-read-view,\n.react-datepicker__month-read-view,\n.react-datepicker__month-year-read-view {\n  border: 1px solid transparent;\n  border-radius: 0.3rem;\n  position: relative;\n}\n.react-datepicker__year-read-view:hover,\n.react-datepicker__month-read-view:hover,\n.react-datepicker__month-year-read-view:hover {\n  cursor: pointer;\n}\n.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {\n  border-top-color: #b3b3b3;\n}\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n  transform: rotate(135deg);\n  right: -16px;\n  top: 0;\n}\n\n.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown,\n.react-datepicker__month-year-dropdown {\n  background-color: #f0f0f0;\n  position: absolute;\n  width: 50%;\n  left: 25%;\n  top: 30px;\n  z-index: 1;\n  text-align: center;\n  border-radius: 0.3rem;\n  border: 1px solid #aeaeae;\n}\n.react-datepicker__year-dropdown:hover,\n.react-datepicker__month-dropdown:hover,\n.react-datepicker__month-year-dropdown:hover {\n  cursor: pointer;\n}\n.react-datepicker__year-dropdown--scrollable,\n.react-datepicker__month-dropdown--scrollable,\n.react-datepicker__month-year-dropdown--scrollable {\n  height: 150px;\n  overflow-y: scroll;\n}\n\n.react-datepicker__year-option,\n.react-datepicker__month-option,\n.react-datepicker__month-year-option {\n  line-height: 20px;\n  width: 100%;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n.react-datepicker__year-option:first-of-type,\n.react-datepicker__month-option:first-of-type,\n.react-datepicker__month-year-option:first-of-type {\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n}\n.react-datepicker__year-option:last-of-type,\n.react-datepicker__month-option:last-of-type,\n.react-datepicker__month-year-option:last-of-type {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  border-bottom-left-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n.react-datepicker__year-option:hover,\n.react-datepicker__month-option:hover,\n.react-datepicker__month-year-option:hover {\n  background-color: #ccc;\n}\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {\n  border-bottom-color: #b3b3b3;\n}\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {\n  border-top-color: #b3b3b3;\n}\n.react-datepicker__year-option--selected,\n.react-datepicker__month-option--selected,\n.react-datepicker__month-year-option--selected {\n  position: absolute;\n  left: 15px;\n}\n\n.react-datepicker__close-icon {\n  cursor: pointer;\n  background-color: transparent;\n  border: 0;\n  outline: 0;\n  padding: 0 6px 0 0;\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n  display: table-cell;\n  vertical-align: middle;\n}\n.react-datepicker__close-icon::after {\n  cursor: pointer;\n  background-color: #216ba5;\n  color: #fff;\n  border-radius: 50%;\n  height: 16px;\n  width: 16px;\n  padding: 2px;\n  font-size: 12px;\n  line-height: 1;\n  text-align: center;\n  display: table-cell;\n  vertical-align: middle;\n  content: \"×\";\n}\n\n.react-datepicker__today-button {\n  background: #f0f0f0;\n  border-top: 1px solid #aeaeae;\n  cursor: pointer;\n  text-align: center;\n  padding: 5px 0;\n  clear: left;\n}\n\n.react-datepicker__portal {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.8);\n  left: 0;\n  top: 0;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  z-index: 2147483647;\n}\n.react-datepicker__portal .react-datepicker__day-name,\n.react-datepicker__portal .react-datepicker__day,\n.react-datepicker__portal .react-datepicker__time-name {\n  width: 3rem;\n  line-height: 3rem;\n}\n@media (max-width: 400px), (max-height: 550px) {\n  .react-datepicker__portal .react-datepicker__day-name,\n.react-datepicker__portal .react-datepicker__day,\n.react-datepicker__portal .react-datepicker__time-name {\n    width: 2rem;\n    line-height: 2rem;\n  }\n}\n.react-datepicker__portal .react-datepicker__current-month,\n.react-datepicker__portal .react-datepicker-time__header {\n  font-size: 1.44rem;\n}\n.date-picker-range {\n    display: flex;\n    flex-direction: row;\n}\n","/* Magnific Popup CSS */\n\n@import \"settings\";\n\n////////////////////////\n//\n// Contents:\n//\n// 1. General styles\n//    - Transluscent overlay\n//    - Containers, wrappers\n//    - Cursors\n//    - Helper classes\n// 2. Appearance\n//    - Preloader & text that displays error messages\n//    - CSS reset for buttons\n//    - Close icon\n//    - \"1 of X\" counter\n//    - Navigation (left/right) arrows\n//    - Iframe content type styles\n//    - Image content type styles\n//    - Media query where size of arrows is reduced\n//    - IE7 support\n//\n////////////////////////\n\n\n\n////////////////////////\n// 1. General styles\n////////////////////////\n\n// Transluscent overlay\n.mfp-bg {\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: $mfp-z-index-base + 2;\n  overflow: hidden;\n  position: fixed;\n\n  background: $mfp-overlay-color;\n  opacity: $mfp-overlay-opacity;\n}\n\n// Wrapper for popup\n.mfp-wrap {\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: $mfp-z-index-base + 3;\n  position: fixed;\n  outline: none !important;\n  -webkit-backface-visibility: hidden; // fixes webkit bug that can cause \"false\" scrollbar\n}\n\n// Root container\n.mfp-container {\n  text-align: center;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  padding: 0 $mfp-popup-padding-left;\n  box-sizing: border-box;\n}\n\n// Vertical centerer helper\n.mfp-container {\n  &:before {\n    content: '';\n    display: inline-block;\n    height: 100%;\n    vertical-align: middle;\n  }\n}\n\n// Remove vertical centering when popup has class `mfp-align-top`\n.mfp-align-top {\n  .mfp-container {\n    &:before {\n      display: none;\n    }\n  }\n}\n\n// Popup content holder\n.mfp-content {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  margin: 0 auto;\n  @if($rtl==false){\n    text-align: left;\n  }\n  @if($rtl==true){\n    text-align: right;\n  }\n  z-index: $mfp-z-index-base + 5;\n}\n.mfp-inline-holder,\n.mfp-ajax-holder {\n  .mfp-content {\n    width: 100%;\n    cursor: auto;\n  }\n}\n\n// Cursors\n.mfp-ajax-cur {\n  cursor: progress;\n}\n.mfp-zoom-out-cur {\n  &, .mfp-image-holder .mfp-close {\n    cursor: -moz-zoom-out;\n    cursor: -webkit-zoom-out;\n    cursor: zoom-out;\n  }\n}\n.mfp-zoom {\n  cursor: pointer;\n  cursor: -webkit-zoom-in;\n  cursor: -moz-zoom-in;\n  cursor: zoom-in;\n}\n.mfp-auto-cursor {\n  .mfp-content {\n    cursor: auto;\n  }\n}\n\n.mfp-close,\n.mfp-arrow,\n.mfp-preloader,\n.mfp-counter {\n  -webkit-user-select:none;\n  -moz-user-select: none;\n  user-select: none;\n}\n\n// Hide the image during the loading\n.mfp-loading {\n  &.mfp-figure {\n    display: none;\n  }\n}\n\n// Helper class that hides stuff\n@if $mfp-use-visuallyhidden {\n  // From HTML5 Boilerplate https://github.com/h5bp/html5-boilerplate/blob/v4.2.0/doc/css.md#visuallyhidden\n  .mfp-hide {\n    border: 0 !important;\n    clip: rect(0 0 0 0) !important;\n    height: 1px !important;\n    margin: -1px !important;\n    overflow: hidden !important;\n    padding: 0 !important;\n    position: absolute !important;\n    width: 1px !important;\n  }\n} @else {\n  .mfp-hide {\n    display: none !important;\n  }\n}\n\n\n////////////////////////\n// 2. Appearance\n////////////////////////\n\n// Preloader and text that displays error messages\n.mfp-preloader {\n  color: $mfp-controls-text-color;\n  position: absolute;\n  top: 50%;\n  width: auto;\n  text-align: center;\n  margin-top: -0.8em;\n  left: 8px;\n  right: 8px;\n  z-index: $mfp-z-index-base + 4;\n  a {\n    color: $mfp-controls-text-color;\n    &:hover {\n      color: $mfp-controls-text-color-hover;\n    }\n  }\n}\n\n// Hide preloader when content successfully loaded\n.mfp-s-ready {\n  .mfp-preloader {\n    display: none;\n  }\n}\n\n// Hide content when it was not loaded\n.mfp-s-error {\n  .mfp-content {\n    display: none;\n  }\n}\n\n// CSS-reset for buttons\nbutton {\n  &.mfp-arrow {\n    overflow: visible;\n    cursor: pointer;\n    background: transparent;\n    border: 0;\n    -webkit-appearance: none;\n    display: block;\n    outline: none;\n    padding: 0;\n    z-index: $mfp-z-index-base + 6;\n    box-shadow: none;\n    touch-action: manipulation;\n  }\n  &::-moz-focus-inner {\n      padding: 0;\n      border: 0\n  }\n}\nbutton {\n  &.mfp-close {\n    overflow: visible;\n    cursor: pointer;\n    border: 0;\n    -webkit-appearance: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    outline: none;\n    padding: 0;\n    z-index: $mfp-z-index-base + 6;\n    box-shadow: $box-shadow;\n    touch-action: manipulation;\n  }\n  &::-moz-focus-inner {\n      padding: 0;\n      border: 0\n  }\n}\n\n\n// Close icon\n.mfp-close {\n  width: 44px;\n  height: 44px;\n  line-height: 44px;\n\n  position: absolute;\n  @if($rtl==false){\n    right: 0;\n  }\n  @if($rtl==true){\n    left: 0;\n  }\n  top: 0;\n  text-decoration: none;\n  text-align: center;\n  // opacity: $mfp-controls-opacity;\n  transform: translate(50%,-50%);\n  color: $mfp-controls-color;\n\n  font-style: normal;\n  font-size: 28px;\n  font-family: Arial, Baskerville, monospace;\n\n  background-color: $white;\n  border-radius: 50%;\n  &:hover,\n  &:focus {\n    opacity: 1;\n  }\n\n  &:active {\n    top: 1px;\n  }\n  &:after{\n    position: absolute;\n    font-family: $nk-dashlite-font;\n    content: $ni-cross-sm;\n    color: $base-text;\n  }\n}\n.mfp-close-btn-in {\n  .mfp-close {\n    color: $mfp-inner-close-icon-color;\n  }\n}\n.mfp-image-holder,\n.mfp-iframe-holder {\n  .mfp-close {\n    color: $white;\n  }\n}\n\n// \"1 of X\" counter\n.mfp-counter {\n  position: absolute;\n  top: 0;\n  @if($rtl==false){\n    right: 0;\n  }\n  @if($rtl==true){\n    left: 0;\n  }\n  color: $mfp-controls-text-color;\n  font-size: 12px;\n  line-height: 18px;\n  white-space: nowrap;\n}\n\n// Navigation arrows\n@if $mfp-include-arrows {\n  .mfp-arrow {\n    position: absolute;\n    opacity: $mfp-controls-opacity;\n    margin: 0;\n    top: 50%;\n    margin-top: -55px;\n    padding: 0;\n    width: 90px;\n    height: 110px;\n    -webkit-tap-highlight-color: rgba(0,0,0,0);\n    &:active {\n      margin-top: -54px;\n    }\n    &:hover,\n    &:focus {\n      opacity: 1;\n    }\n    &:before,\n    &:after {\n      content: '';\n      display: block;\n      width: 0;\n      height: 0;\n      position: absolute;\n      @if($rtl==false){\n        left: 0;\n      }\n      @if($rtl==true){\n        right: 0;\n      }\n      top: 0;\n      margin-top: 35px;\n      @if($rtl==false){\n        margin-left: 35px;\n      }\n      @if($rtl==true){\n        margin-right: 35px;\n      }\n      border: medium inset transparent;\n    }\n\n    &:after {\n\n      border-top-width: 13px;\n      border-bottom-width: 13px;\n      top:8px;\n    }\n\n    &:before {\n      border-top-width: 21px;\n      border-bottom-width: 21px;\n      opacity: 0.7;\n    }\n\n  }\n\n  .mfp-arrow-left {\n    @if($rtl==false){\n      left: 0;\n      &:after {\n        border-right: 17px solid $mfp-controls-color;\n        margin-left: 31px;\n      }\n      &:before {\n        margin-left: 25px;\n        border-right: 27px solid $mfp-controls-border-color;\n      }\n    }\n    @if($rtl==true){\n      right: 0;\n      &:after {\n        border-left: 17px solid $mfp-controls-color;\n        margin-right: 31px;\n      }\n      &:before {\n        margin-right: 25px;\n        border-left: 27px solid $mfp-controls-border-color;\n      }\n    }\n  }\n\n  .mfp-arrow-right {\n    @if($rtl==false){\n      right: 0;\n      &:after {\n        border-left: 17px solid $mfp-controls-color;\n        margin-left: 39px\n      }\n      &:before {\n        border-left: 27px solid $mfp-controls-border-color;\n      }\n    }\n    @if($rtl==true){\n      left: 0;\n      &:after {\n        border-right: 17px solid $mfp-controls-color;\n        margin-right: 39px\n      }\n      &:before {\n        border-right: 27px solid $mfp-controls-border-color;\n      }\n    }\n  }\n}\n\n\n\n// Iframe content type\n@if $mfp-include-iframe-type {\n  .mfp-iframe-holder {\n    padding-top: $mfp-iframe-padding-top;\n    padding-bottom: $mfp-iframe-padding-top;\n    .mfp-content {\n      line-height: 0;\n      width: 100%;\n      max-width: $mfp-iframe-max-width;\n    }\n    // .mfp-close {\n    //   top: -40px;\n    // }\n  }\n  .mfp-iframe-scaler {\n    width: 100%;\n    height: 0;\n    overflow: hidden;\n    padding-top: $mfp-iframe-ratio * 100%;\n    iframe {\n      position: absolute;\n      display: block;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      box-shadow: $mfp-shadow;\n      background: $mfp-iframe-background;\n      border-radius: $border-radius-xl;\n    }\n  }\n}\n\n\n\n// Image content type\n@if $mfp-include-image-type {\n\n  /* Main image in popup */\n  img {\n    &.mfp-img {\n      width: auto;\n      max-width: 100%;\n      height: auto;\n      display: block;\n      line-height: 0;\n      box-sizing: border-box;\n      // padding: $mfp-image-padding-top 0 $mfp-image-padding-bottom;\n      margin: 0 auto;\n      border-radius: $border-radius-xl;\n    }\n  }\n\n  /* The shadow behind the image */\n  .mfp-figure {\n    line-height: 0;\n    &:after {\n      content: '';\n      position: absolute;\n      left: 0;\n      top: $mfp-image-padding-top;\n      bottom: $mfp-image-padding-bottom;\n      display: block;\n      right: 0;\n      width: auto;\n      height: auto;\n      z-index: -1;\n      box-shadow: $mfp-shadow;\n      background: $mfp-image-background;\n    }\n    small {\n      color: $mfp-caption-subtitle-color;\n      display: block;\n      font-size: 12px;\n      line-height: 14px;\n    }\n    figure {\n      margin: 0;\n    }\n  }\n  .mfp-bottom-bar {\n    margin-top: -$mfp-image-padding-bottom + 4;\n    position: absolute;\n    top: 100%;\n    @if($rtl==false){\n      left: 0;\n    }\n    @if($rtl==true){\n      right: 0;\n    }\n    width: 100%;\n    cursor: auto;\n  }\n  .mfp-title {\n    @if($rtl==false){\n      text-align: left;\n    }\n    @if($rtl==true){\n      text-align: right;\n    }\n    line-height: 18px;\n    color: $mfp-caption-title-color;\n    word-wrap: break-word;\n    @if($rtl==false){\n      padding-right: 36px; // leave some space for counter at right side\n    }\n    @if($rtl==true){\n      padding-left: 36px; // leave some space for counter at right side\n    }\n  }\n\n  .mfp-image-holder {\n    .mfp-content {\n      max-width: 100%;\n    }\n  }\n\n  .mfp-gallery {\n    .mfp-image-holder {\n      .mfp-figure {\n        cursor: pointer;\n      }\n    }\n  }\n\n\n  @if $mfp-include-mobile-layout-for-image {\n    @media screen and (max-width: 800px) and (orientation:landscape), screen and (max-height: 300px) {\n      /**\n       * Remove all paddings around the image on small screen\n       */\n      .mfp-img-mobile {\n        .mfp-image-holder {\n          padding-left: 0;\n          padding-right: 0;\n        }\n        img {\n          &.mfp-img {\n            padding: 0;\n          }\n        }\n        .mfp-figure {\n          // The shadow behind the image\n          &:after {\n            top: 0;\n            bottom: 0;\n          }\n          small {\n            display: inline;\n            @if($rtl==false){\n              margin-left: 5px;\n            }\n            @if($rtl==true){\n              margin-right: 5px;\n            }\n          }\n        }\n        .mfp-bottom-bar {\n          background: rgba(0,0,0,0.6);\n          bottom: 0;\n          margin: 0;\n          top: auto;\n          padding: 3px 5px;\n          position: fixed;\n          box-sizing: border-box;\n          &:empty {\n            padding: 0;\n          }\n        }\n        .mfp-counter {\n          @if($rtl==false){\n            right: 5px;\n          }\n          @if($rtl==true){\n            left: 5px;\n          }\n          top: 3px;\n        }\n        .mfp-close {\n          top: 0;\n          @if($rtl==false){\n            right: 0;\n          }\n          @if($rtl==true){\n            left: 0;\n          }\n          width: 35px;\n          height: 35px;\n          line-height: 35px;\n          background: rgba(0, 0, 0, 0.6);\n          position: fixed;\n          text-align: center;\n          padding: 0;\n        }\n      }\n    }\n  }\n}\n\n\n\n// Scale navigation arrows and reduce padding from sides\n@media all and (max-width: 900px) {\n  .mfp-arrow {\n    -webkit-transform: scale(0.75);\n    transform: scale(0.75);\n  }\n  .mfp-arrow-left {\n    -webkit-transform-origin: 0;\n    transform-origin: 0;\n  }\n  .mfp-arrow-right {\n    -webkit-transform-origin: 100%;\n    transform-origin: 100%;\n  }\n  .mfp-container {\n    padding-left: $mfp-popup-padding-left-mobile;\n    padding-right: $mfp-popup-padding-left-mobile;\n  }\n}\n\n","////////////////////////\n//      Settings      //\n////////////////////////\n@use 'sass:math';\n// overlay\n$mfp-overlay-color:                   #0b0b0b !default;                    // Color of overlay screen\n$mfp-overlay-opacity:                 0.8 !default;                        // Opacity of overlay screen\n$mfp-shadow:                          0 0 8px rgba(0, 0, 0, 0.6) !default; // Shadow on image or iframe\n\n// spacing\n$mfp-popup-padding-left:              8px !default;                        // Padding from left and from right side\n$mfp-popup-padding-left-mobile:       6px !default;                        // Same as above, but is applied when width of window is less than 800px\n\n$mfp-z-index-base:                    1040 !default;                       // Base z-index of popup\n\n// controls\n$mfp-include-arrows:                  true !default;                       // Include styles for nav arrows\n$mfp-controls-opacity:                0.65 !default;                       // Opacity of controls\n$mfp-controls-color:                  #FFF !default;                       // Color of controls\n$mfp-controls-border-color:           #3F3F3F !default; \t                 // Border color of controls\n$mfp-inner-close-icon-color:          #333 !default;                       // Color of close button when inside\n$mfp-controls-text-color:             #CCC !default;                       // Color of preloader and \"1 of X\" indicator\n$mfp-controls-text-color-hover:       #FFF !default;                       // Hover color of preloader and \"1 of X\" indicator\n\n// Iframe-type options\n$mfp-include-iframe-type:             true !default;                       // Enable Iframe-type popups\n$mfp-iframe-padding-top:              40px !default;                       // Iframe padding top\n$mfp-iframe-background:               #000 !default;                       // Background color of iframes\n$mfp-iframe-max-width:                900px !default;                      // Maximum width of iframes\n$mfp-iframe-ratio:                    math.div(9,16) !default;                       // Ratio of iframe (9/16 = widescreen, 3/4 = standard, etc.)\n\n// Image-type options\n$mfp-include-image-type:              true !default;                       // Enable Image-type popups\n$mfp-image-background:                #444 !default;\n$mfp-image-padding-top:               40px !default;                       // Image padding top\n$mfp-image-padding-bottom:            40px !default;                       // Image padding bottom\n$mfp-include-mobile-layout-for-image: true !default;                       // Removes paddings from top and bottom\n\n// Image caption options\n$mfp-caption-title-color:             #F3F3F3 !default;                    // Caption title color\n$mfp-caption-subtitle-color:          #BDBDBD !default;                    // Caption subtitle color\n\n// A11y\n$mfp-use-visuallyhidden:              false !default;                      // Hide content from browsers, but make it available for screen readers\n","$animation-speed: .3s;\n$animation-function: ease-out;\n$backdrop-color: rgba(0, 0, 0, .5);\n\n@keyframes modal-video {\n\tfrom {\n\t\topacity: 0;\n\t}\n\n\tto {\n\t\topacity: 1;\n\t}\n}\n\n@keyframes modal-video-inner {\n\tfrom {\n\t\ttransform: translate(0, 100px);\n\t}\n\n\tto {\n\t\ttransform: translate(0, 0);\n\t}\n}\n\n.modal-video {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color: $backdrop-color;\n\tz-index: 1000000;\n\tcursor: pointer;\n\topacity: 1;\n\tanimation-timing-function: $animation-function;\n\tanimation-duration: $animation-speed;\n\tanimation-name: modal-video;\n\t-webkit-transition: opacity $animation-speed $animation-function;\n\t-moz-transition: opacity $animation-speed $animation-function;\n\t-ms-transition: opacity $animation-speed $animation-function;\n\t-o-transition: opacity $animation-speed $animation-function;\n\ttransition: opacity $animation-speed $animation-function;\n}\n\n.modal-video-effect-exit {\n\topacity: 0;\n\n\t& .modal-video-movie-wrap {\n\t\t-webkit-transform: translate(0, 100px);\n\t\t-moz-transform: translate(0, 100px);\n\t\t-ms-transform: translate(0, 100px);\n\t\t-o-transform: translate(0, 100px);\n\t\ttransform: translate(0, 100px);\n\t}\n}\n\n.modal-video-body {\n\tmax-width: 960px;\n\twidth: 100%;\n\theight: 100%;\n\tmargin: 0 auto;\n\tpadding: 0 10px;\n    display: flex;\n    justify-content: center;\n\tbox-sizing: border-box;\n}\n\n.modal-video-inner {\n\tdisplay: flex;\n    justify-content: center;\n    align-items: center;\n\twidth: 100%;\n\theight: 100%;\n\n    @media (orientation: landscape) {\n        padding: 10px 60px;\n        box-sizing: border-box;\n    }\n}\n\n.modal-video-movie-wrap {\n\twidth: 100%;\n\theight: 0;\n\tposition: relative;\n\tpadding-bottom: 56.25%;\n\tbackground-color: #333;\n\tanimation-timing-function: $animation-function;\n\tanimation-duration: $animation-speed;\n\tanimation-name: modal-video-inner;\n\t-webkit-transform: translate(0, 0);\n\t-moz-transform: translate(0, 0);\n\t-ms-transform: translate(0, 0);\n\t-o-transform: translate(0, 0);\n\ttransform: translate(0, 0);\n\t-webkit-transition: -webkit-transform $animation-speed $animation-function;\n\t-moz-transition: -moz-transform $animation-speed $animation-function;\n\t-ms-transition: -ms-transform $animation-speed $animation-function;\n\t-o-transition: -o-transform $animation-speed $animation-function;\n\ttransition: transform $animation-speed $animation-function;\n\n\t& iframe {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n}\n\n.modal-video-close-btn {\n\tposition: absolute;\n\tz-index: 2;\n\ttop: -45px;\n\tright: 0px;\n\tdisplay: inline-block;\n\twidth: 35px;\n\theight: 35px;\n\toverflow: hidden;\n\tborder: none;\n\tbackground: transparent;\n\n    @media (orientation: landscape) {\n        top: 0;\n        right: -45px;\n    }\n\n\t&:before {\n\t\ttransform: rotate(45deg);\n\t}\n\n\t&:after {\n\t\ttransform: rotate(-45deg);\n\t}\n\n\t&:before,\n\t&:after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\theight: 2px;\n\t\twidth: 100%;\n\t\ttop: 50%;\n\t\tleft: 0;\n\t\tmargin-top: -1px;\n\t\tbackground: #fff;\n\t\tborder-radius: 5px;\n\t\tmargin-top: -6px;\n\t}\n}\n",":root {\n  --toastify-color-light: #fff;\n  --toastify-color-dark: #121212;\n  --toastify-color-info: #09c2de;\n  --toastify-color-success: #1ee0ac;\n  --toastify-color-warning: #f4bd0e;\n  --toastify-color-error: #e85347;\n  --toastify-color-transparent: rgba(255, 255, 255, 0.7);\n  --toastify-icon-color-info: var(--toastify-color-info);\n  --toastify-icon-color-success: var(--toastify-color-success);\n  --toastify-icon-color-warning: var(--toastify-color-warning);\n  --toastify-icon-color-error: var(--toastify-color-error);\n  --toastify-toast-width: 320px;\n  --toastify-toast-background: #fff;\n  --toastify-toast-min-height: 64px;\n  --toastify-toast-max-height: 800px;\n  --toastify-font-family: sans-serif;\n  --toastify-z-index: 9999;\n  --toastify-text-color-light: #757575;\n  --toastify-text-color-dark: #fff;\n  --toastify-text-color-info: #fff;\n  --toastify-text-color-success: #fff;\n  --toastify-text-color-warning: #fff;\n  --toastify-text-color-error: #fff;\n  --toastify-spinner-color: #616161;\n  --toastify-spinner-color-empty-area: #e0e0e0;\n  --toastify-color-progress-light: linear-gradient(\n    to right,\n    #4cd964,\n    #5ac8fa,\n    #007aff,\n    #34aadc,\n    #5856d6,\n    #ff2d55\n  );\n  --toastify-color-progress-dark: #bb86fc;\n  --toastify-color-progress-info: var(--toastify-color-info);\n  --toastify-color-progress-success: var(--toastify-color-success);\n  --toastify-color-progress-warning: var(--toastify-color-warning);\n  --toastify-color-progress-error: var(--toastify-color-error);\n}\n\n$toast-close-icon: $ni-cross !default;\n\n.Toastify__toast-container {\n  z-index: var(--toastify-z-index);\n  -webkit-transform: translate3d(0, 0, var(--toastify-z-index) px);\n  position: fixed;\n  box-sizing: border-box;\n  color: #fff;\n  background-color: transparent;\n}\n.Toastify__toast-container--top-left {\n  top: 1em;\n  left: 1em;\n}\n.Toastify__toast-container--top-center {\n  top: 1em;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.Toastify__toast-container--top-right {\n  top: 1em;\n  right: 1em;\n}\n.Toastify__toast-container--bottom-left {\n  bottom: 1em;\n  left: 1em;\n}\n.Toastify__toast-container--bottom-center {\n  bottom: 1em;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.Toastify__toast-container--bottom-right {\n  bottom: 1em;\n  right: 1em;\n}\n\n@media only screen and (max-width : 480px) {\n  .Toastify__toast-container {\n    width: 100vw;\n    padding: 0;\n    left: 0;\n    margin: 0;\n  }\n  .Toastify__toast-container--top-left, .Toastify__toast-container--top-center, .Toastify__toast-container--top-right {\n    top: 0;\n    transform: translateX(0);\n  }\n  .Toastify__toast-container--bottom-left, .Toastify__toast-container--bottom-center, .Toastify__toast-container--bottom-right {\n    bottom: 0;\n    transform: translateX(0);\n  }\n  .Toastify__toast-container--rtl {\n    right: 0;\n    left: initial;\n  }\n}\n.Toastify__toast {\n  position: relative;\n  min-height: var(--toastify-toast-min-height);\n  box-sizing: border-box;\n  border-radius: 4px;\n  color: $base-text !important;\n  margin-bottom: 1rem;\n  width: 425px;\n  background-color: $white;\n  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1), 0 2px 15px 0 rgba(0, 0, 0, 0.05);\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  max-height: var(--toastify-toast-max-height);\n  overflow: hidden;\n  font-family: var(--toastify-font-family);\n  border-left: 4px solid transparent;\n  padding: 0.8rem 0.2rem 0.8rem 1.25rem;\n  opacity: 1;\n  cursor: pointer;\n  direction: ltr;\n}\n.Toastify__toast--rtl {\n  direction: rtl;\n}\n.Toastify__toast-body {\n  margin: auto 0;\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n  padding: 6px;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 0.875rem;\n  line-height: 1.3rem;\n  -ms-flex-align: center;\n      align-items: center;\n  .toastr-text{\n    padding-left: 0.5rem;\n  }\n}\n\n.toastr-text > h4, .toastr-text > h5, .toastr-text > h6 {\n  margin-bottom: 0.35rem;\n  font-size: 1rem;\n  .is-dark & {\n      color: $white;\n  }\n}\n\n.Toastify__toast-body > div:last-child {\n  -ms-flex: 1;\n      flex: 1;\n}\n.Toastify__toast-icon {\n  -webkit-margin-end: 10px;\n          margin-inline-end: 10px;\n  width: 20px;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.Toastify--animate {\n  animation-fill-mode: both;\n  animation-duration: 0.7s;\n}\n\n.Toastify--animate-icon {\n  animation-fill-mode: both;\n  animation-duration: 0.3s;\n}\n\n.toast-close-button{\n  position: absolute;\n  @if($rtl==false){\n      right: 12px;\n  }\n  @if($rtl==true){\n      left: 12px;\n  }\n  top: 50%;\n  transform: translateY(-50%);\n  display: inline-block;\n  height: 32px;\n  width: 32px;\n  text-indent: -9999px;\n  cursor: pointer;\n  &:after{\n      position: absolute;\n      top: 0;\n      left: 0;\n      text-indent: 0;\n      color: $base-light;\n      font-family: $nk-dashlite-font;\n      content: $toast-close-icon;\n      font-size: 18px;\n      line-height: 32px;\n      width: 100%;\n      text-align: center;\n      .is-dark & {\n          color: $light-300;\n      }\n  }\n}\n\n@media only screen and (max-width : 480px) {\n  .Toastify__toast {\n    margin-bottom: 0;\n    border-radius: 0;\n  }\n}\n.Toastify__toast-theme--dark {\n  background: var(--toastify-color-dark);\n  border-color : $info;\n  .icon{\n      color: $info;\n  }\n  color: $white !important;\n  .toast-close-button{\n    position: absolute;\n    @if($rtl==false){\n        right: 12px;\n    }\n    @if($rtl==true){\n        left: 12px;\n    }\n    top: 50%;\n    transform: translateY(-50%);\n    display: inline-block;\n    height: 32px;\n    width: 32px;\n    text-indent: -9999px;\n    cursor: pointer;\n    &:after{\n        position: absolute;\n        top: 0;\n        left: 0;\n        text-indent: 0;\n        color: $light-300;\n        font-family: $nk-dashlite-font;\n        content: $toast-close-icon;\n        font-size: 18px;\n        line-height: 32px;\n        width: 100%;\n        text-align: center;\n    }\n  }\n  .btn-trigger::before{\n    background: none;\n  }\n}\n.Toastify__toast-theme--dark > h5  {\n  color: $white !important;\n}\n.Toastify__toast-theme--light {\n  color: var(--toastify-text-color-light);\n}\n.Toastify__toast--default {\n  color: var(--toastify-text-color-light);\n}\n.Toastify__toast--info {\n  border-color : $info;\n  .icon{\n      color: $info;\n  }\n}\n.Toastify__toast--success {\n  border-color : $success;\n  .icon{\n    color: $success;\n  }\n}\n.Toastify__toast--warning {\n  border-color : $warning;\n  .icon{\n    color: $warning;\n  }\n}\n.Toastify__toast--error {\n  border-color : $danger;\n  .icon{\n      color: $danger;\n  }\n}\n\n.Toastify__progress-bar-theme--light {\n  background: var(--toastify-color-progress-light);\n}\n.Toastify__progress-bar-theme--dark {\n  background: var(--toastify-color-progress-dark);\n}\n.Toastify__progress-bar--info {\n  background: var(--toastify-color-progress-info);\n}\n.Toastify__progress-bar--success {\n  background: var(--toastify-color-progress-success);\n}\n.Toastify__progress-bar--warning {\n  background: var(--toastify-color-progress-warning);\n}\n.Toastify__progress-bar--error {\n  background: var(--toastify-color-progress-error);\n}\n.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info, .Toastify__progress-bar-theme--colored.Toastify__progress-bar--success, .Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning, .Toastify__progress-bar-theme--colored.Toastify__progress-bar--error {\n  background: var(--toastify-color-transparent);\n}\n\n.Toastify__close-button {\n  color: $base-light;\n  background: transparent;\n  font-family: $nk-dashlite-font;\n  outline: none;\n  border: none;\n  padding: 5px 10px;\n  cursor: pointer;\n  opacity: 0.7;\n  transition: 0.3s ease;\n  -ms-flex-item-align: start;\n      align-self: flex-start;\n  &:active, &:focus {\n    outline: none !important;\n  }\n}\n.Toastify__close-button--light {\n  color: #000;\n  opacity: 0.3;\n}\n.Toastify__close-button > svg {\n  fill: currentColor;\n  height: 16px;\n  width: 14px;\n}\n.Toastify__close-button:hover, .Toastify__close-button:focus {\n  opacity: 1;\n}\n\n@keyframes Toastify__trackProgress {\n  0% {\n    transform: scaleX(1);\n  }\n  100% {\n    transform: scaleX(0);\n  }\n}\n.Toastify__progress-bar {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 5px;\n  z-index: var(--toastify-z-index);\n  opacity: 0.7;\n  transform-origin: left;\n}\n.Toastify__progress-bar--animated {\n  animation: Toastify__trackProgress linear 1 forwards;\n}\n.Toastify__progress-bar--controlled {\n  transition: transform 0.2s;\n}\n.Toastify__progress-bar--rtl {\n  right: 0;\n  left: initial;\n  transform-origin: right;\n}\n\n.Toastify__spinner {\n  width: 20px;\n  height: 20px;\n  box-sizing: border-box;\n  border: 2px solid;\n  border-radius: 100%;\n  border-color: var(--toastify-spinner-color-empty-area);\n  border-right-color: var(--toastify-spinner-color);\n  animation: Toastify__spin 0.65s linear infinite;\n}\n\n\n\n@keyframes Toastify__bounceInRight {\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  from {\n    opacity: 0;\n    transform: translate3d(3000px, 0, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(-25px, 0, 0);\n  }\n  75% {\n    transform: translate3d(10px, 0, 0);\n  }\n  90% {\n    transform: translate3d(-5px, 0, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n@keyframes Toastify__bounceOutRight {\n  20% {\n    opacity: 1;\n    transform: translate3d(-20px, 0, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0);\n  }\n}\n@keyframes Toastify__bounceInLeft {\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  0% {\n    opacity: 0;\n    transform: translate3d(-3000px, 0, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(25px, 0, 0);\n  }\n  75% {\n    transform: translate3d(-10px, 0, 0);\n  }\n  90% {\n    transform: translate3d(5px, 0, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n@keyframes Toastify__bounceOutLeft {\n  20% {\n    opacity: 1;\n    transform: translate3d(20px, 0, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0);\n  }\n}\n@keyframes Toastify__bounceInUp {\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  from {\n    opacity: 0;\n    transform: translate3d(0, 3000px, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n  75% {\n    transform: translate3d(0, 10px, 0);\n  }\n  90% {\n    transform: translate3d(0, -5px, 0);\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__bounceOutUp {\n  20% {\n    transform: translate3d(0, -10px, 0);\n  }\n  40%, 45% {\n    opacity: 1;\n    transform: translate3d(0, 20px, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n}\n@keyframes Toastify__bounceInDown {\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  0% {\n    opacity: 0;\n    transform: translate3d(0, -3000px, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(0, 25px, 0);\n  }\n  75% {\n    transform: translate3d(0, -10px, 0);\n  }\n  90% {\n    transform: translate3d(0, 5px, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n@keyframes Toastify__bounceOutDown {\n  20% {\n    transform: translate3d(0, 10px, 0);\n  }\n  40%, 45% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0);\n  }\n}\n.Toastify__bounce-enter--top-left, .Toastify__bounce-enter--bottom-left {\n  animation-name: Toastify__bounceInLeft;\n}\n.Toastify__bounce-enter--top-right, .Toastify__bounce-enter--bottom-right {\n  animation-name: Toastify__bounceInRight;\n}\n.Toastify__bounce-enter--top-center {\n  animation-name: Toastify__bounceInDown;\n}\n.Toastify__bounce-enter--bottom-center {\n  animation-name: Toastify__bounceInUp;\n}\n\n.Toastify__bounce-exit--top-left, .Toastify__bounce-exit--bottom-left {\n  animation-name: Toastify__bounceOutLeft;\n}\n.Toastify__bounce-exit--top-right, .Toastify__bounce-exit--bottom-right {\n  animation-name: Toastify__bounceOutRight;\n}\n.Toastify__bounce-exit--top-center {\n  animation-name: Toastify__bounceOutUp;\n}\n.Toastify__bounce-exit--bottom-center {\n  animation-name: Toastify__bounceOutDown;\n}\n\n@keyframes Toastify__zoomIn {\n  from {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n  50% {\n    opacity: 1;\n  }\n}\n@keyframes Toastify__zoomOut {\n  from {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n  to {\n    opacity: 0;\n  }\n}\n.Toastify__zoom-enter {\n  animation-name: Toastify__zoomIn;\n}\n\n.Toastify__zoom-exit {\n  animation-name: Toastify__zoomOut;\n}\n\n@keyframes Toastify__flipIn {\n  from {\n    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    animation-timing-function: ease-in;\n    opacity: 0;\n  }\n  40% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    animation-timing-function: ease-in;\n  }\n  60% {\n    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n    opacity: 1;\n  }\n  80% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\n  }\n  to {\n    transform: perspective(400px);\n  }\n}\n@keyframes Toastify__flipOut {\n  from {\n    transform: perspective(400px);\n  }\n  30% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    opacity: 1;\n  }\n  to {\n    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    opacity: 0;\n  }\n}\n.Toastify__flip-enter {\n  animation-name: Toastify__flipIn;\n}\n\n.Toastify__flip-exit {\n  animation-name: Toastify__flipOut;\n}\n\n@keyframes Toastify__slideInRight {\n  from {\n    transform: translate3d(110%, 0, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__slideInLeft {\n  from {\n    transform: translate3d(-110%, 0, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__slideInUp {\n  from {\n    transform: translate3d(0, 110%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__slideInDown {\n  from {\n    transform: translate3d(0, -110%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__slideOutRight {\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(110%, 0, 0);\n  }\n}\n@keyframes Toastify__slideOutLeft {\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(-110%, 0, 0);\n  }\n}\n@keyframes Toastify__slideOutDown {\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(0, 500px, 0);\n  }\n}\n@keyframes Toastify__slideOutUp {\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(0, -500px, 0);\n  }\n}\n.Toastify__slide-enter--top-left, .Toastify__slide-enter--bottom-left {\n  animation-name: Toastify__slideInLeft;\n}\n.Toastify__slide-enter--top-right, .Toastify__slide-enter--bottom-right {\n  animation-name: Toastify__slideInRight;\n}\n.Toastify__slide-enter--top-center {\n  animation-name: Toastify__slideInDown;\n}\n.Toastify__slide-enter--bottom-center {\n  animation-name: Toastify__slideInUp;\n}\n\n.Toastify__slide-exit--top-left, .Toastify__slide-exit--bottom-left {\n  animation-name: Toastify__slideOutLeft;\n}\n.Toastify__slide-exit--top-right, .Toastify__slide-exit--bottom-right {\n  animation-name: Toastify__slideOutRight;\n}\n.Toastify__slide-exit--top-center {\n  animation-name: Toastify__slideOutUp;\n}\n.Toastify__slide-exit--bottom-center {\n  animation-name: Toastify__slideOutDown;\n}\n\n@keyframes Toastify__spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/*# sourceMappingURL=ReactToastify.css.map */",".jvectormap-container {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    overflow: hidden;\n    touch-action: none;\n}\n\n.jvectormap-tip {\n    position: absolute;\n    display: none;\n    border: solid 1px #CDCDCD;\n    border-radius: 3px;\n    background: #292929;\n    color: white;\n    font-family: sans-serif, Verdana;\n    font-size: smaller;\n    padding: 3px;\n}\n\n.jvectormap-zoomin, .jvectormap-zoomout, .jvectormap-goback {\n    position: absolute;\n    left: 10px;\n    border-radius: 3px;\n    background: #292929;\n    padding: 3px;\n    color: white;\n    cursor: pointer;\n    line-height: 10px;\n    text-align: center;\n    box-sizing: content-box;\n}\n\n.jvectormap-zoomin, .jvectormap-zoomout {\n    width: 10px;\n    height: 10px;\n}\n\n.jvectormap-zoomin {\n    top: 10px;\n}\n\n.jvectormap-zoomout {\n    top: 30px;\n}\n\n.jvectormap-goback {\n    bottom: 10px;\n    z-index: 1000;\n    padding: 6px;\n}\n\n.jvectormap-spinner {\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    background: center no-repeat url(data:image/gif;base64,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);\n}\n\n.jvectormap-legend-title {\n    font-weight: bold;\n    font-size: 14px;\n    text-align: center;\n}\n\n.jvectormap-legend-cnt {\n    position: absolute;\n}\n\n.jvectormap-legend-cnt-h {\n    bottom: 0;\n    right: 0;\n}\n\n.jvectormap-legend-cnt-v {\n    top: 0;\n    right: 0;\n}\n\n.jvectormap-legend {\n    background: black;\n    color: white;\n    border-radius: 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend {\n    float: left;\n    margin: 0 10px 10px 0;\n    padding: 3px 3px 1px 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {\n    float: left;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend {\n    margin: 10px 10px 0 0;\n    padding: 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick {\n    width: 40px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {\n    height: 15px;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend-tick-sample {\n    height: 20px;\n    width: 20px;\n    display: inline-block;\n    vertical-align: middle;\n}\n\n.jvectormap-legend-tick-text {\n    font-size: 12px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-text {\n    text-align: center;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend-tick-text {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 20px;\n    padding-left: 3px;\n}\n","$image_throbber : \"../../../images/jsTree/throbber.gif\";\n$image_throbber_dark : \"../../../images/jsTree/throbber-dark.gif\";\n$image_32 : \"../../../images/jsTree/32px.png\";\n$image_32_dark : \"../../../images/jsTree/32px-dark.png\";\n$image_40 : \"../../../images/jsTree/40px.png\";\n$image_40_dark : \"../../../images/jsTree/40px-dark.png\";\n/* jsTree default theme */\n.jstree-node,\n.jstree-children,\n.jstree-container-ul {\n  display: block;\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n  list-style-image: none;\n}\n.jstree-node {\n  white-space: nowrap;\n}\n.jstree-anchor {\n  display: inline-block;\n  color: black;\n  white-space: nowrap;\n  padding: 0 4px 0 1px;\n  margin: 0;\n  vertical-align: top;\n}\n.jstree-anchor:focus {\n  outline: 0;\n}\n.jstree-anchor,\n.jstree-anchor:link,\n.jstree-anchor:visited,\n.jstree-anchor:hover,\n.jstree-anchor:active {\n  text-decoration: none;\n  color: inherit;\n}\n.jstree-icon {\n  display: inline-block;\n  text-decoration: none;\n  margin: 0;\n  padding: 0;\n  vertical-align: top;\n  text-align: center;\n}\n.jstree-icon:empty {\n  display: inline-block;\n  text-decoration: none;\n  margin: 0;\n  padding: 0;\n  vertical-align: top;\n  text-align: center;\n}\n.jstree-ocl {\n  cursor: pointer;\n}\n.jstree-leaf > .jstree-ocl {\n  cursor: default;\n}\n.jstree .jstree-open > .jstree-children {\n  display: block;\n}\n.jstree .jstree-closed > .jstree-children,\n.jstree .jstree-leaf > .jstree-children {\n  display: none;\n}\n.jstree-anchor > .jstree-themeicon {\n  margin-right: 2px;\n}\n.jstree-no-icons .jstree-themeicon,\n.jstree-anchor > .jstree-themeicon-hidden {\n  display: none;\n}\n.jstree-hidden,\n.jstree-node.jstree-hidden {\n  display: none;\n}\n.jstree-rtl .jstree-anchor {\n  padding: 0 1px 0 4px;\n}\n.jstree-rtl .jstree-anchor > .jstree-themeicon {\n  margin-left: 2px;\n  margin-right: 0;\n}\n.jstree-rtl .jstree-node {\n  margin-left: 0;\n}\n.jstree-rtl .jstree-container-ul > .jstree-node {\n  margin-right: 0;\n}\n.jstree-wholerow-ul {\n  position: relative;\n  display: inline-block;\n  min-width: 100%;\n}\n.jstree-wholerow-ul .jstree-leaf > .jstree-ocl {\n  cursor: pointer;\n}\n.jstree-wholerow-ul .jstree-anchor,\n.jstree-wholerow-ul .jstree-icon {\n  position: relative;\n}\n.jstree-wholerow-ul .jstree-wholerow {\n  width: 100%;\n  cursor: pointer;\n  position: absolute;\n  left: 0;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.jstree-contextmenu .jstree-anchor {\n  -webkit-user-select: none;\n  /* disable selection/Copy of UIWebView */\n  -webkit-touch-callout: none;\n  /* disable the IOS popup when long-press on a link */\n}\n.vakata-context {\n  display: none;\n}\n.vakata-context,\n.vakata-context ul {\n  margin: 0;\n  padding: .5rem 0;\n  position: absolute;\n  background-color: $dropdown-bg;\n  border-radius:$dropdown-border-radius;\n  border: $dropdown-border-width solid $dropdown-border-color;\n  box-shadow: $dropdown-box-shadow;\n  min-width: $dropdown-width-sm;\n}\n.vakata-context ul {\n  list-style: none;\n  left: 100%;\n  margin-top: -2.7em;\n  margin-left: -4px;\n}\n.vakata-context .vakata-context-right ul {\n  left: auto;\n  right: 100%;\n  margin-left: auto;\n  margin-right: -4px;\n}\n.vakata-context li {\n  list-style: none;\n}\n.vakata-context li > a {\n  display: block;\n  padding: 0 1.25rem;\n  text-decoration: none;\n  width: auto;\n  white-space: nowrap;\n  line-height: 2.4em;\n  font-weight: $fw-medium;\n  color: $base-text;\n}\n.vakata-context li > a:hover {\n  position: relative;\n  color: $accent-color; \n  background: $lighter; \n  box-shadow: none;\n}\n.vakata-context li > a.vakata-context-parent {\n  background-image: url(\"data:image/gif;base64,R0lGODlhCwAHAIAAACgoKP///yH5BAEAAAEALAAAAAALAAcAAAIORI4JlrqN1oMSnmmZDQUAOw==\");\n  background-position: right center;\n  background-repeat: no-repeat;\n}\n.vakata-context li > a:focus {\n  outline: 0;\n}\n.vakata-context .vakata-context-hover > a {\n  position: relative;\n  color: $accent-color; \n  background: $lighter; \n  box-shadow: none;\n}\n.vakata-context .vakata-context-separator > a,\n.vakata-context .vakata-context-separator > a:hover {\n  background: white;\n  border: 0;\n  border-top: 1px solid #e2e3e3;\n  height: 1px;\n  min-height: 1px;\n  max-height: 1px;\n  padding: 0;\n  margin: 0 0 0 2.4em;\n  border-left: 1px solid #e0e0e0;\n  text-shadow: 0 0 0 transparent;\n  box-shadow: 0 0 0 transparent;\n  border-radius: 0;\n  display: none;\n}\n.vakata-context .vakata-contextmenu-disabled a,\n.vakata-context .vakata-contextmenu-disabled a:hover {\n  color: silver;\n  background-color: transparent;\n  border: 0;\n  box-shadow: 0 0 0;\n}\n.vakata-context .vakata-contextmenu-disabled > a > i {\n  filter: grayscale(100%);\n}\n.vakata-context li > a > i {\n  text-decoration: none;\n  display: inline-block;\n  width: 2.4em;\n  height: 2.4em;\n  background: transparent;\n  margin: 0 0 0 -2em;\n  vertical-align: top;\n  text-align: center;\n  line-height: 2.4em;\n}\n.vakata-context li > a > i:empty {\n  width: 2.4em;\n  line-height: 2.4em;\n}\n.vakata-context li > a .vakata-contextmenu-sep {\n  display: inline-block;\n  width: 1px;\n  height: 2.4em;\n  background: white;\n  margin: 0 0.5em 0 0;\n  border-left: 1px solid #e2e3e3;\n  display: none;\n}\n.vakata-context .vakata-contextmenu-shortcut {\n  font-size: 0.8em;\n  color: silver;\n  opacity: 0.5;\n  display: none;\n}\n.vakata-context-rtl ul {\n  left: auto;\n  right: 100%;\n  margin-left: auto;\n  margin-right: -4px;\n}\n.vakata-context-rtl li > a.vakata-context-parent {\n  background-image: url(\"data:image/gif;base64,R0lGODlhCwAHAIAAACgoKP///yH5BAEAAAEALAAAAAALAAcAAAINjI+AC7rWHIsPtmoxLAA7\");\n  background-position: left center;\n  background-repeat: no-repeat;\n}\n.vakata-context-rtl .vakata-context-separator > a {\n  margin: 0 2.4em 0 0;\n  border-left: 0;\n  border-right: 1px solid #e2e3e3;\n}\n.vakata-context-rtl .vakata-context-left ul {\n  right: auto;\n  left: 100%;\n  margin-left: -4px;\n  margin-right: auto;\n}\n.vakata-context-rtl li > a > i {\n  margin: 0 -2em 0 0;\n}\n.vakata-context-rtl li > a .vakata-contextmenu-sep {\n  margin: 0 0 0 0.5em;\n  border-left-color: white;\n  background: #e2e3e3;\n}\n#jstree-marker {\n  position: absolute;\n  top: 0;\n  left: 0;\n  margin: -5px 0 0 0;\n  padding: 0;\n  border-right: 0;\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-left: 5px solid;\n  width: 0;\n  height: 0;\n  font-size: 0;\n  line-height: 0;\n}\n#jstree-dnd {\n  line-height: 16px;\n  margin: 0;\n  padding: 4px;\n}\n#jstree-dnd .jstree-icon,\n#jstree-dnd .jstree-copy {\n  display: inline-block;\n  text-decoration: none;\n  margin: 0 2px 0 0;\n  padding: 0;\n  width: 16px;\n  height: 16px;\n}\n#jstree-dnd .jstree-ok {\n  background: green;\n}\n#jstree-dnd .jstree-er {\n  background: red;\n}\n#jstree-dnd .jstree-copy {\n  margin: 0 2px 0 2px;\n}\n.jstree-default .jstree-node,\n.jstree-default .jstree-icon {\n  background-repeat: no-repeat;\n  background-color: transparent;\n}\n.jstree-default .jstree-anchor,\n.jstree-default .jstree-animated,\n.jstree-default .jstree-wholerow {\n  transition: background-color 0.15s, box-shadow 0.15s !important; \n}\n.jstree-default .jstree-hovered {\n  background: $lighter !important;\n  border-radius: 2px !important;\n  .dark-mode &{\n    background: lighten($darker, 10%) !important;\n  }\n}\n.jstree-default .jstree-context {\n  background: $lighter !important;\n  border-radius: 2px !important;\n  .dark-mode &{\n    background: lighten($darker, 12%);\n  }\n}\n.jstree-default .jstree-clicked {\n  background: $light !important;\n  border-radius: 2px !important;\n  .dark-mode &{\n    background: lighten($darker, 10%) !important;\n  }\n}\n.jstree-default .jstree-no-icons .jstree-anchor > .jstree-themeicon {\n  display: none !important;\n}\n.jstree-default .jstree-disabled {\n  background: transparent !important;\n  color: #666666 !important;\n  .dark-mode &{\n    color: $text-off !important;\n  }\n}\n.jstree-default .jstree-disabled.jstree-hovered {\n  background: transparent !important;\n  box-shadow: none !important;\n}\n.jstree-default .jstree-disabled.jstree-clicked {\n  background: #efefef;\n}\n.jstree-default .jstree-disabled > .jstree-icon {\n  opacity: 0.8;\n  filter: url(\"data:image/svg+xml;utf8,<svg xmlns=\\'http://www.w3.org/2000/svg\\'><filter id=\\'jstree-grayscale\\'><feColorMatrix type=\\'matrix\\' values=\\'0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0\\'/></filter></svg>#jstree-grayscale\") !important;\n  /* Firefox 10+ */\n  filter: gray;\n  /* IE6-9 */\n  -webkit-filter: grayscale(100%);\n  /* Chrome 19+ & Safari 6+ */\n}\n.jstree-default .jstree-search {\n  font-style: italic;\n  color: #8b0000;\n  font-weight: bold;\n}\n.jstree-default .jstree-no-checkboxes .jstree-checkbox {\n  display: none;\n}\n.jstree-default.jstree-checkbox-no-clicked .jstree-clicked {\n  background: transparent;\n  box-shadow: none ;\n}\n.jstree-default.jstree-checkbox-no-clicked .jstree-clicked.jstree-hovered {\n  background: #e7f4f9;\n}\n.jstree-default.jstree-checkbox-no-clicked > .jstree-wholerow-ul .jstree-wholerow-clicked {\n  background: transparent;\n}\n.jstree-default.jstree-checkbox-no-clicked > .jstree-wholerow-ul .jstree-wholerow-clicked.jstree-wholerow-hovered {\n  background: #e7f4f9;\n}\n.jstree-default > .jstree-striped {\n  min-width: 100%;\n  display: inline-block;\n  background: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAkCAMAAAB/qqA+AAAABlBMVEUAAAAAAAClZ7nPAAAAAnRSTlMNAMM9s3UAAAAXSURBVHjajcEBAQAAAIKg/H/aCQZ70AUBjAATb6YPDgAAAABJRU5ErkJggg==\") left top repeat;\n}\n.jstree-default > .jstree-wholerow-ul .jstree-hovered,\n.jstree-default > .jstree-wholerow-ul .jstree-clicked {\n  background: transparent;\n  box-shadow: none;\n  border-radius: 0;\n}\n.jstree-default .jstree-wholerow {\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.jstree-default .jstree-wholerow-hovered {\n  background: $lighter !important;\n  .dark-mode &{\n    background: lighten($darker, 8%) !important;\n  }\n}\n.jstree-default .jstree-wholerow-clicked {\n  background: $lighter !important;\n  .dark-mode &{\n    background: lighten($darker, 8%) !important;\n  }\n}\n.jstree-default .jstree-node {\n  min-height: 24px;\n  line-height: 24px;\n  margin-left: 24px;\n  min-width: 24px;\n}\n.jstree-default .jstree-anchor {\n  line-height: 24px;\n  height: 24px;\n}\n.jstree-default .jstree-icon {\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n}\n.jstree-default .jstree-icon:empty {\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n}\n.jstree-default.jstree-rtl .jstree-node {\n  margin-right: 24px;\n}\n.jstree-default .jstree-wholerow {\n  height: 24px;\n}\n.jstree-default .jstree-node,\n.jstree-default .jstree-icon {\n  background-image: url($image_32) !important;\n}\n.jstree-default .jstree-node {\n  background-position: -292px -4px !important;\n  background-repeat: repeat-y !important;\n}\n.jstree-default .jstree-last {\n  background: transparent !important;\n}\n.jstree-default .jstree-open > .jstree-ocl {\n  background-position: -132px -4px !important;\n}\n.jstree-default .jstree-closed > .jstree-ocl {\n  background-position: -100px -4px !important;\n}\n.jstree-default .jstree-leaf > .jstree-ocl {\n  background-position: -68px -4px !important;\n}\n.jstree-default .jstree-themeicon {\n  background-position: -260px -4px !important;\n}\n.jstree-default > .jstree-no-dots .jstree-node,\n.jstree-default > .jstree-no-dots .jstree-leaf > .jstree-ocl {\n  background: transparent !important;\n}\n.jstree-default > .jstree-no-dots .jstree-open > .jstree-ocl {\n  background-position: -36px -4px !important;\n}\n.jstree-default > .jstree-no-dots .jstree-closed > .jstree-ocl {\n  background-position: -4px -4px !important;\n}\n.jstree-default .jstree-disabled {\n  background: transparent !important;\n}\n.jstree-default .jstree-disabled.jstree-hovered {\n  background: transparent !important;\n}\n.jstree-default .jstree-disabled.jstree-clicked {\n  background: #efefef !important;\n}\n.jstree-default .jstree-checkbox {\n  background-position: -164px -4px !important;\n}\n.jstree-default .jstree-checkbox:hover {\n  background-position: -164px -36px !important;\n}\n.jstree-default.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox,\n.jstree-default .jstree-checked > .jstree-checkbox {\n  background-position: -228px -4px !important;\n}\n.jstree-default.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox:hover,\n.jstree-default .jstree-checked > .jstree-checkbox:hover {\n  background-position: -228px -36px !important;\n}\n.jstree-default .jstree-anchor > .jstree-undetermined {\n  background-position: -196px -4px !important;\n}\n.jstree-default .jstree-anchor > .jstree-undetermined:hover {\n  background-position: -196px -36px !important;\n}\n\n.dark-mode{ \n  .jstree-default .jstree-node,\n  .jstree-default .jstree-icon {\n    background-image: url($image_32_dark) !important;\n  }\n  .jstree-default .jstree-node {\n    background-position: -292px -4px !important;\n    background-repeat: repeat-y !important;\n  }\n  .jstree-default .jstree-last {\n    background: transparent !important;\n  }\n  .jstree-default .jstree-open > .jstree-ocl {\n    background-position: -132px -4px !important;\n  }\n  .jstree-default .jstree-closed > .jstree-ocl {\n    background-position: -100px -4px !important;\n  }\n  .jstree-default .jstree-leaf > .jstree-ocl {\n    background-position: -68px -4px !important;\n  }\n  .jstree-default .jstree-themeicon {\n    background-position: -260px -4px !important;\n  }\n  .jstree-default > .jstree-no-dots .jstree-node,\n  .jstree-default > .jstree-no-dots .jstree-leaf > .jstree-ocl {\n    background: transparent !important;\n  }\n  .jstree-default > .jstree-no-dots .jstree-open > .jstree-ocl {\n    background-position: -36px -4px !important;\n  }\n  .jstree-default > .jstree-no-dots .jstree-closed > .jstree-ocl {\n    background-position: -4px -4px !important;\n  }\n  .jstree-default .jstree-disabled {\n    background: transparent !important;\n  }\n  .jstree-default .jstree-disabled.jstree-hovered {\n    background: transparent !important;\n  }\n  .jstree-default .jstree-disabled.jstree-clicked {\n    background: lighten($darker,5%) !important;\n  }\n  .jstree-default .jstree-checkbox {\n    background-position: -164px -4px !important;\n  }\n  .jstree-default .jstree-checkbox:hover {\n    background-position: -164px -36px !important;\n  }\n  .jstree-default.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox,\n  .jstree-default .jstree-checked > .jstree-checkbox {\n    background-position: -228px -4px !important;\n  }\n  .jstree-default.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox:hover,\n  .jstree-default .jstree-checked > .jstree-checkbox:hover {\n    background-position: -228px -36px !important;\n  }\n  .jstree-default .jstree-anchor > .jstree-undetermined {\n    background-position: -196px -4px !important;\n  }\n  .jstree-default .jstree-anchor > .jstree-undetermined:hover {\n    background-position: -196px -36px !important;\n  }\n}\n\n\n.jstree-default .jstree-checkbox-disabled {\n  opacity: 0.8;\n  filter: url(\"data:image/svg+xml;utf8,<svg xmlns=\\'http://www.w3.org/2000/svg\\'><filter id=\\'jstree-grayscale\\'><feColorMatrix type=\\'matrix\\' values=\\'0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0\\'/></filter></svg>#jstree-grayscale\");\n  /* Firefox 10+ */\n  filter: gray;\n  /* IE6-9 */\n  -webkit-filter: grayscale(100%);\n  /* Chrome 19+ & Safari 6+ */\n}\n.jstree-default > .jstree-striped {\n  background-size: auto 48px;\n}\n.jstree-default.jstree-rtl .jstree-node {\n  background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAACAQMAAAB49I5GAAAABlBMVEUAAAAdHRvEkCwcAAAAAXRSTlMAQObYZgAAAAxJREFUCNdjAAMOBgAAGAAJMwQHdQAAAABJRU5ErkJggg==\");\n  background-position: 100% 1px;\n  background-repeat: repeat-y;\n}\n.jstree-default.jstree-rtl .jstree-last {\n  background: transparent;\n}\n.jstree-default.jstree-rtl .jstree-open > .jstree-ocl {\n  background-position: -132px -36px;\n}\n.jstree-default.jstree-rtl .jstree-closed > .jstree-ocl {\n  background-position: -100px -36px;\n}\n.jstree-default.jstree-rtl .jstree-leaf > .jstree-ocl {\n  background-position: -68px -36px;\n}\n.jstree-default.jstree-rtl > .jstree-no-dots .jstree-node,\n.jstree-default.jstree-rtl > .jstree-no-dots .jstree-leaf > .jstree-ocl {\n  background: transparent !important;\n}\n.jstree-default.jstree-rtl > .jstree-no-dots .jstree-open > .jstree-ocl {\n  background-position: -36px -36px;\n}\n.jstree-default.jstree-rtl > .jstree-no-dots .jstree-closed > .jstree-ocl {\n  background-position: -4px -36px;\n}\n.jstree-default .jstree-themeicon-custom {\n  background-color: transparent !important;\n  background-position: 0 0 !important;\n  margin-right: 0 !important;\n  background-image: none !important;\n  .dark-mode &{\n    background-image: none !important;\n  }\n  &.icon{\n    font-size: 1rem !important;\n  }\n}\n.jstree-default > .jstree-container-ul .jstree-loading > .jstree-ocl {\n  background: url($image_throbber) center center no-repeat !important;\n  .dark-mode &{ \n    background: url($image_throbber_dark) center center no-repeat !important;\n  }\n}\n.jstree-default .jstree-file {\n  background: url($image_32) -100px -68px no-repeat !important;\n  .dark-mode &{ \n    background: url($image_32_dark) -100px -68px no-repeat !important;\n  }\n}\n.jstree-default .jstree-folder {\n  background: url($image_32) -260px -4px no-repeat !important;\n  .dark-mode &{ \n    background: url($image_32_dark) -260px -4px no-repeat !important;\n  }\n}\n.jstree-default > .jstree-container-ul > .jstree-node {\n  margin-left: 0;\n  margin-right: 0;\n}\n#jstree-dnd.jstree-default {\n  line-height: 24px;\n  padding: 0 4px;\n}\n#jstree-dnd.jstree-default .jstree-ok,\n#jstree-dnd.jstree-default .jstree-er {\n  background-image: url($image_32) !important;\n  background-repeat: no-repeat;\n  background-color: transparent;\n  .dark-mode &{ \n    background-image: url($image_32_dark) !important;\n    background-repeat: no-repeat;\n    background-color: transparent;\n  }\n}\n#jstree-dnd.jstree-default i {\n  background: transparent;\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n}\n#jstree-dnd.jstree-default .jstree-ok {\n  background-position: -4px -68px;\n}\n#jstree-dnd.jstree-default .jstree-er {\n  background-position: -36px -68px;\n}\n.dark-mode{ \n  #jstree-dnd.jstree-default .jstree-ok {\n    background-position: -4px -68px;\n  }\n  #jstree-dnd.jstree-default .jstree-er {\n    background-position: -36px -68px;\n  }\n}\n.jstree-default .jstree-ellipsis {\n  overflow: hidden;\n}\n.jstree-default .jstree-ellipsis .jstree-anchor {\n  width: calc(100% - 29px);\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.jstree-default.jstree-rtl .jstree-node {\n  background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAACAQMAAAB49I5GAAAABlBMVEUAAAAdHRvEkCwcAAAAAXRSTlMAQObYZgAAAAxJREFUCNdjAAMOBgAAGAAJMwQHdQAAAABJRU5ErkJggg==\");\n}\n.jstree-default.jstree-rtl .jstree-last {\n  background: transparent;\n}\n.jstree-default-small .jstree-node {\n  min-height: 18px;\n  line-height: 18px;\n  margin-left: 18px;\n  min-width: 18px;\n}\n.jstree-default-small .jstree-anchor {\n  line-height: 18px;\n  height: 18px;\n}\n.jstree-default-small .jstree-icon {\n  width: 18px;\n  height: 18px;\n  line-height: 18px;\n}\n.jstree-default-small .jstree-icon:empty {\n  width: 18px;\n  height: 18px;\n  line-height: 18px;\n}\n.jstree-default-small.jstree-rtl .jstree-node {\n  margin-right: 18px;\n}\n.jstree-default-small .jstree-wholerow {\n  height: 18px;\n}\n.jstree-default-small .jstree-node,\n.jstree-default-small .jstree-icon {\n  background-image: url($image_32) !important;\n}\n.jstree-default-small .jstree-node {\n  background-position: -295px -7px;\n  background-repeat: repeat-y;\n}\n.jstree-default-small .jstree-last {\n  background: transparent;\n}\n.jstree-default-small .jstree-open > .jstree-ocl {\n  background-position: -135px -7px;\n}\n.jstree-default-small .jstree-closed > .jstree-ocl {\n  background-position: -103px -7px;\n}\n.jstree-default-small .jstree-leaf > .jstree-ocl {\n  background-position: -71px -7px;\n}\n.jstree-default-small .jstree-themeicon {\n  background-position: -263px -7px !important;\n}\n.jstree-default-small > .jstree-no-dots .jstree-node,\n.jstree-default-small > .jstree-no-dots .jstree-leaf > .jstree-ocl {\n  background: transparent;\n}\n.jstree-default-small > .jstree-no-dots .jstree-open > .jstree-ocl {\n  background-position: -39px -7px;\n}\n.jstree-default-small > .jstree-no-dots .jstree-closed > .jstree-ocl {\n  background-position: -7px -7px;\n}\n.jstree-default-small .jstree-disabled {\n  background: transparent;\n}\n.jstree-default-small .jstree-disabled.jstree-hovered {\n  background: transparent;\n}\n.jstree-default-small .jstree-disabled.jstree-clicked {\n  background: #efefef;\n}\n.jstree-default-small .jstree-checkbox {\n  background-position: -167px -7px;\n}\n.jstree-default-small .jstree-checkbox:hover {\n  background-position: -167px -39px;\n}\n.jstree-default-small.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox,\n.jstree-default-small .jstree-checked > .jstree-checkbox {\n  background-position: -231px -7px !important;\n}\n.jstree-default-small.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox:hover,\n.jstree-default-small .jstree-checked > .jstree-checkbox:hover {\n  background-position: -231px -39px !important;\n}\n.jstree-default-small .jstree-anchor > .jstree-undetermined {\n  background-position: -199px -7px;\n}\n.jstree-default-small .jstree-anchor > .jstree-undetermined:hover {\n  background-position: -199px -39px;\n}\n.dark-mode{ \n  .jstree-default-small .jstree-node,\n  .jstree-default-small .jstree-icon {\n    background-image: url($image_32_dark) !important;\n  }\n  .jstree-default-small .jstree-node {\n    background-position: -295px -7px;\n    background-repeat: repeat-y;\n  }\n  .jstree-default-small .jstree-last {\n    background: transparent;\n  }\n  .jstree-default-small .jstree-open > .jstree-ocl {\n    background-position: -135px -7px;\n  }\n  .jstree-default-small .jstree-closed > .jstree-ocl {\n    background-position: -103px -7px;\n  }\n  .jstree-default-small .jstree-leaf > .jstree-ocl {\n    background-position: -71px -7px;\n  }\n  .jstree-default-small .jstree-themeicon {\n    background-position: -263px -7px !important;\n  }\n  .jstree-default-small > .jstree-no-dots .jstree-node,\n  .jstree-default-small > .jstree-no-dots .jstree-leaf > .jstree-ocl {\n    background: transparent;\n  }\n  .jstree-default-small > .jstree-no-dots .jstree-open > .jstree-ocl {\n    background-position: -39px -7px;\n  }\n  .jstree-default-small > .jstree-no-dots .jstree-closed > .jstree-ocl {\n    background-position: -7px -7px;\n  }\n  .jstree-default-small .jstree-disabled {\n    background: transparent;\n  }\n  .jstree-default-small .jstree-disabled.jstree-hovered {\n    background: transparent;\n  }\n  .jstree-default-small .jstree-disabled.jstree-clicked {\n    background: #efefef;\n  }\n  .jstree-default-small .jstree-checkbox {\n    background-position: -167px -7px;\n  }\n  .jstree-default-small .jstree-checkbox:hover {\n    background-position: -167px -39px;\n  }\n  .jstree-default-small.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox,\n  .jstree-default-small .jstree-checked > .jstree-checkbox {\n    background-position: -231px -7px;\n  }\n  .jstree-default-small.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox:hover,\n  .jstree-default-small .jstree-checked > .jstree-checkbox:hover {\n    background-position: -231px -39px;\n  }\n  .jstree-default-small .jstree-anchor > .jstree-undetermined {\n    background-position: -199px -7px;\n  }\n  .jstree-default-small .jstree-anchor > .jstree-undetermined:hover {\n    background-position: -199px -39px;\n  }\n}\n.jstree-default-small .jstree-checkbox-disabled {\n  opacity: 0.8;\n  filter: url(\"data:image/svg+xml;utf8,<svg xmlns=\\'http://www.w3.org/2000/svg\\'><filter id=\\'jstree-grayscale\\'><feColorMatrix type=\\'matrix\\' values=\\'0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0\\'/></filter></svg>#jstree-grayscale\");\n  /* Firefox 10+ */\n  filter: gray;\n  /* IE6-9 */\n  -webkit-filter: grayscale(100%);\n  /* Chrome 19+ & Safari 6+ */\n}\n.jstree-default-small > .jstree-striped {\n  background-size: auto 36px;\n}\n.jstree-default-small.jstree-rtl .jstree-node {\n  background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAACAQMAAAB49I5GAAAABlBMVEUAAAAdHRvEkCwcAAAAAXRSTlMAQObYZgAAAAxJREFUCNdjAAMOBgAAGAAJMwQHdQAAAABJRU5ErkJggg==\");\n  background-position: 100% 1px;\n  background-repeat: repeat-y;\n}\n.jstree-default-small.jstree-rtl .jstree-last {\n  background: transparent;\n}\n.jstree-default-small.jstree-rtl .jstree-open > .jstree-ocl {\n  background-position: -135px -39px;\n}\n.jstree-default-small.jstree-rtl .jstree-closed > .jstree-ocl {\n  background-position: -103px -39px;\n}\n.jstree-default-small.jstree-rtl .jstree-leaf > .jstree-ocl {\n  background-position: -71px -39px;\n}\n.jstree-default-small.jstree-rtl > .jstree-no-dots .jstree-node,\n.jstree-default-small.jstree-rtl > .jstree-no-dots .jstree-leaf > .jstree-ocl {\n  background: transparent;\n}\n.jstree-default-small.jstree-rtl > .jstree-no-dots .jstree-open > .jstree-ocl {\n  background-position: -39px -39px;\n}\n.jstree-default-small.jstree-rtl > .jstree-no-dots .jstree-closed > .jstree-ocl {\n  background-position: -7px -39px;\n}\n.jstree-default-small .jstree-themeicon-custom {\n  background-color: transparent !important;\n  background-image: none !important;\n  background-position: 0 0 !important;\n}\n.jstree-default-small > .jstree-container-ul .jstree-loading > .jstree-ocl {\n  background: url($image_throbber) center center no-repeat;\n  .dark-mode &{ \n    background: url($image_throbber_dark) center center no-repeat;\n  }\n}\n.jstree-default-small .jstree-file {\n  background: url($image_32) -103px -71px no-repeat;\n  .dark-mode &{ \n    background: url($image_32_dark) -103px -71px no-repeat !important;\n  }\n}\n.jstree-default-small .jstree-folder {\n  background: url($image_32) -263px -7px no-repeat;\n  .dark-mode &{ \n    background: url($image_32_dark) -263px -7px no-repeat !important;\n  }\n}\n.jstree-default-small > .jstree-container-ul > .jstree-node {\n  margin-left: 0;\n  margin-right: 0;\n}\n#jstree-dnd.jstree-default-small {\n  line-height: 18px;\n  padding: 0 4px;\n}\n#jstree-dnd.jstree-default-small .jstree-ok,\n#jstree-dnd.jstree-default-small .jstree-er {\n  background-image: url($image_32);\n  background-repeat: no-repeat;\n  background-color: transparent;\n  .dark-mode &{ \n    background-image: url($image_32_dark) !important;\n    background-repeat: no-repeat;\n    background-color: transparent;\n  }\n}\n#jstree-dnd.jstree-default-small i {\n  background: transparent;\n  width: 18px;\n  height: 18px;\n  line-height: 18px;\n}\n#jstree-dnd.jstree-default-small .jstree-ok {\n  background-position: -7px -71px;\n}\n#jstree-dnd.jstree-default-small .jstree-er {\n  background-position: -39px -71px;\n}\n.dark-mode{ \n  #jstree-dnd.jstree-default-small .jstree-ok {\n    background-position: -7px -71px;\n  }\n  #jstree-dnd.jstree-default-small .jstree-er {\n    background-position: -39px -71px;\n  }\n}\n.jstree-default-small .jstree-ellipsis {\n  overflow: hidden;\n}\n.jstree-default-small .jstree-ellipsis .jstree-anchor {\n  width: calc(100% - 23px);\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.jstree-default-small.jstree-rtl .jstree-node {\n  background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAACAQMAAABv1h6PAAAABlBMVEUAAAAdHRvEkCwcAAAAAXRSTlMAQObYZgAAAAxJREFUCNdjAAMHBgAAiABBI4gz9AAAAABJRU5ErkJggg==\");\n}\n.jstree-default-small.jstree-rtl .jstree-last {\n  background: transparent;\n}\n.jstree-default-large .jstree-node {\n  min-height: 32px;\n  line-height: 32px;\n  margin-left: 32px;\n  min-width: 32px;\n}\n.jstree-default-large .jstree-anchor {\n  line-height: 32px;\n  height: 32px;\n}\n.jstree-default-large .jstree-icon {\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n}\n.jstree-default-large .jstree-icon:empty {\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n}\n.jstree-default-large.jstree-rtl .jstree-node {\n  margin-right: 32px;\n}\n.jstree-default-large .jstree-wholerow {\n  height: 32px;\n}\n.jstree-default-large .jstree-node,\n.jstree-default-large .jstree-icon {\n  background-image: url($image_32) !important;\n}\n.jstree-default-large .jstree-node {\n  background-position: -288px 0px;\n  background-repeat: repeat-y;\n}\n.jstree-default-large .jstree-last {\n  background: transparent;\n}\n.jstree-default-large .jstree-open > .jstree-ocl {\n  background-position: -128px 0px;\n}\n.jstree-default-large .jstree-closed > .jstree-ocl {\n  background-position: -96px 0px;\n}\n.jstree-default-large .jstree-leaf > .jstree-ocl {\n  background-position: -64px 0px;\n}\n.jstree-default-large .jstree-themeicon {\n  background-position: -256px 0px !important;\n}\n.jstree-default-large > .jstree-no-dots .jstree-node,\n.jstree-default-large > .jstree-no-dots .jstree-leaf > .jstree-ocl {\n  background: transparent;\n}\n.jstree-default-large > .jstree-no-dots .jstree-open > .jstree-ocl {\n  background-position: -32px 0px;\n}\n.jstree-default-large > .jstree-no-dots .jstree-closed > .jstree-ocl {\n  background-position: 0px 0px;\n}\n.jstree-default-large .jstree-disabled {\n  background: transparent;\n}\n.jstree-default-large .jstree-disabled.jstree-hovered {\n  background: transparent;\n}\n.jstree-default-large .jstree-disabled.jstree-clicked {\n  background: #efefef;\n}\n.jstree-default-large .jstree-checkbox {\n  background-position: -160px 0px;\n}\n.jstree-default-large .jstree-checkbox:hover {\n  background-position: -160px -32px;\n}\n.jstree-default-large.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox,\n.jstree-default-large .jstree-checked > .jstree-checkbox {\n  background-position: -224px 0px;\n}\n.jstree-default-large.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox:hover,\n.jstree-default-large .jstree-checked > .jstree-checkbox:hover {\n  background-position: -224px -32px;\n}\n.jstree-default-large .jstree-anchor > .jstree-undetermined {\n  background-position: -192px 0px;\n}\n.jstree-default-large .jstree-anchor > .jstree-undetermined:hover {\n  background-position: -192px -32px;\n}\n.dark-mode{ \n  .jstree-default-large .jstree-node,\n  .jstree-default-large .jstree-icon {\n    background-image: url($image_32_dark) !important;\n  }\n  .jstree-default-large .jstree-node {\n    background-position: -288px 0px;\n    background-repeat: repeat-y;\n  }\n  .jstree-default-large .jstree-last {\n    background: transparent;\n  }\n  .jstree-default-large .jstree-open > .jstree-ocl {\n    background-position: -128px 0px;\n  }\n  .jstree-default-large .jstree-closed > .jstree-ocl {\n    background-position: -96px 0px;\n  }\n  .jstree-default-large .jstree-leaf > .jstree-ocl {\n    background-position: -64px 0px;\n  }\n  .jstree-default-large .jstree-themeicon {\n    background-position: -256px 0px !important;\n  }\n  .jstree-default-large > .jstree-no-dots .jstree-node,\n  .jstree-default-large > .jstree-no-dots .jstree-leaf > .jstree-ocl {\n    background: transparent;\n  }\n  .jstree-default-large > .jstree-no-dots .jstree-open > .jstree-ocl {\n    background-position: -32px 0px;\n  }\n  .jstree-default-large > .jstree-no-dots .jstree-closed > .jstree-ocl {\n    background-position: 0px 0px;\n  }\n  .jstree-default-large .jstree-disabled {\n    background: transparent;\n  }\n  .jstree-default-large .jstree-disabled.jstree-hovered {\n    background: transparent;\n  }\n  .jstree-default-large .jstree-disabled.jstree-clicked {\n    background: #efefef;\n  }\n  .jstree-default-large .jstree-checkbox {\n    background-position: -160px 0px;\n  }\n  .jstree-default-large .jstree-checkbox:hover {\n    background-position: -160px -32px;\n  }\n  .jstree-default-large.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox,\n  .jstree-default-large .jstree-checked > .jstree-checkbox {\n    background-position: -224px 0px;\n  }\n  .jstree-default-large.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox:hover,\n  .jstree-default-large .jstree-checked > .jstree-checkbox:hover {\n    background-position: -224px -32px;\n  }\n  .jstree-default-large .jstree-anchor > .jstree-undetermined {\n    background-position: -192px 0px;\n  }\n  .jstree-default-large .jstree-anchor > .jstree-undetermined:hover {\n    background-position: -192px -32px;\n  }\n}\n.jstree-default-large .jstree-checkbox-disabled {\n  opacity: 0.8;\n  filter: url(\"data:image/svg+xml;utf8,<svg xmlns=\\'http://www.w3.org/2000/svg\\'><filter id=\\'jstree-grayscale\\'><feColorMatrix type=\\'matrix\\' values=\\'0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0\\'/></filter></svg>#jstree-grayscale\");\n  /* Firefox 10+ */\n  filter: gray;\n  /* IE6-9 */\n  -webkit-filter: grayscale(100%);\n  /* Chrome 19+ & Safari 6+ */\n}\n.jstree-default-large > .jstree-striped {\n  background-size: auto 64px;\n}\n.jstree-default-large.jstree-rtl .jstree-node {\n  background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAACAQMAAAB49I5GAAAABlBMVEUAAAAdHRvEkCwcAAAAAXRSTlMAQObYZgAAAAxJREFUCNdjAAMOBgAAGAAJMwQHdQAAAABJRU5ErkJggg==\");\n  background-position: 100% 1px;\n  background-repeat: repeat-y;\n}\n.jstree-default-large.jstree-rtl .jstree-last {\n  background: transparent;\n}\n.jstree-default-large.jstree-rtl .jstree-open > .jstree-ocl {\n  background-position: -128px -32px;\n}\n.jstree-default-large.jstree-rtl .jstree-closed > .jstree-ocl {\n  background-position: -96px -32px;\n}\n.jstree-default-large.jstree-rtl .jstree-leaf > .jstree-ocl {\n  background-position: -64px -32px;\n}\n.jstree-default-large.jstree-rtl > .jstree-no-dots .jstree-node,\n.jstree-default-large.jstree-rtl > .jstree-no-dots .jstree-leaf > .jstree-ocl {\n  background: transparent;\n}\n.jstree-default-large.jstree-rtl > .jstree-no-dots .jstree-open > .jstree-ocl {\n  background-position: -32px -32px;\n}\n.jstree-default-large.jstree-rtl > .jstree-no-dots .jstree-closed > .jstree-ocl {\n  background-position: 0px -32px;\n}\n.jstree-default-large .jstree-themeicon-custom {\n  background-color: transparent !important;\n  background-image: none !important;\n  background-position: 0 0 !important;\n}\n.jstree-default-large > .jstree-container-ul .jstree-loading > .jstree-ocl {\n  background: url($image_throbber) center center no-repeat;\n  .dark-mode &{ \n    background: url($image_throbber_dark) center center no-repeat;\n  }\n}\n.jstree-default-large .jstree-file {\n  background: url($image_32) -96px -64px no-repeat;\n  .dark-mode &{ \n    background: url($image_32_dark) -96px -64px no-repeat;\n  }\n}\n.jstree-default-large .jstree-folder {\n  background: url($image_32) -256px 0px no-repeat;\n  .dark-mode &{ \n    background: url($image_32_dark) -256px 0px no-repeat;\n  }\n}\n.jstree-default-large > .jstree-container-ul > .jstree-node {\n  margin-left: 0;\n  margin-right: 0;\n}\n#jstree-dnd.jstree-default-large {\n  line-height: 32px;\n  padding: 0 4px;\n}\n#jstree-dnd.jstree-default-large .jstree-ok,\n#jstree-dnd.jstree-default-large .jstree-er {\n  background-image: url($image_32);\n  background-repeat: no-repeat;\n  background-color: transparent;\n  .dark-mode &{ \n    background-image: url($image_32_dark);\n    background-repeat: no-repeat;\n    background-color: transparent;\n  }\n}\n#jstree-dnd.jstree-default-large i {\n  background: transparent;\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n}\n#jstree-dnd.jstree-default-large .jstree-ok {\n  background-position: 0px -64px;\n}\n#jstree-dnd.jstree-default-large .jstree-er {\n  background-position: -32px -64px;\n}\n.dark-mode { \n  #jstree-dnd.jstree-default-large .jstree-ok {\n    background-position: 0px -64px;\n  }\n  #jstree-dnd.jstree-default-large .jstree-er {\n    background-position: -32px -64px;\n  }\n}\n.jstree-default-large .jstree-ellipsis {\n  overflow: hidden;\n}\n.jstree-default-large .jstree-ellipsis .jstree-anchor {\n  width: calc(100% - 37px);\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.jstree-default-large.jstree-rtl .jstree-node {\n  background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAACAQMAAAAD0EyKAAAABlBMVEUAAAAdHRvEkCwcAAAAAXRSTlMAQObYZgAAAAxJREFUCNdjgIIGBgABCgCBvVLXcAAAAABJRU5ErkJggg==\");\n}\n.jstree-default-large.jstree-rtl .jstree-last {\n  background: transparent;\n}\n@media (max-width: 768px) {\n  #jstree-dnd.jstree-dnd-responsive {\n    line-height: 40px;\n    font-weight: bold;\n    font-size: 1.1em;\n    text-shadow: 1px 1px white;\n  }\n  #jstree-dnd.jstree-dnd-responsive > i {\n    background: transparent;\n    width: 40px;\n    height: 40px;\n  }\n  #jstree-dnd.jstree-dnd-responsive > .jstree-ok {\n    background-image: url($image_40);\n    background-position: 0 -200px;\n    background-size: 120px 240px;\n    .dark-mode &{ \n      background-image: url($image_40_dark);\n      background-position: 0 -200px;\n      background-size: 120px 240px;\n    }\n  }\n  #jstree-dnd.jstree-dnd-responsive > .jstree-er {\n    background-image: url($image_40);\n    background-position: -40px -200px;\n    background-size: 120px 240px;\n    .dark-mode &{ \n      background-image: url($image_40_dark);\n      background-position: -40px -200px;\n      background-size: 120px 240px;\n    }\n  }\n  #jstree-marker.jstree-dnd-responsive {\n    border-left-width: 10px;\n    border-top-width: 10px;\n    border-bottom-width: 10px;\n    margin-top: -10px;\n  }\n}\n@media (max-width: 768px) {\n  .jstree-default-responsive {\n    /*\n\t.jstree-open > .jstree-ocl,\n\t.jstree-closed > .jstree-ocl { border-radius:20px; background-color:white; }\n\t*/\n  }\n  .jstree-default-responsive .jstree-icon {\n    background-image: url($image_40) !important;\n    .dark-mode &{ \n      background-image: url($image_40_dark) !important;\n    }\n  }\n  .jstree-default-responsive .jstree-node,\n  .jstree-default-responsive .jstree-leaf > .jstree-ocl {\n    background: transparent;\n  }\n  .jstree-default-responsive .jstree-node {\n    min-height: 40px;\n    line-height: 40px;\n    margin-left: 40px;\n    min-width: 40px;\n    white-space: nowrap;\n  }\n  .jstree-default-responsive .jstree-anchor {\n    line-height: 40px;\n    height: 40px;\n  }\n  .jstree-default-responsive .jstree-icon,\n  .jstree-default-responsive .jstree-icon:empty {\n    width: 40px;\n    height: 40px;\n    line-height: 40px;\n  }\n  .jstree-default-responsive > .jstree-container-ul > .jstree-node {\n    margin-left: 0;\n  }\n  .jstree-default-responsive.jstree-rtl .jstree-node {\n    margin-left: 0;\n    margin-right: 40px;\n    background: transparent;\n  }\n  .jstree-default-responsive.jstree-rtl .jstree-container-ul > .jstree-node {\n    margin-right: 0;\n  }\n  .jstree-default-responsive .jstree-ocl,\n  .jstree-default-responsive .jstree-themeicon,\n  .jstree-default-responsive .jstree-checkbox {\n    background-size: 120px 240px !important;\n  }\n  .jstree-default-responsive .jstree-leaf > .jstree-ocl,\n  .jstree-default-responsive.jstree-rtl .jstree-leaf > .jstree-ocl {\n    background: transparent;\n  }\n  .jstree-default-responsive .jstree-open > .jstree-ocl {\n    background-position: 0 0 !important;\n  }\n  .jstree-default-responsive .jstree-closed > .jstree-ocl {\n    background-position: 0 -40px !important;\n  }\n  .jstree-default-responsive.jstree-rtl .jstree-closed > .jstree-ocl {\n    background-position: -40px 0 !important;\n  }\n  .jstree-default-responsive .jstree-themeicon {\n    background-position: -40px -40px;\n  }\n  .jstree-default-responsive .jstree-checkbox,\n  .jstree-default-responsive .jstree-checkbox:hover {\n    background-position: -40px -80px;\n  }\n  .jstree-default-responsive.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox,\n  .jstree-default-responsive.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox:hover,\n  .jstree-default-responsive .jstree-checked > .jstree-checkbox,\n  .jstree-default-responsive .jstree-checked > .jstree-checkbox:hover {\n    background-position: 0 -80px;\n  }\n  .jstree-default-responsive .jstree-anchor > .jstree-undetermined,\n  .jstree-default-responsive .jstree-anchor > .jstree-undetermined:hover {\n    background-position: 0 -120px;\n  }\n  .dark-mode{ \n    .jstree-default-responsive .jstree-ocl,\n    .jstree-default-responsive .jstree-themeicon,\n    .jstree-default-responsive .jstree-checkbox {\n      background-size: 120px 240px;\n    }\n    .jstree-default-responsive .jstree-leaf > .jstree-ocl,\n    .jstree-default-responsive.jstree-rtl .jstree-leaf > .jstree-ocl {\n      background: transparent;\n    }\n    .jstree-default-responsive .jstree-open > .jstree-ocl {\n      background-position: 0 0 !important;\n    }\n    .jstree-default-responsive .jstree-closed > .jstree-ocl {\n      background-position: 0 -40px !important;\n    }\n    .jstree-default-responsive.jstree-rtl .jstree-closed > .jstree-ocl {\n      background-position: -40px 0 !important;\n    }\n    .jstree-default-responsive .jstree-themeicon {\n      background-position: -40px -40px;\n    }\n    .jstree-default-responsive .jstree-checkbox,\n    .jstree-default-responsive .jstree-checkbox:hover {\n      background-position: -40px -80px;\n    }\n    .jstree-default-responsive.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox,\n    .jstree-default-responsive.jstree-checkbox-selection .jstree-clicked > .jstree-checkbox:hover,\n    .jstree-default-responsive .jstree-checked > .jstree-checkbox,\n    .jstree-default-responsive .jstree-checked > .jstree-checkbox:hover {\n      background-position: 0 -80px;\n    }\n    .jstree-default-responsive .jstree-anchor > .jstree-undetermined,\n    .jstree-default-responsive .jstree-anchor > .jstree-undetermined:hover {\n      background-position: 0 -120px;\n    }\n  }\n  .jstree-default-responsive .jstree-anchor {\n    font-weight: bold;\n    font-size: 1.1em;\n    text-shadow: 1px 1px white;\n  }\n  .jstree-default-responsive > .jstree-striped {\n    background: transparent !important;\n  }\n  .jstree-default-responsive .jstree-wholerow {\n    border-top: 1px solid rgba(255, 255, 255, 0.7) !important;\n    border-bottom: 1px solid rgba(64, 64, 64, 0.2) !important;\n    background: #ebebeb !important;\n    height: 40px !important;\n  }\n  .jstree-default-responsive .jstree-wholerow-hovered {\n    background: transparent !important;\n  }\n  .jstree-default-responsive .jstree-wholerow-clicked,.jstree-default-responsive .jstree-wholerow-clicked:hover  {\n    background: #beebff !important;\n  }\n  .jstree-default-responsive .jstree-children .jstree-last > .jstree-wholerow {\n    box-shadow: inset 0 -6px 3px -5px #666666 !important;\n  }\n  .jstree-default-responsive .jstree-children .jstree-open > .jstree-wholerow {\n    box-shadow: inset 0 6px 3px -5px #666666 !important;\n    border-top: 0;\n  }\n  .jstree-default-responsive .jstree-children .jstree-open + .jstree-open {\n    box-shadow: none;\n  }\n  .jstree-default-responsive .jstree-node,\n  .jstree-default-responsive .jstree-icon,\n  .jstree-default-responsive .jstree-node > .jstree-ocl,\n  .jstree-default-responsive .jstree-themeicon,\n  .jstree-default-responsive .jstree-checkbox {\n    background-image: url($image_40) !important;\n    background-size: 120px 240px !important;\n  }\n  .jstree-default-responsive .jstree-node {\n    background-position: -80px 0;\n    background-repeat: repeat-y;\n  }\n  .jstree-default-responsive .jstree-last {\n    background: transparent;\n  }\n  .jstree-default-responsive .jstree-leaf > .jstree-ocl {\n    background-position: -40px -120px;\n  }\n  .jstree-default-responsive .jstree-last > .jstree-ocl {\n    background-position: -40px -160px;\n  }\n  .jstree-default-responsive .jstree-themeicon-custom {\n    background-color: transparent;\n    background-image: none;\n    background-position: 0 0;\n  }\n  .jstree-default-responsive .jstree-file {\n    background: url($image_40) 0 -160px no-repeat !important;\n    background-size: 120px 240px !important;\n  }\n  .jstree-default-responsive .jstree-folder {\n    background: url($image_40) -40px -40px no-repeat !important;\n    background-size: 120px 240px !important;\n  }\n  .dark-mode{ \n    .jstree-default-responsive .jstree-node,\n    .jstree-default-responsive .jstree-icon,\n    .jstree-default-responsive .jstree-node > .jstree-ocl,\n    .jstree-default-responsive .jstree-themeicon,\n    .jstree-default-responsive .jstree-checkbox {\n      background-image: url($image_40_dark);\n      background-size: 120px 240px;\n    }\n    .jstree-default-responsive .jstree-node {\n      background-position: -80px 0;\n      background-repeat: repeat-y;\n    }\n    .jstree-default-responsive .jstree-last {\n      background: transparent;\n    }\n    .jstree-default-responsive .jstree-leaf > .jstree-ocl {\n      background-position: -40px -120px;\n    }\n    .jstree-default-responsive .jstree-last > .jstree-ocl {\n      background-position: -40px -160px;\n    }\n    .jstree-default-responsive .jstree-themeicon-custom {\n      background-color: transparent;\n      background-image: none;\n      background-position: 0 0;\n    }\n    .jstree-default-responsive .jstree-file {\n      background: url($image_40_dark) 0 -160px no-repeat;\n      background-size: 120px 240px;\n    }\n    .jstree-default-responsive .jstree-folder {\n      background: url($image_40_dark) -40px -40px no-repeat;\n      background-size: 120px 240px;\n    }\n  }\n  .jstree-default-responsive > .jstree-container-ul > .jstree-node {\n    margin-left: 0;\n    margin-right: 0;\n  }\n}","@use \"sass:math\";\n.nk-kanban {\n  overflow: auto;\n  padding-bottom: 1rem;\n}\n.kanban-container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  overflow: auto;\n}\n\n.kanban-container * {\n  box-sizing: border-box;\n}\n\n.kanban-board {\n  display: flex;\n  flex-direction: column;\n  padding: math.div($grid-gutter-width, 2);\n  position: relative;\n  transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);\n  flex-shrink: 0;\n  width: 100%;\n}\n.kanban-board.disabled-board {\n  opacity: 0.3;\n}\n\n.kanban-board.is-moving.gu-mirror {\n  transform: rotate(3deg);\n}\n\n.kanban-board.is-moving.gu-mirror .kanban-drag {\n  overflow: hidden;\n  @if ($rtl==false) {\n    padding-right: 50px;\n  }\n  @if ($rtl==true) {\n    padding-left: 50px;\n  }\n}\n\n.kanban-board-header {\n  background: $white;\n  border: 1px solid $border-light;\n  border-top: 3px solid $gray-300;\n  border-radius: $border-radius;\n  padding: 0.5rem 1.25rem;\n  margin-bottom: 1rem;\n}\n.kanban-primary {\n  border-top-color: $accent-color;\n}\n.kanban-success {\n  border-top-color: $success;\n}\n.kanban-info {\n  border-top-color: $info;\n}\n.kanban-warning {\n  border-top-color: $warning;\n}\n.kanban-danger {\n  border-top-color: $danger;\n}\n.kanban-dark {\n  border-top-color: $dark;\n}\n.kanban-title-content {\n  display: flex;\n  align-items: center;\n  .title {\n    font-size: 0.9375rem;\n    margin-bottom: 0;\n    @if ($rtl==false) {\n      margin-right: 0.75rem;\n    }\n    @if ($rtl==true) {\n      margin-left: 0.75rem;\n    }\n    color: $base-text;\n  }\n}\n.kanban-title-board {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.kanban-board header .kanban-title-button {\n  @if ($rtl==false) {\n    float: right;\n  }\n  @if ($rtl==true) {\n    float: left;\n  }\n}\n.kanban-drag {\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n.kanban-board .kanban-drag {\n  min-height: 100px;\n  margin-bottom: 1rem;\n  &:empty {\n    border-radius: $border-radius;\n    border: 1px dashed $border-light;\n  }\n}\n\n.kanban-board:after {\n  clear: both;\n  display: block;\n  content: \"\";\n}\n\n.kanban-item {\n  border-radius: $border-radius;\n  border: 1px solid $border-light;\n  padding: 1rem 1.25rem;\n  margin-bottom: 0.75rem;\n  background: $white;\n\n  width: 350px;\n  transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);\n  &-title {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    + .kanban-item-text {\n      margin-top: 0.5rem;\n    }\n    .title {\n      font-size: 0.9375rem;\n      margin-bottom: 0;\n      @if ($rtl==false) {\n        margin-right: 0.75rem;\n      }\n      @if ($rtl==true) {\n        margin-left: 0.75rem;\n      }\n    }\n  }\n  &-tags {\n    display: flex;\n    padding-top: 0.5rem;\n    margin: -0.125rem;\n    li {\n      padding: 0.125rem;\n    }\n  }\n  &-meta {\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    padding-top: 0.5rem;\n    &-list {\n      display: flex;\n      align-items: center;\n      flex-wrap: wrap;\n      margin: 0 -0.25rem;\n      &:last-child {\n        flex-wrap: nowrap;\n      }\n      &:first-child {\n        padding-right: 1rem;\n      }\n      li {\n        font-size: 0.8125rem;\n        padding: 0 0.25rem;\n        color: $base-light;\n        span {\n          white-space: nowrap;\n        }\n        .icon + span {\n          @if ($rtl==false) {\n            margin-left: 0.25rem;\n          }\n          @if ($rtl==true) {\n            margin-right: 0.25rem;\n          }\n        }\n      }\n    }\n  }\n}\n\n// .kanban-item:hover {\n//   cursor: move;\n// }\n\n.kanban-item:last-child {\n  margin: 0;\n}\n\n.kanban-item.is-moving.gu-mirror {\n  transform: rotate(3deg);\n  height: auto !important;\n}\n\n/* Dragula CSS  */\n.gu-mirror {\n  position: fixed !important;\n  margin: 0 !important;\n  z-index: 9999 !important;\n}\n\n.gu-hide {\n  display: none !important;\n}\n\n.gu-unselectable {\n  -webkit-user-select: none !important;\n  -moz-user-select: none !important;\n  -ms-user-select: none !important;\n  user-select: none !important;\n}\n\n.gu-transit {\n  opacity: 0.2 !important;\n  transform: rotate(0deg) !important;\n}\n\n.drag_handler {\n  background: $white;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  position: relative;\n  top: -3px;\n  @if ($rtl==false) {\n    float: left;\n    margin-right: 4px;\n  }\n  @if ($rtl==true) {\n    float: right;\n    margin-left: 4px;\n  }\n}\n\n.drag_handler:hover {\n  cursor: move;\n}\n\n.drag_handler_icon {\n  position: relative;\n  display: block;\n  background: #000;\n  width: 24px;\n  height: 2px;\n  top: 12px;\n  transition: 0.5s ease-in-out;\n}\n\n.drag_handler_icon:before,\n.drag_handler_icon:after {\n  background: #000;\n  content: \"\";\n  display: block;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  transition: 0.5s ease-in-out;\n}\n\n.drag_handler_icon:before {\n  top: 6px;\n}\n\n.drag_handler_icon:after {\n  bottom: 6px;\n}\n\n.kanban-add-task {\n  color: $accent-color;\n  background: $white;\n  border: 1px dashed $border-light;\n  padding-top: 0.675rem;\n  padding-bottom: 0.675rem;\n  &:hover {\n    color: $white;\n    background: $accent-color;\n    border: 1px solid $accent-color;\n  }\n  &:focus {\n    outline: none;\n    box-shadow: none;\n  }\n}\n","///////////////////////////////////////////////////////\n///            CORE STYLE OF DASHLITE               ///\n///////////////////////////////////////////////////////\n\n/** 03. LAYOUTS */\n@import \"../core/layouts\";\n\n/** 04. UTILITES */\n@import \"../core/utilites\";\n\n/** 05. COMPONENTS */\n@import \"../core/components\";\n\n/** 06. PAGES */\n@import \"../core/pages\";\n\n/** 07. MISC */\n@import \"../core/misc\";\n","body{\n    min-width: $min-body-width;\n    &.nav-shown{\n        overflow: hidden;\n    }\n}\n.nk{\n    &-body{\n        outline: none;\n    }\n    &-app{\n        &-root{\n            outline: none;\n        }\n    }\n    &-main{\n        position: relative;\n    } \n    &-wrap{\n        display: flex;\n        flex-direction: column;\n        min-height: 100vh;\n    }\n    &-content{\n        padding: $content-gap-y 4px;\n        &-fs{\n            min-height: calc(100vh - (#{$header-height} + #{$header-height}));\n            display: flex;\n            align-items: center;\n        }\n    }\n}\n\n@include media-breakpoint-up(sm){\n    .nk{\n        &-content{\n            padding: ($content-gap-y + 8) $content-gap-x-sm;\n            &-fluid{\n                padding-left: 22px;\n                padding-right: 22px;\n            }\n        }\n    }\n}\n@include media-breakpoint-up(lg){\n    .nk{\n        &-content{\n            &-lg {\n                padding-top: ($content-gap-y * 1.5);\n                padding-bottom: ($content-gap-y * 1.5);\n            }\n            &-fluid{\n                padding-left: 24px;\n                padding-right: 24px;\n            }\n        }\n    }\n}\n@media (min-width: 1660px){\n    .nk-content{\n        &-lg {\n            padding-top: ($content-gap-y * 2.25);\n            padding-bottom: ($content-gap-y * 2.25);\n        }\n        &-fluid{\n            padding-left: 44px;\n            padding-right: 44px;\n        }\n    }\n}\n\n// Content\n.nk-content-body{\n    flex-grow: 1;\n}\n.nk-wrap-nosidebar{\n    .nk-content{\n        padding: 0 !important;\n        min-height: 100vh;\n        display: flex;\n        flex-direction: column;\n    }\n}","/// Logo\n/////////////////////////\n.logo{\n    &-link{\n        position: relative;\n        display: inline-block;\n        align-items: center;\n    }\n    &-dark{\n        opacity: 1;\n        .tc-light &,.is-dark &,.is-theme &{\n            opacity: 0;\n        }\n    }\n    &-light{\n        opacity: 0;\n        .tc-light &,.is-dark &,.is-theme &{\n            opacity: 1;\n        }\n    }\n    &-img{\n        max-height: $logo-height;\n        &-lg{\n            max-height: $logo-height-lg;\n        }\n        &-sm{\n            max-height: $logo-height-sm;\n        }\n        &-icon{\n            max-height: $logo-height-icon;\n        }\n        &:not(:first-child){\n            position: absolute;\n            left: 0;\n            top: 50%;\n            transform: translateY(-50%);\n        }\n    }\n}\n\n/// Headers\n////////////////////////////\n@mixin icon-active {\n    opacity: 1;\n    height: 116%;\n    width: 116%;\n}\n.nk{\n    &-header{\n        background: $header-bg-color;\n        border-bottom: 1px solid $header-border-bottom;\n        padding: 0 $header-main-gap-x;\n        box-shadow: 0px 1px 3px 0px rgba($base-color, 0.05);\n        z-index: 1010;\n        @if($dark_option==true) {\n            &.is-dark:not([class*=bg-]){\n                background: $header-bg-dark-color;\n                border-color: $header-border-dark-bottom;\n            }\n        }\n        &.is-light:not([class*=bg-]){\n            background: $white;\n        }\n        @if($dark_theme_option==true) {\n            &.is-theme:not([class*=bg-]){\n                background: $header-bg-theme-color;\n                border-color: $header-border-theme-bottom;\n            }\n        }\n        &-fixed{\n            position: fixed;\n            top: 0;\n            left: 0;\n            right: 0;\n            min-width: $header-min-width;\n            + .nk-content {\n                // margin-top: $header-height;\n                position: relative;\n            }\n        }\n        &-wrap{\n            position: relative;\n            display: flex;\n            align-items: center;\n            margin: 0 -.25rem;\n            > *{\n                padding:0 .25rem;\n            }\n        }\n        &-right{\n            align-items: center;\n            justify-content: flex-end;\n        }\n        &-center{\n            justify-content: center;\n        }\n        &-tools{\n            margin-left: auto;\n            padding-top: $header-main-gap-y;\n            padding-bottom: $header-main-gap-y;\n        }\n        &-brand{\n            flex-shrink: 0;\n            padding-top: $header-main-gap-y;\n            padding-bottom: $header-main-gap-y;\n        }\n        .dropdown-menu{\n            .lead-text{\n                color: $base-color;\n            }\n            .sub-text,.overline-title,.overline-title-alt{\n                color: $base-light;\n            }\n        }\n        &-search{\n            display: none;\n            .form-control{\n                background-color: transparent;\n                border: none;\n            }\n            .icon{\n                @if($dark_option==true) {\n                    .is-dark &{\n                        color: $white;\n                    }\n                }\n                @if($dark_theme_option==true) {\n                    .is-theme &{\n                        color: $white;\n                    }\n                }\n            }\n        }\n    }\n    &-quick{\n        &-nav{\n            display: flex;\n            align-items: center;\n            margin: 0 -6px;\n            > li{\n                padding: 0 6px;\n                &.user-dropdown > a {\n                    padding: 0 2px;\n                }\n            }\n            &-icon{\n                display: inline-flex;\n                position: relative;\n                font-size: 1.5rem;\n                z-index: 1;\n                color: $base-text;\n                padding: .375rem;\n                @if($dark_option==true) {\n                    .is-dark &{\n                        color: lighten($base-light, 10%);\n                    }\n                }\n                @if($dark_theme_option==true) {\n                    .is-theme &{\n                        color: $accent-light;\n                    }\n                    &.nk-nav-toggle{\n                        .is-theme &{\n                            color: $white;\n                        }\n                    }\n                }\n                &:focus{\n                    box-shadow: none;\n                }\n                &:before{\n                    position: absolute;\n                    z-index: -1;\n                    height: 20px;\n                    width: 20px;\n                    top: 50%;\n                    left: 50%;\n                    transform: translate(-50%, -50%);\n                    transform-origin: 50% 50%;\n                    content: '';\n                    background-color: $light-200;\n                    border-radius: 50%;\n                    opacity: 0;\n                    transition: all .3s;\n                    @if($dark_option==true) {\n                        .is-dark &{\n                            background-color: darken($darker,3%);\n                        }\n                    }\n                    @if($dark_theme_option==true) {\n                        .is-theme &{\n                            background-color: darken($accent-dark,10%);\n                        }\n                    }\n                    .show > &{\n                        @include icon-active();\n                    }\n                }\n                &:hover:before,&.active:before{\n                    @include icon-active();\n                }\n            }\n        }\n    }\n}\n@media (max-width:359px){\n    .nk{\n        &-quick{\n            &-nav{\n                margin: 0 -3px;\n                > li{\n                    padding: 0 3px;\n                }\n            }\n        }\n    }\n    .hide-mb-xs{\n        display: none;\n    }\n}\n@media (max-width:575px){\n    .hide-mb-sm{\n        display: none;\n    }\n}\n\n@include media-breakpoint-up(sm){\n    .nk{\n        &-header{\n            padding: 0 $header-main-gap-x-sm;\n            &-search{\n                display: flex;\n                align-items: center;\n                flex-grow: 1;\n            }\n        }\n        &-quick{\n            &-nav{\n                margin: 0 -10px;\n                > li{\n                    padding: 0 10px;\n                }\n            }\n        }\n    }\n}\n@include media-breakpoint-up(lg){\n    .nk{\n        &-header{\n            &-fluid{\n                padding-left: 24px;\n                padding-right: 24px;\n            }\n        }\n    }\n}\n@media (min-width:1660px){\n    .nk{\n        &-header{\n            &-fluid{\n                padding-left: 44px;\n                padding-right: 44px;\n            }\n        }\n    }\n}\n\n.nk-header{\n    &-menu{\n        position: fixed;\n        left: 0;\n        transform: translateX(-100%);\n        top: 0;\n        width: 280px;\n        height: 100vh;\n        max-height: 100vh;\n        z-index: 999;\n        background: $white;\n        &-inner{\n            overflow: auto;\n            max-height: 100%;\n            min-height: 100%;\n        }\n        &.mobile-menu{\n            padding-top: 65px;\n            padding-left: 0;\n            padding-right: 0;\n            transition: transform .4s ease;\n        }\n        &.nk-sidebar-active{\n            transform: translateX(0);\n        }\n    }\n    &-mobile{\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 0 28px;\n        border-bottom: 1px solid $border-light;\n        .logo-dark {\n            opacity: 1;\n        }\n        .logo-light {\n            opacity: 0;\n        }\n        .nk-nav-toggle.nk-quick-nav-icon{\n            color: $base-text;\n            &:before{\n                background-color: $light-200;\n            }\n        }\n    }\n}\n@include media-breakpoint-up(lg){\n    .nk-header{\n        &-menu{\n            .nk-header-mobile{\n                display: none;\n            }\n            position: static;\n            background: transparent;\n            height: auto;\n            max-height: auto;\n            border-right: none;\n            width: auto;\n            padding: 0;\n            overflow: visible;\n            transform: translateX(0) !important;\n        }\n    }\n}\n\n// Header App Switcher\n.nk-header{\n    &-app{\n        &-name{\n            display: flex;\n            align-items: center;\n            flex-shrink: 0;\n        }\n        &-logo{\n            flex-shrink: 0;\n            width: 32px;\n            height: 32px;\n            margin-right: 0.75rem;\n            .icon{\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                width: 32px;\n                height: 32px;\n                border-radius: 50%;\n                font-size: 20px;\n                color: $accent-color;\n                background: rgba($accent-color, .3);\n            }\n        }\n        &-info{\n            line-height: 1.3;\n            .sub-text{\n                font-size: $fx-sz-11;\n                margin-bottom: 0.125rem;\n            }\n            .lead-text{\n                font-size: $fx-sz-14;\n            }\n        }\n        &-switch{\n            position: relative;\n            .nk-header-app-name{\n                padding: 1.5rem $sidebar-gap-x;\n            }\n            > a{\n                display: block;\n                width: 100%;\n                &:after{\n                    position: absolute;\n                    right: 24px;\n                    top: 50%;\n                    transform: translateY(-50%);\n                    font-size: 1rem;\n                    content: $ni-chevron-down;\n                    font-family: $nk-dashlite-font;\n                }\n            }\n            .mobile-menu &{\n                width: 100%;\n                border-bottom: 1px solid $border-light;\n            }\n            .toggle-content{\n                width: 100%;\n                top: 0;\n                transform: translateY(0);\n                height: calc(100vh - 65px);\n                overflow: auto;\n                box-shadow: none;\n                border-radius: 0;\n                background: $white;\n            }\n        }\n        &-head{\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            padding: .75rem $sidebar-gap-x;\n            .title  {\n                font-size: 16px;\n                font-weight: $fw-medium;\n            }\n            .toggle{\n                position: relative;\n                height: 24px;\n                width: 24px;\n                display: inline-flex;\n                align-items: center;\n                justify-content: center;\n            }\n        }\n        &-list{\n            li{\n                border-bottom: 1px solid $border-light;\n            }\n            .nk-header-app-name{\n                padding: 1rem $sidebar-gap-x;\n            }\n        }\n    }\n}\n@media (max-height:615px){\n    .nk-header{\n        &-app{\n            &-switch{\n                .dropdown-menu{\n                    max-height: 416px;\n                    overflow: auto;\n                }\n            }\n        }\n    }\n}\n\n@include media-breakpoint-up(md){\n    .nk-header{\n        &-onlymobile{\n            display: none;\n            + .nk-content{\n                margin-top: 0;\n            }\n        }\n    }\n}","/// Main Sidebar\n/////////////////////////////\n.nk{\n    &-sidebar{\n        position: absolute;\n        background: $sidebar-bg-color;\n        height: 100%;\n        min-height: 100vh;\n        top: 0;\n        left: 0;\n        transform: translateX(-100%);\n        border-right: 1px solid $sidebar-border-color;\n        z-index: 1021;\n        width: $sidebar-width-normal;\n        transition: transform $sidebar-transition-duration $sidebar-transition-name,width $sidebar-transition-duration $sidebar-transition-name;\n        box-shadow: 0px 1px 3px 0px rgba($base-color, 0.05);\n        + .nk-wrap{\n            transition: padding $sidebar-transition-duration $sidebar-transition-name;\n            > .nk-header-fixed{\n                transition: left $sidebar-transition-duration $sidebar-transition-name;\n            }\n        }\n        &.is-light{\n            background: $sidebar-bg-light-color;\n            border-right-color: $sidebar-border-light-color;\n        }\n\n        @if($dark_option==true) {\n            &.is-dark{\n                background: $sidebar-bg-dark-color;\n                border-right-color: $sidebar-border-dark-color;\n            }\n        }\n        @if($dark_theme_option==true) {\n            &.is-theme{\n                background: $sidebar-bg-theme-color;\n                border-right-color: $sidebar-border-theme-color;\n            }\n        }\n        &-overlay{\n            position: fixed;\n            top: 0;\n            right: 0;\n            bottom: 0;\n            left: 0;\n            background: $sidebar-overlay;\n            z-index: 900;\n            animation: overlay-fade-in .4s ease 1;\n        }\n        &-element{\n            overflow: hidden;\n            width: 100%;\n            max-height: 100%;\n        }\n        &.nk-sidebar-active{\n            transform: translateX(0);\n        }\n        &-fixed{\n            position: fixed;\n            max-height: 100vh;\n        }\n        &-head{\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            padding: $header-main-gap-y 24px;\n            min-width: 100%;\n            width: $sidebar-width-normal;\n            height: $header-height;\n        }\n        &-brand{\n            position: relative;\n            flex-shrink: 0;\n        }\n        &-logo{\n            transition: opacity .3s ease;\n            .logo-img:not(:first-child){\n                position: absolute;\n                left: 0;\n                top: 50%;\n                transform: translateY(-50%);\n            }\n        }\n        &-footer{\n            background-color: $sidebar-bg-color;\n            margin-top: auto;\n            padding: 1.75rem $sidebar-gap-x 1.75rem;\n            .is-light &{\n                background: $sidebar-bg-light-color;\n            }\n            @if($dark_option==true) {\n                .is-dark &{\n                    background-color: $sidebar-bg-dark-color;\n                }\n            }\n            @if($dark_theme_option==true) {\n                .is-theme &{\n                    background-color: $sidebar-bg-theme-color;\n                }\n            }\n        }\n        &-body{\n            position: relative;\n            .simplebar-content{\n                padding-bottom: .25rem !important;\n                min-height: 100%;\n                display: flex;\n                flex-direction: column;\n                \n            }\n            .simplebar-scroll-content{\n                min-height: 100%;\n                width: 100%;\n            }\n        }\n        &-content{\n            display: flex;\n            flex-direction: column;\n            height: calc(100vh - #{$header-height});\n            .nk-sidebar-menu{\n                padding-top: 1.5rem;\n                padding-bottom: 3rem;\n                &[data-simplebar]{\n                    height: 100%;\n                }\n            }\n            &[data-simplebar]{\n                > div {width: 100%}\n            }\n        }\n        @if($dark_option==true or $dark_theme_option==true) {\n            &.is-theme, &.is-dark {\n                .user-balance-alt{\n                    color: $accent-light;\n                }\n            }\n        }\n        &-profile{\n            margin-top: auto;\n            width: 100%;\n            .user-avatar{\n                height: 36px !important;\n                width: 36px !important;\n            }\n            .dropdown-toggle{\n                width: 100%;\n                padding: 14px $sidebar-gap-x;\n                &:after{\n                    margin-left: auto;\n                    font-size: 1.125rem;\n                    color: $base-light;\n                }\n            }\n            .dropdown-menu{\n                width: calc(#{$sidebar-width-normal} - #{$sidebar-gap-x * 2});\n            }\n        }\n    }\n}\n@keyframes overlay-fade-in{\n    0%{\n        opacity: 0;\n    }100%{\n        opacity: 1;\n    }\n}\n\n@include media-breakpoint-down(md){\n    .nk{\n        &-sidebar{\n            &-mobile{\n                width: $sidebar-width-normal !important;\n            }\n        }\n    }\n}\n@include media-breakpoint-up(xl){\n    .nk-sidebar-content .nk-sidebar-menu{\n        padding-top: 1rem;\n        padding-bottom: 2.5rem;\n    }\n    .nk-sidebar{\n        overflow: hidden;\n        transform: translateX(0);\n        width: $sidebar-width-normal;\n        + .nk-wrap, &-overlay + .nk-wrap{\n            padding-left: $sidebar-width-normal;\n            > .nk-header-fixed{\n                left: $sidebar-width-normal;\n            }\n        }\n        &.is-compact{\n            &:not(:hover){\n                width: $sidebar-width-compact;\n                .logo-img{\n                    opacity: 0;\n                    transition: opacity .2s linear;\n                    &-small{\n                        opacity: 1;\n                        left: -3px;\n                    }\n                }\n                .user-card{\n                    position: relative;\n                    left: -5px;\n                }\n                .user-info{\n                    opacity: 0;\n                }\n                .nk-sidebar-profile{ \n                    .dropdown-menu{ \n                        opacity: 0; \n                    } \n                }\n            }\n            + .nk-wrap{\n                padding-left: $sidebar-width-compact;\n                > .nk-header-fixed{\n                    left: $sidebar-width-compact;\n                }\n            }\n        }\n        &-overlay{\n            display: none;\n        }\n    }\n}\n\n@include media-breakpoint-up(xl){\n    .nk{\n        &-sidebar{\n            transform: translateX(0);\n        }\n    }\n}\n","@use \"sass:math\";\n$menu_dark_option: $dark_option;\n$menu_dark_theme_option: $dark_theme_option;\n\n// Menu Font\n$menu-link-ff: $alt-font-family !default;\n$menu-link-fs: 13px !default;\n$menu-link-fw: $fw-bold !default;\n$menu-link-lh: 1.25rem !default;\n$menu-link-ls: 0.01em !default;\n$menu-link-case: none !default;\n$menu-link-radius: 6px !default;\n\n$menu-link-gap-y: 0.625rem !default;\n$menu-link-gap-x: $sidebar-gap-x !default;\n\n// Menu Sub/Child Font\n$menu-sub-diff: true;\n$menu-sub-link-ff: $base-font-family !default;\n$menu-sub-link-fs: $fx-sz-14 !default;\n$menu-sub-link-fw: $fw-normal !default;\n$menu-sub-link-lh: $menu-link-lh !default;\n$menu-sub-link-ls: normal !default;\n$menu-sub-link-case: none !default;\n\n$menu-sub-link-gap-y: 0.375rem !default;\n$menu-sub-link-gap-x: $menu-link-gap-x !default;\n\n// Link color\n$menu-link-color-base: lighten($base-text, 12%) !default;\n$menu-link-color-sub: lighten($base-text, 12%) !default;\n$menu-link-color-hover: lighten($accent-color, 5%) !default;\n$menu-border-color: $border-color !default;\n$menu-border-dark-color: rgba($white, 0.12) !default;\n\n$menu-link-background-hover: $light-100 !default;\n\n// Menu Icon\n$menu-icon-width-base: $menu-icon-width !default;\n$menu-icon-font-size: 24px;\n$menu-icon-color-base: $base-light !default;\n$menu-icon-color-hover: $accent-color !default;\n$menu-icon-width-small: $menu-icon-width-sm !default;\n$menu-icon-font-size-small: 18px;\n\n// Count\n$menu-link-count-gap: 0.25rem !default;\n$menu-link-count-fs: 0.85em !default;\n$menu-link-count-color: $base-light !default;\n\n// Menu Main Style\n$menu-main-link-color-base: $base-text !default;\n$menu-main-link-color-light: $base-light !default;\n$menu-main-link-color-sub: $base-text !default;\n\n$menu-main-link-gap-y: 0.5rem !default;\n$menu-main-link-gap-x: 1.25rem !default;\n$menu-main-link-gap-x: 1.25rem !default;\n\n$menu-main-top-link-gap-y: 1.5rem !default;\n$menu-main-top-link-gap-x: 1rem !default;\n\n$menu-main-link-fs: $fx-sz-13 !default; // @desktop only\n$menu-main-top-link-fs: $fx-sz-14 !default; // @desktop only\n\n$menu-main-ddm-width: 200px !default;\n\n// Menu Footer Style\n$menu-footer-link-gap-y: 0.25rem !default;\n$menu-footer-link-color: $base-light !default;\n$menu-footer-icon-width: 1.375rem;\n$menu-footer-link-fs: $fx-sz-12;\n$menu-footer-link-lh: 1.125rem;\n$menu-footer-icon-color: $accent-color;\n\n// Icon\n$menu-toggle-icon-ltr: $ni-chevron-right !default;\n$menu-toggle-icon-rtl: $ni-chevron-left !default;\n$menu-main-toggle-icon: $ni-chevron-down !default;\n$menu-main-sub-toggle-icon-ltr: $ni-chevron-right !default;\n$menu-main-sub-toggle-icon-rtl: $ni-chevron-left !default;\n\n/////////////////////////\n/// Menu Navigation\n/////////////////////////\n\n.nk-profile {\n  padding: 4px math.div($menu-link-gap-x, 2);\n  &-item {\n    padding: $menu-link-gap-y (math.div($menu-link-gap-x, 2) + 16) $menu-link-gap-y math.div($menu-link-gap-x, 2);\n  }\n}\n.nk-menu {\n  li {\n    a {\n      vertical-align: middle;\n      display: flex;\n      position: relative;\n      align-items: center;\n      transition: color 0.3s, background-color 0.3s;\n    }\n  }\n  &-item {\n    padding: 4px math.div($menu-link-gap-x, 2);\n    .nk-menu-sub & {\n      padding: 1px 0;\n    }\n    &.has-sub {\n      position: relative;\n    }\n  }\n  > .nk-menu-item.menu-without-icon > .nk-menu-sub .nk-menu-link {\n    padding-left: 0;\n  }\n  &-link {\n    padding: $menu-link-gap-y (math.div($menu-link-gap-x, 2) + 16) $menu-link-gap-y math.div($menu-link-gap-x, 2);\n    color: $menu-link-color-base;\n    font-family: $menu-link-ff;\n    font-weight: $menu-link-fw;\n    font-size: $menu-link-fs;\n    letter-spacing: $menu-link-ls;\n    text-transform: $menu-link-case;\n    line-height: $menu-link-lh;\n    border-radius: $menu-link-radius;\n    &:hover {\n      color: $menu-link-color-base;\n      background: $menu-link-background-hover;\n      .is-light & {\n        color: $menu-link-color-base;\n        background: $menu-link-background-hover;\n      }\n      @if ($menu_dark_option==true) {\n        .is-dark & {\n          background: lighten($sidebar-bg-dark-color, 5%);\n        }\n      }\n      @if ($menu_dark_theme_option==true) {\n        .is-theme & {\n          background: lighten($sidebar-bg-theme-color, 6%);\n        }\n      }\n      .count {\n        color: $menu-link-color-base;\n      }\n    }\n\n    .active > & {\n      color: $white;\n      background: $menu-footer-icon-color;\n      .is-light & {\n        color: $white !important;\n        background: $menu-footer-icon-color;\n      }\n      @if ($menu_dark_option==true) {\n        .is-dark & {\n          background: lighten($sidebar-bg-dark-color, 5%);\n        }\n      }\n      @if ($menu_dark_theme_option==true) {\n        .is-theme & {\n          background: lighten($sidebar-bg-theme-color, 6%);\n        }\n      }\n      .count {\n        color: $white;\n      }\n    }\n    @if ($menu-sub-diff==true) {\n      .nk-menu-sub & {\n        padding: $menu-sub-link-gap-y ($menu-sub-link-gap-x + 16) $menu-sub-link-gap-y ($menu-icon-width-base);\n        font-family: $menu-sub-link-ff;\n        font-weight: $menu-sub-link-fw;\n        font-size: $menu-sub-link-fs;\n        letter-spacing: $menu-sub-link-ls;\n        text-transform: $menu-sub-link-case;\n        line-height: $menu-sub-link-lh;\n        color: $menu-link-color-sub;\n      }\n    }\n    &.is-disable {\n      cursor: default;\n      &:hover,\n      .active > & {\n        color: $menu-link-color-base;\n        .count {\n          color: $menu-link-color-base;\n        }\n      }\n    }\n    .is-light & {\n      color: $base-text;\n    }\n    @if ($menu_dark_theme_option==true) {\n      .is-theme & {\n        color: darken($accent-light, 8%);\n      }\n    }\n    &:hover,\n    .active > & {\n      .is-light & {\n        color: $menu-link-color-hover;\n      }\n      @if ($menu_dark_theme_option==true) {\n        .is-theme & {\n          color: $white;\n        }\n      }\n    }\n    span.small {\n      color: $base-light;\n      margin-left: 0.5rem;\n    }\n  }\n  &-icon {\n    font-weight: normal;\n    letter-spacing: normal;\n    width: $menu-icon-width-base;\n    line-height: 1;\n    flex-grow: 0;\n    flex-shrink: 0;\n    color: $menu-icon-color-base;\n    @if ($menu_dark_theme_option==true) {\n      .is-theme & {\n        color: darken($accent-light, 8%);\n      }\n    }\n    svg,\n    img {\n      width: $menu-icon-width-base;\n    }\n    .icon {\n      font-size: $menu-icon-font-size;\n      letter-spacing: normal;\n      vertical-align: middle;\n      color: currentColor;\n      transition: color 0.4s, background-color 0.4s;\n    }\n    .nk-menu-link:hover {\n      color: $menu-icon-color-hover !important;\n      @if ($menu_dark_theme_option==true) {\n        .is-theme & {\n          color: $white;\n        }\n      }\n    }\n    .nk-menu-item.active > .nk-menu-link &,\n    .nk-menu-item.current-menu > .nk-menu-link & {\n      color: $white !important;\n      @if ($menu_dark_theme_option==true) {\n        .is-theme & {\n          color: $white;\n        }\n      }\n    }\n    .nk-menu-link.is-disable:hover & {\n      color: $menu-icon-color-base;\n      @if ($menu_dark_theme_option==true) {\n        .is-theme & {\n          color: $accent-light;\n        }\n      }\n    }\n  }\n  &-text {\n    flex-grow: 1;\n    display: inline-block;\n  }\n  &-badge {\n    border-radius: $border-radius-sm;\n    padding: 0 0.4rem;\n    font-size: $fx-sz-11;\n    color: $accent-500;\n    background: $accent-100;\n    position: absolute;\n    top: 50%;\n    right: $sidebar-gap-x;\n    .has-sub & {\n      right: $sidebar-gap-x + 24px;\n    }\n    transform: translateY(-50%);\n    @if ($menu_dark_option==true) {\n      .is-dark & {\n        color: $accent-400;\n        background: lighten($sidebar-bg-dark-color, 10%);\n      }\n    }\n    @if ($menu_dark_theme_option==true) {\n      .is-theme & {\n        color: $accent-300;\n        background: lighten($sidebar-bg-theme-color, 12%);\n      }\n    }\n    .nk-menu-main .nk-menu-sub & {\n      color: $accent-500;\n      background: $accent-100;\n    }\n  }\n  &-divider {\n    margin: 4px math.div($menu-link-gap-x, 2);\n    border-bottom: 1px solid #dbdfea !important;\n  }\n  &-heading {\n    padding: 0.25rem $sidebar-gap-x 0.5rem;\n    color: $base-light;\n    @if ($menu_dark_theme_option==true) {\n      .is-theme & {\n        color: darken($accent-light, 15%);\n      }\n    }\n    .nk-menu-item + & {\n      padding-top: 2.5rem;\n    }\n    .overline-title {\n      color: inherit;\n      white-space: nowrap;\n    }\n    span {\n      font-size: $fx-sz-13;\n      font-weight: $fw-normal;\n    }\n  }\n  &-hr {\n    margin: 1.25rem 0;\n    border-bottom: 1px solid $menu-border-color;\n    @if ($menu_dark_option==true) {\n      .is-dark & {\n        border-color: $menu-border-dark-color;\n      }\n    }\n    @if ($menu_dark_theme_option==true) {\n      .is-theme & {\n        border-color: $menu-border-dark-color;\n      }\n    }\n    + .nk-menu-heading {\n      padding-top: 1rem;\n    }\n  }\n  &-wrap {\n    .nk-menu-toggle + & {\n      height: 0;\n      overflow: hidden;\n      transition: height 0.4s ease;\n    }\n  }\n  &-sub {\n    padding-bottom: 0.25rem;\n    .nk-menu-toggle + & {\n      display: none;\n    }\n    .active > & {\n      display: block;\n    }\n    .nk-menu-link {\n      padding-left: math.div($sidebar-gap-x, 2) + $menu-icon-width-base;\n      &:hover {\n        color: $accent-color;\n        @if ($menu_dark_theme_option==true) {\n          .is-theme & {\n            color: $white;\n          }\n        }\n      }\n      &:hover,\n      .active > & {\n        background-color: transparent;\n      }\n    }\n    .nk-menu-sub {\n      margin-left: math.div($sidebar-gap-x, 2) + $menu-icon-width-base;\n      margin-top: 0.5rem;\n      margin-bottom: 0.5rem;\n      padding-bottom: 0;\n      .nk-menu-link {\n        padding-left: 0.5rem;\n      }\n    }\n    .active > .nk-menu-link {\n      color: $accent-color;\n      @if ($menu_dark_theme_option==true) {\n        .is-theme & {\n          color: $white;\n        }\n      }\n    }\n    // keep active child highlighted on hover (hover above clears the background, leaving white text on white)\n    .active > .nk-menu-link:hover {\n      background-color: $menu-footer-icon-color;\n    }\n    .nk-menu-icon {\n      width: 24px;\n      margin-top: -1px;\n      .icon {\n        margin-top: -1px;\n        font-size: 1.2em;\n      }\n    }\n  }\n\n  &-toggle {\n    position: relative;\n    &:after {\n      position: absolute;\n      font-family: $nk-dashlite-font;\n      top: 50%;\n      content: $menu-toggle-icon-ltr;\n      right: 1.25rem;\n      transform: translateY(-50%);\n      font-size: 1rem;\n      color: $base-light;\n      transition: transform 0.3s, color 0.1s, opacity 0.3s ease 0.3s;\n      @if ($menu_dark_option==true or $menu_dark_theme_option==true) {\n        .is-dark &,\n        .is-theme & {\n          color: rgba($white, 0.4);\n        }\n      }\n    }\n    .has-sub.active > & {\n      &:after {\n        transform: translateY(-50%) rotate(90deg);\n      }\n      background-color: transparent !important;\n      color: $base-text !important;\n    }\n    .icon {\n      font-size: $menu-icon-font-size;\n      letter-spacing: normal;\n      vertical-align: middle;\n      color: $base-text;\n      transition: color 0.4s, background-color 0.4s;\n    }\n  }\n  .count {\n    display: inline-block;\n    font-size: $menu-link-count-fs;\n    margin-left: $menu-link-count-gap;\n    color: $menu-link-count-color;\n    line-height: 1;\n  }\n  &-icon-colored {\n    .nk-menu-icon {\n      color: $menu-icon-color-hover;\n    }\n  }\n}\n@include media-breakpoint-up(xl) {\n  .is-compact {\n    &:not(:hover) {\n      .nk-menu {\n        &-text {\n          opacity: 0;\n          transition: 0.4s linear;\n        }\n        &-badge,\n        &-toggle:after {\n          transition: none;\n          opacity: 0;\n          pointer-events: none;\n        }\n        &-sub {\n          display: none !important;\n        }\n        &-wrap {\n          height: 0 !important;\n        }\n        &-heading {\n          position: relative;\n          .overline-title {\n            opacity: 0;\n          }\n          &:not(:first-child) {\n            &:before {\n              position: absolute;\n              content: \"\";\n              height: 1px;\n              width: 100%;\n              left: 0;\n              top: 50%;\n              background-color: $border-light;\n            }\n          }\n        }\n      }\n    }\n    @if ($menu_dark_theme_option==true) {\n      &.is-theme {\n        &:not(:hover) {\n          .nk-menu {\n            &-heading {\n              &:not(:first-child) {\n                &:before {\n                  background-color: $sidebar-border-theme-color;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    @if ($menu_dark_option==true) {\n      &.is-dark {\n        &:not(:hover) {\n          .nk-menu {\n            &-heading {\n              &:not(:first-child) {\n                &:before {\n                  background-color: $sidebar-border-dark-color;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    .nk-menu {\n      &-badge {\n        transition: opacity 0.3s ease 0.3s;\n      }\n      &-text {\n        white-space: nowrap;\n      }\n    }\n  }\n}\n////////////////////\n// Menu Footer\n////////////////////\n.nk-menu-footer {\n  display: flex;\n  .nk-menu {\n    &-link {\n      padding-left: 0;\n      padding-right: 0;\n      padding-top: 0.25rem;\n      padding-bottom: 0.25rem;\n      color: $menu-footer-link-color;\n      font-family: $base-font-family;\n      font-weight: $fw-medium;\n      &:hover {\n        color: $menu-link-color-hover;\n      }\n      @if ($menu_dark_theme_option==true) {\n        .is-theme & {\n          color: $accent-light;\n        }\n      }\n    }\n    &-icon {\n      width: $menu-footer-icon-width;\n      color: $menu-footer-icon-color;\n      .icon {\n        font-size: 1rem;\n      }\n    }\n    &-text {\n      font-size: $menu-footer-link-fs;\n      line-height: $menu-footer-link-lh;\n    }\n  }\n}\n////////////////////////////\n// Sidebar\n////////////////////////////\n.nk-sidebar {\n  .nk-menu {\n    > li {\n      .nk-menu-sub {\n        .nk-menu-link {\n          // padding-left: math.div($sidebar-gap-x,2) + $menu-icon-width-base;\n          padding-left: 1.5rem;\n        }\n        .nk-menu-sub {\n          margin-top: 0.5rem;\n          margin-bottom: 0.5rem;\n          padding-bottom: 0;\n          margin-left: math.div($sidebar-gap-x, 2) + $menu-icon-width-base;\n          border-left: 1px solid $border-color;\n          .nk-menu-link {\n            padding-left: 0.5rem;\n          }\n        }\n      }\n    }\n  }\n  @if ($menu_dark_option==true or $menu_dark_theme_option==true) {\n    &.is-dark,\n    &.is-theme {\n      .nk-menu {\n        > li {\n          .nk-menu-sub {\n            .nk-menu-sub {\n              border-color: rgba($white, 0.12);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",".nk{\n    &-footer{\n        margin-top: auto;\n        background: $footer-bg-color;\n        border-top: 1px solid $footer-border-bottom;\n        padding: $footer-main-gap-y $footer-main-gap-x;\n        box-shadow: 0px 1px 3px 0px rgba($base-color, 0.05);\n        &.is-dark:not([class*=bg-]){\n            background: $footer-bg-dark-color;\n        }\n        &-wrap{\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            flex-wrap: wrap;\n        }\n        &-copyright{\n            color: $base-light;\n            a{\n                color: inherit;\n                &:hover{\n                    color: $accent-color;\n                }\n            }\n        }\n    }\n}\n@include media-breakpoint-up(sm){\n    .nk{\n        &-footer{\n            padding: $footer-main-gap-y $footer-main-gap-x-sm;\n        }\n    }\n}\n@include media-breakpoint-up(lg){\n    .nk{\n        &-footer{\n            &-fluid{\n                padding-left: 24px;\n                padding-right: 24px;\n            }\n        }\n    }\n}\n@media (min-width:1660px){\n    .nk{\n        &-footer{\n            &-fluid{\n                padding-left: 44px;\n                padding-right: 44px;\n            }\n        }\n    }\n}",".nk{\n    &-split{\n        position: relative;\n        display: flex;\n        &-page{\n            min-height: 100vh;\n        }\n        &-content{\n            position: relative;\n            flex-shrink: 0;\n            width: 100%;\n            min-height: 100%;\n            &-md{\n                @include media-breakpoint-up(md){\n                    width: 642px;\n                }\n            }\n        }\n        &-stretch{\n            flex-grow: 1;\n            flex-shrink: 1;\n        }\n    }\n}\n\n@include media-breakpoint-down(md){\n    .nk-split-stretch{\n        &.toggle-break-lg{\n            width: 460px;\n        }\n    }\n}\n\n.nk-split {\n    &-sm{\n        @include media-breakpoint-down(mb){\n            flex-wrap: wrap;\n        }\n    }\n    &-md{\n        @include media-breakpoint-down(sm){\n            flex-wrap: wrap;\n        }\n    }\n    &-lg{\n        @include media-breakpoint-down(md){\n            flex-wrap: wrap;\n        }\n    }\n    &-xl{\n        @include media-breakpoint-down(lg){\n            flex-wrap: wrap;\n        }\n    }\n    &-xxl{\n        @include media-breakpoint-down(xl){\n            flex-wrap: wrap;\n        }\n    }\n}\n","canvas{\n    width: 100%;\n    max-width: 100%;\n}\na:hover{\n    text-decoration: none;\n}\np:last-child{\n    margin-bottom: 0;\n}\n.del {\n\ttext-decoration: line-through;\n}\nspan[data-toggle=tooltip]:focus {\n    outline: none;\n}","@use 'sass:math';\n@each $size, $length in $spacers {\n    .g-#{$size} {\n        margin: math.div(-$length,2) !important;\n        > li,> div{\n            padding: math.div($length,2) !important;\n        }\n    }\n    .gx-#{$size} {\n        margin-left: math.div(-$length,2) !important;\n        margin-right: math.div(-$length,2) !important;\n        > li,> div{\n            padding-left: math.div($length,2) !important;\n            padding-right: math.div($length,2) !important;\n        }\n    }\n    .gy-#{$size} {\n        margin-top: math.div(-$length,2) !important;\n        margin-bottom: math.div(-$length,2) !important;\n        > li,> div{\n            padding-top: math.div($length,2) !important;\n            padding-bottom: math.div($length,2) !important;\n        }\n    }\n}\n\n.gap {\n    width: 100%;\n    display: block;\n    height: $gutter-width;\n}\n@each $size, $length in $spacers {\n    .gap-#{$size} {\n        height: $length;\n    }\n}\n\n$gaps: sm 0.75rem, md 1.25rem, lg 2rem, xl 2.5rem;\n@each $gap, $size in $gaps {\n    .gap-#{$gap} {\n        height: $size;\n    }\n}\n\n$px-gaps: 10, 20, 30, 40, 50, 60, 70, 80, 90, 100;\n@each $gap in $px-gaps {\n    .gap-#{$gap}px {\n        height: #{$gap}px;\n    }\n}\n","@use 'sass:math';\n$w_100: 100%;\n$li_cols: 2,3,4;\n@each $li_col in $li_cols {\n    .li-col#{$li_col}x{\n        > li {\n            width: math.div($w_100,$li_col);\n            float: left;\n        }\n    }\n}",".alert{\n    &-cta{\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n    &-actions{\n        display: inline-flex;\n        align-items: center;\n        a+a{\n            margin-left: 1rem;\n        }\n    }\n}","$accordion-head-gap-l: 1.25rem;\n$accordion-head-gap-r: $accordion-head-gap-l + 1rem;\n$accordion-inner-gap-x: $accordion-head-gap-l;\n$accordion-head-gap-y: 1rem;\n$accordion-inner-gap-y: 1rem;\n\n$accordion-head-gap-md-x: 1.5rem;\n$accordion-inner-gap-md-x: $accordion-head-gap-md-x;\n\n$accordion-s2-head-gap-l: 0;\n$accordion-s2-head-gap-r: $accordion-s2-head-gap-l + 2.25rem;\n$accordion-s2-inner-gap-x: $accordion-s2-head-gap-l;\n$accordion-s2-head-gap-y: .5rem;\n$accordion-s2-inner-gap-y: .5rem;\n\n$accordion-s2-head-gap-md-l: 0;\n$accordion-s2-head-gap-md-r: $accordion-s2-head-gap-l + 2.25rem;\n$accordion-s2-inner-gap-md-x: $accordion-s2-head-gap-md-l;\n\n$accordion-s3-head-gap-r: 0;\n$accordion-s3-head-gap-l: $accordion-s3-head-gap-r + 2.25rem;\n$accordion-s3-inner-gap-x: $accordion-s3-head-gap-r;\n$accordion-s3-head-gap-y: .5rem;\n$accordion-s3-inner-gap-y: .5rem;\n\n$accordion-s3-head-gap-md-r: 0;\n$accordion-s3-head-gap-md-l: $accordion-s3-head-gap-md-r + 2.25rem;\n$accordion-s3-inner-gap-md-x: $accordion-s3-head-gap-md-l;\n\n//icons\n$accordion-icon: $ni-chevron-up !default;\n$accordion-icon-collapsed: $ni-chevron-down !default;\n$accordion-s2-icon: $ni-minus !default;\n$accordion-s2-icon-collapsed: $ni-plus !default;\n$accordion-s3-icon: $ni-minus !default;\n$accordion-s3-icon-collapsed: $ni-plus !default;\n\n.accordion {\n    border-radius: $border-radius;\n    background: $white;\n    &-heading {\n        padding-bottom: 1.5rem;\n    }\n    &-body {\n        border-radius: $border-radius;\n    }\n    &-item {\n        &:not(:last-child){\n            .accordion-head {\n                border-bottom: 1px solid $border-color;\n            }\n            .accordion-inner {\n                border-bottom: 1px solid $border-color;\n            }\n        }\n        &:last-child {\n            .accordion-inner {\n                border-top: 1px solid $border-color;\n            }\n        }\n    }\n    &-head {\n        padding: $accordion-head-gap-y $accordion-head-gap-r $accordion-head-gap-y $accordion-head-gap-l;\n        display: block;\n        position: relative;\n        .title {\n            margin-bottom: 0;\n            font-size: 1rem;\n            color: $base-color;\n            line-height: 1.3;\n        }\n        &.collapsed{\n            .title{\n                color: $base-text;\n            }\n        }\n    }\n    &-inner {\n        padding: $accordion-inner-gap-y $accordion-inner-gap-x ($accordion-inner-gap-y * 1.25);\n    }\n    &-icon {\n        position: absolute;\n        right: 1rem;\n        top: 50%;\n        font-size: 1rem;\n        color: $base-color;\n        transform: translateY(-50%);\n        transition: rotate 0.4s;\n        width: 20px;\n        height: 20px;\n        text-align: center;\n        line-height: 20px;\n        &:before {\n            content: $accordion-icon;\n            font-family: $nk-dashlite-font;\n            transition: 0.4s;\n            .accordion-head.collapsed &{\n                content: $accordion-icon-collapsed;\n            }\n        }\n    }\n}\n@media (min-width: 768px) {\n    .accordion {\n        &-head {\n            padding: $accordion-head-gap-y $accordion-head-gap-md-x;\n        }\n        &-inner {\n            padding: $accordion-inner-gap-y $accordion-inner-gap-md-x ($accordion-inner-gap-y * 1.25);\n        }\n        &-icon {\n            right: 1.5rem;\n        }\n    }\n}\n\n//acc S2\n.accordion-s2{\n    border: none;  \n    .accordion-icon {\n        right: 0;\n        &:before{\n            content: $accordion-s2-icon;\n        }\n    }\n    .accordion-head{\n        padding: $accordion-s2-head-gap-y $accordion-s2-head-gap-r $accordion-s2-head-gap-y $accordion-s2-head-gap-l;\n        border: none !important;\n        .title{\n            font-size: 1.1rem;\n            color: $accent-color;\n        }\n        &.collapsed{\n            .title{\n                color: $base-text;\n            }\n            .accordion-icon {\n                &:before{\n                    content: $accordion-s2-icon-collapsed;\n                }\n            }\n        }\n    }\n    .accordion-inner{\n        padding: $accordion-s2-inner-gap-y $accordion-s2-inner-gap-x ($accordion-s2-inner-gap-y * 1.25);\n        border: none !important;\n    }\n}\n\n@media (min-width: 768px) {\n    .accordion-s2{\n        .accordion {\n            &-head {\n                padding: $accordion-s2-head-gap-y $accordion-s2-head-gap-md-r $accordion-s2-head-gap-y $accordion-s2-head-gap-md-l;\n            }\n            &-inner {\n                padding: $accordion-s2-inner-gap-y $accordion-s2-inner-gap-md-x ($accordion-s2-inner-gap-y * 1.25);\n            }\n        }\n    }\n}\n\n//acc S3\n.accordion-s3{\n    border: none;  \n    .accordion-icon {\n        left: 0;\n        right: auto;\n        &:before{\n            content: $accordion-s3-icon;\n        }\n    }\n    .accordion-head{\n        padding: $accordion-s3-head-gap-y $accordion-s3-head-gap-r $accordion-s3-head-gap-y $accordion-s3-head-gap-l;\n        border: none !important;\n        .title{\n            font-size: 1.1rem;\n            color: $accent-color;\n        }\n        &.collapsed{\n            .title{\n                color: $base-text;\n            }\n            .accordion-icon {\n                &:before{\n                    content: $accordion-s3-icon-collapsed;\n                }\n            }\n        }\n    }\n    .accordion-inner{\n        padding: $accordion-s3-inner-gap-y $accordion-s3-inner-gap-x ($accordion-s3-inner-gap-y * 1.25);\n        border: none !important;\n    }\n}\n\n@media (min-width: 768px) {\n    .accordion-s3{\n        .accordion {\n            &-head {\n                padding: $accordion-s3-head-gap-y $accordion-s3-head-gap-md-r $accordion-s3-head-gap-y $accordion-s3-head-gap-md-l;\n            }\n            &-inner {\n                padding: $accordion-s3-inner-gap-y $accordion-s3-inner-gap-md-x ($accordion-s3-inner-gap-y * 1.25);\n            }\n        }\n    }\n}","// Dots\n$dot-size:\n    \"xs\"    4px,\n    \"sm\"    6px,\n    \"md\"    8px,\n    \"rg\"    10px,\n    \"lg\"    12px,\n    \"xl\"    16px;\n\n.dot{\n    position: relative;\n    display: inline-block;\n    border-radius: 50%;\n    height: 8px;\n    width: 8px;\n    &-label{\n        &:after{\n            position: absolute;\n            left: 0;\n            top: 0;\n            right: 0;\n            bottom: 0;\n            border-radius: 50%;\n            background: $white;\n            content: '';\n            transform: scale(.65);\n        }\n    }\n    &.sq{\n        border-radius: 3px;\n        &:after{\n            border-radius: 3px;\n        }\n    }\n}\n@each $name, $value in $dot-size {\n    .dot-#{$name}{\n        height: $value;\n        width: $value;\n    }\n}\n@each $name, $value in $theme-colors {\n    .dot-#{$name}{\n        background: $value;\n    }\n}","$list-default-icon: $ni-bullet-fill !default;\n$list-checked-icon: $ni-check-fill-c !default;\n$list-checked-circle-icon: $ni-check-circle-fill !default;\n$list-cross-icon: $ni-cross-fill-c !default;\n$list-step-icon: $ni-circle !default;\n$list-step-current-icon: $ni-disk !default;\n$list-step-done-icon: $ni-check-circle-cut !default;\n\n.list{\n    &:not(:last-child) {\n        margin-bottom: $para-margin;\n    }\n    li{\n        position: relative;\n        padding-left:1.5rem;\n        line-height: 1.5rem;\n        &:not(:last-child){\n            padding-bottom: .5rem;\n        }\n        &:before{\n            position: absolute;\n            left: 0;\n            font-size: $fx-sz-14;\n            line-height: 1.5rem;\n            font-family: $nk-dashlite-font;\n            content: $list-default-icon;\n        }\n        span{\n            color: $base-light;\n        }\n        ul {\n            margin-top: .5rem;\n        }\n    }\n    &-checked{\n        li:before{\n            color: $accent-color;\n            content: $list-checked-icon;\n        }\n        &-circle{\n            li:before{\n                color: $accent-color;\n                content: $list-checked-circle-icon;\n            }\n        }\n    }\n    &-cross {\n        li:before{\n            color: rgba($danger, .8);\n            content: $list-cross-icon;\n        }\n    }\n    &-status {\n        list-style: none;\n        line-height: 1.3;\n        li {\n            display: inline-flex;\n            align-items: center;\n            padding-right: 1rem;\n            vertical-align: middle;\n        }\n        .icon {\n            margin-right: .375rem;\n            line-height: 1.3;\n        }\n    }\n    &-lg {\n        li {\n            padding-left: 2rem;\n            &:not(:last-child){\n                padding-bottom: .75rem;\n            }\n            &:before{\n                font-size: 1.35rem;\n            }\n        }\n    }\n    &-sm{\n        li{\n            padding-left: 1.2rem;\n            &:not(:last-child){\n                padding-bottom: .35rem;\n            }\n            &:before{\n                font-size: $fx-sz-12;\n            }\n        }\n    }\n    &-step{\n        li{\n            color: $base-light;\n            font-weight: 500;\n            &:before{\n                content: $list-step-icon;\n            }\n            &.list-step{\n                &-current{\n                    color: $base-color;\n                    &:before{\n                        content: $list-step-current-icon;\n                        color: $accent-color;\n                    }\n                }\n                &-done{\n                    color: $base-text;\n                    &:before{\n                        content: $list-step-done-icon;\n                        color: $success;\n                    }\n                }\n            }\n        }\n    }\n    &-plain {\n        a {\n            color: $base-text;\n            display: block;\n            line-height: 1.3;\n            padding: 0.5rem 0;\n            &:hover {\n                color: $accent-color;\n            }\n        }\n    }\n    &-category {\n        a {\n            font-weight: $fw-medium;\n        }\n    }\n    &-download {\n        li > a {\n            display: inline-block;\n            padding: .25rem;\n            > .icon {\n                margin:0 .25rem;\n                font-size: 1.25rem;\n            }\n        }\n    }\n}\n\n\n@each $name, $value in $theme-colors {\n    .list-#{$name} {\n        li:before{\n            color: $value;\n        }\n    }\n}","$link-active-icon: $ni-check-thick !default;\n$link-list-menu-icon-ltr: $ni-chevron-right !default;\n$link-list-menu-icon-rtl: $ni-chevron-left !default;\n// Used for Extend.\n.link-bdr-t {\n    border-top: 1px solid $border-light;\n}\n.link-bdr-b {\n    border-bottom: 1px solid $border-light;\n}\n.link-pd-sm {\n    padding: 6px 1rem;\n}\n.link-act-check {\n    &:after {\n        content: $link-active-icon;\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        right: 1rem;\n        font-family: $nk-dashlite-font;\n    }\n}\n\n/// Link Check\n/////////////////////////////////////\n.link-check{\n    padding: .5rem 0;\n    + .link-check{\n        @extend .link-bdr-t;\n    }\n    .divider {\n        margin: .5rem 0;\n    }\n    li{\n        display: block;\n        > span, a{\n            display: block;\n            line-height: 1.25rem;\n            padding: .35rem 1rem;\n        }\n        > span{\n            text-transform: uppercase;\n            color: $base-color;\n            font-weight: 700;\n            font-size: $fx-sz-12;\n            letter-spacing: 1px;\n        }\n        a{\n            display: flex;\n            align-items: center;\n            color: $base-text;\n            font-size: $fx-sz-13;\n            position: relative;\n            &:hover{\n                color: $accent-color; \n                background: $lighter; \n            }\n        }\n        .icon{\n            width: 1.75rem;\n            font-size: 1.125rem;\n        }\n        &.active > a, a.active {\n            @extend .link-act-check;\n        }\n    }\n}\n\n\n/// Link Clean / Tidy\n/////////////////////////////////////\n.link-tidy{\n    li + li {\n        @extend .link-bdr-t;\n    }\n    &.no-bdr {\n        padding: .5rem 0;\n        li:not(.divider) {\n            border-top-width: 0;\n        }\n    }\n    .divider {\n        margin: .5rem 0;\n    }\n    li {\n        position: relative;\n        padding: .625rem 1.1rem;\n        line-height: 1.3rem;\n    }\n    &.sm {\n        li {\n            @extend .link-pd-sm;\n        }\n    }\n}\n\n\n/// Link List\n/////////////////////////////////////\n.link-list{\n    padding: .75rem 0;\n    + .link-list{\n        @extend .link-bdr-t;\n    }\n    .divider {\n        margin: .5rem 0;\n    }\n    a{\n        display: flex;\n        align-items: center;\n        color: $base-text;\n        font-size: $fx-sz-13;\n        line-height: 1.4rem;\n        font-weight: 500;\n        padding: .575rem 0;\n        position: relative;\n        &:hover{\n            color: $primary;\n        }\n        .icon{\n            font-size: 1.125rem;\n            width: 1.5rem;\n            line-height: 1;\n        }\n    }\n}\n\n/// Link List Options\n/////////////////////////////////////\n.link-list-opt{\n    li + li {\n        @extend .link-bdr-t;\n    }\n    &.no-bdr {\n        padding: .5rem 0;\n        li:not(.divider) {\n            border-top-width: 0;\n        }\n    }\n    .divider {\n        margin: .5rem 0;\n    }\n    a{\n        display: flex;\n        align-items: center;\n        padding: .625rem 1.125rem;\n        font-size: $fx-sz-12;\n        font-weight: $fw-medium;\n        color: $base-text;\n        transition: all .4s;\n        line-height: 1.3rem;\n        position: relative;\n        &:hover{\n            color: $accent-color; \n            background: $lighter; \n        }\n        .icon{\n            font-size: 1.125rem;\n            width: 1.75rem;\n            opacity: .8;\n        }\n    }\n    li.active > a, a.active {\n        @extend .link-act-check;\n    }\n    li.disabled > a, a.disabled {\n        pointer-events: none;\n        color: $base-light;\n        opacity: 0.7;\n    }\n    .opt-head {\n        padding: .25rem 1.25rem;\n        color: $base-light;\n    }\n    &.ui-v2 {\n        a {\n            font-weight: $fw-normal;\n        }\n    }\n    &.no-bdr + .link-check {\n        margin-top: -0.75rem;\n\n    }\n    &.ui-colored {\n        li.active > a, a.active {\n            color: $accent-color;\n        }\n    }\n}\n\n.link-list-opt-scrollable {\n    max-height: 250px;\n    overflow-y: auto;\n    li + li {\n        @extend .link-bdr-t;\n    }\n    &.no-bdr {\n        padding: .5rem 0;\n        li:not(.divider) {\n            border-top-width: 0;\n        }\n    }\n    .divider {\n        margin: .5rem 0;\n    }\n    a {\n        display: flex;\n        align-items: center;\n        padding: .625rem 1.125rem;\n        font-size: $fx-sz-12;\n        font-weight: $fw-medium;\n        color: $base-text;\n        transition: all .4s;\n        line-height: 1.3rem;\n        position: relative;\n        &:hover {\n            color: $accent-color;\n            background: $lighter;\n        }\n        .icon {\n            font-size: 1.125rem;\n            width: 1.75rem;\n            opacity: .8;\n        }\n    }\n    li.active > a, a.active {\n        @extend .link-act-check;\n    }\n    li.disabled > a, a.disabled {\n        pointer-events: none;\n        color: $base-light;\n        opacity: 0.7;\n    }\n    .opt-head {\n        padding: .25rem 1.25rem;\n        color: $base-light;\n    }\n    &.ui-v2 {\n        a {\n            font-weight: $fw-normal;\n        }\n    }\n    &.no-bdr + .link-check {\n        margin-top: -0.75rem;\n    }\n    &.ui-colored {\n        li.active > a, a.active {\n            color: $accent-color;\n        }\n    }\n}\n\n\n/// Link List Menu\n/////////////////////////////////////\n.link-list-menu{\n    padding: .75rem 0;\n    .divider {\n        margin: .5rem 0;\n    }\n    a{\n        position: relative;\n        display: flex;\n        align-items: center;\n        padding: .75rem 1.25rem;\n        font-weight: 500;\n        color: $base-text;\n        transition: all .4s;\n        line-height: 1.3rem;\n        &:after{\n             position: absolute;\n            font-size: 1rem;\n            font-family: $nk-dashlite-font;\n            right: 1.25rem;\n            content: $link-list-menu-icon-ltr;\n            color: $base-light;\n            transition: .3s ease;\n        }\n        .icon{\n            font-size: 1.125rem;\n            width: 1.75rem;\n            opacity: .8;\n            color: $base-light;\n            margin-top: -2px;\n        }\n    }\n    li.active > a, a.active, a:hover, li.active > a .icon, a.active .icon, a:hover .icon, li.active > a:after, a.active:after, a:hover:after {\n         color: $accent-color;\n    }\n    &.nav {\n        display: block;\n    }\n}\n\n@include media-breakpoint-up(sm){\n    .link-list-menu{\n        a{\n            padding: 1rem 1.5rem;\n        }\n    }\n}\n\n\n/// Link List Plain\n/////////////////////////////////////\n.link-list-plain{\n    li + li {\n        @extend .link-bdr-t;\n    }\n    &.no-bdr {\n        padding: .5rem 0;\n        li {\n            border-top-width: 0;\n        }\n    }\n    .divider {\n        margin: .5rem 0;\n    }\n    a{\n        display: flex;\n        align-items: center;\n        padding: .5rem 1.25rem;\n        color: $base-text;\n        transition: all .4s;\n        line-height: 1.4rem;\n        position: relative;\n        &:hover{\n            color: $accent-color; \n            background: $lighter; \n        }\n        .icon{\n            font-size: 1.125rem;\n            width: 1.75rem;\n            opacity: .8;\n            color: $accent-color;\n        }\n    }\n    li.active > a, a.active {\n        color: $accent-color; \n        background: $lighter; \n    }\n    &.sm{\n        a{\n            @extend .link-pd-sm;\n        }\n    }\n    &.text-center {\n        a {\n            justify-content: center;\n            padding-left: 0.25rem;\n            padding-right: 0.25rem;\n        }\n    }\n}\n\n@each $li_col in $li_cols {\n    .link-list-plain.li-col#{$li_col}x{\n        > li{\n            border-right: 1px solid $border-light;\n            border-bottom: 1px solid $border-light;\n            border-top: 0;\n        }\n        > li:nth-child(#{$li_col}n) {\n            border-right: none;\n        }\n    }\n}\n\n\n/// Link List Plain\n/////////////////////////////////////\n.link-list-template {\n    a {\n        font-weight: $fw-normal;\n    }\n}","$upload-invalid: $ni-alert-fill !default;\n$upload-valid: $ni-check-circle-fill !default;\n$upload-error: $ni-cross-circle-fill !default;\n//Passcode Toggle\n.passcode{\n    &-icon {\n        display: none;\n        &.icon-show {\n            display: block;\n            .is-shown &{\n                display: none;\n            }\n            .is-hidden &{\n                display: block;\n            }\n        }\n        &.icon-hide {\n            .is-shown &{\n                display: block;\n            }\n            .is-hidden &{\n                display: none;\n            }\n        }\n    }\n}\n\n// Dropdown\n.form-dropdown{\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    padding: 0 20px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: $base-light;\n    > div > span{\n        margin:0 0.5rem;\n    }\n    .dropdown{\n        > a{\n            display: inline-flex;\n        }\n    }\n}\n\n// clipboard\n.form-clip,.form-text-hint{\n    position: absolute;\n    right: $input-height-border;\n    top: $input-height-border;\n    height: calc(#{$input-height-inner} - #{$input-height-border});\n    display: flex;\n    align-items: center;\n    color: $accent-color;\n    padding-left: 1rem;\n    padding-right: .75rem;\n    background: $white;\n    border-radius: $input-border-radius;\n    &.sm{\n        height: $input-height-sm;\n    }\n    &.lg{\n        height: $input-height-lg;\n    }\n    &.xl{\n        height: $input-height-xl;\n    }\n    .icon + span,span + .icon{\n        margin-left: 0.25rem;\n    }\n}\n\n//Upload\n\n.nk-upload{\n    &-input{\n        position: relative;\n        z-index: 2;\n        width: 100%;\n        height: calc(2.125rem + 2px);\n        margin: 0;\n        opacity: 0;\n    }\n    &-label{\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        padding: 1.5rem;\n        width: 100%;\n        min-height: 150px;\n        border-radius: $border-radius;\n        border: 1px dashed $border-light;\n        padding-bottom: 0;\n    }\n    &-init{\n        display: block;\n        text-align: center;\n    }\n    &-files{\n        padding-top: 2rem;\n        display: flex;\n        justify-content: center;\n        margin: -0.5rem;\n        padding-bottom: 2rem;\n        li{\n            position: relative;\n            display: flex;\n            flex-wrap: wrap;\n            align-items: center;\n            flex-direction: column;\n            text-align: center;\n            padding: 0.5rem;\n            img{\n                width: 60px;\n                flex-shrink: 0;\n                border-radius: $border-radius;\n            }\n        }\n        .is-multiple &{\n            li{\n                img{\n                    width: 40px;\n                }\n                .nk-upload-name{\n                    display: none;\n                }\n            }\n        }\n    }\n    &-name{\n        margin: .5rem 0 0;\n        color: $base-text;\n        font-size:.8125rem;\n        font-weight: $fw-medium;\n        width: 150px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n    &-response{\n        margin-left: auto;\n        display: inline-flex;\n        align-items: center;\n        .message{\n            font-size: $fx-sz-12;\n            color:$base-light;\n            + .icon{\n                margin-left: 0.5rem;\n            }\n        }\n        .icon{\n            &:after{\n                font-family: $nk-dashlite-font;\n            }\n            + .message{\n                margin-left: 0.5rem;\n            }\n        }\n        &.invalid{\n            .icon{\n                color: $warning;\n                &:after{\n                    content: $upload-invalid;\n                }\n            }\n        }\n        &.valid{\n            .icon{\n                color: $success;\n                &:after{\n                    content: $upload-valid;\n                }\n            }\n        }\n        &.error{\n            .icon{\n                color: $danger;\n                &:after{\n                    content: $upload-error;\n                }\n            }\n        }\n    }\n    &-foot{\n        display: flex;\n        justify-content: space-between;\n        border-top: 1px dashed $border-light;\n        padding: 1rem 1.25rem;\n        margin: 0 -1.5rem;\n        > span, > button{\n            margin: .25rem;\n        }\n    }\n}\n\n.form {\n    &-editor-custom {\n        textarea {\n            border-radius: $border-radius $border-radius  0 0;\n        }\n    }\n    &-editor-action {\n        border: 1px solid $border-color;\n        border-top: 0;\n        border-radius: 0 0 $border-radius $border-radius;\n        padding: .25rem .5rem;\n        > .link{\n            padding: .5rem;\n            &.collapsed {\n                color: $base-light;\n            }\n            .icon {\n                margin-right: .25rem;\n            }\n        }\n    }\n    &-editor-btn-group, &-btn-group{\n        display: flex;\n        align-items: center;\n        margin: -0.25rem;\n        flex-wrap: wrap;\n        li {\n            padding: .25rem;\n            line-height: 0.5rem;\n        }\n    }\n    &-btn-group {\n        li:first-child {\n            margin-right: .5rem;\n        }\n    }\n    &-btn-secondary {\n        margin-left: auto;\n    }\n}\n\n\n// number\ninput[type=\"number\"] {\n    -webkit-appearance: textfield;\n    -moz-appearance: textfield;\n    appearance: textfield;\n}\ninput[type=number]::-webkit-inner-spin-button, \ninput[type=number]::-webkit-outer-spin-button { \n    -webkit-appearance: none;\n}\n\n.number{\n    &-spinner{\n        padding-left: $input-padding-x + $btn-line-height + $btn-padding-y*2;\n        padding-right: $input-padding-x + $btn-line-height + $btn-padding-y*2;\n        text-align: center;\n        &:focus{\n            border-color: $input-border-color;\n        }\n        &-btn{\n            position: absolute;\n            top: 0;\n        }\n    }\n    &-plus{\n        right: 0;\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n    &-minus{\n        left: 0;\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n    }\n}\n\n// for date range\n.input-group-addon{\n    display: flex;\n    align-items: center;\n    padding: .25rem .75rem;\n    background-color: $lighter;\n    border: $input-border-width solid $input-border-color;\n    font-size: 0.75rem;\n    border-radius: $border-radius;\n    &:not(:last-child){\n        border-right: 0;\n        border-top-right-radius: 0;\n        border-bottom-right-radius: 0;\n    }\n    &:not(:first-child){\n        border-left: 0;\n        border-top-left-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n}","/// Titles/Headings\n///////////////////////////\n\n// Page Title\n.page-title {\n    font-family: $page-title-ff;\n    font-size: $page-title-fs;\n    font-weight: $page-title-fw;\n}\n\n@media (min-width: 992px) {\n    .page-title {\n        font-size: $page-title-fs-lg;\n    }\n}","/// Text\n///////////////////////////\n.overline-title{\n  font-size: $fx-sz-11;\n  line-height: 1.2;\n  letter-spacing: 0.2em;\n  color: $base-light;\n  text-transform: uppercase;\n  font-weight: $fw-bold;\n  font-family:$font-family-base; \n  .text-light & {\n    color: $base-light;\n  }\n  @if($dark_option==true) {\n    .is-dark &{\n      color: $light-400;\n    }\n  }\n  @if($dark_theme_option==true) {\n    .is-theme &{\n      color: $accent-light;\n    }\n  }\n  &-alt{\n    font-family:$font-family-base;\n    font-weight: $fw-bold;\n    line-height: 1.2;\n    letter-spacing: 0.15em;\n    font-size: $fx-sz-11;\n    color: $base-light;\n    text-transform: uppercase;\n    @if($dark_option==true) {\n      .is-dark &{\n        color: $base-light;\n      }\n    }\n    @if($dark_theme_option==true) {\n      .is-theme &{\n        color: $accent-light;\n      }\n    }\n  }\n  &-sap{\n    position: relative;\n    display: inline-block;\n    margin-bottom: 0;\n    padding-left: .35rem;\n    padding-right: .25rem;\n    color: $base-300;\n    &:before,&:after{\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      width: 20px;\n      height: 1px;\n      content: '';\n      background: $base-300;\n    }\n    &:before{\n      right: 100%;\n    }\n    &:after{\n      left: 100%;\n    }\n  }\n}\n.caption-text{\n  font-size: $fx-sz-16;\n  font-weight: $fw-normal;\n  line-height: 1.3;\n  letter-spacing: -0.01em;\n  + .sub-text, + .sub-text-sm{\n    margin-top: 0.5rem;\n    display: block;\n  }\n}\n\n.lead-text{\n  font-size: 0.875rem;\n  font-weight: 700;\n  color: $base-color;\n  display: block;\n  + .sub-text{\n    font-size: $fx-sz-12;\n  }\n  span{\n    color: $base-text;\n    font-weight: 400;\n  }\n  &-lg{\n    font-size: 1.125rem;\n    font-weight: 500;\n    color: $base-color;\n    display: block;\n    @if($dark_theme_option==true) {\n      .is-theme &{\n        color: $white;\n      }\n      .is-theme .is-light &{\n        color: $base-color;\n      }\n    }\n  }\n  @if($dark_option==true) {\n    .is-dark & {\n      color: $light-400;\n      span{\n        color: $light-500;\n      }\n    }\n  }\n  @if($dark_theme_option==true) {\n    .is-theme & {\n      color: $white;\n      span{\n        color: $accent-light;\n      }\n    }\n  }\n  @if($dark_option==true or $dark_theme_option==true) {\n    .is-theme .is-light &, .is-dark .is-light &{\n      color: $base-color;\n      span{\n        color: $base-text;\n      }\n    }\n  }\n}\n.sub-text{\n  display: block;\n  font-size: $fx-sz-13;\n  color: $base-light;\n  span + .dot,.dot + span{\n    margin-left: 0.25rem;\n  }\n  &-sm,+ .sub-text{\n    font-size: $fx-sz-12;\n  }\n  &-sm{\n    color: $base-light;\n    .is-theme &{\n      color: $accent-light;\n    }\n    .is-theme .is-light &{\n      color: $base-light;\n    }\n  }\n  .text-ellipsis &{\n    display: inline;\n  }\n  strong{\n    color: $base-text;\n    font-weight: 700;\n    @if($dark_theme_option==true) {\n      .is-theme &{\n        color: $accent-light;\n      }\n      .is-theme .is-light &{\n        color: $base-text;\n      }\n    }\n  }\n  span{\n    white-space: nowrap;\n  }\n  @if($dark_theme_option==true) {\n    .is-theme &{\n      color: $accent-300;\n    }\n    .is-theme .is-light &{\n      color: $base-light;\n    }\n  }\n}\n\n.text-date{\n  span{\n    color: $base-text;\n  }\n}\nh6{\n  .badge{\n    margin-left: 0.5rem;\n  }\n}\n.fs-9px{\n  font-size: $fx-sz-9;\n}\n.fs-10px{\n  font-size: $fx-sz-10;\n}\n.fs-11px{\n  font-size: $fx-sz-11;\n}\n.fs-12px{\n  font-size: $fx-sz-12;\n}\n.fs-13px{\n  font-size: $fx-sz-13;\n}\n.fs-14px{\n  font-size: $fx-sz-14;\n}\n.fs-15px{\n  font-size: $fx-sz-15;\n}\n.fs-16px{\n  font-size: $fx-sz-16;\n}\n.fs-17px{\n  font-size: 17px;\n}\n.fs-18px{\n  font-size: 18px;\n}\n.fs-19px{\n  font-size: 19px;\n}\n.fs-20px{\n  font-size: 20px;\n}\n.fs-21px{\n  font-size: 21px;\n}\n.fs-22px{\n  font-size: 22px;\n}\n\n.note-text{\n  font-size: $fx-sz-12;\n  font-style: italic;\n  color: $base-light;\n}",".card{\n    .table{\n        margin-bottom: 0;\n        tr:first-child{\n            th,td{\n                border-top: none;\n            }\n        }\n        tr {\n            &:last-child {\n                td:first-child {\n                    border-bottom-left-radius: $border-radius;\n                }\n                td:last-child {\n                    border-bottom-right-radius: $border-radius;\n                }\n            }\n            &:first-child {\n                th:first-child {\n                    border-top-left-radius: $border-radius;\n                }\n                th:last-child {\n                    border-top-right-radius: $border-radius;\n                }\n            }\n        }\n    }\n    + .lead-text{\n        margin-top: 2rem;\n    }\n    .lead-text + &{\n        margin-top: 1rem;\n    }\n    &-custom-s1{\n        .card-inner-group{\n            .card-inner{\n                border-bottom: 1px solid $card-bordered-color;\n            }\n        }\n    }\n}\n@include media-breakpoint-down(md){\n    .card{\n        &-custom-s1{\n            .card-inner-lg{\n                padding-left: 1.5rem;\n                padding-right: 1.5rem;\n            }\n        }\n    }\n}\n@include media-breakpoint-up(lg){\n    .card{\n        &-custom-s1{\n            .card-inner-group{\n                border-right: 1px solid $card-bordered-color;\n                .card-inner{\n                    &:last-child{\n                        border-bottom: none;\n                    }\n                }\n            }\n        }\n    }\n}\n@include media-breakpoint-up(sm){\n    .card-search {\n        .card-body {\n            padding: 1.5rem;\n        }\n    }\n}\n\n\n// Card Aside\n.card-aside{\n    width: 300px;\n    background-color: $white;\n    min-height: 100vh;\n    flex-shrink: 0;\n    &-left{\n        order: -1;\n        border-right: 1px solid $border-light;\n    }\n    &-right{\n        order:100;\n        border-left: 1px solid $border-light;\n    }\n    &-wrap{\n        display: flex;\n        .card-inner,.card-content{\n            flex-grow:1;\n        }\n    }\n}\n\n@include media-breakpoint-down(sm){\n    .toggle-break-md.card-aside{\n        .card-inner-group{\n            max-height: 100vh;\n        }\n    }\n}\n\n@include media-breakpoint-down(md){\n    .toggle-break-lg.card-aside{\n        .card-inner-group{\n            max-height: 100vh;\n        }\n    }\n}\n\n@include media-breakpoint-down(lg){\n    .toggle-break-xl.card-aside{\n        .card-inner-group{\n            max-height: 100vh;\n        }\n    }\n}\n\n@include media-breakpoint-down(xl){\n    .toggle-break-xxl.card-aside{\n        .card-inner-group{\n            max-height: 100vh;\n        }\n    }\n}\n\n\n@include media-breakpoint-up(lg){\n    .card-aside{\n        position: static;\n        display: block;\n    }\n}\n@include media-breakpoint-up(xxl){\n    .card-aside{\n        width: 380px;\n    }\n}","//// User Avatar \n/////////////////////\n.user-avatar, [class^=\"user-avatar\"]:not([class*=\"-group\"]){\n    border-radius: 50%;\n    height: 40px;\n    width: 40px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: $white;\n    background: #D9D9D9;\n    font-size: 44px;\n    // padding-top: 10px;\n    // padding-right: 1px;\n    font-weight: $fw-bold;\n    letter-spacing: 0;\n    flex-shrink: 0;\n\n    position: relative;\n    + .user-info{\n        margin-left: 1rem;\n        width: max-content;\n    }\n    + .user-name{\n        margin-left: 0.75rem;\n    }\n    img{\n        border-radius: 50%;\n    }\n    &.md{\n        + .user-info{\n            margin-left: 1.5rem;\n        }\n        + .user-name{\n            margin-left: 1.25rem;\n        }\n    }\n    .edit{\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        border-radius: 50%;\n        background-color: rgba($dark,.5);\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        color: $white;\n        opacity: 0;\n        transition: opacity .3s;\n    }\n    &:hover{\n        .edit{\n            opacity: 1;\n        }\n    }\n    .status{\n        border: 2px solid $white;\n        position: absolute;\n        bottom: 0;\n        right: 0;\n    }\n    &.sq{\n        border-radius: $border-radius;\n        img{\n            border-radius: $border-radius;\n        }\n        .status{\n            right: -6px;\n            bottom: -6px;\n        }\n    }\n}\n\n// Multiple Avatar\n.user-avatar-multiple{\n    background-color: transparent !important;\n    .user-avatar{\n        position: absolute;\n        height: 70%;\n        width: 70%;\n        font-size: 80%;\n        border: 2px solid $white;\n        &:nth-child(1){\n            top: 0;\n            right: 0;\n        }\n        &:nth-child(2){\n            bottom: 0;\n            left: 0;\n        }\n    }\n}\n\n.user-card .user-avatar.d-none{\n    margin-right: 1rem;\n    + .user-info, + .user-name{\n        margin-left: 0;\n    }\n}\n\n// Sizes\n.user-avatar {\n    &-xl, &.xl {\n        height: 110px;\n        width: 110px;\n        font-size: 40px;\n        font-weight: 400;\n        .status{\n            bottom: 9px;\n            right: 9px;\n        }\n    }\n    &-lg, &.lg {\n        height: 80px;\n        width: 80px;\n        font-size: 28px;\n        font-weight: 400;\n        .status{\n            bottom: 5px;\n            right: 5px;\n        }\n    }\n    &-md, &.md {\n        height: 60px;\n        width: 60px;\n        font-size: 18px;\n        .status{\n            bottom: 2px;\n            right: 2px;\n        }\n    }\n    &-sm, &.sm{\n        height: 32px;\n        width: 32px;\n        font-size: 12px;\n        .status{\n            bottom: -2px;\n            right: -2px;\n        }\n    }\n    &-xs, &.xs{\n        height: 26px;\n        width: 26px;\n        font-size: 9px;\n        font-weight: $fw-bold;\n        .status{\n            bottom: -2px;\n            right: -2px;\n        }\n    }\n}\n// Colors Fix\n$avatar-adj-colors: (\n    \"blue-dim\":        $blue,\n    \"azure-dim\":       $azure,\n    \"indigo-dim\":      $indigo,\n    \"purple-dim\":      $purple,\n    \"pink-dim\":        $pink,\n    \"orange-dim\":      $orange,\n    \"teal-dim\":        $teal,\n    // for bootstrap\n    \"primary-dim\":     $accent-color,\n    \"secondary-dim\":   $base-color,\n    \"success-dim\":     $success,\n    \"info-dim\":        $info,\n    \"warning-dim\":     $warning,\n    \"danger-dim\":      $danger,\n    \"dark-dim\":        $dark,\n    \"gray-dim\":        $light-500,\n    'lighter':         $base-light,\n    'light':           $base-text\n);\n\n@each $name, $color in $avatar-adj-colors{\n    .user-avatar[class*=\"-#{$name}\"] {\n        color: $color;\n    }\n}\n\n\n// User Card\n//////////////////////////\n.user{\n    &-card {\n        display: flex;\n        align-items: center;\n        &-wrap{\n            padding-top: 1.125rem;\n            padding-bottom: 1.125rem;\n        }\n        .user-info {\n            color: $base-light;\n        }\n        &-menu{\n            position: absolute;\n            right: 1rem;\n            top: 1rem;\n        }\n    }\n    &-toggle{\n    \tdisplay: flex;\n        align-items: center;\n        padding:0 1px 1px;\n    }\n    &-status{\n        font-size: $fx-sz-11;\n        font-weight: 500;\n        line-height: 1;\n        padding-top: .125rem;\n        padding-bottom: .375rem;\n        &-unverified{\n            color: $danger;\n        }\n        &-verified{\n            color: $success;\n        }\n    }\n    &-name{\n        color: $base-text;\n        font-size: $fx-sz-13;\n        line-height: 16px;\n        font-weight: $fw-bold;\n        @if($dark_option==true) {\n            .is-dark &{\n                color: lighten($base-light, 5%);\n            }\n        }\n        @if($dark_theme_option==true) {\n            .is-theme &{\n                color: $accent-light;\n            }\n        }\n    }\n    &-action{\n        margin-left:auto;\n        font-size: 20px;\n        color: $base-light;\n    }\n    &-account{\n        &-info{\n            padding-top: 1.5rem;\n            padding-bottom: 1.25rem;\n        }\n        &-data{\n            li{\n                display: flex;\n                justify-content: space-between;\n                padding: .125rem 0;\n            }\n        }\n        &-actions{\n            &:not(:first-child){\n                margin-top: 1.5rem;\n            }\n            ul{\n                display: flex;\n                li{\n                    width: 44%;\n                    &:last-child{\n                        width: 56%;\n                    }\n                }\n            }\n            .btn{\n                width: 100%;\n                font-size: 12px;\n                letter-spacing: 0.04em;\n                padding-left: 0.5rem;\n                padding-right: 0.5rem;\n                text-transform: uppercase;\n            }\n        }\n        &-links{\n            padding: 1rem 0;\n            border-bottom: 1px solid $border-light;\n            &:last-child {\n                .user-account-info & {\n                    border-bottom: 0;\n                    padding-bottom: 0;\n                }\n            }\n            .user-account-info + & {\n                padding-top: 0;\n                margin-top: -0.5rem;\n            }\n            a:link{\n                padding: 0.5rem 0;\n                display: flex;\n            }\n        }\n        &-value{\n            display: inline-flex;\n        }\n    }\n    &-balance{\n        font-size: 1.5rem;\n        line-height: 1;\n        padding:.125rem 0 .375rem;\n        color: $primary;\n        small{\n            font-size: 1rem;\n        }\n        &-alt{\n            font-size: $fx-sz-15;\n            color: $base-text;\n            font-weight: $fw-bold;\n            span{\n                font-weight: $fw-normal;\n            }\n        }\n        &-sub{\n            font-size: $fx-sz-13;\n            color: $base-light;\n            span{\n                color: $base-text;\n            }\n            + a{\n                margin-top: 1rem;\n            }\n        }\n    }\n}\n\n\n\n// user card s2\n///////////////////////\n.user-card-s2{\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    padding: .5rem;\n    .user-avatar{\n        margin:0 auto;\n    }\n    .user-info{\n        margin: 1.25rem 0 0 !important;\n        .sub-text{\n            justify-content: center;\n        }\n        .badge{\n            margin-bottom: 1rem;\n        }\n    }\n}\n\n// user card md\n///////////////////////\n.user-card-md{\n    .lead-text{\n        font-size: 1rem;\n    }\n    .sub-text{\n        font-size: 0.875rem;\n    }\n}\n\n// User Activity\n///////////////////////\n.user-activity{\n    display: flex;\n    &-group{\n        display: flex;\n        flex-wrap: wrap;\n    }\n    &-ck{\n        height: 110px;\n        padding: .5rem .375rem 0;\n    }\n    .icon{\n        width: 2.25rem;\n        font-size: 1.5rem;\n        color: $base-light;\n    }\n    .info{\n        span{\n            display: block;\n        }\n    }\n    .amount{\n        font-size: 1.125rem;\n        line-height: 1.3;\n        font-weight: $fw-medium;\n        color: $base-text;\n    }\n    .title{\n        font-size: $fx-sz-12;\n        color: $base-light;\n    }\n    .gfx{\n        align-self: flex-end;\n        width: 50px;\n        margin-left: 1rem;\n        margin-bottom: 0.25rem;\n    }\n}\n\n// User Contact\n///////////////////////\n.user-contacts{\n    li{\n        color:$base-text;\n        display: flex;\n        font-size: .875rem;\n        line-height: 1.4rem;\n        padding: .375rem 0;\n        .icon{\n            color: $base-light;\n            font-size: 1rem;\n            width: 1.75rem;\n            line-height: inherit;\n            display: inline-block;\n        }\n    }\n}\n\n// User Avatar Group\n///////////////////////\n.user-avatar-group{\n    display: flex;\n    .user-avatar{\n        border:2px solid $white;\n        &:not(:first-child){\n            margin-left: -20%;\n        }\n        &.sm:not(:first-child) {\n            margin-left: -1rem;\n        }\n        &.xs:not(:first-child) {\n            margin-left: -0.5rem;\n        }\n    }\n}\n// User info extend\n///////////////////////\n.user-info{\n    .lead-text,.sub-text{\n        display: flex;\n        align-items: center;\n    }\n    .edit{\n        font-size: 1.25rem;\n        color: $base-light;\n        margin-left: 0.5rem;\n        display: inline-flex;\n        &:hover{\n            color: $accent-color;\n        }\n    }\n}\n\n// User Plan\n///////////////////////\n.user-plan{\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    padding: .75rem 0;\n    &-title{\n        display: flex;\n        align-items: center;\n        color: $base-color;\n        font-weight: $fw-bold;\n        font-size: 1rem;\n        .icon{\n            font-size: 1.5rem;\n            margin-right: 0.75rem;\n            color: $accent-color;\n        }\n    }\n    &-info, &-actions {\n        padding: 0.5rem 0;\n    }\n    &-status{\n        font-size: $fx-sz-13;\n        font-weight: $fw-medium;\n        color: $base-light;\n        text-transform: uppercase;\n        margin-top: 0.5rem;\n    }\n    &-progress{\n        width: 100%;\n        margin-top: 1rem;\n    }\n}",".data{\n    &-list{\n        &:not(:first-child){\n            margin-top: 1.5rem;\n        }\n    }\n    &-item{\n        position: relative;\n        padding: 1rem 1.25rem;\n        display: flex;\n        align-items: center;\n        cursor: pointer;\n        .icon{\n            color: $base-light;\n            text-align: center;\n            height: 32px;\n            vertical-align: middle;\n            line-height: 32px;\n            display: inline-block;\n        }\n        &:not(:last-child){\n            border-bottom: 1px solid $border-light;\n        }\n        &:hover{\n            // background-color: $lighter;\n            .data-label{\n                color: $base-text;\n            }\n            .data-value, .icon{\n                color: $base-color;\n            }\n        }\n    }\n    &-head{\n        padding:0.5rem 1.25rem;\n        margin-bottom: 0.25rem;\n        background-color: $light-100;\n        border-radius: $border-radius;\n        &.is-plain {\n            margin-bottom: 0;\n            &:first-child{\n                margin-top: 1rem;\n            }\n            background-color: transparent;\n        }\n        .title {\n            color: $base-text;\n        }\n    }\n    &-col{\n        flex-grow: 1;\n        span:not(.data-more){\n            display: inline-block;\n            transition: color .3s;\n        }\n        &-end{\n            flex-grow: 0;\n            margin-left: auto;\n        }\n    }\n    &-label{\n        color: $base-light;\n        width: 100%;\n        flex-shrink: 0;\n    }\n    &-value{\n        color: $base-text;\n        font-size: 0.9375rem;\n    }\n    &-more{\n        position: relative;\n        z-index: 4;\n        text-align: center;\n        line-height: 28px;\n        height: 28px;\n        width: 28px;\n        display: inline-grid;\n        align-content: center;\n        &:before{\n            position: absolute;\n            z-index: -1;\n            height: 20px;\n            width: 20px;\n            top: 50%;\n            left: 50%;\n            transform: translate( -50%, -50%);\n            transform-origin: 50% 50%;\n            content: '';\n            background-color: $light-200;\n            border-radius: 50%;\n            opacity: 0;\n            transition: all .3s;\n            .data-item:hover &{\n                opacity: 1;\n                height: 40px;\n                width: 40px;\n            }\n        }\n        .icon{\n            height: auto;\n        }\n        &.disable{\n            &:before{\n                display: none;\n            }\n        }\n    }\n}\n\n.data-list-s2{\n    &:not(:first-child){\n        margin-top: 1rem;\n    }\n    .data{\n        &-item,&-head{\n            padding-left: 0;\n            padding-right: 0;\n            background: transparent;\n        }\n        &-head{\n            border-bottom: 1px solid $border-color;\n        }\n        &-item:not(:last-child){\n            border-bottom-color: $border-color;\n        }\n        &-label{\n            color: $base-text;\n        }\n        &-placeholder{\n            color: $base-light;\n        }\n    }\n}\n\n@include media-breakpoint-up(md){\n    .data{\n        &-list{\n            &:not(:first-child){\n                margin-top: 2rem;\n            }\n            &-s2{\n                &:not(:first-child){\n                    margin-top: 1.25rem;\n                }\n            }\n        }\n        &-item{\n            padding: 1.5rem 1.25rem;\n        }\n        &-col{\n            display: flex;\n            align-items: center;\n            &-end{\n                width: 200px;\n                text-align: right;\n                justify-content: flex-end;\n            }\n        }\n        &-label{\n            &:not([class^=\"w-\"]) {\n                width: 50%;\n            }\n        }\n    }\n}\n\n@media (min-width:1200px) and (max-width:1359px){\n    .card-aside-wrap{\n        .data-list{\n            .data-col{\n                flex-wrap: wrap;\n            }\n            .data-label{\n                width: 100%;\n            }\n        }\n    }\n} \n\n.is-compact .data-item{\n    padding-top: .75rem;\n    padding-bottom: .75rem;\n}\n\n.is-medium .data-item{\n    padding-top: 1.125rem;\n    padding-bottom: 1.125rem;\n}","/// Dropdowns\n///////////////////////////\n.nk-notification{\n    .dropdown-menu &{\n        max-height: 239px;\n        overflow: auto;\n    }\n    &-item{\n        display: flex;\n        align-items: center;\n        padding: 1.25rem 1.75rem;\n    }\n    &-icon{\n        flex-shrink: 0;\n        margin-right: .75rem;\n    }\n    &-text{\n        font-size: $fx-sz-13;\n        color: $base-text;\n        span{\n            color: $base-color\n        }\n    }\n    &-time{\n        font-size: $fx-sz-11;\n        color: $base-light;\n    }\n}\n\n.nk-chat-list, .chat-list {\n    .dropdown-menu &{\n        max-height: 274px;\n        overflow: auto;\n    }\n}","/// Icons\n///////////////////////////\n.icon{\n    &-light{\n        color: $white;\n    }\n    &-dark{\n        color: $base-color;\n    }\n    &-text{\n        display: flex;\n        align-items: center;\n        font-size: $fx-sz-13;\n        .icon{\n            font-size: 1.5em;\n            width: 1.75rem;\n        }\n    }\n    &-image{\n        width: 70px;\n        + h6{\n            margin-top: 1rem;\n        }\n    }\n    &-circle{\n        display: inline-flex;\n        justify-content: center;\n        align-items: center;\n        border-radius: 50%;\n        background: $primary;\n        color: $white;\n        font-size: 18px;\n        height: 36px;\n        width: 36px;\n        &-sm,&.sm{\n            height: 20px;\n            width: 20px;\n            font-size: 12px;\n        }\n        &-md,&.md{\n            height: 28px;\n            width: 28px;\n            font-size: 14px;\n        }\n        &-lg,&.lg{\n            height: 44px;\n            width: 44px;\n            font-size: 24px;\n        }\n        &-xxl,&.xxl{\n            height: 80px;\n            width: 80px;\n            font-size: 40px;\n        }\n    }\n    &-status{\n        position: relative;\n        display: inline-flex;\n        &:after{\n            position: absolute;\n            border-radius: 50%;\n            right: 0;\n            top: 1px;\n            height: 10px;\n            width: 10px;\n            border: 2px solid $white;\n            content: '';\n        }\n        &-info{\n            &:after{\n                background: $info;\n            }\n        }\n        &-danger{\n            &:after{\n                background: $danger;\n            }\n        }\n        &-success{\n            &:after{\n                background: $success;\n            }\n        }\n        &-warning{\n            &:after{\n                background: $warning;\n            }\n        }\n        &-on{\n            &:after{\n                background: $success;\n            }\n        }\n        &-off{\n            &:after{\n                background: $base-light;\n            }\n        }\n        &-na {\n            &:after {\n                display: none;\n            }\n        }\n    }\n    &-overlap{\n        display: inline-flex;\n        align-items: center;\n        flex-direction: row-reverse;\n        flex-shrink: 0;\n        li{\n            border-radius: 50%;\n            border: 2px solid #fff;\n            + li{\n                margin-right: -14px;\n            }\n        }\n        \n        &-alt{\n            display: inline-flex;\n            align-items: flex-end;\n            flex-shrink: 0;\n            li{\n                border-radius: 50%;\n                + li{\n                    margin-left: -16px;\n                    margin-bottom: -10px;\n                }\n            }\n        }\n    }\n}\n\n$icon-adj-bg: (\n    \"btc\"           $brand-color-bitcoin,\n    \"facebook\"      $brand-color-facebook,\n    \"google\"        $brand-color-google,\n    \"btc-dim\"       mix($brand-color-bitcoin, #fff, 13%),\n    \"eth-dim\"       mix($brand-color-ethereum, #fff, 13%),\n    \n    \"white\"         $white\n);\n\n@each $name, $color in $icon-adj-bg{\n    .icon-circle[class*=\"#{$name}\"] {\n        background: $color;\n    }\n}\n\n$icon-adj-colors: (\n    \"blue-dim\":        $blue,\n    \"azure-dim\":       $azure,\n    \"indigo-dim\":      $indigo,\n    \"purple-dim\":      $purple,\n    \"pink-dim\":        $pink,\n    \"orange-dim\":      $orange,\n    \"teal-dim\":        $teal,\n    \"primary-dim\":     $accent-color,\n    \"secondary-dim\":   $base-color,\n    \"success-dim\":     $success,\n    \"info-dim\":        $info,\n    \"warning-dim\":     $warning,\n    \"danger-dim\":      $danger,\n    'light':           $base-text,\n    'lighter':         $base-light,\n    \"dark-dim\":      #dde2ea,\n    \"gray-dim\":      #e9f0f9,\n    \"facebook-dim\":    $brand-color-facebook,\n    \"google-dim\":      $brand-color-google,\n    \"btc-dim\":         $brand-color-bitcoin,\n    \"eth-dim\":         $brand-color-ethereum,\n    \n    'white':           $base-text,\n);\n\n@each $name, $color in $icon-adj-colors{\n    .icon[class*=\"bg-#{$name}\"] {\n        color: $color;\n    }\n}\n\n\n// /// Icon avatar\n// /////////////////////// \n.icon-avatar {\n    width: 1.5rem;\n    height: 1.5rem;\n    display: inline-block;\n    text-align: center;\n    line-height: 1.5rem;\n    border-radius: 50%;\n    background: $accent-200;\n    color: $accent-500;\n    margin-right: 0.5rem;\n    font-size: $fx-sz-12;\n    &-md {\n        width: 2rem;\n        height: 2rem;\n        line-height: 2rem;\n        font-size: $fx-sz-14;\n    }\n}","/// Tables\n///////////////////////////\n.tb-col-hide, .tb-col-xs, .tb-col-mb{\n    display: none !important;\n}\n@each $breakpoint in map-keys($container-max-widths) {\n    $infix: breakpoint-infix($breakpoint, $container-max-widths);\n    .tb-col#{$infix}{\n        @extend .tb-col-hide; \n    }\n}\n\n@each $breakpoint in map-keys($container-max-widths) {\n    @include media-breakpoint-up($breakpoint) {\n        $infix: breakpoint-infix($breakpoint, $container-max-widths);\n        .tb-col#{$infix}{\n            display: table-cell !important;\n        }\n    }\n}\n@media (min-width: 359px) { \n    .tb-col-xs{\n        display: table-cell !important;\n    }\n}\n@media (min-width: 414px) { \n    .tb-col-mb{\n        display: table-cell !important;\n    }\n}\n\n.table-middle td, .tb-row-middle td{\n    vertical-align: middle;\n}\n.tb-col{\n    &-end, &-action{\n        text-align: right;\n    }\n    &-middle {\n        vertical-align: middle;\n    }\n    &-action {\n        .link-cross, .link-done{\n            font-size: 1rem;\n            text-align: center;\n            line-height: 28px;\n            height: 24px;\n            width: 24px;\n            display: inline-block;\n            color: $base-light;\n            vertical-align: middle;\n            border-radius: 12px;\n            .icon {\n                padding-left: 1px;\n            }\n        }\n        .link-cross {\n            &:hover {\n                color: $danger;\n                background: mix($danger, $white, 14%);\n            }\n        }\n        .link-done{\n            &:hover {\n                color: $success;\n                background: mix($success, $white, 14%);\n            }\n        }\n    }\n}\n\n@include media-breakpoint-down(mb){\n    .table-ulogs{\n        th.tb-col-ip {\n            display: none;\n        }\n        tr {\n            display: flex;\n            flex-wrap: wrap;\n            width: 100%;\n            position: relative;\n            padding: 0.5rem 1.25rem;\n            &:not(:first-child) {\n                border-top: 1px solid $border-color;\n            }\n            td {\n                padding: 0;\n                border: 0;\n                &:first-child, &:last-child{\n                    padding: 0;\n                }\n            }\n            td, th{\n                flex-grow: 1;\n            }\n            td.tb-col-os {\n                width: 100%;\n            }\n            th.tb-col-os {\n                width: 40%;\n                min-width: 142px;\n                flex-grow: 0;\n            }\n            td.tb-col-ip {\n                width: 40%;\n                min-width: 130px;\n                flex-grow: 0;\n            }\n            .tb-col-action {\n                position: absolute;\n                right: 10px;\n                top: 50%;\n                transform: translateY(-50%);\n                padding: 0;\n            }\n        }\n        thead tr {\n            padding: 0;\n        }\n    }\n}\n","/// Toggles\n///////////////////////////\n.toggle{\n    &-content{\n        opacity: 0;\n        visibility: hidden;\n        position: absolute;\n        top: calc(100% + 10px);\n        z-index: 9;\n        background: $white;\n        border-radius: $border-radius;\n        box-shadow: $box-shadow;\n        transform: translateY(10px);\n        &-right{\n            left: auto;\n            right: 0;\n        }\n        &-bottom{\n            top: auto;\n            bottom: 0;\n        }\n        &.content-active{\n            transition: all .2s ease;\n            opacity: 1;\n            visibility: visible;\n            transform: translateY(0);\n        }\n    }\n    &-slide{\n        position: fixed;\n        top: 0;\n        z-index: 1021;\n        min-width: 260px;\n        max-width: calc(100% - 40px);\n        transition: transform 650ms ease,;\n        &-left{\n            left: 0;\n            transform: translateX(-100%);\n        }\n        &-right{\n            right: 0;\n            transform: translateX(100%);\n        }\n        &.content-active{\n            transform: translate(0) !important;\n        }\n    }\n    &-overlay{\n        position: fixed;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        background: rgba($dark,.2);\n        z-index: 1020;\n        animation: overlay-fade-in .4s ease 1;\n    }\n}\n\n.toggle-expand{\n    &-content{\n        display: none;\n        &.expanded{\n            display: block;\n        } \n    }\n}\n\n.inactive-text{\n    .toggle-expand &, .toggle-opt & {\n        display: block;\n    }\n    .toggle-expand.active > &, .toggle-opt.active > &{\n        display: none;\n    }\n}\n.active-text{\n    .toggle-expand &, .toggle-opt & {\n        display: none;\n    }\n    .toggle-expand.active > &, .toggle-opt.active > &{\n        display: block;\n    }\n}\n\nbody.toggle-shown{\n    overflow: hidden;\n}\n\n\n\n// Toggle For Page Tools\n@include media-breakpoint-up(sm){\n    .nk-block-tools-toggle{\n        .toggle-expand{\n            display: none;\n            &-content{\n                display: block !important;\n            }\n        }\n    }\n}\n@include media-breakpoint-down(mb){\n    .nk-block-tools-toggle{\n        .toggle-expand-content{\n            position: absolute;\n            left: 0;\n            right: 0;\n            top: 100%;\n            z-index: 99;\n            width: 100vw;\n            padding: 0 $card-stretch-gap-x !important;\n            background: $white;\n            margin-left: - $card-stretch-gap-x;\n            margin-right: - $card-stretch-gap-x;\n            box-shadow: 0 20px 35px rgba(#000,.2);\n        }\n        .nk-block-tools{\n            padding-top: 20px;\n            padding-bottom: 20px;\n            &-opt{\n                margin-left: auto;\n            }\n        }\n    }\n}\n\n// Toggle For Page card\n\n@include media-breakpoint-down(mb){\n    .card-tools-toggle{\n        .card-title-group{\n            position: static;\n        }\n        .toggle-wrap{\n            .toggle-content{\n                padding: 1.25rem 1rem;\n                transform: translate(0);\n                top: 0;\n                left: 0;\n                right: 0;\n                bottom: 0;\n            }\n            .toggle-close{\n                margin-right: auto;\n                .btn-trigger{\n                    &:before{\n                        opacity: 0;\n                    }\n                    &:hover{\n                        &:before{\n                            opacity: 1;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n@include media-breakpoint-up(sm){\n    .card-tools-toggle{\n        z-index: 9;\n        .toggle-wrap{\n            .toggle{\n                display: none;\n                &-content{\n                    z-index: 9;\n                    opacity: 1;\n                    visibility: visible;\n                    position: static;\n                    background: transparent;\n                    box-shadow: none;\n                    transform: translate(0);\n                }\n                &-close{\n                    display: none;\n                }\n            }\n        }\n    }\n}\n\n@each $breakpoint in map-keys($container-max-widths) {\n    @include media-breakpoint-up($breakpoint) {\n        $infix: breakpoint-infix($breakpoint, $container-max-widths);\n        .toggle-break#{$infix}{\n            transition: none;\n            opacity: 1;\n            visibility: visible;\n            transform: translateY(0) !important;\n            position: static;\n            background:transparent;\n            box-shadow: none;\n            z-index: 1 !important;\n            &.collapse{\n                display: block;\n            }\n        }\n    }\n}","/// Nav Switch\n/////////////////////////////\n.nav-switch {\n    display: inline-flex;\n    margin-bottom: 1.5rem;\n    border: 1px solid $border-color;\n    border-radius: 30px;\n    padding: 5px;\n    .nav{\n      &-link {\n        padding: 5px 16px;\n        line-height: 20px;\n        border-radius: 20px;\n        position: static;\n        text-transform: uppercase;\n        font-family: $base-font-family;\n        font-weight: $fw-bold;\n        font-size: 12px;\n        color: $base-light;\n        &.active {\n            background: $primary;\n            color: #fff;\n        }\n        &:after {\n            display: none;\n        }\n      }  \n      &-item {\n            padding: 0;\n            margin: 0 1px;\n            &:last-child {\n                margin-right: 0;\n            }\n            &:first-child {\n                margin-left: 0;\n            }\n        }\n    }\n}\n\n@include media-breakpoint-up(sm){\n    .nav-switch {\n        margin-bottom: 2.5rem;\n    }\n}\n\n/// Nav Switch\n/////////////////////////////\n.nav-switch-s2{\n    display: inline-flex;\n    border-radius: $border-radius;\n    border: none;\n    .nav{\n        &-link {\n            padding: .25rem .7rem;\n            line-height: 20px;\n            border-radius: 0;\n            position: static;\n            text-transform: uppercase;\n            font-family: $base-font-family;\n            font-weight: $fw-bold;\n            font-size: 12px;\n            color: $base-light;\n            border: 1px solid $border-color;\n            &:hover, &:focus {\n                color: $base-text;\n                background: $lighter;\n                border: 1px solid $border-color;\n            }\n\n            &.active {\n                color: $base-color;\n                border: 1px solid $border-color;\n                background: $lighter;\n                box-shadow: inset 0 0 4px -1px rgba($base-light, .25);\n            }\n            &:after {\n                display: none;\n            }\n        }  \n        &-item {\n            padding: 0;\n            margin: 0;\n            &:last-child {\n                margin-right: 0;\n                .nav-link{\n                    border-radius: 0 $border-radius $border-radius 0;\n                }\n            }\n            &:first-child {\n                margin-left: 0;\n                .nav-link{\n                    border-radius: $border-radius 0 0 $border-radius;\n                }\n            }\n            &:not(:first-child){\n                margin-left: -1px;\n            }\n        }\n    }\n}","// Widget\n///////////////////////\n.widget{\n    &-title{\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 0.75rem;\n        > *{\n            margin-bottom: 0;\n        } \n        .text-center & {\n            justify-content: center;\n        }\n        @if($dark_theme_option==true) {\n            a:hover {\n                .is-theme & {\n                    color: $white;\n                }\n            }\n        }\n    }\n}\n\n// Side Widget\n///////////////////////\n.side-wg{\n    &:not(:last-child){\n        margin-bottom: 2.5rem;\n    }\n    &-title {\n        padding-bottom: 0.75rem;\n    }\n    .back-to {\n        font-size: 0.875rem;\n        line-height: 1.1;\n        font-weight: $fw-normal;\n        position: relative;\n        color: $base-light;\n        display: inline-flex;\n        align-items: center;\n        .icon {\n            font-size: 1.25rem;\n            width: 1.75rem;\n            margin-top: -3px;\n            display: inline-block;\n        }\n    }\n}\n\n\n/// Widget CHART\n///////////////////////////\n.nk-ck{\n    height: 260px;\n    &-sm{\n        height: 180px;\n    }\n}\n.nk-ck1{\n    height: 120px;\n}\n.nk-ck2{\n    height: 240px;\n}\n.nk-ck3{\n    height: 160px;\n}\n.nk-cktv{\n    height: 300px;\n    overflow: hidden;\n    border: 1px solid $border-color;\n    border-radius: $border-radius;\n    .tradingview-widget-container {\n        overflow: hidden;\n        position: relative;\n        top: 8px;\n        > div {\n            margin: -1px;\n        }\n    }\n}\n\n@include media-breakpoint-up(sm) {\n    .nk-ck{\n        height: 260px;\n        &-sm{\n            height: 180px;\n        }\n    }\n    .nk-ck1{\n        height: 120px;\n    }\n    .nk-ck2{\n        height: 240px;\n    }\n    .nk-ck3{\n        height: 258px;\n    }\n}\n\n// WG 6\n///////////////////////\n.nk-wg6{\n    &-title{\n        &:not(:first-child){\n            margin-top: 1.5rem;\n        }\n        &:not(:last-child){\n            margin-bottom: 1.5rem;\n        }\n    }\n    &-text{\n        &:not(:last-child){\n            margin-bottom: 1.5rem;\n        }\n    }\n}\n\n\n// ASide WG\n///////////////////////\n.aside-wg{\n    + .aside-wg{\n        padding-top: 2rem;\n    }\n}","/// Modals\n////////////////////////////\n.nk-modal{\n    &-title{\n        &:not(:first-child){\n            margin-top: 1.5rem;\n        }\n        &:not(:last-child){\n            margin-bottom: 1.5rem;\n        }\n        &.title {\n            font-size: 1.5rem;\n        }\n    }\n    &-text{\n        &:not(:last-child){\n            margin-bottom: 1.5rem;\n        }\n        .lead {\n            font-size: 1.1rem;\n            line-height: 1.5;\n        }\n        .sub-text {\n            font-size: $fx-sz-14;\n        }\n    }\n    &-action {\n        margin-top: 1.5rem;\n        &-sm {\n            margin-top: 1rem;\n        }\n        &-md {\n            margin-top: 2rem;\n        }\n        &-lg {\n            margin-top: 2.25rem;\n        }\n    }\n}\n.modal-body-lg{\n    .tab-content{\n        margin-top: 2rem;\n    }\n}\n\n@include media-breakpoint-up(sm){\n    .nk-modal{\n        &-action {\n            &-md {\n                margin-top: 2.5rem;\n            }\n            &-lg {\n                margin-top: 3.25rem;\n            }\n        }\n    }\n}\n\n[data-toggle=\"modal\"]{\n    cursor: pointer;\n}","/// Search\n///////////////////////////\n.search{\n    &-wrap{\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        opacity: 0;\n        background: $white;\n        transition: opacity .4s;\n        border-radius: 6px;\n        pointer-events: none;\n        display: flex;\n        align-items: center;\n        &.active{\n            opacity: 1;\n            z-index: 9;\n            pointer-events: auto;\n        }\n        &-extend{\n            margin-top: -1rem;\n            left: -2px;\n            right: -2px;\n        }\n    }\n    &-toggle{\n        transition: all .4s;\n        opacity: 1;\n        &.active {\n            opacity: 0;\n        }\n    }\n    &-content{\n        position: relative;\n        width: 100%;\n       .form-control{\n            padding-left: $input-height;\n            padding-right: $input-height;\n            &-sm{\n                padding-left: $input-height-sm;\n                padding-right: $input-height-sm;\n            }\n       }\n    }\n    &-back,&-submit{\n        position: absolute;\n        top: 50%;\n        &:focus{\n            box-shadow: none;\n        }\n    }\n    &-back{\n        left: 0;\n        transform: translate(-0.25rem, -50%);\n    }\n    &-submit{\n        right: 0;\n        transform: translate(0.5rem, -50%);\n        &:hover{\n            color: $primary;\n        }\n    }\n}\n\n.nk-search-box {\n    margin-top: 1.5rem;\n    margin-bottom: 1.25rem;\n    .form{\n        &-icon{\n            height: 100%;\n            border: none;\n            background: transparent;\n            width: 3.5rem;\n        }\n        &-control {\n            border-radius: 1.5rem;\n            padding-left: 1.25rem;\n            padding-right: 1.5rem;\n        }\n    }\n}","/// Blocks\n///////////////////////////\n.nk{\n    &-block{\n        .nk-block + &, + .nk-block-head {\n            padding-top: $gutter-width;\n            &-lg{\n                padding-top: 2.5rem;\n            }\n        }\n        .nav-tabs + &{\n            padding-top: 1.5rem;\n            &-sm{\n                padding-top: 1rem;\n            }\n        }\n        &-area{\n            display: flex;\n            &-column{\n                flex-direction: column;\n            }\n        }\n        &-between{\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            > .title:first-child {\n                margin-bottom: 0;\n            }\n        }\n        &-middle{\n            margin-top: auto;\n            margin-bottom: auto;\n        }\n        &-head{\n            position: relative;\n            padding-bottom: 1.25rem;\n            &:only-child{\n                padding-bottom: 0;\n            }\n            h2:not(:last-child){\n                margin-bottom: 1rem;\n            }\n            &-sub{\n                font-size: 1rem;\n                line-height: 1.5rem;\n                margin-bottom: .5rem;\n                color: $base-light;\n                font-weight: $fw-normal;\n                position: relative;\n                .back-to{\n                    color:inherit;\n                    display: inline-flex;\n                    align-items: center;\n                    .icon{\n                        font-size: 1.5rem;\n                        width: 2rem;\n                        margin-top: -3px;\n                        display: inline-block;\n                    }\n                }\n                .dropdown {\n                    position: absolute;\n                    right: -8px;\n                    top: -6px;\n                }\n            }\n            &-xs{\n                padding-bottom: .75rem;\n            }\n            &-sm{\n                padding-bottom: 1rem;\n            }\n            &-lg{\n                padding-bottom: 1.5rem;\n            }\n            & + .nav-tabs {\n                margin-top: -1rem;\n            }\n            .nk-content-body > & {\n                &:first-child {\n                    padding-bottom: 1.75rem;\n                }\n            }\n            .nk-block-text{\n                margin-top: 1.5rem;\n                + .btn{\n                    margin-top: 1.5rem;\n                }\n            }\n        }\n        &-tools{\n            display: flex;\n            align-items: center;\n            > *{\n                display: inline-flex;\n            }\n        }\n        &-des{\n            color: $base-text;\n            strong{\n                color: $base-color;\n            }\n            .icon{\n                vertical-align: middle;\n            }\n        }\n        &-content{\n            + .nk-block-head{\n                padding-top: 2rem;\n                &-sm{\n                    padding-top: 1.5rem;\n                }\n            }\n            &-head{\n                &:not(:last-child){\n                    margin-bottom: 1rem;\n                }\n            }\n        }\n        &-title {\n            &-group {\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                .title {\n                    margin-bottom: 0\n                }\n                &:not(:last-child) {\n                    margin-bottom: .5rem;\n                }\n            }\n        }\n    }\n}\n@include media-breakpoint-up(sm){\n    .nk{\n        &-block{\n            &-head{\n                &-lg{\n                    padding-bottom: 2.5rem;\n                }\n            }\n            &-content{\n                + .nk-block-head{\n                    padding-top: 4rem;\n                    &-sm{\n                        padding-top: 2.5rem;\n                    }\n                }\n            }\n        }\n    }\n}\n@include media-breakpoint-up(md){\n    .nk-block{\n        &-head {\n            .nk-content-body > & {\n                &:first-child {\n                    padding-bottom: 2.5rem;\n                }\n                &-sm{\n                    &:first-child {\n                        padding-bottom: 1.75rem;\n                    }\n                }\n            }\n        }\n        .nav-tabs + & {\n            padding-top: 2.5rem;\n            &-sm{\n                padding-top: 2rem;\n            }\n            &-xs{\n                padding-top: 1.25rem;\n            }\n        }\n        &-text {\n            h5, h6 {\n                font-size: 1rem;\n            }\n        }\n    }\n}\n\n@include media-breakpoint-down(sm){\n    .nk-block-tools{\n        .opt-menu-md{\n            order: 100;\n            margin-left: auto;\n        }\n    }\n}\n\n$breaks: md;\n@each $break in $breaks {\n    @include media-breakpoint-up($break){\n        .nk-block{\n            &-between-#{$break}{\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n            }\n        }\n    }\n}\n\n.nk-block-subhead{\n    padding-bottom: .5rem;\n    border-bottom: 1px solid $border-color;\n}","/// Feature\n///////////////////////////\n.nk-feature{\n    &-center{\n        text-align: center;\n    }\n}","$change-up-icon: $ni-arrow-long-up !default;\n$change-down-icon: $ni-arrow-long-down !default;\n\n/// Misc\n///////////////////////////\n.filter-wg {\n    label.overline-title {\n        margin-bottom: .5rem;\n    }\n}\n\n//// CHANGE\n.change {\n    line-height: 1;\n    .sign {\n        font-family: $nk-dashlite-font;\n        &:before {\n            content: \"\";\n        }\n    }\n    &.up {\n        color: $success !important;\n        .sign:before {\n            content: $change-up-icon;\n        }\n    }\n    &.down {\n        color: $danger !important;\n        .sign:before {\n            content: $change-down-icon;\n        }\n    }\n}\n\n\n// KNOB\n.nk-knob{\n    > div{\n        position: relative;\n        display: inline-block !important;\n    }\n}\n.knob{\n    height: 100% !important;\n    margin-top: 0 !important;\n    font-size: 1.5rem !important;\n}\n.knob-half{\n    height: 50% !important;\n    font-size: 1.25rem !important;\n}\n[class*=\"knob\"]{\n    text-align: center;\n    pointer-events: none;\n    width: 100% !important;\n    font-weight: $fw-normal !important;\n    font-family: $base-font-family !important;\n    color: $base-color !important;\n    margin-left: 0 !important;\n    left: 0;\n    border: none;\n    &:focus{\n        outline: none;\n    }\n}\n\n\n// Stats\n.stats{\n    padding: 0 0 1rem;\n}\n@include media-breakpoint-only(xxl){\n    .nk-content-sidebar{\n        .stats{\n            padding: 1.25rem 1.5rem 1rem;\n        }\n    }\n}\n\n// collapse\n.collapse{\n    &-shown{\n        display: inline-block !important;\n        .collapsed &{\n            display: none !important;\n        }\n    }\n    &-hidden{\n        display: none !important;\n        .collapsed &{\n            display: inline-block !important;\n        }\n    }\n}\n\n\n// clipboard\n.clipboard{\n    &-init{\n        cursor: pointer;\n        .clipboard-success &{\n            color: darken($success,5%);\n        }\n    }\n    &-text{\n        font-size: $fx-sz-12;\n    }\n    &-success{\n        .form-control:focus{\n            border-color: $input-border-color;\n            box-shadow: $input-box-shadow;\n        }\n    }\n}\n\n// News\n.nk-news{\n    &-item{\n        display: flex;\n        align-items: center;\n    }\n    &-icon{\n        width: 2rem;\n        display: inline-flex;\n        flex-shrink: 0;\n        .icon{\n            font-size: 24px;\n            color: $accent-color;\n            @if($dark_theme_option==true) {\n                .is-theme &{\n                    color: lighten($accent-color, 5%);\n                }\n            }\n        }\n        img{\n            width: 24px;\n        }\n    }\n    &-text{\n        display: flex;\n        align-items: center;\n        max-width: calc(100% - 1.5rem);\n        p{\n            font-size: $fx-sz-13;\n            margin-bottom: 0;\n            color: $base-text;\n            font-weight: $fw-medium;\n            text-overflow: ellipsis;\n            overflow: hidden;\n            white-space: nowrap;\n            width: calc(100% - 2rem);\n            span{\n                color:$base-light;\n                font-weight: $fw-normal;\n            }\n            @if($dark_option==true) {\n                .is-dark & {\n                    color: lighten($base-light, 5%);\n                    span{\n                        color: rgba($base-light, .9);\n                    }\n                }\n            }\n            @if($dark_theme_option==true) {\n                .is-theme &{\n                    color: lighten($accent-light, 5%);\n                    span{\n                        color: rgba($accent-light, .8);\n                    }\n                }\n            }\n        }\n        .icon{\n            color: $base-light;\n            margin-left: .25rem;\n            @if($dark_option==true) {\n                .is-dark &{\n                    color: $base-light;\n                }\n            }\n            @if($dark_theme_option==true) {\n                .is-theme &{\n                    color: $accent-light;\n                }\n            }\n        }\n    }\n    &-item:hover &{\n        &-text .icon{\n            color:$accent-color;\n        }\n    }\n}\n\n\n//language-list\n.language{\n    &-list{\n        li:not(:last-child){\n            .language-item{\n                border-bottom: 1px solid $base-100;\n            }\n        }\n    }\n    &-item{\n        display: flex;\n        align-items: center;\n        padding: 12px 20px;\n        color: $gray-700;\n        transition: all .4s;\n        &:hover{\n            color: $light-600;\n            background: $gray-100;\n        }\n    }\n    &-name{\n        font-size: 12px;\n    }\n    &-flag{\n        width: 24px;\n        margin-right: 12px;\n    }\n}\n\n.entry {\n    img,.video,.image-group{\n        border-radius: $border-radius;\n        + p, + h2, + h3, + h4, + h5, + h6, + ul, + ol{\n            margin-top: ($para-margin * 2);\n        }\n    }\n    p {\n        + img{\n            margin-top: $para-margin ;\n        }\n    }\n    p {\n        + h2, + h3, + h4,+ h5, + h6, + .video, + .image-group{\n            padding-top: ($para-margin * .75);\n        }\n    }\n}\n\np > span > .icon.ni {\n    vertical-align: middle;\n}\n\n// DD fix with Button Trigger\n/////////////////////////////////\n.btn-trigger + .dropdown-menu-right, .btn-trigger + .dropdown-menu-left {\n    margin: -.75rem 0;\n}\n\n.btn-trigger + .dropdown-menu-right {\n    margin-right: 16px;\n}\n.btn-trigger + .dropdown-menu-left {\n    margin-left: 16px;\n}\n\n@media (max-width:420px){\n    .btn-trigger + .dropdown-menu-xl, .btn-trigger + .dropdown-menu-lg, .btn-trigger + .dropdown-menu-md {\n        margin-left: 16px;\n        margin-top: .25rem;\n    }\n}\n\n\n// Blockquote Notes\n/////////////////////////////\n.bq-note{\n    &-item {\n        &:not(:first-child) {\n            margin-top: 1.75rem;\n        }\n    }\n    &-text{\n        padding: 1rem 1.25rem;\n        background: $lighter;\n        border-radius: $border-radius;\n    }\n    &-meta{\n        font-size: $fx-sz-12;\n        color: $base-light;\n        margin-top: .75rem;\n        span > span {\n            color: $base-text;\n        }\n        .link {\n            margin-left: .75rem;\n        }\n    }\n    &-sep {\n        height: .25rem;\n        display: block;\n        visibility: hidden;\n        padding: 0 0.25rem;\n    }\n    &-by {\n        display: inline-block;\n    }\n}\n\n@include media-breakpoint-up(sm){\n    .bq-note{\n        &-text{\n            padding: 1.25rem 1.5rem;\n        }\n        &-sep {\n            height: auto;\n            display: inline-block;\n            visibility: visible;\n        }\n    }\n}\n\n@media (min-width:1200px) and (max-width:1359px){\n    .form-settings{\n        .col-lg-5,.col-lg-7{\n            flex: 0 0 100%;\n            max-width: 100%;\n        }\n    }\n}\n\n.embed-responsive{\n    border-radius: $border-radius;\n}\n\n.video{\n    position: relative;\n    overflow: hidden;\n    border-radius: $border-radius;\n    &:before{\n        position: absolute;\n        content: '';\n        bottom: 0;\n        right: 0;\n        left: 0;\n        height: 120px;\n        background: linear-gradient(to top, rgba($black,.4), rgba($black,0));\n    }\n    &-play{\n        display: flex;\n        align-items: center;\n        position: absolute;\n        left: 2rem;\n        bottom: 2rem;\n        color: $white;\n        font-size: 1.25rem;\n        &:hover{\n            color: $white;\n        }\n        .icon{\n            font-size: 2rem;\n        }\n    }\n}",".nk-slider{\n    position: relative;\n    &-s1{\n        width: 290px;\n        max-width: 100%;\n        .slick-dots{\n            position: absolute;\n            right: 1.25rem;\n            top: 1.5rem;\n            padding-top: 0;\n        }\n    }\n    &-s2{\n        .slider-arrows{\n            > div{\n                padding: .5rem 0;\n            }\n        }\n    }\n}",".project{\n    &-head{\n        display: flex;\n        justify-content: space-between;\n        margin-bottom: 1.25rem;\n        align-items: flex-start;\n    }\n    &-title{\n        display: flex;\n        align-items: center;\n        margin-right: 0.75rem;\n        .user-avatar{\n            margin-right: 1rem;\n        }\n        .title{\n            font-size: 0.975rem;\n            &:not(:last-child){\n                margin-bottom: 0.125rem;\n            }\n        }\n    }\n    &-details{\n        margin-bottom: 1rem;\n    }\n    &-progress{\n        margin-bottom: 1rem;\n        &-details{\n            display: flex;\n            justify-content: space-between;\n            margin-bottom: 0.5rem;\n        }\n        &-task{\n            display: flex;\n            align-items: center;\n            color: $base-light;\n            .icon{\n                font-size: 1rem;\n                line-height: 1.5rem;\n                margin-right: 0.25rem;\n            }\n        }\n        &-percent{\n            color: $base-text;\n            font-weight: $fw-medium;\n        }\n    }\n    &-meta{\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n    &-users{\n        display: flex;\n        align-items: center;\n    }\n    &-list{\n        &-progress{\n            display: flex;\n            align-items: center;\n            .progress{\n                width: 100px;\n                margin-right: 0.5rem;\n            }\n        }\n    }\n}\n\n@include media-breakpoint-up(xxl){\n    .project{\n        &-list{\n            &-progress{\n                .progress{\n                    width: 140px;\n                    margin-right: 1rem;\n                }\n            }\n        }\n    }\n}",".team{\n    position: relative;\n    &-info{\n        padding: 1rem 0 1.25rem;\n        li{\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            font-size: .9375rem;\n            line-height: 1.75rem;\n            span {\n                &:first-child{\n                    color: $base-light;\n                }\n                &:last-child{\n                    color: $base-text;\n                }\n            }\n        }\n    }\n    &-status{\n        position: absolute;\n        left: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        height: 20px;\n        width: 20px;\n        border-radius: 50%;\n    }\n    &-options{\n        position: absolute;\n        top: -.25rem;\n        right: -.25rem;\n    }\n    &-details{\n        padding-top: .5rem;\n        text-align: center;\n        max-width: 200px;\n        margin: 0 auto;\n    }\n    &-statistics{\n        display: flex;\n        justify-content: space-around;\n        text-align: center;\n        padding: 1rem 0 1.5rem;\n        li{\n            span {\n                display: block;\n                &:first-child{\n                    font-size: 1.125rem;\n                    color: $base-dark;\n                }\n                &:last-child{\n                    font-size: .875rem;\n                    color: $base-light;\n                }\n            }\n        }\n    }\n    &-view{\n        display: flex;\n        justify-content: center;\n        padding-bottom: 0.25rem;\n    }\n}","/// Global Auths\n/////////////////////////////\n\n.nk-auth{\n    &-body{\n        padding: 1.25rem;\n    }\n    &-footer{\n        padding-bottom: 40px;\n    }\n    &-body,&-footer{\n        width: 100%;\n        max-width: 420px;\n        margin-left: auto;\n        margin-right: auto;\n    }\n    &-footer{\n        padding-left: 1.25rem;\n        padding-right: 1.25rem;\n    }\n    &-footer-full{\n        margin-top: 0;\n    }\n}\n\n@include media-breakpoint-up(lg){\n    .nk-auth{\n        &-container{\n            width: 45%;\n        }\n    }\n}\n@include media-breakpoint-up(xxl){\n    .nk-auth{\n        &-body,&-footer{\n            .nk-split & {\n                margin-right: 90px;\n            }\n        }\n    }\n}","/// Global Error Pages\n/////////////////////////////\n.nk-error{\n    &-ld {\n        padding: 2rem 1rem;\n    }\n    &-gfx{\n        padding-bottom: 30px;\n        max-width: 90%;\n    }\n    &-head{\n        font-size: 160px;\n        font-weight: $fw-bold;\n        background: -webkit-linear-gradient($accent-color, $accent-dark);\n        -webkit-background-clip: text;\n        -webkit-text-fill-color: transparent;\n        opacity: .9;\n    }\n    &-title{\n        padding-bottom: 1rem;\n    }\n    &-text{\n        font-size: 1rem;\n    }\n}\n\n@include media-breakpoint-up(sm){\n    .nk-error{\n        &-lead{\n            font-size: 200px;\n        }\n        &-gfx{\n            padding-bottom: 60px;\n            max-width: 520px;\n        }\n    }\n}","/// Misc\n//////////////////////////\n\n.clipboard-success-message{\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: $success;\n    background: rgba($white,.9);\n    border-radius: $border-radius;\n    opacity: 0;\n    pointer-events: none;\n    transition: opacity .3s;\n    .clipboard-success &{\n        opacity: 1;\n    }\n}","// Shadow on card \n.has-shadow {\n    &.bg-lighter {\n        .card, .sp-pdl-item, .invoice-wrap, .accordion {\n            box-shadow: 0 0 8px -3px rgba($shadow-color-light, 0.15);\n        }\n    }\n    .card, .sp-pdl-item, .invoice-wrap, .accordion {\n        box-shadow: 0 0 6px -2px rgba($shadow-color-light, 0.2);\n    }\n    .data-head, .data-item {\n        padding-left: 1.5rem;\n        padding-right: 1.5rem;\n    }\n    .card .data-head:not(.is-plain) {\n        margin-left: 0.75rem;\n        margin-right: 0.75rem;\n        padding-left: 0.75rem;\n    }\n    .nav-tabs {\n        box-shadow: 0 2px 0 -1px rgba($shadow-color-light, 0.06);\n    }\n    .nk-header {\n        box-shadow: 0 3px 0 -1px rgba($shadow-color-light, 0.04);\n    }\n}\n\n.nio-version {\n    text-transform: uppercase;\n    font-size: 9px;\n    font-weight: 700;\n    letter-spacing: 0.02em;\n    position: absolute;\n    right: -1px;\n    bottom: -3px;\n}\n\n.code {\n    &-tag {\n        color: $purple;\n    }\n    &-class {\n        color: $pink;\n    }\n    &-fnc {\n        color: $cyan;\n    }\n}\n\n.nk-switch-icon{\n    color: lighten($base-light, 5%);\n    height: 1.5rem;\n    width: 1.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    .icon{\n        font-size: 1.5rem;\n    }\n    .icon-sm{\n        font-size: 1.25rem;\n    }\n    &:hover{\n        color: $base-text;\n    }\n    &.active{\n        color: $accent-color;\n    }\n}\n\n//Dark mode switch\n.dark-switch{\n    position: relative;\n    &:before,&:after{\n        position: absolute;\n        content: \"\";\n        transform: translateY(-50%);\n        border-radius: 1.5rem;\n        display: block;\n        top: 50%;\n    }\n    &:before{\n        right: 0;\n        width: 3rem;\n        height: 1.5rem;\n        background-color: $custom-control-indicator-bg;\n        border: $custom-control-indicator-border-color solid $custom-control-indicator-border-width;\n    }\n    &:after{\n        height: 1rem;\n        width: 1rem;\n        right: calc(2rem - #{$custom-control-indicator-border-width} - .125rem);\n        background-color: $custom-control-indicator-border-color;\n    }\n    &.active{\n        &:before{\n            background-color: $accent-color;\n            border-color: $accent-color;\n        }\n        &:after{\n            right: calc(#{$custom-control-indicator-border-width} + .125rem);\n            background-color: $white;\n        }\n    }\n}\n\n.is-scrollable {\n    overflow: auto;\n}\n@if($rtl==true){\n    .ni {\n        &[class*=\"left\"],&[class*=\"right\"], &[class*=\"back-ios\"], &[class*=\"forward-ios\"] {\n        transform: scale(-1);\n            .btn > span + & {\n                padding-left: 0;\n                padding-right: 8px;\n            }\n        }\n    }\n}","/// PROFILE USER DATA\n//////////////////////////\n.profile-ud {\n    &-label{\n        display: block;\n        color: $base-light;\n        .plain & {\n            font-size: $fx-sz-12;\n            font-weight: $fw-medium;\n            text-transform: uppercase;\n            letter-spacing: 0.1em;\n        }\n        .wider & {\n            display: inline-flex;\n            letter-spacing: -0.01em;\n            width: 120px;\n            flex-shrink: 0;\n        }\n    }\n    &-value {\n        color: $base-text;\n        .wider & {\n            text-align: right;\n            font-weight: $fw-medium;\n            width: 100%;\n        }\n    }\n    &.wider {\n        display: flex;\n        padding: .5rem 0;\n    }\n    &.plain {\n        .profile-ud-item:nth-child(n+2) & {\n            margin-top: 1.25rem;\n        }\n    }\n}\n@include media-breakpoint-up(md){\n    .profile-ud {\n        &.wider {\n            padding: .75rem 0;\n        }\n        &-list {\n            display: flex;\n            flex-wrap: wrap;\n            margin: -0.25rem -3.25rem;\n            max-width: 960px;\n        }\n        &-item {\n            width: 50%;\n            padding:0 3.25rem;\n            &:nth-child(2) {\n                .profile-ud.plain {\n                    margin-top: 0;\n                }\n            }\n        }\n    }\n}\n\n/// PROFILE STATS\n//////////////////////////\n.profile-stats{\n    .amount{\n        font-size: 1.125rem;\n        font-weight: $fw-bold;\n    }\n}\n\n\n/// PROFILE BALANCE\n//////////////////////////\n.profile-balance{\n    &-group{\n        display: flex;\n        align-items: flex-end;\n    }\n    &-ck{\n        position: relative;\n        height: 70px;\n        margin-top: .5rem;\n    }\n    &-sub{\n        font-size: .875rem;\n        color: $base-light;\n        &title{\n            font-size: 0.75rem;\n            margin-top: 0.5rem;\n        }\n        .icon{\n            font-size: .75rem;\n        }\n    }\n    &-plus{\n        position: absolute;\n        .icon{\n            font-size: 1rem;\n            line-height: 1.5rem;\n        }\n        ~ *{\n            padding-left: 24px;\n        }\n    }\n    &-amount{\n        .number{\n            font-size: 1.25rem;\n            font-weight: $fw-bold;\n            color: $base-color;\n            line-height: 1.5rem;\n            white-space: nowrap;\n            small{\n                font-weight: $fw-normal;\n            }\n        }\n    }\n}\n",".steps{\n    ul{\n        display: flex;\n        li{\n            flex-grow: 1;\n        }\n    }\n    .current-info{\n        display: none;\n    }\n}\n\n.actions{\n    ul{\n        display: flex;\n        margin: -10px;\n        padding-top: 20px;\n        li{\n            &:first-child{\n                order: 1;\n            }\n            padding:10px;\n            a{\n                display: inline-block;\n                position: relative;\n                color: #fff;\n                font-weight: 500;\n                transition: all .4s ease;\n                border-color: $accent-color;\n                background: $accent-color;\n                @include button-size($btn-padding-y, $btn-padding-x, $btn-font-size, $btn-line-height, $btn-border-radius);\n            }\n            &.disabled{\n                display: none;\n            }\n        }\n    }\n}\n\n.nk-wizard{\n    &-head{\n        display: none;\n    }\n    &-simple{\n        .steps{\n            margin-bottom: 20px;\n            ul{\n                li{\n                    position: relative;\n                    padding-bottom: 5px;\n                    padding-right: 1rem;\n                    margin-bottom: 0.5rem;\n                    h5{\n                        border: none;\n                        padding:0 0 6px 0;\n                        letter-spacing: 0.02em;\n                        font-size: 13px;\n                        text-transform: uppercase;\n                        font-weight: 500;\n                        color: $base-light;\n                    }\n                    .number{\n                        font-size: 13px;\n                        color: $base-light;\n                        font-weight: 700;\n                    }\n                    &:after{\n                        position: absolute;\n                        height: 1px;\n                        width: 100%;\n                        @if($rtl==false){\n                            left: 0;\n                        }\n                        @if($rtl==true){\n                            right: 0;\n                        }\n                        bottom: 0;\n                        content: '';\n                        transition: all .4s;\n                        background: $border-light;\n                    }\n                    &.done,&.current{\n                        &:after{\n                            height: 2px;\n                            background: $accent-color;\n                            width: 100%;\n                        }\n                        h5,.number{\n                            color: $accent-color;\n                        }\n                    }\n                    &.current ~ .done{\n                        &:after{\n                            height: 1px;\n                            background: $border-light;\n                        }\n                        h5,.number{\n                            color: $base-light;\n                        }\n                    }\n                }\n            }\n            .current-info{\n                display: none;\n            }\n        }\n    }\n    &.is-vertical{\n        .steps{\n            ul{\n                flex-wrap: wrap;\n                li{\n                    h5{\n                        text-transform: none;\n                    }\n                }\n            }\n        }\n    }\n}\n\n@include media-breakpoint-up(md){\n    .nk-wizard{\n        &.is-vertical{\n            display: flex;\n            flex-wrap: wrap;\n            .steps{\n                width: 33%;\n                padding-right: 2rem;\n                ul li{\n                    width: 100%;\n                    &:not(:last-child){\n                        margin-bottom: 1rem;\n                    }\n                }\n            }\n            .content{\n                width: 66%;\n            }\n        }\n    }\n}\n","///////////////////////////////////\n/// Special Table | .tb-tnx\n///////////////////////////////////\n.tb-tnx {\n    &-head {\n        font-size: $fx-sz-11;\n        font-weight: $fw-bold;\n        text-transform: uppercase;\n        letter-spacing: 0.12em;\n        background: $lighter;\n        td, th {\n            color: $base-light;\n            padding: 0.625rem .25rem;\n        }\n        th {\n            border-radius:0;\n            &:first-child {\n                border-top-left-radius: 4px;\n            }\n            &:last-child {\n                border-top-right-radius: 4px;\n            }\n        }\n    }\n    &-item {\n        font-size: $fx-sz-14;\n        td{\n            padding: 1.25rem .25rem;\n            vertical-align: middle;\n            .is-compact & {\n                padding-top: .4rem;\n                padding-bottom: .4rem;\n            }\n        }\n    }\n    &-id {\n        a {\n            display: block;\n        }\n        span {\n            font-weight: $fw-medium;\n        }\n    }\n    &-total {\n        .tb-tnx-item & {\n            font-weight: $fw-medium;\n            color: $body-color;\n        }\n    }\n    &-desc {\n        padding-right: .5rem;\n        .tb-tnx-item & {\n            @extend .ellipsis;\n        }\n    }\n    &-date {\n        .tb-tnx-item & {\n            color: $base-light;\n            .date {\n                font-size: $fx-sz-13;\n            }\n        }\n    }\n    &-action{\n        width: 60px;\n        text-align: right;\n        .dropdown {\n            margin-top: -0.25rem;\n            margin-bottom: -0.25rem;\n        }\n    }\n    &-btns {\n    \t.btn + .btn {\n            margin-left: .5rem;\n    \t}\n    \t& + .dropdown {\n            margin-left: 1rem;\n    \t}\n    }\n}\n@media (max-width: 767px){\n    .tb-tnx{\n        &-item, &-head {\n            display: flex;\n            width: 100%;\n            th {\n                flex-grow: 1;\n                padding-top: .5rem;\n                padding-bottom: .5rem;\n            }\n            td{\n                flex-grow: 1;\n                border: none;\n                padding-top: 0;\n                padding-bottom: 0;\n            }\n        }\n\n        &-item {\n            flex-wrap: wrap;\n            padding-top: 1rem;\n            padding-bottom: 1rem;\n            &:not(:last-child){\n                border-bottom: 1px solid $border-light;\n            }\n        }\n        &-amount{\n            width: 110px;\n            text-align: right;\n        }\n        &-id, &-head th:first-child {\n            min-width: 85px;\n            padding-right: .25rem !important;\n            flex-grow: 0 !important;\n        }\n        &-info{\n            width: 45%;\n        }\n        &-date {\n            .date {\n                font-size: $fx-sz-12;\n                & + .date {\n                    padding-left: .5rem;\n                }\n            }\n        }\n\n        &-action{\n            &:last-child{\n                flex-grow: 0;\n                padding-left: .5rem;\n                display: inline-flex;\n                align-items: center;\n            }\n        }\n    }\n}\n\n@media (max-width: 575px){\n    .tb-tnx {\n        &-item {\n            font-size: $fx-sz-13;\n        }\n        &-id {\n            width: 100%;\n            + td {\n                padding-left: 1.25rem;\n            }\n        }\n        &-info{\n            width: 65%;\n        }\n        &-amount{\n            &:last-child {\n                width: 25%;\n            }\n            &:not(:last-child) {\n                display: none;\n            }\n            &.is-alt{\n                position: absolute;\n                display: inline-flex;\n                right: 1.25rem;\n                width: auto;\n                .tb-tnx-total {\n                    order: 5;\n                    padding-left: 1.25rem;\n                }\n            }\n        }\n    }\n}\n\n@media (min-width: 768px){\n    .tb-tnx {\n        &-desc, &-date, &-total, &-status {\n            display: inline-block;\n            vertical-align: middle;\n\n        }\n        &-desc, &-date {\n            width: calc(50% - 4px);\n        }\n        &-total {\n            width: calc(60% - 4px);\n        }\n        &-status{\n            width: calc(40% - 4px);\n        }\n        &-amount {\n            width: 25%;\n        }\n        &-date {\n            .date, > span > span {\n                width: calc(50% - 4px);\n                display: inline-block;\n            }\n            .date + .date, > span > span + span {\n                padding-left: 0.75rem;\n            }\n        }\n    }\n}\n","///////////////////////////////////\n/// Special Table | .tb-odr\n///////////////////////////////////\n.tb-odr {\n    &-item {\n        font-size: $fx-sz-14;\n        td {\n            padding: 1rem .25rem;\n            vertical-align: middle;\n        }\n    }\n    &-id, &-total {\n        display: block;\n        .tb-odr-item & {\n            font-weight: $fw-medium;\n        }\n    }\n    &-id {\n        a {\n            display: block;\n        }\n        span {\n            font-weight: $fw-medium;\n        }\n    }\n    &-total {\n        .tb-odr-item & {\n            color: $base-color;\n            .tb-odr-head & {\n        \t\tcolor: inherit;\n        \t}\n        }\n    }\n    &-date {\n        .tb-odr-item & {\n            color: $base-light;\n            .tb-odr-head & {\n        \t\tcolor: inherit;\n        \t}\n        }\n    }\n    &-info {\n        .tb-odr-item & {\n            @extend .ellipsis;\n        }\n    }\n    &-action {\n    \t> div, > .btn {\n    \t\tvertical-align: middle;\n    \t}\n        &:last-child {\n            padding-left: 1.25rem;\n            text-align: right;\n        }\n    }\n    &-btns {\n    \t.btn + .btn {\n            margin-left: .5rem;\n    \t}\n    }\n    &-id {\n        min-width: 90px;\n    }\n    &-head {\n        background: $lighter;\n        th {\n        \tfont-size: $fx-sz-12;\n\t        font-weight: $fw-bold;\n\t        text-transform: uppercase;\n\t        letter-spacing: 0.12em;\n            color: $base-light;\n            padding: 0.625rem .25rem;\n        }\n    }\n}\n\n@media (max-width: 767px){\n    .tb-odr {\n        &-item {\n            display: flex;\n            th, td {\n                flex-grow: 1;\n            }\n        }\n        &-amount {\n            text-align: right;\n        }\n    } \n}\n@media (max-width: 575px){\n    .tb-odr {\n        &-item {\n            font-size: $fx-sz-13;\n        }\n        &-amount {\n            width: 24%;\n        }\n        &-info {\n            width: 44%;\n        }\n        &-action {\n            width: 2rem;\n            min-width: auto;\n            .tb-odr-item & {\n                padding-left: .5rem;\n            }\n        }\n    }\n}\n@media (min-width: 768px) {\n    .tb-odr {\n        &-info {\n            min-width: 55%;\n        }\n        &-amount {\n            width: 30%;\n        } \n        &-total {\n            min-width: 100px;\n        }\n        &-id, &-total {\n            display: inline-block;\n            + span {\n                padding-left: 1rem;\n            }\n        }\n        &-btns {\n\t    \t& + .dropdown, & + .btn {\n                margin-left: .75rem;\n\t    \t}\n\t    }\n    }\n}\n@media (min-width: 992px) {\n    .tb-odr {\n        &-id {\n            min-width: 120px;\n        }\n        &-total {\n            min-width: 50%;\n        }\n    }\n}\n","///////////////////////////////////\n/// Table Compact - minimal\n///////////////////////////////////\n.is-compact {\n    .tb-tnx, .tb-odr {\n        &-item td {\n            padding-top: .4rem;\n            padding-bottom: .4rem;\n        }\n    }\n}\n@media (max-width: 767px){\n    .is-compact {\n        .tb-tnx, .tb-odr {\n            &-item {\n                padding-top: .5rem;\n                padding-bottom: .5rem;\n                td {\n                    padding-top: 0;\n                    padding-bottom: 0;\n                }\n            }\n        }\n    }\n}","//////////////////////////////////\n//  IV WG 5\n//////////////////////////////////\n.nk-iv-wg5{\n\tdisplay: inline-flex;\n\tflex-direction: column;\n\tmargin-left: auto;\n\tmargin-right: auto;\n\t&-head{\n\t\tmargin-bottom: 1rem;\n\t}\n\t&-title{\n\t\tmargin-bottom: .25rem;\n\t}\n\t&-subtitle{\n\t\tcolor: $base-light;\n\t}\n\t&-ck{\n\t\tmargin-top: auto;\n\t\tposition: relative;\n\t\tdisplay: inline-block;\n\t\t&-result{\n\t\t\tposition: absolute;\n\t\t\ttop: 55%;\n\t\t\tleft: 50%;\n\t\t\ttransform: translate(-50%, -50%);\n\t\t\ttext-align: center;\n\t\t\t.text-lead{\n\t\t\t\tfont-size: 40px;\n\t\t\t\tfont-weight: 300;\n\t\t\t\tcolor: $base-color;\n\t\t\t\tline-height: 1.3;\n\t\t\t\t&.sm{\n\t\t\t\t\tfont-size: 30px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.text-sub{\n\t\t\t\tfont-size: 12px;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tcolor: $base-light;\n\t\t\t}\n\t\t}\n\t\t&-minmax{\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\tcolor: $base-light;\n\t\t\tfont-size: 12px;\n\t\t}\n\t}\n}\n\n@include media-breakpoint-up(xl){\n\t.nk-iv-wg5{\n\t\t&-ck{\n\t\t\tcanvas{\n\t\t\t\twidth: 300px !important;\n\t\t\t\theight: 150px !important;\n\t\t\t}\n\t\t\t&.sm{\n\t\t\t\tcanvas{\n\t\t\t\t\twidth: 240px !important;\n\t\t\t\t\theight: 120px !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}","/// TABLE\n/////////////////////////////////////\n.nk-tb{\n    &-list{\n        display: table;\n        width: 100%;\n        font-size: $fx-sz-13;\n        color: $base-light;\n        &.is-alt {\n            color: $base-text;\n        }\n        .list-status, .tb-status {\n            font-size: $fx-sz-12;\n            font-weight: $fw-medium;\n        }\n        .tb-lead, .tb-amount {\n            font-weight: $fw-medium;\n            color: $base-color;\n            display: block;\n            line-height: 1.4;\n            &-sub {\n                color: $base-text;\n                display: block;\n                line-height: 1.4;\n            }\n        }\n        .tb-sub, .tb-amount-sm {\n            font-size: .9em;\n        }\n        .tb-amount {\n            span, .currency {\n                color: $base-text;\n                font-weight: $fw-normal;\n            }\n        }\n        .user-info .tb-lead + span, .tb-lead + .tb-date {\n            font-size: $fx-sz-11;\n        }\n        .tb-country{\n            display: flex;\n            align-items: center;\n            .name{\n                color: $base-color;\n            }\n            .flag{\n                height: 16px;\n                border-radius: $border-radius-sm;\n                + .name{\n                    margin-left: 0.6875rem;\n                }\n            }\n        }\n        .tb-product{\n            display: flex;\n            align-items: center;\n            .thumb{\n                width: 48px;\n                border-radius: $border-radius;\n                margin-right: 1rem;\n            }\n            .title{\n                font-weight: $fw-bold;\n                font-size: .875rem;\n                color: $base-color;\n            }\n        }\n        .tb-asterisk{\n            font-size: 1.125rem;\n            line-height: 1;\n            vertical-align: middle;\n            a{\n                color:$accent-color;\n            }\n        }\n    }\n    &-item{\n        transition: background-color .3s, box-shadow .3s;\n        display: table-row;\n        &:not(.nk-tb-head):hover, &:not(.nk-tb-head).seleted {\n            background: lighten($lighter, 1%);\n            box-shadow: 0 2px 15px -4px rgba($accent-color, 0.4);\n        }\n    }\n    &-col{\n        position: relative;\n        display: table-cell;\n        vertical-align: middle;\n        padding: 1rem .5rem;\n        &:first-child{\n            padding-left: 1.25rem;\n        }\n        &:last-child{\n            padding-right: 1.25rem;\n        }\n        &-tools{\n            max-width: 1.25rem + .5rem + 2rem;\n        }\n        &-check{\n            width: 3rem;\n            .custom-control{\n                vertical-align: middle;\n            }\n        }\n        .nk-tb-item:not(:last-child) &{\n            border-bottom: 1px solid rgba($border-color, .9);\n        }\n        .nk-tb-head &{\n            padding-top: 0.5rem;\n            padding-bottom: 0.5rem;\n            color: $base-light;\n            font-size: .9em;\n            border-bottom: 1px solid rgba($border-color, .9);\n        }\n        &-action {\n            text-align: right;\n            > .dropdown:last-child {\n                right: -.5rem;\n            }\n        }\n        &-nosort{\n            &:before,&:after{\n                display: none !important;\n            }\n        }\n    }\n    &-actions{\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        position: relative;\n        .nk-tb-ulist &, .nk-tb-actions-adj &{\n            right: -0.5rem;\n        }\n        &.visible1{\n            width: 1rem;\n        }\n    }\n    &-action{\n        &-hidden{\n            opacity: 0;\n            transition: .3s ease;\n            .nk-tb-item:hover &{\n                opacity: 1;\n                background: lighten($lighter, 1%);\n            }\n        }\n    }\n    &-list{\n        .nk-tb-head {\n            .btn-trigger .icon{\n                font-size: 1.5em;\n            }\n        }\n        &.is-separate{\n            margin-top: -8px;\n            border-collapse:separate;\n            border-spacing: 0 8px;\n            .nk-tb-item{\n                > .nk-tb-col{\n                    background: $white;\n                    border: none;\n                    box-shadow: 0px 1px 3px 0px rgba($base-color, 0.05);\n                    &:first-child{\n                        border-radius: 4px 0 0 4px;\n                    }\n                    &:last-child{\n                        border-radius: 0 4px 4px 0;\n                    }\n                }\n                &:hover .nk-tb-action-hidden{\n                    background: $white;\n                }\n            }\n            .nk-tb-head .nk-tb-col{\n                padding-top: 0.75rem;\n                padding-bottom: 0.75rem;\n            }\n        }\n    }\n}\n\n@include media-breakpoint-up(sm){\n    .nk-tb{\n        &-col{\n            &-check{\n                width: 3.25rem;\n            }\n            .nk-tb-item &{\n                &:first-child{\n                    padding-left: 1.5rem;\n                }\n                &:last-child{\n                    padding-right: 1.5rem;\n                }\n            }\n        }\n    }\n}\n@include media-breakpoint-up(xxl){\n    .nk-tb{\n        &-list{\n            font-size: $fx-sz-14;\n            .list-status, .tb-status {\n                font-size: $fx-sz-13;\n            }\n            .user-info .tb-lead + span, .tb-lead + .tb-date {\n                font-size: $fx-sz-12;\n            }\n        }\n    }\n}\n\n///////////////////////////////////\n/// Table Loose - Loose\n///////////////////////////////////\n.is-loose{\n    .nk-tb-item:not(.nk-tb-head){\n        .nk-tb {\n            &-col {\n                padding-top: 1.125rem;\n                padding-bottom: 1.125rem;\n            }\n        }\n    }\n}\n\n///////////////////////////////////\n/// Table Loose - Medium\n///////////////////////////////////\n.is-medium{\n    .nk-tb-item:not(.nk-tb-head){\n        .nk-tb {\n            &-col {\n                padding-top: .75rem;\n                padding-bottom: .75rem;\n            }\n        }\n    }\n}\n\n///////////////////////////////////\n/// Table Compact - minimal\n///////////////////////////////////\n.is-compact{\n    .nk-tb-item:not(.nk-tb-head){\n        .nk-tb {\n            &-col {\n                padding-top: .5rem;\n                padding-bottom: .5rem;\n            }\n        }\n    }\n}\n",".timeline{\n    color: $base-light;\n    line-height: 1.3;\n    + .timeline, &-list + .timeline-head {\n        margin-top: 1.75rem;\n    }\n    &-head{\n        font-size: $fx-sz-14;\n        color: $base-light;\n        margin-bottom: 1rem;\n    }\n    &-item{\n        position: relative;\n        display: flex;\n        align-items: flex-start;\n        &:not(:last-child){\n            padding-bottom: 1.5rem;\n            &:before{\n                position: absolute;\n                height: calc(100% - 11px);\n                width: 1px;\n                background: $border-color;\n                content: '';\n                top: 13px;\n                left: 5px;\n            }\n        }\n    }\n    &-status{\n        position: relative;\n        height: 11px;\n        width: 11px;\n        border-radius: 50%;\n        flex-shrink: 0;\n        margin-top: 2px;\n        &.is-outline{\n            &:after{\n                position: absolute;\n                height: 7px;\n                width: 7px;\n                border-radius: 50%;\n                background: $white;\n                content: '';\n                top: 2px;\n                left: 2px;\n            }\n        }\n    }\n    &-date{\n        position: relative;\n        color: $base-light;\n        width: 90px;\n        @if($rtl==false){\n            margin-left: .75rem;\n        }\n        @if($rtl==true){\n            margin-right: .75rem;\n        }\n        flex-shrink: 0;\n        line-height: 1rem;\n        .icon{\n            @if($rtl==false){\n                right: 0;\n                margin-right: 0.25rem;\n            }\n            @if($rtl==true){\n                left: 0;\n                margin-left: 0.25rem;\n            }\n            vertical-align: middle;\n            color: $base-light;\n            display: inline-block;\n            position: absolute;\n            top: 2px;\n        }\n    }\n    &-data{\n        @if($rtl==false){\n            padding-left: 8px;\n        }\n        @if($rtl==true){\n            padding-right: 8px;\n        }\n    }\n    &-title{\n        font-size: $fx-sz-15;\n        color: $base-color;\n        margin-bottom: .75rem;\n    }\n    &-des{\n        color: $base-light;\n        p{\n            margin-bottom: .25rem;\n        }\n    }\n    .time{\n        display: block;\n        font-size: $fx-sz-12;\n        color: $base-light;\n    }\n}\n@include media-breakpoint-up(sm){\n    .timeline + .timeline, .timeline-list + .timeline-head{\n        margin-top: 2.5rem;\n    }\n}\n@media (max-width:413px){\n    .timeline{\n        &-item{\n            flex-wrap: wrap;\n        }\n        &-date{\n            width: 80px;\n        }\n        &-data{\n            @if($rtl==false){\n                padding: .75rem 0 0 24px;\n            }\n            @if($rtl==true){\n                padding: .75rem 24px 0 0;\n            }\n        }\n    }\n}","$invoice-wrap-xy: 1.25rem !default;\n$invoice-wrap-xy-desk: 3rem !default;\n$invoice-margin-bottom: 1.5rem !default;\n\n/// Invoice\n/////////////////////// \n.invoice {\n    position: relative;\n    &-wrap {\n        padding: $invoice-wrap-xy;\n        border-radius: $border-radius;\n        background: $white\n    }\n    &-action {\n        position: absolute;\n\t\tright: 1.25rem;\n        top: 1.25rem;\n    }\n    &-brand {\n        padding-bottom: $invoice-margin-bottom;\n        img {\n            max-height: 60px;\n        }\n    }\n    // Billing Table\n\t&-bills {\n\t\tfont-size: $fx-sz-12;\n\t\t.table {\n\t\t\tmin-width: 580px;\n\t\t\tth {\n\t\t\t\tcolor: $accent-color;\n\t\t\t\tfont-size: $fx-sz-12;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\tborder-top: 0;\n\t\t\t}\n\t\t\tth, td {\n\t\t\t\t&:last-child {\n\t\t\t\t\ttext-align: right;\n\t\t\t\t}\n\t\t\t}\n\t\t\ttfoot {\n\t\t\t\tborder-top: 1px solid $border-color;\n\t\t\t\ttd {\n\t\t\t\t\tborder-top: 0;\n\t\t\t\t    white-space: nowrap;\n\t\t\t\t    padding-top: .25rem;\n\t\t\t\t    padding-bottom: .25rem;\n\t\t\t\t}\n\t\t\t\ttr:last-child td:not(:first-child), tr:first-child td:not(:first-child) {\n\t\t\t\t\tfont-weight: $fw-medium;\n\t\t\t\t\tpadding-top: 1.25rem;\n\t\t\t\t    padding-bottom: .25rem;\n\t\t\t\t}\n\t\t\t\ttr:last-child td:not(:first-child) {\n\t\t\t\t\tborder-top: 1px solid $border-color;\n\t\t\t\t\tpadding-top: .25rem;\n\t\t\t\t    padding-bottom: .25rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t\n\t// Billing Info\n\t&-head {\n        padding-bottom: $invoice-margin-bottom;\n        display: flex;\n        justify-content: space-between;\n        flex-direction: column;\n    }\n    &-desc {\n    \twidth: 210px;\n    \tpadding-top: $invoice-margin-bottom;\n        .title {\n            text-transform: uppercase;\n            color: $accent-color;\n        }\n        ul {\n            li{\n                padding: .25rem 0;\n            }\n            span{\n            \tfont-size: $fx-sz-13;\n                font-weight: $fw-medium;\n                color: $base-text;\n                &:first-child{\n                    min-width: 90px;\n                    display: inline-block;\n                    text-transform: uppercase;\n                    letter-spacing: 1px;\n                    color: $base-light;\n                }\n                &:last-child {\n\t\t\t\t\tpadding-left: 0.75rem;\n                }\n            }\n        }\n    }\n    &-contact {\n    \t.title {\n    \t\tmargin-bottom: 1rem;\n    \t}\n    \tul {\n    \t\tli {\n                padding:.5rem 0;\n                &:first-child {\n                    padding-top: 0;\n                }\n                &:last-child {\n                    padding-bottom: 0;\n                }\n                line-height: 1.3;\n    \t\t}\n\n    \t\t.icon {\n    \t\t\tline-height: 1.3;\n    \t\t\tfont-size: 1.1em;\n\t\t\t    display: inline-block;\n\t\t\t    vertical-align: top;\n\t\t\t    margin-top: -2px;\n\t\t\t    color: $accent-color;\n\t\t\t\tmargin-right: .5rem;\n\t\t\t    + span {\n\t\t    \t    display: inline-block;\n\t\t\t\t\tvertical-align: top;\n\t\t\t\t\tcolor: $base-light;\n\t\t\t    }\n    \t\t}\n    \t}\n    }\n\n    &-print {\n        max-width: 940px;\n        margin:2rem auto;   \n        .invoice-wrap {\n            padding: 0;\n            border: none !important;\n        }\n    }\n}\n\n@include media-breakpoint-up(md) {\n\t.invoice {\n\t    &-wrap {\n\t        padding: $invoice-wrap-xy-desk;\n\t    }\n\t    &-head {\n\t    \tflex-direction: row;\n\t    }\n\t    &-desc {\n\t    \tpadding-top: 0;\n\t    }\n\t    &-bills {\n\t    \tfont-size: $fs-base;\n\t    }\n\t}\n}\n","// pricing tables\n.pricing{\n    position: relative;\n    height: 100%;\n    &-badge{\n        position: absolute;\n        right: .5rem;\n        top: .5rem;\n    }\n    &-head{\n        text-align: center;\n        padding: 1.75rem 1.5rem;\n        border-bottom: 1px solid $border-light;\n    }\n    &-title{\n        .title{\n            margin-bottom: 0.25rem;\n        }\n        &:not(:last-child){\n            padding-bottom: 1.25rem;\n        }\n    }\n    &-body{\n        padding: 1.75rem 1.75rem 2rem;\n    }\n    &-features{\n        li{\n            display: flex;\n            padding: .25rem 0;\n        }\n    }\n    &-action{\n        margin-top: 1.5rem;\n        text-align: center;\n    }\n    &-media {\n\t\tpadding: 0.25rem 0;\n\t\tmargin-bottom: 1.5rem;\n\t\timg {\n\t\t\tmax-width: 90px;\n\t\t}\n\t}\n\t&-amount {\n\t\tfont-size: 0.875rem;\n        color: $base-light;\n        .amount {\n        \tfont-size: 1.5rem;\n\t        font-weight: $fw-bold;\n\t        color: $body-color;\n        }\n\t}\n}",".nk-add-product{\n    top: $header-height;\n    background-color: $white;\n    width: 400px;\n    height: calc(100vh - #{$header-height});\n    padding: 1.5rem;\n    + .toggle-overlay{\n        z-index: 700;\n    }\n}\n\n.rating{\n    display: flex;\n    align-items: center;\n    margin: 0 -.125rem;\n    color: $warning;\n    > * {\n        padding: 0 .125rem;\n    }\n    .icon{\n        font-size: 1rem;\n    }\n}\n\n.product{\n    &-card{\n        overflow: hidden;\n        height: 100%;\n    }\n    &-thumb{\n        position: relative;\n    }\n    &-badges{\n        position: absolute;\n        top: 1rem;\n        left: 1rem;\n        display: flex;\n        flex-wrap: wrap;\n        margin: -0.25rem;\n        > li{\n            padding: 0.25rem;\n        }\n    }\n    &-tags{\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: center;\n        > li{\n            padding: 0.25rem;\n        }\n        a{\n            color: $base-light;\n            &:hover{\n                color: $primary;\n            }\n        }\n        + .product-title{\n            margin-top: 0.5rem;\n        }\n    }\n    &-title{\n        a{\n            color: $base-color;\n        }\n        + .product-price{\n            margin-top: 1rem;\n        }\n    }\n    &-actions{\n        position: absolute;\n        bottom: .25rem;\n        left: 50%;\n        transform: translateX(-50%);\n        border-radius: $border-radius $border-radius 0 0;\n        overflow: hidden;\n        transition: .2s linear;\n        display: flex;\n        opacity: 0;\n        .product-card:hover &{\n            opacity: 1;\n        }\n        li{\n            padding: 0 .125rem;\n            a{\n                display: inline-flex;\n                align-items: center;\n                justify-content: center;\n                color: $base-text;\n                font-size: $btn-font-size*1.2;\n                height: $btn-line-height + $btn-padding-y*2;\n                width: $btn-line-height + $btn-padding-y*2;\n                transition: .3s ease;\n                &:hover{\n                    color:$primary;\n                }\n            }\n        }\n    }\n    &-gallery{\n        position: relative;\n        height: auto;\n        margin: 0 0 30px 0;\n        border-radius: $border-radius;\n        border:1px solid $border-light;\n        .slick-list{\n            padding-left: 0 !important;\n            padding-right: 0 !important;\n        }\n        .slider-nav{\n            position: absolute;\n            bottom: -30px;\n            left: 50%;\n            transform: translateX(-50%);\n            width: 282px;\n            .slider-item{\n                padding:0 8px;\n                .thumb{\n                    width: 78px;\n                    padding: 1px;\n                    border:2px solid $border-light;\n                    box-shadow:inset 1px 1px 0 $white,inset -1px -1px 0 $white,inset 1px -1px 0 $white,inset -1px 1px 0 $white;\n                    border-radius: $border-radius;\n                    transition: all .3s ease;\n                    cursor: pointer;\n                }\n                &.slick-current{\n                    .thumb{\n                        border-color:$accent-color;\n                        cursor: default;\n                    }\n                }\n            }\n        }\n    }\n    &-rating{\n        display: flex;\n        align-items: center;\n        .amount{\n            margin-left: 0.5rem;\n            color: $base-light;\n        }\n    }\n    &-excrept{\n        margin-top: 1.5rem;\n    }\n    &-meta{\n        margin-top: 2rem;\n        + .product-meta{\n            margin-top: 1.25rem;\n        }\n    }\n}\n\n@media (max-width:420px) {\n    .product{\n        &-gallery{\n            .slider-nav{\n                width: 188px;\n            }\n        }\n    }\n}\n\n@include media-breakpoint-up(md) {\n    .product{\n        &-gallery{\n            .slider-nav{\n                width: 384px;\n            }\n        }\n    }\n}\n@include media-breakpoint-up(xxl) {\n\t.product{\n        &-gallery{\n            .slider-nav{\n                width: 470px;\n            }\n        }\n    }\n}","//gallery\n.gallery{\n    &-image{\n        position: relative;\n        z-index: 1;\n    }\n}","// Sales data widgets\n.nk-sale-data{\n\tflex-shrink: 0;\n\t&-group{\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t}\n\t.amount{\n\t\tdisplay: block;\n\t\tfont-size: 1.75rem;\n\t\tcolor: $base-color;\n\t\t.change{\n\t\t\tfont-size: .875rem;\n\t\t}\n\t\t&.sm{\n\t\t\tfont-size: 1.125rem;\n\t\t\tcolor: $base-light;\n\t\t}\n\t}\n\t.sub-title{\n\t\tcolor: $base-light;\n\t\tfont-size: $fx-sz-12;\n\t\t.change{\n\t\t\tmargin-right: 0.5rem;\n\t\t}\n\t}\n}\n\n.nk-sales-ck{\n\theight: 80px;\n\tflex-grow: 1;\n\t&.large{\n\t\theight: 200px;\n\t}\n}\n\n@include media-breakpoint-between(lg,xl){\n\t.nk-sales-ck{\n\t\t&.sales-revenue{\n\t\t\theight: 164px;\n\t\t}\n\t}\n\t\n}\n\n// Action\n.nk-wg-action{\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\t&-content{\n\t\tposition: relative;\n\t\t@if($rtl==false){\n\t\t\tpadding-left: 2rem;\n\t\t\tpadding-right: 1rem;\n\t\t}\n\t\t@if($rtl==true){\n\t\t\tpadding-right: 2rem;\n\t\t\tpadding-left: 1rem;\n\t\t}\n\t\t.icon{\n\t\t\tfont-size: 1.5rem;\n\t\t\t@if($rtl==false){\n\t\t\t\tleft:0;\n\t\t\t}\n\t\t\t@if($rtl==true){\n\t\t\t\tright:0;\n\t\t\t}\n\t\t\tposition: absolute;\n\t\t\tcolor: $base-light;\n\t\t}\n\t\t.title{\n\t\t\tfont-size: $fx-sz-14;\n\t\t\tfont-weight: $fw-medium;\n\t\t\tpadding-bottom: 0.25rem;\n\t\t}\n\t\tp{\n\t\t\tcolor: $base-light;\n\t\t\tfont-size: $fx-sz-13;\n\t\t\tline-height: 1.25rem;\n\t\t\tstrong{\n\t\t\t\tcolor: $accent-color;\n\t\t\t}\n\t\t}\n\t}\n}\n\n// Overview\n.nk-order-ovwg{\n\t&-ck{\n\t\theight: 180px;\n\t}\n    &-data{\n        padding: 0.75rem 1.25rem 1.25rem;\n        border: 2px solid transparent;\n        border-radius: $border-radius;\n        .amount{\n\t\t\tfont-size: 1.5rem;\n\t\t\tfont-weight: $fw-bold;\n\t\t\tsmall{\n\t\t\t\tfont-weight: $fw-normal;\n\t\t\t}\n        }\n        .info{\n\t\t\tfont-size: $fx-sz-12;\n\t\t\tcolor: $base-light;\n\t\t\tmargin-bottom: .25rem;\n\t\t\tstrong{\n\t\t\t\tcolor: $base-color;\n\t\t\t}\n        }\n        .title{\n\t\t\tfont-size: $fx-sz-14;\n\t\t\tline-height: 1.3;\n\t\t\tcolor: $base-light;\n\t\t\tfont-weight: $fw-medium;\n            .icon{\n\t\t\t\tfont-size: 1rem;\n\t\t\t\theight: 28px;\n\t\t\t\twidth: 28px;\n\t\t\t\tborder-radius: 50%;\n\t\t\t\tbackground: $lighter;\n\t\t\t\tdisplay: inline-flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\t@if($rtl==false){\n\t\t\t\t\tmargin-right: 0.5rem;\n\t\t\t\t}\n\t\t\t\t@if($rtl==true){\n\t\t\t\t\tmargin-left: 0.5rem;\n\t\t\t\t}\n            }\n        }\n        &.buy{\n\t\t\tborder-color: mix($success, #fff, 50%);\n\t\t\t.amount,.title .icon{\n\t\t\t\tcolor: $success;\n\t\t\t}\n        }\n        &.sell{\n\t\t\tborder-color: mix($accent-color, #fff, 50%);\n\t\t\t.amount,.title .icon{\n\t\t\t\tcolor: $accent-color;\n\t\t\t}\n        }\n    }\n}\n\n@include media-breakpoint-up(xxl) {\n\t.nk-order-ovwg{\n\t\t&-ck{\n\t\t\theight: 260px;\n\t\t}\n\t}\n}\n\n//Activity Widgets\n.nk-activity{\n\t&-item{\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tpadding: 1.25rem;\n\t\t&:not(:last-child){\n\t\t\tborder-bottom: 1px solid $border-light;\n\t\t}\n\t}\n\t&-data{\n\t\tmargin-left: 1rem;\n\t\t.time{\n\t\t\tdisplay: block;\n\t\t\tfont-size: $fx-sz-12;\n\t\t\tcolor: $base-light;\n\t\t\tline-height: 1.3;\n\t\t}\n\t}\n}\n@include media-breakpoint-up(sm){\n\t.nk-activity{\n\t\t&-item{\n\t\t\tdisplay: flex;\n\t\t\tpadding: 1rem 1.5rem;\n\t\t}\n\t}\n}\n\n//Activity Widgets\n.nk-support{\n\t&-item{\n\t\tdisplay: flex;\n\t\tpadding: 1.25rem;\n\t\t&:not(:last-child){\n\t\t\tborder-bottom: 1px solid $border-light;\n\t\t}\n\t}\n\t&-content{\n\t\tflex-grow: 1;\n\t\tmargin-left: 1rem;\n\t\t.title{\n\t\t\tfont-size: 0.875rem;\n\t\t\tfont-weight: $fw-bold;\n\t\t\tcolor:$base-color;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: center;\n\t\t}\n\t\tp{\n\t\t\tmargin-bottom: 0;\n\t\t\tmargin-top: 0.25rem;\n\t\t}\n\t\t.time{\n\t\t\tdisplay: block;\n\t\t\tfont-size: $fx-sz-12;\n\t\t\tcolor: $base-light;\n\t\t}\n\t}\n}\n@include media-breakpoint-up(sm){\n\t.nk-support{\n\t\t&-item{\n\t\t\tdisplay: flex;\n\t\t\tpadding: 1.25rem 1.5rem;\n\t\t}\n\t}\n}","//Device Status\n.device-status{\n\tdisplay: flex;\n    flex-direction: column;\n    padding-top: 1rem;\n\t&-ck{\n\t\theight: 200px;\n\t\tmargin: auto 0;\n\t}\n\t&-group{\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tpadding-top: 1.75rem;\n        margin: auto;\n        width:280px;\n        max-width: 100%;\n\t}\n\t&-data{\n\t\t> .icon{\n\t\t\tfont-size: 1.5rem;\n\t\t}\n\t\t.title{\n\t\t\tfont-size: 12px;\n\t\t\tcolor: $base-light;\n\t\t\tmargin-bottom: 0.5rem;\n\t\t}\n\t\t.amount{\n\t\t\tfont-size: 1.125rem;\n\t\t\tcolor: $base-color;\n\t\t\tfont-weight: $fw-medium;\n\t\t}\n\t\t.change{\n\t\t\tmargin-left: -.125rem;\n\t\t}\n\t}\n}\n\n\n//Traffic Channel\n.traffic-channel{\n    margin-top: 1rem;\n\t&-ck{\n\t\theight: 44px;\n\t\twidth: 130px;\n\t\tmargin-top: -4px;\n\t\tmargin-bottom: -4px;\n\t}\n\t&-doughnut-ck{\n\t\theight: 160px;\n\t}\n\t&-group{\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n        padding-top: 1.75rem;\n        margin-left: auto !important;\n        margin-right: auto !important;\n        width:320px;\n        max-width: 100%;\n\t}\n\t&-data{\n\t\twidth: 50%;\n\t\t.title{\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tcolor:$base-light;\n\t\t\tfont-size: $fx-sz-12;\n\t\t\t.dot{\n\t\t\t\tmargin-right: 0.5rem;\n\t\t\t}\n\t\t}\n\t\t.amount{\n\t\t\tfont-size: 1.125rem;\n            color:$base-color;\n\t\t\tmargin-left: 1.25rem;\n\t\t\tsmall{\n\t\t\t\tfont-size: $fx-sz-12;\n\t\t\t\tcolor: $base-light;\n\t\t\t}\n\t\t}\n\t}\n}\n\n@include media-breakpoint-down(mb){\n    .traffic-channel{\n        &-ck{\n            width: 100%;\n        }\n        &-table{\n            .nk-tb-item{\n                display: flex;\n                flex-wrap: wrap;\n                border-bottom: 1px solid $border-light;\n                padding: 1.125rem 0;\n            }\n            .nk-tb-col{\n                border-bottom: none !important;\n                padding-top: 0 !important;\n                padding-bottom: 0 !important;\n            }\n            .nk-tb-channel{\n                width: 50%;\n            }\n            .nk-tb-sessions{\n                width: 25%;\n            }\n            .nk-tb-prev-sessions{\n                display: none;\n            }\n            .nk-tb-change{\n                width: 25%;\n            }\n            .nk-tb-trend{\n                width: 100%;\n\t\t\t\tpadding-left: 1.25rem;\n            }\n        }\n    }\n}\n@media (min-width:1540px) and (max-width:1800px){\n    .traffic-channel{\n        &-data{\n            .amount{\n                font-size: 1rem;\n            }\n        }\n    }\n}\n//Analytic Data\n.analytic-data{\n\t&-group{\n        display: flex;\n        flex-wrap: wrap;\n\t}\n\t.title{\n\t\tfont-size: $fx-sz-12;\n\t\tfont-weight: $fw-medium;\n\t\tcolor: $base-light;\n\t\tmargin-bottom: 0.375rem;\n\t\tspan{\n\t\t\tfont-weight: $fw-normal;\n\t\t}\n\t}\n\t.amount{\n\t\tcolor: $base-color;\n\t\tfont-size: 1.5rem;\n\t\tline-height: 1.2;\n\t\tmargin-bottom: 0.25rem;\n\t\t&-sm{\n\t\t\tfont-size: 1.125rem;\n\t\t}\n\t}\n\t.change{\n\t\tfont-size: $fx-sz-13;\n\t\tmargin-left: -0.125rem;\n\t}\n\t.subtitle{\n\t\tfont-size: $fx-sz-12;\n\t\tcolor: $base-light;\n\t}\n}\n\n@media (min-width:1540px) and (max-width:1800px){\n    .analytic-data{\n        .amount{\n            font-size: 1.25rem;\n            line-height: 1.75rem;\n            &-sm{\n                font-size: 1.125rem;\n            }\n        }\n    }\n}\n\n//Analytic Overview\n.analytic-ov{\n\t&-data{\n\t\twidth: 50%;\n\t}\n\t&-ck{\n\t\theight: 175px;\n\t\tmargin-top: 2rem;\n\t}\n}\n\n@media (min-width:480px){\n    .analytic-ov{\n        &-data{\n            width: 25%;\n        }\n    }\n}\n\n//Analytic User\n.analytic-au{\n\t&-data{\n\t\twidth: 33.3333%;\n\t}\n\t&-ck{\n\t\theight: 170px;\n\t\tmargin-top: 2.25rem;\n\t}\n}\n\n//Analytic Performance\n.analytic-wp{\n\t&-data{\n\t\tdisplay: flex;\n        justify-content: space-between;\n        align-items: flex-end;\n\t}\n\t&-ck{\n\t\theight: 36px;\n\t}\n\t&-graph{\n        width: 150px;\n        margin-top: 0.125rem;\n        margin-bottom: 0.125rem;\n\t\t.title{\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t}\n\t&-text{\n\t\ttext-align: right;\n\t\tmargin-left: .5rem;\n\t}\n}\n@media (min-width:420px) and (max-width:767px){\n    .analytic-wp{\n        &-graph{\n            width: 60%;\n        }\n    }\n}\n@media (min-width:1540px) and (max-width:1800px){\n    .analytic-wp{\n        &-graph{\n            width: 120px;\n        }\n    }\n}\n\n\n//chart label\n.chart-label{\n\tfont-size: $fx-sz-12;\n\tcolor:$base-light;\n\t&-group{\n\t\tmargin-top: 0.5rem;\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t}\n}\n\n//analytics Map\n.analytics-map{\n\t.vector-map{\n\t\theight: 160px;\n\t\tmargin: 1rem 0;\n\t}\n\t&-data{\n\t\tfont-size: .875rem;\n\t\ttd{\n\t\t\tpadding: .25rem 0;\n\t\t}\n\t\t.country{\n\t\t\tcolor:$base-light;\n\t\t}\n\t\t.amount{\n\t\t\tcolor:$base-color;\n\t\t\ttext-align: right;\n\t\t}\n\t\t.percent{\n\t\t\ttext-align: right;\n\t\t\tcolor:$base-light;\n\t\t}\n\t\t&-list{\n\t\t\twidth: 100%;\n\t\t\tmargin-bottom: -0.25rem;\n\t\t}\n\t}\n}","\n.nk-ecwg{\n    .amount{\n        font-size: 2rem;\n        font-weight: $fw-medium;\n        color: $base-color;\n        &-sm{\n            font-size: 1.5rem;\n        }\n        &-xs{\n            font-size: .875rem;\n        }\n        @if($dark_option==true) {\n            .is-dark &{\n                color:$white;\n            }\n        }\n    }\n    .info{\n        font-size: .875rem;\n        @if($dark_option==true) {\n            .is-dark &{\n                color:$accent-300;\n            }\n        }\n    }\n    .sub-title{\n        font-size: .875rem;\n        font-weight: $fw-medium;\n        @if($dark_option==true) {\n            .is-dark &{\n                color:$white;\n            }\n        }\n    }\n    .data{\n        margin-top: 0.5rem;\n        &:not(:last-child){\n            margin-bottom: 2rem;\n        }\n        &-group{\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            .data{\n                margin: 0;\n                padding-right: 20px;\n            }\n        }\n    }\n    &1-ck{\n        height: 110px;\n    }\n    &2-ck{\n        height: 182px;\n    }\n    &3-ck{\n        height: 66px;\n    }\n    &4{\n        display: flex;\n        flex-direction: column;\n        &-ck{\n            height: 180px;\n            width: 180px;\n            margin-right: 1.5rem;\n        }\n        &-legends{\n            flex-grow: 1;\n            padding: 1rem 0;\n            li{\n                display: flex;\n                justify-content: space-between;\n                padding: .25rem 0;\n            }\n            .title{\n                display: flex;\n                align-items: center;\n                .dot{\n                    margin-right: 0.5rem;\n                }\n            }\n        }\n    }\n    &5{\n        &-ck{\n            height: 140px;\n        }\n        .data-group{\n            margin-bottom: 30px;\n        }\n    }\n    &6{\n        &-ck{\n            width: 100px;\n            height: 40px;\n            margin-left: 20px;\n        }\n    }\n    &7{\n        &-ck{\n            height: 180px;\n            width: 180px;\n            margin: 0 auto 15px;\n        }\n        &-legends{\n            display: flex;\n            justify-content: center;\n            flex-wrap: wrap;\n            li{\n                padding: 0.25rem 1rem;\n            }\n            .title{\n                display: flex;\n                align-items: center;\n                color: $base-light;\n                .dot{\n                    margin-right: 0.5rem;\n                }\n            }\n        }\n    }\n    &8{\n        &-ck{\n            height: 200px;\n        }\n        &-legends{\n            display: flex;\n            justify-content: center;\n            flex-wrap: wrap;\n            margin-bottom: 1rem;\n            li{\n                padding: 0.25rem 1rem;\n            }\n            .title{\n                display: flex;\n                align-items: center;\n                color: $base-light;\n                .dot{\n                    margin-right: 0.5rem;\n                }\n            }\n        }\n    }\n}\n@media (max-width:490px){\n    .nk-ecwg{\n        &4{\n            .data-group{\n                flex-wrap: wrap;\n            }\n        }\n        &8{\n            &-ck{\n                height: 140px;\n            }\n        }\n    }\n}\n\n@include media-breakpoint-up(xxl){\n    .nk-ecwg{\n        &4{\n            &-ck{\n                height: 210px;\n                width: 210px;\n                margin-right: 2.5rem;\n            }\n        }\n    }\n}\n\n.nk-top-products{\n    .item{\n        display: flex;\n        align-items: center;\n        padding: 0.625rem 0;\n        line-height: 1.2;\n    }\n    .thumb{\n        width: 44px;\n        margin-right: 1rem;\n        img{\n            border-radius: 4px;\n        }\n    }\n    .total{\n        margin-left: auto;\n        text-align: right;\n    }\n    .title,.amount{\n        font-size: 0.9375rem;\n        color: $base-color;\n        margin-bottom: 0.25rem;\n    }\n    .price,.count{\n        font-size: 0.8125rem;\n        color: $base-light;\n        margin-bottom: 1px;\n    }\n}\n\n.nk-store-statistics{\n    .item{\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 0.5rem 0;\n    }\n    .title{\n        font-size: 0.8125rem;\n        color: $base-light;\n    }\n    .count{\n        font-size: 1.25rem;\n        color: $base-color;\n        font-weight: $fw-bold;\n    }\n    .icon{\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 1.5rem;\n        height: 44px;\n        width: 44px;\n        border-radius: 6px;\n    }\n}\n\n.nk-download {\n    display: flex;\n    width: 100%;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    padding: 1.25rem;\n    border-radius: $border-radius;\n    background: $white;\n    .data {\n        display: flex;\n        flex-grow: 1;\n    }\n    .info{\n        margin-top: .35rem;\n    }\n    .title{\n        font-size: 1rem;\n        line-height: 1.2;\n    }\n    .thumb {\n        flex-shrink: 0;\n        width: 3rem;\n        margin-right: 1rem;\n    }\n    .meta {\n        .version, .release {\n            display: block;\n            line-height: 1.2;\n            padding: 0.25rem 0;\n        }\n    }\n    .title{\n        .badge {\n            margin-left: 1rem;\n        }\n    }\n}\n@include media-breakpoint-up(md) {\n    .nk-download {\n        padding: 1.5rem;\n        .thumb {\n            width: 2.5rem;\n            margin-right: 1.5rem;\n        }\n        .data {\n            align-items: center;\n        }\n        .meta {\n            .version, .release {\n                display: inline-block;\n                padding-right: 1.5rem;\n            }\n        }\n    }\n}\n@media (max-width: 575px){\n    .nk-download {\n        .data{\n            width: 100%;\n            padding-left: 4rem;\n        }\n        .thumb{\n            position: absolute;\n            margin-left: -4rem;\n        }\n        .actions{\n            margin: 0.75rem 0 0;\n            padding-left: 4rem;\n        }\n    }\n}\n\n.nk-add-product{\n    top: $header-height;\n    background-color: $white;\n    width: 400px;\n    height: calc(100vh - #{$header-height});\n    padding: 1.5rem;\n    + .toggle-overlay{\n        z-index: 700;\n    }\n}","// @conditiona -s-\n@if($gd_investment==true) {\n.card{\n    &-title{\n        .subtitle{\n            color: $base-light;\n            font-size: $fx-sz-13;\n            font-weight: $fw-medium;\n        }\n    }\n    &-amount{\n        display: flex; \n        align-items: baseline;\n        .change{\n            @if($rtl==false){\n                margin-left: .5rem;\n            }\n            @if($rtl==true){\n                margin-right: .5rem;\n            }\n        }\n        .amount{\n            font-size: 1.5rem;\n            color: $base-color;\n            span {\n                color: $base-text;\n            }\n        }\n    }\n}\n\n@include media-breakpoint-only(md){\n    .card{\n        &-amount{\n            .amount{\n                font-size: 1rem;\n                font-weight: $fw-medium;\n                span {\n                    font-weight: $fw-normal;\n                }\n            }\n            .change{\n                font-size: 12px;\n            }\n        }\n    }\n}\n\n.nav-tabs-card{\n    .card-inner &{\n        margin-left: -1.25rem;\n        margin-right: -1.25rem;\n    }\n}\n\n@include media-breakpoint-up(sm){\n    .nav-tabs-card{\n        .card-inner &{\n            margin-left: -1.5rem;\n            margin-right: -1.5rem;\n        }\n    }    \n}\n.nav-tabs{\n    &-xs{\n        .nav-link{\n            padding:  .75rem 0;\n            font-size: $fx-sz-13;\n            font-weight: $fw-medium;\n        }\n    }\n}\n@include media-breakpoint-up(md){\n    .nav-tabs{\n        &-xs{\n            .nav-item{\n                @if($rtl==false){\n                    padding-right:1.25rem;\n                }\n                @if($rtl==true){\n                    padding-left:1.25rem;\n                }\n            }\n        }\n    }\n}\n@include media-breakpoint-up(lg){\n    .nav-tabs{\n        &-sm{\n            .nav-item{\n                @if($rtl==false){\n                    padding-right:1.25rem;\n                }\n                @if($rtl==true){\n                    padding-left:1.25rem;\n                }\n            }\n        }\n    }\n}\n@include media-breakpoint-up(xl){\n    .nav-tabs{\n        &-sm{\n            .nav-item{\n                @if($rtl==false){\n                    padding-right:1.25rem;\n                }\n                @if($rtl==true){\n                    padding-left:1.25rem;\n                }\n            }\n        }\n    }\n}\n\n.invest{\n    &-data{\n        display: flex;\n        align-items: flex-end;\n        justify-content: space-between;\n        &-history{\n            @if($rtl==false){\n                margin-right: 20px;\n            }\n            @if($rtl==true){\n                margin-left: 20px;\n            }\n            flex-grow: 1;\n            .title{\n                font-size: $fx-sz-11;\n                color: $base-light;\n                text-transform: uppercase;\n                margin-bottom: 0.125rem;\n                letter-spacing: 0.1em;\n            }\n            .amount{\n                font-size: .9375rem;\n                line-height: 1.1;\n                color: $base-color;\n                span {\n                    color: $base-text;\n                }\n            }\n        }\n        &-amount{\n            display: flex;\n            flex-shrink: 0;\n            flex-grow: 1;\n        }\n        &-ck{\n            flex-grow: 1;\n            height: 48px;\n            width: 80px;\n            margin-bottom: 0.125rem;\n        }\n    }\n}\n\n@media (min-width:768px) and (max-width:1350px), (max-width:359px){\n    .invest-data{\n        margin-top: 0.75rem;\n        &-amount{\n            flex-wrap: wrap;\n            flex-shrink: 1;\n        }\n        &-ck{\n            height: 68px;\n            width: 140px;\n        }\n    }\n}\n\n@include media-breakpoint-only(md){\n    .invest-data-history {\n        .amount {\n            font-size:.75rem;\n            font-weight: $fw-bold;\n            span {\n                font-weight: $fw-normal;\n            }\n        }\n\n    } \n}\n\n.invest-ov{\n    padding: 1.25rem 0 1rem;\n    &:last-child{\n        padding-bottom: 0;\n    }\n    &:not(:last-child){\n        border-bottom: 1px solid $border-light;\n    }\n    .subtitle{\n        color: $base-light;\n        font-size: $fx-sz-13;\n        font-weight: $fw-medium;\n        margin-bottom: 0.25rem;\n    }\n    .title{\n        font-size: $fx-sz-11;\n        color: $base-light;\n        text-transform: uppercase;\n        margin-top: 0.25rem;\n        letter-spacing: 0.1em;\n    }\n    .amount{\n        font-size: 1.25rem;\n        line-height: 1.1;\n        color: $base-color;\n        span {\n            color: $base-text;\n        }\n    }\n    &-details{\n        display: flex;\n    }\n    &-info{\n        width: 60%;\n    }\n    &-stats{\n        width: 40%;\n        > div{\n            display: flex;\n            align-items: baseline;\n        }\n        .change{\n            @if($rtl==false){\n                margin-left: 0.25rem;\n            }\n            @if($rtl==true){\n                margin-right: 0.25rem;\n            }\n        }\n    }\n}\n\n.invest-top{\n    &-ck{\n        padding-top: 20px;\n        height: 70px;\n    }\n}\n} // @condition -e-",".asterisk{\n    a{\n        position: relative;\n        color: $base-light;\n        display: inline-flex;\n        &:hover,&.active{\n            color: $orange;\n            .asterisk{\n                &-on{\n                    opacity: 1;\n                }\n            }\n        }\n        &.active:hover{\n            .asterisk{\n                &-on{\n                    opacity: 0;\n                }\n            }\n        }\n    }\n    &-on{\n        opacity: 0;\n        position: absolute;\n        left: 0;\n        color: $orange;\n        z-index: 1;\n        transition: opacity .2s;\n    }\n}","// Variables\n$reply-body-gap-x :1.25rem;\n$reply-body-gap-x-tab :2.25rem;\n$reply-body-gap-x-dsk :2.5rem;\n\n// Reply of Messages\n//////////////////////////////\n.nk-reply {\n    height: 100%;\n    max-height: 100%;\n    overflow: auto;\n    &-item{\n        padding: 2rem $reply-body-gap-x;\n        + .nk-reply-item{\n            padding-top: 0;\n        }\n        \n        > div:not(.nk-reply-header){\n            @if($rtl==false){\n                margin-left: 48px;\n            }\n            @if($rtl==true){\n                margin-right: 48px;\n            }\n        }\n    }\n    &-header{\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        margin-bottom: 0.5rem;\n        .user-name{\n            @if($rtl==false){\n                margin-left: 1rem;\n            }\n            @if($rtl==true){\n                margin-right: 1rem;\n            }\n            font-size: .875rem;\n            span{\n                color: $base-light;\n                font-weight: $fw-normal;\n            }\n        }\n        .date-time{\n            color: $base-light;\n            font-size: $fx-sz-12;\n        }\n    }\n    &-entry{\n        &.note{\n            background: $lighter;\n            padding: 1.25rem;\n            border-radius: $border-radius;\n        }\n    }\n    &-from{\n        margin-top: 1.25rem;\n        padding: .375rem .75rem;\n        background: $lighter;\n        border-radius: $border-radius;\n        display: inline-block;\n        font-size: $fx-sz-13;\n    }\n    &-meta{\n        overflow: hidden;\n        text-align: center;\n        margin:0 $reply-body-gap-x;\n        padding: 0 2rem;\n        &-info {\n            position: relative;\n            display: inline-block;\n            padding: 0 .75rem;\n            color: $base-light;\n            font-size: $fx-sz-13;\n            line-height: 1.4;\n            span,strong, .who{\n                color:$base-text;\n            }\n            .whom {\n                color: $accent-color;\n            }\n            &:before,&:after{\n                position: absolute;\n                height: 1px;\n                background: $border-light;\n                content: '';\n                width: 100vw;\n                top: 50%;\n            }\n            &:before{\n                right: 100%;\n            }\n            &:after{\n                left: 100%;\n            }\n        }\n    }\n    &-form {\n        border-top: 1px solid $border-light;\n        &-dropdown{\n            @if($rtl==false){\n                margin-left: -0.5rem;\n                margin-right: 0.75rem;\n            }\n            @if($rtl==true){\n                margin-right: -0.5rem;\n                margin-left: 0.75rem;\n            }\n        }\n        &-header{\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            padding:0 1.25rem;\n            border-bottom: 1px solid $border-light;\n        }\n        &-title{\n            display: flex;\n            align-items: center;\n            .title{\n                color:$base-light;\n                @if($rtl==false){\n                    margin-right: .75rem;\n                }\n                @if($rtl==true){\n                    margin-left: .75rem;\n                }\n            }\n        }\n        &-field{\n            padding:.5rem 1.25rem;\n            &:not(:last-child){\n                border-bottom: 1px solid $border-light;\n            }\n            .form-control{\n                font-size: 0.875rem;\n            }\n            textarea.form-control{\n                min-height: 78px;\n                &.ex-large{\n                    min-height: 160px;\n                }\n            }\n            & + .nk-reply-form-tools {\n                border-top: 0;\n            }\n        }\n        &-tools{\n            padding: 1.25rem;\n            border-top: 1px solid $border-light;\n            display: flex;\n            justify-content: space-between;\n        }\n        &-actions{\n            display: inline-flex;\n            align-items: center;\n        }\n        &-options{\n            display: inline-flex;\n        }\n        &-input {\n            display: flex;\n            .label{\n                @if($rtl==false){\n                    margin:.3rem .5rem .3rem 0;\n                }\n                @if($rtl==true){\n                    margin:.3rem 0 .3rem .5rem;\n                }\n                width: 1.25rem;\n                color: $base-light;\n            }\n            &-group{\n                width: 100%;\n            }\n            &-cc, &-bcc{\n                display: none;\n                &.expanded{\n                    display: flex;\n                }\n            }\n            .toggle-opt{\n                display: inline-flex;\n                align-items: center;\n                color: $base-color;\n                &:hover{\n                    color: $accent-color;\n                }\n            }\n        }\n        &-group{\n            position: relative;\n            padding: 1rem 0;\n            flex-grow: 1;\n            display: flex;\n            align-items: flex-start;\n        }\n        &-input-to{\n            padding-right: 3.5rem;\n        }\n        &-nav{\n            position: absolute;\n            display: flex;\n            align-items: center;\n            align-self: flex-start;\n            padding: 1.0625rem 0 0;\n            @if($rtl==false){\n                right: 0;\n            }\n            @if($rtl==true){\n                left: 0;\n            }\n            top: 0;\n            margin: 0 -.375rem;\n            li{\n                a{\n                    font-size: $fx-sz-12;\n                    color: $base-light;\n                    display: block;\n                    line-height: 1.5rem;\n                    padding: .25rem .375rem;\n                    &:hover{\n                        color: $accent-color;\n                    }\n                }\n            }\n        }\n        &-attachment{\n            &-list{\n                background: rgba($light, .6);\n                font-weight: $fw-medium;\n                color: $base-text;\n                border-radius: $border-radius;\n            }\n        }\n    }\n    &-msg{\n        &-info{\n            .is-collapsed &{\n                display: none;\n            }\n        }\n        &-excerpt{\n            color: $base-text;\n            display: none;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            .is-collapsed &{\n                display: block;\n            }\n        }\n        &-meta{\n            padding: .75rem;\n            li{\n                display: flex;\n                line-height: 1.125rem;\n                padding: .1875rem 0;\n                .label{\n                    width: 75px;\n                    text-align: right;\n                    color: $base-light;\n                    font-size: $fx-sz-12;\n                    @if($rtl==false){\n                        margin-right: 0.75rem;\n                    }\n                    @if($rtl==true){\n                        margin-left: 0.75rem;\n                    }\n                }\n                .info{\n                    font-size: $fx-sz-13;\n                    a{\n                        color: $base-text;\n                    }\n                }\n            }\n        }\n    }\n    &-tools{\n        display: flex;\n        align-items: center;\n        flex-shrink: 0;\n        cursor: default;\n        .date{\n            @if($rtl==false){\n                margin-right: 1rem;\n            }\n            @if($rtl==true){\n                margin-left: 1rem;\n            }\n            line-height: 2.25rem;\n            color: $base-text;\n        }\n        .attach-msg {\n            font-size: 1.25rem;\n            @if($rtl==false){\n                margin-right: 0.375rem;\n            }\n            @if($rtl==true){\n                margin-left: 0.375rem;\n            }\n        }\n    }\n    &-desc{\n        display: flex;\n        flex-grow: 1;\n        .is-collapsed &{\n            overflow: hidden;\n        }\n        .nk-reply-header & {\n            align-items: center;\n        }\n    }\n    &-info{\n        @if($rtl==false){\n            margin-left: 1rem;\n        }\n        @if($rtl==true){\n            margin-right: 1rem;\n        }\n        max-width: calc(100% - 4.5rem);\n    }\n    &-header {\n        &.is-collapsed{\n            margin-bottom: 0;\n        }\n        &:not(.is-opened) {\n            cursor: pointer;\n        }\n    }\n    &-body{\n        .is-collapsed + &{\n            display: none;\n        }\n    }\n    &-quick-btns {\n        ul {\n            display: flex;\n            align-items: center;\n        }\n    }\n}\n.is-collapsed{\n    .prev-msg,.next-msg,.more-actions, .replyto-msg, .forwardto-msg{\n        display: none;\n    }\n}\n\n.input-mail{\n    width: 100%;\n    border: none;\n}\n@include media-breakpoint-down(sm){\n    .nk-reply{\n        &-tools{\n            flex-wrap: wrap;\n            .date{\n                font-size: $fx-sz-13;\n                @if($rtl==false){\n                    margin-right: .5rem;\n                }\n                @if($rtl==true){\n                    margin-left: .5rem;\n                }\n            }\n            .attach-msg {\n                font-size: 1.25rem;\n                @if($rtl==false){\n                    margin-right: 0.375rem;\n                }\n                @if($rtl==true){\n                    margin-left: 0.375rem;\n                }\n            }\n        }\n    }\n}\n@include media-breakpoint-down(xs){\n    .nk-reply{\n        &-info{\n            max-width: calc(100% - 2.5rem);\n            @if($rtl==false){\n                margin-left: 0.75rem;\n            }\n            @if($rtl==true){\n                margin-right: 0.75rem;\n            }\n            .is-collapsed &{\n                max-width: calc(100% - 4.5rem);\n            }\n            .date{\n                font-size: $fx-sz-11;\n                color: $base-light;\n                @if($rtl==false){\n                    margin-left: .375rem;\n                }\n                @if($rtl==true){\n                    margin-right: .375rem;\n                }\n            }\n            .lead-text{\n                font-size: $fx-sz-13;\n            }\n        }\n        &-form{\n            &-dropdown{\n                @if($rtl==false){\n                    margin-right: 0.5rem;\n                }\n                @if($rtl==true){\n                    margin-left: 0.5rem;\n                }\n            }\n            &-group{\n                flex-wrap: wrap;\n                align-items: center;\n            }\n            &-title{\n                font-weight: $fw-medium;\n            }\n        }\n        &-tools{\n            .attach-msg,.date-msg{\n                display: none;\n            }\n        }\n        &-avatar{\n            height: 30px;\n            width: 30px;\n        }\n        &-msg{\n            &-excerpt{\n                font-size: $fx-sz-12;\n                margin-top: 0.25rem;\n            }\n            &-info{\n                .sub-text{\n                    font-size: $fx-sz-12;\n                }\n                .dropdown-menu{\n                    @if($rtl==false){\n                        margin-right: 16px !important;\n                    }\n                    @if($rtl==true){\n                        margin-left: 16px !important;\n                    }\n                }\n            }\n        }\n    }\n}\n\n\n@include media-breakpoint-up(sm){\n    .nk-reply {\n        &-form {\n            margin: 0 $reply-body-gap-x-tab $reply-body-gap-x-tab;\n            border: 1px solid $border-light;\n            border-radius: $border-radius;\n            &-header{\n                padding:0 1.5rem;\n            }\n            &-field{\n                padding:.5rem 1.5rem;\n                textarea.form-control{\n                    &.ex-large{\n                        min-height: 278px;\n                    }\n                }\n            }\n            &-tools{\n                padding: 1rem 1.5rem;\n                .modal-body &{\n                    padding: 1.5rem;\n                }\n            }\n        }\n        &-item{\n            padding: 2rem $reply-body-gap-x-tab;\n        }\n        &-meta{\n            margin:0 $reply-body-gap-x-tab;\n        }\n        &-header{\n            .date-time{\n                font-size: $fx-sz-13;\n            }\n        }\n        &-quick-btns {\n            margin: .5rem $reply-body-gap-x-tab $reply-body-gap-x-tab;\n        }\n    }\n}\n\n@include media-breakpoint-up(lg){\n    .nk-reply {\n        &-form {\n            margin: 0 $reply-body-gap-x-dsk $reply-body-gap-x-dsk;\n        }\n        &-item{\n            padding: 2rem $reply-body-gap-x-dsk;\n        }\n        &-meta{\n            margin:0 $reply-body-gap-x-dsk;\n        }\n        &-quick-btns {\n            margin: .5rem $reply-body-gap-x-dsk $reply-body-gap-x-dsk;\n        }\n    }\n}\n",".attach{\n    &-files{\n        margin-top: 1.75rem;\n        border:1px solid $border-light;\n        border-radius: $border-radius;\n    }\n    &-list{\n        padding: 1rem 1.25rem;\n        margin-bottom: -.5rem;\n        display: flex;\n        flex-wrap: wrap;\n    }\n    &-item{\n        width: 180px;\n        padding-right: 2rem;\n        padding-bottom: 0.5rem;\n        a{\n            display: flex;\n            align-items: center;\n            width: 100%;\n            color: $base-text;\n        }\n        .icon{\n            font-size: 1.5rem;\n            color: $accent-color;\n            margin-right: 0.75rem;\n        }\n        span{\n            @extend .ellipsis;\n        }\n    }\n    &-foot{\n        border-top:1px solid $border-light;\n        background: $lighter;\n        padding: .75rem 1.25rem;\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: space-between;\n    }\n    &-info{\n        font-weight: $fw-medium;\n        color: $base-color;\n    }\n    &-download{\n        span{\n            color: $base-light;\n            transition: all .3s;\n        }\n        &:hover{\n            span{\n                color: $accent-color;\n            }\n        }\n    }\n}\n\n@media (max-width:359px){\n    .attach{\n        &-info{\n            font-size: $fx-sz-12;\n        }\n        &-download{\n            font-size:  $fx-sz-12;\n        }\n    }\n}","// Variables\n$msg-item-gap-x:1.25rem;\n$msg-item-gap-x-tab :2rem;\n$msg-item-gap-x-dsk :1.75rem;\n\n$msg-item-gap-y :1.25rem;\n$msg-body-gap-x :1.25rem;\n$msg-body-gap-x-tab :2.25rem;\n$msg-body-gap-x-dsk :2.5rem;\n\n.nk-msg{\n    &-nav{\n        position: relative;\n        border-bottom: 1px solid $border-light;\n        padding: 0 $msg-item-gap-x;\n        background:$lighter;\n        z-index: 2;\n        .search-wrap{\n            padding: 0 1rem;\n            bottom: -1px;\n            border-bottom: 1px solid $border-light;\n        }\n        .search-submit {\n            transform: translate(0.25rem, -50%);\n        }\n    }\n    &-menu{\n        display: flex;\n        margin: 0 -0.75rem;\n        &-item {\n            padding: 0 0.75rem;\n            a{\n                display: inline-flex;\n                position: relative;\n                color: $base-light;\n                font-weight: $fw-medium;\n                font-size: .875rem;\n                line-height: 1.5rem;\n                padding: 1rem 0;\n                &:after{\n                    position: absolute;\n                    content: '';\n                    height: 2px;\n                    background: $accent-color;\n                    bottom: -1px;\n                    left: 0;\n                    right: 0;\n                    opacity: 0;\n                    transition: .3s ease;\n                }\n                .icon{\n                    font-size: 1.125rem;\n                    line-height: 1.5rem;\n                }\n                &:hover{\n                    color:$accent-color;\n                }\n            }\n            &.active{\n                a{\n                    color:$accent-color;\n                    &:after{\n                        opacity: 1;\n                    }\n                }\n            }\n        }\n    }\n}\n\n.nk-msg{\n    position: relative;\n    display: flex;\n    overflow: hidden;\n    min-height: calc(100vh - (#{$header-height} + 64px));\n    max-height: calc(100vh - (#{$header-height} + 64px));\n    background: $white;\n    &-aside{\n        background: $lighter;\n        width: 100%;\n        overflow: hidden;\n        max-height: 100%;\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        flex-shrink: 0;\n        .nk-msg-boxed &{\n            background: rgba($lighter,.7);\n            border-top-left-radius: ($border-radius - 1);\n            border-bottom-left-radius: ($border-radius - 1);\n        }\n    }\n\n    &-list{\n        // max-height: calc(100% - 57px);\n        max-height: 100%;\n        height: 100%;\n        overflow: auto;\n    }\n    &-item{\n        display: flex;\n        padding:$msg-item-gap-y $msg-item-gap-x;\n        &:not(:last-child){\n            border-bottom: 1px solid $border-light;\n        }\n        cursor: pointer;\n        &.active,&.current{\n            background: $white;\n            cursor: default;\n        }\n    }\n    &-info{\n        max-width:calc(100% - 52px);\n        margin-left: 0.75rem;\n        flex-grow: 1;\n    }\n    &-from{\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n    &-context{\n        display: flex;\n        justify-content: space-between;\n        margin-top: 0.25rem;\n        .asterisk{\n            margin-top: auto;\n            // moved to asterisk.scss\n        }\n    }\n    &-sender{\n        display: inline-flex;\n        align-items: center;\n        color: $base-light;\n        font-size: $fx-sz-12;\n        .name{\n            margin-right: 0.5rem;\n            .is-unread &{\n                font-weight: $fw-medium;\n                color: $base-color;\n            }\n        }\n    }\n    &-meta{\n        display: inline-flex;\n        align-items: center;\n        color: $base-light;\n        font-size: $fx-sz-12;\n        .attchment{\n            .icon{\n                font-size: 1.125rem;\n            }\n        }\n        .date{\n            margin-left: 0.75rem;\n        }\n    }\n    &-text{\n        max-width: calc(100% - 35px);\n        flex-grow: 0;\n        padding-right: 0.5rem;\n        .title{\n            font-size: $fx-sz-15;\n            margin-bottom: 0.25rem;\n            @extend .ellipsis;\n        }\n        p{\n            font-size: $fx-sz-13;\n            color:$base-light;\n            max-height: 42px;\n            overflow: hidden;\n            .is-unread &{\n                color: $base-text;\n                font-weight: $fw-medium;\n            }\n        }\n    }\n    &-lables{\n        text-align: center;\n        margin: -.125rem;\n        display: inline-flex;\n        flex-direction: column;\n        > div{\n            padding: .125rem;\n        }\n        .icon{\n            font-size: 1.125rem;\n        }\n        .badge{\n            line-height: 14px;\n            font-size: 10px;\n            padding: 0 .25rem;\n        }\n    }\n    &-body{\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        flex-grow: 1;\n        display: flex;\n        flex-direction: column;\n        overflow: hidden;\n        transition: padding .3s ease-in-out;\n        opacity: 0;pointer-events: none;\n        z-index: 5;\n        &.show-message{\n            opacity: 1;\n            pointer-events: auto;\n        }\n    }\n    &-profile{\n        position: absolute;\n        top: 0;\n        right: 0;\n        transform: translateX(100%);\n        width: 280px;\n        height: 100%;\n        max-height: 100%;\n        transition: transform .3s  ease-in-out;\n        background: $white;\n        z-index: 100;\n        &-toggle{\n            position: absolute;\n            height: 36px;\n            width: 36px;\n            display: none;\n            align-items: center;\n            justify-content: center;\n            bottom: -18px;\n            right: -18px;\n            margin-right: 40px;\n            transition: right .3s ease-in-out, margin .3s ease-in-out .2s;\n            border: 1px solid $border-light;\n            background-color: $white;\n            border-radius: 50%;\n            font-size: 1.125rem;\n            z-index: 2;\n            color:$base-light;\n            z-index: 110;\n            &.active{\n                margin-right: 0;\n                transform: rotate(-180deg);\n            }\n        }\n        &-overlay{\n            position: absolute;\n            top: 0;\n            right: 0;\n            bottom: 0;\n            left: 0;\n            background: $sidebar-overlay;\n            z-index: 600;\n            z-index: 90;\n            animation: overlay-fade-in .4s ease 1;\n        }\n        &.visible{\n            transform: none;\n        }\n    }\n    &-head{\n        position: relative;\n        padding: .75rem $msg-body-gap-x;\n        border-bottom: 1px solid $border-light;\n        .title{\n            margin-bottom: .5rem;\n        }\n        &-meta{\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n        }\n    }\n    &-hide{\n        font-size: 1rem;\n    }\n    &-tags{\n        margin:0 -.75rem;\n        li{\n            padding: 0 .75rem;\n            color:$base-light;\n            > span {\n                display: inline-flex;\n                align-items: center;\n                .icon{\n                    color: $accent-color;\n                    margin-right: 0.25rem;\n                }\n            }\n        }\n    }\n\n    &-actions{\n        display: flex;\n        margin:0 -.25rem;\n        li{\n            padding: 0 .25rem;\n        }\n    }\n}\n\n\n@include media-breakpoint-down(mb){\n    .nk-msg{\n        &-boxed{\n            border: none;\n            border-radius: $border-radius;\n            min-height: calc(100vh - (#{$header-height}));\n            max-height: calc(100vh - (#{$header-height}));\n            // margin: -24px -18px; // @io-v2.0\n        }\n    }\n}\n@include media-breakpoint-up(sm){\n    .nk-msg{\n        &-nav{\n            padding: 0 $msg-item-gap-x-tab;\n            .search-wrap{\n                padding: 0 1.7rem;\n            }\n        }\n        &-item{\n            padding:$msg-item-gap-y $msg-item-gap-x-tab;\n        }\n        &-head{\n            padding: 1rem $msg-body-gap-x-tab;\n            .title{\n                margin-bottom: 1rem;\n            }\n        }\n    }\n    \n}\n@include media-breakpoint-between(sm,md){\n    .nk-msg{\n        &-text{\n            .title{\n                margin-top: 0.125rem;\n                margin-bottom: 0.375rem;\n            }\n        }\n    }\n}\n@include media-breakpoint-up(lg){\n    .nk-msg{\n        &-nav{\n            padding: 0 $msg-item-gap-x-dsk;\n            .search-wrap{\n                padding: 0 ($msg-item-gap-x-dsk - .325rem);\n            }\n        }\n        &-item{\n            padding:$msg-item-gap-y $msg-item-gap-x-dsk;\n        }\n        &-head{\n            padding: 2rem $msg-body-gap-x-dsk;\n            .title{\n                max-height: 82px;\n                overflow: hidden;\n            }\n        }\n        &-aside{\n            width: 320px;\n            border-right: 1px solid $border-light;\n        }\n        &-body{\n            position: static;\n            opacity: 1;\n            pointer-events: auto;\n        }\n        &-profile {\n            border-left: 1px solid $border-light;\n            &-toggle{\n                margin-right: 55px;\n                display: flex;\n            }\n        }\n    }\n}\n@include media-breakpoint-up(xxl){\n    .nk-msg{\n        &-aside{\n            width: 380px;\n        }\n    }\n}\n\n@include media-breakpoint-down(xl){\n    .profile-shown{\n        .nk-msg-profile-toggle{\n            right: 262px;\n            .has-apps-sidebar & {\n                right: -18px;\n            }\n        }\n    }\n}\n@media (max-width:1279px){\n    .has-apps-sidebar{\n        .profile-shown{\n            .nk-msg-profile-toggle{\n                right: 262px;\n            }\n        }\n    }\n}\n@include media-breakpoint-up(xxl){\n    .nk-msg-body{\n        &.profile-shown{\n            padding-right: 280px;\n        }\n    }\n}\n@media (min-width:1280px){\n    .has-apps-sidebar{\n        .nk-msg-body{\n            &.profile-shown{\n                padding-right: 280px;\n            }\n        }\n    }\n}","$ibx-aside-width :      260px;\n\n.ibx-count{\n    position: relative;\n    padding: 0.3125rem 0.75rem;\n    font-size: 0.75rem;\n    color: $base_light;\n    background: $white;\n    border: 1px solid  $border-light;\n    display: inline-block;\n    font-weight: $fw-normal;\n    line-height: 1;\n    text-align: center;\n    white-space: nowrap;\n    vertical-align: baseline;\n    border-radius: $border-radius-sm;\n    &:before,&:after{\n        position: absolute;\n        height: 0;\n        width: 0;\n        top: 50%;\n        transform: translateY(-50%);\n        content: '';\n        border-style: solid;\n    }\n    &:before{\n        right: -8px;\n        border-color: transparent transparent transparent $border-light;\n        border-width: 4px 0 4px 7px;\n    }\n    &:after{\n        right: -6px;\n        border-width: 3px 0 3px 6px;\n        border-color: transparent transparent transparent $white;\n    }\n}\n\n.nk-ibx-context{\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    &-group{\n        display: flex;\n        align-items: center;\n    }\n    &-badges{\n        margin-right: 0.75rem;\n    }\n    &-text{\n        display: inline;\n        color: $base-light;\n        .is-unread &{\n            color: $base-text;\n        }\n        .heading{\n            color: $base-color;\n            .is-unread &{\n                font-weight: $fw-medium;\n            }\n        }\n    }\n}\n\n.ibx-actions{\n    position: relative;\n    display: inline-block;\n    transition: background-color .3s;\n    &-hidden{\n        position: absolute;\n        display: flex;\n        right: calc(100% + 8px);\n        opacity: 0;\n        transition: background-color .3s;\n        .nk-ibx-item:hover &{\n            opacity: 1;\n            background-color:$lighter;\n        }\n    }\n    .nk-ibx-item:hover &{\n        background-color:$lighter;\n    }\n}\n\n.nk-ibx{\n    position: relative;\n    display: flex;\n    overflow: hidden;\n    min-height: calc(100vh - (#{$header-height} + 64px));\n    max-height: calc(100vh - (#{$header-height} + 64px));\n    background: $white;\n    &-aside{\n        position: absolute;\n        background: $white;\n        width: $ibx-aside-width;\n        overflow: hidden;\n        height: 100%;\n        max-height: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: stretch;\n        flex-shrink: 0;\n        border-right: 1px solid $border-light;\n        transform: translateX(-100%);\n        z-index: 99;\n        transition: transform .4s linear;\n        + .toggle-overlay{\n            z-index: 90;\n            position: absolute;\n        }\n        &.content-active{\n            transform: none;\n        }\n    }\n    &-nav{\n        overflow: auto;\n        flex-grow: 1;\n        height: 100%;\n        max-width: 100%;\n        .simplebar-content{\n            height: 100%;\n            display: flex;\n            flex-direction: column;\n        }\n        &-head{\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            padding: 2rem 1.5rem .75rem;\n            .title{\n                font-size: 1rem;\n                margin-bottom: 0;\n            }\n            .dropdown > a, > .link{\n                color: $base-light;\n                font-size: 0.875rem;\n            } \n        }\n    }\n    &-head{\n        position: relative;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: .75rem 1.25rem;\n        border-bottom: 1px solid $border-light;\n        min-height: 61px;\n        .title{\n            font-size: 1rem;\n            margin-bottom: 0;\n        }\n        &-actions, &-tools {\n            display: flex;\n            align-items: center;\n        }\n        &-tools {\n            .btn-icon.btn-trigger .icon {\n                font-size: 1.25rem;\n            }\n        }\n        .search{\n            &-wrap{\n                padding: 0 1.365rem 0 1rem;\n                .icon{\n                    font-size: 1.25rem;\n                }\n            }\n            &-back{\n                transform: translate(-0.5rem, -50%);\n            }\n        }\n        &-check{\n            display: flex;\n            margin-right: .325rem;\n        }\n\n    }\n    &-action{\n        position: relative;\n        padding: 1rem 1.5rem;\n        border-bottom: 1px solid $border-light;\n        &-list{\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n        }\n        &-item{\n            a{\n                display: flex;\n                align-items: center;\n            }\n            .icon{\n                font-size: 1.5rem;\n                + span{\n                    margin-left: 0.5rem;\n                }\n            }\n            .search-toggle{\n                .icon{\n                    font-size: 1.125rem;\n                }\n            }\n        }\n        \n    }\n    &-menu{\n        li{\n            margin: 2px 0;\n            &:hover{\n                background: $lighter;\n                border-radius: $border-radius-sm;\n            }\n            &.active{\n                background: $accent-100;\n                border-radius: $border-radius-sm;\n                \n            }\n        }\n        &-item{\n            position: relative;\n            display: flex;\n            align-items: center;\n            padding: .5rem .75rem;\n            border-radius: $border-radius;\n            .icon{\n                font-size: 1.25rem;\n                line-height: 1.5rem;\n                width: 2rem;\n                color: $base-light;\n            }\n            .badge{\n                margin-left: auto;\n                min-width: 2.25rem;\n                justify-content: center;\n            }\n            .active &{\n                .icon{\n                    color: $accent-color;\n                }\n            }\n        }\n        &-text{\n            font-size: .875rem;\n            color: $base-text;\n            font-weight: $fw-medium;\n            line-height: 1.5rem;\n            .active &{\n                color: $accent-color;\n            }\n        }\n    }\n    &-label, &-contact {\n        > li {\n            position: relative;\n            display: flex;\n            align-items: center;\n            border-radius: $border-radius;\n            margin: 2px 0;\n            transition: background-color .3s;\n            > a{\n                display: flex;\n                padding: .5rem .75rem;\n                flex-grow: 1;\n            }\n            .dropdown{\n                opacity: 0;\n                > a{\n                    color: $base-text;\n                    padding: .6875rem;\n                }\n            }\n            &:hover{\n                background: $lighter;\n                .dropdown{ \n                    opacity: 1;\n                }\n            }\n            &.active{\n                background: $accent-light;\n            }\n        }\n    }\n    &-label{\n        &-text{\n            line-height: 1;\n            margin-left: 1rem;\n            font-size: .875rem;\n            color: $base-text;\n            font-weight: $fw-medium;\n        }\n    }\n    &-menu,&-label,&-contact{\n        padding-left: .75rem;\n        padding-right: .75rem;\n    }\n    &-menu{\n        padding-top: .75rem;\n    }\n    &-contact{\n        padding-bottom: 1.75rem;\n    }\n    &-status{\n        margin-top: auto;\n        background: $lighter;\n        padding: 1.5rem 1.5rem;\n        &-info{\n            margin-bottom: 0.5rem;\n            .icon{\n                width: 1.25rem;\n                display: inline-block;\n            }\n        }\n    }\n    &-body{\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        overflow: hidden;\n        flex-grow: 1;\n        flex-shrink: 1;\n    }\n    &-list{\n        display: flex;\n        flex-direction: column;\n        max-height: 100%;\n        height: 100%;\n        overflow: auto;\n    }\n    &-item{\n        position: relative;\n        display: flex;\n        align-items: center;\n        background: $white;\n        padding: 1rem 1.25rem;\n        transition: background-color .3s;\n        cursor: pointer;\n        &:not(:last-child){\n            border-bottom: 1px solid $border-light;\n        }\n        &:not(.no-hover):hover,&.active {\n            background: $lighter;\n        }\n        &.is-unread {\n            background: rgba($lighter, .6);\n        }\n        &-elem{\n            padding: 0 8px;\n            flex-shrink: 0;\n            &:first-child{\n                padding-left: 0;\n            }\n        }\n        &-check{\n            width: 28px;\n            display: inline-flex;\n        }\n        &-fluid{\n            flex-grow: 1;\n            flex-shrink: 1;\n            width: 100%;\n            max-width: 100%;\n            overflow: hidden;\n        }\n        &-user{\n            .user-name{\n                max-width: calc(100% - 50px);\n                .lead-text{\n                    overflow: hidden;\n                    white-space: nowrap;\n                    text-overflow: ellipsis;\n                    font-weight: $fw-normal;\n                    .is-unread &{\n                        font-weight: $fw-medium;\n                    }\n                }\n            }\n        }\n        &-count{\n            width: 3.25rem;\n        }\n        &-time{\n            width: 80px;\n            text-align: right;\n        }\n        &-attach{\n            width: 2.25rem;\n            text-align: center;\n        }\n        &-star{\n            .asterisk{\n                padding: 0 .25rem;\n                a{\n                    display: flex;\n                }\n                .icon{\n                    line-height: 1;\n                    font-size: 1.125rem;\n                }\n            }\n        }\n        &-tools{\n            padding-right: 0;\n            margin-left: auto;\n            text-align: right;\n        }\n        &-check,&-star,&-attach{\n            position: relative;\n            z-index: 2;\n        }\n        &-tools{\n            position: relative;\n        }\n    }\n    &-link{\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        z-index: 1;\n        + .nk-ibx-item-elem{\n            padding-left: 0;\n        }\n    }\n    &-view{\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        background: $white;\n        z-index: 2;\n        opacity: 0;\n        visibility: hidden;\n        pointer-events: none;\n        display: flex;\n        flex-direction: column;\n        overflow: hidden;\n        &.show-ibx{\n            opacity: 1;\n            visibility: visible;\n            pointer-events: all;\n        }\n    }\n    &-reply{\n        &-head{\n            padding: 1.5rem 1.25rem 0;\n            display: flex;\n            align-items: flex-start;\n            justify-content: space-between;\n            .title{\n                margin-bottom: .75rem;\n            }\n        }\n        &-header{\n            margin-right: -.5rem;\n        }\n        &-item{\n            position: relative;\n            > div:not(.nk-reply-header){\n                margin-left: 0;\n                margin-top: 1.25rem;\n                margin-bottom: 0.75rem;\n            }\n            &:not(:last-child){\n                &:after{\n                    position: absolute;\n                    left: 1.25rem;\n                    right: 1.25rem;\n                    height: 1px;\n                    bottom: 1rem;\n                    content: '';\n                    background: $border-light;\n                }\n            }\n        }\n    }\n}\n\n@include media-breakpoint-up(sm){\n    .nk-ibx{\n        &-item,&-head{\n            padding-left: 2.25rem;\n            padding-right: 2.25rem;\n        }\n        &-head{\n            .search-wrap{\n                padding: 0 2.375rem 0 2rem;\n            }\n        }\n        &-reply{\n            &-head{\n                padding: 2em 2.25rem 0;\n            }\n            &-item{\n                padding-bottom: 2.75rem;\n                > div:not(.nk-reply-header){\n                    margin-left: 56px;\n                }\n                &:not(:last-child):after {\n                    bottom: 1.375rem;\n                    left: 2.25rem;\n                    right: 2.25rem;\n                }\n            }\n            &-quick-btns, &-form {\n                margin-left: 5.75rem;\n            }\n        }\n    }\n}\n@include media-breakpoint-up(md){\n    .nk-ibx{\n        &-item{\n            &-user{\n                width: 180px;\n            }\n        }\n    }\n}\n@include media-breakpoint-up(lg){\n    .nk-ibx{\n        &-aside{\n            position: static;\n            transform: none;\n            transition: none;\n            height: calc(100vh - 128px);\n        }\n        &-menu,&-label,&-contact{\n            padding-left: 1rem;\n            padding-right: 1rem;\n        }\n        &-menu{\n            padding-top: 1rem;\n        }\n        &-contact{\n            padding-bottom: 1rem;\n        }\n        &-nav{\n            &-head{\n                padding-left: 1.75rem;\n                padding-right: 1.75rem;\n            }\n        }\n        &-item,&-head{\n            padding-left: 1.75rem;\n            padding-right: 1.75rem;\n        }\n        &-head{\n            .search-wrap{\n                padding: 0 2.25rem 0 1.5rem;\n            }\n        }\n        &-body{\n            max-width: calc(100% - #{$ibx-aside-width});\n        }\n        &-reply {\n            &-quick-btns, &-form {\n                margin-left: 5.25rem;\n            }\n            &-item,&-head{\n                padding-left: 1.75rem;\n                padding-right: 1.75rem;\n            }\n        }\n    }\n}\n\n@include media-breakpoint-up(xl){\n    .nk-ibx{\n        &-aside{\n            width: 300px;\n        }\n        &-item{\n            &-user{\n                width: 200px;\n            }\n            &-time{\n                margin-right: 5rem;\n            }\n        }\n    }\n}\n@include media-breakpoint-up(xxl){\n    .nk-ibx{\n        &-item{\n            &-user{\n                width: 260px;\n            }\n            &-tools{\n                margin-left: 5rem;\n            }\n        }\n    }\n}\n\n@include media-breakpoint-down(lg){\n    .nk-ibx{\n        &-item{\n            &-attach{\n                display: none;\n            }\n        }\n    }\n}\n\n@include media-breakpoint-down(sm){\n    .nk-ibx{\n        &-item{\n            flex-wrap: wrap;\n            &-elem{\n                padding: 0 4px;\n            }\n            &-fluid{\n                padding-left: 32px;\n                padding-right: 48px;\n                margin-top: 6px;\n                width: calc(100% - 2.5rem);\n                .heading {\n                    display: block;\n                }\n            }\n            &-count,&-attach{\n                display: none;\n            }\n            &-user{\n                flex-grow: 1;\n                .user-avatar{\n                    height: 28px;\n                    width: 28px;\n                    font-size: $fx-sz-12;\n                }\n            }\n            &-time{\n                position: absolute;\n                right: 32px;\n                top: 19px;\n            }\n            &-tools{\n                position: absolute;\n                right: 28px;\n                text-align: right;\n                bottom: 18px;\n            }\n            &-star{\n                position: absolute;\n                left: 28px;\n                top: 50px;\n            }\n        }\n        &-context-badges{\n            display: none;\n        }\n    }\n    .ibx-actions-hidden{\n        display: none;\n    }\n}\n\n@include media-breakpoint-down(mb){\n    .nk-ibx{\n        &-item{\n            &-star{\n                left: 12px;\n            }\n            &-time{\n                right: 12px;\n            }\n            &-tools{\n                right: 8px;\n            }\n        }\n        &-reply{\n            &-head{\n                .title{\n                    font-size: 1.125rem;\n                }\n            }\n            .btn-icon.btn-trigger{\n                padding-top: 0.3125rem;\n                padding-bottom: 0.3125rem;\n                .icon{\n                    width: 1.875rem;;\n                }\n            }\n        }\n    }\n}\n@media (max-width:359px){\n    .nk-ibx{\n        &-head{\n            .btn-icon.btn-trigger{\n                padding-top: 0.3125rem;\n                padding-bottom: 0.3125rem;\n                .icon{\n                    width: 1.875rem;\n                }\n            }\n        }\n    }\n}\n\n@include media-breakpoint-between(sm,md){\n    .nk-ibx{\n        &-aside {\n            width: 320px;\n        }\n        &-menu, &-label, &-contact {\n           padding-left: 1.5rem; \n           padding-right: 1.5rem; \n        }\n        &-nav-head, &-status {\n            padding-left: 2.25rem;\n            padding-right: 2.25rem;\n        }\n    }\n}\n","$fmg-aside-width :          260px;\n$fmg-aside-width-small :    220px;\n$fmg-file-icon-width-xs :    24px;\n$fmg-file-icon-width-sm :    32px;\n$fmg-file-icon-width-lg :    72px;\n\n$file-desc-sap:           $ni-dot !default;\n\n/// Layout for FMG\n.nk-fmg{\n    position: relative;\n    background-color: $lighter;\n    min-height: calc(100vh - (#{$header-height} + 64px));\n    &-aside{\n        position: fixed;\n        width: $fmg-aside-width;\n        overflow: hidden;\n        height: 100%;\n        max-height: 100%;\n        background: $white;\n        flex-shrink: 0;\n        left: 0;\n        transform: translateX(-100%);\n        border-right: 1px solid $border-light;\n        z-index: 99;\n        top: $header-height;\n        transition: transform .4s linear;\n        min-height: calc(100vh - #{$header-height});\n        max-height: calc(100vh - #{$header-height});\n        overflow-y: auto;\n        + .toggle-overlay{\n            z-index: 90;\n        }\n        &.content-active {\n            transform: none;\n        }\n        .simplebar-content{\n            height: 100%;\n        }\n        &-wrap{\n            height: 100%;\n            display: flex;\n            flex-direction: column; \n        }\n        &-top{\n            margin-bottom: auto;\n            margin-bottom: 30px;\n        }\n    }\n    &-menu{\n        padding: 1rem;\n        li{\n            margin: 2px 0;            \n        }\n        &-item{\n            position: relative;\n            display: flex;\n            align-items: center;\n            padding: .5rem .75rem;\n            border-radius: $border-radius;\n            &:hover{\n                background: $lighter;\n                border-radius: $border-radius-sm;\n            }\n            .active > &{\n                background: $accent-100;\n                border-radius: $border-radius-sm;\n            }\n            .icon{\n                font-size: 1.25rem;\n                line-height: 1.25rem;\n                margin-top: -2px;\n                width: 2rem;\n                color: $base-light;\n            }\n            .badge{\n                margin-left: auto;\n                min-width: 2.25rem;\n            }\n            .active > &{\n                .icon{\n                    color: $accent-color;\n                }\n            }\n        }\n        &-text{\n            font-size: .875rem;\n            color: $base-text;\n            font-weight: $fw-medium;\n            line-height: 1.5rem;\n            .active > .nk-fmg-menu-item > &{\n                color: $accent-color;\n            }\n        } \n        li ul {\n            margin-top: -0.125rem;\n            margin-bottom: 0.5rem;\n            padding-left: 2.75rem;\n            ul {\n                padding-left: .75rem;\n                border-left: 1px solid $border-light;\n            }\n            .nk-fmg-menu{\n                &-item {\n                    padding: .125rem 0;\n                    &:hover, &.active {\n                        background: transparent;\n                        span {\n                            color: $accent-color;\n                        }\n                    }\n                }\n                &-text{\n                    font-size: 90%;\n                    line-height: 1.375rem;\n                }\n            }\n        }\n    }\n    &-status{\n        padding: 1.75rem;\n        &-title{\n            font-size: .875rem;\n            display: flex;\n            align-items: center;\n            color: $base-text;\n            margin-bottom: 1rem;\n            .icon{\n                font-size: 1.25rem;\n                margin-right: .75rem;\n            }\n        }\n        &-info{\n            font-size: $fx-sz-12;\n            font-weight: $fw-medium;\n            color: $base-light;\n            margin-top: 1rem;\n        }\n    }\n    &-body{\n        display: flex;\n        flex-direction: column;\n        max-height: 100%;\n        flex-grow: 1;\n        flex-shrink: 0;\n        &-head{\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            flex-wrap: wrap;\n            padding: .75rem 1.25rem;\n            border-bottom: 1px solid $border-color;\n            background-color: $white;\n            z-index: 9;\n            position: relative;\n            top: 0;\n            border-top-right-radius: $border-radius;\n        }\n        &-content{\n            padding:1.125rem 1.25rem;\n            height: 100%;\n            max-height: 100%;\n            overflow: auto;\n        }\n        .simplebar-content {\n            min-height: 470px;\n        }\n    }\n    &-search{\n        display: flex;\n        align-items: center;\n        flex-grow: 1;\n    }\n    &-filter{\n        margin-bottom: 1.25rem;\n        .form-label{\n            font-weight: $fw-medium;\n            font-size: $fx-sz-13;\n            color: $base-light;\n        }\n        .form-group{\n            margin-bottom: 1rem;\n        }\n    }\n    &-switch{\n        background-color: transparent;\n        border-top: 1px solid $border-light;\n        > div{\n            width: 100%;\n        }\n        .dropdown{\n            &-toggle{\n                padding: 1.25rem 1.75rem;\n                width: 100%;\n                flex-direction: column;\n                align-items: flex-start;\n                &:after{\n                    position: absolute;\n                    right: 1.5rem;\n                    top: 50%;\n                    transform: translateY(-50%);\n                    font-size: 1rem;\n                    color: $base-text;\n                }\n            }\n        }\n    }\n    &-listing {\n        min-height: 380px;\n        &.is-scrollable {\n            min-height: auto;\n            max-height: 298px;\n        }\n    }\n}\n@include media-breakpoint-up(sm){\n    .nk-fmg{\n        &-body{\n            &-content{\n                padding-top: 1.25rem;\n                padding-bottom: 1.25rem;\n            }\n        }\n        &-aside-top{\n            margin-bottom: 100px;\n        }\n    }\n}\n@include media-breakpoint-up(lg){\n    .nk-fmg{\n        padding-left: $fmg-aside-width;\n        &-aside {\n            transform: none;\n            transition: none;\n            width: $fmg-aside-width;\n            position: absolute;\n            left: 0;\n            border-top-left-radius: $border-radius;\n            border-bottom-left-radius: $border-radius;\n            top: 0;\n            min-height: 100%;\n            max-height: 100%;\n            &-top{\n                flex-grow: 0;\n            }\n        }\n        &-body{\n            &-head{\n                padding: .75rem 1.75rem;\n                z-index: 9;\n            }\n            &-content{\n                padding: 1.75rem;\n            }\n        }\n    }\n}\n@include media-breakpoint-up(xl){\n    .nk-fmg{\n        padding-left: $fmg-aside-width-small;\n        &-filter.toggle-expand-content {\n            display: block !important;\n        }\n        &-aside{\n            width: $fmg-aside-width-small;\n        }\n    }\n}\n\n@media (min-width: 992px) and (max-width: 1360px) {\n    .nk-fmg{\n        padding-left: $fmg-aside-width-small;\n        &-aside {\n            width: $fmg-aside-width-small;\n        }\n    }\n}\n\n@include media-breakpoint-between(sm,md){\n    .nk-fmg{\n        &-aside {\n            width: 320px;\n        }\n        &-body-head, &-body-content, &-status, &-switch .dropdown-toggle {\n            padding-left: 2.25rem;\n            padding-right: 2.25rem;\n        }\n        &-menu {\n            padding: 1rem 1.75rem;\n        } \n    }\n}\n\n/// Listing File Item\n.nk-file{\n    .tb-sub{\n        font-size: $fx-sz-12;\n        color: $base-light;\n    }\n    .tb-head{\n        font-weight: $fw-medium;\n        font-size: $fx-sz-13;\n        color: $base-light;\n    }\n    &-info {\n        &:hover .nk-file-name .asterisk a, .nk-file-name .asterisk a.active {\n            opacity: 1;\n        }\n    }\n    &-icon {\n        margin-right: 8px;\n        flex-shrink: 0;\n        &-link {\n            display: block;\n            text-decoration: none;\n            color: inherit;\n        }\n        &-type {\n            width: $fmg-file-icon-width-sm;\n            display: inline-block;\n            text-decoration: none;\n            color: inherit;\n            margin:auto;\n        }\n    }\n    &-title {\n        display: flex;\n        align-items: center;\n        .breadcrumb{\n            padding-top: 0.25rem;\n            padding-bottom: 0;\n        }\n    }\n    &-name {\n        font-weight: $fw-medium;\n        color: $base-color;\n        position: relative;\n        line-height: 1.4;\n        &-text {\n            padding-right: 1.5rem;\n            display: inline-block;\n            .title {\n                transition: color .3s;\n                display: inline-block;\n                text-decoration: none;\n                word-break: break-word;\n            }\n            a.title {\n                color: $base-color;\n                &:hover {\n                    color: $accent-color;\n                }\n            }\n        }\n        &-sub{\n            font-size: $fx-sz-12;\n            color: $base-light;\n        }\n        .asterisk{\n            position: absolute;\n            display: inline-flex;\n            margin-left: .5rem;\n            transition: .3s opacity;\n            margin-top: -1px;\n            top: 50%;\n            transform: translateY(-50%);\n            a {\n                opacity: 0;\n            }\n            .icon{\n                font-size: 1.125rem;\n                color:$accent-color;\n            }\n        }\n    }\n    &-desc{\n        display: flex;\n        align-items: center;\n        margin: 0 -.375rem;\n        li{\n            position: relative;\n            padding: 0 .375rem;\n            font-size: $fx-sz-12;\n            color: $base-light;\n            &:not(:first-child):before{\n                content:$file-desc-sap;\n                font-family: $nk-dashlite-font;\n                position: absolute;\n                left: 0;\n                top: 50%;\n                font-size: 11px;\n                line-height: 10px;\n                transform: translate(-50%,-50%);\n                opacity: .8;\n            }\n        }\n    }\n    &-link {\n        text-decoration: none;\n        color: inherit;\n        display: block;\n        &:hover {\n            .title {\n                color: $accent-color;\n            }\n        }\n        .nk-file-info > & {\n            padding: .75rem 0;\n            .is-compact & {\n                padding: .375rem 0;\n            }\n        }\n    }\n    &-share{\n        &-header{\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            padding:0 1.25rem;\n            border-bottom: 1px solid $border-light;\n        }\n        &-field{\n            padding:.5rem 1.25rem;\n            &:not(:last-child){\n                border-bottom: 1px solid $border-light;\n            }\n            .form-control{\n                font-size: 0.875rem;\n            }\n            textarea.form-control{\n                min-height: 78px;\n                &.ex-large{\n                    min-height: 160px;\n                }\n            }\n        }\n        &-input {\n            display: flex;\n            .label{\n                margin:.3rem .5rem .3rem 0;\n                width: 1.25rem;\n                color: $base-light;\n            }\n            &-group{\n                width: 100%;\n            }\n        }\n        &-group{\n            position: relative;\n            padding: 1rem 0;\n            flex-grow: 1;\n            display: flex;\n            align-items: center;\n        }\n        &-nav{\n            flex-shrink: 0;\n        }\n    }\n    &-details{\n        &-row{\n            display: flex;\n            flex-wrap: wrap;\n            padding: .25rem 0;\n        }\n        &-col{\n            font-size: $fx-sz-13;\n            &:first-child{\n                color: $base-light;\n                width: 100%;\n            }\n            &:last-child{\n                color: $base-text;\n            }\n            .breadcrumb{\n                padding: 0;\n            }\n        }\n    }\n}\n@media (min-width:420px){\n    .nk-file{\n        &-details{\n            &-row{\n                flex-wrap: nowrap;\n                padding: .375rem 0;\n            }\n            &-col{\n                &:first-child{\n                    width: 100px;\n                    flex-shrink: 0;\n                }\n            }\n        }\n    }\n}\n@include media-breakpoint-up(sm){\n    .nk-file{\n        &-share{\n            &-field{\n                textarea.form-control{\n                    &.ex-large{\n                        min-height: 278px;\n                    }\n                }\n            }\n        }\n    }\n}\n\n/// Listing View \n.nk-files {\n    .nk-file {\n        .hideable{\n            opacity: 0;\n            transition: opacity .3s;\n        }\n        &:hover{\n            .hideable{\n                opacity: 1;\n            }\n        }\n        &-item{\n            display:table-row;\n            > div  {\n                position: relative;\n                display: table-cell;\n                padding: .5rem;\n                vertical-align: middle;\n            }\n        }\n        &-actions{\n            width: 60px;\n            text-align: center;\n        }\n    } \n    &-head{\n        display:table-header-group;\n        .nk-file-item{\n            > div{\n                font-weight: $fw-medium;\n                font-size: 0.8125rem;\n                padding: 0.25rem;\n                &:first-child{\n                    padding-left: 0;\n                }\n                &:last-child{\n                    padding-right: .5rem;\n                }\n            }\n        }\n        .dropdown-menu-xs {\n            min-width: 140px;\n            max-width: 140px;\n        }\n    }\n    &-list{\n        display:table-row-group;\n    }\n\n    // VIEW LIST\n    &-view-list {\n        display: table;\n        width: 100%;\n        .nk-file{\n            display:table-row;\n            &.selected {\n                background: $accent-200;\n                 > div {\n                    background: transparent;\n                 }\n            }\n            > div{\n                padding: .5rem .375rem;\n                height: 4rem;\n                background-color: $white;\n                &:first-child{\n                    padding-left: 1.25rem;\n                }\n                &.nk-file-info {\n                    padding-top: 0.125rem;\n                    padding-bottom: 0.125rem;\n                }\n            }\n            &:first-child{\n                > div{\n                    &:first-child{\n                        border-top-left-radius: $border-radius;\n                    }\n                    &:last-child{\n                        border-top-right-radius: $border-radius;\n                    }\n                }\n            }\n            &:last-child{\n                > div{\n                    &:first-child{\n                        border-bottom-left-radius: $border-radius;\n                    }\n                    &:last-child{\n                        border-bottom-right-radius: $border-radius;\n                    }\n                }\n            } \n            &:not(:last-child){\n                > div{\n                    border-bottom: 1px solid $border-color;\n                }\n            } \n            .custom-checkbox{\n                margin-right: 1rem;\n            }\n            &-members{\n                .tb-shared{\n                    position: absolute;\n                    left: -1rem;\n                    top: 50%;\n                    transform: translateY(-50%);\n                    font-size: 1rem;\n                }\n            }\n            &-name-text {\n                a.title {\n                    padding: 1rem 0 0.875rem;\n                }\n            }\n            &-icon {\n                + .nk-file-name a.title {\n                    padding-left: ($fmg-file-icon-width-sm + 8px);\n                    margin-left: -($fmg-file-icon-width-sm + 8px);\n                }\n            }\n        }\n        &.is-compact{\n            .nk-file{\n                > div{\n                    height: 3rem;\n                }\n            }\n        }\n    }\n\n    // COMMON FOR GRID & GROUP VIEW\n    &-view-grid, &-view-group {\n        .nk-files-head{\n            margin-bottom: 0.25rem;\n            width: 100%;\n            display: flex;\n            .nk-file-item{\n                display: flex;\n                justify-content: space-between;\n                align-items: center;\n                width: 100%;\n                padding: 0;\n                > div:not(.nk-file-info):not(.nk-file-actions){\n                    display: none;\n                }\n            }\n            .nk-file-actions {\n                width: 30px;\n                padding: 0 !important;\n                margin-right: -4px;\n            }\n        }\n        .nk-files-list {\n            display:flex;\n            flex-wrap:wrap;\n            margin: -8px;\n            .nk-file-actions {\n                position: absolute;\n                border: 0 none;\n                background: transparent;\n                width: 46px;\n                right: 4px;\n                top: 10px;\n            }\n            .custom-control{\n                position: absolute;\n            }\n        }\n        .nk-file{\n            display: flex;\n            position: relative;\n            margin: 8px;\n            background: $white;\n            border-radius: $border-radius;\n            .nk-file-members{\n                display: none;\n            }\n        }\n    }\n\n    // VIEW GRID\n    &-view-grid {\n        .nk-file{\n            display: block;\n            position: relative;\n            width: calc(50% - 16px);\n            text-align: center;\n            padding: .5rem 0.25rem;\n            > div {\n                display: block;\n                padding: 0;\n            }\n            &-title {\n                display: flex;\n                flex-direction: column;\n            }\n            &-icon {\n                display: block;\n                margin: 0;\n                width: 100%;\n                &-type {\n                    width: $fmg-file-icon-width-lg;\n                    padding: .5rem 0;\n                }\n            }\n            &-name {\n                .title {\n                    padding: .5rem 0.125rem .5rem;\n                }\n                &-text {\n                    padding-left: 1.5rem;\n                    padding-right: 1.5rem;\n                }\n            }\n            &-desc {\n                padding: 0 .25rem .75rem;\n                margin-top: -0.125rem;\n                justify-content: center;\n                .members {\n                    display: none;\n                }\n            }\n            &-info > .nk-file-link {\n                padding: .5rem 0;\n            }\n            .nk-file-members{\n                display: none;\n            }\n            .nk-file-meta {\n                padding-bottom: .5rem;\n            }\n            .custom-control{\n                top: .75rem;\n                left: 1rem;\n            }\n        }\n    }\n\n    // VIEW GROUP\n    &-view-group {\n        .nk-file{\n            position: relative;\n            padding: .5rem .5rem;\n            width: 100%;\n            > div {\n                display: block;\n                width: 100%;\n                padding-right: 2.5rem;\n            }\n            &-desc {\n                padding: .25rem .125rem 0;\n            }\n            &-name-text {\n                a.title {\n                    padding: .125rem 0;\n                }\n            }\n            &-icon {\n                + .nk-file-name a.title {\n                    padding-left: ($fmg-file-icon-width-sm + 8px);\n                    margin-left: -($fmg-file-icon-width-sm + 8px);\n                }\n            }\n            .nk-file-actions {\n                right: 2px;\n                top: 4px;\n            }\n            .custom-control{\n                right: .5rem;\n                bottom: .5rem;\n            }\n            .nk-file-meta{\n                display: none;\n            }\n        }\n    }\n\n    &-group{\n        > .title{\n            border-top:1px solid $border-light;\n            font-size: $fx-sz-12;\n            letter-spacing: 0.04em;\n            text-transform: uppercase;\n            padding: 1rem 0;\n            margin: 0;\n        }\n        + .nk-files-group{\n            margin-top: 3rem;\n        }\n    }\n}\n\n@include media-breakpoint-down(sm){\n    .nk-file {\n        &-name-text {\n            font-size: $fx-sz-13;\n            .nk-files-view-grid & {\n                font-size: $fx-sz-12;\n            }\n        }\n    }\n}\n@include media-breakpoint-down(md){\n    .nk-fmg-body .nk-block-tools .btn-icon.btn-trigger .icon {\n        font-size: 1.25rem;\n    }\n}\n@include media-breakpoint-up(sm){\n    .nk-files-view{\n        &-grid {\n            .nk-file{\n                width: calc(33.33% - 16px);\n            }\n        }\n        &-group {\n            .nk-file{\n                width: calc(100% - 16px);\n            }\n        }\n    }\n}\n\n@media (min-width:660px){\n    .nk-files-view{\n        &-group {\n            .nk-file{\n                width: calc(50% - 16px);\n            }\n        }\n    }\n}\n\n@include media-breakpoint-up(xl){\n    .nk-files-view{\n        &-grid {\n            .nk-file{\n                width: calc(25% - 16px);\n            }\n        }\n        &-group {\n            .nk-file{\n                width: calc(50% - 16px);\n            }\n        }\n    }\n}\n\n@include media-breakpoint-up(xxl){\n    .nk-files-view{\n        &-grid {\n            .nk-file{\n                width:calc(20% - 16px);\n            }\n        }\n        &-group {\n            .nk-file{\n                width: calc(33.33% - 16px);\n            }\n        }\n    }\n}\n\n@media (min-width: 1800px) {\n    .nk-files-view{\n        &-grid {\n            .nk-file{\n                width:calc(16.66% - 16px);\n            }\n        }\n        &-group {\n            .nk-file{\n                width: calc(25% - 16px);\n            }\n        }\n    }\n}\n\n@media (max-width: 1199px) and (min-width: 992px), (max-width: 767px) {\n    .nk-files-view-list {\n        .nk-file-members, .nk-file-size {\n            display: none !important;\n        }\n    } \n}\n@media (max-width: 599px) {\n    .nk-files-view-list {\n        .nk-file {\n            &-icon-type {\n                width: $fmg-file-icon-width-xs;\n            }\n            &-meta, &-date, &-size {\n                display: none !important;\n            }\n            .custom-checkbox {\n                margin-right: 0.75rem;\n            }\n        } \n    }\n}\n@media (max-width:359px){\n    .nk-files-view{\n        &-grid {\n            .nk-file{\n                width: 100%;\n            }\n        }\n    }\n}\n\n// Upload\n.nk-upload{\n    &-form{\n        margin-bottom: 2.25rem;\n    }\n    &-list{\n        > .title{\n            font-size:.875rem;\n            padding-bottom: 1rem;\n        }\n    }\n    &-item{\n        display: flex;\n        align-items: center;\n        padding: .5rem;\n        border-radius: $border-radius;\n        border: 1px solid $border-light;\n        margin: .5rem 0;\n    }\n    &-icon {\n        width: 48px;\n        margin-right: .25rem;\n        flex-shrink: 0;\n    }\n    &-info {\n        font-weight: $fw-medium;\n        color: $base-color;\n        flex-grow: 1;\n        padding-right: .75rem;\n    }\n    &-title{\n        display: flex;\n        align-items: flex-end;\n        .title {\n            font-size: .875rem;\n        }\n        .meta{\n            font-size: $fx-sz-12;\n            margin-left: auto;\n            color:$base-light;\n            font-weight: $fw-normal;\n        }\n    }\n    &-size{\n        font-size: $fx-sz-12;\n        color: $base-light;\n        font-weight: $fw-normal;\n    }\n    &-progress{\n        margin: .375rem 0 .25rem;\n    }\n    &-action{\n        margin-left: auto;\n    }\n}","// Variables\n$chat-aside-gap-x: 1.25rem;\n$chat-aside-gap-x-tab: 2.25rem;\n$chat-aside-gap-x-desk: 1.75rem;\n\n$chat-body-gap-x: 1.25rem;\n$chat-body-gap-x-tab: 2.25rem;\n$chat-body-gap-x-desk: 1.75rem;\n\n$chat-aside-width: 320px;\n$chat-aside-width-lg: 325px;\n$chat-aside-width-xl: 382px;\n\n$chat-profile-width: 325px;\n$chat-profile-width-xl: 365px;\n$chat-profile-width-sm: 280px;\n\n$chat-meta-sap: $ni-dot !default;\n\n// for Extend\n.add-opt {\n  &:hover {\n    .sub-text,\n    .icon {\n      color: $accent-color;\n    }\n  }\n}\n.add-opt-icon {\n  .icon {\n    &-circle {\n      height: 32px;\n      width: 32px;\n      font-size: 1rem;\n    }\n    + span,\n    + div {\n      margin-left: 0.75rem;\n    }\n  }\n}\n\n// Chat Listing\n.chat {\n  &-item {\n    position: relative;\n    border-radius: $border-radius;\n    transition: background-color 0.3s;\n    &:hover {\n      background-color: $light-100;\n      .chats-dropdown & {\n        background-color: $lighter;\n      }\n      .chat-actions {\n        opacity: 1;\n        pointer-events: initial;\n        transition: opacity 0.5s;\n      }\n    }\n    &.current {\n      background-color: $lighter;\n      &:hover {\n        background-color: $light-100;\n      }\n    }\n  }\n  &-link {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    padding: 0.75rem;\n    cursor: pointer;\n  }\n  &-media {\n    height: 44px;\n    width: 44px;\n    + .chat-info {\n      margin-left: 0.75rem;\n    }\n  }\n  &-info {\n    width: calc(100% - 3.75rem);\n  }\n  &-from {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    .name {\n      font-size: 0.9375rem;\n      margin-bottom: 0;\n      font-weight: $fw-medium;\n      color: $base-text;\n      .is-unread & {\n        font-weight: $fw-bold;\n        color: $base-color;\n      }\n    }\n    .time {\n      font-size: $fx-sz-12;\n      color: $base-light;\n    }\n  }\n  &-context {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    .text {\n      width: calc(100% - 2.5rem);\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      font-size: $fx-sz-13;\n      color: $base-light;\n      .is-unread & {\n        font-weight: $fw-medium;\n        color: $base-text;\n      }\n    }\n    .status {\n      display: flex;\n      color: rgba($base-light, 0.8);\n      .is-unread & {\n        color: $accent-color;\n      }\n      &.seen {\n        color: $accent-color;\n      }\n    }\n  }\n  &-actions {\n    background-color: $light-100;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0.75rem;\n    opacity: 0;\n    pointer-events: none;\n    z-index: 2;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    width: 3rem;\n  }\n  &-profile {\n    &-group {\n      border-top: 1px solid $border-light;\n      padding: 0.25rem 0;\n    }\n    &-head {\n      padding: 1.25rem 1.5rem;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      .title {\n        margin-bottom: 0;\n      }\n      .indicator-icon {\n        display: inline-flex;\n      }\n      &.collapsed {\n        .indicator-icon {\n          transform: rotate(-180deg);\n        }\n      }\n    }\n    &-body {\n      &-inner {\n        padding: 0 1.5rem 1.5rem;\n      }\n    }\n    &-options {\n      margin: -0.25rem;\n      li {\n        padding: 0.25rem;\n      }\n    }\n    &-settings {\n      margin: -0.5rem;\n      li {\n        padding: 0.5rem;\n      }\n      .custom-control-sm .custom-control-label {\n        padding-left: 0.25rem;\n        font-size: $fx-sz-13;\n        font-weight: $fw-medium;\n        color: $base-text;\n      }\n    }\n    &-media {\n      display: flex;\n      margin: -0.25rem;\n      li {\n        width: 33.33%;\n        padding: 0.25rem;\n        a {\n          display: inline-block;\n        }\n        img {\n          border-radius: $border-radius;\n        }\n      }\n    }\n  }\n  &-option {\n    &-link {\n      display: flex;\n      align-items: center;\n      .lead-text {\n        font-weight: $fw-medium;\n        font-size: $fx-sz-13;\n        transition: color 0.3s;\n        color: $base-text;\n      }\n      @extend .add-opt-icon;\n      &:hover .lead-text {\n        color: $base-dark;\n      }\n    }\n  }\n\n  &-members {\n    margin: -0.375rem -0.5rem;\n    li {\n      position: relative;\n    }\n    &-link {\n      display: flex;\n      align-items: center;\n      padding: 0.375rem 0.5rem;\n      @extend .add-opt-icon;\n    }\n    .user {\n      &-card {\n        position: relative;\n        padding: 0.375rem 0.5rem;\n        border-radius: $border-radius-sm;\n        transition: background-color 0.3s;\n        > a {\n          width: 100%;\n          display: flex;\n          align-items: center;\n        }\n        &:hover {\n          background-color: $light-100;\n          .user-actions {\n            opacity: 1;\n            pointer-events: initial;\n            transition: opacity 0.5s;\n          }\n        }\n      }\n      &-role {\n        margin-left: auto;\n        font-size: $fx-sz-12;\n        color: $base-light;\n      }\n      &-actions {\n        position: absolute;\n        top: 0;\n        right: 0.25rem;\n        bottom: 0;\n        width: 3rem;\n        background-color: $light-100;\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        opacity: 0;\n        pointer-events: none;\n      }\n    }\n  }\n}\n.chat {\n  display: flex;\n  align-items: flex-end;\n  margin: -4px;\n  > div {\n    padding: 4px;\n  }\n  + .chat {\n    padding-top: 0.5rem;\n  }\n  &-avatar {\n    margin-bottom: 1.4rem;\n    &.no-meta {\n      margin-bottom: 0;\n    }\n  }\n  &-bubble {\n    display: flex;\n    align-items: center;\n    padding: 0.125rem 0;\n    &:hover {\n      .chat-msg-more {\n        opacity: 1;\n      }\n    }\n    &s {\n      .attach-files {\n        margin-top: 0.75rem;\n      }\n    }\n  }\n  &-msg {\n    background-color: $white;\n    border-radius: $border-radius-xl;\n    padding: 5px 5px 8px 5px;\n    word-break: normal;\n    word-wrap: normal;\n    overflow-wrap: normal;\n    white-space: normal;\n    &-more {\n      display: flex;\n      align-items: center;\n      margin: 0 0.75rem;\n      opacity: 0;\n      flex-shrink: 0;\n      transition: all 0.3s;\n      > li {\n        padding: 0.25rem;\n      }\n    }\n    &.is-light {\n      background-color: $light;\n      color: $base-text;\n    }\n    &.is-theme {\n      background-color: $accent-color;\n      color: $white;\n    }\n  }\n  &-meta {\n    display: flex;\n    align-items: center;\n    margin: 0.25rem -0.375rem 0;\n    li {\n      position: relative;\n      padding: 0 0.375rem;\n      font-size: $fx-sz-12;\n      color: $base-light;\n      &:not(:first-child):before {\n        content: $chat-meta-sap;\n        font-family: $nk-dashlite-font;\n        position: absolute;\n        left: 0;\n        top: 50%;\n        font-size: 11px;\n        line-height: 10px;\n        transform: translate(-50%, -50%);\n        opacity: 0.8;\n      }\n    }\n  }\n  &-sap {\n    overflow: hidden;\n    text-align: center;\n    padding: 1rem 0;\n    &-meta {\n      position: relative;\n      display: inline-block;\n      padding: 0 0.75rem;\n      color: $base-light;\n      font-size: $fx-sz-12;\n      line-height: 1.4;\n      &:before,\n      &:after {\n        position: absolute;\n        height: 1px;\n        background: $border-color;\n        content: \"\";\n        width: 100vw;\n        top: 50%;\n      }\n      &:before {\n        right: 100%;\n      }\n      &:after {\n        left: 100%;\n      }\n    }\n  }\n\n  &.is-you {\n    .chat-bubble {\n      &s {\n        .attach-files {\n          border-color: $white;\n          overflow: hidden;\n        }\n        .attach-files,\n        .attach-foot {\n          background-color: $white;\n        }\n      }\n      &:last-child {\n        .chat-msg {\n          border-bottom-left-radius: 0;\n        }\n      }\n      &:not(:first-child) {\n        .chat-msg {\n          border-top-left-radius: $border-radius;\n        }\n      }\n      &:not(:last-child) {\n        .chat-msg {\n          border-bottom-left-radius: $border-radius;\n        }\n      }\n    }\n  }\n  &.is-me {\n    justify-content: flex-end;\n    .chat-msg {\n      background-color: $chat-color;\n      color: $black;\n    }\n    .chat-meta {\n      justify-content: flex-end;\n    }\n    .chat-bubble {\n      flex-direction: row-reverse;\n      &s {\n        .attach-files {\n          border-color: $accent-300;\n          overflow: hidden;\n        }\n        .attach-files,\n        .attach-foot {\n          background-color: $white;\n        }\n      }\n      &:last-child {\n        .chat-msg {\n          border-bottom-right-radius: 0;\n        }\n      }\n      &:not(:first-child) {\n        .chat-msg {\n          border-top-right-radius: $border-radius;\n        }\n      }\n      &:not(:last-child) {\n        .chat-msg {\n          border-bottom-right-radius: $border-radius;\n        }\n      }\n    }\n  }\n\n  // Upload option\n  &-upload-option {\n    display: none;\n    position: absolute;\n    left: 100%;\n    padding: 0.5rem;\n    background-color: $white;\n    &.expanded {\n      display: block;\n    }\n    ul {\n      display: flex;\n      align-items: center;\n    }\n    a {\n      color: $accent-color;\n      font-size: 1.25rem;\n      height: 36px;\n      width: 36px;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      &:hover {\n        color: darken($accent-color, 8%);\n      }\n    }\n  }\n}\n\n.fav-list {\n  display: flex;\n  margin: -0.375rem;\n  overflow-x: auto;\n  li {\n    padding: 0.375rem;\n  }\n  a:hover > .user-avatar:after {\n    opacity: 1;\n  }\n  .user-avatar {\n    height: 44px;\n    width: 44px;\n    &:after {\n      content: \"\";\n      position: absolute;\n      width: 100%;\n      left: 0;\n      height: 100%;\n      background: $light-200;\n      transform: scale(1.15);\n      opacity: 0;\n      border-radius: 50%;\n      z-index: -1;\n      transition: opacity 0.3s;\n    }\n  }\n}\n\n@include media-breakpoint-up(md) {\n  .fav-list {\n    flex-wrap: wrap;\n  }\n}\n@media (max-width: 859px) {\n  .fav-list {\n    margin: -0.375rem 0;\n    li {\n      &:first-child {\n        padding-left: 0;\n      }\n      &:last-child {\n        padding-right: 0;\n      }\n    }\n  }\n}\n\n.channel-list {\n  li {\n    margin: 0.125rem -0.5rem;\n  }\n  a {\n    padding: 0.375rem 0.5rem;\n    display: block;\n    transition: all 0.3s;\n    font-weight: $fw-medium;\n    color: $base-text;\n    border-radius: $border-radius-sm;\n    &:hover,\n    &.active {\n      color: $accent-color;\n      background: $accent-100;\n    }\n  }\n}\n\n.contacts {\n  &-list {\n    margin: -0.375rem -0.5rem;\n    & + .contacts-list {\n      margin-top: 1.75rem;\n    }\n    li {\n      position: relative;\n      > .title {\n        padding-left: 1.25rem;\n        margin-bottom: 0.25rem;\n      }\n    }\n    .user {\n      &-card {\n        position: relative;\n        padding: 0.375rem 0.5rem;\n        border-radius: $border-radius-sm;\n        transition: background-color 0.3s;\n        > a {\n          width: 100%;\n          display: flex;\n          align-items: center;\n        }\n        &:hover {\n          background-color: $light-100;\n          .user-actions {\n            opacity: 1;\n            pointer-events: initial;\n            transition: opacity 0.4s;\n          }\n        }\n      }\n      &-meta {\n        margin-left: auto;\n        font-size: $fx-sz-12;\n        color: $base-light;\n      }\n      &-actions {\n        font-size: 12px;\n        position: absolute;\n        top: 0;\n        right: 0.25rem;\n        bottom: 0;\n        width: 4.5rem;\n        background-color: $light-100;\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        opacity: 0;\n        pointer-events: none;\n        > a {\n          padding: 0 0.375rem;\n        }\n      }\n    }\n  }\n  &-add-link {\n    padding: 0.375rem 0.5rem;\n    display: flex;\n    align-items: center;\n    .lead-text {\n      font-weight: $fw-medium;\n      font-size: $fx-sz-13;\n    }\n    @extend .add-opt-icon;\n  }\n}\n\n// Chat Layouts\n.nk-chat {\n  position: relative;\n  display: flex;\n  overflow: hidden;\n  min-height: calc(100vh - (64px));\n  max-height: calc(100vh - (#{$header-height} + 64px));\n  background: $white;\n  &-blank {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    height: 100%;\n    background-color: $light;\n    &-icon {\n      margin-bottom: 1.5rem;\n    }\n  }\n  &-aside {\n    background: $white;\n    width: 100%;\n    overflow: hidden;\n    max-height: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    flex-shrink: 0;\n    &-head {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      padding: 1.125rem $chat-aside-gap-x 0.875rem;\n    }\n    &-user {\n      .title {\n        font-size: 1.375rem;\n        color: $base-color;\n      }\n      .user-avatar {\n        height: 36px;\n        width: 36px;\n        + .title {\n          margin-left: 1rem;\n        }\n      }\n      .dropdown-toggle {\n        &:after {\n          font-size: 1.125rem;\n          color: $base-light;\n          margin-left: 1rem;\n        }\n      }\n    }\n    &-tools {\n      display: flex;\n      align-items: center;\n    }\n    &-body {\n      max-height: 100%;\n      height: 100%;\n      overflow: auto;\n    }\n    &-search {\n      padding: 0 $chat-aside-gap-x;\n      margin-bottom: 1.75rem;\n      margin-top: 0.25rem;\n      .form-control {\n        background-color: $lighter;\n        border-color: $lighter;\n        &::placeholder {\n          color: $base-light;\n        }\n      }\n    }\n  }\n  &-aside-panel {\n    padding: 0 $chat-aside-gap-x 1.75rem;\n    .title {\n      margin-bottom: 0.75rem;\n    }\n  }\n  &-list {\n    padding: 0 ($chat-aside-gap-x - 0.75rem);\n    .title {\n      margin-left: 0.75rem;\n    }\n  }\n  &-body {\n    background: $white;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    transition: padding 0.3s ease-in-out;\n    opacity: 0;\n    pointer-events: none;\n    z-index: 5;\n    &.show-chat {\n      opacity: 1;\n      pointer-events: auto;\n    }\n  }\n  &-head {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 1rem 1.75rem;\n    border-bottom: 1px solid $border-light;\n    background-color: $white;\n    &-info {\n      width: 60%;\n      .user-avatar + .user-info {\n        margin-left: 0.75rem;\n      }\n      .user-info {\n        .lead-text {\n          display: block;\n          text-overflow: ellipsis;\n          overflow: hidden;\n          white-space: nowrap;\n        }\n      }\n    }\n    &-info,\n    &-tools {\n      display: flex;\n      align-items: center;\n      margin: -0.125rem;\n      > li {\n        padding: 0.125rem;\n      }\n      .btn-icon {\n        .icon {\n          font-size: 1.25rem;\n        }\n      }\n    }\n    &-search {\n      position: absolute;\n      top: calc(100% + 1rem);\n      left: 0;\n      z-index: 9;\n      width: 100%;\n      padding: 0 1.75rem;\n      opacity: 0;\n      pointer-events: none;\n      transform: translateY(-10px);\n      transition: all 0.5s;\n      &.show-search {\n        opacity: 1;\n        pointer-events: auto;\n        transform: none;\n      }\n    }\n  }\n  &-panel {\n    background-color: rgba($light, 0.7);\n    height: 100%;\n    max-height: 100%;\n    overflow: auto;\n    padding: 1.25rem;\n  }\n  &-editor {\n    display: flex;\n    align-items: center;\n    padding: 1rem 1.25rem;\n    background-color: $white;\n    &-form {\n      padding: 0 0.5rem;\n      flex-grow: 1;\n      .form-control {\n        min-height: 36px;\n        padding-top: 0.5rem;\n      }\n    }\n    &-upload,\n    &-tools {\n      display: flex;\n      align-items: center;\n      .btn-icon {\n        .icon {\n          font-size: 1.5rem;\n        }\n      }\n    }\n    &-upload {\n      position: relative;\n      z-index: 2;\n      .toggle-opt {\n        transition: 0.3s;\n        &.active {\n          opacity: 0.7;\n          transform: rotate(-45deg);\n        }\n      }\n    }\n  }\n  &-profile {\n    position: absolute;\n    top: 0;\n    right: 0;\n    transform: translateX(100%);\n    width: $chat-profile-width;\n    height: 100%;\n    max-height: 100%;\n    transition: transform 0.3s ease-in-out;\n    background: $white;\n    z-index: 100;\n    &-overlay {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      background: $sidebar-overlay;\n      z-index: 600;\n      z-index: 90;\n      animation: overlay-fade-in 0.4s ease 1;\n    }\n    &.visible {\n      transform: none;\n    }\n  }\n}\n\n@include media-breakpoint-down(sm) {\n  .nk-chat {\n    border: none;\n    border-radius: $border-radius;\n    min-height: calc(100vh - (#{$header-height} + 85px));\n    max-height: calc(100vh - (#{$header-height} + 85px));\n    &-head {\n      padding: 0.75rem 1.25rem;\n      &-user {\n        max-width: calc(100% - 34px);\n        .user-avatar {\n          height: 36px;\n          width: 36px;\n        }\n        .user-info {\n          width: calc(100% - 36px - 0.75rem);\n        }\n      }\n    }\n  }\n}\n\n@include media-breakpoint-up(sm) {\n  .nk-chat {\n    &-head {\n      &-info,\n      &-tools {\n        margin: -0.375rem;\n        > li {\n          padding: 0.375rem;\n        }\n      }\n    }\n  }\n}\n@media (min-width: 576px) and (max-width: 991px) {\n  .nk-chat {\n    &-aside {\n      &-head,\n      &-search {\n        padding-left: $chat-aside-gap-x-tab;\n        padding-right: $chat-aside-gap-x-tab;\n      }\n    }\n    &-aside-panel {\n      padding: 0 $chat-aside-gap-x-tab 1.75rem;\n    }\n    &-list {\n      padding: 0 ($chat-aside-gap-x-tab - 0.75rem);\n    }\n    &-head,\n    &-panel,\n    &-editor {\n      padding-left: $chat-body-gap-x-tab;\n      padding-right: $chat-body-gap-x-tab;\n    }\n    &-head {\n      &-search {\n        padding: 0 $chat-body-gap-x-tab;\n      }\n    }\n  }\n}\n\n@media (min-width: 860px) {\n  .nk-chat {\n    &-aside {\n      width: $chat-aside-width;\n      border-right: 1px solid $border-light;\n    }\n    &-body {\n      position: static;\n      opacity: 1;\n      pointer-events: auto;\n      &-close {\n        display: none;\n      }\n    }\n  }\n}\n@media (max-width: 859px) {\n  .nk-chat {\n    &-body {\n      &.show-chat {\n        position: fixed;\n        z-index: 2999;\n      }\n    }\n    &-head {\n      padding-top: 0.75rem;\n      padding-bottom: 0.75rem;\n    }\n  }\n}\n\n@media (min-width: 860px) and (max-width: 991px) {\n  .nk-chat {\n    &-aside {\n      width: $chat-aside-width + 25px;\n      border-right: 1px solid $border-light;\n    }\n  }\n}\n@media (max-width: 1300px) {\n  .nk-chat {\n    &-profile {\n      width: 100%;\n    }\n  }\n}\n@include media-breakpoint-up(lg) {\n  .nk-chat {\n    &-aside-panel,\n    &-aside-head,\n    &-aside-search {\n      padding-left: $chat-aside-gap-x-desk;\n      padding-right: $chat-aside-gap-x-desk;\n    }\n    &-list {\n      padding: 0 ($chat-aside-gap-x - 0.25rem);\n    }\n    &-aside {\n      width: $chat-aside-width-lg;\n    }\n    &-panel {\n      padding: 1.25rem 1.75rem;\n    }\n  }\n  .chat {\n    &-profile {\n      &-head,\n      &-body-inner {\n        padding-right: 1.75rem;\n        padding-left: 1.75rem;\n      }\n    }\n  }\n}\n@include media-breakpoint-up(xxl) {\n  .nk-chat {\n    &-aside {\n      width: $chat-aside-width-xl;\n    }\n    &-body {\n      &.profile-shown {\n        padding-right: $chat-profile-width-xl;\n      }\n    }\n    &-profile {\n      width: $chat-profile-width-xl;\n      border-left: 1px solid $border-light;\n    }\n  }\n}\n\n@include media-breakpoint-down(xl) {\n  .profile-shown {\n    .nk-chat-profile-toggle {\n      right: 262px;\n      .has-apps-sidebar & {\n        right: -18px;\n      }\n    }\n  }\n}\n\n@media (max-width: 359px) {\n  .nk-chat {\n    &-profile {\n      width: $chat-profile-width-xl;\n    }\n  }\n}\n","/// Preview Purpose\n/////////////////////////////\n.nk-code-preview-box{\n    display: block;\n    color: $base-light;\n    padding:.15rem 1.25rem;\n    border-left: 1px solid $border-light;\n}\n//\n.dashboard-preview{\n    height: 200px;\n    justify-content: center;\n}\n//\n.dropdown-preview{\n    .dropdown-menu{\n        position: static;\n        display: block;\n    }\n    &:after{\n        display: block;\n        clear: both;\n        content: \"\";\n    }\n}\n\n@media (max-width:420px){\n    .dropdown-preview{\n        .dropdown-menu-xl,.dropdown-menu-lg,.dropdown-menu-md{\n            min-width: 100%;\n            max-width: 100%;\n        }\n    }\n}\n// code highlight edit\n.prettyprint{\n    padding: 1.25rem;\n    white-space: pre;\n    box-shadow: none !important;\n    margin-bottom: 0;\n    border-radius: $border-radius;\n}\n\n.code-block{\n    position: relative;\n    padding:1.25rem;\n    background: $white;\n    border-radius: $border-radius;\n    .clipboard-init{\n        position: absolute;\n        top: 12px;\n        right: 12px;\n    }\n    .card-preview + &{\n        margin-top: 28px;\n    }\n    + .code-block {\n        margin-top: -($border-radius - 1);\n        border-top-color: $border-light;\n        border-radius: 0 0 $border-radius $border-radius;\n    }\n    + .card-preview, + .nk-block-head {\n        margin-top: 40px;\n    }\n    .prettyprint{\n        background: $lighter;\n        border: none;\n        padding:.75rem;\n        font-size: 11px;\n        line-height: 20px;\n        max-height: 136px;\n    }\n    .title{\n        margin-bottom: 1rem;\n    }\n    .btn {\n        background-color: $white;\n        &:focus, &:hover {\n            border-color: $border-color;\n            box-shadow: none;\n        }\n    }\n    &-clean {\n        .title {\n            font-size: $fx-sz-11;\n            letter-spacing: 0.2em;\n            text-transform: uppercase;\n            color: $base-light;\n            font-weight: $fw-medium;\n            display: block;\n        }\n    }\n}\n\n//Icon\n.preview{\n    &-icon{\n        &-list{\n            display: flex;\n            flex-wrap: wrap;\n            margin: -15px;\n        }\n        &-item{\n            flex: 1 0 150px;\n            padding: 15px;\n            max-width: 50%;\n        }\n        &-box{\n            position: relative;\n            padding: 25px 20px;\n            text-align: center;\n            .btn-clipboard{\n                position: absolute;\n                top: 0;\n                right: 0;\n                opacity: 0;\n                z-index: 1;\n                &:focus{\n                    border-color:transparent;\n                    box-shadow: none;\n                }\n            }\n            &:hover{\n                .btn-clipboard{\n                    opacity: 1;\n                }\n            }\n            \n        }\n        &-wrap{\n            padding-bottom: 5px;\n            .ni{\n                font-size: 30px;\n            }\n            .preview-icon-svg &{\n                margin-bottom: .5rem;\n                svg{\n                    width: 90px;\n                }\n            }\n        }\n        &-name{\n            color: $base-light;\n            font-size: 11px;\n        }\n    }\n}\n.preview {\n    &-title, &-title-lg {\n        display: block;\n        padding-bottom: .75rem;\n    }\n    &-title-lg {\n        font-size: $fx-sz-13;\n    }\n    &-hr {\n        border-top: 1px solid $border-color;\n        margin-top: 2rem;\n        margin-bottom: 2rem;\n        + .preview-title {\n            padding-top: .5rem;\n        }\n        .nk-block-head + & {\n            margin-top: .5rem;\n        }\n    }\n    &-list{\n        display: flex;\n        flex-wrap: wrap;\n        margin: -0.75rem\n    }\n    &-item {\n        padding: 0.75rem;\n    }\n    &-btn {\n        &-list{\n            display: flex;\n            flex-wrap: wrap;\n            margin: -0.75rem\n        }\n        &-item {\n            width: 50%;\n            padding: 0.75rem;\n            .preview-btn-list-fw & {\n                width: 100%;\n            }\n            .preview-btn-list-3x & {\n                width: 33.33%;\n            }\n        }\n    }\n}\n.example{\n    &-width, &-height, &-border, &-spacing {\n        & > div {\n            font-size: $fx-sz-11;\n            padding: .5rem;\n            text-align: center;\n            background-color: $lighter;\n            \n        }\n    }\n    &-border{\n        margin: -0.5rem;\n        > div {\n            height: 4.5rem;\n            width: 4.5rem;\n            margin: .5rem;\n        }\n    }\n    &-border-all > div {\n        border: 1px solid $border-color;\n    }\n    &-width > div {\n        height: 2rem;\n        background-color: $light;\n        margin-bottom: 0.25rem;\n    }\n    &-height {\n        height: 8rem;\n        & > div {\n            width: 8rem;\n            background-color: $light;\n            margin-right: .5rem;\n        }\n    }\n    &-spacing {\n        & > div {\n            height: 2rem;\n            width: 4.5rem;\n            background-color: $light;\n            margin-bottom: .5rem;\n        }\n        &-pd > div {\n            margin-right: .5rem;\n            height: auto;\n            width: auto;\n            > span {\n                display: block;\n                padding: .25rem;\n                line-height: 1;\n                border-radius: 2px;\n                background-color: $white;\n            }\n        }\n    }\n    &-alerts {\n        &:not(:last-child){\n            margin-bottom: $gutter-width;\n        }\n    }\n}\n\n.components-preview {\n    h4.title, h5.title {\n        font-size: 1.25rem;\n        letter-spacing: -0.01rem;\n        font-family: $base-font-family;\n        font-weight: $fw-medium;\n    }\n    .card-preview > .card-inner{\n        padding: 1.25rem;\n    }\n}\n@include media-breakpoint-up(md){\n    .preview {\n        &-btn-item {\n            width: 25%;\n            .preview-btn-list-fw & {\n                width: 25%;\n            }\n            .preview-btn-list-3x & {\n                width: 16.66%;\n            }\n        }\n    }\n}\n@include media-breakpoint-up(lg){\n    .components-preview {\n        .nk-block + .nk-block-lg {\n            padding-top: 3.75rem;\n        }\n    }\n}\n@include media-breakpoint-down(sm){\n    .preview {\n        &-reference {\n            tr, th, td {\n                display: block;\n                border:0;\n                width: 100% !important;\n            }\n            tbody tr {\n                padding: .5rem 0;\n                &:not(:last-child){\n                    border-bottom: 1px solid $border-light;\n                }\n                &:nth-child(2n){\n                    background-color: rgba($lighter, .3);\n                }\n            }\n            tr td {\n                padding:0.2rem 1.25rem;\n            }\n            tr th:not(:first-child) {\n                display: none;\n            }\n        }\n    }\n}\n\n// DEMO Settings Panel for Preview\n////////////////////////////////////////////\n$rtl: false !default;\n$dark-body-bg: $darker !default;\n$dark-card-bg: darken($dark, 6%) !default;\n$dark-border-color: lighten($darker, 8%) !default;\n\n.nk-sticky-toolbar{\n    position: fixed;\n    border: 3px solid $white;\n    top: 50%;\n    background:#fff;\n    z-index: 600;\n    @if($rtl==false){\n        right: 0;\n        border-radius: 6px 0 0 6px;\n        border-right: 0;\n        box-shadow: -2px 0 24px -2px rgba($shadow-color, .15);\n    }\n    @if($rtl==true){\n        left: 0;\n        border-radius: 0 6px 6px 0;\n        border-left: 0;\n        box-shadow: 2px 0 24px -2px rgba($shadow-color, .15);\n    }\n    li{\n        &:not(:last-child){\n            border-bottom: 2px solid $white;\n        }\n        a{\n            display: flex;\n            height: 36px;\n            width: 36px;\n            align-items: center;\n            justify-content: center;\n            font-size: 18px;\n            color: inherit;\n        }\n    }\n}\n.demo-layout{\n    background-color: rgba($blue,.1);\n    color: $blue;\n}\n.demo-thumb{\n    background-color: rgba($success,.1);\n    color: $success;\n}\n.demo-settings{\n    background-color: rgba($purple,.1);\n    color: $purple;\n}\n.demo-purchase{\n    background-color: rgba($pink,.1);\n    color: $pink;\n}\n@include media-breakpoint-up(sm){\n    .nk-sticky-toolbar{\n        top: 30%;\n        li{\n            a{\n                font-size: 20px;\n                height: 44px;\n                width: 44px;\n            }\n            &.demo-thumb a{\n                font-size: 22px;\n            }\n        }\n    }\n}\n.nk-demo{\n    &-panel{\n        position: fixed;\n        @if($rtl==false){\n            right: 0;\n        }\n        @if($rtl==true){\n            left: 0;\n        }\n        top: 0;\n        width: 320px;\n        max-width: calc(100vw - 40px);\n        max-height: 100vh;\n        height: 100vh;\n        z-index: 9999;\n        background-color: $white;\n        box-shadow: $box-shadow;\n        padding:0 0 1.5rem;\n        + .toggle-overlay{\n            z-index: 9000;\n            background: rgba($darker, 0.05);\n        }\n        .dark-mode & {\n            box-shadow: 0 0 35px 5px rgba($black, .5);\n        }\n    }\n    &-head{\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: .75rem 1.5rem;\n        text-transform: uppercase;\n        border-bottom: 1px solid $border-light;\n        h6{\n            font-size: 13px;\n            letter-spacing: 0.1em;\n        }\n    }\n    &-list{\n        overflow: auto;\n        max-height: calc(100vh - 60px);\n    }\n    &-title{\n        display: block;\n        font-size: .875rem;\n        padding: .675rem 0;\n        text-align: center;\n        color: $base-text;\n        border-top: none;\n        border-radius: 0 0 $border-radius $border-radius;\n        .subtitle {\n            display: block;\n            color: $base-light;\n            font-size: 11px;\n        }\n    }\n    &-item{\n        padding: 2rem 1.5rem 1rem;\n        border-bottom: 1px solid $border-light;\n        a{\n            display: block;\n            &:hover{\n                .nk-demo-title{\n                    color: $accent-color;\n                }\n            }\n        }\n    }\n    &-image{\n        border: 1px solid $border-light;\n        border-radius: $border-radius $border-radius 0 0;\n        padding: 1rem 1rem 0 1rem;\n        img{\n            border-radius: inherit;\n        }\n    }\n    &-note{\n        background: $lighter;\n        padding-bottom: 2rem;\n    }\n}\n\n@include media-breakpoint-up(sm){\n    .nk-demo{\n        &-item{\n            padding: 2rem 2rem 1rem;\n        }\n        &-head{\n            padding: 15px 2rem 13px;\n        }\n        &-note{\n            padding-bottom: 2rem;\n        }\n    }\n}\n\n@include media-breakpoint-up(md){\n    .nk-demo{\n        &-panel{\n            &-2x{\n                width: 640px;\n                .nk-demo-list{\n                    .simplebar-content{\n                        display: flex;\n                        flex-wrap: wrap;\n                        .nk-demo-item{\n                            width: 50%;\n                            &:not(:nth-child(2n)){\n                                border-right: 1px solid $border-light;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n/// Color Scheme\n/////////////////////////\n.nk-opt {\n    &-panel {\n        overflow: auto;\n        max-height: calc(100vh - 84px);\n    }\n    &-reset{\n        padding: 1.5rem 1.5rem 1.5rem;\n    }\n    &-set {\n        padding: 1.5rem 1.5rem 1.5rem;\n        &:not(:last-child){\n            border-bottom: 1px solid $border-light;\n        }\n        &-title {\n            padding: 0 0 0.5rem;\n            text-transform: uppercase;\n            color: $base-light;\n            letter-spacing: 2px;\n            font-weight: $fw-medium;\n            font-size: 11px;\n        }\n    }\n    &-list {\n        padding: 0;\n        flex-wrap: wrap;\n        margin:-0.5rem;\n        display: flex;\n        & + .nk-opt-set-title {\n            margin-top: 1.25rem;\n        }\n    }\n    &-item {\n        width:33%;\n        text-align: center;\n        padding: 0.5rem;\n        &:not(.active):not(.disabled) {\n            cursor: pointer;\n        }\n        &.active {\n            cursor: default; \n        }\n        &.disabled {\n            pointer-events: none;\n            > .nk-opt-item-name {\n                opacity: .5;\n            }\n        }\n        .col-2x & {\n            width: 50%;\n        }\n        .col-4x & {\n            width: 25%;\n        }\n        &-name {\n            font-weight: 400;\n            color: $base-text;\n            font-size: 12px;\n            letter-spacing: 0.02em;\n            small {\n                font-size: 11px;\n            }\n            .dark-mode & {\n                color: $base-400;\n            }\n        }\n        &-bg {\n            background: $white;\n            width: 100%;\n            height: 32px;\n            border: 1px solid $border-color;\n            padding: 3px;\n            margin-bottom: 5px;\n            position: relative;\n            display: block;\n            border-radius: 2px;\n            transition: all 0.3s;\n            .dark-mode & {\n                border-color: $border-dark;\n            }\n            > span:not(.nk-opt-item-name) {\n                display: block;\n                background: $base-text;\n                height: 100%;\n                border-radius: 1px;\n                &.bg-theme {\n                    background: $accent-dark !important;\n                }\n                &.bg-light {\n                    background: $bg-light !important;\n                }\n                &.bg-lighter {\n                    background: $lighter !important;\n                }\n                &.bg-dark {\n                    background: $darker !important;\n                }\n                &.theme-light {\n                    background: linear-gradient(90deg, $lighter 0%, $lighter 50%, $light 50%, $light 100%) !important;\n                }\n                &.theme-dark {\n                    background: linear-gradient(90deg, $dark 0%, $dark 50%, $darker 50%, $darker 100%) !important;\n                }\n                &.skin-default {\n                    background: linear-gradient(90deg, $accent-dark 0%, $accent-dark 28%, $accent-color 28%, $accent-color 72%, $accent-300 72%, $accent-300 100%) !important;\n                }\n                &.skin-purple {\n                    background: linear-gradient(90deg, darken(#854fff, 20%) 0%, darken(#854fff, 20%) 28%, #854fff 28%, #854fff 72%, mix(#854fff, $white, 20%) 72%, mix(#854fff, $white, 20%) 100%) !important;\n                }\n                &.skin-green {\n                    background: linear-gradient(90deg, darken(#0fac81, 20%) 0%, darken(#0fac81, 20%) 28%, #0fac81 28%, #0fac81 72%, mix(#0fac81, $white, 20%) 72%, mix(#0fac81, $white, 20%) 100%) !important;\n                }\n                &.skin-blue {\n                    background: linear-gradient(90deg, darken(#0971fe, 20%) 0%, darken(#0971fe, 20%) 30%, #0971fe 30%, #0971fe 72%, mix(#0971fe, $white, 20%) 72%, mix(#0971fe, $white, 20%) 100%) !important;\n                }\n                &.skin-egyptian {\n                    background: linear-gradient(90deg, darken(#2e62b9, 20%) 0%, darken(#2e62b9, 20%) 30%, #2e62b9 30%, #2e62b9 72%, mix(#2e62b9, $white, 20%) 72%, mix(#2e62b9, $white, 20%) 100%) !important;\n                }\n                &.skin-red {\n                    background: linear-gradient(90deg, darken(#ee3148, 20%) 0%, darken(#ee3148, 20%) 30%, #ee3148 30%, #ee3148 72%, mix(#ee3148, $white, 20%) 72%, mix(#ee3148, $white, 20%) 100%) !important;\n                }\n                &.skin-bluelite {\n                    background: linear-gradient(90deg, darken(#6576ff, 20%) 0%, darken(#6576ff, 20%) 28%, #6576ff 28%, #6576ff 72%, mix(#6576ff, $white, 20%) 72%, mix(#6576ff, $white, 20%) 100%) !important;\n                }\n            }\n            &:hover, &:focus {\n                border-color: $border-light-alt;\n            }\n            .active > &{\n                border-color: $accent-color;\n                box-shadow: 0 0 0 2px rgba($accent-color, 0.2);\n                &:after{\n                    font-family: $nk-dashlite-font;\n                    content: $ni-check-thick;\n                    position: absolute;\n                    left: 50%;\n                    top: 50%;\n                    transform: translate(-50%, -50%);\n                    color: $white;\n                    font-size: 0.875rem;\n                }\n                &.is-light:after {\n                    color: $darker;\n                }\n            }\n            .only-text > & {\n                margin-bottom: 0;\n                height: 28px;\n                &:after {\n                    display: none;\n                }\n            }\n            .disabled > & {\n                border-color: $border-light !important;\n                .dark-mode & {\n                    border-color: $border-dark !important;\n                }\n            }\n            > .nk-opt-item-name {\n                color: $base-color;\n                font-size: 10px;\n                line-height: 1;\n                text-transform: uppercase;\n                font-weight: 500;\n                letter-spacing: 0.12em;\n                position: absolute;\n                top: 50%;\n                left: 50%;\n                transform: translate(-50%, -50%);\n                width: 100%;\n                .dark-mode & {\n                    color: $base-300;\n                }\n                .active > & {\n                    color: $accent-color;\n                    font-weight: 700;\n                }\n            }\n        }\n    }\n}\n\n@media (min-width: 576px) {\n    .nk-opt {\n        &-set, &-reset {\n            padding-left:2rem;\n            padding-right:2rem;\n        }\n    }\n}\n\n// Promo\n.pmo {\n    &-lv {\n        position: fixed;\n        left: 50%;\n        bottom: -50px;\n        max-width: 90%;\n        width: 590px;\n        transform: translate(-50%, 100%);\n        transition: all .4s;\n        background: #fff;\n        border-radius: 50px;\n        box-shadow: 0 0 40px -2px rgba($dark, .25);\n        z-index: 9999;\n        &.active {\n            transform: translate(-50%, 0);\n            bottom: 20px;\n            transition-delay: 1s\n        }\n        &.pmo-dark {\n            background: darken($blue, 20%);\n        }\n    }\n    &-close {\n        color: $base-color;\n        border-radius: 50%;\n        height: 36px;\n        width: 36px;\n        line-height: 38px;\n        background: rgba($light-400, .6);\n        text-align: center;\n        display: inline-block;\n        position: absolute;\n        top: 50%;\n        margin-top: -18px;\n        right: 8px;\n        font-size: 16px;\n        z-index: 99;\n        &:hover {\n            color: $white;\n            background: $base-text;\n        }\n        .pmo-dark & {\n            background: rgba($dark, .3);\n            color: $white;\n            &:hover {\n                background: rgba($dark, .5);\n            }\n        }\n    }\n    &-wrap {\n        display: flex;\n        padding: .875rem 3.5rem .875rem 1.5rem;\n        align-items: center;\n        border-radius: 50px;\n        transition: all 300ms;\n        &:hover {\n            transform: translateX(5px);\n        }\n    }\n    &-text {\n        font-family: $base-font-family;\n        font-size: 14px;\n        line-height: 22px;\n        font-weight: 500;\n        letter-spacing: 0.02em;\n        color: $danger;\n        transition: color .4s;\n        .ni {\n            font-size: 20px;\n            display: inline-block;\n            vertical-align: middle;\n            margin-left: .125rem;\n            margin-top: -3px;\n        }\n        .pmo-dark & {\n            color: $white;\n        }\n    }\n    &-st {\n        position: fixed;\n        right: 25px;\n        bottom: 0;\n        display: flex;\n        align-items: center;\n        transition: all .4s;\n        border-radius: 30px;\n        transform: translateY(100%);\n        box-shadow: 0 5px 40px 0 rgba($darker, .3);\n        color: #fff;\n        background: $danger;\n        z-index: 99999;\n        &:active, &:focus, &:hover {\n            color: #fff\n        }\n        &.pmo-dark {\n            background: darken($blue, 20%);\n        }\n        &.active {\n            bottom: 25px;\n            transform: translateY(0);\n            transition-delay: .4s\n        }\n        &-img {\n            width: 60px;\n            height: 60px;\n            border-radius: 30px;\n            padding: 18px 18px;\n            transition: all .4s\n        }\n\n        &-text {\n            padding: 14px 0;\n            height: 60px;\n            width: 0;\n            overflow: hidden;\n            white-space: nowrap;\n            text-transform: uppercase;\n            letter-spacing: .1em;\n            font-weight: 600;\n            transition: all .4s;\n            visibility: hidden;\n            font-size: 12px;\n            line-height: 16px\n        }\n\n        &:hover .pmo-st-text {\n            width: 220px;\n            visibility: visible;\n            padding: 14px 14px 14px 0\n        }\n    }\n}\n\n@media (max-width:575px) {\n    .promo-cov-st {\n        display: none\n    }\n}\n.dark-mode {\n    .nk-demo-panel {\n        background-color: $dark-card-bg;\n    }\n    .nk-opt-item-bg{\n        background-color: $dark-body-bg;\n    }\n    .nk-demo-head,.nk-opt-set:not(:last-child),.nk-demo-item:not(:last-child) {\n        border-color: $dark-border-color;\n    }\n    .nk-demo-title {\n        color: $base-200;\n    }\n    .nk-demo-image {\n        border-color: $dark-border-color;\n    }\n    // .active > .nk-opt-item-bg.is-light:after{\n    //     color: $white;\n    // }\n    // .active[data-key=\"mode\"] > .nk-opt-item-bg.is-light:after{\n    //     color: $base-500;\n    // }\n    // .nk-opt-item-bg{\n    //     color: $base-400;\n    // }\n}","// STYLE\n.ui-bordered{\n    .card,\n    .code-block,\n    .accordion:not(.accordion-s2):not(.accordion-s3),\n    .card .card-inner + .table .tb-tnx-head, \n    .nk-download {\n        border: 1px solid $border-light;\n    }\n    .nk-tb-list.is-separate .nk-tb-item > div{\n        border-top: 1px solid $border-light;\n        border-bottom: 1px solid $border-light;\n        &:first-child{\n            border-left: 1px solid $border-light;\n        }\n        &:last-child{\n            border-right: 1px solid $border-light;\n        }\n    }\n    .kanban-board-header {\n        border-left: 1px solid $border-light;\n        border-right: 1px solid $border-light;\n        border-bottom: 1px solid $border-light;\n    }\n    .kanban-item {\n        border: 1px solid $border-light;\n    }\n}","// DARK STYLE\n$dark-body-bg: $darker;\n$dark-body-bg-dark: darken($darker, 6%);\n$dark-body-bg-light: darken($darker, 2%);\n$dark-card-bg: darken($dark, 6%);\n$dark-border-color: lighten($darker, 8%);\n$dark-border-light: $light-800;\n\n/* React Select */\n\n$react-select-color: $base-text !default;\n$react-select-placeholder-color: $base-light !default;\n$react-select-bg-color: $white !default;\n\n$react-select-dropdown-item-active: $light !default;\n$react-select-dropdown-item-disabled: rgba($base-light, 0.7) !default;\n\n$react-select-border-width: 1px !default;\n$react-select-border-color: $input-border-color !default;\n$react-select-focus-border-color: $input-focus-border-color !default;\n$react-select-open-border-color: darken($input-border-color, 12%) !default;\n$react-select-box-shadow: none !default;\n$react-select-focus-box-shadow: $input-focus-box-shadow !default;\n$react-select-transition: all 0.3s !default;\n$react-select-border-radius: $border-radius !default;\n\n$react-select-font-family: $base-font-family !default;\n$react-select-font-weight: $input-font-weight !default;\n\n$react-select-padding-x: $input-padding-x !default;\n$react-select-padding-y: $input-padding-y !default;\n$react-select-font-size: $input-font-size !default;\n$react-select-line-height: $input-line-height !default;\n$react-select-input-height: $input-height !default;\n\n$react-select-padding-x-sm: $input-padding-x-sm !default;\n$react-select-padding-y-sm: $input-padding-y-sm !default;\n$react-select-font-size-sm: $input-font-size-sm !default;\n$react-select-line-height-sm: $input-line-height-sm !default;\n$react-select-input-height-sm: $input-height-sm !default;\n\n$react-select-padding-x-lg: $input-padding-x-lg !default;\n$react-select-padding-y-lg: $input-padding-y-lg !default;\n$react-select-font-size-lg: $input-font-size-lg !default;\n$react-select-line-height-lg: $input-line-height-lg !default;\n$react-select-input-height-lg: $input-height-lg !default;\n\n$react-select-padding-x-xl: $input-padding-x-xl !default;\n$react-select-padding-y-xl: $input-padding-y-xl !default;\n$react-select-font-size-xl: $input-font-size-xl !default;\n$react-select-line-height-xl: $input-line-height-xl !default;\n$react-select-input-height-xl: $input-height-xl !default;\n\n$react-select-arrow-font-family: $nk-dashlite-font !default;\n$react-select-arrow-down: $ni-chevron-down !default;\n$react-select-arrow-up: $ni-chevron-up !default;\n\n// Dark Mode\nbody.dark-mode {\n  background: $dark-body-bg !important;\n  color: $base-300;\n  &.ui-shady,\n  &.ui-clean,\n  &.bg-lighter,\n  &.bg-light {\n    background: $dark-body-bg-light !important;\n  }\n}\n.dark-mode {\n  .logo {\n    &-dark {\n      opacity: 0;\n    }\n    &-light {\n      opacity: 1;\n    }\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  .h1,\n  .h2,\n  .h3,\n  .h4,\n  .h5,\n  .h6,\n  .lead-text,\n  .dropdown-title,\n  pre {\n    color: $white;\n  }\n  .text-base,\n  .text-body,\n  .link-text {\n    color: $base-300 !important;\n  }\n  .text-secondary,\n  .icon[class*=\"bg-secondary-dim\"],\n  .user-avatar[class*=\"-light\"],\n  .icon[class*=\"bg-light\"] {\n    color: $base-400 !important;\n  }\n  .text-dark {\n    color: $white !important;\n  }\n  .text-muted {\n    color: $base-400 !important;\n  }\n  // .text-white {\n  //     color: $light-900 !important;\n  // }\n  .text-light,\n  .user-avatar[class*=\"-dark\"] {\n    color: $light-500 !important;\n  }\n  .text-lighter {\n    color: $light-600 !important;\n  }\n  .text-indigo {\n    color: lighten($indigo, 25%) !important;\n  }\n  .bg-light {\n    background-color: $dark-body-bg-light !important;\n  }\n  .bg-lighter {\n    background-color: lighten($dark-body-bg-light, 2%) !important;\n  }\n  .table-striped tbody tr:nth-of-type(odd) {\n    background-color: $darker !important;\n  }\n  .bg-white {\n    background-color: $dark-card-bg !important;\n  }\n  .bg-putih {\n    background-color: #ffffff !important;\n  }\n  .bg-transparent.bg-transparent {\n    background-color: transparent !important;\n  }\n\n  $bg-mix: $dark-card-bg;\n  $bg-colors:\n    \"dark\" $light-100,\n    \"blue-dim\" mix($blue, $bg-mix, 15%),\n    \"azure-dim\" mix($azure, $bg-mix, 15%),\n    \"indigo-dim\" mix($indigo, $bg-mix, 15%),\n    \"purple-dim\" mix($purple, $bg-mix, 15%),\n    \"pink-dim\" mix($pink, $bg-mix, 15%),\n    \"orange-dim\" mix($orange, $bg-mix, 15%),\n    \"teal-dim\" mix($teal, $bg-mix, 15%),\n    // for bootstrap\n    \"primary-dim\" mix($accent-color, $bg-mix, 15%),\n    \"success-dim\" mix($success, $bg-mix, 15%),\n    \"info-dim\" mix($info, $bg-mix, 15%),\n    \"warning-dim\" mix($warning, $bg-mix, 15%),\n    \"danger-dim\" mix($danger, $bg-mix, 15%),\n    \"secondary-dim\" mix($secondary, $bg-mix, 20%),\n    \"dark-dim\" mix($dark, $bg-mix, 15%),\n    \"gray-dim\" mix($gray-500, $bg-mix, 15%),\n    \"btc-dim\" mix($brand-color-bitcoin, $bg-mix, 15%),\n    \"eth-dim\" mix($brand-color-ethereum, $bg-mix, 15%);\n\n  @each $name, $background in $bg-colors {\n    .bg-#{$name} {\n      background-color: $background !important;\n    }\n  }\n\n  $alert-mix: $dark-card-bg;\n  $alerts-dark:\n    \"primary\" $primary mix($primary, $alert-mix, 15%),\n    \"secondary\" lighten($secondary, 35%) mix($secondary, $alert-mix, 20%),\n    \"success\" $success mix($success, $alert-mix, 15%),\n    \"warning\" $warning mix($warning, $alert-mix, 15%),\n    \"info\" $info mix($info, $alert-mix, 15%),\n    \"danger\" $danger mix($danger, $alert-mix, 15%),\n    \"gray\" $gray-400 mix($gray-500, $alert-mix, 15%),\n    \"dark\" $dark mix($dark, $alert-mix, 15%),\n    \"light\" $light-100 mix($light-500, $alert-mix, 15%);\n\n  @each $name, $color, $background in $alerts-dark {\n    .alert-#{$name} {\n      color: $color;\n      background-color: $background;\n      border-color: $background;\n\n      hr {\n        border-top-color: $background;\n      }\n\n      .alert-link {\n        color: darken($color, 10%);\n      }\n    }\n    .alert-fill.alert-#{$name} {\n      color: color-yiq($color);\n      background: $color;\n      .alert-link {\n        color: color-yiq($color);\n      }\n    }\n    .alert-pro.alert-#{$name} {\n      border-color: $color;\n    }\n  }\n\n  $dim-mix: $dark-card-bg;\n  $dim-badge: map-merge(\n    $theme-colors,\n    (\n      \"secondary\": lighten($secondary, 35%),\n      \"dark\": $light,\n      \"light\": $light-400,\n      \"lighter\": $light-500,\n    )\n  );\n\n  @each $name, $color in $dim-badge {\n    .badge-dim.badge-#{$name} {\n      color: $color;\n      background-color: mix($color, $dim-mix, 15%);\n      border-color: mix($color, $dim-mix, 15%);\n    }\n    .badge-dim.badge-outline-#{$name} {\n      color: $color;\n      background-color: mix($color, $dim-mix, 15%);\n      border-color: mix($color, $dim-mix, 40%);\n    }\n  }\n\n  .badge-outline-secondary,\n  .badge-dot.badge-dark,\n  .badge-dot.badge-secondary {\n    color: $light-400;\n  }\n\n  .badge-outline-dark {\n    color: $light;\n    border-color: $light;\n  }\n  .badge-outline-light {\n    color: $light-400;\n    border-color: $light-700;\n  }\n  .badge-dot.badge-dark,\n  .badge-dot.badge-light {\n    background-color: transparent;\n  }\n  .badge-dot.badge-light {\n    color: $light-500;\n  }\n\n  .badge-light,\n  .code-block .btn {\n    color: $light;\n    background: $light-700;\n    border-color: $light-700;\n  }\n  .badge-dark {\n    color: $dark;\n    background: $light-200;\n    border-color: $light-200;\n  }\n\n  // Buttons\n  .btn-light {\n    color: $light;\n    background: $light-700;\n    border-color: $light-700;\n    &:not(:disabled):not(.disabled) {\n      &:hover,\n      &:focus,\n      &.focus,\n      &:active,\n      &.active {\n        background: lighten($light-700, 8%);\n        border-color: lighten($light-700, 8%);\n        color: $light;\n      }\n    }\n  }\n  .btn-dark {\n    color: $dark;\n    background: $light-200;\n    border-color: $light-200;\n    &:not(:disabled):not(.disabled) {\n      &:hover,\n      &:focus,\n      &.focus,\n      &:active,\n      &.active {\n        background: $white;\n        border-color: $white;\n        color: $dark;\n      }\n    }\n  }\n  .btn-outline-dark {\n    border-color: $light-200;\n    color: $light-200;\n    &:not(:disabled):not(.disabled):hover {\n      background: $light-200;\n      color: $dark;\n    }\n  }\n  .btn-outline-secondary {\n    border-color: lighten($secondary, 20%);\n    color: lighten($secondary, 20%);\n    &:not(:disabled):not(.disabled):hover {\n      background: lighten($secondary, 20%);\n      color: $white;\n    }\n  }\n  .btn-outline-light {\n    border-color: $light-600;\n    color: $light-400;\n    &:not(:disabled):not(.disabled):hover {\n      background: $light-600;\n      color: $white;\n    }\n  }\n\n  $dim-mix: $dark-card-bg;\n  $dim-btns:\n    \"primary\" $primary mix($primary, $dim-mix, 18%),\n    \"secondary\" lighten($secondary, 45%) mix($secondary, $dim-mix, 25%),\n    \"success\" $success mix($success, $dim-mix, 18%),\n    \"warning\" $warning mix($warning, $dim-mix, 18%),\n    \"info\" $info mix($info, $dim-mix, 18%),\n    \"danger\" $danger mix($danger, $dim-mix, 18%),\n    \"gray\" $gray-400 mix($gray-500, $dim-mix, 18%),\n    \"dark\" $light-200 mix($light-400, $dim-mix, 18%),\n    \"light\" $light-100 mix($light-500, $dim-mix, 18%),\n    \"lighter\" $light-400 mix($light-500, $dim-mix, 18%);\n\n  @each $name, $color, $background in $dim-btns {\n    .btn-dim.btn-#{$name} {\n      color: $color;\n      background-color: $background;\n      border-color: transparent;\n      &:not(:disabled):not(.disabled):hover {\n        color: lighten($color, 10%);\n        background-color: lighten($background, 7%);\n        border-color: lighten($background, 7%);\n      }\n    }\n  }\n\n  $dim-outline-btns:\n    \"primary\" $primary mix($primary, $dim-mix, 18%) mix($primary, $dim-mix, 35%),\n    \"success\" $success mix($success, $dim-mix, 18%) mix($success, $dim-mix, 35%),\n    \"warning\" $warning mix($warning, $dim-mix, 18%) mix($warning, $dim-mix, 35%),\n    \"info\" $info mix($info, $dim-mix, 18%) mix($info, $dim-mix, 35%),\n    \"danger\" $danger mix($danger, $dim-mix, 18%) mix($danger, $dim-mix, 35%),\n    \"secondary\" lighten($secondary, 25%) mix($secondary, $dim-mix, 25%) mix($secondary, $dim-mix, 70%),\n    \"gray\" $gray-400 mix($gray-500, $dim-mix, 18%) mix($light-500, $dim-mix, 35%),\n    \"dark\" $light-200 mix($light-400, $dim-mix, 18%) mix($light-400, $dim-mix, 35%),\n    \"light\" $light-500 mix($light-600, $dim-mix, 18%) mix($light-500, $dim-mix, 35%);\n\n  @each $name, $color, $background, $border in $dim-outline-btns {\n    .btn-dim.btn-outline-#{$name} {\n      color: $color;\n      background-color: $background;\n      border-color: $border;\n      &:not(:disabled):not(.disabled):hover {\n        color: color-yiq($color);\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n    .btn-white.btn-outline-#{$name},\n    .btn-trans.btn-outline-#{$name} {\n      &:not(.btn-dim):not(:disabled):not(.disabled):hover {\n        color: $color;\n        background: $background;\n      }\n    }\n  }\n\n  .btn-dim.btn-outline-light:not(:disabled):not(.disabled):hover,\n  .btn-white.btn-outline-light:not(:disabled):not(.disabled):hover,\n  .btn-dim.btn-outline-light:not(:disabled):not(.disabled):active,\n  .btn-white.btn-outline-light:not(:disabled):not(.disabled):active,\n  .show > .btn-white.btn-outline-light.dropdown-toggle {\n    background: $light-600;\n    border-color: $light-600;\n    color: $white;\n  }\n\n  .btn-white,\n  .btn-white.btn-dim,\n  .btn-white.btn-outline-light {\n    background: $dark-card-bg;\n  }\n  .btn-outline-light:focus,\n  .btn-outline-light.focus {\n    box-shadow: 0 0 0 $btn-focus-width rgba($white, 0.07) !important;\n  }\n\n  .border,\n  .border-bottom,\n  .border-top,\n  .border-left,\n  .border-right,\n  .dropdown-inner + .dropdown-inner,\n  .dropdown-head,\n  .dropdown-foot,\n  .preview-hr,\n  .select2-container--default .select2-selection--single,\n  .ql-picker-options,\n  .select2-container--default .select2-selection--multiple,\n  .select2-dropdown,\n  .select2-container--default .select2-search--dropdown .select2-search__field,\n  .ui-timepicker-standard,\n  .ql-toolbar,\n  .ql-container,\n  .note-editor,\n  .note-toolbar,\n  .tox .tox-menubar,\n  .tox-toolbar-overlord,\n  .tox-tinymce,\n  .tox .tox-toolbar__group:not(:last-of-type),\n  .tox .tox-statusbar,\n  .tox .tox-menu,\n  .tox-toolbar,\n  .tox-editor-header,\n  .tox .tox-toolbar,\n  .tox .tox-toolbar__primary,\n  .tox .tox-toolbar__overflow,\n  .tox .tox-collection--list .tox-collection__group,\n  .note-btn-group .note-btn,\n  .note-statusbar,\n  .nk-code-preview-box,\n  .swal2-footer,\n  .example-border-all > div,\n  .btn-toolbar-sep,\n  .page-link,\n  .table th,\n  .table td,\n  .table-bordered,\n  .table-bordered th,\n  .table-bordered td,\n  .datatable-wrap,\n  .nk-tb-head .nk-tb-col,\n  .list-group-item,\n  .modal-header,\n  .modal-footer,\n  .popover,\n  .popover-header,\n  .tagify__tag > div::before,\n  .tagify__tag:hover:not([readonly]) div::before,\n  .nk-tb-item:not(:last-child) .nk-tb-col,\n  .nk-activity-item:not(:last-child),\n  .nk-support-item:not(:last-child),\n  .card-inner-group .card-inner:not(:last-child),\n  .card-aside,\n  .nav-tabs,\n  .divider,\n  .data-item:not(:last-child),\n  .nk-footer,\n  .nav-switch-s2 .nav-link,\n  .accordion-item:last-child .accordion-inner,\n  .user-avatar-multiple .user-avatar {\n    border-color: $dark-border-color !important;\n  }\n\n  .card,\n  .code-block,\n  .alert-pro,\n  .modal-content,\n  .toast,\n  .toastr {\n    box-shadow: 0px 1px 3px 0px rgba($black, 0.4);\n  }\n  .toast-header {\n    color: $base-400;\n  }\n  .toast,\n  .toast-header {\n    border-color: lighten($dark-border-color, 2%);\n    background: lighten($dark-card-bg, 2%);\n  }\n\n  .table-active,\n  .table-active > th,\n  .table-active > td,\n  .table-hover tbody tr:hover,\n  .code-block .prettyprint,\n  .list-group-item,\n  .example-spacing-pd > div > span,\n  .custom-file-label::after,\n  .ql-picker-options,\n  .data-more:before,\n  .ui-state-hover,\n  .note-editor.note-frame .note-statusbar,\n  .note-editor.note-airframe .note-statusbar,\n  .swal2-popup,\n  .select2-container--default .select2-results__option--highlighted[aria-selected],\n  .select2-container--default .select2-results__option[aria-selected=\"true\"],\n  .select2-container--default .select2-selection--multiple .select2-selection__choice,\n  .select2-container--default .select2-search--dropdown .select2-search__field,\n  .example-width > div,\n  .example-height > div,\n  .example-border > div,\n  .example-spacing > div {\n    background: $dark-body-bg;\n  }\n  .tox .tox-tbtn:hover,\n  .tox .tox-collection--list .tox-collection__item--active,\n  .tox .tox-mbtn--active,\n  .tox .tox-mbtn:focus:not(:disabled),\n  .tox .tox-mbtn:hover:not(:disabled):not(.tox-mbtn--active),\n  .tox .tox-collection--list .tox-collection__item--enabled {\n    background: darken($dark-body-bg, 4%);\n  }\n  .icon-overlap li {\n    border-color: $dark-card-bg;\n  }\n  .card,\n  .kanban-add-task,\n  .kanban-board-header,\n  .kanban-item {\n    background: $dark-card-bg;\n  }\n  .accordion,\n  .form-clip,\n  .form-text-hint,\n  .card-aside,\n  .code-block,\n  .alert-pro,\n  .modal-content,\n  .toastr,\n  .toggle-content,\n  .nav-switch-s2 .nav-link:hover,\n  .nav-switch-s2 .nav-link:focus,\n  .nav-switch-s2 .nav-link.active,\n  .select2-container--default .select2-selection--single,\n  .select2-container--default .select2-selection--multiple,\n  .select2-dropdown,\n  .custom-file-label,\n  .custom-select,\n  .popover,\n  .search-wrap,\n  .form-control,\n  .form-label-outlined,\n  .input-mail,\n  .page-link,\n  .ui-timepicker-standard,\n  .note-editor,\n  .note-toolbar,\n  .tox .tox-edit-area__iframe,\n  .tox .tox-menubar,\n  .tox-toolbar-overlord,\n  .tox .tox-toolbar,\n  .tox .tox-toolbar__primary,\n  .tox .tox-toolbar__overflow,\n  .tox .tox-statusbar,\n  .tox .tox-menu,\n  .datepicker table tr td.today,\n  .datepicker table tr td.today:hover,\n  .datepicker table tr td.today.disabled,\n  .datepicker table tr td.today.disabled:hover,\n  .datepicker table tr td.day:hover,\n  .datepicker table tr td.day.focused,\n  .datepicker .datepicker-switch:hover,\n  .datepicker .prev:hover,\n  .datepicker .next:hover,\n  .datepicker tfoot tr th:hover {\n    background: $dark-card-bg !important;\n  }\n\n  .clipboard-success-message {\n    background: rgba($dark-card-bg, 0.9);\n  }\n\n  .tagify__tag > div::before,\n  .tagify__tag:hover:not([readonly]) div::before {\n    box-shadow: 0 0 0 1.1em $dark-body-bg inset;\n  }\n  .popover-header {\n    background-color: lighten($dark-card-bg, 3%);\n  }\n  .popover {\n    box-shadow: 0 0 20px -5px rgba($black, 0.6);\n  }\n  .bs-popover-bottom .popover-header::before,\n  .bs-popover-auto[x-placement^=\"bottom\"] .popover-header::before {\n    border-color: $dark-border-color;\n  }\n\n  .bs-popover-top > .arrow::before,\n  .bs-popover-auto[x-placement^=\"top\"] > .arrow::before {\n    border-top-color: $dark-border-color;\n  }\n  .bs-popover-top > .arrow::after,\n  .bs-popover-auto[x-placement^=\"top\"] > .arrow::after {\n    border-top-color: $dark-card-bg;\n  }\n\n  .bs-popover-bottom > .arrow::before,\n  .bs-popover-auto[x-placement^=\"bottom\"] > .arrow::before {\n    border-bottom-color: $dark-border-color;\n  }\n  .bs-popover-bottom > .arrow::after,\n  .bs-popover-auto[x-placement^=\"bottom\"] > .arrow::after {\n    border-bottom-color: $dark-card-bg;\n  }\n\n  .bs-popover-right > .arrow::before,\n  .bs-popover-auto[x-placement^=\"right\"] > .arrow::before {\n    border-right-color: $dark-border-color;\n  }\n  .bs-popover-right > .arrow::after,\n  .bs-popover-auto[x-placement^=\"right\"] > .arrow::after {\n    border-right-color: $dark-card-bg;\n  }\n\n  .bs-popover-left > .arrow::before,\n  .bs-popover-auto[x-placement^=\"left\"] > .arrow::before {\n    border-left-color: $dark-border-color;\n  }\n  .bs-popover-left > .arrow::after,\n  .bs-popover-auto[x-placement^=\"left\"] > .arrow::after {\n    border-left-color: $dark-card-bg;\n  }\n  .team-info li span:last-child,\n  .team-statistics li span:first-child,\n  .project-progress-percent,\n  .kanban-title-content .title,\n  .card-tools-nav li a:hover,\n  .card-tools-nav li a.active,\n  .card-tools-nav li.active a,\n  .card-amount .amount,\n  .accordion-head .title,\n  .custom-file-label::after,\n  .input-mail,\n  .form-control,\n  .form-control:focus,\n  .form-label,\n  .form-label-outlined,\n  .input-group-text,\n  .table .thead-light th,\n  .table-hover tbody tr:hover,\n  .close,\n  .close:hover,\n  .user-name,\n  .nk-news-text p,\n  .data-item:hover .icon,\n  .accordion-icon {\n    color: $white !important;\n  }\n  .close {\n    text-shadow: 0 1px 0 $dark-card-bg;\n    &:focus {\n      outline: none !important;\n    }\n  }\n\n  .nk-block-des,\n  .card-title p,\n  .nk-sale-data .sub-title,\n  .link-check li span,\n  .data-value,\n  .custom-file-label,\n  .custom-select,\n  .form-control-select-multiple .custom-select option,\n  .select2-container--default .select2-selection--single .select2-selection__rendered,\n  .select2-container--default .select2-selection--multiple .select2-selection__rendered,\n  .ui-timepicker-standard a,\n  .note-placeholder,\n  [class*=\"knob\"],\n  .tox .tox-tbtn:hover,\n  .tox .tox-statusbar a,\n  .tox .tox-statusbar__path-item,\n  .tox .tox-statusbar__wordcount,\n  .tox-collection__item-label > *,\n  .nk-quick-nav-icon,\n  .dropzone .dz-message span,\n  .datepicker table tr td.today,\n  .datepicker table tr td.today:hover,\n  .datepicker table tr td.today.disabled,\n  .datepicker table tr td.today.disabled:hover,\n  .datepicker table tr td.day:hover,\n  .datepicker table tr td.day.focused,\n  .page-link,\n  .alert-pro,\n  .nk-news-text p span,\n  .language-item,\n  .nk-tb-list .tb-lead-sub,\n  .nk-tb-list .tb-amount-sub {\n    color: $base-400 !important;\n  }\n  .tox .tox-collection__item-accessory {\n    color: $base-500;\n  }\n  .nk-menu-link,\n  .link-dark,\n  .nk-menu-main .nk-menu-sub .nk-menu-link,\n  .link-list a {\n    color: $base-400;\n    &:hover {\n      color: $accent-color;\n    }\n  }\n  .nk-menu-badge {\n    color: $light-300;\n    background: lighten($dark-card-bg, 12%);\n  }\n  @if ($menu_dark_option==true) {\n    .is-dark .nk-menu-badge {\n      color: $accent-200;\n    }\n  }\n  @if ($menu_dark_theme_option==true) {\n    .is-dark .nk-menu-badge {\n      color: $accent-400;\n    }\n  }\n  .ql-picker.ql-expanded .ql-picker-label,\n  .active > .nk-menu-link,\n  .is-theme .nk-menu-link:hover .nk-menu-icon,\n  .is-theme .nk-menu-item.active > .nk-menu-link .nk-menu-icon,\n  .is-theme .nk-menu-item.current-menu > .nk-menu-link .nk-menu-icon,\n  .is-theme .nk-menu-sub .nk-menu-link:hover,\n  .is-theme .nk-menu-sub .active > .nk-menu-link,\n  .page-link:hover {\n    color: $accent-color !important;\n  }\n  .nk-menu-hr,\n  .nk-menu-main .nk-menu-sub,\n  .nk-sidebar .nk-menu > li .nk-menu-sub .nk-menu-sub,\n  .user-avatar-group .user-avatar {\n    border-color: $dark-border-color;\n  }\n  .table .thead-light th,\n  .page-item.disabled .page-link,\n  .page-link:hover,\n  .tb-odr-head,\n  .tb-tnx-head,\n  .custom-control-input[disabled] ~ .custom-control-label::before,\n  .custom-control-input:disabled ~ .custom-control-label::before {\n    background-color: lighten($dark-card-bg, 11%) !important;\n  }\n  .progress,\n  .data-head,\n  .custom-control-label::before,\n  .input-group-text,\n  .nk-msg-profile-toggle {\n    background-color: lighten($dark-card-bg, 7%) !important;\n  }\n  .nk-msg-profile-toggle,\n  .custom-control-label::before,\n  .form-control,\n  .input-mail,\n  .custom-file-label,\n  .input-group-text,\n  .custom-select,\n  .swal2-input,\n  .swal2-file,\n  .swal2-textarea,\n  .select2-container--default .select2-selection--single,\n  .select2-container--default .select2-selection--multiple,\n  .select2-dropdown,\n  .note-popover .popover-content .dropdown-style > li[aria-label=\"pre\"],\n  .note-editor .note-toolbar .dropdown-style > li[aria-label=\"pre\"],\n  .link-bdr-t,\n  .link-check + .link-check,\n  .link-tidy li + li,\n  .link-list + .link-list,\n  .link-list-opt li + li,\n  .link-list-plain li,\n  .link-list-plain li + li {\n    border-color: lighten($dark-card-bg, 20%) !important;\n  }\n  .custom-switch .custom-control-label::after {\n    background-color: lighten($dark-card-bg, 50%) !important;\n  }\n  .custom-switch .custom-control-input:checked ~ .custom-control-label::after {\n    background-color: $white !important;\n  }\n  .custom-control-input:checked ~ .custom-control-label::before {\n    background-color: $accent-color !important;\n    border-color: $accent-color !important;\n  }\n\n  .btn-trigger:before,\n  .btn-trigger.active:hover:before,\n  .nk-quick-nav-icon:before {\n    background-color: $dark-body-bg-dark;\n  }\n\n  .dropdown-menu {\n    background-color: lighten($dark-card-bg, 2%);\n    border-color: lighten($dark-card-bg, 10%);\n    box-shadow: 0 3px 20px 1px rgba($black, 0.4);\n    &-s1 {\n      border-top-color: $accent-color;\n    }\n  }\n\n  .link-list-plain a,\n  .link-list-opt a,\n  .link-check li a {\n    color: $base-300;\n    &:hover {\n      background: lighten($dark-card-bg, 12%);\n    }\n  }\n\n  .border-transparent {\n    border-color: transparent !important;\n  }\n\n  .note-editor .btn,\n  .ql-picker,\n  .tox .tox-tbtn__select-label,\n  .tox .tox-mbtn__select-label,\n  .lead-text span,\n  .data-list-s2 .data-label,\n  .btn-trigger,\n  .list-step li.list-step-done {\n    color: $base-400;\n  }\n  .ql-fill,\n  .ql-stroke.ql-fill,\n  .tox .tox-tbtn svg {\n    fill: $base-400;\n  }\n  .ql-stroke {\n    stroke: $base-400;\n  }\n  .team-info li span:first-child,\n  .team-statistics li span:last-child,\n  .project-progress-task,\n  .table,\n  .nk-tb-list,\n  .nk-tb-list .tb-amount span,\n  .nk-tb-list .tb-amount .currency,\n  .tb-tnx-item .tb-tnx-total,\n  .tb-odr-item .tb-odr-total,\n  .user-balance-sub span,\n  .dropdown-menu,\n  .pln,\n  .overline-title,\n  .nk-block-des strong,\n  .data-item:hover .data-value,\n  .data-item:hover .data-label,\n  .nk-notification-text,\n  .profile-ud-value,\n  .bq-note-meta span > span,\n  .tagify__tag > div,\n  .popover-body,\n  .input-mail::placeholder,\n  .list-apps-title {\n    color: $base-300;\n  }\n  .nk-notification-text span,\n  .is-unread .chat-context .text {\n    color: $base-200;\n  }\n  .nav-tabs .nav-link {\n    color: $base-300;\n    &.active {\n      color: $accent-color;\n    }\n    &:hover {\n      color: $white;\n    }\n  }\n  .link-list-menu a,\n  .list-plain a {\n    color: $base-400;\n    &:hover,\n    &.active {\n      color: $accent-color;\n    }\n  }\n  .nav-switch .nav-link.active,\n  .list-apps a:hover .list-apps-title {\n    color: $white;\n  }\n  .nk-tb-item:not(.nk-tb-head):hover,\n  .nk-tb-item:not(.nk-tb-head).seleted {\n    box-shadow: 0 2px 15px -4px rgba($black, 0.7);\n  }\n  .nk-tb-item:hover .nk-tb-action-hidden,\n  .bq-note-text,\n  .nk-tb-item:not(.nk-tb-head):hover,\n  .nk-tb-item:not(.nk-tb-head).seleted {\n    background: darken($dark-card-bg, 2%);\n  }\n\n  .nk-apps-sidebar .dropdown-menu .lead-text,\n  .list-step li.list-step-current,\n  .nk-tb-list .tb-lead,\n  .nk-tb-list .tb-amount,\n  .nk-support-content .title,\n  .nk-sale-data .amount {\n    color: $white;\n  }\n\n  .nk-support-content .time,\n  .page-item.disabled .page-link,\n  .card-hint,\n  .list-step li {\n    color: $base-500;\n  }\n\n  // global\n  .nk-order-ovwg-data .title .icon,\n  .timeline-item:not(:last-child):before,\n  .timeline-status.is-outline:after {\n    background-color: lighten($dark-card-bg, 10%);\n  }\n\n  .nk-footer {\n    background-color: $darker;\n  }\n\n  .nk-order-ovwg-data .info strong,\n  .user-activity .amount,\n  .invest-data-history .amount,\n  .analytic-data .amount,\n  .traffic-channel-data .amount,\n  .analytics-map-data .amount,\n  .device-status-data .amount,\n  .invest-ov .amount,\n  .profile-balance-amount .number {\n    color: $white;\n  }\n\n  .invest-ov:not(:last-child) {\n    border-color: lighten($dark-card-bg, 20%);\n  }\n\n  //Layouts\n  .nk-header .dropdown-menu .lead-text,\n  .nk-sidebar-bar .dropdown-menu .lead-text {\n    color: $white;\n  }\n  .nk-header,\n  .nk-header.is-light:not([class*=\"bg-\"]),\n  .nk-sidebar,\n  .nk-sidebar.is-light,\n  .nk-sidebar-head {\n    border-color: $sidebar-border-dark-color !important;\n  }\n  .nk-header,\n  .nk-header.is-light:not([class*=\"bg-\"]),\n  .nk-sidebar,\n  .nk-sidebar.is-light,\n  .nk-header.is-theme:not([class*=\"bg-\"]) {\n    background: $sidebar-bg-dark-color;\n  }\n\n  // Apps\n  .nk-chat-aside-user .title,\n  .nk-file-name,\n  .nk-file-name-text a.title,\n  .is-unread .nk-ibx-context-text .heading,\n  .chat-profile-settings .custom-control-sm .custom-control-label,\n  .attach-info,\n  .profile-stats .amount,\n  .is-unread .chat-from .name {\n    color: $white;\n  }\n  .nk-fmg-menu-item .icon,\n  .nk-ibx-menu-item .icon {\n    color: $base-400;\n  }\n\n  .nk-fmg-menu-text,\n  .nk-ibx-label-text,\n  .nk-ibx-menu-text,\n  .attach-item a,\n  .user-contacts li,\n  .nk-ibx-context-text .heading,\n  .chat-option-link:hover .lead-text,\n  .chat-from .name,\n  .user-plan-title {\n    color: $base-300;\n  }\n\n  .nk-file-name-text a.title:hover,\n  .active > .nk-fmg-menu-item .icon,\n  .active .nk-ibx-menu-text,\n  .active .nk-ibx-menu-item .icon {\n    color: $accent-color;\n  }\n\n  .nk-chat,\n  .nk-chat-aside,\n  .nk-chat-profile,\n  .nk-chat-head,\n  .chat-profile-group,\n  .nk-fmg,\n  .nk-fmg-aside,\n  .nk-fmg-body-head,\n  .nk-fmg-switch,\n  .nk-files-view-grid .nk-file,\n  .nk-files-view-group .nk-file,\n  .nk-ibx,\n  .nk-ibx-aside,\n  .nk-ibx-head,\n  .nk-ibx-item,\n  .nk-reply-form,\n  .nk-reply-form-header,\n  .nk-reply-form-tools,\n  .nk-reply-form-field:not(:last-child),\n  .nk-msg,\n  .nk-msg-head,\n  .nk-msg-profile,\n  .attach-files,\n  .attach-foot,\n  .nk-msg-item:not(:last-child),\n  .nk-msg-aside,\n  .nk-msg-nav,\n  .nk-msg-nav .search-wrap,\n  .nk-files-group > .title,\n  .nk-file-share-header,\n  .nk-files-view-list .nk-file > div {\n    border-color: $dark-border-color !important;\n  }\n  .nk-block-subhead,\n  .data-list-s2 .data-head,\n  .nk-profile-toggle,\n  .nk-profile-content,\n  .user-account-links {\n    border-color: $dark-border-light;\n  }\n  .nk-upload-item,\n  .dropzone {\n    border-color: lighten($dark-border-light, 5%) !important;\n  }\n  .data-list-s2 .data-head {\n    background: transparent !important;\n  }\n\n  .chat-sap-meta:before,\n  .chat-sap-meta:after,\n  .active > .nk-fmg-menu-item,\n  .nk-fmg-menu-item:hover,\n  .nk-ibx-status,\n  .nk-ibx-reply-item:not(:last-child):after,\n  .nk-reply-meta-info:before,\n  .nk-reply-meta-info:after {\n    background: $dark-border-color;\n  }\n\n  .nk-chat,\n  .nk-chat-aside,\n  .nk-chat-profile,\n  .nk-chat-head,\n  .chat-msg,\n  .nk-chat-editor,\n  .nk-chat-blank,\n  .nk-fmg,\n  .nk-fmg-aside,\n  .nk-fmg-body-head,\n  .nk-files-view-grid .nk-file,\n  .nk-files-view-group .nk-file,\n  .nk-ibx,\n  .nk-ibx-aside,\n  .nk-ibx-item,\n  .nk-ibx-view,\n  .nk-msg,\n  .nk-msg-head,\n  .nk-msg-profile,\n  .nk-fmg-switch {\n    background: $dark-card-bg;\n  }\n\n  .nk-ibx-status .progress {\n    background: $dark-card-bg !important;\n  }\n  .nk-chat-panel,\n  .chat-item:hover,\n  .chat-item.current,\n  .chat-item:hover .chat-actions,\n  .chat-members .user-card:hover,\n  .chat-members .user-actions,\n  .nk-profile-content,\n  .nk-msg-item.active,\n  .nk-msg-item.current,\n  .channel-list a:hover,\n  .channel-list a.active {\n    background: darken($dark-body-bg, 2%) !important;\n  }\n  .fav-list .user-avatar:after {\n    background: lighten($dark-card-bg, 25%);\n  }\n\n  .nk-ibx-item:not(.no-hover):hover,\n  .nk-ibx-item.active,\n  .nk-ibx-item:hover .ibx-actions-hidden,\n  .nk-ibx-item:hover .ibx-actions,\n  .nk-ibx-label > li:hover,\n  .nk-ibx-contact > li:hover,\n  .nk-ibx-menu li.active,\n  .nk-ibx-menu li:hover,\n  .dot-label:after,\n  .attach-foot,\n  .nk-reply-from,\n  .nk-reply-entry.note,\n  .nk-msg-aside,\n  .nk-msg-nav,\n  .nk-files-view-grid .nk-file,\n  .nk-files-view-group .nk-file,\n  .nk-files-view-list .nk-file > div {\n    background: $dark-body-bg;\n  }\n  .is-unread .nk-ibx-context-text,\n  .nk-upload-info {\n    color: $base-200;\n  }\n  .nk-reply-msg-excerpt,\n  .nk-ibx-context-text,\n  .user-contacts li .icon,\n  .nk-reply-tools .date {\n    color: $base-400;\n  }\n  .is-unread .nk-msg-sender .name {\n    color: $white;\n  }\n  .nk-reply-meta-info,\n  .nk-reply-from {\n    color: darken($base-400, 2%);\n  }\n  .nk-reply-meta-info span,\n  .nk-reply-meta-info strong,\n  .nk-reply-meta-info .who,\n  .channel-list a {\n    color: $base-300;\n  }\n  .nk-reply-meta-info .whom {\n    color: $accent-color;\n  }\n  .nk-reply-form-attachment-list {\n    background: $dark-body-bg-light;\n  }\n\n  // Full Calendar\n  .fc .fc-toolbar.fc-header-toolbar {\n    .fc-toolbar-chunk {\n      .btn {\n        color: $base-300;\n        border-color: $dark-border-color;\n        &:disabled {\n          color: $base-300;\n          border-color: $dark-border-color;\n        }\n        &:hover,\n        &:focus {\n          color: $white;\n          background: $dark-body-bg;\n          border-color: $dark-border-color;\n        }\n        &:focus {\n          box-shadow: 0 0 0 0.2rem rgba($dark-border-color, 0.5);\n        }\n        &.active {\n          color: $accent-color;\n          border-color: $dark-border-color;\n          background: $dark-body-bg;\n          box-shadow: inset 0 0 4px -1px rgba($dark-border-color, 0.25);\n        }\n      }\n    }\n  }\n  .fc-day {\n    color: $base-300;\n  }\n  .fc-day-other {\n    color: $base-400;\n  }\n  .fc-list-day,\n  .fc-col-header-cell {\n    color: $white;\n  }\n  .fc .fc-list-empty {\n    background: $dark-body-bg;\n  }\n  .fc-timegrid-event-harness-inset .fc-timegrid-event,\n  .fc-timegrid-event.fc-event-mirror {\n    box-shadow: 0px 0px 0px 1px $darker;\n  }\n\n  $colors: (\n    \"primary-dim\" mix($accent-color, $bg-mix, 15%),\n    \"success-dim\" mix($success, $bg-mix, 15%),\n    \"info-dim\" mix($info, $bg-mix, 15%),\n    \"warning-dim\" mix($warning, $bg-mix, 15%),\n    \"danger-dim\" mix($danger, $bg-mix, 15%),\n    \"secondary-dim\" mix($secondary, $bg-mix, 20%),\n    \"dark-dim\" mix($dark, $bg-mix, 15%),\n    \"blue-dim\" mix($blue, $bg-mix, 15%),\n    \"azure-dim\" mix($azure, $bg-mix, 15%),\n    \"indigo-dim\" mix($indigo, $bg-mix, 25%),\n    \"purple-dim\" mix($purple, $bg-mix, 15%),\n    \"pink-dim\" mix($pink, $bg-mix, 15%),\n    \"orange-dim\" mix($orange, $bg-mix, 15%),\n    \"teal-dim\" mix($teal, $bg-mix, 15%)\n  );\n\n  @each $name, $color in $colors {\n    a.fc-event-#{$name} {\n      background-color: $color !important;\n      border-color: $color !important;\n    }\n    .modal-header.fc-event-#{$name} {\n      background-color: $color !important;\n      border-color: darken($color, 5%) !important;\n    }\n    span.fc-event-#{$name} {\n      .dot {\n        background-color: $color !important;\n      }\n    }\n    .fc-event-#{$name}:not(a) {\n      .fc-list-event-dot {\n        background-color: $color !important;\n      }\n    }\n  }\n\n  // card common\n  .code-block, .card-preview,\n    .card .card-inner + .table .tb-tnx-head,\n    .card-bordered,.kanban-add-task,.kanban-board-header,.kanban-item,.kanban-board .kanban-drag:empty, //.card,\n    .accordion-item:not(:last-child) .accordion-head,\n    .accordion-item:not(:last-child) .accordion-inner,\n    .accordion-item:last-child .accordion-inner,\n    .nk-download {\n    border-color: $dark-border-color;\n  }\n  .accordion:not(.accordion-s2):not(.accordion-s3) {\n    border-color: $dark-border-color !important;\n  }\n\n  .card.bg-light .card-header,\n  .card.bg-lighter .card-header {\n    background: rgba($black, 0.2);\n  }\n  .nk-tb-list.is-separate .nk-tb-item > .nk-tb-col {\n    border-top-color: $dark-border-color;\n    border-bottom-color: $dark-border-color;\n    &:first-child {\n      border-left-color: $dark-border-color;\n    }\n    &:last-child {\n      border-right-color: $dark-border-color;\n    }\n  }\n  .modal-footer.bg-light {\n    background-color: darken($dark-card-bg, 2%) !important;\n  }\n  .kanban-primary {\n    border-top-color: $accent-color;\n  }\n  .kanban-success {\n    border-top-color: $success;\n  }\n  .kanban-info {\n    border-top-color: $info;\n  }\n  .kanban-warning {\n    border-top-color: $warning;\n  }\n  .kanban-danger {\n    border-top-color: $danger;\n  }\n  // BORDERED STYLE on DARK\n  &.ui-bordered {\n    .card,\n    .code-block,\n    .accordion:not(.accordion-s2):not(.accordion-s3),\n    .accordion-item:last-child .accordion-inner,\n    .card .card-inner + .table .tb-tnx-head,\n    .card-bordered,\n    .nk-download {\n      border-color: $dark-border-color;\n    }\n    .nk-tb-list.is-separate .nk-tb-item > .nk-tb-col {\n      border-top-color: $dark-border-color;\n      border-bottom-color: $dark-border-color;\n      &:first-child {\n        border-left-color: $dark-border-color;\n      }\n      &:last-child {\n        border-right-color: $dark-border-color;\n      }\n    }\n    .nk-files-view-grid .nk-file,\n    .nk-files-view-group .nk-file {\n      border: none !important;\n    }\n  }\n\n  .nk-order-ovwg-data {\n    &.buy {\n      border-color: mix($success, $dark-card-bg, 60%);\n    }\n    &.sell {\n      border-color: mix($accent-color, $dark-card-bg, 60%);\n    }\n  }\n  .nk-sidebar-overlay {\n    background: rgba($black, 0.6);\n  }\n  .toggle-overlay,\n  .nk-chat-profile-overlay {\n    background: rgba($dark-body-bg-dark, 0.75);\n  }\n  .swal2-container.swal2-backdrop-show {\n    background: rgba($black, 0.85);\n  }\n  .modal-backdrop {\n    opacity: 0.9;\n    background: rgba($black, 0.9);\n  }\n\n  // eCommerce\n  .is-light .nk-menu-link:hover,\n  .is-light .active > .nk-menu-link,\n  .nk-menu-link:hover,\n  .active > .nk-menu-link,\n  .is-theme .nk-menu-link:hover,\n  .is-theme .active > .nk-menu-link {\n    background: lighten($sidebar-bg-dark-color, 5%);\n  }\n\n  .nk-menu-sub .nk-menu-link:hover,\n  .active > .nk-menu-sub .nk-menu-link,\n  .nk-header-search .form-control {\n    background-color: transparent !important;\n  }\n\n  .ui-bordered .nk-tb-list.is-separate .nk-tb-item > .nk-tb-col:first-child,\n  .ui-bordered .nk-tb-list.is-separate .nk-tb-item > .nk-tb-col {\n    border-color: $dark-border-color !important;\n  }\n  .is-compact:not(:hover) .nk-menu-heading:not(:first-child):before {\n    background-color: $dark-border-color;\n  }\n  .nk-add-product {\n    background: lighten($dark-card-bg, 4%);\n    box-shadow: -10px 15px 30px 5px rgba($black, 0.4);\n  }\n\n  .nk-tb-list.is-separate .nk-tb-item > .nk-tb-col,\n  .nk-tb-list.is-separate .nk-tb-item:hover .nk-tb-action-hidden,\n  .nk-download {\n    background-color: $dark-card-bg;\n  }\n  .nk-ecwg .amount,\n  .nk-store-statistics .count,\n  .nk-top-products .title,\n  .nk-top-products .amount,\n  .nk-tb-list .tb-product .title {\n    color: $white;\n  }\n  .nk-ecwg8-legends .title,\n  .nk-ecwg7-legends .title {\n    color: $base-100;\n  }\n\n  //List Box\n  .dual-listbox {\n    .dual-listbox__available,\n    .dual-listbox__selected {\n      border-color: lighten($dark-card-bg, 20%);\n    }\n    .dual-listbox__title {\n      border-left-color: lighten($dark-card-bg, 20%);\n      border-right-color: lighten($dark-card-bg, 20%);\n      border-top-color: lighten($dark-card-bg, 20%);\n    }\n\n    .dual-listbox__item {\n      border-bottom-color: lighten($dark-card-bg, 20%);\n    }\n  }\n\n  // common\n  .input-group-addon {\n    background-color: lighten($dark-card-bg, 4%);\n    border-color: lighten($dark-card-bg, 20%);\n  }\n  .border-light {\n    border-color: $dark-border-color !important;\n  }\n  div.dt-button-info {\n    background-color: $dark-card-bg;\n  }\n  div.dt-button-info h2 {\n    background-color: darken($dark-card-bg, 3%);\n  }\n  div.dt-button-info h2 {\n    border-color: $dark-border-color;\n  }\n  .dropzone {\n    background: $dark-body-bg;\n  }\n  .image-control {\n    .custom-control-input:checked ~ .custom-control-label {\n      &:before {\n        border-color: lighten($dark-card-bg, 20%);\n      }\n    }\n    .custom-control-label {\n      background-color: $dark;\n    }\n  }\n  .custom-control-pro {\n    .custom-control-label {\n      background-color: $dark-card-bg;\n      border-color: lighten($dark-card-bg, 20%);\n    }\n  }\n  .custom-control {\n    &.color-control {\n      .custom-control-label {\n        &::before {\n          background: transparent !important;\n        }\n      }\n    }\n  }\n\n  .slick-dots {\n    li {\n      button {\n        background-color: $dark-body-bg;\n      }\n      &.slick-active {\n        button {\n          background-color: $accent-color;\n        }\n      }\n    }\n  }\n\n  .slick-next,\n  .slick-prev {\n    color: $white;\n    background: $dark-card-bg;\n    border-color: $dark-border-color;\n    &:hover {\n      color: $white;\n      background: $accent-color;\n      border-color: $accent-color;\n    }\n  }\n  .slick-disabled {\n    .slick-next,\n    .slick-prev {\n      color: $light-300;\n      &:hover {\n        color: $light-300;\n        background: $dark-card-bg;\n        border-color: $dark-border-color;\n      }\n    }\n  }\n\n  // Pricing\n  .pricing-head {\n    border-color: $dark-border-color;\n  }\n  .pricing-amount .amount {\n    color: $white;\n  }\n\n  // Product\n  .product {\n    &-title a {\n      color: $white;\n    }\n    &-gallery {\n      border-color: $dark-border-color;\n      .slider-nav {\n        .slider-item {\n          .thumb {\n            border-color: $dark-border-color;\n          }\n          &.slick-current {\n            .thumb {\n              border-color: $accent-color;\n            }\n          }\n        }\n      }\n    }\n  }\n  .invoice-wrap {\n    background-color: $dark-card-bg;\n    border-color: $dark-border-color;\n  }\n  .invoice-bills .table tfoot {\n    border-color: $dark-border-color;\n  }\n  .nk-add-product {\n    background: $dark-body-bg;\n    box-shadow: -10px 15px 30px 5px rgba($black, 0.4);\n  }\n  .noUi-target {\n    background: lighten($dark-card-bg, 15%);\n  }\n  .noUi-handle:before,\n  .noUi-handle:after {\n    background: lighten($dark-border-color, 35%);\n  }\n  .noUi-handle {\n    border-color: lighten($dark-border-color, 35%);\n    background: darken($dark-body-bg, 5%);\n  }\n  .noUi-active {\n    box-shadow:\n      inset 0 0 1px $black,\n      inset 0 1px 7px $black,\n      0 3px 6px -3px $black;\n  }\n}\n\n@media (max-width: 576px) {\n  .dark-mode {\n    .nk-block-tools-toggle {\n      .toggle-expand-content {\n        background-color: lighten($dark-card-bg, 7%);\n      }\n    }\n  }\n}\n\n.dark-mode {\n  .icon[class*=\"text-danger\"] {\n    color: $danger !important;\n  }\n  .icon[class*=\"text-blue\"] {\n    color: $blue !important;\n  }\n  .icon[class*=\"text-purple\"] {\n    color: $purple !important;\n  }\n  .icon[class*=\"text-warning\"] {\n    color: $warning !important;\n  }\n  .icon[class*=\"text-success\"] {\n    color: $success !important;\n  }\n  .icon[class*=\"text-pink\"] {\n    color: $pink !important;\n  }\n  .icon[class*=\"text-orange\"] {\n    color: $orange !important;\n  }\n  .icon[class*=\"text-secondary\"] {\n    color: $secondary !important;\n  }\n  // React Select\n  .react-select-container {\n    box-sizing: border-box !important;\n    margin: 0 !important;\n    position: relative !important;\n    vertical-align: middle !important;\n    cursor: pointer !important;\n    min-height: calc(2.125rem + 2px) !important;\n  }\n  .react-select__control {\n    cursor: pointer !important;\n    color: #8094ae !important;\n    border: 1px solid $dark-border-light !important;\n    background-color: $dark-card-bg !important;\n    //padding: 0 .35rem !important;\n  }\n  .react-select__control:hover {\n    border-color: $dark-border-light !important;\n  }\n  .react-select__single-value {\n    color: #8094ae !important;\n    line-height: 1.25rem !important;\n    font-family: Roboto, sans-serif !important;\n    font-size: 13px !important;\n    font-weight: 400 !important;\n  }\n\n  .react-select__control--is-focused,\n  .react-select__control--menu-is-open,\n  .react-select__control + .react-select__control--is-focused,\n  .react-select__control + .react-select__control--menu-is-open {\n    border: 1px solid $dark-border-light !important;\n    //border-color: $accent-color !important;\n    cursor: pointer !important;\n    box-shadow: none !important;\n  }\n  .react-select__menu {\n    background-color: $dark-card-bg !important;\n    border-radius: $react-select-border-radius !important;\n    box-shadow: $react-select-box-shadow !important;\n    border: $react-select-border-width solid $dark-border-light !important;\n    font-family: $react-select-font-family !important;\n    font-size: $react-select-font-size !important;\n    font-weight: $react-select-font-weight !important;\n    display: block !important;\n    padding: 6px !important;\n    z-index: 1000 !important;\n  }\n  .react-select__option {\n    background-color: $dark-card-bg !important;\n    border-radius: $react-select-border-radius !important;\n    box-shadow: $react-select-box-shadow !important;\n    //border: $react-select-border-width solid $react-select-border-color !important;;\n    font-family: $react-select-font-family !important;\n    font-size: $react-select-font-size !important;\n    font-weight: $react-select-font-weight !important;\n    cursor: pointer !important;\n    display: block !important;\n    font-weight: normal;\n    display: block;\n    white-space: nowrap;\n    min-height: 1.2em;\n    color: #8094ae;\n    padding: 0.375rem 0.75rem !important;\n  }\n  .react-select__option:not(:last-child) {\n    margin-bottom: 0.125rem;\n  }\n  .react-select__option:hover {\n    font-weight: normal;\n    display: block;\n    white-space: nowrap;\n    background-color: $dark-body-bg !important;\n  }\n  .react-select__option--is-selected {\n    color: #8094ae;\n    background: $dark-card-bg !important;\n  }\n  .react-select__placeholder {\n    color: #8094ae !important;\n    font-size: small !important;\n    margin-left: 5px;\n    padding: 0 0.35rem !important;\n  }\n  .react-select__multi-value__label {\n    color: #8094ae !important;\n  }\n  // Multivalue\n  .react-select__multi-value {\n    background-color: $dark-card-bg !important;\n    border-radius: 3px !important;\n    cursor: pointer !important;\n  }\n  .react-select__multi-value__remove {\n    color: #8094ae !important;\n    cursor: pointer !important;\n    display: inline-block !important;\n    font-weight: bold !important;\n  }\n  .react-select__multi-value__remove:hover {\n    background: transparent !important;\n  }\n\n  /* Pagination */\n  .page-item {\n    &:first-child {\n      .page-link {\n        margin-left: 0;\n        @include border-left-radius($border-radius);\n      }\n    }\n    &:last-child {\n      .page-link {\n        @include border-right-radius($border-radius);\n      }\n    }\n\n    &.active .page-link {\n      z-index: 3;\n      color: $dark-card-bg !important;\n      background-color: $pagination-active-bg !important;\n      border-color: $pagination-active-border-color !important;\n    }\n\n    &.disabled .page-link {\n      color: $pagination-disabled-color;\n      pointer-events: none;\n      cursor: auto;\n      background-color: $pagination-disabled-bg;\n      border-color: $pagination-disabled-border-color;\n    }\n  }\n  .react-datepicker-popper {\n    background-color: $dark-card-bg !important;\n    padding: 10px;\n    border-radius: 4px;\n    direction: ltr;\n    border: 1px solid $dark-border-light;\n    box-shadow: none;\n    min-width: 240px;\n    font-size: 0.8125rem;\n  }\n  .react-datepicker__time-container .react-datepicker__time {\n    position: relative;\n    background-color: $dark-card-bg !important;\n    border-bottom-right-radius: 0.3rem;\n  }\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--selected {\n    color: #fff;\n    background-color: $accent-color !important;\n  }\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item:hover {\n    color: $base-400 !important;\n    background-color: $dark-card-bg !important;\n  }\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--selected:hover {\n    color: $base-400 !important;\n    background-color: $dark-card-bg !important;\n  }\n  .react-datepicker__header {\n    text-align: center;\n    position: relative;\n    font-size: 0.8125rem;\n    color: $base-300;\n    font-weight: bold;\n  }\n  .react-datepicker__navigation:hover {\n    background: $dark-body-bg;\n  }\n  .react-datepicker__navigation-icon {\n    position: relative;\n    top: -1px;\n    font-size: 12px;\n    color: #fff;\n    width: 0;\n  }\n  .react-datepicker__day:hover,\n  .react-datepicker__month-text:hover,\n  .react-datepicker__quarter-text:hover,\n  .react-datepicker__year-text:hover {\n    color: $base-400 !important;\n    background-color: $dark-body-bg !important;\n  }\n  .react-datepicker__day--today,\n  .react-datepicker__month-text--today,\n  .react-datepicker__quarter-text--today,\n  .react-datepicker__year-text--today {\n    color: $base-400;\n    background-color: $dark-card-bg;\n    border-radius: 0.3rem;\n  }\n  .react-datepicker__month--selected,\n  .react-datepicker__month--in-selecting-range,\n  .react-datepicker__month--in-range,\n  .react-datepicker__quarter--selected,\n  .react-datepicker__quarter--in-selecting-range,\n  .react-datepicker__quarter--in-range {\n    border-radius: 0.3rem;\n    color: #fff !important;\n    background-color: $accent-color !important;\n  }\n  .react-datepicker__month--selected:hover,\n  .react-datepicker__month--in-selecting-range:hover,\n  .react-datepicker__month--in-range:hover,\n  .react-datepicker__quarter--selected:hover,\n  .react-datepicker__quarter--in-selecting-range:hover,\n  .react-datepicker__quarter--in-range:hover {\n    color: $base-400 !important;\n    background-color: $dark-card-bg !important;\n  }\n  .react-datepicker__day--selected,\n  .react-datepicker__day--in-selecting-range,\n  .react-datepicker__day--in-range,\n  .react-datepicker__month-text--selected,\n  .react-datepicker__month-text--in-selecting-range,\n  .react-datepicker__month-text--in-range,\n  .react-datepicker__quarter-text--selected,\n  .react-datepicker__quarter-text--in-selecting-range,\n  .react-datepicker__quarter-text--in-range,\n  .react-datepicker__year-text--selected,\n  .react-datepicker__year-text--in-selecting-range,\n  .react-datepicker__year-text--in-range {\n    border-radius: 0.3rem;\n    color: #fff !important;\n    background-color: $accent-color !important;\n  }\n  .react-datepicker__day--today:hover,\n  .react-datepicker__year-text--today:hover,\n  .react-datepicker__day--selected:hover,\n  .react-datepicker__day--in-selecting-range:hover,\n  .react-datepicker__day--in-range:hover,\n  .react-datepicker__month-text--selected:hover,\n  .react-datepicker__month-text--in-selecting-range:hover,\n  .react-datepicker__month-text--in-range:hover,\n  .react-datepicker__quarter-text--selected:hover,\n  .react-datepicker__quarter-text--in-selecting-range:hover,\n  .react-datepicker__quarter-text--in-range:hover,\n  .react-datepicker__year-text--selected:hover,\n  .react-datepicker__year-text--in-selecting-range:hover,\n  .react-datepicker__year-text--in-range:hover {\n    color: $base-400 !important;\n    background-color: $dark-card-bg !important;\n  }\n  .react-datepicker__day--in-selecting-range:not(\n    .react-datepicker__day--in-range,\n    .react-datepicker__month-text--in-range,\n    .react-datepicker__quarter-text--in-range,\n    .react-datepicker__year-text--in-range\n  ),\n  .react-datepicker__month-text--in-selecting-range:not(\n    .react-datepicker__day--in-range,\n    .react-datepicker__month-text--in-range,\n    .react-datepicker__quarter-text--in-range,\n    .react-datepicker__year-text--in-range\n  ),\n  .react-datepicker__quarter-text--in-selecting-range:not(\n    .react-datepicker__day--in-range,\n    .react-datepicker__month-text--in-range,\n    .react-datepicker__quarter-text--in-range,\n    .react-datepicker__year-text--in-range\n  ),\n  .react-datepicker__year-text--in-selecting-range:not(\n    .react-datepicker__day--in-range,\n    .react-datepicker__month-text--in-range,\n    .react-datepicker__quarter-text--in-range,\n    .react-datepicker__year-text--in-range\n  ) {\n    background-color: $accent-color;\n    color: #fff;\n  }\n  .react-datepicker__month-text.react-datepicker__month--selected:hover,\n  .react-datepicker__month-text.react-datepicker__month--in-range:hover,\n  .react-datepicker__month-text.react-datepicker__quarter--selected:hover,\n  .react-datepicker__month-text.react-datepicker__quarter--in-range:hover,\n  .react-datepicker__quarter-text.react-datepicker__month--selected:hover,\n  .react-datepicker__quarter-text.react-datepicker__month--in-range:hover,\n  .react-datepicker__quarter-text.react-datepicker__quarter--selected:hover,\n  .react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover {\n    background-color: $accent-color;\n    color: #fff;\n  }\n\n  // rdt_Table\n  .rdt_TableRow,\n  .rdt_TableHeadRow,\n  .rdt_Table {\n    background: $dark-card-bg;\n    color: $base-300 !important;\n    border-color: $dark-border-color;\n  }\n  .rdt_TableCol {\n    color: $base-300 !important;\n  }\n\n  // rdl\n  .rdl-control {\n    background-color: $dark-card-bg !important;\n    border-radius: $border-radius !important;\n    box-shadow: none !important;\n    border-color: $dark-border-light !important;\n  }\n  .rdl-control-label {\n    background-color: $dark-card-bg !important;\n    box-shadow: none !important;\n    border-color: $dark-border-light !important;\n  }\n  .rdl-control > option {\n    background-color: $dark-card-bg !important;\n    box-shadow: none !important;\n    border-color: lighten($dark-card-bg, 20%);\n    color: $base-300;\n  }\n  .rdl-control > option:hover {\n    background-color: $dark-body-bg !important;\n  }\n  .rdt_ExpanderRow {\n    background: $dark-card-bg !important;\n  }\n  .dtr-details {\n    color: $base-300 !important;\n  }\n\n  // toastify\n\n  .Toastify__toast {\n    background: $dark-card-bg !important;\n    color: $white !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
